
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("gGjAb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b0516d70dca921df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $7ZwLV = parcelRequire("7ZwLV");
var $enb7h = parcelRequire("enb7h");

var $5BRby = parcelRequire("5BRby");

var $cA8OV = parcelRequire("cA8OV");

var $fWkFY = parcelRequire("fWkFY");

var $1Iui1 = parcelRequire("1Iui1");

var $h4Fhh = parcelRequire("h4Fhh");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $k8Qyf = parcelRequire("k8Qyf");

var $keguF = parcelRequire("keguF");

var $7vf5z = parcelRequire("7vf5z");

var $jD3pk = parcelRequire("jD3pk");

var $2j5ni = parcelRequire("2j5ni");

var $dWvpo = parcelRequire("dWvpo");

var $kKzsy = parcelRequire("kKzsy");

var $3e4zR = parcelRequire("3e4zR");

var $6M8Uw = parcelRequire("6M8Uw");

var $51ACp = parcelRequire("51ACp");

var $iJHZm = parcelRequire("iJHZm");

var $dxcfv = parcelRequire("dxcfv");

var $dWLk9 = parcelRequire("dWLk9");

var $3e9vj = parcelRequire("3e9vj");

var $4xHig = parcelRequire("4xHig");

var $jK1pm = parcelRequire("jK1pm");

var $9J3fC = parcelRequire("9J3fC");

var $j0CW6 = parcelRequire("j0CW6");

var $7mFxr = parcelRequire("7mFxr");
const $b0516d70dca921df$var$getInviteThirdPartyTeamsExperiment = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('confluence.frontend.growth.invite-3rd-party-teams', (0, $1Iui1.NOT_ENROLLED), [
        (0, $1Iui1.NOT_ENROLLED),
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.VARIATION)
    ]);
const $b0516d70dca921df$var$PeopleProfilesShell = ({ history: history })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [{ data: gspData }, { fetchState: fetchState }] = (0, $dWvpo.useGettingStartedPanelState)();
    (0, $eUqFw.useEffect)(()=>{
        if (gspData === undefined) fetchState();
    }, [
        gspData,
        fetchState
    ]);
    const gspProjectId = gspData?.properties?.user?.projectId;
    const { isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = (0, $2j5ni.useIsFirstProjectITSM)(gspProjectId);
    /**
	 * Initializes the active tab to 'alerts' within the Getting Started Panel
	 * specifically for NPLE for ITSM experiment.
	 */ (0, $3e4zR.useInitializeActiveTab)('alerts', gspProjectId);
    const addFlag = (0, $eUqFw.useMemo)(()=>(0, $j0CW6.createShowFlagHandler)(showFlag, dismissFlag), [
        showFlag,
        dismissFlag
    ]);
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const atlassianAccountId = (0, $dxcfv.useAccountId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const environment = (0, $3e9vj.useEnvironment)();
    const locale = (0, $4xHig.useLocale)();
    const previousSubProduct = (0, $keguF.getPreviousSubProduct)();
    const invitePeopleExperimentalFeatures = {
        inviteThirdPartyTeams: $b0516d70dca921df$var$getInviteThirdPartyTeamsExperiment(),
        displayInfiSpotlight: (0, $1ybV0.ff)('confluence.frontend.growth.display-infi-spotlight')
    };
    const { openModal: openModal } = (0, $enb7h.useInvitePeopleModal)({
        continueUrl: window.location.href,
        enableThirdParty: true,
        experimentalFeatures: invitePeopleExperimentalFeatures,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        showFlag: addFlag,
        source: 'peopleDirectory',
        subProduct: previousSubProduct === 'unknown' || previousSubProduct === null ? undefined : previousSubProduct
    });
    const invitePeopleHandlers = (0, $eUqFw.useMemo)(()=>({
            handleOpenDialog: openModal
        }), [
        openModal
    ]);
    const { shouldUseJSM: shouldUseJSM } = (0, $h4Fhh.useOgTenantInfo)();
    if (!atlassianAccountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWkFY.default), null);
    const { push: push, replace: replace } = history;
    const productFeatureFlags = {
        'event-on-call-consolidation_s97c8': true,
        'event-on-call-consolidation-state': shouldUseJSM
    };
    const isNpleForItsmEnabled = isFirstProject && isFirstProjectItsm && (0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "people-profiles"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: "people-profiles"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9J3fC.default), {
        appName: "jira-directory",
        contextSpaPaths: [
            '/browse',
            '/jira',
            '/projects'
        ],
        contextEntryPoint: "/jira/people",
        env: environment === 'prod' ? 'prod' : 'stg',
        locale: locale,
        // @ts-expect-error - TS2322 - Type '(flagFromPTC: FlagFromPTC) => void' is not assignable to type '(props: FlagProps) => void'.
        addFlag: addFlag,
        push: push,
        replace: replace,
        docTitle: {
            end: 'Jira'
        },
        history: history,
        cloudId: cloudId,
        orgId: orgId,
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'JiraSubProduct | undefined'.
        subProduct: previousSubProduct,
        invitePeopleHandlers: invitePeopleHandlers,
        productFeatureFlags: productFeatureFlags
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: "people-profiles",
        isExpectedToHaveSsr: false,
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: (0, $7mFxr.peopleProfilesPageLoad)
    }), (0, $eI5EY.fg)('set-embedded-directory-spa-ready') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null))), isNpleForItsmEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKzsy.JsdGettingStartedPanelShouldRender), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKzsy.JsdGettingStartedPanelOpenButton), null)));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b0516d70dca921df$export$2e2bcd8739ae039 = ()=>// @ts-expect-error - TS2739 - Type '{ children: (history: any) => Element; }' is missing the following properties from type 'RouteContext': location, query, route, match, action
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51ACp.HistoryAdapter), null, (history)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ZwLV.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0516d70dca921df$var$PeopleProfilesShell, {
            history: history
        })));

});
parcelRegister("cA8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0809371ccd3c77a9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0809371ccd3c77a9$export$2e2bcd8739ae039 = (0, $kwce8.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $c9TLT.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});

parcelRegister("fWkFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42223e83f1ce9c0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3da0c = parcelRequire("3da0c");

var $lPArN = parcelRequire("lPArN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b42223e83f1ce9c0$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $3da0c.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPArN.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("3da0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $156a3428b96ddf9e$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $156a3428b96ddf9e$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});

parcelRegister("lPArN", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dddb8b24cbf4df$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$84dddb8b24cbf4df$export$2e2bcd8739ae039 = ({ url: url })=>{
    window.location.assign(url);
    return null;
};

});


parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("2j5ni", function(module, exports) {

$parcel$export(module.exports, "useGettingStartedPageStateActions", () => $cde75c243fb1da47$export$8d2572f02ec0aa4c);
$parcel$export(module.exports, "useIsFirstProjectITSM", () => $cde75c243fb1da47$export$852fe39748ba826d);
$parcel$export(module.exports, "useGetNpleDisabledProjectProperty", () => $cde75c243fb1da47$export$24659fa3abfd0100);
$parcel$export(module.exports, "useIsGettingStartedPageEnabled", () => $cde75c243fb1da47$export$a58e406dc976509e);

var $eUqFw = parcelRequire("eUqFw");

var $9CmwD = parcelRequire("9CmwD");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $bFzGY = parcelRequire("bFzGY");

var $dwCxb = parcelRequire("dwCxb");

var $bNe1g = parcelRequire("bNe1g");

var $iZJHG = parcelRequire("iZJHG");

var $eryLo = parcelRequire("eryLo");

var $eryLo = parcelRequire("eryLo");

var $gd0Sp = parcelRequire("gd0Sp");

var $cwfEs = parcelRequire("cwfEs");

var $2wBzW = parcelRequire("2wBzW");

var $9qZHX = parcelRequire("9qZHX");
const $cde75c243fb1da47$export$8d2572f02ec0aa4c = ()=>{
    const baseUrl = window.location.origin;
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { data: data } = (0, $bNe1g.useProjectContext)() || {};
    const { projectId: projectId } = data || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const projectIdString = projectId ? projectId.toString() : '';
    return (0, $eUqFw.useMemo)(()=>{
        const actionProps = {
            baseUrl: baseUrl,
            cloudId: cloudId,
            projectId: projectIdString,
            createAnalyticsEvent: createAnalyticsEvent
        };
        return [
            {
                updateLandingPageStateProperties: (0, $9qZHX.updateLandingPageStateProperties)(actionProps),
                getLandingPageState: (0, $9qZHX.getLandingPageState)(actionProps),
                initialiseLandingPageState: (0, $9qZHX.initialiseLandingPageState)(actionProps)
            }
        ];
    }, [
        baseUrl,
        cloudId,
        createAnalyticsEvent,
        projectIdString
    ]);
};
const $cde75c243fb1da47$export$852fe39748ba826d = (inputProjectId)=>{
    const { data: containerContext, loading: loading } = (0, $bNe1g.useProjectContext)();
    const currentProjectId = inputProjectId || containerContext?.projectId;
    const [isFirstProject, setIsFirstProject] = (0, $eUqFw.useState)(false);
    const [isFirstProjectItsm, setIsFirstProjectItsm] = (0, $eUqFw.useState)(false);
    const [isStateLoading, setStateLoading] = (0, $eUqFw.useState)(true);
    const { error: isFirstProjectError, firstProject: firstProject } = (0, $2wBzW.useFirstProjectDetails)();
    (0, $eUqFw.useEffect)(()=>{
        if (currentProjectId && !isFirstProjectError && firstProject) {
            setIsFirstProject(firstProject.projectId === `${currentProjectId}`);
            setIsFirstProjectItsm(firstProject.projectTemplateKey === (0, $9CmwD.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY));
            setStateLoading(false);
        } else if (isFirstProjectError) setStateLoading(false);
    }, [
        currentProjectId,
        firstProject,
        isFirstProjectError,
        setStateLoading
    ]);
    const memoizedValue = (0, $eUqFw.useMemo)(()=>({
            isLoading: loading || (0, $eI5EY.fg)('ssr_nav4_queues_sidebar') ? false : isStateLoading,
            isFirstProject: isFirstProject,
            isFirstProjectItsm: isFirstProjectItsm,
            isFirstProjectError: isFirstProjectError
        }), [
        isFirstProject,
        isFirstProjectItsm,
        isFirstProjectError,
        loading,
        isStateLoading
    ]);
    return memoizedValue;
};
const $cde75c243fb1da47$var$useInitialProjectTemplateProjectPropertyKeyWithFF = (projectId, customContext)=>{
    const isSsrNav4QueuesSidebarProductionised = (0, $eI5EY.fg)('ssr_nav4_queues_sidebar');
    if (isSsrNav4QueuesSidebarProductionised) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data, loading: loading } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $eryLo.requiredFrontendProperties), customContext);
        if (!data) return [
            null,
            loading
        ];
        return [
            data[0, $9CmwD.INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY],
            loading
        ];
    }
    const { [(0, $9CmwD.INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY)]: initialProjectTemplateOld } = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $dwCxb.useProjectProperties)([
        (0, $9CmwD.INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY)
    ], projectId);
    const isLoadingOld = initialProjectTemplateOld === undefined;
    return [
        initialProjectTemplateOld,
        isLoadingOld
    ];
};
const $cde75c243fb1da47$export$da3441212b1c36fb = (projectId, customContext)=>{
    const [initialProjectTemplate, isLoading] = $cde75c243fb1da47$var$useInitialProjectTemplateProjectPropertyKeyWithFF(projectId, customContext);
    const { isLoading: isFirstProjectITSMLoading, isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = $cde75c243fb1da47$export$852fe39748ba826d(projectId);
    const excludedProjectTemplates = isFirstProject && isFirstProjectItsm && (0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation') ? (0, $cwfEs.GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_ITSM) : (0, $cwfEs.GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_PROD);
    return (0, $eUqFw.useMemo)(()=>[
            isLoading || isFirstProjectITSMLoading,
            excludedProjectTemplates.includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            initialProjectTemplate)
        ], [
        excludedProjectTemplates,
        initialProjectTemplate,
        isFirstProjectITSMLoading,
        isLoading
    ]);
};
const $cde75c243fb1da47$export$24659fa3abfd0100 = (projectKeyOrId)=>{
    const [npleDisabled, setNpleDisabled] = (0, $eUqFw.useState)(projectKeyOrId ? undefined : true);
    const [isLoadingNew, setIsLoadingNew] = (0, $eUqFw.useState)(true);
    const isLoading = npleDisabled === undefined;
    const getNpleDisabledProjectProperty = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const response = await (0, $lRmyA.performGetRequest)(`/rest/api/3/project/${projectKeyOrId}/properties/${(0, $cwfEs.DISABLE_NPLE_PROJECT_PROJECT_KEY)}`);
            setNpleDisabled(response.value);
            setIsLoadingNew(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setNpleDisabled(error.statusCode !== 404);
            setIsLoadingNew(false);
            error.statusCode !== 404 && (0, $guiFP.default)({
                meta: {
                    id: 'getDisableNpleProjectProperty',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        projectKeyOrId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (projectKeyOrId) getNpleDisabledProjectProperty();
    }, [
        getNpleDisabledProjectProperty,
        projectKeyOrId
    ]);
    const isLoadingValue = (0, $eI5EY.fg)('jsm-wait-for-project-context-in-nple') ? isLoadingNew : isLoading;
    return [
        isLoadingValue,
        npleDisabled
    ];
};
const $cde75c243fb1da47$var$useGetNpleDisabledProjectPropertyWithFF = (projectKey, customContext)=>{
    const isNpleProductionised = (0, $1ybV0.ff)('getting_started_page_production_rollout');
    const isSsrNav4QueuesSidebarProductionised = (0, $eI5EY.fg)('ssr_nav4_queues_sidebar');
    const [isGetNpleDisabledLoadingOld, npleDisabledOld] = $cde75c243fb1da47$export$24659fa3abfd0100(isNpleProductionised && !isSsrNav4QueuesSidebarProductionised ? projectKey : undefined);
    const { data: requiredProjectPropertiesDataNew, loading: isGetNpleDisabledLoadingNew } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $eryLo.requiredProjectProperties), customContext);
    const npleDisabledNew = requiredProjectPropertiesDataNew ? requiredProjectPropertiesDataNew[0, $cwfEs.DISABLE_NPLE_PROJECT_PROJECT_KEY] : true;
    const npleDisabled = isSsrNav4QueuesSidebarProductionised ? npleDisabledNew : npleDisabledOld;
    const isGetNpleDisabledLoading = isSsrNav4QueuesSidebarProductionised ? isGetNpleDisabledLoadingNew : isGetNpleDisabledLoadingOld;
    return [
        npleDisabled,
        isGetNpleDisabledLoading
    ];
};
const $cde75c243fb1da47$export$a58e406dc976509e = (customContext)=>{
    const { data: data, loading: projectContextLoading } = (0, $bNe1g.useProjectContext)(customContext) || {};
    const isNpleProductionised = (0, $1ybV0.ff)('getting_started_page_production_rollout');
    const { simplified: isSimplified = false, isProjectAdmin: isProjectAdmin, projectKey: projectKey, projectId: projectId } = data || {};
    const [isLoading, isExcludedProject] = $cde75c243fb1da47$export$da3441212b1c36fb(projectId?.toString(), customContext);
    const [npleDisabled, isGetNpleDisabledLoading] = $cde75c243fb1da47$var$useGetNpleDisabledProjectPropertyWithFF(projectKey, customContext);
    const isDataLoading = isLoading || projectContextLoading && (0, $eI5EY.fg)('jsm-wait-for-project-context-in-nple') || isGetNpleDisabledLoading && isNpleProductionised;
    const { appPermissions: appPermissions } = (0, $gd0Sp.useTenantContext)() || {};
    const hasJSMAccess = (0, $eI5EY.fg)('add-product-permission-check-for-nple') ? appPermissions?.hasServiceDeskAccess : true;
    return (0, $eUqFw.useMemo)(()=>[
            isDataLoading,
            !isDataLoading ? hasJSMAccess && isProjectAdmin && !isSimplified && !isExcludedProject && !npleDisabled && isNpleProductionised : false
        ], [
        isDataLoading,
        isProjectAdmin,
        isSimplified,
        isExcludedProject,
        npleDisabled,
        isNpleProductionised,
        hasJSMAccess
    ]);
};

});
parcelRegister("cwfEs", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $e789c0ba11eae82e$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $e789c0ba11eae82e$export$2b3151a089bc8780);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_CHANNELS_CUSTOMISED", () => $e789c0ba11eae82e$export$190fb6b68393ab0a);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_REQUEST_TYPES_REVIEWED", () => $e789c0ba11eae82e$export$b51e545ada86528a);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_QUEUE_CUSTOMISED", () => $e789c0ba11eae82e$export$2527ae3f75e929d);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_ADD_TEAMMATES", () => $e789c0ba11eae82e$export$ad0f77484b3c614d);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_NAME", () => $e789c0ba11eae82e$export$649bb2ebeb1bddc7);
$parcel$export(module.exports, "REFERRER", () => $e789c0ba11eae82e$export$adee93c2017009c);
$parcel$export(module.exports, "ERROR_CODE_NOT_FOUND", () => $e789c0ba11eae82e$export$7741797ac345bc17);
$parcel$export(module.exports, "CONTACT_SUPPORT_URL", () => $e789c0ba11eae82e$export$2c16bd1d8b68b11f);
$parcel$export(module.exports, "JSM_DOCUMENTATION_URL", () => $e789c0ba11eae82e$export$3b0c21ad7d48c17f);
$parcel$export(module.exports, "ASK_COMMUNITY_URL", () => $e789c0ba11eae82e$export$eb3a822ca5964b4c);
$parcel$export(module.exports, "SAMPLE_SPACE_URL", () => $e789c0ba11eae82e$export$7d64ff3c41d97984);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_PROD", () => $e789c0ba11eae82e$export$eb8426badfb143b);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_ITSM", () => $e789c0ba11eae82e$export$6e4b80733f1b287d);
$parcel$export(module.exports, "JSM_EXCLUDED_TEMPLATES_FOR_NPLE", () => $e789c0ba11eae82e$export$849d996b61162ae5);
$parcel$export(module.exports, "REQUEST_CHANNEL_PORTAL", () => $e789c0ba11eae82e$export$84bc97b21fdd244a);
$parcel$export(module.exports, "REQUEST_CHANNEL_CHAT", () => $e789c0ba11eae82e$export$a45136678da730c);
$parcel$export(module.exports, "REQUEST_CHANNEL_EMAIL", () => $e789c0ba11eae82e$export$4585842137473138);
$parcel$export(module.exports, "REQUEST_TYPES_MAX_ELEMENTS", () => $e789c0ba11eae82e$export$4ff5ead961dddcb6);
$parcel$export(module.exports, "ManageQueuesArticleId", () => $e789c0ba11eae82e$export$337d9a01cb6ca6b9);
$parcel$export(module.exports, "RequestChannelsArticleId", () => $e789c0ba11eae82e$export$14ea17a7011e8003);
$parcel$export(module.exports, "RequestTypesArticleId", () => $e789c0ba11eae82e$export$bf7175403ae935b4);
$parcel$export(module.exports, "ViewIssueArticleId", () => $e789c0ba11eae82e$export$3a62b051817d4794);
$parcel$export(module.exports, "LearnAboutProjectRolesArticleId", () => $e789c0ba11eae82e$export$ef07413132434f74);
$parcel$export(module.exports, "REQUEST_CHANNELS", () => $e789c0ba11eae82e$export$66b0ce7a4d805ff);
$parcel$export(module.exports, "REQUEST_TYPES", () => $e789c0ba11eae82e$export$b1183955728be615);
$parcel$export(module.exports, "INVITE_PROJECT_ADMIN", () => $e789c0ba11eae82e$export$d161473fa359f57a);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_PROD", () => $e789c0ba11eae82e$export$56dfbf0bd0f6a594);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_PROD_ITSM", () => $e789c0ba11eae82e$export$7153e91b542b7f0a);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_INVITE_TEAM_MEMBERS_EXPERIMENT_VARIATION", () => $e789c0ba11eae82e$export$ca4e6740a5c6d1f2);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_INVITE_TEAM_MEMBERS_EXPERIMENT_CONTROL", () => $e789c0ba11eae82e$export$27a266f610bac60a);
$parcel$export(module.exports, "DEMO_ISSUE_LABEL", () => $e789c0ba11eae82e$export$fe4edbd608405ae2);
$parcel$export(module.exports, "DEMO_ISSUE_ERROR_FLAG_ID", () => $e789c0ba11eae82e$export$b2f56b9b16e7a5d8);
$parcel$export(module.exports, "DISABLE_NPLE_PROJECT_PROJECT_KEY", () => $e789c0ba11eae82e$export$8b55ba9520951f74);
$parcel$export(module.exports, "DISABLE_NPLE_ERROR_FLAG_ID", () => $e789c0ba11eae82e$export$8ce85ec44321d12);
$parcel$export(module.exports, "DISABLE_NPLE_SUCCESS_FLAG_ID", () => $e789c0ba11eae82e$export$2b5c9784d8cd5f0);
$parcel$export(module.exports, "INCIDENTS", () => $e789c0ba11eae82e$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "CHANGES", () => $e789c0ba11eae82e$export$8598196f74460271);
$parcel$export(module.exports, "ALERTS", () => $e789c0ba11eae82e$export$bc57e9dea1fac017);

var $9CmwD = parcelRequire("9CmwD");
const $e789c0ba11eae82e$export$b8b9d90f9e5bd72b = 'jiraServicedeskGettingStartedPage';
const $e789c0ba11eae82e$export$2b3151a089bc8780 = 'itops-mithril';
const $e789c0ba11eae82e$export$190fb6b68393ab0a = 'servicedesk-getting-started-page-request-channels-customised';
const $e789c0ba11eae82e$export$b51e545ada86528a = 'servicedesk-getting-started-page-request-types-reviewed';
const $e789c0ba11eae82e$export$2527ae3f75e929d = 'servicedesk-getting-started-page-queue-customised';
const $e789c0ba11eae82e$export$ad0f77484b3c614d = 'servicedesk-getting-started-page-invite-team';
const $e789c0ba11eae82e$export$649bb2ebeb1bddc7 = 'servicedesk-getting-started-page';
const $e789c0ba11eae82e$export$f250cf2c117f5561 = 'jsm.it-service-management';
const $e789c0ba11eae82e$export$adee93c2017009c = 'referrer';
const $e789c0ba11eae82e$export$7741797ac345bc17 = 404;
const $e789c0ba11eae82e$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact/#/';
const $e789c0ba11eae82e$export$3b0c21ad7d48c17f = 'https://support.atlassian.com/jira-service-management-cloud/docs/get-started-with-jira-service-management/';
const $e789c0ba11eae82e$export$eb3a822ca5964b4c = 'https://community.atlassian.com/t5/Jira-Service-Management/Welcome-to-Jira-Service-Management/m-p/2690403?utm_source=community&utm_medium=inapp&utm_campaign=P:jira-service-management%7CO:community%7CC:community%7CW:jsmlp%7CH:05/07/2024%7CI:onboarding%7C';
const $e789c0ba11eae82e$export$7d64ff3c41d97984 = '/jira/servicedesk/itsm-sample-space';
const $e789c0ba11eae82e$export$2ff5a711d89d56f0 = '';
const $e789c0ba11eae82e$export$eb8426badfb143b = [
    (0, $9CmwD.IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY),
    (0, $9CmwD.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY),
    (0, $9CmwD.JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY),
    $e789c0ba11eae82e$export$2ff5a711d89d56f0
];
const $e789c0ba11eae82e$export$6e4b80733f1b287d = [
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY),
    $e789c0ba11eae82e$export$2ff5a711d89d56f0
];
const $e789c0ba11eae82e$export$849d996b61162ae5 = [
    $e789c0ba11eae82e$export$f250cf2c117f5561,
    (0, $9CmwD.IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY),
    (0, $9CmwD.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY),
    $e789c0ba11eae82e$export$2ff5a711d89d56f0
];
const $e789c0ba11eae82e$export$84bc97b21fdd244a = 'Portal';
const $e789c0ba11eae82e$export$a45136678da730c = 'Chat';
const $e789c0ba11eae82e$export$4585842137473138 = 'Email';
const $e789c0ba11eae82e$export$4ff5ead961dddcb6 = 4;
const $e789c0ba11eae82e$export$337d9a01cb6ca6b9 = '5b7BuVaVJqmbyCZ2mbMYHD';
const $e789c0ba11eae82e$export$4427f2578322b0c1 = '3cdZ1Fc5T12gySP1kroJJr';
const $e789c0ba11eae82e$export$14ea17a7011e8003 = '3v4bqtuzeA4dOJq6A4yhiM';
const $e789c0ba11eae82e$export$bf7175403ae935b4 = 'eYQImfQnsXgIvrECKaQTF';
const $e789c0ba11eae82e$export$3a62b051817d4794 = '102lbF25oEeqn7GG1rXPUA';
const $e789c0ba11eae82e$export$ef07413132434f74 = '6aIMqm2F5KAhHo3BbFYp0p';
const $e789c0ba11eae82e$export$66b0ce7a4d805ff = 'RequestChannel';
const $e789c0ba11eae82e$export$b1183955728be615 = 'RequestTypes';
const $e789c0ba11eae82e$export$5b2e9a43da487c8d = 'InviteTeam';
const $e789c0ba11eae82e$export$82cf56f84f36683f = 'ManageQueues';
const $e789c0ba11eae82e$export$d161473fa359f57a = 'InviteProjectAdmin';
const $e789c0ba11eae82e$export$56dfbf0bd0f6a594 = 'newLandingPageExperienceProd';
const $e789c0ba11eae82e$export$7153e91b542b7f0a = 'newLandingPageExperienceProdITSM';
const $e789c0ba11eae82e$export$ca4e6740a5c6d1f2 = 'newLandingPageExperienceInviteTeamMemberExperimentVariation';
const $e789c0ba11eae82e$export$27a266f610bac60a = 'newLandingPageExperienceInviteTeamMemberExperimentControl';
const $e789c0ba11eae82e$export$be01cbdafda7d87f = 'rejected';
const $e789c0ba11eae82e$export$fe4edbd608405ae2 = 'onboarding-learn-by-doing-demo-issue';
const $e789c0ba11eae82e$export$b2f56b9b16e7a5d8 = 'onboarding-sample-issue-error';
const $e789c0ba11eae82e$export$8b55ba9520951f74 = 'npleDisabled';
const $e789c0ba11eae82e$export$8ce85ec44321d12 = 'disable-nple-error';
const $e789c0ba11eae82e$export$2b5c9784d8cd5f0 = 'disable-nple-success';
const $e789c0ba11eae82e$export$a50b49a533b5f7bc = 'incidents';
const $e789c0ba11eae82e$export$8598196f74460271 = 'changes';
const $e789c0ba11eae82e$export$bc57e9dea1fac017 = 'alerts';

});

parcelRegister("2wBzW", function(module, exports) {

$parcel$export(module.exports, "useFirstProjectDetails", () => $dc9ff023e450a76d$export$a2dd21ca7232bc34);

var $eUqFw = parcelRequire("eUqFw");


var $gd0Sp = parcelRequire("gd0Sp");

var $WBLbN = parcelRequire("WBLbN");

var $3tjIy = parcelRequire("3tjIy");
const $dc9ff023e450a76d$var$initialState = {
    error: false,
    firstProject: undefined
};
const $dc9ff023e450a76d$var$setError = (error)=>({ setState: setState })=>{
        setState({
            error: error
        });
    };
const $dc9ff023e450a76d$var$setFirstProject = (firstProject)=>({ setState: setState })=>{
        setState({
            firstProject: firstProject
        });
    };
const $dc9ff023e450a76d$export$e324594224ef24da = {
    setError: $dc9ff023e450a76d$var$setError,
    setFirstProject: $dc9ff023e450a76d$var$setFirstProject
};
const $dc9ff023e450a76d$var$store = (0, $WBLbN.createStore)({
    name: 'getting-started-page-is-first-project',
    initialState: $dc9ff023e450a76d$var$initialState,
    actions: $dc9ff023e450a76d$export$e324594224ef24da
});
const $dc9ff023e450a76d$export$a47f6b1a99a5e57f = (0, $WBLbN.createHook)($dc9ff023e450a76d$var$store);
const $dc9ff023e450a76d$export$a2dd21ca7232bc34 = ()=>{
    const [data, { setError: setErrorState, setFirstProject: setFirstProjectDetails }] = $dc9ff023e450a76d$export$a47f6b1a99a5e57f();
    const { licensedProducts: licensedProducts } = (0, $gd0Sp.useTenantContext)() || {};
    const hasJsmLicense = licensedProducts && licensedProducts[0, $2edfd53057852e41$export$c8c1c8c3f8ddba61];
    (0, $eUqFw.useEffect)(()=>{
        if (!hasJsmLicense || data.firstProject || data.error) return;
        (0, $3tjIy.getFirstProject)().then((response)=>{
            setFirstProjectDetails(response);
        }).catch(()=>{
            setErrorState(true);
        });
    }, [
        hasJsmLicense,
        setErrorState,
        setFirstProjectDetails,
        data.firstProject,
        data.error
    ]);
    return data;
};

});
const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$e9c56aa3b027d98f = 'jira-customer-service';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';

parcelRegister("3tjIy", function(module, exports) {

$parcel$export(module.exports, "getFirstProject", () => $1416e82639659d77$export$197802963901b2fb);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $cwfEs = parcelRequire("cwfEs");
const $1416e82639659d77$export$197802963901b2fb = async ()=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)('/rest/servicedesk/latest/xflow/getFirstProject?type=service_desk');
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode !== 404) (0, $guiFP.default)({
            meta: {
                id: 'getFirstProject',
                packageName: (0, $cwfEs.PACKAGE_NAME),
                teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("9qZHX", function(module, exports) {

$parcel$export(module.exports, "initialiseLandingPageState", () => $37d0166180f1cc09$export$afc4bcbfce806408);
$parcel$export(module.exports, "getLandingPageState", () => $37d0166180f1cc09$export$43654a89c1df0019);
$parcel$export(module.exports, "updateLandingPageStateProperties", () => $37d0166180f1cc09$export$2dede61295d6c46);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $cwfEs = parcelRequire("cwfEs");
const $37d0166180f1cc09$export$afc4bcbfce806408 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async ()=>{
        try {
            await (0, $lRmyA.performPostRequest)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page`);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubject: 'State',
                action: 'initialised'
            }), 'jiraServicedeskGettingStartedPage.State initialised');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'State',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
const $37d0166180f1cc09$export$43654a89c1df0019 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async ()=>{
        try {
            const response = await (0, $lRmyA.performGetRequestWithRetry)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page`);
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'State',
                action: 'fetched'
            }), 'jiraServicedeskGettingStartedPage.State fetched');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'State',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
const $37d0166180f1cc09$export$2dede61295d6c46 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async (properties)=>{
        const sectionStateString = JSON.stringify(properties);
        try {
            await (0, $lRmyA.performPostRequest)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page/properties`, {
                body: JSON.stringify({
                    sectionState: sectionStateString
                })
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubject: 'Properties',
                action: 'updated'
            }), 'jiraServicedeskGettingStartedPage.Properties updated', {
                property: properties
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'Properties',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };

});


parcelRegister("dWvpo", function(module, exports) {

$parcel$export(module.exports, "useOpsTeamMode", () => $f367f2772b7579d7$export$97247be508d7d058);
$parcel$export(module.exports, "useGettingStartedPanelState", () => $f367f2772b7579d7$export$50f195e39d82318);
$parcel$export(module.exports, "useGettingStartedPanelActions", () => $f367f2772b7579d7$export$bb089b373d239cdd);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $bFzGY = parcelRequire("bFzGY");

var $h4Fhh = parcelRequire("h4Fhh");

var $SEaoU = parcelRequire("SEaoU");

var $lB25E = parcelRequire("lB25E");

var $IsF0v = parcelRequire("IsF0v");


var $lhDSB = parcelRequire("lhDSB");

var $gEZA0 = parcelRequire("gEZA0");

var $6vrw7 = parcelRequire("6vrw7");

var $gd0Sp = parcelRequire("gd0Sp");

var $8u09c = parcelRequire("8u09c");

var $WBLbN = parcelRequire("WBLbN");

var $dIgUk = parcelRequire("dIgUk");
const $f367f2772b7579d7$var$initialState = {
    data: undefined,
    isGspInitialized: true,
    isSaving: false,
    shouldRecordPerformanceExperiences: true
};
const $f367f2772b7579d7$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'GettingStartedPanelState',
    initialState: $f367f2772b7579d7$var$initialState,
    actions: (0, $dIgUk.actions)
});
const $f367f2772b7579d7$var$useGettingStartedPanelStoreState = (0, $WBLbN.createHook)($f367f2772b7579d7$export$6f57813fe9f31bf9, {
    selector: ({ data: data, isGspInitialized: isGspInitialized, shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences })=>{
        const canRender = isGspInitialized && data?.properties.user.activeState === (0, $8u09c.ActiveState).On;
        const canRenderPanel = canRender && data?.properties.user.visualState === (0, $8u09c.VisualState).FullPanel;
        const canRenderOpenButton = canRender && data?.properties.user.visualState === (0, $8u09c.VisualState).Lozenge;
        const canRenderReopenButton = isGspInitialized && data?.properties.user.activeState === (0, $8u09c.ActiveState).Off;
        const canRenderReopenSpotlight = canRenderReopenButton && data?.properties.user.hasSeenReopenSpotlight === (0, $8u09c.HasSeenReopenSpotlight).No;
        const canPollPanelState = data?.properties.user.activeState === (0, $8u09c.ActiveState).On;
        return {
            data: data,
            canRenderPanel: canRenderPanel,
            canRenderOpenButton: canRenderOpenButton,
            canRenderReopenButton: canRenderReopenButton,
            canRenderReopenSpotlight: canRenderReopenSpotlight,
            canPollPanelState: canPollPanelState,
            shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences
        };
    }
});
const $f367f2772b7579d7$var$useGettingStartedPanelStoreActions = (0, $WBLbN.createHook)($f367f2772b7579d7$export$6f57813fe9f31bf9, {
    selector: null
});
/**
 * Hook returns if FSF tour is seen
 */ const $f367f2772b7579d7$var$useIsProjectTourSeen = ()=>{
    const [{ data: data, isLoading: isLoading, error: error }, { getTourState: getTourState }] = (0, $lhDSB.useTourState)();
    const isError = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(error);
    const hasData = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(data);
    (0, $eUqFw.useEffect)(()=>{
        if (!hasData && !isLoading && !isError) getTourState();
    }, [
        hasData,
        isLoading,
        isError,
        getTourState
    ]);
    return data?.seenProjectTour === (0, $ef7033652bab160b$export$e47bc222770d5cfd);
};
/**
 * Hook returns if ITSM sample project
 */ const $f367f2772b7579d7$var$useIsSampleProject = ()=>{
    const { data: isItsmSampleProject } = (0, $gEZA0.useIsItsmSampleProject)();
    const [{ data: containerContext }] = (0, $SEaoU.useContainerContext)();
    if (isItsmSampleProject != null) return isItsmSampleProject;
    /*
    When isItsmSampleProject is null or undefined - return null/undefined, but only if we are in project context
    (this is to identify that this var has not been initialized yet, see isItsmSampleProject usages, where we check for null/isNil);
    return false otherwise
 */ return containerContext?.contextType === 'project' ? isItsmSampleProject : false;
};
const $f367f2772b7579d7$export$2486eddc1a0bc021 = ()=>{
    const { data: isItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    const [{ data: containerContext }] = (0, $SEaoU.useContainerContext)();
    const projectId = containerContext?.contextType === 'project' && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(containerContext.project) ? (0, $6vrw7.toProjectId)(String(containerContext.project.id)) : undefined;
    return {
        isItsmProject: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectId) && isItsmProject === true,
        projectId: projectId
    };
};
const $f367f2772b7579d7$export$97247be508d7d058 = ()=>{
    const [{ location: { pathname: pathname } }] = (0, $lB25E.useRouter)();
    const { shouldUseJSM: shouldUseJSM } = (0, $h4Fhh.useOgTenantInfo)();
    const isOpsPage = pathname.startsWith('/jira/ops/teams/');
    const [teamId] = (0, $lB25E.usePathParam)('teamId');
    const enableOpsTeamMode = isOpsPage && teamId !== undefined && !!shouldUseJSM;
    return {
        teamId: teamId,
        enableOpsTeamMode: enableOpsTeamMode
    };
};
const $f367f2772b7579d7$export$678a38a9dc2d3a0 = ()=>{
    const { isItsmProject: isItsmProject } = $f367f2772b7579d7$export$2486eddc1a0bc021();
    const { shouldUseJSM: shouldUseJSM } = (0, $h4Fhh.useOgTenantInfo)();
    const enableUserCentricMode = isItsmProject && !!shouldUseJSM;
    return enableUserCentricMode;
};
const $f367f2772b7579d7$var$useActionsMemo = ({ baseUrl: baseUrl, cloudId: cloudId, accountId: accountId, initializeState: initializeState, reopenGettingStartedPanel: reopenGettingStartedPanel, markReopenSpotlightAsSeen: markReopenSpotlightAsSeen, fetchState: fetchState, savePanelState: savePanelState, resolveTask: resolveTask, saveProperty: saveProperty, stopRecordingPerformanceExperiences: stopRecordingPerformanceExperiences, setOpsAdminTaskVisibility: setOpsAdminTaskVisibility })=>{
    const gatewayBaseUrl = (0, $6vrw7.toBaseUrl)(`${baseUrl}/gateway/api`);
    const isItsmSampleProject = $f367f2772b7579d7$var$useIsSampleProject();
    const { isItsmProject: isItsmProject, projectId: projectId } = $f367f2772b7579d7$export$2486eddc1a0bc021();
    const isProjectTourSeen = $f367f2772b7579d7$var$useIsProjectTourSeen();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { teamId: teamId, enableOpsTeamMode: enableOpsTeamMode } = $f367f2772b7579d7$export$97247be508d7d058();
    const enableUserCentricMode = $f367f2772b7579d7$export$678a38a9dc2d3a0();
    return (0, $eUqFw.useMemo)(()=>{
        const actionProps = {
            createAnalyticsEvent: createAnalyticsEvent,
            baseUrl: gatewayBaseUrl,
            cloudId: cloudId,
            accountId: accountId,
            isItsmSampleProject: isItsmSampleProject,
            isProjectTourSeen: isProjectTourSeen,
            isItsmProject: isItsmProject,
            projectId: projectId,
            ...enableOpsTeamMode && {
                teamId: teamId,
                enableOpsTeamMode: enableOpsTeamMode
            },
            ...enableUserCentricMode && {
                enableUserCentricMode: enableUserCentricMode
            }
        };
        return {
            initializeState: initializeState(actionProps),
            reopenGettingStartedPanel: reopenGettingStartedPanel(actionProps),
            markReopenSpotlightAsSeen: markReopenSpotlightAsSeen(actionProps),
            fetchState: fetchState(actionProps),
            savePanelState: savePanelState(actionProps),
            resolveTask: resolveTask(actionProps),
            saveProperty: saveProperty(actionProps),
            stopRecordingPerformanceExperiences: stopRecordingPerformanceExperiences(),
            setOpsAdminTaskVisibility: setOpsAdminTaskVisibility(actionProps)
        };
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        cloudId,
        accountId,
        isItsmSampleProject,
        isProjectTourSeen,
        isItsmProject,
        projectId,
        enableOpsTeamMode,
        teamId,
        enableUserCentricMode,
        initializeState,
        reopenGettingStartedPanel,
        markReopenSpotlightAsSeen,
        fetchState,
        savePanelState,
        resolveTask,
        saveProperty,
        stopRecordingPerformanceExperiences,
        setOpsAdminTaskVisibility
    ]);
};
const $f367f2772b7579d7$var$useStateMemo = ({ data: data, canRenderPanel: canRenderPanel, canRenderOpenButton: canRenderOpenButton, canRenderReopenButton: canRenderReopenButton, canRenderReopenSpotlight: canRenderReopenSpotlight, canPollPanelState: canPollPanelState, shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences })=>(0, $eUqFw.useMemo)(()=>({
            data: data,
            canRenderPanel: canRenderPanel,
            canRenderOpenButton: canRenderOpenButton,
            canRenderReopenButton: canRenderReopenButton,
            canRenderReopenSpotlight: canRenderReopenSpotlight,
            canPollPanelState: canPollPanelState,
            shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences
        }), [
        data,
        canRenderPanel,
        canRenderOpenButton,
        canRenderReopenButton,
        canRenderReopenSpotlight,
        canPollPanelState,
        shouldRecordPerformanceExperiences
    ]);
const $f367f2772b7579d7$export$50f195e39d82318 = ()=>{
    const { cloudId: cloudId, atlassianAccountId: accountId, baseUrl: baseUrl } = (0, $gd0Sp.useTenantContext)();
    const [state, actions] = $f367f2772b7579d7$var$useGettingStartedPanelStoreState();
    const memoizedActions = $f367f2772b7579d7$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl,
        cloudId: cloudId,
        accountId: accountId
    });
    const memoizedState = $f367f2772b7579d7$var$useStateMemo(state);
    return (0, $eUqFw.useMemo)(()=>[
            memoizedState,
            memoizedActions
        ], [
        memoizedActions,
        memoizedState
    ]);
};
const $f367f2772b7579d7$export$bb089b373d239cdd = ()=>{
    const { cloudId: cloudId, atlassianAccountId: accountId, baseUrl: baseUrl } = (0, $gd0Sp.useTenantContext)();
    const [, actions] = $f367f2772b7579d7$var$useGettingStartedPanelStoreActions();
    const memoizedActions = $f367f2772b7579d7$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl,
        cloudId: cloudId,
        accountId: accountId
    });
    return (0, $eUqFw.useMemo)(()=>[
            undefined,
            memoizedActions
        ], [
        memoizedActions
    ]);
};

});
const $ef7033652bab160b$export$17227441e89ee693 = 'INITIAL';
const $ef7033652bab160b$export$23324e66dcb20cea = 'NOTSEEN';
const $ef7033652bab160b$export$e47bc222770d5cfd = 'SEEN';
const $ef7033652bab160b$export$103bedf43ba882db = 'ERROR';
const $ef7033652bab160b$export$b8b9d90f9e5bd72b = 'jiraServicedeskItsmFirstSessionFlow';
const $ef7033652bab160b$export$d57b6b390e78d90f = 'itops-mithril';

parcelRegister("lhDSB", function(module, exports) {

$parcel$export(module.exports, "useTourState", () => $3c47e23fdd4320f6$export$4aecabf781c5d857);

var $eUqFw = parcelRequire("eUqFw");

var $6vrw7 = parcelRequire("6vrw7");

var $WBLbN = parcelRequire("WBLbN");

var $d2tO7 = parcelRequire("d2tO7");
const $3c47e23fdd4320f6$export$d4c72bab9d6cc13a = {
    data: undefined,
    isLoading: false,
    error: undefined
};
const $3c47e23fdd4320f6$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'ItsmFirstSessionFlowTourState',
    initialState: $3c47e23fdd4320f6$export$d4c72bab9d6cc13a,
    actions: (0, $d2tO7.actions)
});
const $3c47e23fdd4320f6$var$useStore = (0, $WBLbN.createHook)($3c47e23fdd4320f6$export$6f57813fe9f31bf9);
// @ts-expect-error - TS7031 - Binding element 'baseUrl' implicitly has an 'any' type. | TS7031 - Binding element 'getTourState' implicitly has an 'any' type. | TS7031 - Binding element 'setTourState' implicitly has an 'any' type.
const $3c47e23fdd4320f6$var$useActionsMemo = ({ baseUrl: baseUrl, getTourState: getTourState, setTourState: setTourState })=>(0, $eUqFw.useMemo)(()=>({
            getTourState: getTourState({
                baseUrl: baseUrl
            }),
            setTourState: setTourState({
                baseUrl: baseUrl
            })
        }), [
        baseUrl,
        getTourState,
        setTourState
    ]);
const $3c47e23fdd4320f6$var$useStateMemo = ({ data: data, isLoading: isLoading, error: error })=>(0, $eUqFw.useMemo)(()=>({
            data: data,
            isLoading: isLoading,
            error: error
        }), [
        data,
        isLoading,
        error
    ]);
const $3c47e23fdd4320f6$export$4aecabf781c5d857 = ()=>{
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const [state, actions] = $3c47e23fdd4320f6$var$useStore();
    const memoizedActions = $3c47e23fdd4320f6$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl
    });
    const memoizedState = $3c47e23fdd4320f6$var$useStateMemo(state);
    return (0, $eUqFw.useMemo)(()=>[
            memoizedState,
            memoizedActions
        ], [
        memoizedActions,
        memoizedState
    ]);
};

});
parcelRegister("d2tO7", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5324b94d76febd17$export$e324594224ef24da);

var $eU696 = parcelRequire("eU696");

var $dv6lu = parcelRequire("dv6lu");
const $5324b94d76febd17$export$e324594224ef24da = {
    getTourState: $eU696.getTourState,
    setTourState: $dv6lu.setTourState
};

});
parcelRegister("eU696", function(module, exports) {

$parcel$export(module.exports, "getTourState", () => $4c66438699410e17$export$a758fd93ae41dde5);

var $fVqUX = parcelRequire("fVqUX");

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");

var $7EhAs = parcelRequire("7EhAs");

var $6vrw7 = parcelRequire("6vrw7");

const $4c66438699410e17$var$getUrl = (baseUrl)=>`${baseUrl}/rest/servicedesk/onboarding/latest/fsf`;
const $4c66438699410e17$var$fetchTourState = async (baseUrl)=>{
    const url = $4c66438699410e17$var$getUrl(baseUrl);
    const response = await fetch(url, (0, $fVqUX.default));
    if (!response.ok) {
        const text = await response.text();
        const error = new (0, $7EhAs.default)(response.status, text);
        // Still throw the error even if it's a client fetch error,
        // so we get the error path in the handling code.
        // We only want to skip analytics firing.
        if (!(0, $JRB5w.isClientFetchError)(error)) (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getTourState_responseNotOK',
                packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
    return response.json();
};
const $4c66438699410e17$export$a758fd93ae41dde5 = ({ baseUrl: baseUrl })=>({ getState: getState, setState: setState })=>async ()=>{
            const { data: data, isLoading: isLoading } = getState();
            if (data || isLoading) return;
            setState({
                error: undefined,
                isLoading: true
            });
            try {
                const result = await $4c66438699410e17$var$fetchTourState(baseUrl);
                const { seenProjectTour: seenProjectTour, projectId: projectId } = result;
                setState({
                    data: {
                        seenProjectTour: seenProjectTour,
                        projectId: projectId === null ? null : (0, $6vrw7.toProjectId)(projectId)
                    },
                    isLoading: false
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (!(0, $JRB5w.isClientFetchError)(error)) (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'getTourState',
                        packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                        teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    error: error,
                    isLoading: false
                });
                if (!(0, $JRB5w.isClientFetchError)(error)) throw error;
            }
        };

});

parcelRegister("dv6lu", function(module, exports) {

$parcel$export(module.exports, "setTourState", () => $106ad4ed6da8c60b$export$35f9649c739aaca3);

var $fVqUX = parcelRequire("fVqUX");

var $guiFP = parcelRequire("guiFP");

var $7EhAs = parcelRequire("7EhAs");

const $106ad4ed6da8c60b$var$getUrl = (baseUrl)=>`${baseUrl}/rest/servicedesk/onboarding/latest/fsf`;
const $106ad4ed6da8c60b$var$putTourState = async (baseUrl, tourState)=>{
    const url = $106ad4ed6da8c60b$var$getUrl(baseUrl);
    const response = await fetch(url, {
        ...(0, $fVqUX.default),
        method: 'PUT',
        body: JSON.stringify(tourState)
    });
    if (!response.ok) {
        const text = await response.text();
        const error = new (0, $7EhAs.default)(response.status, text);
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'setTourState_responseNotOK',
                packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $106ad4ed6da8c60b$export$35f9649c739aaca3 = ({ baseUrl: baseUrl })=>({ setState: setState })=>// @ts-expect-error - TS2322 - Type 'SetTourState' is not assignable to type 'void | Promise<void>'.
        async (tourState)=>{
            setState({
                error: undefined,
                data: tourState,
                isLoading: true
            });
            try {
                await $106ad4ed6da8c60b$var$putTourState(baseUrl, tourState);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'setTourState',
                        packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                        teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    error: error
                });
                throw error;
            } finally{
                setState({
                    isLoading: false
                });
            }
        };

});



parcelRegister("gEZA0", function(module, exports) {

$parcel$export(module.exports, "useIsItsmSampleProject", () => $d550131522ea0515$export$b8afdaba4bd6f483);

var $ldoFd = parcelRequire("ldoFd");

var $IsF0v = parcelRequire("IsF0v");

var $f7V0E = parcelRequire("f7V0E");
const $d550131522ea0515$export$b8afdaba4bd6f483 = ()=>{
    const { data: isDemoProject, loading: loadingIsDemoProject, error: errorIsDemoProject } = (0, $f7V0E.useIsDemoProject)();
    const { data: isItsmProject, loading: loadingIsItsmProject, error: errorIsItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    return {
        data: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isDemoProject) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isItsmProject) ? isDemoProject === true && isItsmProject === true : null,
        loading: loadingIsDemoProject || loadingIsItsmProject,
        error: errorIsDemoProject || errorIsItsmProject
    };
};

});
parcelRegister("f7V0E", function(module, exports) {

$parcel$export(module.exports, "useIsDemoProject", () => $8aa166fc00256124$export$9b4078600f2ad4d2);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $SEaoU = parcelRequire("SEaoU");

var $6vrw7 = parcelRequire("6vrw7");

var $WBLbN = parcelRequire("WBLbN");

var $7kN7I = parcelRequire("7kN7I");

var $au7K4 = parcelRequire("au7K4");
const $8aa166fc00256124$export$d4c72bab9d6cc13a = {};
const $8aa166fc00256124$export$bf108b10a3a0ab90 = (0, $WBLbN.createStore)({
    name: 'IsDemoProject',
    initialState: $8aa166fc00256124$export$d4c72bab9d6cc13a,
    actions: (0, $7kN7I.actions)
});
const $8aa166fc00256124$var$useIsDemoProjectStore = (0, $WBLbN.createHook)($8aa166fc00256124$export$bf108b10a3a0ab90);
// @ts-expect-error - TS7031 - Binding element 'data' implicitly has an 'any' type. | TS7031 - Binding element 'loading' implicitly has an 'any' type. | TS7031 - Binding element 'error' implicitly has an 'any' type.
const $8aa166fc00256124$var$useStateMemo = ({ data: data, loading: loading, error: error })=>(0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
const $8aa166fc00256124$export$9b4078600f2ad4d2 = ()=>{
    const [{ data: contextData }] = (0, $SEaoU.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'. | TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const numProjectId = contextData && contextData.project && contextData.project.id;
    const projectId = (0, $6vrw7.toProjectId)(String(numProjectId));
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const [state, { fetchIsDemoProject: fetchIsDemoProject }] = $8aa166fc00256124$var$useIsDemoProjectStore();
    const memoizedState = $8aa166fc00256124$var$useStateMemo({
        ...state[projectId] ?? (0, $au7K4.initialIsDemoProjectState)
    });
    const { data: data } = memoizedState;
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(numProjectId) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(data)) // @ts-expect-error - TS2349 - This expression is not callable.
        fetchIsDemoProject({
            baseUrl: baseUrl,
            projectId: projectId
        })();
    }, [
        fetchIsDemoProject,
        baseUrl,
        numProjectId,
        projectId,
        data
    ]);
    return memoizedState;
};

});
parcelRegister("7kN7I", function(module, exports) {

$parcel$export(module.exports, "actions", () => $284bc3e2d216ef40$export$e324594224ef24da);

var $eQBT8 = parcelRequire("eQBT8");
const $284bc3e2d216ef40$export$e324594224ef24da = {
    fetchIsDemoProject: $eQBT8.fetchIsDemoProject
};

});
parcelRegister("eQBT8", function(module, exports) {

$parcel$export(module.exports, "fetchIsDemoProject", () => $5aa4af5bc33ec272$export$feaee63a215b34da);

var $ldoFd = parcelRequire("ldoFd");

var $iUq1J = parcelRequire("iUq1J");

var $au7K4 = parcelRequire("au7K4");
const $5aa4af5bc33ec272$export$feaee63a215b34da = ({ baseUrl: baseUrl, projectId: projectId })=>// @ts-expect-error - TS2322 - Type '({ getState, setState }: StoreActionApi<Partial<Record<string, DataState<boolean>>>>) => () => Promise<void>' is not assignable to type 'Action<Partial<Record<string, DataState<boolean>>>, void, void | Promise<void>>'.
    ({ getState: getState, setState: setState })=>async ()=>{
            const projectState = getState()[projectId] ?? (0, $au7K4.initialIsDemoProjectState);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectState.data) || projectState.loading) return;
            setState({
                ...getState(),
                [String(projectId)]: {
                    ...projectState,
                    loading: true
                }
            });
            try {
                const isDemo = await (0, $iUq1J.isDemoProject)({
                    baseUrl: baseUrl,
                    projectId: projectId
                });
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        data: isDemo,
                        error: null,
                        loading: false
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        error: error,
                        loading: false
                    }
                });
                throw error;
            }
        };

});
parcelRegister("iUq1J", function(module, exports) {

$parcel$export(module.exports, "isDemoProject", () => $e1be306bebb9e883$export$cf7813449d38d4ac);
$parcel$export(module.exports, "getItsmSampleProject", () => $e1be306bebb9e883$export$c498e29d716efe7a);

var $lRmyA = parcelRequire("lRmyA");
const $e1be306bebb9e883$export$cf7813449d38d4ac = async ({ baseUrl: baseUrl, projectId: projectId })=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/api/3/project/${projectId}/properties/isDemo`);
        return !!response && !!response.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) /**
			 * Expected when project property is not found.
			 * Demo project has project property "isDemo = true",
			 * otherwise property does not exist
			 * and response status will be 404
			 */ return false;
        throw error;
    }
};
const $e1be306bebb9e883$export$c498e29d716efe7a = async ({ baseUrl: baseUrl })=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/servicedesk/onboarding/1/itsm/sample-project`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) return undefined;
        throw error;
    }
};

});

parcelRegister("au7K4", function(module, exports) {

$parcel$export(module.exports, "initialIsDemoProjectState", () => $099e9baa7e7daa22$export$f6365b0f25aeae62);
const $099e9baa7e7daa22$export$f6365b0f25aeae62 = {
    data: null,
    loading: false,
    error: null
};

});





parcelRegister("8u09c", function(module, exports) {

$parcel$export(module.exports, "ActiveState", () => $07b01345748f10fb$export$2f27df41e8b7edbb);
$parcel$export(module.exports, "VisualState", () => $07b01345748f10fb$export$285eeaa5f468cfb6);
$parcel$export(module.exports, "Product", () => $07b01345748f10fb$export$264ad599d7cef668);
$parcel$export(module.exports, "Environment", () => $07b01345748f10fb$export$7dc6752a22ab011a);
$parcel$export(module.exports, "GspSectionKey", () => $07b01345748f10fb$export$f4906a03a7a2d0af);
$parcel$export(module.exports, "ChecklistTabKey", () => $07b01345748f10fb$export$4f1a05ccc35315c6);
$parcel$export(module.exports, "ProductTourKey", () => $07b01345748f10fb$export$aa90cbc80c330872);
$parcel$export(module.exports, "HeaderState", () => $07b01345748f10fb$export$38aab4015a34ead);
$parcel$export(module.exports, "TaskId", () => $07b01345748f10fb$export$10cc267f702fbadd);
$parcel$export(module.exports, "BasicsTaskIdsProductionised", () => $07b01345748f10fb$export$fe6666d729b0d637);
$parcel$export(module.exports, "TeamEfficiencyTaskIds", () => $07b01345748f10fb$export$ed4dcaac45c6a484);
$parcel$export(module.exports, "ChangesTaskIds", () => $07b01345748f10fb$export$3de0dd66b0de4cdc);
$parcel$export(module.exports, "IncidentsTaskIds", () => $07b01345748f10fb$export$2852680309cf5a68);
$parcel$export(module.exports, "AlertsTaskIds", () => $07b01345748f10fb$export$4f537e3bd8843f30);
$parcel$export(module.exports, "HasSeenReopenSpotlight", () => $07b01345748f10fb$export$72401d057976d548);
$parcel$export(module.exports, "ContainerType", () => $07b01345748f10fb$export$7d7a98f44861e6f7);
$parcel$export(module.exports, "ExplicitStringBoolean", () => $07b01345748f10fb$export$d7341fa10d264a87);
$parcel$export(module.exports, "PropertyKey", () => $07b01345748f10fb$export$e6bec6a1026bf0b4);
var $07b01345748f10fb$export$2f27df41e8b7edbb;
(function(ActiveState) {
    ActiveState["On"] = "on";
    ActiveState["Off"] = "off";
})($07b01345748f10fb$export$2f27df41e8b7edbb || ($07b01345748f10fb$export$2f27df41e8b7edbb = {}));
var $07b01345748f10fb$export$285eeaa5f468cfb6;
(function(VisualState) {
    VisualState["Lozenge"] = "lozenge";
    VisualState["FullPanel"] = "full-panel";
})($07b01345748f10fb$export$285eeaa5f468cfb6 || ($07b01345748f10fb$export$285eeaa5f468cfb6 = {}));
var $07b01345748f10fb$export$264ad599d7cef668;
(function(Product) {
    Product["ServiceDesk"] = "serviceDesk";
    Product["Opsgenie"] = "opsgenie";
})($07b01345748f10fb$export$264ad599d7cef668 || ($07b01345748f10fb$export$264ad599d7cef668 = {}));
var $07b01345748f10fb$export$7dc6752a22ab011a;
(function(Environment) {
    Environment["Local"] = "local";
    Environment["Dev"] = "dev";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
})($07b01345748f10fb$export$7dc6752a22ab011a || ($07b01345748f10fb$export$7dc6752a22ab011a = {}));
var $07b01345748f10fb$export$f4906a03a7a2d0af;
(function(GspSectionKey) {
    GspSectionKey["Checklist"] = "checklist";
    GspSectionKey["ProductTours"] = "productTours";
    GspSectionKey["Home"] = "home";
})($07b01345748f10fb$export$f4906a03a7a2d0af || ($07b01345748f10fb$export$f4906a03a7a2d0af = {}));
var $07b01345748f10fb$export$4f1a05ccc35315c6;
(function(ChecklistTabKey) {
    ChecklistTabKey["Basics"] = "basics";
    ChecklistTabKey["TeamEfficiency"] = "teamEfficiency";
    ChecklistTabKey["Incidents"] = "incidents";
    ChecklistTabKey["Changes"] = "changes";
    ChecklistTabKey["Alerts"] = "alerts";
})($07b01345748f10fb$export$4f1a05ccc35315c6 || ($07b01345748f10fb$export$4f1a05ccc35315c6 = {}));
var $07b01345748f10fb$export$aa90cbc80c330872;
(function(ProductTourKey) {
    ProductTourKey["Welcome"] = "welcome";
    ProductTourKey["IncidentManagement"] = "incident-management";
    ProductTourKey["ChangeManagement"] = "change-management";
})($07b01345748f10fb$export$aa90cbc80c330872 || ($07b01345748f10fb$export$aa90cbc80c330872 = {}));
var $07b01345748f10fb$export$38aab4015a34ead;
(function(HeaderState) {
    HeaderState["Minimized"] = "minimized";
    HeaderState["Expanded"] = "expanded";
})($07b01345748f10fb$export$38aab4015a34ead || ($07b01345748f10fb$export$38aab4015a34ead = {}));
var $07b01345748f10fb$export$10cc267f702fbadd;
(function(TaskId) {
    TaskId["CreateItsmProject"] = "servicedesk-itsm-project-created";
    TaskId["CustomizePortal"] = "servicedesk-portal-name-customized";
    TaskId["AddPortalLogo"] = "servicedesk-logo-added-to-portal";
    TaskId["SetupEmailRequests"] = "servicedesk-email-requests-setup";
    TaskId["SetupChatRequests"] = "servicedesk-chat-requests-setup";
    TaskId["SetupServices"] = "servicedesk-services-setup";
    TaskId["AddTeamMember"] = "servicedesk-team-member-added";
    TaskId["GoBeyondBasics"] = "servicedesk-basics-documentation-accessed";
    TaskId["AutomateYourWork"] = "servicedesk-team-efficiency-automate-your-work";
    TaskId["SetupKnowledgeBase"] = "servicedesk-team-efficiency-setup-knowledge-base";
    TaskId["ConnectCiCdPipeline"] = "servicedesk-change-management-pipeline-connected";
    TaskId["AddChangeApprovers"] = "servicedesk-change-management-change-approvers-added";
    TaskId["TurnOnAutomationRules"] = "servicedesk-change-management-automation-rules-on";
    TaskId["MakeTheMostOfChangeManagement"] = "servicedesk-change-management-documentation-accessed";
    TaskId["SetupProfileForNotifications"] = "opsgenie-user-profile-notifications-setup";
    TaskId["SetupTeam"] = "opsgenie-response-team-setup";
    TaskId["AssignOwnerTeamToServices"] = "opsgenie-owner-team-assigned-to-service";
    TaskId["LevelUpIncidentManagement"] = "opsgenie-incident-management-documentation-accessed";
    TaskId["CustomizeRequestChannels"] = "servicedesk-request-channels-email-portal-requests-customised";
    TaskId["CustomizeRequestTypes"] = "servicedesk-request-types-customised";
    TaskId["ReviewQueueConfigurations"] = "servicedesk-queue-configurations-reviewed";
    TaskId["EnableOpsForTeam"] = "opsgenie-enable-ops-for-team";
    TaskId["ReviewOnCallSetup"] = "opsgenie-review-oncall-setup";
    TaskId["AddIntegration"] = "opsgenie-add-integration";
    TaskId["SetupOpsNotifications"] = "opsgenie-setup-ops-notifications";
    TaskId["ReviewAlerts"] = "opsgenie-review-alerts";
})($07b01345748f10fb$export$10cc267f702fbadd || ($07b01345748f10fb$export$10cc267f702fbadd = {}));
const $07b01345748f10fb$export$9846214c9c3411dc = [
    "servicedesk-itsm-project-created",
    "servicedesk-portal-name-customized",
    "servicedesk-logo-added-to-portal",
    "servicedesk-email-requests-setup",
    "servicedesk-services-setup",
    "servicedesk-team-member-added",
    "servicedesk-basics-documentation-accessed"
];
const $07b01345748f10fb$export$fe6666d729b0d637 = [
    "servicedesk-itsm-project-created",
    "servicedesk-portal-name-customized",
    "servicedesk-email-requests-setup",
    "servicedesk-chat-requests-setup",
    "servicedesk-services-setup",
    "servicedesk-team-member-added"
];
const $07b01345748f10fb$export$ed4dcaac45c6a484 = [
    "servicedesk-team-efficiency-automate-your-work",
    "servicedesk-team-efficiency-setup-knowledge-base"
];
const $07b01345748f10fb$export$3de0dd66b0de4cdc = [
    "servicedesk-change-management-pipeline-connected",
    "servicedesk-change-management-change-approvers-added",
    "servicedesk-change-management-documentation-accessed"
];
const $07b01345748f10fb$export$2852680309cf5a68 = [
    "opsgenie-user-profile-notifications-setup",
    "opsgenie-response-team-setup",
    "opsgenie-owner-team-assigned-to-service",
    "opsgenie-incident-management-documentation-accessed"
];
const $07b01345748f10fb$export$4f537e3bd8843f30 = [
    "opsgenie-enable-ops-for-team",
    "opsgenie-review-oncall-setup",
    "opsgenie-add-integration",
    "opsgenie-setup-ops-notifications",
    "opsgenie-review-alerts"
];
var $07b01345748f10fb$export$72401d057976d548;
(function(HasSeenReopenSpotlight) {
    HasSeenReopenSpotlight["Yes"] = "yes";
    HasSeenReopenSpotlight["No"] = "no";
})($07b01345748f10fb$export$72401d057976d548 || ($07b01345748f10fb$export$72401d057976d548 = {}));
var $07b01345748f10fb$export$7d7a98f44861e6f7;
(function(ContainerType) {
    ContainerType["Project"] = "project";
})($07b01345748f10fb$export$7d7a98f44861e6f7 || ($07b01345748f10fb$export$7d7a98f44861e6f7 = {}));
var $07b01345748f10fb$export$d7341fa10d264a87;
(function(ExplicitStringBoolean) {
    ExplicitStringBoolean["Yes"] = "yes";
    ExplicitStringBoolean["No"] = "no";
})($07b01345748f10fb$export$d7341fa10d264a87 || ($07b01345748f10fb$export$d7341fa10d264a87 = {}));
var $07b01345748f10fb$export$e6bec6a1026bf0b4;
(function(PropertyKey) {
    PropertyKey["VisualState"] = "visualState";
    PropertyKey["ActiveState"] = "activeState";
    PropertyKey["SectionState"] = "sectionState";
    PropertyKey["HasSeenReopenSpotlight"] = "hasSeenReopenSpotlight";
})($07b01345748f10fb$export$e6bec6a1026bf0b4 || ($07b01345748f10fb$export$e6bec6a1026bf0b4 = {}));

});

parcelRegister("dIgUk", function(module, exports) {

$parcel$export(module.exports, "actions", () => $74d379822532afde$export$e324594224ef24da);

var $bqfo7 = parcelRequire("bqfo7");

var $lKOEf = parcelRequire("lKOEf");

var $zvnJx = parcelRequire("zvnJx");

var $82jJZ = parcelRequire("82jJZ");

var $kYwcF = parcelRequire("kYwcF");

var $3ZIER = parcelRequire("3ZIER");

var $aXUph = parcelRequire("aXUph");

var $1mctb = parcelRequire("1mctb");

var $ghO9h = parcelRequire("ghO9h");
const $74d379822532afde$export$e324594224ef24da = {
    initializeState: $lKOEf.initializeState,
    fetchState: $bqfo7.fetchState,
    savePanelState: $3ZIER.savePanelState,
    reopenGettingStartedPanel: $82jJZ.reopenGettingStartedPanel,
    markReopenSpotlightAsSeen: $zvnJx.markReopenSpotlightAsSeen,
    resolveTask: $kYwcF.resolveTask,
    saveProperty: $aXUph.saveProperty,
    stopRecordingPerformanceExperiences: $ghO9h.stopRecordingPerformanceExperiences,
    setOpsAdminTaskVisibility: $1mctb.setOpsAdminTaskVisibility
};

});
parcelRegister("bqfo7", function(module, exports) {

$parcel$export(module.exports, "fetchState", () => $966d678a0c07fdc2$export$f3df9013f2b58bce);

var $1c8hB = parcelRequire("1c8hB");

var $hTLlD = parcelRequire("hTLlD");

var $ldoFd = parcelRequire("ldoFd");

var $feGjZ = parcelRequire("feGjZ");

var $4ZYEI = parcelRequire("4ZYEI");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");


var $1dL7Z = parcelRequire("1dL7Z");

var $isHzQ = parcelRequire("isHzQ");

var $ajx4y = parcelRequire("ajx4y");

var $lKOEf = parcelRequire("lKOEf");
const $966d678a0c07fdc2$export$e15c3a0c2c6f7c69 = {
    RESPONSE_NOT_OBJECT: 'response is not an object',
    RESPONSE_COMPLETED_ITEMS_NOT_ARRAY: 'response.completedItems is not an array',
    RESPONSE_PROPERTIES_NOT_OBJECT: 'response.properties is not an object',
    RESPONSE_PROPERTIES_USER_NOT_OBJECT: 'response.properties.user is not an object',
    RESPONSE_PROPERTIES_USER_SECTION_STATE_NOT_STRING: 'response.properties.user.sectionState is not a string',
    FAILED_PANEL_STATE_JSON_PARSE: 'Failed to parse panelState as JSON'
};
const $966d678a0c07fdc2$var$tryInitializeState = async ({ dispatch: dispatch, ...actionProps })=>{
    const { isProjectTourSeen: isProjectTourSeen, isItsmProject: isItsmProject, projectId: projectId, isItsmSampleProject: isItsmSampleProject, enableOpsTeamMode: enableOpsTeamMode } = actionProps;
    const isNpleForItsmEnabled = (0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
    const hasProject = (isNpleForItsmEnabled || isProjectTourSeen) && isItsmProject && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectId) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isItsmSampleProject);
    if (hasProject || // We will show the alert tab regardless of the project conditions.
    enableOpsTeamMode) await dispatch((0, $lKOEf.initializeState)(actionProps))({
        projectId: projectId
    });
};
const $966d678a0c07fdc2$export$8f32748afb26c81d = (response)=>{
    try {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(response)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_NOT_OBJECT);
        const completedTasks = response?.completedItems;
        const properties = response?.properties;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(completedTasks)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_COMPLETED_ITEMS_NOT_ARRAY);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(properties)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_NOT_OBJECT);
        const userProperties = properties.user;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(userProperties)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_USER_NOT_OBJECT);
        const sectionStateString = userProperties.sectionState;
        if (sectionStateString === undefined) return undefined;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($4ZYEI)))(sectionStateString)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_USER_SECTION_STATE_NOT_STRING);
        try {
            // further validation on this object to be done within the GSP component
            JSON.parse(sectionStateString);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (parseError) {
            throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.FAILED_PANEL_STATE_JSON_PARSE);
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'fetchState_constructDataFromResponse',
                packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                teamName: 'itops-mithril'
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $966d678a0c07fdc2$export$f3df9013f2b58bce = (actionProps)=>({ getState: getState, setState: setState, dispatch: dispatch })=>async ()=>{
            const { isGspInitialized: isGspInitialized, isSaving: isSaving, data: currentData } = getState();
            const { baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent, enableOpsTeamMode: enableOpsTeamMode, teamId: teamId, enableUserCentricMode: enableUserCentricMode } = actionProps;
            // If state is being saved, do not fetch, as it could fetch old state before it has been saved.
            if (isSaving) return;
            // If state is initialized, fetch the state
            if (isGspInitialized) try {
                let response;
                try {
                    response = await (0, $2OdyW.default)((0, $lKOEf.getUrl)({
                        baseUrl: baseUrl,
                        cloudId: cloudId
                    }), {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'include'
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // 404 indicates that the checklist is not yet initialized for the user
                    if (error.statusCode !== 404) throw error;
                }
                // If state is being saved, do not save fetched state,
                // as it will override current state that is being saved.
                if (isSaving) return;
                let data = response ? $966d678a0c07fdc2$export$8f32748afb26c81d(response) : undefined;
                if (enableUserCentricMode && data) data = await (0, $ajx4y.handleUserCentricMode)(data, cloudId);
                else if (enableOpsTeamMode && teamId && data) {
                    const opsAdminTaskVisibility = currentData?.properties.user['ops-admin-tasks-visibility'];
                    data.properties.user['ops-admin-tasks-visibility'] = opsAdminTaskVisibility;
                    data = await (0, $isHzQ.handleOpsTeamMode)(data, teamId, cloudId);
                }
                // Skip unnecessary re-renders caused by the data reference changing
                if (!!data && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(data, currentData)) return;
                setState({
                    data: data,
                    isGspInitialized: !!data
                });
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.fetchState succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if ((0, $1dL7Z.isExpectedError)(error)) return;
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'fetchState',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
            /**
		 * If state is not initialized - try to initialize it
		 * Re-getting isGspInitialized from the getState(), because it might be changed (to false) by the code above
		 */ const { isGspInitialized: currentIsGspInitialized } = getState();
            if (!currentIsGspInitialized) $966d678a0c07fdc2$var$tryInitializeState({
                ...actionProps,
                dispatch: dispatch
            });
        };

});
const $ae3aa738acb13786$export$a72c07e4474ec8ca = 'jiraServicedeskGettingStartedPanel';
const $ae3aa738acb13786$export$47712c7937145142 = 320;
const $ae3aa738acb13786$export$1cad4f611a1c0229 = 220;
const $ae3aa738acb13786$export$b8b9d90f9e5bd72b = 'jiraServicedeskGettingStartedPanel';
const $ae3aa738acb13786$export$bc8b984358922f81 = 'team';
const $ae3aa738acb13786$export$d59a8243d815f2eb = 'jsm-getting-started-panel';
const $ae3aa738acb13786$export$cbbd90bf5df877bd = 'cloudid';
const $ae3aa738acb13786$export$a74074a8f4372ab0 = 'referrer';

parcelRegister("1dL7Z", function(module, exports) {

$parcel$export(module.exports, "isInClassicSettingsPage", () => $1d31dcdfdfe25380$export$a6e1eca03e2de987);
$parcel$export(module.exports, "getCurrentPageName", () => $1d31dcdfdfe25380$export$e2c4f60e8cad01fb);
$parcel$export(module.exports, "isExpectedError", () => $1d31dcdfdfe25380$export$8715824c16ceeca0);
$parcel$export(module.exports, "shouldIncludePathname", () => $1d31dcdfdfe25380$export$83501d9ba065ef89);
$parcel$export(module.exports, "shouldExcludePathname", () => $1d31dcdfdfe25380$export$8752a3c4a740bd52);
$parcel$export(module.exports, "shouldExcludeRouteName", () => $1d31dcdfdfe25380$export$5d52a100c70d4375);
// TODO once all pages that checklist cover are in SPA, we should change this to use matchedRoute instead of pathname

var $2oOo5 = parcelRequire("2oOo5");

var $JRB5w = parcelRequire("JRB5w");
const $1d31dcdfdfe25380$export$d7638addf23014e7 = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+$/.test(pathname);
const $1d31dcdfdfe25380$export$1b685dac913c7026 = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/[\w\W]+$/.test(pathname) || /\/browse\/[\w\W]+$/.test(pathname);
const $1d31dcdfdfe25380$export$a05100bbf8bc68c3 = (pathname)=>/\/projects\/[\w\d]+\/reports/.test(pathname);
const $1d31dcdfdfe25380$export$e75cc3ec1f686973 = (pathname)=>/\/projects\/[\w\d]+\/knowledge/.test(pathname);
const $1d31dcdfdfe25380$export$6292763547421a38 = (pathname)=>/\/projects\/[\w\d]+\/customers$/.test(pathname);
const $1d31dcdfdfe25380$export$35dc6022d31ad167 = (pathname)=>/\/projects\/[\w\d]+\/organization\/[\d]+$/.test(pathname);
const $1d31dcdfdfe25380$export$f8f0d4e52d7e9716 = (pathname)=>$1d31dcdfdfe25380$export$a05100bbf8bc68c3(pathname) && (pathname.endsWith('edit') || pathname.endsWith('new'));
const $1d31dcdfdfe25380$export$753a23d2a857eec = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/edit$/.test(pathname) || /\/projects\/[\w\d]+\/queues\/custom\/new$/.test(pathname);
const $1d31dcdfdfe25380$export$66d002c194bc72aa = (pathname)=>/\/projects\/[\w\d]+\/services\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$430089990bd4af09 = (pathname)=>/\/projects\/[\w\d]+\/on-call-schedule\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$a655a298d384c316 = (pathname)=>/\/projects\/[\w\d]+\/section\/incidents\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$1c5f444b718144b7 = (pathname)=>/\/projects\/[\w\d]+\/section\/problems\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$42dd8a49c7fa462c = (pathname)=>/\/projects\/[\w\d]+\/section\/changes\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$5c77a7ea15a04e63 = (pathname)=>/\/projects\/[\w\d]+\/section\/service-requests\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$dbf902576403f80e = (pathname)=>/\/secure\/project\/EditProject!default.jspa/.test(pathname);
const $1d31dcdfdfe25380$export$458d0b4237ae1dad = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/people/.test(pathname);
const $1d31dcdfdfe25380$export$3b5fbfd2bca32dde = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/summary/.test(pathname);
const $1d31dcdfdfe25380$export$aeffbab88b3257bb = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/issuetypes/.test(pathname);
const $1d31dcdfdfe25380$export$7e3236de8c2c8fcb = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/request-types\/category\/[\w]+/.test(pathname);
const $1d31dcdfdfe25380$export$908f99db4c2098a0 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/change-management/.test(pathname);
const $1d31dcdfdfe25380$export$c5b9a5ba6b3e9b66 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/customer-permissions/.test(pathname);
const $1d31dcdfdfe25380$export$f4e3d864ce1a2f74 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/language/.test(pathname);
const $1d31dcdfdfe25380$export$21361d1ad00e769e = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/portal-settings/.test(pathname);
const $1d31dcdfdfe25380$export$6208845cb364d4de = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/email-settings/.test(pathname);
const $1d31dcdfdfe25380$export$16978d524c086b4 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/email/.test(pathname);
const $1d31dcdfdfe25380$export$b6d6b41b75346458 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/customer-notifications/.test(pathname);
const $1d31dcdfdfe25380$export$5b2153f9a7427657 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/widget/.test(pathname);
const $1d31dcdfdfe25380$export$c5434c69e9b50e81 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/feedback-settings/.test(pathname);
const $1d31dcdfdfe25380$export$3a7002667b72e8d7 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/confluence-kb/.test(pathname);
const $1d31dcdfdfe25380$export$542a1f79f5837827 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/sla/.test(pathname);
const $1d31dcdfdfe25380$export$b748c9dbd5996d34 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/automation/.test(pathname);
const $1d31dcdfdfe25380$export$455a6199a321423 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/apps/.test(pathname);
const $1d31dcdfdfe25380$export$fa426b2da28e4ae2 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/workflows/.test(pathname);
const $1d31dcdfdfe25380$export$fc0fba46b7584812 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/screens/.test(pathname);
const $1d31dcdfdfe25380$export$882325faa1a194c6 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/fields/.test(pathname);
const $1d31dcdfdfe25380$export$8bb0073f55baf38b = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-versions/.test(pathname);
const $1d31dcdfdfe25380$export$1b69f3aa169f179 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-components/.test(pathname);
const $1d31dcdfdfe25380$export$1c47b1cb87da237 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/permissions/.test(pathname);
const $1d31dcdfdfe25380$export$ee56a66aa8efb6da = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/issuesecurity/.test(pathname);
const $1d31dcdfdfe25380$export$6256b4d737fa56f2 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/notifications/.test(pathname);
const $1d31dcdfdfe25380$export$3f77d24f8de610a0 = (pathname)=>/\/secure\/ViewCollectors!default.jspa/.test(pathname);
const $1d31dcdfdfe25380$export$a6e1eca03e2de987 = (pathname)=>$1d31dcdfdfe25380$export$dbf902576403f80e(pathname) || $1d31dcdfdfe25380$export$458d0b4237ae1dad(pathname) || $1d31dcdfdfe25380$export$3b5fbfd2bca32dde(pathname) || $1d31dcdfdfe25380$export$aeffbab88b3257bb(pathname) || $1d31dcdfdfe25380$export$7e3236de8c2c8fcb(pathname) || $1d31dcdfdfe25380$export$908f99db4c2098a0(pathname) || $1d31dcdfdfe25380$export$c5b9a5ba6b3e9b66(pathname) || $1d31dcdfdfe25380$export$f4e3d864ce1a2f74(pathname) || $1d31dcdfdfe25380$export$21361d1ad00e769e(pathname) || $1d31dcdfdfe25380$export$6208845cb364d4de(pathname) || $1d31dcdfdfe25380$export$16978d524c086b4(pathname) || $1d31dcdfdfe25380$export$b6d6b41b75346458(pathname) || $1d31dcdfdfe25380$export$5b2153f9a7427657(pathname) || $1d31dcdfdfe25380$export$c5434c69e9b50e81(pathname) || $1d31dcdfdfe25380$export$3a7002667b72e8d7(pathname) || $1d31dcdfdfe25380$export$542a1f79f5837827(pathname) || $1d31dcdfdfe25380$export$b748c9dbd5996d34(pathname) || $1d31dcdfdfe25380$export$455a6199a321423(pathname) || $1d31dcdfdfe25380$export$fa426b2da28e4ae2(pathname) || $1d31dcdfdfe25380$export$fc0fba46b7584812(pathname) || $1d31dcdfdfe25380$export$882325faa1a194c6(pathname) || $1d31dcdfdfe25380$export$8bb0073f55baf38b(pathname) || $1d31dcdfdfe25380$export$1b69f3aa169f179(pathname) || $1d31dcdfdfe25380$export$1c47b1cb87da237(pathname) || $1d31dcdfdfe25380$export$ee56a66aa8efb6da(pathname) || $1d31dcdfdfe25380$export$6256b4d737fa56f2(pathname) || $1d31dcdfdfe25380$export$3f77d24f8de610a0(pathname);
const $1d31dcdfdfe25380$var$screenNameMap = {
    queues: $1d31dcdfdfe25380$export$d7638addf23014e7,
    issues: $1d31dcdfdfe25380$export$1b685dac913c7026,
    customers: $1d31dcdfdfe25380$export$6292763547421a38,
    reports: $1d31dcdfdfe25380$export$a05100bbf8bc68c3,
    knowledge: $1d31dcdfdfe25380$export$e75cc3ec1f686973,
    services: $1d31dcdfdfe25380$export$66d002c194bc72aa,
    onCall: $1d31dcdfdfe25380$export$430089990bd4af09,
    incidents: $1d31dcdfdfe25380$export$a655a298d384c316,
    problems: $1d31dcdfdfe25380$export$1c5f444b718144b7,
    changes: $1d31dcdfdfe25380$export$42dd8a49c7fa462c,
    serviceRequests: $1d31dcdfdfe25380$export$5c77a7ea15a04e63,
    classicSettingsDetails: $1d31dcdfdfe25380$export$dbf902576403f80e,
    classicSettingsPeople: $1d31dcdfdfe25380$export$458d0b4237ae1dad,
    classicSettingsSummary: $1d31dcdfdfe25380$export$3b5fbfd2bca32dde,
    classicSettingsIssueTypes: $1d31dcdfdfe25380$export$aeffbab88b3257bb,
    classicSettingsRequestTypes: $1d31dcdfdfe25380$export$7e3236de8c2c8fcb,
    classicSettingsChangeManagement: $1d31dcdfdfe25380$export$908f99db4c2098a0,
    classicSettingsCustomerPermissions: $1d31dcdfdfe25380$export$c5b9a5ba6b3e9b66,
    classicSettingsLanguage: $1d31dcdfdfe25380$export$f4e3d864ce1a2f74,
    classicSettingsPortal: $1d31dcdfdfe25380$export$21361d1ad00e769e,
    classicSettingsEmail: $1d31dcdfdfe25380$export$6208845cb364d4de,
    classicSettingsEmailAlias: $1d31dcdfdfe25380$export$16978d524c086b4,
    classicSettingsCustomerNotifications: $1d31dcdfdfe25380$export$b6d6b41b75346458,
    classicSettingsWidget: $1d31dcdfdfe25380$export$5b2153f9a7427657,
    classicSettingsFeedback: $1d31dcdfdfe25380$export$c5434c69e9b50e81,
    classicSettingsConfluence: $1d31dcdfdfe25380$export$3a7002667b72e8d7,
    classicSettingsSla: $1d31dcdfdfe25380$export$542a1f79f5837827,
    classicSettingsAutomation: $1d31dcdfdfe25380$export$b748c9dbd5996d34,
    classicSettingsApps: $1d31dcdfdfe25380$export$455a6199a321423,
    classicSettingsWorkflows: $1d31dcdfdfe25380$export$fa426b2da28e4ae2,
    classicSettingsScreens: $1d31dcdfdfe25380$export$fc0fba46b7584812,
    classicSettingsFields: $1d31dcdfdfe25380$export$882325faa1a194c6,
    classicSettingsVersions: $1d31dcdfdfe25380$export$8bb0073f55baf38b,
    classicSettingsComponents: $1d31dcdfdfe25380$export$1b69f3aa169f179,
    classicSettingsPermissions: $1d31dcdfdfe25380$export$1c47b1cb87da237,
    classicSettingsIssueSecurity: $1d31dcdfdfe25380$export$ee56a66aa8efb6da,
    classicSettingsNotifications: $1d31dcdfdfe25380$export$6256b4d737fa56f2,
    classicSettingsIssueCollectors: $1d31dcdfdfe25380$export$3f77d24f8de610a0
};
const $1d31dcdfdfe25380$export$e2c4f60e8cad01fb = (pathname)=>(0, (/*@__PURE__*/$parcel$interopDefault($2oOo5)))($1d31dcdfdfe25380$var$screenNameMap, (isCurrentScreen)=>isCurrentScreen(pathname)) || '';
const $1d31dcdfdfe25380$export$8715824c16ceeca0 = (error)=>// these are out of our control so treat them as expected
    (0, $JRB5w.isClientFetchError)(error);
const $1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER = {
    pathnameRegexes: [
        // 'Classic Settings Customer Notifications',
        '/servicedesk/admin/[\\w\\d]+/customer-notifications'
    ],
    pathnameRegexesForNple: [
        // 'Classic Settings Customer Notifications',
        '/servicedesk/admin/[\\w\\d]+/customer-notifications',
        // 'Portal Settings Page'
        '/jira/servicedesk/projects/[\\w\\d]+/settings/portal-settings',
        // 'People Page'
        '/plugins/servlet/project-config/[\\w\\d]+/people',
        // 'Getting Started Page'
        '/jira/servicedesk/projects/[\\w\\d]+/getting-started'
    ],
    routeNames: [
        // 'Reports',
        'servicedesk-reports',
        // 'Reports - Custom',
        'servicedesk-reports-custom',
        // 'Reports - Create',
        'servicedesk-reports-custom-create',
        // 'Reports - Edit',
        'servicedesk-reports-custom-edit',
        // 'Reports - Time Scale Issue',
        'servicedesk-reports-custom-time-scale-issue',
        // 'Reports - Time Scale',
        'servicedesk-reports-custom-time-scale',
        // 'Reports - Satisfaction',
        'servicedesk-reports-satisfaction',
        // 'Reports - Satisfaction Time Scale Issue',
        'servicedesk-reports-satisfaction-time-scale-issue',
        // 'Reports - Satisfaction TIme Scale',
        'servicedesk-reports-satisfaction-time-scale',
        // 'Reports - Summary',
        'servicedesk-reports-summary',
        // 'Reports - Type',
        'servicedesk-reports-type',
        // 'Reports - Workload',
        'servicedesk-reports-workload',
        // 'Queues - New',
        'servicedesk-queues-new',
        // 'Queues - Edit',
        'servicedesk-queues-edit'
    ]
};
const $1d31dcdfdfe25380$var$GSP_INCLUDED_PAGES_FILTER = {
    pathnameRegexes: [
        '/jira/people/search'
    ]
};
const $1d31dcdfdfe25380$export$83501d9ba065ef89 = (pathname)=>$1d31dcdfdfe25380$var$GSP_INCLUDED_PAGES_FILTER.pathnameRegexes.some((regex)=>new RegExp(regex).test(pathname));
const $1d31dcdfdfe25380$export$8752a3c4a740bd52 = (pathname, isNpleForItsmEnabled)=>isNpleForItsmEnabled ? $1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER.pathnameRegexesForNple.some((regex)=>new RegExp(regex).test(pathname)) : $1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER.pathnameRegexes.some((regex)=>new RegExp(regex).test(pathname));
const $1d31dcdfdfe25380$export$5d52a100c70d4375 = (currentRouteName)=>$1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER.routeNames.some((routeName)=>routeName === currentRouteName);

});
parcelRegister("2oOo5", function(module, exports) {

var $1FGIk = parcelRequire("1FGIk");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */ function $1bf4e8901877f248$var$findKey(object, predicate) {
    return $1FGIk(object, $7qARj(predicate, 3), $piimr);
}
module.exports = $1bf4e8901877f248$var$findKey;

});
parcelRegister("1FGIk", function(module, exports) {
/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */ function $137ac0dffc9def22$var$baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
            result = key;
            return false;
        }
    });
    return result;
}
module.exports = $137ac0dffc9def22$var$baseFindKey;

});



parcelRegister("isHzQ", function(module, exports) {

$parcel$export(module.exports, "handleOpsTeamMode", () => $c920f201dd81d401$export$b05151222ac96edd);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $8u09c = parcelRequire("8u09c");
var $4eEU1 = parcelRequire("4eEU1");
async function $c920f201dd81d401$export$b05151222ac96edd(data, teamId, cloudId) {
    const mutatedData = {
        ...data
    };
    // we need to unset team centric items if they are set in the project page for the user
    mutatedData.completedItems = mutatedData.completedItems.filter((item)=>{
        if (item === (0, $8u09c.TaskId).ReviewOnCallSetup || item === (0, $8u09c.TaskId).AddIntegration) return false;
        return true;
    });
    // If user has not have right to see those items, we don't need to fetch them.
    if (mutatedData.properties.user['ops-admin-tasks-visibility'] === (0, $4eEU1.VisibilityValues).Visible) try {
        const teamCentricResponse = await (0, $2OdyW.default)(`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/team/${teamId}/list/jsm-getting-started-panel`, {
            method: 'GET',
            mode: 'cors'
        });
        // we will override completed items by setting team-centric items
        mutatedData.completedItems = [
            ...mutatedData?.completedItems,
            ...teamCentricResponse?.completedItems
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The list is not initialized yet
        if (error.statusCode !== 404) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'handleOpsTeamMode-TeamCentricResponse',
                    packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                    teamName: 'Alexstrasza'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return mutatedData;
}

});
parcelRegister("4eEU1", function(module, exports) {

$parcel$export(module.exports, "OpsVisibilityKeys", () => $5d00ee66e441ccba$export$3cae6a891a2fb0c1);
$parcel$export(module.exports, "SdVisibilityKeys", () => $5d00ee66e441ccba$export$9ffa2df2d13a51e4);
$parcel$export(module.exports, "OgVisibilityKeys", () => $5d00ee66e441ccba$export$37aa46ee833f23f2);
$parcel$export(module.exports, "VisibilityValues", () => $5d00ee66e441ccba$export$b715b908ae0969fa);
$parcel$export(module.exports, "SdVisibilityRoles", () => $5d00ee66e441ccba$export$47a23917fcedd235);
var $5d00ee66e441ccba$export$3cae6a891a2fb0c1;
(function(OpsVisibilityKeys) {
    OpsVisibilityKeys["OpsTasksVisibility"] = "ops-tasks-visibility";
    OpsVisibilityKeys["OpsAdminTasksVisibility"] = "ops-admin-tasks-visibility";
})($5d00ee66e441ccba$export$3cae6a891a2fb0c1 || ($5d00ee66e441ccba$export$3cae6a891a2fb0c1 = {}));
var $5d00ee66e441ccba$export$9ffa2df2d13a51e4;
(function(SdVisibilityKeys) {
    SdVisibilityKeys["SdStandardTasksVisibility"] = "servicedesk-standard-tasks-visibility";
    SdVisibilityKeys["SdAdvancedTasksVisibility"] = "servicedesk-advanced-tasks-visibility";
})($5d00ee66e441ccba$export$9ffa2df2d13a51e4 || ($5d00ee66e441ccba$export$9ffa2df2d13a51e4 = {}));
var $5d00ee66e441ccba$export$37aa46ee833f23f2;
(function(OgVisibilityKeys) {
    OgVisibilityKeys["OgSetupProfileForNotificationsTaskVisibility"] = "opsgenie-user-profile-notifications-setup-task-visibility";
    OgVisibilityKeys["OgSetupTeamTaskVisibility"] = "opsgenie-response-team-setup-task-visibility";
    OgVisibilityKeys["OgAssignOwnerTeamToServicesTaskVisibility"] = "opsgenie-owner-team-assigned-to-service-task-visibility";
    OgVisibilityKeys["OgLevelUpIncidentManagementTaskVisibility"] = "opsgenie-incident-management-documentation-accessed-task-visibility";
})($5d00ee66e441ccba$export$37aa46ee833f23f2 || ($5d00ee66e441ccba$export$37aa46ee833f23f2 = {}));
var $5d00ee66e441ccba$export$b715b908ae0969fa;
(function(VisibilityValues) {
    VisibilityValues["Hidden"] = "hidden";
    VisibilityValues["Visible"] = "visible";
    VisibilityValues["Unset"] = "unset";
})($5d00ee66e441ccba$export$b715b908ae0969fa || ($5d00ee66e441ccba$export$b715b908ae0969fa = {}));
var $5d00ee66e441ccba$export$47a23917fcedd235;
(function(SdVisibilityRoles) {
    SdVisibilityRoles["Advanced"] = "advanced";
    SdVisibilityRoles["Standard"] = "standard";
})($5d00ee66e441ccba$export$47a23917fcedd235 || ($5d00ee66e441ccba$export$47a23917fcedd235 = {}));

});


parcelRegister("ajx4y", function(module, exports) {

$parcel$export(module.exports, "handleUserCentricMode", () => $07f045f9f08d9204$export$10caa25085bdca55);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $8u09c = parcelRequire("8u09c");
async function $07f045f9f08d9204$export$10caa25085bdca55(data, cloudId) {
    const mutatedData = {
        ...data
    };
    // we need to unset user centric items if they are set in the ops team page for that user
    mutatedData.completedItems = mutatedData.completedItems.filter((item)=>{
        if (item === (0, $8u09c.TaskId).ReviewOnCallSetup || item === (0, $8u09c.TaskId).AddIntegration) return false;
        return true;
    });
    try {
        const userCentricResponse = await (0, $2OdyW.default)(`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel`, {
            method: 'GET',
            mode: 'cors'
        });
        // we will override completed items by getting/setting user-centric endpoint
        const userCentricCompletedItems = userCentricResponse.completedItems.filter((item)=>{
            if (item === (0, $8u09c.TaskId).ReviewOnCallSetup || item === (0, $8u09c.TaskId).AddIntegration) return true;
            return false;
        });
        mutatedData.completedItems = [
            ...mutatedData.completedItems,
            ...userCentricCompletedItems
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The list is not initialized yet
        if (error.statusCode !== 404) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'handleUserCentricMode-UserCentricResponse',
                    packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                    teamName: 'Alexstrasza'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return mutatedData;
}

});

parcelRegister("lKOEf", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $7814cf240c11be32$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "initializeState", () => $7814cf240c11be32$export$3ee49b4c70c0ec29);

var $ldoFd = parcelRequire("ldoFd");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");


var $3gGTI = parcelRequire("3gGTI");

var $8GtZ0 = parcelRequire("8GtZ0");
var $4eEU1 = parcelRequire("4eEU1");

var $isHzQ = parcelRequire("isHzQ");

var $ajx4y = parcelRequire("ajx4y");

var $3ZIER = parcelRequire("3ZIER");
const $7814cf240c11be32$export$94df0e59ebebf4a7 = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/aggregate/list/jsm-getting-started-panel`;
const $7814cf240c11be32$export$3ee49b4c70c0ec29 = (actionProps)=>({ setState: setState, getState: getState, dispatch: dispatch })=>async ({ projectId: projectId })=>{
            const { baseUrl: baseUrl, cloudId: cloudId, isItsmSampleProject: isItsmSampleProject, createAnalyticsEvent: createAnalyticsEvent, enableOpsTeamMode: enableOpsTeamMode, teamId: teamId, enableUserCentricMode: enableUserCentricMode } = actionProps;
            // Do not initialize unless it's known that project is not sample ITSM project
            if (isItsmSampleProject !== false) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isItsmSampleProject)) (0, $guiFP.default)({
                    meta: {
                        id: 'initializeState_isItsmSampleProject_unknown',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    }
                });
                return;
            }
            const initializeStateOnce = async (attemptIndex, totalAttempts)=>{
                const isFinalAttempt = attemptIndex === totalAttempts - 1;
                // Stop any other updates to the state that might occur
                setState({
                    isSaving: true
                });
                // Fetch any existing data from ST (this will include any task visibility keys)
                let response;
                try {
                    response = await (0, $2OdyW.default)($7814cf240c11be32$export$94df0e59ebebf4a7({
                        baseUrl: baseUrl,
                        cloudId: cloudId
                    }), {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'include'
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // 404 indicates that the checklist is not yet initialized for the user
                    if (error.statusCode === 404) {
                        setState({
                            isSaving: false,
                            isGspInitialized: false
                        });
                        return;
                    }
                    setState({
                        isSaving: false
                    });
                    if (isFinalAttempt) (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'initializeState_fetch',
                            packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    throw error;
                }
                // TODO: validate properly https://jdog.jira-dev.com/browse/JIG-392
                // We can't use constructDataFromResponse because initial server data only
                // contains a subset of the full GSP state (just task visiblity keys)
                const serverData = response;
                /* Merge in server values and defaults, according to the following:
			 *  - completedItems from default state, to allow for reset behaviour with FSF override flag
			 *  - properties comes from server values first, to add task visibility and non-user properties
			 *  - default state user properties are merged in over the top of server properties to reset
			 *    things like sectionState, activeState, visualState, hasSeenReopenSpotlight in the
			 *    case of FSF override flag where server state already exists.
			 *    Assumption: the only properties contained in the default state are user properties
			 *  - projectId from current project
			 */ let data = {
                    completedItems: (0, $8GtZ0.defaultGspState).completedItems,
                    properties: {
                        ...serverData.properties,
                        user: {
                            ...serverData.properties.user,
                            ...(0, $8GtZ0.defaultGspState).properties.user,
                            projectId: projectId
                        }
                    }
                };
                if (enableUserCentricMode && data) data = await (0, $ajx4y.handleUserCentricMode)(data, cloudId);
                else if (enableOpsTeamMode && teamId && data) {
                    const opsAdminTaskVisibility = getState().data?.properties.user['ops-admin-tasks-visibility'] ?? (0, $4eEU1.VisibilityValues).Hidden;
                    data.properties.user['ops-admin-tasks-visibility'] = opsAdminTaskVisibility;
                    data = await (0, $isHzQ.handleOpsTeamMode)(data, teamId, cloudId);
                }
                // Save our newly merged state
                try {
                    setState({
                        data: data,
                        isGspInitialized: true,
                        isSaving: false
                    });
                    await dispatch((0, $3ZIER.savePanelState)(actionProps))(data);
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.initializeState succeeded`);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    setState({
                        isGspInitialized: true,
                        isSaving: false
                    });
                    if (isFinalAttempt) (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'initializeState',
                            packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            };
            await (0, $3gGTI.withExponentialBackoffRetries)({
                callback: initializeStateOnce,
                totalAttempts: 5,
                baseIntervalMs: 500
            });
        };

});
parcelRegister("3gGTI", function(module, exports) {

$parcel$export(module.exports, "withExponentialBackoffRetries", () => $06938d82719cce50$export$344601bd15a7b6d);
const $06938d82719cce50$var$waitTimeMs = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $06938d82719cce50$export$344601bd15a7b6d = async ({ callback: callback, totalAttempts: totalAttempts, baseIntervalMs: baseIntervalMs })=>{
    for(let attemptIndex = 0; attemptIndex < totalAttempts; attemptIndex += 1)/* eslint-disable no-await-in-loop */ try {
        return await callback(attemptIndex, totalAttempts);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (attemptIndex + 1 < totalAttempts) // if retry attempts remain, wait time before trying again
        await $06938d82719cce50$var$waitTimeMs(baseIntervalMs * Math.pow(2, attemptIndex));
        else // else if no more attempts, throw the error
        throw error;
    }
    throw Error('withExponentialBackoffRetries should not reach');
};

});

parcelRegister("8GtZ0", function(module, exports) {

$parcel$export(module.exports, "defaultGspState", () => $72b93b78f031cb2c$export$4db8363977bdf2d4);
$parcel$export(module.exports, "GSP", () => $72b93b78f031cb2c$export$1cb8c028028700ec);

var $8u09c = parcelRequire("8u09c");
// This is duplicated to avoid importing from section-state
// to attempt to keep bundle size down.
// These values must be manually kept in sync.
const $72b93b78f031cb2c$var$defaultSectionStateV2 = {
    version: 2,
    activeSection: (0, $8u09c.GspSectionKey).Home,
    sections: {
        checklist: {
            headerState: (0, $8u09c.HeaderState).Expanded,
            activeTab: (0, $8u09c.ChecklistTabKey).Basics,
            tabs: {
                basics: {
                    activeTask: undefined
                },
                teamEfficiency: {
                    activeTask: undefined
                },
                incidents: {
                    activeTask: undefined
                },
                changes: {
                    activeTask: undefined
                },
                alerts: {
                    activeTask: undefined
                }
            }
        },
        productTours: {
            headerState: (0, $8u09c.HeaderState).Expanded,
            activeTour: (0, $8u09c.ProductTourKey).Welcome
        }
    }
};
const $72b93b78f031cb2c$export$4db8363977bdf2d4 = {
    completedItems: [
        (0, $8u09c.TaskId).CreateItsmProject
    ],
    properties: {
        containers: [],
        user: {
            activeState: (0, $8u09c.ActiveState).On,
            visualState: (0, $8u09c.VisualState).FullPanel,
            sectionState: JSON.stringify($72b93b78f031cb2c$var$defaultSectionStateV2),
            hasSeenReopenSpotlight: (0, $8u09c.HasSeenReopenSpotlight).No
        }
    }
};
const $72b93b78f031cb2c$export$1cb8c028028700ec = 'GettingStartedPanel';

});

parcelRegister("3ZIER", function(module, exports) {

$parcel$export(module.exports, "savePanelState", () => $98e7316a9047ea56$export$8756ef0989d9dd58);

var $guiFP = parcelRequire("guiFP");

var $5G2eQ = parcelRequire("5G2eQ");

var $jMP2a = parcelRequire("jMP2a");


var $3gGTI = parcelRequire("3gGTI");
const $98e7316a9047ea56$var$getUrl = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel/properties`;
const $98e7316a9047ea56$export$8756ef0989d9dd58 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async (state)=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to save panel state without current GSP state.');
                // Set the state locally without waiting for the API call
                setState({
                    data: state,
                    isSaving: true
                });
                const { sectionState: sectionState, activeState: activeState, visualState: visualState, projectId: projectId, hasSeenReopenSpotlight: hasSeenReopenSpotlight } = state.properties.user;
                await (0, $3gGTI.withExponentialBackoffRetries)({
                    callback: ()=>(0, $5G2eQ.default)($98e7316a9047ea56$var$getUrl({
                            baseUrl: baseUrl,
                            cloudId: cloudId
                        }), {
                            method: 'POST',
                            credentials: 'include',
                            body: JSON.stringify({
                                sectionState: sectionState,
                                activeState: activeState,
                                visualState: visualState,
                                projectId: projectId,
                                hasSeenReopenSpotlight: hasSeenReopenSpotlight
                            })
                        }).toPromise(),
                    totalAttempts: 5,
                    baseIntervalMs: 500
                });
                setState({
                    isSaving: false
                });
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.savePanelState succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'savePanelState',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});
parcelRegister("5G2eQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d9fb25724578ccf$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $bH2vr = parcelRequire("bH2vr");

var $etaBp = parcelRequire("etaBp");
const $0d9fb25724578ccf$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$0d9fb25724578ccf$export$2e2bcd8739ae039 = (url, options = {})=>(0, $3JafE.Observable).of(url).mergeMap(()=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), options), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $7byHA.default)(status);
        }
        if (response.status === $0d9fb25724578ccf$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $3JafE.Observable).of(response.responseText || 'OK');
    });

});




parcelRegister("zvnJx", function(module, exports) {

$parcel$export(module.exports, "markReopenSpotlightAsSeen", () => $63ec54d2a46c288c$export$e6838fe71dc9c3f5);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");


var $8u09c = parcelRequire("8u09c");

var $3ZIER = parcelRequire("3ZIER");
const $63ec54d2a46c288c$export$e6838fe71dc9c3f5 = (actionProps)=>({ getState: getState, dispatch: dispatch })=>async ()=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to mark reopen spotlight as seen without current state');
                await dispatch((0, $3ZIER.savePanelState)(actionProps))({
                    ...data,
                    properties: {
                        ...data.properties,
                        user: {
                            ...data.properties.user,
                            hasSeenReopenSpotlight: (0, $8u09c.HasSeenReopenSpotlight).Yes
                        }
                    }
                });
                (0, $jMP2a.fireTrackAnalytics)(actionProps.createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.markReopenSpotlightAsSeen succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'markReopenSpotlightAsSeen',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});

parcelRegister("82jJZ", function(module, exports) {

$parcel$export(module.exports, "reopenGettingStartedPanel", () => $e6623632044ca83f$export$3f8a23b1578c0a37);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");


var $3gGTI = parcelRequire("3gGTI");

var $8u09c = parcelRequire("8u09c");

var $lKOEf = parcelRequire("lKOEf");

var $aXUph = parcelRequire("aXUph");
const $e6623632044ca83f$export$3f8a23b1578c0a37 = (actionProps)=>({ getState: getState, dispatch: dispatch })=>async ({ projectId: projectId } = {})=>{
            const getStateIfLoaded = async ()=>{
                const state = getState();
                const dataNotYetLoaded = state.isGspInitialized && state.data === undefined;
                if (dataNotYetLoaded) throw new Error('GSP data not yet loaded when trying to reopen');
                return state;
            };
            try {
                // a user can exit a tour and call `reopenGettingStartedPanel` before the GSP
                // state has loaded so retry a few times and hopefully the data will be there.
                // This will only log the final error that is thrown after the retries are exhausted.
                // 6 attempts at 500ms base interval gives us a ~15 second window. We could wait longer
                // but then the GSP reopening would be so far removed from closing the tour that it
                // probably isn't the user experience that we want
                const { data: data, isGspInitialized: isGspInitialized } = await (0, $3gGTI.withExponentialBackoffRetries)({
                    callback: getStateIfLoaded,
                    totalAttempts: 6,
                    baseIntervalMs: 500
                });
                if (!isGspInitialized) {
                    if (projectId !== undefined) {
                        await dispatch((0, $lKOEf.initializeState)(actionProps))({
                            projectId: projectId
                        });
                        return;
                    }
                    throw new Error('No projectId to initialize GSP with');
                }
                if (!data) throw new Error('Trying to reopen GSP without current state');
                await dispatch((0, $aXUph.saveProperty)(actionProps))({
                    key: (0, $8u09c.PropertyKey).VisualState,
                    value: (0, $8u09c.VisualState).FullPanel
                });
                await dispatch((0, $aXUph.saveProperty)(actionProps))({
                    key: (0, $8u09c.PropertyKey).ActiveState,
                    value: (0, $8u09c.ActiveState).On
                });
                (0, $jMP2a.fireTrackAnalytics)(actionProps.createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.reopenGettingStartedPanel succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'reopenGettingStartedPanel',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});
parcelRegister("aXUph", function(module, exports) {

$parcel$export(module.exports, "saveProperty", () => $4fd2e9e2afb8272e$export$3d751d226e9d1512);

var $guiFP = parcelRequire("guiFP");

var $5G2eQ = parcelRequire("5G2eQ");

var $jMP2a = parcelRequire("jMP2a");


var $3gGTI = parcelRequire("3gGTI");
const $4fd2e9e2afb8272e$var$getUrl = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel/properties`;
const $4fd2e9e2afb8272e$export$3d751d226e9d1512 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async ({ key: key, value: value })=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to save property without current GSP state.');
                // Set the state locally without waiting for the API call
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                [key.toString()]: value
                            }
                        }
                    },
                    isSaving: true
                });
                await (0, $3gGTI.withExponentialBackoffRetries)({
                    callback: ()=>(0, $5G2eQ.default)($4fd2e9e2afb8272e$var$getUrl({
                            baseUrl: baseUrl,
                            cloudId: cloudId
                        }), {
                            method: 'POST',
                            credentials: 'include',
                            body: JSON.stringify({
                                [key.toString()]: value
                            })
                        }).toPromise(),
                    totalAttempts: 5,
                    baseIntervalMs: 500
                });
                setState({
                    isSaving: false
                });
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.saveProperty succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'saveProperty',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };

});


parcelRegister("kYwcF", function(module, exports) {

$parcel$export(module.exports, "resolveTask", () => $e0acf0603356b206$export$7c43f246bcca61d3);

var $guiFP = parcelRequire("guiFP");

var $5G2eQ = parcelRequire("5G2eQ");

var $jMP2a = parcelRequire("jMP2a");


var $3gGTI = parcelRequire("3gGTI");

var $6vrw7 = parcelRequire("6vrw7");
// Data taken from https://hello.atlassian.net/wiki/spaces/VPORT/pages/808505558/Checklist+Item+Scope+Auto+API+for+Completion
// where 'project' === 'container', 'user' === 'user' and 'instance' === 'workspace'
const $e0acf0603356b206$var$getScopeFromTaskId = (taskId)=>{
    switch(taskId){
        // String literals used instead of `TaskId.<task>` for flow to acknowledge
        // that this is an exhaustive switch statement
        case 'servicedesk-itsm-project-created':
        case 'servicedesk-portal-name-customized':
        case 'servicedesk-logo-added-to-portal':
        case 'servicedesk-email-requests-setup':
        case 'servicedesk-team-member-added':
            return 'container';
        case 'servicedesk-change-management-documentation-accessed':
        case 'servicedesk-basics-documentation-accessed':
        case 'servicedesk-queue-configurations-reviewed':
        case 'servicedesk-request-types-customised':
        case 'servicedesk-request-channels-email-portal-requests-customised':
        case 'servicedesk-chat-requests-setup':
            return 'user';
        case 'servicedesk-services-setup':
        case 'servicedesk-change-management-pipeline-connected':
        case 'servicedesk-change-management-change-approvers-added':
        case 'servicedesk-change-management-automation-rules-on':
            return 'workspace';
        // Note that the following should only ever be completed in
        // Opsgenie but they are included here for type completeness
        case 'opsgenie-user-profile-notifications-setup':
        case 'opsgenie-incident-management-documentation-accessed':
            return 'user';
        case 'opsgenie-response-team-setup':
        case 'opsgenie-owner-team-assigned-to-service':
            return 'workspace';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            taskId; // type level assertion that we have an exhaustive switch
            throw new Error(`Unknown scope for task ${taskId}`); // runtime assertion
    }
};
const $e0acf0603356b206$export$94df0e59ebebf4a7 = ({ baseUrl: baseUrl, cloudId: cloudId, scope: scope, projectId: projectId, taskId: taskId })=>{
    let scopePath = ''; // scope === 'workspace'
    if (scope === 'container') scopePath = `project/${projectId}/`;
    if (scope === 'user') scopePath = 'user/';
    return `${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/${scopePath}list/jsm-getting-started-panel/item/${taskId}`;
};
const $e0acf0603356b206$export$7c43f246bcca61d3 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async (taskId)=>{
            const { data: data } = getState();
            try {
                if (!data) return;
                const { completedItems: completedItems, properties: properties } = data;
                const isTaskAlreadyCompleted = completedItems.includes(taskId);
                if (!isTaskAlreadyCompleted) {
                    const updatedTasks = [
                        ...completedItems,
                        taskId
                    ];
                    // Set the state locally without waiting for the API call
                    setState({
                        data: {
                            ...data,
                            completedItems: updatedTasks
                        },
                        isSaving: true
                    });
                    // Hit the appropriate checklist scope endpoint to add the newly completed task
                    const scope = $e0acf0603356b206$var$getScopeFromTaskId(taskId);
                    const projectId = (0, $6vrw7.toProjectId)(properties.user.projectId || '');
                    await (0, $3gGTI.withExponentialBackoffRetries)({
                        callback: ()=>(0, $5G2eQ.default)($e0acf0603356b206$export$94df0e59ebebf4a7({
                                baseUrl: baseUrl,
                                cloudId: cloudId,
                                scope: scope,
                                projectId: projectId,
                                taskId: taskId
                            }), {
                                method: 'POST',
                                credentials: 'include'
                            }).toPromise(),
                        totalAttempts: 5,
                        baseIntervalMs: 500
                    });
                    // Resume polling for GSP state
                    setState({
                        isSaving: false
                    });
                }
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.resolveTask succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'resolveTask',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});

parcelRegister("1mctb", function(module, exports) {

$parcel$export(module.exports, "setOpsAdminTaskVisibility", () => $ac16bf64e18ce8db$export$b9e7846826f1ebfd);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $4eEU1 = parcelRequire("4eEU1");
const $ac16bf64e18ce8db$export$b9e7846826f1ebfd = ({ teamId: teamId, cloudId: cloudId })=>({ getState: getState, setState: setState })=>async ()=>{
            const { data: data } = getState();
            if (!data) throw new Error('Trying to set ops admin task visibility without current GSP state.');
            try {
                const adminTaskVisibilityResponse = await (0, $2OdyW.default)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/full-panel-access?platformTeamId=${teamId}
            `, {
                    method: 'GET'
                });
                const visibility = adminTaskVisibilityResponse.embeddedValue ? (0, $4eEU1.VisibilityValues).Visible : (0, $4eEU1.VisibilityValues).Hidden;
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                'ops-admin-tasks-visibility': visibility
                            }
                        }
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                'ops-admin-tasks-visibility': (0, $4eEU1.VisibilityValues).Hidden
                            }
                        }
                    }
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'setOpsAdminTaskVisibility',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'Alexstrasza'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };

});

parcelRegister("ghO9h", function(module, exports) {

$parcel$export(module.exports, "stopRecordingPerformanceExperiences", () => $73f30f16f4664d6e$export$3566fd94709fa84a);
const $73f30f16f4664d6e$export$3566fd94709fa84a = ()=>({ setState: setState })=>()=>{
            setState({
                shouldRecordPerformanceExperiences: false
            });
        };

});



parcelRegister("kKzsy", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $993d872dc7228c2f$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $993d872dc7228c2f$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $993d872dc7228c2f$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $993d872dc7228c2f$export$c7732c55900cf0b9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("5palF")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanel = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("5N7oJ")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("1U7AI")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("1kr4I")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $993d872dc7228c2f$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender, null));
$993d872dc7228c2f$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $993d872dc7228c2f$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanel, null));
$993d872dc7228c2f$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $993d872dc7228c2f$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton, null));
$993d872dc7228c2f$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $993d872dc7228c2f$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight, null));
$993d872dc7228c2f$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("5palF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kd6Ju").then(()=>parcelRequire('appSk'));

});

parcelRegister("5N7oJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("5eFqM")
]).then(()=>parcelRequire('ddfk6'));

});

parcelRegister("1U7AI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("ahRif")
]).then(()=>parcelRequire('1HvEW'));

});

parcelRegister("1kr4I", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("cxrYi")
]).then(()=>parcelRequire('f9sDQ'));

});


parcelRegister("3e4zR", function(module, exports) {

$parcel$export(module.exports, "useInitializeActiveTab", () => $fca831ba939738e0$export$b0f185249c3d08fd);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $2j5ni = parcelRequire("2j5ni");

var $dWvpo = parcelRequire("dWvpo");

var $8GtZ0 = parcelRequire("8GtZ0");
var $8u09c = parcelRequire("8u09c");
const $fca831ba939738e0$export$b0f185249c3d08fd = (activeTabName, gspProjectId)=>{
    const { isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = (0, $2j5ni.useIsFirstProjectITSM)(gspProjectId);
    const isNpleForItsmEnabled = isFirstProject && isFirstProjectItsm && (0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
    const [{ data: gspStateData }, { saveProperty: saveProperty }] = (0, $dWvpo.useGettingStartedPanelState)();
    const [isInitializedActiveTab, setIsInitializedActiveTab] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (activeTabName === '') return;
        if (!isInitializedActiveTab && isNpleForItsmEnabled && gspStateData) {
            const sectionStateJSON = gspStateData.properties?.user?.sectionState ?? (0, $8GtZ0.defaultGspState).properties.user.sectionState;
            const sectionState = JSON.parse(sectionStateJSON);
            if (sectionState.sections.checklist.activeTab !== activeTabName) {
                sectionState.sections.checklist.activeTab = activeTabName;
                saveProperty({
                    key: (0, $8u09c.PropertyKey).SectionState,
                    value: JSON.stringify(sectionState)
                });
            }
            setIsInitializedActiveTab(true);
        }
    }, [
        isNpleForItsmEnabled,
        gspStateData,
        saveProperty,
        activeTabName,
        isInitializedActiveTab
    ]);
    const resetInitialization = ()=>setIsInitializedActiveTab(false);
    return {
        resetInitialization: resetInitialization
    };
};

});

parcelRegister("51ACp", function(module, exports) {

$parcel$export(module.exports, "HistoryAdapter", () => $7c9b058abf515682$export$d852f51b8427aefc);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $dsNuc = parcelRequire("dsNuc");
// eslint-disable-next-line jira/react/no-class-components
class $7c9b058abf515682$var$HistoryAdapterComponent extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.compatibleHistory = (0, $dsNuc.createReactRouterCompatibleHistory)(props.history);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.children !== this.props.children;
    }
    componentWillUnmount() {
        this.compatibleHistory.destroy && this.compatibleHistory.destroy();
    }
    render() {
        const { children: children } = this.props;
        return children(this.compatibleHistory);
    }
}
const $7c9b058abf515682$export$d852f51b8427aefc = (0, $lB25E.withRouter)($7c9b058abf515682$var$HistoryAdapterComponent);

});
parcelRegister("dsNuc", function(module, exports) {

$parcel$export(module.exports, "createReactRouterCompatibleHistory", () => $03e13d3d865e0b52$export$2df73cd79c2401bf);

var $6l6Xk = parcelRequire("6l6Xk");
const $03e13d3d865e0b52$export$2df73cd79c2401bf = (history)=>{
    let cleaned = false;
    let listeners = [];
    // @ts-expect-error - TS2304 - Cannot find name 'HistoryAction'.
    const listen = (callback)=>{
        if (cleaned) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const unsubscribe = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(history.listen(callback));
        const listener = {
            unsubscribe: unsubscribe
        };
        listeners.push(listener);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>{
            listener.unsubscribe();
        });
    };
    const cleanup = ()=>{
        listeners.forEach(({ unsubscribe: unsubscribe })=>{
            unsubscribe();
        });
        cleaned = true;
        listeners = [];
    };
    return {
        get length () {
            return history.length;
        },
        get location () {
            return history.location;
        },
        get action () {
            return history.action;
        },
        get index () {
            return history.index;
        },
        get entries () {
            return history.entries;
        },
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        push: (path, state)=>history.push(path, state),
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        replace: (path, state)=>history.replace(path, state),
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        go: (n)=>history.go(n),
        goBack: ()=>history.goBack(),
        goForward: ()=>history.goForward(),
        // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
        createHref: (...args)=>history.createHref(...args),
        // Memory only
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        canGo: (n)=>{
            if (history.canGo) return history.canGo(n);
            return true;
        },
        listen: listen,
        // @ts-expect-error - TS7006 - Parameter 'blocker' implicitly has an 'any' type.
        block: (blocker)=>history.block(blocker),
        destroy: cleanup
    };
};

});


parcelRegister("9J3fC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e98daa64b3e2536$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Rbdp = parcelRequire("4Rbdp");
var $7YLRZ = parcelRequire("7YLRZ");

var $37mOt = parcelRequire("37mOt");

var $lxT0c = parcelRequire("lxT0c");

const $4e98daa64b3e2536$var$EmbeddableDirectory = (props)=>{
    const { addFlag: addFlag, appName: appName, contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, locale: locale, push: push, replace: replace, docTitle: docTitle, statusCodeHandlers: statusCodeHandlers, env: env, history: history, isSentryEnabled: isSentryEnabled = true, cloudId: cloudId, orgId: orgId, teamCentralHandlers: teamCentralHandlers, subProduct: subProduct, productFeatureFlags: productFeatureFlags, invitePeopleHandlers: invitePeopleHandlers } = props;
    if (env) (0, $37mOt.setEnv)(env);
    const analyticsClient = (0, $4Rbdp.useSetupAnalyticsClient)(cloudId, appName, subProduct);
    const apolloClient = (0, $7YLRZ.useSetupApolloClient)(cloudId);
    if (!analyticsClient) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxT0c.default), {
        apolloClient: apolloClient,
        analytics: analyticsClient,
        appName: appName,
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint,
        env: env,
        push: push,
        replace: replace,
        addFlag: addFlag,
        locale: locale,
        docTitle: docTitle,
        statusCodeHandlers: statusCodeHandlers,
        history: history,
        cloudId: cloudId,
        orgId: orgId,
        teamCentralHandlers: teamCentralHandlers,
        skipI18nProvider: false,
        productFeatureFlags: productFeatureFlags,
        invitePeopleHandlers: invitePeopleHandlers,
        isSentryEnabled: isSentryEnabled
    });
};
var $4e98daa64b3e2536$export$2e2bcd8739ae039 = $4e98daa64b3e2536$var$EmbeddableDirectory;

});
parcelRegister("4Rbdp", function(module, exports) {

$parcel$export(module.exports, "useSetupAnalyticsClient", () => $dd2f4903c9dec189$export$bcd55e98e7c6e45e);

var $eUqFw = parcelRequire("eUqFw");

var $e6nUx = parcelRequire("e6nUx");
function $dd2f4903c9dec189$var$getAnalyticsSubproduct(appName, subProduct) {
    if (!subProduct) return appName;
    return `jira-${subProduct}-directory`;
}
function $dd2f4903c9dec189$export$bcd55e98e7c6e45e(cloudId, appName, subProduct) {
    const analyticsSubProduct = (0, $eUqFw.useMemo)(()=>$dd2f4903c9dec189$var$getAnalyticsSubproduct(appName, subProduct), [
        appName,
        subProduct
    ]);
    const [analyticsClient, setAnalyticsClient] = (0, $eUqFw.useState)((0, $e6nUx.getAnalyticsClient)({
        mode: appName,
        subproduct: analyticsSubProduct,
        cloudId: cloudId
    }));
    // setup analytics object
    (0, $eUqFw.useEffect)(()=>{
        if (!cloudId) return;
        const analytics = (0, $e6nUx.getAnalyticsClient)({
            mode: appName,
            subproduct: analyticsSubProduct,
            cloudId: cloudId
        });
        setAnalyticsClient(analytics);
    }, [
        cloudId,
        analyticsSubProduct,
        appName
    ]);
    // TODO: fix-me - currently, cloudId is required to render People app.
    // When analytics client without cloud id is used, Cypress test `dev-packages/cypress/src/specs/analytics.spec.ts` is flaky.
    // It seems that the analytics client without cloud id used first, then analytics client with cloud is replaced, but the app does not re-render in Cypress tests.
    return cloudId ? analyticsClient : undefined;
}

});
parcelRegister("e6nUx", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsClient", () => $c74395c9cb33ba3a$export$fde53e78fd93a54d);

var $dNAsL = parcelRequire("dNAsL");
var $1C9jQ = parcelRequire("1C9jQ");

var $4GU27 = parcelRequire("4GU27");
var $avLBj = parcelRequire("avLBj");
var $37mOt = parcelRequire("37mOt");

var $aPkDp = parcelRequire("aPkDp");

var $1io2n = parcelRequire("1io2n");

var $hh0j4 = parcelRequire("hh0j4");

var $bsMUn = parcelRequire("bsMUn");
function $c74395c9cb33ba3a$var$getServerName() {
    return window.location.hostname;
}
const { LOCAL: $c74395c9cb33ba3a$var$LOCAL, DEV: $c74395c9cb33ba3a$var$DEV, STAGING: $c74395c9cb33ba3a$var$STAGING, PROD: $c74395c9cb33ba3a$var$PROD } = (0, $1C9jQ.envType);
const $c74395c9cb33ba3a$var$ENV_MAP = {
    local: $c74395c9cb33ba3a$var$LOCAL,
    test: $c74395c9cb33ba3a$var$LOCAL,
    adev: $c74395c9cb33ba3a$var$DEV,
    'stg-east': $c74395c9cb33ba3a$var$STAGING,
    stg: $c74395c9cb33ba3a$var$STAGING
};
const $c74395c9cb33ba3a$var$getEnvType = (env)=>{
    return $c74395c9cb33ba3a$var$ENV_MAP[env] || $c74395c9cb33ba3a$var$PROD;
};
const $c74395c9cb33ba3a$var$analyticsConfig = (0, $avLBj.getConfig)().analytics;
const $c74395c9cb33ba3a$var$SUB_PRODUCT_DEFAULT = 'siteDirectory';
const $c74395c9cb33ba3a$var$PRODUCT_DEFAULT = 'people';
class $c74395c9cb33ba3a$var$AnalyticsClient {
    constructor(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    options = {}, { commonProperties: commonProperties = {}, eventPrefix: eventPrefix = 'atlassian.people', subproduct: subproduct = $c74395c9cb33ba3a$var$SUB_PRODUCT_DEFAULT, cloudId: cloudId = '' } = {}){
        const customOptions = {
            commonProperties: commonProperties,
            eventPrefix: eventPrefix
        };
        this.cloudId = cloudId;
        this.commonProperties = customOptions.commonProperties;
        this.eventPrefix = customOptions.eventPrefix;
        this.state = {
            analyticsscheme: $c74395c9cb33ba3a$var$analyticsConfig.scheme,
            analyticsserver: $c74395c9cb33ba3a$var$analyticsConfig.server,
            server: $c74395c9cb33ba3a$var$getServerName(),
            product: $c74395c9cb33ba3a$var$PRODUCT_DEFAULT,
            isReadyToSend: false,
            pendingEventsQueue: [],
            storage_key: 'atlassian.people.analytics',
            ...options
        };
        // New GAS pipeline client
        this.analyticsWebClient = new (0, $dNAsL.default)({
            env: $c74395c9cb33ba3a$var$getEnvType((0, $37mOt.getEnv)()),
            product: 'people',
            subproduct: subproduct
        }, {});
        this.initUFO();
        this._expTracker = (0, $hh0j4.configureNewTracker)(this);
    }
    setTeamId(teamId) {
        this.teamId = teamId;
    }
    initUFO() {
        if ((0, $4GU27.getAppName)() !== (0, $4GU27.AppNames).STANDALONE_DIRECTORY) return;
        (0, $aPkDp.payloadPublisher).setup({
            gasv3: this.analyticsWebClient,
            product: 'people',
            app: {
                // @ts-ignore
                version: {
                    web: __VERSION__
                }
            },
            region: (0, $37mOt.getEnv)()
        });
    // import { ufologger } from @atlassian/ufo and uncomment the following line to see UFO logs:
    // ufologger.enable();
    }
    getAnalyticsWebClient() {
        return this.analyticsWebClient;
    }
    expTracker() {
        return this._expTracker;
    }
    sendTrackEvent(eventData) {
        this.analyticsWebClient.sendTrackEvent(eventData);
    }
    /**
	 * Checks whether the library has been initialized and decides whether the event should be sent or cached
	 * @param {*} eventType Values could be 'track', 'screen', 'operation, 'ui'
	 * @param {*} eventData Data of the event
	 * @param {Function} cb Callback is called when the event is sent successfully.
	 */ canEventBeSent(eventType, eventData, cb) {
        if (this.state.isReadyToSend) return true;
        // add to `pendingEventsQueue` in order to send the event later
        this.state.pendingEventsQueue.push({
            eventType: eventType,
            eventData: eventData,
            // `eventCallback` is called when `pendingEventsQueue` is processed and eventData is sent
            eventCallback: cb
        });
        return false;
    }
    pushTrackEvent(eventData, cb) {
        if (this.canEventBeSent('track', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendTrackEvent(event, cb);
        }
    }
    pushUIEvent(eventData, cb) {
        if (this.canEventBeSent('ui', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendUIEvent(event, cb);
        }
    }
    pushOperationalEvent(eventData, cb) {
        if (this.canEventBeSent('operation', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendOperationalEvent(event, cb);
        }
    }
    pushScreenEvent(eventData, cb) {
        const additionalAttributes = (0, $bsMUn.default).get();
        (0, $bsMUn.default).markUsed();
        if (eventData && additionalAttributes) eventData = {
            ...eventData,
            attributes: {
                ...additionalAttributes,
                ...eventData.attributes
            }
        };
        if (this.canEventBeSent('screen', eventData, cb)) this.analyticsWebClient.sendScreenEvent(eventData, cb);
    }
    buildEventPayload(eventData) {
        const attributes = this.teamId || eventData.attributes ? {
            ...this.teamId && {
                teamId: this.teamId
            },
            ...eventData.attributes
        } : null;
        return {
            containerType: null,
            containerId: null,
            objectType: null,
            objectId: null,
            source: null,
            actionSubject: null,
            action: null,
            actionSubjectId: null,
            tags: [],
            ...eventData,
            attributes: attributes
        };
    }
    mapAnalyticsKeyToEvent(analyticsKey) {
        return (0, $1io2n.analyticsKeyToEventMap)[analyticsKey] || null;
    }
    /**
	 *  Start up E-MAU events in the new analytics pipeline (GAS v3)
	 *  See: https://extranet.atlassian.com/display/BPO/DACI%3A+E-MAU+Definition
	 */ async startUIViewedEvent(principalUserId) {
        if (!principalUserId) return;
        this.analyticsWebClient.setTenantInfo((0, $1C9jQ.tenantType).CLOUD_ID, this.cloudId || '');
        this.analyticsWebClient.setUserInfo((0, $1C9jQ.userType).ATLASSIAN_ACCOUNT, principalUserId);
        this.analyticsWebClient.startUIViewedEvent();
        this.state.isReadyToSend = true;
        this.flushPendingEventsQueue();
    }
    /**
	 * Flush all the pending events in the queue
	 */ flushPendingEventsQueue() {
        this.state.pendingEventsQueue.forEach((element)=>{
            const { eventType: eventType, eventData: eventData, eventCallback: eventCallback } = element;
            switch(eventType){
                case 'track':
                    this.pushTrackEvent(eventData, eventCallback);
                    break;
                case 'ui':
                    this.pushUIEvent(eventData, eventCallback);
                    break;
                case 'screen':
                    this.pushScreenEvent(eventData, eventCallback);
                    break;
                case 'operation':
                    this.pushOperationalEvent(eventData, eventCallback);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.error('Invalide Event :', element);
                    break;
            }
        });
    }
}
var $c74395c9cb33ba3a$export$2e2bcd8739ae039 = $c74395c9cb33ba3a$var$AnalyticsClient;
let $c74395c9cb33ba3a$var$preservedAnaylticsClient;
const $c74395c9cb33ba3a$export$fde53e78fd93a54d = ({ mode: mode, subproduct: subproduct, cloudId: cloudId })=>{
    if (!cloudId) return;
    if ($c74395c9cb33ba3a$var$preservedAnaylticsClient) return $c74395c9cb33ba3a$var$preservedAnaylticsClient;
    $c74395c9cb33ba3a$var$preservedAnaylticsClient = new $c74395c9cb33ba3a$var$AnalyticsClient({}, {
        commonProperties: {
            mode: mode
        },
        subproduct: subproduct,
        cloudId: cloudId
    });
    return $c74395c9cb33ba3a$var$preservedAnaylticsClient;
};

});
parcelRegister("4GU27", function(module, exports) {

$parcel$export(module.exports, "AppNames", () => $12268ee2ffd3be16$export$b767e803e7ca9563);
$parcel$export(module.exports, "getAppName", () => $12268ee2ffd3be16$export$dcecb2dbc7fe753c);
var $12268ee2ffd3be16$export$b767e803e7ca9563;
(function(AppNames) {
    AppNames["EMBEDDABLE_DIRECTORY"] = "embeddableDirectory";
    AppNames["STANDALONE_DIRECTORY"] = "standaloneDirectory";
})($12268ee2ffd3be16$export$b767e803e7ca9563 || ($12268ee2ffd3be16$export$b767e803e7ca9563 = {}));
function $12268ee2ffd3be16$export$dcecb2dbc7fe753c() {
    // @ts-ignore
    return window.__app_name__ || "embeddableDirectory";
}

});

parcelRegister("avLBj", function(module, exports) {

$parcel$export(module.exports, "isFedramp", () => $3c24c4ec25204a15$export$634ecc602a6871aa);
$parcel$export(module.exports, "getConfig", () => $3c24c4ec25204a15$export$44487a86467333c3);

var $1Zvbf = parcelRequire("1Zvbf");

var $dfBCt = parcelRequire("dfBCt");

var $4GU27 = parcelRequire("4GU27");

var $37mOt = parcelRequire("37mOt");

var $fU34a = parcelRequire("fU34a");
// default configs is also config for production env
const $3c24c4ec25204a15$var$productionConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.atlassian.com',
    teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
};
const $3c24c4ec25204a15$var$devAndStagingConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com',
    teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
};
const $3c24c4ec25204a15$var$localAndTestConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'http',
        server: 'localhost:3000'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com',
    teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
};
const $3c24c4ec25204a15$var$fedrampConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian-us-gov-mod.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard'
};
const $3c24c4ec25204a15$var$EnvOverrideKeys = [
    'adev',
    'stg-east',
    'local',
    'test',
    'fedramp',
    'prod-east'
];
const $3c24c4ec25204a15$var$environmentOverrides = {
    'prod-east': $3c24c4ec25204a15$var$productionConfig,
    local: {
        ...(0, $fU34a.LOCAL_PRODUCTION_BACKEND) ? $3c24c4ec25204a15$var$productionConfig : $3c24c4ec25204a15$var$localAndTestConfig,
        analytics: {
            scheme: 'http',
            server: `${(0, (/*@__PURE__*/$parcel$interopDefault($1Zvbf))).location.hostname}:3000`
        }
    },
    test: {
        ...$3c24c4ec25204a15$var$localAndTestConfig
    },
    adev: $3c24c4ec25204a15$var$devAndStagingConfig,
    'stg-east': $3c24c4ec25204a15$var$devAndStagingConfig,
    fedramp: $3c24c4ec25204a15$var$fedrampConfig
};
const $3c24c4ec25204a15$var$cachedConfig = {};
function $3c24c4ec25204a15$export$634ecc602a6871aa() {
    return (0, $dfBCt.isFedRamp)();
}
function $3c24c4ec25204a15$export$44487a86467333c3() {
    const env = $3c24c4ec25204a15$export$634ecc602a6871aa() ? 'fedramp' : (0, $37mOt.getEnv)();
    const appName = (0, $4GU27.getAppName)();
    const key = `${env}_${appName}`;
    if (!$3c24c4ec25204a15$var$cachedConfig[key]) {
        if ($3c24c4ec25204a15$var$EnvOverrideKeys.includes(env)) $3c24c4ec25204a15$var$cachedConfig[key] = {
            ...$3c24c4ec25204a15$var$environmentOverrides[env]
        };
        else // fallback to prod as customers can have custom domains.
        $3c24c4ec25204a15$var$cachedConfig[key] = {
            ...$3c24c4ec25204a15$var$environmentOverrides['prod-east']
        };
    }
    return $3c24c4ec25204a15$var$cachedConfig[key];
}

});
parcelRegister("37mOt", function(module, exports) {

$parcel$export(module.exports, "setEnv", () => $90cb06051ad5805a$export$84bc02d3c7a6b55f);
$parcel$export(module.exports, "getEnv", () => $90cb06051ad5805a$export$4bd44a2aa29d3d6e);

var $1Zvbf = parcelRequire("1Zvbf");

var $fU34a = parcelRequire("fU34a");
var $90cb06051ad5805a$export$e7dfafc24fab792e;
(function(MicrosEnv) {
    MicrosEnv["ADEV"] = "adev";
    MicrosEnv["STG_EAST"] = "stg-east";
    MicrosEnv["PROD_EAST"] = "prod-east";
})($90cb06051ad5805a$export$e7dfafc24fab792e || ($90cb06051ad5805a$export$e7dfafc24fab792e = {}));
const $90cb06051ad5805a$export$d76bdf9f4281ae1b = {
    local: 'local',
    test: 'test',
    prod: 'prod',
    stg: 'staging',
    ["adev"]: 'staging',
    ["stg-east"]: 'staging',
    ["prod-east"]: 'production'
};
const $90cb06051ad5805a$var$SIMPLE_TO_DAMN_COMPLEX_ENV = {
    prod: 'prod-east',
    stg: 'stg-east'
};
let $90cb06051ad5805a$var$presetEnv;
const $90cb06051ad5805a$export$84bc02d3c7a6b55f = (env)=>{
    const envOverride = $90cb06051ad5805a$var$SIMPLE_TO_DAMN_COMPLEX_ENV[env];
    if (envOverride) $90cb06051ad5805a$var$presetEnv = envOverride;
};
function $90cb06051ad5805a$export$4bd44a2aa29d3d6e() {
    if ($90cb06051ad5805a$var$presetEnv) return $90cb06051ad5805a$var$presetEnv;
    if (0, $fU34a.DEV) return 'local';
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Zvbf))).__env__;
}
function $90cb06051ad5805a$export$15b8d8b1ba394f55() {
    return $90cb06051ad5805a$export$d76bdf9f4281ae1b[$90cb06051ad5805a$export$4bd44a2aa29d3d6e()];
}

});
parcelRegister("fU34a", function(module, exports) {

$parcel$export(module.exports, "DEV", () => $2486455d18d42cfe$export$404582bc18fe4d9e);
$parcel$export(module.exports, "LOCAL_PRODUCTION_BACKEND", () => $2486455d18d42cfe$export$771a63345d182ddd);
// @ts-ignore
const $2486455d18d42cfe$export$404582bc18fe4d9e = typeof __DEV__ !== 'undefined' && __DEV__;
const $2486455d18d42cfe$export$771a63345d182ddd = // @ts-ignore
typeof __LOCAL_PRODUCTION_BACKEND__ !== 'undefined' && // @ts-ignore
__LOCAL_PRODUCTION_BACKEND__;

});



parcelRegister("1io2n", function(module, exports) {

$parcel$export(module.exports, "AnalyticsKeys", () => $5d8ec327ad207f5d$export$e8d1ded05852e864);
$parcel$export(module.exports, "analyticsKeyToEventMap", () => $5d8ec327ad207f5d$export$6430c2bbc66a6fa);
$parcel$export(module.exports, "AnalyticsEventSource", () => $5d8ec327ad207f5d$export$2102531865f3e90e);
$parcel$export(module.exports, "AnalyticsEventActions", () => $5d8ec327ad207f5d$export$74eee170ad238aae);
$parcel$export(module.exports, "AnalyticsEventSubjects", () => $5d8ec327ad207f5d$export$670f80b77450980d);
const $5d8ec327ad207f5d$export$e8d1ded05852e864 = {
    ACTIVITY_ALL_VIEW: 'activity.all.view',
    ACTIVITY_WATCHING_VIEW: 'activity.watching.view',
    HISTORY_VIEW: 'history.view',
    PEOPLE_VIEW: 'people-search.view',
    PROFILE_PAGE_VIEW: 'profile-page.view',
    AGENT_PROFILE_PAGE_VIEW: 'agent-profile-page.view',
    PROFILE_WORKED_ON_PAGE_VIEW: 'profile-worked-on-page.view',
    PROFILE_SETTINGS_CLOSE_ACCOUNT_VIEW: 'profile-settings.close-account.view',
    PROFILE_SETTINGS_EMAIL_VIEW: 'profile-settings.email.view',
    PROFILE_SETTINGS_GENERAL_VIEW: 'profile-settings.general.view',
    PROFILE_SETTINGS_PROFILE_AND_VISIBILITY_VIEW: 'profile-settings.profile-and-visibility.view',
    PROFILE_SETTINGS_PRIVACY_VIEW: 'profile-settings.privacy.view',
    PROFILE_SETTINGS_PRODUCT_VIEW: 'profile-settings.product.view',
    PROFILE_SETTINGS_SECURITY_VIEW: 'profile-settings.security.view',
    PROFILE_SETTINGS_TWO_STEP_VERIFICATION_VIEW: 'profile-settings.security.two-step-verification.view',
    PROFILE_SETTINGS_API_TOKENS_VIEW: 'profile-settings.security.api-tokens.view',
    PROFILE_SETTINGS_RECENT_DEVICES_VIEW: 'profile-settings.security.recent-devices.view',
    PROFILE_SETTINGS_CONNECTED_APPS_VIEW: 'profile-settings.connected-apps.view',
    TEAM_PROFILE_VIEW: 'team-profile.view',
    KUDOS_PAGE_VIEW: 'kudos-page.view',
    TEAM_PROFILE_BROWSE_ALL: 'team-profile.browse-all',
    ALL_TEAMS_DISABLED: 'profile-search.view.all-teams.disabled',
    // TODO: remove these once we move to a new analytics platform
    LEGACY_ACTIVITY_ALL_VIEW: 'newsfeed.view'
};
const $5d8ec327ad207f5d$export$6430c2bbc66a6fa = {
    [$5d8ec327ad207f5d$export$e8d1ded05852e864.PROFILE_PAGE_VIEW]: 'userProfile',
    [$5d8ec327ad207f5d$export$e8d1ded05852e864.TEAM_PROFILE_BROWSE_ALL]: 'teamsPage'
};
var $5d8ec327ad207f5d$export$2102531865f3e90e;
(function(AnalyticsEventSource) {
    // `/people/<userId>` page
    AnalyticsEventSource["USER_PROFILE_SCREEN"] = "userProfileScreen";
    AnalyticsEventSource["USER_PROFILE_ABOUT"] = "userProfileAbout";
    // `/people/<userId>/work` page
    AnalyticsEventSource["USER_WORK_SCREEN"] = "userWorkScreen";
    // `/people/agent/<agentId>` page
    AnalyticsEventSource["AGENT_PROFILE_SCREEN"] = "agentProfileScreen";
    AnalyticsEventSource["AGENT_DELETE_SUCCESS_FLAG"] = "agentDeletedSuccessflag";
    AnalyticsEventSource["AGENT_DELETE_ERROR_FLAG"] = "agentDeletedErrorflag";
    // `/people/team/<teamId>` page
    AnalyticsEventSource["TEAM_PROFILE_SCREEN"] = "teamProfileScreen";
    AnalyticsEventSource["TEAM_PROFILE_ABOUT"] = "teamProfileAbout";
    AnalyticsEventSource["TEAM_RESTORE_SCREEN"] = "teamRestoreScreen";
    AnalyticsEventSource["TEAM_RESTORE_SUCCESS_FLAG"] = "teamReactivatedSuccessflag";
    AnalyticsEventSource["TEAM_RESTORE_ERROR_FLAG"] = "teamReactivatedErrorflag";
    AnalyticsEventSource["CREATE_TEAM_MODAL"] = "createTeamModal";
    // `/people/search` page
    AnalyticsEventSource["DIRECTORY_SCREEN"] = "directoryScreen";
    // new `/people/search` page
    AnalyticsEventSource["PEOPLE_HOME"] = "peopleHome";
    AnalyticsEventSource["PEOPLE_DRAWER"] = "peopleDrawer";
    // inside avatar menu
    AnalyticsEventSource["USER_MENU"] = "userMenu";
    // experimentLeaf */
    AnalyticsEventSource["ADD_PEOPLE_MODAL"] = "addPeopleModal";
    // generic metrics
    AnalyticsEventSource["CLIENT_METRICS"] = "clientMetrics";
    // generic metrics
    AnalyticsEventSource["DIRECTORY_APP"] = "directoryApp";
    AnalyticsEventSource["INITIALS_DIALOG"] = "avatarInitialsPicker";
    // /people/kudos/:uuid
    AnalyticsEventSource["KUDOS_SCREEN"] = "kudos";
    AnalyticsEventSource["PROFILE_CARD"] = "profilecard";
    // new `/people/search/teams` page
    AnalyticsEventSource["TEAMS_PAGE"] = "teamsPage";
})($5d8ec327ad207f5d$export$2102531865f3e90e || ($5d8ec327ad207f5d$export$2102531865f3e90e = {}));
var $5d8ec327ad207f5d$export$74eee170ad238aae;
(function(AnalyticsEventActions) {
    AnalyticsEventActions["ACCEPTED"] = "accepted";
    AnalyticsEventActions["CLICKED"] = "clicked";
    AnalyticsEventActions["CLOSED"] = "closed";
    AnalyticsEventActions["COLLAPSED"] = "collapsed";
    AnalyticsEventActions["CREATED"] = "created";
    AnalyticsEventActions["DECLINED"] = "declined";
    AnalyticsEventActions["DELETED"] = "deleted";
    AnalyticsEventActions["EDITED"] = "edited";
    AnalyticsEventActions["EXPANDED"] = "expanded";
    AnalyticsEventActions["EXPOSED"] = "exposed";
    AnalyticsEventActions["FAILED"] = "failed";
    AnalyticsEventActions["JOINED"] = "joined";
    AnalyticsEventActions["REDIRECTED"] = "redirected";
    AnalyticsEventActions["REMOVED"] = "removed";
    AnalyticsEventActions["SENT"] = "sent";
    AnalyticsEventActions["SORTED"] = "sorted";
    AnalyticsEventActions["STARTED"] = "started";
    AnalyticsEventActions["OPENED"] = "opened";
    AnalyticsEventActions["SHOWN"] = "shown";
    AnalyticsEventActions["SUBMITTED"] = "submitted";
    AnalyticsEventActions["SUCCEEDED"] = "succeeded";
    AnalyticsEventActions["TRIGGERED"] = "triggered";
    AnalyticsEventActions["TYPED"] = "typed";
    AnalyticsEventActions["VIEWED"] = "viewed";
    AnalyticsEventActions["MOUNTED"] = "mounted";
    AnalyticsEventActions["MOVED"] = "moved";
    AnalyticsEventActions["DRAGGED"] = "dragged";
    AnalyticsEventActions["SELECTED"] = "selected";
})($5d8ec327ad207f5d$export$74eee170ad238aae || ($5d8ec327ad207f5d$export$74eee170ad238aae = {}));
var $5d8ec327ad207f5d$export$670f80b77450980d;
(function(AnalyticsEventSubjects) {
    AnalyticsEventSubjects["TEAM_LINK"] = "teamLink";
    AnalyticsEventSubjects["BUTTON"] = "button";
    AnalyticsEventSubjects["MODAL_DIALOG"] = "modalDialog";
    AnalyticsEventSubjects["FORM"] = "form";
    AnalyticsEventSubjects["ERROR"] = "error";
})($5d8ec327ad207f5d$export$670f80b77450980d || ($5d8ec327ad207f5d$export$670f80b77450980d = {}));

});

parcelRegister("hh0j4", function(module, exports) {

$parcel$export(module.exports, "configureNewTracker", () => $2039e55a38e3127d$export$54c7ecd74762af6a);
$parcel$export(module.exports, "isNetworkError", () => $2039e55a38e3127d$export$476aa014e2fd89d5);

var $hUYqC = parcelRequire("hUYqC");

var $4GU27 = parcelRequire("4GU27");

var $1io2n = parcelRequire("1io2n");

var $3MeXN = parcelRequire("3MeXN");

var $3W7Kz = parcelRequire("3W7Kz");

var $fECJU = parcelRequire("fECJU");
function $2039e55a38e3127d$export$54c7ecd74762af6a(analytics) {
    const tracker = new $2039e55a38e3127d$var$DirectoryExperienceTracker({
        isNetworkOfflineError: $2039e55a38e3127d$export$476aa014e2fd89d5
    });
    tracker.subscribe((event)=>{
        if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
            const performanceAttributes = $2039e55a38e3127d$var$computePerformanceAttributes(event);
            const errorAttributes = $2039e55a38e3127d$var$computeErrorAttributes(event);
            const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                // Because standalone app is deployed to prod quickly,
                // we will use this attribute to query in Splunk sooner.
                isStandalone: (0, $4GU27.getAppName)() === (0, $4GU27.AppNames).STANDALONE_DIRECTORY,
                hasBrowseUsersPermission: (0, $3MeXN.isFlagEnabled)((0, $26c363c9409b0d5d$export$28456d095a642fd))
            });
            const actionSubject = $2039e55a38e3127d$var$sanitiseExperienceName(event.name);
            analytics.pushOperationalEvent({
                source: (0, $1io2n.AnalyticsEventSource).CLIENT_METRICS,
                actionSubject: actionSubject,
                action: event.action,
                attributes: finalErrorDetails
            });
            if (event.action === 'taskFail') (0, $fECJU.logErrorMessage)(`taskFail:${actionSubject}`, finalErrorDetails);
        }
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('unload', ()=>{
        tracker.abort({
            reason: 'Abort due to Window unloading',
            attributes: {
                cause: 'WINDOW_UNLOAD'
            }
        });
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('pagehide', ()=>{
        tracker.abort({
            reason: 'Window unloading',
            attributes: {
                cause: 'PAGE_HIDE'
            }
        });
    });
    return tracker;
}
function $2039e55a38e3127d$var$sanitiseExperienceName(name) {
    return name.replace(/[\/-]/g, '_');
}
function $2039e55a38e3127d$var$computeErrorAttributes(event) {
    const attributes = {};
    if (event.action === 'taskFail' && event.error) {
        attributes.failError = event.error.message;
        attributes.traceId = event.error.traceId ?? null;
    }
    if (event.action === 'taskAbort' && event.reason) attributes.abortReason = event.reason;
    return attributes;
}
// compute sloSatisfied: true/false based on the latencySlo attribute
// for monitoring in SignalFx
function $2039e55a38e3127d$var$computePerformanceAttributes(event) {
    if (event.action === 'taskStart') return {};
    const duration = event.duration;
    const latencySlo = event.attributes && event.attributes['latencySlo'];
    if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
    return {
        sloSatisfied: duration <= latencySlo,
        taskDuration: duration,
        latencySlo: latencySlo
    };
}
class $2039e55a38e3127d$var$DirectoryExperienceTracker extends (0, $hUYqC.ExperienceTracker) {
    constructor(options){
        super(options);
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if ((0, $3W7Kz.isAuthError)(error)) {
            this.abort({
                name: name,
                reason: 'Abort due to user unauthenticated',
                attributes: {
                    cause: 'USER_UNAUTHENTICATED',
                    error: error,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        if ((0, $3W7Kz.isErrorStatusCode)((0, $3W7Kz.StatusCode).GONE, error)) {
            this.abort({
                name: name,
                reason: 'Abort due to unavailable resource',
                attributes: {
                    cause: 'GONE',
                    error: error,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        const reason = (0, $3W7Kz.ignoredErrorReason)(error);
        if (reason) {
            this.abort({
                name: name,
                reason: 'Abort due to an error in ignore list',
                attributes: {
                    cause: reason,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        super.stopOnError({
            name: name,
            error: error,
            attributes: attributes
        });
    }
}
function $2039e55a38e3127d$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    // @ts-ignore
    !!(error['graphQLErrors'] && error['networkError']));
}

});
const $26c363c9409b0d5d$export$28456d095a642fd = 'internal.browse-users-allowed';

parcelRegister("3MeXN", function(module, exports) {

$parcel$export(module.exports, "FeatureFlag", () => $607ef5d7f85c9ea8$export$df35587a8f95f16f);
$parcel$export(module.exports, "isFlagEnabled", () => $607ef5d7f85c9ea8$export$ba72073d757a1bc2);

var $82kzV = parcelRequire("82kzV");

var $37mOt = parcelRequire("37mOt");

var $2fFJv = parcelRequire("2fFJv");
var $607ef5d7f85c9ea8$export$df35587a8f95f16f;
(function(FeatureFlag) {
    //CA-13 Adding Tags at profile level
    FeatureFlag["ENABLE_PROJECT_CONNECT_USER_TAGS"] = "enable_skills_and_interest_tags_in_profile_page";
    //Teams in JSM Ops productFeatureFlags
    FeatureFlag["EVENT_ON_CALL_EFF"] = "event-on-call-consolidation_s97c8";
    FeatureFlag["EVENT_ON_CALL_CONSOLIDATION_STATE"] = "event-on-call-consolidation-state";
    // Control for Open Sites permissions check
    FeatureFlag["ENABLE_MOCK_OPEN_SITES_FAIL"] = "ptc-directory-ui.deny-open-sites-in-fe";
    // Atlas
    FeatureFlag["DISABLE_ATLAS_CROSSWFLOW_ADS"] = "disable_atlas_crossflow_ads";
})($607ef5d7f85c9ea8$export$df35587a8f95f16f || ($607ef5d7f85c9ea8$export$df35587a8f95f16f = {}));
// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails
const $607ef5d7f85c9ea8$var$DEFAULT_FEATURE_FLAGS = {
    ["enable_skills_and_interest_tags_in_profile_page"]: false,
    ["ptc-directory-ui.deny-open-sites-in-fe"]: false,
    ["disable_atlas_crossflow_ads"]: false,
    ["event-on-call-consolidation_s97c8"]: false,
    ["event-on-call-consolidation-state"]: false
};
// Overrides only for local/CI environments
const $607ef5d7f85c9ea8$var$LOCAL_OVERRIDE_FEATURE_FLAGS = {
    // Features rolled out to 100%
    // Atlassian-only features
    ["enable_skills_and_interest_tags_in_profile_page"]: true
};
const $607ef5d7f85c9ea8$export$7101ae34ef1f53be = ()=>$2fFJv?.env?.NODE_ENV === 'development' || (0, $37mOt.getEnv)() === 'local' ? {
        ...$607ef5d7f85c9ea8$var$DEFAULT_FEATURE_FLAGS,
        ...$607ef5d7f85c9ea8$var$LOCAL_OVERRIDE_FEATURE_FLAGS
    } : {
        ...$607ef5d7f85c9ea8$var$DEFAULT_FEATURE_FLAGS
    };
function $607ef5d7f85c9ea8$export$ba72073d757a1bc2(flag) {
    return (0, $82kzV.isFlagEnabled)(flag);
}

});
parcelRegister("82kzV", function(module, exports) {

$parcel$export(module.exports, "getSettingsFromStorage", () => $c660a7d1088ec419$export$b40bc67e97afc0ed);
$parcel$export(module.exports, "isFlagEnabled", () => $c660a7d1088ec419$export$ba72073d757a1bc2);

var $chxpa = parcelRequire("chxpa");

var $ezaHs = parcelRequire("ezaHs");

var $60itv = parcelRequire("60itv");
const $c660a7d1088ec419$var$STORAGE_KEY_SETTINGS = 'atlassian.ptc-directory.settings';
function $c660a7d1088ec419$export$d9d01ff109db30f0(settings) {
    (0, $ezaHs.default).setItem($c660a7d1088ec419$var$STORAGE_KEY_SETTINGS, JSON.stringify(settings));
    $c660a7d1088ec419$export$455c5cbefb010abd(settings);
}
function $c660a7d1088ec419$export$b40bc67e97afc0ed() {
    const settingsString = (0, $ezaHs.default).getItem($c660a7d1088ec419$var$STORAGE_KEY_SETTINGS);
    try {
        const parsed = settingsString ? JSON.parse(settingsString) : null;
        if ($c660a7d1088ec419$var$isStringBooleanDictionary(parsed)) return parsed;
        return null;
    } catch (e) {
        (0, $chxpa.logException)(e, 'Could not get settings from storage', {
            locallyStoredSettings: settingsString
        });
        return null;
    }
}
const $c660a7d1088ec419$var$effectiveFlags = {
    ...(0, $60itv.DEFAULT_FEATURE_FLAGS),
    ...$c660a7d1088ec419$export$b40bc67e97afc0ed() || {}
};
function $c660a7d1088ec419$export$455c5cbefb010abd(newFlags) {
    Object.assign($c660a7d1088ec419$var$effectiveFlags, newFlags);
}
/**
 * We use this function to validate that the settings retrieved from local storage are of the correct shape.
 * We intentionally don't check against explicit keys, as keys may have changed since being stored.
 */ function $c660a7d1088ec419$var$isStringBooleanDictionary(result) {
    return result !== null && Object.keys(result).every((resultKey)=>typeof resultKey === 'string' && typeof result[resultKey] === 'boolean');
}
function $c660a7d1088ec419$export$2f63519103163252(featureFlag) {
    return Object.keys((0, $60itv.PRODUCT_FEATURE_FLAGS)).includes(featureFlag);
}
function $c660a7d1088ec419$export$ba72073d757a1bc2(flag) {
    return $c660a7d1088ec419$var$effectiveFlags[flag];
}

});
parcelRegister("chxpa", function(module, exports) {

$parcel$export(module.exports, "logException", () => $64bc0cc2c1c9f8b8$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logInfoMessage", () => $64bc0cc2c1c9f8b8$export$386587bcf05ee8ea);

var $jnlyS = parcelRequire("jnlyS");
const $64bc0cc2c1c9f8b8$var$packageContext = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $64bc0cc2c1c9f8b8$export$f86b2a1a2ce291b3 = (0, $jnlyS.logExceptionWithPackageContext)($64bc0cc2c1c9f8b8$var$packageContext);
const $64bc0cc2c1c9f8b8$export$ece28f5cfa04608 = (0, $jnlyS.logErrorMessageWithPackageContext)($64bc0cc2c1c9f8b8$var$packageContext);
const $64bc0cc2c1c9f8b8$export$386587bcf05ee8ea = (0, $jnlyS.logInfoMessageWithPackageContext)($64bc0cc2c1c9f8b8$var$packageContext);
const $64bc0cc2c1c9f8b8$export$9edc7d6f1c33ddc = (0, $jnlyS.createErrorHandlerWithPackageContext)($64bc0cc2c1c9f8b8$var$packageContext);

});

parcelRegister("ezaHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c49d4726f7a3a865$export$2e2bcd8739ae039);

var $chxpa = parcelRequire("chxpa");
const $c49d4726f7a3a865$var$PREFIX = 'ptc-dir-ui.';
const $c49d4726f7a3a865$var$memoryLocalStorage = {
    data: {},
    setItem: (key, value)=>{
        $c49d4726f7a3a865$var$memoryLocalStorage.data[key] = value;
    },
    getItem: (key)=>{
        return $c49d4726f7a3a865$var$memoryLocalStorage.data[key];
    },
    removeItem: (key)=>{
        delete $c49d4726f7a3a865$var$memoryLocalStorage.data[key];
    }
};
const $c49d4726f7a3a865$var$localStorage = window.localStorage || $c49d4726f7a3a865$var$memoryLocalStorage;
var // A facade for browser localstorage.
$c49d4726f7a3a865$export$2e2bcd8739ae039 = {
    isQuotaExceeded () {
        const key = `${$c49d4726f7a3a865$var$PREFIX}:${Date.now()}`;
        try {
            $c49d4726f7a3a865$var$localStorage.setItem(key, 'test');
        } catch (e) {
            return true;
        } finally{
            $c49d4726f7a3a865$var$localStorage.removeItem(key);
        }
        return false;
    },
    setItem (key, value) {
        try {
            $c49d4726f7a3a865$var$localStorage.setItem($c49d4726f7a3a865$var$PREFIX + key, value);
            return true;
        } catch (error) {
            // maybe we can use cookie as alternative storage
            (0, $chxpa.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return false;
    },
    getItem (key) {
        try {
            return $c49d4726f7a3a865$var$localStorage.getItem($c49d4726f7a3a865$var$PREFIX + key);
        } catch (error) {
            (0, $chxpa.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return null;
    },
    getItemSafely (key, defaultValue, fallback) {
        try {
            const storedValue = $c49d4726f7a3a865$var$localStorage.getItem($c49d4726f7a3a865$var$PREFIX + key);
            if (storedValue) return storedValue;
            if (this.setItem(key, defaultValue)) return defaultValue;
        } catch (error) {
            (0, $chxpa.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return fallback;
    }
};

});

parcelRegister("60itv", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_FEATURE_FLAGS", () => $8214895edb6008d4$export$f55f538942f87030);
$parcel$export(module.exports, "DEFAULT_FEATURE_FLAGS", () => $8214895edb6008d4$export$f38af5fc86a6e665);
// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails
// This is a list of feature flags that are overwritable by products. The defaults are still loaded from the client
const $8214895edb6008d4$export$f55f538942f87030 = {};
const $8214895edb6008d4$export$f38af5fc86a6e665 = {
    'ptc-directory-ui.enable.cancel-join-requests-silently': false,
    'ptc-directory-ui.deny-open-sites-in-fe': false,
    'ptc-directory-ui.enable.atlas-team-health-monitor': false,
    ...$8214895edb6008d4$export$f55f538942f87030
};

});



parcelRegister("3W7Kz", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $88d59d6acccbea0d$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $88d59d6acccbea0d$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $88d59d6acccbea0d$export$9677d7c364ada66c);
$parcel$export(module.exports, "ignoredErrorReason", () => $88d59d6acccbea0d$export$ece443678e6cc3f5);
$parcel$export(module.exports, "is4xxError", () => $88d59d6acccbea0d$export$94c4b26e937da69);
$parcel$export(module.exports, "doesErrorContainStatus", () => $88d59d6acccbea0d$export$7c7624f23566b6ff);
$parcel$export(module.exports, "DirectoryErrorCode", () => $88d59d6acccbea0d$export$b19e812222b57630);
$parcel$export(module.exports, "isApolloError", () => $88d59d6acccbea0d$export$17f5e6bd290bb15d);
var $88d59d6acccbea0d$export$fe4bb20808298551;
(function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
})($88d59d6acccbea0d$export$fe4bb20808298551 || ($88d59d6acccbea0d$export$fe4bb20808298551 = {}));
var $88d59d6acccbea0d$export$f66f92b8741acd5b;
(function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
})($88d59d6acccbea0d$export$f66f92b8741acd5b || ($88d59d6acccbea0d$export$f66f92b8741acd5b = {}));
function $88d59d6acccbea0d$export$cde1786a482f9a1c(error) {
    return $88d59d6acccbea0d$export$9677d7c364ada66c(401, error) || $88d59d6acccbea0d$export$9677d7c364ada66c(403, error);
}
const $88d59d6acccbea0d$export$c27af9588f06f6fc = [
    'SentryIgnoreError'
];
const $88d59d6acccbea0d$export$f4c3d57f2f41ffe2 = {
    'Could not verify accountId from header': 'AccountIdMismatch'
};
function $88d59d6acccbea0d$export$ece443678e6cc3f5(error) {
    const constructor = error?.constructor.name;
    if (constructor && $88d59d6acccbea0d$export$c27af9588f06f6fc.includes(constructor)) return constructor;
    const message = error?.message || '';
    const containedReason = message && Object.keys($88d59d6acccbea0d$export$f4c3d57f2f41ffe2).find((ignoredMessage)=>message.includes(ignoredMessage));
    if (containedReason) return $88d59d6acccbea0d$export$f4c3d57f2f41ffe2[containedReason];
}
function $88d59d6acccbea0d$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $88d59d6acccbea0d$export$94c4b26e937da69(error) {
    if (!error) return false;
    const statusCode = error['status'] || error['statusCode'];
    if (parseInt(statusCode, 10) >= 400 && parseInt(statusCode, 10) < 500) return true;
    const reg = new RegExp(/status (code)?.*(4\d\d)/g);
    return !!error.message?.match(reg);
}
function $88d59d6acccbea0d$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $88d59d6acccbea0d$export$b19e812222b57630;
(function(DirectoryErrorCode) {
    DirectoryErrorCode["MISSING_ERROR_MESSAGE"] = "MissingErrorMessage";
})($88d59d6acccbea0d$export$b19e812222b57630 || ($88d59d6acccbea0d$export$b19e812222b57630 = {}));
var $88d59d6acccbea0d$export$c33cd4757598521c;
(function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
})($88d59d6acccbea0d$export$c33cd4757598521c || ($88d59d6acccbea0d$export$c33cd4757598521c = {}));
function $88d59d6acccbea0d$export$76843b239f07f80a(error, field) {
    return error instanceof Error && field in error;
}
function $88d59d6acccbea0d$export$17f5e6bd290bb15d(err) {
    return typeof err === 'object' && err !== null && 'graphQLErrors' in err;
}

});

parcelRegister("fECJU", function(module, exports) {

$parcel$export(module.exports, "logException", () => $38686236c3951331$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $38686236c3951331$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $38686236c3951331$export$386587bcf05ee8ea);
$parcel$export(module.exports, "createErrorHandler", () => $38686236c3951331$export$9edc7d6f1c33ddc);

var $jnlyS = parcelRequire("jnlyS");
var $fcdA0 = parcelRequire("fcdA0");
const $38686236c3951331$var$packageContext = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $38686236c3951331$export$f86b2a1a2ce291b3 = (0, $jnlyS.logExceptionWithPackageContext)($38686236c3951331$var$packageContext);
const $38686236c3951331$export$ece28f5cfa04608 = (0, $jnlyS.logErrorMessageWithPackageContext)($38686236c3951331$var$packageContext);
const $38686236c3951331$export$386587bcf05ee8ea = (0, $jnlyS.logInfoMessageWithPackageContext)($38686236c3951331$var$packageContext);
const $38686236c3951331$export$9edc7d6f1c33ddc = (0, $jnlyS.createErrorHandlerWithPackageContext)($38686236c3951331$var$packageContext);

});
parcelRegister("fcdA0", function(module, exports) {

$parcel$export(module.exports, "useTeamsSentryClientSetup", () => $a542d775eabef1c8$export$e30f49f36a0eeaeb);

var $eUqFw = parcelRequire("eUqFw");

var $9CTdJ = parcelRequire("9CTdJ");
const $a542d775eabef1c8$export$e30f49f36a0eeaeb = (isSentryEnabled, config)=>{
    const [sentryInitialised, setSentryInitialised] = (0, $eUqFw.useState)(false);
    const setupSentry = (0, $eUqFw.useCallback)(async ()=>{
        if (!sentryInitialised && isSentryEnabled && !(0, $9CTdJ.sentryClient)) await (0, $9CTdJ.setupSentryClient)(config);
    }, [
        config,
        isSentryEnabled,
        sentryInitialised
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setupSentry().then(()=>setSentryInitialised(true));
    }, [
        setupSentry
    ]);
    return 0, $9CTdJ.sentryClient;
};

});



parcelRegister("bsMUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $546a5f695a4fb237$export$2e2bcd8739ae039);
/**
 * A singleton module that will store a referrer data in a closure
 * and retrieve that data in an analytics client untill the app has
 * a route transition happened.
 *
 * How it works:
 * 1. whenever we init our app with `src` or `ref` in the URL we gonna preserve them here
 * 2. in every screen event we gonna retrieve `src` and `ref` and add them to event attributes
 * 3. as soon as app transitions to any other route we gonna cleanup the stored referrer data
 *    to stop tracking it further.
 *
 * Notes:
 *  Due to how `referrerInfo` is used to store data temporarily, now it is used only at 2 places:
 * - Analytic Client `packages/common/src/clients/analytics-client.ts`
 * - RecordTransition `packages/embeddable-directory/src/components/RecordTransition/RecordTransition.tsx`
 * If other codes try to access value inside `referrerInfo`, they may access old/empty data.
 */ 
var $hYfIu = parcelRequire("hYfIu");
// the storage for our referrer info;
let $546a5f695a4fb237$var$data = null;
const $546a5f695a4fb237$var$referrerInfo = {
    // as we preserving the data, we should at least get it once to record in analytics before allowing cleanup
    isUsed: false,
    markUsed () {
        $546a5f695a4fb237$var$referrerInfo.isUsed = true;
    },
    get () {
        return $546a5f695a4fb237$var$data;
    },
    set ({ src: src = '', ref: ref = '' }) {
        // clean up strings
        $546a5f695a4fb237$var$data = {
            src: (0, $hYfIu.sanitiseValue)(src || '', {
                shouldHaveSafeCharsOnly: true,
                shouldEncode: true
            }),
            ref: (0, $hYfIu.sanitiseValue)(ref, {
                shouldHaveSafeCharsOnly: true,
                shouldEncode: true
            })
        };
    },
    cleanup (force) {
        if (!$546a5f695a4fb237$var$referrerInfo.isUsed && !force) return;
        $546a5f695a4fb237$var$data = null;
    }
};
var $546a5f695a4fb237$export$2e2bcd8739ae039 = $546a5f695a4fb237$var$referrerInfo;

});
parcelRegister("hYfIu", function(module, exports) {

$parcel$export(module.exports, "sanitiseValue", () => $571db4be5b3da701$export$b66eb39ba856053f);
const $571db4be5b3da701$var$FORBIDDEN_CODE_CHARS = [
    8207
];
function $571db4be5b3da701$export$b66eb39ba856053f(value, options = {}) {
    let trimmedStr = value.trim();
    $571db4be5b3da701$var$FORBIDDEN_CODE_CHARS.forEach((codeChar)=>{
        const char = String.fromCharCode(codeChar);
        const re = new RegExp(char, 'gm');
        trimmedStr = trimmedStr.replace(re, '');
    });
    if (options.shouldHaveSafeCharsOnly) {
        trimmedStr = trimmedStr.replace(/[^a-z0-9_-]/gim, '');
        trimmedStr = trimmedStr.trim();
    }
    if (options.shouldEncode) trimmedStr = encodeURIComponent(trimmedStr);
    return trimmedStr;
}

});




parcelRegister("7YLRZ", function(module, exports) {

$parcel$export(module.exports, "useSetupApolloClient", () => $6a4f8a0fb42dfb71$export$78cd44b109ba6e2a);

var $eUqFw = parcelRequire("eUqFw");

var $k7WCG = parcelRequire("k7WCG");
function $6a4f8a0fb42dfb71$export$78cd44b109ba6e2a(cloudId) {
    const [apolloClient, setApolloClient] = (0, $eUqFw.useState)((0, $k7WCG.getApolloClient)({
        getCloudId: ()=>cloudId
    }));
    const gatewayClient = (0, $k7WCG.getGatewayClient)();
    // setup directory Apollo client
    (0, $eUqFw.useEffect)(()=>{
        if (!cloudId) return;
        const apolloClient = (0, $k7WCG.getApolloClient)({
            getCloudId: ()=>cloudId
        });
        /**
		 * Enables the field @cloudId in apollo queries
		 */ apolloClient.writeData({
            data: {
                cloudId: cloudId
            }
        });
        setApolloClient(apolloClient);
    }, [
        cloudId
    ]);
    // setup gateway Apollo client
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * Enables the field @cloudId in apollo queries
		 */ gatewayClient.writeData({
            data: {
                cloudId: cloudId || 'None'
            }
        });
    }, [
        cloudId,
        gatewayClient
    ]);
    return apolloClient;
}

});
parcelRegister("k7WCG", function(module, exports) {

$parcel$export(module.exports, "getApolloClient", () => $77a39de2f2aeeb01$export$1e6cfeaf8b88bd01);
$parcel$export(module.exports, "getGatewayClient", () => $77a39de2f2aeeb01$export$719274339c63410a);
$parcel$export(module.exports, "getTeamCentralClient", () => $77a39de2f2aeeb01$export$6ef19f8a51b6041);

var $kj8KJQ = parcelRequire("kj8KJQ");

var $fU34a = parcelRequire("fU34a");
var $avLBj = parcelRequire("avLBj");

var $lhBhN = parcelRequire("lhBhN");
const $77a39de2f2aeeb01$var$customFetch = (0, $lhBhN.withDefaultExponentialBackoff)(fetch);
/*************************************************/ // a common Apollo Client
let $77a39de2f2aeeb01$var$cachedApolloClient;
const $77a39de2f2aeeb01$export$1e6cfeaf8b88bd01 = (customConfig)=>{
    if ($77a39de2f2aeeb01$var$cachedApolloClient) return $77a39de2f2aeeb01$var$cachedApolloClient;
    const apolloClient = $77a39de2f2aeeb01$export$67100df7b1079985(customConfig);
    // don't cache apolloClient when cloudId is empty string
    if (customConfig?.getCloudId && customConfig?.getCloudId()) $77a39de2f2aeeb01$var$cachedApolloClient = apolloClient;
    return apolloClient;
};
const $77a39de2f2aeeb01$export$67100df7b1079985 = (customConfig)=>(0, $kj8KJQ.createApolloClient)({
        connectToDevTools: !!(0, $fU34a.DEV),
        url: {
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot,
            collaborationGraph: (0, $avLBj.getConfig)().collaborationGraph
        },
        customFetch: $77a39de2f2aeeb01$var$customFetch,
        ...customConfig
    });
/*************************************************/ // Worklens client
let $77a39de2f2aeeb01$var$cachedWorklensClient;
const $77a39de2f2aeeb01$export$f0c45e63c1288a74 = ()=>{
    if ($77a39de2f2aeeb01$var$cachedWorklensClient) return $77a39de2f2aeeb01$var$cachedWorklensClient;
    $77a39de2f2aeeb01$var$cachedWorklensClient = (0, $kj8KJQ.createWorklensClient)({
        url: {
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot
        },
        customFetch: $77a39de2f2aeeb01$var$customFetch
    });
    return $77a39de2f2aeeb01$var$cachedWorklensClient;
};
/*************************************************/ // GraphQL Gateway client
let $77a39de2f2aeeb01$var$cachedGatewayClient;
const $77a39de2f2aeeb01$export$719274339c63410a = ()=>{
    if ($77a39de2f2aeeb01$var$cachedGatewayClient) return $77a39de2f2aeeb01$var$cachedGatewayClient;
    $77a39de2f2aeeb01$var$cachedGatewayClient = (0, $kj8KJQ.createAtlassianGatewayClient)({
        url: {
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot
        },
        customFetch: $77a39de2f2aeeb01$var$customFetch
    });
    return $77a39de2f2aeeb01$var$cachedGatewayClient;
};
/*************************************************/ // GraphQL Team Central client
let $77a39de2f2aeeb01$var$cachedTeamCentralClient;
const $77a39de2f2aeeb01$export$6ef19f8a51b6041 = ()=>{
    if ($77a39de2f2aeeb01$var$cachedTeamCentralClient) return $77a39de2f2aeeb01$var$cachedTeamCentralClient;
    $77a39de2f2aeeb01$var$cachedTeamCentralClient = (0, $kj8KJQ.createTeamCentralClient)({
        url: {
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot
        },
        customFetch: $77a39de2f2aeeb01$var$customFetch
    });
    return $77a39de2f2aeeb01$var$cachedTeamCentralClient;
};

});
parcelRegister("kj8KJQ", function(module, exports) {

$parcel$export(module.exports, "createApolloClient", () => $faa19ad8ea5a421f$export$67100df7b1079985);
$parcel$export(module.exports, "createWorklensClient", () => $faa19ad8ea5a421f$export$72afd8225aad0e67);
$parcel$export(module.exports, "createAtlassianGatewayClient", () => $faa19ad8ea5a421f$export$a518457feff205cb);
$parcel$export(module.exports, "createTeamCentralClient", () => $faa19ad8ea5a421f$export$63d9e7c1fb26588f);

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");

var $711qW = parcelRequire("711qW");

var $aAMCg = parcelRequire("aAMCg");

var $9rafI = parcelRequire("9rafI");

var $2fzHI = parcelRequire("2fzHI");

var $kc4ri = parcelRequire("kc4ri");

var $dc8YU = parcelRequire("dc8YU");

var $IBBFX = parcelRequire("IBBFX");

var $aF0EL = parcelRequire("aF0EL");

var $5vw7Q = parcelRequire("5vw7Q");
const $faa19ad8ea5a421f$export$67100df7b1079985 = (options)=>{
    const { retryLink: retryOptions = {}, getCloudId: getCloudId, url: url, statusCodeHandlers: statusCodeHandlers = {}, customFetch: customFetch } = options;
    // Build up a list of Apollo links
    const links = [];
    /**
   * Apollo link for handling request errors
   */ const errorLink = (0, $dc8YU.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    if (errorLink) links.push(errorLink);
    /**
   * Apollo link for retrying certain failed requests
   */ const retryLink = (0, $IBBFX.createRetryLink)(retryOptions);
    if (retryLink) links.push(retryLink);
    /**
   * Apollo link that determines whether to send a request to directory
   * service or resolve the query locally using a custom resolver
   */ const customResolversLink = new (0, $711qW.SchemaLink)({
        schema: (0, $aAMCg.addResolveFunctionsToSchema)({
            schema: $5vw7Q.schema,
            resolvers: $aF0EL.default
        }),
        context: {
            url: url,
            fetch: (0, $9rafI.getCustomResolversFetch)({
                fetch: customFetch || fetch,
                statusCodeHandlers: statusCodeHandlers
            })
        }
    });
    const directoryHttpLink = (0, $kc4ri.createDirectoryHttpLink)({
        url: `${url ? url.stargateRoot : ''}/directory/graphql`,
        getCloudId: getCloudId
    });
    links.push((0, $bvQX6.split)(// if query has @custom, use customResolversLink
    (operation)=>(0, $2fzHI.isCustomQuery)(operation), customResolversLink, // use directory link
    directoryHttpLink));
    return new (0, $jlBDe.default)({
        connectToDevTools: !!options.connectToDevTools,
        link: (0, $bvQX6.from)(links),
        cache: new (0, $2vRh6.InMemoryCache)(),
        // empty object enables @client directive
        resolvers: {}
    });
};
const $faa19ad8ea5a421f$export$72afd8225aad0e67 = (options)=>{
    const { retryLink: retryOptions = {}, url: url, statusCodeHandlers: statusCodeHandlers = {} } = options;
    const errorLink = (0, $dc8YU.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    const retryLink = (0, $IBBFX.createRetryLink)(retryOptions);
    const httpLink = (0, $kc4ri.createDirectoryHttpLink)({
        url: `${url.stargateRoot}/worklens/api/graphql`
    });
    const links = [
        errorLink,
        retryLink,
        httpLink
    ];
    return new (0, $jlBDe.default)({
        link: (0, $bvQX6.from)(links),
        cache: new (0, $2vRh6.InMemoryCache)()
    });
};
const $faa19ad8ea5a421f$export$a518457feff205cb = (options)=>{
    const { retryLink: retryOptions = {}, url: url, statusCodeHandlers: statusCodeHandlers = {} } = options;
    const errorLink = (0, $dc8YU.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    const retryLink = (0, $IBBFX.createRetryLink)(retryOptions);
    const httpLink = (0, $kc4ri.createDirectoryHttpLink)({
        url: `${url.stargateRoot}/graphql`
    });
    const links = [
        errorLink,
        retryLink,
        httpLink
    ];
    return new (0, $jlBDe.default)({
        link: (0, $bvQX6.from)(links),
        cache: new (0, $2vRh6.InMemoryCache)(),
        // empty object enables @client directive
        resolvers: {}
    });
};
const $faa19ad8ea5a421f$export$63d9e7c1fb26588f = (options)=>{
    const { retryLink: retryOptions = {}, url: url, statusCodeHandlers: statusCodeHandlers = {} } = options;
    const errorLink = (0, $dc8YU.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    const retryLink = (0, $IBBFX.createRetryLink)(retryOptions);
    const httpLink = (0, $kc4ri.createDirectoryHttpLink)({
        url: `${url ? url.stargateRoot : ''}/watermelon/graphql`
    });
    const links = [
        errorLink,
        retryLink,
        httpLink
    ];
    return new (0, $jlBDe.default)({
        link: (0, $bvQX6.from)(links),
        cache: new (0, $2vRh6.InMemoryCache)({
            dataIdFromObject: (obj)=>{
                switch(obj.__typename){
                    case 'Icon':
                        return `${obj.id}:${obj.shortName}|${obj.color}`;
                    case 'GoalPhaseDetails':
                    case 'ProjectPhaseDetails':
                    case 'GqlJiraIssue':
                    case 'GqlJiraIssueType':
                    case 'GqlJiraStatus':
                    case 'GqlJiraStatusCategory':
                        return `${obj.__typename}:${obj.id}`;
                    default:
                        return obj.id;
                }
            }
        })
    });
};

});
parcelRegister("2vRh6", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $1d47cd4d9b8db33d$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1d47cd4d9b8db33d$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");

var $bO1Qv = parcelRequire("bO1Qv");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $7xYai = parcelRequire("7xYai");

var $8j2fP = parcelRequire("8j2fP");
var $1d47cd4d9b8db33d$var$haveWarned = false;
function $1d47cd4d9b8db33d$var$shouldWarn() {
    var answer = !$1d47cd4d9b8db33d$var$haveWarned;
    if (!(0, $42BH7.isTest)()) $1d47cd4d9b8db33d$var$haveWarned = true;
    return answer;
}
var $1d47cd4d9b8db33d$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1d47cd4d9b8db33d$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1d47cd4d9b8db33d$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1d47cd4d9b8db33d$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8j2fP.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8j2fP.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1d47cd4d9b8db33d$var$hasOwn = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $7xYai.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1d47cd4d9b8db33d$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1d47cd4d9b8db33d$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory(seed) {
    return new $1d47cd4d9b8db33d$var$DepTrackingCache(seed);
}
var $1d47cd4d9b8db33d$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $7xYai.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $7xYai.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $7xYai.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $42BH7.getQueryDefinition)(query);
        variables = (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8j2fP.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $66hGB.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $42BH7.getMainDefinition)(query);
        var fragments = (0, $42BH7.getFragmentDefinitions)(query);
        var fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8j2fP.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $42BH7.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $42BH7.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $42BH7.resultKeyNameFromField)(field),
            directives: (0, $42BH7.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $42BH7.isIdValue)(value)) throw new (0, $8j2fP.InvariantError)(10);
}
function $1d47cd4d9b8db33d$var$defaultFragmentMatcher() {
    return true;
}
function $1d47cd4d9b8db33d$export$7a4899fe13f33235(idValue) {
    (0, $8j2fP.invariant)((0, $42BH7.isIdValue)(idValue), 11);
}
function $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $42BH7.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $42BH7.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $42BH7.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1d47cd4d9b8db33d$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1d47cd4d9b8db33d$export$7e2b40d1002de152(seed) {
    return new $1d47cd4d9b8db33d$export$ee7258b8691956a3(seed);
}
var $1d47cd4d9b8db33d$export$de4e6870dc6ac801 = function(_super) {
    (0, $fKE23.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1d47cd4d9b8db33d$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1d47cd4d9b8db33d$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1d47cd4d9b8db33d$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $42BH7.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $42BH7.createFragmentMap)((0, $42BH7.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1d47cd4d9b8db33d$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var resultFieldKey = (0, $42BH7.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8j2fP.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $42BH7.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1d47cd4d9b8db33d$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $42BH7.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $42BH7.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1d47cd4d9b8db33d$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8j2fP.invariant)(!semanticId || !$1d47cd4d9b8db33d$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $42BH7.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $42BH7.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8j2fP.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8j2fP.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1d47cd4d9b8db33d$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $66hGB.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $42BH7.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1d47cd4d9b8db33d$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1d47cd4d9b8db33d$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $42BH7.isIdValue)(value) && $1d47cd4d9b8db33d$var$isGeneratedId(value.id) && (0, $42BH7.isIdValue)(realValue) && !(0, $66hGB.equal)(value, realValue) && $1d47cd4d9b8db33d$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, generated), real);
    if ((0, $66hGB.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1d47cd4d9b8db33d$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1d47cd4d9b8db33d$var$defaultConfig = {
    fragmentMatcher: new $1d47cd4d9b8db33d$export$5d3fcf53267091de(),
    dataIdFromObject: $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1d47cd4d9b8db33d$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$OptimisticCacheLayer = function(_super) {
    (0, $fKE23.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1d47cd4d9b8db33d$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1d47cd4d9b8db33d$export$ee7258b8691956a3);
var $1d47cd4d9b8db33d$export$467265324939f47f = function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $1d47cd4d9b8db33d$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1d47cd4d9b8db33d$var$DepTrackingCache() : new $1d47cd4d9b8db33d$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1d47cd4d9b8db33d$export$eb8361c5d132fb8f();
        _this.storeReader = new $1d47cd4d9b8db33d$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $7xYai.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8j2fP.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1d47cd4d9b8db33d$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1d47cd4d9b8db33d$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $42BH7.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $bO1Qv.ApolloCache));

});
parcelRegister("bO1Qv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $8985cbc47a37b971$export$5fc74f25506aa9c);

var $42BH7 = parcelRequire("42BH7");
function $8985cbc47a37b971$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $8985cbc47a37b971$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $8985cbc47a37b971$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $8985cbc47a37b971$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $8985cbc47a37b971$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $8985cbc47a37b971$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $8985cbc47a37b971$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $8985cbc47a37b971$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $8985cbc47a37b971$export$94affb487e701bf2;
$8985cbc47a37b971$export$94affb487e701bf2 || ($8985cbc47a37b971$export$94affb487e701bf2 = {});

});

parcelRegister("7xYai", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $57ea48f9f955816f$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $57ea48f9f955816f$export$4997ffc0176396a6);

var $182fv = parcelRequire("182fv");
function $57ea48f9f955816f$var$defaultDispose() {}
var $57ea48f9f955816f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $57ea48f9f955816f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $57ea48f9f955816f$var$parentEntrySlot = new (0, $182fv.Slot)();
var $57ea48f9f955816f$var$reusableEmptyArray = [];
var $57ea48f9f955816f$var$emptySetPool = [];
var $57ea48f9f955816f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $57ea48f9f955816f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $57ea48f9f955816f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $57ea48f9f955816f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $57ea48f9f955816f$var$valueCopy(value) {
    return value.slice(0);
}
var $57ea48f9f955816f$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $57ea48f9f955816f$var$assert(!this.recomputing, "already recomputing");
        if (!$57ea48f9f955816f$var$rememberParent(this) && $57ea48f9f955816f$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $57ea48f9f955816f$var$mightBeDirty(this) ? $57ea48f9f955816f$var$reallyRecompute(this) : $57ea48f9f955816f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $57ea48f9f955816f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $57ea48f9f955816f$var$forgetChildren(this).forEach($57ea48f9f955816f$var$maybeReportOrphan);
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $57ea48f9f955816f$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $57ea48f9f955816f$var$rememberParent(child) {
    var parent = $57ea48f9f955816f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($57ea48f9f955816f$var$mightBeDirty(child)) $57ea48f9f955816f$var$reportDirtyChild(parent, child);
        else $57ea48f9f955816f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $57ea48f9f955816f$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $57ea48f9f955816f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $57ea48f9f955816f$var$parentEntrySlot.withValue(entry, $57ea48f9f955816f$var$recomputeNewValue, [
        entry
    ]);
    if ($57ea48f9f955816f$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $57ea48f9f955816f$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($57ea48f9f955816f$var$maybeReportOrphan);
    return $57ea48f9f955816f$var$valueGet(entry.value);
}
function $57ea48f9f955816f$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $57ea48f9f955816f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $57ea48f9f955816f$var$setClean(entry) {
    entry.dirty = false;
    if ($57ea48f9f955816f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $57ea48f9f955816f$var$reportClean(entry);
}
function $57ea48f9f955816f$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportDirtyChild(parent, child);
    });
}
function $57ea48f9f955816f$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $57ea48f9f955816f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert($57ea48f9f955816f$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $57ea48f9f955816f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $57ea48f9f955816f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $57ea48f9f955816f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert(!$57ea48f9f955816f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $57ea48f9f955816f$var$valueCopy(child.value));
    else if (!$57ea48f9f955816f$var$valueIs(childValue, child.value)) parent.setDirty();
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
    if ($57ea48f9f955816f$var$mightBeDirty(parent)) return;
    $57ea48f9f955816f$var$reportClean(parent);
}
function $57ea48f9f955816f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($57ea48f9f955816f$var$emptySetPool.length < $57ea48f9f955816f$var$POOL_TARGET_SIZE) $57ea48f9f955816f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $57ea48f9f955816f$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $57ea48f9f955816f$var$forgetChildren(parent) {
    var children = $57ea48f9f955816f$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $57ea48f9f955816f$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $57ea48f9f955816f$var$assert(parent.dirtyChildren === null);
    return children;
}
function $57ea48f9f955816f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
}
function $57ea48f9f955816f$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $57ea48f9f955816f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $57ea48f9f955816f$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $57ea48f9f955816f$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $57ea48f9f955816f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $57ea48f9f955816f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $57ea48f9f955816f$var$keyTrie = new $57ea48f9f955816f$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $57ea48f9f955816f$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $57ea48f9f955816f$var$keyTrie.lookupArray(args);
}
var $57ea48f9f955816f$var$caches = new Set();
function $57ea48f9f955816f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $57ea48f9f955816f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $57ea48f9f955816f$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$57ea48f9f955816f$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $57ea48f9f955816f$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $57ea48f9f955816f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$57ea48f9f955816f$var$parentEntrySlot.hasValue()) {
            $57ea48f9f955816f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $57ea48f9f955816f$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("182fv", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $0d28486785009faf$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $0d28486785009faf$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $0d28486785009faf$var$MISSING_VALUE = {};
var $0d28486785009faf$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $0d28486785009faf$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0d28486785009faf$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $0d28486785009faf$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $0d28486785009faf$var$MISSING_VALUE) break;
                if (context_1 !== $0d28486785009faf$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0d28486785009faf$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0d28486785009faf$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0d28486785009faf$var$currentContext.slots[this.id] = $0d28486785009faf$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $0d28486785009faf$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $0d28486785009faf$var$currentContext;
            $0d28486785009faf$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0d28486785009faf$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $0d28486785009faf$var$currentContext;
            return function() {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0d28486785009faf$var$currentContext) {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $0d28486785009faf$var$globalKey = "@wry/context:Slot";
var $0d28486785009faf$var$host = Array;
var $0d28486785009faf$export$8c6ed5c666ac1360 = $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] || function() {
    var Slot = $0d28486785009faf$var$makeSlotClass();
    try {
        Object.defineProperty($0d28486785009faf$var$host, $0d28486785009faf$var$globalKey, {
            value: $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $0d28486785009faf$export$2385a24977818dd0 = $0d28486785009faf$export$8c6ed5c666ac1360.bind, $0d28486785009faf$export$9fa6f2e300a97f8 = $0d28486785009faf$export$8c6ed5c666ac1360.noContext;
function $0d28486785009faf$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($0d28486785009faf$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $0d28486785009faf$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $0d28486785009faf$export$2385a24977818dd0(gen.next);
        var boundThrow = $0d28486785009faf$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($0d28486785009faf$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $0d28486785009faf$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $0d28486785009faf$var$wrappedFibers = [];
function $0d28486785009faf$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($0d28486785009faf$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $0d28486785009faf$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $0d28486785009faf$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("711qW", function(module, exports) {

$parcel$export(module.exports, "SchemaLink", () => $51b9bd0fcd15a4c3$export$f2b7839aa4c35c8d);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");

var $3MP74 = parcelRequire("3MP74");
var $51b9bd0fcd15a4c3$export$f2b7839aa4c35c8d = function(_super) {
    (0, $fKE23.__extends)(SchemaLink, _super);
    function SchemaLink(_a) {
        var schema = _a.schema, rootValue = _a.rootValue, context = _a.context;
        var _this = _super.call(this) || this;
        _this.schema = schema;
        _this.rootValue = rootValue;
        _this.context = context;
        return _this;
    }
    SchemaLink.prototype.request = function(operation) {
        var _this = this;
        return new (0, $bvQX6.Observable)(function(observer) {
            Promise.resolve((0, $3MP74.execute)(_this.schema, operation.query, _this.rootValue, typeof _this.context === 'function' ? _this.context(operation) : _this.context, operation.variables, operation.operationName)).then(function(data) {
                if (!observer.closed) {
                    observer.next(data);
                    observer.complete();
                }
            }).catch(function(error) {
                if (!observer.closed) observer.error(error);
            });
        });
    };
    return SchemaLink;
}((0, $bvQX6.ApolloLink));
var $51b9bd0fcd15a4c3$export$2e2bcd8739ae039 = $51b9bd0fcd15a4c3$export$f2b7839aa4c35c8d;

});
parcelRegister("3MP74", function(module, exports) {

$parcel$export(module.exports, "execute", () => $28b9215d12482e59$export$51396ec711da548b);
$parcel$export(module.exports, "assertValidExecutionArguments", () => $28b9215d12482e59$export$e02b605d81e17af1);
$parcel$export(module.exports, "buildExecutionContext", () => $28b9215d12482e59$export$312a3f029bac48f9);
$parcel$export(module.exports, "defaultFieldResolver", () => $28b9215d12482e59$export$21fc6d079630d659);
$parcel$export(module.exports, "collectFields", () => $28b9215d12482e59$export$c23741d442fe90e9);
$parcel$export(module.exports, "getFieldDef", () => $28b9215d12482e59$export$dab6dcab745bb1b6);
$parcel$export(module.exports, "buildResolveInfo", () => $28b9215d12482e59$export$27b5443b7768606f);

var $biK02 = parcelRequire("biK02");

var $aF2x8 = parcelRequire("aF2x8");

var $43MJl = parcelRequire("43MJl");

var $fZdRY = parcelRequire("fZdRY");

var $cvCbM = parcelRequire("cvCbM");

var $fbtyx = parcelRequire("fbtyx");

var $8DMvn = parcelRequire("8DMvn");

var $3SMRB = parcelRequire("3SMRB");

var $jvU6q = parcelRequire("jvU6q");

var $kZHaf = parcelRequire("kZHaf");

var $9fgMZ = parcelRequire("9fgMZ");

var $02KAV = parcelRequire("02KAV");

var $1c4hI = parcelRequire("1c4hI");

var $izaFt = parcelRequire("izaFt");

var $h2iUh = parcelRequire("h2iUh");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");

var $bis9F = parcelRequire("bis9F");

var $gqGQB = parcelRequire("gqGQB");
function $28b9215d12482e59$export$51396ec711da548b(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    return arguments.length === 1 ? $28b9215d12482e59$var$executeImpl(argsOrSchema) : $28b9215d12482e59$var$executeImpl({
        schema: argsOrSchema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    });
}
function $28b9215d12482e59$export$6d0f20a121527483(args) {
    var result = $28b9215d12482e59$var$executeImpl(args); // Assert that the execution was synchronous.
    if ((0, $cvCbM.default)(result)) throw new Error('GraphQL execution failed to complete synchronously.');
    return result;
}
function $28b9215d12482e59$var$executeImpl(args) {
    var schema = args.schema, document = args.document, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, typeResolver = args.typeResolver; // If arguments are missing or incorrect, throw an error.
    $28b9215d12482e59$export$e02b605d81e17af1(schema, document, variableValues); // If a valid execution context cannot be created due to incorrect arguments,
    // a "Response" with only errors is returned.
    var exeContext = $28b9215d12482e59$export$312a3f029bac48f9(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver); // Return early errors if execution context failed.
    if (Array.isArray(exeContext)) return {
        errors: exeContext
    };
     // Return a Promise that will eventually resolve to the data described by
    // The "Response" section of the GraphQL specification.
    //
    // If errors are encountered while executing a GraphQL field, only that
    // field and its descendants will be omitted, and sibling fields will still
    // be executed. An execution which encounters errors will still result in a
    // resolved Promise.
    var data = $28b9215d12482e59$var$executeOperation(exeContext, exeContext.operation, rootValue);
    return $28b9215d12482e59$var$buildResponse(exeContext, data);
}
/**
 * Given a completed execution context and data, build the { errors, data }
 * response defined by the "Response" section of the GraphQL specification.
 */ function $28b9215d12482e59$var$buildResponse(exeContext, data) {
    if ((0, $cvCbM.default)(data)) return data.then(function(resolved) {
        return $28b9215d12482e59$var$buildResponse(exeContext, resolved);
    });
    return exeContext.errors.length === 0 ? {
        data: data
    } : {
        errors: exeContext.errors,
        data: data
    };
}
function $28b9215d12482e59$export$e02b605d81e17af1(schema, document, rawVariableValues) {
    document || (0, $fZdRY.default)(0, 'Must provide document.'); // If the schema used for execution is invalid, throw an error.
    (0, $izaFt.assertValidSchema)(schema); // Variables, if provided, must be an object.
    rawVariableValues == null || (0, $fbtyx.default)(rawVariableValues) || (0, $fZdRY.default)(0, 'Variables must be provided as an Object where each property is a variable value. Perhaps look to see if an unparsed JSON string was provided.');
}
function $28b9215d12482e59$export$312a3f029bac48f9(schema, document, rootValue, contextValue, rawVariableValues, operationName, fieldResolver, typeResolver) {
    var _definition$name, _operation$variableDe;
    var operation;
    var fragments = Object.create(null);
    for(var _i2 = 0, _document$definitions2 = document.definitions; _i2 < _document$definitions2.length; _i2++){
        var definition = _document$definitions2[_i2];
        switch(definition.kind){
            case (0, $1c4hI.Kind).OPERATION_DEFINITION:
                if (operationName == null) {
                    if (operation !== undefined) return [
                        new (0, $9fgMZ.GraphQLError)('Must provide operation name if query contains multiple operations.')
                    ];
                    operation = definition;
                } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) operation = definition;
                break;
            case (0, $1c4hI.Kind).FRAGMENT_DEFINITION:
                fragments[definition.name.value] = definition;
                break;
        }
    }
    if (!operation) {
        if (operationName != null) return [
            new (0, $9fgMZ.GraphQLError)("Unknown operation named \"".concat(operationName, "\"."))
        ];
        return [
            new (0, $9fgMZ.GraphQLError)('Must provide an operation.')
        ];
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    var variableDefinitions = (_operation$variableDe = operation.variableDefinitions) !== null && _operation$variableDe !== void 0 ? _operation$variableDe : [];
    var coercedVariableValues = (0, $gqGQB.getVariableValues)(schema, variableDefinitions, rawVariableValues !== null && rawVariableValues !== void 0 ? rawVariableValues : {}, {
        maxErrors: 50
    });
    if (coercedVariableValues.errors) return coercedVariableValues.errors;
    return {
        schema: schema,
        fragments: fragments,
        rootValue: rootValue,
        contextValue: contextValue,
        operation: operation,
        variableValues: coercedVariableValues.coerced,
        fieldResolver: fieldResolver !== null && fieldResolver !== void 0 ? fieldResolver : $28b9215d12482e59$export$21fc6d079630d659,
        typeResolver: typeResolver !== null && typeResolver !== void 0 ? typeResolver : $28b9215d12482e59$export$4a45c17a1ba2cb7,
        errors: []
    };
}
/**
 * Implements the "Evaluating operations" section of the spec.
 */ function $28b9215d12482e59$var$executeOperation(exeContext, operation, rootValue) {
    var type = (0, $bis9F.getOperationRootType)(exeContext.schema, operation);
    var fields = $28b9215d12482e59$export$c23741d442fe90e9(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
    var path = undefined; // Errors from sub-fields of a NonNull type may propagate to the top level,
    // at which point we still log the error and null the parent field, which
    // in this case is the entire response.
    try {
        var result = operation.operation === 'mutation' ? $28b9215d12482e59$var$executeFieldsSerially(exeContext, type, rootValue, path, fields) : $28b9215d12482e59$var$executeFields(exeContext, type, rootValue, path, fields);
        if ((0, $cvCbM.default)(result)) return result.then(undefined, function(error) {
            exeContext.errors.push(error);
            return Promise.resolve(null);
        });
        return result;
    } catch (error) {
        exeContext.errors.push(error);
        return null;
    }
}
/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "write" mode.
 */ function $28b9215d12482e59$var$executeFieldsSerially(exeContext, parentType, sourceValue, path, fields) {
    return (0, $3SMRB.default)(Object.keys(fields), function(results, responseName) {
        var fieldNodes = fields[responseName];
        var fieldPath = (0, $kZHaf.addPath)(path, responseName, parentType.name);
        var result = $28b9215d12482e59$var$resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
        if (result === undefined) return results;
        if ((0, $cvCbM.default)(result)) return result.then(function(resolvedResult) {
            results[responseName] = resolvedResult;
            return results;
        });
        results[responseName] = result;
        return results;
    }, Object.create(null));
}
/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "read" mode.
 */ function $28b9215d12482e59$var$executeFields(exeContext, parentType, sourceValue, path, fields) {
    var results = Object.create(null);
    var containsPromise = false;
    for(var _i4 = 0, _Object$keys2 = Object.keys(fields); _i4 < _Object$keys2.length; _i4++){
        var responseName = _Object$keys2[_i4];
        var fieldNodes = fields[responseName];
        var fieldPath = (0, $kZHaf.addPath)(path, responseName, parentType.name);
        var result = $28b9215d12482e59$var$resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
        if (result !== undefined) {
            results[responseName] = result;
            if ((0, $cvCbM.default)(result)) containsPromise = true;
        }
    } // If there are no promises, we can just return the object
    if (!containsPromise) return results;
     // Otherwise, results is a map from field name to the result of resolving that
    // field, which is possibly a promise. Return a promise that will return this
    // same map, but with any promises replaced with the values they resolved to.
    return (0, $jvU6q.default)(results);
}
function $28b9215d12482e59$export$c23741d442fe90e9(exeContext, runtimeType, selectionSet, fields, visitedFragmentNames) {
    for(var _i6 = 0, _selectionSet$selecti2 = selectionSet.selections; _i6 < _selectionSet$selecti2.length; _i6++){
        var selection = _selectionSet$selecti2[_i6];
        switch(selection.kind){
            case (0, $1c4hI.Kind).FIELD:
                if (!$28b9215d12482e59$var$shouldIncludeNode(exeContext, selection)) continue;
                var name = $28b9215d12482e59$var$getFieldEntryKey(selection);
                if (!fields[name]) fields[name] = [];
                fields[name].push(selection);
                break;
            case (0, $1c4hI.Kind).INLINE_FRAGMENT:
                if (!$28b9215d12482e59$var$shouldIncludeNode(exeContext, selection) || !$28b9215d12482e59$var$doesFragmentConditionMatch(exeContext, selection, runtimeType)) continue;
                $28b9215d12482e59$export$c23741d442fe90e9(exeContext, runtimeType, selection.selectionSet, fields, visitedFragmentNames);
                break;
            case (0, $1c4hI.Kind).FRAGMENT_SPREAD:
                var fragName = selection.name.value;
                if (visitedFragmentNames[fragName] || !$28b9215d12482e59$var$shouldIncludeNode(exeContext, selection)) continue;
                visitedFragmentNames[fragName] = true;
                var fragment = exeContext.fragments[fragName];
                if (!fragment || !$28b9215d12482e59$var$doesFragmentConditionMatch(exeContext, fragment, runtimeType)) continue;
                $28b9215d12482e59$export$c23741d442fe90e9(exeContext, runtimeType, fragment.selectionSet, fields, visitedFragmentNames);
                break;
        }
    }
    return fields;
}
/**
 * Determines if a field should be included based on the @include and @skip
 * directives, where @skip has higher precedence than @include.
 */ function $28b9215d12482e59$var$shouldIncludeNode(exeContext, node) {
    var skip = (0, $gqGQB.getDirectiveValues)((0, $bOniD.GraphQLSkipDirective), node, exeContext.variableValues);
    if ((skip === null || skip === void 0 ? void 0 : skip.if) === true) return false;
    var include = (0, $gqGQB.getDirectiveValues)((0, $bOniD.GraphQLIncludeDirective), node, exeContext.variableValues);
    if ((include === null || include === void 0 ? void 0 : include.if) === false) return false;
    return true;
}
/**
 * Determines if a fragment is applicable to the given type.
 */ function $28b9215d12482e59$var$doesFragmentConditionMatch(exeContext, fragment, type) {
    var typeConditionNode = fragment.typeCondition;
    if (!typeConditionNode) return true;
    var conditionalType = (0, $3zSAT.typeFromAST)(exeContext.schema, typeConditionNode);
    if (conditionalType === type) return true;
    if ((0, $lXoEQ.isAbstractType)(conditionalType)) return exeContext.schema.isSubType(conditionalType, type);
    return false;
}
/**
 * Implements the logic to compute the key of a given field's entry
 */ function $28b9215d12482e59$var$getFieldEntryKey(node) {
    return node.alias ? node.alias.value : node.name.value;
}
/**
 * Resolves the field on the given source object. In particular, this
 * figures out the value that the field returns by calling its resolve function,
 * then calls completeValue to complete promises, serialize scalars, or execute
 * the sub-selection-set for objects.
 */ function $28b9215d12482e59$var$resolveField(exeContext, parentType, source, fieldNodes, path) {
    var _fieldDef$resolve;
    var fieldNode = fieldNodes[0];
    var fieldName = fieldNode.name.value;
    var fieldDef = $28b9215d12482e59$export$dab6dcab745bb1b6(exeContext.schema, parentType, fieldName);
    if (!fieldDef) return;
    var returnType = fieldDef.type;
    var resolveFn = (_fieldDef$resolve = fieldDef.resolve) !== null && _fieldDef$resolve !== void 0 ? _fieldDef$resolve : exeContext.fieldResolver;
    var info = $28b9215d12482e59$export$27b5443b7768606f(exeContext, fieldDef, fieldNodes, parentType, path); // Get the resolve function, regardless of if its result is normal or abrupt (error).
    try {
        // Build a JS object of arguments from the field.arguments AST, using the
        // variables scope to fulfill any variable references.
        // TODO: find a way to memoize, in case this field is within a List type.
        var args = (0, $gqGQB.getArgumentValues)(fieldDef, fieldNodes[0], exeContext.variableValues); // The resolve function's optional third argument is a context value that
        // is provided to every resolve function within an execution. It is commonly
        // used to represent an authenticated user, or request-specific caches.
        var _contextValue = exeContext.contextValue;
        var result = resolveFn(source, args, _contextValue, info);
        var completed;
        if ((0, $cvCbM.default)(result)) completed = result.then(function(resolved) {
            return $28b9215d12482e59$var$completeValue(exeContext, returnType, fieldNodes, info, path, resolved);
        });
        else completed = $28b9215d12482e59$var$completeValue(exeContext, returnType, fieldNodes, info, path, result);
        if ((0, $cvCbM.default)(completed)) // Note: we don't rely on a `catch` method, but we do expect "thenable"
        // to take a second callback for the error case.
        return completed.then(undefined, function(rawError) {
            var error = (0, $02KAV.locatedError)(rawError, fieldNodes, (0, $kZHaf.pathToArray)(path));
            return $28b9215d12482e59$var$handleFieldError(error, returnType, exeContext);
        });
        return completed;
    } catch (rawError) {
        var error = (0, $02KAV.locatedError)(rawError, fieldNodes, (0, $kZHaf.pathToArray)(path));
        return $28b9215d12482e59$var$handleFieldError(error, returnType, exeContext);
    }
}
function $28b9215d12482e59$export$27b5443b7768606f(exeContext, fieldDef, fieldNodes, parentType, path) {
    // The resolve function's optional fourth argument is a collection of
    // information about the current execution state.
    return {
        fieldName: fieldDef.name,
        fieldNodes: fieldNodes,
        returnType: fieldDef.type,
        parentType: parentType,
        path: path,
        schema: exeContext.schema,
        fragments: exeContext.fragments,
        rootValue: exeContext.rootValue,
        operation: exeContext.operation,
        variableValues: exeContext.variableValues
    };
}
function $28b9215d12482e59$var$handleFieldError(error, returnType, exeContext) {
    // If the field type is non-nullable, then it is resolved without any
    // protection from errors, however it still properly locates the error.
    if ((0, $lXoEQ.isNonNullType)(returnType)) throw error;
     // Otherwise, error protection is applied, logging the error and resolving
    // a null value for this field if one is encountered.
    exeContext.errors.push(error);
    return null;
}
/**
 * Implements the instructions for completeValue as defined in the
 * "Field entries" section of the spec.
 *
 * If the field type is Non-Null, then this recursively completes the value
 * for the inner type. It throws a field error if that completion returns null,
 * as per the "Nullability" section of the spec.
 *
 * If the field type is a List, then this recursively completes the value
 * for the inner type on each item in the list.
 *
 * If the field type is a Scalar or Enum, ensures the completed value is a legal
 * value of the type by calling the `serialize` method of GraphQL type
 * definition.
 *
 * If the field is an abstract type, determine the runtime type of the value
 * and then complete based on that type
 *
 * Otherwise, the field type expects a sub-selection set, and will complete the
 * value by evaluating all sub-selections.
 */ function $28b9215d12482e59$var$completeValue(exeContext, returnType, fieldNodes, info, path, result) {
    // If result is an Error, throw a located error.
    if (result instanceof Error) throw result;
     // If field type is NonNull, complete for inner type, and throw field error
    // if result is null.
    if ((0, $lXoEQ.isNonNullType)(returnType)) {
        var completed = $28b9215d12482e59$var$completeValue(exeContext, returnType.ofType, fieldNodes, info, path, result);
        if (completed === null) throw new Error("Cannot return null for non-nullable field ".concat(info.parentType.name, ".").concat(info.fieldName, "."));
        return completed;
    } // If result value is null or undefined then return null.
    if (result == null) return null;
     // If field type is List, complete each item in the list with the inner type
    if ((0, $lXoEQ.isListType)(returnType)) return $28b9215d12482e59$var$completeListValue(exeContext, returnType, fieldNodes, info, path, result);
     // If field type is a leaf type, Scalar or Enum, serialize to a valid value,
    // returning null if serialization is not possible.
    if ((0, $lXoEQ.isLeafType)(returnType)) return $28b9215d12482e59$var$completeLeafValue(returnType, result);
     // If field type is an abstract type, Interface or Union, determine the
    // runtime Object type and complete for that type.
    if ((0, $lXoEQ.isAbstractType)(returnType)) return $28b9215d12482e59$var$completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result);
     // If field type is Object, execute and complete all sub-selections.
    // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isObjectType)(returnType)) return $28b9215d12482e59$var$completeObjectValue(exeContext, returnType, fieldNodes, info, path, result);
     // istanbul ignore next (Not reachable. All possible output types have been considered)
    (0, $43MJl.default)(0, 'Cannot complete value of unexpected output type: ' + (0, $biK02.default)(returnType));
}
/**
 * Complete a list value by completing each item in the list with the
 * inner type
 */ function $28b9215d12482e59$var$completeListValue(exeContext, returnType, fieldNodes, info, path, result) {
    // This is specified as a simple map, however we're optimizing the path
    // where the list contains no Promises by avoiding creating another Promise.
    var itemType = returnType.ofType;
    var containsPromise = false;
    var completedResults = (0, $8DMvn.default)(result, function(item, index) {
        // No need to modify the info object containing the path,
        // since from here on it is not ever accessed by resolver functions.
        var itemPath = (0, $kZHaf.addPath)(path, index, undefined);
        try {
            var completedItem;
            if ((0, $cvCbM.default)(item)) completedItem = item.then(function(resolved) {
                return $28b9215d12482e59$var$completeValue(exeContext, itemType, fieldNodes, info, itemPath, resolved);
            });
            else completedItem = $28b9215d12482e59$var$completeValue(exeContext, itemType, fieldNodes, info, itemPath, item);
            if ((0, $cvCbM.default)(completedItem)) {
                containsPromise = true; // Note: we don't rely on a `catch` method, but we do expect "thenable"
                // to take a second callback for the error case.
                return completedItem.then(undefined, function(rawError) {
                    var error = (0, $02KAV.locatedError)(rawError, fieldNodes, (0, $kZHaf.pathToArray)(itemPath));
                    return $28b9215d12482e59$var$handleFieldError(error, itemType, exeContext);
                });
            }
            return completedItem;
        } catch (rawError) {
            var error = (0, $02KAV.locatedError)(rawError, fieldNodes, (0, $kZHaf.pathToArray)(itemPath));
            return $28b9215d12482e59$var$handleFieldError(error, itemType, exeContext);
        }
    });
    if (completedResults == null) throw new (0, $9fgMZ.GraphQLError)("Expected Iterable, but did not find one for field \"".concat(info.parentType.name, ".").concat(info.fieldName, "\"."));
    return containsPromise ? Promise.all(completedResults) : completedResults;
}
/**
 * Complete a Scalar or Enum by serializing to a valid value, returning
 * null if serialization is not possible.
 */ function $28b9215d12482e59$var$completeLeafValue(returnType, result) {
    var serializedResult = returnType.serialize(result);
    if (serializedResult === undefined) throw new Error("Expected a value of type \"".concat((0, $biK02.default)(returnType), "\" but ") + "received: ".concat((0, $biK02.default)(result)));
    return serializedResult;
}
/**
 * Complete a value of an abstract type by determining the runtime object type
 * of that value, then complete the value for that type.
 */ function $28b9215d12482e59$var$completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result) {
    var _returnType$resolveTy;
    var resolveTypeFn = (_returnType$resolveTy = returnType.resolveType) !== null && _returnType$resolveTy !== void 0 ? _returnType$resolveTy : exeContext.typeResolver;
    var contextValue = exeContext.contextValue;
    var runtimeType = resolveTypeFn(result, contextValue, info, returnType);
    if ((0, $cvCbM.default)(runtimeType)) return runtimeType.then(function(resolvedRuntimeType) {
        return $28b9215d12482e59$var$completeObjectValue(exeContext, $28b9215d12482e59$var$ensureValidRuntimeType(resolvedRuntimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
    });
    return $28b9215d12482e59$var$completeObjectValue(exeContext, $28b9215d12482e59$var$ensureValidRuntimeType(runtimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
}
function $28b9215d12482e59$var$ensureValidRuntimeType(runtimeTypeOrName, exeContext, returnType, fieldNodes, info, result) {
    if (runtimeTypeOrName == null) throw new (0, $9fgMZ.GraphQLError)("Abstract type \"".concat(returnType.name, "\" must resolve to an Object type at runtime for field \"").concat(info.parentType.name, ".").concat(info.fieldName, "\". Either the \"").concat(returnType.name, "\" type should provide a \"resolveType\" function or each possible type should provide an \"isTypeOf\" function."), fieldNodes);
     // FIXME: temporary workaround until support for passing object types would be removed in v16.0.0
    var runtimeTypeName = (0, $lXoEQ.isNamedType)(runtimeTypeOrName) ? runtimeTypeOrName.name : runtimeTypeOrName;
    if (typeof runtimeTypeName !== 'string') throw new (0, $9fgMZ.GraphQLError)("Abstract type \"".concat(returnType.name, "\" must resolve to an Object type at runtime for field \"").concat(info.parentType.name, ".").concat(info.fieldName, "\" with ") + "value ".concat((0, $biK02.default)(result), ", received \"").concat((0, $biK02.default)(runtimeTypeOrName), "\"."));
    var runtimeType = exeContext.schema.getType(runtimeTypeName);
    if (runtimeType == null) throw new (0, $9fgMZ.GraphQLError)("Abstract type \"".concat(returnType.name, "\" was resolve to a type \"").concat(runtimeTypeName, "\" that does not exist inside schema."), fieldNodes);
    if (!(0, $lXoEQ.isObjectType)(runtimeType)) throw new (0, $9fgMZ.GraphQLError)("Abstract type \"".concat(returnType.name, "\" was resolve to a non-object type \"").concat(runtimeTypeName, "\"."), fieldNodes);
    if (!exeContext.schema.isSubType(returnType, runtimeType)) throw new (0, $9fgMZ.GraphQLError)("Runtime Object type \"".concat(runtimeType.name, "\" is not a possible type for \"").concat(returnType.name, "\"."), fieldNodes);
    return runtimeType;
}
/**
 * Complete an Object value by executing all sub-selections.
 */ function $28b9215d12482e59$var$completeObjectValue(exeContext, returnType, fieldNodes, info, path, result) {
    // If there is an isTypeOf predicate function, call it with the
    // current result. If isTypeOf returns false, then raise an error rather
    // than continuing execution.
    if (returnType.isTypeOf) {
        var isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);
        if ((0, $cvCbM.default)(isTypeOf)) return isTypeOf.then(function(resolvedIsTypeOf) {
            if (!resolvedIsTypeOf) throw $28b9215d12482e59$var$invalidReturnTypeError(returnType, result, fieldNodes);
            return $28b9215d12482e59$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
        });
        if (!isTypeOf) throw $28b9215d12482e59$var$invalidReturnTypeError(returnType, result, fieldNodes);
    }
    return $28b9215d12482e59$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
}
function $28b9215d12482e59$var$invalidReturnTypeError(returnType, result, fieldNodes) {
    return new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat(returnType.name, "\" but got: ").concat((0, $biK02.default)(result), "."), fieldNodes);
}
function $28b9215d12482e59$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result) {
    // Collect sub-fields to execute to complete this value.
    var subFieldNodes = $28b9215d12482e59$var$collectSubfields(exeContext, returnType, fieldNodes);
    return $28b9215d12482e59$var$executeFields(exeContext, returnType, result, path, subFieldNodes);
}
/**
 * A memoized collection of relevant subfields with regard to the return
 * type. Memoizing ensures the subfields are not repeatedly calculated, which
 * saves overhead when resolving lists of values.
 */ var $28b9215d12482e59$var$collectSubfields = (0, $aF2x8.default)($28b9215d12482e59$var$_collectSubfields);
function $28b9215d12482e59$var$_collectSubfields(exeContext, returnType, fieldNodes) {
    var subFieldNodes = Object.create(null);
    var visitedFragmentNames = Object.create(null);
    for(var _i8 = 0; _i8 < fieldNodes.length; _i8++){
        var node = fieldNodes[_i8];
        if (node.selectionSet) subFieldNodes = $28b9215d12482e59$export$c23741d442fe90e9(exeContext, returnType, node.selectionSet, subFieldNodes, visitedFragmentNames);
    }
    return subFieldNodes;
}
var $28b9215d12482e59$export$4a45c17a1ba2cb7 = function defaultTypeResolver(value, contextValue, info, abstractType) {
    // First, look for `__typename`.
    if ((0, $fbtyx.default)(value) && typeof value.__typename === 'string') return value.__typename;
     // Otherwise, test each possible type.
    var possibleTypes = info.schema.getPossibleTypes(abstractType);
    var promisedIsTypeOfResults = [];
    for(var i = 0; i < possibleTypes.length; i++){
        var type = possibleTypes[i];
        if (type.isTypeOf) {
            var isTypeOfResult = type.isTypeOf(value, contextValue, info);
            if ((0, $cvCbM.default)(isTypeOfResult)) promisedIsTypeOfResults[i] = isTypeOfResult;
            else if (isTypeOfResult) return type.name;
        }
    }
    if (promisedIsTypeOfResults.length) return Promise.all(promisedIsTypeOfResults).then(function(isTypeOfResults) {
        for(var _i9 = 0; _i9 < isTypeOfResults.length; _i9++){
            if (isTypeOfResults[_i9]) return possibleTypes[_i9].name;
        }
    });
};
var $28b9215d12482e59$export$21fc6d079630d659 = function defaultFieldResolver(source, args, contextValue, info) {
    // ensure source is a value for which property access is acceptable.
    if ((0, $fbtyx.default)(source) || typeof source === 'function') {
        var property = source[info.fieldName];
        if (typeof property === 'function') return source[info.fieldName](args, contextValue, info);
        return property;
    }
};
function $28b9215d12482e59$export$dab6dcab745bb1b6(schema, parentType, fieldName) {
    if (fieldName === (0, $h2iUh.SchemaMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $h2iUh.SchemaMetaFieldDef;
    else if (fieldName === (0, $h2iUh.TypeMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $h2iUh.TypeMetaFieldDef;
    else if (fieldName === (0, $h2iUh.TypeNameMetaFieldDef).name) return 0, $h2iUh.TypeNameMetaFieldDef;
    return parentType.getFields()[fieldName];
}

});
parcelRegister("aF2x8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e58f7eb075f9f2$export$2e2bcd8739ae039);
/**
 * Memoizes the provided three-argument function.
 */ function $f8e58f7eb075f9f2$export$2e2bcd8739ae039(fn) {
    var cache0;
    return function memoized(a1, a2, a3) {
        if (!cache0) cache0 = new WeakMap();
        var cache1 = cache0.get(a1);
        var cache2;
        if (cache1) {
            cache2 = cache1.get(a2);
            if (cache2) {
                var cachedValue = cache2.get(a3);
                if (cachedValue !== undefined) return cachedValue;
            }
        } else {
            cache1 = new WeakMap();
            cache0.set(a1, cache1);
        }
        if (!cache2) {
            cache2 = new WeakMap();
            cache1.set(a2, cache2);
        }
        var newValue = fn(a1, a2, a3);
        cache2.set(a3, newValue);
        return newValue;
    };
}

});

parcelRegister("cvCbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $23d6e18c41560dd9$export$2e2bcd8739ae039);
/**
 * Returns true if the value acts like a Promise, i.e. has a "then" function,
 * otherwise returns false.
 */ // eslint-disable-next-line no-redeclare
function $23d6e18c41560dd9$export$2e2bcd8739ae039(value) {
    return typeof (value === null || value === void 0 ? void 0 : value.then) === 'function';
}

});

parcelRegister("8DMvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $313b09bab2d4edd6$export$2e2bcd8739ae039);

var $gwa3m = parcelRequire("gwa3m");
function $313b09bab2d4edd6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $313b09bab2d4edd6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $313b09bab2d4edd6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $313b09bab2d4edd6$var$_typeof(obj);
}
function $313b09bab2d4edd6$export$2e2bcd8739ae039(collection) {
    var mapFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function(item) {
        return item;
    };
    if (collection == null || $313b09bab2d4edd6$var$_typeof(collection) !== 'object') return null;
    if (Array.isArray(collection)) return collection.map(mapFn);
     // Is Iterable?
    var iteratorMethod = collection[0, $gwa3m.SYMBOL_ITERATOR];
    if (typeof iteratorMethod === 'function') {
        // $FlowFixMe[incompatible-use]
        var iterator = iteratorMethod.call(collection);
        var result = [];
        var step;
        for(var i = 0; !(step = iterator.next()).done; ++i)result.push(mapFn(step.value, i));
        return result;
    } // Is Array like?
    var length = collection.length;
    if (typeof length === 'number' && length >= 0 && length % 1 === 0) {
        var _result = [];
        for(var _i = 0; _i < length; ++_i){
            if (!Object.prototype.hasOwnProperty.call(collection, _i)) return null;
            _result.push(mapFn(collection[String(_i)], _i));
        }
        return _result;
    }
    return null;
}

});

parcelRegister("3SMRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2153f857d28efb07$export$2e2bcd8739ae039);

var $cvCbM = parcelRequire("cvCbM");
function $2153f857d28efb07$export$2e2bcd8739ae039(values, callback, initialValue) {
    return values.reduce(function(previous, value) {
        return (0, $cvCbM.default)(previous) ? previous.then(function(resolved) {
            return callback(resolved, value);
        }) : callback(previous, value);
    }, initialValue);
}

});

parcelRegister("jvU6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $397d1cfe82a99329$export$2e2bcd8739ae039);
/**
 * This function transforms a JS object `ObjMap<Promise<T>>` into
 * a `Promise<ObjMap<T>>`
 *
 * This is akin to bluebird's `Promise.props`, but implemented only using
 * `Promise.all` so it will work with any implementation of ES6 promises.
 */ function $397d1cfe82a99329$export$2e2bcd8739ae039(object) {
    var keys = Object.keys(object);
    var valuesAndPromises = keys.map(function(name) {
        return object[name];
    });
    return Promise.all(valuesAndPromises).then(function(values) {
        return values.reduce(function(resolvedObject, value, i) {
            resolvedObject[keys[i]] = value;
            return resolvedObject;
        }, Object.create(null));
    });
}

});

parcelRegister("kZHaf", function(module, exports) {

$parcel$export(module.exports, "addPath", () => $d383cb52810c09e2$export$4c25481b843feb0b);
$parcel$export(module.exports, "pathToArray", () => $d383cb52810c09e2$export$38d939edd7751830);
/**
 * Given a Path and a key, return a new Path containing the new key.
 */ function $d383cb52810c09e2$export$4c25481b843feb0b(prev, key, typename) {
    return {
        prev: prev,
        key: key,
        typename: typename
    };
}
function $d383cb52810c09e2$export$38d939edd7751830(path) {
    var flattened = [];
    var curr = path;
    while(curr){
        flattened.push(curr.key);
        curr = curr.prev;
    }
    return flattened.reverse();
}

});

parcelRegister("02KAV", function(module, exports) {

$parcel$export(module.exports, "locatedError", () => $b788feeccd28d1f2$export$d6d5dddbbbfd3fca);

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");
function $b788feeccd28d1f2$export$d6d5dddbbbfd3fca(rawOriginalError, nodes, path) {
    var _nodes;
    // Sometimes a non-error is thrown, wrap it as an Error instance to ensure a consistent Error interface.
    var originalError = rawOriginalError instanceof Error ? rawOriginalError : new Error('Unexpected error value: ' + (0, $biK02.default)(rawOriginalError)); // Note: this uses a brand-check to support GraphQL errors originating from other contexts.
    if (Array.isArray(originalError.path)) return originalError;
    return new (0, $9fgMZ.GraphQLError)(originalError.message, (_nodes = originalError.nodes) !== null && _nodes !== void 0 ? _nodes : nodes, originalError.source, originalError.positions, path, originalError);
}

});

parcelRegister("izaFt", function(module, exports) {

$parcel$export(module.exports, "validateSchema", () => $52ea6309b40538c9$export$4741711f07dbb8e7);
$parcel$export(module.exports, "assertValidSchema", () => $52ea6309b40538c9$export$d32aa1886d3569c6);

var $bmIpK = parcelRequire("bmIpK");

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $02KAV = parcelRequire("02KAV");

var $2atqN = parcelRequire("2atqN");

var $f5cpS = parcelRequire("f5cpS");

var $6BdRO = parcelRequire("6BdRO");

var $h2iUh = parcelRequire("h2iUh");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");
function $52ea6309b40538c9$export$4741711f07dbb8e7(schema) {
    // First check to ensure the provided value is in fact a GraphQLSchema.
    (0, $6BdRO.assertSchema)(schema); // If this Schema has already been validated, return the previous results.
    if (schema.__validationErrors) return schema.__validationErrors;
     // Validate the schema, producing a list of errors.
    var context = new $52ea6309b40538c9$var$SchemaValidationContext(schema);
    $52ea6309b40538c9$var$validateRootTypes(context);
    $52ea6309b40538c9$var$validateDirectives(context);
    $52ea6309b40538c9$var$validateTypes(context); // Persist the results of validation before returning to ensure validation
    // does not run multiple times for this schema.
    var errors = context.getErrors();
    schema.__validationErrors = errors;
    return errors;
}
function $52ea6309b40538c9$export$d32aa1886d3569c6(schema) {
    var errors = $52ea6309b40538c9$export$4741711f07dbb8e7(schema);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}
var $52ea6309b40538c9$var$SchemaValidationContext = /*#__PURE__*/ function() {
    function SchemaValidationContext(schema) {
        this._errors = [];
        this.schema = schema;
    }
    var _proto = SchemaValidationContext.prototype;
    _proto.reportError = function reportError(message, nodes) {
        var _nodes = Array.isArray(nodes) ? nodes.filter(Boolean) : nodes;
        this.addError(new (0, $9fgMZ.GraphQLError)(message, _nodes));
    };
    _proto.addError = function addError(error) {
        this._errors.push(error);
    };
    _proto.getErrors = function getErrors() {
        return this._errors;
    };
    return SchemaValidationContext;
}();
function $52ea6309b40538c9$var$validateRootTypes(context) {
    var schema = context.schema;
    var queryType = schema.getQueryType();
    if (!queryType) context.reportError('Query root type must be provided.', schema.astNode);
    else if (!(0, $lXoEQ.isObjectType)(queryType)) {
        var _getOperationTypeNode;
        context.reportError("Query root type must be Object type, it cannot be ".concat((0, $biK02.default)(queryType), "."), (_getOperationTypeNode = $52ea6309b40538c9$var$getOperationTypeNode(schema, 'query')) !== null && _getOperationTypeNode !== void 0 ? _getOperationTypeNode : queryType.astNode);
    }
    var mutationType = schema.getMutationType();
    if (mutationType && !(0, $lXoEQ.isObjectType)(mutationType)) {
        var _getOperationTypeNode2;
        context.reportError('Mutation root type must be Object type if provided, it cannot be ' + "".concat((0, $biK02.default)(mutationType), "."), (_getOperationTypeNode2 = $52ea6309b40538c9$var$getOperationTypeNode(schema, 'mutation')) !== null && _getOperationTypeNode2 !== void 0 ? _getOperationTypeNode2 : mutationType.astNode);
    }
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType && !(0, $lXoEQ.isObjectType)(subscriptionType)) {
        var _getOperationTypeNode3;
        context.reportError('Subscription root type must be Object type if provided, it cannot be ' + "".concat((0, $biK02.default)(subscriptionType), "."), (_getOperationTypeNode3 = $52ea6309b40538c9$var$getOperationTypeNode(schema, 'subscription')) !== null && _getOperationTypeNode3 !== void 0 ? _getOperationTypeNode3 : subscriptionType.astNode);
    }
}
function $52ea6309b40538c9$var$getOperationTypeNode(schema, operation) {
    var operationNodes = $52ea6309b40538c9$var$getAllSubNodes(schema, function(node) {
        return node.operationTypes;
    });
    for(var _i2 = 0; _i2 < operationNodes.length; _i2++){
        var node = operationNodes[_i2];
        if (node.operation === operation) return node.type;
    }
    return undefined;
}
function $52ea6309b40538c9$var$validateDirectives(context) {
    for(var _i4 = 0, _context$schema$getDi2 = context.schema.getDirectives(); _i4 < _context$schema$getDi2.length; _i4++){
        var directive = _context$schema$getDi2[_i4];
        // Ensure all directives are in fact GraphQL directives.
        if (!(0, $bOniD.isDirective)(directive)) {
            context.reportError("Expected directive but got: ".concat((0, $biK02.default)(directive), "."), directive === null || directive === void 0 ? void 0 : directive.astNode);
            continue;
        } // Ensure they are named correctly.
        $52ea6309b40538c9$var$validateName(context, directive); // TODO: Ensure proper locations.
        // Ensure the arguments are valid.
        for(var _i6 = 0, _directive$args2 = directive.args; _i6 < _directive$args2.length; _i6++){
            var arg = _directive$args2[_i6];
            // Ensure they are named correctly.
            $52ea6309b40538c9$var$validateName(context, arg); // Ensure the type is an input type.
            if (!(0, $lXoEQ.isInputType)(arg.type)) context.reportError("The type of @".concat(directive.name, "(").concat(arg.name, ":) must be Input Type ") + "but got: ".concat((0, $biK02.default)(arg.type), "."), arg.astNode);
            if ((0, $lXoEQ.isRequiredArgument)(arg) && arg.deprecationReason != null) {
                var _arg$astNode;
                context.reportError("Required argument @".concat(directive.name, "(").concat(arg.name, ":) cannot be deprecated."), [
                    $52ea6309b40538c9$var$getDeprecatedDirectiveNode(arg.astNode),
                    (_arg$astNode = arg.astNode) === null || _arg$astNode === void 0 ? void 0 : _arg$astNode.type
                ]);
            }
        }
    }
}
function $52ea6309b40538c9$var$validateName(context, node) {
    // Ensure names are valid, however introspection types opt out.
    var error = (0, $2atqN.isValidNameError)(node.name);
    if (error) context.addError((0, $02KAV.locatedError)(error, node.astNode));
}
function $52ea6309b40538c9$var$validateTypes(context) {
    var validateInputObjectCircularRefs = $52ea6309b40538c9$var$createInputObjectCircularRefsValidator(context);
    var typeMap = context.schema.getTypeMap();
    for(var _i8 = 0, _objectValues2 = (0, $dVq2R.default)(typeMap); _i8 < _objectValues2.length; _i8++){
        var type = _objectValues2[_i8];
        // Ensure all provided types are in fact GraphQL type.
        if (!(0, $lXoEQ.isNamedType)(type)) {
            context.reportError("Expected GraphQL named type but got: ".concat((0, $biK02.default)(type), "."), type.astNode);
            continue;
        } // Ensure it is named correctly (excluding introspection types).
        if (!(0, $h2iUh.isIntrospectionType)(type)) $52ea6309b40538c9$var$validateName(context, type);
        if ((0, $lXoEQ.isObjectType)(type)) {
            // Ensure fields are valid
            $52ea6309b40538c9$var$validateFields(context, type); // Ensure objects implement the interfaces they claim to.
            $52ea6309b40538c9$var$validateInterfaces(context, type);
        } else if ((0, $lXoEQ.isInterfaceType)(type)) {
            // Ensure fields are valid.
            $52ea6309b40538c9$var$validateFields(context, type); // Ensure interfaces implement the interfaces they claim to.
            $52ea6309b40538c9$var$validateInterfaces(context, type);
        } else if ((0, $lXoEQ.isUnionType)(type)) // Ensure Unions include valid member types.
        $52ea6309b40538c9$var$validateUnionMembers(context, type);
        else if ((0, $lXoEQ.isEnumType)(type)) // Ensure Enums have valid values.
        $52ea6309b40538c9$var$validateEnumValues(context, type);
        else if ((0, $lXoEQ.isInputObjectType)(type)) {
            // Ensure Input Object fields are valid.
            $52ea6309b40538c9$var$validateInputFields(context, type); // Ensure Input Objects do not contain non-nullable circular references
            validateInputObjectCircularRefs(type);
        }
    }
}
function $52ea6309b40538c9$var$validateFields(context, type) {
    var fields = (0, $dVq2R.default)(type.getFields()); // Objects and Interfaces both must define one or more fields.
    if (fields.length === 0) context.reportError("Type ".concat(type.name, " must define one or more fields."), $52ea6309b40538c9$var$getAllNodes(type));
    for(var _i10 = 0; _i10 < fields.length; _i10++){
        var field = fields[_i10];
        // Ensure they are named correctly.
        $52ea6309b40538c9$var$validateName(context, field); // Ensure the type is an output type
        if (!(0, $lXoEQ.isOutputType)(field.type)) {
            var _field$astNode;
            context.reportError("The type of ".concat(type.name, ".").concat(field.name, " must be Output Type ") + "but got: ".concat((0, $biK02.default)(field.type), "."), (_field$astNode = field.astNode) === null || _field$astNode === void 0 ? void 0 : _field$astNode.type);
        } // Ensure the arguments are valid
        for(var _i12 = 0, _field$args2 = field.args; _i12 < _field$args2.length; _i12++){
            var arg = _field$args2[_i12];
            var argName = arg.name; // Ensure they are named correctly.
            $52ea6309b40538c9$var$validateName(context, arg); // Ensure the type is an input type
            if (!(0, $lXoEQ.isInputType)(arg.type)) {
                var _arg$astNode2;
                context.reportError("The type of ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) must be Input ") + "Type but got: ".concat((0, $biK02.default)(arg.type), "."), (_arg$astNode2 = arg.astNode) === null || _arg$astNode2 === void 0 ? void 0 : _arg$astNode2.type);
            }
            if ((0, $lXoEQ.isRequiredArgument)(arg) && arg.deprecationReason != null) {
                var _arg$astNode3;
                context.reportError("Required argument ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) cannot be deprecated."), [
                    $52ea6309b40538c9$var$getDeprecatedDirectiveNode(arg.astNode),
                    (_arg$astNode3 = arg.astNode) === null || _arg$astNode3 === void 0 ? void 0 : _arg$astNode3.type
                ]);
            }
        }
    }
}
function $52ea6309b40538c9$var$validateInterfaces(context, type) {
    var ifaceTypeNames = Object.create(null);
    for(var _i14 = 0, _type$getInterfaces2 = type.getInterfaces(); _i14 < _type$getInterfaces2.length; _i14++){
        var iface = _type$getInterfaces2[_i14];
        if (!(0, $lXoEQ.isInterfaceType)(iface)) {
            context.reportError("Type ".concat((0, $biK02.default)(type), " must only implement Interface types, ") + "it cannot implement ".concat((0, $biK02.default)(iface), "."), $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        if (type === iface) {
            context.reportError("Type ".concat(type.name, " cannot implement itself because it would create a circular reference."), $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        if (ifaceTypeNames[iface.name]) {
            context.reportError("Type ".concat(type.name, " can only implement ").concat(iface.name, " once."), $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        ifaceTypeNames[iface.name] = true;
        $52ea6309b40538c9$var$validateTypeImplementsAncestors(context, type, iface);
        $52ea6309b40538c9$var$validateTypeImplementsInterface(context, type, iface);
    }
}
function $52ea6309b40538c9$var$validateTypeImplementsInterface(context, type, iface) {
    var typeFieldMap = type.getFields(); // Assert each interface field is implemented.
    for(var _i16 = 0, _objectValues4 = (0, $dVq2R.default)(iface.getFields()); _i16 < _objectValues4.length; _i16++){
        var ifaceField = _objectValues4[_i16];
        var fieldName = ifaceField.name;
        var typeField = typeFieldMap[fieldName]; // Assert interface field exists on type.
        if (!typeField) {
            context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expected but ").concat(type.name, " does not provide it."), [
                ifaceField.astNode
            ].concat($52ea6309b40538c9$var$getAllNodes(type)));
            continue;
        } // Assert interface field type is satisfied by type field type, by being
        // a valid subtype. (covariant)
        if (!(0, $f5cpS.isTypeSubTypeOf)(context.schema, typeField.type, ifaceField.type)) {
            var _ifaceField$astNode, _typeField$astNode;
            context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expects type ") + "".concat((0, $biK02.default)(ifaceField.type), " but ").concat(type.name, ".").concat(fieldName, " ") + "is type ".concat((0, $biK02.default)(typeField.type), "."), [
                (_ifaceField$astNode = ifaceField.astNode) === null || _ifaceField$astNode === void 0 ? void 0 : _ifaceField$astNode.type,
                (_typeField$astNode = typeField.astNode) === null || _typeField$astNode === void 0 ? void 0 : _typeField$astNode.type
            ]);
        } // Assert each interface field arg is implemented.
        var _loop = function _loop(_i18, _ifaceField$args2) {
            var ifaceArg = _ifaceField$args2[_i18];
            var argName = ifaceArg.name;
            var typeArg = (0, $bmIpK.default)(typeField.args, function(arg) {
                return arg.name === argName;
            }); // Assert interface field arg exists on object field.
            if (!typeArg) {
                context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) expected but ").concat(type.name, ".").concat(fieldName, " does not provide it."), [
                    ifaceArg.astNode,
                    typeField.astNode
                ]);
                return "continue";
            } // Assert interface field arg type matches object field arg type.
            // (invariant)
            // TODO: change to contravariant?
            if (!(0, $f5cpS.isEqualType)(ifaceArg.type, typeArg.type)) {
                var _ifaceArg$astNode, _typeArg$astNode;
                context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) ") + "expects type ".concat((0, $biK02.default)(ifaceArg.type), " but ") + "".concat(type.name, ".").concat(fieldName, "(").concat(argName, ":) is type ") + "".concat((0, $biK02.default)(typeArg.type), "."), [
                    (_ifaceArg$astNode = ifaceArg.astNode) === null || _ifaceArg$astNode === void 0 ? void 0 : _ifaceArg$astNode.type,
                    (_typeArg$astNode = typeArg.astNode) === null || _typeArg$astNode === void 0 ? void 0 : _typeArg$astNode.type
                ]);
            } // TODO: validate default values?
        };
        for(var _i18 = 0, _ifaceField$args2 = ifaceField.args; _i18 < _ifaceField$args2.length; _i18++){
            var _ret = _loop(_i18, _ifaceField$args2);
            if (_ret === "continue") continue;
        } // Assert additional arguments must not be required.
        var _loop2 = function _loop2(_i20, _typeField$args2) {
            var typeArg = _typeField$args2[_i20];
            var argName = typeArg.name;
            var ifaceArg = (0, $bmIpK.default)(ifaceField.args, function(arg) {
                return arg.name === argName;
            });
            if (!ifaceArg && (0, $lXoEQ.isRequiredArgument)(typeArg)) context.reportError("Object field ".concat(type.name, ".").concat(fieldName, " includes required argument ").concat(argName, " that is missing from the Interface field ").concat(iface.name, ".").concat(fieldName, "."), [
                typeArg.astNode,
                ifaceField.astNode
            ]);
        };
        for(var _i20 = 0, _typeField$args2 = typeField.args; _i20 < _typeField$args2.length; _i20++)_loop2(_i20, _typeField$args2);
    }
}
function $52ea6309b40538c9$var$validateTypeImplementsAncestors(context, type, iface) {
    var ifaceInterfaces = type.getInterfaces();
    for(var _i22 = 0, _iface$getInterfaces2 = iface.getInterfaces(); _i22 < _iface$getInterfaces2.length; _i22++){
        var transitive = _iface$getInterfaces2[_i22];
        if (ifaceInterfaces.indexOf(transitive) === -1) context.reportError(transitive === type ? "Type ".concat(type.name, " cannot implement ").concat(iface.name, " because it would create a circular reference.") : "Type ".concat(type.name, " must implement ").concat(transitive.name, " because it is implemented by ").concat(iface.name, "."), [].concat($52ea6309b40538c9$var$getAllImplementsInterfaceNodes(iface, transitive), $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface)));
    }
}
function $52ea6309b40538c9$var$validateUnionMembers(context, union) {
    var memberTypes = union.getTypes();
    if (memberTypes.length === 0) context.reportError("Union type ".concat(union.name, " must define one or more member types."), $52ea6309b40538c9$var$getAllNodes(union));
    var includedTypeNames = Object.create(null);
    for(var _i24 = 0; _i24 < memberTypes.length; _i24++){
        var memberType = memberTypes[_i24];
        if (includedTypeNames[memberType.name]) {
            context.reportError("Union type ".concat(union.name, " can only include type ").concat(memberType.name, " once."), $52ea6309b40538c9$var$getUnionMemberTypeNodes(union, memberType.name));
            continue;
        }
        includedTypeNames[memberType.name] = true;
        if (!(0, $lXoEQ.isObjectType)(memberType)) context.reportError("Union type ".concat(union.name, " can only include Object types, ") + "it cannot include ".concat((0, $biK02.default)(memberType), "."), $52ea6309b40538c9$var$getUnionMemberTypeNodes(union, String(memberType)));
    }
}
function $52ea6309b40538c9$var$validateEnumValues(context, enumType) {
    var enumValues = enumType.getValues();
    if (enumValues.length === 0) context.reportError("Enum type ".concat(enumType.name, " must define one or more values."), $52ea6309b40538c9$var$getAllNodes(enumType));
    for(var _i26 = 0; _i26 < enumValues.length; _i26++){
        var enumValue = enumValues[_i26];
        var valueName = enumValue.name; // Ensure valid name.
        $52ea6309b40538c9$var$validateName(context, enumValue);
        if (valueName === 'true' || valueName === 'false' || valueName === 'null') context.reportError("Enum type ".concat(enumType.name, " cannot include value: ").concat(valueName, "."), enumValue.astNode);
    }
}
function $52ea6309b40538c9$var$validateInputFields(context, inputObj) {
    var fields = (0, $dVq2R.default)(inputObj.getFields());
    if (fields.length === 0) context.reportError("Input Object type ".concat(inputObj.name, " must define one or more fields."), $52ea6309b40538c9$var$getAllNodes(inputObj));
     // Ensure the arguments are valid
    for(var _i28 = 0; _i28 < fields.length; _i28++){
        var field = fields[_i28];
        // Ensure they are named correctly.
        $52ea6309b40538c9$var$validateName(context, field); // Ensure the type is an input type
        if (!(0, $lXoEQ.isInputType)(field.type)) {
            var _field$astNode2;
            context.reportError("The type of ".concat(inputObj.name, ".").concat(field.name, " must be Input Type ") + "but got: ".concat((0, $biK02.default)(field.type), "."), (_field$astNode2 = field.astNode) === null || _field$astNode2 === void 0 ? void 0 : _field$astNode2.type);
        }
        if ((0, $lXoEQ.isRequiredInputField)(field) && field.deprecationReason != null) {
            var _field$astNode3;
            context.reportError("Required input field ".concat(inputObj.name, ".").concat(field.name, " cannot be deprecated."), [
                $52ea6309b40538c9$var$getDeprecatedDirectiveNode(field.astNode),
                (_field$astNode3 = field.astNode) === null || _field$astNode3 === void 0 ? void 0 : _field$astNode3.type
            ]);
        }
    }
}
function $52ea6309b40538c9$var$createInputObjectCircularRefsValidator(context) {
    // Modified copy of algorithm from 'src/validation/rules/NoFragmentCycles.js'.
    // Tracks already visited types to maintain O(N) and to ensure that cycles
    // are not redundantly reported.
    var visitedTypes = Object.create(null); // Array of types nodes used to produce meaningful errors
    var fieldPath = []; // Position in the type path
    var fieldPathIndexByTypeName = Object.create(null);
    return detectCycleRecursive; // This does a straight-forward DFS to find cycles.
    // It does not terminate when a cycle was found but continues to explore
    // the graph to find all possible cycles.
    function detectCycleRecursive(inputObj) {
        if (visitedTypes[inputObj.name]) return;
        visitedTypes[inputObj.name] = true;
        fieldPathIndexByTypeName[inputObj.name] = fieldPath.length;
        var fields = (0, $dVq2R.default)(inputObj.getFields());
        for(var _i30 = 0; _i30 < fields.length; _i30++){
            var field = fields[_i30];
            if ((0, $lXoEQ.isNonNullType)(field.type) && (0, $lXoEQ.isInputObjectType)(field.type.ofType)) {
                var fieldType = field.type.ofType;
                var cycleIndex = fieldPathIndexByTypeName[fieldType.name];
                fieldPath.push(field);
                if (cycleIndex === undefined) detectCycleRecursive(fieldType);
                else {
                    var cyclePath = fieldPath.slice(cycleIndex);
                    var pathStr = cyclePath.map(function(fieldObj) {
                        return fieldObj.name;
                    }).join('.');
                    context.reportError("Cannot reference Input Object \"".concat(fieldType.name, "\" within itself through a series of non-null fields: \"").concat(pathStr, "\"."), cyclePath.map(function(fieldObj) {
                        return fieldObj.astNode;
                    }));
                }
                fieldPath.pop();
            }
        }
        fieldPathIndexByTypeName[inputObj.name] = undefined;
    }
}
function $52ea6309b40538c9$var$getAllNodes(object) {
    var astNode = object.astNode, extensionASTNodes = object.extensionASTNodes;
    return astNode ? extensionASTNodes ? [
        astNode
    ].concat(extensionASTNodes) : [
        astNode
    ] : extensionASTNodes !== null && extensionASTNodes !== void 0 ? extensionASTNodes : [];
}
function $52ea6309b40538c9$var$getAllSubNodes(object, getter) {
    var subNodes = [];
    for(var _i32 = 0, _getAllNodes2 = $52ea6309b40538c9$var$getAllNodes(object); _i32 < _getAllNodes2.length; _i32++){
        var _getter;
        var node = _getAllNodes2[_i32];
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        subNodes = subNodes.concat((_getter = getter(node)) !== null && _getter !== void 0 ? _getter : []);
    }
    return subNodes;
}
function $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface) {
    return $52ea6309b40538c9$var$getAllSubNodes(type, function(typeNode) {
        return typeNode.interfaces;
    }).filter(function(ifaceNode) {
        return ifaceNode.name.value === iface.name;
    });
}
function $52ea6309b40538c9$var$getUnionMemberTypeNodes(union, typeName) {
    return $52ea6309b40538c9$var$getAllSubNodes(union, function(unionNode) {
        return unionNode.types;
    }).filter(function(typeNode) {
        return typeNode.name.value === typeName;
    });
}
function $52ea6309b40538c9$var$getDeprecatedDirectiveNode(definitionNode) {
    var _definitionNode$direc;
    // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    return definitionNode === null || definitionNode === void 0 ? void 0 : (_definitionNode$direc = definitionNode.directives) === null || _definitionNode$direc === void 0 ? void 0 : _definitionNode$direc.find(function(node) {
        return node.name.value === (0, $bOniD.GraphQLDeprecatedDirective).name;
    });
}

});
parcelRegister("bmIpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf979c8600d7bc76$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound]
var $bf979c8600d7bc76$var$find = Array.prototype.find ? function(list, predicate) {
    return Array.prototype.find.call(list, predicate);
} : function(list, predicate) {
    for(var _i2 = 0; _i2 < list.length; _i2++){
        var value = list[_i2];
        if (predicate(value)) return value;
    }
};
var $bf979c8600d7bc76$export$2e2bcd8739ae039 = $bf979c8600d7bc76$var$find;

});

parcelRegister("dVq2R", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba73c2159267889$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $1ba73c2159267889$var$objectValues = Object.values || function(obj) {
    return Object.keys(obj).map(function(key) {
        return obj[key];
    });
};
var $1ba73c2159267889$export$2e2bcd8739ae039 = $1ba73c2159267889$var$objectValues;

});

parcelRegister("2atqN", function(module, exports) {

$parcel$export(module.exports, "isValidNameError", () => $b83fd21d28648a79$export$4ecdb5b419400d23);

var $fZdRY = parcelRequire("fZdRY");

var $9fgMZ = parcelRequire("9fgMZ");
var $b83fd21d28648a79$var$NAME_RX = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
function $b83fd21d28648a79$export$38c12a9ffd7a1417(name) {
    var error = $b83fd21d28648a79$export$4ecdb5b419400d23(name);
    if (error) throw error;
    return name;
}
function $b83fd21d28648a79$export$4ecdb5b419400d23(name) {
    typeof name === 'string' || (0, $fZdRY.default)(0, 'Expected name to be a string.');
    if (name.length > 1 && name[0] === '_' && name[1] === '_') return new (0, $9fgMZ.GraphQLError)("Name \"".concat(name, "\" must not begin with \"__\", which is reserved by GraphQL introspection."));
    if (!$b83fd21d28648a79$var$NAME_RX.test(name)) return new (0, $9fgMZ.GraphQLError)("Names must match /^[_a-zA-Z][_a-zA-Z0-9]*$/ but \"".concat(name, "\" does not."));
}

});

parcelRegister("f5cpS", function(module, exports) {

$parcel$export(module.exports, "isEqualType", () => $34731a9f0a0c30ed$export$c8e484a9929e6d9f);
$parcel$export(module.exports, "isTypeSubTypeOf", () => $34731a9f0a0c30ed$export$c3f31adb68f3e853);
$parcel$export(module.exports, "doTypesOverlap", () => $34731a9f0a0c30ed$export$5e7a8ea86de754bd);

var $lXoEQ = parcelRequire("lXoEQ");
function $34731a9f0a0c30ed$export$c8e484a9929e6d9f(typeA, typeB) {
    // Equivalent types are equal.
    if (typeA === typeB) return true;
     // If either type is non-null, the other must also be non-null.
    if ((0, $lXoEQ.isNonNullType)(typeA) && (0, $lXoEQ.isNonNullType)(typeB)) return $34731a9f0a0c30ed$export$c8e484a9929e6d9f(typeA.ofType, typeB.ofType);
     // If either type is a list, the other must also be a list.
    if ((0, $lXoEQ.isListType)(typeA) && (0, $lXoEQ.isListType)(typeB)) return $34731a9f0a0c30ed$export$c8e484a9929e6d9f(typeA.ofType, typeB.ofType);
     // Otherwise the types are not equal.
    return false;
}
function $34731a9f0a0c30ed$export$c3f31adb68f3e853(schema, maybeSubType, superType) {
    // Equivalent type is a valid subtype
    if (maybeSubType === superType) return true;
     // If superType is non-null, maybeSubType must also be non-null.
    if ((0, $lXoEQ.isNonNullType)(superType)) {
        if ((0, $lXoEQ.isNonNullType)(maybeSubType)) return $34731a9f0a0c30ed$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType.ofType);
        return false;
    }
    if ((0, $lXoEQ.isNonNullType)(maybeSubType)) // If superType is nullable, maybeSubType may be non-null or nullable.
    return $34731a9f0a0c30ed$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType);
     // If superType type is a list, maybeSubType type must also be a list.
    if ((0, $lXoEQ.isListType)(superType)) {
        if ((0, $lXoEQ.isListType)(maybeSubType)) return $34731a9f0a0c30ed$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType.ofType);
        return false;
    }
    if ((0, $lXoEQ.isListType)(maybeSubType)) // If superType is not a list, maybeSubType must also be not a list.
    return false;
     // If superType type is an abstract type, check if it is super type of maybeSubType.
    // Otherwise, the child type is not a valid subtype of the parent type.
    return (0, $lXoEQ.isAbstractType)(superType) && ((0, $lXoEQ.isInterfaceType)(maybeSubType) || (0, $lXoEQ.isObjectType)(maybeSubType)) && schema.isSubType(superType, maybeSubType);
}
function $34731a9f0a0c30ed$export$5e7a8ea86de754bd(schema, typeA, typeB) {
    // Equivalent types overlap
    if (typeA === typeB) return true;
    if ((0, $lXoEQ.isAbstractType)(typeA)) {
        if ((0, $lXoEQ.isAbstractType)(typeB)) // If both types are abstract, then determine if there is any intersection
        // between possible concrete types of each.
        return schema.getPossibleTypes(typeA).some(function(type) {
            return schema.isSubType(typeB, type);
        });
         // Determine if the latter type is a possible concrete type of the former.
        return schema.isSubType(typeA, typeB);
    }
    if ((0, $lXoEQ.isAbstractType)(typeB)) // Determine if the former type is a possible concrete type of the latter.
    return schema.isSubType(typeB, typeA);
     // Otherwise the types do not overlap.
    return false;
}

});
parcelRegister("lXoEQ", function(module, exports) {

$parcel$export(module.exports, "isType", () => $4cde51e3b6dfd290$export$26b9f946b448f23e);
$parcel$export(module.exports, "isScalarType", () => $4cde51e3b6dfd290$export$5ef3b9aefb31c08b);
$parcel$export(module.exports, "isObjectType", () => $4cde51e3b6dfd290$export$f3091ca7b0907a5f);
$parcel$export(module.exports, "isInterfaceType", () => $4cde51e3b6dfd290$export$32fba5696fa641e);
$parcel$export(module.exports, "isUnionType", () => $4cde51e3b6dfd290$export$cca4caab5ef5a545);
$parcel$export(module.exports, "isEnumType", () => $4cde51e3b6dfd290$export$360fc30cf304623);
$parcel$export(module.exports, "isInputObjectType", () => $4cde51e3b6dfd290$export$594edc80cf154b94);
$parcel$export(module.exports, "isListType", () => $4cde51e3b6dfd290$export$f1003c1e9d4b008c);
$parcel$export(module.exports, "isNonNullType", () => $4cde51e3b6dfd290$export$146b6508fa0d6c82);
$parcel$export(module.exports, "GraphQLScalarType", () => $4cde51e3b6dfd290$export$64842b98ea53a3c9);
$parcel$export(module.exports, "GraphQLObjectType", () => $4cde51e3b6dfd290$export$375d3757a19c2e6e);
$parcel$export(module.exports, "assertObjectType", () => $4cde51e3b6dfd290$export$37a13eb12fbf3bc7);
$parcel$export(module.exports, "GraphQLInterfaceType", () => $4cde51e3b6dfd290$export$148e92587b8bf1f9);
$parcel$export(module.exports, "assertInterfaceType", () => $4cde51e3b6dfd290$export$b0fa8729bfe4811b);
$parcel$export(module.exports, "GraphQLUnionType", () => $4cde51e3b6dfd290$export$33c479b4c3812d0b);
$parcel$export(module.exports, "GraphQLEnumType", () => $4cde51e3b6dfd290$export$2577fb93f8748953);
$parcel$export(module.exports, "GraphQLInputObjectType", () => $4cde51e3b6dfd290$export$ea29baa44b9fd772);
$parcel$export(module.exports, "GraphQLList", () => $4cde51e3b6dfd290$export$de552006a6243367);
$parcel$export(module.exports, "GraphQLNonNull", () => $4cde51e3b6dfd290$export$ea3122a3d819ac9d);
$parcel$export(module.exports, "isInputType", () => $4cde51e3b6dfd290$export$1e617af703572bb5);
$parcel$export(module.exports, "isOutputType", () => $4cde51e3b6dfd290$export$27aadee607de5794);
$parcel$export(module.exports, "isLeafType", () => $4cde51e3b6dfd290$export$b390adabc64bab3);
$parcel$export(module.exports, "isCompositeType", () => $4cde51e3b6dfd290$export$3d8f0e61f2e75bb0);
$parcel$export(module.exports, "isAbstractType", () => $4cde51e3b6dfd290$export$6ea44a810dec4ac5);
$parcel$export(module.exports, "assertNullableType", () => $4cde51e3b6dfd290$export$9c6e9b78e1767de4);
$parcel$export(module.exports, "getNullableType", () => $4cde51e3b6dfd290$export$88b885687e78334b);
$parcel$export(module.exports, "isNamedType", () => $4cde51e3b6dfd290$export$f99194494d5b1a26);
$parcel$export(module.exports, "getNamedType", () => $4cde51e3b6dfd290$export$e6cd8ba67f39ede0);
$parcel$export(module.exports, "argsToArgsConfig", () => $4cde51e3b6dfd290$export$ae5ade30c645f6fd);
$parcel$export(module.exports, "isRequiredArgument", () => $4cde51e3b6dfd290$export$caef08b21560291a);
$parcel$export(module.exports, "isRequiredInputField", () => $4cde51e3b6dfd290$export$2657dcc79c2b6229);

var $apet0 = parcelRequire("apet0");

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $hbiEd = parcelRequire("hbiEd");

var $6MWHL = parcelRequire("6MWHL");

var $eCJ4z = parcelRequire("eCJ4z");

var $fZdRY = parcelRequire("fZdRY");

var $2AFgT = parcelRequire("2AFgT");

var $aVhwC = parcelRequire("aVhwC");

var $8nBnZ = parcelRequire("8nBnZ");

var $fbtyx = parcelRequire("fbtyx");

var $7J7By = parcelRequire("7J7By");

var $51GHS = parcelRequire("51GHS");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $iTQJQ = parcelRequire("iTQJQ");
function $4cde51e3b6dfd290$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4cde51e3b6dfd290$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4cde51e3b6dfd290$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4cde51e3b6dfd290$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $4cde51e3b6dfd290$export$26b9f946b448f23e(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) || $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type) || $4cde51e3b6dfd290$export$594edc80cf154b94(type) || $4cde51e3b6dfd290$export$f1003c1e9d4b008c(type) || $4cde51e3b6dfd290$export$146b6508fa0d6c82(type);
}
function $4cde51e3b6dfd290$export$804de46662e4ac95(type) {
    if (!$4cde51e3b6dfd290$export$26b9f946b448f23e(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL type."));
    return type;
}
function $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$64842b98ea53a3c9);
}
function $4cde51e3b6dfd290$export$6bfb69547e804cfa(type) {
    if (!$4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Scalar type."));
    return type;
}
function $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$375d3757a19c2e6e);
}
function $4cde51e3b6dfd290$export$37a13eb12fbf3bc7(type) {
    if (!$4cde51e3b6dfd290$export$f3091ca7b0907a5f(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Object type."));
    return type;
}
function $4cde51e3b6dfd290$export$32fba5696fa641e(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$148e92587b8bf1f9);
}
function $4cde51e3b6dfd290$export$b0fa8729bfe4811b(type) {
    if (!$4cde51e3b6dfd290$export$32fba5696fa641e(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Interface type."));
    return type;
}
function $4cde51e3b6dfd290$export$cca4caab5ef5a545(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$33c479b4c3812d0b);
}
function $4cde51e3b6dfd290$export$fd1fc643145b79aa(type) {
    if (!$4cde51e3b6dfd290$export$cca4caab5ef5a545(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Union type."));
    return type;
}
function $4cde51e3b6dfd290$export$360fc30cf304623(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$2577fb93f8748953);
}
function $4cde51e3b6dfd290$export$152b058be1610b0e(type) {
    if (!$4cde51e3b6dfd290$export$360fc30cf304623(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Enum type."));
    return type;
}
function $4cde51e3b6dfd290$export$594edc80cf154b94(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$ea29baa44b9fd772);
}
function $4cde51e3b6dfd290$export$d3177a47c4ed448a(type) {
    if (!$4cde51e3b6dfd290$export$594edc80cf154b94(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Input Object type."));
    return type;
}
function $4cde51e3b6dfd290$export$f1003c1e9d4b008c(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$de552006a6243367);
}
function $4cde51e3b6dfd290$export$a4a2309317558e91(type) {
    if (!$4cde51e3b6dfd290$export$f1003c1e9d4b008c(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL List type."));
    return type;
}
function $4cde51e3b6dfd290$export$146b6508fa0d6c82(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$ea3122a3d819ac9d);
}
function $4cde51e3b6dfd290$export$4c0a7702e4a2acc9(type) {
    if (!$4cde51e3b6dfd290$export$146b6508fa0d6c82(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Non-Null type."));
    return type;
}
function $4cde51e3b6dfd290$export$1e617af703572bb5(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type) || $4cde51e3b6dfd290$export$594edc80cf154b94(type) || $4cde51e3b6dfd290$export$2dbe78c78d9c62bb(type) && $4cde51e3b6dfd290$export$1e617af703572bb5(type.ofType);
}
function $4cde51e3b6dfd290$export$6e3e8b9b85427518(type) {
    if (!$4cde51e3b6dfd290$export$1e617af703572bb5(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL input type."));
    return type;
}
function $4cde51e3b6dfd290$export$27aadee607de5794(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) || $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type) || $4cde51e3b6dfd290$export$2dbe78c78d9c62bb(type) && $4cde51e3b6dfd290$export$27aadee607de5794(type.ofType);
}
function $4cde51e3b6dfd290$export$3efb5e473c31d62b(type) {
    if (!$4cde51e3b6dfd290$export$27aadee607de5794(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL output type."));
    return type;
}
function $4cde51e3b6dfd290$export$b390adabc64bab3(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type);
}
function $4cde51e3b6dfd290$export$2bb5b8127c27d0cc(type) {
    if (!$4cde51e3b6dfd290$export$b390adabc64bab3(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL leaf type."));
    return type;
}
function $4cde51e3b6dfd290$export$3d8f0e61f2e75bb0(type) {
    return $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) || $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type);
}
function $4cde51e3b6dfd290$export$5b55b276a74cf725(type) {
    if (!$4cde51e3b6dfd290$export$3d8f0e61f2e75bb0(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL composite type."));
    return type;
}
function $4cde51e3b6dfd290$export$6ea44a810dec4ac5(type) {
    return $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type);
}
function $4cde51e3b6dfd290$export$d7092fd91c1fbaf8(type) {
    if (!$4cde51e3b6dfd290$export$6ea44a810dec4ac5(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL abstract type."));
    return type;
}
function $4cde51e3b6dfd290$export$de552006a6243367(ofType) {
    // istanbul ignore else (to be removed in v16.0.0)
    if (this instanceof $4cde51e3b6dfd290$export$de552006a6243367) this.ofType = $4cde51e3b6dfd290$export$804de46662e4ac95(ofType);
    else return new $4cde51e3b6dfd290$export$de552006a6243367(ofType);
} // Need to cast through any to alter the prototype.
$4cde51e3b6dfd290$export$de552006a6243367.prototype.toString = function toString() {
    return '[' + String(this.ofType) + ']';
};
$4cde51e3b6dfd290$export$de552006a6243367.prototype.toJSON = function toJSON() {
    return this.toString();
};
Object.defineProperty($4cde51e3b6dfd290$export$de552006a6243367.prototype, (0, $gwa3m.SYMBOL_TO_STRING_TAG), {
    get: function get() {
        return 'GraphQLList';
    }
}); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$de552006a6243367);
function $4cde51e3b6dfd290$export$ea3122a3d819ac9d(ofType) {
    // istanbul ignore else (to be removed in v16.0.0)
    if (this instanceof $4cde51e3b6dfd290$export$ea3122a3d819ac9d) this.ofType = $4cde51e3b6dfd290$export$9c6e9b78e1767de4(ofType);
    else return new $4cde51e3b6dfd290$export$ea3122a3d819ac9d(ofType);
} // Need to cast through any to alter the prototype.
$4cde51e3b6dfd290$export$ea3122a3d819ac9d.prototype.toString = function toString() {
    return String(this.ofType) + '!';
};
$4cde51e3b6dfd290$export$ea3122a3d819ac9d.prototype.toJSON = function toJSON() {
    return this.toString();
};
Object.defineProperty($4cde51e3b6dfd290$export$ea3122a3d819ac9d.prototype, (0, $gwa3m.SYMBOL_TO_STRING_TAG), {
    get: function get() {
        return 'GraphQLNonNull';
    }
}); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$ea3122a3d819ac9d);
function $4cde51e3b6dfd290$export$2dbe78c78d9c62bb(type) {
    return $4cde51e3b6dfd290$export$f1003c1e9d4b008c(type) || $4cde51e3b6dfd290$export$146b6508fa0d6c82(type);
}
function $4cde51e3b6dfd290$export$ee52e012d8d583c6(type) {
    if (!$4cde51e3b6dfd290$export$2dbe78c78d9c62bb(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL wrapping type."));
    return type;
}
function $4cde51e3b6dfd290$export$103e38848746832(type) {
    return $4cde51e3b6dfd290$export$26b9f946b448f23e(type) && !$4cde51e3b6dfd290$export$146b6508fa0d6c82(type);
}
function $4cde51e3b6dfd290$export$9c6e9b78e1767de4(type) {
    if (!$4cde51e3b6dfd290$export$103e38848746832(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL nullable type."));
    return type;
}
function $4cde51e3b6dfd290$export$88b885687e78334b(type) {
    /* eslint-enable no-redeclare */ if (type) return $4cde51e3b6dfd290$export$146b6508fa0d6c82(type) ? type.ofType : type;
}
function $4cde51e3b6dfd290$export$f99194494d5b1a26(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) || $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type) || $4cde51e3b6dfd290$export$594edc80cf154b94(type);
}
function $4cde51e3b6dfd290$export$57234e7b640498aa(type) {
    if (!$4cde51e3b6dfd290$export$f99194494d5b1a26(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL named type."));
    return type;
}
function $4cde51e3b6dfd290$export$e6cd8ba67f39ede0(type) {
    /* eslint-enable no-redeclare */ if (type) {
        var unwrappedType = type;
        while($4cde51e3b6dfd290$export$2dbe78c78d9c62bb(unwrappedType))unwrappedType = unwrappedType.ofType;
        return unwrappedType;
    }
}
/**
 * Used while defining GraphQL types to allow for circular references in
 * otherwise immutable type definitions.
 */ function $4cde51e3b6dfd290$var$resolveThunk(thunk) {
    // $FlowFixMe[incompatible-use]
    return typeof thunk === 'function' ? thunk() : thunk;
}
function $4cde51e3b6dfd290$var$undefineIfEmpty(arr) {
    return arr && arr.length > 0 ? arr : undefined;
}
var $4cde51e3b6dfd290$export$64842b98ea53a3c9 = /*#__PURE__*/ function() {
    function GraphQLScalarType(config) {
        var _config$parseValue, _config$serialize, _config$parseLiteral;
        var parseValue = (_config$parseValue = config.parseValue) !== null && _config$parseValue !== void 0 ? _config$parseValue : (0, $7J7By.default);
        this.name = config.name;
        this.description = config.description;
        this.specifiedByUrl = config.specifiedByUrl;
        this.serialize = (_config$serialize = config.serialize) !== null && _config$serialize !== void 0 ? _config$serialize : (0, $7J7By.default);
        this.parseValue = parseValue;
        this.parseLiteral = (_config$parseLiteral = config.parseLiteral) !== null && _config$parseLiteral !== void 0 ? _config$parseLiteral : function(node, variables) {
            return parseValue((0, $iTQJQ.valueFromASTUntyped)(node, variables));
        };
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
        config.specifiedByUrl == null || typeof config.specifiedByUrl === 'string' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"specifiedByUrl\" as a string, ") + "but got: ".concat((0, $biK02.default)(config.specifiedByUrl), "."));
        config.serialize == null || typeof config.serialize === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"serialize\" function. If this custom Scalar is also used as an input type, ensure \"parseValue\" and \"parseLiteral\" functions are also provided."));
        if (config.parseLiteral) typeof config.parseValue === 'function' && typeof config.parseLiteral === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide both \"parseValue\" and \"parseLiteral\" functions."));
    }
    var _proto = GraphQLScalarType.prototype;
    _proto.toConfig = function toConfig() {
        var _this$extensionASTNod;
        return {
            name: this.name,
            description: this.description,
            specifiedByUrl: this.specifiedByUrl,
            serialize: this.serialize,
            parseValue: this.parseValue,
            parseLiteral: this.parseLiteral,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod = this.extensionASTNodes) !== null && _this$extensionASTNod !== void 0 ? _this$extensionASTNod : []
        };
    };
    _proto.toString = function toString() {
        return this.name;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLScalarType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLScalarType';
            }
        }
    ]);
    return GraphQLScalarType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$64842b98ea53a3c9);
var $4cde51e3b6dfd290$export$375d3757a19c2e6e = /*#__PURE__*/ function() {
    function GraphQLObjectType(config) {
        this.name = config.name;
        this.description = config.description;
        this.isTypeOf = config.isTypeOf;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._fields = $4cde51e3b6dfd290$var$defineFieldMap.bind(undefined, config);
        this._interfaces = $4cde51e3b6dfd290$var$defineInterfaces.bind(undefined, config);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
        config.isTypeOf == null || typeof config.isTypeOf === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"isTypeOf\" as a function, ") + "but got: ".concat((0, $biK02.default)(config.isTypeOf), "."));
    }
    var _proto2 = GraphQLObjectType.prototype;
    _proto2.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto2.getInterfaces = function getInterfaces() {
        if (typeof this._interfaces === 'function') this._interfaces = this._interfaces();
        return this._interfaces;
    };
    _proto2.toConfig = function toConfig() {
        return {
            name: this.name,
            description: this.description,
            interfaces: this.getInterfaces(),
            fields: $4cde51e3b6dfd290$var$fieldsToFieldsConfig(this.getFields()),
            isTypeOf: this.isTypeOf,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: this.extensionASTNodes || []
        };
    };
    _proto2.toString = function toString() {
        return this.name;
    };
    _proto2.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLObjectType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLObjectType';
            }
        }
    ]);
    return GraphQLObjectType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$375d3757a19c2e6e);
function $4cde51e3b6dfd290$var$defineInterfaces(config) {
    var _resolveThunk;
    var interfaces = (_resolveThunk = $4cde51e3b6dfd290$var$resolveThunk(config.interfaces)) !== null && _resolveThunk !== void 0 ? _resolveThunk : [];
    Array.isArray(interfaces) || (0, $fZdRY.default)(0, "".concat(config.name, " interfaces must be an Array or a function which returns an Array."));
    return interfaces;
}
function $4cde51e3b6dfd290$var$defineFieldMap(config) {
    var fieldMap = $4cde51e3b6dfd290$var$resolveThunk(config.fields);
    $4cde51e3b6dfd290$var$isPlainObj(fieldMap) || (0, $fZdRY.default)(0, "".concat(config.name, " fields must be an object with field names as keys or a function which returns such an object."));
    return (0, $6MWHL.default)(fieldMap, function(fieldConfig, fieldName) {
        var _fieldConfig$args;
        $4cde51e3b6dfd290$var$isPlainObj(fieldConfig) || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " field config must be an object."));
        !('isDeprecated' in fieldConfig) || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " should provide \"deprecationReason\" instead of \"isDeprecated\"."));
        fieldConfig.resolve == null || typeof fieldConfig.resolve === 'function' || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " field resolver must be a function if ") + "provided, but got: ".concat((0, $biK02.default)(fieldConfig.resolve), "."));
        var argsConfig = (_fieldConfig$args = fieldConfig.args) !== null && _fieldConfig$args !== void 0 ? _fieldConfig$args : {};
        $4cde51e3b6dfd290$var$isPlainObj(argsConfig) || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " args must be an object with argument names as keys."));
        var args = (0, $apet0.default)(argsConfig).map(function(_ref) {
            var argName = _ref[0], argConfig = _ref[1];
            return {
                name: argName,
                description: argConfig.description,
                type: argConfig.type,
                defaultValue: argConfig.defaultValue,
                deprecationReason: argConfig.deprecationReason,
                extensions: argConfig.extensions && (0, $eCJ4z.default)(argConfig.extensions),
                astNode: argConfig.astNode
            };
        });
        return {
            name: fieldName,
            description: fieldConfig.description,
            type: fieldConfig.type,
            args: args,
            resolve: fieldConfig.resolve,
            subscribe: fieldConfig.subscribe,
            isDeprecated: fieldConfig.deprecationReason != null,
            deprecationReason: fieldConfig.deprecationReason,
            extensions: fieldConfig.extensions && (0, $eCJ4z.default)(fieldConfig.extensions),
            astNode: fieldConfig.astNode
        };
    });
}
function $4cde51e3b6dfd290$var$isPlainObj(obj) {
    return (0, $fbtyx.default)(obj) && !Array.isArray(obj);
}
function $4cde51e3b6dfd290$var$fieldsToFieldsConfig(fields) {
    return (0, $6MWHL.default)(fields, function(field) {
        return {
            description: field.description,
            type: field.type,
            args: $4cde51e3b6dfd290$export$ae5ade30c645f6fd(field.args),
            resolve: field.resolve,
            subscribe: field.subscribe,
            deprecationReason: field.deprecationReason,
            extensions: field.extensions,
            astNode: field.astNode
        };
    });
}
function $4cde51e3b6dfd290$export$ae5ade30c645f6fd(args) {
    return (0, $2AFgT.default)(args, function(arg) {
        return arg.name;
    }, function(arg) {
        return {
            description: arg.description,
            type: arg.type,
            defaultValue: arg.defaultValue,
            deprecationReason: arg.deprecationReason,
            extensions: arg.extensions,
            astNode: arg.astNode
        };
    });
}
function $4cde51e3b6dfd290$export$caef08b21560291a(arg) {
    return $4cde51e3b6dfd290$export$146b6508fa0d6c82(arg.type) && arg.defaultValue === undefined;
}
var $4cde51e3b6dfd290$export$148e92587b8bf1f9 = /*#__PURE__*/ function() {
    function GraphQLInterfaceType(config) {
        this.name = config.name;
        this.description = config.description;
        this.resolveType = config.resolveType;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._fields = $4cde51e3b6dfd290$var$defineFieldMap.bind(undefined, config);
        this._interfaces = $4cde51e3b6dfd290$var$defineInterfaces.bind(undefined, config);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
        config.resolveType == null || typeof config.resolveType === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, $biK02.default)(config.resolveType), "."));
    }
    var _proto3 = GraphQLInterfaceType.prototype;
    _proto3.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto3.getInterfaces = function getInterfaces() {
        if (typeof this._interfaces === 'function') this._interfaces = this._interfaces();
        return this._interfaces;
    };
    _proto3.toConfig = function toConfig() {
        var _this$extensionASTNod2;
        return {
            name: this.name,
            description: this.description,
            interfaces: this.getInterfaces(),
            fields: $4cde51e3b6dfd290$var$fieldsToFieldsConfig(this.getFields()),
            resolveType: this.resolveType,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod2 = this.extensionASTNodes) !== null && _this$extensionASTNod2 !== void 0 ? _this$extensionASTNod2 : []
        };
    };
    _proto3.toString = function toString() {
        return this.name;
    };
    _proto3.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLInterfaceType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLInterfaceType';
            }
        }
    ]);
    return GraphQLInterfaceType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$148e92587b8bf1f9);
var $4cde51e3b6dfd290$export$33c479b4c3812d0b = /*#__PURE__*/ function() {
    function GraphQLUnionType(config) {
        this.name = config.name;
        this.description = config.description;
        this.resolveType = config.resolveType;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._types = $4cde51e3b6dfd290$var$defineTypes.bind(undefined, config);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
        config.resolveType == null || typeof config.resolveType === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, $biK02.default)(config.resolveType), "."));
    }
    var _proto4 = GraphQLUnionType.prototype;
    _proto4.getTypes = function getTypes() {
        if (typeof this._types === 'function') this._types = this._types();
        return this._types;
    };
    _proto4.toConfig = function toConfig() {
        var _this$extensionASTNod3;
        return {
            name: this.name,
            description: this.description,
            types: this.getTypes(),
            resolveType: this.resolveType,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod3 = this.extensionASTNodes) !== null && _this$extensionASTNod3 !== void 0 ? _this$extensionASTNod3 : []
        };
    };
    _proto4.toString = function toString() {
        return this.name;
    };
    _proto4.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLUnionType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLUnionType';
            }
        }
    ]);
    return GraphQLUnionType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$33c479b4c3812d0b);
function $4cde51e3b6dfd290$var$defineTypes(config) {
    var types = $4cde51e3b6dfd290$var$resolveThunk(config.types);
    Array.isArray(types) || (0, $fZdRY.default)(0, "Must provide Array of types or a function which returns such an array for Union ".concat(config.name, "."));
    return types;
}
var $4cde51e3b6dfd290$export$2577fb93f8748953 = /*#__PURE__*/ function() {
    function GraphQLEnumType(config) {
        this.name = config.name;
        this.description = config.description;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._values = $4cde51e3b6dfd290$var$defineEnumValues(this.name, config.values);
        this._valueLookup = new Map(this._values.map(function(enumValue) {
            return [
                enumValue.value,
                enumValue
            ];
        }));
        this._nameLookup = (0, $hbiEd.default)(this._values, function(value) {
            return value.name;
        });
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
    }
    var _proto5 = GraphQLEnumType.prototype;
    _proto5.getValues = function getValues() {
        return this._values;
    };
    _proto5.getValue = function getValue(name) {
        return this._nameLookup[name];
    };
    _proto5.serialize = function serialize(outputValue) {
        var enumValue = this._valueLookup.get(outputValue);
        if (enumValue === undefined) throw new (0, $9fgMZ.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent value: ").concat((0, $biK02.default)(outputValue)));
        return enumValue.name;
    };
    _proto5.parseValue = function parseValue(inputValue) /* T */ {
        if (typeof inputValue !== 'string') {
            var valueStr = (0, $biK02.default)(inputValue);
            throw new (0, $9fgMZ.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent non-string value: ").concat(valueStr, ".") + $4cde51e3b6dfd290$var$didYouMeanEnumValue(this, valueStr));
        }
        var enumValue = this.getValue(inputValue);
        if (enumValue == null) throw new (0, $9fgMZ.GraphQLError)("Value \"".concat(inputValue, "\" does not exist in \"").concat(this.name, "\" enum.") + $4cde51e3b6dfd290$var$didYouMeanEnumValue(this, inputValue));
        return enumValue.value;
    };
    _proto5.parseLiteral = function parseLiteral(valueNode, _variables) /* T */ {
        // Note: variables will be resolved to a value before calling this function.
        if (valueNode.kind !== (0, $1c4hI.Kind).ENUM) {
            var valueStr = (0, $aKlnM.print)(valueNode);
            throw new (0, $9fgMZ.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent non-enum value: ").concat(valueStr, ".") + $4cde51e3b6dfd290$var$didYouMeanEnumValue(this, valueStr), valueNode);
        }
        var enumValue = this.getValue(valueNode.value);
        if (enumValue == null) {
            var _valueStr = (0, $aKlnM.print)(valueNode);
            throw new (0, $9fgMZ.GraphQLError)("Value \"".concat(_valueStr, "\" does not exist in \"").concat(this.name, "\" enum.") + $4cde51e3b6dfd290$var$didYouMeanEnumValue(this, _valueStr), valueNode);
        }
        return enumValue.value;
    };
    _proto5.toConfig = function toConfig() {
        var _this$extensionASTNod4;
        var values = (0, $2AFgT.default)(this.getValues(), function(value) {
            return value.name;
        }, function(value) {
            return {
                description: value.description,
                value: value.value,
                deprecationReason: value.deprecationReason,
                extensions: value.extensions,
                astNode: value.astNode
            };
        });
        return {
            name: this.name,
            description: this.description,
            values: values,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod4 = this.extensionASTNodes) !== null && _this$extensionASTNod4 !== void 0 ? _this$extensionASTNod4 : []
        };
    };
    _proto5.toString = function toString() {
        return this.name;
    };
    _proto5.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLEnumType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLEnumType';
            }
        }
    ]);
    return GraphQLEnumType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$2577fb93f8748953);
function $4cde51e3b6dfd290$var$didYouMeanEnumValue(enumType, unknownValueStr) {
    var allNames = enumType.getValues().map(function(value) {
        return value.name;
    });
    var suggestedValues = (0, $bru1k.default)(unknownValueStr, allNames);
    return (0, $8nBnZ.default)('the enum value', suggestedValues);
}
function $4cde51e3b6dfd290$var$defineEnumValues(typeName, valueMap) {
    $4cde51e3b6dfd290$var$isPlainObj(valueMap) || (0, $fZdRY.default)(0, "".concat(typeName, " values must be an object with value names as keys."));
    return (0, $apet0.default)(valueMap).map(function(_ref2) {
        var valueName = _ref2[0], valueConfig = _ref2[1];
        $4cde51e3b6dfd290$var$isPlainObj(valueConfig) || (0, $fZdRY.default)(0, "".concat(typeName, ".").concat(valueName, " must refer to an object with a \"value\" key ") + "representing an internal value but got: ".concat((0, $biK02.default)(valueConfig), "."));
        !('isDeprecated' in valueConfig) || (0, $fZdRY.default)(0, "".concat(typeName, ".").concat(valueName, " should provide \"deprecationReason\" instead of \"isDeprecated\"."));
        return {
            name: valueName,
            description: valueConfig.description,
            value: valueConfig.value !== undefined ? valueConfig.value : valueName,
            isDeprecated: valueConfig.deprecationReason != null,
            deprecationReason: valueConfig.deprecationReason,
            extensions: valueConfig.extensions && (0, $eCJ4z.default)(valueConfig.extensions),
            astNode: valueConfig.astNode
        };
    });
}
var $4cde51e3b6dfd290$export$ea29baa44b9fd772 = /*#__PURE__*/ function() {
    function GraphQLInputObjectType(config) {
        this.name = config.name;
        this.description = config.description;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._fields = $4cde51e3b6dfd290$var$defineInputFieldMap.bind(undefined, config);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
    }
    var _proto6 = GraphQLInputObjectType.prototype;
    _proto6.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto6.toConfig = function toConfig() {
        var _this$extensionASTNod5;
        var fields = (0, $6MWHL.default)(this.getFields(), function(field) {
            return {
                description: field.description,
                type: field.type,
                defaultValue: field.defaultValue,
                deprecationReason: field.deprecationReason,
                extensions: field.extensions,
                astNode: field.astNode
            };
        });
        return {
            name: this.name,
            description: this.description,
            fields: fields,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod5 = this.extensionASTNodes) !== null && _this$extensionASTNod5 !== void 0 ? _this$extensionASTNod5 : []
        };
    };
    _proto6.toString = function toString() {
        return this.name;
    };
    _proto6.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLInputObjectType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLInputObjectType';
            }
        }
    ]);
    return GraphQLInputObjectType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$ea29baa44b9fd772);
function $4cde51e3b6dfd290$var$defineInputFieldMap(config) {
    var fieldMap = $4cde51e3b6dfd290$var$resolveThunk(config.fields);
    $4cde51e3b6dfd290$var$isPlainObj(fieldMap) || (0, $fZdRY.default)(0, "".concat(config.name, " fields must be an object with field names as keys or a function which returns such an object."));
    return (0, $6MWHL.default)(fieldMap, function(fieldConfig, fieldName) {
        !('resolve' in fieldConfig) || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " field has a resolve property, but Input Types cannot define resolvers."));
        return {
            name: fieldName,
            description: fieldConfig.description,
            type: fieldConfig.type,
            defaultValue: fieldConfig.defaultValue,
            deprecationReason: fieldConfig.deprecationReason,
            extensions: fieldConfig.extensions && (0, $eCJ4z.default)(fieldConfig.extensions),
            astNode: fieldConfig.astNode
        };
    });
}
function $4cde51e3b6dfd290$export$2657dcc79c2b6229(field) {
    return $4cde51e3b6dfd290$export$146b6508fa0d6c82(field.type) && field.defaultValue === undefined;
}

});
parcelRegister("apet0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b08f9c07090601a$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $7b08f9c07090601a$var$objectEntries = Object.entries || function(obj) {
    return Object.keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
};
var $7b08f9c07090601a$export$2e2bcd8739ae039 = $7b08f9c07090601a$var$objectEntries;

});

parcelRegister("hbiEd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8bc0ac8e121286d$export$2e2bcd8739ae039);
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * for each value in the array.
 *
 * This provides a convenient lookup for the array items if the key function
 * produces unique results.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: { name: 'Jon', num: '555-1234' },
 *     //   Jenny: { name: 'Jenny', num: '867-5309' } }
 *     const entriesByName = keyMap(
 *       phoneBook,
 *       entry => entry.name
 *     )
 *
 *     // { name: 'Jenny', num: '857-6309' }
 *     const jennyEntry = entriesByName['Jenny']
 *
 */ function $b8bc0ac8e121286d$export$2e2bcd8739ae039(list, keyFn) {
    return list.reduce(function(map, item) {
        map[keyFn(item)] = item;
        return map;
    }, Object.create(null));
}

});

parcelRegister("6MWHL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8fd45ca354e0fd3$export$2e2bcd8739ae039);

var $apet0 = parcelRequire("apet0");
function $f8fd45ca354e0fd3$export$2e2bcd8739ae039(map, fn) {
    var result = Object.create(null);
    for(var _i2 = 0, _objectEntries2 = (0, $apet0.default)(map); _i2 < _objectEntries2.length; _i2++){
        var _ref2 = _objectEntries2[_i2];
        var _key = _ref2[0];
        var _value = _ref2[1];
        result[_key] = fn(_value, _key);
    }
    return result;
}

});

parcelRegister("eCJ4z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b444aa0d60034f90$export$2e2bcd8739ae039);

var $apet0 = parcelRequire("apet0");
function $b444aa0d60034f90$export$2e2bcd8739ae039(obj) {
    /* eslint-enable no-redeclare */ if (Object.getPrototypeOf(obj) === null) return obj;
    var map = Object.create(null);
    for(var _i2 = 0, _objectEntries2 = (0, $apet0.default)(obj); _i2 < _objectEntries2.length; _i2++){
        var _ref2 = _objectEntries2[_i2];
        var key = _ref2[0];
        var value = _ref2[1];
        map[key] = value;
    }
    return map;
}

});

parcelRegister("2AFgT", function(module, exports) {

$parcel$export(module.exports, "default", () => $825d74909efe1661$export$2e2bcd8739ae039);
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * and a function to produce the values from each item in the array.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: '555-1234', Jenny: '867-5309' }
 *     const phonesByName = keyValMap(
 *       phoneBook,
 *       entry => entry.name,
 *       entry => entry.num
 *     )
 *
 */ function $825d74909efe1661$export$2e2bcd8739ae039(list, keyFn, valFn) {
    return list.reduce(function(map, item) {
        map[keyFn(item)] = valFn(item);
        return map;
    }, Object.create(null));
}

});

parcelRegister("8nBnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35e74e446587809$export$2e2bcd8739ae039);
var $d35e74e446587809$var$MAX_SUGGESTIONS = 5;
function $d35e74e446587809$export$2e2bcd8739ae039(firstArg, secondArg) {
    var _ref = typeof firstArg === 'string' ? [
        firstArg,
        secondArg
    ] : [
        undefined,
        firstArg
    ], subMessage = _ref[0], suggestionsArg = _ref[1];
    var message = ' Did you mean ';
    if (subMessage) message += subMessage + ' ';
    var suggestions = suggestionsArg.map(function(x) {
        return "\"".concat(x, "\"");
    });
    switch(suggestions.length){
        case 0:
            return '';
        case 1:
            return message + suggestions[0] + '?';
        case 2:
            return message + suggestions[0] + ' or ' + suggestions[1] + '?';
    }
    var selected = suggestions.slice(0, $d35e74e446587809$var$MAX_SUGGESTIONS);
    var lastItem = selected.pop();
    return message + selected.join(', ') + ', or ' + lastItem + '?';
}

});

parcelRegister("7J7By", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3262e5f24e9ad17$export$2e2bcd8739ae039);
/**
 * Returns the first argument it receives.
 */ function $a3262e5f24e9ad17$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("bru1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c1d5be3d827a25$export$2e2bcd8739ae039);

var $daK4l = parcelRequire("daK4l");
function $60c1d5be3d827a25$export$2e2bcd8739ae039(input, options) {
    var optionsByDistance = Object.create(null);
    var lexicalDistance = new $60c1d5be3d827a25$var$LexicalDistance(input);
    var threshold = Math.floor(input.length * 0.4) + 1;
    for(var _i2 = 0; _i2 < options.length; _i2++){
        var option = options[_i2];
        var distance = lexicalDistance.measure(option, threshold);
        if (distance !== undefined) optionsByDistance[option] = distance;
    }
    return Object.keys(optionsByDistance).sort(function(a, b) {
        var distanceDiff = optionsByDistance[a] - optionsByDistance[b];
        return distanceDiff !== 0 ? distanceDiff : (0, $daK4l.default)(a, b);
    });
}
/**
 * Computes the lexical distance between strings A and B.
 *
 * The "distance" between two strings is given by counting the minimum number
 * of edits needed to transform string A into string B. An edit can be an
 * insertion, deletion, or substitution of a single character, or a swap of two
 * adjacent characters.
 *
 * Includes a custom alteration from Damerau-Levenshtein to treat case changes
 * as a single edit which helps identify mis-cased values with an edit distance
 * of 1.
 *
 * This distance can be useful for detecting typos in input or sorting
 */ var $60c1d5be3d827a25$var$LexicalDistance = /*#__PURE__*/ function() {
    function LexicalDistance(input) {
        this._input = input;
        this._inputLowerCase = input.toLowerCase();
        this._inputArray = $60c1d5be3d827a25$var$stringToArray(this._inputLowerCase);
        this._rows = [
            new Array(input.length + 1).fill(0),
            new Array(input.length + 1).fill(0),
            new Array(input.length + 1).fill(0)
        ];
    }
    var _proto = LexicalDistance.prototype;
    _proto.measure = function measure(option, threshold) {
        if (this._input === option) return 0;
        var optionLowerCase = option.toLowerCase(); // Any case change counts as a single edit
        if (this._inputLowerCase === optionLowerCase) return 1;
        var a = $60c1d5be3d827a25$var$stringToArray(optionLowerCase);
        var b = this._inputArray;
        if (a.length < b.length) {
            var tmp = a;
            a = b;
            b = tmp;
        }
        var aLength = a.length;
        var bLength = b.length;
        if (aLength - bLength > threshold) return undefined;
        var rows = this._rows;
        for(var j = 0; j <= bLength; j++)rows[0][j] = j;
        for(var i = 1; i <= aLength; i++){
            var upRow = rows[(i - 1) % 3];
            var currentRow = rows[i % 3];
            var smallestCell = currentRow[0] = i;
            for(var _j = 1; _j <= bLength; _j++){
                var cost = a[i - 1] === b[_j - 1] ? 0 : 1;
                var currentCell = Math.min(upRow[_j] + 1, currentRow[_j - 1] + 1, upRow[_j - 1] + cost // substitute
                );
                if (i > 1 && _j > 1 && a[i - 1] === b[_j - 2] && a[i - 2] === b[_j - 1]) {
                    // transposition
                    var doubleDiagonalCell = rows[(i - 2) % 3][_j - 2];
                    currentCell = Math.min(currentCell, doubleDiagonalCell + 1);
                }
                if (currentCell < smallestCell) smallestCell = currentCell;
                currentRow[_j] = currentCell;
            } // Early exit, since distance can't go smaller than smallest element of the previous row.
            if (smallestCell > threshold) return undefined;
        }
        var distance = rows[aLength % 3][bLength];
        return distance <= threshold ? distance : undefined;
    };
    return LexicalDistance;
}();
function $60c1d5be3d827a25$var$stringToArray(str) {
    var strLength = str.length;
    var array = new Array(strLength);
    for(var i = 0; i < strLength; ++i)array[i] = str.charCodeAt(i);
    return array;
}

});
parcelRegister("daK4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $1240f08dc429303b$export$2e2bcd8739ae039);
/**
 * Returns a number indicating whether a reference string comes before, or after,
 * or is the same as the given string in natural sort order.
 *
 * See: https://en.wikipedia.org/wiki/Natural_sort_order
 *
 */ function $1240f08dc429303b$export$2e2bcd8739ae039(aStr, bStr) {
    var aIdx = 0;
    var bIdx = 0;
    while(aIdx < aStr.length && bIdx < bStr.length){
        var aChar = aStr.charCodeAt(aIdx);
        var bChar = bStr.charCodeAt(bIdx);
        if ($1240f08dc429303b$var$isDigit(aChar) && $1240f08dc429303b$var$isDigit(bChar)) {
            var aNum = 0;
            do {
                ++aIdx;
                aNum = aNum * 10 + aChar - $1240f08dc429303b$var$DIGIT_0;
                aChar = aStr.charCodeAt(aIdx);
            }while ($1240f08dc429303b$var$isDigit(aChar) && aNum > 0);
            var bNum = 0;
            do {
                ++bIdx;
                bNum = bNum * 10 + bChar - $1240f08dc429303b$var$DIGIT_0;
                bChar = bStr.charCodeAt(bIdx);
            }while ($1240f08dc429303b$var$isDigit(bChar) && bNum > 0);
            if (aNum < bNum) return -1;
            if (aNum > bNum) return 1;
        } else {
            if (aChar < bChar) return -1;
            if (aChar > bChar) return 1;
            ++aIdx;
            ++bIdx;
        }
    }
    return aStr.length - bStr.length;
}
var $1240f08dc429303b$var$DIGIT_0 = 48;
var $1240f08dc429303b$var$DIGIT_9 = 57;
function $1240f08dc429303b$var$isDigit(code) {
    return !isNaN(code) && $1240f08dc429303b$var$DIGIT_0 <= code && code <= $1240f08dc429303b$var$DIGIT_9;
}

});


parcelRegister("iTQJQ", function(module, exports) {

$parcel$export(module.exports, "valueFromASTUntyped", () => $da10b2789fd99674$export$448e0963aec9442f);

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $2AFgT = parcelRequire("2AFgT");

var $1c4hI = parcelRequire("1c4hI");
function $da10b2789fd99674$export$448e0963aec9442f(valueNode, variables) {
    switch(valueNode.kind){
        case (0, $1c4hI.Kind).NULL:
            return null;
        case (0, $1c4hI.Kind).INT:
            return parseInt(valueNode.value, 10);
        case (0, $1c4hI.Kind).FLOAT:
            return parseFloat(valueNode.value);
        case (0, $1c4hI.Kind).STRING:
        case (0, $1c4hI.Kind).ENUM:
        case (0, $1c4hI.Kind).BOOLEAN:
            return valueNode.value;
        case (0, $1c4hI.Kind).LIST:
            return valueNode.values.map(function(node) {
                return $da10b2789fd99674$export$448e0963aec9442f(node, variables);
            });
        case (0, $1c4hI.Kind).OBJECT:
            return (0, $2AFgT.default)(valueNode.fields, function(field) {
                return field.name.value;
            }, function(field) {
                return $da10b2789fd99674$export$448e0963aec9442f(field.value, variables);
            });
        case (0, $1c4hI.Kind).VARIABLE:
            return variables === null || variables === void 0 ? void 0 : variables[valueNode.name.value];
    } // istanbul ignore next (Not reachable. All possible value nodes have been considered)
    (0, $43MJl.default)(0, 'Unexpected value node: ' + (0, $biK02.default)(valueNode));
}

});



parcelRegister("6BdRO", function(module, exports) {

$parcel$export(module.exports, "GraphQLSchema", () => $1e230b99124f3642$export$730e8b0fd6e4f02b);
$parcel$export(module.exports, "assertSchema", () => $1e230b99124f3642$export$6554dabc0f90e0c3);

var $bmIpK = parcelRequire("bmIpK");

var $96Cqc = parcelRequire("96Cqc");

var $dVq2R = parcelRequire("dVq2R");

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $eCJ4z = parcelRequire("eCJ4z");

var $fZdRY = parcelRequire("fZdRY");

var $aVhwC = parcelRequire("aVhwC");

var $fbtyx = parcelRequire("fbtyx");

var $h2iUh = parcelRequire("h2iUh");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");
function $1e230b99124f3642$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1e230b99124f3642$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1e230b99124f3642$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1e230b99124f3642$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1e230b99124f3642$export$213e2a3e7c4f326e(schema) {
    return (0, $aVhwC.default)(schema, $1e230b99124f3642$export$730e8b0fd6e4f02b);
}
function $1e230b99124f3642$export$6554dabc0f90e0c3(schema) {
    if (!$1e230b99124f3642$export$213e2a3e7c4f326e(schema)) throw new Error("Expected ".concat((0, $biK02.default)(schema), " to be a GraphQL schema."));
    return schema;
}
var $1e230b99124f3642$export$730e8b0fd6e4f02b = /*#__PURE__*/ function() {
    // Used as a cache for validateSchema().
    function GraphQLSchema(config) {
        var _config$directives;
        // If this schema was built from a source known to be valid, then it may be
        // marked with assumeValid to avoid an additional type system validation.
        this.__validationErrors = config.assumeValid === true ? [] : undefined; // Check for common mistakes during construction to produce early errors.
        (0, $fbtyx.default)(config) || (0, $fZdRY.default)(0, 'Must provide configuration object.');
        !config.types || Array.isArray(config.types) || (0, $fZdRY.default)(0, "\"types\" must be Array if provided but got: ".concat((0, $biK02.default)(config.types), "."));
        !config.directives || Array.isArray(config.directives) || (0, $fZdRY.default)(0, '"directives" must be Array if provided but got: ' + "".concat((0, $biK02.default)(config.directives), "."));
        this.description = config.description;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = config.extensionASTNodes;
        this._queryType = config.query;
        this._mutationType = config.mutation;
        this._subscriptionType = config.subscription; // Provide specified directives (e.g. @include and @skip) by default.
        this._directives = (_config$directives = config.directives) !== null && _config$directives !== void 0 ? _config$directives : (0, $bOniD.specifiedDirectives); // To preserve order of user-provided types, we add first to add them to
        // the set of "collected" types, so `collectReferencedTypes` ignore them.
        var allReferencedTypes = new Set(config.types);
        if (config.types != null) for(var _i2 = 0, _config$types2 = config.types; _i2 < _config$types2.length; _i2++){
            var type = _config$types2[_i2];
            // When we ready to process this type, we remove it from "collected" types
            // and then add it together with all dependent types in the correct position.
            allReferencedTypes.delete(type);
            $1e230b99124f3642$var$collectReferencedTypes(type, allReferencedTypes);
        }
        if (this._queryType != null) $1e230b99124f3642$var$collectReferencedTypes(this._queryType, allReferencedTypes);
        if (this._mutationType != null) $1e230b99124f3642$var$collectReferencedTypes(this._mutationType, allReferencedTypes);
        if (this._subscriptionType != null) $1e230b99124f3642$var$collectReferencedTypes(this._subscriptionType, allReferencedTypes);
        for(var _i4 = 0, _this$_directives2 = this._directives; _i4 < _this$_directives2.length; _i4++){
            var directive = _this$_directives2[_i4];
            // Directives are not validated until validateSchema() is called.
            if ((0, $bOniD.isDirective)(directive)) for(var _i6 = 0, _directive$args2 = directive.args; _i6 < _directive$args2.length; _i6++){
                var arg = _directive$args2[_i6];
                $1e230b99124f3642$var$collectReferencedTypes(arg.type, allReferencedTypes);
            }
        }
        $1e230b99124f3642$var$collectReferencedTypes((0, $h2iUh.__Schema), allReferencedTypes); // Storing the resulting map for reference by the schema.
        this._typeMap = Object.create(null);
        this._subTypeMap = Object.create(null); // Keep track of all implementations by interface name.
        this._implementationsMap = Object.create(null);
        for(var _i8 = 0, _arrayFrom2 = (0, $96Cqc.default)(allReferencedTypes); _i8 < _arrayFrom2.length; _i8++){
            var namedType = _arrayFrom2[_i8];
            if (namedType == null) continue;
            var typeName = namedType.name;
            typeName || (0, $fZdRY.default)(0, 'One of the provided types for building the Schema is missing a name.');
            if (this._typeMap[typeName] !== undefined) throw new Error("Schema must contain uniquely named types but contains multiple types named \"".concat(typeName, "\"."));
            this._typeMap[typeName] = namedType;
            if ((0, $lXoEQ.isInterfaceType)(namedType)) // Store implementations by interface.
            for(var _i10 = 0, _namedType$getInterfa2 = namedType.getInterfaces(); _i10 < _namedType$getInterfa2.length; _i10++){
                var iface = _namedType$getInterfa2[_i10];
                if ((0, $lXoEQ.isInterfaceType)(iface)) {
                    var implementations = this._implementationsMap[iface.name];
                    if (implementations === undefined) implementations = this._implementationsMap[iface.name] = {
                        objects: [],
                        interfaces: []
                    };
                    implementations.interfaces.push(namedType);
                }
            }
            else if ((0, $lXoEQ.isObjectType)(namedType)) // Store implementations by objects.
            for(var _i12 = 0, _namedType$getInterfa4 = namedType.getInterfaces(); _i12 < _namedType$getInterfa4.length; _i12++){
                var _iface = _namedType$getInterfa4[_i12];
                if ((0, $lXoEQ.isInterfaceType)(_iface)) {
                    var _implementations = this._implementationsMap[_iface.name];
                    if (_implementations === undefined) _implementations = this._implementationsMap[_iface.name] = {
                        objects: [],
                        interfaces: []
                    };
                    _implementations.objects.push(namedType);
                }
            }
        }
    }
    var _proto = GraphQLSchema.prototype;
    _proto.getQueryType = function getQueryType() {
        return this._queryType;
    };
    _proto.getMutationType = function getMutationType() {
        return this._mutationType;
    };
    _proto.getSubscriptionType = function getSubscriptionType() {
        return this._subscriptionType;
    };
    _proto.getTypeMap = function getTypeMap() {
        return this._typeMap;
    };
    _proto.getType = function getType(name) {
        return this.getTypeMap()[name];
    };
    _proto.getPossibleTypes = function getPossibleTypes(abstractType) {
        return (0, $lXoEQ.isUnionType)(abstractType) ? abstractType.getTypes() : this.getImplementations(abstractType).objects;
    };
    _proto.getImplementations = function getImplementations(interfaceType) {
        var implementations = this._implementationsMap[interfaceType.name];
        return implementations !== null && implementations !== void 0 ? implementations : {
            objects: [],
            interfaces: []
        };
    } // @deprecated: use isSubType instead - will be removed in v16.
    ;
    _proto.isPossibleType = function isPossibleType(abstractType, possibleType) {
        return this.isSubType(abstractType, possibleType);
    };
    _proto.isSubType = function isSubType(abstractType, maybeSubType) {
        var map = this._subTypeMap[abstractType.name];
        if (map === undefined) {
            map = Object.create(null);
            if ((0, $lXoEQ.isUnionType)(abstractType)) for(var _i14 = 0, _abstractType$getType2 = abstractType.getTypes(); _i14 < _abstractType$getType2.length; _i14++){
                var type = _abstractType$getType2[_i14];
                map[type.name] = true;
            }
            else {
                var implementations = this.getImplementations(abstractType);
                for(var _i16 = 0, _implementations$obje2 = implementations.objects; _i16 < _implementations$obje2.length; _i16++){
                    var _type = _implementations$obje2[_i16];
                    map[_type.name] = true;
                }
                for(var _i18 = 0, _implementations$inte2 = implementations.interfaces; _i18 < _implementations$inte2.length; _i18++){
                    var _type2 = _implementations$inte2[_i18];
                    map[_type2.name] = true;
                }
            }
            this._subTypeMap[abstractType.name] = map;
        }
        return map[maybeSubType.name] !== undefined;
    };
    _proto.getDirectives = function getDirectives() {
        return this._directives;
    };
    _proto.getDirective = function getDirective(name) {
        return (0, $bmIpK.default)(this.getDirectives(), function(directive) {
            return directive.name === name;
        });
    };
    _proto.toConfig = function toConfig() {
        var _this$extensionASTNod;
        return {
            description: this.description,
            query: this.getQueryType(),
            mutation: this.getMutationType(),
            subscription: this.getSubscriptionType(),
            types: (0, $dVq2R.default)(this.getTypeMap()),
            directives: this.getDirectives().slice(),
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod = this.extensionASTNodes) !== null && _this$extensionASTNod !== void 0 ? _this$extensionASTNod : [],
            assumeValid: this.__validationErrors !== undefined
        };
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $1e230b99124f3642$var$_createClass(GraphQLSchema, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLSchema';
            }
        }
    ]);
    return GraphQLSchema;
}();
function $1e230b99124f3642$var$collectReferencedTypes(type, typeSet) {
    var namedType = (0, $lXoEQ.getNamedType)(type);
    if (!typeSet.has(namedType)) {
        typeSet.add(namedType);
        if ((0, $lXoEQ.isUnionType)(namedType)) for(var _i20 = 0, _namedType$getTypes2 = namedType.getTypes(); _i20 < _namedType$getTypes2.length; _i20++){
            var memberType = _namedType$getTypes2[_i20];
            $1e230b99124f3642$var$collectReferencedTypes(memberType, typeSet);
        }
        else if ((0, $lXoEQ.isObjectType)(namedType) || (0, $lXoEQ.isInterfaceType)(namedType)) {
            for(var _i22 = 0, _namedType$getInterfa6 = namedType.getInterfaces(); _i22 < _namedType$getInterfa6.length; _i22++){
                var interfaceType = _namedType$getInterfa6[_i22];
                $1e230b99124f3642$var$collectReferencedTypes(interfaceType, typeSet);
            }
            for(var _i24 = 0, _objectValues2 = (0, $dVq2R.default)(namedType.getFields()); _i24 < _objectValues2.length; _i24++){
                var field = _objectValues2[_i24];
                $1e230b99124f3642$var$collectReferencedTypes(field.type, typeSet);
                for(var _i26 = 0, _field$args2 = field.args; _i26 < _field$args2.length; _i26++){
                    var arg = _field$args2[_i26];
                    $1e230b99124f3642$var$collectReferencedTypes(arg.type, typeSet);
                }
            }
        } else if ((0, $lXoEQ.isInputObjectType)(namedType)) for(var _i28 = 0, _objectValues4 = (0, $dVq2R.default)(namedType.getFields()); _i28 < _objectValues4.length; _i28++){
            var _field = _objectValues4[_i28];
            $1e230b99124f3642$var$collectReferencedTypes(_field.type, typeSet);
        }
    }
    return typeSet;
}

});
parcelRegister("96Cqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff75e7d75b147b76$export$2e2bcd8739ae039);

var $gwa3m = parcelRequire("gwa3m");
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound]
var $ff75e7d75b147b76$var$arrayFrom = Array.from || function(obj, mapFn, thisArg) {
    if (obj == null) throw new TypeError('Array.from requires an array-like object - not null or undefined');
     // Is Iterable?
    var iteratorMethod = obj[0, $gwa3m.SYMBOL_ITERATOR];
    if (typeof iteratorMethod === 'function') {
        var iterator = iteratorMethod.call(obj);
        var result = [];
        var step;
        for(var i = 0; !(step = iterator.next()).done; ++i){
            result.push(mapFn.call(thisArg, step.value, i)); // Infinite Iterators could cause forEach to run forever.
            // After a very large number of iterations, produce an error.
            // istanbul ignore if (Too big to actually test)
            if (i > 9999999) throw new TypeError('Near-infinite iteration.');
        }
        return result;
    } // Is Array like?
    var length = obj.length;
    if (typeof length === 'number' && length >= 0 && length % 1 === 0) {
        var _result = [];
        for(var _i = 0; _i < length; ++_i)if (Object.prototype.hasOwnProperty.call(obj, _i)) _result.push(mapFn.call(thisArg, obj[_i], _i));
        return _result;
    }
    return [];
};
var $ff75e7d75b147b76$export$2e2bcd8739ae039 = $ff75e7d75b147b76$var$arrayFrom;

});

parcelRegister("h2iUh", function(module, exports) {

$parcel$export(module.exports, "__Schema", () => $6ebe99021e9a5959$export$1f18df711f6fa0ac);
$parcel$export(module.exports, "TypeKind", () => $6ebe99021e9a5959$export$c29cf3c48471da7c);
$parcel$export(module.exports, "SchemaMetaFieldDef", () => $6ebe99021e9a5959$export$36ed059ad2080404);
$parcel$export(module.exports, "TypeMetaFieldDef", () => $6ebe99021e9a5959$export$87a968d084148b61);
$parcel$export(module.exports, "TypeNameMetaFieldDef", () => $6ebe99021e9a5959$export$b9c17490e825648e);
$parcel$export(module.exports, "introspectionTypes", () => $6ebe99021e9a5959$export$560bc6e8f6d098f4);
$parcel$export(module.exports, "isIntrospectionType", () => $6ebe99021e9a5959$export$e1862b156b15ce4f);

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $aKlnM = parcelRequire("aKlnM");

var $5hGV7 = parcelRequire("5hGV7");

var $cMIyS = parcelRequire("cMIyS");

var $auu22 = parcelRequire("auu22");

var $lXoEQ = parcelRequire("lXoEQ");
var $6ebe99021e9a5959$export$1f18df711f6fa0ac = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__Schema',
    description: 'A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.',
    fields: function fields() {
        return {
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(schema) {
                    return schema.description;
                }
            },
            types: {
                description: 'A list of all types supported by this server.',
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7))),
                resolve: function resolve(schema) {
                    return (0, $dVq2R.default)(schema.getTypeMap());
                }
            },
            queryType: {
                description: 'The type that query operations will be rooted at.',
                type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7),
                resolve: function resolve(schema) {
                    return schema.getQueryType();
                }
            },
            mutationType: {
                description: 'If this server supports mutation, the type that mutation operations will be rooted at.',
                type: $6ebe99021e9a5959$export$b46ca740abcddda7,
                resolve: function resolve(schema) {
                    return schema.getMutationType();
                }
            },
            subscriptionType: {
                description: 'If this server support subscription, the type that subscription operations will be rooted at.',
                type: $6ebe99021e9a5959$export$b46ca740abcddda7,
                resolve: function resolve(schema) {
                    return schema.getSubscriptionType();
                }
            },
            directives: {
                description: 'A list of all directives supported by this server.',
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$2492e8c5b8ba489f))),
                resolve: function resolve(schema) {
                    return schema.getDirectives();
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$2492e8c5b8ba489f = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__Directive',
    description: "A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.\n\nIn some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.",
    fields: function fields() {
        return {
            name: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
                resolve: function resolve(directive) {
                    return directive.name;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(directive) {
                    return directive.description;
                }
            },
            isRepeatable: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
                resolve: function resolve(directive) {
                    return directive.isRepeatable;
                }
            },
            locations: {
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$70e870c5930737d1))),
                resolve: function resolve(directive) {
                    return directive.locations;
                }
            },
            args: {
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$bc79df5a9719c05b))),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(field, _ref) {
                    var includeDeprecated = _ref.includeDeprecated;
                    return includeDeprecated ? field.args : field.args.filter(function(arg) {
                        return arg.deprecationReason == null;
                    });
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$70e870c5930737d1 = new (0, $lXoEQ.GraphQLEnumType)({
    name: '__DirectiveLocation',
    description: 'A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.',
    values: {
        QUERY: {
            value: (0, $5hGV7.DirectiveLocation).QUERY,
            description: 'Location adjacent to a query operation.'
        },
        MUTATION: {
            value: (0, $5hGV7.DirectiveLocation).MUTATION,
            description: 'Location adjacent to a mutation operation.'
        },
        SUBSCRIPTION: {
            value: (0, $5hGV7.DirectiveLocation).SUBSCRIPTION,
            description: 'Location adjacent to a subscription operation.'
        },
        FIELD: {
            value: (0, $5hGV7.DirectiveLocation).FIELD,
            description: 'Location adjacent to a field.'
        },
        FRAGMENT_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).FRAGMENT_DEFINITION,
            description: 'Location adjacent to a fragment definition.'
        },
        FRAGMENT_SPREAD: {
            value: (0, $5hGV7.DirectiveLocation).FRAGMENT_SPREAD,
            description: 'Location adjacent to a fragment spread.'
        },
        INLINE_FRAGMENT: {
            value: (0, $5hGV7.DirectiveLocation).INLINE_FRAGMENT,
            description: 'Location adjacent to an inline fragment.'
        },
        VARIABLE_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).VARIABLE_DEFINITION,
            description: 'Location adjacent to a variable definition.'
        },
        SCHEMA: {
            value: (0, $5hGV7.DirectiveLocation).SCHEMA,
            description: 'Location adjacent to a schema definition.'
        },
        SCALAR: {
            value: (0, $5hGV7.DirectiveLocation).SCALAR,
            description: 'Location adjacent to a scalar definition.'
        },
        OBJECT: {
            value: (0, $5hGV7.DirectiveLocation).OBJECT,
            description: 'Location adjacent to an object type definition.'
        },
        FIELD_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).FIELD_DEFINITION,
            description: 'Location adjacent to a field definition.'
        },
        ARGUMENT_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).ARGUMENT_DEFINITION,
            description: 'Location adjacent to an argument definition.'
        },
        INTERFACE: {
            value: (0, $5hGV7.DirectiveLocation).INTERFACE,
            description: 'Location adjacent to an interface definition.'
        },
        UNION: {
            value: (0, $5hGV7.DirectiveLocation).UNION,
            description: 'Location adjacent to a union definition.'
        },
        ENUM: {
            value: (0, $5hGV7.DirectiveLocation).ENUM,
            description: 'Location adjacent to an enum definition.'
        },
        ENUM_VALUE: {
            value: (0, $5hGV7.DirectiveLocation).ENUM_VALUE,
            description: 'Location adjacent to an enum value definition.'
        },
        INPUT_OBJECT: {
            value: (0, $5hGV7.DirectiveLocation).INPUT_OBJECT,
            description: 'Location adjacent to an input object type definition.'
        },
        INPUT_FIELD_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).INPUT_FIELD_DEFINITION,
            description: 'Location adjacent to an input object field definition.'
        }
    }
});
var $6ebe99021e9a5959$export$b46ca740abcddda7 = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__Type',
    description: 'The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.',
    fields: function fields() {
        return {
            kind: {
                type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$163610506c99e78f),
                resolve: function resolve(type) {
                    if ((0, $lXoEQ.isScalarType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.SCALAR;
                    if ((0, $lXoEQ.isObjectType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.OBJECT;
                    if ((0, $lXoEQ.isInterfaceType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.INTERFACE;
                    if ((0, $lXoEQ.isUnionType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.UNION;
                    if ((0, $lXoEQ.isEnumType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.ENUM;
                    if ((0, $lXoEQ.isInputObjectType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.INPUT_OBJECT;
                    if ((0, $lXoEQ.isListType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.LIST;
                     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
                    if ((0, $lXoEQ.isNonNullType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.NON_NULL;
                     // istanbul ignore next (Not reachable. All possible types have been considered)
                    (0, $43MJl.default)(0, "Unexpected type: \"".concat((0, $biK02.default)(type), "\"."));
                }
            },
            name: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(type) {
                    return type.name !== undefined ? type.name : undefined;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(type) {
                    return type.description !== undefined ? type.description : undefined;
                }
            },
            specifiedByUrl: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(obj) {
                    return obj.specifiedByUrl !== undefined ? obj.specifiedByUrl : undefined;
                }
            },
            fields: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$c93780024e419b02)),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref2) {
                    var includeDeprecated = _ref2.includeDeprecated;
                    if ((0, $lXoEQ.isObjectType)(type) || (0, $lXoEQ.isInterfaceType)(type)) {
                        var fields = (0, $dVq2R.default)(type.getFields());
                        return includeDeprecated ? fields : fields.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            interfaces: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7)),
                resolve: function resolve(type) {
                    if ((0, $lXoEQ.isObjectType)(type) || (0, $lXoEQ.isInterfaceType)(type)) return type.getInterfaces();
                }
            },
            possibleTypes: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7)),
                resolve: function resolve(type, _args, _context, _ref3) {
                    var schema = _ref3.schema;
                    if ((0, $lXoEQ.isAbstractType)(type)) return schema.getPossibleTypes(type);
                }
            },
            enumValues: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b93e3441ec96b29a)),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref4) {
                    var includeDeprecated = _ref4.includeDeprecated;
                    if ((0, $lXoEQ.isEnumType)(type)) {
                        var values = type.getValues();
                        return includeDeprecated ? values : values.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            inputFields: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$bc79df5a9719c05b)),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref5) {
                    var includeDeprecated = _ref5.includeDeprecated;
                    if ((0, $lXoEQ.isInputObjectType)(type)) {
                        var values = (0, $dVq2R.default)(type.getFields());
                        return includeDeprecated ? values : values.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            ofType: {
                type: $6ebe99021e9a5959$export$b46ca740abcddda7,
                resolve: function resolve(type) {
                    return type.ofType !== undefined ? type.ofType : undefined;
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$c93780024e419b02 = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__Field',
    description: 'Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.',
    fields: function fields() {
        return {
            name: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
                resolve: function resolve(field) {
                    return field.name;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(field) {
                    return field.description;
                }
            },
            args: {
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$bc79df5a9719c05b))),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(field, _ref6) {
                    var includeDeprecated = _ref6.includeDeprecated;
                    return includeDeprecated ? field.args : field.args.filter(function(arg) {
                        return arg.deprecationReason == null;
                    });
                }
            },
            type: {
                type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7),
                resolve: function resolve(field) {
                    return field.type;
                }
            },
            isDeprecated: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
                resolve: function resolve(field) {
                    return field.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(field) {
                    return field.deprecationReason;
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$bc79df5a9719c05b = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__InputValue',
    description: 'Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.',
    fields: function fields() {
        return {
            name: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
                resolve: function resolve(inputValue) {
                    return inputValue.name;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(inputValue) {
                    return inputValue.description;
                }
            },
            type: {
                type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7),
                resolve: function resolve(inputValue) {
                    return inputValue.type;
                }
            },
            defaultValue: {
                type: (0, $auu22.GraphQLString),
                description: 'A GraphQL-formatted string representing the default value for this input value.',
                resolve: function resolve(inputValue) {
                    var type = inputValue.type, defaultValue = inputValue.defaultValue;
                    var valueAST = (0, $cMIyS.astFromValue)(defaultValue, type);
                    return valueAST ? (0, $aKlnM.print)(valueAST) : null;
                }
            },
            isDeprecated: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
                resolve: function resolve(field) {
                    return field.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(obj) {
                    return obj.deprecationReason;
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$b93e3441ec96b29a = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__EnumValue',
    description: 'One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.',
    fields: function fields() {
        return {
            name: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
                resolve: function resolve(enumValue) {
                    return enumValue.name;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(enumValue) {
                    return enumValue.description;
                }
            },
            isDeprecated: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
                resolve: function resolve(enumValue) {
                    return enumValue.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(enumValue) {
                    return enumValue.deprecationReason;
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$c29cf3c48471da7c = Object.freeze({
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    INPUT_OBJECT: 'INPUT_OBJECT',
    LIST: 'LIST',
    NON_NULL: 'NON_NULL'
});
var $6ebe99021e9a5959$export$163610506c99e78f = new (0, $lXoEQ.GraphQLEnumType)({
    name: '__TypeKind',
    description: 'An enum describing what kind of type a given `__Type` is.',
    values: {
        SCALAR: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.SCALAR,
            description: 'Indicates this type is a scalar.'
        },
        OBJECT: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.OBJECT,
            description: 'Indicates this type is an object. `fields` and `interfaces` are valid fields.'
        },
        INTERFACE: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.INTERFACE,
            description: 'Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields.'
        },
        UNION: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.UNION,
            description: 'Indicates this type is a union. `possibleTypes` is a valid field.'
        },
        ENUM: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.ENUM,
            description: 'Indicates this type is an enum. `enumValues` is a valid field.'
        },
        INPUT_OBJECT: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.INPUT_OBJECT,
            description: 'Indicates this type is an input object. `inputFields` is a valid field.'
        },
        LIST: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.LIST,
            description: 'Indicates this type is a list. `ofType` is a valid field.'
        },
        NON_NULL: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.NON_NULL,
            description: 'Indicates this type is a non-null. `ofType` is a valid field.'
        }
    }
});
var $6ebe99021e9a5959$export$36ed059ad2080404 = {
    name: '__schema',
    type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$1f18df711f6fa0ac),
    description: 'Access the current type schema of this server.',
    args: [],
    resolve: function resolve(_source, _args, _context, _ref7) {
        var schema = _ref7.schema;
        return schema;
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var $6ebe99021e9a5959$export$87a968d084148b61 = {
    name: '__type',
    type: $6ebe99021e9a5959$export$b46ca740abcddda7,
    description: 'Request the type information of a single type.',
    args: [
        {
            name: 'name',
            description: undefined,
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
            defaultValue: undefined,
            deprecationReason: undefined,
            extensions: undefined,
            astNode: undefined
        }
    ],
    resolve: function resolve(_source, _ref8, _context, _ref9) {
        var name = _ref8.name;
        var schema = _ref9.schema;
        return schema.getType(name);
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var $6ebe99021e9a5959$export$b9c17490e825648e = {
    name: '__typename',
    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
    description: 'The name of the current Object type at runtime.',
    args: [],
    resolve: function resolve(_source, _args, _context, _ref10) {
        var parentType = _ref10.parentType;
        return parentType.name;
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var $6ebe99021e9a5959$export$560bc6e8f6d098f4 = Object.freeze([
    $6ebe99021e9a5959$export$1f18df711f6fa0ac,
    $6ebe99021e9a5959$export$2492e8c5b8ba489f,
    $6ebe99021e9a5959$export$70e870c5930737d1,
    $6ebe99021e9a5959$export$b46ca740abcddda7,
    $6ebe99021e9a5959$export$c93780024e419b02,
    $6ebe99021e9a5959$export$bc79df5a9719c05b,
    $6ebe99021e9a5959$export$b93e3441ec96b29a,
    $6ebe99021e9a5959$export$163610506c99e78f
]);
function $6ebe99021e9a5959$export$e1862b156b15ce4f(type) {
    return $6ebe99021e9a5959$export$560bc6e8f6d098f4.some(function(_ref11) {
        var name = _ref11.name;
        return type.name === name;
    });
}

});
parcelRegister("cMIyS", function(module, exports) {

$parcel$export(module.exports, "astFromValue", () => $8815f467872381b8$export$973c016b19737b40);

var $2ajMd = parcelRequire("2ajMd");

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $fbtyx = parcelRequire("fbtyx");

var $8DMvn = parcelRequire("8DMvn");

var $1c4hI = parcelRequire("1c4hI");

var $auu22 = parcelRequire("auu22");

var $lXoEQ = parcelRequire("lXoEQ");
function $8815f467872381b8$export$973c016b19737b40(value, type) {
    if ((0, $lXoEQ.isNonNullType)(type)) {
        var astValue = $8815f467872381b8$export$973c016b19737b40(value, type.ofType);
        if ((astValue === null || astValue === void 0 ? void 0 : astValue.kind) === (0, $1c4hI.Kind).NULL) return null;
        return astValue;
    } // only explicit null, not undefined, NaN
    if (value === null) return {
        kind: (0, $1c4hI.Kind).NULL
    };
     // undefined
    if (value === undefined) return null;
     // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
    // the value is not an array, convert the value using the list's item type.
    if ((0, $lXoEQ.isListType)(type)) {
        var itemType = type.ofType;
        var items = (0, $8DMvn.default)(value);
        if (items != null) {
            var valuesNodes = [];
            for(var _i2 = 0; _i2 < items.length; _i2++){
                var item = items[_i2];
                var itemNode = $8815f467872381b8$export$973c016b19737b40(item, itemType);
                if (itemNode != null) valuesNodes.push(itemNode);
            }
            return {
                kind: (0, $1c4hI.Kind).LIST,
                values: valuesNodes
            };
        }
        return $8815f467872381b8$export$973c016b19737b40(value, itemType);
    } // Populate the fields of the input object by creating ASTs from each value
    // in the JavaScript object according to the fields in the input type.
    if ((0, $lXoEQ.isInputObjectType)(type)) {
        if (!(0, $fbtyx.default)(value)) return null;
        var fieldNodes = [];
        for(var _i4 = 0, _objectValues2 = (0, $dVq2R.default)(type.getFields()); _i4 < _objectValues2.length; _i4++){
            var field = _objectValues2[_i4];
            var fieldValue = $8815f467872381b8$export$973c016b19737b40(value[field.name], field.type);
            if (fieldValue) fieldNodes.push({
                kind: (0, $1c4hI.Kind).OBJECT_FIELD,
                name: {
                    kind: (0, $1c4hI.Kind).NAME,
                    value: field.name
                },
                value: fieldValue
            });
        }
        return {
            kind: (0, $1c4hI.Kind).OBJECT,
            fields: fieldNodes
        };
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isLeafType)(type)) {
        // Since value is an internally represented value, it must be serialized
        // to an externally represented value before converting into an AST.
        var serialized = type.serialize(value);
        if (serialized == null) return null;
         // Others serialize based on their corresponding JavaScript scalar types.
        if (typeof serialized === 'boolean') return {
            kind: (0, $1c4hI.Kind).BOOLEAN,
            value: serialized
        };
         // JavaScript numbers can be Int or Float values.
        if (typeof serialized === 'number' && (0, $2ajMd.default)(serialized)) {
            var stringNum = String(serialized);
            return $8815f467872381b8$var$integerStringRegExp.test(stringNum) ? {
                kind: (0, $1c4hI.Kind).INT,
                value: stringNum
            } : {
                kind: (0, $1c4hI.Kind).FLOAT,
                value: stringNum
            };
        }
        if (typeof serialized === 'string') {
            // Enum types use Enum literals.
            if ((0, $lXoEQ.isEnumType)(type)) return {
                kind: (0, $1c4hI.Kind).ENUM,
                value: serialized
            };
             // ID types can use Int literals.
            if (type === (0, $auu22.GraphQLID) && $8815f467872381b8$var$integerStringRegExp.test(serialized)) return {
                kind: (0, $1c4hI.Kind).INT,
                value: serialized
            };
            return {
                kind: (0, $1c4hI.Kind).STRING,
                value: serialized
            };
        }
        throw new TypeError("Cannot convert value to AST: ".concat((0, $biK02.default)(serialized), "."));
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, $43MJl.default)(0, 'Unexpected input type: ' + (0, $biK02.default)(type));
}
/**
 * IntValue:
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit ( Digit+ )?
 */ var $8815f467872381b8$var$integerStringRegExp = /^-?(?:0|[1-9][0-9]*)$/;

});
parcelRegister("2ajMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec3464f8e85982de$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $ec3464f8e85982de$var$isFinitePolyfill = Number.isFinite || function(value) {
    return typeof value === 'number' && isFinite(value);
};
var $ec3464f8e85982de$export$2e2bcd8739ae039 = $ec3464f8e85982de$var$isFinitePolyfill;

});

parcelRegister("auu22", function(module, exports) {

$parcel$export(module.exports, "GraphQLInt", () => $b7a726a9eae6fb8d$export$4d4383325330928b);
$parcel$export(module.exports, "GraphQLFloat", () => $b7a726a9eae6fb8d$export$3b54cc45efb7ef0d);
$parcel$export(module.exports, "GraphQLString", () => $b7a726a9eae6fb8d$export$bf00325280f7630c);
$parcel$export(module.exports, "GraphQLBoolean", () => $b7a726a9eae6fb8d$export$bcd144a2158fe517);
$parcel$export(module.exports, "GraphQLID", () => $b7a726a9eae6fb8d$export$530df982af95a879);
$parcel$export(module.exports, "specifiedScalarTypes", () => $b7a726a9eae6fb8d$export$5df80378609411b9);
$parcel$export(module.exports, "isSpecifiedScalarType", () => $b7a726a9eae6fb8d$export$5d6bb1cb0ae296ca);

var $2ajMd = parcelRequire("2ajMd");

var $nUGRp = parcelRequire("nUGRp");

var $biK02 = parcelRequire("biK02");

var $fbtyx = parcelRequire("fbtyx");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
// 32-bit signed integer, providing the broadest support across platforms.
//
// n.b. JavaScript's integers are safe between -(2^53 - 1) and 2^53 - 1 because
// they are internally represented as IEEE 754 doubles.
var $b7a726a9eae6fb8d$var$MAX_INT = 2147483647;
var $b7a726a9eae6fb8d$var$MIN_INT = -2147483648;
function $b7a726a9eae6fb8d$var$serializeInt(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue ? 1 : 0;
    var num = coercedValue;
    if (typeof coercedValue === 'string' && coercedValue !== '') num = Number(coercedValue);
    if (!(0, $nUGRp.default)(num)) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non-integer value: ".concat((0, $biK02.default)(coercedValue)));
    if (num > $b7a726a9eae6fb8d$var$MAX_INT || num < $b7a726a9eae6fb8d$var$MIN_INT) throw new (0, $9fgMZ.GraphQLError)('Int cannot represent non 32-bit signed integer value: ' + (0, $biK02.default)(coercedValue));
    return num;
}
function $b7a726a9eae6fb8d$var$coerceInt(inputValue) {
    if (!(0, $nUGRp.default)(inputValue)) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non-integer value: ".concat((0, $biK02.default)(inputValue)));
    if (inputValue > $b7a726a9eae6fb8d$var$MAX_INT || inputValue < $b7a726a9eae6fb8d$var$MIN_INT) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non 32-bit signed integer value: ".concat(inputValue));
    return inputValue;
}
var $b7a726a9eae6fb8d$export$4d4383325330928b = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'Int',
    description: 'The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.',
    serialize: $b7a726a9eae6fb8d$var$serializeInt,
    parseValue: $b7a726a9eae6fb8d$var$coerceInt,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).INT) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non-integer value: ".concat((0, $aKlnM.print)(valueNode)), valueNode);
        var num = parseInt(valueNode.value, 10);
        if (num > $b7a726a9eae6fb8d$var$MAX_INT || num < $b7a726a9eae6fb8d$var$MIN_INT) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non 32-bit signed integer value: ".concat(valueNode.value), valueNode);
        return num;
    }
});
function $b7a726a9eae6fb8d$var$serializeFloat(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue ? 1 : 0;
    var num = coercedValue;
    if (typeof coercedValue === 'string' && coercedValue !== '') num = Number(coercedValue);
    if (!(0, $2ajMd.default)(num)) throw new (0, $9fgMZ.GraphQLError)("Float cannot represent non numeric value: ".concat((0, $biK02.default)(coercedValue)));
    return num;
}
function $b7a726a9eae6fb8d$var$coerceFloat(inputValue) {
    if (!(0, $2ajMd.default)(inputValue)) throw new (0, $9fgMZ.GraphQLError)("Float cannot represent non numeric value: ".concat((0, $biK02.default)(inputValue)));
    return inputValue;
}
var $b7a726a9eae6fb8d$export$3b54cc45efb7ef0d = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'Float',
    description: 'The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).',
    serialize: $b7a726a9eae6fb8d$var$serializeFloat,
    parseValue: $b7a726a9eae6fb8d$var$coerceFloat,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).FLOAT && valueNode.kind !== (0, $1c4hI.Kind).INT) throw new (0, $9fgMZ.GraphQLError)("Float cannot represent non numeric value: ".concat((0, $aKlnM.print)(valueNode)), valueNode);
        return parseFloat(valueNode.value);
    }
}); // Support serializing objects with custom valueOf() or toJSON() functions -
// a common way to represent a complex value which can be represented as
// a string (ex: MongoDB id objects).
function $b7a726a9eae6fb8d$var$serializeObject(outputValue) {
    if ((0, $fbtyx.default)(outputValue)) {
        if (typeof outputValue.valueOf === 'function') {
            var valueOfResult = outputValue.valueOf();
            if (!(0, $fbtyx.default)(valueOfResult)) return valueOfResult;
        }
        if (typeof outputValue.toJSON === 'function') // $FlowFixMe[incompatible-use]
        return outputValue.toJSON();
    }
    return outputValue;
}
function $b7a726a9eae6fb8d$var$serializeString(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue); // Serialize string, boolean and number values to a string, but do not
    // attempt to coerce object, function, symbol, or other types as strings.
    if (typeof coercedValue === 'string') return coercedValue;
    if (typeof coercedValue === 'boolean') return coercedValue ? 'true' : 'false';
    if ((0, $2ajMd.default)(coercedValue)) return coercedValue.toString();
    throw new (0, $9fgMZ.GraphQLError)("String cannot represent value: ".concat((0, $biK02.default)(outputValue)));
}
function $b7a726a9eae6fb8d$var$coerceString(inputValue) {
    if (typeof inputValue !== 'string') throw new (0, $9fgMZ.GraphQLError)("String cannot represent a non string value: ".concat((0, $biK02.default)(inputValue)));
    return inputValue;
}
var $b7a726a9eae6fb8d$export$bf00325280f7630c = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'String',
    description: 'The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.',
    serialize: $b7a726a9eae6fb8d$var$serializeString,
    parseValue: $b7a726a9eae6fb8d$var$coerceString,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).STRING) throw new (0, $9fgMZ.GraphQLError)("String cannot represent a non string value: ".concat((0, $aKlnM.print)(valueNode)), valueNode);
        return valueNode.value;
    }
});
function $b7a726a9eae6fb8d$var$serializeBoolean(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue;
    if ((0, $2ajMd.default)(coercedValue)) return coercedValue !== 0;
    throw new (0, $9fgMZ.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, $biK02.default)(coercedValue)));
}
function $b7a726a9eae6fb8d$var$coerceBoolean(inputValue) {
    if (typeof inputValue !== 'boolean') throw new (0, $9fgMZ.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, $biK02.default)(inputValue)));
    return inputValue;
}
var $b7a726a9eae6fb8d$export$bcd144a2158fe517 = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'Boolean',
    description: 'The `Boolean` scalar type represents `true` or `false`.',
    serialize: $b7a726a9eae6fb8d$var$serializeBoolean,
    parseValue: $b7a726a9eae6fb8d$var$coerceBoolean,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).BOOLEAN) throw new (0, $9fgMZ.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, $aKlnM.print)(valueNode)), valueNode);
        return valueNode.value;
    }
});
function $b7a726a9eae6fb8d$var$serializeID(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue);
    if (typeof coercedValue === 'string') return coercedValue;
    if ((0, $nUGRp.default)(coercedValue)) return String(coercedValue);
    throw new (0, $9fgMZ.GraphQLError)("ID cannot represent value: ".concat((0, $biK02.default)(outputValue)));
}
function $b7a726a9eae6fb8d$var$coerceID(inputValue) {
    if (typeof inputValue === 'string') return inputValue;
    if ((0, $nUGRp.default)(inputValue)) return inputValue.toString();
    throw new (0, $9fgMZ.GraphQLError)("ID cannot represent value: ".concat((0, $biK02.default)(inputValue)));
}
var $b7a726a9eae6fb8d$export$530df982af95a879 = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'ID',
    description: 'The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID.',
    serialize: $b7a726a9eae6fb8d$var$serializeID,
    parseValue: $b7a726a9eae6fb8d$var$coerceID,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).STRING && valueNode.kind !== (0, $1c4hI.Kind).INT) throw new (0, $9fgMZ.GraphQLError)('ID cannot represent a non-string and non-integer value: ' + (0, $aKlnM.print)(valueNode), valueNode);
        return valueNode.value;
    }
});
var $b7a726a9eae6fb8d$export$5df80378609411b9 = Object.freeze([
    $b7a726a9eae6fb8d$export$bf00325280f7630c,
    $b7a726a9eae6fb8d$export$4d4383325330928b,
    $b7a726a9eae6fb8d$export$3b54cc45efb7ef0d,
    $b7a726a9eae6fb8d$export$bcd144a2158fe517,
    $b7a726a9eae6fb8d$export$530df982af95a879
]);
function $b7a726a9eae6fb8d$export$5d6bb1cb0ae296ca(type) {
    return $b7a726a9eae6fb8d$export$5df80378609411b9.some(function(_ref) {
        var name = _ref.name;
        return type.name === name;
    });
}

});
parcelRegister("nUGRp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c759a73a7c0b3364$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $c759a73a7c0b3364$var$isInteger = Number.isInteger || function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};
var $c759a73a7c0b3364$export$2e2bcd8739ae039 = $c759a73a7c0b3364$var$isInteger;

});




parcelRegister("bOniD", function(module, exports) {

$parcel$export(module.exports, "isDirective", () => $68b3a31c3f813eb2$export$4b5d79f26e0e3ad5);
$parcel$export(module.exports, "GraphQLDirective", () => $68b3a31c3f813eb2$export$90407e48aac654e9);
$parcel$export(module.exports, "GraphQLIncludeDirective", () => $68b3a31c3f813eb2$export$f92fb5dbf075dbee);
$parcel$export(module.exports, "GraphQLSkipDirective", () => $68b3a31c3f813eb2$export$7adbe9be7084cfe3);
$parcel$export(module.exports, "DEFAULT_DEPRECATION_REASON", () => $68b3a31c3f813eb2$export$15edbda76f1f9a89);
$parcel$export(module.exports, "GraphQLDeprecatedDirective", () => $68b3a31c3f813eb2$export$ed64f8040ac801d1);
$parcel$export(module.exports, "GraphQLSpecifiedByDirective", () => $68b3a31c3f813eb2$export$26ce3cf10bb75d41);
$parcel$export(module.exports, "specifiedDirectives", () => $68b3a31c3f813eb2$export$c48d2e3f4e034403);
$parcel$export(module.exports, "isSpecifiedDirective", () => $68b3a31c3f813eb2$export$7d2e48434602f4fe);

var $apet0 = parcelRequire("apet0");

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $eCJ4z = parcelRequire("eCJ4z");

var $fZdRY = parcelRequire("fZdRY");

var $aVhwC = parcelRequire("aVhwC");

var $fbtyx = parcelRequire("fbtyx");

var $51GHS = parcelRequire("51GHS");

var $5hGV7 = parcelRequire("5hGV7");

var $auu22 = parcelRequire("auu22");

var $lXoEQ = parcelRequire("lXoEQ");
function $68b3a31c3f813eb2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $68b3a31c3f813eb2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $68b3a31c3f813eb2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $68b3a31c3f813eb2$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $68b3a31c3f813eb2$export$4b5d79f26e0e3ad5(directive) {
    return (0, $aVhwC.default)(directive, $68b3a31c3f813eb2$export$90407e48aac654e9);
}
function $68b3a31c3f813eb2$export$976bef3b79eaee5d(directive) {
    if (!$68b3a31c3f813eb2$export$4b5d79f26e0e3ad5(directive)) throw new Error("Expected ".concat((0, $biK02.default)(directive), " to be a GraphQL directive."));
    return directive;
}
var $68b3a31c3f813eb2$export$90407e48aac654e9 = /*#__PURE__*/ function() {
    function GraphQLDirective(config) {
        var _config$isRepeatable, _config$args;
        this.name = config.name;
        this.description = config.description;
        this.locations = config.locations;
        this.isRepeatable = (_config$isRepeatable = config.isRepeatable) !== null && _config$isRepeatable !== void 0 ? _config$isRepeatable : false;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        config.name || (0, $fZdRY.default)(0, 'Directive must be named.');
        Array.isArray(config.locations) || (0, $fZdRY.default)(0, "@".concat(config.name, " locations must be an Array."));
        var args = (_config$args = config.args) !== null && _config$args !== void 0 ? _config$args : {};
        (0, $fbtyx.default)(args) && !Array.isArray(args) || (0, $fZdRY.default)(0, "@".concat(config.name, " args must be an object with argument names as keys."));
        this.args = (0, $apet0.default)(args).map(function(_ref) {
            var argName = _ref[0], argConfig = _ref[1];
            return {
                name: argName,
                description: argConfig.description,
                type: argConfig.type,
                defaultValue: argConfig.defaultValue,
                deprecationReason: argConfig.deprecationReason,
                extensions: argConfig.extensions && (0, $eCJ4z.default)(argConfig.extensions),
                astNode: argConfig.astNode
            };
        });
    }
    var _proto = GraphQLDirective.prototype;
    _proto.toConfig = function toConfig() {
        return {
            name: this.name,
            description: this.description,
            locations: this.locations,
            args: (0, $lXoEQ.argsToArgsConfig)(this.args),
            isRepeatable: this.isRepeatable,
            extensions: this.extensions,
            astNode: this.astNode
        };
    };
    _proto.toString = function toString() {
        return '@' + this.name;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $68b3a31c3f813eb2$var$_createClass(GraphQLDirective, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLDirective';
            }
        }
    ]);
    return GraphQLDirective;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($68b3a31c3f813eb2$export$90407e48aac654e9);
var $68b3a31c3f813eb2$export$f92fb5dbf075dbee = new $68b3a31c3f813eb2$export$90407e48aac654e9({
    name: 'include',
    description: 'Directs the executor to include this field or fragment only when the `if` argument is true.',
    locations: [
        (0, $5hGV7.DirectiveLocation).FIELD,
        (0, $5hGV7.DirectiveLocation).FRAGMENT_SPREAD,
        (0, $5hGV7.DirectiveLocation).INLINE_FRAGMENT
    ],
    args: {
        if: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
            description: 'Included when true.'
        }
    }
});
var $68b3a31c3f813eb2$export$7adbe9be7084cfe3 = new $68b3a31c3f813eb2$export$90407e48aac654e9({
    name: 'skip',
    description: 'Directs the executor to skip this field or fragment when the `if` argument is true.',
    locations: [
        (0, $5hGV7.DirectiveLocation).FIELD,
        (0, $5hGV7.DirectiveLocation).FRAGMENT_SPREAD,
        (0, $5hGV7.DirectiveLocation).INLINE_FRAGMENT
    ],
    args: {
        if: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
            description: 'Skipped when true.'
        }
    }
});
var $68b3a31c3f813eb2$export$15edbda76f1f9a89 = 'No longer supported';
var $68b3a31c3f813eb2$export$ed64f8040ac801d1 = new $68b3a31c3f813eb2$export$90407e48aac654e9({
    name: 'deprecated',
    description: 'Marks an element of a GraphQL schema as no longer supported.',
    locations: [
        (0, $5hGV7.DirectiveLocation).FIELD_DEFINITION,
        (0, $5hGV7.DirectiveLocation).ARGUMENT_DEFINITION,
        (0, $5hGV7.DirectiveLocation).INPUT_FIELD_DEFINITION,
        (0, $5hGV7.DirectiveLocation).ENUM_VALUE
    ],
    args: {
        reason: {
            type: (0, $auu22.GraphQLString),
            description: 'Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).',
            defaultValue: $68b3a31c3f813eb2$export$15edbda76f1f9a89
        }
    }
});
var $68b3a31c3f813eb2$export$26ce3cf10bb75d41 = new $68b3a31c3f813eb2$export$90407e48aac654e9({
    name: 'specifiedBy',
    description: 'Exposes a URL that specifies the behaviour of this scalar.',
    locations: [
        (0, $5hGV7.DirectiveLocation).SCALAR
    ],
    args: {
        url: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
            description: 'The URL that specifies the behaviour of this scalar.'
        }
    }
});
var $68b3a31c3f813eb2$export$c48d2e3f4e034403 = Object.freeze([
    $68b3a31c3f813eb2$export$f92fb5dbf075dbee,
    $68b3a31c3f813eb2$export$7adbe9be7084cfe3,
    $68b3a31c3f813eb2$export$ed64f8040ac801d1,
    $68b3a31c3f813eb2$export$26ce3cf10bb75d41
]);
function $68b3a31c3f813eb2$export$7d2e48434602f4fe(directive) {
    return $68b3a31c3f813eb2$export$c48d2e3f4e034403.some(function(_ref2) {
        var name = _ref2.name;
        return name === directive.name;
    });
}

});



parcelRegister("3zSAT", function(module, exports) {

$parcel$export(module.exports, "typeFromAST", () => $a77d3e2f56140695$export$292685f75a322892);

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $1c4hI = parcelRequire("1c4hI");

var $lXoEQ = parcelRequire("lXoEQ");
function $a77d3e2f56140695$export$292685f75a322892(schema, typeNode) {
    /* eslint-enable no-redeclare */ var innerType;
    if (typeNode.kind === (0, $1c4hI.Kind).LIST_TYPE) {
        innerType = $a77d3e2f56140695$export$292685f75a322892(schema, typeNode.type);
        return innerType && new (0, $lXoEQ.GraphQLList)(innerType);
    }
    if (typeNode.kind === (0, $1c4hI.Kind).NON_NULL_TYPE) {
        innerType = $a77d3e2f56140695$export$292685f75a322892(schema, typeNode.type);
        return innerType && new (0, $lXoEQ.GraphQLNonNull)(innerType);
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if (typeNode.kind === (0, $1c4hI.Kind).NAMED_TYPE) return schema.getType(typeNode.name.value);
     // istanbul ignore next (Not reachable. All possible type nodes have been considered)
    (0, $43MJl.default)(0, 'Unexpected type node: ' + (0, $biK02.default)(typeNode));
}

});

parcelRegister("bis9F", function(module, exports) {

$parcel$export(module.exports, "getOperationRootType", () => $508b1182b247a60e$export$f5bcbf8a32f314e5);

var $9fgMZ = parcelRequire("9fgMZ");
function $508b1182b247a60e$export$f5bcbf8a32f314e5(schema, operation) {
    if (operation.operation === 'query') {
        var queryType = schema.getQueryType();
        if (!queryType) throw new (0, $9fgMZ.GraphQLError)('Schema does not define the required query root type.', operation);
        return queryType;
    }
    if (operation.operation === 'mutation') {
        var mutationType = schema.getMutationType();
        if (!mutationType) throw new (0, $9fgMZ.GraphQLError)('Schema is not configured for mutations.', operation);
        return mutationType;
    }
    if (operation.operation === 'subscription') {
        var subscriptionType = schema.getSubscriptionType();
        if (!subscriptionType) throw new (0, $9fgMZ.GraphQLError)('Schema is not configured for subscriptions.', operation);
        return subscriptionType;
    }
    throw new (0, $9fgMZ.GraphQLError)('Can only have query, mutation and subscription operations.', operation);
}

});

parcelRegister("gqGQB", function(module, exports) {

$parcel$export(module.exports, "getVariableValues", () => $b695b1e556e9787e$export$2038fbf5c9bccf57);
$parcel$export(module.exports, "getArgumentValues", () => $b695b1e556e9787e$export$5af04a8495f7ef54);
$parcel$export(module.exports, "getDirectiveValues", () => $b695b1e556e9787e$export$1f7174681493b2aa);

var $bmIpK = parcelRequire("bmIpK");

var $hbiEd = parcelRequire("hbiEd");

var $biK02 = parcelRequire("biK02");

var $laAus = parcelRequire("laAus");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");

var $3E0nn = parcelRequire("3E0nn");

var $dEek8 = parcelRequire("dEek8");
function $b695b1e556e9787e$export$2038fbf5c9bccf57(schema, varDefNodes, inputs, options) {
    var errors = [];
    var maxErrors = options === null || options === void 0 ? void 0 : options.maxErrors;
    try {
        var coerced = $b695b1e556e9787e$var$coerceVariableValues(schema, varDefNodes, inputs, function(error) {
            if (maxErrors != null && errors.length >= maxErrors) throw new (0, $9fgMZ.GraphQLError)('Too many errors processing variables, error limit reached. Execution aborted.');
            errors.push(error);
        });
        if (errors.length === 0) return {
            coerced: coerced
        };
    } catch (error) {
        errors.push(error);
    }
    return {
        errors: errors
    };
}
function $b695b1e556e9787e$var$coerceVariableValues(schema, varDefNodes, inputs, onError) {
    var coercedValues = {};
    var _loop = function _loop(_i2) {
        var varDefNode = varDefNodes[_i2];
        var varName = varDefNode.variable.name.value;
        var varType = (0, $3zSAT.typeFromAST)(schema, varDefNode.type);
        if (!(0, $lXoEQ.isInputType)(varType)) {
            // Must use input types for variables. This should be caught during
            // validation, however is checked again here for safety.
            var varTypeStr = (0, $aKlnM.print)(varDefNode.type);
            onError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(varName, "\" expected value of type \"").concat(varTypeStr, "\" which cannot be used as an input type."), varDefNode.type));
            return "continue";
        }
        if (!$b695b1e556e9787e$var$hasOwnProperty(inputs, varName)) {
            if (varDefNode.defaultValue) coercedValues[varName] = (0, $3E0nn.valueFromAST)(varDefNode.defaultValue, varType);
            else if ((0, $lXoEQ.isNonNullType)(varType)) {
                var _varTypeStr = (0, $biK02.default)(varType);
                onError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(varName, "\" of required type \"").concat(_varTypeStr, "\" was not provided."), varDefNode));
            }
            return "continue";
        }
        var value = inputs[varName];
        if (value === null && (0, $lXoEQ.isNonNullType)(varType)) {
            var _varTypeStr2 = (0, $biK02.default)(varType);
            onError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(varName, "\" of non-null type \"").concat(_varTypeStr2, "\" must not be null."), varDefNode));
            return "continue";
        }
        coercedValues[varName] = (0, $dEek8.coerceInputValue)(value, varType, function(path, invalidValue, error) {
            var prefix = "Variable \"$".concat(varName, "\" got invalid value ") + (0, $biK02.default)(invalidValue);
            if (path.length > 0) prefix += " at \"".concat(varName).concat((0, $laAus.default)(path), "\"");
            onError(new (0, $9fgMZ.GraphQLError)(prefix + '; ' + error.message, varDefNode, undefined, undefined, undefined, error.originalError));
        });
    };
    for(var _i2 = 0; _i2 < varDefNodes.length; _i2++){
        var _ret = _loop(_i2);
        if (_ret === "continue") continue;
    }
    return coercedValues;
}
function $b695b1e556e9787e$export$5af04a8495f7ef54(def, node, variableValues) {
    var _node$arguments;
    var coercedValues = {}; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    var argumentNodes = (_node$arguments = node.arguments) !== null && _node$arguments !== void 0 ? _node$arguments : [];
    var argNodeMap = (0, $hbiEd.default)(argumentNodes, function(arg) {
        return arg.name.value;
    });
    for(var _i4 = 0, _def$args2 = def.args; _i4 < _def$args2.length; _i4++){
        var argDef = _def$args2[_i4];
        var name = argDef.name;
        var argType = argDef.type;
        var argumentNode = argNodeMap[name];
        if (!argumentNode) {
            if (argDef.defaultValue !== undefined) coercedValues[name] = argDef.defaultValue;
            else if ((0, $lXoEQ.isNonNullType)(argType)) throw new (0, $9fgMZ.GraphQLError)("Argument \"".concat(name, "\" of required type \"").concat((0, $biK02.default)(argType), "\" ") + 'was not provided.', node);
            continue;
        }
        var valueNode = argumentNode.value;
        var isNull = valueNode.kind === (0, $1c4hI.Kind).NULL;
        if (valueNode.kind === (0, $1c4hI.Kind).VARIABLE) {
            var variableName = valueNode.name.value;
            if (variableValues == null || !$b695b1e556e9787e$var$hasOwnProperty(variableValues, variableName)) {
                if (argDef.defaultValue !== undefined) coercedValues[name] = argDef.defaultValue;
                else if ((0, $lXoEQ.isNonNullType)(argType)) throw new (0, $9fgMZ.GraphQLError)("Argument \"".concat(name, "\" of required type \"").concat((0, $biK02.default)(argType), "\" ") + "was provided the variable \"$".concat(variableName, "\" which was not provided a runtime value."), valueNode);
                continue;
            }
            isNull = variableValues[variableName] == null;
        }
        if (isNull && (0, $lXoEQ.isNonNullType)(argType)) throw new (0, $9fgMZ.GraphQLError)("Argument \"".concat(name, "\" of non-null type \"").concat((0, $biK02.default)(argType), "\" ") + 'must not be null.', valueNode);
        var coercedValue = (0, $3E0nn.valueFromAST)(valueNode, argType, variableValues);
        if (coercedValue === undefined) // Note: ValuesOfCorrectTypeRule validation should catch this before
        // execution. This is a runtime check to ensure execution does not
        // continue with an invalid argument value.
        throw new (0, $9fgMZ.GraphQLError)("Argument \"".concat(name, "\" has invalid value ").concat((0, $aKlnM.print)(valueNode), "."), valueNode);
        coercedValues[name] = coercedValue;
    }
    return coercedValues;
}
function $b695b1e556e9787e$export$1f7174681493b2aa(directiveDef, node, variableValues) {
    var directiveNode = node.directives && (0, $bmIpK.default)(node.directives, function(directive) {
        return directive.name.value === directiveDef.name;
    });
    if (directiveNode) return $b695b1e556e9787e$export$5af04a8495f7ef54(directiveDef, directiveNode, variableValues);
}
function $b695b1e556e9787e$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});
parcelRegister("laAus", function(module, exports) {

$parcel$export(module.exports, "default", () => $227415a0e63f15f5$export$2e2bcd8739ae039);
/**
 * Build a string describing the path.
 */ function $227415a0e63f15f5$export$2e2bcd8739ae039(path) {
    return path.map(function(key) {
        return typeof key === 'number' ? '[' + key.toString() + ']' : '.' + key;
    }).join('');
}

});

parcelRegister("3E0nn", function(module, exports) {

$parcel$export(module.exports, "valueFromAST", () => $d700774db2a0232b$export$d32bfdfcfbe60e55);

var $dVq2R = parcelRequire("dVq2R");

var $hbiEd = parcelRequire("hbiEd");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $1c4hI = parcelRequire("1c4hI");

var $lXoEQ = parcelRequire("lXoEQ");
function $d700774db2a0232b$export$d32bfdfcfbe60e55(valueNode, type, variables) {
    if (!valueNode) // When there is no node, then there is also no value.
    // Importantly, this is different from returning the value null.
    return;
    if (valueNode.kind === (0, $1c4hI.Kind).VARIABLE) {
        var variableName = valueNode.name.value;
        if (variables == null || variables[variableName] === undefined) // No valid return value.
        return;
        var variableValue = variables[variableName];
        if (variableValue === null && (0, $lXoEQ.isNonNullType)(type)) return; // Invalid: intentionally return no value.
         // Note: This does no further checking that this variable is correct.
        // This assumes that this query has been validated and the variable
        // usage here is of the correct type.
        return variableValue;
    }
    if ((0, $lXoEQ.isNonNullType)(type)) {
        if (valueNode.kind === (0, $1c4hI.Kind).NULL) return; // Invalid: intentionally return no value.
        return $d700774db2a0232b$export$d32bfdfcfbe60e55(valueNode, type.ofType, variables);
    }
    if (valueNode.kind === (0, $1c4hI.Kind).NULL) // This is explicitly returning the value null.
    return null;
    if ((0, $lXoEQ.isListType)(type)) {
        var itemType = type.ofType;
        if (valueNode.kind === (0, $1c4hI.Kind).LIST) {
            var coercedValues = [];
            for(var _i2 = 0, _valueNode$values2 = valueNode.values; _i2 < _valueNode$values2.length; _i2++){
                var itemNode = _valueNode$values2[_i2];
                if ($d700774db2a0232b$var$isMissingVariable(itemNode, variables)) {
                    // If an array contains a missing variable, it is either coerced to
                    // null or if the item type is non-null, it considered invalid.
                    if ((0, $lXoEQ.isNonNullType)(itemType)) return; // Invalid: intentionally return no value.
                    coercedValues.push(null);
                } else {
                    var itemValue = $d700774db2a0232b$export$d32bfdfcfbe60e55(itemNode, itemType, variables);
                    if (itemValue === undefined) return; // Invalid: intentionally return no value.
                    coercedValues.push(itemValue);
                }
            }
            return coercedValues;
        }
        var coercedValue = $d700774db2a0232b$export$d32bfdfcfbe60e55(valueNode, itemType, variables);
        if (coercedValue === undefined) return; // Invalid: intentionally return no value.
        return [
            coercedValue
        ];
    }
    if ((0, $lXoEQ.isInputObjectType)(type)) {
        if (valueNode.kind !== (0, $1c4hI.Kind).OBJECT) return; // Invalid: intentionally return no value.
        var coercedObj = Object.create(null);
        var fieldNodes = (0, $hbiEd.default)(valueNode.fields, function(field) {
            return field.name.value;
        });
        for(var _i4 = 0, _objectValues2 = (0, $dVq2R.default)(type.getFields()); _i4 < _objectValues2.length; _i4++){
            var field = _objectValues2[_i4];
            var fieldNode = fieldNodes[field.name];
            if (!fieldNode || $d700774db2a0232b$var$isMissingVariable(fieldNode.value, variables)) {
                if (field.defaultValue !== undefined) coercedObj[field.name] = field.defaultValue;
                else if ((0, $lXoEQ.isNonNullType)(field.type)) return; // Invalid: intentionally return no value.
                continue;
            }
            var fieldValue = $d700774db2a0232b$export$d32bfdfcfbe60e55(fieldNode.value, field.type, variables);
            if (fieldValue === undefined) return; // Invalid: intentionally return no value.
            coercedObj[field.name] = fieldValue;
        }
        return coercedObj;
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isLeafType)(type)) {
        // Scalars and Enums fulfill parsing a literal value via parseLiteral().
        // Invalid values represent a failure to parse correctly, in which case
        // no value is returned.
        var result;
        try {
            result = type.parseLiteral(valueNode, variables);
        } catch (_error) {
            return; // Invalid: intentionally return no value.
        }
        if (result === undefined) return; // Invalid: intentionally return no value.
        return result;
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, $43MJl.default)(0, 'Unexpected input type: ' + (0, $biK02.default)(type));
} // Returns true if the provided valueNode is a variable which is not defined
// in the set of variables.
function $d700774db2a0232b$var$isMissingVariable(valueNode, variables) {
    return valueNode.kind === (0, $1c4hI.Kind).VARIABLE && (variables == null || variables[valueNode.name.value] === undefined);
}

});

parcelRegister("dEek8", function(module, exports) {

$parcel$export(module.exports, "coerceInputValue", () => $6618e9631598014d$export$7964ec791f1fa3f1);

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $8nBnZ = parcelRequire("8nBnZ");

var $fbtyx = parcelRequire("fbtyx");

var $8DMvn = parcelRequire("8DMvn");

var $bru1k = parcelRequire("bru1k");

var $laAus = parcelRequire("laAus");

var $kZHaf = parcelRequire("kZHaf");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $6618e9631598014d$export$7964ec791f1fa3f1(inputValue, type) {
    var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $6618e9631598014d$var$defaultOnError;
    return $6618e9631598014d$var$coerceInputValueImpl(inputValue, type, onError);
}
function $6618e9631598014d$var$defaultOnError(path, invalidValue, error) {
    var errorPrefix = 'Invalid value ' + (0, $biK02.default)(invalidValue);
    if (path.length > 0) errorPrefix += " at \"value".concat((0, $laAus.default)(path), "\"");
    error.message = errorPrefix + ': ' + error.message;
    throw error;
}
function $6618e9631598014d$var$coerceInputValueImpl(inputValue, type, onError, path) {
    if ((0, $lXoEQ.isNonNullType)(type)) {
        if (inputValue != null) return $6618e9631598014d$var$coerceInputValueImpl(inputValue, type.ofType, onError, path);
        onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Expected non-nullable type \"".concat((0, $biK02.default)(type), "\" not to be null.")));
        return;
    }
    if (inputValue == null) // Explicitly return the value null.
    return null;
    if ((0, $lXoEQ.isListType)(type)) {
        var itemType = type.ofType;
        var coercedList = (0, $8DMvn.default)(inputValue, function(itemValue, index) {
            var itemPath = (0, $kZHaf.addPath)(path, index, undefined);
            return $6618e9631598014d$var$coerceInputValueImpl(itemValue, itemType, onError, itemPath);
        });
        if (coercedList != null) return coercedList;
         // Lists accept a non-list value as a list of one.
        return [
            $6618e9631598014d$var$coerceInputValueImpl(inputValue, itemType, onError, path)
        ];
    }
    if ((0, $lXoEQ.isInputObjectType)(type)) {
        if (!(0, $fbtyx.default)(inputValue)) {
            onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Expected type \"".concat(type.name, "\" to be an object.")));
            return;
        }
        var coercedValue = {};
        var fieldDefs = type.getFields();
        for(var _i2 = 0, _objectValues2 = (0, $dVq2R.default)(fieldDefs); _i2 < _objectValues2.length; _i2++){
            var field = _objectValues2[_i2];
            var fieldValue = inputValue[field.name];
            if (fieldValue === undefined) {
                if (field.defaultValue !== undefined) coercedValue[field.name] = field.defaultValue;
                else if ((0, $lXoEQ.isNonNullType)(field.type)) {
                    var typeStr = (0, $biK02.default)(field.type);
                    onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Field \"".concat(field.name, "\" of required type \"").concat(typeStr, "\" was not provided.")));
                }
                continue;
            }
            coercedValue[field.name] = $6618e9631598014d$var$coerceInputValueImpl(fieldValue, field.type, onError, (0, $kZHaf.addPath)(path, field.name, type.name));
        } // Ensure every provided field is defined.
        for(var _i4 = 0, _Object$keys2 = Object.keys(inputValue); _i4 < _Object$keys2.length; _i4++){
            var fieldName = _Object$keys2[_i4];
            if (!fieldDefs[fieldName]) {
                var suggestions = (0, $bru1k.default)(fieldName, Object.keys(type.getFields()));
                onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Field \"".concat(fieldName, "\" is not defined by type \"").concat(type.name, "\".") + (0, $8nBnZ.default)(suggestions)));
            }
        }
        return coercedValue;
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isLeafType)(type)) {
        var parseResult; // Scalars and Enums determine if a input value is valid via parseValue(),
        // which can throw to indicate failure. If it throws, maintain a reference
        // to the original error.
        try {
            parseResult = type.parseValue(inputValue);
        } catch (error) {
            if (error instanceof (0, $9fgMZ.GraphQLError)) onError((0, $kZHaf.pathToArray)(path), inputValue, error);
            else onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Expected type \"".concat(type.name, "\". ") + error.message, undefined, undefined, undefined, undefined, error));
            return;
        }
        if (parseResult === undefined) onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Expected type \"".concat(type.name, "\".")));
        return parseResult;
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, $43MJl.default)(0, 'Unexpected input type: ' + (0, $biK02.default)(type));
}

});




parcelRegister("aAMCg", function(module, exports) {
function $7b62fa5a6bcf3d57$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7b62fa5a6bcf3d57$var$__export((parcelRequire("crrCr")));

$7b62fa5a6bcf3d57$var$__export((parcelRequire("hbdmQ")));

$7b62fa5a6bcf3d57$var$__export((parcelRequire("akAyp")));

$7b62fa5a6bcf3d57$var$__export((parcelRequire("16dWW")));

var $gVW6u = parcelRequire("gVW6u");
module.exports.SchemaDirectiveVisitor = $gVW6u.SchemaDirectiveVisitor;

});
parcelRegister("crrCr", function(module, exports) {
function $90ed6e3aead06406$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");

var $gVW6u = parcelRequire("gVW6u");

var $b3EaX = parcelRequire("b3EaX");

function $90ed6e3aead06406$var$makeExecutableSchema(_a) {
    var typeDefs = _a.typeDefs, _b = _a.resolvers, resolvers = _b === void 0 ? {} : _b, connectors = _a.connectors, logger = _a.logger, _c = _a.allowUndefinedInResolve, allowUndefinedInResolve = _c === void 0 ? true : _c, _d = _a.resolverValidationOptions, resolverValidationOptions = _d === void 0 ? {} : _d, _e = _a.directiveResolvers, directiveResolvers = _e === void 0 ? null : _e, _f = _a.schemaDirectives, schemaDirectives = _f === void 0 ? null : _f, _g = _a.parseOptions, parseOptions = _g === void 0 ? {} : _g, _h = _a.inheritResolversFromInterfaces, inheritResolversFromInterfaces = _h === void 0 ? false : _h;
    // Validate and clean up arguments
    if (typeof resolverValidationOptions !== 'object') throw new (parcelRequire("cYGSS")).SchemaError('Expected `resolverValidationOptions` to be an object');
    if (!typeDefs) throw new (parcelRequire("cYGSS")).SchemaError('Must provide typeDefs');
    if (!resolvers) throw new (parcelRequire("cYGSS")).SchemaError('Must provide resolvers');
    // We allow passing in an array of resolver maps, in which case we merge them
    var resolverMap = Array.isArray(resolvers) ? resolvers.filter(function(resolverObj) {
        return typeof resolverObj === 'object';
    }).reduce($b3EaX.default, {}) : resolvers;
    // Arguments are now validated and cleaned up
    var schema = (parcelRequire("cYGSS")).buildSchemaFromTypeDefinitions(typeDefs, parseOptions);
    schema = (parcelRequire("cYGSS")).addResolveFunctionsToSchema({
        schema: schema,
        resolvers: resolverMap,
        resolverValidationOptions: resolverValidationOptions,
        inheritResolversFromInterfaces: inheritResolversFromInterfaces
    });
    (parcelRequire("cYGSS")).assertResolveFunctionsPresent(schema, resolverValidationOptions);
    if (!allowUndefinedInResolve) $90ed6e3aead06406$var$addCatchUndefinedToSchema(schema);
    if (logger) $90ed6e3aead06406$var$addErrorLoggingToSchema(schema, logger);
    if (typeof resolvers['__schema'] === 'function') // TODO a bit of a hack now, better rewrite generateSchema to attach it there.
    // not doing that now, because I'd have to rewrite a lot of tests.
    (parcelRequire("cYGSS")).addSchemaLevelResolveFunction(schema, resolvers['__schema']);
    if (connectors) // connectors are optional, at least for now. That means you can just import them in the resolve
    // function if you want.
    (parcelRequire("cYGSS")).attachConnectorsToContext(schema, connectors);
    if (directiveResolvers) (parcelRequire("cYGSS")).attachDirectiveResolvers(schema, directiveResolvers);
    if (schemaDirectives) $gVW6u.SchemaDirectiveVisitor.visitSchemaDirectives(schema, schemaDirectives);
    return schema;
}
module.exports.makeExecutableSchema = $90ed6e3aead06406$var$makeExecutableSchema;
function $90ed6e3aead06406$var$decorateToCatchUndefined(fn, hint) {
    if (typeof fn === 'undefined') fn = $3MP74.defaultFieldResolver;
    return function(root, args, ctx, info) {
        var result = fn(root, args, ctx, info);
        if (typeof result === 'undefined') throw new Error("Resolve function for \"" + hint + "\" returned undefined");
        return result;
    };
}
function $90ed6e3aead06406$var$addCatchUndefinedToSchema(schema) {
    (parcelRequire("cYGSS")).forEachField(schema, function(field, typeName, fieldName) {
        var errorHint = typeName + "." + fieldName;
        field.resolve = $90ed6e3aead06406$var$decorateToCatchUndefined(field.resolve, errorHint);
    });
}
module.exports.addCatchUndefinedToSchema = $90ed6e3aead06406$var$addCatchUndefinedToSchema;
function $90ed6e3aead06406$var$addErrorLoggingToSchema(schema, logger) {
    if (!logger) throw new Error('Must provide a logger');
    if (typeof logger.log !== 'function') throw new Error('Logger.log must be a function');
    (parcelRequire("cYGSS")).forEachField(schema, function(field, typeName, fieldName) {
        var errorHint = typeName + "." + fieldName;
        field.resolve = (parcelRequire("cYGSS")).decorateWithLogger(field.resolve, logger, errorHint);
    });
}
module.exports.addErrorLoggingToSchema = $90ed6e3aead06406$var$addErrorLoggingToSchema;

$90ed6e3aead06406$var$__export((parcelRequire("cYGSS")));

});
parcelRegister("gVW6u", function(module, exports) {
var $c53f0a6913fad0c1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c53f0a6913fad0c1$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $6BdRO = parcelRequire("6BdRO");
var $1c4hI = parcelRequire("1c4hI");

var $gqGQB = parcelRequire("gqGQB");
var $c53f0a6913fad0c1$var$hasOwn = Object.prototype.hasOwnProperty;
// Abstract base class of any visitor implementation, defining the available
// visitor methods along with their parameter types, and providing a static
// helper function for determining whether a subclass implements a given
// visitor method, as opposed to inheriting one of the stubs defined here.
var $c53f0a6913fad0c1$var$SchemaVisitor = /** @class */ function() {
    function SchemaVisitor() {}
    // Determine if this SchemaVisitor (sub)class implements a particular
    // visitor method.
    SchemaVisitor.implementsVisitorMethod = function(methodName) {
        if (!methodName.startsWith('visit')) return false;
        var method = this.prototype[methodName];
        if (typeof method !== 'function') return false;
        if (this === SchemaVisitor) // The SchemaVisitor class implements every visitor method.
        return true;
        var stub = SchemaVisitor.prototype[methodName];
        if (method === stub) // If this.prototype[methodName] was just inherited from SchemaVisitor,
        // then this class does not really implement the method.
        return false;
        return true;
    };
    // Concrete subclasses of SchemaVisitor should override one or more of these
    // visitor methods, in order to express their interest in handling certain
    // schema types/locations. Each method may return null to remove the given
    // type from the schema, a non-null value of the same type to update the
    // type in the schema, or nothing to leave the type as it was.
    /* tslint:disable:no-empty */ SchemaVisitor.prototype.visitSchema = function(schema) {};
    SchemaVisitor.prototype.visitScalar = function(scalar) {};
    SchemaVisitor.prototype.visitObject = function(object) {};
    SchemaVisitor.prototype.visitFieldDefinition = function(field, details) {};
    SchemaVisitor.prototype.visitArgumentDefinition = function(argument, details) {};
    SchemaVisitor.prototype.visitInterface = function(iface) {};
    SchemaVisitor.prototype.visitUnion = function(union) {};
    SchemaVisitor.prototype.visitEnum = function(type) {};
    SchemaVisitor.prototype.visitEnumValue = function(value, details) {};
    SchemaVisitor.prototype.visitInputObject = function(object) {};
    SchemaVisitor.prototype.visitInputFieldDefinition = function(field, details) {};
    return SchemaVisitor;
}();
module.exports.SchemaVisitor = $c53f0a6913fad0c1$var$SchemaVisitor;
// Generic function for visiting GraphQLSchema objects.
function $c53f0a6913fad0c1$var$visitSchema(schema, // To accommodate as many different visitor patterns as possible, the
// visitSchema function does not simply accept a single instance of the
// SchemaVisitor class, but instead accepts a function that takes the
// current VisitableSchemaType object and the name of a visitor method and
// returns an array of SchemaVisitor instances that implement the visitor
// method and have an interest in handling the given VisitableSchemaType
// object. In the simplest case, this function can always return an array
// containing a single visitor object, without even looking at the type or
// methodName parameters. In other cases, this function might sometimes
// return an empty array to indicate there are no visitors that should be
// applied to the given VisitableSchemaType object. For an example of a
// visitor pattern that benefits from this abstraction, see the
// SchemaDirectiveVisitor class below.
visitorSelector) {
    // Helper function that calls visitorSelector and applies the resulting
    // visitors to the given type, with arguments [type, ...args].
    function callMethod(methodName, type) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        visitorSelector(type, methodName).every(function(visitor) {
            var newType = visitor[methodName].apply(visitor, $c53f0a6913fad0c1$var$__spreadArrays([
                type
            ], args));
            if (typeof newType === 'undefined') // Keep going without modifying type.
            return true;
            if (methodName === 'visitSchema' || type instanceof $6BdRO.GraphQLSchema) throw new Error("Method " + methodName + " cannot replace schema with " + newType);
            if (newType === null) {
                // Stop the loop and return null form callMethod, which will cause
                // the type to be removed from the schema.
                type = null;
                return false;
            }
            // Update type to the new type returned by the visitor method, so that
            // later directives will see the new type, and callMethod will return
            // the final type.
            type = newType;
            return true;
        });
        // If there were no directives for this type object, or if all visitor
        // methods returned nothing, type will be returned unmodified.
        return type;
    }
    // Recursive helper function that calls any appropriate visitor methods for
    // each object in the schema, then traverses the object's children (if any).
    function visit(type) {
        if (type instanceof $6BdRO.GraphQLSchema) {
            // Unlike the other types, the root GraphQLSchema object cannot be
            // replaced by visitor methods, because that would make life very hard
            // for SchemaVisitor subclasses that rely on the original schema object.
            callMethod('visitSchema', type);
            $c53f0a6913fad0c1$var$updateEachKey(type.getTypeMap(), function(namedType, typeName) {
                if (!typeName.startsWith('__')) // Call visit recursively to let it determine which concrete
                // subclass of GraphQLNamedType we found in the type map. Because
                // we're using updateEachKey, the result of visit(namedType) may
                // cause the type to be removed or replaced.
                return visit(namedType);
            });
            return type;
        }
        if (type instanceof $lXoEQ.GraphQLObjectType) {
            // Note that callMethod('visitObject', type) may not actually call any
            // methods, if there are no @directive annotations associated with this
            // type, or if this SchemaDirectiveVisitor subclass does not override
            // the visitObject method.
            var newObject = callMethod('visitObject', type);
            if (newObject) visitFields(newObject);
            return newObject;
        }
        if (type instanceof $lXoEQ.GraphQLInterfaceType) {
            var newInterface = callMethod('visitInterface', type);
            if (newInterface) visitFields(newInterface);
            return newInterface;
        }
        if (type instanceof $lXoEQ.GraphQLInputObjectType) {
            var newInputObject_1 = callMethod('visitInputObject', type);
            if (newInputObject_1) $c53f0a6913fad0c1$var$updateEachKey(newInputObject_1.getFields(), function(field) {
                // Since we call a different method for input object fields, we
                // can't reuse the visitFields function here.
                return callMethod('visitInputFieldDefinition', field, {
                    objectType: newInputObject_1
                });
            });
            return newInputObject_1;
        }
        if (type instanceof $lXoEQ.GraphQLScalarType) return callMethod('visitScalar', type);
        if (type instanceof $lXoEQ.GraphQLUnionType) return callMethod('visitUnion', type);
        if (type instanceof $lXoEQ.GraphQLEnumType) {
            var newEnum_1 = callMethod('visitEnum', type);
            if (newEnum_1) $c53f0a6913fad0c1$var$updateEachKey(newEnum_1.getValues(), function(value) {
                return callMethod('visitEnumValue', value, {
                    enumType: newEnum_1
                });
            });
            return newEnum_1;
        }
        throw new Error("Unexpected schema type: " + type);
    }
    function visitFields(type) {
        $c53f0a6913fad0c1$var$updateEachKey(type.getFields(), function(field) {
            // It would be nice if we could call visit(field) recursively here, but
            // GraphQLField is merely a type, not a value that can be detected using
            // an instanceof check, so we have to visit the fields in this lexical
            // context, so that TypeScript can validate the call to
            // visitFieldDefinition.
            var newField = callMethod('visitFieldDefinition', field, {
                // While any field visitor needs a reference to the field object, some
                // field visitors may also need to know the enclosing (parent) type,
                // perhaps to determine if the parent is a GraphQLObjectType or a
                // GraphQLInterfaceType. To obtain a reference to the parent, a
                // visitor method can have a second parameter, which will be an object
                // with an .objectType property referring to the parent.
                objectType: type
            });
            if (newField && newField.args) $c53f0a6913fad0c1$var$updateEachKey(newField.args, function(arg) {
                return callMethod('visitArgumentDefinition', arg, {
                    // Like visitFieldDefinition, visitArgumentDefinition takes a
                    // second parameter that provides additional context, namely the
                    // parent .field and grandparent .objectType. Remember that the
                    // current GraphQLSchema is always available via this.schema.
                    field: newField,
                    objectType: type
                });
            });
            return newField;
        });
    }
    visit(schema);
    // Return the original schema for convenience, even though it cannot have
    // been replaced or removed by the code above.
    return schema;
}
module.exports.visitSchema = $c53f0a6913fad0c1$var$visitSchema;
// Update any references to named schema types that disagree with the named
// types found in schema.getTypeMap().
function $c53f0a6913fad0c1$var$healSchema(schema) {
    heal(schema);
    return schema;
    function heal(type) {
        if (type instanceof $6BdRO.GraphQLSchema) {
            var originalTypeMap_1 = type.getTypeMap();
            var actualNamedTypeMap_1 = Object.create(null);
            // If any of the .name properties of the GraphQLNamedType objects in
            // schema.getTypeMap() have changed, the keys of the type map need to
            // be updated accordingly.
            $c53f0a6913fad0c1$var$each(originalTypeMap_1, function(namedType, typeName) {
                if (typeName.startsWith('__')) return;
                var actualName = namedType.name;
                if (actualName.startsWith('__')) return;
                if ($c53f0a6913fad0c1$var$hasOwn.call(actualNamedTypeMap_1, actualName)) throw new Error("Duplicate schema type name " + actualName);
                actualNamedTypeMap_1[actualName] = namedType;
            // Note: we are deliberately leaving namedType in the schema by its
            // original name (which might be different from actualName), so that
            // references by that name can be healed.
            });
            // Now add back every named type by its actual name.
            $c53f0a6913fad0c1$var$each(actualNamedTypeMap_1, function(namedType, typeName) {
                originalTypeMap_1[typeName] = namedType;
            });
            // Directive declaration argument types can refer to named types.
            $c53f0a6913fad0c1$var$each(type.getDirectives(), function(decl) {
                if (decl.args) $c53f0a6913fad0c1$var$each(decl.args, function(arg) {
                    arg.type = healType(arg.type);
                });
            });
            $c53f0a6913fad0c1$var$each(originalTypeMap_1, function(namedType, typeName) {
                if (!typeName.startsWith('__')) heal(namedType);
            });
            $c53f0a6913fad0c1$var$updateEachKey(originalTypeMap_1, function(namedType, typeName) {
                // Dangling references to renamed types should remain in the schema
                // during healing, but must be removed now, so that the following
                // invariant holds for all names: schema.getType(name).name === name
                if (!typeName.startsWith('__') && !$c53f0a6913fad0c1$var$hasOwn.call(actualNamedTypeMap_1, typeName)) return null;
            });
        } else if (type instanceof $lXoEQ.GraphQLObjectType) {
            healFields(type);
            $c53f0a6913fad0c1$var$each(type.getInterfaces(), function(iface) {
                return heal(iface);
            });
        } else if (type instanceof $lXoEQ.GraphQLInterfaceType) healFields(type);
        else if (type instanceof $lXoEQ.GraphQLInputObjectType) $c53f0a6913fad0c1$var$each(type.getFields(), function(field) {
            field.type = healType(field.type);
        });
        else if (type instanceof $lXoEQ.GraphQLScalarType) ;
        else if (type instanceof $lXoEQ.GraphQLUnionType) $c53f0a6913fad0c1$var$updateEachKey(type.getTypes(), function(t) {
            return healType(t);
        });
        else if (type instanceof $lXoEQ.GraphQLEnumType) ;
        else throw new Error("Unexpected schema type: " + type);
    }
    function healFields(type) {
        $c53f0a6913fad0c1$var$each(type.getFields(), function(field) {
            field.type = healType(field.type);
            if (field.args) $c53f0a6913fad0c1$var$each(field.args, function(arg) {
                arg.type = healType(arg.type);
            });
        });
    }
    function healType(type) {
        // Unwrap the two known wrapper types
        if (type instanceof $lXoEQ.GraphQLList) type = new $lXoEQ.GraphQLList(healType(type.ofType));
        else if (type instanceof $lXoEQ.GraphQLNonNull) type = new $lXoEQ.GraphQLNonNull(healType(type.ofType));
        else if ($lXoEQ.isNamedType(type)) {
            // If a type annotation on a field or an argument or a union member is
            // any `GraphQLNamedType` with a `name`, then it must end up identical
            // to `schema.getType(name)`, since `schema.getTypeMap()` is the source
            // of truth for all named schema types.
            var namedType = type;
            var officialType = schema.getType(namedType.name);
            if (officialType && namedType !== officialType) return officialType;
        }
        return type;
    }
}
module.exports.healSchema = $c53f0a6913fad0c1$var$healSchema;
// This class represents a reusable implementation of a @directive that may
// appear in a GraphQL schema written in Schema Definition Language.
//
// By overriding one or more visit{Object,Union,...} methods, a subclass
// registers interest in certain schema types, such as GraphQLObjectType,
// GraphQLUnionType, etc. When SchemaDirectiveVisitor.visitSchemaDirectives is
// called with a GraphQLSchema object and a map of visitor subclasses, the
// overidden methods of those subclasses allow the visitors to obtain
// references to any type objects that have @directives attached to them,
// enabling visitors to inspect or modify the schema as appropriate.
//
// For example, if a directive called @rest(url: "...") appears after a field
// definition, a SchemaDirectiveVisitor subclass could provide meaning to that
// directive by overriding the visitFieldDefinition method (which receives a
// GraphQLField parameter), and then the body of that visitor method could
// manipulate the field's resolver function to fetch data from a REST endpoint
// described by the url argument passed to the @rest directive:
//
//   const typeDefs = `
//   type Query {
//     people: [Person] @rest(url: "/api/v1/people")
//   }`;
//
//   const schema = makeExecutableSchema({ typeDefs });
//
//   SchemaDirectiveVisitor.visitSchemaDirectives(schema, {
//     rest: class extends SchemaDirectiveVisitor {
//       public visitFieldDefinition(field: GraphQLField<any, any>) {
//         const { url } = this.args;
//         field.resolve = () => fetch(url);
//       }
//     }
//   });
//
// The subclass in this example is defined as an anonymous class expression,
// for brevity. A truly reusable SchemaDirectiveVisitor would most likely be
// defined in a library using a named class declaration, and then exported for
// consumption by other modules and packages.
//
// See below for a complete list of overridable visitor methods, their
// parameter types, and more details about the properties exposed by instances
// of the SchemaDirectiveVisitor class.
var $c53f0a6913fad0c1$var$SchemaDirectiveVisitor = /** @class */ function(_super) {
    $c53f0a6913fad0c1$var$__extends(SchemaDirectiveVisitor, _super);
    // Mark the constructor protected to enforce passing SchemaDirectiveVisitor
    // subclasses (not instances) to visitSchemaDirectives.
    function SchemaDirectiveVisitor(config) {
        var _this = _super.call(this) || this;
        _this.name = config.name;
        _this.args = config.args;
        _this.visitedType = config.visitedType;
        _this.schema = config.schema;
        _this.context = config.context;
        return _this;
    }
    // Override this method to return a custom GraphQLDirective (or modify one
    // already present in the schema) to enforce argument types, provide default
    // argument values, or specify schema locations where this @directive may
    // appear. By default, any declaration found in the schema will be returned.
    SchemaDirectiveVisitor.getDirectiveDeclaration = function(directiveName, schema) {
        return schema.getDirective(directiveName);
    };
    // Call SchemaDirectiveVisitor.visitSchemaDirectives to visit every
    // @directive in the schema and create an appropriate SchemaDirectiveVisitor
    // instance to visit the object decorated by the @directive.
    SchemaDirectiveVisitor.visitSchemaDirectives = function(schema, directiveVisitors, // Optional context object that will be available to all visitor instances
    // via this.context. Defaults to an empty null-prototype object.
    context) {
        if (context === void 0) context = Object.create(null);
        // If the schema declares any directives for public consumption, record
        // them here so that we can properly coerce arguments when/if we encounter
        // an occurrence of the directive while walking the schema below.
        var declaredDirectives = this.getDeclaredDirectives(schema, directiveVisitors);
        // Map from directive names to lists of SchemaDirectiveVisitor instances
        // created while visiting the schema.
        var createdVisitors = Object.create(null);
        Object.keys(directiveVisitors).forEach(function(directiveName) {
            createdVisitors[directiveName] = [];
        });
        function visitorSelector(type, methodName) {
            var visitors = [];
            var directiveNodes = type.astNode && type.astNode.directives;
            if (!directiveNodes) return visitors;
            directiveNodes.forEach(function(directiveNode) {
                var directiveName = directiveNode.name.value;
                if (!$c53f0a6913fad0c1$var$hasOwn.call(directiveVisitors, directiveName)) return;
                var visitorClass = directiveVisitors[directiveName];
                // Avoid creating visitor objects if visitorClass does not override
                // the visitor method named by methodName.
                if (!visitorClass.implementsVisitorMethod(methodName)) return;
                var decl = declaredDirectives[directiveName];
                var args;
                if (decl) // If this directive was explicitly declared, use the declared
                // argument types (and any default values) to check, coerce, and/or
                // supply default values for the given arguments.
                args = $gqGQB.getArgumentValues(decl, directiveNode);
                else {
                    // If this directive was not explicitly declared, just convert the
                    // argument nodes to their corresponding JavaScript values.
                    args = Object.create(null);
                    directiveNode.arguments.forEach(function(arg) {
                        args[arg.name.value] = $c53f0a6913fad0c1$var$valueFromASTUntyped(arg.value);
                    });
                }
                // As foretold in comments near the top of the visitSchemaDirectives
                // method, this is where instances of the SchemaDirectiveVisitor class
                // get created and assigned names. While subclasses could override the
                // constructor method, the constructor is marked as protected, so
                // these are the only arguments that will ever be passed.
                visitors.push(new visitorClass({
                    name: directiveName,
                    args: args,
                    visitedType: type,
                    schema: schema,
                    context: context
                }));
            });
            if (visitors.length > 0) visitors.forEach(function(visitor) {
                createdVisitors[visitor.name].push(visitor);
            });
            return visitors;
        }
        $c53f0a6913fad0c1$var$visitSchema(schema, visitorSelector);
        // Automatically update any references to named schema types replaced
        // during the traversal, so implementors don't have to worry about that.
        $c53f0a6913fad0c1$var$healSchema(schema);
        return createdVisitors;
    };
    SchemaDirectiveVisitor.getDeclaredDirectives = function(schema, directiveVisitors) {
        var declaredDirectives = Object.create(null);
        $c53f0a6913fad0c1$var$each(schema.getDirectives(), function(decl) {
            declaredDirectives[decl.name] = decl;
        });
        // If the visitor subclass overrides getDirectiveDeclaration, and it
        // returns a non-null GraphQLDirective, use that instead of any directive
        // declared in the schema itself. Reasoning: if a SchemaDirectiveVisitor
        // goes to the trouble of implementing getDirectiveDeclaration, it should
        // be able to rely on that implementation.
        $c53f0a6913fad0c1$var$each(directiveVisitors, function(visitorClass, directiveName) {
            var decl = visitorClass.getDirectiveDeclaration(directiveName, schema);
            if (decl) declaredDirectives[directiveName] = decl;
        });
        $c53f0a6913fad0c1$var$each(declaredDirectives, function(decl, name) {
            if (!$c53f0a6913fad0c1$var$hasOwn.call(directiveVisitors, name)) // SchemaDirectiveVisitors.visitSchemaDirectives might be called
            // multiple times with partial directiveVisitors maps, so it's not
            // necessarily an error for directiveVisitors to be missing an
            // implementation of a directive that was declared in the schema.
            return;
            var visitorClass = directiveVisitors[name];
            $c53f0a6913fad0c1$var$each(decl.locations, function(loc) {
                var visitorMethodName = $c53f0a6913fad0c1$var$directiveLocationToVisitorMethodName(loc);
                if ($c53f0a6913fad0c1$var$SchemaVisitor.implementsVisitorMethod(visitorMethodName) && !visitorClass.implementsVisitorMethod(visitorMethodName)) // While visitor subclasses may implement extra visitor methods,
                // it's definitely a mistake if the GraphQLDirective declares itself
                // applicable to certain schema locations, and the visitor subclass
                // does not implement all the corresponding methods.
                throw new Error("SchemaDirectiveVisitor for @" + name + " must implement " + visitorMethodName + " method");
            });
        });
        return declaredDirectives;
    };
    return SchemaDirectiveVisitor;
}($c53f0a6913fad0c1$var$SchemaVisitor);
module.exports.SchemaDirectiveVisitor = $c53f0a6913fad0c1$var$SchemaDirectiveVisitor;
// Convert a string like "FIELD_DEFINITION" to "visitFieldDefinition".
function $c53f0a6913fad0c1$var$directiveLocationToVisitorMethodName(loc) {
    return 'visit' + loc.replace(/([^_]*)_?/g, function(wholeMatch, part) {
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    });
}
function $c53f0a6913fad0c1$var$each(arrayOrObject, callback) {
    Object.keys(arrayOrObject).forEach(function(key) {
        callback(arrayOrObject[key], key);
    });
}
// A more powerful version of each that has the ability to replace or remove
// array or object keys.
function $c53f0a6913fad0c1$var$updateEachKey(arrayOrObject, // The callback can return nothing to leave the key untouched, null to remove
// the key from the array or object, or a non-null V to replace the value.
callback) {
    var deletedCount = 0;
    Object.keys(arrayOrObject).forEach(function(key) {
        var result = callback(arrayOrObject[key], key);
        if (typeof result === 'undefined') return;
        if (result === null) {
            delete arrayOrObject[key];
            deletedCount++;
            return;
        }
        arrayOrObject[key] = result;
    });
    if (deletedCount > 0 && Array.isArray(arrayOrObject)) // Remove any holes from the array due to deleted elements.
    arrayOrObject.splice(0).forEach(function(elem) {
        arrayOrObject.push(elem);
    });
}
// Similar to the graphql-js function of the same name, slightly simplified:
// https://github.com/graphql/graphql-js/blob/master/src/utilities/valueFromASTUntyped.js
function $c53f0a6913fad0c1$var$valueFromASTUntyped(valueNode) {
    switch(valueNode.kind){
        case $1c4hI.Kind.NULL:
            return null;
        case $1c4hI.Kind.INT:
            return parseInt(valueNode.value, 10);
        case $1c4hI.Kind.FLOAT:
            return parseFloat(valueNode.value);
        case $1c4hI.Kind.STRING:
        case $1c4hI.Kind.ENUM:
        case $1c4hI.Kind.BOOLEAN:
            return valueNode.value;
        case $1c4hI.Kind.LIST:
            return valueNode.values.map($c53f0a6913fad0c1$var$valueFromASTUntyped);
        case $1c4hI.Kind.OBJECT:
            var obj_1 = Object.create(null);
            valueNode.fields.forEach(function(field) {
                obj_1[field.name.value] = $c53f0a6913fad0c1$var$valueFromASTUntyped(field.value);
            });
            return obj_1;
        /* istanbul ignore next */ default:
            throw new Error('Unexpected value kind: ' + valueNode.kind);
    }
}

});

parcelRegister("b3EaX", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $80cf239c99e32ce4$var$mergeDeep(target, source) {
    var output = Object.assign({}, target);
    if ($80cf239c99e32ce4$var$isObject(target) && $80cf239c99e32ce4$var$isObject(source)) Object.keys(source).forEach(function(key) {
        var _a, _b;
        if ($80cf239c99e32ce4$var$isObject(source[key])) {
            if (!(key in target)) Object.assign(output, (_a = {}, _a[key] = source[key], _a));
            else output[key] = $80cf239c99e32ce4$var$mergeDeep(target[key], source[key]);
        } else Object.assign(output, (_b = {}, _b[key] = source[key], _b));
    });
    return output;
}
module.exports.default = $80cf239c99e32ce4$var$mergeDeep;
function $80cf239c99e32ce4$var$isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}

});

parcelRegister("cYGSS", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gLRgj = parcelRequire("gLRgj");
module.exports.addResolveFunctionsToSchema = $gLRgj.default;

var $lQXQV = parcelRequire("lQXQV");
module.exports.addSchemaLevelResolveFunction = $lQXQV.default;

var $7ZqjT = parcelRequire("7ZqjT");
module.exports.assertResolveFunctionsPresent = $7ZqjT.default;

var $glxQ5 = parcelRequire("glxQ5");
module.exports.attachDirectiveResolvers = $glxQ5.default;

var $4Vy0J = parcelRequire("4Vy0J");
module.exports.attachConnectorsToContext = $4Vy0J.default;

var $kYZ7H = parcelRequire("kYZ7H");
module.exports.buildSchemaFromTypeDefinitions = $kYZ7H.default;

var $zi3Qo = parcelRequire("zi3Qo");
module.exports.chainResolvers = $zi3Qo.chainResolvers;

var $3zHIx = parcelRequire("3zHIx");
module.exports.checkForResolveTypeResolver = $3zHIx.default;

var $fzT6r = parcelRequire("fzT6r");
module.exports.concatenateTypeDefs = $fzT6r.default;

var $jhVll = parcelRequire("jhVll");
module.exports.decorateWithLogger = $jhVll.default;

var $anY4o = parcelRequire("anY4o");
module.exports.extendResolversFromInterfaces = $anY4o.default;

var $4YHnC = parcelRequire("4YHnC");
module.exports.extractExtensionDefinitions = $4YHnC.default;

var $bKZOs = parcelRequire("bKZOs");
module.exports.forEachField = $bKZOs.default;

var $69KMn = parcelRequire("69KMn");
module.exports.SchemaError = $69KMn.default;

});
parcelRegister("gLRgj", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cYGSS = parcelRequire("cYGSS");

var $lXoEQ = parcelRequire("lXoEQ");
var $6BdRO = parcelRequire("6BdRO");

var $esVhq = parcelRequire("esVhq");

var $cYGSS = parcelRequire("cYGSS");

var $l0ywS = parcelRequire("l0ywS");
function $c35a59e5905db8e3$var$addResolveFunctionsToSchema(options, legacyInputResolvers, legacyInputValidationOptions) {
    if (options instanceof $6BdRO.GraphQLSchema) {
        console.warn('The addResolveFunctionsToSchema function takes named options now; see IAddResolveFunctionsToSchemaOptions');
        options = {
            schema: options,
            resolvers: legacyInputResolvers,
            resolverValidationOptions: legacyInputValidationOptions
        };
    }
    var schema = options.schema, inputResolvers = options.resolvers, _a = options.resolverValidationOptions, resolverValidationOptions = _a === void 0 ? {} : _a, _b = options.inheritResolversFromInterfaces, inheritResolversFromInterfaces = _b === void 0 ? false : _b;
    var _c = resolverValidationOptions.allowResolversNotInSchema, allowResolversNotInSchema = _c === void 0 ? false : _c, requireResolversForResolveType = resolverValidationOptions.requireResolversForResolveType;
    var resolvers = inheritResolversFromInterfaces ? $cYGSS.extendResolversFromInterfaces(schema, inputResolvers) : inputResolvers;
    // Used to map the external value of an enum to its internal value, when
    // that internal value is provided by a resolver.
    var enumValueMap = Object.create(null);
    Object.keys(resolvers).forEach(function(typeName) {
        var resolverValue = resolvers[typeName];
        var resolverType = typeof resolverValue;
        if (resolverType !== 'object' && resolverType !== 'function') throw new $cYGSS.SchemaError("\"" + typeName + "\" defined in resolvers, but has invalid value \"" + resolverValue + "\". A resolver's value " + "must be of type object or function.");
        var type = schema.getType(typeName);
        if (!type && typeName !== '__schema') {
            if (allowResolversNotInSchema) return;
            throw new $cYGSS.SchemaError("\"" + typeName + "\" defined in resolvers, but not in schema");
        }
        Object.keys(resolverValue).forEach(function(fieldName) {
            if (fieldName.startsWith('__')) {
                // this is for isTypeOf and resolveType and all the other stuff.
                type[fieldName.substring(2)] = resolverValue[fieldName];
                return;
            }
            if (type instanceof $lXoEQ.GraphQLScalarType) {
                type[fieldName] = resolverValue[fieldName];
                return;
            }
            if (type instanceof $lXoEQ.GraphQLEnumType) {
                if (!type.getValue(fieldName)) {
                    if (allowResolversNotInSchema) return;
                    throw new $cYGSS.SchemaError(typeName + "." + fieldName + " was defined in resolvers, but enum is not in schema");
                }
                // We've encountered an enum resolver that is being used to provide an
                // internal enum value.
                // Reference: https://www.apollographql.com/docs/graphql-tools/scalars.html#internal-values
                //
                // We're storing a map of the current enums external facing value to
                // its resolver provided internal value. This map is used to transform
                // the current schema to a new schema that includes enums with the new
                // internal value.
                enumValueMap[type.name] = enumValueMap[type.name] || {};
                enumValueMap[type.name][fieldName] = resolverValue[fieldName];
                return;
            }
            // object type
            var fields = $c35a59e5905db8e3$var$getFieldsForType(type);
            if (!fields) {
                if (allowResolversNotInSchema) return;
                throw new $cYGSS.SchemaError(typeName + " was defined in resolvers, but it's not an object");
            }
            if (!fields[fieldName]) {
                if (allowResolversNotInSchema) return;
                throw new $cYGSS.SchemaError(typeName + "." + fieldName + " defined in resolvers, but not in schema");
            }
            var field = fields[fieldName];
            var fieldResolve = resolverValue[fieldName];
            if (typeof fieldResolve === 'function') // for convenience. Allows shorter syntax in resolver definition file
            $c35a59e5905db8e3$var$setFieldProperties(field, {
                resolve: fieldResolve
            });
            else {
                if (typeof fieldResolve !== 'object') throw new $cYGSS.SchemaError("Resolver " + typeName + "." + fieldName + " must be object or function");
                $c35a59e5905db8e3$var$setFieldProperties(field, fieldResolve);
            }
        });
    });
    $cYGSS.checkForResolveTypeResolver(schema, requireResolversForResolveType);
    // If there are any enum resolver functions (that are used to return
    // internal enum values), create a new schema that includes enums with the
    // new internal facing values.
    var updatedSchema = $esVhq.applySchemaTransforms(schema, [
        new $l0ywS.default(enumValueMap)
    ]);
    return updatedSchema;
}
function $c35a59e5905db8e3$var$getFieldsForType(type) {
    if (type instanceof $lXoEQ.GraphQLObjectType || type instanceof $lXoEQ.GraphQLInterfaceType) return type.getFields();
    else return undefined;
}
function $c35a59e5905db8e3$var$setFieldProperties(field, propertiesObj) {
    Object.keys(propertiesObj).forEach(function(propertyName) {
        field[propertyName] = propertiesObj[propertyName];
    });
}
module.exports.default = $c35a59e5905db8e3$var$addResolveFunctionsToSchema;

});
parcelRegister("esVhq", function(module, exports) {
var $a8801cd741f34ae5$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $a8801cd741f34ae5$var$applySchemaTransforms(originalSchema, transforms) {
    return transforms.reduce(function(schema, transform) {
        return transform.transformSchema ? transform.transformSchema(schema) : schema;
    }, originalSchema);
}
module.exports.applySchemaTransforms = $a8801cd741f34ae5$var$applySchemaTransforms;
function $a8801cd741f34ae5$var$applyRequestTransforms(originalRequest, transforms) {
    return transforms.reduce(function(request, transform) {
        return transform.transformRequest ? transform.transformRequest(request) : request;
    }, originalRequest);
}
module.exports.applyRequestTransforms = $a8801cd741f34ae5$var$applyRequestTransforms;
function $a8801cd741f34ae5$var$applyResultTransforms(originalResult, transforms) {
    return transforms.reduce(function(result, transform) {
        return transform.transformResult ? transform.transformResult(result) : result;
    }, originalResult);
}
module.exports.applyResultTransforms = $a8801cd741f34ae5$var$applyResultTransforms;
function $a8801cd741f34ae5$var$composeTransforms() {
    var transforms = [];
    for(var _i = 0; _i < arguments.length; _i++)transforms[_i] = arguments[_i];
    var reverseTransforms = $a8801cd741f34ae5$var$__spreadArrays(transforms).reverse();
    return {
        transformSchema: function(originalSchema) {
            return $a8801cd741f34ae5$var$applySchemaTransforms(originalSchema, transforms);
        },
        transformRequest: function(originalRequest) {
            return $a8801cd741f34ae5$var$applyRequestTransforms(originalRequest, reverseTransforms);
        },
        transformResult: function(result) {
            return $a8801cd741f34ae5$var$applyResultTransforms(result, reverseTransforms);
        }
    };
}
module.exports.composeTransforms = $a8801cd741f34ae5$var$composeTransforms;

});

parcelRegister("l0ywS", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");

var $esiZ2 = parcelRequire("esiZ2");
// Transformation used to modifiy `GraphQLEnumType` values in a schema.
var $f4b461dd5b4b26c8$var$ConvertEnumValues = /** @class */ function() {
    function ConvertEnumValues(enumValueMap) {
        this.enumValueMap = enumValueMap;
    }
    // Walk a schema looking for `GraphQLEnumType` types. If found, and
    // matching types have been identified in `this.enumValueMap`, create new
    // `GraphQLEnumType` types using the `this.enumValueMap` specified new
    // values, and return them in the new schema.
    ConvertEnumValues.prototype.transformSchema = function(schema) {
        var _a;
        var enumValueMap = this.enumValueMap;
        if (!enumValueMap || Object.keys(enumValueMap).length === 0) return schema;
        var transformedSchema = $esiZ2.visitSchema(schema, (_a = {}, _a[$esiZ2.VisitSchemaKind.ENUM_TYPE] = function(enumType) {
            var externalToInternalValueMap = enumValueMap[enumType.name];
            if (externalToInternalValueMap) {
                var values = enumType.getValues();
                var newValues_1 = {};
                values.forEach(function(value) {
                    var newValue = Object.keys(externalToInternalValueMap).includes(value.name) ? externalToInternalValueMap[value.name] : value.name;
                    newValues_1[value.name] = {
                        value: newValue,
                        deprecationReason: value.deprecationReason,
                        description: value.description,
                        astNode: value.astNode
                    };
                });
                return new $lXoEQ.GraphQLEnumType({
                    name: enumType.name,
                    description: enumType.description,
                    astNode: enumType.astNode,
                    values: newValues_1
                });
            }
            return enumType;
        }, _a));
        return transformedSchema;
    };
    return ConvertEnumValues;
}();
module.exports.default = $f4b461dd5b4b26c8$var$ConvertEnumValues;

});
parcelRegister("esiZ2", function(module, exports) {
var $a86267ec7e8e9726$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $6BdRO = parcelRequire("6BdRO");

var $h8S1f = parcelRequire("h8S1f");
var $a86267ec7e8e9726$var$VisitSchemaKind;
(function(VisitSchemaKind) {
    VisitSchemaKind["TYPE"] = "VisitSchemaKind.TYPE";
    VisitSchemaKind["SCALAR_TYPE"] = "VisitSchemaKind.SCALAR_TYPE";
    VisitSchemaKind["ENUM_TYPE"] = "VisitSchemaKind.ENUM_TYPE";
    VisitSchemaKind["COMPOSITE_TYPE"] = "VisitSchemaKind.COMPOSITE_TYPE";
    VisitSchemaKind["OBJECT_TYPE"] = "VisitSchemaKind.OBJECT_TYPE";
    VisitSchemaKind["INPUT_OBJECT_TYPE"] = "VisitSchemaKind.INPUT_OBJECT_TYPE";
    VisitSchemaKind["ABSTRACT_TYPE"] = "VisitSchemaKind.ABSTRACT_TYPE";
    VisitSchemaKind["UNION_TYPE"] = "VisitSchemaKind.UNION_TYPE";
    VisitSchemaKind["INTERFACE_TYPE"] = "VisitSchemaKind.INTERFACE_TYPE";
    VisitSchemaKind["ROOT_OBJECT"] = "VisitSchemaKind.ROOT_OBJECT";
    VisitSchemaKind["QUERY"] = "VisitSchemaKind.QUERY";
    VisitSchemaKind["MUTATION"] = "VisitSchemaKind.MUTATION";
    VisitSchemaKind["SUBSCRIPTION"] = "VisitSchemaKind.SUBSCRIPTION";
})($a86267ec7e8e9726$var$VisitSchemaKind = module.exports.VisitSchemaKind || (module.exports.VisitSchemaKind = {}));
function $a86267ec7e8e9726$var$visitSchema(schema, visitor, stripResolvers) {
    var types = {};
    var resolveType = $h8S1f.createResolveType(function(name) {
        if (typeof types[name] === 'undefined') throw new Error("Can't find type " + name + ".");
        return types[name];
    });
    var queryType = schema.getQueryType();
    var mutationType = schema.getMutationType();
    var subscriptionType = schema.getSubscriptionType();
    var typeMap = schema.getTypeMap();
    Object.keys(typeMap).map(function(typeName) {
        var type = typeMap[typeName];
        if ($lXoEQ.isNamedType(type) && $lXoEQ.getNamedType(type).name.slice(0, 2) !== '__') {
            var specifiers = $a86267ec7e8e9726$var$getTypeSpecifiers(type, schema);
            var typeVisitor = $a86267ec7e8e9726$var$getVisitor(visitor, specifiers);
            if (typeVisitor) {
                var result = typeVisitor(type, schema);
                if (typeof result === 'undefined') types[typeName] = $h8S1f.recreateType(type, resolveType, !stripResolvers);
                else if (result === null) types[typeName] = null;
                else types[typeName] = $h8S1f.recreateType(result, resolveType, !stripResolvers);
            } else types[typeName] = $h8S1f.recreateType(type, resolveType, !stripResolvers);
        }
    });
    return new $6BdRO.GraphQLSchema({
        query: queryType ? types[queryType.name] : null,
        mutation: mutationType ? types[mutationType.name] : null,
        subscription: subscriptionType ? types[subscriptionType.name] : null,
        types: Object.keys(types).map(function(name) {
            return types[name];
        })
    });
}
module.exports.visitSchema = $a86267ec7e8e9726$var$visitSchema;
function $a86267ec7e8e9726$var$getTypeSpecifiers(type, schema) {
    var specifiers = [
        $a86267ec7e8e9726$var$VisitSchemaKind.TYPE
    ];
    if (type instanceof $lXoEQ.GraphQLObjectType) {
        specifiers.unshift($a86267ec7e8e9726$var$VisitSchemaKind.COMPOSITE_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.OBJECT_TYPE);
        var query = schema.getQueryType();
        var mutation = schema.getMutationType();
        var subscription = schema.getSubscriptionType();
        if (type === query) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.ROOT_OBJECT, $a86267ec7e8e9726$var$VisitSchemaKind.QUERY);
        else if (type === mutation) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.ROOT_OBJECT, $a86267ec7e8e9726$var$VisitSchemaKind.MUTATION);
        else if (type === subscription) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.ROOT_OBJECT, $a86267ec7e8e9726$var$VisitSchemaKind.SUBSCRIPTION);
    } else if (type instanceof $lXoEQ.GraphQLInputObjectType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.INPUT_OBJECT_TYPE);
    else if (type instanceof $lXoEQ.GraphQLInterfaceType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.COMPOSITE_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.ABSTRACT_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.INTERFACE_TYPE);
    else if (type instanceof $lXoEQ.GraphQLUnionType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.COMPOSITE_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.ABSTRACT_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.UNION_TYPE);
    else if (type instanceof $lXoEQ.GraphQLEnumType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.ENUM_TYPE);
    else if (type instanceof $lXoEQ.GraphQLScalarType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.SCALAR_TYPE);
    return specifiers;
}
function $a86267ec7e8e9726$var$getVisitor(visitor, specifiers) {
    var typeVisitor = null;
    var stack = $a86267ec7e8e9726$var$__spreadArrays(specifiers);
    while(!typeVisitor && stack.length > 0){
        var next = stack.pop();
        typeVisitor = visitor[next];
    }
    return typeVisitor;
}

});
parcelRegister("h8S1f", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");
var $bOniD = parcelRequire("bOniD");
var $1c4hI = parcelRequire("1c4hI");

var $kgFtY = parcelRequire("kgFtY");

var $j0Odg = parcelRequire("j0Odg");

var $8je8M = parcelRequire("8je8M");
function $c7ad1618233e9756$var$recreateType(type, resolveType, keepResolvers) {
    if (type instanceof $lXoEQ.GraphQLObjectType) {
        var fields_1 = type.getFields();
        var interfaces_1 = type.getInterfaces();
        return new $lXoEQ.GraphQLObjectType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            isTypeOf: keepResolvers ? type.isTypeOf : undefined,
            fields: function() {
                return $c7ad1618233e9756$var$fieldMapToFieldConfigMap(fields_1, resolveType, keepResolvers);
            },
            interfaces: function() {
                return interfaces_1.map(function(iface) {
                    return resolveType(iface);
                });
            }
        });
    } else if (type instanceof $lXoEQ.GraphQLInterfaceType) {
        var fields_2 = type.getFields();
        return new $lXoEQ.GraphQLInterfaceType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            fields: function() {
                return $c7ad1618233e9756$var$fieldMapToFieldConfigMap(fields_2, resolveType, keepResolvers);
            },
            resolveType: keepResolvers ? type.resolveType : function(parent, context, info) {
                return $j0Odg.default(parent, info.schema);
            }
        });
    } else if (type instanceof $lXoEQ.GraphQLUnionType) return new $lXoEQ.GraphQLUnionType({
        name: type.name,
        description: type.description,
        astNode: type.astNode,
        types: function() {
            return type.getTypes().map(function(unionMember) {
                return resolveType(unionMember);
            });
        },
        resolveType: keepResolvers ? type.resolveType : function(parent, context, info) {
            return $j0Odg.default(parent, info.schema);
        }
    });
    else if (type instanceof $lXoEQ.GraphQLInputObjectType) return new $lXoEQ.GraphQLInputObjectType({
        name: type.name,
        description: type.description,
        astNode: type.astNode,
        fields: function() {
            return $c7ad1618233e9756$var$inputFieldMapToFieldConfigMap(type.getFields(), resolveType);
        }
    });
    else if (type instanceof $lXoEQ.GraphQLEnumType) {
        var values = type.getValues();
        var newValues_1 = {};
        values.forEach(function(value) {
            newValues_1[value.name] = {
                value: value.value,
                deprecationReason: value.deprecationReason,
                description: value.description,
                astNode: value.astNode
            };
        });
        return new $lXoEQ.GraphQLEnumType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            values: newValues_1
        });
    } else if (type instanceof $lXoEQ.GraphQLScalarType) {
        if (keepResolvers || $kgFtY.default(type)) return type;
        else return new $lXoEQ.GraphQLScalarType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            serialize: function(value) {
                return value;
            },
            parseValue: function(value) {
                return value;
            },
            parseLiteral: function(ast) {
                return $c7ad1618233e9756$var$parseLiteral(ast);
            }
        });
    } else throw new Error("Invalid type " + type);
}
module.exports.recreateType = $c7ad1618233e9756$var$recreateType;
function $c7ad1618233e9756$var$recreateDirective(directive, resolveType) {
    return new $bOniD.GraphQLDirective({
        name: directive.name,
        description: directive.description,
        locations: directive.locations,
        args: $c7ad1618233e9756$var$argsToFieldConfigArgumentMap(directive.args, resolveType),
        astNode: directive.astNode
    });
}
module.exports.recreateDirective = $c7ad1618233e9756$var$recreateDirective;
function $c7ad1618233e9756$var$parseLiteral(ast) {
    switch(ast.kind){
        case $1c4hI.Kind.STRING:
        case $1c4hI.Kind.BOOLEAN:
            return ast.value;
        case $1c4hI.Kind.INT:
        case $1c4hI.Kind.FLOAT:
            return parseFloat(ast.value);
        case $1c4hI.Kind.OBJECT:
            var value_1 = Object.create(null);
            ast.fields.forEach(function(field) {
                value_1[field.name.value] = $c7ad1618233e9756$var$parseLiteral(field.value);
            });
            return value_1;
        case $1c4hI.Kind.LIST:
            return ast.values.map($c7ad1618233e9756$var$parseLiteral);
        default:
            return null;
    }
}
function $c7ad1618233e9756$var$fieldMapToFieldConfigMap(fields, resolveType, keepResolvers) {
    var result = {};
    Object.keys(fields).forEach(function(name) {
        var field = fields[name];
        var type = resolveType(field.type);
        if (type !== null) result[name] = $c7ad1618233e9756$var$fieldToFieldConfig(fields[name], resolveType, keepResolvers);
    });
    return result;
}
module.exports.fieldMapToFieldConfigMap = $c7ad1618233e9756$var$fieldMapToFieldConfigMap;
function $c7ad1618233e9756$var$createResolveType(getType) {
    var resolveType = function(type) {
        if (type instanceof $lXoEQ.GraphQLList) {
            var innerType = resolveType(type.ofType);
            if (innerType === null) return null;
            else return new $lXoEQ.GraphQLList(innerType);
        } else if (type instanceof $lXoEQ.GraphQLNonNull) {
            var innerType = resolveType(type.ofType);
            if (innerType === null) return null;
            else return new $lXoEQ.GraphQLNonNull(innerType);
        } else if ($lXoEQ.isNamedType(type)) {
            var typeName = $lXoEQ.getNamedType(type).name;
            switch(typeName){
                case $auu22.GraphQLInt.name:
                    return $auu22.GraphQLInt;
                case $auu22.GraphQLFloat.name:
                    return $auu22.GraphQLFloat;
                case $auu22.GraphQLString.name:
                    return $auu22.GraphQLString;
                case $auu22.GraphQLBoolean.name:
                    return $auu22.GraphQLBoolean;
                case $auu22.GraphQLID.name:
                    return $auu22.GraphQLID;
                default:
                    return getType(typeName, type);
            }
        } else return type;
    };
    return resolveType;
}
module.exports.createResolveType = $c7ad1618233e9756$var$createResolveType;
function $c7ad1618233e9756$var$fieldToFieldConfig(field, resolveType, keepResolvers) {
    return {
        type: resolveType(field.type),
        args: $c7ad1618233e9756$var$argsToFieldConfigArgumentMap(field.args, resolveType),
        resolve: keepResolvers ? field.resolve : $8je8M.default,
        subscribe: keepResolvers ? field.subscribe : null,
        description: field.description,
        deprecationReason: field.deprecationReason,
        astNode: field.astNode
    };
}
module.exports.fieldToFieldConfig = $c7ad1618233e9756$var$fieldToFieldConfig;
function $c7ad1618233e9756$var$argsToFieldConfigArgumentMap(args, resolveType) {
    var result = {};
    args.forEach(function(arg) {
        var newArg = $c7ad1618233e9756$var$argumentToArgumentConfig(arg, resolveType);
        if (newArg) result[newArg[0]] = newArg[1];
    });
    return result;
}
module.exports.argsToFieldConfigArgumentMap = $c7ad1618233e9756$var$argsToFieldConfigArgumentMap;
function $c7ad1618233e9756$var$argumentToArgumentConfig(argument, resolveType) {
    var type = resolveType(argument.type);
    if (type === null) return null;
    else return [
        argument.name,
        {
            type: type,
            defaultValue: argument.defaultValue,
            description: argument.description
        }
    ];
}
module.exports.argumentToArgumentConfig = $c7ad1618233e9756$var$argumentToArgumentConfig;
function $c7ad1618233e9756$var$inputFieldMapToFieldConfigMap(fields, resolveType) {
    var result = {};
    Object.keys(fields).forEach(function(name) {
        var field = fields[name];
        var type = resolveType(field.type);
        if (type !== null) result[name] = $c7ad1618233e9756$var$inputFieldToFieldConfig(fields[name], resolveType);
    });
    return result;
}
module.exports.inputFieldMapToFieldConfigMap = $c7ad1618233e9756$var$inputFieldMapToFieldConfigMap;
function $c7ad1618233e9756$var$inputFieldToFieldConfig(field, resolveType) {
    return {
        type: resolveType(field.type),
        defaultValue: field.defaultValue,
        description: field.description,
        astNode: field.astNode
    };
}
module.exports.inputFieldToFieldConfig = $c7ad1618233e9756$var$inputFieldToFieldConfig;

});
parcelRegister("kgFtY", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");
// FIXME: Replace with https://github.com/graphql/graphql-js/blob/master/src/type/scalars.js#L139
module.exports.specifiedScalarTypes = [
    $auu22.GraphQLString,
    $auu22.GraphQLInt,
    $auu22.GraphQLFloat,
    $auu22.GraphQLBoolean,
    $auu22.GraphQLID
];
function $ec157ad38f1a9f87$var$isSpecifiedScalarType(type) {
    return $lXoEQ.isNamedType(type) && // Would prefer to use specifiedScalarTypes.some(), however %checks needs
    // a simple expression.
    (type.name === $auu22.GraphQLString.name || type.name === $auu22.GraphQLInt.name || type.name === $auu22.GraphQLFloat.name || type.name === $auu22.GraphQLBoolean.name || type.name === $auu22.GraphQLID.name);
}
module.exports.default = $ec157ad38f1a9f87$var$isSpecifiedScalarType;

});

parcelRegister("j0Odg", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
function $dd74f7a1403eef9b$var$resolveFromParentTypename(parent, schema) {
    var parentTypename = parent['__typename'];
    if (!parentTypename) throw new Error('Did not fetch typename for object, unable to resolve interface.');
    var resolvedType = schema.getType(parentTypename);
    if (!(resolvedType instanceof $lXoEQ.GraphQLObjectType)) throw new Error('__typename did not match an object type: ' + parentTypename);
    return resolvedType;
}
module.exports.default = $dd74f7a1403eef9b$var$resolveFromParentTypename;

});

parcelRegister("8je8M", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kZHaf = parcelRequire("kZHaf");

var $02KAV = parcelRequire("02KAV");

var $10LTa = parcelRequire("10LTa");

var $57Vxb = parcelRequire("57Vxb");
// Resolver that knows how to:
// a) handle aliases for proxied schemas
// b) handle errors from proxied schemas
var $60cb111eb226f1bd$var$defaultMergedResolver = function(parent, args, context, info) {
    if (!parent) return null;
    var responseKey = $57Vxb.getResponseKeyFromInfo(info);
    var errorResult = $10LTa.getErrorsFromParent(parent, responseKey);
    if (errorResult.kind === 'OWN') throw $02KAV.locatedError(new Error(errorResult.error.message), info.fieldNodes, $kZHaf.pathToArray(info.path));
    var result = parent[responseKey];
    if (result == null) result = parent[info.fieldName];
    // subscription result mapping
    if (!result && parent.data && parent.data[responseKey]) result = parent.data[responseKey];
    if (errorResult.errors) result = $10LTa.annotateWithChildrenErrors(result, errorResult.errors);
    return result;
};
module.exports.default = $60cb111eb226f1bd$var$defaultMergedResolver;

});
parcelRegister("10LTa", function(module, exports) {
var $0bcaf03a9acca47e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0bcaf03a9acca47e$var$__assign = module.exports && module.exports.__assign || function() {
    $0bcaf03a9acca47e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0bcaf03a9acca47e$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kZHaf = parcelRequire("kZHaf");

var $02KAV = parcelRequire("02KAV");

var $57Vxb = parcelRequire("57Vxb");
if (typeof $parcel$global !== 'undefined' && 'Symbol' in $parcel$global || typeof window !== 'undefined' && 'Symbol' in window) module.exports.ERROR_SYMBOL = Symbol('subSchemaErrors');
else module.exports.ERROR_SYMBOL = '@@__subSchemaErrors';
function $0bcaf03a9acca47e$var$annotateWithChildrenErrors(object, childrenErrors) {
    var _a;
    if (!childrenErrors || childrenErrors.length === 0) // Nothing to see here, move along
    return object;
    if (Array.isArray(object)) {
        var byIndex_1 = {};
        childrenErrors.forEach(function(error) {
            if (!error.path) return;
            var index = error.path[1];
            var current = byIndex_1[index] || [];
            current.push($0bcaf03a9acca47e$var$__assign($0bcaf03a9acca47e$var$__assign({}, error), {
                path: error.path.slice(1)
            }));
            byIndex_1[index] = current;
        });
        return object.map(function(item, index) {
            return $0bcaf03a9acca47e$var$annotateWithChildrenErrors(item, byIndex_1[index]);
        });
    }
    return $0bcaf03a9acca47e$var$__assign($0bcaf03a9acca47e$var$__assign({}, object), (_a = {}, _a[module.exports.ERROR_SYMBOL] = childrenErrors.map(function(error) {
        return $0bcaf03a9acca47e$var$__assign($0bcaf03a9acca47e$var$__assign({}, error), error.path ? {
            path: error.path.slice(1)
        } : {});
    }), _a));
}
module.exports.annotateWithChildrenErrors = $0bcaf03a9acca47e$var$annotateWithChildrenErrors;
function $0bcaf03a9acca47e$var$getErrorsFromParent(object, fieldName) {
    var errors = object && object[module.exports.ERROR_SYMBOL] || [];
    var childrenErrors = [];
    for(var _i = 0, errors_1 = errors; _i < errors_1.length; _i++){
        var error = errors_1[_i];
        if (!error.path || error.path.length === 1 && error.path[0] === fieldName) return {
            kind: 'OWN',
            error: error
        };
        else if (error.path[0] === fieldName) childrenErrors.push(error);
    }
    return {
        kind: 'CHILDREN',
        errors: childrenErrors
    };
}
module.exports.getErrorsFromParent = $0bcaf03a9acca47e$var$getErrorsFromParent;
var $0bcaf03a9acca47e$var$CombinedError = /** @class */ function(_super) {
    $0bcaf03a9acca47e$var$__extends(CombinedError, _super);
    function CombinedError(message, errors) {
        var _this = _super.call(this, message) || this;
        _this.errors = errors;
        return _this;
    }
    return CombinedError;
}(Error);
function $0bcaf03a9acca47e$var$checkResultAndHandleErrors(result, info, responseKey) {
    if (!responseKey) responseKey = $57Vxb.getResponseKeyFromInfo(info);
    if (result.errors && (!result.data || result.data[responseKey] == null)) {
        // apollo-link-http & http-link-dataloader need the
        // result property to be passed through for better error handling.
        // If there is only one error, which contains a result property, pass the error through
        var newError = result.errors.length === 1 && $0bcaf03a9acca47e$var$hasResult(result.errors[0]) ? result.errors[0] : new $0bcaf03a9acca47e$var$CombinedError($0bcaf03a9acca47e$var$concatErrors(result.errors), result.errors);
        throw $02KAV.locatedError(newError, info.fieldNodes, $kZHaf.pathToArray(info.path));
    }
    var resultObject = result.data[responseKey];
    if (result.errors) resultObject = $0bcaf03a9acca47e$var$annotateWithChildrenErrors(resultObject, result.errors);
    return resultObject;
}
module.exports.checkResultAndHandleErrors = $0bcaf03a9acca47e$var$checkResultAndHandleErrors;
function $0bcaf03a9acca47e$var$concatErrors(errors) {
    return errors.map(function(error) {
        return error.message;
    }).join('\n');
}
function $0bcaf03a9acca47e$var$hasResult(error) {
    return error.result || error.extensions || error.originalError && error.originalError.result;
}

});
parcelRegister("57Vxb", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Get the key under which the result of this resolver will be placed in the response JSON. Basically, just
 * resolves aliases.
 * @param info The info argument to the resolver.
 */ function $3bba3c508f8a2a51$var$getResponseKeyFromInfo(info) {
    return info.fieldNodes[0].alias ? info.fieldNodes[0].alias.value : info.fieldName;
}
module.exports.getResponseKeyFromInfo = $3bba3c508f8a2a51$var$getResponseKeyFromInfo;

});







parcelRegister("lQXQV", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");
// wraps all resolve functions of query, mutation or subscription fields
// with the provided function to simulate a root schema level resolve funciton
function $fe8ce1cef8f746df$var$addSchemaLevelResolveFunction(schema, fn) {
    // TODO test that schema is a schema, fn is a function
    var rootTypes = [
        schema.getQueryType(),
        schema.getMutationType(),
        schema.getSubscriptionType()
    ].filter(function(x) {
        return !!x;
    });
    rootTypes.forEach(function(type) {
        // XXX this should run at most once per request to simulate a true root resolver
        // for graphql-js this is an approximation that works with queries but not mutations
        var rootResolveFn = $fe8ce1cef8f746df$var$runAtMostOncePerRequest(fn);
        var fields = type.getFields();
        Object.keys(fields).forEach(function(fieldName) {
            // XXX if the type is a subscription, a same query AST will be ran multiple times so we
            // deactivate here the runOnce if it's a subscription. This may not be optimal though...
            if (type === schema.getSubscriptionType()) fields[fieldName].resolve = $fe8ce1cef8f746df$var$wrapResolver(fields[fieldName].resolve, fn);
            else fields[fieldName].resolve = $fe8ce1cef8f746df$var$wrapResolver(fields[fieldName].resolve, rootResolveFn);
        });
    });
}
// XXX badly named function. this doesn't really wrap, it just chains resolvers...
function $fe8ce1cef8f746df$var$wrapResolver(innerResolver, outerResolver) {
    return function(obj, args, ctx, info) {
        return Promise.resolve(outerResolver(obj, args, ctx, info)).then(function(root) {
            if (innerResolver) return innerResolver(root, args, ctx, info);
            return $3MP74.defaultFieldResolver(root, args, ctx, info);
        });
    };
}
// XXX this function only works for resolvers
// XXX very hacky way to remember if the function
// already ran for this request. This will only work
// if people don't actually cache the operation.
// if they do cache the operation, they will have to
// manually remove the __runAtMostOnce before every request.
function $fe8ce1cef8f746df$var$runAtMostOncePerRequest(fn) {
    var value;
    var randomNumber = Math.random();
    return function(root, args, ctx, info) {
        if (!info.operation['__runAtMostOnce']) info.operation['__runAtMostOnce'] = {};
        if (!info.operation['__runAtMostOnce'][randomNumber]) {
            info.operation['__runAtMostOnce'][randomNumber] = true;
            value = fn(root, args, ctx, info);
        }
        return value;
    };
}
module.exports.default = $fe8ce1cef8f746df$var$addSchemaLevelResolveFunction;

});

parcelRegister("7ZqjT", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");

var $cYGSS = parcelRequire("cYGSS");
function $5d12a578553eba05$var$assertResolveFunctionsPresent(schema, resolverValidationOptions) {
    if (resolverValidationOptions === void 0) resolverValidationOptions = {};
    var _a = resolverValidationOptions.requireResolversForArgs, requireResolversForArgs = _a === void 0 ? false : _a, _b = resolverValidationOptions.requireResolversForNonScalar, requireResolversForNonScalar = _b === void 0 ? false : _b, _c = resolverValidationOptions.requireResolversForAllFields, requireResolversForAllFields = _c === void 0 ? false : _c;
    if (requireResolversForAllFields && (requireResolversForArgs || requireResolversForNonScalar)) throw new TypeError("requireResolversForAllFields takes precedence over the more specific assertions. Please configure either requireResolversForAllFields or requireResolversForArgs / requireResolversForNonScalar, but not a combination of them.");
    $cYGSS.forEachField(schema, function(field, typeName, fieldName) {
        // requires a resolve function for *every* field.
        if (requireResolversForAllFields) $5d12a578553eba05$var$expectResolveFunction(field, typeName, fieldName);
        // requires a resolve function on every field that has arguments
        if (requireResolversForArgs && field.args.length > 0) $5d12a578553eba05$var$expectResolveFunction(field, typeName, fieldName);
        // requires a resolve function on every field that returns a non-scalar type
        if (requireResolversForNonScalar && !($lXoEQ.getNamedType(field.type) instanceof $lXoEQ.GraphQLScalarType)) $5d12a578553eba05$var$expectResolveFunction(field, typeName, fieldName);
    });
}
function $5d12a578553eba05$var$expectResolveFunction(field, typeName, fieldName) {
    if (!field.resolve) {
        console.warn(// tslint:disable-next-line: max-line-length
        "Resolve function missing for \"" + typeName + "." + fieldName + "\". To disable this warning check https://github.com/apollostack/graphql-tools/issues/131");
        return;
    }
    if (typeof field.resolve !== 'function') throw new $cYGSS.SchemaError("Resolver \"" + typeName + "." + fieldName + "\" must be a function");
}
module.exports.default = $5d12a578553eba05$var$assertResolveFunctionsPresent;

});

parcelRegister("glxQ5", function(module, exports) {
var $be68db39ae07a569$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $be68db39ae07a569$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $be68db39ae07a569$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");

var $gVW6u = parcelRequire("gVW6u");
function $be68db39ae07a569$var$attachDirectiveResolvers(schema, directiveResolvers) {
    if (typeof directiveResolvers !== 'object') throw new Error("Expected directiveResolvers to be of type object, got " + typeof directiveResolvers);
    if (Array.isArray(directiveResolvers)) throw new Error('Expected directiveResolvers to be of type object, got Array');
    var schemaDirectives = Object.create(null);
    Object.keys(directiveResolvers).forEach(function(directiveName) {
        schemaDirectives[directiveName] = /** @class */ function(_super) {
            $be68db39ae07a569$var$__extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            class_1.prototype.visitFieldDefinition = function(field) {
                var _this = this;
                var resolver = directiveResolvers[directiveName];
                var originalResolver = field.resolve || $3MP74.defaultFieldResolver;
                var directiveArgs = this.args;
                field.resolve = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var source = args[0], context = args[2], info = args[3];
                    return resolver(function() {
                        return $be68db39ae07a569$var$__awaiter(_this, void 0, void 0, function() {
                            return $be68db39ae07a569$var$__generator(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    originalResolver.apply(field, args)
                                ];
                            });
                        });
                    }, source, directiveArgs, context, info);
                };
            };
            return class_1;
        }($gVW6u.SchemaDirectiveVisitor);
    });
    $gVW6u.SchemaDirectiveVisitor.visitSchemaDirectives(schema, schemaDirectives);
}
module.exports.default = $be68db39ae07a569$var$attachDirectiveResolvers;

});

parcelRegister("4Vy0J", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6BdRO = parcelRequire("6BdRO");

var $ie50m = parcelRequire("ie50m");

var $cYGSS = parcelRequire("cYGSS");
// takes a GraphQL-JS schema and an object of connectors, then attaches
// the connectors to the context by wrapping each query or mutation resolve
// function with a function that attaches connectors if they don't exist.
// attaches connectors only once to make sure they are singletons
var $3966de2652c7f7e4$var$attachConnectorsToContext = $ie50m.deprecated({
    version: '0.7.0',
    url: 'https://github.com/apollostack/graphql-tools/issues/140'
}, function(schema, connectors) {
    if (!schema || !(schema instanceof $6BdRO.GraphQLSchema)) throw new Error("schema must be an instance of GraphQLSchema. This error could be caused by installing more than one version of GraphQL-JS");
    if (typeof connectors !== 'object') {
        var connectorType = typeof connectors;
        throw new Error("Expected connectors to be of type object, got " + connectorType);
    }
    if (Object.keys(connectors).length === 0) throw new Error('Expected connectors to not be an empty object');
    if (Array.isArray(connectors)) throw new Error('Expected connectors to be of type object, got Array');
    if (schema['_apolloConnectorsAttached']) throw new Error('Connectors already attached to context, cannot attach more than once');
    schema['_apolloConnectorsAttached'] = true;
    var attachconnectorFn = function(root, args, ctx) {
        if (typeof ctx !== 'object') {
            // if in any way possible, we should throw an error when the attachconnectors
            // function is called, not when a query is executed.
            var contextType = typeof ctx;
            throw new Error("Cannot attach connector because context is not an object: " + contextType);
        }
        if (typeof ctx.connectors === 'undefined') ctx.connectors = {};
        Object.keys(connectors).forEach(function(connectorName) {
            var connector = connectors[connectorName];
            if (!!connector.prototype) ctx.connectors[connectorName] = new connector(ctx);
            else throw new Error("Connector must be a function or an class");
        });
        return root;
    };
    $cYGSS.addSchemaLevelResolveFunction(schema, attachconnectorFn);
});
module.exports.default = $3966de2652c7f7e4$var$attachConnectorsToContext;

});
parcelRegister("ie50m", function(module, exports) {
/*
    Deprecated Decorator v0.1
    https://github.com/vilic/deprecated-decorator
*/ "use strict";
/** @internal */ module.exports.options = {
    getWarner: undefined
};
function $d44d6aab074f7c0d$var$createWarner(type, name, alternative, version, url) {
    var warnedPositions = {};
    return function() {
        var stack = new Error().stack || '';
        var at = (stack.match(/(?:\s+at\s.+){2}\s+at\s(.+)/) || [
            undefined,
            ''
        ])[1];
        if (/\)$/.test(at)) at = at.match(/[^(]+(?=\)$)/)[0];
        else at = at.trim();
        if (at in warnedPositions) return;
        warnedPositions[at] = true;
        var message;
        switch(type){
            case 'class':
                message = 'Class';
                break;
            case 'property':
                message = 'Property';
                break;
            case 'method':
                message = 'Method';
                break;
            case 'function':
                message = 'Function';
                break;
        }
        message += " `" + name + "` has been deprecated";
        if (version) message += " since version " + version;
        if (alternative) message += ", use `" + alternative + "` instead";
        message += '.';
        if (at) message += "\n    at " + at;
        if (url) message += "\nCheck out " + url + " for more information.";
        console.warn(message);
    };
}
function $d44d6aab074f7c0d$var$decorateProperty(type, name, descriptor, alternative, version, url) {
    var warner = (module.exports.options.getWarner || $d44d6aab074f7c0d$var$createWarner)(type, name, alternative, version, url);
    descriptor = descriptor || {
        writable: true,
        enumerable: false,
        configurable: true
    };
    var deprecatedDescriptor = {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable
    };
    if (descriptor.get || descriptor.set) {
        if (descriptor.get) deprecatedDescriptor.get = function() {
            warner();
            return descriptor.get.call(this);
        };
        if (descriptor.set) deprecatedDescriptor.set = function(value) {
            warner();
            return descriptor.set.call(this, value);
        };
    } else {
        var propertyValue_1 = descriptor.value;
        deprecatedDescriptor.get = function() {
            warner();
            return propertyValue_1;
        };
        if (descriptor.writable) deprecatedDescriptor.set = function(value) {
            warner();
            propertyValue_1 = value;
        };
    }
    return deprecatedDescriptor;
}
function $d44d6aab074f7c0d$var$decorateFunction(type, target, alternative, version, url) {
    var name = target.name;
    var warner = (module.exports.options.getWarner || $d44d6aab074f7c0d$var$createWarner)(type, name, alternative, version, url);
    var fn = function() {
        warner();
        return target.apply(this, arguments);
    };
    for(var _i = 0, _a = Object.getOwnPropertyNames(target); _i < _a.length; _i++){
        var propertyName = _a[_i];
        var descriptor = Object.getOwnPropertyDescriptor(target, propertyName);
        if (descriptor.writable) fn[propertyName] = target[propertyName];
        else if (descriptor.configurable) Object.defineProperty(fn, propertyName, descriptor);
    }
    return fn;
}
function $d44d6aab074f7c0d$var$deprecated() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
    var fn = args[args.length - 1];
    if (typeof fn === 'function') fn = args.pop();
    else fn = undefined;
    var options = args[0];
    var alternative;
    var version;
    var url;
    if (typeof options === 'string') {
        alternative = options;
        version = args[1];
        url = args[2];
    } else if (options) alternative = options.alternative, version = options.version, url = options.url, options;
    if (fn) return $d44d6aab074f7c0d$var$decorateFunction('function', fn, alternative, version, url);
    return function(target, name, descriptor) {
        if (typeof name === 'string') {
            var type = descriptor && typeof descriptor.value === 'function' ? 'method' : 'property';
            return $d44d6aab074f7c0d$var$decorateProperty(type, name, descriptor, alternative, version, url);
        } else if (typeof target === 'function') {
            var constructor = $d44d6aab074f7c0d$var$decorateFunction('class', target, alternative, version, url);
            var className = target.name;
            for(var _i = 0, _a = Object.getOwnPropertyNames(constructor); _i < _a.length; _i++){
                var propertyName = _a[_i];
                var descriptor_1 = Object.getOwnPropertyDescriptor(constructor, propertyName);
                descriptor_1 = $d44d6aab074f7c0d$var$decorateProperty('class', className, descriptor_1, alternative, version, url);
                if (descriptor_1.writable) constructor[propertyName] = target[propertyName];
                else if (descriptor_1.configurable) Object.defineProperty(constructor, propertyName, descriptor_1);
            }
            return constructor;
        }
    };
}
module.exports.deprecated = $d44d6aab074f7c0d$var$deprecated;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d44d6aab074f7c0d$var$deprecated;

});


parcelRegister("kYZ7H", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gUA8G = parcelRequire("gUA8G");
var $glHRe = parcelRequire("glHRe");
var $6ds0g = parcelRequire("6ds0g");

var $cYGSS = parcelRequire("cYGSS");

var $9Dtw4 = parcelRequire("9Dtw4");
function $f468d303274a5a69$var$buildSchemaFromTypeDefinitions(typeDefinitions, parseOptions) {
    // TODO: accept only array here, otherwise interfaces get confusing.
    var myDefinitions = typeDefinitions;
    var astDocument;
    if ($f468d303274a5a69$var$isDocumentNode(typeDefinitions)) astDocument = typeDefinitions;
    else if (typeof myDefinitions !== 'string') {
        if (!Array.isArray(myDefinitions)) {
            var type = typeof myDefinitions;
            throw new $cYGSS.SchemaError("typeDefs must be a string, array or schema AST, got " + type);
        }
        myDefinitions = $cYGSS.concatenateTypeDefs(myDefinitions);
    }
    if (typeof myDefinitions === 'string') astDocument = $6ds0g.parse(myDefinitions, parseOptions);
    var backcompatOptions = {
        commentDescriptions: true
    };
    var typesAst = $9Dtw4.default(astDocument);
    // TODO fix types https://github.com/apollographql/graphql-tools/issues/542
    var schema = $gUA8G.buildASTSchema(typesAst, backcompatOptions);
    var extensionsAst = $cYGSS.extractExtensionDefinitions(astDocument);
    if (extensionsAst.definitions.length > 0) // TODO fix types https://github.com/apollographql/graphql-tools/issues/542
    schema = $glHRe.extendSchema(schema, extensionsAst, backcompatOptions);
    return schema;
}
function $f468d303274a5a69$var$isDocumentNode(typeDefinitions) {
    return typeDefinitions.kind !== undefined;
}
module.exports.default = $f468d303274a5a69$var$buildSchemaFromTypeDefinitions;

});
parcelRegister("gUA8G", function(module, exports) {

$parcel$export(module.exports, "buildASTSchema", () => $7def873e387d0baa$export$25eeb85cb306d87);
$parcel$export(module.exports, "buildSchema", () => $7def873e387d0baa$export$f668ee82107a74bd);

var $fZdRY = parcelRequire("fZdRY");

var $1c4hI = parcelRequire("1c4hI");

var $6ds0g = parcelRequire("6ds0g");

var $dGflO = parcelRequire("dGflO");

var $6BdRO = parcelRequire("6BdRO");

var $bOniD = parcelRequire("bOniD");

var $glHRe = parcelRequire("glHRe");
function $7def873e387d0baa$export$25eeb85cb306d87(documentAST, options) {
    documentAST != null && documentAST.kind === (0, $1c4hI.Kind).DOCUMENT || (0, $fZdRY.default)(0, 'Must provide valid Document AST.');
    if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) (0, $dGflO.assertValidSDL)(documentAST);
    var emptySchemaConfig = {
        description: undefined,
        types: [],
        directives: [],
        extensions: undefined,
        extensionASTNodes: [],
        assumeValid: false
    };
    var config = (0, $glHRe.extendSchemaImpl)(emptySchemaConfig, documentAST, options);
    if (config.astNode == null) for(var _i2 = 0, _config$types2 = config.types; _i2 < _config$types2.length; _i2++){
        var type = _config$types2[_i2];
        switch(type.name){
            // Note: While this could make early assertions to get the correctly
            // typed values below, that would throw immediately while type system
            // validation with validateSchema() will produce more actionable results.
            case 'Query':
                config.query = type;
                break;
            case 'Mutation':
                config.mutation = type;
                break;
            case 'Subscription':
                config.subscription = type;
                break;
        }
    }
    var directives = config.directives; // If specified directives were not explicitly declared, add them.
    var _loop = function _loop(_i4) {
        var stdDirective = (0, $bOniD.specifiedDirectives)[_i4];
        if (directives.every(function(directive) {
            return directive.name !== stdDirective.name;
        })) directives.push(stdDirective);
    };
    for(var _i4 = 0; _i4 < (0, $bOniD.specifiedDirectives).length; _i4++)_loop(_i4);
    return new (0, $6BdRO.GraphQLSchema)(config);
}
function $7def873e387d0baa$export$f668ee82107a74bd(source, options) {
    var document = (0, $6ds0g.parse)(source, {
        noLocation: options === null || options === void 0 ? void 0 : options.noLocation,
        allowLegacySDLEmptyFields: options === null || options === void 0 ? void 0 : options.allowLegacySDLEmptyFields,
        allowLegacySDLImplementsInterfaces: options === null || options === void 0 ? void 0 : options.allowLegacySDLImplementsInterfaces,
        experimentalFragmentVariables: options === null || options === void 0 ? void 0 : options.experimentalFragmentVariables
    });
    return $7def873e387d0baa$export$25eeb85cb306d87(document, {
        commentDescriptions: options === null || options === void 0 ? void 0 : options.commentDescriptions,
        assumeValidSDL: options === null || options === void 0 ? void 0 : options.assumeValidSDL,
        assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
    });
}

});
parcelRegister("dGflO", function(module, exports) {

$parcel$export(module.exports, "validate", () => $2cc2c5fa39eae947$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "assertValidSDL", () => $2cc2c5fa39eae947$export$e53e4d7168bd6d92);
$parcel$export(module.exports, "assertValidSDLExtension", () => $2cc2c5fa39eae947$export$9917845776f624a4);

var $fZdRY = parcelRequire("fZdRY");

var $9fgMZ = parcelRequire("9fgMZ");

var $961BR = parcelRequire("961BR");

var $izaFt = parcelRequire("izaFt");

var $hMOry = parcelRequire("hMOry");

var $k6EZ2 = parcelRequire("k6EZ2");

var $5RV6E = parcelRequire("5RV6E");
function $2cc2c5fa39eae947$export$a22775fa5e2eebd9(schema, documentAST) {
    var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $k6EZ2.specifiedRules);
    var typeInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new (0, $hMOry.TypeInfo)(schema);
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        maxErrors: undefined
    };
    documentAST || (0, $fZdRY.default)(0, 'Must provide document.'); // If the schema used for validation is invalid, throw an error.
    (0, $izaFt.assertValidSchema)(schema);
    var abortObj = Object.freeze({});
    var errors = [];
    var context = new (0, $5RV6E.ValidationContext)(schema, documentAST, typeInfo, function(error) {
        if (options.maxErrors != null && errors.length >= options.maxErrors) {
            errors.push(new (0, $9fgMZ.GraphQLError)('Too many validation errors, error limit reached. Validation aborted.'));
            throw abortObj;
        }
        errors.push(error);
    }); // This uses a specialized visitor which runs multiple visitors in parallel,
    // while maintaining the visitor skip and break API.
    var visitor = (0, $961BR.visitInParallel)(rules.map(function(rule) {
        return rule(context);
    })); // Visit the whole document with each instance of all provided rules.
    try {
        (0, $961BR.visit)(documentAST, (0, $hMOry.visitWithTypeInfo)(typeInfo, visitor));
    } catch (e) {
        if (e !== abortObj) throw e;
    }
    return errors;
}
function $2cc2c5fa39eae947$export$664b3e1af4fc59b0(documentAST, schemaToExtend) {
    var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $k6EZ2.specifiedSDLRules);
    var errors = [];
    var context = new (0, $5RV6E.SDLValidationContext)(documentAST, schemaToExtend, function(error) {
        errors.push(error);
    });
    var visitors = rules.map(function(rule) {
        return rule(context);
    });
    (0, $961BR.visit)(documentAST, (0, $961BR.visitInParallel)(visitors));
    return errors;
}
function $2cc2c5fa39eae947$export$e53e4d7168bd6d92(documentAST) {
    var errors = $2cc2c5fa39eae947$export$664b3e1af4fc59b0(documentAST);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}
function $2cc2c5fa39eae947$export$9917845776f624a4(documentAST, schema) {
    var errors = $2cc2c5fa39eae947$export$664b3e1af4fc59b0(documentAST, schema);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}

});
parcelRegister("hMOry", function(module, exports) {

$parcel$export(module.exports, "TypeInfo", () => $3a9a642677abfb9d$export$f0c1fe746ce4bb1e);
$parcel$export(module.exports, "visitWithTypeInfo", () => $3a9a642677abfb9d$export$18ca434620348336);

var $bmIpK = parcelRequire("bmIpK");

var $1c4hI = parcelRequire("1c4hI");

var $c8MIO = parcelRequire("c8MIO");

var $961BR = parcelRequire("961BR");

var $lXoEQ = parcelRequire("lXoEQ");

var $h2iUh = parcelRequire("h2iUh");

var $3zSAT = parcelRequire("3zSAT");
var $3a9a642677abfb9d$export$f0c1fe746ce4bb1e = /*#__PURE__*/ function() {
    function TypeInfo(schema, // to support non-spec-compliant code bases. You should never need to use it.
    // It may disappear in the future.
    getFieldDefFn, // beginning somewhere other than documents.
    initialType) {
        this._schema = schema;
        this._typeStack = [];
        this._parentTypeStack = [];
        this._inputTypeStack = [];
        this._fieldDefStack = [];
        this._defaultValueStack = [];
        this._directive = null;
        this._argument = null;
        this._enumValue = null;
        this._getFieldDef = getFieldDefFn !== null && getFieldDefFn !== void 0 ? getFieldDefFn : $3a9a642677abfb9d$var$getFieldDef;
        if (initialType) {
            if ((0, $lXoEQ.isInputType)(initialType)) this._inputTypeStack.push(initialType);
            if ((0, $lXoEQ.isCompositeType)(initialType)) this._parentTypeStack.push(initialType);
            if ((0, $lXoEQ.isOutputType)(initialType)) this._typeStack.push(initialType);
        }
    }
    var _proto = TypeInfo.prototype;
    _proto.getType = function getType() {
        if (this._typeStack.length > 0) return this._typeStack[this._typeStack.length - 1];
    };
    _proto.getParentType = function getParentType() {
        if (this._parentTypeStack.length > 0) return this._parentTypeStack[this._parentTypeStack.length - 1];
    };
    _proto.getInputType = function getInputType() {
        if (this._inputTypeStack.length > 0) return this._inputTypeStack[this._inputTypeStack.length - 1];
    };
    _proto.getParentInputType = function getParentInputType() {
        if (this._inputTypeStack.length > 1) return this._inputTypeStack[this._inputTypeStack.length - 2];
    };
    _proto.getFieldDef = function getFieldDef() {
        if (this._fieldDefStack.length > 0) return this._fieldDefStack[this._fieldDefStack.length - 1];
    };
    _proto.getDefaultValue = function getDefaultValue() {
        if (this._defaultValueStack.length > 0) return this._defaultValueStack[this._defaultValueStack.length - 1];
    };
    _proto.getDirective = function getDirective() {
        return this._directive;
    };
    _proto.getArgument = function getArgument() {
        return this._argument;
    };
    _proto.getEnumValue = function getEnumValue() {
        return this._enumValue;
    };
    _proto.enter = function enter(node) {
        var schema = this._schema; // Note: many of the types below are explicitly typed as "mixed" to drop
        // any assumptions of a valid schema to ensure runtime types are properly
        // checked before continuing since TypeInfo is used as part of validation
        // which occurs before guarantees of schema and document validity.
        switch(node.kind){
            case (0, $1c4hI.Kind).SELECTION_SET:
                var namedType = (0, $lXoEQ.getNamedType)(this.getType());
                this._parentTypeStack.push((0, $lXoEQ.isCompositeType)(namedType) ? namedType : undefined);
                break;
            case (0, $1c4hI.Kind).FIELD:
                var parentType = this.getParentType();
                var fieldDef;
                var fieldType;
                if (parentType) {
                    fieldDef = this._getFieldDef(schema, parentType, node);
                    if (fieldDef) fieldType = fieldDef.type;
                }
                this._fieldDefStack.push(fieldDef);
                this._typeStack.push((0, $lXoEQ.isOutputType)(fieldType) ? fieldType : undefined);
                break;
            case (0, $1c4hI.Kind).DIRECTIVE:
                this._directive = schema.getDirective(node.name.value);
                break;
            case (0, $1c4hI.Kind).OPERATION_DEFINITION:
                var type;
                switch(node.operation){
                    case 'query':
                        type = schema.getQueryType();
                        break;
                    case 'mutation':
                        type = schema.getMutationType();
                        break;
                    case 'subscription':
                        type = schema.getSubscriptionType();
                        break;
                }
                this._typeStack.push((0, $lXoEQ.isObjectType)(type) ? type : undefined);
                break;
            case (0, $1c4hI.Kind).INLINE_FRAGMENT:
            case (0, $1c4hI.Kind).FRAGMENT_DEFINITION:
                var typeConditionAST = node.typeCondition;
                var outputType = typeConditionAST ? (0, $3zSAT.typeFromAST)(schema, typeConditionAST) : (0, $lXoEQ.getNamedType)(this.getType());
                this._typeStack.push((0, $lXoEQ.isOutputType)(outputType) ? outputType : undefined);
                break;
            case (0, $1c4hI.Kind).VARIABLE_DEFINITION:
                var inputType = (0, $3zSAT.typeFromAST)(schema, node.type);
                this._inputTypeStack.push((0, $lXoEQ.isInputType)(inputType) ? inputType : undefined);
                break;
            case (0, $1c4hI.Kind).ARGUMENT:
                var _this$getDirective;
                var argDef;
                var argType;
                var fieldOrDirective = (_this$getDirective = this.getDirective()) !== null && _this$getDirective !== void 0 ? _this$getDirective : this.getFieldDef();
                if (fieldOrDirective) {
                    argDef = (0, $bmIpK.default)(fieldOrDirective.args, function(arg) {
                        return arg.name === node.name.value;
                    });
                    if (argDef) argType = argDef.type;
                }
                this._argument = argDef;
                this._defaultValueStack.push(argDef ? argDef.defaultValue : undefined);
                this._inputTypeStack.push((0, $lXoEQ.isInputType)(argType) ? argType : undefined);
                break;
            case (0, $1c4hI.Kind).LIST:
                var listType = (0, $lXoEQ.getNullableType)(this.getInputType());
                var itemType = (0, $lXoEQ.isListType)(listType) ? listType.ofType : listType; // List positions never have a default value.
                this._defaultValueStack.push(undefined);
                this._inputTypeStack.push((0, $lXoEQ.isInputType)(itemType) ? itemType : undefined);
                break;
            case (0, $1c4hI.Kind).OBJECT_FIELD:
                var objectType = (0, $lXoEQ.getNamedType)(this.getInputType());
                var inputFieldType;
                var inputField;
                if ((0, $lXoEQ.isInputObjectType)(objectType)) {
                    inputField = objectType.getFields()[node.name.value];
                    if (inputField) inputFieldType = inputField.type;
                }
                this._defaultValueStack.push(inputField ? inputField.defaultValue : undefined);
                this._inputTypeStack.push((0, $lXoEQ.isInputType)(inputFieldType) ? inputFieldType : undefined);
                break;
            case (0, $1c4hI.Kind).ENUM:
                var enumType = (0, $lXoEQ.getNamedType)(this.getInputType());
                var enumValue;
                if ((0, $lXoEQ.isEnumType)(enumType)) enumValue = enumType.getValue(node.value);
                this._enumValue = enumValue;
                break;
        }
    };
    _proto.leave = function leave(node) {
        switch(node.kind){
            case (0, $1c4hI.Kind).SELECTION_SET:
                this._parentTypeStack.pop();
                break;
            case (0, $1c4hI.Kind).FIELD:
                this._fieldDefStack.pop();
                this._typeStack.pop();
                break;
            case (0, $1c4hI.Kind).DIRECTIVE:
                this._directive = null;
                break;
            case (0, $1c4hI.Kind).OPERATION_DEFINITION:
            case (0, $1c4hI.Kind).INLINE_FRAGMENT:
            case (0, $1c4hI.Kind).FRAGMENT_DEFINITION:
                this._typeStack.pop();
                break;
            case (0, $1c4hI.Kind).VARIABLE_DEFINITION:
                this._inputTypeStack.pop();
                break;
            case (0, $1c4hI.Kind).ARGUMENT:
                this._argument = null;
                this._defaultValueStack.pop();
                this._inputTypeStack.pop();
                break;
            case (0, $1c4hI.Kind).LIST:
            case (0, $1c4hI.Kind).OBJECT_FIELD:
                this._defaultValueStack.pop();
                this._inputTypeStack.pop();
                break;
            case (0, $1c4hI.Kind).ENUM:
                this._enumValue = null;
                break;
        }
    };
    return TypeInfo;
}();
/**
 * Not exactly the same as the executor's definition of getFieldDef, in this
 * statically evaluated environment we do not always have an Object type,
 * and need to handle Interface and Union types.
 */ function $3a9a642677abfb9d$var$getFieldDef(schema, parentType, fieldNode) {
    var name = fieldNode.name.value;
    if (name === (0, $h2iUh.SchemaMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $h2iUh.SchemaMetaFieldDef;
    if (name === (0, $h2iUh.TypeMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $h2iUh.TypeMetaFieldDef;
    if (name === (0, $h2iUh.TypeNameMetaFieldDef).name && (0, $lXoEQ.isCompositeType)(parentType)) return 0, $h2iUh.TypeNameMetaFieldDef;
    if ((0, $lXoEQ.isObjectType)(parentType) || (0, $lXoEQ.isInterfaceType)(parentType)) return parentType.getFields()[name];
}
function $3a9a642677abfb9d$export$18ca434620348336(typeInfo, visitor) {
    return {
        enter: function enter(node) {
            typeInfo.enter(node);
            var fn = (0, $961BR.getVisitFn)(visitor, node.kind, /* isLeaving */ false);
            if (fn) {
                var result = fn.apply(visitor, arguments);
                if (result !== undefined) {
                    typeInfo.leave(node);
                    if ((0, $c8MIO.isNode)(result)) typeInfo.enter(result);
                }
                return result;
            }
        },
        leave: function leave(node) {
            var fn = (0, $961BR.getVisitFn)(visitor, node.kind, /* isLeaving */ true);
            var result;
            if (fn) result = fn.apply(visitor, arguments);
            typeInfo.leave(node);
            return result;
        }
    };
}

});

parcelRegister("k6EZ2", function(module, exports) {

$parcel$export(module.exports, "specifiedRules", () => $1607320a9964483f$export$ac8e8f03d4e8a76c);
$parcel$export(module.exports, "specifiedSDLRules", () => $1607320a9964483f$export$117d63808a280985);
// Spec Section: "Executable Definitions"

var $aqW0R = parcelRequire("aqW0R");

var $2GDYp = parcelRequire("2GDYp");

var $O3j40 = parcelRequire("O3j40");

var $ldBEm = parcelRequire("ldBEm");

var $6e5RT = parcelRequire("6e5RT");

var $czW5Z = parcelRequire("czW5Z");

var $3Rll6 = parcelRequire("3Rll6");

var $d8bud = parcelRequire("d8bud");

var $hRE8v = parcelRequire("hRE8v");

var $alcPf = parcelRequire("alcPf");

var $50e65 = parcelRequire("50e65");

var $lajJ7 = parcelRequire("lajJ7");

var $rkd39 = parcelRequire("rkd39");

var $bRsXY = parcelRequire("bRsXY");

var $b6uMB = parcelRequire("b6uMB");

var $8zYa7 = parcelRequire("8zYa7");

var $5k1Qg = parcelRequire("5k1Qg");

var $loWoH = parcelRequire("loWoH");

var $is7or = parcelRequire("is7or");

var $gGl3W = parcelRequire("gGl3W");

var $kXrJO = parcelRequire("kXrJO");

var $bhI3j = parcelRequire("bhI3j");

var $bN26g = parcelRequire("bN26g");

var $gnP1U = parcelRequire("gnP1U");

var $h0Hyz = parcelRequire("h0Hyz");

var $1W7Gt = parcelRequire("1W7Gt");

var $gawpj = parcelRequire("gawpj");

var $b8axV = parcelRequire("b8axV");

var $lOmVT = parcelRequire("lOmVT");

var $1H4NC = parcelRequire("1H4NC");

var $lVZ4j = parcelRequire("lVZ4j");

var $jCJ2v = parcelRequire("jCJ2v");

var $kJWSQ = parcelRequire("kJWSQ");
var $1607320a9964483f$export$ac8e8f03d4e8a76c = Object.freeze([
    (0, $aqW0R.ExecutableDefinitionsRule),
    (0, $2GDYp.UniqueOperationNamesRule),
    (0, $O3j40.LoneAnonymousOperationRule),
    (0, $ldBEm.SingleFieldSubscriptionsRule),
    (0, $6e5RT.KnownTypeNamesRule),
    (0, $czW5Z.FragmentsOnCompositeTypesRule),
    (0, $3Rll6.VariablesAreInputTypesRule),
    (0, $d8bud.ScalarLeafsRule),
    (0, $hRE8v.FieldsOnCorrectTypeRule),
    (0, $alcPf.UniqueFragmentNamesRule),
    (0, $50e65.KnownFragmentNamesRule),
    (0, $lajJ7.NoUnusedFragmentsRule),
    (0, $rkd39.PossibleFragmentSpreadsRule),
    (0, $bRsXY.NoFragmentCyclesRule),
    (0, $b6uMB.UniqueVariableNamesRule),
    (0, $8zYa7.NoUndefinedVariablesRule),
    (0, $5k1Qg.NoUnusedVariablesRule),
    (0, $loWoH.KnownDirectivesRule),
    (0, $is7or.UniqueDirectivesPerLocationRule),
    (0, $gGl3W.KnownArgumentNamesRule),
    (0, $kXrJO.UniqueArgumentNamesRule),
    (0, $bhI3j.ValuesOfCorrectTypeRule),
    (0, $bN26g.ProvidedRequiredArgumentsRule),
    (0, $gnP1U.VariablesInAllowedPositionRule),
    (0, $h0Hyz.OverlappingFieldsCanBeMergedRule),
    (0, $1W7Gt.UniqueInputFieldNamesRule)
]);
var $1607320a9964483f$export$117d63808a280985 = Object.freeze([
    (0, $gawpj.LoneSchemaDefinitionRule),
    (0, $b8axV.UniqueOperationTypesRule),
    (0, $lOmVT.UniqueTypeNamesRule),
    (0, $1H4NC.UniqueEnumValueNamesRule),
    (0, $lVZ4j.UniqueFieldDefinitionNamesRule),
    (0, $jCJ2v.UniqueDirectiveNamesRule),
    (0, $6e5RT.KnownTypeNamesRule),
    (0, $loWoH.KnownDirectivesRule),
    (0, $is7or.UniqueDirectivesPerLocationRule),
    (0, $kJWSQ.PossibleTypeExtensionsRule),
    (0, $gGl3W.KnownArgumentNamesOnDirectivesRule),
    (0, $kXrJO.UniqueArgumentNamesRule),
    (0, $1W7Gt.UniqueInputFieldNamesRule),
    (0, $bN26g.ProvidedRequiredArgumentsOnDirectivesRule)
]);

});
parcelRegister("aqW0R", function(module, exports) {

$parcel$export(module.exports, "ExecutableDefinitionsRule", () => $3f76dad52af02d86$export$c3d3637a3c3c605e);

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $9nArG = parcelRequire("9nArG");
function $3f76dad52af02d86$export$c3d3637a3c3c605e(context) {
    return {
        Document: function Document(node) {
            for(var _i2 = 0, _node$definitions2 = node.definitions; _i2 < _node$definitions2.length; _i2++){
                var definition = _node$definitions2[_i2];
                if (!(0, $9nArG.isExecutableDefinitionNode)(definition)) {
                    var defName = definition.kind === (0, $1c4hI.Kind).SCHEMA_DEFINITION || definition.kind === (0, $1c4hI.Kind).SCHEMA_EXTENSION ? 'schema' : '"' + definition.name.value + '"';
                    context.reportError(new (0, $9fgMZ.GraphQLError)("The ".concat(defName, " definition is not executable."), definition));
                }
            }
            return false;
        }
    };
}

});
parcelRegister("9nArG", function(module, exports) {

$parcel$export(module.exports, "isExecutableDefinitionNode", () => $6727414c23a41723$export$4cedd8740794bd78);
$parcel$export(module.exports, "isTypeSystemDefinitionNode", () => $6727414c23a41723$export$b05c7141ec7770ba);
$parcel$export(module.exports, "isTypeSystemExtensionNode", () => $6727414c23a41723$export$fbc18e88163d676d);
$parcel$export(module.exports, "isSelectionNode", () => $6727414c23a41723$export$65772b71e1d017ba);
$parcel$export(module.exports, "isTypeDefinitionNode", () => $6727414c23a41723$export$a3584bba04f5bfe0);
$parcel$export(module.exports, "isTypeExtensionNode", () => $6727414c23a41723$export$d7907721b241e11f);

var $1c4hI = parcelRequire("1c4hI");
function $6727414c23a41723$export$e7ecd7c16613ccfd(node) {
    return $6727414c23a41723$export$4cedd8740794bd78(node) || $6727414c23a41723$export$b05c7141ec7770ba(node) || $6727414c23a41723$export$fbc18e88163d676d(node);
}
function $6727414c23a41723$export$4cedd8740794bd78(node) {
    return node.kind === (0, $1c4hI.Kind).OPERATION_DEFINITION || node.kind === (0, $1c4hI.Kind).FRAGMENT_DEFINITION;
}
function $6727414c23a41723$export$65772b71e1d017ba(node) {
    return node.kind === (0, $1c4hI.Kind).FIELD || node.kind === (0, $1c4hI.Kind).FRAGMENT_SPREAD || node.kind === (0, $1c4hI.Kind).INLINE_FRAGMENT;
}
function $6727414c23a41723$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $1c4hI.Kind).VARIABLE || node.kind === (0, $1c4hI.Kind).INT || node.kind === (0, $1c4hI.Kind).FLOAT || node.kind === (0, $1c4hI.Kind).STRING || node.kind === (0, $1c4hI.Kind).BOOLEAN || node.kind === (0, $1c4hI.Kind).NULL || node.kind === (0, $1c4hI.Kind).ENUM || node.kind === (0, $1c4hI.Kind).LIST || node.kind === (0, $1c4hI.Kind).OBJECT;
}
function $6727414c23a41723$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $1c4hI.Kind).NAMED_TYPE || node.kind === (0, $1c4hI.Kind).LIST_TYPE || node.kind === (0, $1c4hI.Kind).NON_NULL_TYPE;
}
function $6727414c23a41723$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $1c4hI.Kind).SCHEMA_DEFINITION || $6727414c23a41723$export$a3584bba04f5bfe0(node) || node.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION;
}
function $6727414c23a41723$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).UNION_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION;
}
function $6727414c23a41723$export$fbc18e88163d676d(node) {
    return node.kind === (0, $1c4hI.Kind).SCHEMA_EXTENSION || $6727414c23a41723$export$d7907721b241e11f(node);
}
function $6727414c23a41723$export$d7907721b241e11f(node) {
    return node.kind === (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).UNION_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION;
}

});


parcelRegister("2GDYp", function(module, exports) {

$parcel$export(module.exports, "UniqueOperationNamesRule", () => $88c36e73ececd949$export$a40a702cd7ad2eae);

var $9fgMZ = parcelRequire("9fgMZ");
function $88c36e73ececd949$export$a40a702cd7ad2eae(context) {
    var knownOperationNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition(node) {
            var operationName = node.name;
            if (operationName) {
                if (knownOperationNames[operationName.value]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one operation named \"".concat(operationName.value, "\"."), [
                    knownOperationNames[operationName.value],
                    operationName
                ]));
                else knownOperationNames[operationName.value] = operationName;
            }
            return false;
        },
        FragmentDefinition: function FragmentDefinition() {
            return false;
        }
    };
}

});

parcelRegister("O3j40", function(module, exports) {

$parcel$export(module.exports, "LoneAnonymousOperationRule", () => $6e91d6c02aeb4125$export$3a79c63c3de7a55f);

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");
function $6e91d6c02aeb4125$export$3a79c63c3de7a55f(context) {
    var operationCount = 0;
    return {
        Document: function Document(node) {
            operationCount = node.definitions.filter(function(definition) {
                return definition.kind === (0, $1c4hI.Kind).OPERATION_DEFINITION;
            }).length;
        },
        OperationDefinition: function OperationDefinition(node) {
            if (!node.name && operationCount > 1) context.reportError(new (0, $9fgMZ.GraphQLError)('This anonymous operation must be the only defined operation.', node));
        }
    };
}

});

parcelRegister("ldBEm", function(module, exports) {

$parcel$export(module.exports, "SingleFieldSubscriptionsRule", () => $870ac591d38eb8ac$export$477fa0c787c0222d);

var $9fgMZ = parcelRequire("9fgMZ");
function $870ac591d38eb8ac$export$477fa0c787c0222d(context) {
    return {
        OperationDefinition: function OperationDefinition(node) {
            if (node.operation === 'subscription') {
                if (node.selectionSet.selections.length !== 1) context.reportError(new (0, $9fgMZ.GraphQLError)(node.name ? "Subscription \"".concat(node.name.value, "\" must select only one top level field.") : 'Anonymous Subscription must select only one top level field.', node.selectionSet.selections.slice(1)));
            }
        }
    };
}

});

parcelRegister("6e5RT", function(module, exports) {

$parcel$export(module.exports, "KnownTypeNamesRule", () => $30acddca3c136894$export$2317edbae2efecbd);

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $9nArG = parcelRequire("9nArG");

var $auu22 = parcelRequire("auu22");

var $h2iUh = parcelRequire("h2iUh");
function $30acddca3c136894$export$2317edbae2efecbd(context) {
    var schema = context.getSchema();
    var existingTypesMap = schema ? schema.getTypeMap() : Object.create(null);
    var definedTypes = Object.create(null);
    for(var _i2 = 0, _context$getDocument$2 = context.getDocument().definitions; _i2 < _context$getDocument$2.length; _i2++){
        var def = _context$getDocument$2[_i2];
        if ((0, $9nArG.isTypeDefinitionNode)(def)) definedTypes[def.name.value] = true;
    }
    var typeNames = Object.keys(existingTypesMap).concat(Object.keys(definedTypes));
    return {
        NamedType: function NamedType(node, _1, parent, _2, ancestors) {
            var typeName = node.name.value;
            if (!existingTypesMap[typeName] && !definedTypes[typeName]) {
                var _ancestors$;
                var definitionNode = (_ancestors$ = ancestors[2]) !== null && _ancestors$ !== void 0 ? _ancestors$ : parent;
                var isSDL = definitionNode != null && $30acddca3c136894$var$isSDLNode(definitionNode);
                if (isSDL && $30acddca3c136894$var$isStandardTypeName(typeName)) return;
                var suggestedTypes = (0, $bru1k.default)(typeName, isSDL ? $30acddca3c136894$var$standardTypeNames.concat(typeNames) : typeNames);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown type \"".concat(typeName, "\".") + (0, $8nBnZ.default)(suggestedTypes), node));
            }
        }
    };
}
var $30acddca3c136894$var$standardTypeNames = [].concat((0, $auu22.specifiedScalarTypes), (0, $h2iUh.introspectionTypes)).map(function(type) {
    return type.name;
});
function $30acddca3c136894$var$isStandardTypeName(typeName) {
    return $30acddca3c136894$var$standardTypeNames.indexOf(typeName) !== -1;
}
function $30acddca3c136894$var$isSDLNode(value) {
    return !Array.isArray(value) && ((0, $9nArG.isTypeSystemDefinitionNode)(value) || (0, $9nArG.isTypeSystemExtensionNode)(value));
}

});

parcelRegister("czW5Z", function(module, exports) {

$parcel$export(module.exports, "FragmentsOnCompositeTypesRule", () => $f80cba82208a6444$export$cb5241ba71fd55e0);

var $9fgMZ = parcelRequire("9fgMZ");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");
function $f80cba82208a6444$export$cb5241ba71fd55e0(context) {
    return {
        InlineFragment: function InlineFragment(node) {
            var typeCondition = node.typeCondition;
            if (typeCondition) {
                var type = (0, $3zSAT.typeFromAST)(context.getSchema(), typeCondition);
                if (type && !(0, $lXoEQ.isCompositeType)(type)) {
                    var typeStr = (0, $aKlnM.print)(typeCondition);
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment cannot condition on non composite type \"".concat(typeStr, "\"."), typeCondition));
                }
            }
        },
        FragmentDefinition: function FragmentDefinition(node) {
            var type = (0, $3zSAT.typeFromAST)(context.getSchema(), node.typeCondition);
            if (type && !(0, $lXoEQ.isCompositeType)(type)) {
                var typeStr = (0, $aKlnM.print)(node.typeCondition);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment \"".concat(node.name.value, "\" cannot condition on non composite type \"").concat(typeStr, "\"."), node.typeCondition));
            }
        }
    };
}

});

parcelRegister("3Rll6", function(module, exports) {

$parcel$export(module.exports, "VariablesAreInputTypesRule", () => $ab1cf3b33f18ed8d$export$f20a29632b437591);

var $9fgMZ = parcelRequire("9fgMZ");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");
function $ab1cf3b33f18ed8d$export$f20a29632b437591(context) {
    return {
        VariableDefinition: function VariableDefinition(node) {
            var type = (0, $3zSAT.typeFromAST)(context.getSchema(), node.type);
            if (type && !(0, $lXoEQ.isInputType)(type)) {
                var variableName = node.variable.name.value;
                var typeName = (0, $aKlnM.print)(node.type);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(variableName, "\" cannot be non-input type \"").concat(typeName, "\"."), node.type));
            }
        }
    };
}

});

parcelRegister("d8bud", function(module, exports) {

$parcel$export(module.exports, "ScalarLeafsRule", () => $df259c4803cc1d81$export$d779f66f65c88b9a);

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $df259c4803cc1d81$export$d779f66f65c88b9a(context) {
    return {
        Field: function Field(node) {
            var type = context.getType();
            var selectionSet = node.selectionSet;
            if (type) {
                if ((0, $lXoEQ.isLeafType)((0, $lXoEQ.getNamedType)(type))) {
                    if (selectionSet) {
                        var fieldName = node.name.value;
                        var typeStr = (0, $biK02.default)(type);
                        context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(fieldName, "\" must not have a selection since type \"").concat(typeStr, "\" has no subfields."), selectionSet));
                    }
                } else if (!selectionSet) {
                    var _fieldName = node.name.value;
                    var _typeStr = (0, $biK02.default)(type);
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(_fieldName, "\" of type \"").concat(_typeStr, "\" must have a selection of subfields. Did you mean \"").concat(_fieldName, " { ... }\"?"), node));
                }
            }
        }
    };
}

});

parcelRegister("hRE8v", function(module, exports) {

$parcel$export(module.exports, "FieldsOnCorrectTypeRule", () => $ab2475b39bd43e66$export$595e5c0bf2d10a85);

var $96Cqc = parcelRequire("96Cqc");

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $daK4l = parcelRequire("daK4l");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $ab2475b39bd43e66$export$595e5c0bf2d10a85(context) {
    return {
        Field: function Field(node) {
            var type = context.getParentType();
            if (type) {
                var fieldDef = context.getFieldDef();
                if (!fieldDef) {
                    // This field doesn't exist, lets look for suggestions.
                    var schema = context.getSchema();
                    var fieldName = node.name.value; // First determine if there are any suggested types to condition on.
                    var suggestion = (0, $8nBnZ.default)('to use an inline fragment on', $ab2475b39bd43e66$var$getSuggestedTypeNames(schema, type, fieldName)); // If there are no suggested types, then perhaps this was a typo?
                    if (suggestion === '') suggestion = (0, $8nBnZ.default)($ab2475b39bd43e66$var$getSuggestedFieldNames(type, fieldName));
                     // Report an error, including helpful suggestions.
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Cannot query field \"".concat(fieldName, "\" on type \"").concat(type.name, "\".") + suggestion, node));
                }
            }
        }
    };
}
/**
 * Go through all of the implementations of type, as well as the interfaces that
 * they implement. If any of those types include the provided field, suggest them,
 * sorted by how often the type is referenced.
 */ function $ab2475b39bd43e66$var$getSuggestedTypeNames(schema, type, fieldName) {
    if (!(0, $lXoEQ.isAbstractType)(type)) // Must be an Object type, which does not have possible fields.
    return [];
    var suggestedTypes = new Set();
    var usageCount = Object.create(null);
    for(var _i2 = 0, _schema$getPossibleTy2 = schema.getPossibleTypes(type); _i2 < _schema$getPossibleTy2.length; _i2++){
        var possibleType = _schema$getPossibleTy2[_i2];
        if (!possibleType.getFields()[fieldName]) continue;
         // This object type defines this field.
        suggestedTypes.add(possibleType);
        usageCount[possibleType.name] = 1;
        for(var _i4 = 0, _possibleType$getInte2 = possibleType.getInterfaces(); _i4 < _possibleType$getInte2.length; _i4++){
            var _usageCount$possibleI;
            var possibleInterface = _possibleType$getInte2[_i4];
            if (!possibleInterface.getFields()[fieldName]) continue;
             // This interface type defines this field.
            suggestedTypes.add(possibleInterface);
            usageCount[possibleInterface.name] = ((_usageCount$possibleI = usageCount[possibleInterface.name]) !== null && _usageCount$possibleI !== void 0 ? _usageCount$possibleI : 0) + 1;
        }
    }
    return (0, $96Cqc.default)(suggestedTypes).sort(function(typeA, typeB) {
        // Suggest both interface and object types based on how common they are.
        var usageCountDiff = usageCount[typeB.name] - usageCount[typeA.name];
        if (usageCountDiff !== 0) return usageCountDiff;
         // Suggest super types first followed by subtypes
        if ((0, $lXoEQ.isInterfaceType)(typeA) && schema.isSubType(typeA, typeB)) return -1;
        if ((0, $lXoEQ.isInterfaceType)(typeB) && schema.isSubType(typeB, typeA)) return 1;
        return (0, $daK4l.default)(typeA.name, typeB.name);
    }).map(function(x) {
        return x.name;
    });
}
/**
 * For the field name provided, determine if there are any similar field names
 * that may be the result of a typo.
 */ function $ab2475b39bd43e66$var$getSuggestedFieldNames(type, fieldName) {
    if ((0, $lXoEQ.isObjectType)(type) || (0, $lXoEQ.isInterfaceType)(type)) {
        var possibleFieldNames = Object.keys(type.getFields());
        return (0, $bru1k.default)(fieldName, possibleFieldNames);
    } // Otherwise, must be a Union type, which does not define fields.
    return [];
}

});

parcelRegister("alcPf", function(module, exports) {

$parcel$export(module.exports, "UniqueFragmentNamesRule", () => $2a7b73aaa0b2b3c4$export$a920e0f1967f4b0a);

var $9fgMZ = parcelRequire("9fgMZ");
function $2a7b73aaa0b2b3c4$export$a920e0f1967f4b0a(context) {
    var knownFragmentNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            var fragmentName = node.name.value;
            if (knownFragmentNames[fragmentName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one fragment named \"".concat(fragmentName, "\"."), [
                knownFragmentNames[fragmentName],
                node.name
            ]));
            else knownFragmentNames[fragmentName] = node.name;
            return false;
        }
    };
}

});

parcelRegister("50e65", function(module, exports) {

$parcel$export(module.exports, "KnownFragmentNamesRule", () => $9260c47151c2fbfb$export$94c8dd81fb6d3111);

var $9fgMZ = parcelRequire("9fgMZ");
function $9260c47151c2fbfb$export$94c8dd81fb6d3111(context) {
    return {
        FragmentSpread: function FragmentSpread(node) {
            var fragmentName = node.name.value;
            var fragment = context.getFragment(fragmentName);
            if (!fragment) context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown fragment \"".concat(fragmentName, "\"."), node.name));
        }
    };
}

});

parcelRegister("lajJ7", function(module, exports) {

$parcel$export(module.exports, "NoUnusedFragmentsRule", () => $7e58a6a99152422b$export$d29d2e5ed74717af);

var $9fgMZ = parcelRequire("9fgMZ");
function $7e58a6a99152422b$export$d29d2e5ed74717af(context) {
    var operationDefs = [];
    var fragmentDefs = [];
    return {
        OperationDefinition: function OperationDefinition(node) {
            operationDefs.push(node);
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            fragmentDefs.push(node);
            return false;
        },
        Document: {
            leave: function leave() {
                var fragmentNameUsed = Object.create(null);
                for(var _i2 = 0; _i2 < operationDefs.length; _i2++){
                    var operation = operationDefs[_i2];
                    for(var _i4 = 0, _context$getRecursive2 = context.getRecursivelyReferencedFragments(operation); _i4 < _context$getRecursive2.length; _i4++){
                        var fragment = _context$getRecursive2[_i4];
                        fragmentNameUsed[fragment.name.value] = true;
                    }
                }
                for(var _i6 = 0; _i6 < fragmentDefs.length; _i6++){
                    var fragmentDef = fragmentDefs[_i6];
                    var fragName = fragmentDef.name.value;
                    if (fragmentNameUsed[fragName] !== true) context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment \"".concat(fragName, "\" is never used."), fragmentDef));
                }
            }
        }
    };
}

});

parcelRegister("rkd39", function(module, exports) {

$parcel$export(module.exports, "PossibleFragmentSpreadsRule", () => $3ff113974e6929b5$export$aa7b39ab48da3359);

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");

var $f5cpS = parcelRequire("f5cpS");
function $3ff113974e6929b5$export$aa7b39ab48da3359(context) {
    return {
        InlineFragment: function InlineFragment(node) {
            var fragType = context.getType();
            var parentType = context.getParentType();
            if ((0, $lXoEQ.isCompositeType)(fragType) && (0, $lXoEQ.isCompositeType)(parentType) && !(0, $f5cpS.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
                var parentTypeStr = (0, $biK02.default)(parentType);
                var fragTypeStr = (0, $biK02.default)(fragType);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment cannot be spread here as objects of type \"".concat(parentTypeStr, "\" can never be of type \"").concat(fragTypeStr, "\"."), node));
            }
        },
        FragmentSpread: function FragmentSpread(node) {
            var fragName = node.name.value;
            var fragType = $3ff113974e6929b5$var$getFragmentType(context, fragName);
            var parentType = context.getParentType();
            if (fragType && parentType && !(0, $f5cpS.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
                var parentTypeStr = (0, $biK02.default)(parentType);
                var fragTypeStr = (0, $biK02.default)(fragType);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment \"".concat(fragName, "\" cannot be spread here as objects of type \"").concat(parentTypeStr, "\" can never be of type \"").concat(fragTypeStr, "\"."), node));
            }
        }
    };
}
function $3ff113974e6929b5$var$getFragmentType(context, name) {
    var frag = context.getFragment(name);
    if (frag) {
        var type = (0, $3zSAT.typeFromAST)(context.getSchema(), frag.typeCondition);
        if ((0, $lXoEQ.isCompositeType)(type)) return type;
    }
}

});

parcelRegister("bRsXY", function(module, exports) {

$parcel$export(module.exports, "NoFragmentCyclesRule", () => $a757a6928f091056$export$25eccb87f5a000e6);

var $9fgMZ = parcelRequire("9fgMZ");
function $a757a6928f091056$export$25eccb87f5a000e6(context) {
    // Tracks already visited fragments to maintain O(N) and to ensure that cycles
    // are not redundantly reported.
    var visitedFrags = Object.create(null); // Array of AST nodes used to produce meaningful errors
    var spreadPath = []; // Position in the spread path
    var spreadPathIndexByName = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            detectCycleRecursive(node);
            return false;
        }
    }; // This does a straight-forward DFS to find cycles.
    // It does not terminate when a cycle was found but continues to explore
    // the graph to find all possible cycles.
    function detectCycleRecursive(fragment) {
        if (visitedFrags[fragment.name.value]) return;
        var fragmentName = fragment.name.value;
        visitedFrags[fragmentName] = true;
        var spreadNodes = context.getFragmentSpreads(fragment.selectionSet);
        if (spreadNodes.length === 0) return;
        spreadPathIndexByName[fragmentName] = spreadPath.length;
        for(var _i2 = 0; _i2 < spreadNodes.length; _i2++){
            var spreadNode = spreadNodes[_i2];
            var spreadName = spreadNode.name.value;
            var cycleIndex = spreadPathIndexByName[spreadName];
            spreadPath.push(spreadNode);
            if (cycleIndex === undefined) {
                var spreadFragment = context.getFragment(spreadName);
                if (spreadFragment) detectCycleRecursive(spreadFragment);
            } else {
                var cyclePath = spreadPath.slice(cycleIndex);
                var viaPath = cyclePath.slice(0, -1).map(function(s) {
                    return '"' + s.name.value + '"';
                }).join(', ');
                context.reportError(new (0, $9fgMZ.GraphQLError)("Cannot spread fragment \"".concat(spreadName, "\" within itself") + (viaPath !== '' ? " via ".concat(viaPath, ".") : '.'), cyclePath));
            }
            spreadPath.pop();
        }
        spreadPathIndexByName[fragmentName] = undefined;
    }
}

});

parcelRegister("b6uMB", function(module, exports) {

$parcel$export(module.exports, "UniqueVariableNamesRule", () => $8cba4410d1ba8a7f$export$b9352e3a23ba4aa2);

var $9fgMZ = parcelRequire("9fgMZ");
function $8cba4410d1ba8a7f$export$b9352e3a23ba4aa2(context) {
    var knownVariableNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            knownVariableNames = Object.create(null);
        },
        VariableDefinition: function VariableDefinition(node) {
            var variableName = node.variable.name.value;
            if (knownVariableNames[variableName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one variable named \"$".concat(variableName, "\"."), [
                knownVariableNames[variableName],
                node.variable.name
            ]));
            else knownVariableNames[variableName] = node.variable.name;
        }
    };
}

});

parcelRegister("8zYa7", function(module, exports) {

$parcel$export(module.exports, "NoUndefinedVariablesRule", () => $9f30efbbf7a4ad88$export$207476dbb3f797ab);

var $9fgMZ = parcelRequire("9fgMZ");
function $9f30efbbf7a4ad88$export$207476dbb3f797ab(context) {
    var variableNameDefined = Object.create(null);
    return {
        OperationDefinition: {
            enter: function enter() {
                variableNameDefined = Object.create(null);
            },
            leave: function leave(operation) {
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    var varName = node.name.value;
                    if (variableNameDefined[varName] !== true) context.reportError(new (0, $9fgMZ.GraphQLError)(operation.name ? "Variable \"$".concat(varName, "\" is not defined by operation \"").concat(operation.name.value, "\".") : "Variable \"$".concat(varName, "\" is not defined."), [
                        node,
                        operation
                    ]));
                }
            }
        },
        VariableDefinition: function VariableDefinition(node) {
            variableNameDefined[node.variable.name.value] = true;
        }
    };
}

});

parcelRegister("5k1Qg", function(module, exports) {

$parcel$export(module.exports, "NoUnusedVariablesRule", () => $73f3814f2ba8a2d1$export$300a3bc5a4f49273);

var $9fgMZ = parcelRequire("9fgMZ");
function $73f3814f2ba8a2d1$export$300a3bc5a4f49273(context) {
    var variableDefs = [];
    return {
        OperationDefinition: {
            enter: function enter() {
                variableDefs = [];
            },
            leave: function leave(operation) {
                var variableNameUsed = Object.create(null);
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    variableNameUsed[node.name.value] = true;
                }
                for(var _i4 = 0, _variableDefs2 = variableDefs; _i4 < _variableDefs2.length; _i4++){
                    var variableDef = _variableDefs2[_i4];
                    var variableName = variableDef.variable.name.value;
                    if (variableNameUsed[variableName] !== true) context.reportError(new (0, $9fgMZ.GraphQLError)(operation.name ? "Variable \"$".concat(variableName, "\" is never used in operation \"").concat(operation.name.value, "\".") : "Variable \"$".concat(variableName, "\" is never used."), variableDef));
                }
            }
        },
        VariableDefinition: function VariableDefinition(def) {
            variableDefs.push(def);
        }
    };
}

});

parcelRegister("loWoH", function(module, exports) {

$parcel$export(module.exports, "KnownDirectivesRule", () => $f639a2bd47be29e5$export$f4ca94d7d1cf5874);

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $5hGV7 = parcelRequire("5hGV7");

var $bOniD = parcelRequire("bOniD");
function $f639a2bd47be29e5$export$f4ca94d7d1cf5874(context) {
    var locationsMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $bOniD.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        locationsMap[directive.name] = directive.locations;
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) locationsMap[def.name.value] = def.locations.map(function(name) {
            return name.value;
        });
    }
    return {
        Directive: function Directive(node, _key, _parent, _path, ancestors) {
            var name = node.name.value;
            var locations = locationsMap[name];
            if (!locations) {
                context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown directive \"@".concat(name, "\"."), node));
                return;
            }
            var candidateLocation = $f639a2bd47be29e5$var$getDirectiveLocationForASTPath(ancestors);
            if (candidateLocation && locations.indexOf(candidateLocation) === -1) context.reportError(new (0, $9fgMZ.GraphQLError)("Directive \"@".concat(name, "\" may not be used on ").concat(candidateLocation, "."), node));
        }
    };
}
function $f639a2bd47be29e5$var$getDirectiveLocationForASTPath(ancestors) {
    var appliedTo = ancestors[ancestors.length - 1];
    !Array.isArray(appliedTo) || (0, $43MJl.default)(0);
    switch(appliedTo.kind){
        case (0, $1c4hI.Kind).OPERATION_DEFINITION:
            return $f639a2bd47be29e5$var$getDirectiveLocationForOperation(appliedTo.operation);
        case (0, $1c4hI.Kind).FIELD:
            return (0, $5hGV7.DirectiveLocation).FIELD;
        case (0, $1c4hI.Kind).FRAGMENT_SPREAD:
            return (0, $5hGV7.DirectiveLocation).FRAGMENT_SPREAD;
        case (0, $1c4hI.Kind).INLINE_FRAGMENT:
            return (0, $5hGV7.DirectiveLocation).INLINE_FRAGMENT;
        case (0, $1c4hI.Kind).FRAGMENT_DEFINITION:
            return (0, $5hGV7.DirectiveLocation).FRAGMENT_DEFINITION;
        case (0, $1c4hI.Kind).VARIABLE_DEFINITION:
            return (0, $5hGV7.DirectiveLocation).VARIABLE_DEFINITION;
        case (0, $1c4hI.Kind).SCHEMA_DEFINITION:
        case (0, $1c4hI.Kind).SCHEMA_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).SCHEMA;
        case (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).SCALAR;
        case (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).OBJECT;
        case (0, $1c4hI.Kind).FIELD_DEFINITION:
            return (0, $5hGV7.DirectiveLocation).FIELD_DEFINITION;
        case (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).INTERFACE;
        case (0, $1c4hI.Kind).UNION_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).UNION_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).UNION;
        case (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).ENUM;
        case (0, $1c4hI.Kind).ENUM_VALUE_DEFINITION:
            return (0, $5hGV7.DirectiveLocation).ENUM_VALUE;
        case (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).INPUT_OBJECT;
        case (0, $1c4hI.Kind).INPUT_VALUE_DEFINITION:
            var parentNode = ancestors[ancestors.length - 3];
            return parentNode.kind === (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION ? (0, $5hGV7.DirectiveLocation).INPUT_FIELD_DEFINITION : (0, $5hGV7.DirectiveLocation).ARGUMENT_DEFINITION;
    }
}
function $f639a2bd47be29e5$var$getDirectiveLocationForOperation(operation) {
    switch(operation){
        case 'query':
            return (0, $5hGV7.DirectiveLocation).QUERY;
        case 'mutation':
            return (0, $5hGV7.DirectiveLocation).MUTATION;
        case 'subscription':
            return (0, $5hGV7.DirectiveLocation).SUBSCRIPTION;
    } // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $43MJl.default)(0, 'Unexpected operation: ' + (0, $biK02.default)(operation));
}

});

parcelRegister("is7or", function(module, exports) {

$parcel$export(module.exports, "UniqueDirectivesPerLocationRule", () => $d948a6cd5aabc74f$export$4a38f68ea408504c);

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $9nArG = parcelRequire("9nArG");

var $bOniD = parcelRequire("bOniD");
function $d948a6cd5aabc74f$export$4a38f68ea408504c(context) {
    var uniqueDirectiveMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $bOniD.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        uniqueDirectiveMap[directive.name] = !directive.isRepeatable;
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) uniqueDirectiveMap[def.name.value] = !def.repeatable;
    }
    var schemaDirectives = Object.create(null);
    var typeDirectivesMap = Object.create(null);
    return {
        // Many different AST nodes may contain directives. Rather than listing
        // them all, just listen for entering any node, and check to see if it
        // defines any directives.
        enter: function enter(node) {
            if (node.directives == null) return;
            var seenDirectives;
            if (node.kind === (0, $1c4hI.Kind).SCHEMA_DEFINITION || node.kind === (0, $1c4hI.Kind).SCHEMA_EXTENSION) seenDirectives = schemaDirectives;
            else if ((0, $9nArG.isTypeDefinitionNode)(node) || (0, $9nArG.isTypeExtensionNode)(node)) {
                var typeName = node.name.value;
                seenDirectives = typeDirectivesMap[typeName];
                if (seenDirectives === undefined) typeDirectivesMap[typeName] = seenDirectives = Object.create(null);
            } else seenDirectives = Object.create(null);
            for(var _i6 = 0, _node$directives2 = node.directives; _i6 < _node$directives2.length; _i6++){
                var _directive = _node$directives2[_i6];
                var directiveName = _directive.name.value;
                if (uniqueDirectiveMap[directiveName]) {
                    if (seenDirectives[directiveName]) context.reportError(new (0, $9fgMZ.GraphQLError)("The directive \"@".concat(directiveName, "\" can only be used once at this location."), [
                        seenDirectives[directiveName],
                        _directive
                    ]));
                    else seenDirectives[directiveName] = _directive;
                }
            }
        }
    };
}

});

parcelRegister("gGl3W", function(module, exports) {

$parcel$export(module.exports, "KnownArgumentNamesRule", () => $f06ff2fed7190b23$export$5d7b3b4b6779c802);
$parcel$export(module.exports, "KnownArgumentNamesOnDirectivesRule", () => $f06ff2fed7190b23$export$6eb6eb4c5417f2c4);

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $bOniD = parcelRequire("bOniD");
function $f06ff2fed7190b23$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f06ff2fed7190b23$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f06ff2fed7190b23$var$ownKeys(Object(source), true).forEach(function(key) {
            $f06ff2fed7190b23$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f06ff2fed7190b23$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f06ff2fed7190b23$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f06ff2fed7190b23$export$5d7b3b4b6779c802(context) {
    return $f06ff2fed7190b23$var$_objectSpread($f06ff2fed7190b23$var$_objectSpread({}, $f06ff2fed7190b23$export$6eb6eb4c5417f2c4(context)), {}, {
        Argument: function Argument(argNode) {
            var argDef = context.getArgument();
            var fieldDef = context.getFieldDef();
            var parentType = context.getParentType();
            if (!argDef && fieldDef && parentType) {
                var argName = argNode.name.value;
                var knownArgsNames = fieldDef.args.map(function(arg) {
                    return arg.name;
                });
                var suggestions = (0, $bru1k.default)(argName, knownArgsNames);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown argument \"".concat(argName, "\" on field \"").concat(parentType.name, ".").concat(fieldDef.name, "\".") + (0, $8nBnZ.default)(suggestions), argNode));
            }
        }
    });
}
function $f06ff2fed7190b23$export$6eb6eb4c5417f2c4(context) {
    var directiveArgs = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $bOniD.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        directiveArgs[directive.name] = directive.args.map(function(arg) {
            return arg.name;
        });
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) {
            var _def$arguments;
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var argsNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
            directiveArgs[def.name.value] = argsNodes.map(function(arg) {
                return arg.name.value;
            });
        }
    }
    return {
        Directive: function Directive(directiveNode) {
            var directiveName = directiveNode.name.value;
            var knownArgs = directiveArgs[directiveName];
            if (directiveNode.arguments && knownArgs) for(var _i6 = 0, _directiveNode$argume2 = directiveNode.arguments; _i6 < _directiveNode$argume2.length; _i6++){
                var argNode = _directiveNode$argume2[_i6];
                var argName = argNode.name.value;
                if (knownArgs.indexOf(argName) === -1) {
                    var suggestions = (0, $bru1k.default)(argName, knownArgs);
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown argument \"".concat(argName, "\" on directive \"@").concat(directiveName, "\".") + (0, $8nBnZ.default)(suggestions), argNode));
                }
            }
            return false;
        }
    };
}

});

parcelRegister("kXrJO", function(module, exports) {

$parcel$export(module.exports, "UniqueArgumentNamesRule", () => $bc8bcb3d805db150$export$8598b5acb1d855ca);

var $9fgMZ = parcelRequire("9fgMZ");
function $bc8bcb3d805db150$export$8598b5acb1d855ca(context) {
    var knownArgNames = Object.create(null);
    return {
        Field: function Field() {
            knownArgNames = Object.create(null);
        },
        Directive: function Directive() {
            knownArgNames = Object.create(null);
        },
        Argument: function Argument(node) {
            var argName = node.name.value;
            if (knownArgNames[argName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one argument named \"".concat(argName, "\"."), [
                knownArgNames[argName],
                node.name
            ]));
            else knownArgNames[argName] = node.name;
            return false;
        }
    };
}

});

parcelRegister("bhI3j", function(module, exports) {

$parcel$export(module.exports, "ValuesOfCorrectTypeRule", () => $7b4ecfc9076050ee$export$669bf87f50cfda9b);

var $dVq2R = parcelRequire("dVq2R");

var $hbiEd = parcelRequire("hbiEd");

var $biK02 = parcelRequire("biK02");

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");
function $7b4ecfc9076050ee$export$669bf87f50cfda9b(context) {
    return {
        ListValue: function ListValue(node) {
            // Note: TypeInfo will traverse into a list's item type, so look to the
            // parent input type to check if it is a list.
            var type = (0, $lXoEQ.getNullableType)(context.getParentInputType());
            if (!(0, $lXoEQ.isListType)(type)) {
                $7b4ecfc9076050ee$var$isValidValueNode(context, node);
                return false; // Don't traverse further.
            }
        },
        ObjectValue: function ObjectValue(node) {
            var type = (0, $lXoEQ.getNamedType)(context.getInputType());
            if (!(0, $lXoEQ.isInputObjectType)(type)) {
                $7b4ecfc9076050ee$var$isValidValueNode(context, node);
                return false; // Don't traverse further.
            } // Ensure every required field exists.
            var fieldNodeMap = (0, $hbiEd.default)(node.fields, function(field) {
                return field.name.value;
            });
            for(var _i2 = 0, _objectValues2 = (0, $dVq2R.default)(type.getFields()); _i2 < _objectValues2.length; _i2++){
                var fieldDef = _objectValues2[_i2];
                var fieldNode = fieldNodeMap[fieldDef.name];
                if (!fieldNode && (0, $lXoEQ.isRequiredInputField)(fieldDef)) {
                    var typeStr = (0, $biK02.default)(fieldDef.type);
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(type.name, ".").concat(fieldDef.name, "\" of required type \"").concat(typeStr, "\" was not provided."), node));
                }
            }
        },
        ObjectField: function ObjectField(node) {
            var parentType = (0, $lXoEQ.getNamedType)(context.getParentInputType());
            var fieldType = context.getInputType();
            if (!fieldType && (0, $lXoEQ.isInputObjectType)(parentType)) {
                var suggestions = (0, $bru1k.default)(node.name.value, Object.keys(parentType.getFields()));
                context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(node.name.value, "\" is not defined by type \"").concat(parentType.name, "\".") + (0, $8nBnZ.default)(suggestions), node));
            }
        },
        NullValue: function NullValue(node) {
            var type = context.getInputType();
            if ((0, $lXoEQ.isNonNullType)(type)) context.reportError(new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat((0, $biK02.default)(type), "\", found ").concat((0, $aKlnM.print)(node), "."), node));
        },
        EnumValue: function EnumValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        },
        IntValue: function IntValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        },
        FloatValue: function FloatValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        },
        StringValue: function StringValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        },
        BooleanValue: function BooleanValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        }
    };
}
/**
 * Any value literal may be a valid representation of a Scalar, depending on
 * that scalar type.
 */ function $7b4ecfc9076050ee$var$isValidValueNode(context, node) {
    // Report any error at the full type expected by the location.
    var locationType = context.getInputType();
    if (!locationType) return;
    var type = (0, $lXoEQ.getNamedType)(locationType);
    if (!(0, $lXoEQ.isLeafType)(type)) {
        var typeStr = (0, $biK02.default)(locationType);
        context.reportError(new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat(typeStr, "\", found ").concat((0, $aKlnM.print)(node), "."), node));
        return;
    } // Scalars and Enums determine if a literal value is valid via parseLiteral(),
    // which may throw or return an invalid value to indicate failure.
    try {
        var parseResult = type.parseLiteral(node, undefined);
        if (parseResult === undefined) {
            var _typeStr = (0, $biK02.default)(locationType);
            context.reportError(new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat(_typeStr, "\", found ").concat((0, $aKlnM.print)(node), "."), node));
        }
    } catch (error) {
        var _typeStr2 = (0, $biK02.default)(locationType);
        if (error instanceof (0, $9fgMZ.GraphQLError)) context.reportError(error);
        else context.reportError(new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat(_typeStr2, "\", found ").concat((0, $aKlnM.print)(node), "; ") + error.message, node, undefined, undefined, undefined, error));
    }
}

});

parcelRegister("bN26g", function(module, exports) {

$parcel$export(module.exports, "ProvidedRequiredArgumentsRule", () => $ab49904624b6b37c$export$4df169576372c8b2);
$parcel$export(module.exports, "ProvidedRequiredArgumentsOnDirectivesRule", () => $ab49904624b6b37c$export$5ff6a71c337c020f);

var $biK02 = parcelRequire("biK02");

var $hbiEd = parcelRequire("hbiEd");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");
function $ab49904624b6b37c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ab49904624b6b37c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ab49904624b6b37c$var$ownKeys(Object(source), true).forEach(function(key) {
            $ab49904624b6b37c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ab49904624b6b37c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ab49904624b6b37c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ab49904624b6b37c$export$4df169576372c8b2(context) {
    return $ab49904624b6b37c$var$_objectSpread($ab49904624b6b37c$var$_objectSpread({}, $ab49904624b6b37c$export$5ff6a71c337c020f(context)), {}, {
        Field: {
            // Validate on leave to allow for deeper errors to appear first.
            leave: function leave(fieldNode) {
                var _fieldNode$arguments;
                var fieldDef = context.getFieldDef();
                if (!fieldDef) return false;
                 // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
                var argNodes = (_fieldNode$arguments = fieldNode.arguments) !== null && _fieldNode$arguments !== void 0 ? _fieldNode$arguments : [];
                var argNodeMap = (0, $hbiEd.default)(argNodes, function(arg) {
                    return arg.name.value;
                });
                for(var _i2 = 0, _fieldDef$args2 = fieldDef.args; _i2 < _fieldDef$args2.length; _i2++){
                    var argDef = _fieldDef$args2[_i2];
                    var argNode = argNodeMap[argDef.name];
                    if (!argNode && (0, $lXoEQ.isRequiredArgument)(argDef)) {
                        var argTypeStr = (0, $biK02.default)(argDef.type);
                        context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(fieldDef.name, "\" argument \"").concat(argDef.name, "\" of type \"").concat(argTypeStr, "\" is required, but it was not provided."), fieldNode));
                    }
                }
            }
        }
    });
}
function $ab49904624b6b37c$export$5ff6a71c337c020f(context) {
    var requiredArgsMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $bOniD.specifiedDirectives);
    for(var _i4 = 0; _i4 < definedDirectives.length; _i4++){
        var directive = definedDirectives[_i4];
        requiredArgsMap[directive.name] = (0, $hbiEd.default)(directive.args.filter((0, $lXoEQ.isRequiredArgument)), function(arg) {
            return arg.name;
        });
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i6 = 0; _i6 < astDefinitions.length; _i6++){
        var def = astDefinitions[_i6];
        if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) {
            var _def$arguments;
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var argNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
            requiredArgsMap[def.name.value] = (0, $hbiEd.default)(argNodes.filter($ab49904624b6b37c$var$isRequiredArgumentNode), function(arg) {
                return arg.name.value;
            });
        }
    }
    return {
        Directive: {
            // Validate on leave to allow for deeper errors to appear first.
            leave: function leave(directiveNode) {
                var directiveName = directiveNode.name.value;
                var requiredArgs = requiredArgsMap[directiveName];
                if (requiredArgs) {
                    var _directiveNode$argume;
                    // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
                    var _argNodes = (_directiveNode$argume = directiveNode.arguments) !== null && _directiveNode$argume !== void 0 ? _directiveNode$argume : [];
                    var argNodeMap = (0, $hbiEd.default)(_argNodes, function(arg) {
                        return arg.name.value;
                    });
                    for(var _i8 = 0, _Object$keys2 = Object.keys(requiredArgs); _i8 < _Object$keys2.length; _i8++){
                        var argName = _Object$keys2[_i8];
                        if (!argNodeMap[argName]) {
                            var argType = requiredArgs[argName].type;
                            var argTypeStr = (0, $lXoEQ.isType)(argType) ? (0, $biK02.default)(argType) : (0, $aKlnM.print)(argType);
                            context.reportError(new (0, $9fgMZ.GraphQLError)("Directive \"@".concat(directiveName, "\" argument \"").concat(argName, "\" of type \"").concat(argTypeStr, "\" is required, but it was not provided."), directiveNode));
                        }
                    }
                }
            }
        }
    };
}
function $ab49904624b6b37c$var$isRequiredArgumentNode(arg) {
    return arg.type.kind === (0, $1c4hI.Kind).NON_NULL_TYPE && arg.defaultValue == null;
}

});

parcelRegister("gnP1U", function(module, exports) {

$parcel$export(module.exports, "VariablesInAllowedPositionRule", () => $2271e9cfabe9e688$export$7251631d636f2f74);

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");

var $f5cpS = parcelRequire("f5cpS");
function $2271e9cfabe9e688$export$7251631d636f2f74(context) {
    var varDefMap = Object.create(null);
    return {
        OperationDefinition: {
            enter: function enter() {
                varDefMap = Object.create(null);
            },
            leave: function leave(operation) {
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    var type = _ref2.type;
                    var defaultValue = _ref2.defaultValue;
                    var varName = node.name.value;
                    var varDef = varDefMap[varName];
                    if (varDef && type) {
                        // A var type is allowed if it is the same or more strict (e.g. is
                        // a subtype of) than the expected type. It can be more strict if
                        // the variable type is non-null when the expected type is nullable.
                        // If both are list types, the variable item type can be more strict
                        // than the expected item type (contravariant).
                        var schema = context.getSchema();
                        var varType = (0, $3zSAT.typeFromAST)(schema, varDef.type);
                        if (varType && !$2271e9cfabe9e688$var$allowedVariableUsage(schema, varType, varDef.defaultValue, type, defaultValue)) {
                            var varTypeStr = (0, $biK02.default)(varType);
                            var typeStr = (0, $biK02.default)(type);
                            context.reportError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(varName, "\" of type \"").concat(varTypeStr, "\" used in position expecting type \"").concat(typeStr, "\"."), [
                                varDef,
                                node
                            ]));
                        }
                    }
                }
            }
        },
        VariableDefinition: function VariableDefinition(node) {
            varDefMap[node.variable.name.value] = node;
        }
    };
}
/**
 * Returns true if the variable is allowed in the location it was found,
 * which includes considering if default values exist for either the variable
 * or the location at which it is located.
 */ function $2271e9cfabe9e688$var$allowedVariableUsage(schema, varType, varDefaultValue, locationType, locationDefaultValue) {
    if ((0, $lXoEQ.isNonNullType)(locationType) && !(0, $lXoEQ.isNonNullType)(varType)) {
        var hasNonNullVariableDefaultValue = varDefaultValue != null && varDefaultValue.kind !== (0, $1c4hI.Kind).NULL;
        var hasLocationDefaultValue = locationDefaultValue !== undefined;
        if (!hasNonNullVariableDefaultValue && !hasLocationDefaultValue) return false;
        var nullableLocationType = locationType.ofType;
        return (0, $f5cpS.isTypeSubTypeOf)(schema, varType, nullableLocationType);
    }
    return (0, $f5cpS.isTypeSubTypeOf)(schema, varType, locationType);
}

});

parcelRegister("h0Hyz", function(module, exports) {

$parcel$export(module.exports, "OverlappingFieldsCanBeMergedRule", () => $79d19cce53ef75b6$export$ca8652d62af5670);

var $bmIpK = parcelRequire("bmIpK");

var $apet0 = parcelRequire("apet0");

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");
function $79d19cce53ef75b6$var$reasonMessage(reason) {
    if (Array.isArray(reason)) return reason.map(function(_ref) {
        var responseName = _ref[0], subReason = _ref[1];
        return "subfields \"".concat(responseName, "\" conflict because ") + $79d19cce53ef75b6$var$reasonMessage(subReason);
    }).join(' and ');
    return reason;
}
function $79d19cce53ef75b6$export$ca8652d62af5670(context) {
    // A memoization for when two fragments are compared "between" each other for
    // conflicts. Two fragments may be compared many times, so memoizing this can
    // dramatically improve the performance of this validator.
    var comparedFragmentPairs = new $79d19cce53ef75b6$var$PairSet(); // A cache for the "field map" and list of fragment names found in any given
    // selection set. Selection sets may be asked for this information multiple
    // times, so this improves the performance of this validator.
    var cachedFieldsAndFragmentNames = new Map();
    return {
        SelectionSet: function SelectionSet(selectionSet) {
            var conflicts = $79d19cce53ef75b6$var$findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, context.getParentType(), selectionSet);
            for(var _i2 = 0; _i2 < conflicts.length; _i2++){
                var _ref3 = conflicts[_i2];
                var _ref2$ = _ref3[0];
                var responseName = _ref2$[0];
                var reason = _ref2$[1];
                var fields1 = _ref3[1];
                var fields2 = _ref3[2];
                var reasonMsg = $79d19cce53ef75b6$var$reasonMessage(reason);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Fields \"".concat(responseName, "\" conflict because ").concat(reasonMsg, ". Use different aliases on the fields to fetch both if this was intentional."), fields1.concat(fields2)));
            }
        }
    };
}
/**
 * Algorithm:
 *
 * Conflicts occur when two fields exist in a query which will produce the same
 * response name, but represent differing values, thus creating a conflict.
 * The algorithm below finds all conflicts via making a series of comparisons
 * between fields. In order to compare as few fields as possible, this makes
 * a series of comparisons "within" sets of fields and "between" sets of fields.
 *
 * Given any selection set, a collection produces both a set of fields by
 * also including all inline fragments, as well as a list of fragments
 * referenced by fragment spreads.
 *
 * A) Each selection set represented in the document first compares "within" its
 * collected set of fields, finding any conflicts between every pair of
 * overlapping fields.
 * Note: This is the *only time* that a the fields "within" a set are compared
 * to each other. After this only fields "between" sets are compared.
 *
 * B) Also, if any fragment is referenced in a selection set, then a
 * comparison is made "between" the original set of fields and the
 * referenced fragment.
 *
 * C) Also, if multiple fragments are referenced, then comparisons
 * are made "between" each referenced fragment.
 *
 * D) When comparing "between" a set of fields and a referenced fragment, first
 * a comparison is made between each field in the original set of fields and
 * each field in the the referenced set of fields.
 *
 * E) Also, if any fragment is referenced in the referenced selection set,
 * then a comparison is made "between" the original set of fields and the
 * referenced fragment (recursively referring to step D).
 *
 * F) When comparing "between" two fragments, first a comparison is made between
 * each field in the first referenced set of fields and each field in the the
 * second referenced set of fields.
 *
 * G) Also, any fragments referenced by the first must be compared to the
 * second, and any fragments referenced by the second must be compared to the
 * first (recursively referring to step F).
 *
 * H) When comparing two fields, if both have selection sets, then a comparison
 * is made "between" both selection sets, first comparing the set of fields in
 * the first selection set with the set of fields in the second.
 *
 * I) Also, if any fragment is referenced in either selection set, then a
 * comparison is made "between" the other set of fields and the
 * referenced fragment.
 *
 * J) Also, if two fragments are referenced in both selection sets, then a
 * comparison is made "between" the two fragments.
 *
 */ // Find all conflicts found "within" a selection set, including those found
// via spreading in fragments. Called when visiting each SelectionSet in the
// GraphQL Document.
function $79d19cce53ef75b6$var$findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentType, selectionSet) {
    var conflicts = [];
    var _getFieldsAndFragment = $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet), fieldMap = _getFieldsAndFragment[0], fragmentNames = _getFieldsAndFragment[1]; // (A) Find find all conflicts "within" the fields of this selection set.
    // Note: this is the *only place* `collectConflictsWithin` is called.
    $79d19cce53ef75b6$var$collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap);
    if (fragmentNames.length !== 0) // (B) Then collect conflicts between these fields and those represented by
    // each spread fragment name found.
    for(var i = 0; i < fragmentNames.length; i++){
        $79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fieldMap, fragmentNames[i]); // (C) Then compare this fragment with all other fragments found in this
        // selection set to collect conflicts between fragments spread together.
        // This compares each item in the list of fragment names to every other
        // item in that same list (except for itself).
        for(var j = i + 1; j < fragmentNames.length; j++)$79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fragmentNames[i], fragmentNames[j]);
    }
    return conflicts;
} // Collect all conflicts found between a set of fields and a fragment reference
// including via spreading in any nested fragments.
function $79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentName) {
    var fragment = context.getFragment(fragmentName);
    if (!fragment) return;
    var _getReferencedFieldsA = $79d19cce53ef75b6$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment), fieldMap2 = _getReferencedFieldsA[0], fragmentNames2 = _getReferencedFieldsA[1]; // Do not compare a fragment's fieldMap to itself.
    if (fieldMap === fieldMap2) return;
     // (D) First collect any conflicts between the provided collection of fields
    // and the collection of fields represented by the given fragment.
    $79d19cce53ef75b6$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fieldMap2); // (E) Then collect any conflicts between the provided collection of fields
    // and any fragment names found in the given fragment.
    for(var i = 0; i < fragmentNames2.length; i++)$79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentNames2[i]);
} // Collect all conflicts found between two fragments, including via spreading in
// any nested fragments.
function $79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentName2) {
    // No need to compare a fragment to itself.
    if (fragmentName1 === fragmentName2) return;
     // Memoize so two fragments are not compared for conflicts more than once.
    if (comparedFragmentPairs.has(fragmentName1, fragmentName2, areMutuallyExclusive)) return;
    comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);
    var fragment1 = context.getFragment(fragmentName1);
    var fragment2 = context.getFragment(fragmentName2);
    if (!fragment1 || !fragment2) return;
    var _getReferencedFieldsA2 = $79d19cce53ef75b6$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment1), fieldMap1 = _getReferencedFieldsA2[0], fragmentNames1 = _getReferencedFieldsA2[1];
    var _getReferencedFieldsA3 = $79d19cce53ef75b6$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment2), fieldMap2 = _getReferencedFieldsA3[0], fragmentNames2 = _getReferencedFieldsA3[1]; // (F) First, collect all conflicts between these two collections of fields
    // (not including any nested fragments).
    $79d19cce53ef75b6$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (G) Then collect conflicts between the first fragment and any nested
    // fragments spread in the second fragment.
    for(var j = 0; j < fragmentNames2.length; j++)$79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentNames2[j]);
     // (G) Then collect conflicts between the second fragment and any nested
    // fragments spread in the first fragment.
    for(var i = 0; i < fragmentNames1.length; i++)$79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[i], fragmentName2);
} // Find all conflicts found between two selection sets, including those found
// via spreading in fragments. Called when determining if conflicts exist
// between the sub-fields of two overlapping fields.
function $79d19cce53ef75b6$var$findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, parentType1, selectionSet1, parentType2, selectionSet2) {
    var conflicts = [];
    var _getFieldsAndFragment2 = $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType1, selectionSet1), fieldMap1 = _getFieldsAndFragment2[0], fragmentNames1 = _getFieldsAndFragment2[1];
    var _getFieldsAndFragment3 = $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType2, selectionSet2), fieldMap2 = _getFieldsAndFragment3[0], fragmentNames2 = _getFieldsAndFragment3[1]; // (H) First, collect all conflicts between these two collections of field.
    $79d19cce53ef75b6$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (I) Then collect conflicts between the first collection of fields and
    // those referenced by each fragment name associated with the second.
    if (fragmentNames2.length !== 0) for(var j = 0; j < fragmentNames2.length; j++)$79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fragmentNames2[j]);
     // (I) Then collect conflicts between the second collection of fields and
    // those referenced by each fragment name associated with the first.
    if (fragmentNames1.length !== 0) for(var i = 0; i < fragmentNames1.length; i++)$79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap2, fragmentNames1[i]);
     // (J) Also collect conflicts between any fragment names by the first and
    // fragment names by the second. This compares each item in the first set of
    // names to each item in the second set of names.
    for(var _i3 = 0; _i3 < fragmentNames1.length; _i3++)for(var _j = 0; _j < fragmentNames2.length; _j++)$79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[_i3], fragmentNames2[_j]);
    return conflicts;
} // Collect all Conflicts "within" one collection of fields.
function $79d19cce53ef75b6$var$collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap) {
    // A field map is a keyed collection, where each key represents a response
    // name and the value at that key is a list of all fields which provide that
    // response name. For every response name, if there are multiple fields, they
    // must be compared to find a potential conflict.
    for(var _i5 = 0, _objectEntries2 = (0, $apet0.default)(fieldMap); _i5 < _objectEntries2.length; _i5++){
        var _ref5 = _objectEntries2[_i5];
        var responseName = _ref5[0];
        var fields = _ref5[1];
        // This compares every field in the list to every other field in this list
        // (except to itself). If the list only has one item, nothing needs to
        // be compared.
        if (fields.length > 1) {
            for(var i = 0; i < fields.length; i++)for(var j = i + 1; j < fields.length; j++){
                var conflict = $79d19cce53ef75b6$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, responseName, fields[i], fields[j]);
                if (conflict) conflicts.push(conflict);
            }
        }
    }
} // Collect all Conflicts between two collections of fields. This is similar to,
// but different from the `collectConflictsWithin` function above. This check
// assumes that `collectConflictsWithin` has already been called on each
// provided collection of fields. This is true because this validator traverses
// each individual selection set.
function $79d19cce53ef75b6$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, fieldMap1, fieldMap2) {
    // A field map is a keyed collection, where each key represents a response
    // name and the value at that key is a list of all fields which provide that
    // response name. For any response name which appears in both provided field
    // maps, each field from the first field map must be compared to every field
    // in the second field map to find potential conflicts.
    for(var _i7 = 0, _Object$keys2 = Object.keys(fieldMap1); _i7 < _Object$keys2.length; _i7++){
        var responseName = _Object$keys2[_i7];
        var fields2 = fieldMap2[responseName];
        if (fields2) {
            var fields1 = fieldMap1[responseName];
            for(var i = 0; i < fields1.length; i++)for(var j = 0; j < fields2.length; j++){
                var conflict = $79d19cce53ef75b6$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, fields1[i], fields2[j]);
                if (conflict) conflicts.push(conflict);
            }
        }
    }
} // Determines if there is a conflict between two particular fields, including
// comparing their sub-fields.
function $79d19cce53ef75b6$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, field1, field2) {
    var parentType1 = field1[0], node1 = field1[1], def1 = field1[2];
    var parentType2 = field2[0], node2 = field2[1], def2 = field2[2]; // If it is known that two fields could not possibly apply at the same
    // time, due to the parent types, then it is safe to permit them to diverge
    // in aliased field or arguments used as they will not present any ambiguity
    // by differing.
    // It is known that two parent types could never overlap if they are
    // different Object types. Interface or Union types might overlap - if not
    // in the current state of the schema, then perhaps in some future version,
    // thus may not safely diverge.
    var areMutuallyExclusive = parentFieldsAreMutuallyExclusive || parentType1 !== parentType2 && (0, $lXoEQ.isObjectType)(parentType1) && (0, $lXoEQ.isObjectType)(parentType2);
    if (!areMutuallyExclusive) {
        var _node1$arguments, _node2$arguments;
        // Two aliases must refer to the same field.
        var name1 = node1.name.value;
        var name2 = node2.name.value;
        if (name1 !== name2) return [
            [
                responseName,
                "\"".concat(name1, "\" and \"").concat(name2, "\" are different fields")
            ],
            [
                node1
            ],
            [
                node2
            ]
        ];
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var args1 = (_node1$arguments = node1.arguments) !== null && _node1$arguments !== void 0 ? _node1$arguments : []; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var args2 = (_node2$arguments = node2.arguments) !== null && _node2$arguments !== void 0 ? _node2$arguments : []; // Two field calls must have the same arguments.
        if (!$79d19cce53ef75b6$var$sameArguments(args1, args2)) return [
            [
                responseName,
                'they have differing arguments'
            ],
            [
                node1
            ],
            [
                node2
            ]
        ];
    } // The return type for each field.
    var type1 = def1 === null || def1 === void 0 ? void 0 : def1.type;
    var type2 = def2 === null || def2 === void 0 ? void 0 : def2.type;
    if (type1 && type2 && $79d19cce53ef75b6$var$doTypesConflict(type1, type2)) return [
        [
            responseName,
            "they return conflicting types \"".concat((0, $biK02.default)(type1), "\" and \"").concat((0, $biK02.default)(type2), "\"")
        ],
        [
            node1
        ],
        [
            node2
        ]
    ];
     // Collect and compare sub-fields. Use the same "visited fragment names" list
    // for both collections so fields in a fragment reference are never
    // compared to themselves.
    var selectionSet1 = node1.selectionSet;
    var selectionSet2 = node2.selectionSet;
    if (selectionSet1 && selectionSet2) {
        var conflicts = $79d19cce53ef75b6$var$findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, (0, $lXoEQ.getNamedType)(type1), selectionSet1, (0, $lXoEQ.getNamedType)(type2), selectionSet2);
        return $79d19cce53ef75b6$var$subfieldConflicts(conflicts, responseName, node1, node2);
    }
}
function $79d19cce53ef75b6$var$sameArguments(arguments1, arguments2) {
    if (arguments1.length !== arguments2.length) return false;
    return arguments1.every(function(argument1) {
        var argument2 = (0, $bmIpK.default)(arguments2, function(argument) {
            return argument.name.value === argument1.name.value;
        });
        if (!argument2) return false;
        return $79d19cce53ef75b6$var$sameValue(argument1.value, argument2.value);
    });
}
function $79d19cce53ef75b6$var$sameValue(value1, value2) {
    return (0, $aKlnM.print)(value1) === (0, $aKlnM.print)(value2);
} // Two types conflict if both types could not apply to a value simultaneously.
// Composite types are ignored as their individual field types will be compared
// later recursively. However List and Non-Null types must match.
function $79d19cce53ef75b6$var$doTypesConflict(type1, type2) {
    if ((0, $lXoEQ.isListType)(type1)) return (0, $lXoEQ.isListType)(type2) ? $79d19cce53ef75b6$var$doTypesConflict(type1.ofType, type2.ofType) : true;
    if ((0, $lXoEQ.isListType)(type2)) return true;
    if ((0, $lXoEQ.isNonNullType)(type1)) return (0, $lXoEQ.isNonNullType)(type2) ? $79d19cce53ef75b6$var$doTypesConflict(type1.ofType, type2.ofType) : true;
    if ((0, $lXoEQ.isNonNullType)(type2)) return true;
    if ((0, $lXoEQ.isLeafType)(type1) || (0, $lXoEQ.isLeafType)(type2)) return type1 !== type2;
    return false;
} // Given a selection set, return the collection of fields (a mapping of response
// name to field nodes and definitions) as well as a list of fragment names
// referenced via fragment spreads.
function $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet) {
    var cached = cachedFieldsAndFragmentNames.get(selectionSet);
    if (!cached) {
        var nodeAndDefs = Object.create(null);
        var fragmentNames = Object.create(null);
        $79d19cce53ef75b6$var$_collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames);
        cached = [
            nodeAndDefs,
            Object.keys(fragmentNames)
        ];
        cachedFieldsAndFragmentNames.set(selectionSet, cached);
    }
    return cached;
} // Given a reference to a fragment, return the represented collection of fields
// as well as a list of nested fragment names referenced via fragment spreads.
function $79d19cce53ef75b6$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment) {
    // Short-circuit building a type from the node if possible.
    var cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);
    if (cached) return cached;
    var fragmentType = (0, $3zSAT.typeFromAST)(context.getSchema(), fragment.typeCondition);
    return $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragmentType, fragment.selectionSet);
}
function $79d19cce53ef75b6$var$_collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames) {
    for(var _i9 = 0, _selectionSet$selecti2 = selectionSet.selections; _i9 < _selectionSet$selecti2.length; _i9++){
        var selection = _selectionSet$selecti2[_i9];
        switch(selection.kind){
            case (0, $1c4hI.Kind).FIELD:
                var fieldName = selection.name.value;
                var fieldDef = void 0;
                if ((0, $lXoEQ.isObjectType)(parentType) || (0, $lXoEQ.isInterfaceType)(parentType)) fieldDef = parentType.getFields()[fieldName];
                var responseName = selection.alias ? selection.alias.value : fieldName;
                if (!nodeAndDefs[responseName]) nodeAndDefs[responseName] = [];
                nodeAndDefs[responseName].push([
                    parentType,
                    selection,
                    fieldDef
                ]);
                break;
            case (0, $1c4hI.Kind).FRAGMENT_SPREAD:
                fragmentNames[selection.name.value] = true;
                break;
            case (0, $1c4hI.Kind).INLINE_FRAGMENT:
                var typeCondition = selection.typeCondition;
                var inlineFragmentType = typeCondition ? (0, $3zSAT.typeFromAST)(context.getSchema(), typeCondition) : parentType;
                $79d19cce53ef75b6$var$_collectFieldsAndFragmentNames(context, inlineFragmentType, selection.selectionSet, nodeAndDefs, fragmentNames);
                break;
        }
    }
} // Given a series of Conflicts which occurred between two sub-fields, generate
// a single Conflict.
function $79d19cce53ef75b6$var$subfieldConflicts(conflicts, responseName, node1, node2) {
    if (conflicts.length > 0) return [
        [
            responseName,
            conflicts.map(function(_ref6) {
                var reason = _ref6[0];
                return reason;
            })
        ],
        conflicts.reduce(function(allFields, _ref7) {
            var fields1 = _ref7[1];
            return allFields.concat(fields1);
        }, [
            node1
        ]),
        conflicts.reduce(function(allFields, _ref8) {
            var fields2 = _ref8[2];
            return allFields.concat(fields2);
        }, [
            node2
        ])
    ];
}
/**
 * A way to keep track of pairs of things when the ordering of the pair does
 * not matter. We do this by maintaining a sort of double adjacency sets.
 */ var $79d19cce53ef75b6$var$PairSet = /*#__PURE__*/ function() {
    function PairSet() {
        this._data = Object.create(null);
    }
    var _proto = PairSet.prototype;
    _proto.has = function has(a, b, areMutuallyExclusive) {
        var first = this._data[a];
        var result = first && first[b];
        if (result === undefined) return false;
         // areMutuallyExclusive being false is a superset of being true,
        // hence if we want to know if this PairSet "has" these two with no
        // exclusivity, we have to ensure it was added as such.
        if (areMutuallyExclusive === false) return result === false;
        return true;
    };
    _proto.add = function add(a, b, areMutuallyExclusive) {
        this._pairSetAdd(a, b, areMutuallyExclusive);
        this._pairSetAdd(b, a, areMutuallyExclusive);
    };
    _proto._pairSetAdd = function _pairSetAdd(a, b, areMutuallyExclusive) {
        var map = this._data[a];
        if (!map) {
            map = Object.create(null);
            this._data[a] = map;
        }
        map[b] = areMutuallyExclusive;
    };
    return PairSet;
}();

});

parcelRegister("1W7Gt", function(module, exports) {

$parcel$export(module.exports, "UniqueInputFieldNamesRule", () => $eb92478c221189f8$export$de7865c052ebdd8c);

var $9fgMZ = parcelRequire("9fgMZ");
function $eb92478c221189f8$export$de7865c052ebdd8c(context) {
    var knownNameStack = [];
    var knownNames = Object.create(null);
    return {
        ObjectValue: {
            enter: function enter() {
                knownNameStack.push(knownNames);
                knownNames = Object.create(null);
            },
            leave: function leave() {
                knownNames = knownNameStack.pop();
            }
        },
        ObjectField: function ObjectField(node) {
            var fieldName = node.name.value;
            if (knownNames[fieldName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one input field named \"".concat(fieldName, "\"."), [
                knownNames[fieldName],
                node.name
            ]));
            else knownNames[fieldName] = node.name;
        }
    };
}

});

parcelRegister("gawpj", function(module, exports) {

$parcel$export(module.exports, "LoneSchemaDefinitionRule", () => $f71f83ba1740d4a2$export$9eae4c44f9d64405);

var $9fgMZ = parcelRequire("9fgMZ");
function $f71f83ba1740d4a2$export$9eae4c44f9d64405(context) {
    var _ref, _ref2, _oldSchema$astNode;
    var oldSchema = context.getSchema();
    var alreadyDefined = (_ref = (_ref2 = (_oldSchema$astNode = oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.astNode) !== null && _oldSchema$astNode !== void 0 ? _oldSchema$astNode : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getQueryType()) !== null && _ref2 !== void 0 ? _ref2 : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getMutationType()) !== null && _ref !== void 0 ? _ref : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getSubscriptionType();
    var schemaDefinitionsCount = 0;
    return {
        SchemaDefinition: function SchemaDefinition(node) {
            if (alreadyDefined) {
                context.reportError(new (0, $9fgMZ.GraphQLError)('Cannot define a new schema within a schema extension.', node));
                return;
            }
            if (schemaDefinitionsCount > 0) context.reportError(new (0, $9fgMZ.GraphQLError)('Must provide only one schema definition.', node));
            ++schemaDefinitionsCount;
        }
    };
}

});

parcelRegister("b8axV", function(module, exports) {

$parcel$export(module.exports, "UniqueOperationTypesRule", () => $892cef0dee83a4c5$export$d9750570c6d13894);

var $9fgMZ = parcelRequire("9fgMZ");
function $892cef0dee83a4c5$export$d9750570c6d13894(context) {
    var schema = context.getSchema();
    var definedOperationTypes = Object.create(null);
    var existingOperationTypes = schema ? {
        query: schema.getQueryType(),
        mutation: schema.getMutationType(),
        subscription: schema.getSubscriptionType()
    } : {};
    return {
        SchemaDefinition: checkOperationTypes,
        SchemaExtension: checkOperationTypes
    };
    function checkOperationTypes(node) {
        var _node$operationTypes;
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
        for(var _i2 = 0; _i2 < operationTypesNodes.length; _i2++){
            var operationType = operationTypesNodes[_i2];
            var operation = operationType.operation;
            var alreadyDefinedOperationType = definedOperationTypes[operation];
            if (existingOperationTypes[operation]) context.reportError(new (0, $9fgMZ.GraphQLError)("Type for ".concat(operation, " already defined in the schema. It cannot be redefined."), operationType));
            else if (alreadyDefinedOperationType) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one ".concat(operation, " type in schema."), [
                alreadyDefinedOperationType,
                operationType
            ]));
            else definedOperationTypes[operation] = operationType;
        }
        return false;
    }
}

});

parcelRegister("lOmVT", function(module, exports) {

$parcel$export(module.exports, "UniqueTypeNamesRule", () => $2484c652452810b0$export$380307ee0123f80e);

var $9fgMZ = parcelRequire("9fgMZ");
function $2484c652452810b0$export$380307ee0123f80e(context) {
    var knownTypeNames = Object.create(null);
    var schema = context.getSchema();
    return {
        ScalarTypeDefinition: checkTypeName,
        ObjectTypeDefinition: checkTypeName,
        InterfaceTypeDefinition: checkTypeName,
        UnionTypeDefinition: checkTypeName,
        EnumTypeDefinition: checkTypeName,
        InputObjectTypeDefinition: checkTypeName
    };
    function checkTypeName(node) {
        var typeName = node.name.value;
        if (schema !== null && schema !== void 0 && schema.getType(typeName)) {
            context.reportError(new (0, $9fgMZ.GraphQLError)("Type \"".concat(typeName, "\" already exists in the schema. It cannot also be defined in this type definition."), node.name));
            return;
        }
        if (knownTypeNames[typeName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one type named \"".concat(typeName, "\"."), [
            knownTypeNames[typeName],
            node.name
        ]));
        else knownTypeNames[typeName] = node.name;
        return false;
    }
}

});

parcelRegister("1H4NC", function(module, exports) {

$parcel$export(module.exports, "UniqueEnumValueNamesRule", () => $2bea4695779a7344$export$f5a22bb45cdc635d);

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $2bea4695779a7344$export$f5a22bb45cdc635d(context) {
    var schema = context.getSchema();
    var existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
    var knownValueNames = Object.create(null);
    return {
        EnumTypeDefinition: checkValueUniqueness,
        EnumTypeExtension: checkValueUniqueness
    };
    function checkValueUniqueness(node) {
        var _node$values;
        var typeName = node.name.value;
        if (!knownValueNames[typeName]) knownValueNames[typeName] = Object.create(null);
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var valueNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
        var valueNames = knownValueNames[typeName];
        for(var _i2 = 0; _i2 < valueNodes.length; _i2++){
            var valueDef = valueNodes[_i2];
            var valueName = valueDef.name.value;
            var existingType = existingTypeMap[typeName];
            if ((0, $lXoEQ.isEnumType)(existingType) && existingType.getValue(valueName)) context.reportError(new (0, $9fgMZ.GraphQLError)("Enum value \"".concat(typeName, ".").concat(valueName, "\" already exists in the schema. It cannot also be defined in this type extension."), valueDef.name));
            else if (valueNames[valueName]) context.reportError(new (0, $9fgMZ.GraphQLError)("Enum value \"".concat(typeName, ".").concat(valueName, "\" can only be defined once."), [
                valueNames[valueName],
                valueDef.name
            ]));
            else valueNames[valueName] = valueDef.name;
        }
        return false;
    }
}

});

parcelRegister("lVZ4j", function(module, exports) {

$parcel$export(module.exports, "UniqueFieldDefinitionNamesRule", () => $c30f67380d4d4d7a$export$b3dfc0de81924308);

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $c30f67380d4d4d7a$export$b3dfc0de81924308(context) {
    var schema = context.getSchema();
    var existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
    var knownFieldNames = Object.create(null);
    return {
        InputObjectTypeDefinition: checkFieldUniqueness,
        InputObjectTypeExtension: checkFieldUniqueness,
        InterfaceTypeDefinition: checkFieldUniqueness,
        InterfaceTypeExtension: checkFieldUniqueness,
        ObjectTypeDefinition: checkFieldUniqueness,
        ObjectTypeExtension: checkFieldUniqueness
    };
    function checkFieldUniqueness(node) {
        var _node$fields;
        var typeName = node.name.value;
        if (!knownFieldNames[typeName]) knownFieldNames[typeName] = Object.create(null);
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var fieldNodes = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
        var fieldNames = knownFieldNames[typeName];
        for(var _i2 = 0; _i2 < fieldNodes.length; _i2++){
            var fieldDef = fieldNodes[_i2];
            var fieldName = fieldDef.name.value;
            if ($c30f67380d4d4d7a$var$hasField(existingTypeMap[typeName], fieldName)) context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(typeName, ".").concat(fieldName, "\" already exists in the schema. It cannot also be defined in this type extension."), fieldDef.name));
            else if (fieldNames[fieldName]) context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(typeName, ".").concat(fieldName, "\" can only be defined once."), [
                fieldNames[fieldName],
                fieldDef.name
            ]));
            else fieldNames[fieldName] = fieldDef.name;
        }
        return false;
    }
}
function $c30f67380d4d4d7a$var$hasField(type, fieldName) {
    if ((0, $lXoEQ.isObjectType)(type) || (0, $lXoEQ.isInterfaceType)(type) || (0, $lXoEQ.isInputObjectType)(type)) return type.getFields()[fieldName] != null;
    return false;
}

});

parcelRegister("jCJ2v", function(module, exports) {

$parcel$export(module.exports, "UniqueDirectiveNamesRule", () => $d3a75eab1a7085ce$export$b06952068b20c86f);

var $9fgMZ = parcelRequire("9fgMZ");
function $d3a75eab1a7085ce$export$b06952068b20c86f(context) {
    var knownDirectiveNames = Object.create(null);
    var schema = context.getSchema();
    return {
        DirectiveDefinition: function DirectiveDefinition(node) {
            var directiveName = node.name.value;
            if (schema !== null && schema !== void 0 && schema.getDirective(directiveName)) {
                context.reportError(new (0, $9fgMZ.GraphQLError)("Directive \"@".concat(directiveName, "\" already exists in the schema. It cannot be redefined."), node.name));
                return;
            }
            if (knownDirectiveNames[directiveName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one directive named \"@".concat(directiveName, "\"."), [
                knownDirectiveNames[directiveName],
                node.name
            ]));
            else knownDirectiveNames[directiveName] = node.name;
            return false;
        }
    };
}

});

parcelRegister("kJWSQ", function(module, exports) {

$parcel$export(module.exports, "PossibleTypeExtensionsRule", () => $56e81335f8ee936c$export$50309357bc4f0e8b);

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $9nArG = parcelRequire("9nArG");

var $lXoEQ = parcelRequire("lXoEQ");
var $56e81335f8ee936c$var$_defKindToExtKind;
function $56e81335f8ee936c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $56e81335f8ee936c$export$50309357bc4f0e8b(context) {
    var schema = context.getSchema();
    var definedTypes = Object.create(null);
    for(var _i2 = 0, _context$getDocument$2 = context.getDocument().definitions; _i2 < _context$getDocument$2.length; _i2++){
        var def = _context$getDocument$2[_i2];
        if ((0, $9nArG.isTypeDefinitionNode)(def)) definedTypes[def.name.value] = def;
    }
    return {
        ScalarTypeExtension: checkExtension,
        ObjectTypeExtension: checkExtension,
        InterfaceTypeExtension: checkExtension,
        UnionTypeExtension: checkExtension,
        EnumTypeExtension: checkExtension,
        InputObjectTypeExtension: checkExtension
    };
    function checkExtension(node) {
        var typeName = node.name.value;
        var defNode = definedTypes[typeName];
        var existingType = schema === null || schema === void 0 ? void 0 : schema.getType(typeName);
        var expectedKind;
        if (defNode) expectedKind = $56e81335f8ee936c$var$defKindToExtKind[defNode.kind];
        else if (existingType) expectedKind = $56e81335f8ee936c$var$typeToExtKind(existingType);
        if (expectedKind) {
            if (expectedKind !== node.kind) {
                var kindStr = $56e81335f8ee936c$var$extensionKindToTypeName(node.kind);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Cannot extend non-".concat(kindStr, " type \"").concat(typeName, "\"."), defNode ? [
                    defNode,
                    node
                ] : node));
            }
        } else {
            var allTypeNames = Object.keys(definedTypes);
            if (schema) allTypeNames = allTypeNames.concat(Object.keys(schema.getTypeMap()));
            var suggestedTypes = (0, $bru1k.default)(typeName, allTypeNames);
            context.reportError(new (0, $9fgMZ.GraphQLError)("Cannot extend type \"".concat(typeName, "\" because it is not defined.") + (0, $8nBnZ.default)(suggestedTypes), node.name));
        }
    }
}
var $56e81335f8ee936c$var$defKindToExtKind = ($56e81335f8ee936c$var$_defKindToExtKind = {}, $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION, (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION, (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION, (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).UNION_TYPE_DEFINITION, (0, $1c4hI.Kind).UNION_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION, (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION, (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION), $56e81335f8ee936c$var$_defKindToExtKind);
function $56e81335f8ee936c$var$typeToExtKind(type) {
    if ((0, $lXoEQ.isScalarType)(type)) return (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION;
    if ((0, $lXoEQ.isObjectType)(type)) return (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION;
    if ((0, $lXoEQ.isInterfaceType)(type)) return (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION;
    if ((0, $lXoEQ.isUnionType)(type)) return (0, $1c4hI.Kind).UNION_TYPE_EXTENSION;
    if ((0, $lXoEQ.isEnumType)(type)) return (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION;
     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isInputObjectType)(type)) return (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION;
     // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $43MJl.default)(0, 'Unexpected type: ' + (0, $biK02.default)(type));
}
function $56e81335f8ee936c$var$extensionKindToTypeName(kind) {
    switch(kind){
        case (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION:
            return 'scalar';
        case (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION:
            return 'object';
        case (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION:
            return 'interface';
        case (0, $1c4hI.Kind).UNION_TYPE_EXTENSION:
            return 'union';
        case (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION:
            return 'enum';
        case (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION:
            return 'input object';
    } // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $43MJl.default)(0, 'Unexpected kind: ' + (0, $biK02.default)(kind));
}

});


parcelRegister("5RV6E", function(module, exports) {

$parcel$export(module.exports, "SDLValidationContext", () => $4e98916749b0fed4$export$62ce401b55355c79);
$parcel$export(module.exports, "ValidationContext", () => $4e98916749b0fed4$export$d452675449e81987);

var $1c4hI = parcelRequire("1c4hI");

var $961BR = parcelRequire("961BR");

var $hMOry = parcelRequire("hMOry");
function $4e98916749b0fed4$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e98916749b0fed4$export$ebdf7b7a2f7aef8b = /*#__PURE__*/ function() {
    function ASTValidationContext(ast, onError) {
        this._ast = ast;
        this._fragments = undefined;
        this._fragmentSpreads = new Map();
        this._recursivelyReferencedFragments = new Map();
        this._onError = onError;
    }
    var _proto = ASTValidationContext.prototype;
    _proto.reportError = function reportError(error) {
        this._onError(error);
    };
    _proto.getDocument = function getDocument() {
        return this._ast;
    };
    _proto.getFragment = function getFragment(name) {
        var fragments = this._fragments;
        if (!fragments) this._fragments = fragments = this.getDocument().definitions.reduce(function(frags, statement) {
            if (statement.kind === (0, $1c4hI.Kind).FRAGMENT_DEFINITION) frags[statement.name.value] = statement;
            return frags;
        }, Object.create(null));
        return fragments[name];
    };
    _proto.getFragmentSpreads = function getFragmentSpreads(node) {
        var spreads = this._fragmentSpreads.get(node);
        if (!spreads) {
            spreads = [];
            var setsToVisit = [
                node
            ];
            while(setsToVisit.length !== 0){
                var set = setsToVisit.pop();
                for(var _i2 = 0, _set$selections2 = set.selections; _i2 < _set$selections2.length; _i2++){
                    var selection = _set$selections2[_i2];
                    if (selection.kind === (0, $1c4hI.Kind).FRAGMENT_SPREAD) spreads.push(selection);
                    else if (selection.selectionSet) setsToVisit.push(selection.selectionSet);
                }
            }
            this._fragmentSpreads.set(node, spreads);
        }
        return spreads;
    };
    _proto.getRecursivelyReferencedFragments = function getRecursivelyReferencedFragments(operation) {
        var fragments = this._recursivelyReferencedFragments.get(operation);
        if (!fragments) {
            fragments = [];
            var collectedNames = Object.create(null);
            var nodesToVisit = [
                operation.selectionSet
            ];
            while(nodesToVisit.length !== 0){
                var node = nodesToVisit.pop();
                for(var _i4 = 0, _this$getFragmentSpre2 = this.getFragmentSpreads(node); _i4 < _this$getFragmentSpre2.length; _i4++){
                    var spread = _this$getFragmentSpre2[_i4];
                    var fragName = spread.name.value;
                    if (collectedNames[fragName] !== true) {
                        collectedNames[fragName] = true;
                        var fragment = this.getFragment(fragName);
                        if (fragment) {
                            fragments.push(fragment);
                            nodesToVisit.push(fragment.selectionSet);
                        }
                    }
                }
            }
            this._recursivelyReferencedFragments.set(operation, fragments);
        }
        return fragments;
    };
    return ASTValidationContext;
}();
var $4e98916749b0fed4$export$62ce401b55355c79 = /*#__PURE__*/ function(_ASTValidationContext) {
    $4e98916749b0fed4$var$_inheritsLoose(SDLValidationContext, _ASTValidationContext);
    function SDLValidationContext(ast, schema, onError) {
        var _this;
        _this = _ASTValidationContext.call(this, ast, onError) || this;
        _this._schema = schema;
        return _this;
    }
    var _proto2 = SDLValidationContext.prototype;
    _proto2.getSchema = function getSchema() {
        return this._schema;
    };
    return SDLValidationContext;
}($4e98916749b0fed4$export$ebdf7b7a2f7aef8b);
var $4e98916749b0fed4$export$d452675449e81987 = /*#__PURE__*/ function(_ASTValidationContext2) {
    $4e98916749b0fed4$var$_inheritsLoose(ValidationContext, _ASTValidationContext2);
    function ValidationContext(schema, ast, typeInfo, onError) {
        var _this2;
        _this2 = _ASTValidationContext2.call(this, ast, onError) || this;
        _this2._schema = schema;
        _this2._typeInfo = typeInfo;
        _this2._variableUsages = new Map();
        _this2._recursiveVariableUsages = new Map();
        return _this2;
    }
    var _proto3 = ValidationContext.prototype;
    _proto3.getSchema = function getSchema() {
        return this._schema;
    };
    _proto3.getVariableUsages = function getVariableUsages(node) {
        var usages = this._variableUsages.get(node);
        if (!usages) {
            var newUsages = [];
            var typeInfo = new (0, $hMOry.TypeInfo)(this._schema);
            (0, $961BR.visit)(node, (0, $hMOry.visitWithTypeInfo)(typeInfo, {
                VariableDefinition: function VariableDefinition() {
                    return false;
                },
                Variable: function Variable(variable) {
                    newUsages.push({
                        node: variable,
                        type: typeInfo.getInputType(),
                        defaultValue: typeInfo.getDefaultValue()
                    });
                }
            }));
            usages = newUsages;
            this._variableUsages.set(node, usages);
        }
        return usages;
    };
    _proto3.getRecursiveVariableUsages = function getRecursiveVariableUsages(operation) {
        var usages = this._recursiveVariableUsages.get(operation);
        if (!usages) {
            usages = this.getVariableUsages(operation);
            for(var _i6 = 0, _this$getRecursivelyR2 = this.getRecursivelyReferencedFragments(operation); _i6 < _this$getRecursivelyR2.length; _i6++){
                var frag = _this$getRecursivelyR2[_i6];
                usages = usages.concat(this.getVariableUsages(frag));
            }
            this._recursiveVariableUsages.set(operation, usages);
        }
        return usages;
    };
    _proto3.getType = function getType() {
        return this._typeInfo.getType();
    };
    _proto3.getParentType = function getParentType() {
        return this._typeInfo.getParentType();
    };
    _proto3.getInputType = function getInputType() {
        return this._typeInfo.getInputType();
    };
    _proto3.getParentInputType = function getParentInputType() {
        return this._typeInfo.getParentInputType();
    };
    _proto3.getFieldDef = function getFieldDef() {
        return this._typeInfo.getFieldDef();
    };
    _proto3.getDirective = function getDirective() {
        return this._typeInfo.getDirective();
    };
    _proto3.getArgument = function getArgument() {
        return this._typeInfo.getArgument();
    };
    _proto3.getEnumValue = function getEnumValue() {
        return this._typeInfo.getEnumValue();
    };
    return ValidationContext;
}($4e98916749b0fed4$export$ebdf7b7a2f7aef8b);

});


parcelRegister("glHRe", function(module, exports) {

$parcel$export(module.exports, "extendSchema", () => $6ade12bb8df37dc4$export$35f5fe5f3e862ea3);
$parcel$export(module.exports, "extendSchemaImpl", () => $6ade12bb8df37dc4$export$97eac8f938300c6f);
$parcel$export(module.exports, "getDescription", () => $6ade12bb8df37dc4$export$67580b1c13935958);

var $dVq2R = parcelRequire("dVq2R");

var $hbiEd = parcelRequire("hbiEd");

var $biK02 = parcelRequire("biK02");

var $6MWHL = parcelRequire("6MWHL");

var $43MJl = parcelRequire("43MJl");

var $fZdRY = parcelRequire("fZdRY");

var $1c4hI = parcelRequire("1c4hI");

var $hFu5F = parcelRequire("hFu5F");

var $flA0a = parcelRequire("flA0a");

var $9nArG = parcelRequire("9nArG");

var $dGflO = parcelRequire("dGflO");

var $gqGQB = parcelRequire("gqGQB");

var $6BdRO = parcelRequire("6BdRO");

var $auu22 = parcelRequire("auu22");

var $h2iUh = parcelRequire("h2iUh");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");

var $3E0nn = parcelRequire("3E0nn");
function $6ade12bb8df37dc4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6ade12bb8df37dc4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6ade12bb8df37dc4$var$ownKeys(Object(source), true).forEach(function(key) {
            $6ade12bb8df37dc4$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6ade12bb8df37dc4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6ade12bb8df37dc4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6ade12bb8df37dc4$export$35f5fe5f3e862ea3(schema, documentAST, options) {
    (0, $6BdRO.assertSchema)(schema);
    documentAST != null && documentAST.kind === (0, $1c4hI.Kind).DOCUMENT || (0, $fZdRY.default)(0, 'Must provide valid Document AST.');
    if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) (0, $dGflO.assertValidSDLExtension)(documentAST, schema);
    var schemaConfig = schema.toConfig();
    var extendedConfig = $6ade12bb8df37dc4$export$97eac8f938300c6f(schemaConfig, documentAST, options);
    return schemaConfig === extendedConfig ? schema : new (0, $6BdRO.GraphQLSchema)(extendedConfig);
}
function $6ade12bb8df37dc4$export$97eac8f938300c6f(schemaConfig, documentAST, options) {
    var _schemaDef, _schemaDef$descriptio, _schemaDef2, _options$assumeValid;
    // Collect the type definitions and extensions found in the document.
    var typeDefs = [];
    var typeExtensionsMap = Object.create(null); // New directives and types are separate because a directives and types can
    // have the same name. For example, a type named "skip".
    var directiveDefs = [];
    var schemaDef; // Schema extensions are collected which may add additional operation types.
    var schemaExtensions = [];
    for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
        var def = _documentAST$definiti2[_i2];
        if (def.kind === (0, $1c4hI.Kind).SCHEMA_DEFINITION) schemaDef = def;
        else if (def.kind === (0, $1c4hI.Kind).SCHEMA_EXTENSION) schemaExtensions.push(def);
        else if ((0, $9nArG.isTypeDefinitionNode)(def)) typeDefs.push(def);
        else if ((0, $9nArG.isTypeExtensionNode)(def)) {
            var extendedTypeName = def.name.value;
            var existingTypeExtensions = typeExtensionsMap[extendedTypeName];
            typeExtensionsMap[extendedTypeName] = existingTypeExtensions ? existingTypeExtensions.concat([
                def
            ]) : [
                def
            ];
        } else if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) directiveDefs.push(def);
    } // If this document contains no new types, extensions, or directives then
    // return the same unmodified GraphQLSchema instance.
    if (Object.keys(typeExtensionsMap).length === 0 && typeDefs.length === 0 && directiveDefs.length === 0 && schemaExtensions.length === 0 && schemaDef == null) return schemaConfig;
    var typeMap = Object.create(null);
    for(var _i4 = 0, _schemaConfig$types2 = schemaConfig.types; _i4 < _schemaConfig$types2.length; _i4++){
        var existingType = _schemaConfig$types2[_i4];
        typeMap[existingType.name] = extendNamedType(existingType);
    }
    for(var _i6 = 0; _i6 < typeDefs.length; _i6++){
        var _stdTypeMap$name;
        var typeNode = typeDefs[_i6];
        var name = typeNode.name.value;
        typeMap[name] = (_stdTypeMap$name = $6ade12bb8df37dc4$var$stdTypeMap[name]) !== null && _stdTypeMap$name !== void 0 ? _stdTypeMap$name : buildType(typeNode);
    }
    var operationTypes = $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({
        // Get the extended root operation types.
        query: schemaConfig.query && replaceNamedType(schemaConfig.query),
        mutation: schemaConfig.mutation && replaceNamedType(schemaConfig.mutation),
        subscription: schemaConfig.subscription && replaceNamedType(schemaConfig.subscription)
    }, schemaDef && getOperationTypes([
        schemaDef
    ])), getOperationTypes(schemaExtensions)); // Then produce and return a Schema config with these types.
    return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({
        description: (_schemaDef = schemaDef) === null || _schemaDef === void 0 ? void 0 : (_schemaDef$descriptio = _schemaDef.description) === null || _schemaDef$descriptio === void 0 ? void 0 : _schemaDef$descriptio.value
    }, operationTypes), {}, {
        types: (0, $dVq2R.default)(typeMap),
        directives: [].concat(schemaConfig.directives.map(replaceDirective), directiveDefs.map(buildDirective)),
        extensions: undefined,
        astNode: (_schemaDef2 = schemaDef) !== null && _schemaDef2 !== void 0 ? _schemaDef2 : schemaConfig.astNode,
        extensionASTNodes: schemaConfig.extensionASTNodes.concat(schemaExtensions),
        assumeValid: (_options$assumeValid = options === null || options === void 0 ? void 0 : options.assumeValid) !== null && _options$assumeValid !== void 0 ? _options$assumeValid : false
    }); // Below are functions used for producing this schema that have closed over
    // this scope and have access to the schema, cache, and newly defined types.
    function replaceType(type) {
        if ((0, $lXoEQ.isListType)(type)) // $FlowFixMe[incompatible-return]
        return new (0, $lXoEQ.GraphQLList)(replaceType(type.ofType));
        if ((0, $lXoEQ.isNonNullType)(type)) // $FlowFixMe[incompatible-return]
        return new (0, $lXoEQ.GraphQLNonNull)(replaceType(type.ofType));
        return replaceNamedType(type);
    }
    function replaceNamedType(type) {
        // Note: While this could make early assertions to get the correctly
        // typed values, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        return typeMap[type.name];
    }
    function replaceDirective(directive) {
        var config = directive.toConfig();
        return new (0, $bOniD.GraphQLDirective)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            args: (0, $6MWHL.default)(config.args, extendArg)
        }));
    }
    function extendNamedType(type) {
        if ((0, $h2iUh.isIntrospectionType)(type) || (0, $auu22.isSpecifiedScalarType)(type)) // Builtin types are not extended.
        return type;
        if ((0, $lXoEQ.isScalarType)(type)) return extendScalarType(type);
        if ((0, $lXoEQ.isObjectType)(type)) return extendObjectType(type);
        if ((0, $lXoEQ.isInterfaceType)(type)) return extendInterfaceType(type);
        if ((0, $lXoEQ.isUnionType)(type)) return extendUnionType(type);
        if ((0, $lXoEQ.isEnumType)(type)) return extendEnumType(type);
         // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
        if ((0, $lXoEQ.isInputObjectType)(type)) return extendInputObjectType(type);
         // istanbul ignore next (Not reachable. All possible types have been considered)
        (0, $43MJl.default)(0, 'Unexpected type: ' + (0, $biK02.default)(type));
    }
    function extendInputObjectType(type) {
        var _typeExtensionsMap$co;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co !== void 0 ? _typeExtensionsMap$co : [];
        return new (0, $lXoEQ.GraphQLInputObjectType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            fields: function fields() {
                return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, (0, $6MWHL.default)(config.fields, function(field) {
                    return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, field), {}, {
                        type: replaceType(field.type)
                    });
                })), buildInputFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendEnumType(type) {
        var _typeExtensionsMap$ty;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$ty = typeExtensionsMap[type.name]) !== null && _typeExtensionsMap$ty !== void 0 ? _typeExtensionsMap$ty : [];
        return new (0, $lXoEQ.GraphQLEnumType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            values: $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config.values), buildEnumValueMap(extensions)),
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendScalarType(type) {
        var _typeExtensionsMap$co2;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co2 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co2 !== void 0 ? _typeExtensionsMap$co2 : [];
        var specifiedByUrl = config.specifiedByUrl;
        for(var _i8 = 0; _i8 < extensions.length; _i8++){
            var _getSpecifiedByUrl;
            var extensionNode = extensions[_i8];
            specifiedByUrl = (_getSpecifiedByUrl = $6ade12bb8df37dc4$var$getSpecifiedByUrl(extensionNode)) !== null && _getSpecifiedByUrl !== void 0 ? _getSpecifiedByUrl : specifiedByUrl;
        }
        return new (0, $lXoEQ.GraphQLScalarType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            specifiedByUrl: specifiedByUrl,
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendObjectType(type) {
        var _typeExtensionsMap$co3;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co3 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co3 !== void 0 ? _typeExtensionsMap$co3 : [];
        return new (0, $lXoEQ.GraphQLObjectType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            interfaces: function interfaces() {
                return [].concat(type.getInterfaces().map(replaceNamedType), buildInterfaces(extensions));
            },
            fields: function fields() {
                return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, (0, $6MWHL.default)(config.fields, extendField)), buildFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendInterfaceType(type) {
        var _typeExtensionsMap$co4;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co4 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co4 !== void 0 ? _typeExtensionsMap$co4 : [];
        return new (0, $lXoEQ.GraphQLInterfaceType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            interfaces: function interfaces() {
                return [].concat(type.getInterfaces().map(replaceNamedType), buildInterfaces(extensions));
            },
            fields: function fields() {
                return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, (0, $6MWHL.default)(config.fields, extendField)), buildFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendUnionType(type) {
        var _typeExtensionsMap$co5;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co5 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co5 !== void 0 ? _typeExtensionsMap$co5 : [];
        return new (0, $lXoEQ.GraphQLUnionType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            types: function types() {
                return [].concat(type.getTypes().map(replaceNamedType), buildUnionTypes(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendField(field) {
        return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, field), {}, {
            type: replaceType(field.type),
            // $FlowFixMe[incompatible-call]
            args: (0, $6MWHL.default)(field.args, extendArg)
        });
    }
    function extendArg(arg) {
        return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, arg), {}, {
            type: replaceType(arg.type)
        });
    }
    function getOperationTypes(nodes) {
        var opTypes = {};
        for(var _i10 = 0; _i10 < nodes.length; _i10++){
            var _node$operationTypes;
            var node = nodes[_i10];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
            for(var _i12 = 0; _i12 < operationTypesNodes.length; _i12++){
                var operationType = operationTypesNodes[_i12];
                opTypes[operationType.operation] = getNamedType(operationType.type);
            }
        } // Note: While this could make early assertions to get the correctly
        // typed values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        return opTypes;
    }
    function getNamedType(node) {
        var _stdTypeMap$name2;
        var name = node.name.value;
        var type = (_stdTypeMap$name2 = $6ade12bb8df37dc4$var$stdTypeMap[name]) !== null && _stdTypeMap$name2 !== void 0 ? _stdTypeMap$name2 : typeMap[name];
        if (type === undefined) throw new Error("Unknown type: \"".concat(name, "\"."));
        return type;
    }
    function getWrappedType(node) {
        if (node.kind === (0, $1c4hI.Kind).LIST_TYPE) return new (0, $lXoEQ.GraphQLList)(getWrappedType(node.type));
        if (node.kind === (0, $1c4hI.Kind).NON_NULL_TYPE) return new (0, $lXoEQ.GraphQLNonNull)(getWrappedType(node.type));
        return getNamedType(node);
    }
    function buildDirective(node) {
        var locations = node.locations.map(function(_ref) {
            var value = _ref.value;
            return value;
        });
        return new (0, $bOniD.GraphQLDirective)({
            name: node.name.value,
            description: $6ade12bb8df37dc4$export$67580b1c13935958(node, options),
            locations: locations,
            isRepeatable: node.repeatable,
            args: buildArgumentMap(node.arguments),
            astNode: node
        });
    }
    function buildFieldMap(nodes) {
        var fieldConfigMap = Object.create(null);
        for(var _i14 = 0; _i14 < nodes.length; _i14++){
            var _node$fields;
            var node = nodes[_i14];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var nodeFields = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
            for(var _i16 = 0; _i16 < nodeFields.length; _i16++){
                var field = nodeFields[_i16];
                fieldConfigMap[field.name.value] = {
                    // Note: While this could make assertions to get the correctly typed
                    // value, that would throw immediately while type system validation
                    // with validateSchema() will produce more actionable results.
                    type: getWrappedType(field.type),
                    description: $6ade12bb8df37dc4$export$67580b1c13935958(field, options),
                    args: buildArgumentMap(field.arguments),
                    deprecationReason: $6ade12bb8df37dc4$var$getDeprecationReason(field),
                    astNode: field
                };
            }
        }
        return fieldConfigMap;
    }
    function buildArgumentMap(args) {
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var argsNodes = args !== null && args !== void 0 ? args : [];
        var argConfigMap = Object.create(null);
        for(var _i18 = 0; _i18 < argsNodes.length; _i18++){
            var arg = argsNodes[_i18];
            // Note: While this could make assertions to get the correctly typed
            // value, that would throw immediately while type system validation
            // with validateSchema() will produce more actionable results.
            var type = getWrappedType(arg.type);
            argConfigMap[arg.name.value] = {
                type: type,
                description: $6ade12bb8df37dc4$export$67580b1c13935958(arg, options),
                defaultValue: (0, $3E0nn.valueFromAST)(arg.defaultValue, type),
                deprecationReason: $6ade12bb8df37dc4$var$getDeprecationReason(arg),
                astNode: arg
            };
        }
        return argConfigMap;
    }
    function buildInputFieldMap(nodes) {
        var inputFieldMap = Object.create(null);
        for(var _i20 = 0; _i20 < nodes.length; _i20++){
            var _node$fields2;
            var node = nodes[_i20];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var fieldsNodes = (_node$fields2 = node.fields) !== null && _node$fields2 !== void 0 ? _node$fields2 : [];
            for(var _i22 = 0; _i22 < fieldsNodes.length; _i22++){
                var field = fieldsNodes[_i22];
                // Note: While this could make assertions to get the correctly typed
                // value, that would throw immediately while type system validation
                // with validateSchema() will produce more actionable results.
                var type = getWrappedType(field.type);
                inputFieldMap[field.name.value] = {
                    type: type,
                    description: $6ade12bb8df37dc4$export$67580b1c13935958(field, options),
                    defaultValue: (0, $3E0nn.valueFromAST)(field.defaultValue, type),
                    deprecationReason: $6ade12bb8df37dc4$var$getDeprecationReason(field),
                    astNode: field
                };
            }
        }
        return inputFieldMap;
    }
    function buildEnumValueMap(nodes) {
        var enumValueMap = Object.create(null);
        for(var _i24 = 0; _i24 < nodes.length; _i24++){
            var _node$values;
            var node = nodes[_i24];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var valuesNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
            for(var _i26 = 0; _i26 < valuesNodes.length; _i26++){
                var value = valuesNodes[_i26];
                enumValueMap[value.name.value] = {
                    description: $6ade12bb8df37dc4$export$67580b1c13935958(value, options),
                    deprecationReason: $6ade12bb8df37dc4$var$getDeprecationReason(value),
                    astNode: value
                };
            }
        }
        return enumValueMap;
    }
    function buildInterfaces(nodes) {
        var interfaces = [];
        for(var _i28 = 0; _i28 < nodes.length; _i28++){
            var _node$interfaces;
            var node = nodes[_i28];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var interfacesNodes = (_node$interfaces = node.interfaces) !== null && _node$interfaces !== void 0 ? _node$interfaces : [];
            for(var _i30 = 0; _i30 < interfacesNodes.length; _i30++){
                var type = interfacesNodes[_i30];
                // Note: While this could make assertions to get the correctly typed
                // values below, that would throw immediately while type system
                // validation with validateSchema() will produce more actionable
                // results.
                interfaces.push(getNamedType(type));
            }
        }
        return interfaces;
    }
    function buildUnionTypes(nodes) {
        var types = [];
        for(var _i32 = 0; _i32 < nodes.length; _i32++){
            var _node$types;
            var node = nodes[_i32];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var typeNodes = (_node$types = node.types) !== null && _node$types !== void 0 ? _node$types : [];
            for(var _i34 = 0; _i34 < typeNodes.length; _i34++){
                var type = typeNodes[_i34];
                // Note: While this could make assertions to get the correctly typed
                // values below, that would throw immediately while type system
                // validation with validateSchema() will produce more actionable
                // results.
                types.push(getNamedType(type));
            }
        }
        return types;
    }
    function buildType(astNode) {
        var _typeExtensionsMap$na;
        var name = astNode.name.value;
        var description = $6ade12bb8df37dc4$export$67580b1c13935958(astNode, options);
        var extensionNodes = (_typeExtensionsMap$na = typeExtensionsMap[name]) !== null && _typeExtensionsMap$na !== void 0 ? _typeExtensionsMap$na : [];
        switch(astNode.kind){
            case (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION:
                var extensionASTNodes = extensionNodes;
                var allNodes = [
                    astNode
                ].concat(extensionASTNodes);
                return new (0, $lXoEQ.GraphQLObjectType)({
                    name: name,
                    description: description,
                    interfaces: function interfaces() {
                        return buildInterfaces(allNodes);
                    },
                    fields: function fields() {
                        return buildFieldMap(allNodes);
                    },
                    astNode: astNode,
                    extensionASTNodes: extensionASTNodes
                });
            case (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION:
                var _extensionASTNodes = extensionNodes;
                var _allNodes = [
                    astNode
                ].concat(_extensionASTNodes);
                return new (0, $lXoEQ.GraphQLInterfaceType)({
                    name: name,
                    description: description,
                    interfaces: function interfaces() {
                        return buildInterfaces(_allNodes);
                    },
                    fields: function fields() {
                        return buildFieldMap(_allNodes);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes
                });
            case (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION:
                var _extensionASTNodes2 = extensionNodes;
                var _allNodes2 = [
                    astNode
                ].concat(_extensionASTNodes2);
                return new (0, $lXoEQ.GraphQLEnumType)({
                    name: name,
                    description: description,
                    values: buildEnumValueMap(_allNodes2),
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes2
                });
            case (0, $1c4hI.Kind).UNION_TYPE_DEFINITION:
                var _extensionASTNodes3 = extensionNodes;
                var _allNodes3 = [
                    astNode
                ].concat(_extensionASTNodes3);
                return new (0, $lXoEQ.GraphQLUnionType)({
                    name: name,
                    description: description,
                    types: function types() {
                        return buildUnionTypes(_allNodes3);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes3
                });
            case (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION:
                var _extensionASTNodes4 = extensionNodes;
                return new (0, $lXoEQ.GraphQLScalarType)({
                    name: name,
                    description: description,
                    specifiedByUrl: $6ade12bb8df37dc4$var$getSpecifiedByUrl(astNode),
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes4
                });
            case (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION:
                var _extensionASTNodes5 = extensionNodes;
                var _allNodes4 = [
                    astNode
                ].concat(_extensionASTNodes5);
                return new (0, $lXoEQ.GraphQLInputObjectType)({
                    name: name,
                    description: description,
                    fields: function fields() {
                        return buildInputFieldMap(_allNodes4);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes5
                });
        } // istanbul ignore next (Not reachable. All possible type definition nodes have been considered)
        (0, $43MJl.default)(0, 'Unexpected type definition node: ' + (0, $biK02.default)(astNode));
    }
}
var $6ade12bb8df37dc4$var$stdTypeMap = (0, $hbiEd.default)((0, $auu22.specifiedScalarTypes).concat((0, $h2iUh.introspectionTypes)), function(type) {
    return type.name;
});
/**
 * Given a field or enum value node, returns the string value for the
 * deprecation reason.
 */ function $6ade12bb8df37dc4$var$getDeprecationReason(node) {
    var deprecated = (0, $gqGQB.getDirectiveValues)((0, $bOniD.GraphQLDeprecatedDirective), node);
    return deprecated === null || deprecated === void 0 ? void 0 : deprecated.reason;
}
/**
 * Given a scalar node, returns the string value for the specifiedByUrl.
 */ function $6ade12bb8df37dc4$var$getSpecifiedByUrl(node) {
    var specifiedBy = (0, $gqGQB.getDirectiveValues)((0, $bOniD.GraphQLSpecifiedByDirective), node);
    return specifiedBy === null || specifiedBy === void 0 ? void 0 : specifiedBy.url;
}
function $6ade12bb8df37dc4$export$67580b1c13935958(node, options) {
    if (node.description) return node.description.value;
    if ((options === null || options === void 0 ? void 0 : options.commentDescriptions) === true) {
        var rawValue = $6ade12bb8df37dc4$var$getLeadingCommentBlock(node);
        if (rawValue !== undefined) return (0, $flA0a.dedentBlockStringValue)('\n' + rawValue);
    }
}
function $6ade12bb8df37dc4$var$getLeadingCommentBlock(node) {
    var loc = node.loc;
    if (!loc) return;
    var comments = [];
    var token = loc.startToken.prev;
    while(token != null && token.kind === (0, $hFu5F.TokenKind).COMMENT && token.next && token.prev && token.line + 1 === token.next.line && token.line !== token.prev.line){
        var value = String(token.value);
        comments.push(value);
        token = token.prev;
    }
    return comments.length > 0 ? comments.reverse().join('\n') : undefined;
}

});


parcelRegister("9Dtw4", function(module, exports) {
var $703ea6dd6d6923b7$var$__assign = module.exports && module.exports.__assign || function() {
    $703ea6dd6d6923b7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $703ea6dd6d6923b7$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1c4hI = parcelRequire("1c4hI");
function $703ea6dd6d6923b7$var$filterExtensionDefinitions(ast) {
    var extensionDefs = ast.definitions.filter(function(def) {
        return def.kind !== $1c4hI.Kind.OBJECT_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.INTERFACE_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.INPUT_OBJECT_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.UNION_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.ENUM_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.SCALAR_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.SCHEMA_EXTENSION;
    });
    return $703ea6dd6d6923b7$var$__assign($703ea6dd6d6923b7$var$__assign({}, ast), {
        definitions: extensionDefs
    });
}
module.exports.default = $703ea6dd6d6923b7$var$filterExtensionDefinitions;

});


parcelRegister("zi3Qo", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");
function $06a14789b0ee6806$var$chainResolvers(resolvers) {
    return function(root, args, ctx, info) {
        return resolvers.reduce(function(prev, curResolver) {
            if (curResolver) return curResolver(prev, args, ctx, info);
            return $3MP74.defaultFieldResolver(prev, args, ctx, info);
        }, root);
    };
}
module.exports.chainResolvers = $06a14789b0ee6806$var$chainResolvers;

});

parcelRegister("3zHIx", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");

var $cYGSS = parcelRequire("cYGSS");
// If we have any union or interface types throw if no there is no resolveType or isTypeOf resolvers
function $29a68d5bffacbb58$var$checkForResolveTypeResolver(schema, requireResolversForResolveType) {
    Object.keys(schema.getTypeMap()).map(function(typeName) {
        return schema.getType(typeName);
    }).forEach(function(type) {
        if (!(type instanceof $lXoEQ.GraphQLUnionType || type instanceof $lXoEQ.GraphQLInterfaceType)) return;
        if (!type.resolveType) {
            if (requireResolversForResolveType === false) return;
            if (requireResolversForResolveType === true) throw new $cYGSS.SchemaError("Type \"" + type.name + "\" is missing a \"resolveType\" resolver");
            // tslint:disable-next-line:max-line-length
            console.warn("Type \"" + type.name + "\" is missing a \"__resolveType\" resolver. Pass false into " + "\"resolverValidationOptions.requireResolversForResolveType\" to disable this warning.");
        }
    });
}
module.exports.default = $29a68d5bffacbb58$var$checkForResolveTypeResolver;

});

parcelRegister("fzT6r", function(module, exports) {
var $b574de2b55f17580$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aKlnM = parcelRequire("aKlnM");

var $cYGSS = parcelRequire("cYGSS");
function $b574de2b55f17580$var$concatenateTypeDefs(typeDefinitionsAry, calledFunctionRefs) {
    if (calledFunctionRefs === void 0) calledFunctionRefs = [];
    var resolvedTypeDefinitions = [];
    typeDefinitionsAry.forEach(function(typeDef) {
        if (typeDef.kind !== undefined) typeDef = $aKlnM.print(typeDef);
        if (typeof typeDef === 'function') {
            if (calledFunctionRefs.indexOf(typeDef) === -1) {
                calledFunctionRefs.push(typeDef);
                resolvedTypeDefinitions = resolvedTypeDefinitions.concat($b574de2b55f17580$var$concatenateTypeDefs(typeDef(), calledFunctionRefs));
            }
        } else if (typeof typeDef === 'string') resolvedTypeDefinitions.push(typeDef.trim());
        else {
            var type = typeof typeDef;
            throw new $cYGSS.SchemaError("typeDef array must contain only strings and functions, got " + type);
        }
    });
    return $b574de2b55f17580$var$uniq(resolvedTypeDefinitions.map(function(x) {
        return x.trim();
    })).join('\n');
}
function $b574de2b55f17580$var$uniq(array) {
    return array.reduce(function(accumulator, currentValue) {
        return accumulator.indexOf(currentValue) === -1 ? $b574de2b55f17580$var$__spreadArrays(accumulator, [
            currentValue
        ]) : accumulator;
    }, []);
}
module.exports.default = $b574de2b55f17580$var$concatenateTypeDefs;

});

parcelRegister("jhVll", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");
/*
 * fn: The function to decorate with the logger
 * logger: an object instance of type Logger
 * hint: an optional hint to add to the error's message
 */ function $e0ac160d29c86bae$var$decorateWithLogger(fn, logger, hint) {
    if (typeof fn === 'undefined') fn = $3MP74.defaultFieldResolver;
    var logError = function(e) {
        // TODO: clone the error properly
        var newE = new Error();
        newE.stack = e.stack;
        /* istanbul ignore else: always get the hint from addErrorLoggingToSchema */ if (hint) {
            newE['originalMessage'] = e.message;
            newE['message'] = "Error in resolver " + hint + "\n" + e.message;
        }
        logger.log(newE);
    };
    return function(root, args, ctx, info) {
        try {
            var result = fn(root, args, ctx, info);
            // If the resolve function returns a Promise log any Promise rejects.
            if (result && typeof result.then === 'function' && typeof result.catch === 'function') result.catch(function(reason) {
                // make sure that it's an error we're logging.
                var error = reason instanceof Error ? reason : new Error(reason);
                logError(error);
                // We don't want to leave an unhandled exception so pass on error.
                return reason;
            });
            return result;
        } catch (e) {
            logError(e);
            // we want to pass on the error, just in case.
            throw e;
        }
    };
}
module.exports.default = $e0ac160d29c86bae$var$decorateWithLogger;

});

parcelRegister("anY4o", function(module, exports) {
var $78faa5f901c93c41$var$__assign = module.exports && module.exports.__assign || function() {
    $78faa5f901c93c41$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $78faa5f901c93c41$var$__assign.apply(this, arguments);
};
var $78faa5f901c93c41$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
function $78faa5f901c93c41$var$extendResolversFromInterfaces(schema, resolvers) {
    var typeNames = Object.keys($78faa5f901c93c41$var$__assign($78faa5f901c93c41$var$__assign({}, schema.getTypeMap()), resolvers));
    var extendedResolvers = {};
    typeNames.forEach(function(typeName) {
        var typeResolvers = resolvers[typeName];
        var type = schema.getType(typeName);
        if (type instanceof $lXoEQ.GraphQLObjectType) {
            var interfaceResolvers = type.getInterfaces().map(function(iFace) {
                return resolvers[iFace.name];
            });
            extendedResolvers[typeName] = Object.assign.apply(Object, $78faa5f901c93c41$var$__spreadArrays([
                {}
            ], interfaceResolvers, [
                typeResolvers
            ]));
        } else if (typeResolvers) extendedResolvers[typeName] = typeResolvers;
    });
    return extendedResolvers;
}
module.exports.default = $78faa5f901c93c41$var$extendResolversFromInterfaces;

});

parcelRegister("4YHnC", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $39fe6a5e79c5f7d4$var$newExtensionDefinitionKind = 'ObjectTypeExtension';
var $39fe6a5e79c5f7d4$var$interfaceExtensionDefinitionKind = 'InterfaceTypeExtension';
var $39fe6a5e79c5f7d4$var$inputObjectExtensionDefinitionKind = 'InputObjectTypeExtension';
var $39fe6a5e79c5f7d4$var$unionExtensionDefinitionKind = 'UnionTypeExtension';
var $39fe6a5e79c5f7d4$var$enumExtensionDefinitionKind = 'EnumTypeExtension';
function $39fe6a5e79c5f7d4$var$extractExtensionDefinitions(ast) {
    var extensionDefs = ast.definitions.filter(function(def) {
        return def.kind === $39fe6a5e79c5f7d4$var$newExtensionDefinitionKind || def.kind === $39fe6a5e79c5f7d4$var$interfaceExtensionDefinitionKind || def.kind === $39fe6a5e79c5f7d4$var$inputObjectExtensionDefinitionKind || def.kind === $39fe6a5e79c5f7d4$var$unionExtensionDefinitionKind || def.kind === $39fe6a5e79c5f7d4$var$enumExtensionDefinitionKind;
    });
    return Object.assign({}, ast, {
        definitions: extensionDefs
    });
}
module.exports.default = $39fe6a5e79c5f7d4$var$extractExtensionDefinitions;

});

parcelRegister("bKZOs", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
function $88f3f05290386e89$var$forEachField(schema, fn) {
    var typeMap = schema.getTypeMap();
    Object.keys(typeMap).forEach(function(typeName) {
        var type = typeMap[typeName];
        // TODO: maybe have an option to include these?
        if (!$lXoEQ.getNamedType(type).name.startsWith('__') && type instanceof $lXoEQ.GraphQLObjectType) {
            var fields_1 = type.getFields();
            Object.keys(fields_1).forEach(function(fieldName) {
                var field = fields_1[fieldName];
                fn(field, typeName, fieldName);
            });
        }
    });
}
module.exports.default = $88f3f05290386e89$var$forEachField;

});

parcelRegister("69KMn", function(module, exports) {
var $47b7debb288af193$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// @schemaDefinition: A GraphQL type schema in shorthand
// @resolvers: Definitions for resolvers to be merged with schema
var $47b7debb288af193$var$SchemaError = /** @class */ function(_super) {
    $47b7debb288af193$var$__extends(SchemaError, _super);
    function SchemaError(message) {
        var _this = _super.call(this, message) || this;
        _this.message = message;
        Error.captureStackTrace(_this, _this.constructor);
        return _this;
    }
    return SchemaError;
}(Error);
module.exports.default = $47b7debb288af193$var$SchemaError;

});



parcelRegister("hbdmQ", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $9CBYi = parcelRequire("9CBYi");
var $6BdRO = parcelRequire("6BdRO");

var $hompL = parcelRequire("hompL");

var $crrCr = parcelRequire("crrCr");
// This function wraps addMockFunctionsToSchema for more convenience
function $c81dd5440f0cf1c4$var$mockServer(schema, mocks, preserveResolvers) {
    if (preserveResolvers === void 0) preserveResolvers = false;
    var mySchema;
    if (!(schema instanceof $6BdRO.GraphQLSchema)) // TODO: provide useful error messages here if this fails
    mySchema = $crrCr.buildSchemaFromTypeDefinitions(schema);
    else mySchema = schema;
    $c81dd5440f0cf1c4$var$addMockFunctionsToSchema({
        schema: mySchema,
        mocks: mocks,
        preserveResolvers: preserveResolvers
    });
    return {
        query: function(query, vars) {
            return $9CBYi.graphql(mySchema, query, {}, {}, vars);
        }
    };
}
module.exports.mockServer = $c81dd5440f0cf1c4$var$mockServer;
var $c81dd5440f0cf1c4$var$defaultMockMap = new Map();
$c81dd5440f0cf1c4$var$defaultMockMap.set('Int', function() {
    return Math.round(Math.random() * 200) - 100;
});
$c81dd5440f0cf1c4$var$defaultMockMap.set('Float', function() {
    return Math.random() * 200 - 100;
});
$c81dd5440f0cf1c4$var$defaultMockMap.set('String', function() {
    return 'Hello World';
});
$c81dd5440f0cf1c4$var$defaultMockMap.set('Boolean', function() {
    return Math.random() > 0.5;
});
$c81dd5440f0cf1c4$var$defaultMockMap.set('ID', function() {
    return $hompL.v4();
});
// TODO allow providing a seed such that lengths of list could be deterministic
// this could be done by using casual to get a random list length if the casual
// object is global.
function $c81dd5440f0cf1c4$var$addMockFunctionsToSchema(_a) {
    var schema = _a.schema, _b = _a.mocks, mocks = _b === void 0 ? {} : _b, _c = _a.preserveResolvers, preserveResolvers = _c === void 0 ? false : _c;
    if (!schema) throw new Error('Must provide schema to mock');
    if (!(schema instanceof $6BdRO.GraphQLSchema)) throw new Error('Value at "schema" must be of type GraphQLSchema');
    if (!$c81dd5440f0cf1c4$var$isObject(mocks)) throw new Error('mocks must be of type Object');
    // use Map internally, because that API is nicer.
    var mockFunctionMap = new Map();
    Object.keys(mocks).forEach(function(typeName) {
        mockFunctionMap.set(typeName, mocks[typeName]);
    });
    mockFunctionMap.forEach(function(mockFunction, mockTypeName) {
        if (typeof mockFunction !== 'function') throw new Error("mockFunctionMap[" + mockTypeName + "] must be a function");
    });
    var mockType = function(type, typeName, fieldName) {
        // order of precendence for mocking:
        // 1. if the object passed in already has fieldName, just use that
        // --> if it's a function, that becomes your resolver
        // --> if it's a value, the mock resolver will return that
        // 2. if the nullableType is a list, recurse
        // 2. if there's a mock defined for this typeName, that will be used
        // 3. if there's no mock defined, use the default mocks for this type
        return function(root, args, context, info) {
            // nullability doesn't matter for the purpose of mocking.
            var fieldType = $lXoEQ.getNullableType(type);
            var namedFieldType = $lXoEQ.getNamedType(fieldType);
            if (root && typeof root[fieldName] !== 'undefined') {
                var result = void 0;
                // if we're here, the field is already defined
                if (typeof root[fieldName] === 'function') {
                    result = root[fieldName](root, args, context, info);
                    if (result instanceof $c81dd5440f0cf1c4$var$MockList) result = result.mock(root, args, context, info, fieldType, mockType);
                } else result = root[fieldName];
                // Now we merge the result with the default mock for this type.
                // This allows overriding defaults while writing very little code.
                if (mockFunctionMap.has(namedFieldType.name)) result = $c81dd5440f0cf1c4$var$mergeMocks(mockFunctionMap.get(namedFieldType.name).bind(null, root, args, context, info), result);
                return result;
            }
            if (fieldType instanceof $lXoEQ.GraphQLList || fieldType instanceof $lXoEQ.GraphQLNonNull) return [
                mockType(fieldType.ofType)(root, args, context, info),
                mockType(fieldType.ofType)(root, args, context, info)
            ];
            if (mockFunctionMap.has(fieldType.name) && !(fieldType instanceof $lXoEQ.GraphQLUnionType || fieldType instanceof $lXoEQ.GraphQLInterfaceType)) // the object passed doesn't have this field, so we apply the default mock
            return mockFunctionMap.get(fieldType.name)(root, args, context, info);
            if (fieldType instanceof $lXoEQ.GraphQLObjectType) // objects don't return actual data, we only need to mock scalars!
            return {};
            // if a mock function is provided for unionType or interfaceType, execute it to resolve the concrete type
            // otherwise randomly pick a type from all implementation types
            if (fieldType instanceof $lXoEQ.GraphQLUnionType || fieldType instanceof $lXoEQ.GraphQLInterfaceType) {
                var implementationType = void 0;
                if (mockFunctionMap.has(fieldType.name)) {
                    var interfaceMockObj = mockFunctionMap.get(fieldType.name)(root, args, context, info);
                    if (!interfaceMockObj || !interfaceMockObj.__typename) return Error("Please return a __typename in \"" + fieldType.name + "\"");
                    implementationType = schema.getType(interfaceMockObj.__typename);
                } else {
                    var possibleTypes = schema.getPossibleTypes(fieldType);
                    implementationType = $c81dd5440f0cf1c4$var$getRandomElement(possibleTypes);
                }
                return Object.assign({
                    __typename: implementationType
                }, mockType(implementationType)(root, args, context, info));
            }
            if (fieldType instanceof $lXoEQ.GraphQLEnumType) return $c81dd5440f0cf1c4$var$getRandomElement(fieldType.getValues()).value;
            if ($c81dd5440f0cf1c4$var$defaultMockMap.has(fieldType.name)) return $c81dd5440f0cf1c4$var$defaultMockMap.get(fieldType.name)(root, args, context, info);
            // if we get to here, we don't have a value, and we don't have a mock for this type,
            // we could return undefined, but that would be hard to debug, so we throw instead.
            // however, we returning it instead of throwing it, so preserveResolvers can handle the failures.
            return Error("No mock defined for type \"" + fieldType.name + "\"");
        };
    };
    $crrCr.forEachField(schema, function(field, typeName, fieldName) {
        $c81dd5440f0cf1c4$var$assignResolveType(field.type, preserveResolvers);
        var mockResolver;
        // we have to handle the root mutation and root query types differently,
        // because no resolver is called at the root.
        /* istanbul ignore next: Must provide schema DefinitionNode with query type or a type named Query. */ var isOnQueryType = schema.getQueryType() && schema.getQueryType().name === typeName;
        var isOnMutationType = schema.getMutationType() && schema.getMutationType().name === typeName;
        if (isOnQueryType || isOnMutationType) {
            if (mockFunctionMap.has(typeName)) {
                var rootMock_1 = mockFunctionMap.get(typeName);
                // XXX: BUG in here, need to provide proper signature for rootMock.
                if (typeof rootMock_1(undefined, {}, {}, {})[fieldName] === 'function') mockResolver = function(root, args, context, info) {
                    var updatedRoot = root || {}; // TODO: should we clone instead?
                    updatedRoot[fieldName] = rootMock_1(root, args, context, info)[fieldName];
                    // XXX this is a bit of a hack to still use mockType, which
                    // lets you mock lists etc. as well
                    // otherwise we could just set field.resolve to rootMock()[fieldName]
                    // it's like pretending there was a resolve function that ran before
                    // the root resolve function.
                    return mockType(field.type, typeName, fieldName)(updatedRoot, args, context, info);
                };
            }
        }
        if (!mockResolver) mockResolver = mockType(field.type, typeName, fieldName);
        if (!preserveResolvers || !field.resolve) field.resolve = mockResolver;
        else {
            var oldResolver_1 = field.resolve;
            field.resolve = function(rootObject, args, context, info) {
                return Promise.all([
                    mockResolver(rootObject, args, context, info),
                    oldResolver_1(rootObject, args, context, info)
                ]).then(function(values) {
                    var mockedValue = values[0], resolvedValue = values[1];
                    // In case we couldn't mock
                    if (mockedValue instanceof Error) {
                        // only if value was not resolved, populate the error.
                        if (undefined === resolvedValue) throw mockedValue;
                        return resolvedValue;
                    }
                    if (resolvedValue instanceof Date && mockedValue instanceof Date) return undefined !== resolvedValue ? resolvedValue : mockedValue;
                    if ($c81dd5440f0cf1c4$var$isObject(mockedValue) && $c81dd5440f0cf1c4$var$isObject(resolvedValue)) {
                        // Object.assign() won't do here, as we need to all properties, including
                        // the non-enumerable ones and defined using Object.defineProperty
                        var emptyObject = Object.create(Object.getPrototypeOf(resolvedValue));
                        return $c81dd5440f0cf1c4$var$copyOwnProps(emptyObject, resolvedValue, mockedValue);
                    }
                    return undefined !== resolvedValue ? resolvedValue : mockedValue;
                });
            };
        }
    });
}
module.exports.addMockFunctionsToSchema = $c81dd5440f0cf1c4$var$addMockFunctionsToSchema;
function $c81dd5440f0cf1c4$var$isObject(thing) {
    return thing === Object(thing) && !Array.isArray(thing);
}
// returns a random element from that ary
function $c81dd5440f0cf1c4$var$getRandomElement(ary) {
    var sample = Math.floor(Math.random() * ary.length);
    return ary[sample];
}
function $c81dd5440f0cf1c4$var$mergeObjects(a, b) {
    return Object.assign(a, b);
}
function $c81dd5440f0cf1c4$var$copyOwnPropsIfNotPresent(target, source) {
    Object.getOwnPropertyNames(source).forEach(function(prop) {
        if (!Object.getOwnPropertyDescriptor(target, prop)) Object.defineProperty(target, prop, Object.getOwnPropertyDescriptor(source, prop));
    });
}
function $c81dd5440f0cf1c4$var$copyOwnProps(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        var chain = source;
        while(chain){
            $c81dd5440f0cf1c4$var$copyOwnPropsIfNotPresent(target, chain);
            chain = Object.getPrototypeOf(chain);
        }
    });
    return target;
}
// takes either an object or a (possibly nested) array
// and completes the customMock object with any fields
// defined on genericMock
// only merges objects or arrays. Scalars are returned as is
function $c81dd5440f0cf1c4$var$mergeMocks(genericMockFunction, customMock) {
    if (Array.isArray(customMock)) return customMock.map(function(el) {
        return $c81dd5440f0cf1c4$var$mergeMocks(genericMockFunction, el);
    });
    if ($c81dd5440f0cf1c4$var$isObject(customMock)) return $c81dd5440f0cf1c4$var$mergeObjects(genericMockFunction(), customMock);
    return customMock;
}
function $c81dd5440f0cf1c4$var$getResolveType(namedFieldType) {
    if (namedFieldType instanceof $lXoEQ.GraphQLInterfaceType || namedFieldType instanceof $lXoEQ.GraphQLUnionType) return namedFieldType.resolveType;
    else return undefined;
}
function $c81dd5440f0cf1c4$var$assignResolveType(type, preserveResolvers) {
    var fieldType = $lXoEQ.getNullableType(type);
    var namedFieldType = $lXoEQ.getNamedType(fieldType);
    var oldResolveType = $c81dd5440f0cf1c4$var$getResolveType(namedFieldType);
    if (preserveResolvers && oldResolveType && oldResolveType.length) return;
    if (namedFieldType instanceof $lXoEQ.GraphQLUnionType || namedFieldType instanceof $lXoEQ.GraphQLInterfaceType) // the default `resolveType` always returns null. We add a fallback
    // resolution that works with how unions and interface are mocked
    namedFieldType.resolveType = function(data, context, info) {
        return info.schema.getType(data.__typename);
    };
}
var $c81dd5440f0cf1c4$var$MockList = /** @class */ function() {
    // wrappedFunction can return another MockList or a value
    function MockList(len, wrappedFunction) {
        this.len = len;
        if (typeof wrappedFunction !== 'undefined') {
            if (typeof wrappedFunction !== 'function') throw new Error('Second argument to MockList must be a function or undefined');
            this.wrappedFunction = wrappedFunction;
        }
    }
    MockList.prototype.mock = function(root, args, context, info, fieldType, mockTypeFunc) {
        var arr;
        if (Array.isArray(this.len)) arr = new Array(this.randint(this.len[0], this.len[1]));
        else arr = new Array(this.len);
        for(var i = 0; i < arr.length; i++)if (typeof this.wrappedFunction === 'function') {
            var res = this.wrappedFunction(root, args, context, info);
            if (res instanceof MockList) {
                var nullableType = $lXoEQ.getNullableType(fieldType.ofType);
                arr[i] = res.mock(root, args, context, info, nullableType, mockTypeFunc);
            } else arr[i] = res;
        } else arr[i] = mockTypeFunc(fieldType.ofType)(root, args, context, info);
        return arr;
    };
    MockList.prototype.randint = function(low, high) {
        return Math.floor(Math.random() * (high - low + 1) + low);
    };
    return MockList;
}();
module.exports.MockList = $c81dd5440f0cf1c4$var$MockList;

});
parcelRegister("9CBYi", function(module, exports) {

$parcel$export(module.exports, "graphql", () => $c4e440e580a0befe$export$1eb4e7c0ed67b035);

var $cvCbM = parcelRequire("cvCbM");

var $6ds0g = parcelRequire("6ds0g");

var $dGflO = parcelRequire("dGflO");

var $izaFt = parcelRequire("izaFt");

var $3MP74 = parcelRequire("3MP74");
function $c4e440e580a0befe$export$1eb4e7c0ed67b035(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    var _arguments = arguments;
    /* eslint-enable no-redeclare */ // Always return a Promise for a consistent API.
    return new Promise(function(resolve) {
        return resolve(_arguments.length === 1 ? $c4e440e580a0befe$var$graphqlImpl(argsOrSchema) : $c4e440e580a0befe$var$graphqlImpl({
            schema: argsOrSchema,
            source: source,
            rootValue: rootValue,
            contextValue: contextValue,
            variableValues: variableValues,
            operationName: operationName,
            fieldResolver: fieldResolver,
            typeResolver: typeResolver
        }));
    });
}
function $c4e440e580a0befe$export$51b1816fb8b0711e(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    var result = arguments.length === 1 ? $c4e440e580a0befe$var$graphqlImpl(argsOrSchema) : $c4e440e580a0befe$var$graphqlImpl({
        schema: argsOrSchema,
        source: source,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    }); // Assert that the execution was synchronous.
    if ((0, $cvCbM.default)(result)) throw new Error('GraphQL execution failed to complete synchronously.');
    return result;
}
function $c4e440e580a0befe$var$graphqlImpl(args) {
    var schema = args.schema, source = args.source, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, typeResolver = args.typeResolver; // Validate Schema
    var schemaValidationErrors = (0, $izaFt.validateSchema)(schema);
    if (schemaValidationErrors.length > 0) return {
        errors: schemaValidationErrors
    };
     // Parse
    var document;
    try {
        document = (0, $6ds0g.parse)(source);
    } catch (syntaxError) {
        return {
            errors: [
                syntaxError
            ]
        };
    } // Validate
    var validationErrors = (0, $dGflO.validate)(schema, document);
    if (validationErrors.length > 0) return {
        errors: validationErrors
    };
     // Execute
    return (0, $3MP74.execute)({
        schema: schema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    });
}

});


parcelRegister("akAyp", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1kTmX = parcelRequire("1kTmX");
module.exports.makeRemoteExecutableSchema = $1kTmX.default;
module.exports.defaultCreateRemoteResolver = $1kTmX.createResolver;

var $cns77 = parcelRequire("cns77");
module.exports.introspectSchema = $cns77.default;

var $2KwZj = parcelRequire("2KwZj");
module.exports.mergeSchemas = $2KwZj.default;

var $7UWAA = parcelRequire("7UWAA");
module.exports.delegateToSchema = $7UWAA.default;

var $8je8M = parcelRequire("8je8M");
module.exports.defaultMergedResolver = $8je8M.default;

});
parcelRegister("1kTmX", function(module, exports) {
var $0f929bdd6e89143d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0f929bdd6e89143d$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0f929bdd6e89143d$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gUA8G = parcelRequire("gUA8G");
var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $gQVH8 = parcelRequire("gQVH8");

var $i07ri = parcelRequire("i07ri");

var $hRrcw = parcelRequire("hRrcw");

var $crrCr = parcelRequire("crrCr");

var $h8S1f = parcelRequire("h8S1f");

var $j0Odg = parcelRequire("j0Odg");

var $8je8M = parcelRequire("8je8M");

var $10LTa = parcelRequire("10LTa");

var $583I3 = parcelRequire("583I3");
function $0f929bdd6e89143d$var$makeRemoteExecutableSchema(_a) {
    var _b;
    var schema = _a.schema, link = _a.link, fetcher = _a.fetcher, _c = _a.createResolver, customCreateResolver = _c === void 0 ? $0f929bdd6e89143d$var$createResolver : _c, buildSchemaOptions = _a.buildSchemaOptions, _d = _a.printSchemaOptions, printSchemaOptions = _d === void 0 ? {
        commentDescriptions: true
    } : _d;
    if (!fetcher && link) fetcher = $i07ri.default(link);
    var typeDefs;
    if (typeof schema === 'string') {
        typeDefs = schema;
        schema = $gUA8G.buildSchema(typeDefs, buildSchemaOptions);
    } else typeDefs = $gQVH8.printSchema(schema, printSchemaOptions);
    // prepare query resolvers
    var queryResolvers = {};
    var queryType = schema.getQueryType();
    var queries = queryType.getFields();
    Object.keys(queries).forEach(function(key) {
        queryResolvers[key] = customCreateResolver(fetcher);
    });
    // prepare mutation resolvers
    var mutationResolvers = {};
    var mutationType = schema.getMutationType();
    if (mutationType) {
        var mutations = mutationType.getFields();
        Object.keys(mutations).forEach(function(key) {
            mutationResolvers[key] = customCreateResolver(fetcher);
        });
    }
    // prepare subscription resolvers
    var subscriptionResolvers = {};
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType) {
        var subscriptions = subscriptionType.getFields();
        Object.keys(subscriptions).forEach(function(key) {
            subscriptionResolvers[key] = {
                subscribe: $0f929bdd6e89143d$var$createSubscriptionResolver(key, link)
            };
        });
    }
    // merge resolvers into resolver map
    var resolvers = (_b = {}, _b[queryType.name] = queryResolvers, _b);
    if (!$hRrcw.default(mutationResolvers)) resolvers[mutationType.name] = mutationResolvers;
    if (!$hRrcw.default(subscriptionResolvers)) resolvers[subscriptionType.name] = subscriptionResolvers;
    // add missing abstract resolvers (scalar, unions, interfaces)
    var typeMap = schema.getTypeMap();
    var types = Object.keys(typeMap).map(function(name) {
        return typeMap[name];
    });
    var _loop_1 = function(type) {
        if (type instanceof $lXoEQ.GraphQLInterfaceType || type instanceof $lXoEQ.GraphQLUnionType) resolvers[type.name] = {
            __resolveType: function(parent, context, info) {
                return $j0Odg.default(parent, info.schema);
            }
        };
        else if (type instanceof $lXoEQ.GraphQLScalarType) {
            if (!(type === $auu22.GraphQLID || type === $auu22.GraphQLString || type === $auu22.GraphQLFloat || type === $auu22.GraphQLBoolean || type === $auu22.GraphQLInt)) resolvers[type.name] = $h8S1f.recreateType(type, function(name) {
                return null;
            }, false);
        } else if (type instanceof $lXoEQ.GraphQLObjectType && type.name.slice(0, 2) !== '__' && type !== queryType && type !== mutationType && type !== subscriptionType) {
            var resolver_1 = {};
            Object.keys(type.getFields()).forEach(function(field) {
                resolver_1[field] = $8je8M.default;
            });
            resolvers[type.name] = resolver_1;
        }
    };
    for(var _i = 0, types_1 = types; _i < types_1.length; _i++){
        var type = types_1[_i];
        _loop_1(type);
    }
    return $crrCr.makeExecutableSchema({
        typeDefs: typeDefs,
        resolvers: resolvers
    });
}
module.exports.default = $0f929bdd6e89143d$var$makeRemoteExecutableSchema;
function $0f929bdd6e89143d$var$createResolver(fetcher) {
    var _this = this;
    return function(root, args, context, info) {
        return $0f929bdd6e89143d$var$__awaiter(_this, void 0, void 0, function() {
            var fragments, document, result;
            return $0f929bdd6e89143d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        fragments = Object.keys(info.fragments).map(function(fragment) {
                            return info.fragments[fragment];
                        });
                        document = {
                            kind: $1c4hI.Kind.DOCUMENT,
                            definitions: $0f929bdd6e89143d$var$__spreadArrays([
                                info.operation
                            ], fragments)
                        };
                        return [
                            4 /*yield*/ ,
                            fetcher({
                                query: document,
                                variables: info.variableValues,
                                context: {
                                    graphqlContext: context
                                }
                            })
                        ];
                    case 1:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            $10LTa.checkResultAndHandleErrors(result, info)
                        ];
                }
            });
        });
    };
}
module.exports.createResolver = $0f929bdd6e89143d$var$createResolver;
function $0f929bdd6e89143d$var$createSubscriptionResolver(name, link) {
    return function(root, args, context, info) {
        var fragments = Object.keys(info.fragments).map(function(fragment) {
            return info.fragments[fragment];
        });
        var document = {
            kind: $1c4hI.Kind.DOCUMENT,
            definitions: $0f929bdd6e89143d$var$__spreadArrays([
                info.operation
            ], fragments)
        };
        var operation = {
            query: document,
            variables: info.variableValues,
            context: {
                graphqlContext: context
            }
        };
        var observable = $i07ri.execute(link, operation);
        return $583I3.observableToAsyncIterable(observable);
    };
}

});
parcelRegister("gQVH8", function(module, exports) {

$parcel$export(module.exports, "printSchema", () => $ad02b274e585f6bd$export$f7c984b74d0fc2e7);

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $aKlnM = parcelRequire("aKlnM");

var $flA0a = parcelRequire("flA0a");

var $h2iUh = parcelRequire("h2iUh");

var $auu22 = parcelRequire("auu22");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");

var $cMIyS = parcelRequire("cMIyS");
function $ad02b274e585f6bd$export$f7c984b74d0fc2e7(schema, options) {
    return $ad02b274e585f6bd$var$printFilteredSchema(schema, function(n) {
        return !(0, $bOniD.isSpecifiedDirective)(n);
    }, $ad02b274e585f6bd$var$isDefinedType, options);
}
function $ad02b274e585f6bd$export$436bfe9e87d1be55(schema, options) {
    return $ad02b274e585f6bd$var$printFilteredSchema(schema, (0, $bOniD.isSpecifiedDirective), (0, $h2iUh.isIntrospectionType), options);
}
function $ad02b274e585f6bd$var$isDefinedType(type) {
    return !(0, $auu22.isSpecifiedScalarType)(type) && !(0, $h2iUh.isIntrospectionType)(type);
}
function $ad02b274e585f6bd$var$printFilteredSchema(schema, directiveFilter, typeFilter, options) {
    var directives = schema.getDirectives().filter(directiveFilter);
    var types = (0, $dVq2R.default)(schema.getTypeMap()).filter(typeFilter);
    return [
        $ad02b274e585f6bd$var$printSchemaDefinition(schema)
    ].concat(directives.map(function(directive) {
        return $ad02b274e585f6bd$var$printDirective(directive, options);
    }), types.map(function(type) {
        return $ad02b274e585f6bd$export$199528f8b0f9bf49(type, options);
    })).filter(Boolean).join('\n\n') + '\n';
}
function $ad02b274e585f6bd$var$printSchemaDefinition(schema) {
    if (schema.description == null && $ad02b274e585f6bd$var$isSchemaOfCommonNames(schema)) return;
    var operationTypes = [];
    var queryType = schema.getQueryType();
    if (queryType) operationTypes.push("  query: ".concat(queryType.name));
    var mutationType = schema.getMutationType();
    if (mutationType) operationTypes.push("  mutation: ".concat(mutationType.name));
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType) operationTypes.push("  subscription: ".concat(subscriptionType.name));
    return $ad02b274e585f6bd$var$printDescription({}, schema) + "schema {\n".concat(operationTypes.join('\n'), "\n}");
}
/**
 * GraphQL schema define root types for each type of operation. These types are
 * the same as any other type and can be named in any manner, however there is
 * a common naming convention:
 *
 *   schema {
 *     query: Query
 *     mutation: Mutation
 *   }
 *
 * When using this naming convention, the schema description can be omitted.
 */ function $ad02b274e585f6bd$var$isSchemaOfCommonNames(schema) {
    var queryType = schema.getQueryType();
    if (queryType && queryType.name !== 'Query') return false;
    var mutationType = schema.getMutationType();
    if (mutationType && mutationType.name !== 'Mutation') return false;
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType && subscriptionType.name !== 'Subscription') return false;
    return true;
}
function $ad02b274e585f6bd$export$199528f8b0f9bf49(type, options) {
    if ((0, $lXoEQ.isScalarType)(type)) return $ad02b274e585f6bd$var$printScalar(type, options);
    if ((0, $lXoEQ.isObjectType)(type)) return $ad02b274e585f6bd$var$printObject(type, options);
    if ((0, $lXoEQ.isInterfaceType)(type)) return $ad02b274e585f6bd$var$printInterface(type, options);
    if ((0, $lXoEQ.isUnionType)(type)) return $ad02b274e585f6bd$var$printUnion(type, options);
    if ((0, $lXoEQ.isEnumType)(type)) return $ad02b274e585f6bd$var$printEnum(type, options);
     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isInputObjectType)(type)) return $ad02b274e585f6bd$var$printInputObject(type, options);
     // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $43MJl.default)(0, 'Unexpected type: ' + (0, $biK02.default)(type));
}
function $ad02b274e585f6bd$var$printScalar(type, options) {
    return $ad02b274e585f6bd$var$printDescription(options, type) + "scalar ".concat(type.name) + $ad02b274e585f6bd$var$printSpecifiedByUrl(type);
}
function $ad02b274e585f6bd$var$printImplementedInterfaces(type) {
    var interfaces = type.getInterfaces();
    return interfaces.length ? ' implements ' + interfaces.map(function(i) {
        return i.name;
    }).join(' & ') : '';
}
function $ad02b274e585f6bd$var$printObject(type, options) {
    return $ad02b274e585f6bd$var$printDescription(options, type) + "type ".concat(type.name) + $ad02b274e585f6bd$var$printImplementedInterfaces(type) + $ad02b274e585f6bd$var$printFields(options, type);
}
function $ad02b274e585f6bd$var$printInterface(type, options) {
    return $ad02b274e585f6bd$var$printDescription(options, type) + "interface ".concat(type.name) + $ad02b274e585f6bd$var$printImplementedInterfaces(type) + $ad02b274e585f6bd$var$printFields(options, type);
}
function $ad02b274e585f6bd$var$printUnion(type, options) {
    var types = type.getTypes();
    var possibleTypes = types.length ? ' = ' + types.join(' | ') : '';
    return $ad02b274e585f6bd$var$printDescription(options, type) + 'union ' + type.name + possibleTypes;
}
function $ad02b274e585f6bd$var$printEnum(type, options) {
    var values = type.getValues().map(function(value, i) {
        return $ad02b274e585f6bd$var$printDescription(options, value, '  ', !i) + '  ' + value.name + $ad02b274e585f6bd$var$printDeprecated(value.deprecationReason);
    });
    return $ad02b274e585f6bd$var$printDescription(options, type) + "enum ".concat(type.name) + $ad02b274e585f6bd$var$printBlock(values);
}
function $ad02b274e585f6bd$var$printInputObject(type, options) {
    var fields = (0, $dVq2R.default)(type.getFields()).map(function(f, i) {
        return $ad02b274e585f6bd$var$printDescription(options, f, '  ', !i) + '  ' + $ad02b274e585f6bd$var$printInputValue(f);
    });
    return $ad02b274e585f6bd$var$printDescription(options, type) + "input ".concat(type.name) + $ad02b274e585f6bd$var$printBlock(fields);
}
function $ad02b274e585f6bd$var$printFields(options, type) {
    var fields = (0, $dVq2R.default)(type.getFields()).map(function(f, i) {
        return $ad02b274e585f6bd$var$printDescription(options, f, '  ', !i) + '  ' + f.name + $ad02b274e585f6bd$var$printArgs(options, f.args, '  ') + ': ' + String(f.type) + $ad02b274e585f6bd$var$printDeprecated(f.deprecationReason);
    });
    return $ad02b274e585f6bd$var$printBlock(fields);
}
function $ad02b274e585f6bd$var$printBlock(items) {
    return items.length !== 0 ? ' {\n' + items.join('\n') + '\n}' : '';
}
function $ad02b274e585f6bd$var$printArgs(options, args) {
    var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    if (args.length === 0) return '';
     // If every arg does not have a description, print them on one line.
    if (args.every(function(arg) {
        return !arg.description;
    })) return '(' + args.map($ad02b274e585f6bd$var$printInputValue).join(', ') + ')';
    return '(\n' + args.map(function(arg, i) {
        return $ad02b274e585f6bd$var$printDescription(options, arg, '  ' + indentation, !i) + '  ' + indentation + $ad02b274e585f6bd$var$printInputValue(arg);
    }).join('\n') + '\n' + indentation + ')';
}
function $ad02b274e585f6bd$var$printInputValue(arg) {
    var defaultAST = (0, $cMIyS.astFromValue)(arg.defaultValue, arg.type);
    var argDecl = arg.name + ': ' + String(arg.type);
    if (defaultAST) argDecl += " = ".concat((0, $aKlnM.print)(defaultAST));
    return argDecl + $ad02b274e585f6bd$var$printDeprecated(arg.deprecationReason);
}
function $ad02b274e585f6bd$var$printDirective(directive, options) {
    return $ad02b274e585f6bd$var$printDescription(options, directive) + 'directive @' + directive.name + $ad02b274e585f6bd$var$printArgs(options, directive.args) + (directive.isRepeatable ? ' repeatable' : '') + ' on ' + directive.locations.join(' | ');
}
function $ad02b274e585f6bd$var$printDeprecated(reason) {
    if (reason == null) return '';
    var reasonAST = (0, $cMIyS.astFromValue)(reason, (0, $auu22.GraphQLString));
    if (reasonAST && reason !== (0, $bOniD.DEFAULT_DEPRECATION_REASON)) return ' @deprecated(reason: ' + (0, $aKlnM.print)(reasonAST) + ')';
    return ' @deprecated';
}
function $ad02b274e585f6bd$var$printSpecifiedByUrl(scalar) {
    if (scalar.specifiedByUrl == null) return '';
    var url = scalar.specifiedByUrl;
    var urlAST = (0, $cMIyS.astFromValue)(url, (0, $auu22.GraphQLString));
    urlAST || (0, $43MJl.default)(0, 'Unexpected null value returned from `astFromValue` for specifiedByUrl');
    return ' @specifiedBy(url: ' + (0, $aKlnM.print)(urlAST) + ')';
}
function $ad02b274e585f6bd$var$printDescription(options, def) {
    var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var firstInBlock = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var description = def.description;
    if (description == null) return '';
    if ((options === null || options === void 0 ? void 0 : options.commentDescriptions) === true) return $ad02b274e585f6bd$var$printDescriptionWithComments(description, indentation, firstInBlock);
    var preferMultipleLines = description.length > 70;
    var blockString = (0, $flA0a.printBlockString)(description, '', preferMultipleLines);
    var prefix = indentation && !firstInBlock ? '\n' + indentation : indentation;
    return prefix + blockString.replace(/\n/g, '\n' + indentation) + '\n';
}
function $ad02b274e585f6bd$var$printDescriptionWithComments(description, indentation, firstInBlock) {
    var prefix = indentation && !firstInBlock ? '\n' : '';
    var comment = description.split('\n').map(function(line) {
        return indentation + (line !== '' ? '# ' + line : '#');
    }).join('\n');
    return prefix + comment + '\n';
}

});

parcelRegister("i07ri", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bvQX6 = parcelRequire("bvQX6");

var $bvQX6 = parcelRequire("bvQX6");
module.exports.execute = $bvQX6.execute;
function $0361c62ee1cf4ad3$var$linkToFetcher(link) {
    return function(fetcherOperation) {
        return $bvQX6.makePromise($bvQX6.execute(link, fetcherOperation));
    };
}
module.exports.default = $0361c62ee1cf4ad3$var$linkToFetcher;

});

parcelRegister("hRrcw", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $d00c7c79d0194f7f$var$isEmptyObject(obj) {
    if (!obj) return true;
    for(var key in obj){
        if (Object.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
module.exports.default = $d00c7c79d0194f7f$var$isEmptyObject;

});

parcelRegister("583I3", function(module, exports) {
var $3bc093be1df103cf$var$__assign = module.exports && module.exports.__assign || function() {
    $3bc093be1df103cf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3bc093be1df103cf$var$__assign.apply(this, arguments);
};
var $3bc093be1df103cf$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3bc093be1df103cf$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cRJgL = parcelRequire("cRJgL");
function $3bc093be1df103cf$var$observableToAsyncIterable(observable) {
    var _a;
    var pullQueue = [];
    var pushQueue = [];
    var listening = true;
    var pushValue = function(_a) {
        var data = _a.data;
        if (pullQueue.length !== 0) pullQueue.shift()({
            value: data,
            done: false
        });
        else pushQueue.push({
            value: data
        });
    };
    var pushError = function(error) {
        if (pullQueue.length !== 0) pullQueue.shift()({
            value: {
                errors: [
                    error
                ]
            },
            done: false
        });
        else pushQueue.push({
            value: {
                errors: [
                    error
                ]
            }
        });
    };
    var pullValue = function() {
        return new Promise(function(resolve) {
            if (pushQueue.length !== 0) {
                var element = pushQueue.shift();
                // either {value: {errors: [...]}} or {value: ...}
                resolve($3bc093be1df103cf$var$__assign($3bc093be1df103cf$var$__assign({}, element), {
                    done: false
                }));
            } else pullQueue.push(resolve);
        });
    };
    var subscription = observable.subscribe({
        next: function(value) {
            pushValue(value);
        },
        error: function(err) {
            pushError(err);
        }
    });
    var emptyQueue = function() {
        if (listening) {
            listening = false;
            subscription.unsubscribe();
            pullQueue.forEach(function(resolve) {
                return resolve({
                    value: undefined,
                    done: true
                });
            });
            pullQueue.length = 0;
            pushQueue.length = 0;
        }
    };
    return _a = {
        next: function() {
            return $3bc093be1df103cf$var$__awaiter(this, void 0, void 0, function() {
                return $3bc093be1df103cf$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        listening ? pullValue() : this.return()
                    ];
                });
            });
        },
        return: function() {
            emptyQueue();
            return Promise.resolve({
                value: undefined,
                done: true
            });
        },
        throw: function(error) {
            emptyQueue();
            return Promise.reject(error);
        }
    }, _a[$cRJgL.$$asyncIterator] = function() {
        return this;
    }, _a;
}
module.exports.observableToAsyncIterable = $3bc093be1df103cf$var$observableToAsyncIterable;

});
parcelRegister("cRJgL", function(module, exports) {

$parcel$export(module.exports, "$$asyncIterator", () => $367ded6c6908ab1f$export$5ee754c34122a0ae);
/**
 * Copyright (c) 2016, Lee Byron
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 * @ignore
 */ /**
 * [Iterator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator)
 * is a *protocol* which describes a standard way to produce a sequence of
 * values, typically the values of the Iterable represented by this Iterator.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterator-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterator
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator|MDN Iteration protocols}
 */ /**
 * [Iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * their iteration behavior, such as what values are looped over in a
 * [`for...of`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for...of)
 * loop or `iterall`'s `forEach` function. Many [built-in types](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#Builtin_iterables)
 * implement the Iterable protocol, including `Array` and `Map`.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterable-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterable
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable|MDN Iteration protocols}
 */ // In ES2015 environments, Symbol exists
var $367ded6c6908ab1f$var$SYMBOL /*: any */  = typeof Symbol === 'function' ? Symbol : void 0;
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
var $367ded6c6908ab1f$var$SYMBOL_ITERATOR = $367ded6c6908ab1f$var$SYMBOL && $367ded6c6908ab1f$var$SYMBOL.iterator;
var $367ded6c6908ab1f$export$9785f547d3164dac = $367ded6c6908ab1f$var$SYMBOL_ITERATOR || '@@iterator';
function $367ded6c6908ab1f$export$9652023d9040757(obj) {
    return !!$367ded6c6908ab1f$export$23f5ee39f998bf6f(obj);
}
function $367ded6c6908ab1f$export$1e2f57719e155213(obj) {
    var length = obj != null && obj.length;
    return typeof length === 'number' && length >= 0 && length % 1 === 0;
}
function $367ded6c6908ab1f$export$cea7aa84e978eba5(obj) {
    return Object(obj) === obj && ($367ded6c6908ab1f$export$1e2f57719e155213(obj) || $367ded6c6908ab1f$export$9652023d9040757(obj));
}
function $367ded6c6908ab1f$export$6731da38428a8625(iterable) {
    var method = $367ded6c6908ab1f$export$23f5ee39f998bf6f(iterable);
    if (method) return method.call(iterable);
}
function $367ded6c6908ab1f$export$23f5ee39f998bf6f(iterable) {
    if (iterable != null) {
        var method = $367ded6c6908ab1f$var$SYMBOL_ITERATOR && iterable[$367ded6c6908ab1f$var$SYMBOL_ITERATOR] || iterable['@@iterator'];
        if (typeof method === 'function') return method;
    }
}
function $367ded6c6908ab1f$export$7342c78d7e13e778(collection) {
    if (collection != null) {
        var iterator = $367ded6c6908ab1f$export$6731da38428a8625(collection);
        if (iterator) return iterator;
        if ($367ded6c6908ab1f$export$1e2f57719e155213(collection)) return new $367ded6c6908ab1f$var$ArrayLikeIterator(collection);
    }
}
// When the object provided to `createIterator` is not Iterable but is
// Array-like, this simple Iterator is created.
function $367ded6c6908ab1f$var$ArrayLikeIterator(obj) {
    this._o = obj;
    this._i = 0;
}
// Note: all Iterators are themselves Iterable.
$367ded6c6908ab1f$var$ArrayLikeIterator.prototype[$367ded6c6908ab1f$export$9785f547d3164dac] = function() {
    return this;
};
// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
$367ded6c6908ab1f$var$ArrayLikeIterator.prototype.next = function() {
    if (this._o === void 0 || this._i >= this._o.length) {
        this._o = void 0;
        return {
            value: void 0,
            done: true
        };
    }
    return {
        value: this._o[this._i++],
        done: false
    };
};
function $367ded6c6908ab1f$export$4b80e395e36b5a56(collection, callback, thisArg) {
    if (collection != null) {
        if (typeof collection.forEach === 'function') return collection.forEach(callback, thisArg);
        var i = 0;
        var iterator = $367ded6c6908ab1f$export$6731da38428a8625(collection);
        if (iterator) {
            var step;
            while(!(step = iterator.next()).done){
                callback.call(thisArg, step.value, i++, collection);
                // Infinite Iterators could cause forEach to run forever.
                // After a very large number of iterations, produce an error.
                /* istanbul ignore if */ if (i > 9999999) throw new TypeError('Near-infinite iteration.');
            }
        } else if ($367ded6c6908ab1f$export$1e2f57719e155213(collection)) {
            for(; i < collection.length; i++)if (collection.hasOwnProperty(i)) callback.call(thisArg, collection[i], i, collection);
        }
    }
}
/////////////////////////////////////////////////////
//                                                 //
//                 ASYNC ITERATORS                 //
//                                                 //
/////////////////////////////////////////////////////
/**
 * [AsyncIterable](https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * an asynchronous iteration behavior, such as what values are looped over in
 * a [`for-await-of`](https://tc39.github.io/proposal-async-iteration/#sec-for-in-and-for-of-statements)
 * loop or `iterall`'s {@link forAwaitEach} function.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterable
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface|Async Iteration Proposal}
 * @template T The type of each iterated value
 * @property {function (): AsyncIterator<T>} Symbol.asyncIterator
 *   A method which produces an AsyncIterator for this AsyncIterable.
 */ /**
 * [AsyncIterator](https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface)
 * is a *protocol* which describes a standard way to produce and consume an
 * asynchronous sequence of values, typically the values of the
 * {@link AsyncIterable} represented by this {@link AsyncIterator}.
 *
 * AsyncIterator is similar to Observable or Stream. Like an {@link Iterator} it
 * also as a `next()` method, however instead of an IteratorResult,
 * calling this method returns a {@link Promise} for a IteratorResult.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterator
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface|Async Iteration Proposal}
 */ // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $367ded6c6908ab1f$var$SYMBOL_ASYNC_ITERATOR = $367ded6c6908ab1f$var$SYMBOL && $367ded6c6908ab1f$var$SYMBOL.asyncIterator;
var $367ded6c6908ab1f$export$5ee754c34122a0ae = $367ded6c6908ab1f$var$SYMBOL_ASYNC_ITERATOR || '@@asyncIterator';
function $367ded6c6908ab1f$export$edb10ab8dd75a915(obj) {
    return !!$367ded6c6908ab1f$export$b39a85787ec1202f(obj);
}
function $367ded6c6908ab1f$export$d5127502cdffbf83(asyncIterable) {
    var method = $367ded6c6908ab1f$export$b39a85787ec1202f(asyncIterable);
    if (method) return method.call(asyncIterable);
}
function $367ded6c6908ab1f$export$b39a85787ec1202f(asyncIterable) {
    if (asyncIterable != null) {
        var method = $367ded6c6908ab1f$var$SYMBOL_ASYNC_ITERATOR && asyncIterable[$367ded6c6908ab1f$var$SYMBOL_ASYNC_ITERATOR] || asyncIterable['@@asyncIterator'];
        if (typeof method === 'function') return method;
    }
}
function $367ded6c6908ab1f$export$86c18c6347f4a8c4(source) {
    if (source != null) {
        var asyncIterator = $367ded6c6908ab1f$export$d5127502cdffbf83(source);
        if (asyncIterator) return asyncIterator;
        var iterator = $367ded6c6908ab1f$export$7342c78d7e13e778(source);
        if (iterator) return new $367ded6c6908ab1f$var$AsyncFromSyncIterator(iterator);
    }
}
// When the object provided to `createAsyncIterator` is not AsyncIterable but is
// sync Iterable, this simple wrapper is created.
function $367ded6c6908ab1f$var$AsyncFromSyncIterator(iterator) {
    this._i = iterator;
}
// Note: all AsyncIterators are themselves AsyncIterable.
$367ded6c6908ab1f$var$AsyncFromSyncIterator.prototype[$367ded6c6908ab1f$export$5ee754c34122a0ae] = function() {
    return this;
};
// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
$367ded6c6908ab1f$var$AsyncFromSyncIterator.prototype.next = function(value) {
    return $367ded6c6908ab1f$var$unwrapAsyncFromSync(this._i, 'next', value);
};
$367ded6c6908ab1f$var$AsyncFromSyncIterator.prototype.return = function(value) {
    return this._i.return ? $367ded6c6908ab1f$var$unwrapAsyncFromSync(this._i, 'return', value) : Promise.resolve({
        value: value,
        done: true
    });
};
$367ded6c6908ab1f$var$AsyncFromSyncIterator.prototype.throw = function(value) {
    return this._i.throw ? $367ded6c6908ab1f$var$unwrapAsyncFromSync(this._i, 'throw', value) : Promise.reject(value);
};
function $367ded6c6908ab1f$var$unwrapAsyncFromSync(iterator, fn, value) {
    var step;
    return new Promise(function(resolve) {
        step = iterator[fn](value);
        resolve(step.value);
    }).then(function(value) {
        return {
            value: value,
            done: step.done
        };
    });
}
function $367ded6c6908ab1f$export$186aebae43ba1fda(source, callback, thisArg) {
    var asyncIterator = $367ded6c6908ab1f$export$86c18c6347f4a8c4(source);
    if (asyncIterator) {
        var i = 0;
        return new Promise(function(resolve, reject) {
            function next() {
                asyncIterator.next().then(function(step) {
                    if (!step.done) Promise.resolve(callback.call(thisArg, step.value, i++, source)).then(next).catch(reject);
                    else resolve();
                    // Explicitly return null, silencing bluebird-style warnings.
                    return null;
                }).catch(reject);
                // Explicitly return null, silencing bluebird-style warnings.
                return null;
            }
            next();
        });
    }
}

});



parcelRegister("cns77", function(module, exports) {
var $902d70db2f1b5675$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $902d70db2f1b5675$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kYuQD = parcelRequire("kYuQD");
var $6ds0g = parcelRequire("6ds0g");

var $iZRls = parcelRequire("iZRls");

var $i07ri = parcelRequire("i07ri");
var $902d70db2f1b5675$var$parsedIntrospectionQuery = $6ds0g.parse($iZRls.getIntrospectionQuery());
function $902d70db2f1b5675$var$introspectSchema(fetcher, linkContext) {
    return $902d70db2f1b5675$var$__awaiter(this, void 0, void 0, function() {
        var introspectionResult, schema;
        return $902d70db2f1b5675$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    // Convert link to fetcher
                    if (fetcher.request) fetcher = $i07ri.default(fetcher);
                    return [
                        4 /*yield*/ ,
                        fetcher({
                            query: $902d70db2f1b5675$var$parsedIntrospectionQuery,
                            context: linkContext
                        })
                    ];
                case 1:
                    introspectionResult = _a.sent();
                    if (introspectionResult.errors && introspectionResult.errors.length || !introspectionResult.data.__schema) throw introspectionResult.errors;
                    else {
                        schema = $kYuQD.buildClientSchema(introspectionResult.data);
                        return [
                            2 /*return*/ ,
                            schema
                        ];
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.default = $902d70db2f1b5675$var$introspectSchema;

});
parcelRegister("kYuQD", function(module, exports) {

$parcel$export(module.exports, "buildClientSchema", () => $b48bf1e0077cad25$export$de8c236cf09c987c);

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $fZdRY = parcelRequire("fZdRY");

var $2AFgT = parcelRequire("2AFgT");

var $fbtyx = parcelRequire("fbtyx");

var $6ds0g = parcelRequire("6ds0g");

var $6BdRO = parcelRequire("6BdRO");

var $bOniD = parcelRequire("bOniD");

var $auu22 = parcelRequire("auu22");

var $h2iUh = parcelRequire("h2iUh");

var $lXoEQ = parcelRequire("lXoEQ");

var $3E0nn = parcelRequire("3E0nn");
function $b48bf1e0077cad25$export$de8c236cf09c987c(introspection, options) {
    (0, $fbtyx.default)(introspection) && (0, $fbtyx.default)(introspection.__schema) || (0, $fZdRY.default)(0, "Invalid or incomplete introspection result. Ensure that you are passing \"data\" property of introspection response and no \"errors\" was returned alongside: ".concat((0, $biK02.default)(introspection), ".")); // Get the schema from the introspection result.
    var schemaIntrospection = introspection.__schema; // Iterate through all types, getting the type definition for each.
    var typeMap = (0, $2AFgT.default)(schemaIntrospection.types, function(typeIntrospection) {
        return typeIntrospection.name;
    }, function(typeIntrospection) {
        return buildType(typeIntrospection);
    }); // Include standard types only if they are used.
    for(var _i2 = 0, _ref2 = [].concat((0, $auu22.specifiedScalarTypes), (0, $h2iUh.introspectionTypes)); _i2 < _ref2.length; _i2++){
        var stdType = _ref2[_i2];
        if (typeMap[stdType.name]) typeMap[stdType.name] = stdType;
    } // Get the root Query, Mutation, and Subscription types.
    var queryType = schemaIntrospection.queryType ? getObjectType(schemaIntrospection.queryType) : null;
    var mutationType = schemaIntrospection.mutationType ? getObjectType(schemaIntrospection.mutationType) : null;
    var subscriptionType = schemaIntrospection.subscriptionType ? getObjectType(schemaIntrospection.subscriptionType) : null; // Get the directives supported by Introspection, assuming empty-set if
    // directives were not queried for.
    var directives = schemaIntrospection.directives ? schemaIntrospection.directives.map(buildDirective) : []; // Then produce and return a Schema with these types.
    return new (0, $6BdRO.GraphQLSchema)({
        description: schemaIntrospection.description,
        query: queryType,
        mutation: mutationType,
        subscription: subscriptionType,
        types: (0, $dVq2R.default)(typeMap),
        directives: directives,
        assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
    }); // Given a type reference in introspection, return the GraphQLType instance.
    // preferring cached instances before building new instances.
    function getType(typeRef) {
        if (typeRef.kind === (0, $h2iUh.TypeKind).LIST) {
            var itemRef = typeRef.ofType;
            if (!itemRef) throw new Error('Decorated type deeper than introspection query.');
            return new (0, $lXoEQ.GraphQLList)(getType(itemRef));
        }
        if (typeRef.kind === (0, $h2iUh.TypeKind).NON_NULL) {
            var nullableRef = typeRef.ofType;
            if (!nullableRef) throw new Error('Decorated type deeper than introspection query.');
            var nullableType = getType(nullableRef);
            return new (0, $lXoEQ.GraphQLNonNull)((0, $lXoEQ.assertNullableType)(nullableType));
        }
        return getNamedType(typeRef);
    }
    function getNamedType(typeRef) {
        var typeName = typeRef.name;
        if (!typeName) throw new Error("Unknown type reference: ".concat((0, $biK02.default)(typeRef), "."));
        var type = typeMap[typeName];
        if (!type) throw new Error("Invalid or incomplete schema, unknown type: ".concat(typeName, ". Ensure that a full introspection query is used in order to build a client schema."));
        return type;
    }
    function getObjectType(typeRef) {
        return (0, $lXoEQ.assertObjectType)(getNamedType(typeRef));
    }
    function getInterfaceType(typeRef) {
        return (0, $lXoEQ.assertInterfaceType)(getNamedType(typeRef));
    } // Given a type's introspection result, construct the correct
    // GraphQLType instance.
    function buildType(type) {
        if (type != null && type.name != null && type.kind != null) switch(type.kind){
            case (0, $h2iUh.TypeKind).SCALAR:
                return buildScalarDef(type);
            case (0, $h2iUh.TypeKind).OBJECT:
                return buildObjectDef(type);
            case (0, $h2iUh.TypeKind).INTERFACE:
                return buildInterfaceDef(type);
            case (0, $h2iUh.TypeKind).UNION:
                return buildUnionDef(type);
            case (0, $h2iUh.TypeKind).ENUM:
                return buildEnumDef(type);
            case (0, $h2iUh.TypeKind).INPUT_OBJECT:
                return buildInputObjectDef(type);
        }
        var typeStr = (0, $biK02.default)(type);
        throw new Error("Invalid or incomplete introspection result. Ensure that a full introspection query is used in order to build a client schema: ".concat(typeStr, "."));
    }
    function buildScalarDef(scalarIntrospection) {
        return new (0, $lXoEQ.GraphQLScalarType)({
            name: scalarIntrospection.name,
            description: scalarIntrospection.description,
            specifiedByUrl: scalarIntrospection.specifiedByUrl
        });
    }
    function buildImplementationsList(implementingIntrospection) {
        // TODO: Temporary workaround until GraphQL ecosystem will fully support
        // 'interfaces' on interface types.
        if (implementingIntrospection.interfaces === null && implementingIntrospection.kind === (0, $h2iUh.TypeKind).INTERFACE) return [];
        if (!implementingIntrospection.interfaces) {
            var implementingIntrospectionStr = (0, $biK02.default)(implementingIntrospection);
            throw new Error("Introspection result missing interfaces: ".concat(implementingIntrospectionStr, "."));
        }
        return implementingIntrospection.interfaces.map(getInterfaceType);
    }
    function buildObjectDef(objectIntrospection) {
        return new (0, $lXoEQ.GraphQLObjectType)({
            name: objectIntrospection.name,
            description: objectIntrospection.description,
            interfaces: function interfaces() {
                return buildImplementationsList(objectIntrospection);
            },
            fields: function fields() {
                return buildFieldDefMap(objectIntrospection);
            }
        });
    }
    function buildInterfaceDef(interfaceIntrospection) {
        return new (0, $lXoEQ.GraphQLInterfaceType)({
            name: interfaceIntrospection.name,
            description: interfaceIntrospection.description,
            interfaces: function interfaces() {
                return buildImplementationsList(interfaceIntrospection);
            },
            fields: function fields() {
                return buildFieldDefMap(interfaceIntrospection);
            }
        });
    }
    function buildUnionDef(unionIntrospection) {
        if (!unionIntrospection.possibleTypes) {
            var unionIntrospectionStr = (0, $biK02.default)(unionIntrospection);
            throw new Error("Introspection result missing possibleTypes: ".concat(unionIntrospectionStr, "."));
        }
        return new (0, $lXoEQ.GraphQLUnionType)({
            name: unionIntrospection.name,
            description: unionIntrospection.description,
            types: function types() {
                return unionIntrospection.possibleTypes.map(getObjectType);
            }
        });
    }
    function buildEnumDef(enumIntrospection) {
        if (!enumIntrospection.enumValues) {
            var enumIntrospectionStr = (0, $biK02.default)(enumIntrospection);
            throw new Error("Introspection result missing enumValues: ".concat(enumIntrospectionStr, "."));
        }
        return new (0, $lXoEQ.GraphQLEnumType)({
            name: enumIntrospection.name,
            description: enumIntrospection.description,
            values: (0, $2AFgT.default)(enumIntrospection.enumValues, function(valueIntrospection) {
                return valueIntrospection.name;
            }, function(valueIntrospection) {
                return {
                    description: valueIntrospection.description,
                    deprecationReason: valueIntrospection.deprecationReason
                };
            })
        });
    }
    function buildInputObjectDef(inputObjectIntrospection) {
        if (!inputObjectIntrospection.inputFields) {
            var inputObjectIntrospectionStr = (0, $biK02.default)(inputObjectIntrospection);
            throw new Error("Introspection result missing inputFields: ".concat(inputObjectIntrospectionStr, "."));
        }
        return new (0, $lXoEQ.GraphQLInputObjectType)({
            name: inputObjectIntrospection.name,
            description: inputObjectIntrospection.description,
            fields: function fields() {
                return buildInputValueDefMap(inputObjectIntrospection.inputFields);
            }
        });
    }
    function buildFieldDefMap(typeIntrospection) {
        if (!typeIntrospection.fields) throw new Error("Introspection result missing fields: ".concat((0, $biK02.default)(typeIntrospection), "."));
        return (0, $2AFgT.default)(typeIntrospection.fields, function(fieldIntrospection) {
            return fieldIntrospection.name;
        }, buildField);
    }
    function buildField(fieldIntrospection) {
        var type = getType(fieldIntrospection.type);
        if (!(0, $lXoEQ.isOutputType)(type)) {
            var typeStr = (0, $biK02.default)(type);
            throw new Error("Introspection must provide output type for fields, but received: ".concat(typeStr, "."));
        }
        if (!fieldIntrospection.args) {
            var fieldIntrospectionStr = (0, $biK02.default)(fieldIntrospection);
            throw new Error("Introspection result missing field args: ".concat(fieldIntrospectionStr, "."));
        }
        return {
            description: fieldIntrospection.description,
            deprecationReason: fieldIntrospection.deprecationReason,
            type: type,
            args: buildInputValueDefMap(fieldIntrospection.args)
        };
    }
    function buildInputValueDefMap(inputValueIntrospections) {
        return (0, $2AFgT.default)(inputValueIntrospections, function(inputValue) {
            return inputValue.name;
        }, buildInputValue);
    }
    function buildInputValue(inputValueIntrospection) {
        var type = getType(inputValueIntrospection.type);
        if (!(0, $lXoEQ.isInputType)(type)) {
            var typeStr = (0, $biK02.default)(type);
            throw new Error("Introspection must provide input type for arguments, but received: ".concat(typeStr, "."));
        }
        var defaultValue = inputValueIntrospection.defaultValue != null ? (0, $3E0nn.valueFromAST)((0, $6ds0g.parseValue)(inputValueIntrospection.defaultValue), type) : undefined;
        return {
            description: inputValueIntrospection.description,
            type: type,
            defaultValue: defaultValue,
            deprecationReason: inputValueIntrospection.deprecationReason
        };
    }
    function buildDirective(directiveIntrospection) {
        if (!directiveIntrospection.args) {
            var directiveIntrospectionStr = (0, $biK02.default)(directiveIntrospection);
            throw new Error("Introspection result missing directive args: ".concat(directiveIntrospectionStr, "."));
        }
        if (!directiveIntrospection.locations) {
            var _directiveIntrospectionStr = (0, $biK02.default)(directiveIntrospection);
            throw new Error("Introspection result missing directive locations: ".concat(_directiveIntrospectionStr, "."));
        }
        return new (0, $bOniD.GraphQLDirective)({
            name: directiveIntrospection.name,
            description: directiveIntrospection.description,
            isRepeatable: directiveIntrospection.isRepeatable,
            locations: directiveIntrospection.locations.slice(),
            args: buildInputValueDefMap(directiveIntrospection.args)
        });
    }
}

});

parcelRegister("iZRls", function(module, exports) {

$parcel$export(module.exports, "getIntrospectionQuery", () => $1669bb0e2cec0c6e$export$67a66015194c88d7);
function $1669bb0e2cec0c6e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1669bb0e2cec0c6e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1669bb0e2cec0c6e$var$ownKeys(Object(source), true).forEach(function(key) {
            $1669bb0e2cec0c6e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1669bb0e2cec0c6e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1669bb0e2cec0c6e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1669bb0e2cec0c6e$export$67a66015194c88d7(options) {
    var optionsWithDefault = $1669bb0e2cec0c6e$var$_objectSpread({
        descriptions: true,
        specifiedByUrl: false,
        directiveIsRepeatable: false,
        schemaDescription: false,
        inputValueDeprecation: false
    }, options);
    var descriptions = optionsWithDefault.descriptions ? 'description' : '';
    var specifiedByUrl = optionsWithDefault.specifiedByUrl ? 'specifiedByUrl' : '';
    var directiveIsRepeatable = optionsWithDefault.directiveIsRepeatable ? 'isRepeatable' : '';
    var schemaDescription = optionsWithDefault.schemaDescription ? descriptions : '';
    function inputDeprecation(str) {
        return optionsWithDefault.inputValueDeprecation ? str : '';
    }
    return "\n    query IntrospectionQuery {\n      __schema {\n        ".concat(schemaDescription, "\n        queryType { name }\n        mutationType { name }\n        subscriptionType { name }\n        types {\n          ...FullType\n        }\n        directives {\n          name\n          ").concat(descriptions, "\n          ").concat(directiveIsRepeatable, "\n          locations\n          args").concat(inputDeprecation('(includeDeprecated: true)'), " {\n            ...InputValue\n          }\n        }\n      }\n    }\n\n    fragment FullType on __Type {\n      kind\n      name\n      ").concat(descriptions, "\n      ").concat(specifiedByUrl, "\n      fields(includeDeprecated: true) {\n        name\n        ").concat(descriptions, "\n        args").concat(inputDeprecation('(includeDeprecated: true)'), " {\n          ...InputValue\n        }\n        type {\n          ...TypeRef\n        }\n        isDeprecated\n        deprecationReason\n      }\n      inputFields").concat(inputDeprecation('(includeDeprecated: true)'), " {\n        ...InputValue\n      }\n      interfaces {\n        ...TypeRef\n      }\n      enumValues(includeDeprecated: true) {\n        name\n        ").concat(descriptions, "\n        isDeprecated\n        deprecationReason\n      }\n      possibleTypes {\n        ...TypeRef\n      }\n    }\n\n    fragment InputValue on __InputValue {\n      name\n      ").concat(descriptions, "\n      type { ...TypeRef }\n      defaultValue\n      ").concat(inputDeprecation('isDeprecated'), "\n      ").concat(inputDeprecation('deprecationReason'), "\n    }\n\n    fragment TypeRef on __Type {\n      kind\n      name\n      ofType {\n        kind\n        name\n        ofType {\n          kind\n          name\n          ofType {\n            kind\n            name\n            ofType {\n              kind\n              name\n              ofType {\n                kind\n                name\n                ofType {\n                  kind\n                  name\n                  ofType {\n                    kind\n                    name\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ");
}

});


parcelRegister("2KwZj", function(module, exports) {
var $2009775a7df124d7$var$__assign = module.exports && module.exports.__assign || function() {
    $2009775a7df124d7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2009775a7df124d7$var$__assign.apply(this, arguments);
};
var $2009775a7df124d7$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $glHRe = parcelRequire("glHRe");
var $lXoEQ = parcelRequire("lXoEQ");
var $bOniD = parcelRequire("bOniD");
var $6BdRO = parcelRequire("6BdRO");
var $1c4hI = parcelRequire("1c4hI");
var $6ds0g = parcelRequire("6ds0g");

var $crrCr = parcelRequire("crrCr");

var $h8S1f = parcelRequire("h8S1f");

var $7UWAA = parcelRequire("7UWAA");

var $dkK13 = parcelRequire("dkK13");

var $16dWW = parcelRequire("16dWW");

var $b3EaX = parcelRequire("b3EaX");

var $gVW6u = parcelRequire("gVW6u");
function $2009775a7df124d7$var$mergeSchemas(_a) {
    var schemas = _a.schemas, onTypeConflict = _a.onTypeConflict, resolvers = _a.resolvers, schemaDirectives = _a.schemaDirectives, inheritResolversFromInterfaces = _a.inheritResolversFromInterfaces, mergeDirectives = _a.mergeDirectives;
    return $2009775a7df124d7$var$mergeSchemasImplementation({
        schemas: schemas,
        resolvers: resolvers,
        schemaDirectives: schemaDirectives,
        inheritResolversFromInterfaces: inheritResolversFromInterfaces,
        mergeDirectives: mergeDirectives
    });
}
module.exports.default = $2009775a7df124d7$var$mergeSchemas;
function $2009775a7df124d7$var$mergeSchemasImplementation(_a) {
    var schemas = _a.schemas, resolvers = _a.resolvers, schemaDirectives = _a.schemaDirectives, inheritResolversFromInterfaces = _a.inheritResolversFromInterfaces, mergeDirectives = _a.mergeDirectives;
    var allSchemas = [];
    var typeCandidates = {};
    var types = {};
    var extensions = [];
    var directives = [];
    var fragments = [];
    var resolveType = $h8S1f.createResolveType(function(name) {
        if (types[name] === undefined) throw new Error("Can't find type " + name + ".");
        return types[name];
    });
    schemas.forEach(function(schema) {
        if (schema instanceof $6BdRO.GraphQLSchema) {
            allSchemas.push(schema);
            var queryType_1 = schema.getQueryType();
            var mutationType_1 = schema.getMutationType();
            var subscriptionType_1 = schema.getSubscriptionType();
            if (queryType_1) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, 'Query', {
                schema: schema,
                type: queryType_1
            });
            if (mutationType_1) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, 'Mutation', {
                schema: schema,
                type: mutationType_1
            });
            if (subscriptionType_1) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, 'Subscription', {
                schema: schema,
                type: subscriptionType_1
            });
            if (mergeDirectives) {
                var directiveInstances = schema.getDirectives();
                directiveInstances.forEach(function(directive) {
                    directives.push(directive);
                });
            }
            var typeMap_1 = schema.getTypeMap();
            Object.keys(typeMap_1).forEach(function(typeName) {
                var type = typeMap_1[typeName];
                if ($lXoEQ.isNamedType(type) && $lXoEQ.getNamedType(type).name.slice(0, 2) !== '__' && type !== queryType_1 && type !== mutationType_1 && type !== subscriptionType_1) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, type.name, {
                    schema: schema,
                    type: type
                });
            });
        } else if (typeof schema === 'string' || schema && schema.kind === $1c4hI.Kind.DOCUMENT) {
            var parsedSchemaDocument = typeof schema === 'string' ? $6ds0g.parse(schema) : schema;
            parsedSchemaDocument.definitions.forEach(function(def) {
                var type = $dkK13.default(def);
                if (type instanceof $bOniD.GraphQLDirective && mergeDirectives) directives.push(type);
                else if (type && !(type instanceof $bOniD.GraphQLDirective)) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, type.name, {
                    type: type
                });
            });
            var extensionsDocument = $crrCr.extractExtensionDefinitions(parsedSchemaDocument);
            if (extensionsDocument.definitions.length > 0) extensions.push(extensionsDocument);
        } else if (Array.isArray(schema)) schema.forEach(function(type) {
            $2009775a7df124d7$var$addTypeCandidate(typeCandidates, type.name, {
                type: type
            });
        });
        else throw new Error("Invalid schema passed");
    });
    var mergeInfo = $2009775a7df124d7$var$createMergeInfo(allSchemas, fragments);
    if (!resolvers) resolvers = {};
    else if (typeof resolvers === 'function') {
        console.warn('Passing functions as resolver parameter is deprecated. Use `info.mergeInfo` instead.');
        resolvers = resolvers(mergeInfo);
    } else if (Array.isArray(resolvers)) resolvers = resolvers.reduce(function(left, right) {
        if (typeof right === 'function') {
            console.warn('Passing functions as resolver parameter is deprecated. Use `info.mergeInfo` instead.');
            right = right(mergeInfo);
        }
        return $b3EaX.default(left, right);
    }, {});
    var generatedResolvers = {};
    Object.keys(typeCandidates).forEach(function(typeName) {
        var resultType = $2009775a7df124d7$var$defaultVisitType(typeName, typeCandidates[typeName]);
        if (resultType === null) types[typeName] = null;
        else {
            var type = void 0;
            var typeResolvers = void 0;
            if ($lXoEQ.isNamedType(resultType)) type = resultType;
            else if (resultType.type) {
                type = resultType.type;
                typeResolvers = resultType.resolvers;
            } else throw new Error("Invalid visitType result for type " + typeName);
            types[typeName] = $h8S1f.recreateType(type, resolveType, false);
            if (typeResolvers) generatedResolvers[typeName] = typeResolvers;
        }
    });
    var mergedSchema = new $6BdRO.GraphQLSchema({
        query: types.Query,
        mutation: types.Mutation,
        subscription: types.Subscription,
        types: Object.keys(types).map(function(key) {
            return types[key];
        }),
        directives: directives.map(function(directive) {
            return $h8S1f.recreateDirective(directive, resolveType);
        })
    });
    extensions.forEach(function(extension) {
        mergedSchema = $glHRe.extendSchema(mergedSchema, extension, {
            commentDescriptions: true
        });
    });
    if (!resolvers) resolvers = {};
    else if (Array.isArray(resolvers)) resolvers = resolvers.reduce($b3EaX.default, {});
    Object.keys(resolvers).forEach(function(typeName) {
        var type = resolvers[typeName];
        if (type instanceof $lXoEQ.GraphQLScalarType) return;
        Object.keys(type).forEach(function(fieldName) {
            var field = type[fieldName];
            if (field.fragment) fragments.push({
                field: fieldName,
                fragment: field.fragment
            });
        });
    });
    mergedSchema = $crrCr.addResolveFunctionsToSchema({
        schema: mergedSchema,
        resolvers: $b3EaX.default(generatedResolvers, resolvers),
        inheritResolversFromInterfaces: inheritResolversFromInterfaces
    });
    $2009775a7df124d7$var$forEachField(mergedSchema, function(field) {
        if (field.resolve) {
            var fieldResolver_1 = field.resolve;
            field.resolve = function(parent, args, context, info) {
                var newInfo = $2009775a7df124d7$var$__assign($2009775a7df124d7$var$__assign({}, info), {
                    mergeInfo: mergeInfo
                });
                return fieldResolver_1(parent, args, context, newInfo);
            };
        }
        if (field.subscribe) {
            var fieldResolver_2 = field.subscribe;
            field.subscribe = function(parent, args, context, info) {
                var newInfo = $2009775a7df124d7$var$__assign($2009775a7df124d7$var$__assign({}, info), {
                    mergeInfo: mergeInfo
                });
                return fieldResolver_2(parent, args, context, newInfo);
            };
        }
    });
    if (schemaDirectives) $gVW6u.SchemaDirectiveVisitor.visitSchemaDirectives(mergedSchema, schemaDirectives);
    return mergedSchema;
}
function $2009775a7df124d7$var$createMergeInfo(allSchemas, fragments) {
    return {
        delegate: function(operation, fieldName, args, context, info, transforms) {
            console.warn("`mergeInfo.delegate` is deprecated. Use `mergeInfo.delegateToSchema and pass explicit schema instances.");
            var schema = $2009775a7df124d7$var$guessSchemaByRootField(allSchemas, operation, fieldName);
            var expandTransforms = new $16dWW.ExpandAbstractTypes(info.schema, schema);
            var fragmentTransform = new $16dWW.ReplaceFieldWithFragment(schema, fragments);
            return $7UWAA.default({
                schema: schema,
                operation: operation,
                fieldName: fieldName,
                args: args,
                context: context,
                info: info,
                transforms: $2009775a7df124d7$var$__spreadArrays(transforms || [], [
                    expandTransforms,
                    fragmentTransform
                ])
            });
        },
        delegateToSchema: function(options) {
            return $7UWAA.default($2009775a7df124d7$var$__assign($2009775a7df124d7$var$__assign({}, options), {
                transforms: options.transforms
            }));
        },
        fragments: fragments
    };
}
function $2009775a7df124d7$var$guessSchemaByRootField(schemas, operation, fieldName) {
    for(var _i = 0, schemas_1 = schemas; _i < schemas_1.length; _i++){
        var schema = schemas_1[_i];
        var rootObject = void 0;
        if (operation === 'subscription') rootObject = schema.getSubscriptionType();
        else if (operation === 'mutation') rootObject = schema.getMutationType();
        else rootObject = schema.getQueryType();
        if (rootObject) {
            var fields = rootObject.getFields();
            if (fields[fieldName]) return schema;
        }
    }
    throw new Error("Could not find subschema with field `" + operation + "." + fieldName + "`");
}
function $2009775a7df124d7$var$createDelegatingResolver(schema, operation, fieldName) {
    return function(root, args, context, info) {
        return info.mergeInfo.delegateToSchema({
            schema: schema,
            operation: operation,
            fieldName: fieldName,
            args: args,
            context: context,
            info: info
        });
    };
}
function $2009775a7df124d7$var$forEachField(schema, fn) {
    var typeMap = schema.getTypeMap();
    Object.keys(typeMap).forEach(function(typeName) {
        var type = typeMap[typeName];
        if (!$lXoEQ.getNamedType(type).name.startsWith('__') && type instanceof $lXoEQ.GraphQLObjectType) {
            var fields_1 = type.getFields();
            Object.keys(fields_1).forEach(function(fieldName) {
                var field = fields_1[fieldName];
                fn(field, typeName, fieldName);
            });
        }
    });
}
function $2009775a7df124d7$var$addTypeCandidate(typeCandidates, name, typeCandidate) {
    if (!typeCandidates[name]) typeCandidates[name] = [];
    typeCandidates[name].push(typeCandidate);
}
function $2009775a7df124d7$var$defaultVisitType(name, candidates, candidateSelector) {
    if (!candidateSelector) candidateSelector = function(cands) {
        return cands[cands.length - 1];
    };
    var resolveType = $h8S1f.createResolveType(function(_, type) {
        return type;
    });
    if (name === 'Query' || name === 'Mutation' || name === 'Subscription') {
        var fields_2 = {};
        var operationName_1;
        switch(name){
            case 'Query':
                operationName_1 = 'query';
                break;
            case 'Mutation':
                operationName_1 = 'mutation';
                break;
            case 'Subscription':
                operationName_1 = 'subscription';
                break;
            default:
                break;
        }
        var resolvers_1 = {};
        var resolverKey_1 = operationName_1 === 'subscription' ? 'subscribe' : 'resolve';
        candidates.forEach(function(_a) {
            var candidateType = _a.type, schema = _a.schema;
            var candidateFields = candidateType.getFields();
            fields_2 = $2009775a7df124d7$var$__assign($2009775a7df124d7$var$__assign({}, fields_2), candidateFields);
            Object.keys(candidateFields).forEach(function(fieldName) {
                var _a;
                resolvers_1[fieldName] = (_a = {}, _a[resolverKey_1] = $2009775a7df124d7$var$createDelegatingResolver(schema, operationName_1, fieldName), _a);
            });
        });
        var type = new $lXoEQ.GraphQLObjectType({
            name: name,
            fields: $h8S1f.fieldMapToFieldConfigMap(fields_2, resolveType, false)
        });
        return {
            type: type,
            resolvers: resolvers_1
        };
    } else {
        var candidate = candidateSelector(candidates);
        return candidate.type;
    }
}

});
parcelRegister("7UWAA", function(module, exports) {
var $5c3b35ed0de98ad1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5c3b35ed0de98ad1$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5c3b35ed0de98ad1$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");
var $6BdRO = parcelRequire("6BdRO");
var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $2vhbx = parcelRequire("2vhbx");
var $dGflO = parcelRequire("dGflO");

var $esVhq = parcelRequire("esVhq");

var $iijzq = parcelRequire("iijzq");

var $8Vthi = parcelRequire("8Vthi");

var $aYyML = parcelRequire("aYyML");

var $gvWNr = parcelRequire("gvWNr");

var $fB7Hv = parcelRequire("fB7Hv");

var $kYtVo = parcelRequire("kYtVo");

var $4trzE = parcelRequire("4trzE");

var $goXjX = parcelRequire("goXjX");
function $5c3b35ed0de98ad1$var$delegateToSchema(options) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (options instanceof $6BdRO.GraphQLSchema) throw new Error("Passing positional arguments to delegateToSchema is a deprecated. Please pass named parameters instead.");
    return $5c3b35ed0de98ad1$var$delegateToSchemaImplementation(options);
}
module.exports.default = $5c3b35ed0de98ad1$var$delegateToSchema;
function $5c3b35ed0de98ad1$var$delegateToSchemaImplementation(options) {
    return $5c3b35ed0de98ad1$var$__awaiter(this, void 0, void 0, function() {
        var info, _a, args, operation, rawDocument, rawRequest, transforms, processedRequest, errors, _b, executionResult;
        return $5c3b35ed0de98ad1$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    info = options.info, _a = options.args, args = _a === void 0 ? {} : _a;
                    operation = options.operation || info.operation.operation;
                    rawDocument = $5c3b35ed0de98ad1$var$createDocument(options.fieldName, operation, info.fieldNodes, Object.keys(info.fragments).map(function(fragmentName) {
                        return info.fragments[fragmentName];
                    }), info.operation.variableDefinitions, info.operation.name);
                    rawRequest = {
                        document: rawDocument,
                        variables: info.variableValues
                    };
                    transforms = $5c3b35ed0de98ad1$var$__spreadArrays(options.transforms || [], [
                        new $kYtVo.default(info.schema, options.schema)
                    ]);
                    if (info.mergeInfo && info.mergeInfo.fragments) transforms.push(new $4trzE.default(options.schema, info.mergeInfo.fragments));
                    transforms = transforms.concat([
                        new $iijzq.default(options.schema, args),
                        new $8Vthi.default(options.schema),
                        new $aYyML.default(options.schema),
                        new $gvWNr.default(info, options.fieldName)
                    ]);
                    if ($lXoEQ.isEnumType(options.info.returnType)) transforms = transforms.concat(new $goXjX.default(options.info.returnType));
                    processedRequest = $esVhq.applyRequestTransforms(rawRequest, transforms);
                    if (!options.skipValidation) {
                        errors = $dGflO.validate(options.schema, processedRequest.document);
                        if (errors.length > 0) throw errors;
                    }
                    if (!(operation === 'query' || operation === 'mutation')) return [
                        3 /*break*/ ,
                        2
                    ];
                    _b = $esVhq.applyResultTransforms;
                    return [
                        4 /*yield*/ ,
                        $3MP74.execute(options.schema, processedRequest.document, info.rootValue, options.context, processedRequest.variables)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _b.apply(void 0, [
                            _c.sent(),
                            transforms
                        ])
                    ];
                case 2:
                    if (!(operation === 'subscription')) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        $2vhbx.subscribe(options.schema, processedRequest.document, info.rootValue, options.context, processedRequest.variables)
                    ];
                case 3:
                    executionResult = _c.sent();
                    // "subscribe" to the subscription result and map the result through the transforms
                    return [
                        2 /*return*/ ,
                        $fB7Hv.default(executionResult, function(result) {
                            var _a;
                            var transformedResult = $esVhq.applyResultTransforms(result, transforms);
                            var subscriptionKey = Object.keys(result.data)[0];
                            // for some reason the returned transformedResult needs to be nested inside the root subscription field
                            // does not work otherwise...
                            return _a = {}, _a[subscriptionKey] = transformedResult, _a;
                        })
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $5c3b35ed0de98ad1$var$createDocument(targetField, targetOperation, originalSelections, fragments, variables, operationName) {
    var selections = [];
    var args = [];
    originalSelections.forEach(function(field) {
        var fieldSelections = field.selectionSet ? field.selectionSet.selections : [];
        selections = selections.concat(fieldSelections);
        args = args.concat(field.arguments || []);
    });
    var selectionSet = null;
    if (selections.length > 0) selectionSet = {
        kind: $1c4hI.Kind.SELECTION_SET,
        selections: selections
    };
    var rootField = {
        kind: $1c4hI.Kind.FIELD,
        alias: null,
        arguments: args,
        selectionSet: selectionSet,
        name: {
            kind: $1c4hI.Kind.NAME,
            value: targetField
        }
    };
    var rootSelectionSet = {
        kind: $1c4hI.Kind.SELECTION_SET,
        selections: [
            rootField
        ]
    };
    var operationDefinition = {
        kind: $1c4hI.Kind.OPERATION_DEFINITION,
        operation: targetOperation,
        variableDefinitions: variables,
        selectionSet: rootSelectionSet,
        name: operationName
    };
    return {
        kind: $1c4hI.Kind.DOCUMENT,
        definitions: $5c3b35ed0de98ad1$var$__spreadArrays([
            operationDefinition
        ], fragments)
    };
}

});
parcelRegister("2vhbx", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $0952dea42f1ba206$export$ec068583843480e7);

var $biK02 = parcelRequire("biK02");

var $lVzNK = parcelRequire("lVzNK");

var $kZHaf = parcelRequire("kZHaf");

var $9fgMZ = parcelRequire("9fgMZ");

var $02KAV = parcelRequire("02KAV");

var $gqGQB = parcelRequire("gqGQB");

var $3MP74 = parcelRequire("3MP74");

var $bis9F = parcelRequire("bis9F");

var $b1Z8M = parcelRequire("b1Z8M");
function $0952dea42f1ba206$export$ec068583843480e7(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    return arguments.length === 1 ? $0952dea42f1ba206$var$subscribeImpl(argsOrSchema) : $0952dea42f1ba206$var$subscribeImpl({
        schema: argsOrSchema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        subscribeFieldResolver: subscribeFieldResolver
    });
}
/**
 * This function checks if the error is a GraphQLError. If it is, report it as
 * an ExecutionResult, containing only errors and no data. Otherwise treat the
 * error as a system-class error and re-throw it.
 */ function $0952dea42f1ba206$var$reportGraphQLError(error) {
    if (error instanceof (0, $9fgMZ.GraphQLError)) return {
        errors: [
            error
        ]
    };
    throw error;
}
function $0952dea42f1ba206$var$subscribeImpl(args) {
    var schema = args.schema, document = args.document, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, subscribeFieldResolver = args.subscribeFieldResolver;
    var sourcePromise = $0952dea42f1ba206$export$640ee730a9007071(schema, document, rootValue, contextValue, variableValues, operationName, subscribeFieldResolver); // For each payload yielded from a subscription, map it over the normal
    // GraphQL `execute` function, with `payload` as the rootValue.
    // This implements the "MapSourceToResponseEvent" algorithm described in
    // the GraphQL specification. The `execute` function provides the
    // "ExecuteSubscriptionEvent" algorithm, as it is nearly identical to the
    // "ExecuteQuery" algorithm, for which `execute` is also used.
    var mapSourceToResponse = function mapSourceToResponse(payload) {
        return (0, $3MP74.execute)({
            schema: schema,
            document: document,
            rootValue: payload,
            contextValue: contextValue,
            variableValues: variableValues,
            operationName: operationName,
            fieldResolver: fieldResolver
        });
    }; // Resolve the Source Stream, then map every source value to a
    // ExecutionResult value as described above.
    return sourcePromise.then(function(resultOrStream) {
        return (0, $lVzNK.default)(resultOrStream) ? (0, $b1Z8M.default)(resultOrStream, mapSourceToResponse, $0952dea42f1ba206$var$reportGraphQLError) : resultOrStream;
    });
}
function $0952dea42f1ba206$export$640ee730a9007071(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
    // If arguments are missing or incorrectly typed, this is an internal
    // developer mistake which should throw an early error.
    (0, $3MP74.assertValidExecutionArguments)(schema, document, variableValues);
    return new Promise(function(resolve) {
        // If a valid context cannot be created due to incorrect arguments,
        // this will throw an error.
        var exeContext = (0, $3MP74.buildExecutionContext)(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
        resolve(Array.isArray(exeContext) ? {
            errors: exeContext
        } : $0952dea42f1ba206$var$executeSubscription(exeContext));
    }).catch($0952dea42f1ba206$var$reportGraphQLError);
}
function $0952dea42f1ba206$var$executeSubscription(exeContext) {
    var schema = exeContext.schema, operation = exeContext.operation, variableValues = exeContext.variableValues, rootValue = exeContext.rootValue;
    var type = (0, $bis9F.getOperationRootType)(schema, operation);
    var fields = (0, $3MP74.collectFields)(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
    var responseNames = Object.keys(fields);
    var responseName = responseNames[0];
    var fieldNodes = fields[responseName];
    var fieldNode = fieldNodes[0];
    var fieldName = fieldNode.name.value;
    var fieldDef = (0, $3MP74.getFieldDef)(schema, type, fieldName);
    if (!fieldDef) throw new (0, $9fgMZ.GraphQLError)("The subscription field \"".concat(fieldName, "\" is not defined."), fieldNodes);
    var path = (0, $kZHaf.addPath)(undefined, responseName, type.name);
    var info = (0, $3MP74.buildResolveInfo)(exeContext, fieldDef, fieldNodes, type, path); // Coerce to Promise for easier error handling and consistent return type.
    return new Promise(function(resolveResult) {
        var _fieldDef$subscribe;
        // Implements the "ResolveFieldEventStream" algorithm from GraphQL specification.
        // It differs from "ResolveFieldValue" due to providing a different `resolveFn`.
        // Build a JS object of arguments from the field.arguments AST, using the
        // variables scope to fulfill any variable references.
        var args = (0, $gqGQB.getArgumentValues)(fieldDef, fieldNodes[0], variableValues); // The resolve function's optional third argument is a context value that
        // is provided to every resolve function within an execution. It is commonly
        // used to represent an authenticated user, or request-specific caches.
        var contextValue = exeContext.contextValue; // Call the `subscribe()` resolver or the default resolver to produce an
        // AsyncIterable yielding raw payloads.
        var resolveFn = (_fieldDef$subscribe = fieldDef.subscribe) !== null && _fieldDef$subscribe !== void 0 ? _fieldDef$subscribe : exeContext.fieldResolver;
        resolveResult(resolveFn(rootValue, args, contextValue, info));
    }).then(function(eventStream) {
        if (eventStream instanceof Error) throw (0, $02KAV.locatedError)(eventStream, fieldNodes, (0, $kZHaf.pathToArray)(path));
         // Assert field returned an event stream, otherwise yield an error.
        if (!(0, $lVzNK.default)(eventStream)) throw new Error('Subscription field must return Async Iterable. ' + "Received: ".concat((0, $biK02.default)(eventStream), "."));
        return eventStream;
    }, function(error) {
        throw (0, $02KAV.locatedError)(error, fieldNodes, (0, $kZHaf.pathToArray)(path));
    });
}

});
parcelRegister("lVzNK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0c2a0b88b975b05$export$2e2bcd8739ae039);

var $gwa3m = parcelRequire("gwa3m");
function $f0c2a0b88b975b05$export$2e2bcd8739ae039(maybeAsyncIterable) {
    return typeof (maybeAsyncIterable === null || maybeAsyncIterable === void 0 ? void 0 : maybeAsyncIterable[0, $gwa3m.SYMBOL_ASYNC_ITERATOR]) === 'function';
}

});

parcelRegister("b1Z8M", function(module, exports) {

$parcel$export(module.exports, "default", () => $e70a078baba341ab$export$2e2bcd8739ae039);

var $gwa3m = parcelRequire("gwa3m");
function $e70a078baba341ab$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e70a078baba341ab$export$2e2bcd8739ae039(iterable, callback, rejectCallback) {
    // $FlowFixMe[prop-missing]
    var iteratorMethod = iterable[0, $gwa3m.SYMBOL_ASYNC_ITERATOR];
    var iterator = iteratorMethod.call(iterable);
    var $return;
    var abruptClose;
    if (typeof iterator.return === 'function') {
        $return = iterator.return;
        abruptClose = function abruptClose(error) {
            var rethrow = function rethrow() {
                return Promise.reject(error);
            };
            return $return.call(iterator).then(rethrow, rethrow);
        };
    }
    function mapResult(result) {
        return result.done ? result : $e70a078baba341ab$var$asyncMapValue(result.value, callback).then($e70a078baba341ab$var$iteratorResult, abruptClose);
    }
    var mapReject;
    if (rejectCallback) {
        // Capture rejectCallback to ensure it cannot be null.
        var reject = rejectCallback;
        mapReject = function mapReject(error) {
            return $e70a078baba341ab$var$asyncMapValue(error, reject).then($e70a078baba341ab$var$iteratorResult, abruptClose);
        };
    }
    /* TODO: Flow doesn't support symbols as keys:
     https://github.com/facebook/flow/issues/3258 */ return $e70a078baba341ab$var$_defineProperty({
        next: function next() {
            return iterator.next().then(mapResult, mapReject);
        },
        return: function _return() {
            return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({
                value: undefined,
                done: true
            });
        },
        throw: function _throw(error) {
            if (typeof iterator.throw === 'function') return iterator.throw(error).then(mapResult, mapReject);
            return Promise.reject(error).catch(abruptClose);
        }
    }, (0, $gwa3m.SYMBOL_ASYNC_ITERATOR), function() {
        return this;
    });
}
function $e70a078baba341ab$var$asyncMapValue(value, callback) {
    return new Promise(function(resolve) {
        return resolve(callback(value));
    });
}
function $e70a078baba341ab$var$iteratorResult(value) {
    return {
        value: value,
        done: false
    };
}

});


parcelRegister("iijzq", function(module, exports) {
var $d51916b58a73dae6$var$__assign = module.exports && module.exports.__assign || function() {
    $d51916b58a73dae6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d51916b58a73dae6$var$__assign.apply(this, arguments);
};
var $d51916b58a73dae6$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $d51916b58a73dae6$var$AddArgumentsAsVariablesTransform = /** @class */ function() {
    function AddArgumentsAsVariablesTransform(schema, args) {
        this.schema = schema;
        this.args = args;
    }
    AddArgumentsAsVariablesTransform.prototype.transformRequest = function(originalRequest) {
        var _a = $d51916b58a73dae6$var$addVariablesToRootField(this.schema, originalRequest.document, this.args), document = _a.document, newVariables = _a.newVariables;
        var variables = $d51916b58a73dae6$var$__assign($d51916b58a73dae6$var$__assign({}, originalRequest.variables), newVariables);
        return {
            document: document,
            variables: variables
        };
    };
    return AddArgumentsAsVariablesTransform;
}();
module.exports.default = $d51916b58a73dae6$var$AddArgumentsAsVariablesTransform;
function $d51916b58a73dae6$var$addVariablesToRootField(targetSchema, document, args) {
    var operations = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.OPERATION_DEFINITION;
    });
    var fragments = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.FRAGMENT_DEFINITION;
    });
    var variableNames = {};
    var newOperations = operations.map(function(operation) {
        var existingVariables = operation.variableDefinitions.map(function(variableDefinition) {
            return variableDefinition.variable.name.value;
        });
        var variableCounter = 0;
        var variables = {};
        var generateVariableName = function(argName) {
            var varName;
            do {
                varName = "_v" + variableCounter + "_" + argName;
                variableCounter++;
            }while (existingVariables.indexOf(varName) !== -1);
            return varName;
        };
        var type;
        if (operation.operation === 'subscription') type = targetSchema.getSubscriptionType();
        else if (operation.operation === 'mutation') type = targetSchema.getMutationType();
        else type = targetSchema.getQueryType();
        var newSelectionSet = [];
        operation.selectionSet.selections.forEach(function(selection) {
            if (selection.kind === $1c4hI.Kind.FIELD) {
                var newArgs_1 = {};
                selection.arguments.forEach(function(argument) {
                    newArgs_1[argument.name.value] = argument;
                });
                var name_1 = selection.name.value;
                var field = type.getFields()[name_1];
                field.args.forEach(function(argument) {
                    if (argument.name in args) {
                        var variableName = generateVariableName(argument.name);
                        variableNames[argument.name] = variableName;
                        newArgs_1[argument.name] = {
                            kind: $1c4hI.Kind.ARGUMENT,
                            name: {
                                kind: $1c4hI.Kind.NAME,
                                value: argument.name
                            },
                            value: {
                                kind: $1c4hI.Kind.VARIABLE,
                                name: {
                                    kind: $1c4hI.Kind.NAME,
                                    value: variableName
                                }
                            }
                        };
                        existingVariables.push(variableName);
                        variables[variableName] = {
                            kind: $1c4hI.Kind.VARIABLE_DEFINITION,
                            variable: {
                                kind: $1c4hI.Kind.VARIABLE,
                                name: {
                                    kind: $1c4hI.Kind.NAME,
                                    value: variableName
                                }
                            },
                            type: $d51916b58a73dae6$var$typeToAst(argument.type)
                        };
                    }
                });
                newSelectionSet.push($d51916b58a73dae6$var$__assign($d51916b58a73dae6$var$__assign({}, selection), {
                    arguments: Object.keys(newArgs_1).map(function(argName) {
                        return newArgs_1[argName];
                    })
                }));
            } else newSelectionSet.push(selection);
        });
        return $d51916b58a73dae6$var$__assign($d51916b58a73dae6$var$__assign({}, operation), {
            variableDefinitions: operation.variableDefinitions.concat(Object.keys(variables).map(function(varName) {
                return variables[varName];
            })),
            selectionSet: {
                kind: $1c4hI.Kind.SELECTION_SET,
                selections: newSelectionSet
            }
        });
    });
    var newVariables = {};
    Object.keys(variableNames).forEach(function(name) {
        newVariables[variableNames[name]] = args[name];
    });
    return {
        document: $d51916b58a73dae6$var$__assign($d51916b58a73dae6$var$__assign({}, document), {
            definitions: $d51916b58a73dae6$var$__spreadArrays(newOperations, fragments)
        }),
        newVariables: newVariables
    };
}
function $d51916b58a73dae6$var$typeToAst(type) {
    if (type instanceof $lXoEQ.GraphQLNonNull) {
        var innerType = $d51916b58a73dae6$var$typeToAst(type.ofType);
        if (innerType.kind === $1c4hI.Kind.LIST_TYPE || innerType.kind === $1c4hI.Kind.NAMED_TYPE) return {
            kind: $1c4hI.Kind.NON_NULL_TYPE,
            type: innerType
        };
        else throw new Error('Incorrent inner non-null type');
    } else if (type instanceof $lXoEQ.GraphQLList) return {
        kind: $1c4hI.Kind.LIST_TYPE,
        type: $d51916b58a73dae6$var$typeToAst(type.ofType)
    };
    else return {
        kind: $1c4hI.Kind.NAMED_TYPE,
        name: {
            kind: $1c4hI.Kind.NAME,
            value: type.toString()
        }
    };
}

});

parcelRegister("8Vthi", function(module, exports) {
var $67fa5b975bcbc2ac$var$__assign = module.exports && module.exports.__assign || function() {
    $67fa5b975bcbc2ac$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $67fa5b975bcbc2ac$var$__assign.apply(this, arguments);
};
var $67fa5b975bcbc2ac$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $h2iUh = parcelRequire("h2iUh");
var $961BR = parcelRequire("961BR");

var $eYOZQ = parcelRequire("eYOZQ");
var $67fa5b975bcbc2ac$var$FilterToSchema = /** @class */ function() {
    function FilterToSchema(targetSchema) {
        this.targetSchema = targetSchema;
    }
    FilterToSchema.prototype.transformRequest = function(originalRequest) {
        var document = $67fa5b975bcbc2ac$var$filterDocumentToSchema(this.targetSchema, originalRequest.document);
        return $67fa5b975bcbc2ac$var$__assign($67fa5b975bcbc2ac$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return FilterToSchema;
}();
module.exports.default = $67fa5b975bcbc2ac$var$FilterToSchema;
function $67fa5b975bcbc2ac$var$filterDocumentToSchema(targetSchema, document) {
    var operations = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.OPERATION_DEFINITION;
    });
    var fragments = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.FRAGMENT_DEFINITION;
    });
    var usedFragments = [];
    var newOperations = [];
    var newFragments = [];
    var validFragments = fragments.filter(function(fragment) {
        var typeName = fragment.typeCondition.name.value;
        return Boolean(targetSchema.getType(typeName));
    });
    var validFragmentsWithType = {};
    validFragments.forEach(function(fragment) {
        var typeName = fragment.typeCondition.name.value;
        var type = targetSchema.getType(typeName);
        validFragmentsWithType[fragment.name.value] = type;
    });
    var fragmentSet = Object.create(null);
    operations.forEach(function(operation) {
        var type;
        if (operation.operation === 'subscription') type = targetSchema.getSubscriptionType();
        else if (operation.operation === 'mutation') type = targetSchema.getMutationType();
        else type = targetSchema.getQueryType();
        var _a = $67fa5b975bcbc2ac$var$filterSelectionSet(targetSchema, type, validFragmentsWithType, operation.selectionSet), selectionSet = _a.selectionSet, operationUsedFragments = _a.usedFragments, operationUsedVariables = _a.usedVariables;
        usedFragments = $67fa5b975bcbc2ac$var$union(usedFragments, operationUsedFragments);
        var _b = $67fa5b975bcbc2ac$var$collectFragmentVariables(targetSchema, fragmentSet, validFragments, validFragmentsWithType, usedFragments), collectedUsedVariables = _b.usedVariables, collectedNewFragments = _b.newFragments, collectedFragmentSet = _b.fragmentSet;
        var fullUsedVariables = $67fa5b975bcbc2ac$var$union(operationUsedVariables, collectedUsedVariables);
        newFragments = collectedNewFragments;
        fragmentSet = collectedFragmentSet;
        var variableDefinitions = operation.variableDefinitions.filter(function(variable) {
            return fullUsedVariables.indexOf(variable.variable.name.value) !== -1;
        });
        newOperations.push({
            kind: $1c4hI.Kind.OPERATION_DEFINITION,
            operation: operation.operation,
            name: operation.name,
            directives: operation.directives,
            variableDefinitions: variableDefinitions,
            selectionSet: selectionSet
        });
    });
    return {
        kind: $1c4hI.Kind.DOCUMENT,
        definitions: $67fa5b975bcbc2ac$var$__spreadArrays(newOperations, newFragments)
    };
}
function $67fa5b975bcbc2ac$var$collectFragmentVariables(targetSchema, fragmentSet, validFragments, validFragmentsWithType, usedFragments) {
    var usedVariables = [];
    var newFragments = [];
    var _loop_1 = function() {
        var nextFragmentName = usedFragments.pop();
        var fragment = validFragments.find(function(fr) {
            return fr.name.value === nextFragmentName;
        });
        if (fragment) {
            var name_1 = nextFragmentName;
            var typeName = fragment.typeCondition.name.value;
            var type = targetSchema.getType(typeName);
            var _a = $67fa5b975bcbc2ac$var$filterSelectionSet(targetSchema, type, validFragmentsWithType, fragment.selectionSet), selectionSet = _a.selectionSet, fragmentUsedFragments = _a.usedFragments, fragmentUsedVariables = _a.usedVariables;
            usedFragments = $67fa5b975bcbc2ac$var$union(usedFragments, fragmentUsedFragments);
            usedVariables = $67fa5b975bcbc2ac$var$union(usedVariables, fragmentUsedVariables);
            if (!fragmentSet[name_1]) {
                fragmentSet[name_1] = true;
                newFragments.push({
                    kind: $1c4hI.Kind.FRAGMENT_DEFINITION,
                    name: {
                        kind: $1c4hI.Kind.NAME,
                        value: name_1
                    },
                    typeCondition: fragment.typeCondition,
                    selectionSet: selectionSet
                });
            }
        }
    };
    while(usedFragments.length !== 0)_loop_1();
    return {
        usedVariables: usedVariables,
        newFragments: newFragments,
        fragmentSet: fragmentSet
    };
}
function $67fa5b975bcbc2ac$var$filterSelectionSet(schema, type, validFragments, selectionSet) {
    var _a;
    var usedFragments = [];
    var usedVariables = [];
    var typeStack = [
        type
    ];
    // Should be rewritten using visitWithSchema
    var filteredSelectionSet = $961BR.visit(selectionSet, (_a = {}, _a[$1c4hI.Kind.FIELD] = {
        enter: function(node) {
            var parentType = $67fa5b975bcbc2ac$var$resolveType(typeStack[typeStack.length - 1]);
            if (parentType instanceof $lXoEQ.GraphQLObjectType || parentType instanceof $lXoEQ.GraphQLInterfaceType) {
                var fields = parentType.getFields();
                var field = node.name.value === '__typename' ? $h2iUh.TypeNameMetaFieldDef : fields[node.name.value];
                if (!field) return null;
                else typeStack.push(field.type);
                var argNames_1 = (field.args || []).map(function(arg) {
                    return arg.name;
                });
                if (node.arguments) {
                    var args = node.arguments.filter(function(arg) {
                        return argNames_1.indexOf(arg.name.value) !== -1;
                    });
                    if (args.length !== node.arguments.length) return $67fa5b975bcbc2ac$var$__assign($67fa5b975bcbc2ac$var$__assign({}, node), {
                        arguments: args
                    });
                }
            } else if (parentType instanceof $lXoEQ.GraphQLUnionType && node.name.value === '__typename') typeStack.push($h2iUh.TypeNameMetaFieldDef.type);
        },
        leave: function(node) {
            var _a;
            var currentType = typeStack.pop();
            var resolvedType = $67fa5b975bcbc2ac$var$resolveType(currentType);
            if (resolvedType instanceof $lXoEQ.GraphQLObjectType || resolvedType instanceof $lXoEQ.GraphQLInterfaceType) {
                var selections = node.selectionSet && node.selectionSet.selections || null;
                if (!selections || selections.length === 0) {
                    // need to remove any added variables. Is there a better way to do this?
                    $961BR.visit(node, (_a = {}, _a[$1c4hI.Kind.VARIABLE] = function(variableNode) {
                        var index = usedVariables.indexOf(variableNode.name.value);
                        if (index !== -1) usedVariables.splice(index, 1);
                    }, _a));
                    return null;
                }
            }
        }
    }, _a[$1c4hI.Kind.FRAGMENT_SPREAD] = function(node) {
        if (node.name.value in validFragments) {
            var parentType = $67fa5b975bcbc2ac$var$resolveType(typeStack[typeStack.length - 1]);
            var innerType = validFragments[node.name.value];
            if (!$eYOZQ.default(schema, parentType, innerType)) return null;
            else {
                usedFragments.push(node.name.value);
                return;
            }
        } else return null;
    }, _a[$1c4hI.Kind.INLINE_FRAGMENT] = {
        enter: function(node) {
            if (node.typeCondition) {
                var innerType = schema.getType(node.typeCondition.name.value);
                var parentType = $67fa5b975bcbc2ac$var$resolveType(typeStack[typeStack.length - 1]);
                if ($eYOZQ.default(schema, parentType, innerType)) typeStack.push(innerType);
                else return null;
            }
        },
        leave: function(node) {
            typeStack.pop();
        }
    }, _a[$1c4hI.Kind.VARIABLE] = function(node) {
        usedVariables.push(node.name.value);
    }, _a));
    return {
        selectionSet: filteredSelectionSet,
        usedFragments: usedFragments,
        usedVariables: usedVariables
    };
}
function $67fa5b975bcbc2ac$var$resolveType(type) {
    var lastType = type;
    while(lastType instanceof $lXoEQ.GraphQLNonNull || lastType instanceof $lXoEQ.GraphQLList)lastType = lastType.ofType;
    return lastType;
}
function $67fa5b975bcbc2ac$var$union() {
    var arrays = [];
    for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
    var cache = {};
    var result = [];
    arrays.forEach(function(array) {
        array.forEach(function(item) {
            if (!cache[item]) {
                cache[item] = true;
                result.push(item);
            }
        });
    });
    return result;
}

});
parcelRegister("eYOZQ", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f5cpS = parcelRequire("f5cpS");
var $lXoEQ = parcelRequire("lXoEQ");
function $ae7e3a242f220513$var$implementsAbstractType(schema, typeA, typeB) {
    if (typeA === typeB) return true;
    else if ($lXoEQ.isCompositeType(typeA) && $lXoEQ.isCompositeType(typeB)) return $f5cpS.doTypesOverlap(schema, typeA, typeB);
    else return false;
}
module.exports.default = $ae7e3a242f220513$var$implementsAbstractType;

});


parcelRegister("aYyML", function(module, exports) {
var $7fda7dad3e357eae$var$__assign = module.exports && module.exports.__assign || function() {
    $7fda7dad3e357eae$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7fda7dad3e357eae$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $hMOry = parcelRequire("hMOry");
var $961BR = parcelRequire("961BR");
var $7fda7dad3e357eae$var$AddTypenameToAbstract = /** @class */ function() {
    function AddTypenameToAbstract(targetSchema) {
        this.targetSchema = targetSchema;
    }
    AddTypenameToAbstract.prototype.transformRequest = function(originalRequest) {
        var document = $7fda7dad3e357eae$var$addTypenameToAbstract(this.targetSchema, originalRequest.document);
        return $7fda7dad3e357eae$var$__assign($7fda7dad3e357eae$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return AddTypenameToAbstract;
}();
module.exports.default = $7fda7dad3e357eae$var$AddTypenameToAbstract;
function $7fda7dad3e357eae$var$addTypenameToAbstract(targetSchema, document) {
    var _a;
    var typeInfo = new $hMOry.TypeInfo(targetSchema);
    return $961BR.visit(document, $hMOry.visitWithTypeInfo(typeInfo, (_a = {}, _a[$1c4hI.Kind.SELECTION_SET] = function(node) {
        var parentType = typeInfo.getParentType();
        var selections = node.selections;
        if (parentType && (parentType instanceof $lXoEQ.GraphQLInterfaceType || parentType instanceof $lXoEQ.GraphQLUnionType) && !selections.find(function(_) {
            return _.kind === $1c4hI.Kind.FIELD && _.name.value === '__typename';
        })) selections = selections.concat({
            kind: $1c4hI.Kind.FIELD,
            name: {
                kind: $1c4hI.Kind.NAME,
                value: '__typename'
            }
        });
        if (selections !== node.selections) return $7fda7dad3e357eae$var$__assign($7fda7dad3e357eae$var$__assign({}, node), {
            selections: selections
        });
    }, _a)));
}

});

parcelRegister("gvWNr", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $10LTa = parcelRequire("10LTa");
var $c05d26599fa40d22$var$CheckResultAndHandleErrors = /** @class */ function() {
    function CheckResultAndHandleErrors(info, fieldName) {
        this.info = info;
        this.fieldName = fieldName;
    }
    CheckResultAndHandleErrors.prototype.transformResult = function(result) {
        return $10LTa.checkResultAndHandleErrors(result, this.info, this.fieldName);
    };
    return CheckResultAndHandleErrors;
}();
module.exports.default = $c05d26599fa40d22$var$CheckResultAndHandleErrors;

});

parcelRegister("fB7Hv", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cRJgL = parcelRequire("cRJgL");
/**
 * Given an AsyncIterable and a callback function, return an AsyncIterator
 * which produces values mapped via calling the callback function.
 */ function $b5b048e835d5ba5c$var$mapAsyncIterator(iterator, callback, rejectCallback) {
    var _a;
    var $return;
    var abruptClose;
    if (typeof iterator.return === 'function') {
        $return = iterator.return;
        abruptClose = function(error) {
            var rethrow = function() {
                return Promise.reject(error);
            };
            return $return.call(iterator).then(rethrow, rethrow);
        };
    }
    function mapResult(result) {
        return result.done ? result : $b5b048e835d5ba5c$var$asyncMapValue(result.value, callback).then($b5b048e835d5ba5c$var$iteratorResult, abruptClose);
    }
    var mapReject;
    if (rejectCallback) {
        // Capture rejectCallback to ensure it cannot be null.
        var reject_1 = rejectCallback;
        mapReject = function(error) {
            return $b5b048e835d5ba5c$var$asyncMapValue(error, reject_1).then($b5b048e835d5ba5c$var$iteratorResult, abruptClose);
        };
    }
    return _a = {
        next: function() {
            return iterator.next().then(mapResult, mapReject);
        },
        return: function() {
            return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({
                value: undefined,
                done: true
            });
        },
        throw: function(error) {
            if (typeof iterator.throw === 'function') return iterator.throw(error).then(mapResult, mapReject);
            return Promise.reject(error).catch(abruptClose);
        }
    }, _a[$cRJgL.$$asyncIterator] = function() {
        return this;
    }, _a;
}
module.exports.default = $b5b048e835d5ba5c$var$mapAsyncIterator;
function $b5b048e835d5ba5c$var$asyncMapValue(value, callback) {
    return new Promise(function(resolve) {
        return resolve(callback(value));
    });
}
function $b5b048e835d5ba5c$var$iteratorResult(value) {
    return {
        value: value,
        done: false
    };
}

});

parcelRegister("kYtVo", function(module, exports) {
var $f4509fae9d1b991a$var$__assign = module.exports && module.exports.__assign || function() {
    $f4509fae9d1b991a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f4509fae9d1b991a$var$__assign.apply(this, arguments);
};
var $f4509fae9d1b991a$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $hMOry = parcelRequire("hMOry");
var $961BR = parcelRequire("961BR");

var $eYOZQ = parcelRequire("eYOZQ");
var $f4509fae9d1b991a$var$ExpandAbstractTypes = /** @class */ function() {
    function ExpandAbstractTypes(transformedSchema, targetSchema) {
        this.targetSchema = targetSchema;
        this.mapping = $f4509fae9d1b991a$var$extractPossibleTypes(transformedSchema, targetSchema);
        this.reverseMapping = $f4509fae9d1b991a$var$flipMapping(this.mapping);
    }
    ExpandAbstractTypes.prototype.transformRequest = function(originalRequest) {
        var document = $f4509fae9d1b991a$var$expandAbstractTypes(this.targetSchema, this.mapping, this.reverseMapping, originalRequest.document);
        return $f4509fae9d1b991a$var$__assign($f4509fae9d1b991a$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return ExpandAbstractTypes;
}();
module.exports.default = $f4509fae9d1b991a$var$ExpandAbstractTypes;
function $f4509fae9d1b991a$var$extractPossibleTypes(transformedSchema, targetSchema) {
    var typeMap = transformedSchema.getTypeMap();
    var mapping = {};
    Object.keys(typeMap).forEach(function(typeName) {
        var type = typeMap[typeName];
        if ($lXoEQ.isAbstractType(type)) {
            var targetType = targetSchema.getType(typeName);
            if (!$lXoEQ.isAbstractType(targetType)) {
                var implementations = transformedSchema.getPossibleTypes(type) || [];
                mapping[typeName] = implementations.filter(function(impl) {
                    return targetSchema.getType(impl.name);
                }).map(function(impl) {
                    return impl.name;
                });
            }
        }
    });
    return mapping;
}
function $f4509fae9d1b991a$var$flipMapping(mapping) {
    var result = {};
    Object.keys(mapping).forEach(function(typeName) {
        var toTypeNames = mapping[typeName];
        toTypeNames.forEach(function(toTypeName) {
            if (!result[toTypeName]) result[toTypeName] = [];
            result[toTypeName].push(typeName);
        });
    });
    return result;
}
function $f4509fae9d1b991a$var$expandAbstractTypes(targetSchema, mapping, reverseMapping, document) {
    var _a;
    var operations = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.OPERATION_DEFINITION;
    });
    var fragments = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.FRAGMENT_DEFINITION;
    });
    var existingFragmentNames = fragments.map(function(fragment) {
        return fragment.name.value;
    });
    var fragmentCounter = 0;
    var generateFragmentName = function(typeName) {
        var fragmentName;
        do {
            fragmentName = "_" + typeName + "_Fragment" + fragmentCounter;
            fragmentCounter++;
        }while (existingFragmentNames.indexOf(fragmentName) !== -1);
        return fragmentName;
    };
    var newFragments = [];
    var fragmentReplacements = {};
    fragments.forEach(function(fragment) {
        newFragments.push(fragment);
        var possibleTypes = mapping[fragment.typeCondition.name.value];
        if (possibleTypes) {
            fragmentReplacements[fragment.name.value] = [];
            possibleTypes.forEach(function(possibleTypeName) {
                var name = generateFragmentName(possibleTypeName);
                existingFragmentNames.push(name);
                var newFragment = {
                    kind: $1c4hI.Kind.FRAGMENT_DEFINITION,
                    name: {
                        kind: $1c4hI.Kind.NAME,
                        value: name
                    },
                    typeCondition: {
                        kind: $1c4hI.Kind.NAMED_TYPE,
                        name: {
                            kind: $1c4hI.Kind.NAME,
                            value: possibleTypeName
                        }
                    },
                    selectionSet: fragment.selectionSet
                };
                newFragments.push(newFragment);
                fragmentReplacements[fragment.name.value].push({
                    fragmentName: name,
                    typeName: possibleTypeName
                });
            });
        }
    });
    var newDocument = $f4509fae9d1b991a$var$__assign($f4509fae9d1b991a$var$__assign({}, document), {
        definitions: $f4509fae9d1b991a$var$__spreadArrays(operations, newFragments)
    });
    var typeInfo = new $hMOry.TypeInfo(targetSchema);
    return $961BR.visit(newDocument, $hMOry.visitWithTypeInfo(typeInfo, (_a = {}, _a[$1c4hI.Kind.SELECTION_SET] = function(node) {
        var newSelections = $f4509fae9d1b991a$var$__spreadArrays(node.selections);
        var parentType = $lXoEQ.getNamedType(typeInfo.getParentType());
        node.selections.forEach(function(selection) {
            if (selection.kind === $1c4hI.Kind.INLINE_FRAGMENT) {
                var possibleTypes = mapping[selection.typeCondition.name.value];
                if (possibleTypes) possibleTypes.forEach(function(possibleType) {
                    if ($eYOZQ.default(targetSchema, parentType, targetSchema.getType(possibleType))) newSelections.push({
                        kind: $1c4hI.Kind.INLINE_FRAGMENT,
                        typeCondition: {
                            kind: $1c4hI.Kind.NAMED_TYPE,
                            name: {
                                kind: $1c4hI.Kind.NAME,
                                value: possibleType
                            }
                        },
                        selectionSet: selection.selectionSet
                    });
                });
            } else if (selection.kind === $1c4hI.Kind.FRAGMENT_SPREAD) {
                var fragmentName = selection.name.value;
                var replacements = fragmentReplacements[fragmentName];
                if (replacements) replacements.forEach(function(replacement) {
                    var typeName = replacement.typeName;
                    if ($eYOZQ.default(targetSchema, parentType, targetSchema.getType(typeName))) newSelections.push({
                        kind: $1c4hI.Kind.FRAGMENT_SPREAD,
                        name: {
                            kind: $1c4hI.Kind.NAME,
                            value: replacement.fragmentName
                        }
                    });
                });
            }
        });
        if (parentType && reverseMapping[parentType.name]) newSelections.push({
            kind: $1c4hI.Kind.FIELD,
            name: {
                kind: $1c4hI.Kind.NAME,
                value: '__typename'
            }
        });
        if (newSelections.length !== node.selections.length) return $f4509fae9d1b991a$var$__assign($f4509fae9d1b991a$var$__assign({}, node), {
            selections: newSelections
        });
    }, _a)));
}

});

parcelRegister("4trzE", function(module, exports) {
var $341f4279b3bb4e24$var$__assign = module.exports && module.exports.__assign || function() {
    $341f4279b3bb4e24$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $341f4279b3bb4e24$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1c4hI = parcelRequire("1c4hI");
var $6ds0g = parcelRequire("6ds0g");
var $hMOry = parcelRequire("hMOry");
var $961BR = parcelRequire("961BR");
var $341f4279b3bb4e24$var$ReplaceFieldWithFragment = /** @class */ function() {
    function ReplaceFieldWithFragment(targetSchema, fragments) {
        this.targetSchema = targetSchema;
        this.mapping = {};
        for(var _i = 0, fragments_1 = fragments; _i < fragments_1.length; _i++){
            var _a = fragments_1[_i], field = _a.field, fragment = _a.fragment;
            var parsedFragment = $341f4279b3bb4e24$var$parseFragmentToInlineFragment(fragment);
            var actualTypeName = parsedFragment.typeCondition.name.value;
            this.mapping[actualTypeName] = this.mapping[actualTypeName] || {};
            if (this.mapping[actualTypeName][field]) this.mapping[actualTypeName][field].push(parsedFragment);
            else this.mapping[actualTypeName][field] = [
                parsedFragment
            ];
        }
    }
    ReplaceFieldWithFragment.prototype.transformRequest = function(originalRequest) {
        var document = $341f4279b3bb4e24$var$replaceFieldsWithFragments(this.targetSchema, originalRequest.document, this.mapping);
        return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return ReplaceFieldWithFragment;
}();
module.exports.default = $341f4279b3bb4e24$var$ReplaceFieldWithFragment;
function $341f4279b3bb4e24$var$replaceFieldsWithFragments(targetSchema, document, mapping) {
    var _a;
    var typeInfo = new $hMOry.TypeInfo(targetSchema);
    return $961BR.visit(document, $hMOry.visitWithTypeInfo(typeInfo, (_a = {}, _a[$1c4hI.Kind.SELECTION_SET] = function(node) {
        var parentType = typeInfo.getParentType();
        if (parentType) {
            var parentTypeName_1 = parentType.name;
            var selections_1 = node.selections;
            if (mapping[parentTypeName_1]) node.selections.forEach(function(selection) {
                if (selection.kind === $1c4hI.Kind.FIELD) {
                    var name_1 = selection.name.value;
                    var fragments = mapping[parentTypeName_1][name_1];
                    if (fragments && fragments.length > 0) {
                        var fragment = $341f4279b3bb4e24$var$concatInlineFragments(parentTypeName_1, fragments);
                        selections_1 = selections_1.concat(fragment);
                    }
                }
            });
            if (selections_1 !== node.selections) return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, node), {
                selections: selections_1
            });
        }
    }, _a)));
}
function $341f4279b3bb4e24$var$parseFragmentToInlineFragment(definitions) {
    if (definitions.trim().startsWith('fragment')) {
        var document_1 = $6ds0g.parse(definitions);
        for(var _i = 0, _a = document_1.definitions; _i < _a.length; _i++){
            var definition = _a[_i];
            if (definition.kind === $1c4hI.Kind.FRAGMENT_DEFINITION) return {
                kind: $1c4hI.Kind.INLINE_FRAGMENT,
                typeCondition: definition.typeCondition,
                selectionSet: definition.selectionSet
            };
        }
    }
    var query = $6ds0g.parse("{" + definitions + "}").definitions[0];
    for(var _b = 0, _c = query.selectionSet.selections; _b < _c.length; _b++){
        var selection = _c[_b];
        if (selection.kind === $1c4hI.Kind.INLINE_FRAGMENT) return selection;
    }
    throw new Error('Could not parse fragment');
}
function $341f4279b3bb4e24$var$concatInlineFragments(type, fragments) {
    var fragmentSelections = fragments.reduce(function(selections, fragment) {
        return selections.concat(fragment.selectionSet.selections);
    }, []);
    var deduplicatedFragmentSelection = $341f4279b3bb4e24$var$deduplicateSelection(fragmentSelections);
    return {
        kind: $1c4hI.Kind.INLINE_FRAGMENT,
        typeCondition: {
            kind: $1c4hI.Kind.NAMED_TYPE,
            name: {
                kind: $1c4hI.Kind.NAME,
                value: type
            }
        },
        selectionSet: {
            kind: $1c4hI.Kind.SELECTION_SET,
            selections: deduplicatedFragmentSelection
        }
    };
}
function $341f4279b3bb4e24$var$deduplicateSelection(nodes) {
    var selectionMap = nodes.reduce(function(map, node) {
        var _a, _b, _c;
        switch(node.kind){
            case 'Field':
                if (node.alias) {
                    if (map.hasOwnProperty(node.alias.value)) return map;
                    else return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), (_a = {}, _a[node.alias.value] = node, _a));
                } else {
                    if (map.hasOwnProperty(node.name.value)) return map;
                    else return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), (_b = {}, _b[node.name.value] = node, _b));
                }
            case 'FragmentSpread':
                if (map.hasOwnProperty(node.name.value)) return map;
                else return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), (_c = {}, _c[node.name.value] = node, _c));
            case 'InlineFragment':
                if (map.__fragment) {
                    var fragment = map.__fragment;
                    return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), {
                        __fragment: $341f4279b3bb4e24$var$concatInlineFragments(fragment.typeCondition.name.value, [
                            fragment,
                            node
                        ])
                    });
                } else return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), {
                    __fragment: node
                });
            default:
                return map;
        }
    }, {});
    var selection = Object.keys(selectionMap).reduce(function(selectionList, node) {
        return selectionList.concat(selectionMap[node]);
    }, []);
    return selection;
}

});

parcelRegister("goXjX", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bf0ce71a50359f69$var$ConvertEnumResponse = /** @class */ function() {
    function ConvertEnumResponse(enumNode) {
        this.enumNode = enumNode;
    }
    ConvertEnumResponse.prototype.transformResult = function(result) {
        var value = this.enumNode.getValue(result);
        if (value) return value.value;
        return result;
    };
    return ConvertEnumResponse;
}();
module.exports.default = $bf0ce71a50359f69$var$ConvertEnumResponse;

});


parcelRegister("dkK13", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5hGV7 = parcelRequire("5hGV7");
var $glHRe = parcelRequire("glHRe");
var $bOniD = parcelRequire("bOniD");
var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");
var $1c4hI = parcelRequire("1c4hI");
var $3E0nn = parcelRequire("3E0nn");

var $j0Odg = parcelRequire("j0Odg");
var $9b50d66fb2ab7736$var$backcompatOptions = {
    commentDescriptions: true
};
function $9b50d66fb2ab7736$var$typeFromAST(node) {
    switch(node.kind){
        case $1c4hI.Kind.OBJECT_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeObjectType(node);
        case $1c4hI.Kind.INTERFACE_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeInterfaceType(node);
        case $1c4hI.Kind.ENUM_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeEnumType(node);
        case $1c4hI.Kind.UNION_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeUnionType(node);
        case $1c4hI.Kind.SCALAR_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeScalarType(node);
        case $1c4hI.Kind.INPUT_OBJECT_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeInputObjectType(node);
        case $1c4hI.Kind.DIRECTIVE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeDirective(node);
        default:
            return null;
    }
}
module.exports.default = $9b50d66fb2ab7736$var$typeFromAST;
function $9b50d66fb2ab7736$var$makeObjectType(node) {
    return new $lXoEQ.GraphQLObjectType({
        name: node.name.value,
        fields: function() {
            return $9b50d66fb2ab7736$var$makeFields(node.fields);
        },
        interfaces: function() {
            return node.interfaces.map(function(iface) {
                return $9b50d66fb2ab7736$var$createNamedStub(iface.name.value, 'interface');
            });
        },
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions)
    });
}
function $9b50d66fb2ab7736$var$makeInterfaceType(node) {
    return new $lXoEQ.GraphQLInterfaceType({
        name: node.name.value,
        fields: function() {
            return $9b50d66fb2ab7736$var$makeFields(node.fields);
        },
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions),
        resolveType: function(parent, context, info) {
            return $j0Odg.default(parent, info.schema);
        }
    });
}
function $9b50d66fb2ab7736$var$makeEnumType(node) {
    var values = {};
    node.values.forEach(function(value) {
        values[value.name.value] = {
            description: $glHRe.getDescription(value, $9b50d66fb2ab7736$var$backcompatOptions)
        };
    });
    return new $lXoEQ.GraphQLEnumType({
        name: node.name.value,
        values: values,
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions)
    });
}
function $9b50d66fb2ab7736$var$makeUnionType(node) {
    return new $lXoEQ.GraphQLUnionType({
        name: node.name.value,
        types: function() {
            return node.types.map(function(type) {
                return $9b50d66fb2ab7736$var$resolveType(type, 'object');
            });
        },
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions),
        resolveType: function(parent, context, info) {
            return $j0Odg.default(parent, info.schema);
        }
    });
}
function $9b50d66fb2ab7736$var$makeScalarType(node) {
    return new $lXoEQ.GraphQLScalarType({
        name: node.name.value,
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions),
        serialize: function() {
            return null;
        },
        // Note: validation calls the parse functions to determine if a
        // literal value is correct. Returning null would cause use of custom
        // scalars to always fail validation. Returning false causes them to
        // always pass validation.
        parseValue: function() {
            return false;
        },
        parseLiteral: function() {
            return false;
        }
    });
}
function $9b50d66fb2ab7736$var$makeInputObjectType(node) {
    return new $lXoEQ.GraphQLInputObjectType({
        name: node.name.value,
        fields: function() {
            return $9b50d66fb2ab7736$var$makeValues(node.fields);
        },
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions)
    });
}
function $9b50d66fb2ab7736$var$makeFields(nodes) {
    var result = {};
    nodes.forEach(function(node) {
        var deprecatedDirective = node.directives.find(function(directive) {
            return directive && directive.name && directive.name.value === 'deprecated';
        });
        var deprecatedArgument = deprecatedDirective && deprecatedDirective.arguments && deprecatedDirective.arguments.find(function(arg) {
            return arg && arg.name && arg.name.value === 'reason';
        });
        var deprecationReason = deprecatedArgument && deprecatedArgument.value && deprecatedArgument.value.value;
        result[node.name.value] = {
            type: $9b50d66fb2ab7736$var$resolveType(node.type, 'object'),
            args: $9b50d66fb2ab7736$var$makeValues(node.arguments),
            description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions),
            deprecationReason: deprecationReason
        };
    });
    return result;
}
function $9b50d66fb2ab7736$var$makeValues(nodes) {
    var result = {};
    nodes.forEach(function(node) {
        var type = $9b50d66fb2ab7736$var$resolveType(node.type, 'input');
        result[node.name.value] = {
            type: type,
            defaultValue: $3E0nn.valueFromAST(node.defaultValue, type),
            description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions)
        };
    });
    return result;
}
function $9b50d66fb2ab7736$var$resolveType(node, type) {
    switch(node.kind){
        case $1c4hI.Kind.LIST_TYPE:
            return new $lXoEQ.GraphQLList($9b50d66fb2ab7736$var$resolveType(node.type, type));
        case $1c4hI.Kind.NON_NULL_TYPE:
            return new $lXoEQ.GraphQLNonNull($9b50d66fb2ab7736$var$resolveType(node.type, type));
        default:
            return $9b50d66fb2ab7736$var$createNamedStub(node.name.value, type);
    }
}
function $9b50d66fb2ab7736$var$createNamedStub(name, type) {
    var constructor;
    if (type === 'object') constructor = $lXoEQ.GraphQLObjectType;
    else if (type === 'interface') constructor = $lXoEQ.GraphQLInterfaceType;
    else constructor = $lXoEQ.GraphQLInputObjectType;
    return new constructor({
        name: name,
        fields: {
            __fake: {
                type: $auu22.GraphQLString
            }
        }
    });
}
function $9b50d66fb2ab7736$var$makeDirective(node) {
    var locations = [];
    node.locations.forEach(function(location) {
        if (location.value in $5hGV7.DirectiveLocation) locations.push(location.value);
    });
    return new $bOniD.GraphQLDirective({
        name: node.name.value,
        description: node.description ? node.description.value : null,
        args: $9b50d66fb2ab7736$var$makeValues(node.arguments),
        locations: locations
    });
}

});

parcelRegister("16dWW", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5HvdU = parcelRequire("5HvdU");
module.exports.transformSchema = $5HvdU.default;

var $iijzq = parcelRequire("iijzq");
module.exports.AddArgumentsAsVariables = $iijzq.default;

var $gvWNr = parcelRequire("gvWNr");
module.exports.CheckResultAndHandleErrors = $gvWNr.default;

var $4trzE = parcelRequire("4trzE");
module.exports.ReplaceFieldWithFragment = $4trzE.default;

var $aYyML = parcelRequire("aYyML");
module.exports.AddTypenameToAbstract = $aYyML.default;

var $8Vthi = parcelRequire("8Vthi");
module.exports.FilterToSchema = $8Vthi.default;

var $irkOK = parcelRequire("irkOK");
module.exports.RenameTypes = $irkOK.default;

var $dhAZO = parcelRequire("dhAZO");
module.exports.FilterTypes = $dhAZO.default;

var $kXMIm = parcelRequire("kXMIm");
module.exports.TransformRootFields = $kXMIm.default;

var $loOHi = parcelRequire("loOHi");
module.exports.RenameRootFields = $loOHi.default;

var $2PHcZ = parcelRequire("2PHcZ");
module.exports.FilterRootFields = $2PHcZ.default;

var $kYtVo = parcelRequire("kYtVo");
module.exports.ExpandAbstractTypes = $kYtVo.default;

var $1t5NR = parcelRequire("1t5NR");
module.exports.ExtractField = $1t5NR.default;

var $6rbaH = parcelRequire("6rbaH");
module.exports.WrapQuery = $6rbaH.default;

});
parcelRegister("5HvdU", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $crrCr = parcelRequire("crrCr");

var $esiZ2 = parcelRequire("esiZ2");

var $esVhq = parcelRequire("esVhq");

var $cLqiN = parcelRequire("cLqiN");
function $4269303177f37031$var$transformSchema(targetSchema, transforms) {
    var schema = $esiZ2.visitSchema(targetSchema, {}, true);
    var mapping = $cLqiN.generateSimpleMapping(targetSchema);
    var resolvers = $cLqiN.generateProxyingResolvers(targetSchema, transforms, mapping);
    schema = $crrCr.addResolveFunctionsToSchema({
        schema: schema,
        resolvers: resolvers,
        resolverValidationOptions: {
            allowResolversNotInSchema: true
        }
    });
    schema = $esVhq.applySchemaTransforms(schema, transforms);
    schema.transforms = transforms;
    return schema;
}
module.exports.default = $4269303177f37031$var$transformSchema;

});
parcelRegister("cLqiN", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7UWAA = parcelRequire("7UWAA");
function $94ae46e8a1e4c305$var$generateProxyingResolvers(targetSchema, transforms, mapping) {
    var result = {};
    Object.keys(mapping).forEach(function(name) {
        result[name] = {};
        var innerMapping = mapping[name];
        Object.keys(innerMapping).forEach(function(from) {
            var _a;
            var to = innerMapping[from];
            var resolverType = to.operation === 'subscription' ? 'subscribe' : 'resolve';
            result[name][from] = (_a = {}, _a[resolverType] = $94ae46e8a1e4c305$var$createProxyingResolver(targetSchema, to.operation, to.name, transforms), _a);
        });
    });
    return result;
}
module.exports.generateProxyingResolvers = $94ae46e8a1e4c305$var$generateProxyingResolvers;
function $94ae46e8a1e4c305$var$generateSimpleMapping(targetSchema) {
    var query = targetSchema.getQueryType();
    var mutation = targetSchema.getMutationType();
    var subscription = targetSchema.getSubscriptionType();
    var result = {};
    if (query) result[query.name] = $94ae46e8a1e4c305$var$generateMappingFromObjectType(query, 'query');
    if (mutation) result[mutation.name] = $94ae46e8a1e4c305$var$generateMappingFromObjectType(mutation, 'mutation');
    if (subscription) result[subscription.name] = $94ae46e8a1e4c305$var$generateMappingFromObjectType(subscription, 'subscription');
    return result;
}
module.exports.generateSimpleMapping = $94ae46e8a1e4c305$var$generateSimpleMapping;
function $94ae46e8a1e4c305$var$generateMappingFromObjectType(type, operation) {
    var result = {};
    var fields = type.getFields();
    Object.keys(fields).forEach(function(fieldName) {
        result[fieldName] = {
            name: fieldName,
            operation: operation
        };
    });
    return result;
}
module.exports.generateMappingFromObjectType = $94ae46e8a1e4c305$var$generateMappingFromObjectType;
function $94ae46e8a1e4c305$var$createProxyingResolver(schema, operation, fieldName, transforms) {
    return function(parent, args, context, info) {
        return $7UWAA.default({
            schema: schema,
            operation: operation,
            fieldName: fieldName,
            args: {},
            context: context,
            info: info,
            transforms: transforms
        });
    };
}

});


parcelRegister("irkOK", function(module, exports) {
var $d6cae588b371003a$var$__assign = module.exports && module.exports.__assign || function() {
    $d6cae588b371003a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d6cae588b371003a$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $961BR = parcelRequire("961BR");

var $kgFtY = parcelRequire("kgFtY");

var $esiZ2 = parcelRequire("esiZ2");
var $d6cae588b371003a$var$RenameTypes = /** @class */ function() {
    function RenameTypes(renamer, options) {
        this.renamer = renamer;
        this.reverseMap = {};
        var _a = options || {}, _b = _a.renameBuiltins, renameBuiltins = _b === void 0 ? false : _b, _c = _a.renameScalars, renameScalars = _c === void 0 ? true : _c;
        this.renameBuiltins = renameBuiltins;
        this.renameScalars = renameScalars;
    }
    RenameTypes.prototype.transformSchema = function(originalSchema) {
        var _a;
        var _this = this;
        return $esiZ2.visitSchema(originalSchema, (_a = {}, _a[$esiZ2.VisitSchemaKind.TYPE] = function(type) {
            if ($kgFtY.default(type) && !_this.renameBuiltins) return undefined;
            if (type instanceof $lXoEQ.GraphQLScalarType && !_this.renameScalars) return undefined;
            var newName = _this.renamer(type.name);
            if (newName && newName !== type.name) {
                _this.reverseMap[newName] = type.name;
                var newType = Object.assign(Object.create(type), type);
                newType.name = newName;
                return newType;
            }
        }, _a[$esiZ2.VisitSchemaKind.ROOT_OBJECT] = function(type) {
            return undefined;
        }, _a));
    };
    RenameTypes.prototype.transformRequest = function(originalRequest) {
        var _a;
        var _this = this;
        var newDocument = $961BR.visit(originalRequest.document, (_a = {}, _a[$1c4hI.Kind.NAMED_TYPE] = function(node) {
            var name = node.name.value;
            if (name in _this.reverseMap) return $d6cae588b371003a$var$__assign($d6cae588b371003a$var$__assign({}, node), {
                name: {
                    kind: $1c4hI.Kind.NAME,
                    value: _this.reverseMap[name]
                }
            });
        }, _a));
        return {
            document: newDocument,
            variables: originalRequest.variables
        };
    };
    RenameTypes.prototype.transformResult = function(result) {
        if (result.data) {
            var data = this.renameTypes(result.data, 'data');
            if (data !== result.data) return $d6cae588b371003a$var$__assign($d6cae588b371003a$var$__assign({}, result), {
                data: data
            });
        }
        return result;
    };
    RenameTypes.prototype.renameTypes = function(value, name) {
        var _this = this;
        if (name === '__typename') return this.renamer(value);
        if (value && typeof value === 'object') {
            var newValue_1 = Array.isArray(value) ? [] : Object.create(Object.getPrototypeOf(value));
            var returnNewValue_1 = false;
            Object.keys(value).forEach(function(key) {
                var oldChild = value[key];
                var newChild = _this.renameTypes(oldChild, key);
                newValue_1[key] = newChild;
                if (newChild !== oldChild) returnNewValue_1 = true;
            });
            if (returnNewValue_1) return newValue_1;
        }
        return value;
    };
    return RenameTypes;
}();
module.exports.default = $d6cae588b371003a$var$RenameTypes;

});

parcelRegister("dhAZO", function(module, exports) {
/* tslint:disable:no-unused-expression */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $esiZ2 = parcelRequire("esiZ2");
var $9ab98f817eaa02e6$var$FilterTypes = /** @class */ function() {
    function FilterTypes(filter) {
        this.filter = filter;
    }
    FilterTypes.prototype.transformSchema = function(schema) {
        var _a;
        var _this = this;
        return $esiZ2.visitSchema(schema, (_a = {}, _a[$esiZ2.VisitSchemaKind.TYPE] = function(type) {
            if (_this.filter(type)) return undefined;
            else return null;
        }, _a));
    };
    return FilterTypes;
}();
module.exports.default = $9ab98f817eaa02e6$var$FilterTypes;

});

parcelRegister("kXMIm", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");

var $hRrcw = parcelRequire("hRrcw");

var $esiZ2 = parcelRequire("esiZ2");

var $h8S1f = parcelRequire("h8S1f");
var $f42f1b0b8b143d7f$var$TransformRootFields = /** @class */ function() {
    function TransformRootFields(transform) {
        this.transform = transform;
    }
    TransformRootFields.prototype.transformSchema = function(originalSchema) {
        var _a;
        var _this = this;
        return $esiZ2.visitSchema(originalSchema, (_a = {}, _a[$esiZ2.VisitSchemaKind.QUERY] = function(type) {
            return $f42f1b0b8b143d7f$var$transformFields(type, function(fieldName, field) {
                return _this.transform('Query', fieldName, field);
            });
        }, _a[$esiZ2.VisitSchemaKind.MUTATION] = function(type) {
            return $f42f1b0b8b143d7f$var$transformFields(type, function(fieldName, field) {
                return _this.transform('Mutation', fieldName, field);
            });
        }, _a[$esiZ2.VisitSchemaKind.SUBSCRIPTION] = function(type) {
            return $f42f1b0b8b143d7f$var$transformFields(type, function(fieldName, field) {
                return _this.transform('Subscription', fieldName, field);
            });
        }, _a));
    };
    return TransformRootFields;
}();
module.exports.default = $f42f1b0b8b143d7f$var$TransformRootFields;
function $f42f1b0b8b143d7f$var$transformFields(type, transformer) {
    var resolveType = $h8S1f.createResolveType(function(name, originalType) {
        return originalType;
    });
    var fields = type.getFields();
    var newFields = {};
    Object.keys(fields).forEach(function(fieldName) {
        var field = fields[fieldName];
        var newField = transformer(fieldName, field);
        if (typeof newField === 'undefined') newFields[fieldName] = $h8S1f.fieldToFieldConfig(field, resolveType, true);
        else if (newField !== null) {
            if (newField.name) newFields[newField.name] = newField.field;
            else newFields[fieldName] = newField;
        }
    });
    if ($hRrcw.default(newFields)) return null;
    else return new $lXoEQ.GraphQLObjectType({
        name: type.name,
        description: type.description,
        astNode: type.astNode,
        fields: newFields
    });
}

});

parcelRegister("loOHi", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h8S1f = parcelRequire("h8S1f");

var $kXMIm = parcelRequire("kXMIm");
var $0405365c21702eb7$var$RenameRootFields = /** @class */ function() {
    function RenameRootFields(renamer) {
        var resolveType = $h8S1f.createResolveType(function(name, type) {
            return type;
        });
        this.transformer = new $kXMIm.default(function(operation, fieldName, field) {
            return {
                name: renamer(operation, fieldName, field),
                field: $h8S1f.fieldToFieldConfig(field, resolveType, true)
            };
        });
    }
    RenameRootFields.prototype.transformSchema = function(originalSchema) {
        return this.transformer.transformSchema(originalSchema);
    };
    return RenameRootFields;
}();
module.exports.default = $0405365c21702eb7$var$RenameRootFields;

});

parcelRegister("2PHcZ", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kXMIm = parcelRequire("kXMIm");
var $2101dc7cb7293aa4$var$FilterRootFields = /** @class */ function() {
    function FilterRootFields(filter) {
        this.transformer = new $kXMIm.default(function(operation, fieldName, field) {
            if (filter(operation, fieldName, field)) return undefined;
            else return null;
        });
    }
    FilterRootFields.prototype.transformSchema = function(originalSchema) {
        return this.transformer.transformSchema(originalSchema);
    };
    return FilterRootFields;
}();
module.exports.default = $2101dc7cb7293aa4$var$FilterRootFields;

});

parcelRegister("1t5NR", function(module, exports) {
var $111d00430a4fd662$var$__assign = module.exports && module.exports.__assign || function() {
    $111d00430a4fd662$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $111d00430a4fd662$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $961BR = parcelRequire("961BR");
var $1c4hI = parcelRequire("1c4hI");
var $111d00430a4fd662$var$ExtractField = /** @class */ function() {
    function ExtractField(_a) {
        var from = _a.from, to = _a.to;
        this.from = from;
        this.to = to;
    }
    ExtractField.prototype.transformRequest = function(originalRequest) {
        var _a, _b;
        var fromSelection;
        var ourPathFrom = JSON.stringify(this.from);
        var ourPathTo = JSON.stringify(this.to);
        var fieldPath = [];
        $961BR.visit(originalRequest.document, (_a = {}, _a[$1c4hI.Kind.FIELD] = {
            enter: function(node) {
                fieldPath.push(node.name.value);
                if (ourPathFrom === JSON.stringify(fieldPath)) {
                    fromSelection = node.selectionSet;
                    return $961BR.BREAK;
                }
            },
            leave: function(node) {
                fieldPath.pop();
            }
        }, _a));
        fieldPath = [];
        var newDocument = $961BR.visit(originalRequest.document, (_b = {}, _b[$1c4hI.Kind.FIELD] = {
            enter: function(node) {
                fieldPath.push(node.name.value);
                if (ourPathTo === JSON.stringify(fieldPath) && fromSelection) return $111d00430a4fd662$var$__assign($111d00430a4fd662$var$__assign({}, node), {
                    selectionSet: fromSelection
                });
            },
            leave: function(node) {
                fieldPath.pop();
            }
        }, _b));
        return $111d00430a4fd662$var$__assign($111d00430a4fd662$var$__assign({}, originalRequest), {
            document: newDocument
        });
    };
    return ExtractField;
}();
module.exports.default = $111d00430a4fd662$var$ExtractField;

});

parcelRegister("6rbaH", function(module, exports) {
var $4afdee23e45449aa$var$__assign = module.exports && module.exports.__assign || function() {
    $4afdee23e45449aa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4afdee23e45449aa$var$__assign.apply(this, arguments);
};
var $4afdee23e45449aa$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1c4hI = parcelRequire("1c4hI");
var $961BR = parcelRequire("961BR");
var $4afdee23e45449aa$var$WrapQuery = /** @class */ function() {
    function WrapQuery(path, wrapper, extractor) {
        this.path = path;
        this.wrapper = wrapper;
        this.extractor = extractor;
    }
    WrapQuery.prototype.transformRequest = function(originalRequest) {
        var _a;
        var _this = this;
        var document = originalRequest.document;
        var fieldPath = [];
        var ourPath = JSON.stringify(this.path);
        var newDocument = $961BR.visit(document, (_a = {}, _a[$1c4hI.Kind.FIELD] = {
            enter: function(node) {
                fieldPath.push(node.name.value);
                if (ourPath === JSON.stringify(fieldPath)) {
                    var wrapResult = _this.wrapper(node.selectionSet);
                    // Selection can be either a single selection or a selection set. If it's just one selection,
                    // let's wrap it in a selection set. Otherwise, keep it as is.
                    var selectionSet = wrapResult.kind === $1c4hI.Kind.SELECTION_SET ? wrapResult : {
                        kind: $1c4hI.Kind.SELECTION_SET,
                        selections: [
                            wrapResult
                        ]
                    };
                    return $4afdee23e45449aa$var$__assign($4afdee23e45449aa$var$__assign({}, node), {
                        selectionSet: selectionSet
                    });
                }
            },
            leave: function(node) {
                fieldPath.pop();
            }
        }, _a));
        return $4afdee23e45449aa$var$__assign($4afdee23e45449aa$var$__assign({}, originalRequest), {
            document: newDocument
        });
    };
    WrapQuery.prototype.transformResult = function(originalResult) {
        var rootData = originalResult.data;
        if (rootData) {
            var data = rootData;
            var path = $4afdee23e45449aa$var$__spreadArrays(this.path);
            while(path.length > 1){
                var next = path.shift();
                if (data[next]) data = data[next];
            }
            data[path[0]] = this.extractor(data[path[0]]);
        }
        return {
            data: rootData,
            errors: originalResult.errors
        };
    };
    return WrapQuery;
}();
module.exports.default = $4afdee23e45449aa$var$WrapQuery;

});





parcelRegister("9rafI", function(module, exports) {

$parcel$export(module.exports, "getCustomResolversFetch", () => $ecaa18f4df472130$export$18b0a4b86a372cdb);
class $ecaa18f4df472130$export$26e841bcf1aeb894 extends Error {
    constructor(response, resBody){
        super(`[FetchError] Request failed with status ${response.status} and statusMessage=${response.statusText}`);
        this.status = response.status;
        this.response = response;
        this.responseBody = resBody;
        this.name = this.constructor.name;
    }
}
function $ecaa18f4df472130$var$removeEmptyProp(obj) {
    const result = {
        ...obj
    };
    Object.entries(result).forEach(([key, val])=>{
        if (val === undefined || val === null) // @ts-ignore (TS7053)
        delete result[key];
    });
    return result;
}
// In docs of fetch API, https://developer.mozilla.org/en/docs/Web/API/Fetch_API,
// fetch just throw error for network error, it does not throw error for server error like 400,...
async function $ecaa18f4df472130$var$handleFetchCommonResponse(res) {
    if (!res.ok) {
        let resBody;
        try {
            resBody = await res.json();
        } catch (e) {
        // ignore parsing body error
        }
        throw new $ecaa18f4df472130$export$26e841bcf1aeb894(res, resBody);
    }
    return res;
}
const $ecaa18f4df472130$export$18b0a4b86a372cdb = ({ fetch: fetch, statusCodeHandlers: statusCodeHandlers = {} })=>(url, fetchOptions = {})=>{
        const headers = {
            'Content-Type': 'application/json',
            ...fetchOptions.headers
        };
        return fetch(url, {
            credentials: 'include',
            ...fetchOptions,
            headers: $ecaa18f4df472130$var$removeEmptyProp(headers)
        }).then((response)=>{
            const { status: status } = response;
            const handler = statusCodeHandlers[status];
            if (typeof handler === 'function') handler(response);
            return response;
        }).then($ecaa18f4df472130$var$handleFetchCommonResponse);
    };

});

parcelRegister("2fzHI", function(module, exports) {

$parcel$export(module.exports, "isCustomQuery", () => $e7371a3132f5fe12$export$e722a3789f7fabfb);

var $faVZP = parcelRequire("faVZP");
const $e7371a3132f5fe12$var$isDefinitionObjectHasDirective = (def, directiveName)=>{
    if (!def) return false;
    for (const node of def){
        const { operation: type, directives: directives } = node;
        if (type === 'query' || type === 'mutation') return directives && directives.some((directive)=>directive.name.value === directiveName);
    }
};
const $e7371a3132f5fe12$var$isQueryContainDirective = (opt, directiveName)=>{
    const globalDef = opt.query && opt.query.definitions;
    const childDef = opt.query && // @ts-ignore (TS7053)
    opt.query[opt.operationName] && // @ts-ignore (TS7053)
    opt.query[opt.operationName].definitions;
    return !!($e7371a3132f5fe12$var$isDefinitionObjectHasDirective(globalDef, directiveName) || $e7371a3132f5fe12$var$isDefinitionObjectHasDirective(childDef, directiveName));
};
const $e7371a3132f5fe12$export$e722a3789f7fabfb = (opt)=>{
    return $e7371a3132f5fe12$var$isQueryContainDirective(opt, (0, $faVZP.Directives).CUSTOM);
};

});
parcelRegister("faVZP", function(module, exports) {

$parcel$export(module.exports, "Directives", () => $7d8045d4bd8f732b$export$129646a0e1af8d85);
$parcel$export(module.exports, "CustomDirective", () => $7d8045d4bd8f732b$export$97a7ea7443254e53);

var $5hGV7 = parcelRequire("5hGV7");
var $bOniD = parcelRequire("bOniD");
var $7d8045d4bd8f732b$export$129646a0e1af8d85;
(function(Directives) {
    Directives["CUSTOM"] = "custom";
})($7d8045d4bd8f732b$export$129646a0e1af8d85 || ($7d8045d4bd8f732b$export$129646a0e1af8d85 = {}));
const $7d8045d4bd8f732b$export$97a7ea7443254e53 = new (0, $bOniD.GraphQLDirective)({
    name: "custom",
    locations: [
        (0, $5hGV7.DirectiveLocation).QUERY,
        (0, $5hGV7.DirectiveLocation).MUTATION
    ]
});

});


parcelRegister("kc4ri", function(module, exports) {

$parcel$export(module.exports, "createDirectoryHttpLink", () => $c62c18ac2fce61ec$export$bacc55ff336c5f9d);
/*
 * Apollo link that does the fetching
 * Docs: https://www.apollographql.com/docs/link/links/http.html
 */ 
var $35Kb7 = parcelRequire("35Kb7");
const $c62c18ac2fce61ec$export$bacc55ff336c5f9d = ({ url: url, getCloudId: getCloudId })=>{
    const customFetch = async (uri, options)=>{
        const body = JSON.parse(options.body);
        const uriWithOps = body.operationName ? `${uri}?q=${body.operationName}` : uri;
        if (body.variables && body.variables._withCloudId && getCloudId) {
            delete body.variables._withCloudId;
            body.variables.cloudId = getCloudId();
            options.body = JSON.stringify(body);
        }
        return fetch(uriWithOps, options);
    };
    return new (0, $35Kb7.HttpLink)({
        uri: url,
        credentials: 'include',
        fetch: customFetch
    });
};

});
parcelRegister("35Kb7", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $2405a8c9bbd1579c$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");

var $cp9eN = parcelRequire("cp9eN");
var $2405a8c9bbd1579c$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $cp9eN.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bvQX6.ApolloLink)(function(operation) {
        var chosenURI = (0, $cp9eN.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $cp9eN.selectHttpOptionsAndBody)(operation, (0, $cp9eN.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $cp9eN.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $bvQX6.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $cp9eN.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $bvQX6.fromError)(parseError);
        }
        return new (0, $bvQX6.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $cp9eN.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $cp9eN.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $cp9eN.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $2405a8c9bbd1579c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $2405a8c9bbd1579c$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $bvQX6.ApolloLink));

});
parcelRegister("cp9eN", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $907efc3a22e8ac51$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $907efc3a22e8ac51$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $907efc3a22e8ac51$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $907efc3a22e8ac51$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $907efc3a22e8ac51$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $907efc3a22e8ac51$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $907efc3a22e8ac51$export$63ccc2571850f81a);

var $fKE23 = parcelRequire("fKE23");

var $aKlnM = parcelRequire("aKlnM");

var $8j2fP = parcelRequire("8j2fP");
var $907efc3a22e8ac51$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $907efc3a22e8ac51$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $907efc3a22e8ac51$var$defaultOptions = {
    method: 'POST'
};
var $907efc3a22e8ac51$export$dd86f00dc866e75d = {
    http: $907efc3a22e8ac51$var$defaultHttpOptions,
    headers: $907efc3a22e8ac51$var$defaultHeaders,
    options: $907efc3a22e8ac51$var$defaultOptions
};
var $907efc3a22e8ac51$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $907efc3a22e8ac51$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $907efc3a22e8ac51$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8j2fP.InvariantError)(1);
    }
};
var $907efc3a22e8ac51$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $907efc3a22e8ac51$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fKE23.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)({}, options, config.options, {
            headers: (0, $fKE23.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $aKlnM.print)(query);
    return {
        options: options,
        body: body
    };
};
var $907efc3a22e8ac51$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8j2fP.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $907efc3a22e8ac51$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});



parcelRegister("dc8YU", function(module, exports) {

$parcel$export(module.exports, "createErrorLink", () => $e1b63d7cef8a14b5$export$d0106730d0f8f3b5);
/*
 * Apollo Link for additional requests error handling
 * Docs: https://www.apollographql.com/docs/link/links/error.html
 */ 
var $aqG9W = parcelRequire("aqG9W");

var $7a5mw = parcelRequire("7a5mw");
const $e1b63d7cef8a14b5$export$d0106730d0f8f3b5 = ({ statusCodeHandlers: statusCodeHandlers })=>(0, $aqG9W.onError)((errorResponse)=>{
        const networkError = errorResponse.networkError;
        const graphQLErrors = errorResponse.graphQLErrors;
        if (graphQLErrors) // Our existing GraphQLError has its own type, and graphql one is not exposing the type information correctly
        // So in here we gonna go with `any` type for now
        // eslint-disable-next-line no-console
        console.error((0, $7a5mw.GraphQLError).from(errorResponse.graphQLErrors));
        if (networkError) {
            const statusCode = networkError.statusCode;
            const handler = statusCodeHandlers[statusCode];
            if (typeof handler === 'function') {
                /**
				 * these functions are expecting a Response object, which is not present here.
				 * It appears statusCodeHandlers are never passed to createErrorLink, so we should investigate removal
				 */ // @ts-ignore
                handler();
                return;
            }
        }
    });

});
parcelRegister("aqG9W", function(module, exports) {

$parcel$export(module.exports, "onError", () => $797d090cd04ee84b$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $797d090cd04ee84b$export$2288787135a8f66e(errorHandler) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        return new (0, $bvQX6.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $797d090cd04ee84b$export$d2c8415987899609 = function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $797d090cd04ee84b$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("7a5mw", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $8b8d4bdb5078c4ba$export$92d6ed0888e7cb7f);
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $8b8d4bdb5078c4ba$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.stack = new Error(message).stack || '';
    }
}
class $8b8d4bdb5078c4ba$export$c73ca302efeda3b4 extends $8b8d4bdb5078c4ba$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $8b8d4bdb5078c4ba$export$c73ca302efeda3b4.prototype);
    }
}
class $8b8d4bdb5078c4ba$export$20de9a0e470e95aa extends $8b8d4bdb5078c4ba$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $8b8d4bdb5078c4ba$export$20de9a0e470e95aa.prototype);
    }
}
class $8b8d4bdb5078c4ba$export$65bd6083489bd8bb extends $8b8d4bdb5078c4ba$var$CommonError {
    constructor({ message: message, status: status }){
        super(message);
        Object.setPrototypeOf(this, $8b8d4bdb5078c4ba$export$65bd6083489bd8bb.prototype);
        this.status = status;
    }
}
class $8b8d4bdb5078c4ba$export$92d6ed0888e7cb7f extends $8b8d4bdb5078c4ba$var$CommonError {
    constructor({ message: message = 'unknown', category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $8b8d4bdb5078c4ba$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $8b8d4bdb5078c4ba$export$92d6ed0888e7cb7f(errorData);
        };
    }
}

});


parcelRegister("IBBFX", function(module, exports) {

$parcel$export(module.exports, "createRetryLink", () => $b7cd4a766e7d180f$export$91ceafe7c6f4a732);
/*
 * Apollo Link to make sure our requests have re-try functionality in case of request failure
 * Docs: https://www.apollographql.com/docs/link/links/retry.html
 */ 
var $kcwGc = parcelRequire("kcwGc");
const $b7cd4a766e7d180f$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $b7cd4a766e7d180f$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
const $b7cd4a766e7d180f$export$91ceafe7c6f4a732 = (retryOptions)=>new (0, $kcwGc.RetryLink)({
        delay: {
            initial: $b7cd4a766e7d180f$export$8f4286bf21155381.INITIAL_DELAY,
            max: Infinity,
            jitter: $b7cd4a766e7d180f$export$8f4286bf21155381.JITTER,
            ...retryOptions.delay
        },
        attempts: {
            max: $b7cd4a766e7d180f$export$8f4286bf21155381.MAX_RETRIES,
            retryIf: (error, operation)=>{
                const context = operation.getContext();
                const response = context.response;
                const noRetry = context.noRetry;
                return $b7cd4a766e7d180f$export$55b2fbd5d4a32495(response && response.status) && !noRetry;
            },
            ...retryOptions.attempts
        }
    });

});
parcelRegister("kcwGc", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $eb4e47225b0a9c93$export$943d544ad120494a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $eb4e47225b0a9c93$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $eb4e47225b0a9c93$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $eb4e47225b0a9c93$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $fKE23.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $eb4e47225b0a9c93$export$943d544ad120494a = function(_super) {
    (0, $fKE23.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $eb4e47225b0a9c93$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $eb4e47225b0a9c93$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $eb4e47225b0a9c93$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $bvQX6.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $bvQX6.ApolloLink));

});


parcelRegister("aF0EL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9958bdb038f54fc$export$2e2bcd8739ae039);
// queries

var $gtDgu = parcelRequire("gtDgu");

var $a2KjS = parcelRequire("a2KjS");

var $kb4lE = parcelRequire("kb4lE");

var $hpxt4 = parcelRequire("hpxt4");

var $6Qg8I = parcelRequire("6Qg8I");

var $fHNXj = parcelRequire("fHNXj");

var $7yX2V = parcelRequire("7yX2V");

var $ftcMs = parcelRequire("ftcMs");

var $lOzcg = parcelRequire("lOzcg");

var $8r1hQ = parcelRequire("8r1hQ");

var $2QHLp = parcelRequire("2QHLp");

var $b4OYd = parcelRequire("b4OYd");

var $5Xb3F = parcelRequire("5Xb3F");

var $1JiO5 = parcelRequire("1JiO5");

var $nZOkC = parcelRequire("nZOkC");

var $9p4em = parcelRequire("9p4em");
// mutations
const $a9958bdb038f54fc$var$resolvers = {
    Query: {
        User: $2QHLp.default,
        MyAvatar: $hpxt4.default,
        UserOrganization: $9p4em.default,
        UserManageConfig: $b4OYd.default,
        UserManagePrivacySettings: $1JiO5.default,
        UserManageLinkedAccounts: $5Xb3F.default,
        UserManagePrivacySettingsAllowed: $nZOkC.default,
        TeamInSlack: $6Qg8I.default,
        Containers: $gtDgu.default,
        TeamLinkIcons: $fHNXj.default
    },
    Mutation: {
        updateUser: $ftcMs.default,
        deleteUserAvatar: $a2KjS.default,
        updateUserAvatar: $lOzcg.default,
        updateUserPrivacySettings: $8r1hQ.default,
        updateTeamInSlack: $7yX2V.default,
        disconnectTeamInSlack: $kb4lE.default
    }
};
var $a9958bdb038f54fc$export$2e2bcd8739ae039 = $a9958bdb038f54fc$var$resolvers;

});
parcelRegister("gtDgu", function(module, exports) {

$parcel$export(module.exports, "default", () => $72318d20def4b021$export$2e2bcd8739ae039);
const $72318d20def4b021$var$Containers = async (_, args, context, info)=>{
    const { userId: userId, maxNumberOfResults: maxNumberOfResults, principalId: principalId, siteId: siteId, sessionId: sessionId } = args;
    return await context.fetch(`${context.url.collaborationGraph}/v1/collaborationgraph/user/container`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
            },
            containerTypes: [
                'confluenceSpace',
                'jiraProject'
            ],
            maxNumberOfResults: maxNumberOfResults,
            userId: userId,
            expanded: true
        })
    }).then((res)=>{
        // Matches type of QueryData['Containers'] in
        // packages/embeddable-directory/src/components/CGContainers/ContainersQuery.tsx
        return res.json();
    });
};
var $72318d20def4b021$export$2e2bcd8739ae039 = $72318d20def4b021$var$Containers;

});

parcelRegister("a2KjS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1177cd2879ccae9b$export$2e2bcd8739ae039);
const $1177cd2879ccae9b$var$deleteUserAvatar = async (_, args, context)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
    return context.fetch(url, {
        method: 'DELETE'
    }).then(()=>true);
};
var $1177cd2879ccae9b$export$2e2bcd8739ae039 = $1177cd2879ccae9b$var$deleteUserAvatar;

});

parcelRegister("kb4lE", function(module, exports) {

$parcel$export(module.exports, "default", () => $24c541ba469c7e24$export$2e2bcd8739ae039);
const $24c541ba469c7e24$var$disconnectTeamInSlack = async (_, args, context)=>{
    const { teamId: teamId } = args;
    const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}`;
    return context.fetch(url, {
        method: 'DELETE'
    }).then((data)=>data.json()).then((data)=>({
            id: teamId,
            ...data
        }));
};
var $24c541ba469c7e24$export$2e2bcd8739ae039 = $24c541ba469c7e24$var$disconnectTeamInSlack;

});

parcelRegister("hpxt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $30feb055f36caac4$export$2e2bcd8739ae039);
const $30feb055f36caac4$var$myAvatar = async (root, args, context)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
    return context.fetch(url).then((data)=>data.json());
};
var $30feb055f36caac4$export$2e2bcd8739ae039 = $30feb055f36caac4$var$myAvatar;

});

parcelRegister("6Qg8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe8035ed807b5575$export$2e2bcd8739ae039);
const $fe8035ed807b5575$var$teamInSlack = async (root, args, context)=>{
    const { teamId: teamId, teamName: teamName } = args;
    const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}?teamName=${encodeURIComponent(teamName)}`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>({
            id: teamId,
            ...data
        }));
};
var $fe8035ed807b5575$export$2e2bcd8739ae039 = $fe8035ed807b5575$var$teamInSlack;

});

parcelRegister("fHNXj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aef831b14b7f6ef$export$2e2bcd8739ae039);

var $38Hap = parcelRequire("38Hap");
const $8aef831b14b7f6ef$var$TeamLinkIcons = async (_, args, context, info)=>{
    const requestBody = args.teamLinkUrls.map((url)=>({
            resourceUrl: url
        }));
    const options = {
        method: 'POST',
        body: JSON.stringify(requestBody)
    };
    return context.fetch(`${context.url.stargateRoot}/object-resolver/resolve/batch`, options).then((res)=>res.json()).then((0, $38Hap.transformIconData));
};
var $8aef831b14b7f6ef$export$2e2bcd8739ae039 = $8aef831b14b7f6ef$var$TeamLinkIcons;

});
parcelRegister("38Hap", function(module, exports) {

$parcel$export(module.exports, "transformIconData", () => $c2ed405c568dc9b8$export$39f4468adf4cb57c);
/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */ var $c2ed405c568dc9b8$var$ProviderNames;
/**
 * These names match the Provider Name in the JSON-LD response from respective resolvers
 */ (function(ProviderNames) {
    ProviderNames["CONFLUENCE"] = "Confluence";
    ProviderNames["JIRA"] = "Jira";
})($c2ed405c568dc9b8$var$ProviderNames || ($c2ed405c568dc9b8$var$ProviderNames = {}));
const $c2ed405c568dc9b8$export$c64ca1c808335e8b = (jsonLd)=>{
    const { url: url, generator: { name: name, icon: icon } } = jsonLd;
    switch(name){
        case "Confluence":
            return {
                linkUrl: url,
                iconUrl: $c2ed405c568dc9b8$var$getConfluenceFavicon(url),
                productName: name
            };
        case "Jira":
            return {
                linkUrl: url,
                iconUrl: $c2ed405c568dc9b8$var$getJiraFavicon(url),
                productName: name
            };
        default:
            return {
                linkUrl: url,
                iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                productName: name
            };
    }
};
const $c2ed405c568dc9b8$var$isIconItemSuccess = (response)=>{
    return response.status === 200;
};
const $c2ed405c568dc9b8$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($c2ed405c568dc9b8$var$isIconItemSuccess).map((resp)=>resp.body.data).map($c2ed405c568dc9b8$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
const $c2ed405c568dc9b8$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
const $c2ed405c568dc9b8$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;

});


parcelRegister("7yX2V", function(module, exports) {

$parcel$export(module.exports, "default", () => $528df15cf8bcf4a5$export$2e2bcd8739ae039);
const $528df15cf8bcf4a5$var$updateTeamInSlack = async (_, args, context)=>{
    const { teamId: teamId, channelId: channelId, usergroupHandle: usergroupHandle } = args;
    const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`;
    return context.fetch(url, {
        method: 'POST'
    }).then((data)=>data.json()).then((data)=>({
            id: teamId,
            ...data
        }));
};
var $528df15cf8bcf4a5$export$2e2bcd8739ae039 = $528df15cf8bcf4a5$var$updateTeamInSlack;

});

parcelRegister("ftcMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $619d99325a777068$export$2e2bcd8739ae039);

var $ksnu5 = parcelRequire("ksnu5");
const $619d99325a777068$var$updateUser = async (_, args, context, info)=>{
    const { id: id, input: input } = args;
    const url = `${context.url.stargateRoot}/users/${id}/manage/profile`;
    const body = JSON.stringify($ksnu5.toManageAPIInput(input));
    return context.fetch(url, {
        method: 'PATCH',
        body: body
    }).then((data)=>data.json()).then((res)=>$ksnu5.fromManageAPIResponse(res));
};
var $619d99325a777068$export$2e2bcd8739ae039 = $619d99325a777068$var$updateUser;

});
parcelRegister("ksnu5", function(module, exports) {

$parcel$export(module.exports, "fromManageAPIResponse", () => $e0e79894baf9dcb9$export$5299664357e4f3dd);
$parcel$export(module.exports, "toManageAPIInput", () => $e0e79894baf9dcb9$export$7b103107c889cb67);
parcelRequire("6Y9ZA");
var $8db47 = parcelRequire("8db47");
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $e0e79894baf9dcb9$var$PROFILE_PROPS_MAP = new Map([
    [
        'id',
        'account_id'
    ],
    [
        'fullName',
        'name'
    ],
    [
        'nickname',
        'nickname'
    ],
    [
        'timezone',
        'zoneinfo'
    ],
    [
        'locale',
        'locale'
    ],
    [
        'avatarUrl',
        'picture'
    ],
    [
        'email',
        'email'
    ]
]);
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $e0e79894baf9dcb9$var$EXTENDED_PROFILE_PROPS_MAP = new Map([
    [
        'title',
        'job_title'
    ],
    [
        'department',
        'department'
    ],
    [
        'companyName',
        'organization'
    ],
    [
        'location',
        'location'
    ],
    [
        'phoneNumber',
        'phone_number'
    ]
]);
const $e0e79894baf9dcb9$export$5299664357e4f3dd = (res)=>{
    const data = res.account;
    const extendedData = data && data.extended_profile || {};
    if (!data) return null;
    const timeZone = data.zoneinfo;
    const localTime = ({ format: format })=>{
        if (!timeZone) return null;
        try {
            return (0, $8db47.default)(new Date(), timeZone, format);
        } catch (error) {
            // TODO: PTC-4908 send error to sentry for reporting
            return null;
        }
    };
    const profileProps = Array.from($e0e79894baf9dcb9$var$PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($e0e79894baf9dcb9$var$PROFILE_PROPS_MAP.has(key)) acc[key] = data[$e0e79894baf9dcb9$var$PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    const extendedProfileProps = Array.from($e0e79894baf9dcb9$var$EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($e0e79894baf9dcb9$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) acc[key] = extendedData[$e0e79894baf9dcb9$var$EXTENDED_PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    return {
        ...profileProps,
        ...extendedProfileProps,
        localTime: localTime
    };
};
const $e0e79894baf9dcb9$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ($e0e79894baf9dcb9$var$PROFILE_PROPS_MAP.has(key)) output[$e0e79894baf9dcb9$var$PROFILE_PROPS_MAP.get(key)] = input[key];
        if ($e0e79894baf9dcb9$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) output.extended_profile[$e0e79894baf9dcb9$var$EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
    });
    return output;
};

});
parcelRegister("6Y9ZA", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("8db47")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $8db47 = parcelRequire("8db47");





});
parcelRegister("8db47", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fa81efa1c4ca6aa$export$2e2bcd8739ae039);

var $1WmNj = parcelRequire("1WmNj");

var $bmMNO = parcelRequire("bmMNO");

var $gONQq = parcelRequire("gONQq");
function $5fa81efa1c4ca6aa$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1WmNj)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $bmMNO.default)((0, $gONQq.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("bmMNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $84679af07277c994$export$2e2bcd8739ae039);

var $Yg8hb = parcelRequire("Yg8hb");

var $8EHc3 = parcelRequire("8EHc3");

var $8skeH = parcelRequire("8skeH");
var $84679af07277c994$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $84679af07277c994$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($84679af07277c994$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $8skeH.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $8EHc3.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yg8hb)))(dirtyDate, formatStr, options);
}

});
parcelRegister("8EHc3", function(module, exports) {

$parcel$export(module.exports, "default", () => $64d39075a143f763$export$2e2bcd8739ae039);

var $g5dTR = parcelRequire("g5dTR");

var $gAmrF = parcelRequire("gAmrF");
var $64d39075a143f763$var$MILLISECONDS_IN_MINUTE = 60000;
var $64d39075a143f763$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $64d39075a143f763$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $64d39075a143f763$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $64d39075a143f763$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $64d39075a143f763$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $64d39075a143f763$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $64d39075a143f763$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $64d39075a143f763$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $64d39075a143f763$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $64d39075a143f763$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $64d39075a143f763$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $64d39075a143f763$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $g5dTR.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $g5dTR.default)('long', date, options);
        }
    }
};
function $64d39075a143f763$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $gAmrF.default)(timeZone, originalDate, true) / $64d39075a143f763$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $64d39075a143f763$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $64d39075a143f763$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $64d39075a143f763$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $64d39075a143f763$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $64d39075a143f763$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $64d39075a143f763$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $64d39075a143f763$var$formatTimezone(offset, dirtyDelimeter);
}
function $64d39075a143f763$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $64d39075a143f763$var$addLeadingZeros(minutes, 2);
}
var $64d39075a143f763$export$2e2bcd8739ae039 = $64d39075a143f763$var$formatters;

});
parcelRegister("g5dTR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb57e53ae9fd2536$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $bb57e53ae9fd2536$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $bb57e53ae9fd2536$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $bb57e53ae9fd2536$var$partsTimeZone(dtf, date) : $bb57e53ae9fd2536$var$hackyTimeZone(dtf, date);
}
function $bb57e53ae9fd2536$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $bb57e53ae9fd2536$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $bb57e53ae9fd2536$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("gAmrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1316b4e02cb5348$export$2e2bcd8739ae039);

var $2QyCk = parcelRequire("2QyCk");

var $gKnpJ = parcelRequire("gKnpJ");
var $c1316b4e02cb5348$var$MILLISECONDS_IN_HOUR = 3600000;
var $c1316b4e02cb5348$var$MILLISECONDS_IN_MINUTE = 60000;
var $c1316b4e02cb5348$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $c1316b4e02cb5348$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $c1316b4e02cb5348$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $c1316b4e02cb5348$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$c1316b4e02cb5348$var$validateTimezone(hours)) return NaN;
        return -(hours * $c1316b4e02cb5348$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $c1316b4e02cb5348$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$c1316b4e02cb5348$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $c1316b4e02cb5348$var$MILLISECONDS_IN_HOUR + minutes * $c1316b4e02cb5348$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($c1316b4e02cb5348$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $c1316b4e02cb5348$var$toUtcDate(date);
        var offset = $c1316b4e02cb5348$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $c1316b4e02cb5348$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $c1316b4e02cb5348$var$toUtcDate(date) {
    return (0, $gKnpJ.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $c1316b4e02cb5348$var$calcOffset(date, timezoneString) {
    var tokens = (0, $2QyCk.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $gKnpJ.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $c1316b4e02cb5348$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $c1316b4e02cb5348$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $c1316b4e02cb5348$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $c1316b4e02cb5348$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $c1316b4e02cb5348$var$validIANATimezoneCache = {};
function $c1316b4e02cb5348$var$isValidTimezoneIANAString(timeZoneString) {
    if ($c1316b4e02cb5348$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $c1316b4e02cb5348$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("2QyCk", function(module, exports) {

$parcel$export(module.exports, "default", () => $212b4a583181c1a2$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $212b4a583181c1a2$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $212b4a583181c1a2$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $212b4a583181c1a2$var$partsOffset(dtf, date) : $212b4a583181c1a2$var$hackyOffset(dtf, date);
}
var $212b4a583181c1a2$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $212b4a583181c1a2$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $212b4a583181c1a2$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $212b4a583181c1a2$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $212b4a583181c1a2$var$dtfCache = {};
function $212b4a583181c1a2$var$getDateTimeFormat(timeZone) {
    if (!$212b4a583181c1a2$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $212b4a583181c1a2$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $212b4a583181c1a2$var$dtfCache[timeZone];
}

});

parcelRegister("gKnpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3131abe4c6832f7$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $c3131abe4c6832f7$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("8skeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6280a2b303703ea0$export$2e2bcd8739ae039);

var $4Zzm9 = parcelRequire("4Zzm9");

var $YdpzT = parcelRequire("YdpzT");

var $gAmrF = parcelRequire("gAmrF");

var $dmkNl = parcelRequire("dmkNl");
var $6280a2b303703ea0$var$MILLISECONDS_IN_HOUR = 3600000;
var $6280a2b303703ea0$var$MILLISECONDS_IN_MINUTE = 60000;
var $6280a2b303703ea0$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $6280a2b303703ea0$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $dmkNl.default)
};
function $6280a2b303703ea0$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $6280a2b303703ea0$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($4Zzm9)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $6280a2b303703ea0$var$splitDateString(argument);
    var parseYearResult = $6280a2b303703ea0$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $6280a2b303703ea0$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $6280a2b303703ea0$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $gAmrF.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($YdpzT)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($YdpzT)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $6280a2b303703ea0$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $6280a2b303703ea0$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $6280a2b303703ea0$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $6280a2b303703ea0$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $6280a2b303703ea0$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $6280a2b303703ea0$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $6280a2b303703ea0$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $6280a2b303703ea0$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $6280a2b303703ea0$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $6280a2b303703ea0$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $6280a2b303703ea0$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$6280a2b303703ea0$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $6280a2b303703ea0$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$6280a2b303703ea0$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $6280a2b303703ea0$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$6280a2b303703ea0$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $6280a2b303703ea0$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$6280a2b303703ea0$var$validateWeekDate(year, week)) return new Date(NaN);
        return $6280a2b303703ea0$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $6280a2b303703ea0$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$6280a2b303703ea0$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $6280a2b303703ea0$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $6280a2b303703ea0$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $6280a2b303703ea0$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$6280a2b303703ea0$var$validateTime(hours)) return NaN;
        return hours % 24 * $6280a2b303703ea0$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $6280a2b303703ea0$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$6280a2b303703ea0$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $6280a2b303703ea0$var$MILLISECONDS_IN_HOUR + minutes * $6280a2b303703ea0$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $6280a2b303703ea0$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$6280a2b303703ea0$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $6280a2b303703ea0$var$MILLISECONDS_IN_HOUR + minutes * $6280a2b303703ea0$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $6280a2b303703ea0$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $6280a2b303703ea0$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $6280a2b303703ea0$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $6280a2b303703ea0$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $6280a2b303703ea0$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $6280a2b303703ea0$var$isLeapYearIndex(year);
        if (isLeapYear && date > $6280a2b303703ea0$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $6280a2b303703ea0$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $6280a2b303703ea0$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $6280a2b303703ea0$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $6280a2b303703ea0$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $6280a2b303703ea0$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("dmkNl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b9d75d8b5656164$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $9b9d75d8b5656164$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $9b9d75d8b5656164$export$2e2bcd8739ae039 = $9b9d75d8b5656164$var$tzPattern;

});



parcelRegister("gONQq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3e7faf876a592b4$export$2e2bcd8739ae039);

var $gAmrF = parcelRequire("gAmrF");

var $8skeH = parcelRequire("8skeH");
function $c3e7faf876a592b4$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $8skeH.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $gAmrF.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});





parcelRegister("lOzcg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a68acc39fe2e5cfc$export$2e2bcd8739ae039);

var $9j18L = parcelRequire("9j18L");
const $a68acc39fe2e5cfc$var$updateUserAvatar = async (_, args, context)=>{
    const { userId: userId, fileURI: fileURI } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
    const fileObject = (0, $9j18L.dataURItoFile)(fileURI);
    const formData = new FormData();
    formData.append('file', fileObject);
    const fetchOptions = {
        method: 'PUT',
        body: formData,
        headers: {
            'Content-Type': undefined
        }
    };
    return context// @ts-ignore: we want to not pass 'Content-Type' header explicitly
    .fetch(url, fetchOptions)// Although current API in id-public-api-facade does not return new uploaded avatar,
    // we still want to have it in client-side
    .then(()=>({
            url: fileURI
        }));
};
var $a68acc39fe2e5cfc$export$2e2bcd8739ae039 = $a68acc39fe2e5cfc$var$updateUserAvatar;

});
parcelRegister("9j18L", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $3e0626c6f1dbcda6$export$80d19edb7b1ae293);
function $3e0626c6f1dbcda6$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        mimeString = 'unknown';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}

});


parcelRegister("8r1hQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15dfeed0d83cf95$export$2e2bcd8739ae039);

var $bH1Tn = parcelRequire("bH1Tn");
const $e15dfeed0d83cf95$var$updateUserPrivacySettings = async (_, args, context, info)=>{
    const { id: id, input: input } = args;
    const url = `${context.url.stargateRoot}/users/${id}/manage/privacy-settings`;
    const body = JSON.stringify((0, $bH1Tn.transformPrivacySettingsFormatFromSchemaToApi)(input));
    return context.fetch(url, {
        method: 'PATCH',
        body: body
    }).then((data)=>data.json()).then((data)=>(0, $bH1Tn.transformPrivacySettingsFormatFromApiToSchema)(data)).then((data)=>({
            ...data,
            id: id
        }));
};
var $e15dfeed0d83cf95$export$2e2bcd8739ae039 = $e15dfeed0d83cf95$var$updateUserPrivacySettings;

});
parcelRegister("bH1Tn", function(module, exports) {

$parcel$export(module.exports, "PRIVACY_SETTINGS_SCHEMA_TO_API_MAP", () => $4a3cb05849ec1dea$export$4154b9b275895abf);
$parcel$export(module.exports, "transformPrivacySettingsFormatFromApiToSchema", () => $4a3cb05849ec1dea$export$bfc3808f21c9d49d);
$parcel$export(module.exports, "transformPrivacySettingsFormatFromSchemaToApi", () => $4a3cb05849ec1dea$export$f5a6643bba95b2d0);

var $98tnj = parcelRequire("98tnj");
const $4a3cb05849ec1dea$var$manageUserPrivacySettingsKeys = [
    'name',
    'nickname',
    'zoneinfo',
    'picture',
    'email',
    'phoneNumber',
    'jobTitle',
    'organization',
    'department',
    'location'
];
const $4a3cb05849ec1dea$var$schemaKeys = {
    name: 'name',
    nickname: 'nickname',
    zoneinfo: 'zoneinfo',
    picture: 'picture',
    email: 'email',
    phoneNumber: 'phoneNumber',
    jobTitle: 'jobTitle',
    organization: 'organization',
    department: 'department',
    location: 'location'
};
const $4a3cb05849ec1dea$var$apiKeys = {
    name: 'name',
    nickname: 'nickname',
    zoneinfo: 'zoneinfo',
    picture: 'picture',
    email: 'email',
    phoneNumber: 'extended_profile.phone_number',
    jobTitle: 'extended_profile.job_title',
    organization: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $4a3cb05849ec1dea$export$4154b9b275895abf = {
    [$4a3cb05849ec1dea$var$schemaKeys.name]: $4a3cb05849ec1dea$var$apiKeys.name,
    [$4a3cb05849ec1dea$var$schemaKeys.nickname]: $4a3cb05849ec1dea$var$apiKeys.nickname,
    [$4a3cb05849ec1dea$var$schemaKeys.zoneinfo]: $4a3cb05849ec1dea$var$apiKeys.zoneinfo,
    [$4a3cb05849ec1dea$var$schemaKeys.picture]: $4a3cb05849ec1dea$var$apiKeys.picture,
    [$4a3cb05849ec1dea$var$schemaKeys.email]: $4a3cb05849ec1dea$var$apiKeys.email,
    [$4a3cb05849ec1dea$var$schemaKeys.phoneNumber]: $4a3cb05849ec1dea$var$apiKeys.phoneNumber,
    // extended profile
    [$4a3cb05849ec1dea$var$schemaKeys.jobTitle]: $4a3cb05849ec1dea$var$apiKeys.jobTitle,
    [$4a3cb05849ec1dea$var$schemaKeys.organization]: $4a3cb05849ec1dea$var$apiKeys.organization,
    [$4a3cb05849ec1dea$var$schemaKeys.department]: $4a3cb05849ec1dea$var$apiKeys.department,
    [$4a3cb05849ec1dea$var$schemaKeys.location]: $4a3cb05849ec1dea$var$apiKeys.location
};
const $4a3cb05849ec1dea$export$bfc3808f21c9d49d = (data)=>Object.keys($4a3cb05849ec1dea$export$4154b9b275895abf).reduce((memo, schemaValue)=>{
        const apiResponseKey = $4a3cb05849ec1dea$export$4154b9b275895abf[schemaValue];
        const privacySetting = data[apiResponseKey];
        memo[schemaValue] = (0, $98tnj.toUpperCase)(privacySetting);
        return memo;
    }, {});
const $4a3cb05849ec1dea$export$64774399daaaf8ff = {
    [$4a3cb05849ec1dea$var$apiKeys.name]: $4a3cb05849ec1dea$var$schemaKeys.name,
    [$4a3cb05849ec1dea$var$apiKeys.nickname]: $4a3cb05849ec1dea$var$schemaKeys.nickname,
    [$4a3cb05849ec1dea$var$apiKeys.zoneinfo]: $4a3cb05849ec1dea$var$schemaKeys.zoneinfo,
    [$4a3cb05849ec1dea$var$apiKeys.picture]: $4a3cb05849ec1dea$var$schemaKeys.picture,
    [$4a3cb05849ec1dea$var$apiKeys.email]: $4a3cb05849ec1dea$var$schemaKeys.email,
    [$4a3cb05849ec1dea$var$apiKeys.phoneNumber]: $4a3cb05849ec1dea$var$schemaKeys.phoneNumber,
    // extended profile
    [$4a3cb05849ec1dea$var$apiKeys.jobTitle]: $4a3cb05849ec1dea$var$schemaKeys.jobTitle,
    [$4a3cb05849ec1dea$var$apiKeys.organization]: $4a3cb05849ec1dea$var$schemaKeys.organization,
    [$4a3cb05849ec1dea$var$apiKeys.department]: $4a3cb05849ec1dea$var$schemaKeys.department,
    [$4a3cb05849ec1dea$var$apiKeys.location]: $4a3cb05849ec1dea$var$schemaKeys.location
};
const $4a3cb05849ec1dea$export$f5a6643bba95b2d0 = (data)=>Object.keys($4a3cb05849ec1dea$export$64774399daaaf8ff).reduce((memo, apiValue)=>{
        const apiResponseKey = $4a3cb05849ec1dea$export$64774399daaaf8ff[apiValue];
        const privacySetting = data[apiResponseKey];
        if (privacySetting) memo[apiValue] = privacySetting.toLowerCase();
        return memo;
    }, {});

});
parcelRegister("98tnj", function(module, exports) {

$parcel$export(module.exports, "toUpperCase", () => $7c7442d98f50f4dd$export$d80c591a9e16646);
const $7c7442d98f50f4dd$export$d80c591a9e16646 = (input)=>{
    if (typeof input === 'string') return input.toUpperCase();
    return null;
};

});



parcelRegister("2QHLp", function(module, exports) {

$parcel$export(module.exports, "default", () => $42e6c4959e7ee502$export$2e2bcd8739ae039);
// https://developer.atlassian.com/cloud/admin/user-management/rest/#api-users-account-id-manage-profile-get

var $ksnu5 = parcelRequire("ksnu5");
const $42e6c4959e7ee502$var$User = async (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/profile`;
    return context.fetch(url).then((data)=>data.json()).then((res)=>$ksnu5.fromManageAPIResponse(res));
};
var $42e6c4959e7ee502$export$2e2bcd8739ae039 = $42e6c4959e7ee502$var$User;

});

parcelRegister("b4OYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $04693d6a16f65a74$export$2e2bcd8739ae039);
// https://developer.atlassian.com/cloud/admin/user-management/rest/#api-users-account-id-manage-profile-get

var $cI9hn = parcelRequire("cI9hn");
const $04693d6a16f65a74$var$UserManageConfig = async (_, args, context)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>(0, $cI9hn.transformUserManageConfig)(data));
};
var $04693d6a16f65a74$export$2e2bcd8739ae039 = $04693d6a16f65a74$var$UserManageConfig;

});
parcelRegister("cI9hn", function(module, exports) {

$parcel$export(module.exports, "transformUserManageConfig", () => $28c546e4b7c9451c$export$d7725d3d27b80a68);
const $28c546e4b7c9451c$var$MUTABILITY_DETAILS_MAP = {
    fullName: 'name',
    nickname: 'nickname',
    timezone: 'zoneinfo',
    locale: 'locale',
    email: 'email',
    // extended profile
    title: 'extended_profile.job_title',
    phoneNumber: 'extended_profile.phone_number',
    companyName: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $28c546e4b7c9451c$var$CUSTOM_FIELD_PLACE = {
    email: 'email.initiateChange',
    picture: 'avatar'
};
const $28c546e4b7c9451c$var$getFieldConfig = (data, field)=>{
    if ((field === 'email' || field === 'picture') && $28c546e4b7c9451c$var$CUSTOM_FIELD_PLACE[field]) return data[$28c546e4b7c9451c$var$CUSTOM_FIELD_PLACE[field]];
    const mappedFieldKey = $28c546e4b7c9451c$var$MUTABILITY_DETAILS_MAP[field];
    // @ts-ignore
    return data['profile.write'][mappedFieldKey];
};
const $28c546e4b7c9451c$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $28c546e4b7c9451c$var$getFieldConfig(data, field);
    if (!fieldConfig || fieldConfig.allowed) return null;
    const reason = fieldConfig.reason;
    return {
        field: field,
        reason: reason && reason.key || null
    };
};
const $28c546e4b7c9451c$export$d7725d3d27b80a68 = (data)=>({
        mutabilityConstraints: Object.keys($28c546e4b7c9451c$var$MUTABILITY_DETAILS_MAP)// @ts-ignore
        .map((field)=>$28c546e4b7c9451c$var$getMutabilityConstraintFor(data, field)).filter((truthy)=>truthy)
    });

});


parcelRegister("5Xb3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7094f361c129dd$export$2e2bcd8739ae039);
const $5e7094f361c129dd$var$UserManageLinkedAccounts = (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/linked-accounts`;
    return context.fetch(url).then((res)=>res.json()).then((data)=>{
        return {
            google: Boolean(data && data.google && data.google.linked),
            microsoft: Boolean(data && data.microsoft && data.microsoft.linked),
            apple: Boolean(data && data.apple && data.apple.linked),
            saml: Boolean(data && data.saml && data.saml.linked)
        };
    });
};
var $5e7094f361c129dd$export$2e2bcd8739ae039 = $5e7094f361c129dd$var$UserManageLinkedAccounts;

});

parcelRegister("1JiO5", function(module, exports) {

$parcel$export(module.exports, "default", () => $46faeceb3386542d$export$2e2bcd8739ae039);

var $bH1Tn = parcelRequire("bH1Tn");
const $46faeceb3386542d$var$UserManagePrivacySettings = async (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/privacy-settings`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>(0, $bH1Tn.transformPrivacySettingsFormatFromApiToSchema)(data)).then((data)=>({
            ...data,
            id: userId
        }));
};
var $46faeceb3386542d$export$2e2bcd8739ae039 = $46faeceb3386542d$var$UserManagePrivacySettings;

});

parcelRegister("nZOkC", function(module, exports) {

$parcel$export(module.exports, "default", () => $710823b41f059521$export$2e2bcd8739ae039);

var $6TMC6 = parcelRequire("6TMC6");
const $710823b41f059521$var$UserManagePrivacySettingsAllowed = async (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/privacy-settings/allowed`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>(0, $6TMC6.transformUserManagePrivacySettingsAllowed)(data));
};
var $710823b41f059521$export$2e2bcd8739ae039 = $710823b41f059521$var$UserManagePrivacySettingsAllowed;

});
parcelRegister("6TMC6", function(module, exports) {

$parcel$export(module.exports, "transformUserManagePrivacySettingsAllowed", () => $3f74b8bf27517af7$export$3f9c63641eb8459e);

var $98tnj = parcelRequire("98tnj");

var $bH1Tn = parcelRequire("bH1Tn");
const $3f74b8bf27517af7$var$getAllowedPrivacySettingsFor = (data, schemaValue)=>{
    const apiResponseKey = (0, $bH1Tn.PRIVACY_SETTINGS_SCHEMA_TO_API_MAP)[schemaValue];
    const allowedPrivacySettings = data[apiResponseKey];
    if (!allowedPrivacySettings || !allowedPrivacySettings.length) return null;
    return allowedPrivacySettings.map((0, $98tnj.toUpperCase));
};
const $3f74b8bf27517af7$export$3f9c63641eb8459e = (data)=>Object.keys((0, $bH1Tn.PRIVACY_SETTINGS_SCHEMA_TO_API_MAP)).reduce((memo, schemaValue)=>{
        memo[schemaValue] = $3f74b8bf27517af7$var$getAllowedPrivacySettingsFor(data, schemaValue);
        return memo;
    }, {});

});


parcelRegister("9p4em", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d10328063ea67ac$export$2e2bcd8739ae039);
const $5d10328063ea67ac$var$UserOrganization = async (_, args, context, info)=>{
    const url = `${context.url.stargateRoot}/my-orgs`;
    return context.fetch(url).then((data)=>data.json()).then((res)=>({
            cloudId: res.managedBy && res.managedBy.id || null,
            name: res.managedBy && res.managedBy.name || null
        }));
};
var $5d10328063ea67ac$export$2e2bcd8739ae039 = $5d10328063ea67ac$var$UserOrganization;

});


parcelRegister("5vw7Q", function(module, exports) {

$parcel$export(module.exports, "schema", () => $b784d66e9747d667$export$4902baddc787debb);

var $6BdRO = parcelRequire("6BdRO");

var $faVZP = parcelRequire("faVZP");

var $heEzi = parcelRequire("heEzi");

var $lGJzb = parcelRequire("lGJzb");
const $b784d66e9747d667$export$4902baddc787debb = new (0, $6BdRO.GraphQLSchema)({
    directives: [
        (0, $faVZP.CustomDirective)
    ],
    query: (0, $lGJzb.default),
    mutation: (0, $heEzi.default)
});

});
parcelRegister("heEzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $84467a5a29396f2a$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $b8KHw = parcelRequire("b8KHw");

var $juXua = parcelRequire("juXua");

var $duQex = parcelRequire("duQex");

var $hEdbw = parcelRequire("hEdbw");
const $84467a5a29396f2a$var$MutationRoot = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        updateUser: {
            type: (0, $duQex.default),
            args: {
                id: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                input: {
                    type: (0, $duQex.UserInput)
                }
            }
        },
        deleteUserAvatar: {
            description: "Delete user's Atlassian account avatar. In the absence of an Atlassian account avatar, the user's gravatar will be used",
            type: (0, $auu22.GraphQLBoolean),
            args: {
                userId: {
                    description: "User's Atlassian account ID",
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        updateUserAvatar: {
            description: 'Upload an Atlassian account avatar.',
            type: new (0, $lXoEQ.GraphQLObjectType)({
                fields: {
                    url: {
                        type: (0, $auu22.GraphQLString)
                    }
                },
                name: (0, $b8KHw.TypeNames).AVATAR,
                description: 'New avatar URL after uploading successfully'
            }),
            args: {
                userId: {
                    description: "User's Atlassian account ID",
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                fileURI: {
                    description: `Encoded string of image file will be uploaded.
            The avatar has a file size limit of 1MB.`,
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        updateUserPrivacySettings: {
            description: "Updates a user\u2019s privacy settings.",
            type: (0, $hEdbw.default),
            args: {
                id: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                input: {
                    type: (0, $hEdbw.UserPrivacySettingsInput)
                }
            }
        },
        updateTeamInSlack: {
            type: (0, $juXua.default),
            args: {
                teamId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                channelId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                usergroupHandle: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        disconnectTeamInSlack: {
            type: (0, $juXua.default),
            args: {
                teamId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        }
    },
    name: 'Mutation'
});
var $84467a5a29396f2a$export$2e2bcd8739ae039 = $84467a5a29396f2a$var$MutationRoot;

});
parcelRegister("b8KHw", function(module, exports) {

$parcel$export(module.exports, "TypeNames", () => $ad9d9fc5de5dcf19$export$df40df59413bc65c);
var $ad9d9fc5de5dcf19$export$df40df59413bc65c;
(function(TypeNames) {
    TypeNames["USER"] = "_custom_User";
    TypeNames["USER_INPUT"] = "_custom_UserInput";
    TypeNames["USER_MANAGE_CONFIG"] = "_custom_UserManageConfig";
    TypeNames["USER_DETAILS_MUTABILITY_CONSTRAINTS"] = "_custom_UserDetailsMutabilityConstraints";
    TypeNames["USER_MANAGE_LINKED_ACCOUNTS"] = "_custom_UserManageLinkedAccounts";
    TypeNames["PRIVACY_VALUE"] = "_custom_PrivacyValue";
    TypeNames["PRIVACY_VALUE_INPUT"] = "_custom_PrivacyValueInput";
    TypeNames["PRIVACY_SETTINGS"] = "_custom_PrivacySettings";
    TypeNames["PRIVACY_SETTINGS_INPUT"] = "_custom_PrivacySettingsInput";
    TypeNames["PRIVACY_VALUES_CONFIG"] = "_custom_PrivacyValuesConfig";
    TypeNames["USER_PLACE"] = "_custom_UserPlace";
    TypeNames["USER_ORGANIZATION"] = "_custom_UserOrganization";
    TypeNames["PERMISSION_VALUE"] = "_custom_PermissionValue";
    TypeNames["AVATAR"] = "_custom_Avatar";
    TypeNames["MY_AVATAR"] = "_custom_MyAvatar";
    // Whether a team is active in slack
    TypeNames["TeamSlackStatus"] = "_custom_TeamSlackStatus";
    TypeNames["CLASSIC_APP"] = "_custom_ClassicApp";
    TypeNames["CLASSIC_APPS"] = "_custom_ClassicApps";
    TypeNames["MARKETPLACE_APP"] = "_custom_MarketplaceApp";
    TypeNames["CLASSIC_APP_INSTALLATION"] = "_custom_ClassicAppInstallation";
    TypeNames["MARKETPLACE_APP_PERMISSION"] = "_custom_MarketplaceAppPermission";
    TypeNames["MARKETPLACE_APP_PERMISSIONS"] = "_custom_MarketplaceAppPermissions";
    TypeNames["API_TOKEN"] = "_custom_ApiToken";
    TypeNames["SESSIONS_AND_DEVICES"] = "_custom_SessionsAndDevices";
    TypeNames["SESSION"] = "_custom_Session";
    TypeNames["DEVICE"] = "_custom_Device";
    TypeNames["ELEVATED_SESSION"] = "_custom_ElevatedSession";
    TypeNames["TSV_ENROLLMENT_DETAILS"] = "_custom_TsvEnrollmentDetails";
    TypeNames["CONTAINERS"] = "_custom_Containers";
    TypeNames["CONTAINER"] = "_custom_Container";
    TypeNames["CONTAINER_DETAILS"] = "_custom_ContainerDetails";
    TypeNames["COLOUR_SETTING"] = "_custom_ColourSetting";
    TypeNames["TEAM_LINK_ICON"] = "_custom_TeamLinkIcon";
})($ad9d9fc5de5dcf19$export$df40df59413bc65c || ($ad9d9fc5de5dcf19$export$df40df59413bc65c = {}));

});

parcelRegister("juXua", function(module, exports) {

$parcel$export(module.exports, "default", () => $63b1b2debc32ad0f$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $b8KHw = parcelRequire("b8KHw");
const $63b1b2debc32ad0f$var$TeamInSlackStatusType = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: (0, $auu22.GraphQLString)
        },
        connected: {
            type: (0, $auu22.GraphQLBoolean)
        },
        slackChannelId: {
            type: (0, $auu22.GraphQLString)
        },
        slackChannelName: {
            type: (0, $auu22.GraphQLString)
        },
        usergroupHandle: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $b8KHw.TypeNames).TeamSlackStatus,
    description: 'Whether the team has opted in to being synced with slack'
});
var $63b1b2debc32ad0f$export$2e2bcd8739ae039 = $63b1b2debc32ad0f$var$TeamInSlackStatusType;

});

parcelRegister("duQex", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d3ff161f9c136e3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "UserInput", () => $0d3ff161f9c136e3$export$3ac5e585cf392ee0);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $b8KHw = parcelRequire("b8KHw");
const $0d3ff161f9c136e3$var$User = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: (0, $auu22.GraphQLString)
        },
        fullName: {
            type: (0, $auu22.GraphQLString)
        },
        nickname: {
            type: (0, $auu22.GraphQLString)
        },
        timezone: {
            type: (0, $auu22.GraphQLString)
        },
        locale: {
            type: (0, $auu22.GraphQLString)
        },
        avatarUrl: {
            type: (0, $auu22.GraphQLString)
        },
        email: {
            type: (0, $auu22.GraphQLString)
        },
        status: {
            type: (0, $auu22.GraphQLString)
        },
        // extended profile
        title: {
            type: (0, $auu22.GraphQLString)
        },
        companyName: {
            type: (0, $auu22.GraphQLString)
        },
        department: {
            type: (0, $auu22.GraphQLString)
        },
        location: {
            type: (0, $auu22.GraphQLString)
        },
        phoneNumber: {
            type: (0, $auu22.GraphQLString)
        },
        // This should be considered to move to component level that uses timezone
        localTime: {
            type: (0, $auu22.GraphQLString),
            args: {
                format: {
                    description: 'moment.js format string',
                    type: (0, $auu22.GraphQLString),
                    defaultValue: ''
                },
                locale: {
                    description: 'locale for output',
                    type: (0, $auu22.GraphQLString),
                    defaultValue: 'en'
                }
            }
        }
    },
    name: (0, $b8KHw.TypeNames).USER,
    description: 'All User related data will be behind this GraphQL section'
});
var $0d3ff161f9c136e3$export$2e2bcd8739ae039 = $0d3ff161f9c136e3$var$User;
const $0d3ff161f9c136e3$export$3ac5e585cf392ee0 = new (0, $lXoEQ.GraphQLInputObjectType)({
    fields: {
        fullName: {
            type: (0, $auu22.GraphQLString)
        },
        nickname: {
            type: (0, $auu22.GraphQLString)
        },
        timezone: {
            type: (0, $auu22.GraphQLString)
        },
        locale: {
            type: (0, $auu22.GraphQLString)
        },
        email: {
            type: (0, $auu22.GraphQLString)
        },
        status: {
            type: (0, $auu22.GraphQLString)
        },
        // extended profile
        title: {
            type: (0, $auu22.GraphQLString)
        },
        companyName: {
            type: (0, $auu22.GraphQLString)
        },
        department: {
            type: (0, $auu22.GraphQLString)
        },
        location: {
            type: (0, $auu22.GraphQLString)
        },
        phoneNumber: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $b8KHw.TypeNames).USER_INPUT
});

});

parcelRegister("hEdbw", function(module, exports) {

$parcel$export(module.exports, "UserPrivacySettingsInput", () => $b3d38d46463d4f1d$export$5d92383dfb6e3588);
$parcel$export(module.exports, "PrivacyValue", () => $b3d38d46463d4f1d$export$8d71fec0dbffb7e5);
$parcel$export(module.exports, "default", () => $b3d38d46463d4f1d$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $b8KHw = parcelRequire("b8KHw");
const $b3d38d46463d4f1d$export$5c97c5d10d84e13c = new (0, $lXoEQ.GraphQLEnumType)({
    name: (0, $b8KHw.TypeNames).PRIVACY_VALUE_INPUT,
    values: {
        PUBLIC: {
            value: 'public'
        },
        COLLABORATOR: {
            value: 'collaborator'
        },
        PRIVATE: {
            value: 'private'
        }
    }
});
const $b3d38d46463d4f1d$export$5d92383dfb6e3588 = new (0, $lXoEQ.GraphQLInputObjectType)({
    fields: {
        name: {
            type: (0, $auu22.GraphQLString)
        },
        nickname: {
            type: (0, $auu22.GraphQLString)
        },
        jobTitle: {
            type: (0, $auu22.GraphQLString)
        },
        department: {
            type: (0, $auu22.GraphQLString)
        },
        organization: {
            type: (0, $auu22.GraphQLString)
        },
        location: {
            type: (0, $auu22.GraphQLString)
        },
        zoneinfo: {
            type: (0, $auu22.GraphQLString)
        },
        email: {
            type: (0, $auu22.GraphQLString)
        },
        phoneNumber: {
            type: (0, $auu22.GraphQLString)
        },
        picture: {
            type: (0, $auu22.GraphQLString)
        },
        teamType: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $b8KHw.TypeNames).PRIVACY_SETTINGS_INPUT,
    description: 'User privacy settings values to be set'
});
const $b3d38d46463d4f1d$var$DefaultPrivacyValue = new (0, $lXoEQ.GraphQLEnumType)({
    name: (0, $b8KHw.TypeNames).PRIVACY_VALUE,
    values: {
        PUBLIC: {
            value: 'PUBLIC'
        },
        COLLABORATOR: {
            value: 'COLLABORATOR'
        },
        PRIVATE: {
            value: 'PRIVATE'
        }
    }
});
const $b3d38d46463d4f1d$export$8d71fec0dbffb7e5 = new (0, $lXoEQ.GraphQLNonNull)($b3d38d46463d4f1d$var$DefaultPrivacyValue);
const $b3d38d46463d4f1d$var$UserManagePrivacySettings = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        name: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        nickname: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        jobTitle: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        department: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        organization: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        location: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        zoneinfo: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        email: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        phoneNumber: {
            type: $b3d38d46463d4f1d$var$DefaultPrivacyValue
        },
        picture: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        teamType: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        }
    },
    name: (0, $b8KHw.TypeNames).PRIVACY_SETTINGS,
    description: 'User privacy settings values'
});
var $b3d38d46463d4f1d$export$2e2bcd8739ae039 = $b3d38d46463d4f1d$var$UserManagePrivacySettings;

});


parcelRegister("lGJzb", function(module, exports) {

$parcel$export(module.exports, "default", () => $045d90912ea1834b$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $gkM5H = parcelRequire("gkM5H");
var $juXua = parcelRequire("juXua");
var $cM0OU = parcelRequire("cM0OU");
var $duQex = parcelRequire("duQex");
var $3uo0Q = parcelRequire("3uo0Q");
var $8aln8 = parcelRequire("8aln8");
var $hEdbw = parcelRequire("hEdbw");
var $91dgD = parcelRequire("91dgD");
var $bLCVI = parcelRequire("bLCVI");

var $iskZh = parcelRequire("iskZh");
const $045d90912ea1834b$var$QueryRoot = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        UserOrganization: {
            type: (0, $bLCVI.default)
        },
        User: {
            type: (0, $duQex.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        MyAvatar: {
            type: (0, $gkM5H.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        UserManageConfig: {
            type: (0, $3uo0Q.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        UserManagePrivacySettings: {
            type: (0, $hEdbw.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        UserManagePrivacySettingsAllowed: {
            type: (0, $91dgD.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        UserManageLinkedAccounts: {
            type: (0, $8aln8.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        TeamInSlack: {
            type: (0, $juXua.default),
            args: {
                teamId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                teamName: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        Containers: {
            type: (0, $iskZh.default),
            args: {
                principalId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                siteId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                maxNumberOfResults: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLInt))
                },
                sessionId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        TeamLinkIcons: {
            type: new (0, $lXoEQ.GraphQLList)((0, $cM0OU.default)),
            args: {
                teamLinkUrls: {
                    type: new (0, $lXoEQ.GraphQLList)((0, $auu22.GraphQLString))
                }
            }
        }
    },
    name: 'Query'
});
var $045d90912ea1834b$export$2e2bcd8739ae039 = $045d90912ea1834b$var$QueryRoot;

});
parcelRegister("gkM5H", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c897dbbe8caaae$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $b8KHw = parcelRequire("b8KHw");
const $34c897dbbe8caaae$var$MyAvatar = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        url: {
            type: (0, $auu22.GraphQLString)
        },
        uploaded: {
            type: (0, $auu22.GraphQLBoolean)
        }
    },
    name: (0, $b8KHw.TypeNames).MY_AVATAR,
    description: "Get meta-data about current user\u2019s avatar"
});
var $34c897dbbe8caaae$export$2e2bcd8739ae039 = $34c897dbbe8caaae$var$MyAvatar;

});

parcelRegister("cM0OU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9b4f4cf16dceeb$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $b8KHw = parcelRequire("b8KHw");
const $4b9b4f4cf16dceeb$var$TeamLinkIcon = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        linkUrl: {
            type: (0, $auu22.GraphQLString)
        },
        iconUrl: {
            type: (0, $auu22.GraphQLString)
        },
        productName: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $b8KHw.TypeNames).TEAM_LINK_ICON,
    description: 'Icon URL to use for a link'
});
var $4b9b4f4cf16dceeb$export$2e2bcd8739ae039 = $4b9b4f4cf16dceeb$var$TeamLinkIcon;

});

parcelRegister("3uo0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2677d4762e1cbae0$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $b8KHw = parcelRequire("b8KHw");
const $2677d4762e1cbae0$var$MutabilityConstraints = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        field: {
            type: (0, $auu22.GraphQLString)
        },
        reason: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $b8KHw.TypeNames).USER_DETAILS_MUTABILITY_CONSTRAINTS
});
const $2677d4762e1cbae0$var$UserManageConfig = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        mutabilityConstraints: {
            type: new (0, $lXoEQ.GraphQLList)($2677d4762e1cbae0$var$MutabilityConstraints)
        }
    },
    name: (0, $b8KHw.TypeNames).USER_MANAGE_CONFIG,
    description: 'User mutability constraints values'
});
var $2677d4762e1cbae0$export$2e2bcd8739ae039 = $2677d4762e1cbae0$var$UserManageConfig;

});

parcelRegister("8aln8", function(module, exports) {

$parcel$export(module.exports, "default", () => $034870d16281027d$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $b8KHw = parcelRequire("b8KHw");
const $034870d16281027d$var$LinkedAccounts = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        google: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean))
        },
        microsoft: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean))
        },
        apple: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean))
        },
        saml: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean))
        }
    },
    name: (0, $b8KHw.TypeNames).USER_MANAGE_LINKED_ACCOUNTS
});
var $034870d16281027d$export$2e2bcd8739ae039 = $034870d16281027d$var$LinkedAccounts;

});

parcelRegister("91dgD", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf106d3cd037b98$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");

var $b8KHw = parcelRequire("b8KHw");

var $hEdbw = parcelRequire("hEdbw");
const $fcf106d3cd037b98$var$AllowedPrivacyValue = new (0, $lXoEQ.GraphQLList)((0, $hEdbw.PrivacyValue));
const $fcf106d3cd037b98$var$UserManagePrivacySettingsAllowed = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        name: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        nickname: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        jobTitle: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        department: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        organization: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        location: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        zoneinfo: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        email: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        phoneNumber: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        picture: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        teamType: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        }
    },
    name: (0, $b8KHw.TypeNames).PRIVACY_VALUES_CONFIG,
    description: 'User privacy settings allowed values'
});
var $fcf106d3cd037b98$export$2e2bcd8739ae039 = $fcf106d3cd037b98$var$UserManagePrivacySettingsAllowed;

});

parcelRegister("bLCVI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c23ee84c3314354$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $b8KHw = parcelRequire("b8KHw");
const $6c23ee84c3314354$var$UserPlace = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        cloudId: {
            type: (0, $auu22.GraphQLString)
        },
        name: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $b8KHw.TypeNames).USER_ORGANIZATION,
    description: 'Organization a user belongs to'
});
var $6c23ee84c3314354$export$2e2bcd8739ae039 = $6c23ee84c3314354$var$UserPlace;

});

parcelRegister("iskZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cf5506f7004febb$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $b8KHw = parcelRequire("b8KHw");
const $4cf5506f7004febb$var$ContainerDetails = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        key: {
            type: (0, $auu22.GraphQLString)
        },
        name: {
            type: (0, $auu22.GraphQLString)
        },
        url: {
            type: (0, $auu22.GraphQLString)
        },
        iconUrl: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $b8KHw.TypeNames).CONTAINER_DETAILS
});
const $4cf5506f7004febb$var$Container = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        entityType: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        containerType: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        score: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLFloat))
        },
        containerDetails: {
            type: $4cf5506f7004febb$var$ContainerDetails
        }
    },
    name: (0, $b8KHw.TypeNames).CONTAINER
});
const $4cf5506f7004febb$var$Containers = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        collaborationGraphEntities: {
            type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($4cf5506f7004febb$var$Container)))
        }
    },
    name: (0, $b8KHw.TypeNames).CONTAINERS,
    description: 'A list of Places Spaces/Projects'
});
var $4cf5506f7004febb$export$2e2bcd8739ae039 = $4cf5506f7004febb$var$Containers;

});




parcelRegister("lhBhN", function(module, exports) {

$parcel$export(module.exports, "withDefaultExponentialBackoff", () => $ae7ba0d1a49c4623$export$455df4c93665fa4a);
const $ae7ba0d1a49c4623$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $ae7ba0d1a49c4623$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
// tslint:disable-next-line no-any
const $ae7ba0d1a49c4623$var$defaultRetryIfCallback = (a)=>!a;
const $ae7ba0d1a49c4623$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $ae7ba0d1a49c4623$var$defaultRetryIfCallback
};
function $ae7ba0d1a49c4623$export$20eaa22f2295996f(toTry, hofOptions = $ae7ba0d1a49c4623$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
function $ae7ba0d1a49c4623$export$455df4c93665fa4a(fetchOp) {
    return $ae7ba0d1a49c4623$export$20eaa22f2295996f(fetchOp, {
        initial: $ae7ba0d1a49c4623$export$8f4286bf21155381.INITIAL_DELAY,
        jitter: $ae7ba0d1a49c4623$export$8f4286bf21155381.JITTER,
        max: $ae7ba0d1a49c4623$export$8f4286bf21155381.MAX_RETRIES,
        retryIf: (response)=>$ae7ba0d1a49c4623$export$55b2fbd5d4a32495(response.status)
    });
}

});



parcelRegister("lxT0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $986af4a2a75dece7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4ErPU = parcelRequire("4ErPU");

var $1xrmr = parcelRequire("1xrmr");

var $2nfCW = parcelRequire("2nfCW");
var $fHuyz = parcelRequire("fHuyz");
var $aVqnF = parcelRequire("aVqnF");
var $g6xgY = parcelRequire("g6xgY");
var $cWYE1 = parcelRequire("cWYE1");
var $fcdA0 = parcelRequire("fcdA0");
var $6XUHL = parcelRequire("6XUHL");
var $5bjdJ = parcelRequire("5bjdJ");

var $1wQUJ = parcelRequire("1wQUJ");

var $lnHnV = parcelRequire("lnHnV");

var $jnlyS = parcelRequire("jnlyS");

var $avLBj = parcelRequire("avLBj");
var $37mOt = parcelRequire("37mOt");

var $ictQ5 = parcelRequire("ictQ5");

var $gi0VS = parcelRequire("gi0VS");

var $jmrxX = parcelRequire("jmrxX");

var $YnDGC = parcelRequire("YnDGC");

var $4vhsL = parcelRequire("4vhsL");

var $aILpI = parcelRequire("aILpI");
function $986af4a2a75dece7$export$2e2bcd8739ae039(props) {
    const { appName: appName, analytics: analytics, apolloClient: apolloClient, contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, replace: replace, push: push, locale: locale, skipI18nProvider: skipI18nProvider, addFlag: addFlag, docTitle: docTitle, env: env, history: history, statusCodeHandlers: statusCodeHandlers, cloudId: cloudId, orgId: orgId, teamCentralHandlers: teamCentralHandlers, productFeatureFlags: productFeatureFlags, invitePeopleHandlers: invitePeopleHandlers, isSentryEnabled: isSentryEnabled } = props;
    const sentryClient = (0, $fcdA0.useTeamsSentryClientSetup)(isSentryEnabled, {
        appName: appName,
        env: (0, $37mOt.getEnv)()
    });
    const [, { setCloudId: setCloudId }] = (0, $6XUHL.useSite)();
    const [, { setOrgId: setOrgId }] = (0, $cWYE1.useOrg)();
    const [, { initTeamCentral: initTeamCentral }] = (0, $5bjdJ.useTeamCentralStoreApi)();
    const { isJiraAvailable: isJiraAvailable } = (0, $1wQUJ.useJiraCheckService)(cloudId);
    const expTracker = analytics.expTracker();
    const analyticsClient = analytics.getAnalyticsWebClient();
    (0, $eUqFw.useEffect)(()=>{
        if (orgId) // @ts-expect-error - Property 'setOrgInfo' does not exist on type 'Promise<AnalyticsWebClient>'
        analyticsClient?.setOrgInfo(orgId);
    }, [
        analyticsClient,
        orgId
    ]);
    const appConfig = (0, $eUqFw.useMemo)(()=>({
            env: env,
            appName: appName,
            contextSpaPaths: contextSpaPaths,
            contextEntryPoint: contextEntryPoint,
            push: push,
            replace: replace,
            addFlag: addFlag,
            locale: locale,
            docTitle: docTitle,
            cloudId: cloudId,
            orgId: orgId,
            productFeatureFlags: productFeatureFlags,
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot,
            isJiraAvailable: isJiraAvailable
        }), [
        env,
        appName,
        contextSpaPaths,
        contextEntryPoint,
        isJiraAvailable,
        push,
        replace,
        addFlag,
        locale,
        docTitle,
        cloudId,
        orgId,
        productFeatureFlags
    ]);
    // init statusCodeHandlersProvider
    (0, $eUqFw.useEffect)(()=>{
        if (statusCodeHandlers) (0, $g6xgY.statusCodeHandlersProvider).setHandlers(statusCodeHandlers);
    }, [
        statusCodeHandlers
    ]);
    // save cloud id passed from consumers to a remote state management.
    (0, $eUqFw.useEffect)(()=>{
        setCloudId(cloudId);
    }, [
        cloudId,
        setCloudId
    ]);
    // save org id passed from consumers to a remote state management.
    (0, $eUqFw.useEffect)(()=>{
        setOrgId(orgId);
    }, [
        orgId,
        setOrgId
    ]);
    // Init and save various team central related data and preconditions
    (0, $eUqFw.useEffect)(()=>{
        initTeamCentral(appName, cloudId, teamCentralHandlers);
    }, [
        appName,
        cloudId,
        teamCentralHandlers,
        initTeamCentral
    ]);
    const handleTransition = (0, $eUqFw.useCallback)((pathname)=>{
        if (expTracker) expTracker.abort({
            reason: 'Route changes.'
        });
        (0, $jnlyS.addBreadcrumb)(pathname);
    }, [
        expTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVqnF.default), {
        messagesConfig: (0, $ictQ5.default),
        skip: typeof skipI18nProvider !== 'undefined' ? skipI18nProvider : !locale,
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $YnDGC.default), {
        analytics: analytics,
        appName: appName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lnHnV.TeamsWrapper), {
        sentryClient: sentryClient,
        appConfig: appConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jmrxX.default), {
        env: env,
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint,
        docTitle: docTitle,
        appName: appName,
        addFlag: addFlag,
        push: push,
        locale: locale,
        replace: replace,
        history: history,
        cloudId: cloudId,
        orgId: orgId,
        isJiraAvailable: isJiraAvailable,
        teamCentralHandlers: teamCentralHandlers,
        productFeatureFlags: productFeatureFlags,
        invitePeopleHandlers: invitePeopleHandlers
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2nfCW.default), {
        analytics: analytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1xrmr.ExperienceTrackerContext).Provider, {
        value: analytics.expTracker()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4vhsL.RelativeWrapperOfHeaderImage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ErPU.ApolloProvider), {
        client: apolloClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fHuyz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aILpI.default), {
        appName: appName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gi0VS.default), {
        contextEntryPoint: contextEntryPoint,
        history: history,
        onTransition: handleTransition
    })))))))))));
}

});
parcelRegister("4ErPU", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $36307d91b5e24fba$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $36307d91b5e24fba$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $36307d91b5e24fba$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $36307d91b5e24fba$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $36307d91b5e24fba$export$8f49e4af10703ce3);

var $eUqFw = parcelRequire("eUqFw");

var $8j2fP = parcelRequire("8j2fP");
var $36307d91b5e24fba$var$apolloContext;
function $36307d91b5e24fba$export$a47505d961ee3a1() {
    if (!$36307d91b5e24fba$var$apolloContext) $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
    return $36307d91b5e24fba$var$apolloContext;
}
function $36307d91b5e24fba$export$c2ee824bcc89ca6a() {
    $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
}
var $36307d91b5e24fba$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8j2fP.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $36307d91b5e24fba$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8j2fP.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $36307d91b5e24fba$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($36307d91b5e24fba$export$d1d99cf900472499 || ($36307d91b5e24fba$export$d1d99cf900472499 = {}));
var $36307d91b5e24fba$var$cache = new Map();
function $36307d91b5e24fba$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $36307d91b5e24fba$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $36307d91b5e24fba$export$8f49e4af10703ce3(document) {
    var cached = $36307d91b5e24fba$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8j2fP.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8j2fP.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8j2fP.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $36307d91b5e24fba$export$d1d99cf900472499.Query : $36307d91b5e24fba$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $36307d91b5e24fba$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8j2fP.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $36307d91b5e24fba$var$cache.set(document, payload);
    return payload;
}

});

parcelRegister("2nfCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $29d63922d1b7ecbc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $J9LlC = parcelRequire("J9LlC");
class $29d63922d1b7ecbc$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $J9LlC.AnalyticsContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            analytics: this.props.analytics
        };
    }
}

});
parcelRegister("J9LlC", function(module, exports) {

$parcel$export(module.exports, "defaultAnalyticsClient", () => $2575254e26e9efc9$export$7fa70eb12a96b7d1);
$parcel$export(module.exports, "AnalyticsContext", () => $2575254e26e9efc9$export$83cd6c3eba7d8d9e);

var $eUqFw = parcelRequire("eUqFw");

var $fECJU = parcelRequire("fECJU");
const $2575254e26e9efc9$var$defaultAnalyticsMethod = ()=>{
    // tslint:disable-next-line no-console
    // eslint-disable-next-line no-console
    console.warn('No analytics client has been provided.');
    (0, $fECJU.logInfoMessage)('Analytics Context accessed before AnalyticsClient was loaded');
};
const $2575254e26e9efc9$export$7fa70eb12a96b7d1 = {
    getAnalyticsWebClient: ()=>{
        $2575254e26e9efc9$var$defaultAnalyticsMethod();
        return;
    },
    pushTrackEvent: $2575254e26e9efc9$var$defaultAnalyticsMethod,
    pushScreenEvent: $2575254e26e9efc9$var$defaultAnalyticsMethod,
    pushUIEvent: $2575254e26e9efc9$var$defaultAnalyticsMethod,
    pushOperationalEvent: $2575254e26e9efc9$var$defaultAnalyticsMethod,
    startUIViewedEvent: $2575254e26e9efc9$var$defaultAnalyticsMethod,
    expTracker: ()=>{
        throw new Error('No analytics client has been provided');
    },
    setTeamId: ()=>{
        throw new Error('No analytics client has been provided');
    }
};
const $2575254e26e9efc9$var$AnalyticsContextState = {
    analytics: $2575254e26e9efc9$export$7fa70eb12a96b7d1
};
const $2575254e26e9efc9$export$83cd6c3eba7d8d9e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($2575254e26e9efc9$var$AnalyticsContextState);

});


parcelRegister("fHuyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36d4b8ef3efbbc1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2quw6 = parcelRequire("2quw6");

var $73k7H = parcelRequire("73k7H");
const $c36d4b8ef3efbbc1$var$initialStates = {
    DialogComponent: null,
    dialogProps: null,
    isOpen: false
};
function $c36d4b8ef3efbbc1$var$dialogReducer(state, action) {
    switch(action.type){
        case 'open':
            return {
                ...state,
                DialogComponent: action.payload?.DialogComponent || null,
                dialogProps: action.payload?.dialogProps || null,
                isOpen: true
            };
        case 'close':
            return {
                ...state,
                DialogComponent: null,
                dialogProps: null,
                isOpen: false
            };
        default:
            throw new Error();
    }
}
function $c36d4b8ef3efbbc1$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const [stateDialogProvider, dispatch] = (0, $eUqFw.useReducer)($c36d4b8ef3efbbc1$var$dialogReducer, $c36d4b8ef3efbbc1$var$initialStates);
    const valueProvider = (0, $eUqFw.useMemo)(()=>({
            openDialog: (DialogComponent, dialogProps = null)=>dispatch({
                    type: 'open',
                    payload: {
                        DialogComponent: DialogComponent,
                        dialogProps: dialogProps
                    }
                }),
            closeDialog: ()=>dispatch({
                    type: 'close'
                })
        }), []);
    return(// @ts-ignore
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $73k7H.DialogsContext).Provider, {
        value: valueProvider
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2quw6.default), stateDialogProvider)));
}

});
parcelRegister("2quw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $50035a600ad5fc7d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $73k7H = parcelRequire("73k7H");
function $50035a600ad5fc7d$export$2e2bcd8739ae039(props) {
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose, dialogProps: dialogProps } = props;
    const { closeDialog: closeDialog } = (0, $eUqFw.useContext)((0, $73k7H.DialogsContext));
    if (!DialogComponent) return null;
    const handleCloseDialog = ()=>{
        closeDialog();
        if (onClose) onClose();
        if (dialogProps?.onClose) dialogProps.onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DialogComponent, {
        ...dialogProps,
        onClose: handleCloseDialog
    }));
}

});
parcelRegister("73k7H", function(module, exports) {

$parcel$export(module.exports, "DialogsContext", () => $c75792d8e8b4ab19$export$412f7f691e39b0da);

var $eUqFw = parcelRequire("eUqFw");
const $c75792d8e8b4ab19$var$dialogsContextState = {
    openDialog: ()=>null,
    closeDialog: ()=>null
};
const $c75792d8e8b4ab19$export$412f7f691e39b0da = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($c75792d8e8b4ab19$var$dialogsContextState);

});



parcelRegister("aVqnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $13b41a06c5285c94$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");

var $fECJU = parcelRequire("fECJU");

var $1Zw99 = parcelRequire("1Zw99");
/**
 * Sets up the react-intl IntlProvider for its children, blocking until translations are loaded
 */ const $13b41a06c5285c94$var$NO_MESSAGES = {};
class $13b41a06c5285c94$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    componentDidMount() {
        if (this.props.skip !== true) this.loadData();
    }
    async loadData() {
        const { messagesConfig: messagesConfig, locale: predefinedLocale } = this.props;
        const locale = await (0, $1Zw99.getEffectiveLocale)(predefinedLocale);
        if (locale === (0, $1Zw99.DEFAULT_LOCALE)) {
            // Everything is already loaded for English
            this.setState({
                locale: (0, $1Zw99.DEFAULT_LOCALE),
                messages: {}
            });
            return;
        }
        try {
            const messages = await (0, $1Zw99.loadIntlData)(messagesConfig, locale);
            this.setState({
                locale: locale,
                messages: messages || $13b41a06c5285c94$var$NO_MESSAGES
            });
        } catch (error) {
            // @ts-ignore
            (0, $fECJU.logException)(error, 'Error loading translations.', {
                locale: locale
            });
            // show english on error
            this.setState({
                locale: (0, $1Zw99.DEFAULT_LOCALE),
                messages: $13b41a06c5285c94$var$NO_MESSAGES
            });
        }
    }
    render() {
        const { skip: skip } = this.props;
        // TODO: [PTC-4968] Long term 'skip' prop to be removed in favour being skipped by
        //       default and `embeddable-directory` to rely on parent product i18n provider.
        //       The idea is to merge package i18n files into product ones, and ship that
        //       one global product i18n translation rather than packages fetching their own.
        if (skip) return this.props.children;
        const { locale: locale, messages: messages } = this.state;
        // Idea for improvement we should not block rendering UI while fetching messages
        // https://product-fabric.atlassian.net/browse/PTC-2176
        if (!messages) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
            key: `intl-provider-5-${locale}`,
            "data-test-language": locale,
            locale: locale,
            defaultLocale: (0, $1Zw99.DEFAULT_LOCALE),
            messages: messages
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            locale: (0, $1Zw99.DEFAULT_LOCALE),
            messages: undefined
        };
    }
}

});
parcelRegister("1Zw99", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $a97407a716811b1a$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "getEffectiveLocale", () => $a97407a716811b1a$export$5211f28df9ef284a);
$parcel$export(module.exports, "loadIntlData", () => $a97407a716811b1a$export$d225990554fb28f7);

var $9qyRi = parcelRequire("9qyRi");

var $1Zvbf = parcelRequire("1Zvbf");

var $6GHn9 = parcelRequire("6GHn9");
const $a97407a716811b1a$export$1af4c7e47ad72f44 = 'en';
const $a97407a716811b1a$export$b6a046f0eef1bb2 = [
    'cs',
    'cs-CZ',
    'da',
    'da-DK',
    'de',
    'de-DE',
    'en-GB',
    'es',
    'es-ES',
    'et',
    'et-EE',
    'fi',
    'fi-FI',
    'fr',
    'fr-FR',
    'hu',
    'hu-HU',
    'is',
    'is-IS',
    'it',
    'it-IT',
    'ja',
    'ja-JP',
    'ko',
    'ko-KR',
    'nb',
    'nb-NO',
    'nl',
    'nl-NL',
    'pl',
    'pl-PL',
    'pt',
    'pt-BR',
    'pt-PT',
    'ro',
    'ro-RO',
    'ru',
    'ru-RU',
    'sk',
    'sk-SK',
    'sv',
    'sv-SE',
    'tr',
    'tr-TR',
    'th',
    'th-TH',
    'uk',
    'uk-UA',
    'vi',
    'vi-VN',
    'zh',
    'zh-TW',
    'zh-HK',
    'zh-ZH',
    'zh-CN'
];
// In URL, a tester can pass lang code or locale into URL, e.g `?locale=fr` or `?locale=cs-CZ`
const $a97407a716811b1a$var$getLocaleFromUrl = ()=>{
    const { locale: locale } = (0, (/*@__PURE__*/$parcel$interopDefault($9qyRi))).parse((0, (/*@__PURE__*/$parcel$interopDefault($1Zvbf))).location.search);
    const localeFromUrl = Array.isArray(locale) ? locale[0] : locale;
    return localeFromUrl;
};
function $a97407a716811b1a$var$getSupportedLocale(locale) {
    if (typeof locale !== 'string') return null;
    locale = locale.replace('_', '-');
    if ($a97407a716811b1a$export$b6a046f0eef1bb2.includes(locale)) return locale;
    // If we don't have the exact locale available, attempt to match just the language
    const languageCode = locale.substring(0, 2);
    if ($a97407a716811b1a$export$b6a046f0eef1bb2.includes(languageCode)) return languageCode;
}
const $a97407a716811b1a$export$5211f28df9ef284a = async (predefinedLocale)=>{
    // locale that we can manually pass to intl provider
    const receivedLocale = $a97407a716811b1a$var$getSupportedLocale(predefinedLocale);
    if (receivedLocale) return receivedLocale;
    // locale that we can pass to intl provider via `locale` GET param
    const localeInUrl = $a97407a716811b1a$var$getSupportedLocale($a97407a716811b1a$var$getLocaleFromUrl());
    if (localeInUrl) return localeInUrl;
    let userLocale;
    try {
        userLocale = (await (0, $6GHn9.userInfoProvider).get()).locale;
    } catch (e) {
        userLocale = $a97407a716811b1a$export$1af4c7e47ad72f44;
    }
    return $a97407a716811b1a$var$getSupportedLocale(userLocale) || $a97407a716811b1a$export$1af4c7e47ad72f44;
};
const $a97407a716811b1a$export$d225990554fb28f7 = (localesConfig, locale)=>{
    const pickedConfig = localesConfig.find((config)=>config.locales.includes(locale));
    const loader = pickedConfig?.loader;
    if (!loader) return Promise.resolve(null);
    return new Promise((resolve, reject)=>{
        // Fails if we haven't loaded/resolved after 30 seconds
        const rejectTimer = setTimeout(reject, 30000);
        loader().then((res)=>{
            clearTimeout(rejectTimer);
            // depending on a builder and config used in a project the result of dynamic imports could be behind `default`
            // this way we'll cover both cases
            resolve(res && res.default || res);
        });
    });
};

});
parcelRegister("9qyRi", function(module, exports) {

$parcel$export(module.exports, "extract", () => $6dd194fbfa826ed8$export$f9380c9a627682d3, (v) => $6dd194fbfa826ed8$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $6dd194fbfa826ed8$export$98e6a39c04603d36, (v) => $6dd194fbfa826ed8$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $6dd194fbfa826ed8$export$fac44ee5b035f737, (v) => $6dd194fbfa826ed8$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $6dd194fbfa826ed8$export$7a5253c0f62e0150, (v) => $6dd194fbfa826ed8$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $6dd194fbfa826ed8$export$a8c1621ea79325d3, (v) => $6dd194fbfa826ed8$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $6dd194fbfa826ed8$export$357523c63a2253b9, (v) => $6dd194fbfa826ed8$export$357523c63a2253b9 = v);
$parcel$export(module.exports, "exclude", () => $6dd194fbfa826ed8$export$44c361b8ec72ef7f, (v) => $6dd194fbfa826ed8$export$44c361b8ec72ef7f = v);
var $6dd194fbfa826ed8$export$f9380c9a627682d3;
var $6dd194fbfa826ed8$export$98e6a39c04603d36;
var $6dd194fbfa826ed8$export$fac44ee5b035f737;
var $6dd194fbfa826ed8$export$7a5253c0f62e0150;
var $6dd194fbfa826ed8$export$a8c1621ea79325d3;
var $6dd194fbfa826ed8$export$357523c63a2253b9;
var $6dd194fbfa826ed8$export$44c361b8ec72ef7f;
'use strict';

var $hXDaG = parcelRequire("hXDaG");

var $bJEvY = parcelRequire("bJEvY");

var $9CHQr = parcelRequire("9CHQr");

var $aARfw = parcelRequire("aARfw");
const $6dd194fbfa826ed8$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $6dd194fbfa826ed8$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $6dd194fbfa826ed8$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $6dd194fbfa826ed8$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $6dd194fbfa826ed8$var$encode(key, options),
                            '[',
                            $6dd194fbfa826ed8$var$encode(index, options),
                            ']=',
                            $6dd194fbfa826ed8$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $6dd194fbfa826ed8$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $6dd194fbfa826ed8$var$encode(key, options),
                            '[]=',
                            $6dd194fbfa826ed8$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $6dd194fbfa826ed8$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $6dd194fbfa826ed8$var$encode(key, options),
                            ':list=',
                            $6dd194fbfa826ed8$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $6dd194fbfa826ed8$var$encode(key, options),
                                keyValueSep,
                                $6dd194fbfa826ed8$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $6dd194fbfa826ed8$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $6dd194fbfa826ed8$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $6dd194fbfa826ed8$var$encode(key, options),
                            '=',
                            $6dd194fbfa826ed8$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $6dd194fbfa826ed8$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $6dd194fbfa826ed8$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $6dd194fbfa826ed8$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$6dd194fbfa826ed8$var$decode(item, options)) : value === null ? value : $6dd194fbfa826ed8$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $6dd194fbfa826ed8$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$6dd194fbfa826ed8$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $6dd194fbfa826ed8$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $6dd194fbfa826ed8$var$encode(value, options) {
    if (options.encode) return options.strict ? $hXDaG(value) : encodeURIComponent(value);
    return value;
}
function $6dd194fbfa826ed8$var$decode(value, options) {
    if (options.decode) return $bJEvY(value);
    return value;
}
function $6dd194fbfa826ed8$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $6dd194fbfa826ed8$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $6dd194fbfa826ed8$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $6dd194fbfa826ed8$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $6dd194fbfa826ed8$var$extract(input) {
    input = $6dd194fbfa826ed8$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $6dd194fbfa826ed8$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $6dd194fbfa826ed8$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $6dd194fbfa826ed8$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $6dd194fbfa826ed8$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $9CHQr(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $6dd194fbfa826ed8$var$decode(value, options);
        formatter($6dd194fbfa826ed8$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $6dd194fbfa826ed8$var$parseValue(value[k], options);
        else ret[key] = $6dd194fbfa826ed8$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $6dd194fbfa826ed8$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$6dd194fbfa826ed8$export$f9380c9a627682d3 = $6dd194fbfa826ed8$var$extract;
$6dd194fbfa826ed8$export$98e6a39c04603d36 = $6dd194fbfa826ed8$var$parse;
$6dd194fbfa826ed8$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $6dd194fbfa826ed8$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $6dd194fbfa826ed8$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $6dd194fbfa826ed8$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $6dd194fbfa826ed8$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $6dd194fbfa826ed8$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $6dd194fbfa826ed8$var$encode(key, options) + '=' + $6dd194fbfa826ed8$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$6dd194fbfa826ed8$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $9CHQr(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $6dd194fbfa826ed8$var$parse($6dd194fbfa826ed8$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $6dd194fbfa826ed8$var$decode(hash, options)
    } : {});
};
$6dd194fbfa826ed8$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$6dd194fbfa826ed8$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $6dd194fbfa826ed8$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $6dd194fbfa826ed8$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $6dd194fbfa826ed8$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $6dd194fbfa826ed8$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $6dd194fbfa826ed8$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$6dd194fbfa826ed8$var$encodeFragmentIdentifier] ? $6dd194fbfa826ed8$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$6dd194fbfa826ed8$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$6dd194fbfa826ed8$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $6dd194fbfa826ed8$export$7a5253c0f62e0150(input, options);
    return $6dd194fbfa826ed8$export$a8c1621ea79325d3({
        url: url,
        query: $aARfw(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$6dd194fbfa826ed8$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $6dd194fbfa826ed8$export$357523c63a2253b9(input, exclusionFilter, options);
};

});

parcelRegister("6GHn9", function(module, exports) {

$parcel$export(module.exports, "userInfoProvider", () => $e61adc51fb035db3$export$30a852ca4cb27370);

var $avLBj = parcelRequire("avLBj");
// Needs to be declared here to avoid blowing up this earlyInit bundle
class $e61adc51fb035db3$var$FetchError extends Error {
    constructor(response){
        super(`Request failed with status ${response.status}`);
        this.response = response;
        this.name = this.constructor.name;
    }
}
class $e61adc51fb035db3$export$dc10e400a1189789 {
    get(fetchOp = fetch) {
        if (this.promise) return this.promise;
        const getJson = (url)=>fetchOp(url, {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response)=>{
                if (!response.ok) throw new $e61adc51fb035db3$var$FetchError(response);
                return response.json();
            });
        this.promise = getJson(`${(0, $avLBj.getConfig)().stargateRoot}/me`).then((me)=>{
            return {
                userId: me.account_id,
                locale: me.locale,
                fullName: me.name,
                avatarUrl: me.picture,
                email: me.email,
                title: me.extended_profile?.job_title
            };
        });
        return this.promise;
    }
}
const $e61adc51fb035db3$export$30a852ca4cb27370 = new $e61adc51fb035db3$export$dc10e400a1189789();

});



parcelRegister("g6xgY", function(module, exports) {

$parcel$export(module.exports, "statusCodeHandlersProvider", () => $b389f1e4009c9291$export$8c005e458e12d501);
$parcel$export(module.exports, "handleResponse", () => $b389f1e4009c9291$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $b389f1e4009c9291$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $b389f1e4009c9291$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $b389f1e4009c9291$export$8c005e458e12d501.handlers = handlers;
    }
};
function $b389f1e4009c9291$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $b389f1e4009c9291$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});

parcelRegister("cWYE1", function(module, exports) {

$parcel$export(module.exports, "useOrg", () => $56a182d0938d5096$export$7f785727a26e156);

var $WBLbN = parcelRequire("WBLbN");

var $huuRB = parcelRequire("huuRB");
const $56a182d0938d5096$export$7f785727a26e156 = (0, $WBLbN.createHook)((0, $huuRB.Store));

});
parcelRegister("huuRB", function(module, exports) {

$parcel$export(module.exports, "Store", () => $702cfadf35231ae4$export$390f32400eaf98c9);

var $WBLbN = parcelRequire("WBLbN");
const $702cfadf35231ae4$var$actions = {
    setOrgId: (orgId)=>({ setState: setState })=>{
            setState({
                orgId: orgId
            });
        }
};
const $702cfadf35231ae4$var$initialState = {
    orgId: undefined
};
const $702cfadf35231ae4$export$390f32400eaf98c9 = (0, $WBLbN.createStore)({
    initialState: $702cfadf35231ae4$var$initialState,
    actions: $702cfadf35231ae4$var$actions,
    name: 'Org'
});

});


parcelRegister("6XUHL", function(module, exports) {

$parcel$export(module.exports, "useSite", () => $597a5e5609a64ad3$export$7870fa8e7cdd59f8);

var $WBLbN = parcelRequire("WBLbN");

var $huxiY = parcelRequire("huxiY");
const $597a5e5609a64ad3$export$7870fa8e7cdd59f8 = (0, $WBLbN.createHook)((0, $huxiY.Store));
const $597a5e5609a64ad3$export$9da0f7c65f28ed16 = ()=>$597a5e5609a64ad3$export$7870fa8e7cdd59f8()[0].cloudId;

});
parcelRegister("huxiY", function(module, exports) {

$parcel$export(module.exports, "Store", () => $62a61f0c605d4bb7$export$390f32400eaf98c9);

var $WBLbN = parcelRequire("WBLbN");
const $62a61f0c605d4bb7$var$actions = {
    // This action is used by EmbeddedDirectory to get Cloud Id in a remote store.
    setCloudId: (cloudId)=>({ setState: setState })=>{
            setState({
                cloudId: cloudId
            });
        }
};
const $62a61f0c605d4bb7$var$initialState = {
    cloudId: ''
};
const $62a61f0c605d4bb7$export$390f32400eaf98c9 = (0, $WBLbN.createStore)({
    initialState: $62a61f0c605d4bb7$var$initialState,
    actions: $62a61f0c605d4bb7$var$actions,
    name: 'Site'
});

});


parcelRegister("5bjdJ", function(module, exports) {

$parcel$export(module.exports, "useTeamCentralStore", () => $b12059845066d221$export$39314e672c06693f);
$parcel$export(module.exports, "useTeamCentralStoreApi", () => $b12059845066d221$export$7c58a39ba496932b);
$parcel$export(module.exports, "useIsTeamCentral", () => $b12059845066d221$export$9da989c55553d02d);
$parcel$export(module.exports, "useTeamCentralPresent", () => $b12059845066d221$export$20f07b26e9a56b9);

var $WBLbN = parcelRequire("WBLbN");

var $4QbXv = parcelRequire("4QbXv");
const $b12059845066d221$var$initialState = {
    isTeamCentral: false,
    hasWorkspace: false,
    orgHasWorkspace: false,
    teamCentralHandlers: {}
};
const $b12059845066d221$var$actions = {
    initTeamCentral: (appName, cloudId, teamCentralHandlers = {})=>({ setState: setState })=>{
            const isTeamCentral = appName === 'teamcentral-directory';
            if (isTeamCentral) // Assume site already has a TC workspace if directory is running in TC mode
            setState({
                isTeamCentral: isTeamCentral,
                hasWorkspace: true,
                orgHasWorkspace: true,
                teamCentralHandlers: teamCentralHandlers
            });
            else {
                // Otherwise, fetch for workspace information
                const requests = [
                    (0, $4QbXv.default).hasWorkspaceForCloudId(cloudId),
                    (0, $4QbXv.default).doesOrgContainAnyWorkspace(cloudId)
                ];
                Promise.all(requests).then(([hasWorkspace, orgHasWorkspace])=>{
                    setState({
                        isTeamCentral: false,
                        hasWorkspace: hasWorkspace,
                        orgHasWorkspace: orgHasWorkspace,
                        teamCentralHandlers: teamCentralHandlers
                    });
                });
            }
        }
};
/**
 * Manage states of searching People and Teams in search home page.
 */ const $b12059845066d221$var$Store = (0, $WBLbN.createStore)({
    initialState: $b12059845066d221$var$initialState,
    actions: $b12059845066d221$var$actions,
    name: 'SearchHomePage'
});
const $b12059845066d221$export$39314e672c06693f = (0, $WBLbN.createHook)($b12059845066d221$var$Store);
const $b12059845066d221$export$7c58a39ba496932b = (0, $WBLbN.createHook)($b12059845066d221$var$Store, {
    selector: null
});
const $b12059845066d221$export$9da989c55553d02d = (0, $WBLbN.createHook)($b12059845066d221$var$Store, {
    selector: (s)=>s.isTeamCentral
});
const $b12059845066d221$export$20f07b26e9a56b9 = (0, $WBLbN.createHook)($b12059845066d221$var$Store, {
    selector: (s)=>s.isTeamCentral || s.hasWorkspace || s.orgHasWorkspace
});

});
parcelRegister("4QbXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $914340ae6ba5af49$export$2e2bcd8739ae039);

var $8tM2T = parcelRequire("8tM2T");

var $avLBj = parcelRequire("avLBj");

var $7YRKk = parcelRequire("7YRKk");
class $914340ae6ba5af49$export$424050aeba67e883 extends (0, $7YRKk.default) {
    constructor(){
        super({
            serviceUrl: (0, $avLBj.getConfig)().stargateRoot
        });
    }
    async hasWorkspaceForCloudId(cloudId) {
        const maybeShardedPrefix = this.buildMaybeShardedPrefix(cloudId);
        try {
            await this.getResource(`${maybeShardedPrefix}/workspace/exists?cloudId=${cloudId}`);
            return true;
        } catch (err) {
            return false;
        }
    }
    async doesOrgContainAnyWorkspace(cloudId) {
        const maybeShardedPrefix = this.buildMaybeShardedPrefix(cloudId);
        try {
            await this.getResource(`${maybeShardedPrefix}/organization/containsAnyWorkspace?cloudId=${cloudId}`);
            return true;
        } catch (err) {
            return false;
        }
    }
    buildMaybeShardedPrefix(cloudId) {
        if ((0, $8tM2T.default).initializeCompleted() && (0, $8tM2T.default).checkGate('enable_ptc_sharded_townsquare_calls')) return `/townsquare/s/${cloudId}`;
        else return '/watermelon';
    }
}
var /**
 * REST Client to make calls to resources on the team central service.
 *
 * Note: You probably don't want to use this directly. Use the centralised store instead where these values
 * have already been fetched. See useTeamCentralStore().
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$914340ae6ba5af49$export$2e2bcd8739ae039 = new $914340ae6ba5af49$export$424050aeba67e883();

});
parcelRegister("7YRKk", function(module, exports) {

$parcel$export(module.exports, "default", () => $24f1f619e88e4d0d$export$2e2bcd8739ae039);

var $2vzCR = parcelRequire("2vzCR");

var $6l6Xk = parcelRequire("6l6Xk");

var $bIP89 = parcelRequire("bIP89");

var $5s2sH = parcelRequire("5s2sH");

var $3W7Kz = parcelRequire("3W7Kz");

var $lhBhN = parcelRequire("lhBhN");

var $g6xgY = parcelRequire("g6xgY");
const $24f1f619e88e4d0d$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
const $24f1f619e88e4d0d$var$fetchWithExponentialBackoff = (0, $lhBhN.withDefaultExponentialBackoff)(fetch);
// tslint:disable-next-line no-any
function $24f1f619e88e4d0d$var$parseResponse(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}
async function $24f1f619e88e4d0d$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || (0, $3W7Kz.DirectoryErrorCode).MISSING_ERROR_MESSAGE);
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}
let $24f1f619e88e4d0d$var$incrementRedirectCount;
let $24f1f619e88e4d0d$var$clearRedirectCount;
$24f1f619e88e4d0d$export$7a0fc52d8c359feb();
function $24f1f619e88e4d0d$export$7a0fc52d8c359feb() {
    $24f1f619e88e4d0d$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>(0, $5s2sH.setCookie)((0, $5s2sH.REDIRECT_COUNT), (0, $5s2sH.getCookieAsInteger)((0, $5s2sH.REDIRECT_COUNT)) + 1));
    $24f1f619e88e4d0d$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>(0, $5s2sH.clearCookie)((0, $5s2sH.REDIRECT_COUNT)));
}
class $24f1f619e88e4d0d$var$RestClient {
    constructor({ serviceUrl: serviceUrl = '' } = {}){
        /**
	 * This function is necessary for if `statusCodeHandler` prescribes a login
	 * redirect upon a 401 response.
	 * While the default redirect behaviour may be overriden, this function has
	 * been kept separate to ensure it cannot be overriden, lest a host
	 * application supply embeddable-directory with a custom handler that suffers
	 * the infinite redirect bug.
	 */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $24f1f619e88e4d0d$var$incrementRedirectCount();
            } else $24f1f619e88e4d0d$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
    async getResource(path) {
        return this.makeRequest(path);
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
			 * PATCH must be uppercase as per fetch spec only
			 * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
			 * are normalised to uppercase.
			 *
			 * https://github.com/github/fetch/issues/37
			 * https://fetch.spec.whatwg.org/#methods
			 */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {}) {
        const url = this.serviceUrl + path;
        const options = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, $24f1f619e88e4d0d$var$defaultFetchOptions, additionalFetchOptions);
        const response = await $24f1f619e88e4d0d$var$fetchWithExponentialBackoff(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $g6xgY.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $bIP89.SentryIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await $24f1f619e88e4d0d$export$91c32f1b22d29b2d(response);
                throw new (0, $bIP89.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined
                });
            }
        }
        return additionalFetchOptions.ignoreResponse ? null : $24f1f619e88e4d0d$var$parseResponse(response);
    }
}
var $24f1f619e88e4d0d$export$2e2bcd8739ae039 = $24f1f619e88e4d0d$var$RestClient;

});
parcelRegister("bIP89", function(module, exports) {

$parcel$export(module.exports, "SentryIgnoreError", () => $0d8d304f06bbe3da$export$20de9a0e470e95aa);
$parcel$export(module.exports, "HttpError", () => $0d8d304f06bbe3da$export$65bd6083489bd8bb);
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $0d8d304f06bbe3da$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.stack = new Error(message).stack || '';
    }
}
class $0d8d304f06bbe3da$export$c73ca302efeda3b4 extends $0d8d304f06bbe3da$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $0d8d304f06bbe3da$export$c73ca302efeda3b4.prototype);
    }
}
class $0d8d304f06bbe3da$export$20de9a0e470e95aa extends $0d8d304f06bbe3da$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $0d8d304f06bbe3da$export$20de9a0e470e95aa.prototype);
    }
}
class $0d8d304f06bbe3da$export$65bd6083489bd8bb extends $0d8d304f06bbe3da$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId }){
        super(message);
        Object.setPrototypeOf(this, $0d8d304f06bbe3da$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
    }
}
class $0d8d304f06bbe3da$export$92d6ed0888e7cb7f extends $0d8d304f06bbe3da$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $0d8d304f06bbe3da$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $0d8d304f06bbe3da$export$92d6ed0888e7cb7f(errorData);
        };
    }
}

});

parcelRegister("5s2sH", function(module, exports) {

$parcel$export(module.exports, "REDIRECT_COUNT", () => $fdd1818a133899fa$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $fdd1818a133899fa$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $fdd1818a133899fa$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $fdd1818a133899fa$export$ad3506281d5a5e5d);
const $fdd1818a133899fa$export$f6101897f0230549 = 'redirectCount';
const $fdd1818a133899fa$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $fdd1818a133899fa$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $fdd1818a133899fa$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $fdd1818a133899fa$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});




parcelRegister("1wQUJ", function(module, exports) {

$parcel$export(module.exports, "useJiraCheckService", () => $0940e0779d722170$export$b998d6ed276aaffa);

var $eUqFw = parcelRequire("eUqFw");

var $9w676 = parcelRequire("9w676");

var $coKBF = parcelRequire("coKBF");
const $0940e0779d722170$export$3847702755d66eb8 = (cloudId, options)=>{
    const [request, controller] = (0, $eUqFw.useMemo)(()=>(0, $coKBF.defaultRequestAbort)(cloudId), [
        cloudId
    ]);
    const [getJiraCheck, result] = (0, $9w676.useLazyService)(request, controller, {
        initialState: {
            ...options?.initialState
        }
    });
    return [
        getJiraCheck,
        {
            ...result,
            isJiraAvailable: Boolean(result.data?.permitted)
        }
    ];
};
const $0940e0779d722170$export$b998d6ed276aaffa = (...[cloudId, options])=>{
    const [getJiraCheck, result] = $0940e0779d722170$export$3847702755d66eb8(cloudId, options);
    (0, $eUqFw.useEffect)(()=>{
        if (cloudId) getJiraCheck();
    }, [
        cloudId,
        getJiraCheck
    ]);
    return result;
};

});
parcelRegister("coKBF", function(module, exports) {

$parcel$export(module.exports, "defaultRequestAbort", () => $6a29c6a3e09196bb$export$46f584bffbc74fe);

var $boS14 = parcelRequire("boS14");
const $6a29c6a3e09196bb$export$5cf469f83bcf3f9e = '/gateway/api/permissions/permitted';
const $6a29c6a3e09196bb$export$fcd6a587480f569c = (cloudId)=>({
        permissionId: 'write',
        resourceId: `ari:cloud:jira-software::site/${cloudId}`
    });
const $6a29c6a3e09196bb$export$46f584bffbc74fe = (cloudId)=>cloudId ? (0, $boS14.requestWithAbort)($6a29c6a3e09196bb$export$5cf469f83bcf3f9e, {
        body: JSON.stringify($6a29c6a3e09196bb$export$fcd6a587480f569c(cloudId))
    }) : [
        ()=>Promise.resolve(new Response()),
        new AbortController()
    ];

});


parcelRegister("lnHnV", function(module, exports) {

$parcel$export(module.exports, "TeamsWrapper", () => $686fad245ce3537f$export$7d5cea3023a4360c);

var $eUqFw = parcelRequire("eUqFw");

var $4MkQ9 = parcelRequire("4MkQ9");

var $hbP2g = parcelRequire("hbP2g");

var $fcdA0 = parcelRequire("fcdA0");

var $aupWM = parcelRequire("aupWM");

var $jvxHp = parcelRequire("jvxHp");

var $nagX1 = parcelRequire("nagX1");
const $686fad245ce3537f$var$IS_LOCAL = false;
function $686fad245ce3537f$export$7d5cea3023a4360c({ children: children, appConfig: appConfig }) {
    (0, $fcdA0.useTeamsSentryClientSetup)(!$686fad245ce3537f$var$IS_LOCAL, {
        env: appConfig.env,
        appName: appConfig.appName ? `${appConfig.appName}` : undefined
    });
    (0, $aupWM.useSetAppConfig)(appConfig);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvxHp.AppConfigProvider), appConfig, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $nagX1.ProfileCardClientConfigProvider), appConfig, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4MkQ9.WrappedPeopleTeamsAnalyticsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hbP2g.DialogProvider), null, children))));
}

});
parcelRegister("4MkQ9", function(module, exports) {

$parcel$export(module.exports, "WrappedPeopleTeamsAnalyticsProvider", () => $e4002ee4296d3b4e$export$b73a44d03ba9da78);
$parcel$export(module.exports, "usePeopleTeamAnalyticsEvents", () => $e4002ee4296d3b4e$export$48acf7e27d4331f);
$parcel$export(module.exports, "useTeamsExperienceTracker", () => $e4002ee4296d3b4e$export$5792e6ebc464482e);

var $eUqFw = parcelRequire("eUqFw");

var $dcbVh = parcelRequire("dcbVh");

var $fcW8A = parcelRequire("fcW8A");

var $dIJIS = parcelRequire("dIJIS");

var $hoy9g = parcelRequire("hoy9g");

var $eibJo = parcelRequire("eibJo");
const $e4002ee4296d3b4e$var$defaultAnalyticsContextData = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $e4002ee4296d3b4e$export$b73a44d03ba9da78({ analyticsContextData: analyticsContextData, children: children }) {
    const data = (0, $eUqFw.useMemo)(()=>{
        if (typeof analyticsContextData === 'object') return {
            ...$e4002ee4296d3b4e$var$defaultAnalyticsContextData,
            ...analyticsContextData
        };
        return $e4002ee4296d3b4e$var$defaultAnalyticsContextData;
    }, [
        analyticsContextData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dcbVh.PeopleTeamsAnalyticsContext), {
        data: data
    }, children);
}
const $e4002ee4296d3b4e$export$48acf7e27d4331f = ()=>{
    const [{ eventAttributes: injectedEventAttributes }, { setEventAttributes: setEventAttributes }] = (0, $fcW8A.usePeopleTeamsAnalyticsSubcontext)();
    const { fireEvent: fireEvent } = (0, $hoy9g.useAnalyticsEvents)();
    const fireEventWithSubcontextAttributesInjected = (0, $eUqFw.useCallback)((...params)=>{
        const [event, attributes] = params;
        const eventWithSubcontextAttributes = {
            ...attributes,
            ...injectedEventAttributes
        };
        // @ts-ignore allow injecting subcontext attributes
        fireEvent(event, eventWithSubcontextAttributes);
    }, [
        fireEvent,
        injectedEventAttributes
    ]);
    return {
        fireEvent: fireEventWithSubcontextAttributesInjected,
        setInjectedEventAttributes: setEventAttributes
    };
};
const $e4002ee4296d3b4e$export$b72f2eb2a11f7b8 = ()=>(0, $eibJo.useAnalyticsEventsWithTags)();
const $e4002ee4296d3b4e$export$5792e6ebc464482e = ()=>{
    const { fireEvent: fireEvent } = $e4002ee4296d3b4e$export$48acf7e27d4331f();
    const fireExperienceEvent = (0, $eUqFw.useCallback)((action, subject, attributes)=>{
        // @ts-ignore TODO: we may need to declare the keys to a const in the types file so we can do a check here
        fireEvent(`operational.${subject.replace(/[\/-]/g, '_')}.${action}`, {
            ...attributes,
            source: 'clientMetrics'
        });
    }, [
        fireEvent
    ]);
    const experienceTracker = (0, $eUqFw.useMemo)(()=>(0, $dIJIS.createTeamsExperienceTracker)(fireExperienceEvent), [
        fireExperienceEvent
    ]);
    return experienceTracker;
};

});
parcelRegister("fcW8A", function(module, exports) {

$parcel$export(module.exports, "usePeopleTeamsAnalyticsSubcontext", () => $853557399d2da6aa$export$86448e866930ba8d);
$parcel$export(module.exports, "useInjectedEventAttribute", () => $853557399d2da6aa$export$831917a198e22e70);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");
const $853557399d2da6aa$var$initialState = {
    eventAttributes: {}
};
const $853557399d2da6aa$var$actions = {
    setEventAttributes: (eventAttributes)=>({ setState: setState, getState: getState })=>{
            const existingEventAttributes = getState().eventAttributes;
            const newEventAttributes = {
                ...existingEventAttributes,
                ...eventAttributes
            };
            Object.keys(newEventAttributes).forEach((keyString)=>{
                const key = keyString;
                if (newEventAttributes[key] === undefined) delete newEventAttributes[key];
            });
            setState({
                eventAttributes: newEventAttributes
            });
        }
};
const $853557399d2da6aa$var$AnalyticsSubcontextStore = (0, $WBLbN.createStore)({
    initialState: $853557399d2da6aa$var$initialState,
    actions: $853557399d2da6aa$var$actions
});
const $853557399d2da6aa$export$86448e866930ba8d = (0, $WBLbN.createHook)($853557399d2da6aa$var$AnalyticsSubcontextStore);
const $853557399d2da6aa$export$831917a198e22e70 = (key, value)=>{
    const { setEventAttributes: setEventAttributes } = $853557399d2da6aa$export$86448e866930ba8d()[1];
    (0, $eUqFw.useEffect)(()=>{
        setEventAttributes({
            [key]: value
        });
        return ()=>setEventAttributes({
                [key]: undefined
            });
    }, [
        key,
        value,
        setEventAttributes
    ]);
};

});

parcelRegister("dIJIS", function(module, exports) {

$parcel$export(module.exports, "createTeamsExperienceTracker", () => $bbae83430c0c67db$export$c0c885a04612b38d);

var $74BVL = parcelRequire("74BVL");

var $c4v9k = parcelRequire("c4v9k");

var $iDMVZ = parcelRequire("iDMVZ");
function $bbae83430c0c67db$export$c0c885a04612b38d(fireExperienceEvent, options) {
    const tracker = new (0, $c4v9k.TeamsExperienceTracker)({
        isNetworkOfflineError: (0, $iDMVZ.isNetworkError)
    });
    tracker.subscribe((event)=>{
        if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
            const performanceAttributes = (0, $iDMVZ.computePerformanceAttributes)(event);
            const errorAttributes = (0, $iDMVZ.computeErrorAttributes)(event);
            const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                // Because standalone app is deployed to prod quickly,
                // we will use this attribute to query in Splunk sooner.
                isStandalone: !!options?.isStandalone,
                hasBrowseUsersPermission: !!options?.hasBrowseUsersPermission
            });
            fireExperienceEvent(event.action, event.name, finalErrorDetails);
            if (event.action === 'taskFail' && options?.logErrorMessage) options.logErrorMessage(`taskFail:${event.name}`, finalErrorDetails);
        }
    });
    (0, $74BVL.bindAll)(window, [
        {
            type: 'unload',
            listener: ()=>tracker.abort({
                    reason: 'Abort due to Window unloading',
                    attributes: {
                        cause: 'WINDOW_UNLOAD'
                    }
                })
        },
        {
            type: 'pagehide',
            listener: ()=>{
                tracker.abort({
                    reason: 'Window unloading',
                    attributes: {
                        cause: 'PAGE_HIDE'
                    }
                });
            }
        }
    ]);
    return tracker;
}

});
parcelRegister("c4v9k", function(module, exports) {

$parcel$export(module.exports, "TeamsExperienceTracker", () => $422f184a6cf2157a$export$9e9a48cf2c297bd1);

var $hUYqC = parcelRequire("hUYqC");

var $dgmsd = parcelRequire("dgmsd");
class $422f184a6cf2157a$export$9e9a48cf2c297bd1 extends (0, $hUYqC.ExperienceTracker) {
    _errorNameInIgnoredList(error) {
        const name = error && error.constructor.name;
        return this._ignoredErrors.includes(name) ? name : undefined;
    }
    constructor(options){
        super(options);
        // error names here will also be sent in the attribute `cause`
        this._ignoredErrors = [
            'SentryIgnoreError'
        ];
    }
    stopOnError({ name: name, error: error }) {
        if ((0, $dgmsd.isAuthError)(error)) {
            this.abort({
                name: name,
                reason: 'Abort due to user unauthenticated',
                attributes: {
                    cause: 'USER_UNAUTHENTICATED',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        if ((0, $dgmsd.isErrorStatusCode)((0, $dgmsd.StatusCode).GONE, error)) {
            this.abort({
                name: name,
                reason: 'Abort due to unavailable resource',
                attributes: {
                    cause: 'GONE',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        const ignoredErrorName = this._errorNameInIgnoredList(error);
        if (ignoredErrorName) {
            this.abort({
                name: name,
                reason: 'Abort due to an error in ignore list',
                attributes: {
                    cause: ignoredErrorName
                },
                checkForTimeout: false
            });
            return;
        }
        super.stopOnError({
            name: name,
            error: error
        });
    }
}

});
parcelRegister("dgmsd", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $79950f660a5fd4ec$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $79950f660a5fd4ec$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $79950f660a5fd4ec$export$9677d7c364ada66c);
var $79950f660a5fd4ec$export$f66f92b8741acd5b;
(function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
})($79950f660a5fd4ec$export$f66f92b8741acd5b || ($79950f660a5fd4ec$export$f66f92b8741acd5b = {}));
function $79950f660a5fd4ec$export$cde1786a482f9a1c(error) {
    return $79950f660a5fd4ec$export$9677d7c364ada66c(401, error) || $79950f660a5fd4ec$export$9677d7c364ada66c(403, error);
}
function $79950f660a5fd4ec$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}

});


parcelRegister("iDMVZ", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $62eac4a9fff37424$export$476aa014e2fd89d5);
$parcel$export(module.exports, "computeErrorAttributes", () => $62eac4a9fff37424$export$5e7501d1cb9a5aa0);
$parcel$export(module.exports, "computePerformanceAttributes", () => $62eac4a9fff37424$export$b978343735080139);

var $leHv2 = parcelRequire("leHv2");
function $62eac4a9fff37424$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}
function $62eac4a9fff37424$export$5e7501d1cb9a5aa0(event) {
    const attributes = {};
    if ($62eac4a9fff37424$var$isFailEvent(event)) attributes.failError = event.error;
    if ($62eac4a9fff37424$var$isAbortEvent(event)) attributes.abortReason = event.reason;
    return attributes;
}
function $62eac4a9fff37424$export$b978343735080139(event) {
    if ($62eac4a9fff37424$var$isStopEvent(event)) {
        const duration = event.duration;
        const latencySlo = event.attributes && $62eac4a9fff37424$var$hasLatencySLO(event.attributes) && event.attributes['latencySlo'];
        if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
        return {
            sloSatisfied: duration <= latencySlo,
            taskDuration: duration,
            latencySlo: latencySlo
        };
    }
    return {};
}
function $62eac4a9fff37424$var$isStopEvent(e) {
    return (0, $leHv2.isStop)(e);
}
function $62eac4a9fff37424$var$isFailEvent(e) {
    return e.action === 'taskFail';
}
function $62eac4a9fff37424$var$isAbortEvent(e) {
    return e.action === 'taskAbort';
}
function $62eac4a9fff37424$var$hasLatencySLO(attributes) {
    return Object(attributes).hasOwnProperty('latencySlo');
}

});
parcelRegister("leHv2", function(module, exports) {

$parcel$export(module.exports, "isStop", () => $eab71776b63487cc$export$16e3f1b03b231b35);
$parcel$export(module.exports, "hasName", () => $eab71776b63487cc$export$57069f5b2ecc9128);
const $eab71776b63487cc$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $eab71776b63487cc$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);

});



parcelRegister("hoy9g", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $302edda2643b42d1$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::e5658fd58feb1dc44871f04f2de92d8a>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $8Ng9u = parcelRequire("8Ng9u");

var $4oQpM = parcelRequire("4oQpM");
const $302edda2643b42d1$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireEvent = (0, $eUqFw.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $4oQpM.default)(...params));
        event.fire((0, $8Ng9u.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("8Ng9u", function(module, exports) {

$parcel$export(module.exports, "EVENT_CHANNEL", () => $da3f6a3574c672d1$export$3f072f06b90c3985);

var $88sYM = parcelRequire("88sYM");
const $da3f6a3574c672d1$export$3f072f06b90c3985 = (0, $88sYM.FabricChannel).peopleTeams;

});

parcelRegister("4oQpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8130caa2eeb8088f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::0d40b99453dc3bdb802ab78b4560ab56>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ const $8130caa2eeb8088f$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $8130caa2eeb8088f$export$2e2bcd8739ae039 = $8130caa2eeb8088f$var$createEventPayload;

});


parcelRegister("eibJo", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEventsWithTags", () => $f7bc74d7f38ff9e8$export$e8e0cef07f76dd91);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $8Ng9u = parcelRequire("8Ng9u");

var $4oQpM = parcelRequire("4oQpM");
const $f7bc74d7f38ff9e8$export$e8e0cef07f76dd91 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireEventWithTags = (0, $eUqFw.useCallback)((tags, ...params)=>{
        const event = createAnalyticsEvent((0, $4oQpM.default)(...params));
        if (event.payload) event.payload.tags = tags;
        event.fire((0, $8Ng9u.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEventWithTags: fireEventWithTags
    };
};

});


parcelRegister("hbP2g", function(module, exports) {

$parcel$export(module.exports, "DialogProvider", () => $26363409c20a3039$export$7ab5cfe96fae86d3);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $4pz2s = parcelRequire("4pz2s");
const $26363409c20a3039$var$dialogProviderReducer = (state, action)=>{
    switch(action.type){
        case 'open':
            return {
                ...state,
                DialogComponent: action.payload?.DialogComponent || null,
                isOpen: true
            };
        case 'close':
            return {
                ...state,
                DialogComponent: null,
                dialogProps: null,
                isOpen: false
            };
        default:
            throw new Error(`Unhandled type for dialogReducer: ${action.type}`);
    }
};
const $26363409c20a3039$export$b52337b35cd3c980 = (props)=>{
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose } = props;
    const { closeDialog: closeDialog } = (0, $eUqFw.useContext)((0, $4pz2s.DialogContext));
    if (!DialogComponent) return null;
    const handleCloseDialog = ()=>{
        closeDialog();
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(DialogComponent, {
        onClose: handleCloseDialog
    }));
};
const $26363409c20a3039$export$7ab5cfe96fae86d3 = ({ children: children })=>{
    const [dialogProviderState, dispatch] = (0, $eUqFw.useReducer)($26363409c20a3039$var$dialogProviderReducer, {
        DialogComponent: null,
        isOpen: false
    });
    const value = (0, $eUqFw.useMemo)(()=>({
            openDialog: (DialogComponent)=>dispatch({
                    type: 'open',
                    payload: {
                        DialogComponent: DialogComponent
                    }
                }),
            closeDialog: ()=>dispatch({
                    type: 'close'
                })
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4pz2s.DialogContext).Provider, {
        value: value
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26363409c20a3039$export$b52337b35cd3c980, dialogProviderState));
};

});
parcelRegister("4pz2s", function(module, exports) {

$parcel$export(module.exports, "DialogContext", () => $50c7b3c04fb05296$export$8b93a07348a7730c);

var $eUqFw = parcelRequire("eUqFw");
const $50c7b3c04fb05296$export$8b93a07348a7730c = (0, $eUqFw.createContext)({
    openDialog: ()=>null,
    closeDialog: ()=>null
});

});


parcelRegister("aupWM", function(module, exports) {

$parcel$export(module.exports, "useSetAppConfig", () => $66b8a5d544869c17$export$338e93cfada2e9d7);

var $1DnXE = parcelRequire("1DnXE");

var $8YnxP = parcelRequire("8YnxP");

var $fvJih = parcelRequire("fvJih");
const $66b8a5d544869c17$export$338e93cfada2e9d7 = (appConfig)=>{
    (0, $1DnXE.useSetClientConfig)({
        cloudId: appConfig.cloudId,
        stargateRoot: appConfig.stargateRoot,
        env: appConfig.env,
        orgId: appConfig.orgId,
        principalUserId: appConfig.principalUserId
    });
    (0, $fvJih.useSetTeamsProductConfig)({
        appName: appConfig.appName,
        productName: appConfig.productName,
        isJiraAvailable: appConfig.isJiraAvailable,
        subProduct: appConfig.subProduct,
        locale: appConfig.locale,
        productFeatureFlags: appConfig.productFeatureFlags
    });
    (0, $8YnxP.useSetTeamsNavigationConfig)({
        contextSpaPaths: appConfig.contextSpaPaths,
        contextEntryPoint: appConfig.contextEntryPoint
    });
};

});
parcelRegister("1DnXE", function(module, exports) {

$parcel$export(module.exports, "useSetClientConfig", () => $77c55830228dffdc$export$2f68760d90a1443f);

var $eUqFw = parcelRequire("eUqFw");

var $2M4K2 = parcelRequire("2M4K2");

var $7QGbN = parcelRequire("7QGbN");
const $77c55830228dffdc$export$2f68760d90a1443f = (clientConfig)=>{
    const { setClientConfig: setClientConfig } = (0, $7QGbN.useSetTeamsConfigActions)();
    (0, $2M4K2.useTeamsClientSetup)(clientConfig.stargateRoot, clientConfig.cloudId, clientConfig.orgId);
    (0, $eUqFw.useEffect)(()=>{
        setClientConfig(clientConfig);
    }, [
        setClientConfig,
        clientConfig
    ]);
};

});
parcelRegister("2M4K2", function(module, exports) {

$parcel$export(module.exports, "useTeamsClientSetup", () => $bdff1aa08c1d4521$export$50a3d4f5c944b117);

var $eUqFw = parcelRequire("eUqFw");

var $cAxhS = parcelRequire("cAxhS");

var $jnlyS = parcelRequire("jnlyS");
const $bdff1aa08c1d4521$export$50a3d4f5c944b117 = (stargateRoot, cloudId, orgId)=>{
    (0, $eUqFw.useEffect)(()=>{
        if (!stargateRoot) return;
        (0, $cAxhS.teamsClient).setBaseUrl(stargateRoot);
    }, [
        stargateRoot
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cAxhS.teamsClient).setContext({
            cloudId: cloudId,
            orgId: orgId
        });
        if (!orgId) (0, $jnlyS.logErrorMessage)(`No orgId set - useTeamsClientSetup`, {
            cloudId: cloudId
        });
    }, [
        cloudId,
        orgId
    ]);
};

});

parcelRegister("7QGbN", function(module, exports) {

$parcel$export(module.exports, "useAppConfigStoreState", () => $5cc85e4b54ee5ac2$export$ace1f350f4f044c0);
$parcel$export(module.exports, "useSetTeamsConfigActions", () => $5cc85e4b54ee5ac2$export$b652cf4936246835);
$parcel$export(module.exports, "useNavigationState", () => $5cc85e4b54ee5ac2$export$e482f4662aebc4a0);

var $WBLbN = parcelRequire("WBLbN");
const $5cc85e4b54ee5ac2$var$defaultNavigationState = {
    contextSpaPaths: [],
    contextEntryPoint: null
};
const $5cc85e4b54ee5ac2$var$defaultClientConfigState = {
    cloudId: null,
    stargateRoot: '',
    env: undefined
};
const $5cc85e4b54ee5ac2$var$defaultTeamsProductConfigState = {
    appName: null,
    productName: null,
    isJiraAvailable: false
};
const $5cc85e4b54ee5ac2$var$defaultState = {
    ...$5cc85e4b54ee5ac2$var$defaultNavigationState,
    ...$5cc85e4b54ee5ac2$var$defaultClientConfigState,
    ...$5cc85e4b54ee5ac2$var$defaultTeamsProductConfigState,
    docTitle: {}
};
const $5cc85e4b54ee5ac2$var$actions = {
    setNavigationConfig: (navigationConfig)=>({ setState: setState })=>{
            setState({
                ...navigationConfig
            });
        },
    setClientConfig: (clientConfig)=>({ setState: setState })=>{
            setState({
                ...clientConfig
            });
        },
    setTeamsProductConfig: (teamsProductConfig)=>({ setState: setState })=>{
            setState({
                ...teamsProductConfig
            });
        },
    // Set all config at once
    setAppConfig: (appConfig)=>({ setState: setState })=>{
            setState({
                ...appConfig
            });
        }
};
const $5cc85e4b54ee5ac2$var$AppConfigStore = (0, $WBLbN.createStore)({
    initialState: $5cc85e4b54ee5ac2$var$defaultState,
    actions: $5cc85e4b54ee5ac2$var$actions
});
const $5cc85e4b54ee5ac2$export$61884cfbde7fd829 = (0, $WBLbN.createHook)($5cc85e4b54ee5ac2$var$AppConfigStore);
const $5cc85e4b54ee5ac2$var$useAppConfigActions = (0, $WBLbN.createHook)($5cc85e4b54ee5ac2$var$AppConfigStore, {
    selector: null
});
const $5cc85e4b54ee5ac2$export$ace1f350f4f044c0 = ()=>$5cc85e4b54ee5ac2$export$61884cfbde7fd829()[0];
const $5cc85e4b54ee5ac2$export$b652cf4936246835 = ()=>{
    return $5cc85e4b54ee5ac2$var$useAppConfigActions()[1];
};
const $5cc85e4b54ee5ac2$export$7b278989f04c1040 = ()=>$5cc85e4b54ee5ac2$export$ace1f350f4f044c0().appName;
const $5cc85e4b54ee5ac2$export$e482f4662aebc4a0 = ()=>{
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint } = $5cc85e4b54ee5ac2$export$ace1f350f4f044c0();
    return {
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint
    };
};

});


parcelRegister("8YnxP", function(module, exports) {

$parcel$export(module.exports, "useSetTeamsNavigationConfig", () => $eb0231108fd8c267$export$254030771a907fca);

var $eUqFw = parcelRequire("eUqFw");

var $7QGbN = parcelRequire("7QGbN");
const $eb0231108fd8c267$export$254030771a907fca = (config)=>{
    const { setNavigationConfig: setNavigationConfig } = (0, $7QGbN.useSetTeamsConfigActions)();
    (0, $eUqFw.useEffect)(()=>{
        setNavigationConfig(config);
    }, [
        setNavigationConfig,
        config
    ]);
};

});

parcelRegister("fvJih", function(module, exports) {

$parcel$export(module.exports, "useSetTeamsProductConfig", () => $cdd34fd473eebb6d$export$f8296902b02e4ba1);

var $eUqFw = parcelRequire("eUqFw");

var $7QGbN = parcelRequire("7QGbN");
const $cdd34fd473eebb6d$export$f8296902b02e4ba1 = (teamsProductConfig)=>{
    const { setTeamsProductConfig: setTeamsProductConfig } = (0, $7QGbN.useSetTeamsConfigActions)();
    (0, $eUqFw.useEffect)(()=>{
        setTeamsProductConfig(teamsProductConfig);
    }, [
        setTeamsProductConfig,
        teamsProductConfig
    ]);
};

});


parcelRegister("jvxHp", function(module, exports) {

$parcel$export(module.exports, "AppConfigProvider", () => $aa3d7b0453d67589$export$42f491f31057ae78);
$parcel$export(module.exports, "useNavigationActions", () => $aa3d7b0453d67589$export$d52b0df9de5d0e40);
$parcel$export(module.exports, "useAddFlag", () => $aa3d7b0453d67589$export$6d75236f0e3dc17e);

var $eUqFw = parcelRequire("eUqFw");

var $369AT = parcelRequire("369AT");

var $3mCjh = parcelRequire("3mCjh");

var $7QGbN = parcelRequire("7QGbN");
const $aa3d7b0453d67589$var$error = new Error('AppConfig is not setup in RSS');
const $aa3d7b0453d67589$var$defaultValue = {
    push: ()=>{
        throw $aa3d7b0453d67589$var$error;
    },
    replace: ()=>{
        throw $aa3d7b0453d67589$var$error;
    },
    addFlag: ()=>{
        throw $aa3d7b0453d67589$var$error;
    }
};
const $aa3d7b0453d67589$var$AppConfigContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($aa3d7b0453d67589$var$defaultValue);
function $aa3d7b0453d67589$export$42f491f31057ae78({ children: children, push: pushProp, replace: replaceProp, addFlag: addFlagProp }) {
    const { contextEntryPoint: contextEntryPoint } = (0, $7QGbN.useNavigationState)();
    const addFlag = (0, $eUqFw.useCallback)((props)=>{
        const { type: type, ...rest } = props;
        addFlagProp({
            ...rest,
            id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
            type: type,
            appearance: 'normal',
            icon: (0, $369AT.getTypeIcon)(type)
        });
    }, [
        addFlagProp
    ]);
    const push = (0, $eUqFw.useCallback)((path)=>{
        const finalPath = (0, $3mCjh.prefixWithContextEntryPoint)(path, contextEntryPoint);
        return pushProp(finalPath);
    }, [
        pushProp,
        contextEntryPoint
    ]);
    const replace = (0, $eUqFw.useCallback)((path)=>{
        const finalPath = (0, $3mCjh.prefixWithContextEntryPoint)(path, contextEntryPoint);
        return replaceProp(finalPath);
    }, [
        contextEntryPoint,
        replaceProp
    ]);
    const configValue = (0, $eUqFw.useMemo)(()=>({
            addFlag: addFlag,
            push: push,
            replace: replace
        }), [
        addFlag,
        push,
        replace
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa3d7b0453d67589$var$AppConfigContext.Provider, {
        value: configValue
    }, children);
}
const $aa3d7b0453d67589$var$useAppConfigProvider = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($aa3d7b0453d67589$var$AppConfigContext);
const $aa3d7b0453d67589$export$d52b0df9de5d0e40 = ()=>{
    const { push: push, replace: replace } = $aa3d7b0453d67589$var$useAppConfigProvider();
    return {
        push: push,
        replace: replace
    };
};
const $aa3d7b0453d67589$export$6d75236f0e3dc17e = ()=>{
    const { addFlag: addFlag } = $aa3d7b0453d67589$var$useAppConfigProvider();
    return addFlag;
};

});
parcelRegister("369AT", function(module, exports) {

$parcel$export(module.exports, "getTypeIcon", () => $acd49c5dcdacb2d3$export$672f92b0d52b7cfe);

var $eUqFw = parcelRequire("eUqFw");

var $gw74N = parcelRequire("gw74N");

var $iqFZO = parcelRequire("iqFZO");

var $1Qu2i = parcelRequire("1Qu2i");

const $acd49c5dcdacb2d3$var$flagIconByType = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gw74N))), {
        spacing: "spacious",
        label: "",
        color: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Qu2i))), {
        spacing: "spacious",
        label: "",
        color: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`
    })
};
const $acd49c5dcdacb2d3$var$DefaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iqFZO))), {
    spacing: "spacious",
    label: "",
    color: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`
});
const $acd49c5dcdacb2d3$export$672f92b0d52b7cfe = (type = 'normal')=>$acd49c5dcdacb2d3$var$flagIconByType[type] || $acd49c5dcdacb2d3$var$DefaultIcon;

});
parcelRegister("iqFZO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::65b39b642792ddada4228d7fe706de02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6ab3b374a166728$var$_react = $d6ab3b374a166728$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d6ab3b374a166728$var$_success = $d6ab3b374a166728$var$_interopRequireDefault((parcelRequire("50qGm")));

var $d6ab3b374a166728$var$_checkCircle = $d6ab3b374a166728$var$_interopRequireDefault((parcelRequire("aWvIp")));
function $d6ab3b374a166728$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d6ab3b374a166728$var$SuccessIcon = (props)=>/*#__PURE__*/ $d6ab3b374a166728$var$_react.default.createElement($d6ab3b374a166728$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $d6ab3b374a166728$var$_checkCircle.default
    }, props));
$d6ab3b374a166728$var$SuccessIcon.Name = 'SuccessIconMigration';
var $d6ab3b374a166728$var$_default = module.exports.default = $d6ab3b374a166728$var$SuccessIcon;

});
parcelRegister("50qGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a280b44c69b6de4f4f93ebdb24542b07>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a51a662974016bc$var$_react = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a51a662974016bc$var$_UNSAFE_baseNew = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3a51a662974016bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a51a662974016bc$var$SuccessIcon = (props)=>/*#__PURE__*/ $3a51a662974016bc$var$_react.default.createElement($3a51a662974016bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$3a51a662974016bc$var$SuccessIcon.displayName = 'SuccessIcon';
var $3a51a662974016bc$var$_default = module.exports.default = $3a51a662974016bc$var$SuccessIcon;

});


var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';


parcelRegister("3mCjh", function(module, exports) {

$parcel$export(module.exports, "isAbsoluteLink", () => $c59df311e83496b4$export$895d6838d29edd02);
$parcel$export(module.exports, "prefixWithContextEntryPoint", () => $c59df311e83496b4$export$715c8f9057ac0c01);
$parcel$export(module.exports, "getRelativeUrl", () => $c59df311e83496b4$export$d614758658023fd);
$parcel$export(module.exports, "EXTERNAL_LINKS", () => $c59df311e83496b4$export$4cf71c31cd7fa836);

var $bAnhx = parcelRequire("bAnhx");

var $chxpa = parcelRequire("chxpa");
const $c59df311e83496b4$export$895d6838d29edd02 = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $c59df311e83496b4$export$715c8f9057ac0c01 = (path, contextEntryPoint = null)=>{
    if ($c59df311e83496b4$export$895d6838d29edd02(path) || // do not prefix for absolute URL
    contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
    path.startsWith('/')) return path;
    return `${contextEntryPoint}/${path}`;
};
const $c59df311e83496b4$export$d614758658023fd = (url)=>{
    if (!$c59df311e83496b4$export$895d6838d29edd02(url)) return url;
    try {
        const { pathname: pathname, search: search, hash: hash } = new URL(url);
        return `${pathname}${search}${hash}`;
    } catch (error) {
        (0, $chxpa.logException)(error, 'Cannot parse URL in getRelativeUrl', {
            url: url
        });
    }
    return url;
};
const $c59df311e83496b4$export$4cf71c31cd7fa836 = {
    TEAM_INVITE_LEARN_MORE: `${(0, $bAnhx.getAtlassianContextUrl)('support')}/atlassian-account/docs/start-an-atlassian-team/#Add-or-remove-members-of-a-team`
};

});
parcelRegister("bAnhx", function(module, exports) {

$parcel$export(module.exports, "getAtlassianContextUrl", () => $299d3bc44f0f7017$export$9986ff99701c314f);
$parcel$export(module.exports, "getAtlassianContextDomain", () => $299d3bc44f0f7017$export$50f0d77e468746eb);

var $bW292 = parcelRequire("bW292");

var $avLBj = parcelRequire("avLBj");
function $299d3bc44f0f7017$export$9986ff99701c314f(domainKey) {
    if ((0, $avLBj.isFedramp)()) return (0, $bW292.getATLContextUrl)(domainKey);
    else return `https://${domainKey}.atlassian.com`;
}
function $299d3bc44f0f7017$export$50f0d77e468746eb(domainKey) {
    if ((0, $avLBj.isFedramp)()) return (0, $bW292.getATLContextDomain)(domainKey);
    else return `${domainKey}.atlassian.com`;
}

});



parcelRegister("nagX1", function(module, exports) {

$parcel$export(module.exports, "ProfileCardClientConfigProvider", () => $a87a24aa67c2e32c$export$47bd48f80e3bc7b3);

var $eUqFw = parcelRequire("eUqFw");

var $9dvKM = parcelRequire("9dvKM");

var $bCEZR = parcelRequire("bCEZR");
function $a87a24aa67c2e32c$export$47bd48f80e3bc7b3({ children: children, ...props }) {
    const profileCardClient = (0, $bCEZR.useProfileClient)();
    const config = (0, $eUqFw.useMemo)(()=>({
            ...props,
            profileCardClient: profileCardClient
        }), [
        props,
        profileCardClient
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dvKM.ProfileCardClientConfigContext).Provider, {
        value: config
    }, children);
}

});
parcelRegister("9dvKM", function(module, exports) {

$parcel$export(module.exports, "ProfileCardClientConfigContext", () => $b7078bb491c002ec$export$c804cb3b184b670f);
$parcel$export(module.exports, "useProfileCardClientConfig", () => $b7078bb491c002ec$export$a3c560c84e5d436d);

var $eUqFw = parcelRequire("eUqFw");
const $b7078bb491c002ec$var$error = new Error('ProfileCardClientConfigProvider is not found in higher components');
const $b7078bb491c002ec$var$defaultState = {
    addFlag: ()=>{
        // eslint-disable-next-line no-console
        console.error($b7078bb491c002ec$var$error);
    },
    push: ()=>{
        // eslint-disable-next-line no-console
        console.error($b7078bb491c002ec$var$error);
    },
    contextEntryPoint: null,
    cloudId: null
};
const $b7078bb491c002ec$export$c804cb3b184b670f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($b7078bb491c002ec$var$defaultState);
const $b7078bb491c002ec$export$a3c560c84e5d436d = ()=>(0, $eUqFw.useContext)($b7078bb491c002ec$export$c804cb3b184b670f);

});

parcelRegister("bCEZR", function(module, exports) {

$parcel$export(module.exports, "useProfileClient", () => $5cbeb46e44fe9407$export$d43dc22a8337ee9f);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $8PYmV = parcelRequire("8PYmV");

var $WQNHl = parcelRequire("WQNHl");
const $5cbeb46e44fe9407$var$CACHE_MAX_AGE = 60000;
const $5cbeb46e44fe9407$var$actions = {
    createClient: (stargateRoot, enableTeamCentral = false)=>({ setState: setState })=>{
            const profileClient = new (0, $8PYmV.default)({
                gatewayGraphqlUrl: `${stargateRoot}/graphql`,
                url: `${stargateRoot}/directory/graphql`,
                teamCentralUrl: enableTeamCentral ? `${stargateRoot}/watermelon/graphql` : undefined,
                // teamCentralBaseUrl: enableTeamCentral
                //   ? getConfig().teamCentralUrl
                //   : undefined,
                cacheSize: 20,
                cacheMaxAge: $5cbeb46e44fe9407$var$CACHE_MAX_AGE
            });
            setState({
                profileClient: profileClient
            });
            return profileClient;
        }
};
const $5cbeb46e44fe9407$var$ProfileClientStore = (0, $WBLbN.createStore)({
    initialState: {},
    actions: $5cbeb46e44fe9407$var$actions
});
const $5cbeb46e44fe9407$var$useProfileClientState = (0, $WBLbN.createHook)($5cbeb46e44fe9407$var$ProfileClientStore);
const $5cbeb46e44fe9407$export$d43dc22a8337ee9f = ()=>{
    // const [teamCentralStore] = useTeamCentralStore();
    const [{ profileClient: profileClient }, { createClient: createClient }] = $5cbeb46e44fe9407$var$useProfileClientState();
    const { stargateRoot: stargateRoot } = (0, $WQNHl.useAppConfig)();
    (0, $eUqFw.useEffect)(()=>{
        createClient(stargateRoot);
    }, [
        createClient,
        stargateRoot
    ]);
    // TODO: enable team central
    // useEffect(() => {
    //   if (teamCentralStore.hasWorkspace || teamCentralStore.orgHasWorkspace) {
    //     // re-create the client and enable team central features
    //     createClient(true);
    //   }
    // }, [teamCentralStore.hasWorkspace, teamCentralStore.orgHasWorkspace]);
    return profileClient;
};

});
parcelRegister("8PYmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac2720ab38ce9772$export$2e2bcd8739ae039);

var $4eGN1 = parcelRequire("4eGN1");

var $lsiAJ = parcelRequire("lsiAJ");

var $kWhjG = parcelRequire("kWhjG");

var $b4hs7 = parcelRequire("b4hs7");
var $ac2720ab38ce9772$export$2e2bcd8739ae039 = (0, $lsiAJ.default);

});
parcelRegister("4eGN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3adc3d48b40454$export$2e2bcd8739ae039);

var $6roQF = parcelRequire("6roQF");
class $7c3adc3d48b40454$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $6roQF.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});
parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("lsiAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b7dde52ef02eed$export$2e2bcd8739ae039);

var $dfBCt = parcelRequire("dfBCt");

var $9KeXL = parcelRequire("9KeXL");

var $kmpkL = parcelRequire("kmpkL");

var $kWhjG = parcelRequire("kWhjG");

var $b4hs7 = parcelRequire("b4hs7");
const $84b7dde52ef02eed$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $84b7dde52ef02eed$var$ProfileCardClient {
    constructor(config, clients){
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$84b7dde52ef02eed$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $84b7dde52ef02eed$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $b4hs7.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $kWhjG.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $9KeXL.default)(withDefaultConfig);
        this.tcClient = $84b7dde52ef02eed$var$maybeCreateTeamCentralClient(config, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    getTeamCentralBaseUrl() {
        return this.tcClient?.options.teamCentralBaseUrl;
    }
    shouldShowGiveKudos() {
        if (!this.tcClient || !this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
}
function $84b7dde52ef02eed$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $dfBCt.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralUrl = config.teamCentralUrl;
    return teamCentralUrl ? new (0, $kmpkL.default)({
        ...config,
        teamCentralUrl: teamCentralUrl
    }) : undefined;
}
var $84b7dde52ef02eed$export$2e2bcd8739ae039 = $84b7dde52ef02eed$var$ProfileCardClient;

});
parcelRegister("9KeXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a501e1692a6dcaf$export$2e2bcd8739ae039);

var $3vXh8 = parcelRequire("3vXh8");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");
const $4a501e1692a6dcaf$var$createHeaders = (product, cloudId)=>{
    const config = {
        headers: {
            'X-Product': product,
            'X-Experience-Id': 'profile-card',
            'X-Cloudid': cloudId || ''
        }
    };
    return new Headers({
        ...config.headers || {}
    });
};
class $4a501e1692a6dcaf$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(id, cloudId) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $4a501e1692a6dcaf$var$createHeaders(product, this.options.cloudId);
        if (id.type === 'identity') return fetch(new Request(`/gateway/api/assist/agents/v1/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        return fetch(new Request(`/gateway/api/assist/agents/v1/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('succeeded', 'request', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('failed', 'request', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('triggered'));
            const headers = $4a501e1692a6dcaf$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('failed', 'deleteAgent', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('triggered', 'actionSubjectId'));
            const headers = $4a501e1692a6dcaf$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('succeeded', actionSubjectId, {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('failed', actionSubjectId, {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("3vXh8", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $3825798267526520$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $3825798267526520$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $3825798267526520$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $3825798267526520$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $3825798267526520$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $3825798267526520$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $3825798267526520$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $3825798267526520$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $3825798267526520$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $3825798267526520$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $3825798267526520$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $3825798267526520$export$a9f8c9f412cf5664);

var $cEOpo = parcelRequire("cEOpo");
/** Below lines are copied from teams common analytics */ const $3825798267526520$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $3825798267526520$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $3825798267526520$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $3825798267526520$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($3825798267526520$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $3825798267526520$var$TEAM_SUBJECT = 'teamProfileCard';
const $3825798267526520$var$USER_SUBJECT = 'profilecard';
const $3825798267526520$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $3825798267526520$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $cEOpo.getPageTime)())
        }
    });
const $3825798267526520$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $3825798267526520$var$USER_SUBJECT;
        case 'team':
            return $3825798267526520$var$TEAM_SUBJECT;
        case 'agent':
            return $3825798267526520$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $3825798267526520$export$d50ab8a3b6975c = (type, method)=>{
    return $3825798267526520$var$createEvent('ui', 'triggered', $3825798267526520$var$getActionSubject(type), undefined, {
        method: method
    });
};
const $3825798267526520$export$c9b0e37b229a297b = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$TEAM_SUBJECT, 'request', attributes);
const $3825798267526520$export$12dae48763368ac9 = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$USER_SUBJECT, 'request', attributes);
const $3825798267526520$export$41816a317479160b = (type, actionSubjectId, attributes)=>$3825798267526520$var$createEvent('ui', 'rendered', $3825798267526520$var$getActionSubject(type), actionSubjectId, attributes);
const $3825798267526520$export$fdcd134fbeb1f921 = (type, attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$getActionSubject(type), 'action', attributes);
const $3825798267526520$export$93260987012593be = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$USER_SUBJECT, 'reportingLines', attributes);
const $3825798267526520$export$79befd155063a6a7 = (type, attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$getActionSubject(type), 'moreActions', attributes);
const $3825798267526520$export$2703289b35687fde = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'avatar', attributes);
const $3825798267526520$export$b4411a7661cf2d3f = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $3825798267526520$export$c86679da702d560e = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $3825798267526520$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("cEOpo", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $77671953c6d01f45$export$e9faea7c41053334);
const $77671953c6d01f45$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $77671953c6d01f45$var$performanceAvailable = $77671953c6d01f45$var$isPerformanceAvailable();
const $77671953c6d01f45$var$initialPageTime = Date.now();
const $77671953c6d01f45$export$e9faea7c41053334 = ()=>{
    if ($77671953c6d01f45$var$performanceAvailable) return performance.now();
    return Date.now() - $77671953c6d01f45$var$initialPageTime;
};

});


parcelRegister("bl3OJ", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $d2cc0f3532818141$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $d2cc0f3532818141$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $d2cc0f3532818141$export$d9ad65d422ee3f8c);

var $j4C9S = parcelRequire("j4C9S");
const $d2cc0f3532818141$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $d2cc0f3532818141$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $d2cc0f3532818141$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $d2cc0f3532818141$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $j4C9S.DirectoryGraphQLError)) return !!error && $d2cc0f3532818141$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $j4C9S.AGGError)) return !!error.errorType && $d2cc0f3532818141$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $d2cc0f3532818141$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $d2cc0f3532818141$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $j4C9S.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($d2cc0f3532818141$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($d2cc0f3532818141$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $j4C9S.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$d2cc0f3532818141$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $j4C9S.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($d2cc0f3532818141$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($d2cc0f3532818141$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $j4C9S.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$d2cc0f3532818141$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $j4C9S.DirectoryGraphQLErrors) || causeError instanceof (0, $j4C9S.AGGErrors)) return $d2cc0f3532818141$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $d2cc0f3532818141$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $j4C9S.DirectoryGraphQLErrors)(errors, traceId);
};
const $d2cc0f3532818141$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $j4C9S.AGGErrors)(errors, traceId);
};

});
parcelRegister("j4C9S", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $343a8316fe4e3587$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $343a8316fe4e3587$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $343a8316fe4e3587$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $343a8316fe4e3587$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $343a8316fe4e3587$export$60d8267243755b9c);
class $343a8316fe4e3587$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $343a8316fe4e3587$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $343a8316fe4e3587$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $343a8316fe4e3587$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $343a8316fe4e3587$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $343a8316fe4e3587$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $343a8316fe4e3587$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});



parcelRegister("kmpkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8fb2ad4171564c$export$2e2bcd8739ae039);

var $4eGN1 = parcelRequire("4eGN1");

var $6WG70 = parcelRequire("6WG70");
const $ab8fb2ad4171564c$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $ab8fb2ad4171564c$export$f8c05b360e45cd0 = (featureKey, context)=>({
        query: `
    query isFeatureKeyEnabled($featureKey: String!, $context: [IsFeatureEnabledContextInput]) {
      isFeatureEnabled(featureKey: $featureKey, context: $context) {
        enabled
      }
    }
  `,
        variables: {
            featureKey: featureKey,
            context: context || []
        }
    });
function $ab8fb2ad4171564c$var$hasTCWorkspace(config) {
    return config.cloudId ? fetch(`/gateway/api/watermelon/organization/containsAnyWorkspace?cloudId=${config.cloudId}`).then((res)=>{
        return !res || res && res.ok;
    }) : Promise.resolve(false);
}
let $ab8fb2ad4171564c$var$isTCReadyPromiseMap = new Map();
class $ab8fb2ad4171564c$var$TeamCentralCardClient extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.featureFlagKeys = new Map();
        this.isTCReadyPromise = this.createTcReadyPromise(options);
    }
    createTcReadyPromise(config) {
        if (config.cloudId) {
            let promise = $ab8fb2ad4171564c$var$isTCReadyPromiseMap.get(config.cloudId);
            if (!promise) {
                promise = $ab8fb2ad4171564c$var$hasTCWorkspace(config);
                $ab8fb2ad4171564c$var$isTCReadyPromiseMap.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    async makeFeatureFlagCheckRequest(featureKey, context) {
        if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
        const query = $ab8fb2ad4171564c$export$f8c05b360e45cd0(featureKey, context);
        const response = await (0, $6WG70.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=isFeatureKeyEnabled`, query);
        return response.isFeatureEnabled.enabled;
    }
    async makeRequest(userId) {
        if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
        const query = $ab8fb2ad4171564c$export$1862ef0c3880ca8d(userId);
        const response = await (0, $6WG70.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=ReportingLines`, query);
        return response.reportingLines;
    }
    getReportingLines(userId) {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    getFlagEnabled(featureKey, productIdentifier) {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) {
                if (!featureKey) return Promise.reject(new Error('featureKey missing'));
                if (this.featureFlagKeys.has(featureKey)) return Promise.resolve(this.featureFlagKeys.get(featureKey));
                if (this.bypassOnFailure) return Promise.resolve(false);
                const context = [
                    {
                        key: 'productIdentifier',
                        value: productIdentifier || 'unset'
                    }
                ];
                return new Promise((resolve)=>{
                    this.makeFeatureFlagCheckRequest(featureKey, context).then((enabled)=>{
                        this.featureFlagKeys.set(featureKey, enabled);
                        resolve(enabled);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        resolve(false);
                    });
                });
            }
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    checkWorkspaceExists() {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $ab8fb2ad4171564c$export$2e2bcd8739ae039 = $ab8fb2ad4171564c$var$TeamCentralCardClient;

});
parcelRegister("6WG70", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $415b57eeeceb8e81$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $415b57eeeceb8e81$export$a14afb5f82fe705);

var $j4C9S = parcelRequire("j4C9S");

var $bl3OJ = parcelRequire("bl3OJ");
const $415b57eeeceb8e81$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $415b57eeeceb8e81$var$id = (headers)=>headers;
async function $415b57eeeceb8e81$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id) {
    return $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bl3OJ.handleDirectoryGraphQLErrors));
}
async function $415b57eeeceb8e81$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id) {
    return $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bl3OJ.handleAGGErrors));
}
async function $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id, handleErrors) {
    const headers = processHeaders($415b57eeeceb8e81$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $j4C9S.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});


parcelRegister("kWhjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $26e65ba6df7e3eef$export$2e2bcd8739ae039);

var $3vXh8 = parcelRequire("3vXh8");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");

var $k39sp = parcelRequire("k39sp");
class $26e65ba6df7e3eef$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $k39sp.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('succeeded', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('failed', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("k39sp", function(module, exports) {

$parcel$export(module.exports, "getTeamFromAGG", () => $b92dd34bfd4aec4a$export$26a8aad0c7182dd6);

var $6WG70 = parcelRequire("6WG70");
const $b92dd34bfd4aec4a$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $b92dd34bfd4aec4a$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $b92dd34bfd4aec4a$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $b92dd34bfd4aec4a$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $b92dd34bfd4aec4a$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $b92dd34bfd4aec4a$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$b92dd34bfd4aec4a$var$TEAM_FRAGMENT}
    }
  }
}`;
const $b92dd34bfd4aec4a$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $b92dd34bfd4aec4a$export$4968f4e0119a5d9c,
        variables: {
            teamId: $b92dd34bfd4aec4a$export$681597d03c8a0fd2(teamId),
            siteId: siteId || 'None'
        }
    });
const $b92dd34bfd4aec4a$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $b92dd34bfd4aec4a$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $b92dd34bfd4aec4a$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $6WG70.AGGQuery)(url, query, $b92dd34bfd4aec4a$export$1229c72526c01df2);
    return $b92dd34bfd4aec4a$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("b4hs7", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b3ff2ca38ed950$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $3vXh8 = parcelRequire("3vXh8");

var $j9Z8Z = parcelRequire("j9Z8Z");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");

var $6WG70 = parcelRequire("6WG70");
const $80b3ff2ca38ed950$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $80b3ff2ca38ed950$export$bfbf383663068c37 = (cloudId, userId)=>({
        query: `query User($userId: String!, $cloudId: String!) {
    User: CloudUser(userId: $userId, cloudId: $cloudId) {
      id
      isCurrentUser
      status
      statusModifiedDate
      isBot
      isNotMentionable
      fullName
      nickname
      email
      meta: title
      location
      companyName
      avatarUrl(size: 192)
      remoteWeekdayIndex: localTime(format: "d")
      remoteWeekdayString: localTime(format: "ddd")
      remoteTimeString: localTime(format: "h:mma")
    }
  }`,
        variables: {
            cloudId: cloudId,
            userId: userId
        }
    });
const $80b3ff2ca38ed950$export$8230f28f7ae567ea = (userId)=>({
        //The query name needs to be app_user_characteristics in order to return appType field
        query: `query app_user_characteristics($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`,
        variables: {
            userId: userId
        }
    });
const $80b3ff2ca38ed950$var$queryAGGUser = async (url, userId)=>{
    const query = $80b3ff2ca38ed950$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $6WG70.AGGQuery)(url, query);
    return user;
};
class $80b3ff2ca38ed950$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        if ((0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query_profile_card')) {
            const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
            const userQueryPromise = $80b3ff2ca38ed950$var$queryAGGUser(gatewayGraphqlUrl, userId);
            const user = await userQueryPromise;
            let timestring;
            const localWeekdayIndex = new Date().getDay().toString();
            if (user.zoneinfo) {
                if ((0, $j9Z8Z.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $j9Z8Z.localTime)(user.zoneinfo, 'h:mmbbb') || undefined;
                else timestring = (0, $j9Z8Z.localTime)(user.zoneinfo, 'eee h:mmbbb') || undefined;
            }
            return {
                ...user,
                isBot: user.__typename === 'AppUser',
                isAgent: user.appType === 'agent',
                status: user.accountStatus,
                statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
                avatarUrl: user.picture,
                email: user.email,
                fullName: user.name,
                location: user.extendedProfile?.location,
                meta: user.extendedProfile?.jobTitle,
                nickname: user.nickname,
                companyName: user.extendedProfile?.organization,
                timestring: timestring
            };
        } else {
            if (!this.options.url) throw new Error('options.url is a required parameter');
            const query = $80b3ff2ca38ed950$export$bfbf383663068c37(cloudId, userId);
            const response = await (0, $6WG70.directoryGraphqlQuery)(this.options.url, query);
            return $80b3ff2ca38ed950$export$b26b7f9bcf400835(response);
        }
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('succeeded', {
                    duration: (0, $cEOpo.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('failed', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("j9Z8Z", function(module, exports) {

$parcel$export(module.exports, "localTime", () => $8973c96ca3937b75$export$f0dfd716e7b023cd);
parcelRequire("isoj5");
var $hhZDn = parcelRequire("hhZDn");
const $8973c96ca3937b75$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $hhZDn.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("isoj5", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("hhZDn")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $hhZDn = parcelRequire("hhZDn");





});
parcelRegister("hhZDn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c963d570fe7b6c77$export$2e2bcd8739ae039);

var $1WmNj = parcelRequire("1WmNj");

var $7ue53 = parcelRequire("7ue53");

var $iPYJi = parcelRequire("iPYJi");
function $c963d570fe7b6c77$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1WmNj)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $7ue53.default)((0, $iPYJi.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("7ue53", function(module, exports) {

$parcel$export(module.exports, "default", () => $573641d4461c49f9$export$2e2bcd8739ae039);

var $Yg8hb = parcelRequire("Yg8hb");

var $fIcie = parcelRequire("fIcie");

var $MQM8H = parcelRequire("MQM8H");
var $573641d4461c49f9$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $573641d4461c49f9$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($573641d4461c49f9$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $MQM8H.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $fIcie.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yg8hb)))(dirtyDate, formatStr, options);
}

});
parcelRegister("fIcie", function(module, exports) {

$parcel$export(module.exports, "default", () => $b704803901ba91de$export$2e2bcd8739ae039);

var $3duP9 = parcelRequire("3duP9");

var $5joVX = parcelRequire("5joVX");
var $b704803901ba91de$var$MILLISECONDS_IN_MINUTE = 60000;
var $b704803901ba91de$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $b704803901ba91de$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $b704803901ba91de$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $b704803901ba91de$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $b704803901ba91de$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $b704803901ba91de$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $b704803901ba91de$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $b704803901ba91de$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $b704803901ba91de$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $b704803901ba91de$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $b704803901ba91de$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $b704803901ba91de$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $3duP9.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $3duP9.default)('long', date, options);
        }
    }
};
function $b704803901ba91de$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $5joVX.default)(timeZone, originalDate, true) / $b704803901ba91de$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $b704803901ba91de$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $b704803901ba91de$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $b704803901ba91de$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $b704803901ba91de$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $b704803901ba91de$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $b704803901ba91de$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $b704803901ba91de$var$formatTimezone(offset, dirtyDelimeter);
}
function $b704803901ba91de$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $b704803901ba91de$var$addLeadingZeros(minutes, 2);
}
var $b704803901ba91de$export$2e2bcd8739ae039 = $b704803901ba91de$var$formatters;

});
parcelRegister("3duP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $257a7efc9a6a7864$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $257a7efc9a6a7864$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $257a7efc9a6a7864$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $257a7efc9a6a7864$var$partsTimeZone(dtf, date) : $257a7efc9a6a7864$var$hackyTimeZone(dtf, date);
}
function $257a7efc9a6a7864$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $257a7efc9a6a7864$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $257a7efc9a6a7864$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("5joVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3de211721fa9aed9$export$2e2bcd8739ae039);

var $fu1or = parcelRequire("fu1or");

var $469iB = parcelRequire("469iB");
var $3de211721fa9aed9$var$MILLISECONDS_IN_HOUR = 3600000;
var $3de211721fa9aed9$var$MILLISECONDS_IN_MINUTE = 60000;
var $3de211721fa9aed9$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $3de211721fa9aed9$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $3de211721fa9aed9$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $3de211721fa9aed9$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$3de211721fa9aed9$var$validateTimezone(hours)) return NaN;
        return -(hours * $3de211721fa9aed9$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $3de211721fa9aed9$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$3de211721fa9aed9$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $3de211721fa9aed9$var$MILLISECONDS_IN_HOUR + minutes * $3de211721fa9aed9$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($3de211721fa9aed9$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $3de211721fa9aed9$var$toUtcDate(date);
        var offset = $3de211721fa9aed9$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $3de211721fa9aed9$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $3de211721fa9aed9$var$toUtcDate(date) {
    return (0, $469iB.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $3de211721fa9aed9$var$calcOffset(date, timezoneString) {
    var tokens = (0, $fu1or.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $469iB.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $3de211721fa9aed9$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $3de211721fa9aed9$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $3de211721fa9aed9$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $3de211721fa9aed9$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $3de211721fa9aed9$var$validIANATimezoneCache = {};
function $3de211721fa9aed9$var$isValidTimezoneIANAString(timeZoneString) {
    if ($3de211721fa9aed9$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $3de211721fa9aed9$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("fu1or", function(module, exports) {

$parcel$export(module.exports, "default", () => $b45abcffef27852f$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $b45abcffef27852f$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $b45abcffef27852f$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $b45abcffef27852f$var$partsOffset(dtf, date) : $b45abcffef27852f$var$hackyOffset(dtf, date);
}
var $b45abcffef27852f$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $b45abcffef27852f$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $b45abcffef27852f$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $b45abcffef27852f$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $b45abcffef27852f$var$dtfCache = {};
function $b45abcffef27852f$var$getDateTimeFormat(timeZone) {
    if (!$b45abcffef27852f$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $b45abcffef27852f$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $b45abcffef27852f$var$dtfCache[timeZone];
}

});

parcelRegister("469iB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fbeef8f33537542$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $2fbeef8f33537542$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("MQM8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $092d6be9aa48deb7$export$2e2bcd8739ae039);

var $4Zzm9 = parcelRequire("4Zzm9");

var $YdpzT = parcelRequire("YdpzT");

var $5joVX = parcelRequire("5joVX");

var $cK6LU = parcelRequire("cK6LU");
var $092d6be9aa48deb7$var$MILLISECONDS_IN_HOUR = 3600000;
var $092d6be9aa48deb7$var$MILLISECONDS_IN_MINUTE = 60000;
var $092d6be9aa48deb7$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $092d6be9aa48deb7$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $cK6LU.default)
};
function $092d6be9aa48deb7$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $092d6be9aa48deb7$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($4Zzm9)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $092d6be9aa48deb7$var$splitDateString(argument);
    var parseYearResult = $092d6be9aa48deb7$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $092d6be9aa48deb7$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $092d6be9aa48deb7$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $5joVX.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($YdpzT)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($YdpzT)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $092d6be9aa48deb7$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $092d6be9aa48deb7$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $092d6be9aa48deb7$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $092d6be9aa48deb7$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $092d6be9aa48deb7$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $092d6be9aa48deb7$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $092d6be9aa48deb7$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $092d6be9aa48deb7$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $092d6be9aa48deb7$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $092d6be9aa48deb7$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $092d6be9aa48deb7$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$092d6be9aa48deb7$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $092d6be9aa48deb7$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$092d6be9aa48deb7$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $092d6be9aa48deb7$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$092d6be9aa48deb7$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $092d6be9aa48deb7$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$092d6be9aa48deb7$var$validateWeekDate(year, week)) return new Date(NaN);
        return $092d6be9aa48deb7$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $092d6be9aa48deb7$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$092d6be9aa48deb7$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $092d6be9aa48deb7$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $092d6be9aa48deb7$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $092d6be9aa48deb7$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$092d6be9aa48deb7$var$validateTime(hours)) return NaN;
        return hours % 24 * $092d6be9aa48deb7$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $092d6be9aa48deb7$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$092d6be9aa48deb7$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $092d6be9aa48deb7$var$MILLISECONDS_IN_HOUR + minutes * $092d6be9aa48deb7$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $092d6be9aa48deb7$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$092d6be9aa48deb7$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $092d6be9aa48deb7$var$MILLISECONDS_IN_HOUR + minutes * $092d6be9aa48deb7$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $092d6be9aa48deb7$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $092d6be9aa48deb7$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $092d6be9aa48deb7$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $092d6be9aa48deb7$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $092d6be9aa48deb7$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $092d6be9aa48deb7$var$isLeapYearIndex(year);
        if (isLeapYear && date > $092d6be9aa48deb7$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $092d6be9aa48deb7$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $092d6be9aa48deb7$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $092d6be9aa48deb7$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $092d6be9aa48deb7$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $092d6be9aa48deb7$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("cK6LU", function(module, exports) {

$parcel$export(module.exports, "default", () => $946f08a27a12da04$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $946f08a27a12da04$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $946f08a27a12da04$export$2e2bcd8739ae039 = $946f08a27a12da04$var$tzPattern;

});



parcelRegister("iPYJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $db6c190bd1e807d1$export$2e2bcd8739ae039);

var $5joVX = parcelRequire("5joVX");

var $MQM8H = parcelRequire("MQM8H");
function $db6c190bd1e807d1$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $MQM8H.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $5joVX.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});







parcelRegister("WQNHl", function(module, exports) {

$parcel$export(module.exports, "useNavigation", () => $d6d1f66cab2625be$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useAppConfig", () => $d6d1f66cab2625be$export$a3e0ece8c3f698d7);

var $jvxHp = parcelRequire("jvxHp");

var $7QGbN = parcelRequire("7QGbN");

var $7QGbN = parcelRequire("7QGbN");
const $d6d1f66cab2625be$export$d0fd4b7106de2769 = ()=>{
    const state = (0, $7QGbN.useNavigationState)();
    const actions = (0, $jvxHp.useNavigationActions)();
    return {
        ...actions,
        ...state
    };
};
const $d6d1f66cab2625be$export$a3e0ece8c3f698d7 = ()=>{
    const storeState = (0, $7QGbN.useAppConfigStoreState)();
    const navigation = $d6d1f66cab2625be$export$d0fd4b7106de2769();
    const addFlag = (0, $jvxHp.useAddFlag)();
    return {
        ...storeState,
        ...navigation,
        addFlag: addFlag
    };
};

});




parcelRegister("ictQ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $80ab5d07faa3a76b$export$2e2bcd8739ae039);
// TODO: PTC-2088 - simplify list of locales

























const $80ab5d07faa3a76b$var$messagesConfig = [
    // Czech
    {
        locales: [
            'cs',
            'cs-CZ'
        ],
        loader: ()=>(parcelRequire("0PQn6"))
    },
    // Danish
    {
        locales: [
            'da',
            'da-DK'
        ],
        loader: ()=>(parcelRequire("5kJSn"))
    },
    // German
    {
        locales: [
            'de',
            'de-DE'
        ],
        loader: ()=>(parcelRequire("8nYEL"))
    },
    // Spain
    {
        locales: [
            'es',
            'es-ES'
        ],
        loader: ()=>(parcelRequire("h1I4C"))
    },
    // Finnish
    {
        locales: [
            'fi',
            'fi-FI'
        ],
        loader: ()=>(parcelRequire("jZ6Cp"))
    },
    // French
    {
        locales: [
            'fr',
            'fr-FR'
        ],
        loader: ()=>(parcelRequire("3lunH"))
    },
    // Hungarian
    {
        locales: [
            'hu',
            'hu-HU'
        ],
        loader: ()=>(parcelRequire("9Sd66"))
    },
    // Icelandic
    {
        locales: [
            'is',
            'is-IS'
        ],
        loader: ()=>(parcelRequire("37JbB"))
    },
    // Italian
    {
        locales: [
            'it',
            'it-IT'
        ],
        loader: ()=>(parcelRequire("dzmrI"))
    },
    // Japanese
    {
        locales: [
            'ja',
            'ja-JP'
        ],
        loader: ()=>(parcelRequire("exGAT"))
    },
    // Korean
    {
        locales: [
            'ko',
            'ko-KR'
        ],
        loader: ()=>(parcelRequire("4jLFs"))
    },
    // Dutch
    {
        locales: [
            'nl',
            'nl-NL'
        ],
        loader: ()=>(parcelRequire("bbWXO"))
    },
    // Norwegian (Norway)
    {
        locales: [
            'nb',
            'nb-NO'
        ],
        loader: ()=>(parcelRequire("5Dmqh"))
    },
    // Polish
    {
        locales: [
            'pl',
            'pl-PL'
        ],
        loader: ()=>(parcelRequire("2umD5"))
    },
    // Portuguese -
    {
        locales: [
            'pt-BR'
        ],
        loader: ()=>(parcelRequire("l3KuZ"))
    },
    // Romanian
    {
        locales: [
            'ro',
            'ro-RO'
        ],
        loader: ()=>(parcelRequire("eFmja"))
    },
    // Russian
    {
        locales: [
            'ru',
            'ru-RU'
        ],
        loader: ()=>(parcelRequire("bSCZn"))
    },
    // Swedish
    {
        locales: [
            'sv',
            'sv-SE'
        ],
        loader: ()=>(parcelRequire("57zk1"))
    },
    // China uses Chinese (Simplified)
    {
        locales: [
            'zh',
            'zh-CN',
            'zh-Hans'
        ],
        loader: ()=>(parcelRequire("5I3ZN"))
    },
    // Taiwan or Hong Kong uses Chinese (Traditional)
    {
        locales: [
            'zh-TW',
            'zh-HK',
            'zh-Hant'
        ],
        loader: ()=>(parcelRequire("kTTPP"))
    },
    // Turkish
    {
        locales: [
            'tr',
            'tr-TR'
        ],
        loader: ()=>(parcelRequire("6L6sS"))
    },
    // Thai
    {
        locales: [
            'th',
            'th-TH'
        ],
        loader: ()=>(parcelRequire("6QZyv"))
    },
    // Ukrainian
    {
        locales: [
            'uk',
            'uk-UA'
        ],
        loader: ()=>(parcelRequire("6y46F"))
    },
    // Vietnamese
    {
        locales: [
            'vi',
            'vi-VN'
        ],
        loader: ()=>(parcelRequire("8BTIn"))
    },
    // English (UK)
    {
        locales: [
            'en-GB'
        ],
        loader: ()=>(parcelRequire("6asiO"))
    }
];
var $80ab5d07faa3a76b$export$2e2bcd8739ae039 = $80ab5d07faa3a76b$var$messagesConfig;

});
parcelRegister("0PQn6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("89x0z").then(()=>parcelRequire('foPRb'));

});

parcelRegister("5kJSn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3Tk96").then(()=>parcelRequire('jlwFL'));

});

parcelRegister("8nYEL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hiJlJ").then(()=>parcelRequire('8E7Ro'));

});

parcelRegister("h1I4C", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("NTwa6").then(()=>parcelRequire('l8bnP'));

});

parcelRegister("jZ6Cp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5J8s7").then(()=>parcelRequire('f2MQa'));

});

parcelRegister("3lunH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7Aduf").then(()=>parcelRequire('e7MFP'));

});

parcelRegister("9Sd66", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kbqAI").then(()=>parcelRequire('4VCvg'));

});

parcelRegister("37JbB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("eXZ2t").then(()=>parcelRequire('i2oUb'));

});

parcelRegister("dzmrI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jsBQk").then(()=>parcelRequire('4PLPT'));

});

parcelRegister("exGAT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cKWYa").then(()=>parcelRequire('j5UvR'));

});

parcelRegister("4jLFs", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cJyfb").then(()=>parcelRequire('5afLJ'));

});

parcelRegister("bbWXO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("83hzl").then(()=>parcelRequire('3oH0y'));

});

parcelRegister("5Dmqh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bGLMC").then(()=>parcelRequire('cJIaj'));

});

parcelRegister("2umD5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hGT66").then(()=>parcelRequire('5BrBc'));

});

parcelRegister("l3KuZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bQpzg").then(()=>parcelRequire('7Jyoa'));

});

parcelRegister("eFmja", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kywHi").then(()=>parcelRequire('22X6B'));

});

parcelRegister("bSCZn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7Unnn").then(()=>parcelRequire('gVYgL'));

});

parcelRegister("57zk1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("d6XXp").then(()=>parcelRequire('9yC4X'));

});

parcelRegister("5I3ZN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hYoWl").then(()=>parcelRequire('c89VR'));

});

parcelRegister("kTTPP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gxLin").then(()=>parcelRequire('95pUJ'));

});

parcelRegister("6L6sS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dZ68S").then(()=>parcelRequire('d5eEb'));

});

parcelRegister("6QZyv", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("82F5W").then(()=>parcelRequire('jaAWf'));

});

parcelRegister("6y46F", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2JEDr").then(()=>parcelRequire('2XPpC'));

});

parcelRegister("8BTIn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2qEq2").then(()=>parcelRequire('lQNCV'));

});

parcelRegister("6asiO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5uIQ7").then(()=>parcelRequire('3ftDY'));

});


parcelRegister("gi0VS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e0f31a05bf5bdff$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7QNSj = parcelRequire("7QNSj");
var $bqSCJ = parcelRequire("bqSCJ");
var $9MQbY = parcelRequire("9MQbY");

var $XHGTv = parcelRequire("XHGTv");

var $2sEko = parcelRequire("2sEko");

var $QAW5b = parcelRequire("QAW5b");

var $ghjoM = parcelRequire("ghjoM");

var $4ckcM = parcelRequire("4ckcM");

var $p3lye = parcelRequire("p3lye");

var $3RsMI = parcelRequire("3RsMI");

var $bo3ra = parcelRequire("bo3ra");

var $8ziB5 = parcelRequire("8ziB5");

var $jmvGy = parcelRequire("jmvGy");

var $eurvo = parcelRequire("eurvo");

var $9j0B5 = parcelRequire("9j0B5");

var $eMmYZ = parcelRequire("eMmYZ");

var $jIuH4 = parcelRequire("jIuH4");
// Team Profile
// Kudos
const $7e0f31a05bf5bdff$var$renderRoutes = (contextEntryPoint, canViewTeams)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9MQbY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        exact: true,
        path: `${contextEntryPoint}/`,
        render: (0, $p3lye.default)
    }), !canViewTeams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/search/teams`,
        render: (0, $8ziB5.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/search`,
        render: (0, $bo3ra.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/kudos/:uuid`,
        render: (0, $ghjoM.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        exact: true,
        path: `${contextEntryPoint}/team`,
        render: (0, $eurvo.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3RsMI.RouteWithOrgIdLoading), {
        path: `${contextEntryPoint}/team/:teamId`,
        render: (0, $jmvGy.default)
    }), (0, $XHGTv.fg)('rovo_agent_profile_page') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/agent/:agentId`,
        render: (0, $QAW5b.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/:userId/work`,
        render: (0, $jIuH4.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/:userId/*`,
        render: (0, $eMmYZ.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/me`,
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ckcM.default), {
                ...props,
                contextEntryPoint: contextEntryPoint
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/:userId`,
        render: (0, $9j0B5.default)
    }));
};
function $7e0f31a05bf5bdff$var$AppRoutes(props) {
    const { contextEntryPoint: contextEntryPoint, history: history, onTransition: onTransition } = props;
    const { permissions: { canViewTeams: canViewTeams } } = (0, $2sEko.useTeamVisibility)();
    (0, $eUqFw.useEffect)(()=>{
        if (!onTransition) return;
        let unsubscribeBlockingHistory = ()=>{};
        let unsubscribeListeningHistory = ()=>{};
        if (history) {
            let lastHistoryLocation;
            unsubscribeListeningHistory = history.listen(({ pathname: pathname })=>{
                lastHistoryLocation = pathname;
            });
            // We're using history.block() here instead of history.listen()
            // because we want this to run BEFORE transition happens.
            unsubscribeBlockingHistory = history.block(({ pathname: pathname })=>{
                if (lastHistoryLocation !== pathname) onTransition(pathname);
            });
        }
        return ()=>{
            unsubscribeBlockingHistory();
            unsubscribeListeningHistory();
        };
    }, [
        onTransition,
        history
    ]);
    const routes = $7e0f31a05bf5bdff$var$renderRoutes(contextEntryPoint, canViewTeams);
    // If `history` object is not passed to `EmbeddableDirectory`, `EmbeddableDirectory` will use `Router` component from product in higher component tree.
    // If `history` object is passed to `EmbeddableDirectory`, `EmbeddableDirectory` will render its own `Router` component.
    // @ts-ignore - Property 'children' does not exist on type 'IntrinsicAttributes & IntrinsicClassAttributes<Router> & Readonly<RouterProps>'
    // This was added when enrolling `@atlassian/ptc-embeddable-directory` into JFE local consumption
    return history ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bqSCJ.default), {
        history: history
    }, routes) : routes;
}
var $7e0f31a05bf5bdff$export$2e2bcd8739ae039 = $7e0f31a05bf5bdff$var$AppRoutes;

});
parcelRegister("7QNSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b7413dcddcdf29e$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $k43p8 = parcelRequire("k43p8");
var $5b7413dcddcdf29e$export$2e2bcd8739ae039 = (0, $k43p8.default);

});
parcelRegister("k43p8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9b6d266f4833098$export$2e2bcd8739ae039);

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $1d3eD = parcelRequire("1d3eD");
var $e9b6d266f4833098$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $e9b6d266f4833098$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e9b6d266f4833098$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e9b6d266f4833098$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e9b6d266f4833098$var$isEmptyChildren = function isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(children) === 0;
};
/**
 * The public API for matching a single path and rendering.
 */ var $e9b6d266f4833098$var$Route = function(_React$Component) {
    $e9b6d266f4833098$var$_inherits(Route, _React$Component);
    function Route() {
        var _temp, _this, _ret;
        $e9b6d266f4833098$var$_classCallCheck(this, Route);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $e9b6d266f4833098$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props, _this.context.router)
        }, _temp), $e9b6d266f4833098$var$_possibleConstructorReturn(_this, _ret);
    }
    Route.prototype.getChildContext = function getChildContext() {
        return {
            router: $e9b6d266f4833098$var$_extends({}, this.context.router, {
                route: {
                    location: this.props.location || this.context.router.route.location,
                    match: this.state.match
                }
            })
        };
    };
    Route.prototype.computeMatch = function computeMatch(_ref, router) {
        var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
        if (computedMatch) return computedMatch; // <Switch> already computed the match for us
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(router, "You should not use <Route> or withRouter() outside a <Router>");
        var route = router.route;
        var pathname = (location || route.location).pathname;
        return (0, $1d3eD.default)(pathname, {
            path: path,
            strict: strict,
            exact: exact,
            sensitive: sensitive
        }, route.match);
    };
    Route.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.component && this.props.children && !$e9b6d266f4833098$var$isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.render && this.props.children && !$e9b6d266f4833098$var$isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
    };
    Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        this.setState({
            match: this.computeMatch(nextProps, nextContext.router)
        });
    };
    Route.prototype.render = function render() {
        var match = this.state.match;
        var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
        var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
        var location = this.props.location || route.location;
        var props = {
            match: match,
            location: location,
            history: history,
            staticContext: staticContext
        };
        if (component) return match ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(component, props) : null;
        if (render) return match ? render(props) : null;
        if (typeof children === "function") return children(props);
        if (children && !$e9b6d266f4833098$var$isEmptyChildren(children)) return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(children);
        return null;
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$e9b6d266f4833098$var$Route.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    component: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node
    ]),
    location: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
$e9b6d266f4833098$var$Route.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        route: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
    })
};
$e9b6d266f4833098$var$Route.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
};
var $e9b6d266f4833098$export$2e2bcd8739ae039 = $e9b6d266f4833098$var$Route;

});


parcelRegister("bqSCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $852c7e8f766e6629$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $aTrRe = parcelRequire("aTrRe");
var $852c7e8f766e6629$export$2e2bcd8739ae039 = (0, $aTrRe.default);

});
parcelRegister("aTrRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee4a658adeb8d1a$export$2e2bcd8739ae039);

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
var $7ee4a658adeb8d1a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $7ee4a658adeb8d1a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7ee4a658adeb8d1a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7ee4a658adeb8d1a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var $7ee4a658adeb8d1a$var$Router = function(_React$Component) {
    $7ee4a658adeb8d1a$var$_inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        $7ee4a658adeb8d1a$var$_classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $7ee4a658adeb8d1a$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), $7ee4a658adeb8d1a$var$_possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: $7ee4a658adeb8d1a$var$_extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(children == null || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(children) : null;
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$7ee4a658adeb8d1a$var$Router.propTypes = {
    history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node
};
$7ee4a658adeb8d1a$var$Router.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
$7ee4a658adeb8d1a$var$Router.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
};
var $7ee4a658adeb8d1a$export$2e2bcd8739ae039 = $7ee4a658adeb8d1a$var$Router;

});


parcelRegister("9MQbY", function(module, exports) {

$parcel$export(module.exports, "default", () => $72011505e90bfe2d$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $e8LPn = parcelRequire("e8LPn");
var $72011505e90bfe2d$export$2e2bcd8739ae039 = (0, $e8LPn.default);

});
parcelRegister("e8LPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4b6e9a2b5461b16$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $1d3eD = parcelRequire("1d3eD");
function $a4b6e9a2b5461b16$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a4b6e9a2b5461b16$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a4b6e9a2b5461b16$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for rendering the first <Route> that matches.
 */ var $a4b6e9a2b5461b16$var$Switch = function(_React$Component) {
    $a4b6e9a2b5461b16$var$_inherits(Switch, _React$Component);
    function Switch() {
        $a4b6e9a2b5461b16$var$_classCallCheck(this, Switch);
        return $a4b6e9a2b5461b16$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Switch.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(this.context.router, "You should not use <Switch> outside a <Router>");
    };
    Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    };
    Switch.prototype.render = function render() {
        var route = this.context.router.route;
        var children = this.props.children;
        var location = this.props.location || route.location;
        var match = void 0, child = void 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.forEach(children, function(element) {
            if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(element)) {
                var _element$props = element.props, pathProp = _element$props.path, exact = _element$props.exact, strict = _element$props.strict, sensitive = _element$props.sensitive, from = _element$props.from;
                var path = pathProp || from;
                child = element;
                match = (0, $1d3eD.default)(location.pathname, {
                    path: path,
                    exact: exact,
                    strict: strict,
                    sensitive: sensitive
                }, route.match);
            }
        });
        return match ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            location: location,
            computedMatch: match
        }) : null;
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$a4b6e9a2b5461b16$var$Switch.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        route: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
    }).isRequired
};
$a4b6e9a2b5461b16$var$Switch.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
var $a4b6e9a2b5461b16$export$2e2bcd8739ae039 = $a4b6e9a2b5461b16$var$Switch;

});


parcelRegister("2sEko", function(module, exports) {

$parcel$export(module.exports, "useTeamVisibility", () => $5aebb31ceecfc80b$export$acf57ff2f92f51c1);

var $eUqFw = parcelRequire("eUqFw");

var $4MkQ9 = parcelRequire("4MkQ9");

var $eFsBo = parcelRequire("eFsBo");

var $chxpa = parcelRequire("chxpa");

var $5tIUP = parcelRequire("5tIUP");

var $gakch = parcelRequire("gakch");

var $6XUHL = parcelRequire("6XUHL");
const $5aebb31ceecfc80b$export$7d97a022bd09a6fb = ()=>{
    return {
        isTeamsVisiblityEnabled: true,
        failOpenSites: false
    };
};
const $5aebb31ceecfc80b$var$useTeamPermissionsAnalytics = ({ data: data, error: error, permissions: permissions })=>{
    const { fireEvent: fireEvent } = (0, $4MkQ9.usePeopleTeamAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (error) {
            (0, $chxpa.logException)(error, 'Error loading team permissions in useTeamsPermissionsService');
            fireEvent('operational.teamsPermissionsRequest.failed', {
                message: error.message,
                status: error.status,
                path: error.path
            });
        }
    }, [
        error,
        fireEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data && permissions) fireEvent('operational.teamsPermissionsRequest.succeeded', {
            canCreateTeams: permissions.canCreateTeams,
            canViewTeams: permissions.canViewTeams,
            canAdminTeams: !!permissions.canAdminTeams
        });
    }, [
        data,
        fireEvent,
        permissions
    ]);
};
const $5aebb31ceecfc80b$export$acf57ff2f92f51c1 = ()=>{
    const { orgId: orgId } = (0, $5tIUP.useV3OrgIdStatus)();
    const [{ cloudId: cloudId }] = (0, $6XUHL.useSite)();
    const [{ principalUserId: principalUserId }] = (0, $gakch.usePrincipalUser)();
    const result = (0, $eFsBo.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        enabled: true,
        attributes: {
            userId: principalUserId
        }
    });
    $5aebb31ceecfc80b$var$useTeamPermissionsAnalytics(result);
    return {
        isLoading: result.isLoading,
        permissions: result.permissions
    };
};

});
parcelRegister("5tIUP", function(module, exports) {

$parcel$export(module.exports, "useV3OrgIdStatus", () => $f873947ce1669c4b$export$52558c271a487a01);

var $cWYE1 = parcelRequire("cWYE1");
function $f873947ce1669c4b$export$52558c271a487a01() {
    const [{ orgId: orgId }] = (0, $cWYE1.useOrg)();
    return {
        orgId: orgId,
        isOrgLoading: !orgId
    };
}

});

parcelRegister("gakch", function(module, exports) {

$parcel$export(module.exports, "usePrincipalUser", () => $3e5c3574957a0740$export$33e3bf16c7530dd4);

var $WBLbN = parcelRequire("WBLbN");

var $cAxhS = parcelRequire("cAxhS");
var $iuVe2 = parcelRequire("iuVe2");
// Private actions:
// It is called by `getPrincipalUserInfo` action
const $3e5c3574957a0740$var$getIsSiteAdmin = (cloudId)=>async ({ setState: setState })=>{
        if (!cloudId) {
            setState({
                isSiteAdmin: false
            });
            return;
        }
        let isSiteAdmin = false;
        try {
            isSiteAdmin = await (0, $cAxhS.teamsClient).getIsSiteAdmin(cloudId);
        } catch (e) {
        // do nothing because isSiteAdmin is returned as false
        } finally{
            setState({
                isSiteAdmin: isSiteAdmin
            });
        }
    };
// it is called by `getPrincipalUserInfo` action
const $3e5c3574957a0740$var$getMutability = (userId)=>async ({ setState: setState })=>{
        try {
            const data = await (0, $cAxhS.teamsClient).getProfileWithMutability(userId);
            setState({
                mutabilityConstraints: data
            });
        } catch (e) {
        // do nothing because isSiteAdmin is returned as false
        }
    };
const $3e5c3574957a0740$var$actions = {
    /**
	 * Get user information of current logged-in user.
	 * @param cloudId: If Cloud Id is passed, that means People Directory is rendered in a site and we use Cloud Id to check 'isSiteAdmin' info.
	 * If Cloud Id is not passed, `isSiteAdmin` is false by default.
	 */ getPrincipalUserInfo: (cloudId)=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            // stop fetching when it is already fetched
            if (getState().isFetching || getState().hasLoaded) return;
            setState({
                isFetching: true,
                hasLoaded: false
            });
            try {
                const userBasicData = await (0, $iuVe2.userInfoProvider).get();
                setState({
                    principalUserId: userBasicData.userId,
                    ...userBasicData
                });
                dispatch($3e5c3574957a0740$var$getIsSiteAdmin(cloudId));
                dispatch($3e5c3574957a0740$var$getMutability(userBasicData.userId));
                setState({
                    hasLoaded: true
                });
            } catch (e) {
                setState({
                    hasError: true,
                    hasLoaded: false
                });
            } finally{
                setState({
                    isFetching: false
                });
            }
        }
};
const $3e5c3574957a0740$var$initialState = {
    principalUserId: '',
    avatarUrl: '',
    email: '',
    fullName: '',
    title: '',
    isSiteAdmin: false,
    isFetching: false,
    hasError: false,
    hasLoaded: false
};
/**
 * Manage states of a site
 */ const $3e5c3574957a0740$var$Store = (0, $WBLbN.createStore)({
    initialState: $3e5c3574957a0740$var$initialState,
    actions: $3e5c3574957a0740$var$actions,
    name: 'PrincipalUser'
});
const $3e5c3574957a0740$export$33e3bf16c7530dd4 = (0, $WBLbN.createHook)($3e5c3574957a0740$var$Store);

});
parcelRegister("iuVe2", function(module, exports) {

$parcel$export(module.exports, "userInfoProvider", () => $9b8eb04ff6aedda1$export$30a852ca4cb27370);

var $i6gsr = parcelRequire("i6gsr");
// Needs to be declared here to avoid blowing up this earlyInit bundle
class $9b8eb04ff6aedda1$var$FetchError extends Error {
    constructor(response){
        super(`Request failed with status ${response.status}`);
        this.response = response;
        this.name = this.constructor.name;
    }
}
class $9b8eb04ff6aedda1$export$dc10e400a1189789 {
    get(fetchOp = fetch) {
        if (this.promise) return this.promise;
        const getJson = (url)=>fetchOp(url, {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response)=>{
                if (!response.ok) throw new $9b8eb04ff6aedda1$var$FetchError(response);
                return response.json();
            });
        this.promise = getJson(`${(0, $i6gsr.DEFAULT_CONFIG).stargateRoot}/me`).then((me)=>{
            return {
                userId: me.account_id,
                locale: me.locale,
                fullName: me.name,
                avatarUrl: me.picture,
                email: me.email,
                title: me.extended_profile?.job_title
            };
        });
        return this.promise;
    }
}
const $9b8eb04ff6aedda1$export$30a852ca4cb27370 = new $9b8eb04ff6aedda1$export$dc10e400a1189789();

});



parcelRegister("QAW5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $edcc4ae3113f9523$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $7qMvm = parcelRequire("7qMvm");

var $gjneQ = parcelRequire("gjneQ");

var $4RubW = parcelRequire("4RubW");
const $edcc4ae3113f9523$var$AgentProfileRoute = ({ match: match })=>{
    const { agentId: agentId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RubW.default), {
        name: (0, $1io2n.AnalyticsKeys).AGENT_PROFILE_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qMvm.default), {
        name: (0, $1io2n.AnalyticsKeys).AGENT_PROFILE_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjneQ.default), {
        agentId: decodeURIComponent(agentId)
    }));
};
var $edcc4ae3113f9523$export$2e2bcd8739ae039 = $edcc4ae3113f9523$var$AgentProfileRoute;

});
parcelRegister("7qMvm", function(module, exports) {

$parcel$export(module.exports, "default", () => $080311b12c26624d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $74Hyh = parcelRequire("74Hyh");
const $080311b12c26624d$export$430619e48d4c20bb = (props)=>{
    const analytics = (0, $74Hyh.default)();
    const { name: name } = props;
    (0, $eUqFw.useEffect)(()=>{
        analytics.pushOperationalEvent({
            source: (0, $1io2n.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: name,
            action: (0, $1io2n.AnalyticsEventActions).MOUNTED
        });
    }, [
        analytics,
        name
    ]);
    return null;
};
var $080311b12c26624d$export$2e2bcd8739ae039 = $080311b12c26624d$export$430619e48d4c20bb;

});
parcelRegister("74Hyh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c682e676c991a7a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $J9LlC = parcelRequire("J9LlC");
const $8c682e676c991a7a$var$useAnalytics = ()=>(0, $eUqFw.useContext)((0, $J9LlC.AnalyticsContext)).analytics;
var $8c682e676c991a7a$export$2e2bcd8739ae039 = $8c682e676c991a7a$var$useAnalytics;

});


parcelRegister("gjneQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7408c0876dba071$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

var $6N6gd = parcelRequire("6N6gd");

const $c7408c0876dba071$var$LazyAgentProfile = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("8OFDT")),
    loading: ()=>null
});
$c7408c0876dba071$var$LazyAgentProfile.displayName = 'lazy(AgentProfile)';
var $c7408c0876dba071$export$2e2bcd8739ae039 = (0, $6N6gd.AgentProfilePageComponent);

});
parcelRegister("6N6gd", function(module, exports) {

$parcel$export(module.exports, "AgentProfilePageComponent", () => $9ee032f59205ed68$export$555f6d88454da0bb);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $fM5iV = parcelRequire("fM5iV");
var $1n3pn = parcelRequire("1n3pn");
var $920hm = parcelRequire("920hm");

var $4Bees = parcelRequire("4Bees");

var $364Zq = parcelRequire("364Zq");
var $18uvb = parcelRequire("18uvb");

var $4MkQ9 = parcelRequire("4MkQ9");

var $3W7Kz = parcelRequire("3W7Kz");
var $b2XvR = parcelRequire("b2XvR");
var $hWnzK = parcelRequire("hWnzK");
var $elP2D = parcelRequire("elP2D");
var $gakch = parcelRequire("gakch");
var $iNIpe = parcelRequire("iNIpe");
var $6XUHL = parcelRequire("6XUHL");

var $j9wA1 = parcelRequire("j9wA1");

var $5OFKT = parcelRequire("5OFKT");

var $4vhsL = parcelRequire("4vhsL");

var $kZURK = parcelRequire("kZURK");

var $6r9ui = parcelRequire("6r9ui");

var $UsOwV = parcelRequire("UsOwV");

var $h9to7 = parcelRequire("h9to7");
var $92Jzo = parcelRequire("92Jzo");
var $3fooa = parcelRequire("3fooa");
var $biE4w = parcelRequire("biE4w");

var $91PIt = parcelRequire("91PIt");

var $fvq4y = parcelRequire("fvq4y");

var $91BVc = parcelRequire("91BVc");

var $5BUhr = parcelRequire("5BUhr");

var $jvkFO = parcelRequire("jvkFO");

var $1g5v7 = parcelRequire("1g5v7");

var $m9pXn = parcelRequire("m9pXn");

var $1V5FM = parcelRequire("1V5FM");
const $9ee032f59205ed68$var$AGENT_PROFILE_PAGE_LATENCY_TARGET = 1000;
const $9ee032f59205ed68$var$mainColumnStyle = (0, $1ZAYh.xcss)({});
const $9ee032f59205ed68$var$bannerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.500',
    marginInline: 'space.negative.400'
});
const $9ee032f59205ed68$var$avatarStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300'
});
const $9ee032f59205ed68$export$555f6d88454da0bb = (props)=>{
    const { agentId: agentId } = props;
    const { productName: productName } = (0, $kZURK.useAppConfig)();
    const [{ cloudId: cloudId }] = (0, $6XUHL.useSite)();
    const [{ agentData: agentData }, { setAgentInfo: setAgentInfo }] = (0, $5OFKT.useRovoAgentData)();
    const [{ principalUserId: principalUserId }] = (0, $gakch.usePrincipalUser)();
    const { fireEvent: fireEvent } = (0, $4MkQ9.usePeopleTeamAnalyticsEvents)();
    const product = (0, $eUqFw.useMemo)(()=>productName?.toLowerCase(), [
        productName
    ]);
    const [starCount, setStarCount] = (0, $eUqFw.useState)(0);
    const [isStarred, setIsStarred] = (0, $eUqFw.useState)(false);
    const { data: data, error: error, isFetching: isFetching } = (0, $18uvb.useAgentDetailsController)({
        agentId: agentId,
        experienceId: 'profile-page',
        product: product || 'rovo',
        enabled: agentData?.id !== agentId
    });
    (0, $eUqFw.useEffect)(()=>{
        fireEvent('screen.agentProfile.viewed', {});
    }, [
        fireEvent
    ]);
    (0, $hWnzK.useExpTrackerStart)({
        id: agentId,
        name: (0, $iNIpe.UserExperienceNames).AGENT_PROFILE_PAGE,
        latencySloMs: $9ee032f59205ed68$var$AGENT_PROFILE_PAGE_LATENCY_TARGET
    });
    (0, $elP2D.useExpTrackerStop)({
        name: (0, $iNIpe.UserExperienceNames).AGENT_PROFILE_PAGE,
        checkShouldAbort: (error)=>{
            if (!(0, $3W7Kz.isAuthError)(error)) return;
            return error.message;
        },
        error: error
    });
    const agentIdentityId = (0, $eUqFw.useMemo)(()=>{
        return agentData?.identity_account_id ? (0, $j9wA1.trimUserARI)(agentData?.identity_account_id) : '';
    }, [
        agentData?.identity_account_id
    ]);
    const isAgentCreatedByCurrentUser = (0, $eUqFw.useMemo)(()=>{
        return agentData?.creator_type === 'CUSTOMER' ? (0, $j9wA1.trimUserARI)(agentData?.creator || '') === principalUserId : false;
    }, [
        agentData?.creator,
        agentData?.creator_type,
        principalUserId
    ]);
    const { openDialog: openDialog } = (0, $b2XvR.useDialog)();
    (0, $eUqFw.useEffect)(()=>{
        if (data) {
            setAgentInfo(data);
            setStarCount(data.favourite_count);
            setIsStarred(data.favourite);
        }
    }, [
        data,
        setAgentInfo
    ]);
    const { setFavouriteAgent: setFavouriteAgent, editAgent: editAgent, copyAgent: copyAgent, duplicateAgent: duplicateAgent, deleteAgent: deleteAgent, onChatWithAgent: onChatWithAgent, startConversation: startConversation } = (0, $1V5FM.useAgentActions)({
        agentId: data?.id,
        agentIdentityAccountId: data?.identity_account_id,
        product: product,
        cloudId: cloudId,
        agentName: agentData?.name
    });
    const handleOnDeleteAgent = ()=>{
        openDialog((0, $m9pXn.default), {
            agentName: agentData?.name,
            agentId: agentData?.id,
            onDelete: deleteAgent,
            onClose: ()=>{}
        });
    };
    const isForgeAgent = (0, $eUqFw.useMemo)(()=>data?.creator_type === 'THIRD_PARTY' || data?.creator_type === 'FORGE', [
        data?.creator_type
    ]);
    const handleCopyInstructions = ()=>{
        if (agentData?.system_prompt_template) navigator.clipboard.writeText(agentData?.system_prompt_template.toString());
    };
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $91PIt.ErrorScreen), {
        error: error,
        key: agentId
    });
    if (isFetching) /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4vhsL.App), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium"
    }));
    if (!agentData) return null;
    const handleFavouriteAgent = async ()=>{
        const onSuccessCallBack = ()=>{
            setStarCount(isStarred ? starCount - 1 : starCount + 1);
            setIsStarred(!isStarred);
        };
        setFavouriteAgent(!isStarred, onSuccessCallBack);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $UsOwV.default), {
        title: agentData.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4vhsL.App), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9ee032f59205ed68$var$bannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1n3pn.AgentBanner), {
        agentId: agentData.id,
        agentNamedId: agentData.named_id,
        agentIdentityAccountId: agentData.identity_account_id,
        height: 192
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $92Jzo.Body), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $biE4w.ResponsiveSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h9to7.AsideColumn), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9ee032f59205ed68$var$avatarStyles,
        style: {
            marginTop: '-105px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fM5iV.AgentAvatar), {
        agentId: agentData.id,
        agentNamedId: agentData.named_id,
        agentIdentityAccountId: agentData.identity_account_id,
        size: "xxlarge"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $920hm.AgentProfileInfo), {
        agentName: agentData?.name,
        isStarred: isStarred,
        onStarToggle: ()=>handleFavouriteAgent(),
        creatorRender: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1g5v7.AgentCreator), {
            create_type: agentData.creator_type,
            creator: agentData.creator || undefined
        }),
        starCountRender: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $920hm.AgentStarCount), {
            isLoading: isFetching,
            starCount: starCount
        }),
        agentDescription: agentData.description,
        isHidden: agentData.visibility === 'PRIVATE'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BUhr.AgentActions), {
        isAgentCreatedByUser: isAgentCreatedByCurrentUser,
        onEditAgent: editAgent,
        onCopyAgent: copyAgent,
        onDuplicateAgent: duplicateAgent,
        onDeleteAgent: handleOnDeleteAgent,
        onChatClick: onChatWithAgent
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $91BVc.AgentAboutPanel), {
        agent: agentData
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3fooa.MainColumn), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.500",
        xcss: $9ee032f59205ed68$var$mainColumnStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvkFO.AgentConversationStartersSection), {
        isAgentDefault: agentData.is_default,
        userDefinedConversationStarters: agentData.user_defined_conversation_starters,
        onConversationStarterClick: (conversationStarter)=>{
            startConversation(conversationStarter);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $364Zq.AgentInstructions), {
        promptTemplate: agentData.system_prompt_template,
        onCopy: handleCopyInstructions,
        isForgeAgent: isForgeAgent,
        fullHeightText: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fvq4y.default), {
        userId: agentIdentityId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6r9ui.default), {
        userId: agentIdentityId,
        status: agentData.deactivated ? 'inactive' : 'active',
        userFullName: agentData.name
    }))))))));
};

});
parcelRegister("fM5iV", function(module, exports) {

$parcel$export(module.exports, "AgentAvatar", () => $c46244c3a4e4701a$export$38b71b080e1832c8);

var $eUqFw = parcelRequire("eUqFw");

var $eri7S = parcelRequire("eri7S");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1n3pn = parcelRequire("1n3pn");
/**
 * This solution has been derived from this codepen: https://codepen.io/anyen-ltovn/pen/qBYYzea
 */ const $c46244c3a4e4701a$var$agentAvatarStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    clipPath: `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`
});
const $c46244c3a4e4701a$var$innerShapeStyles = (0, $1ZAYh.xcss)({
    height: '95%',
    width: '95%',
    clipPath: `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`
});
const $c46244c3a4e4701a$var$imageStyles = (0, $1ZAYh.xcss)({
    objectFit: 'cover',
    height: '100%',
    width: '100%'
});
const $c46244c3a4e4701a$var$avatarContentContainer = (0, $1ZAYh.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $c46244c3a4e4701a$export$38b71b080e1832c8 = ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        "aria-label": label,
        xcss: $c46244c3a4e4701a$var$agentAvatarStyles,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $eri7S.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $eri7S.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
            ...showBorder ? {
                backgroundColor: '#fff'
            } : {}
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c46244c3a4e4701a$var$innerShapeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c46244c3a4e4701a$var$avatarContentContainer
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "img",
        xcss: $c46244c3a4e4701a$var$imageStyles,
        src: imageUrl,
        alt: name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1n3pn.GeneratedAvatar), {
        agentId: agentId,
        agentNamedId: agentNamedId,
        agentIdentityAccountId: agentIdentityAccountId,
        size: size
    }))));
};

});
parcelRegister("1n3pn", function(module, exports) {

$parcel$export(module.exports, "AgentBanner", () => $301f5eef7defe046$export$6efaefb8ad2fba40);
$parcel$export(module.exports, "GeneratedAvatar", () => $301f5eef7defe046$export$96bb253b7de22616);

var $eUqFw = parcelRequire("eUqFw");

var $eri7S = parcelRequire("eri7S");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

const $301f5eef7defe046$var$AutoDevAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("3np4F")));

const $301f5eef7defe046$var$AutoFixAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("eiGdd")));

const $301f5eef7defe046$var$AutoReviewAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("36ZMD")));

const $301f5eef7defe046$var$BacklogBuddyAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("9J9Hz")));

const $301f5eef7defe046$var$CommsCrafterAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("dvnFV")));

const $301f5eef7defe046$var$CultureAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("gtHxc")));

const $301f5eef7defe046$var$CustomerInsightAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("6tEjB")));

const $301f5eef7defe046$var$DecisionDirectorAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("2tneT")));

const $301f5eef7defe046$var$FeatureFlagAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("flvFN")));

const $301f5eef7defe046$var$GenericAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("dvI7f")));

const $301f5eef7defe046$var$HireWriterAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("5u7W0")));

const $301f5eef7defe046$var$MarketingMessageMaestroAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("vYCuY")));

const $301f5eef7defe046$var$MyUserManualAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("bB4tj")));

const $301f5eef7defe046$var$OkrOracleAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("1zgmh")));

const $301f5eef7defe046$var$OpsAgentAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("jh8xr")));

const $301f5eef7defe046$var$PitchPerfectorAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("cT6os")));

const $301f5eef7defe046$var$ProductRequirementAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("eX3Cm")));

const $301f5eef7defe046$var$ReleaseNotesAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("dRQbc")));

const $301f5eef7defe046$var$ResearchScoutAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("4SaeS")));

const $301f5eef7defe046$var$SocialMediaScribeAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("8FWre")));

const $301f5eef7defe046$var$TeamConnectionAvatar = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("i7nW4")));
const $301f5eef7defe046$var$yellowColor = {
    primary: '#FCA700',
    secondary: '#FFC716'
};
const $301f5eef7defe046$var$purpleColor = {
    primary: '#BF63F3',
    secondary: '#D8A0F7'
};
const $301f5eef7defe046$var$greenColor = {
    primary: '#82B536',
    secondary: '#B3DF72'
};
const $301f5eef7defe046$var$blueColor = {
    primary: '#357DE8',
    secondary: '#669DF1'
};
const $301f5eef7defe046$var$colorList = [
    $301f5eef7defe046$var$yellowColor,
    $301f5eef7defe046$var$purpleColor,
    $301f5eef7defe046$var$greenColor,
    $301f5eef7defe046$var$blueColor
];
const $301f5eef7defe046$var$avatarList = [
    $301f5eef7defe046$var$CustomerInsightAvatar,
    $301f5eef7defe046$var$BacklogBuddyAvatar,
    $301f5eef7defe046$var$DecisionDirectorAvatar,
    $301f5eef7defe046$var$CommsCrafterAvatar,
    $301f5eef7defe046$var$AutoDevAvatar,
    $301f5eef7defe046$var$OkrOracleAvatar,
    $301f5eef7defe046$var$CultureAvatar,
    $301f5eef7defe046$var$SocialMediaScribeAvatar,
    $301f5eef7defe046$var$TeamConnectionAvatar,
    $301f5eef7defe046$var$HireWriterAvatar,
    $301f5eef7defe046$var$OpsAgentAvatar,
    $301f5eef7defe046$var$ResearchScoutAvatar,
    $301f5eef7defe046$var$ReleaseNotesAvatar,
    $301f5eef7defe046$var$MyUserManualAvatar,
    $301f5eef7defe046$var$PitchPerfectorAvatar,
    $301f5eef7defe046$var$AutoDevAvatar,
    $301f5eef7defe046$var$AutoFixAvatar,
    $301f5eef7defe046$var$AutoReviewAvatar,
    $301f5eef7defe046$var$MarketingMessageMaestroAvatar,
    $301f5eef7defe046$var$FeatureFlagAvatar,
    $301f5eef7defe046$var$ProductRequirementAvatar
];
const $301f5eef7defe046$export$a834793a4d0d739e = $301f5eef7defe046$var$avatarList.length * $301f5eef7defe046$var$colorList.length;
const $301f5eef7defe046$var$imageStyles = (0, $1ZAYh.xcss)({
    objectFit: 'cover',
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $301f5eef7defe046$var$outOfTheBoxAgentAvatar = {
    decision_director_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($301f5eef7defe046$var$DecisionDirectorAvatar, {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                primaryColor: $301f5eef7defe046$var$greenColor.primary,
                secondaryColor: $301f5eef7defe046$var$greenColor.secondary
            }),
        color: $301f5eef7defe046$var$greenColor
    },
    user_manual_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($301f5eef7defe046$var$MyUserManualAvatar, {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                primaryColor: $301f5eef7defe046$var$yellowColor.primary,
                secondaryColor: $301f5eef7defe046$var$yellowColor.secondary
            }),
        color: $301f5eef7defe046$var$yellowColor
    },
    product_requirements_expert_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($301f5eef7defe046$var$ProductRequirementAvatar, {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                primaryColor: $301f5eef7defe046$var$yellowColor.primary,
                secondaryColor: $301f5eef7defe046$var$yellowColor.secondary
            }),
        color: $301f5eef7defe046$var$yellowColor
    },
    jira_issue_gardener_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($301f5eef7defe046$var$BacklogBuddyAvatar, {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                primaryColor: $301f5eef7defe046$var$greenColor.primary,
                secondaryColor: $301f5eef7defe046$var$greenColor.secondary
            }),
        color: $301f5eef7defe046$var$greenColor
    },
    it_ops_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($301f5eef7defe046$var$OpsAgentAvatar, {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                primaryColor: $301f5eef7defe046$var$purpleColor.primary,
                secondaryColor: $301f5eef7defe046$var$purpleColor.secondary
            }),
        color: $301f5eef7defe046$var$purpleColor
    }
};
const $301f5eef7defe046$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
    // we prioritise agentIdentityAccountId first if it is available
    // this is because agentIdentityAccountId is more widely available (e.g. in ProfilePage)
    const idForAgentAvatar = agentIdentityAccountId || agentId;
    if (idForAgentAvatar) {
        // Take the last 8 characters of the id because JS can't handle 16 digit numbers
        const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
        const parsedId = parseInt(trimmedId, 16);
        if (isNaN(parsedId)) return 0;
        else return parsedId;
    }
    return null;
};
const $301f5eef7defe046$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, size: size })=>{
    if (typeof agentNamedId === 'string' && $301f5eef7defe046$var$outOfTheBoxAgentAvatar[agentNamedId]) {
        const ootbAvatarResult = $301f5eef7defe046$var$outOfTheBoxAgentAvatar[agentNamedId];
        return {
            render: ootbAvatarResult.getRender(size),
            color: ootbAvatarResult.color
        };
    }
    const numberId = $301f5eef7defe046$export$c84eb7708138dd4({
        agentIdentityAccountId: agentIdentityAccountId,
        agentId: agentId
    });
    if (numberId !== null) {
        /**
		 * this create all possible combinations of avatars and colors
		 * e.g. [[avatar1, color1], [avatar1, color2], [avatar2, color1], [avatar2, color2]]
		 * then choose 1 based on agentId
		 */ const totalCombinations = $301f5eef7defe046$var$avatarList.length * $301f5eef7defe046$var$colorList.length;
        const combinationIndex = numberId % totalCombinations;
        const avatarIndex = Math.floor(combinationIndex / $301f5eef7defe046$var$colorList.length);
        const colorIndex = combinationIndex % $301f5eef7defe046$var$colorList.length;
        const Avatar = $301f5eef7defe046$var$avatarList[avatarIndex];
        const color = $301f5eef7defe046$var$colorList[colorIndex];
        return {
            render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Avatar, {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                primaryColor: color.primary,
                secondaryColor: color.secondary
            }),
            color: color
        };
    }
    return {
        render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($301f5eef7defe046$var$GenericAvatar, {
            size: (0, $eri7S.AVATAR_SIZES)[size],
            primaryColor: $301f5eef7defe046$var$blueColor.primary,
            secondaryColor: $301f5eef7defe046$var$blueColor.secondary
        }),
        color: $301f5eef7defe046$var$blueColor
    };
};
const $301f5eef7defe046$var$bannerStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});
const $301f5eef7defe046$export$6efaefb8ad2fba40 = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, height: height })=>{
    const { color: color } = $301f5eef7defe046$var$getAvatarRender({
        agentNamedId: agentNamedId,
        agentId: agentId,
        agentIdentityAccountId: agentIdentityAccountId,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $301f5eef7defe046$var$bannerStyles,
        style: {
            backgroundColor: color.primary,
            height: `${height}px`
        }
    });
};
const $301f5eef7defe046$export$96bb253b7de22616 = (props)=>{
    const { render: render, color: color } = $301f5eef7defe046$var$getAvatarRender(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $301f5eef7defe046$var$imageStyles,
        style: {
            backgroundColor: color.primary
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, render));
};

});
parcelRegister("3np4F", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("g1RXl").then(()=>parcelRequire('5TKhN'));

});

parcelRegister("eiGdd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lcNNj").then(()=>parcelRequire('gintv'));

});

parcelRegister("36ZMD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1h3gG").then(()=>parcelRequire('dLzpK'));

});

parcelRegister("9J9Hz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("c4zo4").then(()=>parcelRequire('4MSOB'));

});

parcelRegister("dvnFV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("id2c4").then(()=>parcelRequire('7bSsT'));

});

parcelRegister("gtHxc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("eFh2x").then(()=>parcelRequire('7NM53'));

});

parcelRegister("6tEjB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6MN1U").then(()=>parcelRequire('19LR2'));

});

parcelRegister("2tneT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dBzFD").then(()=>parcelRequire('a4vlK'));

});

parcelRegister("flvFN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jOrRH").then(()=>parcelRequire('6Je5I'));

});

parcelRegister("dvI7f", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("94wS8").then(()=>parcelRequire('fksEs'));

});

parcelRegister("5u7W0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5ysfx").then(()=>parcelRequire('fGiBX'));

});

parcelRegister("vYCuY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kpC5N").then(()=>parcelRequire('54k0x'));

});

parcelRegister("bB4tj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ewsLs").then(()=>parcelRequire('bTTug'));

});

parcelRegister("1zgmh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aGAz7").then(()=>parcelRequire('8zvm7'));

});

parcelRegister("jh8xr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aacwp").then(()=>parcelRequire('8zaiw'));

});

parcelRegister("cT6os", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hLtm8").then(()=>parcelRequire('3oTAZ'));

});

parcelRegister("eX3Cm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8Mxpl").then(()=>parcelRequire('3ptGp'));

});

parcelRegister("dRQbc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5XeXE").then(()=>parcelRequire('7zNkv'));

});

parcelRegister("4SaeS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dSDwa").then(()=>parcelRequire('lLzmU'));

});

parcelRegister("8FWre", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aSR8a").then(()=>parcelRequire('89yuV'));

});

parcelRegister("i7nW4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7O9uR").then(()=>parcelRequire('pHJ36'));

});



parcelRegister("920hm", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCreator", () => $f487095b9eea36be$export$f35b2eeaa7e3db15);
$parcel$export(module.exports, "AgentStarCount", () => $f487095b9eea36be$export$65f8fe094f79ae2);
$parcel$export(module.exports, "AgentProfileInfo", () => $f487095b9eea36be$export$e02348ba0b01a210);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hI5oG = parcelRequire("hI5oG");

var $daM3L = parcelRequire("daM3L");

var $45uQ5 = parcelRequire("45uQ5");
var $aFHo6 = parcelRequire("aFHo6");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $hFxJG = parcelRequire("hFxJG");

var $8cU5f = parcelRequire("8cU5f");

var $kfZqf = parcelRequire("kfZqf");

var $cfzU9 = parcelRequire("cfzU9");

var $aj3Jh = parcelRequire("aj3Jh");
const $f487095b9eea36be$var$clickableItemStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050'
});
const $f487095b9eea36be$var$countStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    display: 'flex',
    alignItems: 'center',
    gap: 'space.025'
});
const $f487095b9eea36be$var$nameStyles = (0, $1ZAYh.xcss)({
    justifyContent: 'space-between',
    alignItems: 'flex-start'
});
const $f487095b9eea36be$var$descriptionStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.0',
    marginBottom: 'space.100'
});
const $f487095b9eea36be$export$f35b2eeaa7e3db15 = ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $aj3Jh.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100,
                borderRadius: 3
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM') return formatMessage((0, $aj3Jh.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $45uQ5.AtlassianIcon), {
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') return formatMessage((0, $aj3Jh.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: creator.profileLink,
                onClick: ()=>onCreatorLinkClick(),
                target: "_blank"
            }, creator.name, ' ', creator.status === 'inactive' && formatMessage((0, $aj3Jh.messages).agentDeactivated))
        });
        if (creator.type === 'THIRD_PARTY') return formatMessage((0, $aj3Jh.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$clickableItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aFHo6.RovoIcon), {
        appearance: "brand",
        size: "small"
    }), creatorRender) : null;
};
const $f487095b9eea36be$export$65f8fe094f79ae2 = ({ starCount: starCount, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if ((starCount === null || starCount === undefined) && !isLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$countStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($daM3L))), {
        label: "",
        size: "small"
    }), isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
        testId: "agent-profile-info-star-count-skeleton",
        isShimmering: true,
        height: 16,
        width: 75,
        borderRadius: 3
    }) : formatMessage((0, $aj3Jh.messages).starredCount, {
        count: starCount
    }));
};
const $f487095b9eea36be$var$wrapperStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.100'
});
const $f487095b9eea36be$var$tooltipWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    marginInline: 'space.100',
    position: 'relative',
    bottom: 'space.025'
});
const $f487095b9eea36be$var$headingWrapperStyles = (0, $1ZAYh.xcss)({
    position: 'relative'
});
const $f487095b9eea36be$export$e02348ba0b01a210 = ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        xcss: $f487095b9eea36be$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $f487095b9eea36be$var$nameStyles,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$headingWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "span",
        size: "xlarge"
    }, agentName), isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$tooltipWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $aj3Jh.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kfZqf.HiddenIcon), {
        label: formatMessage((0, $aj3Jh.messages).hiddenIcon)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cfzU9.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$descriptionStyles,
        as: "p"
    }, agentDescription), starCountRender);
};

});
parcelRegister("45uQ5", function(module, exports) {

$parcel$export(module.exports, "AtlassianIcon", () => $12a88b946c693080$export$8a485e2e7ed91e8f);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $12a88b946c693080$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const $12a88b946c693080$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $lpzFL.defaultLogoParams).size, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $12a88b946c693080$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("aFHo6", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", () => $e6e5f467bfb8f1b0$export$e23ae35269442b4f);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $e6e5f467bfb8f1b0$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
    <g fill="${colors.iconColor}" fill-rule="evenodd">
      <path d="M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z"/>
      <path d="m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z"/>
    </g>
  </svg>`;
};
const $e6e5f467bfb8f1b0$export$e23ae35269442b4f = ({ appearance: appearance, label: label = 'Rovo', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        svg: $e6e5f467bfb8f1b0$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hFxJG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6854df9b98f4b182$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");
const $6854df9b98f4b182$var$shimmer = (0, $lcnyw.skeletonShimmer)();
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6854df9b98f4b182$var$shimmerKeyframes = (0, $byn9U.keyframes)($6854df9b98f4b182$var$shimmer.keyframes);
const $6854df9b98f4b182$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...$6854df9b98f4b182$var$shimmer.css
});
const $6854df9b98f4b182$var$activeShimmerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animationName: `${$6854df9b98f4b182$var$shimmerKeyframes}`
});
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ const $6854df9b98f4b182$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: [
            $6854df9b98f4b182$var$skeletonStyles,
            isShimmering && $6854df9b98f4b182$var$activeShimmerStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                width: width,
                height: height,
                borderRadius: borderRadius
            }
        ],
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        }
    });
};
var $6854df9b98f4b182$export$2e2bcd8739ae039 = $6854df9b98f4b182$var$Skeleton;

});

parcelRegister("kfZqf", function(module, exports) {

$parcel$export(module.exports, "HiddenIcon", () => $a21c86407f311f09$export$bce21421c351deb1);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $a21c86407f311f09$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.75961 3.82038L0.469614 1.53039L1.53027 0.469727L15.5303 14.4697L14.4696 15.5304L11.9569 13.0177C10.7749 13.6441 9.42396 14.0001 7.99985 14.0001C4.43327 14.0001 1.31894 11.7676 0.167087 8.61989C0.0206752 8.21978 0.0206129 7.78052 0.167056 7.38031C0.683493 5.96897 1.59401 4.74336 2.75961 3.82038ZM3.82896 4.88973C2.80461 5.65938 2.01287 6.70107 1.57571 7.89577C1.5511 7.96303 1.55109 8.03706 1.57574 8.10442C2.50926 10.6555 5.05721 12.5001 7.99985 12.5001C9.00694 12.5001 9.96863 12.284 10.8358 11.8965L9.52381 10.5846C9.07723 10.8483 8.55598 11.0001 7.99994 11.0001C6.34309 11.0001 4.99994 9.65691 4.99994 8.00006C4.99994 7.44402 5.15166 6.92277 5.41542 6.47619L3.82896 4.88973ZM6.55063 7.6114C6.51755 7.7353 6.49994 7.86555 6.49994 8.00006C6.49994 8.82848 7.17152 9.50006 7.99994 9.50006C8.13445 9.50006 8.2647 9.48246 8.3886 9.44937L6.55063 7.6114ZM7.99985 3.50006C7.50971 3.50006 7.03064 3.55121 6.56817 3.64826L6.26011 2.18024C6.82282 2.06215 7.40511 2.00006 7.99985 2.00006C11.5664 2.00006 14.6809 4.23249 15.8328 7.38022C15.9792 7.78032 15.9793 8.21955 15.8328 8.61977C15.5258 9.45892 15.0793 10.2324 14.5232 10.9153L13.3601 9.96815C13.8143 9.41034 14.1762 8.78194 14.4242 8.10432C14.4488 8.03708 14.4488 7.96307 14.4242 7.8957C13.4906 5.34464 10.9425 3.50006 7.99985 3.50006Z",
        fill: "currentColor"
    }));
const $a21c86407f311f09$export$bce21421c351deb1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $a21c86407f311f09$var$CustomGlyph,
        ...props
    });

});

parcelRegister("cfzU9", function(module, exports) {

$parcel$export(module.exports, "StarIconButton", () => $0d5e336c9f732951$export$703abb8bd2abdfa5);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $daM3L = parcelRequire("daM3L");

var $hlWtt = parcelRequire("hlWtt");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4vqt4 = parcelRequire("4vqt4");
const $0d5e336c9f732951$var$pressableStarIconStyles = (0, $1ZAYh.xcss)({
    background: 'transparent',
    padding: 'space.0',
    height: '32px',
    width: '32px'
});
const $0d5e336c9f732951$var$hiddenStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
const $0d5e336c9f732951$export$703abb8bd2abdfa5 = ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        xcss: [
            $0d5e336c9f732951$var$pressableStarIconStyles,
            !visible && $0d5e336c9f732951$var$hiddenStyles
        ],
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, isStarred || isHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hlWtt))), {
        size: "medium",
        label: formatMessage((0, $4vqt4.default).removeFromFavouritesLabel),
        primaryColor: "var(--ds-background-accent-yellow-subtler-pressed, #E2B203)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($daM3L))), {
        size: "medium",
        label: formatMessage((0, $4vqt4.default).clickToFavouriteLabel),
        primaryColor: "var(--ds-background-accent-gray-bolder-hovered, #44546F)"
    }));
};

});
parcelRegister("4vqt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $237a04530def53a1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $237a04530def53a1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeFromFavouritesLabel: {
        id: 'rovo-chat.browse-agents.remove-from-favourites-label',
        defaultMessage: 'Remove from favourites',
        description: 'Remove from favourites label'
    },
    clickToFavouriteLabel: {
        id: 'rovo-chat.browse-agents.click-to-favourite-label',
        defaultMessage: 'Not favourited, click to favourite',
        description: 'Click to favourite agent label'
    }
});

});


parcelRegister("aj3Jh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b9eb9dca2dfa43df$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b9eb9dca2dfa43df$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    agentCreatedBy: {
        id: 'ai-mate.agent-profile-info.created-by',
        defaultMessage: 'Rovo Agent by {creatorNameWithLink}',
        description: 'Message to show who created this Rovo agent'
    },
    agentDeactivated: {
        id: 'ai-mate.agent-profile-info.deactivated',
        defaultMessage: '(deactivated)',
        description: 'Message to show that this agent is deactivated'
    },
    starredCount: {
        id: 'ai-mate.agent-profile-info.starred-count',
        defaultMessage: '{count} starred',
        description: 'Message to show how many times this agent has been starred by users'
    },
    hiddenIcon: {
        id: 'ai-mate.agent-profile-info.hidden-icon',
        defaultMessage: 'Hidden',
        description: 'Icon to show that this agent is hidden'
    },
    hiddenTooltip: {
        id: 'ai-mate.agent-profile-info.hidden-tooltip',
        defaultMessage: "Agent won't show in search results",
        description: 'Tooltip to explain what strikethough eye icon means'
    },
    starAgentTooltip: {
        id: 'ai-mate.agent-profile-info.star-agent-tooltip',
        defaultMessage: 'Star Agent',
        description: 'Tooltip to explain what star icon does'
    }
});

});


parcelRegister("364Zq", function(module, exports) {

$parcel$export(module.exports, "AgentInstructions", () => $5333590b5487b175$export$48d253a044b54931);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $j9fWg = parcelRequire("j9fWg");

var $dmCPj = parcelRequire("dmCPj");

var $fXMW0 = parcelRequire("fXMW0");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $2mSN2 = parcelRequire("2mSN2");
const $5333590b5487b175$var$fullSizeTextStyles = (0, $1ZAYh.xcss)({
    maxHeight: '100%',
    overflowY: 'auto'
});
const $5333590b5487b175$var$instructionsContainerStyles = (0, $1ZAYh.xcss)({
    border: `1px solid ${"var(--ds-border-input, #8590A2)"}`,
    borderRadius: 'border.radius.100',
    whiteSpace: 'pre-line',
    position: 'relative',
    padding: 'space.100',
    flex: '1'
});
const $5333590b5487b175$var$smallTextStyles = (0, $1ZAYh.xcss)({
    maxHeight: '400px',
    overflowY: 'scroll'
});
const $5333590b5487b175$var$copyContainerStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: '10px',
    right: '10px'
});
const $5333590b5487b175$var$hiddenStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
const $5333590b5487b175$var$headingStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    letterSpacing: 'normal'
});
const $5333590b5487b175$var$forgeAgentWrapperStyles = (0, $1ZAYh.xcss)({
    boxShadow: 'elevation.shadow.raised',
    padding: 'space.200',
    borderRadius: 'border.radius.100'
});
const $5333590b5487b175$export$48d253a044b54931 = ({ promptTemplate: promptTemplate, onCopy: onCopy, isForgeAgent: isForgeAgent, fullHeightText: fullHeightText = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [instructionsHovered, setInstructionsHovered] = (0, $eUqFw.useState)(false);
    const [mouseEnterHappened, setMouseEnterHappened] = (0, $eUqFw.useState)(false);
    const getInstructionsRender = ()=>{
        if (isForgeAgent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: $5333590b5487b175$var$forgeAgentWrapperStyles,
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fXMW0))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
            weight: "bold"
        }, formatMessage((0, $2mSN2.default).privateInstructionsTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
            size: "small"
        }, formatMessage((0, $2mSN2.default).privateInstructionsDescription))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: [
                $5333590b5487b175$var$instructionsContainerStyles,
                fullHeightText ? $5333590b5487b175$var$fullSizeTextStyles : $5333590b5487b175$var$smallTextStyles
            ],
            onMouseEnter: ()=>{
                setMouseEnterHappened(true);
                setInstructionsHovered(true);
            },
            onMouseLeave: ()=>{
                setMouseEnterHappened(false);
                setInstructionsHovered(false);
            },
            onFocus: ()=>setInstructionsHovered(true),
            onBlur: ()=>{
                if (!mouseEnterHappened) setInstructionsHovered(false);
            }
        }, promptTemplate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, promptTemplate), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: [
                $5333590b5487b175$var$copyContainerStyles,
                !instructionsHovered && $5333590b5487b175$var$hiddenStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $2mSN2.default).copyInstructionsTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            type: "button",
            onClick: ()=>onCopy(promptTemplate),
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), iconProps),
            appearance: "subtle",
            spacing: "compact",
            label: formatMessage((0, $2mSN2.default).copyInstructionsLabel)
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
            as: "em",
            color: "color.text.subtle"
        }, formatMessage((0, $2mSN2.default).noInstructionPlaceholder)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "h2",
        xcss: $5333590b5487b175$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        size: "large",
        color: "color.text.subtle",
        weight: "semibold"
    }, formatMessage((0, $2mSN2.default).instructionsLabel))), getInstructionsRender()));
};

});
parcelRegister("dmCPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bab72963b78cefe$var$_react = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9bab72963b78cefe$var$_copy = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("dBCpP")));
function $9bab72963b78cefe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9bab72963b78cefe$var$CopyIcon = (props)=>/*#__PURE__*/ $9bab72963b78cefe$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $9bab72963b78cefe$var$_copy.default
    }));
$9bab72963b78cefe$var$CopyIcon.displayName = 'CopyIcon';
var $9bab72963b78cefe$var$_default = module.exports.default = $9bab72963b78cefe$var$CopyIcon;

});
parcelRegister("dBCpP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb7c6c8cdb896d771e123a497630ca2d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e7c879c9eefdea2$var$_react = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9e7c879c9eefdea2$var$_UNSAFE_baseNew = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9e7c879c9eefdea2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e7c879c9eefdea2$var$CopyIcon = (props)=>/*#__PURE__*/ $9e7c879c9eefdea2$var$_react.default.createElement($9e7c879c9eefdea2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$9e7c879c9eefdea2$var$CopyIcon.displayName = 'CopyIcon';
var $9e7c879c9eefdea2$var$_default = module.exports.default = $9e7c879c9eefdea2$var$CopyIcon;

});


parcelRegister("fXMW0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9f253171a9f20fe$var$_react = $b9f253171a9f20fe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b9f253171a9f20fe$var$_lockLocked = $b9f253171a9f20fe$var$_interopRequireDefault((parcelRequire("gWhpp")));
function $b9f253171a9f20fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b9f253171a9f20fe$var$LockIcon = (props)=>/*#__PURE__*/ $b9f253171a9f20fe$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $b9f253171a9f20fe$var$_lockLocked.default
    }));
$b9f253171a9f20fe$var$LockIcon.displayName = 'LockIcon';
var $b9f253171a9f20fe$var$_default = module.exports.default = $b9f253171a9f20fe$var$LockIcon;

});
parcelRegister("gWhpp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1d1b3dafeedb3bcbc92be5929839e615>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c54f9120ca8b9e22$var$_react = $c54f9120ca8b9e22$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c54f9120ca8b9e22$var$_UNSAFE_baseNew = $c54f9120ca8b9e22$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c54f9120ca8b9e22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c54f9120ca8b9e22$var$LockLockedIcon = (props)=>/*#__PURE__*/ $c54f9120ca8b9e22$var$_react.default.createElement($c54f9120ca8b9e22$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
    }, props));
$c54f9120ca8b9e22$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $c54f9120ca8b9e22$var$_default = module.exports.default = $c54f9120ca8b9e22$var$LockLockedIcon;

});


parcelRegister("2mSN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $eae5057ad637ba04$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $eae5057ad637ba04$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    instructionsLabel: {
        id: 'rovo-chat.view-agent.instructions-label',
        defaultMessage: 'Instructions',
        description: 'Label for instructions'
    },
    copyInstructionsLabel: {
        id: 'rovo-chat.view-agent.copy-instructions-label',
        defaultMessage: 'Copy',
        description: 'Label for copy instructions button'
    },
    copyInstructionsTooltip: {
        id: 'rovo-chat.view-agent.copy-instructions-tooltip',
        defaultMessage: 'Copy response',
        description: 'Label for copy instructions tooltip'
    },
    noInstructionPlaceholder: {
        id: 'rovo-chat.view-agent.no-instruction-placeholder',
        defaultMessage: 'This Agent has no custom instructions',
        description: 'Placeholder for no instructions'
    },
    privateInstructionsTitle: {
        id: 'rovo-chat.view-agent.hidden-instructions-title',
        defaultMessage: 'These instructions are private',
        description: 'Title of the instructions section, this is displayed when instructions are purposely hidden'
    },
    privateInstructionsDescription: {
        id: 'rovo-chat.view-agent.hidden-instructions-description',
        defaultMessage: 'Agents built by Atlassian Marketplace partners have their instructions hidden for privacy.',
        description: 'Description of the instructions section, this is displayed when instructions are purposely hidden'
    }
});

});


parcelRegister("18uvb", function(module, exports) {

$parcel$export(module.exports, "useAgentDetailsController", () => $8b4745ade1be5544$export$e65200649bbc56ce);
$parcel$export(module.exports, "useAgentDetailsByIdentityAccountId", () => $8b4745ade1be5544$export$7d1c308c0d5404ad);

var $asu8X = parcelRequire("asu8X");

var $19xaS = parcelRequire("19xaS");
var $dXg8a = parcelRequire("dXg8a");

var $1DkoF = parcelRequire("1DkoF");
var $6n1kb = parcelRequire("6n1kb");
const $8b4745ade1be5544$export$e65200649bbc56ce = ({ agentId: agentId, experienceId: experienceId, product: product, enabled: enabled = true })=>{
    (0, $asu8X.di)((0, $1DkoF.useAssistanceService));
    const assistanceService = (0, $1DkoF.useAssistanceService)({
        experienceId: experienceId,
        product: product
    });
    const experience = (0, $dXg8a.useAIMateExperienceTracker)();
    const queryResult = (0, $6n1kb.useQuery)({
        queryKey: [
            'fetchAgentDetails',
            agentId
        ],
        queryFn: ()=>{
            experience.start({
                id: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_AGENT_ID,
                name: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_AGENT_ID
            });
            return assistanceService.getAgentDetails(agentId);
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_AGENT_ID
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_AGENT_ID,
                error: error
            });
        },
        enabled: enabled
    });
    return queryResult;
};
const $8b4745ade1be5544$export$7d1c308c0d5404ad = ({ identityAccountId: identityAccountId, experienceId: experienceId, product: product, enabled: enabled = true })=>{
    (0, $asu8X.di)((0, $1DkoF.useAssistanceService));
    const assistanceService = (0, $1DkoF.useAssistanceService)({
        experienceId: experienceId,
        product: product
    });
    const experience = (0, $dXg8a.useAIMateExperienceTracker)();
    const queryResult = (0, $6n1kb.useQuery)({
        queryKey: [
            'fetchAgentDetails',
            identityAccountId
        ],
        queryFn: ()=>{
            experience.start({
                id: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
                name: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID
            });
            return assistanceService.getAgentDetailsByIdentityAccountId(identityAccountId);
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
                error: error
            });
        },
        enabled: enabled
    });
    return queryResult;
};

});
parcelRegister("19xaS", function(module, exports) {

$parcel$export(module.exports, "ExperienceName", () => $6575de2c7f86c640$export$b881bd9f00ed8ed1);
const $6575de2c7f86c640$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    FETCH_CHAT: 'aiMateFetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    FETCH_FEATURES: 'aiMateFetchFeatures',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions'
};

});

parcelRegister("dXg8a", function(module, exports) {

$parcel$export(module.exports, "useAIMateExperienceTracker", () => $9d991c98fe9d7243$export$412c53791574f6f0);

var $eUqFw = parcelRequire("eUqFw");

var $hUYqC = parcelRequire("hUYqC");

var $jBIQr = parcelRequire("jBIQr");

var $cIgNV = parcelRequire("cIgNV");

var $9ngKA = parcelRequire("9ngKA");
class $9d991c98fe9d7243$var$ExperienceTrackerHandler {
    constructor(){
        this.experienceTracker = new (0, $hUYqC.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        this.experienceTracker.subscribe((event)=>{
            // for FailEvent
            if ('error' in event) {
                // do not fail experience tracking if the error is a client fetch error
                if ((0, $jBIQr.isClientFetchError)(event.error)) return;
                // Filter 5xx errors since backend monitoring will cover this
                // as per https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3547354267/Meeting+notes+FE+SLOs+which+one+to+promote
                if (event.error?.metadata?.statusCode >= 500) return;
                const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                (0, $cIgNV.logException)({
                    exception: error,
                    name: event.name,
                    tags: {
                        source: 'aiMateExperienceTracker'
                    }
                });
            }
            this.sendAnalyticsEvent?.({
                eventType: 'operational',
                action: event.action,
                actionSubject: 'ui',
                attributes: {
                    task: event.name,
                    taskId: event.id,
                    startTime: event.startTime,
                    ...event.attributes
                }
            }, {
                removeDefaultTags: true
            });
        });
    }
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$9d991c98fe9d7243$var$ExperienceTrackerHandler.instance) $9d991c98fe9d7243$var$ExperienceTrackerHandler.instance = new $9d991c98fe9d7243$var$ExperienceTrackerHandler();
        return $9d991c98fe9d7243$var$ExperienceTrackerHandler.instance;
    }
}
const $9d991c98fe9d7243$export$412c53791574f6f0 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $9ngKA.useAnalytics)();
    (0, $eUqFw.useEffect)(()=>{
        $9d991c98fe9d7243$var$ExperienceTrackerHandler.getInstance().setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    return $9d991c98fe9d7243$var$ExperienceTrackerHandler.getInstance().experienceTracker;
};

});
parcelRegister("jBIQr", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $40259eea45a92ab6$export$2e7adc44463c3f4f);
// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
const $40259eea45a92ab6$var$KNOWN_NETWORK_ERRORS = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $40259eea45a92ab6$var$isClientFetchErrorMessage = (message)=>Boolean(message) && !!$40259eea45a92ab6$var$KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $40259eea45a92ab6$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $40259eea45a92ab6$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($40259eea45a92ab6$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name) || $40259eea45a92ab6$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($40259eea45a92ab6$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || $40259eea45a92ab6$var$isClientFetchErrorMessage(error.cause.message)));

});

parcelRegister("cIgNV", function(module, exports) {

$parcel$export(module.exports, "setupSentryClient", () => $790e2728a7a6a566$export$d8bd0edf6c978788);
$parcel$export(module.exports, "logException", () => $790e2728a7a6a566$export$f86b2a1a2ce291b3);

var $jBIQr = parcelRequire("jBIQr");

var $7SJVd = parcelRequire("7SJVd");

// importing local file instead of from '@sentry/browser' otherwise there will be typescript errors
const $790e2728a7a6a566$var$importSentryAsync = async ()=>Promise.resolve((parcelRequire("itytM")));
let $790e2728a7a6a566$var$sentryClient;
// copied from platform/packages/people-and-teams/teams-client/src/services/sentry/utils/initialise-sentry.ts
const $790e2728a7a6a566$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
const $790e2728a7a6a566$var$getEnvironment = ()=>{
    return 'production';
};
const $790e2728a7a6a566$export$d8bd0edf6c978788 = async ({ accountId: accountId = 'UNKNOWN_AAID', product: product = 'UNKNOWN' })=>{
    if ($790e2728a7a6a566$var$sentryClient) {
        // if sentry is trying to be initialized again with new product or account id
        // update the user and tags
        if (product !== 'UNKNOWN') $790e2728a7a6a566$var$sentryClient.setTag('product', product);
        if (accountId !== 'UNKNOWN_AAID') $790e2728a7a6a566$var$sentryClient.setUser({
            id: accountId
        });
        // do not initialise sentry again, only update the existing one
        return;
    }
    let importedSentry;
    try {
        importedSentry = await $790e2728a7a6a566$var$importSentryAsync();
    } catch (e) {
        console.warn('Failed to load conversation-assistant sentry', e); // eslint-disable-line no-console
        return;
    }
    importedSentry.init({
        // from https://atlassian-2y.sentry.io/projects/ai-mate-conversation-assistant/getting-started/
        dsn: 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680',
        environment: $790e2728a7a6a566$var$getEnvironment(),
        integrations: (integrations)=>{
            return integrations.filter((integration)=>{
                return $790e2728a7a6a566$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        },
        initialScope: {
            user: {
                id: accountId
            },
            tags: {
                packageName: '@atlassian/conversation-assistant',
                product: product
            }
        },
        // referencing jira/src/packages/platform/observability/errors-handling/src/utils/sentry/handling/normalise-sentry-event.tsx
        beforeSend: (event, hint)=>{
            const exception = hint?.originalException;
            // Ignore network-like errors
            if ((0, $jBIQr.isClientFetchError)(exception)) return null;
            if (!event.tags?.name) // we only want to capture errors that has `name` tag from `logException` function below
            // since the `DISABLED_INTEGRATIONS` filter above is not enough to prevent unhandled errors
            return null;
            let updatedEvent = event;
            if (updatedEvent.request?.url) {
                // Ignore events from localhost and staging
                if (updatedEvent.request.url.includes('localhost') || updatedEvent.request.url.includes('jira-dev.com')) return null;
                updatedEvent.request.url = (0, $7SJVd.normaliseUrl)(updatedEvent.request.url);
            }
            return updatedEvent;
        },
        attachStacktrace: true
    });
    $790e2728a7a6a566$var$sentryClient = importedSentry;
};
const $790e2728a7a6a566$var$getSentryClient = async ()=>{
    if (!$790e2728a7a6a566$var$sentryClient) // this only happens if something using sentry before the initialisation in root app
    await $790e2728a7a6a566$export$d8bd0edf6c978788({});
    return $790e2728a7a6a566$var$sentryClient;
};
const $790e2728a7a6a566$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    const sentryClient = await $790e2728a7a6a566$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        scope.setTag('name', name);
        if (tags) scope.setTags(tags);
        sentryClient.captureException(exception, scope);
    });
};

});
parcelRegister("7SJVd", function(module, exports) {

$parcel$export(module.exports, "normaliseUrl", () => $c57c2115e83c7812$export$d57ae76c6dc57a5);
const $c57c2115e83c7812$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $c57c2115e83c7812$var$ATLAS_HOST = 'home.atlassian.com';
const $c57c2115e83c7812$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $c57c2115e83c7812$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $c57c2115e83c7812$var$ATLAS_HOST || parsedUrl.host === $c57c2115e83c7812$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$c57c2115e83c7812$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};

});



parcelRegister("1DkoF", function(module, exports) {

$parcel$export(module.exports, "AssistanceServiceImpl", () => $e9dc854f88cc6758$export$a522c5f4ccda1c94);
$parcel$export(module.exports, "AssistanceServiceProvider", () => $e9dc854f88cc6758$export$8fe647eb935c33db);
$parcel$export(module.exports, "useAssistanceService", () => $e9dc854f88cc6758$export$7e31a1844ebbaf85);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $XHGTv = parcelRequire("XHGTv");

var $557eF = parcelRequire("557eF");

var $bxiUx = parcelRequire("bxiUx");

var $cm6c0 = parcelRequire("cm6c0");

var $2zKwB = parcelRequire("2zKwB");

var $5s3f8 = parcelRequire("5s3f8");

var $lA7RZ = parcelRequire("lA7RZ");
const $e9dc854f88cc6758$var$PRODUCT_HEADER = 'x-product';
const $e9dc854f88cc6758$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
class $e9dc854f88cc6758$export$a522c5f4ccda1c94 {
    constructor(props){
        this.getConfig = ()=>{
            return {
                ...this.config
            };
        };
        this.getAgentActions = async ()=>{
            const response = await this.fetchJson({
                path: '/agents/configuration/v1/actions',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
            return response.actions;
        };
        const defaultConfig = {
            baseUrl: '/gateway/api/assist',
            headers: {}
        };
        this.config = {
            ...props,
            baseUrl: props.baseUrl || defaultConfig.baseUrl,
            headers: {
                ...props.headers || defaultConfig.headers
            }
        };
    }
    createHeaders(init) {
        return new Headers({
            [$e9dc854f88cc6758$var$PRODUCT_HEADER]: this.config.product,
            [$e9dc854f88cc6758$var$EXPERIENCE_ID_HEADER]: this.config.experienceId,
            ...this.config.headers || {},
            ...init || {}
        });
    }
    async fetch({ path: path, options: options, throwResponseOnError: throwResponseOnError = false }) {
        const { baseUrl: baseUrl } = this.config;
        const requestUrl = (0, $cm6c0.addPath)(baseUrl, path);
        const response = await (0, $lA7RZ.fetchFn)(requestUrl, options);
        return (0, $cm6c0.processResponse)({
            response: response,
            throwResponseOnError: throwResponseOnError
        });
    }
    async fetchJson({ path: path, options: options, throwResponseOnError: throwResponseOnError }) {
        const response = await this.fetch({
            path: path,
            options: options,
            throwResponseOnError: throwResponseOnError
        });
        const json = await response.json();
        return json;
    }
    async fetchStream({ path: path, options: options, throwResponseOnError: throwResponseOnError }) {
        const response = await this.fetch({
            path: path,
            options: options,
            throwResponseOnError: throwResponseOnError
        });
        return (0, $557eF.readJsonStream)(response);
    }
    async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, editorContext: editorContext, browserContext: browserContext, additionalContext: additionalContext }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        // If browserContext received and context is undefined, assume we're unable to retrieve the context of the page in focus
        const url = browserContext ? browserContext.context?.browserUrl : window?.location?.href;
        const body = {
            content: message,
            context: {
                browser_url: url,
                ...editorContext ? {
                    editor: editorContext
                } : {},
                // If browserUrl is inaccessable, fallback to htmlBody or canvasText if they exist
                ...browserContext ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText
                    }
                } : {},
                ...additionalContext
            },
            recipient_agent_named_id: agentNamedId,
            agent_id: agentId,
            mimeType: typeof message === 'string' ? 'text/markdown' : 'text/adf',
            // don't allow store message if feature flag is off
            store_message: (0, $XHGTv.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: citationsEnabled
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/chat/v1/channel/${conversationId}/message/stream`,
            options: options
        });
    }
    async getChat(conversationId) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const rawChat = await this.fetchJson({
            path: `/chat/v1/channel/${conversationId}/messages`,
            options: options
        });
        return rawChat.map((message)=>// Must be converted into StreamResponse
            (0, $bxiUx.isHumanMessage)(message) ? message : (0, $5s3f8.toStreamResponse)(message));
    }
    async deleteChat(conversationId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        await this.fetch({
            path: `/chat/v1/channel/${conversationId}`,
            options: options
        });
    }
    async getFeatures(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: 'features',
            options: options
        });
    }
    async getAgents(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: 'agents/v1',
            options: options
        });
    }
    async getAgentDetails(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `agents/v1/${id}`,
            options: options
        });
    }
    async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `agents/v1/accountid/${identityAccountId}`,
            options: options
        });
    }
    async getAgentFileUploadToken(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: 'agents/v1/media/upload/credentials',
            options: options
        });
    }
    async createAgent(payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        return this.fetchJson({
            path: '/agents/v1',
            options: options
        });
    }
    async updateAgent(id, payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: `/agents/v1/${id}`,
            options: options,
            throwResponseOnError: true
        });
        return response;
    }
    async deleteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/agents/v1/${id}`,
            options: options,
            throwResponseOnError: true
        });
    }
    async favouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'POST',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/agents/v1/${id}/favourite`,
            options: options,
            throwResponseOnError: true
        });
    }
    async unfavouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/agents/v1/${id}/favourite`,
            options: options,
            throwResponseOnError: true
        });
    }
    async createConversationChannel(options) {
        return this.fetchJson({
            path: '/chat/v1/channel',
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    name: options?.name ?? (0, $2zKwB.generateConversationName)(),
                    dialogues: options?.dialogues ?? undefined
                })
            }
        });
    }
    async getConversationChannels() {
        return this.fetchJson({
            path: '/chat/v1/channels',
            options: {
                method: 'GET',
                headers: this.createHeaders()
            }
        });
    }
    updateConversationChannel(id, payload) {
        return this.fetchJson({
            path: `/chat/v1/channel/${id}`,
            options: {
                method: 'PUT',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(payload)
            }
        });
    }
    async resolveConversationAction(id, payload) {
        return this.fetchJson({
            path: `/chat/v1/channel/${id}/action`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(payload)
            }
        });
    }
    async speechToText(blob) {
        const formData = new FormData();
        formData.append('audio_recording', blob);
        const response = await this.fetchJson({
            path: '/speech/inference',
            options: {
                method: 'POST',
                headers: this.createHeaders(),
                body: formData
            }
        });
        return response.transcription;
    }
    async generateConversationStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/agents/v1/suggest-conversation-starter',
            options: options
        });
    }
    async generateContextualConversationStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchStream({
            path: '/agents/v1/conversation-starter',
            options: options
        });
    }
}
const $e9dc854f88cc6758$var$AssistanceServiceContext = /*#__PURE__*/ (0, $eUqFw.createContext)(new $e9dc854f88cc6758$export$a522c5f4ccda1c94({
    baseUrl: '',
    product: '',
    experienceId: ''
}));
const $e9dc854f88cc6758$export$8fe647eb935c33db = ({ value: value, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9dc854f88cc6758$var$AssistanceServiceContext.Provider, {
        value: value
    }, children);
const $e9dc854f88cc6758$export$7e31a1844ebbaf85 = (props)=>{
    (0, $asu8X.di)((0, $eUqFw.useContext), $e9dc854f88cc6758$export$a522c5f4ccda1c94);
    const service = (0, $eUqFw.useContext)($e9dc854f88cc6758$var$AssistanceServiceContext);
    if (!props || !props.experienceId && !props.product) return service;
    return new $e9dc854f88cc6758$export$a522c5f4ccda1c94({
        ...service.getConfig(),
        product: props.product ?? service.getConfig().product,
        experienceId: props.experienceId ?? service.getConfig().experienceId
    });
};

});
parcelRegister("557eF", function(module, exports) {

$parcel$export(module.exports, "readJsonStream", () => $a80f6e356c62f163$export$1f24b2b263bcfa75);

var $8acmF = parcelRequire("8acmF");
async function* $a80f6e356c62f163$export$1f24b2b263bcfa75(response) {
    const reader = (0, $8acmF.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                yield JSON.parse(chunk);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}

});
parcelRegister("8acmF", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $f4d81fef4da7e14c$export$f6383c3ea1307da9);
const $f4d81fef4da7e14c$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};

});


parcelRegister("bxiUx", function(module, exports) {

$parcel$export(module.exports, "isHumanMessage", () => $8a04ac5703dd9200$export$a69fab2afb88c2eb);
$parcel$export(module.exports, "isAssistantMessage", () => $8a04ac5703dd9200$export$6f965deda7f0960c);
$parcel$export(module.exports, "isStreamResponse", () => $8a04ac5703dd9200$export$b4631726cbc1440a);
$parcel$export(module.exports, "isAgentResponse", () => $8a04ac5703dd9200$export$a6e5100ca2770191);
$parcel$export(module.exports, "isStreamError", () => $8a04ac5703dd9200$export$d422a2733a3b5def);
$parcel$export(module.exports, "isStreamAUPError", () => $8a04ac5703dd9200$export$1e1cf807ece63df4);
$parcel$export(module.exports, "isStreamAnswerPart", () => $8a04ac5703dd9200$export$e45102edbc73b240);
$parcel$export(module.exports, "isStreamTrace", () => $8a04ac5703dd9200$export$fd5a05be03f147a0);
$parcel$export(module.exports, "isStreamPluginInvocation", () => $8a04ac5703dd9200$export$51a1b4e474708d74);
$parcel$export(module.exports, "isFollowUpMessage", () => $8a04ac5703dd9200$export$aeae5b4fda357302);
$parcel$export(module.exports, "isChannelNotFoundError", () => $8a04ac5703dd9200$export$6ce1ccc24e75456f);
$parcel$export(module.exports, "isRateLimitedError", () => $8a04ac5703dd9200$export$bc96a6a479480590);
$parcel$export(module.exports, "isConversationChannelDataMessage", () => $8a04ac5703dd9200$export$b454081350f4a578);

var $cfr3D = parcelRequire("cfr3D");
const $8a04ac5703dd9200$export$5945515082cc2cbf = 'CONVERSATION_CHANNEL_NOT_FOUND';
const $8a04ac5703dd9200$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
const $8a04ac5703dd9200$export$fb661125ffb29bd6 = (message)=>{
    return $8a04ac5703dd9200$export$a69fab2afb88c2eb(message) || $8a04ac5703dd9200$export$6f965deda7f0960c(message) || $8a04ac5703dd9200$export$b4631726cbc1440a(message);
};
const $8a04ac5703dd9200$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $8a04ac5703dd9200$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $8a04ac5703dd9200$export$a6e5100ca2770191 = (message)=>message instanceof Object && $8a04ac5703dd9200$export$6f965deda7f0960c(message.message);
const $8a04ac5703dd9200$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $8a04ac5703dd9200$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $8a04ac5703dd9200$export$1e1cf807ece63df4 = (message)=>$8a04ac5703dd9200$export$d422a2733a3b5def(message) && message.message?.message_template === $8a04ac5703dd9200$export$c424fe9570a5f2d9;
const $8a04ac5703dd9200$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $8a04ac5703dd9200$export$fd5a05be03f147a0 = (message)=>message instanceof Object && message.type === 'TRACE';
const $8a04ac5703dd9200$export$51a1b4e474708d74 = (message)=>message instanceof Object && message.type === 'PLUGIN_INVOCATION';
const $8a04ac5703dd9200$export$821c27cda9a33379 = (message)=>message instanceof Object && message.role === 'PLUGIN_INVOCATION';
const $8a04ac5703dd9200$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $8a04ac5703dd9200$export$6ce1ccc24e75456f = (error)=>(0, $cfr3D.isApiError)(error) && error.metadata?.errorCode === $8a04ac5703dd9200$export$5945515082cc2cbf;
const $8a04ac5703dd9200$export$bc96a6a479480590 = (error)=>(0, $cfr3D.isApiError)(error) && error.metadata.statusCode === 429;
const $8a04ac5703dd9200$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';

});
parcelRegister("cfr3D", function(module, exports) {

$parcel$export(module.exports, "ApiError", () => $d45584f6148535cd$export$f2e832acab1bdd79);
$parcel$export(module.exports, "isApiError", () => $d45584f6148535cd$export$89d83cc97c52a37);
$parcel$export(module.exports, "mapErrorToApiError", () => $d45584f6148535cd$export$3c02d1a328d4d808);
class $d45584f6148535cd$export$f2e832acab1bdd79 extends Error {
    constructor(message, metadata){
        super(message);
        this.message = message;
        this.metadata = metadata;
    }
}
const $d45584f6148535cd$export$89d83cc97c52a37 = (error)=>error instanceof $d45584f6148535cd$export$f2e832acab1bdd79;
const $d45584f6148535cd$export$3c02d1a328d4d808 = (error)=>{
    if ($d45584f6148535cd$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $d45584f6148535cd$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};

});


parcelRegister("cm6c0", function(module, exports) {

$parcel$export(module.exports, "addPath", () => $8588739682628087$export$4c25481b843feb0b);
$parcel$export(module.exports, "processResponse", () => $8588739682628087$export$21fcb6cfd5628534);

var $cfr3D = parcelRequire("cfr3D");
const $8588739682628087$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
const $8588739682628087$var$processErrorResponse = async ({ response: response, throwResponseOnError: throwResponseOnError })=>{
    if (throwResponseOnError) {
        const result = await response.json();
        throw result;
    }
    let errorCode;
    let outputErrorMessage;
    const responseText = await response.text();
    try {
        const errorBodyJson = JSON.parse(responseText);
        const { error_code: error_code, error_message: error_message, message_template: message_template, errors: errors, errorMessage: errorMessage } = errorBodyJson;
        const errorMessageText = errorMessage ?? error_message;
        if (errors?.length) // Use a single error code for now
        errorCode = errors[0];
        else if (error_code) errorCode = error_code;
        else errorCode = message_template;
        if (!errorCode || !errorMessageText) outputErrorMessage = responseText;
        else outputErrorMessage = `${errorCode} - ${errorMessageText}`;
    } catch (err) {
        outputErrorMessage = responseText;
    }
    throw new (0, $cfr3D.ApiError)(`[Code ${response.status}] ${outputErrorMessage}`, {
        errorCode: errorCode,
        statusCode: response.status
    });
};
const $8588739682628087$export$21fcb6cfd5628534 = async ({ response: response, throwResponseOnError: throwResponseOnError })=>{
    if (!response.ok || response.status >= 400) await $8588739682628087$var$processErrorResponse({
        response: response,
        throwResponseOnError: throwResponseOnError
    });
    return response;
};

});

parcelRegister("2zKwB", function(module, exports) {

$parcel$export(module.exports, "generateConversationName", () => $ece6dfd9e7920834$export$11cc4786742ed7c2);
const $ece6dfd9e7920834$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};

});

parcelRegister("5s3f8", function(module, exports) {

$parcel$export(module.exports, "getId", () => $1e57ca9768887963$export$218c8c3169c024d2);
$parcel$export(module.exports, "updatePluginInvocation", () => $1e57ca9768887963$export$a76cc257b3881cb7);
$parcel$export(module.exports, "addAnswerPart", () => $1e57ca9768887963$export$6e5609c05ab74cc7);
$parcel$export(module.exports, "removeSensitiveData", () => $1e57ca9768887963$export$efd4f6b5d168b654);
$parcel$export(module.exports, "createHumanMessage", () => $1e57ca9768887963$export$4010f996e89e886a);
$parcel$export(module.exports, "toStreamResponse", () => $1e57ca9768887963$export$3220a4ff7b3a96df);

var $bxiUx = parcelRequire("bxiUx");
const $1e57ca9768887963$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $1e57ca9768887963$var$updatePluginInvocationAssistantMessage = (response, streamPluginInvocation)=>{
    const { message: pluginInvocation } = streamPluginInvocation;
    const pluginInvocationMessage = {
        message_id: response.id,
        ...pluginInvocation
    };
    const updatedMessage = {
        ...response
    };
    const updatedPluginInvocations = [
        ...updatedMessage.plugin_invocations
    ];
    const currentIndex = updatedPluginInvocations.findIndex((pi)=>pi.plugin_name === pluginInvocationMessage.plugin_name);
    if (currentIndex === -1) updatedPluginInvocations.push(pluginInvocationMessage);
    else updatedPluginInvocations[currentIndex] = pluginInvocationMessage;
    updatedMessage.plugin_invocations = updatedPluginInvocations;
    return updatedMessage;
};
const $1e57ca9768887963$var$updatePluginInvocationAgentResponse = (response, streamPluginInvocation)=>({
        ...response,
        message: $1e57ca9768887963$var$updatePluginInvocationAssistantMessage(response.message, streamPluginInvocation)
    });
const $1e57ca9768887963$export$a76cc257b3881cb7 = (response, streamPluginInvocation)=>({
        ...response,
        message: $1e57ca9768887963$var$updatePluginInvocationAgentResponse(response.message, streamPluginInvocation)
    });
const $1e57ca9768887963$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $1e57ca9768887963$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $1e57ca9768887963$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
const $1e57ca9768887963$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $1e57ca9768887963$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $1e57ca9768887963$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $1e57ca9768887963$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $1e57ca9768887963$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $1e57ca9768887963$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $1e57ca9768887963$var$removeSensitiveDataAgentResponse(message.message)
    });
const $1e57ca9768887963$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId
    };
};
const $1e57ca9768887963$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $bxiUx.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};
const $1e57ca9768887963$export$6304914e90dcefe0 = ()=>({
        account_id: '',
        cloud_id: '',
        env: '',
        env_type: '',
        model: '',
        ai_enabled_on_site: false,
        assistance_feature_enabled: false,
        debug_enabled: false
    });

});

parcelRegister("lA7RZ", function(module, exports) {

$parcel$export(module.exports, "fetchFn", () => $de59aa9f38bde4ce$export$10f0d162cb6dae7c);
const $de59aa9f38bde4ce$export$10f0d162cb6dae7c = window.fetch;

});


parcelRegister("6n1kb", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $a17d33a204558ba9$export$dd0a697e1782aedd);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $WBLbN = parcelRequire("WBLbN");

var $cfr3D = parcelRequire("cfr3D");
const $a17d33a204558ba9$var$store = (0, $WBLbN.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            }
    }
});
const $a17d33a204558ba9$var$selector = (0, $WBLbN.createSelector)((state)=>state.cache, (_, key)=>key, (cache, key)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: false
    });
const $a17d33a204558ba9$var$useCacheEntry = (0, $WBLbN.createHook)($a17d33a204558ba9$var$store, {
    selector: $a17d33a204558ba9$var$selector
});
const $a17d33a204558ba9$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $eUqFw.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $eUqFw.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $eUqFw.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $a17d33a204558ba9$var$useCacheEntry(queryKey);
    const fetchData = (0, $eUqFw.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response
            });
            onSuccessRef.current?.(response);
        } catch (error) {
            const apiError = (0, $cfr3D.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $74BVL.bind)(window, {
                type: 'focus',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) fetchData();
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData
    };
};

});


parcelRegister("b2XvR", function(module, exports) {

$parcel$export(module.exports, "useDialog", () => $319c7dc791b5bd18$export$d55e7ee900f34e93);

var $eUqFw = parcelRequire("eUqFw");

var $73k7H = parcelRequire("73k7H");
const $319c7dc791b5bd18$export$d55e7ee900f34e93 = ()=>{
    return (0, $eUqFw.useContext)((0, $73k7H.DialogsContext));
};

});

parcelRegister("hWnzK", function(module, exports) {

$parcel$export(module.exports, "useExpTrackerStart", () => $900818a9c0895379$export$3ec42c6cc9df311c);

var $eUqFw = parcelRequire("eUqFw");

var $ft6b2 = parcelRequire("ft6b2");

var $74Hyh = parcelRequire("74Hyh");
function $900818a9c0895379$export$3ec42c6cc9df311c(options) {
    const { id: id, name: name, timeout: timeout, isTriggerOnMount: isTriggerOnMount = true, subExperiences: subExperiences, latencySloMs: latencySloMs, startAttributes: startAttributes, onSuccess: onSuccess } = options;
    const analytics = (0, $74Hyh.default)();
    const tracker = analytics.expTracker();
    const triggerStartEvent = (0, $eUqFw.useCallback)(()=>{
        const options = {
            id: id,
            name: name,
            timeout: timeout,
            collect: undefined,
            attributes: startAttributes,
            onSuccess: onSuccess
        };
        if (subExperiences) options.collect = (0, $ft6b2.collectAll)(subExperiences);
        if (latencySloMs) options.attributes = {
            latencySlo: latencySloMs
        };
        tracker.start(options);
    }, [
        id,
        name,
        timeout,
        startAttributes,
        onSuccess,
        subExperiences,
        latencySloMs,
        tracker
    ]);
    const triggerSuccessEvent = (0, $eUqFw.useCallback)(()=>{
        tracker.succeed({
            name: name
        });
    }, [
        name,
        tracker
    ]);
    const triggerFailEvent = (0, $eUqFw.useCallback)((error)=>{
        tracker.stopOnError({
            name: name,
            error: error
        });
    }, [
        name,
        tracker
    ]);
    const triggerAbortEvent = (0, $eUqFw.useCallback)((reason)=>{
        tracker.abort({
            name: name,
            reason: reason
        });
    }, [
        name,
        tracker
    ]);
    // we use 'useState' here because we want to trigger start event as soon as possible, before rendering component,
    (0, $eUqFw.useState)(()=>{
        // default behaviour: trigger start event when mounting.
        // "isTriggerOnMount=false" is allow to turn off the default behaviour.
        if (isTriggerOnMount) triggerStartEvent();
    });
    // allow to trigger start event whenever consumers want like inside onClick.
    return {
        start: triggerStartEvent,
        succeed: triggerSuccessEvent,
        abort: triggerAbortEvent,
        fail: triggerFailEvent
    };
}

});
parcelRegister("ft6b2", function(module, exports) {

$parcel$export(module.exports, "collectAll", () => $9bc91ab382327f8b$export$feb7963ae429f97f);
$parcel$export(module.exports, "collectAny", () => $9bc91ab382327f8b$export$79dbdd3e43727beb);

var $leHv2 = parcelRequire("leHv2");
function $9bc91ab382327f8b$export$feb7963ae429f97f(experienceNames) {
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')));
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $leHv2.isStop)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
}
function $9bc91ab382327f8b$export$79dbdd3e43727beb(experienceNames) {
    return (events, experience)=>experience.stopOn(events.find((event)=>(0, $leHv2.isStop)(event) && (0, $leHv2.hasName)(event, ...experienceNames)));
}

});


parcelRegister("elP2D", function(module, exports) {

$parcel$export(module.exports, "useExpTrackerStop", () => $8ec2dddd4be05add$export$432668e70196929c);

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $74Hyh = parcelRequire("74Hyh");
function $8ec2dddd4be05add$export$432668e70196929c(options) {
    const { name: name, error: error, checkShouldAbort: checkShouldAbort } = options;
    const analytics = (0, $74Hyh.default)();
    const tracker = analytics.expTracker();
    (0, $eUqFw.useEffect)(()=>{
        const triggerStopEvent = ()=>{
            if (!error) return;
            // If error has a statusCode of 429, abort instead.
            if ($8ec2dddd4be05add$var$isRateLimitError(error)) {
                abortExpTracker(`Ignoring 429 error: ${error.message}`);
                return;
            }
            tracker.stopOnError({
                name: name,
                error: error
            });
        };
        const abortExpTracker = (reason)=>{
            tracker.abort({
                name: name,
                reason: reason
            });
        };
        if (error) {
            const reason = checkShouldAbort ? checkShouldAbort(error) : undefined;
            if (typeof reason === 'string' || $8ec2dddd4be05add$var$isRateLimitError(error)) abortExpTracker(reason ?? `Ignoring 429 error: ${error.message}`);
            else triggerStopEvent();
        }
    }, [
        checkShouldAbort,
        error,
        name,
        tracker
    ]);
}
const $8ec2dddd4be05add$var$isRateLimitError = (error)=>{
    if (error instanceof (0, $jlBDe.ApolloError) && error.networkError) return $8ec2dddd4be05add$var$isRateLimitError(error.networkError);
    return 'statusCode' in error && error.statusCode === 429 || 'status' in error && error.status === 429 || error.message.includes('429');
};

});

parcelRegister("iNIpe", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_TIMEOUT_USER_EXP", () => $dc425c21f8648fe1$export$6a2b57b882ff619b);
$parcel$export(module.exports, "UserExperienceNames", () => $dc425c21f8648fe1$export$aff1d63763bf8a44);
$parcel$export(module.exports, "TEAM_PROFILE_PAGE_SUB_EVENT_NAMES", () => $dc425c21f8648fe1$export$f6872ed66cc3dc3a);
$parcel$export(module.exports, "USER_PROFILE_PAGE_SUB_EVENT_NAMES", () => $dc425c21f8648fe1$export$e302f7a9166a33eb);
$parcel$export(module.exports, "SEARCH_HOME_PAGE_SUB_EVENT_NAMES", () => $dc425c21f8648fe1$export$ab5c192ffd15cb07);
$parcel$export(module.exports, "CREATE_TEAM_FLOW_SUB_EVENT_NAMES", () => $dc425c21f8648fe1$export$bebaacf4c0d1b056);
// Use defaut timeout from Confluence
// https://stash.atlassian.com/projects/confcloud/repos/confluence-frontend/browse/next/packages/experience-tracker/src/ExperienceTimeout.ts#2
const $dc425c21f8648fe1$export$6a2b57b882ff619b = 60000; // 60s
const $dc425c21f8648fe1$export$c816bd9ab77da948 = 15000; // 15s
var $dc425c21f8648fe1$export$aff1d63763bf8a44;
(function(UserExperienceNames) {
    UserExperienceNames["CREATE_TEAM"] = "createTeam";
    UserExperienceNames["CREATE_TEAM_OPEN_DIALOG"] = "createTeam/openDialog";
    UserExperienceNames["CREATE_TEAM_SUBMIT"] = "createTeam/create";
    // a compound experience
    UserExperienceNames["TEAM_PROFILE_PAGE"] = "teamProfile/render";
    UserExperienceNames["TEAM_PROFILE_MEMBERS"] = "teamProfile/membersPanel";
    UserExperienceNames["TEAM_PROFILE_LINKS"] = "teamProfile/links";
    UserExperienceNames["TEAM_PROFILE_WORKED_ON"] = "teamProfile/workedOn";
    UserExperienceNames["TEAM_PROFILE_TEAM_ABOUT"] = "teamProfile/teamAboutPanel";
    UserExperienceNames["TEAM_PROFILE_PROJECTS_AND_GOALS"] = "teamProfile/projectsAndGoals";
    UserExperienceNames["TEAM_PROFILE_HELP_POINTERS"] = "teamProfile/helpPointers";
    UserExperienceNames["TEAM_PROFILE_KUDOS"] = "teamProfile/kudos";
    UserExperienceNames["TEAM_PROFILE_SOFTWARE_COMPONENTS"] = "teamProfile/softwareComponents";
    UserExperienceNames["USER_PROFILE_AI_TOPICS"] = "userProfile/aiTopics";
    // a compound experience
    UserExperienceNames["USER_PROFILE_PAGE"] = "userProfile/render";
    UserExperienceNames["USER_PROFILE_PAGE_SLOW"] = "userProfile/renderSlow";
    UserExperienceNames["USER_PROFILE_WORKED_ON"] = "userProfile/workedOn";
    UserExperienceNames["USER_PROFILE_CONTAINERS"] = "userProfile/container";
    UserExperienceNames["USER_PROFILE_USER_ABOUT"] = "userProfile/userAbout";
    UserExperienceNames["USER_PROFILE_COLLABORATORS"] = "userProfile/collaborators";
    UserExperienceNames["USER_PROFILE_USERS_TEAMS"] = "userProfile/usersTeams";
    UserExperienceNames["USER_PROFILE_USER_MANAGER"] = "userProfile/userManager";
    UserExperienceNames["USER_PROFILE_TAG"] = "userProfile/tag";
    // a compound experience
    UserExperienceNames["SEARCH_HOME_PAGE"] = "searchHomePage/render";
    UserExperienceNames["SEARCH_HOME_PAGE_COLLABORATORS"] = "searchHomePage/collaborators";
    UserExperienceNames["SEARCH_HOME_PAGE_YOUR_TEAMS"] = "searchHomePage/yourTeams";
    UserExperienceNames["USER_PROFILE_PROJECTS_AND_GOALS"] = "userProfile/projectsAndGoals";
    UserExperienceNames["USER_PROFILE_MANAGERS_AND_TEAMS"] = "userProfile/managersAndTeams";
    UserExperienceNames["USER_PROFILE_KUDOS"] = "userProfile/kudos";
    // edit team name or description from Team profile page
    UserExperienceNames["EDIT_TEAM_NAME_OR_DESCRIPTION"] = "editTeamNameOrDescription";
    // remove team member
    UserExperienceNames["REMOVE_TEAM_MEMBER"] = "removeTeamMember";
    UserExperienceNames["REMOVE_TEAM_MEMBER_OPEN_DIALOG"] = "removeTeamMember/openDialog";
    UserExperienceNames["REMOVE_TEAM_MEMBER_SUBMIT"] = "removeTeamMember/submit";
    // upload user avatar from User profile page
    UserExperienceNames["UPLOAD_USER_AVATAR"] = "uploadUserAvatar";
    UserExperienceNames["UPLOAD_HEADER_IMAGE"] = "uploadHeaderImage";
    // team membership control changing
    UserExperienceNames["MEMBERSHIP_CONTROL_CHANGE"] = "membershipControl/change";
    UserExperienceNames["MEMBERSHIP_CONTROL_HANDLE_REQUESTS"] = "membershipControl/handleRequests";
    UserExperienceNames["MEMBERSHIP_CONTROL_TEAM_TYPE"] = "membershipControl/teamType";
    // agent profile page
    UserExperienceNames["AGENT_PROFILE_PAGE"] = "agentProfile/render";
})($dc425c21f8648fe1$export$aff1d63763bf8a44 || ($dc425c21f8648fe1$export$aff1d63763bf8a44 = {}));
const $dc425c21f8648fe1$export$f6872ed66cc3dc3a = [
    "teamProfile/membersPanel",
    "teamProfile/links",
    "teamProfile/workedOn",
    "teamProfile/teamAboutPanel"
];
const $dc425c21f8648fe1$export$e302f7a9166a33eb = [
    "userProfile/userAbout",
    "userProfile/usersTeams",
    "userProfile/workedOn",
    "userProfile/container",
    "userProfile/collaborators"
];
const $dc425c21f8648fe1$export$ab5c192ffd15cb07 = [
    "searchHomePage/collaborators",
    "searchHomePage/yourTeams"
];
const $dc425c21f8648fe1$export$bebaacf4c0d1b056 = [
    "createTeam/openDialog",
    "createTeam/create"
];
const $dc425c21f8648fe1$export$74d8df99c7474c3b = [
    "removeTeamMember/openDialog",
    "removeTeamMember/submit"
];

});

parcelRegister("j9wA1", function(module, exports) {

$parcel$export(module.exports, "filterExcludedMessages", () => $4bb3163e6510fef5$export$c29ee7cc86cf93b3);
$parcel$export(module.exports, "ORG_ARI_PREFIX", () => $4bb3163e6510fef5$export$1c01d3601a97c3b);
$parcel$export(module.exports, "fromV2ToTeamSearchViewFormat", () => $4bb3163e6510fef5$export$af61e778dfb162b1);
$parcel$export(module.exports, "trimUserARI", () => $4bb3163e6510fef5$export$4fd803d471120b8f);
const $4bb3163e6510fef5$var$EXCLUDED_GRAPHQL_ERROR_MESSAGES = [
    'TeamDeleted'
];
function $4bb3163e6510fef5$export$c29ee7cc86cf93b3(errors) {
    return errors.filter((error)=>$4bb3163e6510fef5$var$EXCLUDED_GRAPHQL_ERROR_MESSAGES.every((excludedMessage)=>!error.message.includes(excludedMessage)) && error?.extensions?.classification !== 'TEAMS_TEAM_DELETED');
}
const $4bb3163e6510fef5$export$ec4e6762fd0f4a48 = 'ari:cloud:teams::team/';
const $4bb3163e6510fef5$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';
const $4bb3163e6510fef5$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $4bb3163e6510fef5$export$1c01d3601a97c3b = 'ari:cloud:platform::org/';
const $4bb3163e6510fef5$export$af61e778dfb162b1 = (nodes)=>{
    return nodes.map((node)=>{
        return {
            id: $4bb3163e6510fef5$export$5916b2f8faacfe5a(node.team.id),
            orgId: node.team.organizationId,
            membershipSettings: node.team.membershipSettings,
            description: node.team.description,
            displayName: node.team.displayName,
            state: node.team.state,
            largeAvatarImageUrl: node.team.largeAvatarImageUrl,
            smallAvatarImageUrl: node.team.smallAvatarImageUrl,
            largeHeaderImageUrl: node.team.largeHeaderImageUrl,
            smallHeaderImageUrl: node.team.smallHeaderImageUrl,
            members: node.team.members?.nodes?.filter((memberNode)=>memberNode.member?.id)?.map((memberNode)=>({
                    id: $4bb3163e6510fef5$export$4fd803d471120b8f(memberNode.member?.id),
                    status: memberNode.member?.accountStatus,
                    fullName: memberNode.member?.name || '',
                    avatarUrl: memberNode.member?.picture
                })),
            memberCount: node.memberCount,
            includesYou: node.includesYou
        };
    });
};
const $4bb3163e6510fef5$export$5916b2f8faacfe5a = (teamId = '')=>{
    return teamId.replace($4bb3163e6510fef5$export$cfedc369802e0c68, '').replace($4bb3163e6510fef5$export$ec4e6762fd0f4a48, ''); // PTC-4213 will remove the references to the old team ARI
};
const $4bb3163e6510fef5$export$4fd803d471120b8f = (userId = '')=>{
    return userId.replace($4bb3163e6510fef5$export$470b0d72e4fdc43a, '');
};
const $4bb3163e6510fef5$export$a94a044414e86bdc = (orgId)=>{
    return orgId?.replace($4bb3163e6510fef5$export$1c01d3601a97c3b, '');
};

});

parcelRegister("5OFKT", function(module, exports) {

$parcel$export(module.exports, "useRovoAgentData", () => $fd087b40596c6bba$export$763c7f4444e7eb2d);

var $WBLbN = parcelRequire("WBLbN");
const $fd087b40596c6bba$var$setAgentInfo = (data)=>({ setState: setState })=>{
        setState({
            agentData: data
        });
    };
const $fd087b40596c6bba$var$actions = {
    setAgentInfo: $fd087b40596c6bba$var$setAgentInfo
};
const $fd087b40596c6bba$var$RovoAgentStore = (0, $WBLbN.createStore)({
    initialState: {
        agentData: undefined
    },
    actions: $fd087b40596c6bba$var$actions
});
const $fd087b40596c6bba$export$6301922aaad7e8f5 = (0, $WBLbN.createHook)($fd087b40596c6bba$var$RovoAgentStore, {
    selector: (state)=>state.agentData
});
const $fd087b40596c6bba$export$763c7f4444e7eb2d = (0, $WBLbN.createHook)($fd087b40596c6bba$var$RovoAgentStore);

});

parcelRegister("4vhsL", function(module, exports) {

$parcel$export(module.exports, "App", () => $6241b55617e5ad9a$export$86fbec116b87613f);
$parcel$export(module.exports, "RelativeWrapperOfHeaderImage", () => $6241b55617e5ad9a$export$c0d0370fa0c37541);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $6241b55617e5ad9a$export$86fbec116b87613f = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ccxr90-0"
})`height:100%;*{box-sizing:border-box;}a:hover{text-decoration:none;}`;
const $6241b55617e5ad9a$export$c0d0370fa0c37541 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ccxr90-1"
})`position:relative;`;

});

parcelRegister("kZURK", function(module, exports) {

$parcel$export(module.exports, "useAppConfig", () => $153d740657af5726$export$a3e0ece8c3f698d7);
$parcel$export(module.exports, "default", () => $153d740657af5726$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $153d740657af5726$var$error = new Error('AppConfigProvider is not found in higher components');
const $153d740657af5726$var$defaultState = {
    addFlag: ()=>{
        throw $153d740657af5726$var$error;
    },
    push: ()=>{
        throw $153d740657af5726$var$error;
    },
    replace: ()=>{
        throw $153d740657af5726$var$error;
    },
    history: undefined,
    contextSpaPaths: [],
    contextEntryPoint: '',
    docTitle: {},
    appName: '',
    productName: '',
    env: undefined,
    cloudId: '',
    isJiraAvailable: false,
    productFeatureFlags: {},
    orgId: undefined
};
const $153d740657af5726$var$AppConfigContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($153d740657af5726$var$defaultState);
const $153d740657af5726$export$a3e0ece8c3f698d7 = ()=>{
    return (0, $eUqFw.useContext)($153d740657af5726$var$AppConfigContext);
};
var $153d740657af5726$export$2e2bcd8739ae039 = $153d740657af5726$var$AppConfigContext;

});

parcelRegister("6r9ui", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ed2665c5d761a44$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gakch = parcelRequire("gakch");

var $8vv9I = parcelRequire("8vv9I");
var $drtHI = parcelRequire("drtHI");

var $7fnBH = parcelRequire("7fnBH");
function $7ed2665c5d761a44$var$ContainersInProfilePage(props) {
    const { userId: userId, status: status, userFullName: userFullName } = props;
    const [{ principalUserId: principalUserId }] = (0, $gakch.usePrincipalUser)();
    const { error: error, hasError: hasError, data: data, loading: loading } = (0, $7fnBH.default)({
        userId: userId,
        maxNumberOfCards: (0, $8vv9I.DEFAULT_CARDS_SIZE)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $drtHI.default), {
        hasLoaded: !!data && !loading,
        isCurrentUser: principalUserId === userId,
        userStatus: status,
        hasError: hasError,
        error: error,
        items: data,
        userId: userId,
        userFullName: userFullName
    });
}
var $7ed2665c5d761a44$export$2e2bcd8739ae039 = $7ed2665c5d761a44$var$ContainersInProfilePage;

});
parcelRegister("8vv9I", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CARDS_SIZE", () => $8f1d023661cb18ca$export$eea11e2ee6ebb03f);

var $drtHI = parcelRequire("drtHI");
const $8f1d023661cb18ca$export$eea11e2ee6ebb03f = 4;

});
parcelRegister("drtHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e517b91468353b90$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");

var $iNIpe = parcelRequire("iNIpe");
var $2lryl = parcelRequire("2lryl");
var $hWnzK = parcelRequire("hWnzK");
var $elP2D = parcelRequire("elP2D");
var $7RUjl = parcelRequire("7RUjl");

var $8VkCG = parcelRequire("8VkCG");

var $2r2pX = parcelRequire("2r2pX");

var $lwh18 = parcelRequire("lwh18");

var $fKtEI = parcelRequire("fKtEI");
const $e517b91468353b90$var$MAX_PLACES_LIMIT = 50;
function $e517b91468353b90$var$ProfilePlaces(props) {
    const { hasError: hasError, error: error, hasLoaded: hasLoaded, isCurrentUser: isCurrentUser, userStatus: userStatus, items: items = [], userId: userId, userFullName: userFullName } = props;
    (0, $hWnzK.useExpTrackerStart)({
        id: userId,
        name: (0, $iNIpe.UserExperienceNames).USER_PROFILE_CONTAINERS,
        timeout: (0, $iNIpe.DEFAULT_TIMEOUT_USER_EXP)
    });
    (0, $elP2D.useExpTrackerStop)({
        name: (0, $iNIpe.UserExperienceNames).USER_PROFILE_CONTAINERS,
        error: error
    });
    const renderSkeleton = ()=>{
        const defaultNumOfPlaces = 4;
        return Array(defaultNumOfPlaces).fill(undefined).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lwh18.default), {
                key: `item-${index}`,
                type: "space",
                name: "",
                path: "",
                hasLoaded: false
            }));
    };
    const renderPlacesList = ()=>{
        /**
		 * NOTE: Following is just a hack to limit the total number of boards.
		 * In real life the total number of places will be far less than this.
		 * But since there's no guarantee that the backend will not be sending
		 * a very large number of boards, the following limit is enforced.
		 */ const places = items.slice(0, $e517b91468353b90$var$MAX_PLACES_LIMIT);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fKtEI.ProfilePlacesList, {
            "data-test-selector": "profile-places"
        }, hasLoaded ? places.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lwh18.default), {
                key: `${item.type}-${item.name}`,
                type: item.type,
                name: item.name,
                path: item.path,
                icon: item.icon,
                hasLoaded: true
            })) : renderSkeleton());
    };
    const headline = isCurrentUser ? $e517b91468353b90$export$defe85febe8b728c.ownerHeadline : userStatus === (0, $7RUjl.UserStatus).inactive || userStatus === (0, $7RUjl.UserStatus).closed ? $e517b91468353b90$export$defe85febe8b728c.otherHeadlinePast : $e517b91468353b90$export$defe85febe8b728c.otherHeadline;
    // loading --> rendering skeleton
    // not loading + empty data --> rendering empty state and ExperienceSuccess
    // not loading + has error --> rendering nothing and "useExpTrackerStop" will trigger the stop experience event.
    // not loading + has data --> render UI and ExperienceSuccess
    if (hasLoaded && !hasError && items.length === 0) // trigger success event when data is loaded but it's empty
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2r2pX.PanelContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2r2pX.PanelContentHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2r2pX.PanelContentTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), headline))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fKtEI.EmptyPlacesList, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8VkCG.default), {
        isCurrentUser: isCurrentUser || false,
        userFullName: userFullName,
        userStatus: userStatus
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2lryl.ExperienceSuccess), {
        hasLoaded: true,
        name: (0, $iNIpe.UserExperienceNames).USER_PROFILE_CONTAINERS
    }));
    if (hasError) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2r2pX.PanelContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2r2pX.PanelContentHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2r2pX.PanelContentTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), headline))), renderPlacesList(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2lryl.ExperienceSuccess), {
        hasLoaded: hasLoaded && !hasError,
        name: (0, $iNIpe.UserExperienceNames).USER_PROFILE_CONTAINERS
    }));
}
const $e517b91468353b90$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    ownerHeadline: {
        id: 'pf-home.profile-page.places-list.owner.headline',
        defaultMessage: 'Places you work in',
        description: 'Section headline for Places where a users personal Confluence space and Jira boards shown to profile owner'
    },
    otherHeadline: {
        id: 'pf-home.profile-page.places-list.other.headline',
        defaultMessage: 'Places they work in',
        description: 'Section headline for Places where a users personal Confluence space and Jira boards shown to a profile visitor'
    },
    otherHeadlinePast: {
        id: 'pf-home.profile-page.places-list.other.headline-past',
        defaultMessage: 'Places they work in',
        description: 'Section headline for Places where a deactivated or deleted users personal Confluence space and Jira boards shown to a profile visitor'
    }
});
var $e517b91468353b90$export$2e2bcd8739ae039 = $e517b91468353b90$var$ProfilePlaces;

});
parcelRegister("2lryl", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccess", () => $b88b941b211c1efe$export$4962f3898bd5c829);

var $eUqFw = parcelRequire("eUqFw");

var $fItxu = parcelRequire("fItxu");
function $b88b941b211c1efe$export$4962f3898bd5c829(props) {
    const { hasLoaded: hasLoaded, name: name, attributes: attributes } = props;
    if (!hasLoaded) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fItxu.ExperienceSuccess), {
        name: name,
        attributes: attributes
    });
}

});
parcelRegister("fItxu", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccess", () => $87ed4ea7384910e9$export$4962f3898bd5c829);

var $eUqFw = parcelRequire("eUqFw");

var $1xrmr = parcelRequire("1xrmr");
function $87ed4ea7384910e9$export$4962f3898bd5c829({ name: name, attributes: attributes }) {
    const experienceTracker = (0, $eUqFw.useContext)((0, $1xrmr.ExperienceTrackerContext));
    (0, $eUqFw.useEffect)(()=>experienceTracker.succeed({
            name: name,
            attributes: attributes
        }), [
        name,
        attributes,
        experienceTracker
    ]);
    return null;
}

});


parcelRegister("7RUjl", function(module, exports) {

$parcel$export(module.exports, "UserStatus", () => $882aaec64a960ca8$export$a82073022ded66e8);
$parcel$export(module.exports, "FieldType", () => $882aaec64a960ca8$export$ed12481c953b8653);
var $882aaec64a960ca8$export$ef730685c1b8e238;
(function(UserPrivacyLevel) {
    UserPrivacyLevel["private"] = "private";
    UserPrivacyLevel["domain"] = "domain";
    UserPrivacyLevel["public"] = "public";
})($882aaec64a960ca8$export$ef730685c1b8e238 || ($882aaec64a960ca8$export$ef730685c1b8e238 = {}));
var $882aaec64a960ca8$export$a82073022ded66e8;
(function(UserStatus) {
    UserStatus["active"] = "active";
    UserStatus["inactive"] = "inactive";
    UserStatus["closed"] = "closed";
})($882aaec64a960ca8$export$a82073022ded66e8 || ($882aaec64a960ca8$export$a82073022ded66e8 = {}));
var $882aaec64a960ca8$export$ed12481c953b8653;
(function(FieldType) {
    FieldType["FullName"] = "fullName";
    FieldType["Nickname"] = "nickname";
    FieldType["Title"] = "title";
    FieldType["Department"] = "department";
    FieldType["CompanyName"] = "companyName";
    FieldType["Location"] = "location";
    FieldType["Timezone"] = "timezone";
    FieldType["Email"] = "email";
    FieldType["PhoneNumber"] = "phoneNumber";
    FieldType["Avatar"] = "picture";
    FieldType["Language"] = "language";
    FieldType["LocalTime"] = "localTime";
    FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
    FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
    FieldType["RemoteTimeString"] = "remoteTimeString";
})($882aaec64a960ca8$export$ed12481c953b8653 || ($882aaec64a960ca8$export$ed12481c953b8653 = {}));
var $882aaec64a960ca8$export$a9678af7d3f0f4cb;
(function(IdentityFieldName) {
    IdentityFieldName["PHONE_NUMBER"] = "phone_number";
    IdentityFieldName["JOB_TITLE"] = "job_title";
    IdentityFieldName["DEPARTMENT"] = "department";
    IdentityFieldName["COMPANY_NAME"] = "organization";
    IdentityFieldName["LOCATION"] = "location";
    IdentityFieldName["ZONEINFO"] = "zoneinfo";
    IdentityFieldName["NAME"] = "name";
    IdentityFieldName["EMAIL"] = "email";
})($882aaec64a960ca8$export$a9678af7d3f0f4cb || ($882aaec64a960ca8$export$a9678af7d3f0f4cb = {}));

});

parcelRegister("8VkCG", function(module, exports) {

$parcel$export(module.exports, "default", () => $70df9b46fc4f1dbf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $7RUjl = parcelRequire("7RUjl");

var $7Qxx6 = parcelRequire("7Qxx6");

var $5qYG0 = parcelRequire("5qYG0");
const $70df9b46fc4f1dbf$var$EmptyPlacesListState = ({ isCurrentUser: isCurrentUser, userFullName: userFullName, userStatus: userStatus })=>{
    const intl = (0, $5JgJ2.default)();
    const renderDescText = ()=>{
        const descMessage = isCurrentUser ? $70df9b46fc4f1dbf$var$messages.noPlacesListOwnerDesc : userStatus === (0, $7RUjl.UserStatus).inactive || userStatus === (0, $7RUjl.UserStatus).closed ? $70df9b46fc4f1dbf$var$messages.noPlacesListPastUserDesc : $70df9b46fc4f1dbf$var$messages.noPlacesListOtherDesc;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...descMessage,
            values: {
                user: userFullName
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Qxx6.default), {
        title: intl.formatMessage($70df9b46fc4f1dbf$var$messages.noPlacesListTitle),
        description: renderDescText(),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($5qYG0)))
    });
};
const $70df9b46fc4f1dbf$var$messages = (0, $90IgZ.defineMessages)({
    noPlacesListTitle: {
        id: 'ptc-directory.profile-page.places-list.no-places-list.title',
        defaultMessage: "We don\u2019t have places to show here yet",
        description: 'Title of the message displayed when there is no places associated to the profile that is being viewed'
    },
    noPlacesListOwnerDesc: {
        id: 'ptc-directory.profile-page.places-list.no-places-list.owner.description',
        defaultMessage: "There are no projects or spaces you\u2019ve worked in across the last 90 days.",
        description: 'Description of the message displayed when there is no places associated to the owner profile that is being viewed'
    },
    noPlacesListOtherDesc: {
        id: 'ptc-directory.profile-page.places-list.no-places-list.other.description',
        defaultMessage: "{user} hasn\u2019t worked in any projects or spaces in the last 90 days.",
        description: 'Description of the message displayed when there is no places associated to the person profile that is being viewed'
    },
    noPlacesListPastUserDesc: {
        id: 'ptc-directory.profile-page.places-list.no-places-list.past-user.description',
        defaultMessage: "{user}\u2019s account is deactivated or deleted. We can\u2019t show the projects or spaces {user} worked in across the last 90 days.",
        description: 'Description of the message displayed when there is no places associated to a deactivated or deleted users profile that is being viewed'
    }
});
var $70df9b46fc4f1dbf$export$2e2bcd8739ae039 = $70df9b46fc4f1dbf$var$EmptyPlacesListState;

});
parcelRegister("7Qxx6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e64a849bb046147$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $vwUyF = parcelRequire("vwUyF");
function $4e64a849bb046147$export$c696c866211ccfa4({ title: title, description: description, image: image, imageUrl: imageUrl, actions: actions, py: py, px: px, testId: testId }) {
    const img = imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $vwUyF.EmptyStateImage), {
        src: imageUrl
    }) : image;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $vwUyF.EmptyStateContainer), {
        py: py,
        px: px,
        "data-testid": testId
    }, img && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $vwUyF.EmptyStateImageContainer), null, img), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $vwUyF.EmptyStateBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $vwUyF.EmptyStateTitle), null, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $vwUyF.EmptyStateDescription), null, description), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $vwUyF.EmptyStateActions), null, actions)));
}
var $4e64a849bb046147$export$2e2bcd8739ae039 = $4e64a849bb046147$export$c696c866211ccfa4;

});
parcelRegister("vwUyF", function(module, exports) {

$parcel$export(module.exports, "EmptyStateContainer", () => $e03b86fcc88d5b37$export$2a511c47e1cb5779);
$parcel$export(module.exports, "EmptyStateImageContainer", () => $e03b86fcc88d5b37$export$bd5d2fea0a40a42f);
$parcel$export(module.exports, "EmptyStateImage", () => $e03b86fcc88d5b37$export$a7907bb86a15af4e);
$parcel$export(module.exports, "EmptyStateBody", () => $e03b86fcc88d5b37$export$df244a6e5075ebb4);
$parcel$export(module.exports, "EmptyStateTitle", () => $e03b86fcc88d5b37$export$54260be545246e4e);
$parcel$export(module.exports, "EmptyStateDescription", () => $e03b86fcc88d5b37$export$242239d9c1732d0a);
$parcel$export(module.exports, "EmptyStateActions", () => $e03b86fcc88d5b37$export$725343b91068621d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");

var $joBf7 = parcelRequire("joBf7");
function $e03b86fcc88d5b37$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e03b86fcc88d5b37$var$gridSizeTimes = (factor)=>(0, $lcnyw.gridSize)() * factor;
const $e03b86fcc88d5b37$export$2a511c47e1cb5779 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1i83sxm6"
})((props)=>({
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${$e03b86fcc88d5b37$var$gridSizeTimes(props.py || 4)}px ${$e03b86fcc88d5b37$var$gridSizeTimes(props.px || 7)}px`,
        transition: 'box-shadow 0.25s ease',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center'
    }));
const $e03b86fcc88d5b37$export$bd5d2fea0a40a42f = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1i83sxm5"
})({
    display: 'flex',
    flex: '0 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$e03b86fcc88d5b37$var$gridSizeTimes(15)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: `${$e03b86fcc88d5b37$var$gridSizeTimes(15)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: `${$e03b86fcc88d5b37$var$gridSizeTimes(4)}px`,
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `${$e03b86fcc88d5b37$var$gridSizeTimes(15)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${$e03b86fcc88d5b37$var$gridSizeTimes(15)}px`
    }
});
const $e03b86fcc88d5b37$export$a7907bb86a15af4e = /*#__PURE__*/ (0, $joBf7.default)("img", {
    target: "e1i83sxm4"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${$e03b86fcc88d5b37$var$gridSizeTimes(15)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: `${$e03b86fcc88d5b37$var$gridSizeTimes(15)}px`
});
const $e03b86fcc88d5b37$export$df244a6e5075ebb4 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1i83sxm3"
})({
    name: "p4355k",
    styles: "min-width:180px"
});
const $e03b86fcc88d5b37$export$54260be545246e4e = /*#__PURE__*/ (0, $joBf7.default)("h3", {
    target: "e1i83sxm2"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginBottom: `${$e03b86fcc88d5b37$var$gridSizeTimes(2)}px`
});
const $e03b86fcc88d5b37$export$242239d9c1732d0a = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1i83sxm1"
})({
    name: "0",
    styles: ""
});
const $e03b86fcc88d5b37$export$725343b91068621d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1i83sxm0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: `${$e03b86fcc88d5b37$var$gridSizeTimes(2)}px`
});

});


parcelRegister("5qYG0", function(module, exports) {
module.exports = new URL("PlacesListEmpty_ptc.36d458cf.svg", import.meta.url).toString();

});


parcelRegister("2r2pX", function(module, exports) {

$parcel$export(module.exports, "PanelContent", () => $0b0ec1501e88789e$export$d30ae7d97aafb468);
$parcel$export(module.exports, "PanelContentHeader", () => $0b0ec1501e88789e$export$eb71a19746598b2f);
$parcel$export(module.exports, "PanelContentTitle", () => $0b0ec1501e88789e$export$c703356189ebc2de);
$parcel$export(module.exports, "PanelContentBody", () => $0b0ec1501e88789e$export$c75fef9a59663656);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");


var $4lTFP = parcelRequire("4lTFP");
const $0b0ec1501e88789e$export$d30ae7d97aafb468 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1r5dj51-0"
})``;
const $0b0ec1501e88789e$export$eb71a19746598b2f = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1r5dj51-1"
})`display:flex;flex-direction:row;justify-content:space-between;margin-bottom:${(props)=>props.hasSubInfo ? "var(--ds-space-050, 4px)" : "var(--ds-space-200, 16px)"};position:relative;`;
const $0b0ec1501e88789e$export$c703356189ebc2de = /*#__PURE__*/ (0, $kwce8.default).h2.withConfig({
    componentId: "sc-1r5dj51-2"
})`${(0, $4lTFP.h500)};margin-top:0;word-break:break-all;`;
const $0b0ec1501e88789e$export$58f06e463130acb4 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1r5dj51-3"
})`background:${`var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};padding:${"var(--ds-space-100, 8px)"};`;
const $0b0ec1501e88789e$export$c75fef9a59663656 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1r5dj51-4"
})`background:${`var(--ds-surface-raised, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)}`})`};padding-top:${"var(--ds-space-200, 16px)"};padding-bottom:${"var(--ds-space-200, 16px)"};padding-left:${"var(--ds-space-075, 6px)"};padding-right:${"var(--ds-space-075, 6px)"};`;

});

parcelRegister("lwh18", function(module, exports) {

$parcel$export(module.exports, "default", () => $085643d095c371dc$export$2e2bcd8739ae039);

var $enCbb = parcelRequire("enCbb");
var $085643d095c371dc$export$2e2bcd8739ae039 = (0, $enCbb.default);

});
parcelRegister("enCbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d90b592119be6103$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $02DNG = parcelRequire("02DNG");

var $g3Rra = parcelRequire("g3Rra");

var $7EJuT = parcelRequire("7EJuT");

var $aVkzK = parcelRequire("aVkzK");

var $lcnyw = parcelRequire("lcnyw");

var $1io2n = parcelRequire("1io2n");
var $ifN5f = parcelRequire("ifN5f");
var $1PG9B = parcelRequire("1PG9B");
var $74Hyh = parcelRequire("74Hyh");

var $epTk7 = parcelRequire("epTk7");
const $d90b592119be6103$export$d4349a8ff634836e = $epTk7.PlaceLink;
const $d90b592119be6103$var$MainIcon = ({ icon: icon, type: type })=>{
    if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($epTk7.BaseIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "small",
        src: icon,
        appearance: "square"
    }));
    if (type === 'space') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($epTk7.SpaceIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($02DNG))), {
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7EJuT))),
        color: "currentColor",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: ""
    }));
    else if (type === 'board') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($epTk7.BoardIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3Rra))), {
        color: "currentColor",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: ""
    }));
    return null;
};
const $d90b592119be6103$var$HeaderIcon = ({ type: type })=>{
    switch(type){
        case 'space':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ifN5f.default), {
                size: "xsmall",
                productKey: (0, $1PG9B.ShortProductKey).CONFLUENCE
            });
        case 'board':
        case 'project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ifN5f.default), {
                size: "xsmall",
                productKey: (0, $1PG9B.ShortProductKey).JIRA
            });
        default:
            return null;
    }
};
function $d90b592119be6103$var$typeToTitle(type) {
    switch(type){
        case 'space':
            return 'Confluence';
        case 'board':
        case 'project':
            return 'Jira';
        default:
            return '';
    }
}
const $d90b592119be6103$export$a67ff5ee53b7f29a = (props)=>{
    const analytics = (0, $74Hyh.default)();
    const { name: name, path: path, type: type, hasLoaded: hasLoaded } = props;
    const handleAnchorClick = ()=>{
        analytics.pushUIEvent({
            source: (0, $1io2n.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'placesLink',
            action: (0, $1io2n.AnalyticsEventActions).CLICKED,
            attributes: {
                type: type
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($epTk7.PlacesItem, null, hasLoaded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($epTk7.Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($epTk7.HeaderIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d90b592119be6103$var$HeaderIcon, {
        type: type
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($epTk7.HeaderTitle, null, $d90b592119be6103$var$typeToTitle(type))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($epTk7.Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d90b592119be6103$var$MainIcon, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($epTk7.Details, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d90b592119be6103$export$d4349a8ff634836e, {
        href: path,
        onClick: handleAnchorClick
    }, name)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        isShimmering: true,
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
        cssFn: ()=>({
                minHeight: (0, $lcnyw.gridSize)() * 2,
                width: (0, $lcnyw.gridSize)() * 18.75,
                marginBottom: "var(--ds-space-050, 4px)",
                paddingLeft: 0,
                paddingRight: 0
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        hasIcon: true,
        isShimmering: true,
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
        cssFn: ()=>({
                minHeight: (0, $lcnyw.gridSize)() * 3.5,
                paddingLeft: 0,
                paddingRight: 0
            })
    })));
};
var $d90b592119be6103$export$2e2bcd8739ae039 = $d90b592119be6103$export$a67ff5ee53b7f29a;

});
parcelRegister("g3Rra", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9372a8941ba30f2eeefd7697e8da64d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb1660a76ac0e96d$var$_react = $bb1660a76ac0e96d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $bb1660a76ac0e96d$var$_board = $bb1660a76ac0e96d$var$_interopRequireDefault((parcelRequire("1GihF")));

var $bb1660a76ac0e96d$var$_board2 = $bb1660a76ac0e96d$var$_interopRequireDefault((parcelRequire("28ybo")));
function $bb1660a76ac0e96d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for BoardIcon.
 * This component is BoardIcon, with `UNSAFE_fallbackIcon` set to "BoardIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb1660a76ac0e96d$var$BoardIcon = (props)=>/*#__PURE__*/ $bb1660a76ac0e96d$var$_react.default.createElement($bb1660a76ac0e96d$var$_board.default, Object.assign({
        LEGACY_fallbackIcon: $bb1660a76ac0e96d$var$_board2.default
    }, props));
$bb1660a76ac0e96d$var$BoardIcon.Name = 'BoardIconMigration';
var $bb1660a76ac0e96d$var$_default = module.exports.default = $bb1660a76ac0e96d$var$BoardIcon;

});
parcelRegister("1GihF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8be58094d2c3db585c5ad72e0a89c62d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1397e58017ba0490$var$_react = $1397e58017ba0490$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1397e58017ba0490$var$_UNSAFE_baseNew = $1397e58017ba0490$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $1397e58017ba0490$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1397e58017ba0490$var$BoardIcon = (props)=>/*#__PURE__*/ $1397e58017ba0490$var$_react.default.createElement($1397e58017ba0490$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M5.583 2.75H2C1.31 2.75.75 3.31.75 4v8c0 .69.56 1.25 1.25 1.25h3.583m0-10.5v10.5m0-10.5h4.834m-4.834 10.5h4.834m0-10.5H14c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25h-3.583m0-10.5v10.5"/>`
    }, props));
$1397e58017ba0490$var$BoardIcon.displayName = 'BoardIcon';
var $1397e58017ba0490$var$_default = module.exports.default = $1397e58017ba0490$var$BoardIcon;

});

parcelRegister("28ybo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18e6d81a18ae6069$var$_react = $18e6d81a18ae6069$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $18e6d81a18ae6069$var$_board = $18e6d81a18ae6069$var$_interopRequireDefault((parcelRequire("1GihF")));
function $18e6d81a18ae6069$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $18e6d81a18ae6069$var$BoardIcon = (props)=>/*#__PURE__*/ $18e6d81a18ae6069$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props, {
        newIcon: $18e6d81a18ae6069$var$_board.default
    }));
$18e6d81a18ae6069$var$BoardIcon.displayName = 'BoardIcon';
var $18e6d81a18ae6069$var$_default = module.exports.default = $18e6d81a18ae6069$var$BoardIcon;

});


parcelRegister("7EJuT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $592f8fa51fe15971$var$_react = $592f8fa51fe15971$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $592f8fa51fe15971$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $592f8fa51fe15971$var$FolderFilledIcon = (props)=>/*#__PURE__*/ $592f8fa51fe15971$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.2 6h7.81C21.108 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.99 1.992H3.99A1.99 1.99 0 0 1 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
    }, props));
$592f8fa51fe15971$var$FolderFilledIcon.displayName = 'FolderFilledIcon';
var $592f8fa51fe15971$var$_default = module.exports.default = $592f8fa51fe15971$var$FolderFilledIcon;

});

parcelRegister("ifN5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $13822b656e5b8ea7$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eUqFw = parcelRequire("eUqFw");

var $jexQk = parcelRequire("jexQk");
var $5KT10 = parcelRequire("5KT10");
var $77CtJ = parcelRequire("77CtJ");
var $ecIoc = parcelRequire("ecIoc");
var $3BBkl = parcelRequire("3BBkl");
var $clhc3 = parcelRequire("clhc3");

var $1PG9B = parcelRequire("1PG9B");
function $13822b656e5b8ea7$export$2e2bcd8739ae039(props) {
    const { productKey: productKey, size: size = 'small', defaultIcon: defaultIcon = null, productName: productName } = props;
    const mapProductKeyToIcon = {
        [(0, $1PG9B.ShortProductKey).JIRA]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
            size: size,
            label: productName || 'Jira',
            appearance: "brand"
        }),
        [(0, $1PG9B.ShortProductKey).CONFLUENCE]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
            size: size,
            label: productName || 'Confluence',
            appearance: "brand"
        }),
        [(0, $1PG9B.ShortProductKey).JIRA_SOFTWARE]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3BBkl.JiraSoftwareIcon), {
            size: size,
            label: productName || 'Jira',
            appearance: "brand"
        }),
        [(0, $1PG9B.ShortProductKey).JIRA_SERVICE_DESK]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ecIoc.JiraServiceManagementIcon), {
            size: size,
            label: productName || 'Jira',
            appearance: "brand"
        }),
        [(0, $1PG9B.ShortProductKey).JIRA_CORE]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clhc3.JiraWorkManagementIcon), {
            size: size,
            label: productName || 'Jira',
            appearance: "brand"
        }),
        [(0, $1PG9B.ShortProductKey).BITBUCKET]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jexQk.BitbucketIcon), {
            size: size,
            label: productName || 'Bitbucket',
            appearance: "brand"
        })
    };
    return productKey && mapProductKeyToIcon[productKey] ? mapProductKeyToIcon[productKey] : defaultIcon;
}

});
parcelRegister("jexQk", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", () => $281e4c44e69e1ae0$export$5fc1066e677788d4);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $281e4c44e69e1ae0$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $281e4c44e69e1ae0$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $281e4c44e69e1ae0$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5KT10", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $bd2fb8be68c26b84$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $bd2fb8be68c26b84$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $bd2fb8be68c26b84$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $bd2fb8be68c26b84$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3BBkl", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareIcon", () => $5cd8aace864d207e$export$c3835feba2a66e67);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $5cd8aace864d207e$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $lpzFL.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $lpzFL.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
    <defs>
      <linearGradient x1="108.695%" x2="12.439%" y1="-14.936%" y2="45.215%" id="${id}-1">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="0%" x2="91.029%" y1="118.55%" y2="63.971%" id="${id}-2">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" stroke-width="1" fill-rule="nonzero">
      <path fill="${colors.iconColor}" d="M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z" />
      <path fill="url(#${id}-1" d="M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z" />
      <path fill="url(#${id}-2" d="M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z" />
    </g>
  </svg>`;
};
const $5cd8aace864d207e$export$c3835feba2a66e67 = ({ appearance: appearance, label: label = 'Jira Software', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const id = (0, $ki32l.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $5cd8aace864d207e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("clhc3", function(module, exports) {

$parcel$export(module.exports, "JiraWorkManagementIcon", () => $8917aa390d837519$export$7330b9fc5718fd30);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $8917aa390d837519$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $lpzFL.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $lpzFL.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id="${id}"
        gradientUnits="userSpaceOnUse"
        x1="13.9485"
        x2="20.7792"
        y1="20.2388"
        y2="11.8277"
      >
        <stop offset="0" stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} />
        <stop offset="100%" stop-color="${colors.iconGradientStop}" />
      </linearGradient>
      <path
        d="m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z"
        fill="url(#${id})"
      />
      <path
      fill="${colors.iconColor}"
      d="m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z"
      />
    </svg>`;
};
const $8917aa390d837519$export$7330b9fc5718fd30 = ({ appearance: appearance, label: label = 'Jira Work Management', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const id = (0, $ki32l.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $8917aa390d837519$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1PG9B", function(module, exports) {

$parcel$export(module.exports, "ShortProductKey", () => $963bd8b8b0e89b4c$export$736dd0bf2ecc436f);
$parcel$export(module.exports, "ProductName", () => $963bd8b8b0e89b4c$export$acdfad52bc8c6626);
/**
 * ShortProductKey is used in code. It should not have a special characters or empty space
 */ var $963bd8b8b0e89b4c$export$736dd0bf2ecc436f;
(function(ShortProductKey) {
    ShortProductKey["CONFLUENCE"] = "confluence";
    ShortProductKey["JIRA"] = "jira";
    ShortProductKey["JIRA_CORE"] = "jira_core";
    ShortProductKey["JIRA_SOFTWARE"] = "jira_software";
    ShortProductKey["JIRA_SERVICE_DESK"] = "jira_service_key";
    ShortProductKey["BITBUCKET"] = "bitbucket";
})($963bd8b8b0e89b4c$export$736dd0bf2ecc436f || ($963bd8b8b0e89b4c$export$736dd0bf2ecc436f = {}));
var $963bd8b8b0e89b4c$export$acdfad52bc8c6626;
(function(ProductName) {
    ProductName["CONFLUENCE"] = "Confluence";
    ProductName["JIRA"] = "Jira";
    ProductName["JIRA_CORE"] = "Jira Core";
    ProductName["JIRA_SOFTWARE"] = "Jira Software";
    ProductName["JIRA_SERVICE_DESK"] = "Jira Service Desk";
    ProductName["BITBUCKET"] = "Bitbucket";
    ProductName["TEAM_CENTRAL"] = "Team Central";
    ProductName["ATLAS"] = "Atlas";
    ProductName["HOME"] = "Atlassian Home";
})($963bd8b8b0e89b4c$export$acdfad52bc8c6626 || ($963bd8b8b0e89b4c$export$acdfad52bc8c6626 = {}));
const $963bd8b8b0e89b4c$export$ff506ffd2c56b336 = {
    ["Jira"]: 'JIRA',
    ["Confluence"]: 'CONFLUENCE',
    ["Team Central"]: 'TOWNSQUARE',
    ["Atlas"]: 'TOWNSQUARE',
    ["Atlassian Home"]: 'HOME'
};
var $963bd8b8b0e89b4c$export$fc3a4bf3fb08b1b4;
(function(LongProductKey) {
    LongProductKey["JIRA_CORE"] = "jira-core.ondemand";
    LongProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    LongProductKey["CONFLUENCE"] = "confluence.ondemand";
    LongProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    LongProductKey["BITBUCKET"] = "bitbucket";
})($963bd8b8b0e89b4c$export$fc3a4bf3fb08b1b4 || ($963bd8b8b0e89b4c$export$fc3a4bf3fb08b1b4 = {}));

});


parcelRegister("epTk7", function(module, exports) {

$parcel$export(module.exports, "BaseIcon", () => $ff1692c5118b71c2$export$20931e2295160b07);
$parcel$export(module.exports, "PlacesItem", () => $ff1692c5118b71c2$export$834d50fab48eb11a);
$parcel$export(module.exports, "Header", () => $ff1692c5118b71c2$export$8b251419efc915eb);
$parcel$export(module.exports, "HeaderIcon", () => $ff1692c5118b71c2$export$3a4bb31ac4bd7451);
$parcel$export(module.exports, "HeaderTitle", () => $ff1692c5118b71c2$export$edb76fdb8665f52);
$parcel$export(module.exports, "Content", () => $ff1692c5118b71c2$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "SpaceIcon", () => $ff1692c5118b71c2$export$38ffce4a7986ba20);
$parcel$export(module.exports, "BoardIcon", () => $ff1692c5118b71c2$export$2f9da8868573b55d);
$parcel$export(module.exports, "Details", () => $ff1692c5118b71c2$export$3e8048d3cf2ba3fd);
$parcel$export(module.exports, "PlaceLink", () => $ff1692c5118b71c2$export$d4349a8ff634836e);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");


var $4lTFP = parcelRequire("4lTFP");

var $kcFkB = parcelRequire("kcFkB");
const $ff1692c5118b71c2$export$20931e2295160b07 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-6lxli0-0"
})`border-radius:${"var(--ds-border-radius-100, 3px)"};display:flex;width:${"var(--ds-space-300, 24px)"};height:${"var(--ds-space-300, 24px)"};color:${`var(--ds-surface-raised, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`};margin-left:${"var(--ds-space-050, 4px)"};margin-top:${"var(--ds-space-050, 4px)"};margin-right:${"var(--ds-space-150, 12px)"};span{display:flex;align-items:center;justify-content:center;}svg{width:${"var(--ds-space-250, 20px)"};height:${"var(--ds-space-250, 20px)"};}img{width:${"var(--ds-space-300, 24px)"};height:${"var(--ds-space-300, 24px)"};}`;
const $ff1692c5118b71c2$export$834d50fab48eb11a = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-6lxli0-1"
})`position:relative;border-radius:${"var(--ds-border-radius-100, 3px)"};padding:${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-150, 12px)"};background:${`var(--ds-surface-raised, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)}`})`};transition:box-shadow 0.25s ease;overflow:hidden;display:flex;flex-direction:column;&:hover,&.active{box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`};}`;
const $ff1692c5118b71c2$export$8b251419efc915eb = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-6lxli0-2"
})`display:flex;flex-direction:row;align-items:center;margin-bottom:${"var(--ds-space-050, 4px)"};`;
const $ff1692c5118b71c2$export$3a4bb31ac4bd7451 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-6lxli0-3"
})`display:flex;margin-left:${"var(--ds-space-025, 2px)"};margin-right:${"var(--ds-space-050, 4px)"};width:${"var(--ds-space-200, 16px)"};height:${"var(--ds-space-200, 16px)"};color:${`var(--ds-icon-brand, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`};`;
const $ff1692c5118b71c2$export$edb76fdb8665f52 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-6lxli0-4"
})`${(0, $4lTFP.h200)};margin-top:0px;`;
const $ff1692c5118b71c2$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-6lxli0-5"
})`display:flex;align-items:center;`;
const $ff1692c5118b71c2$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $kwce8.default)($ff1692c5118b71c2$export$20931e2295160b07).withConfig({
    componentId: "sc-6lxli0-6"
})`background:${`var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`};display:grid;place-items:center;`;
const $ff1692c5118b71c2$export$2f9da8868573b55d = /*#__PURE__*/ (0, $kwce8.default)($ff1692c5118b71c2$export$20931e2295160b07).withConfig({
    componentId: "sc-6lxli0-7"
})`background:${`var(--ds-icon-brand, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`};`;
const $ff1692c5118b71c2$export$3e8048d3cf2ba3fd = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-6lxli0-8"
})`display:flex;flex-direction:column;min-width:0;white-space:nowrap;`;
const $ff1692c5118b71c2$export$d4349a8ff634836e = /*#__PURE__*/ (0, $kwce8.default)((0, $kcFkB.default)).withConfig({
    componentId: "sc-6lxli0-9"
})`${(0, $4lTFP.h500)};margin-top:${"var(--ds-space-025, 2px)"};text-overflow:ellipsis;overflow:hidden;&:focus{box-shadow:0 0 0 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`};outline:none;border-radius:${"var(--ds-border-radius-100, 3px)"};}`;

});
parcelRegister("kcFkB", function(module, exports) {

$parcel$export(module.exports, "default", () => $14139912674d8d40$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $74Hyh = parcelRequire("74Hyh");

var $fef5r = parcelRequire("fef5r");

var $kZURK = parcelRequire("kZURK");
const $14139912674d8d40$var$isModified = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $14139912674d8d40$var$getSpaAndRelativePath = (href, contextSpaPaths)=>{
    const relativePath = (0, $fef5r.getRelativeUrl)(href);
    const isSPA = (0, $fef5r.isSPALink)(relativePath, contextSpaPaths);
    return {
        isSPA: isSPA,
        relativePath: relativePath
    };
};
const $14139912674d8d40$export$a6c7ac8248d6e38a = ({ href: href, onClick: onClick, target: target, ...rest })=>{
    const analytics = (0, $74Hyh.default)();
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, push: push } = (0, $kZURK.useAppConfig)();
    (0, $eUqFw.useEffect)(()=>{
        if (!href) analytics.pushOperationalEvent({
            source: (0, $1io2n.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: 'link',
            action: (0, $1io2n.AnalyticsEventActions).FAILED,
            attributes: {
                contextSpaPaths: contextSpaPaths,
                contextEntryPoint: contextEntryPoint
            },
            tags: [
                'error'
            ]
        });
    }, [
        analytics,
        contextEntryPoint,
        contextSpaPaths,
        href
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        if (onClick) onClick(event);
        if (href) {
            const { relativePath: relativePath, isSPA: isSPA } = $14139912674d8d40$var$getSpaAndRelativePath(href, contextSpaPaths);
            if (isSPA && // only use push for links that work for SPA transitions
            !event.defaultPrevented && // set when onClick called preventDefault
            event.button === 0 && // only use push for left mouse button clicks
            (!target || target === '_self') && // let browser handle "_blank" etc
            !$14139912674d8d40$var$isModified(event) // let browser handle clicks with modifier
            ) {
                event.preventDefault();
                push(relativePath);
            }
        }
    }, [
        onClick,
        href,
        contextSpaPaths,
        push,
        target
    ]);
    if (href) {
        const { isSPA: isSPA } = $14139912674d8d40$var$getSpaAndRelativePath(href, contextSpaPaths);
        const props = {
            href: (0, $fef5r.prefixWithContextEntryPoint)(href, contextEntryPoint),
            ...target ? {
                target: target
            } : isSPA ? {} : {
                target: '_blank'
            },
            ...isSPA ? {} : {
                rel: 'noopener noreferrer'
            }
        };
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            ...rest,
            onClick: handleClick,
            ...props
        });
    }
    // if href is missing render <a> with original onClick handler
    // and without href or target
    // Note that we trigger an operational event in `componentDidMount` to monitor why `href` is not passed.
    // I have a suspicion that empty href can cause broken link
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        ...rest,
        onClick: onClick
    });
};
var $14139912674d8d40$export$2e2bcd8739ae039 = $14139912674d8d40$export$a6c7ac8248d6e38a;

});
parcelRegister("fef5r", function(module, exports) {

$parcel$export(module.exports, "getDomainFromLinkUri", () => $440eaf48988a4d90$export$cda14c9dfe45538);
$parcel$export(module.exports, "getRelativeUrl", () => $440eaf48988a4d90$export$d614758658023fd);
$parcel$export(module.exports, "prefixWithContextEntryPoint", () => $440eaf48988a4d90$export$715c8f9057ac0c01);
$parcel$export(module.exports, "isSPALink", () => $440eaf48988a4d90$export$82ba20246315fbed);

var $fECJU = parcelRequire("fECJU");
const $440eaf48988a4d90$export$1cc7e75fbd30f64f = (location)=>`${location.hash}${location.search}`;
const $440eaf48988a4d90$export$cda14c9dfe45538 = (url)=>{
    let hostname;
    try {
        try {
            hostname = $440eaf48988a4d90$export$eb5a321f13bbb969(url);
        } catch (noProtocolError) {
            /**
			 * Backend (Legion) validates whether the string is URI compliant. But URL expects
			 * the string to have a protocol. This is not validated by URI compliancy. So
			 * following is just a quick fix just for display purposes.
			 */ hostname = $440eaf48988a4d90$export$eb5a321f13bbb969('http://' + url);
        }
    } catch (error) {
        return '';
    }
    return hostname.replace(/^www\./, '');
};
const $440eaf48988a4d90$export$eb5a321f13bbb969 = (url)=>{
    const urlObj = new URL(url);
    return urlObj.hostname;
};
const $440eaf48988a4d90$export$c8d36b71889c2b08 = (email)=>{
    const parts = email.split('@');
    if (parts.length === 1) return null;
    else if (parts.length === 2 && !parts[0]) return null;
    else if (!parts[parts.length - 1]) return null;
    return parts[parts.length - 1];
};
const $440eaf48988a4d90$export$d614758658023fd = (url)=>{
    if (!$440eaf48988a4d90$var$isAbsoluteLink(url)) return url;
    try {
        const { pathname: pathname, search: search, hash: hash } = new URL(url);
        return `${pathname}${search}${hash}`;
    } catch (error) {
        (0, $fECJU.logException)(error, 'Cannot parse URL in getRelativeUrl', {
            url: url
        });
    }
    return url;
};
const $440eaf48988a4d90$var$isAbsoluteLink = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $440eaf48988a4d90$export$715c8f9057ac0c01 = (path, contextEntryPoint = '')=>{
    if ($440eaf48988a4d90$var$isAbsoluteLink(path) || // do not prefix for absolute URL
    contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
    path.startsWith('/')) return path;
    return `${contextEntryPoint}/${path}`;
};
const $440eaf48988a4d90$export$82ba20246315fbed = (url, contextSpaPaths)=>{
    if (!contextSpaPaths || !contextSpaPaths.length) return false;
    let isStartWithContextSPA;
    if ($440eaf48988a4d90$var$isAbsoluteLink(url)) try {
        const { pathname: pathname, search: search, hash: hash, origin: origin } = new URL(url);
        const relativeUrl = `${pathname}${search}${hash}`;
        const isSameDomain = window.location.href.includes(origin);
        isStartWithContextSPA = !!contextSpaPaths.find((contextPath)=>{
            return relativeUrl.startsWith(contextPath);
        });
        return isStartWithContextSPA && isSameDomain;
    } catch (error) {
        (0, $fECJU.logException)(error, 'Cannot parse URL in isSPALink', {
            url: url
        });
        return false;
    }
    // is relative link
    isStartWithContextSPA = !!contextSpaPaths.find((contextPath)=>{
        return url.startsWith(contextPath);
    });
    return isStartWithContextSPA || !url.startsWith('/');
};

});





parcelRegister("fKtEI", function(module, exports) {

$parcel$export(module.exports, "ProfilePlacesList", () => $af57ac2dec2eab57$export$f092d7408da4b0d);
$parcel$export(module.exports, "EmptyPlacesList", () => $af57ac2dec2eab57$export$f88a6b5813accf5a);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

const $af57ac2dec2eab57$export$f092d7408da4b0d = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-114isdp-0"
})`padding:${"var(--ds-space-100, 8px)"};border-radius:${"var(--ds-border-radius-100, 3px)"};background:${`var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`};> div{margin-bottom:${"var(--ds-space-100, 8px)"};}> div:last-child{margin-bottom:0;}`;
const $af57ac2dec2eab57$export$f88a6b5813accf5a = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-114isdp-1"
})`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-100, 8px)"};border-radius:${"var(--ds-border-radius-100, 3px)"};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)}`})`};> div{margin-bottom:${"var(--ds-space-100, 8px)"};}> div:last-child{margin-bottom:0;}`;

});



parcelRegister("7fnBH", function(module, exports) {

$parcel$export(module.exports, "default", () => $86cfbea6b3cabc0f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $hompL = parcelRequire("hompL");

var $1io2n = parcelRequire("1io2n");
var $k7WCG = parcelRequire("k7WCG");
var $74Hyh = parcelRequire("74Hyh");
var $gakch = parcelRequire("gakch");
var $6XUHL = parcelRequire("6XUHL");

var $lDT5A = parcelRequire("lDT5A");

var $7y2aq = parcelRequire("7y2aq");
const $86cfbea6b3cabc0f$var$getCurrentTime = ()=>window && window.performance ? window.performance.now() : Date.now();
function $86cfbea6b3cabc0f$var$useContainersQuery(props) {
    const [{ cloudId: cloudId }] = (0, $6XUHL.useSite)();
    const [{ principalUserId: principalUserId }] = (0, $gakch.usePrincipalUser)();
    const analytics = (0, $74Hyh.default)();
    const [sessionId] = (0, $eUqFw.useState)((0, (/*@__PURE__*/$parcel$interopDefault($hompL)))());
    const [startTime, setStartTime] = (0, $eUqFw.useState)(0);
    (0, $eUqFw.useEffect)(()=>{
        setStartTime($86cfbea6b3cabc0f$var$getCurrentTime());
    }, []);
    const userId = props.userId || principalUserId;
    const triggerAnalyticsEvent = (0, $eUqFw.useCallback)((elapsedTimeMs, data)=>{
        const containers = data.Containers && data.Containers.collaborationGraphEntities || [];
        const ids = containers.map(({ id: id })=>id);
        analytics.pushOperationalEvent({
            source: (0, $1io2n.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'collaboration-graph',
            attributes: {
                resultLength: ids.length,
                sessionId: sessionId,
                resultIds: ids,
                endpoint: 'userToContainer',
                userId: userId,
                elapsedTimeMs: elapsedTimeMs
            },
            action: 'requested'
        });
    }, [
        userId,
        analytics,
        sessionId
    ]);
    const handleOnCompleted = (0, $eUqFw.useCallback)((data)=>{
        const end = $86cfbea6b3cabc0f$var$getCurrentTime();
        const diff = end - startTime;
        triggerAnalyticsEvent(diff, data || {});
    }, [
        startTime,
        triggerAnalyticsEvent
    ]);
    const { loading: loading, error: error, data: data } = (0, $iZuDo.useQuery)((0, $lDT5A.default), {
        client: (0, $k7WCG.getApolloClient)(),
        variables: {
            siteId: cloudId,
            userId: userId,
            principalId: principalUserId,
            maxNumberOfResults: props.maxNumberOfCards,
            sessionId: sessionId
        },
        errorPolicy: 'all',
        skip: !principalUserId,
        onCompleted: handleOnCompleted
    });
    return {
        data: data ? (0, $7y2aq.toContainersViewFormat)(data.Containers?.collaborationGraphEntities) : [],
        loading: loading,
        hasError: !!error,
        error: error
    };
}
var $86cfbea6b3cabc0f$export$2e2bcd8739ae039 = $86cfbea6b3cabc0f$var$useContainersQuery;

});
parcelRegister("iZuDo", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $dd35afdbf6e72e7e$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $dd35afdbf6e72e7e$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $dd35afdbf6e72e7e$export$eb9a56e7a29e494);

var $4ErPU = parcelRequire("4ErPU");

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $66hGB = parcelRequire("66hGB");

var $8j2fP = parcelRequire("8j2fP");
var $dd35afdbf6e72e7e$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $66hGB.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8j2fP.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $4ErPU.parser)(document);
        var requiredOperationName = (0, $4ErPU.operationName)(type);
        var usedOperationName = (0, $4ErPU.operationName)(operation.type);
        (0, $8j2fP.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $dd35afdbf6e72e7e$var$QueryData = function(_super) {
    (0, $fKE23.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $jlBDe.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $jlBDe.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $4ErPU.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $fKE23.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $66hGB.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $66hGB.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $66hGB.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $jlBDe.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $jlBDe.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $66hGB.equal)(this.previousOptions.query, query) && (0, $66hGB.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, $66hGB.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $dd35afdbf6e72e7e$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eUqFw.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $dd35afdbf6e72e7e$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $dd35afdbf6e72e7e$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eUqFw.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eUqFw.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $dd35afdbf6e72e7e$export$dd0a697e1782aedd(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, false);
}
function $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, true);
}
var $dd35afdbf6e72e7e$var$MutationData = function(_super) {
    (0, $fKE23.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $4ErPU.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $4ErPU.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $fKE23.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $fKE23.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jlBDe.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $66hGB.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eUqFw.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $dd35afdbf6e72e7e$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $dd35afdbf6e72e7e$var$SubscriptionData = function(_super) {
    (0, $fKE23.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $66hGB.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eUqFw.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eUqFw.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $dd35afdbf6e72e7e$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $dd35afdbf6e72e7e$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $4ErPU.getApolloContext)()).client;
    (0, $8j2fP.invariant)(client, 1);
    return client;
}
function $dd35afdbf6e72e7e$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $dd35afdbf6e72e7e$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $dd35afdbf6e72e7e$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("lDT5A", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4bcabfb5173582c$export$2e2bcd8739ae039);

var $9ypom = parcelRequire("9ypom");
var $d4bcabfb5173582c$export$2e2bcd8739ae039 = (0, $9ypom.default)`
	query ContainersQuery(
		$userId: String!
		$principalId: String!
		$siteId: String!
		$sessionId: String
		$maxNumberOfResults: Int!
	) @custom {
		Containers(
			principalId: $principalId
			userId: $userId
			siteId: $siteId
			sessionId: $sessionId
			maxNumberOfResults: $maxNumberOfResults
		) {
			collaborationGraphEntities {
				id
				containerType
				entityType
				containerDetails {
					id
					key
					name
					url
					iconUrl
				}
			}
		}
	}
`;

});

parcelRegister("7y2aq", function(module, exports) {

$parcel$export(module.exports, "toContainersViewFormat", () => $16fc36f9506649ad$export$1700279c740b8615);
const $16fc36f9506649ad$var$getType = ({ containerType: containerType })=>{
    switch(containerType){
        case 'jiraProject':
            return 'project';
        case 'confluenceSpace':
            return 'space';
        default:
            return 'project';
    }
};
function $16fc36f9506649ad$export$1700279c740b8615(nodes) {
    if (!nodes) return [];
    return nodes.filter((container)=>!!container).filter(({ containerType: containerType = '' })=>containerType === 'jiraProject' || containerType === 'confluenceSpace').map((node)=>{
        if (!node || !node.containerDetails) return;
        return {
            id: node?.id,
            name: node?.containerDetails?.name,
            icon: node?.containerDetails?.iconUrl,
            type: $16fc36f9506649ad$var$getType(node),
            path: node?.containerDetails?.url,
            hasLoaded: true
        };
    }).filter((it)=>!!it);
}

});



parcelRegister("UsOwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4705b8018767ee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cAdhl = parcelRequire("cAdhl");

var $d8MGR = parcelRequire("d8MGR");
function $7c4705b8018767ee$export$dd5ad0b65cf665da(props) {
    const { children: children, docTitle: docTitle, title: title } = props;
    const resultTitle = [
        docTitle.start,
        title,
        docTitle.end
    ].filter((s)=>Boolean(s)).join(docTitle.delimiter || ' - ');
    return(// @ts-ignore
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cAdhl))), {
        title: resultTitle
    }, children));
}
var $7c4705b8018767ee$export$2e2bcd8739ae039 = (0, $d8MGR.default)($7c4705b8018767ee$export$dd5ad0b65cf665da);

});
parcelRegister("cAdhl", function(module, exports) {
'use strict';

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $guxOe = parcelRequire("guxOe");
function $929325b2bd5c056d$var$reducePropsToState(propsList) {
    var innermostProps = propsList[propsList.length - 1];
    if (innermostProps) return innermostProps.title;
}
function $929325b2bd5c056d$var$handleStateChangeOnClient(title) {
    var nextTitle = title || '';
    if (nextTitle !== document.title) document.title = nextTitle;
}
function $929325b2bd5c056d$var$DocumentTitle() {}
$929325b2bd5c056d$var$DocumentTitle.prototype = Object.create($eUqFw.Component.prototype);
$929325b2bd5c056d$var$DocumentTitle.displayName = 'DocumentTitle';
$929325b2bd5c056d$var$DocumentTitle.propTypes = {
    title: $1Qivz.string.isRequired
};
$929325b2bd5c056d$var$DocumentTitle.prototype.render = function() {
    if (this.props.children) return $eUqFw.Children.only(this.props.children);
    else return null;
};
module.exports = $guxOe($929325b2bd5c056d$var$reducePropsToState, $929325b2bd5c056d$var$handleStateChangeOnClient)($929325b2bd5c056d$var$DocumentTitle);

});
parcelRegister("guxOe", function(module, exports) {
'use strict';
function $c019ac826b959248$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $eUqFw = parcelRequire("eUqFw");
var $c019ac826b959248$var$React__default = $c019ac826b959248$var$_interopDefault($eUqFw);

var $c019ac826b959248$var$shallowEqual = $c019ac826b959248$var$_interopDefault((parcelRequire("h295B")));
function $c019ac826b959248$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c019ac826b959248$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $c019ac826b959248$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $c019ac826b959248$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_Component) {
            $c019ac826b959248$var$_inheritsLoose(SideEffect, _Component);
            function SideEffect() {
                return _Component.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$c019ac826b959248$var$shallowEqual(nextProps, this.props);
            };
            _proto.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $c019ac826b959248$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($eUqFw.Component);
        $c019ac826b959248$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $c019ac826b959248$var$_defineProperty(SideEffect, "canUseDOM", $c019ac826b959248$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $c019ac826b959248$var$withSideEffect;

});
parcelRegister("h295B", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});



parcelRegister("d8MGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7eef17aaf0c2ced$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kZURK = parcelRequire("kZURK");
function $e7eef17aaf0c2ced$export$2e2bcd8739ae039(WrappedComponent) {
    const nameOfWrapperComponent = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithDocumentTitleComponent extends (0, $eUqFw.PureComponent) {
        static{
            this.displayName = `withDocumentTitleHOC(${nameOfWrapperComponent})`;
        }
        render() {
            const wrappedComponentProps = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZURK.default).Consumer, null, ({ docTitle: docTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...wrappedComponentProps,
                    docTitle: docTitle
                }));
        }
    }
    return WithDocumentTitleComponent;
}

});


parcelRegister("h9to7", function(module, exports) {

$parcel$export(module.exports, "AsideColumn", () => $aeb7a6dc4aea7c6f$export$7fd6f44981b465b2);
$parcel$export(module.exports, "AsideColumnItem", () => $aeb7a6dc4aea7c6f$export$f634bf5b1a9553c4);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ /**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $01qao = parcelRequire("01qao");

var $klWOd = parcelRequire("klWOd");
const $aeb7a6dc4aea7c6f$export$7fd6f44981b465b2 = /*#__PURE__*/ (0, $kwce8.default).aside.withConfig({
    componentId: "xyb5d3-0"
})`${(0, $01qao.baseColumnStyles)};flex:0 0 ${(0, $klWOd.profileGridSizeTimes)(4)}px;margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;
const $aeb7a6dc4aea7c6f$export$f634bf5b1a9553c4 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "xyb5d3-1"
})`&:not(:last-child){margin-bottom:${"var(--ds-space-300, 24px)"};}`;

});
parcelRegister("01qao", function(module, exports) {

$parcel$export(module.exports, "baseColumnStyles", () => $80956a56fbdd5d3d$export$d0f72508c56edec0);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line import/order, @repo/internal/styles/use-emotion, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $klWOd = parcelRequire("klWOd");
const $80956a56fbdd5d3d$export$d0f72508c56edec0 = /*#__PURE__*/ (0, $kwce8.css)`padding:0 ${(0, $klWOd.halfGutterSize)}px;min-width:${(0, $klWOd.minColumnWidth)}px;@media (max-width:${(0, $klWOd.responsiveThreshold)}px){flex:1 1;padding:0;}`;

});
parcelRegister("klWOd", function(module, exports) {

$parcel$export(module.exports, "profileGridSizeTimes", () => $d373ac9db6f6a38c$export$4ee2721235c833ba);
$parcel$export(module.exports, "halfGutterSize", () => $d373ac9db6f6a38c$export$a5c9f6dcfaa13620);
$parcel$export(module.exports, "minColumnWidth", () => $d373ac9db6f6a38c$export$78f737406522d217);
$parcel$export(module.exports, "responsiveThreshold", () => $d373ac9db6f6a38c$export$e52bb911ec277d52);
/**
 * Util function for creating sizes based on the profile grid.
 * Takes the form a of function to be consistent with Atlaskit theme grid sizes.
 */ const $d373ac9db6f6a38c$export$4ee2721235c833ba = (n)=>80 * n;
const $d373ac9db6f6a38c$export$a5c9f6dcfaa13620 = 20;
const $d373ac9db6f6a38c$export$78f737406522d217 = $d373ac9db6f6a38c$export$4ee2721235c833ba(3);
const $d373ac9db6f6a38c$export$a3fc3c10977fa604 = 768;
const $d373ac9db6f6a38c$export$e52bb911ec277d52 = $d373ac9db6f6a38c$export$a3fc3c10977fa604 + 64;

});



parcelRegister("92Jzo", function(module, exports) {

$parcel$export(module.exports, "Body", () => $0a4da1be8393684f$export$4b2c32e08f77ff18);

var $eUqFw = parcelRequire("eUqFw");

var $hibcJ = parcelRequire("hibcJ");
const $0a4da1be8393684f$export$4b2c32e08f77ff18 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($hibcJ.Body, null, children);
const $0a4da1be8393684f$export$77acdd2a63439b4c = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($hibcJ.WideBody, null, children);
var $0a4da1be8393684f$export$2e2bcd8739ae039 = $0a4da1be8393684f$export$4b2c32e08f77ff18;

});
parcelRegister("hibcJ", function(module, exports) {

$parcel$export(module.exports, "Body", () => $53a1fac98ea08d07$export$4b2c32e08f77ff18);
$parcel$export(module.exports, "WideBody", () => $53a1fac98ea08d07$export$77acdd2a63439b4c);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $klWOd = parcelRequire("klWOd");
const $53a1fac98ea08d07$export$4b2c32e08f77ff18 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1g7almm-0"
})`display:flex;flex-direction:column;justify-content:flex-start;min-height:calc(100vh - 56px);max-width:${(0, $klWOd.profileGridSizeTimes)(12.5)}px;margin:0 auto;padding:0 ${(0, $klWOd.halfGutterSize)}px;@media (max-width:${(0, $klWOd.responsiveThreshold)}px){padding:0 ${"var(--ds-space-300, 24px)"};}padding-bottom:${"var(--ds-space-400, 32px)"};`;
const $53a1fac98ea08d07$export$77acdd2a63439b4c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1g7almm-1"
})`display:flex;flex-direction:column;justify-content:flex-start;min-height:calc(100vh - 56px);max-width:${(0, $klWOd.profileGridSizeTimes)(18)}px;margin:0 auto;padding:0 ${(0, $klWOd.halfGutterSize)}px;@media (max-width:${(0, $klWOd.responsiveThreshold)}px){padding:0 ${"var(--ds-space-300, 24px)"};}padding-bottom:${"var(--ds-space-400, 32px)"};`;

});


parcelRegister("3fooa", function(module, exports) {

$parcel$export(module.exports, "MainColumn", () => $5c545fabe56c9a11$export$2d9aae88ab6846ab);
$parcel$export(module.exports, "MainColumnItem", () => $5c545fabe56c9a11$export$a3de91dc1c7d9c74);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ /**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $lcnyw = parcelRequire("lcnyw");

var $01qao = parcelRequire("01qao");

var $klWOd = parcelRequire("klWOd");
const $5c545fabe56c9a11$export$2d9aae88ab6846ab = /*#__PURE__*/ (0, $kwce8.default).main.withConfig({
    componentId: "e4gbwm-0"
})`${(0, $01qao.baseColumnStyles)};flex:0 1 ${(0, $klWOd.profileGridSizeTimes)(8)}px;margin-top:${"var(--ds-space-400, 32px)"};margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;
const $5c545fabe56c9a11$export$a3de91dc1c7d9c74 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "e4gbwm-1"
})`scroll-margin-top:${(0, $lcnyw.gridSize)() * 23}px;&:not(:last-child){margin-bottom:${"var(--ds-space-400, 32px)"};}`;
const $5c545fabe56c9a11$export$b59f717f8d137994 = /*#__PURE__*/ (0, $kwce8.default).main.withConfig({
    componentId: "e4gbwm-2"
})`${(0, $01qao.baseColumnStyles)};flex:0 1 ${(0, $klWOd.profileGridSizeTimes)(12)}px;margin-top:${"var(--ds-space-400, 32px)"};margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;

});

parcelRegister("biE4w", function(module, exports) {

$parcel$export(module.exports, "ResponsiveSection", () => $5741c5a99192e0fa$export$6f5ca33df9ef97dc);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $klWOd = parcelRequire("klWOd");

var $hmn7h = parcelRequire("hmn7h");
const $5741c5a99192e0fa$export$6f5ca33df9ef97dc = /*#__PURE__*/ (0, $kwce8.default)((0, $hmn7h.Section)).withConfig({
    componentId: "uvj1rq-0"
})`@media (max-width:${(0, $klWOd.responsiveThreshold)}px){flex-direction:column;justify-content:flex-start;}`;

});
parcelRegister("hmn7h", function(module, exports) {

$parcel$export(module.exports, "Section", () => $de2f7dbe74a50baa$export$6e2c8f0811a474ce);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $de2f7dbe74a50baa$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "jfynxk-0"
})`display:flex;flex-direction:row;justify-content:center;`;

});


parcelRegister("91PIt", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $dd8729b5be211aa1$export$42f84e610f279c31);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $5QRJ0 = parcelRequire("5QRJ0");
var $74Hyh = parcelRequire("74Hyh");

var $4sj9N = parcelRequire("4sj9N");

var $4EGup = parcelRequire("4EGup");

var $79D9e = parcelRequire("79D9e");
const $dd8729b5be211aa1$export$db8be4c3614e42ec = new Map([
    [
        (0, $4sj9N.ErrorCategory).NotFound,
        (0, $4EGup.UserNotFound)
    ]
]);
const $dd8729b5be211aa1$export$42f84e610f279c31 = ({ error: error })=>{
    const analytics = (0, $74Hyh.default)();
    // Failed analytics
    (0, $eUqFw.useEffect)(()=>{
        analytics.pushTrackEvent({
            action: (0, $1io2n.AnalyticsEventActions).FAILED,
            actionSubject: `${(0, $1io2n.AnalyticsEventSource).USER_PROFILE_SCREEN}Load`,
            source: (0, $1io2n.AnalyticsEventSource).USER_PROFILE_SCREEN
        });
    }, [
        analytics
    ]);
    const errorCategory = (0, $4sj9N.parseErrorObjectToErrorCategory)(error);
    const ErrorComponent = errorCategory !== '' && $dd8729b5be211aa1$export$db8be4c3614e42ec.has(errorCategory) ? $dd8729b5be211aa1$export$db8be4c3614e42ec.get(errorCategory) : (0, $5QRJ0.GenericErrorPage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($79D9e.LoadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorComponent, null));
};

});
parcelRegister("5QRJ0", function(module, exports) {

$parcel$export(module.exports, "GenericErrorPage", () => $5f4e0a9772863911$export$5d76009b056f3e5d);
$parcel$export(module.exports, "default", () => $5f4e0a9772863911$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");

var $7u4fN = parcelRequire("7u4fN");

var $bAnhx = parcelRequire("bAnhx");

var $9ZrC8 = parcelRequire("9ZrC8");

var $diBJy = parcelRequire("diBJy");
const $5f4e0a9772863911$export$2369ec80391a4c8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.ErrorImage, {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($9ZrC8)))
});
const $5f4e0a9772863911$export$c120a0e80fd44ca6 = ({ title: title, body: body, image: image, actions: actions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.Container, {
        "data-test-selector": "error-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.ImageOuter, null, image || $5f4e0a9772863911$export$2369ec80391a4c8c), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.ErrorTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.Title, null, title)), body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.DescriptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.Description, null, body))), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.ButtonContainer, null, actions));
};
const $5f4e0a9772863911$export$5d76009b056f3e5d = (props)=>{
    const actions = props.hasSupportLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        rel: "noopener noreferrer",
        target: "_blank",
        href: `${(0, $bAnhx.getAtlassianContextUrl)('support')}/contact/#/`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $5f4e0a9772863911$var$messages.contactUs));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5f4e0a9772863911$export$c120a0e80fd44ca6, {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $5f4e0a9772863911$var$messages.title),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $5f4e0a9772863911$var$messages.description),
        actions: actions || undefined
    });
};
const $5f4e0a9772863911$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        id: 'pf-home.generic-error-title',
        defaultMessage: 'Something went wrong'
    },
    contactUs: {
        id: 'ptc-directory.error-boundary.message-link-text',
        defaultMessage: 'Contact support',
        description: 'The text of the link leading to the Atlassian support website, shown below the error description on the error pages'
    },
    description: {
        id: 'pf-home.generic-error-description',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things."
    }
});
var $5f4e0a9772863911$export$2e2bcd8739ae039 = $5f4e0a9772863911$export$c120a0e80fd44ca6;

});
parcelRegister("9ZrC8", function(module, exports) {
module.exports = new URL("svg-error-window_ptc.150cf151.svg", import.meta.url).toString();

});

parcelRegister("diBJy", function(module, exports) {

$parcel$export(module.exports, "ErrorImage", () => $193ab7da24e944c3$export$7326e6d938a8137b);
$parcel$export(module.exports, "Container", () => $193ab7da24e944c3$export$42a852a2b6b56249);
$parcel$export(module.exports, "ImageOuter", () => $193ab7da24e944c3$export$6cce79b2fcc860dc);
$parcel$export(module.exports, "TitleWrapper", () => $193ab7da24e944c3$export$585a3b23e887288b);
$parcel$export(module.exports, "ButtonContainer", () => $193ab7da24e944c3$export$eddf54ea3db8d0f0);
$parcel$export(module.exports, "Title", () => $193ab7da24e944c3$export$f99233281efd08a0);
$parcel$export(module.exports, "DescriptionWrapper", () => $193ab7da24e944c3$export$2bf1f2b0d31b60fc);
$parcel$export(module.exports, "Description", () => $193ab7da24e944c3$export$393edc798c47379d);
$parcel$export(module.exports, "ErrorTextContainer", () => $193ab7da24e944c3$export$5086488b1ac4411e);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

const $193ab7da24e944c3$export$7326e6d938a8137b = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "kvymlk-0"
})`width:263px;margin:0 0 ${"var(--ds-space-600, 48px)"} 0;display:flex;`;
const $193ab7da24e944c3$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "kvymlk-1"
})`align-items:center;justify-content:center;display:flex;flex-wrap:wrap;margin:${"var(--ds-space-1000, 80px)"} auto 0;max-width:600px;flex-direction:column;@media (max-width:640px){flex-direction:column;}`;
const $193ab7da24e944c3$export$6cce79b2fcc860dc = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "kvymlk-2"
})`flex:none;flex-basis:200px;justify-content:center;@media (max-width:640px){margin-right:0;flex-basis:auto;& img{max-width:100%;padding:0 ${"var(--ds-space-300, 24px)"};}}`;
const $193ab7da24e944c3$export$585a3b23e887288b = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "kvymlk-3"
})`display:flex;margin-bottom:${"var(--ds-space-150, 12px)"};@media (max-width:640px){text-align:center;}`;
const $193ab7da24e944c3$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "kvymlk-4"
})`display:flex;justify-content:center;text-align:center;margin-top:${"var(--ds-space-200, 16px)"};`;
const $193ab7da24e944c3$export$f99233281efd08a0 = /*#__PURE__*/ (0, $kwce8.default).h1.withConfig({
    componentId: "kvymlk-5"
})``;
const $193ab7da24e944c3$export$2bf1f2b0d31b60fc = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "kvymlk-6"
})`display:flex;flex-wrap:wrap;`;
const $193ab7da24e944c3$export$393edc798c47379d = /*#__PURE__*/ (0, $kwce8.default).p.withConfig({
    componentId: "kvymlk-7"
})`font-size:1em;line-height:24px;color:${`var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`};@media (max-width:640px){text-align:center;}`;
const $193ab7da24e944c3$export$5086488b1ac4411e = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "kvymlk-8"
})`display:flex;justify-content:center;text-align:center;flex-wrap:wrap;width:80%;flex-direction:column;align-items:center;@media (max-width:640px){max-width:304px;width:100%;}`;

});


parcelRegister("4sj9N", function(module, exports) {

$parcel$export(module.exports, "ErrorCategory", () => $0e51598af5ba9092$export$fe4bb20808298551);
$parcel$export(module.exports, "isRealErrorUserProfile", () => $0e51598af5ba9092$export$ad79d1c90d717965);
$parcel$export(module.exports, "errorUserNotFound", () => $0e51598af5ba9092$export$10bf856e639f2ac5);
$parcel$export(module.exports, "parseErrorObjectToErrorCategory", () => $0e51598af5ba9092$export$cf76974422373a05);
$parcel$export(module.exports, "parseTeamErrorCategory", () => $0e51598af5ba9092$export$cd92fd5c21ce6635);

var $kRC4x = parcelRequire("kRC4x");
var $0e51598af5ba9092$export$fe4bb20808298551;
(function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
})($0e51598af5ba9092$export$fe4bb20808298551 || ($0e51598af5ba9092$export$fe4bb20808298551 = {}));
const $0e51598af5ba9092$export$ad79d1c90d717965 = (error)=>{
    if (!error) return false;
    if (error?.message?.includes('User not found') || error?.message?.includes('Access is denied') || error?.message?.includes('TEAM CENTRAL UNAUTHORIZED')) return false;
    if (!error.graphQLErrors) return true;
    // is ApolloError
    return !error.graphQLErrors.every((e)=>!e || e.category === "NotFound" || e.category === "NotPermitted");
};
const $0e51598af5ba9092$export$10bf856e639f2ac5 = new Error('User not found');
function $0e51598af5ba9092$export$cf76974422373a05(error) {
    if (!error) return '';
    if (error?.message === $0e51598af5ba9092$export$10bf856e639f2ac5.message) return "NotFound";
    return error.graphQLErrors?.[0]?.category;
}
const $0e51598af5ba9092$var$MAP_TEAM_STATUS_ERROR_TYPES_MAP = {
    403: (0, $kRC4x.TeamProfileErrorType).NO_PERMISSION,
    404: (0, $kRC4x.TeamProfileErrorType).TEAM_MISSING,
    410: (0, $kRC4x.TeamProfileErrorType).TEAM_DELETED
};
const $0e51598af5ba9092$export$cd92fd5c21ce6635 = (error)=>error ? $0e51598af5ba9092$var$MAP_TEAM_STATUS_ERROR_TYPES_MAP[error.status] || (0, $kRC4x.TeamProfileErrorType).UNKNOWN : null;

});
parcelRegister("kRC4x", function(module, exports) {

$parcel$export(module.exports, "TeamProfileErrorType", () => $dde41d35893af066$export$b89d4f1cb2ee533c);
var $dde41d35893af066$export$b89d4f1cb2ee533c;
(function(TeamProfileErrorType) {
    TeamProfileErrorType["TEAM_MISSING"] = "teamMissing";
    TeamProfileErrorType["NO_PERMISSION"] = "noPermission";
    TeamProfileErrorType["TEAM_DELETED"] = "deleted";
    TeamProfileErrorType["UNKNOWN"] = "unknown";
    TeamProfileErrorType["NO_ACCESS_TO_TEAMS"] = "noAccessToTeams";
})($dde41d35893af066$export$b89d4f1cb2ee533c || ($dde41d35893af066$export$b89d4f1cb2ee533c = {}));

});


parcelRegister("4EGup", function(module, exports) {

$parcel$export(module.exports, "UserNotFound", () => $a7a4164910082b04$export$d1f0ba24af7dd9bb);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");

var $6zOB7 = parcelRequire("6zOB7");

var $5QRJ0 = parcelRequire("5QRJ0");
var $74Hyh = parcelRequire("74Hyh");

var $8egSs = parcelRequire("8egSs");

var $kcFkB = parcelRequire("kcFkB");

var $7ZldT = parcelRequire("7ZldT");
const $a7a4164910082b04$var$Actions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kcFkB.default), {
        href: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $a7a4164910082b04$var$messages.buttonText)));
const $a7a4164910082b04$var$NOT_FOUND_IMAGE_WIDTH = 497;
const $a7a4164910082b04$export$d1f0ba24af7dd9bb = ()=>{
    const analytics = (0, $74Hyh.default)();
    const expTracker = analytics.expTracker();
    // In a weird case, back and forth by browser back/next button causes `Query` of `react-apollo` does not return `error` correctly although user is not exsited.
    // So it is better to abort all current user experience tracking when user is not found.
    (0, $eUqFw.useEffect)(()=>{
        expTracker.abort({
            reason: 'User Not Found'
        });
    }, [
        expTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5QRJ0.default), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $a7a4164910082b04$var$messages.notFoundTitle),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $a7a4164910082b04$var$messages.notFoundDescription1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $a7a4164910082b04$var$messages.notFoundDescription2)),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7ZldT.NotFoundImage, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8egSs))),
            width: $a7a4164910082b04$var$NOT_FOUND_IMAGE_WIDTH
        }),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7a4164910082b04$var$Actions, null)
    });
};
const $a7a4164910082b04$var$messages = (0, $90IgZ.defineMessages)({
    notFoundTitle: {
        id: 'ptc-directory.profile-page.not-found.title',
        defaultMessage: "Looks like we\u2019re off the beaten track",
        description: 'The title of the error page when a user tries to view a user but the user id does not exist'
    },
    notFoundDescription1: {
        id: 'ptc-directory.profile-page.not-found.description.first',
        defaultMessage: 'We landed here for a user that does not exist.',
        description: 'The first line of the description when a user landed on an invalid page'
    },
    notFoundDescription2: {
        id: 'ptc-directory.profile-page.not-found.description.second',
        defaultMessage: 'Head back to the directory to search for another user.',
        description: 'The second line of the description when a user landed on an invalid page'
    },
    buttonText: {
        id: 'ptc-directory.profile-page.error.home.button',
        defaultMessage: 'Back to directory',
        description: 'The button text to return to the search page'
    }
});

});
parcelRegister("8egSs", function(module, exports) {
module.exports = new URL("svg-user-not-found_ptc.0205a184.svg", import.meta.url).toString();

});

parcelRegister("7ZldT", function(module, exports) {

$parcel$export(module.exports, "NotFoundImage", () => $95fa6dcadf52d716$export$22dc9752913c971e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $95fa6dcadf52d716$export$22dc9752913c971e = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "sc-1wghneo-0"
})`margin:0 0 ${"var(--ds-space-500, 40px)"} 0;display:flex;`;

});


parcelRegister("79D9e", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $7d886cb82115933d$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "AvatarWrapper", () => $7d886cb82115933d$export$f7513421c53ce141);
$parcel$export(module.exports, "Details", () => $7d886cb82115933d$export$3e8048d3cf2ba3fd);
$parcel$export(module.exports, "Name", () => $7d886cb82115933d$export$c7bd411105e2dec3);
$parcel$export(module.exports, "Nickname", () => $7d886cb82115933d$export$445f45ad592d8c5);
$parcel$export(module.exports, "LoadingWrapper", () => $7d886cb82115933d$export$43a792a870d28db2);
$parcel$export(module.exports, "NonActiveUserLozenge", () => $7d886cb82115933d$export$184eb2c877f30f66);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ 
var $kwce8 = parcelRequire("kwce8");


var $4lTFP = parcelRequire("4lTFP");
const $7d886cb82115933d$export$3f46768c2c1337f2 = -91;
const $7d886cb82115933d$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oxac7m-0"
})`margin-top:${$7d886cb82115933d$export$3f46768c2c1337f2}px;`;
const $7d886cb82115933d$export$b4afcc4b43e79a52 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oxac7m-1"
})`height:0;padding:0;margin:${"var(--ds-space-250, 20px)"} 0 0 0;`;
const $7d886cb82115933d$export$f7513421c53ce141 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oxac7m-2"
})`position:relative;display:inline-block;height:134px;width:134px;border-radius:50%;margin-bottom:${"var(--ds-space-200, 16px)"};`;
const $7d886cb82115933d$export$3e8048d3cf2ba3fd = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oxac7m-3"
})`display:flex;flex-direction:column;`;
const $7d886cb82115933d$export$c7bd411105e2dec3 = /*#__PURE__*/ (0, $kwce8.default).h1.withConfig({
    componentId: "sc-1oxac7m-4"
})`${(0, $4lTFP.h700)} margin-top:0;margin-bottom:${"var(--ds-space-150, 12px)"};word-break:break-all;`;
const $7d886cb82115933d$export$445f45ad592d8c5 = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-1oxac7m-5"
})`color:${`var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`};margin-bottom:${"var(--ds-space-150, 12px)"};word-break:break-all;`;
const $7d886cb82115933d$export$43a792a870d28db2 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oxac7m-6"
})`opacity:${(props)=>props.isLoading ? 0 : 1};`;
const $7d886cb82115933d$export$184eb2c877f30f66 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oxac7m-7"
})`margin-bottom:${"var(--ds-space-250, 20px)"};margin-top:${"var(--ds-space-050, 4px)"};`;

});


parcelRegister("fvq4y", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cc61cae86926305$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $77Go9 = parcelRequire("77Go9");
const $9cc61cae86926305$var$WorkedOnListContainer = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77Go9.default), props);
};
var $9cc61cae86926305$export$2e2bcd8739ae039 = $9cc61cae86926305$var$WorkedOnListContainer;

});
parcelRegister("77Go9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b82f56997923938b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $gakch = parcelRequire("gakch");

var $k7Bof = parcelRequire("k7Bof");

var $fpa0Z = parcelRequire("fpa0Z");

var $hKky0 = parcelRequire("hKky0");

var $8mJg6 = parcelRequire("8mJg6");

var $f57LX = parcelRequire("f57LX");
const $b82f56997923938b$var$ProfileRecentWorkClient = (props)=>{
    const { userId: userId } = props;
    const [{ principalUserId: principalUserId }] = (0, $gakch.usePrincipalUser)();
    const [activities, setActivities] = (0, $eUqFw.useState)([]);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(true);
    const activityClient = (0, $k7Bof.useActivityClient)('v3', 'people');
    const { data: userData } = (0, $hKky0.default)({
        userId: userId,
        skip: (0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query')
    });
    const { data: userAggData } = (0, $fpa0Z.useTeamsUser)(userId, !userId || !(0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query'));
    const loadActivities = (0, $eUqFw.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const fetchedActivities = await activityClient.fetchActivities([
                50,
                125,
                250
            ], {
                limit: 50,
                actors: [
                    `ari:cloud:identity::user/${userId}`
                ]
            }, [
                'workedOn'
            ]);
            const translated = (0, $8mJg6.transformDataFromRecentWorkClient)(fetchedActivities.workedOn);
            setActivities(translated);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            // @ts-ignore
            setError(error);
        }
    }, [
        activityClient,
        userId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (userId) loadActivities();
    }, [
        loadActivities,
        userId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f57LX.default), {
        userFullName: (0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query') ? userAggData?.fullName : userData.userFullName,
        userId: userId,
        currentUserId: principalUserId,
        error: error,
        hasError: !!error,
        isLoading: isLoading,
        activities: activities
    });
};
var $b82f56997923938b$export$2e2bcd8739ae039 = $b82f56997923938b$var$ProfileRecentWorkClient;

});
parcelRegister("fpa0Z", function(module, exports) {

$parcel$export(module.exports, "useTeamsUser", () => $969c2a2e21660117$export$14c10fb40f456eef);

var $eUqFw = parcelRequire("eUqFw");

var $l3Df4 = parcelRequire("l3Df4");
const $969c2a2e21660117$export$14c10fb40f456eef = (userId, skip)=>{
    const [users, { getUser: getUser, setUserData: setUserData }] = (0, $l3Df4.useUser)();
    const userState = users[userId];
    (0, $eUqFw.useEffect)(()=>{
        if (!skip) getUser(userId);
    }, [
        getUser,
        skip,
        userId
    ]);
    return {
        data: userState?.user,
        isLoading: userState?.isLoading,
        error: userState?.error,
        refetch: ()=>getUser(userId, true),
        setUserData: (data)=>setUserData(userId, data)
    };
};

});
parcelRegister("l3Df4", function(module, exports) {

$parcel$export(module.exports, "useUser", () => $cdeaf2ad7ad3ecb8$export$23bbbc4533528f03);

var $WBLbN = parcelRequire("WBLbN");

var $cAxhS = parcelRequire("cAxhS");
const $cdeaf2ad7ad3ecb8$var$CACHE_MAX_AGE = 300000; // 5 minutes
const $cdeaf2ad7ad3ecb8$var$CACHE_MAX_SIZE = 5;
const $cdeaf2ad7ad3ecb8$var$initialState = {};
const $cdeaf2ad7ad3ecb8$export$e324594224ef24da = {
    getUser: (userId, isRefetching)=>async ({ getState: getState, setState: setState })=>{
            const userState = getState()[userId];
            // Do not fetch the user if it is still in cache
            // Or it is loading
            // Or it is refetching
            if (!isRefetching && userState && (userState.isLoading || userState.exp > Date.now())) return;
            // Remove the oldest user from the cache if the cache is full
            const userIds = Object.keys(getState());
            if (userIds.length >= $cdeaf2ad7ad3ecb8$var$CACHE_MAX_SIZE) {
                const mutableState = {
                    ...getState()
                };
                const oldestUserId = userIds.reduce((oldest, current)=>mutableState[current].exp < mutableState[oldest].exp ? current : oldest);
                delete mutableState[oldestUserId];
                setState({
                    ...mutableState
                });
            }
            setState({
                [userId]: {
                    isLoading: true,
                    error: undefined,
                    user: undefined,
                    exp: -1
                }
            });
            try {
                // AGG user query does not verify user’s org membership,
                // it can provide user info to users who are outside the org.
                // To apply proper restrictions on visibility, we need to check if the user is present in the site.
                // Read more in https://hello.atlassian.net/wiki/spaces/PTC/pages/3492140773/LDR+Replace+pf-directory+CloudUser+with+AGG+User
                const userCheckPromise = (0, $cAxhS.teamsClient).getUserInSiteUserBase(userId);
                const userQueryPromise = (0, $cAxhS.teamsClient).queryAGGUser(userId);
                const checkUserPresentInSiteRes = await userCheckPromise;
                if (!checkUserPresentInSiteRes.isPresent) {
                    setState({
                        [userId]: {
                            isLoading: false,
                            exp: -1
                        }
                    });
                    return;
                }
                const user = await userQueryPromise;
                setState({
                    [userId]: {
                        isLoading: false,
                        exp: Date.now() + $cdeaf2ad7ad3ecb8$var$CACHE_MAX_AGE,
                        user: {
                            ...user,
                            fullName: user.name,
                            title: user.extendedProfile?.jobTitle,
                            timezone: user.zoneinfo,
                            locale: user.locale,
                            location: user.extendedProfile?.location,
                            companyName: user.extendedProfile?.organization,
                            department: user.extendedProfile?.department,
                            avatarUrl: user.picture,
                            status: user.accountStatus,
                            isBot: user.__typename === 'AppUser',
                            userType: 'user',
                            phoneNumber: user.extendedProfile?.phoneNumbers && user.extendedProfile?.phoneNumbers[0]?.value,
                            isAgent: user.appType === 'agent'
                        }
                    }
                });
            } catch (error) {
                setState({
                    [userId]: {
                        error: error instanceof Error ? error : new Error('Unknown error'),
                        isLoading: false,
                        exp: -1
                    }
                });
            }
        },
    /**
	 * Expose a method to set user data
	 * Useful when we want to update user data that needs relatively long time in BE to sync
	 */ setUserData: (userId, data)=>({ getState: getState, setState: setState })=>{
            const userState = getState()[userId];
            if (!userState || !userState.user) return;
            setState({
                [userId]: {
                    ...userState,
                    user: userState.user && {
                        ...userState.user,
                        ...data
                    }
                }
            });
        }
};
const $cdeaf2ad7ad3ecb8$var$Store = (0, $WBLbN.createStore)({
    initialState: $cdeaf2ad7ad3ecb8$var$initialState,
    actions: $cdeaf2ad7ad3ecb8$export$e324594224ef24da,
    name: 'User'
});
const $cdeaf2ad7ad3ecb8$export$23bbbc4533528f03 = (0, $WBLbN.createHook)($cdeaf2ad7ad3ecb8$var$Store);

});


parcelRegister("hKky0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf83a5773d3bf4a$export$2e2bcd8739ae039);

var $iZuDo = parcelRequire("iZuDo");

var $k7WCG = parcelRequire("k7WCG");
var $fECJU = parcelRequire("fECJU");

var $efuAK = parcelRequire("efuAK");
/**
 * @private
 * @deprecated Use useTeamsUser from @atlassian/teams/user instead
 * Should be removed when cleaning up migrate_cloud_user_to_agg_user_query
 */ function $9bf83a5773d3bf4a$var$useCloudUser({ userId: userId, skip: skip }) {
    const { loading: loading, error: error, data: data } = (0, $iZuDo.useQuery)((0, $efuAK.default), {
        client: (0, $k7WCG.getApolloClient)(),
        variables: {
            userId: userId,
            _withCloudId: true
        },
        skip: !userId || skip
    });
    if (error) (0, $fECJU.logErrorMessage)('useCloudUser', error);
    const cloudUser = !error && !loading ? data?.CloudUser : {};
    return {
        data: {
            ...cloudUser,
            userFullName: cloudUser?.fullName || ''
        },
        isLoading: loading,
        hasError: !!error || !loading && !data?.CloudUser,
        error: error
    };
}
var $9bf83a5773d3bf4a$export$2e2bcd8739ae039 = $9bf83a5773d3bf4a$var$useCloudUser;

});
parcelRegister("efuAK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d62286f4f91f4209$export$2e2bcd8739ae039);

var $9ypom = parcelRequire("9ypom");
var $d62286f4f91f4209$export$2e2bcd8739ae039 = (0, $9ypom.default)`
	query CloudUser($userId: String!, $cloudId: String) {
		CloudUser(userId: $userId, cloudId: $cloudId) {
			id
			fullName
			avatarUrl
			email
			timezone
			locale
			title
			location
			companyName
			department
			statusModifiedDate
			isNotMentionable
			phoneNumber
		}
	}
`;

});


parcelRegister("8mJg6", function(module, exports) {

$parcel$export(module.exports, "transformDataFromRecentWorkClient", () => $ac8be4bc274d33f1$export$25e790c9ec501a25);

var $a4aIS = parcelRequire("a4aIS");
function $ac8be4bc274d33f1$var$getDirectContainer(node) {
    let container = '';
    const len = node.containers?.length || 0;
    if (node.containers && len > 0) container = node.containers[len - 1].name;
    const provider = (0, $a4aIS.toTitleCase)((0, $a4aIS.replaceUnderscoresToSpace)((0, $a4aIS.replaceHypensToSpace)(node.object.product.toLowerCase())));
    return container || provider; // fallback is product name
}
function $ac8be4bc274d33f1$var$transformContributorToActivity(contributor, type = '', date = null) {
    return {
        date: date,
        user: {
            id: contributor.accountId,
            fullName: contributor.name
        },
        type: type
    };
}
function $ac8be4bc274d33f1$var$transformNodeToWorkLensActivityObject(node) {
    const { name: name = '', url: url = '', icon: icon = null, product: product = '' } = node.object || {};
    return {
        name: name || '',
        url: url,
        cloudId: '',
        iconUrl: icon ? icon.value : '',
        provider: product,
        container: $ac8be4bc274d33f1$var$getDirectContainer(node)
    };
}
function $ac8be4bc274d33f1$var$transformContributersForActor({ actor: actor, contributors: contributors, eventType: eventType, timestamp: timestamp }) {
    const updatedContributors = !contributors.length && actor ? [
        actor
    ] : contributors;
    return updatedContributors.map((contributor)=>$ac8be4bc274d33f1$var$transformContributorToActivity(contributor, eventType, timestamp));
}
function $ac8be4bc274d33f1$export$25e790c9ec501a25(nodes) {
    return nodes.map((node)=>{
        const { object: { id: objectId }, timestamp: timestamp } = node;
        return {
            objectId: objectId,
            lastModification: timestamp,
            activity: $ac8be4bc274d33f1$var$transformContributersForActor(node),
            object: {
                ...$ac8be4bc274d33f1$var$transformNodeToWorkLensActivityObject(node)
            }
        };
    });
}

});
parcelRegister("a4aIS", function(module, exports) {

$parcel$export(module.exports, "toTitleCase", () => $8616fb4cb613cb4d$export$f06f8b3003f18927);
$parcel$export(module.exports, "replaceUnderscoresToSpace", () => $8616fb4cb613cb4d$export$d3895e5768a00fee);
$parcel$export(module.exports, "replaceHypensToSpace", () => $8616fb4cb613cb4d$export$568995155ea86c06);
/**
 * Method to capitalise first letter of an input string
 * @param text {String} - the input string
 * @return {String}
 */ const $8616fb4cb613cb4d$export$1270e6249ad1a81f = (text)=>typeof text === 'string' ? text.charAt(0).toUpperCase() + text.substr(1) : '';
const $8616fb4cb613cb4d$export$f06f8b3003f18927 = (text)=>{
    if (typeof text !== 'string') return '';
    const words = text.split(' ');
    return words.map((word)=>$8616fb4cb613cb4d$export$1270e6249ad1a81f(word)).join(' ');
};
const $8616fb4cb613cb4d$export$d3895e5768a00fee = (text)=>typeof text === 'string' ? text// underscores to spaces
    .replace(/_/g, ' ')// spaces to space
    .replace(/ +/g, ' ') : '';
const $8616fb4cb613cb4d$export$568995155ea86c06 = (text)=>typeof text === 'string' ? text// underscores to spaces
    .replace(/-/g, ' ')// spaces to space
    .replace(/ +/g, ' ') : '';

});


parcelRegister("f57LX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbacf8e119f4296e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $iNIpe = parcelRequire("iNIpe");
var $2lryl = parcelRequire("2lryl");
var $74Hyh = parcelRequire("74Hyh");
var $hWnzK = parcelRequire("hWnzK");
var $elP2D = parcelRequire("elP2D");

var $4sj9N = parcelRequire("4sj9N");

var $km3L9 = parcelRequire("km3L9");
var $bFEXl = parcelRequire("bFEXl");

var $9m7xM = parcelRequire("9m7xM");
function $bbacf8e119f4296e$export$c8678fe90ec246e0(props) {
    const { activities: activities, userId: userId, currentUserId: currentUserId, isLoading: isLoading, userFullName: userFullName, hasError: hasError, error: error } = props;
    const analytics = (0, $74Hyh.default)();
    const onClickViewAllLink = (0, $eUqFw.useCallback)((location)=>{
        analytics.pushUIEvent({
            source: (0, $1io2n.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'viewAllWork',
            action: (0, $1io2n.AnalyticsEventActions).CLICKED,
            attributes: {
                location: location
            }
        });
    }, [
        analytics
    ]);
    const onClickShowMore = (0, $eUqFw.useCallback)((numItemsDisplayed)=>{
        analytics.pushUIEvent({
            source: (0, $1io2n.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'moreWork',
            action: (0, $1io2n.AnalyticsEventActions).CLICKED,
            attributes: {
                numItemsDisplayed: numItemsDisplayed
            }
        });
    }, [
        analytics
    ]);
    const onActivityEntryClick = (0, $eUqFw.useCallback)((provider, entryIndex)=>{
        analytics.pushUIEvent({
            source: (0, $1io2n.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'activityEntry',
            action: (0, $1io2n.AnalyticsEventActions).CLICKED,
            attributes: {
                provider: provider.toUpperCase(),
                entryIndex: entryIndex
            }
        });
    }, [
        analytics
    ]);
    (0, $hWnzK.useExpTrackerStart)({
        id: userId,
        name: (0, $iNIpe.UserExperienceNames).USER_PROFILE_WORKED_ON,
        timeout: (0, $iNIpe.DEFAULT_TIMEOUT_USER_EXP)
    });
    (0, $elP2D.useExpTrackerStop)({
        name: (0, $iNIpe.UserExperienceNames).USER_PROFILE_WORKED_ON,
        error: error,
        checkShouldAbort: (error)=>{
            if ((0, $4sj9N.isRealErrorUserProfile)(error)) return;
            return `Aborted because of ${error.message}`;
        }
    });
    let emptyView;
    if (hasError) emptyView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bFEXl.default), {
        userFullName: userFullName,
        userId: userId
    });
    else emptyView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $km3L9.default), {
        isCurrentUser: !!userId && userId === currentUserId,
        userFullName: userFullName,
        isForTable: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9m7xM.default), {
        activities: activities,
        currentUserId: currentUserId,
        viewAllLink: `${userId}/work`,
        isLoading: isLoading,
        onClickViewAllLink: onClickViewAllLink,
        onClickShowMore: onClickShowMore,
        onClickActivityEntry: onActivityEntryClick,
        emptyView: emptyView,
        userId: userId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2lryl.ExperienceSuccess), {
        hasLoaded: !hasError && !isLoading,
        name: (0, $iNIpe.UserExperienceNames).USER_PROFILE_WORKED_ON
    }));
}
var $bbacf8e119f4296e$export$2e2bcd8739ae039 = $bbacf8e119f4296e$export$c8678fe90ec246e0;

});
parcelRegister("km3L9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7159b19029edd8d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $220ac = parcelRequire("220ac");

var $7Qxx6 = parcelRequire("7Qxx6");

var $jD9DW = parcelRequire("jD9DW");

var $89vgZ = parcelRequire("89vgZ");
function $e7159b19029edd8d$var$EmptyWorkState(props) {
    const { isForTable: isForTable, userId: userId, userFullName: userFullName, isCurrentUser: isCurrentUser } = props;
    const intl = (0, $5JgJ2.default)();
    const renderDescText = ()=>{
        const descMessage = isCurrentUser ? $e7159b19029edd8d$var$messages.noWorkListDescForYou : $e7159b19029edd8d$var$messages.noWorkListPersonDesc;
        return userFullName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...descMessage,
            values: {
                user: userFullName
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $e7159b19029edd8d$var$messages.noWorkListTeamDesc);
    };
    if (isForTable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: intl.formatMessage($e7159b19029edd8d$var$messages.noWorkListTitle),
        description: renderDescText(),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($jD9DW))),
        primaryAction: userId && userFullName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $89vgZ.default), {
            isInEmptyState: true,
            userId: userId,
            userFullName: userFullName
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Qxx6.default), {
        title: intl.formatMessage($e7159b19029edd8d$var$messages.noWorkListTitle),
        description: renderDescText(),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($jD9DW))),
        actions: userId && userFullName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $89vgZ.default), {
            isInEmptyState: true,
            userId: userId,
            userFullName: userFullName
        })
    });
}
const $e7159b19029edd8d$var$messages = (0, $90IgZ.defineMessages)({
    noWorkListTitle: {
        id: 'ptc-directory.profile-page.work-list.no-work-list.title',
        defaultMessage: 'There is no work to see here',
        description: 'Title of the message displayed when there is no work associated to the profile that is being viewed'
    },
    noWorkListTeamDesc: {
        id: 'ptc-directory.profile-page.work-list.no-work-list.team.description',
        defaultMessage: 'Things the team created, edited or commented on in the last 90 days',
        description: 'Description of the message displayed when there is no work associated to the team profile that is being viewed'
    },
    noWorkListPersonDesc: {
        id: 'ptc-directory.profile-page.work-list.no-work-list.personal.description',
        defaultMessage: 'Things {user} created, edited or commented on in the last 90 days.',
        description: 'Description of the message displayed when there is no work associated to the person profile that is being viewed'
    },
    noWorkListDescForYou: {
        id: 'ptc-directory.profile-page.work-list.no-work-list.personal.description.you',
        defaultMessage: 'Things you created, edited or commented on in the last 90 days.',
        description: 'Description of the message displayed when there is no work associated to the current logged-in person profile that is being viewed'
    }
});
var $e7159b19029edd8d$export$2e2bcd8739ae039 = $e7159b19029edd8d$var$EmptyWorkState;

});
parcelRegister("jD9DW", function(module, exports) {
module.exports = new URL("WorkListEmpty_ptc.c984a049.svg", import.meta.url).toString();

});

parcelRegister("89vgZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7610b9bbbc1a6a8b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");

var $1io2n = parcelRequire("1io2n");
var $74Hyh = parcelRequire("74Hyh");

var $1Yiiu = parcelRequire("1Yiiu");
const $7610b9bbbc1a6a8b$var$getConfluenceSearchLink = (userId)=>{
    return `/wiki/search?contributors=${encodeURIComponent(userId)}&lastModified=lastMonth`;
};
const $7610b9bbbc1a6a8b$var$getJiraSearchLink = (userId)=>{
    // not sure why Jira does not need context-path for issue search page
    const jql = `assignee in (${userId})` + ` OR reporter in (${userId})` + ` OR creator in (${userId})` + ` OR watcher in (${userId})` + ' ORDER BY updated DESC';
    return `/issues/?jql=${encodeURIComponent(jql)}`;
};
const $7610b9bbbc1a6a8b$var$SearchLink = (props)=>{
    const analytics = (0, $74Hyh.default)();
    const { container: container, userId: userId } = props;
    const onClickSearchLink = ()=>{
        analytics.pushUIEvent({
            source: (0, $1io2n.AnalyticsEventSource).USER_WORK_SCREEN,
            actionSubject: 'searchMoreLink',
            action: (0, $1io2n.AnalyticsEventActions).CLICKED,
            attributes: {
                container: container
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yiiu.StyledLink), {
        href: container === 'Confluence' ? $7610b9bbbc1a6a8b$var$getConfluenceSearchLink(userId) : $7610b9bbbc1a6a8b$var$getJiraSearchLink(userId),
        target: "_blank",
        "data-test-selector": container.toLowerCase(),
        onClick: onClickSearchLink
    }, container);
};
const $7610b9bbbc1a6a8b$var$SearchMoreWork = (props)=>{
    const { isInEmptyState: isInEmptyState, userId: userId, userFullName: userFullName } = props;
    if (!userId || !userFullName) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, isInEmptyState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $7610b9bbbc1a6a8b$var$messages.searchInEmptyState) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $7610b9bbbc1a6a8b$var$messages.searchNotInEmptyState), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7610b9bbbc1a6a8b$var$SearchLink, {
        container: "Confluence",
        userId: userId
    }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $7610b9bbbc1a6a8b$var$messages.or), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7610b9bbbc1a6a8b$var$SearchLink, {
        container: "Jira",
        userId: userId
    }));
};
const $7610b9bbbc1a6a8b$var$messages = (0, $90IgZ.defineMessages)({
    searchInEmptyState: {
        id: 'ptc-directory.profile-page.work-list.search.in.empty.state',
        defaultMessage: 'You can also search in',
        description: 'A part of a full message is which "You can also search in Confluence or Jira". This is used in empty state of work list component'
    },
    searchNotInEmptyState: {
        id: 'ptc-directory.profile-page.work-list.search.in.not.empty.state',
        defaultMessage: 'Search for more in',
        description: 'A part of a full message is which "Search for more in in Confluence or Jira". This is used in empty state of work list table component'
    },
    or: {
        id: 'ptc-directory.profile-page.work-list.or',
        defaultMessage: 'or',
        description: ''
    }
});
var $7610b9bbbc1a6a8b$export$2e2bcd8739ae039 = $7610b9bbbc1a6a8b$var$SearchMoreWork;

});
parcelRegister("1Yiiu", function(module, exports) {

$parcel$export(module.exports, "StyledLink", () => $f1ea7bde11a82da3$export$9048d548939551ee);
/**
 * Use this component whenever you would need <a> or <Link>.
 * Use with `href` property to create an <a> tag and with `to` property
 * to create a <Link> tag.
 *
 * With using this component for all link elements we make sure links have
 * the proper hover and focus styles. Atlaskit/button with link appearance
 * does not have a correct focus style and is harder to deal with as it might
 * need additional props like spacing depending on where it's used.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");


var $kcFkB = parcelRequire("kcFkB");
const $f1ea7bde11a82da3$var$getColor = (props)=>props.appearance === 'subtle' ? `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})` : `var(--ds-link, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
const $f1ea7bde11a82da3$var$getHoverColor = (props)=>props.appearance === 'subtle' ? `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$7c87d337fb91a97d})` : `var(--ds-link, ${0, $73a5c9d720aa66e1$export$e62e8919cca44969})`;
const $f1ea7bde11a82da3$var$getActiveColor = (props)=>props.appearance === 'subtle' ? `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7c87d337fb91a97d})` : `var(--ds-link-pressed, ${0, $73a5c9d720aa66e1$export$e62e8919cca44969})`;
const $f1ea7bde11a82da3$export$9048d548939551ee = /*#__PURE__*/ (0, $kwce8.default)((0, $kcFkB.default)).withConfig({
    componentId: "ae9szl-0"
})`color:${(props)=>$f1ea7bde11a82da3$var$getColor(props)};&&:hover{color:${(props)=>$f1ea7bde11a82da3$var$getHoverColor(props)};text-decoration:underline;}&&:focus{outline:2px solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`};outline-offset:2px;}&&:active{color:${(props)=>$f1ea7bde11a82da3$var$getActiveColor(props)};outline:none;text-decoration:none;}`;

});



parcelRegister("bFEXl", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa2963a13b31b838$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $220ac = parcelRequire("220ac");

var $bAnhx = parcelRequire("bAnhx");

var $aFS1F = parcelRequire("aFS1F");

var $89vgZ = parcelRequire("89vgZ");
const $fa2963a13b31b838$var$SUPPORT_LINK_URI = (0, $bAnhx.getAtlassianContextUrl)('support');
const $fa2963a13b31b838$var$SUPPORT_LINK = (0, $bAnhx.getAtlassianContextDomain)('support');
function $fa2963a13b31b838$var$ErrorWorkState(props) {
    const { userId: userId, userFullName: userFullName } = props;
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: intl.formatMessage($fa2963a13b31b838$var$messages.errorTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...$fa2963a13b31b838$var$messages.errorDesc,
            values: {
                a: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                        "data-testid": "support-link",
                        href: $fa2963a13b31b838$var$SUPPORT_LINK_URI,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, $fa2963a13b31b838$var$SUPPORT_LINK)
            }
        }),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($aFS1F))),
        primaryAction: userFullName && userId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $89vgZ.default), {
            isInEmptyState: true,
            userId: userId,
            userFullName: userFullName
        })
    });
}
const $fa2963a13b31b838$var$messages = (0, $90IgZ.defineMessages)({
    errorTitle: {
        id: 'ptc-directory.profile-page.table-work-list.error.title',
        defaultMessage: 'We seem to have lost the connection',
        description: 'Title of error UI when fetching work list fails'
    },
    errorDesc: {
        id: 'ptc-directory.profile-page.table-work-list.error.desc',
        defaultMessage: 'Wait a few moments, then try refreshing the page. If this keeps happening, let us know at <a></a>.',
        description: 'Description of error UI when fetching work list fails'
    }
});
var $fa2963a13b31b838$export$2e2bcd8739ae039 = $fa2963a13b31b838$var$ErrorWorkState;

});
parcelRegister("aFS1F", function(module, exports) {
module.exports = new URL("WorkListError_ptc.b9457501.svg", import.meta.url).toString();

});


parcelRegister("9m7xM", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd2236c4eaf7d16a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");

var $gQ7yD = parcelRequire("gQ7yD");

var $0mRcP = parcelRequire("0mRcP");

var $kgmqw = parcelRequire("kgmqw");
const $cd2236c4eaf7d16a$var$timeFormatOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
};
const $cd2236c4eaf7d16a$var$getDescription = (activityObject, currentUserId)=>{
    if (activityObject.activity.length <= 0 || !activityObject.activity[0].user) return null;
    const description = activityObject.activity.length > 1 ? (0, $0mRcP.getI18nDataForManyEntries)(activityObject.activity, currentUserId) : (0, $0mRcP.getI18nDataForSingleEntry)(activityObject.activity[0], currentUserId);
    return description;
};
const $cd2236c4eaf7d16a$var$isDefined = (prop)=>{
    return !!prop;
};
function $cd2236c4eaf7d16a$export$ad0c9978cddbc3ff(activities, currentUserId) {
    return activities.map((activityObject)=>{
        const i18nForDescription = $cd2236c4eaf7d16a$var$getDescription(activityObject, currentUserId);
        if (!i18nForDescription) return null;
        if (i18nForDescription && 'time' in i18nForDescription.params && typeof i18nForDescription.params.time === 'string') i18nForDescription.params.time = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90IgZ.FormattedDate), {
            ...$cd2236c4eaf7d16a$var$timeFormatOptions,
            value: i18nForDescription.params.time
        });
        const { name: name = '', iconUrl: iconUrl = '', url: url = '', container: container = '', provider: provider = '' } = activityObject?.object || {};
        return {
            objectName: name,
            objectIconUrl: iconUrl,
            objectUrl: url,
            containerName: container,
            provider: provider,
            description: i18nForDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...i18nForDescription.key,
                values: i18nForDescription.params
            }) : ''
        };
    }).filter($cd2236c4eaf7d16a$var$isDefined);
}
const $cd2236c4eaf7d16a$var$getInfoText = (userId, currentUserId)=>{
    /**
	 * Return null if:
	 *  - userId or currentUserId is not defined
	 *  - current user is not viewing own activity
	 */ if (!userId || !currentUserId || userId !== currentUserId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kgmqw.messages).privacyAssuringInfoText);
};
function $cd2236c4eaf7d16a$export$2e2bcd8739ae039(props) {
    const { activities: activities, currentUserId: currentUserId, userId: userId, titleText: titleText, emptyView: emptyView, isLoading: isLoading, ...otherProps } = props;
    const workItems = $cd2236c4eaf7d16a$export$ad0c9978cddbc3ff(activities || [], currentUserId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQ7yD.default), {
        ...otherProps,
        workItems: workItems,
        isInitiallyExpanded: false,
        emptyView: emptyView,
        titleText: titleText,
        infoText: $cd2236c4eaf7d16a$var$getInfoText(userId, currentUserId),
        isLoading: isLoading
    });
}

});
parcelRegister("gQ7yD", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d83a374db5bb23$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $4ZUSO = parcelRequire("4ZUSO");

var $1Yiiu = parcelRequire("1Yiiu");

var $2r2pX = parcelRequire("2r2pX");

var $1W5tM = parcelRequire("1W5tM");

var $b0i96 = parcelRequire("b0i96");
const $82d83a374db5bb23$export$2aa3c3bd0ee6f3b7 = (props)=>{
    const [isExpanded, setIsExpanded] = (0, $eUqFw.useState)(props.isInitiallyExpanded);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onShowMore = (e)=>{
        e.preventDefault();
        const { workItems: workItems, onClickShowMore: onClickShowMore, limitExpanded: limitExpanded } = props;
        setIsExpanded(true);
        const workItemsCount = workItems.length;
        if (onClickShowMore) onClickShowMore(// No limit? Show workItems count, otherwise show smaller of limit vs count
        !limitExpanded ? workItemsCount : workItemsCount <= limitExpanded ? workItemsCount : limitExpanded);
    };
    const onClickViewAllLink = (location)=>()=>{
            if (props.onClickViewAllLink) props.onClickViewAllLink(location);
        };
    const onClickActivityEntry = (provider, entryIndex)=>()=>{
            if (props.onClickActivityEntry) props.onClickActivityEntry(provider, entryIndex);
        };
    const renderShowMoreButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0i96.FooterLink, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yiiu.StyledLink), {
            appearance: "subtle",
            onClick: onShowMore,
            href: "#",
            "aria-label": formatMessage($82d83a374db5bb23$export$defe85febe8b728c.showMoreLinkLabel)
        }, formatMessage($82d83a374db5bb23$export$defe85febe8b728c.showMoreLink)));
    const renderViewAllFooterButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0i96.FooterLink, null, renderViewAllLink({
            appearance: 'subtle',
            location: 'footer'
        }));
    const renderViewAllHeaderButton = ()=>props.workItems.length > 0 && props.viewAllLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0i96.HeaderLink, null, renderViewAllLink({
            location: 'header'
        }));
    const renderViewAllLink = (linkOptions)=>{
        const { appearance: appearance = 'default', location: location } = linkOptions;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yiiu.StyledLink), {
            appearance: appearance,
            href: props.viewAllLink,
            onClick: onClickViewAllLink(location),
            "aria-label": formatMessage($82d83a374db5bb23$export$defe85febe8b728c.viewAllLinkLabel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $82d83a374db5bb23$export$defe85febe8b728c.viewAllLink));
    };
    const renderFooterButtons = ()=>{
        const { viewAllLink: viewAllLink, workItems: workItems, limitDefault: limitDefault } = props;
        const workItemsCount = workItems.length;
        const canExpand = workItemsCount > limitDefault;
        if (workItemsCount === 0) return null;
        if (!isExpanded && canExpand) return renderShowMoreButton();
        if (viewAllLink) return renderViewAllFooterButton();
        return null;
    };
    const renderWorkItems = ()=>{
        const { workItems: workItems, limitDefault: limitDefault, limitExpanded: limitExpanded, emptyView: emptyView, isLoading: isLoading } = props;
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0i96.SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZUSO.default), {
            hasIcon: true,
            isShimmering: true,
            cssFn: ()=>({
                    paddingLeft: "var(--ds-space-100, 8px)",
                    paddingRight: "var(--ds-space-100, 8px)"
                }),
            itemCount: limitDefault || 0
        }));
        if (!workItems.length) return emptyView;
        const limit = isExpanded ? limitExpanded : limitDefault;
        return workItems.slice(0, limit).map((resourceItem, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1W5tM.default), {
                key: `work-item-${idx}`,
                objectName: resourceItem.objectName,
                description: resourceItem.description,
                objectUrl: resourceItem.objectUrl,
                objectIconUrl: resourceItem.objectIconUrl,
                containerName: resourceItem.containerName,
                provider: resourceItem.provider,
                onClick: onClickActivityEntry(resourceItem.provider, idx)
            }));
    };
    const { titleText: titleText, infoText: infoText } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2r2pX.PanelContent), {
        "data-testid": "profile-work-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2r2pX.PanelContentHeader), {
        hasSubInfo: !!infoText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2r2pX.PanelContentTitle), null, titleText || formatMessage($82d83a374db5bb23$export$defe85febe8b728c.listTitle)), renderViewAllHeaderButton()), infoText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0i96.WorkListInfoText, null, infoText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0i96.WorkListItems, null, renderWorkItems(), renderFooterButtons()));
};
$82d83a374db5bb23$export$2aa3c3bd0ee6f3b7.defaultProps = {
    isInitiallyExpanded: false,
    workItems: [],
    limitDefault: 5,
    limitExpanded: 10,
    onClickViewAllLink: ()=>null,
    onClickShowMore: ()=>null,
    onClickActivityEntry: ()=>null
};
const $82d83a374db5bb23$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    listTitle: {
        id: 'ptc-directory.profile-page.work-list.title',
        defaultMessage: 'Worked on'
    },
    showMoreLink: {
        id: 'ptc-directory.profile-page.work-list.show-more.link',
        defaultMessage: 'Show more',
        description: 'Link to reveal more work associated to the profile that is being viewed'
    },
    showMoreLinkLabel: {
        id: 'ptc-directory.profile-page.work-list.show-more.label',
        defaultMessage: 'Show more about worked on pages',
        description: 'Helper text for screen reader users. It is announced by screen reader when user focus the show more link'
    },
    viewAllLink: {
        id: 'ptc-directory.profile-page.work-list.view-all.link',
        defaultMessage: 'View all',
        description: 'Link to navigate to Work child page'
    },
    viewAllLinkLabel: {
        id: 'ptc-directory.profile-page.work-list.view-all.label',
        defaultMessage: 'View all worked on pages',
        description: 'Helper text for screen reader users. It is announced by screen reader when user focus the view all link'
    }
});
var $82d83a374db5bb23$export$2e2bcd8739ae039 = $82d83a374db5bb23$export$2aa3c3bd0ee6f3b7;

});
parcelRegister("4ZUSO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b296057aa290c571$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aVkzK = parcelRequire("aVkzK");
const $b296057aa290c571$var$SkeletonList = ({ hasIcon: hasIcon, hasAvatar: hasAvatar, isShimmering: isShimmering, cssFn: cssFn, itemCount: itemCount })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, Array(itemCount).fill(undefined).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
            key: `skeleton-${index}`,
            hasAvatar: hasAvatar,
            hasIcon: hasIcon,
            isShimmering: isShimmering,
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            cssFn: cssFn
        })));
};
var $b296057aa290c571$export$2e2bcd8739ae039 = $b296057aa290c571$var$SkeletonList;

});

parcelRegister("1W5tM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c70ebb0cf65172a5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");

var $ffiyv = parcelRequire("ffiyv");

var $0mRcP = parcelRequire("0mRcP");

var $gKMnh = parcelRequire("gKMnh");
const $c70ebb0cf65172a5$export$314aaaef607a8c3a = (props)=>{
    const { provider: provider, objectIconUrl: objectIconUrl, objectName: objectName, containerName: containerName, description: description, objectUrl: objectUrl, onClick: onClick } = props;
    const renderDraftStatus = ()=>{
        if (!(0, $0mRcP.isConfluenceDraft)(provider, objectUrl)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($gKMnh.LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "inprogress"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $c70ebb0cf65172a5$var$messages.draft)));
    };
    const renderBody = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($gKMnh.Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($gKMnh.ContentIcon, {
            src: objectIconUrl,
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($gKMnh.Details, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($gKMnh.DetailsHeadline, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, objectName), renderDraftStatus()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($gKMnh.DetailsDescription, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($gKMnh.ContainerName, null, containerName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($gKMnh.Description, null, description))));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($gKMnh.WorkItemLink, {
        href: objectUrl,
        onClick: onClick
    }, renderBody());
};
const $c70ebb0cf65172a5$var$messages = (0, $90IgZ.defineMessages)({
    draft: {
        id: 'ptc-directory.profile-page.work-item.draft',
        defaultMessage: 'Draft',
        description: 'A status of Confluence draft page. Draft pages are pages that have not yet been published. This text shows in a lozenge and in work list'
    }
});
var $c70ebb0cf65172a5$export$2e2bcd8739ae039 = $c70ebb0cf65172a5$export$314aaaef607a8c3a;

});
parcelRegister("0mRcP", function(module, exports) {

$parcel$export(module.exports, "getI18nDataForSingleEntry", () => $e847d4c3023a67ed$export$8d4c96888e68a4cb);
$parcel$export(module.exports, "getI18nDataForManyEntries", () => $e847d4c3023a67ed$export$a8eeb0c18ec4b955);
$parcel$export(module.exports, "isConfluenceDraft", () => $e847d4c3023a67ed$export$c73d42331d87b9d8);

var $jh9tF = parcelRequire("jh9tF");
var $iHCx5 = parcelRequire("iHCx5");

var $kgmqw = parcelRequire("kgmqw");
const $e847d4c3023a67ed$export$493c11ff22f45a24 = (activityDate)=>{
    if ((0, $iHCx5.default)(activityDate)) return 'Yesterday';
    if ((0, $jh9tF.default)(activityDate)) return 'Today';
    return 'Time';
};
var $e847d4c3023a67ed$export$5f5db21fc2e4c897;
(function(ActivityType) {
    ActivityType["EDITED"] = "Edited";
    ActivityType["COMMENTED"] = "Commented";
    ActivityType["CREATED"] = "Created";
    ActivityType["WORKED"] = "Worked";
    // some new event type from Worklens
    ActivityType["ASSIGNED"] = "Assigned";
    ActivityType["UNASSIGNED"] = "Unassigned";
    ActivityType["LIKED"] = "Liked";
    ActivityType["PUBLISHED"] = "Published";
    ActivityType["UPDATED"] = "Updated";
})($e847d4c3023a67ed$export$5f5db21fc2e4c897 || ($e847d4c3023a67ed$export$5f5db21fc2e4c897 = {}));
const $e847d4c3023a67ed$export$72f0c8726f4b058c = (activityType)=>{
    const allActivityVerbs = Object.values($e847d4c3023a67ed$export$5f5db21fc2e4c897);
    const supportedVerb = allActivityVerbs.find((actionType)=>{
        return actionType.toLowerCase() === activityType.toLowerCase();
    });
    return supportedVerb || "Worked";
};
const $e847d4c3023a67ed$export$8d4c96888e68a4cb = (activityEntry, currentUserId)=>{
    // Due to i18n'ing being a hard problem, there are many possible cases already listed in messages.
    // We'll construct the key rather than list them all here.
    // Key will be of the form: [you|other]Individual[Verb][Today|Yesterday|Time]
    const whoMadeActivity = activityEntry.user && activityEntry.user.id === currentUserId ? 'you' : 'other';
    const activityVerb = $e847d4c3023a67ed$export$72f0c8726f4b058c(activityEntry.type);
    const activityTime = $e847d4c3023a67ed$export$493c11ff22f45a24(activityEntry.date ? new Date(activityEntry.date) : new Date());
    const params = {
        name: activityEntry.user.fullName || ''
    };
    if (activityTime === 'Time') params.time = activityEntry.date || undefined;
    return {
        key: (0, $kgmqw.messages)[whoMadeActivity + 'Individual' + activityVerb + activityTime],
        params: params
    };
};
const $e847d4c3023a67ed$var$I18N_KEYS_VARIATIONS_FOR_MULTIPLE = {
    you: {
        // including "with you" meaning for more than 1 activity
        '2': (0, $kgmqw.messages).youDoubleWorkedOn,
        '3': (0, $kgmqw.messages).youTripleWorkedOn,
        many: (0, $kgmqw.messages).youManyWorkedOn
    },
    others: {
        '2': (0, $kgmqw.messages).othersDoubleWorkedOn,
        '3': (0, $kgmqw.messages).othersTripleWorkedOn,
        many: (0, $kgmqw.messages).othersManyWorkedOn
    }
};
const $e847d4c3023a67ed$export$a8eeb0c18ec4b955 = (userActivityEntries, currentUser)=>{
    const containsCurrentUser = userActivityEntries.some((activity)=>activity.user.id === currentUser);
    const otherUserFullNames = userActivityEntries.filter((activity)=>activity.user.id !== currentUser).map((activity)=>activity.user.fullName);
    // params that we will pass to our translations
    const othersCount = otherUserFullNames.length - (containsCurrentUser ? 1 : 2);
    const names = {};
    otherUserFullNames.forEach((userFullName, idx)=>{
        // @ts-ignore
        names[`name${idx + 1}`] = userFullName;
    });
    const activitiesCount = userActivityEntries.length;
    const collabAmount = activitiesCount <= 3 ? activitiesCount : 'many';
    const collabType = containsCurrentUser ? 'you' : 'others';
    return {
        // @ts-ignore
        key: $e847d4c3023a67ed$var$I18N_KEYS_VARIATIONS_FOR_MULTIPLE[collabType][collabAmount],
        params: {
            count: othersCount,
            ...names
        }
    };
};
function $e847d4c3023a67ed$export$c73d42331d87b9d8(provider, objectUrl) {
    if (!provider || !objectUrl) return false;
    return provider.toLowerCase() === 'confluence' && (objectUrl.includes('draftId=') || objectUrl.includes('draftShareId='));
}

});
parcelRegister("kgmqw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ce352edc187a706e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");

var $7xnUk = parcelRequire("7xnUk");

var $9itKK = parcelRequire("9itKK");

var $bpg8s = parcelRequire("bpg8s");

var $24Miz = parcelRequire("24Miz");
/**
 * There are a LOT of messages here due to the joys of i18n. They roughly fall into the following categories"
 *  -> Single person that isn't you performed an action (one for each verb and time period combination)
 *  -> Single person that is you performed an action (one for each verb and time period combination)
 *  -> Two people performed an action (one for including you, and one for not including you)
 *  -> Three people performed an action (one for including you, and one for not including you)
 *  -> More than three people performed an action (one for including you, and one for not including you)
 */ const $ce352edc187a706e$var$otherMsg = (0, $90IgZ.defineMessages)({
    privacyAssuringInfoText: {
        id: 'ptc-directory.work-activity.privacy-assurity',
        defaultMessage: 'Others will only see what they can access.',
        description: "Appears next to a list of recently worked on items on a user\u2019s own profile page. Only appears when viewing yourself. Text assuring the user that private activity items will not appear to others who view this page. Visibility is subject to each individual\u2019s privileges."
    }
});
const $ce352edc187a706e$export$defe85febe8b728c = {
    ...$ce352edc187a706e$var$otherMsg,
    ...(0, $7xnUk.messages),
    ...(0, $9itKK.messages),
    ...(0, $24Miz.messages),
    ...(0, $bpg8s.messages)
};

});
parcelRegister("7xnUk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $daf72119069073ad$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $daf72119069073ad$var$msgForCommented = (0, $90IgZ.defineMessages)({
    otherIndividualCommentedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.today',
        defaultMessage: '{name} commented here today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else commented on the work today."
    },
    otherIndividualCommentedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.yesterday',
        defaultMessage: '{name} commented here yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else commented on the work yesterday."
    },
    otherIndividualCommentedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.time',
        defaultMessage: '{name} commented here on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else commented on the work earlier than yesterday."
    }
});
const $daf72119069073ad$var$msgForCreated = (0, $90IgZ.defineMessages)({
    otherIndividualCreatedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.created.today',
        defaultMessage: '{name} created this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else created the work today."
    },
    otherIndividualCreatedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.created.yesterday',
        defaultMessage: '{name} created this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else created the work yesterday"
    },
    otherIndividualCreatedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.created.time',
        defaultMessage: '{name} created this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else created the work earlier than yesterday."
    }
});
const $daf72119069073ad$var$msgForEdited = (0, $90IgZ.defineMessages)({
    otherIndividualEditedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.today',
        defaultMessage: '{name} edited this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else edited the work today"
    },
    otherIndividualEditedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.yesterday',
        defaultMessage: '{name} edited this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else edited the work yesterday"
    },
    otherIndividualEditedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.time',
        defaultMessage: '{name} edited this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else edited the work earlier than yesterday"
    }
});
const $daf72119069073ad$var$msgForWorked = (0, $90IgZ.defineMessages)({
    otherIndividualWorkedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.today',
        defaultMessage: '{name} worked on this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else performed an unknown operation on the work today"
    },
    otherIndividualWorkedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.yesterday',
        defaultMessage: '{name} worked on this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else performed an unknown operation on the work yesterday"
    },
    otherIndividualWorkedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.time',
        defaultMessage: '{name} worked on this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else performed an unknown operation on the work earlier than yesterday"
    }
});
const $daf72119069073ad$var$msgForAssigned = (0, $90IgZ.defineMessages)({
    otherIndividualAssignedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.today',
        defaultMessage: '{name} was assigned this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else assigned the work today"
    },
    otherIndividualAssignedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.yesterday',
        defaultMessage: '{name} was assigned this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else assigned the work yesterday"
    },
    otherIndividualAssignedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.time',
        defaultMessage: '{name} was assigned this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else assigned the work earlier than yesterday"
    }
});
const $daf72119069073ad$var$msgForUnassigned = (0, $90IgZ.defineMessages)({
    otherIndividualUnassignedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.today',
        defaultMessage: '{name} was unassigned this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else unassigned the work today"
    },
    otherIndividualUnassignedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.yesterday',
        defaultMessage: '{name} was unassigned this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else unassigned the work yesterday"
    },
    otherIndividualUnassignedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.time',
        defaultMessage: '{name} was unassigned this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else unassigned the work earlier than yesterday"
    }
});
const $daf72119069073ad$var$msgForLiked = (0, $90IgZ.defineMessages)({
    otherIndividualLikedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.today',
        defaultMessage: '{name} liked this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else liked the work today"
    },
    otherIndividualLikedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.yesterday',
        defaultMessage: '{name} liked this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else liked the work yesterday"
    },
    otherIndividualLikedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.time',
        defaultMessage: '{name} liked this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else liked the work earlier than yesterday"
    }
});
const $daf72119069073ad$var$msgForPublished = (0, $90IgZ.defineMessages)({
    otherIndividualPublishedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.published.today',
        defaultMessage: '{name} published this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else published the work today"
    },
    otherIndividualPublishedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.published.yesterday',
        defaultMessage: '{name} published this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else published the work yesterday"
    },
    otherIndividualPublishedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.published.time',
        defaultMessage: '{name} published this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else published the work earlier than yesterday"
    }
});
const $daf72119069073ad$var$msgForUpdated = (0, $90IgZ.defineMessages)({
    otherIndividualUpdatedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.today',
        defaultMessage: '{name} updated this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else updated the work today"
    },
    otherIndividualUpdatedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.yesterday',
        defaultMessage: '{name} updated this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else updated the work yesterday"
    },
    otherIndividualUpdatedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.time',
        defaultMessage: '{name} updated this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else updated the work earlier than yesterday"
    }
});
const $daf72119069073ad$export$defe85febe8b728c = {
    ...$daf72119069073ad$var$msgForCommented,
    ...$daf72119069073ad$var$msgForCreated,
    ...$daf72119069073ad$var$msgForEdited,
    ...$daf72119069073ad$var$msgForWorked,
    ...$daf72119069073ad$var$msgForAssigned,
    ...$daf72119069073ad$var$msgForUnassigned,
    ...$daf72119069073ad$var$msgForLiked,
    ...$daf72119069073ad$var$msgForPublished,
    ...$daf72119069073ad$var$msgForUpdated
};

});

parcelRegister("9itKK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4b56bc22e30eaf99$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $4b56bc22e30eaf99$var$msgForWorked = (0, $90IgZ.defineMessages)({
    youIndividualWorkedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.today',
        defaultMessage: 'You worked on this today',
        description: "This message appears in work list area of the user profile pageand indicate when you performed an unknown operation on the work today"
    },
    youIndividualWorkedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.yesterday',
        defaultMessage: 'You worked on this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when you performed an unknown operation on the work yesterday"
    },
    youIndividualWorkedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.time',
        defaultMessage: 'You worked on this {time}',
        description: "This message appears in work list area of the user profile pageand indicate when you performed an unknown operation on the work earlier than yesterday"
    }
});
const $4b56bc22e30eaf99$var$msgForCommented = (0, $90IgZ.defineMessages)({
    youIndividualCommentedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.today',
        defaultMessage: 'You commented here today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user commented on the work today"
    },
    youIndividualCommentedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.yesterday',
        defaultMessage: 'You commented here yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user commented on the work yesterday"
    },
    youIndividualCommentedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.time',
        defaultMessage: 'You commented here on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user commented on the work earlier than yesterday"
    }
});
const $4b56bc22e30eaf99$var$msgForCreated = (0, $90IgZ.defineMessages)({
    youIndividualCreatedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.created.today',
        defaultMessage: 'You created this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user created the work today"
    },
    youIndividualCreatedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.created.yesterday',
        defaultMessage: 'You created this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user created the work yesterday"
    },
    youIndividualCreatedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.created.time',
        defaultMessage: 'You created this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user created the work earlier than yesterday"
    }
});
const $4b56bc22e30eaf99$var$msgForEdited = (0, $90IgZ.defineMessages)({
    youIndividualEditedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.today',
        defaultMessage: 'You edited this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user edited the work today"
    },
    youIndividualEditedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.yesterday',
        defaultMessage: 'You edited this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user edited the work yesterday"
    },
    youIndividualEditedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.time',
        defaultMessage: 'You edited this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user edited the work earlier than yesterday"
    }
});
const $4b56bc22e30eaf99$var$msgForAssigned = (0, $90IgZ.defineMessages)({
    youIndividualAssignedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.today',
        defaultMessage: 'You were assigned this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work today"
    },
    youIndividualAssignedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.yesterday',
        defaultMessage: 'You were assigned this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualAssignedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.time',
        defaultMessage: 'You were assigned this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work earlier than yesterday"
    }
});
const $4b56bc22e30eaf99$var$msgForUnassigned = (0, $90IgZ.defineMessages)({
    youIndividualUnassignedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.today',
        defaultMessage: 'You were unassigned this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is unassigned the work today"
    },
    youIndividualUnassignedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.yesterday',
        defaultMessage: 'You were unassigned this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualUnassignedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.time',
        defaultMessage: 'You were unassigned this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is unassigned the work earlier than yesterday"
    }
});
const $4b56bc22e30eaf99$var$msgForLiked = (0, $90IgZ.defineMessages)({
    youIndividualLikedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.today',
        defaultMessage: 'You liked this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user liked the work today"
    },
    youIndividualLikedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.yesterday',
        defaultMessage: 'You liked this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualLikedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.time',
        defaultMessage: 'You liked this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user liked the work earlier than yesterday"
    }
});
const $4b56bc22e30eaf99$var$msgForPublished = (0, $90IgZ.defineMessages)({
    youIndividualPublishedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.published.today',
        defaultMessage: 'You published this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user published the work today"
    },
    youIndividualPublishedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.published.yesterday',
        defaultMessage: 'You published this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualPublishedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.published.time',
        defaultMessage: 'You published this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user published the work earlier than yesterday"
    }
});
const $4b56bc22e30eaf99$var$msgForUpdated = (0, $90IgZ.defineMessages)({
    youIndividualUpdatedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.today',
        defaultMessage: 'You updated this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user updated the work today"
    },
    youIndividualUpdatedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.yesterday',
        defaultMessage: 'You updated this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualUpdatedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.time',
        defaultMessage: 'You updated this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user updated the work earlier than yesterday"
    }
});
const $4b56bc22e30eaf99$export$defe85febe8b728c = {
    ...$4b56bc22e30eaf99$var$msgForWorked,
    ...$4b56bc22e30eaf99$var$msgForCommented,
    ...$4b56bc22e30eaf99$var$msgForCreated,
    ...$4b56bc22e30eaf99$var$msgForEdited,
    ...$4b56bc22e30eaf99$var$msgForAssigned,
    ...$4b56bc22e30eaf99$var$msgForUnassigned,
    ...$4b56bc22e30eaf99$var$msgForLiked,
    ...$4b56bc22e30eaf99$var$msgForPublished,
    ...$4b56bc22e30eaf99$var$msgForUpdated
};

});

parcelRegister("bpg8s", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7a63ef53668778ef$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $7a63ef53668778ef$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    othersManyWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.many.others.worked',
        defaultMessage: '{name1}, {name2}, and {count} others have all worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when more than three users that arent you worked on an object"
    },
    youManyWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.many.you.worked',
        defaultMessage: 'You, {name1}, and {count} others have all worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when more than three users including the current user worked on an object"
    }
});

});

parcelRegister("24Miz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $021e496d78e3ae6a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $021e496d78e3ae6a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    othersDoubleWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.double.others.worked',
        defaultMessage: '{name1} and {name2} have both worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when two users that arent you worked on an object"
    },
    youDoubleWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.double.you.worked',
        defaultMessage: 'You and {name1} have both worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when two users including the current user worked on an object"
    },
    // Messages for three people
    othersTripleWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.triple.others.worked',
        defaultMessage: '{name1}, {name2}, and {name3} have all worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when three users that arent you worked on an object"
    },
    youTripleWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.triple.you.worked',
        defaultMessage: 'You, {name1}, and {name2} have all worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when three users including the current user worked on an object"
    }
});

});



parcelRegister("gKMnh", function(module, exports) {

$parcel$export(module.exports, "WorkItemLink", () => $574a0fec7cf043a7$export$337f3677fd9cf9c1);
$parcel$export(module.exports, "Content", () => $574a0fec7cf043a7$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "ContentIcon", () => $574a0fec7cf043a7$export$a1ea799cb5c1b499);
$parcel$export(module.exports, "Details", () => $574a0fec7cf043a7$export$3e8048d3cf2ba3fd);
$parcel$export(module.exports, "DetailsHeadline", () => $574a0fec7cf043a7$export$505f19144b08f91a);
$parcel$export(module.exports, "DetailsDescription", () => $574a0fec7cf043a7$export$6ac35bf2875b1dd9);
$parcel$export(module.exports, "ContainerName", () => $574a0fec7cf043a7$export$b7e45c2cd09f088a);
$parcel$export(module.exports, "Description", () => $574a0fec7cf043a7$export$393edc798c47379d);
$parcel$export(module.exports, "LozengeWrapper", () => $574a0fec7cf043a7$export$75180efdd3f4d9c2);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");


var $kcFkB = parcelRequire("kcFkB");
const $574a0fec7cf043a7$export$337f3677fd9cf9c1 = /*#__PURE__*/ (0, $kwce8.default)((0, $kcFkB.default)).withConfig({
    componentId: "sc-1brh7h6-0"
})`position:relative;margin:0;overflow:hidden;display:block;padding-left:${"var(--ds-space-150, 12px)"};padding-right:${"var(--ds-space-150, 12px)"};border-radius:${"var(--ds-border-radius-100, 3px)"};&:hover{background:${`var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`};}&:focus{outline:0;box-shadow:0 0 0 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`};}& + &{margin:${"var(--ds-space-050, 4px)"} 0 0 0;}`;
const $574a0fec7cf043a7$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1brh7h6-1"
})`display:flex;`;
const $574a0fec7cf043a7$export$a1ea799cb5c1b499 = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "sc-1brh7h6-2"
})`border-radius:${"var(--ds-border-radius-100, 3px)"};display:flex;flex-shrink:0;width:${"var(--ds-space-300, 24px)"};height:${"var(--ds-space-300, 24px)"};margin-top:${"var(--ds-space-100, 8px)"};margin-bottom:${"var(--ds-space-100, 8px)"};`;
const $574a0fec7cf043a7$export$3e8048d3cf2ba3fd = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1brh7h6-3"
})`display:flex;flex-direction:column;margin-left:${"var(--ds-space-200, 16px)"};justify-content:center;min-width:0;`;
const $574a0fec7cf043a7$export$505f19144b08f91a = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1brh7h6-4"
})`padding-right:${"var(--ds-space-150, 12px)"};padding-bottom:${"var(--ds-space-025, 2px)"};display:flex;align-items:center;p{display:inline-block;font-size:14px;line-height:16px;margin:0;color:${`var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`};overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}`;
const $574a0fec7cf043a7$export$6ac35bf2875b1dd9 = /*#__PURE__*/ (0, $kwce8.default).p.withConfig({
    componentId: "sc-1brh7h6-5"
})`font-size:11px;line-height:14px;color:${`var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`};margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:${"var(--ds-space-150, 12px)"};`;
const $574a0fec7cf043a7$export$b7e45c2cd09f088a = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-1brh7h6-6"
})`&:after{content:'\\00B7';padding-right:${"var(--ds-space-050, 4px)"};padding-left:${"var(--ds-space-050, 4px)"};}`;
const $574a0fec7cf043a7$export$393edc798c47379d = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-1brh7h6-7"
})``;
const $574a0fec7cf043a7$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-1brh7h6-8"
})`margin-left:${"var(--ds-space-050, 4px)"};`;

});


parcelRegister("b0i96", function(module, exports) {

$parcel$export(module.exports, "HeaderLink", () => $7424be62a4fa6f82$export$29c3409e43add430);
$parcel$export(module.exports, "FooterLink", () => $7424be62a4fa6f82$export$e0513c91be1318ca);
$parcel$export(module.exports, "WorkListInfoText", () => $7424be62a4fa6f82$export$fff90b174811109c);
$parcel$export(module.exports, "WorkListItems", () => $7424be62a4fa6f82$export$3af7e1e011c8bee1);
$parcel$export(module.exports, "SkeletonWrapper", () => $7424be62a4fa6f82$export$6069cbe61f690103);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");


var $hxsfc = parcelRequire("hxsfc");
const $7424be62a4fa6f82$export$29c3409e43add430 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-12dsuy4-0"
})`margin-left:${"var(--ds-space-300, 24px)"};`;
const $7424be62a4fa6f82$export$e0513c91be1318ca = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-12dsuy4-1"
})`font-size:11px;margin-left:${"var(--ds-space-150, 12px)"};margin-top:${"var(--ds-space-200, 16px)"};display:flex;color:${`var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`};`;
const $7424be62a4fa6f82$export$fff90b174811109c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-12dsuy4-2"
})`display:flex;align-items:center;width:100%;${(0, $hxsfc.smallTextTypography)};`;
const $7424be62a4fa6f82$export$3af7e1e011c8bee1 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-12dsuy4-3"
})`border-radius:${"var(--ds-border-radius-100, 3px)"};background-color:${"var(--ds-surface-raised, transparent)"};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)}`})`};padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-100, 8px)"};${$7424be62a4fa6f82$export$fff90b174811109c} + &{margin-top:${"var(--ds-space-200, 16px)"};}`;
const $7424be62a4fa6f82$export$7fd31be4a556b1a0 = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "sc-12dsuy4-4"
})`height:${144}px;`;
const $7424be62a4fa6f82$export$475f8a59614a59ca = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-12dsuy4-5"
})`margin-left:${"var(--ds-space-400, 32px)"};min-width:180px;`;
const $7424be62a4fa6f82$export$a4f85c7f5a5731ac = /*#__PURE__*/ (0, $kwce8.default).h3.withConfig({
    componentId: "sc-12dsuy4-6"
})`margin-bottom:${"var(--ds-space-200, 16px)"};`;
const $7424be62a4fa6f82$export$cb03cebe08ab9b6a = /*#__PURE__*/ (0, $kwce8.default).p.withConfig({
    componentId: "sc-12dsuy4-7"
})``;
const $7424be62a4fa6f82$export$6069cbe61f690103 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-12dsuy4-8"
})`& + &{margin:${"var(--ds-space-050, 4px)"} 0 0 0;}`;

});
parcelRegister("hxsfc", function(module, exports) {

$parcel$export(module.exports, "ellipsis", () => $c058019d36b5e247$export$a5b94313d6908893);
$parcel$export(module.exports, "twoLineEllipsis", () => $c058019d36b5e247$export$e6fc941710bd9bc7);
$parcel$export(module.exports, "ellipsisInFlexChild", () => $c058019d36b5e247$export$58ca30256a534b20);
$parcel$export(module.exports, "smallTextTypography", () => $c058019d36b5e247$export$64de456cd1a0ab3f);
$parcel$export(module.exports, "linkShadowItem", () => $c058019d36b5e247$export$37da6d213fb80270);
$parcel$export(module.exports, "MultilineEllipsis", () => $c058019d36b5e247$export$7252344cf484ff6d);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ 

var $kwce8 = parcelRequire("kwce8");

var $7OQHj = parcelRequire("7OQHj");
const $c058019d36b5e247$export$a5b94313d6908893 = `
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const $c058019d36b5e247$export$e6fc941710bd9bc7 = `
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $c058019d36b5e247$export$58ca30256a534b20 = /*#__PURE__*/ (0, $kwce8.css)`min-width:0;${$c058019d36b5e247$export$a5b94313d6908893};`;
const $c058019d36b5e247$export$2c2e9c688ff3eaac = /*#__PURE__*/ (0, $kwce8.css)`font-size:14px;font-weight:400;letter-spacing:-0.005em;color:${`var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`};line-height:20px;`;
const $c058019d36b5e247$export$64de456cd1a0ab3f = /*#__PURE__*/ (0, $kwce8.css)`color:${`var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`};font-size:12px;line-height:${14 / 12};`;
const $c058019d36b5e247$export$37da6d213fb80270 = /*#__PURE__*/ (0, $kwce8.css)`background:${`var(--ds-surface-raised, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};transition:box-shadow 0.25s ease;box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)}`})`};&:hover,&.active{box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`};}`;
const $c058019d36b5e247$export$7252344cf484ff6d = (maxLines = 1, lineHeight = (0, $7OQHj.rootAbsoluteLineHeight))=>(0, $kwce8.css)`overflow:hidden;-webkit-line-clamp:${maxLines};-webkit-box-orient:vertical;display:-webkit-box;text-overflow:ellipsis;max-height:${maxLines * lineHeight}px;`;

});
parcelRegister("7OQHj", function(module, exports) {

$parcel$export(module.exports, "rootAbsoluteLineHeight", () => $2d83a3775c6b73fd$export$914d38d0b781a6d3);
$parcel$export(module.exports, "getGlobalTheme", () => $2d83a3775c6b73fd$export$813ecdf77207a053);
const $2d83a3775c6b73fd$export$3abda77ebd0bb50f = 1.42857143;
const $2d83a3775c6b73fd$export$a22cfca5dbca7fb5 = 14;
const $2d83a3775c6b73fd$export$914d38d0b781a6d3 = $2d83a3775c6b73fd$export$3abda77ebd0bb50f * $2d83a3775c6b73fd$export$a22cfca5dbca7fb5;
const $2d83a3775c6b73fd$export$813ecdf77207a053 = ()=>{
    // Determine global theme
    const documentElement = document.documentElement;
    const rawTheme = documentElement.getAttribute('data-theme');
    return rawTheme === 'dark' ? 'dark' : 'light';
};

});








parcelRegister("91BVc", function(module, exports) {

$parcel$export(module.exports, "AgentAboutPanel", () => $7a9de29830a4680a$export$a9a242371bd64127);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $hWMAc = parcelRequire("hWMAc");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $391Jw = parcelRequire("391Jw");
var $1Zrfp = parcelRequire("1Zrfp");

var $1io2n = parcelRequire("1io2n");

var $j9wA1 = parcelRequire("j9wA1");

var $2LVgg = parcelRequire("2LVgg");
const $7a9de29830a4680a$var$agentAboutPanelStyles = (0, $1ZAYh.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderRadius: '6px',
    padding: 'space.300',
    display: 'flex',
    flexDirection: 'column'
});
const $7a9de29830a4680a$var$headingStyles = (0, $1ZAYh.xcss)({
    textTransform: 'uppercase',
    fontSize: '12px',
    fontWeight: '600'
});
const $7a9de29830a4680a$var$AbouSectionHeaders = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $7a9de29830a4680a$var$headingStyles
    }, children);
const $7a9de29830a4680a$export$eceb80593c9ade2e = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $7a9de29830a4680a$var$agentAboutPanelStyles,
        space: "space.300"
    }, children);
const $7a9de29830a4680a$export$a9a242371bd64127 = ({ agent: agent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const agentIdentityId = (0, $j9wA1.trimUserARI)(agent?.identity_account_id || '');
    const agentPluginConfig = agent.available_plugins?.['Search-QA-Plugin'];
    const isForgeAgent = agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7a9de29830a4680a$export$eceb80593c9ade2e, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7a9de29830a4680a$var$AbouSectionHeaders, null, formatMessage($7a9de29830a4680a$var$messages.aboutLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWMAc))), {
        label: "",
        color: "currentColor"
    }), formatMessage($7a9de29830a4680a$var$messages.rovoAgentLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7a9de29830a4680a$var$AbouSectionHeaders, null, formatMessage($7a9de29830a4680a$var$messages.knowledgeLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $391Jw.AgentKnowledgeSection), {
        cloudUrl: '',
        spaceKeys: agentPluginConfig?.space_filter ?? [],
        aris: (0, $1Zrfp.getEnabledKnowlegeArisFromAgent)(agent),
        isForgeAgent: isForgeAgent
    })), (0, $XHGTv.fg)('enable_teams_for_agents') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2LVgg.default), {
        userId: agentIdentityId,
        isActiveUser: !agent.deactivated,
        userFullName: agent.name,
        analyticsSource: (0, $1io2n.AnalyticsEventSource).USER_PROFILE_SCREEN
    }))));
};
const $7a9de29830a4680a$var$messages = (0, $90IgZ.defineMessages)({
    aboutLabel: {
        id: 'ptc-directory.agent-profile.about-agent.about-label',
        defaultMessage: 'About',
        description: 'Label for about section of the agent'
    },
    rovoAgentLabel: {
        id: 'ptc-directory.agent-profile.about-agent.rovo-agent-label',
        defaultMessage: 'Rovo Agent',
        description: 'The content inside About section, indicating this profile is a Rovo Agent'
    },
    knowledgeLabel: {
        id: 'ptc-directory.agent-profile.about-agent.knowledge-label',
        defaultMessage: 'Knowledge',
        description: 'Label for knowledge section of the agent'
    },
    teamsLabel: {
        id: 'ptc-directory.agent-profile.about-agent.teams-label',
        defaultMessage: 'Teams',
        description: 'Label for teams section of the agent'
    },
    createTeamLabel: {
        id: 'ptc-directory.agent-profile.about-agent.teams-label',
        defaultMessage: 'Create a team together',
        description: 'Label for teams section of the agent'
    }
});

});
parcelRegister("hWMAc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71433f9acaed41c70af23acdbb168054>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d10d89fd43d4d820$var$_react = $d10d89fd43d4d820$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d10d89fd43d4d820$var$_UNSAFE_baseNew = $d10d89fd43d4d820$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $d10d89fd43d4d820$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d10d89fd43d4d820$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $d10d89fd43d4d820$var$_react.default.createElement($d10d89fd43d4d820$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 8.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V8.75m-12.5 0V6c0-.69.56-1.25 1.25-1.25h1.75m-3 4H8m6.25 0V6c0-.69-.56-1.25-1.25-1.25h-1.75m3 4H8m0 0V11M4.75 4.75V3c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v1.75m-6.5 0h6.5"/>`
    }, props));
$d10d89fd43d4d820$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
var $d10d89fd43d4d820$var$_default = module.exports.default = $d10d89fd43d4d820$var$BriefcaseIcon;

});

parcelRegister("391Jw", function(module, exports) {

$parcel$export(module.exports, "AgentKnowledgeSection", () => $20677fe25093fe57$export$b1c40600d1679d39);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $asu8X = parcelRequire("asu8X");

var $fXMW0 = parcelRequire("fXMW0");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");

var $hFxJG = parcelRequire("hFxJG");

var $lPrVW = parcelRequire("lPrVW");
var $aml13 = parcelRequire("aml13");

var $6n1kb = parcelRequire("6n1kb");

var $gJOO5 = parcelRequire("gJOO5");

var $ibi44 = parcelRequire("ibi44");

var $2Hoee = parcelRequire("2Hoee");
const $20677fe25093fe57$export$b1c40600d1679d39 = ({ cloudUrl: cloudUrl, spaceKeys: spaceKeys, aris: aris, isForgeAgent: isForgeAgent })=>{
    (0, $asu8X.di)((0, $ibi44.useKnowledgeFilterService));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getEntitiesByAris: getEntitiesByAris } = (0, $ibi44.useKnowledgeFilterService)();
    const { isFetching: isFetching, data: urls } = (0, $6n1kb.useQuery)({
        queryKey: [
            'getEntitiesByAris'
        ].concat(aris || []).concat(spaceKeys || []),
        queryFn: async ()=>{
            if (!(0, $XHGTv.fg)('rovo_chat_use_new_knowledge_filters')) return spaceKeys.map((spaceKey)=>`${cloudUrl}/wiki/spaces/${spaceKey}/overview`);
            if (!aris?.length) return [];
            const entities = await getEntitiesByAris({
                aris: aris
            });
            const links = entities.map((entity)=>entity.url);
            return links;
        },
        enabled: !isForgeAgent
    });
    const getKnowledgeRender = ()=>{
        if (isForgeAgent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fXMW0))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
            weight: "bold"
        }, formatMessage((0, $2Hoee.default).privateKnowledgeTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
            size: "small"
        }, formatMessage((0, $2Hoee.default).privateKnowledgeDescription))));
        if (!urls?.length && !isFetching) return formatMessage((0, $2Hoee.default).noKnowledgeAdded);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.050"
        }, isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
            height: 22,
            width: 200,
            borderRadius: 8,
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
            height: 22,
            width: 150,
            borderRadius: 8,
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
            height: 22,
            width: 200,
            borderRadius: 8,
            isShimmering: true
        })) : urls?.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPrVW.Card), {
                key: url,
                fallbackComponent: (0, $gJOO5.smartLinkFallback)(url),
                appearance: "inline",
                url: url
            })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "view-agent-knowledge-cards"
    }, getKnowledgeRender()));
};

});
parcelRegister("lPrVW", function(module, exports) {

$parcel$export(module.exports, "Card", () => $78a7752e8d5385c2$export$60332b2344f7fe41);

var $eUqFw = parcelRequire("eUqFw");

var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $en3x5 = parcelRequire("en3x5");

var $6VBvh = parcelRequire("6VBvh");

var $9A6mL = parcelRequire("9A6mL");

var $bTNMs = parcelRequire("bTNMs");

var $2qhQi = parcelRequire("2qhQi");
var $3dpxL = parcelRequire("3dpxL");
class $78a7752e8d5385c2$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const content = (0, $9A6mL.isCardWithData)(this.props) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $en3x5.CardWithDataRenderer), this.props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6VBvh.CardWithURLRenderer), this.props);
        return this.props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
            locale: "en"
        }, content);
    }
}
const $78a7752e8d5385c2$export$60332b2344f7fe41 = (0, $1ngde.default)((0, $bTNMs.context))((0, $2jDha.default)()((0, $2qhQi.default)($78a7752e8d5385c2$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("en3x5", function(module, exports) {

$parcel$export(module.exports, "CardWithDataRenderer", () => $d28fa1f36649938a$export$9d0e69e8740e5c1c);

var $eUqFw = parcelRequire("eUqFw");

class $d28fa1f36649938a$export$9d0e69e8740e5c1c extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.CardContent = null;
    }
    static moduleImporter(target) {
        (parcelRequire("jPswi")).then((module)=>{
            $d28fa1f36649938a$export$9d0e69e8740e5c1c.CardContent = module.CardWithDataContent;
            target.forceUpdate();
        });
    }
    componentDidMount() {
        if ($d28fa1f36649938a$export$9d0e69e8740e5c1c.CardContent === null) (this.props.importer || $d28fa1f36649938a$export$9d0e69e8740e5c1c.moduleImporter)(this);
    }
    render() {
        const { id: id, appearance: appearance, data: data, isSelected: isSelected, onClick: onClick, onResolve: onResolve, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle } = this.props;
        if (!data) throw new Error('@atlaskit/smart-cards: you are trying to render a card with data, but does not provide any');
        if ($d28fa1f36649938a$export$9d0e69e8740e5c1c.CardContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d28fa1f36649938a$export$9d0e69e8740e5c1c.CardContent, {
            id: id,
            inlinePreloaderStyle: inlinePreloaderStyle,
            appearance: appearance,
            data: data,
            isSelected: isSelected,
            onClick: onClick,
            onResolve: onResolve,
            testId: testId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-card-with-data": true
        });
    }
}

});
parcelRegister("jPswi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("g7aEm")
]).then(()=>parcelRequire('fqHYs'));

});


parcelRegister("6VBvh", function(module, exports) {

$parcel$export(module.exports, "CardWithURLRenderer", () => $aec66ec7aed7ad8a$export$e00a7788e30dc998);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $hEsGF = parcelRequire("hEsGF");

var $jb3WS = parcelRequire("jb3WS");

var $jtkmg = parcelRequire("jtkmg");

var $fsWgj = parcelRequire("fsWgj");

var $9A6mL = parcelRequire("9A6mL");

var $6oJXW = parcelRequire("6oJXW");

var $asu8X = parcelRequire("asu8X");

const $aec66ec7aed7ad8a$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(0, $9A6mL.importWithRetry)(()=>(parcelRequire("5SeSf"))));
function $aec66ec7aed7ad8a$export$e00a7788e30dc998(props) {
    (0, $asu8X.di)($aec66ec7aed7ad8a$export$a7690c318cd6a95e);
    const [id] = (0, $eUqFw.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))());
    (0, $eUqFw.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $hEsGF.clearMarks)(id);
            (0, $hEsGF.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, isFrameVisible: isFrameVisible, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, showActions: showActions, showServerActions: showServerActions, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, showAuthTooltip: showAuthTooltip, analyticsEvents: analyticsEvents, placeholder: placeholder, fallbackComponent: fallbackComponent, useLegacyBlockCard: useLegacyBlockCard, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder } = props;
    const analytics = (0, $jtkmg.useSmartLinkAnalytics)(url ?? '', undefined, id);
    const isFlexibleUi = (0, $6oJXW.isFlexibleUiCard)(children);
    const errorHandler = (0, $eUqFw.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') analytics.operational.chunkloadFailedEvent({
            display: appearance,
            error: error,
            errorInfo: errorInfo
        });
        else if (error.name !== 'APIError') analytics.ui.renderFailedEvent({
            display: isFlexibleUi ? 'flexible' : appearance,
            id: id,
            error: error,
            errorInfo: errorInfo
        });
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analytics.operational,
        analytics.ui,
        appearance,
        id,
        onError,
        url,
        isFlexibleUi
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FallbackComponent, null);
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        isFrameVisible: isFrameVisible,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        showActions: showActions,
        showServerActions: showServerActions,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        showAuthTooltip: showAuthTooltip,
        analyticsEvents: analyticsEvents,
        placeholder: placeholder,
        useLegacyBlockCard: useLegacyBlockCard,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fsWgj.LoadingCardLink), cardWithUrlProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aec66ec7aed7ad8a$export$a7690c318cd6a95e, cardWithUrlProps, children)));
}

});
parcelRegister("hEsGF", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $c9b3a002aa9f3cfd$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $c9b3a002aa9f3cfd$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $c9b3a002aa9f3cfd$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $c9b3a002aa9f3cfd$export$185802fd694ee1f5);
const $c9b3a002aa9f3cfd$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable = $c9b3a002aa9f3cfd$var$isPerformanceAPIAvailable();
const $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $c9b3a002aa9f3cfd$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $c9b3a002aa9f3cfd$export$1a717feb4df1a945 = (id)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $c9b3a002aa9f3cfd$export$de42547d395c8271 = (id)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $c9b3a002aa9f3cfd$var$getMark = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $c9b3a002aa9f3cfd$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $c9b3a002aa9f3cfd$export$185802fd694ee1f5 = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$984df7f61dd7928f(id, status);
        const measure = $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $c9b3a002aa9f3cfd$var$getMark(id, 'pending');
            const endMark = $c9b3a002aa9f3cfd$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});

parcelRegister("jb3WS", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("eUqFw")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("jtkmg", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalytics", () => $4156fbcb4ce186b5$export$57c7fece972c9472);

var $eUqFw = parcelRequire("eUqFw");

var $cGAGh = parcelRequire("cGAGh");

var $bTNMs = parcelRequire("bTNMs");
var $x8tkc = parcelRequire("x8tkc");

var $2cI4y = parcelRequire("2cI4y");

var $269iK = parcelRequire("269iK");

var $gqldc = parcelRequire("gqldc");

var $bTNMs = parcelRequire("bTNMs");

var $h71BW = parcelRequire("h71BW");
const $4156fbcb4ce186b5$var$applyCommonAttributes = (event, commonAttributes)=>{
    if (event && event.attributes) {
        for (const [key, value] of Object.entries(commonAttributes))if (event.attributes[key] === undefined) event.attributes[key] = value;
    }
    return event;
};
const $4156fbcb4ce186b5$export$57c7fece972c9472 = (url, /**
	 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2681 Internal documentation for deprecation (no external access)}
	 * Overriding the analytics dispatch method is deprecated. Please omit this argument.
	 */ _dispatchAnalytics, /**
	 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2681 Internal documentation for deprecation (no external access)}
	 * Provide this via the id prop on the `<Card />` component.
	 */ id, /**
	 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2681 Internal documentation for deprecation (no external access)}
	 * Provide this attribute via analytics context.
	 */ defaultLocation)=>{
    const { dispatchAnalytics: dispatchAnalytics } = (0, $h71BW.useDispatchAnalytics)(_dispatchAnalytics);
    const defaultId = id || 'NULL';
    // We don't want to trigger a re-render by using useSmartCardState
    const { store: store } = (0, $gqldc.useSmartLinkContext)();
    const state = store ? (0, $cGAGh.getUrl)(store, url) : undefined;
    const details = state ? state.details : undefined;
    const extractedDefinitionId = (0, $269iK.getDefinitionId)(details);
    const extractedExtensionKey = (0, $269iK.getExtensionKey)(details);
    const extractedResourceType = (0, $269iK.getResourceType)(details);
    const extractedSubproduct = (0, $269iK.getSubproduct)(details);
    const extractedProduct = (0, $269iK.getProduct)(details);
    const extractedStatusDetails = (0, $269iK.getStatusDetails)(details);
    const commonAttributes = (0, $eUqFw.useMemo)(()=>({
            id: defaultId,
            definitionId: extractedDefinitionId,
            extensionKey: extractedExtensionKey,
            resourceType: extractedResourceType,
            destinationObjectType: extractedResourceType,
            destinationSubproduct: extractedSubproduct,
            destinationProduct: extractedProduct,
            location: defaultLocation,
            statusDetails: extractedStatusDetails
        }), [
        defaultId,
        extractedDefinitionId,
        extractedExtensionKey,
        extractedResourceType,
        extractedSubproduct,
        extractedProduct,
        defaultLocation,
        extractedStatusDetails
    ]);
    /** Contains all ui analytics events */ const ui = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event that represents when a user clicks on the authentication
			 * call to action with no current authenticated account. (i.e. Connect to Preview).
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ authEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiAuthEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks on the authentication
			 * call to action with a forbidden authenticated account. (i.e. Try another account).
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ authAlternateAccountEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiAuthAlternateAccountEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user
			 * click a button.
			 * @param data A partial analytics event payload
			 */ buttonClickedEvent: (data)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: data.actionSubjectId,
                    attributes: {
                        ...(0, $bTNMs.context),
                        ...data.attributes
                    },
                    eventType: 'ui'
                }, commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks on a Smart Link.
			 * @param id The unique ID for this Smart Link.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param isModifierKeyPressed Whether a modifier key was pressed when clicking the Smart Link.
			 * @param location Where the Smart Link is currently rendered.
			 * @param destinationProduct The product the Smart Link is linked to.
			 * @returns
			 */ cardClickedEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiCardClickedEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    isModifierKeyPressed: isModifierKeyPressed,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    actionSubjectId: actionSubjectId
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user dwells their cursor on a Smart Link's iframe.
			 * @param id The unique ID for this Smart Link.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param location Where the Smart Link is currently rendered.
			 * @param destinationProduct The product the Smart Link is linked to.
			 * @param dwellTime Total seconds that the user has dwelled on this iframe
			 * @param dwellPercentVisible Percentage element was visible at end of dwell
			 * @returns
			 */ iframeDwelledEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiIframeDwelledEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    dwellTime: dwellTime,
                    dwellPercentVisible: dwellPercentVisible
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks or tabs into a Smart Link's iframe.
			 * @param id The unique ID for this Smart Link.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param location Where the Smart Link is currently rendered.
			 * @param destinationProduct The product the Smart Link is linked to.
			 * @returns
			 */ iframeFocusedEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiIframeFocusedEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks on a Smart Link action.
			 * Note: This also starts the UFO smart-link-action-invocation experience.
			 * @param id The unique ID for this Smart Link.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param actionType The type of the action that was clicked, e.g. PreviewAction
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param invokeType @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2681 Internal documentation for deprecation (no external access)}
			 * @returns
			 */ actionClickedEvent: ({ id: id, actionType: actionType, display: display, extensionKey: overrideExtensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const extensionKey = overrideExtensionKey ?? extractedExtensionKey;
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiActionClickedEvent)({
                    id: id ?? defaultId,
                    actionType: actionType,
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents when a user clicks on a hover preview's "navigate to link" button.
			 * https://product-fabric.atlassian.net/wiki/spaces/EM/pages/3206743323/Analytics+Metrics+-+Hover+Previews
			 * @param previewDisplay What format the preview is in.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param previewInvokeMethod How the preview was triggered.
			 */ hoverCardOpenLinkClickedEvent: ({ previewDisplay: previewDisplay, definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiHoverCardOpenLinkClickedEvent)({
                    id: defaultId,
                    previewDisplay: previewDisplay,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents when a user closed the authentication window without authenticating after opening it.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ closedAuthEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiClosedAuthEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user close a modal.
			 * @param data A partial analytics event payload
			 */ modalClosedEvent: (data)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes({
                    action: 'closed',
                    actionSubject: 'modal',
                    actionSubjectId: data.actionSubjectId,
                    attributes: {
                        ...(0, $bTNMs.context),
                        ...data.attributes
                    },
                    eventType: 'ui'
                }, commonAttributes)),
            /**
			 * This fires an event that represents when a Smart Link was rendered successfully.
			 * Note: this fires even if the Smart Link request errored out.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param id The unique ID for this Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param canBeDatasource An indicator that shows that a smart link can be converted to a datasource
			 */ renderSuccessEvent: ({ display: display, status: status, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource = false })=>{
                const experienceId = id ? id : defaultId;
                (0, $2cI4y.succeedUfoExperience)('smart-link-rendered', experienceId, {
                    extensionKey: extensionKey,
                    display: display
                });
                // UFO will disregard this if authentication experience has not yet been started
                (0, $2cI4y.succeedUfoExperience)('smart-link-authenticated', experienceId, {
                    display: display
                });
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiRenderSuccessEvent)({
                    display: display,
                    status: status,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    canBeDatasource: canBeDatasource
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents when a Smart Link renders unsuccessfuly.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param id The unique ID for this Smart Link.
			 * @param error: An error representing why the Smart Link render failed.
			 * @param errorInfo: Additional details about the error including the stack trace.
			 */ renderFailedEvent: ({ display: display, id: id, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                // Start and fail the smart-link-rendered experience. If it has already
                // been started nothing happens.
                (0, $2cI4y.startUfoExperience)('smart-link-rendered', experienceId);
                (0, $2cI4y.failUfoExperience)('smart-link-rendered', experienceId);
                (0, $2cI4y.failUfoExperience)('smart-link-authenticated', experienceId);
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiRenderFailedEvent)({
                    display: display,
                    error: error,
                    errorInfo: errorInfo,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents a hover preview being opened.
			 * @param hoverDisplay Whether the hover preview was displayed as a card or embed.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param previewInvokeMethod How the preview was triggered.
			 * @returns
			 */ hoverCardViewedEvent: ({ previewDisplay: previewDisplay, previewInvokeMethod: previewInvokeMethod, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiHoverCardViewedEvent)({
                    id: id,
                    previewDisplay: previewDisplay,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod,
                    status: status
                }), commonAttributes)),
            /**
			 * This fires an event that represents a hover preview being dismissed.
			 * @param hoverDisplay Whether the hover preview was displayed as a card or embed.
			 * @param hoverTime The duration that the user hovered over a Smart Link before the preview was dismissed.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resolver invoked.
			 * @param previewInvokeMethod How the preview was triggered.
			 * @returns
			 */ hoverCardDismissedEvent: ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, previewInvokeMethod: previewInvokeMethod, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiHoverCardDismissedEvent)({
                    previewDisplay: previewDisplay,
                    id: id,
                    hoverTime: hoverTime,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod,
                    status: status
                }), commonAttributes)),
            /**
			 * Fires an event that signifies that a "Learn More" link was clicked on an unauthenticated card
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param location The location where a link is displayed (jiraWebLinks, confluencePages etc)
			 */ learnMoreClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiLearnMoreLinkClickedEvent)(), commonAttributes)),
            /**
			 * Fires an event that represent a click was performed on a Status Lozenge
			 */ smartLinkLozengeActionClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiSmartLinkStatusLozengeButtonClicked)(), commonAttributes)),
            /**
			 * Fires an event that represent a click was performed on a Status Lozenge's dropdown item
			 */ smartLinkLozengeActionListItemClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiSmartLinkStatusListItemButtonClicked)(), commonAttributes)),
            /**
			 * Fires an event that represent a click was performed on a Status Lozenge open preview button
			 */ smartLinkLozengeActionErrorOpenPreviewClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiSmartLinkStatusOpenPreviewButtonClicked)(), commonAttributes)),
            smartLinkServerActionClickedEvent: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiServerActionClicked)(props), commonAttributes))
        }), [
        dispatchAnalytics,
        commonAttributes,
        defaultId,
        extractedExtensionKey
    ]);
    /** Contains all operational analytics events */ const operational = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event that represents an action being successfully invoked.
			 * @param id The unique ID for this Smart Link.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param actionType The type of action invoked, e.g. PreviewAction
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 */ invokeSucceededEvent: ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.invokeSucceededEvent)({
                    id: id ?? defaultId,
                    actionType: actionType,
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents an action being unsuccessfully invoked.
			 * @param id The unique ID for this Smart Link.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param actionType The type of action invoked, e.g. PreviewAction
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param reason The reason the invocation failed.
			 */ invokeFailedEvent: ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.invokeFailedEvent)({
                    id: id ?? defaultId,
                    actionType: actionType,
                    display: display,
                    reason: reason,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents an account successfully being connected via a Smart Link.
			 * @param id The unique ID for this Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 */ connectSucceededEvent: ({ id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                (0, $2cI4y.startUfoExperience)('smart-link-authenticated', experienceId, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.connectSucceededEvent)({
                    ...commonAttributes,
                    id: experienceId,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents an account unsuccessfully being connected.
			 * @param id The unique ID for this Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param reason The reason why the Smart Link connect account failed.
			 */ connectFailedEvent: ({ id: id, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                (0, $2cI4y.startUfoExperience)('smart-link-authenticated', experienceId, {
                    extensionKey: extensionKey,
                    status: reason
                });
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.connectFailedEvent)({
                    ...commonAttributes,
                    id: experienceId,
                    reason: reason,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event which represents a Smart Link request succeeding or failing based on the status.
			 * @param id The unique ID for this Smart Link.
			 * @param status The status of the Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param resourceType The type of resource that was invoked. This is provider specific (e.g. File, PullRequest).
			 * @param error An error representing why the Smart Link request failed.
			 */ instrument: ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
                const event = (0, $x8tkc.instrumentEvent)({
                    ...commonAttributes,
                    id: id,
                    status: status,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    error: error
                });
                if (event) dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes(event, commonAttributes));
            },
            /**
			 * This fires an event that represents when a Smart Link renders unsuccessfuly.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param id The unique ID for this Smart Link.
			 * @param error: An error representing why the Smart Link render failed.
			 * @param errorInfo: Additional details about the error including the stack trace.
			 */ chunkloadFailedEvent: ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.chunkloadFailedEvent)({
                    display: display,
                    error: error,
                    errorInfo: errorInfo,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            }
        }), [
        defaultId,
        commonAttributes,
        dispatchAnalytics
    ]);
    /** Contains all track analytics events */ const track = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event which represents a user connecting their account to view a Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ appAccountConnected: ({ extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackAppAccountConnected)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event which represents a user starting the Smart Link connect account process.
			 * @param location a location where the Smart Link auth action was initiated.
			 * @param extensionKey The extensionKey of the Smart Link resolver invoked.
			 * @returns
			 */ appAccountAuthStarted: ({ extensionKey: extensionKey, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackAppAccountAuthStarted)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    location: location
                }), commonAttributes)),
            /**
			 * Removed in EDM-5153: This is an even from an experiment.
			 * @deprecated
			 */ linkUpdated: ()=>{},
            /**
			 * This fires a tracking event before an action invoke api call is made
			 */ smartLinkQuickActionStarted: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackSmartLinkQuickActionStarted)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
			 * This fires a tracking event after an action invoke api call is successful
			 */ smartLinkQuickActionSuccess: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackSmartLinkQuickActionSuccess)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
			 * This fires a tracking event after an action invoke api call has failed
			 */ smartLinkQuickActionFailed: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackSmartLinkQuickActionFailed)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
			 * Fires a track event when we call loadMetadata() to get information for a hover card
			 */ hoverCardResolutionStarted: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackHoverCardResolutionStarted)({
                    display: 'hoverCardPreview',
                    ...commonAttributes
                }), commonAttributes))
        }), [
        commonAttributes,
        dispatchAnalytics
    ]);
    /** Contains all screen analytics events */ const screen = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event which represents the connect account page being opened.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ authPopupEvent: ({ extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.screenAuthPopupEvent)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user view a modal.
			 * @param data A partial analytics event payload
			 */ modalViewedEvent: (data)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes({
                    action: 'viewed',
                    actionSubject: data.name,
                    attributes: {
                        ...(0, $bTNMs.context),
                        ...data.attributes
                    },
                    eventType: 'screen',
                    name: data.name
                }, commonAttributes))
        }), [
        commonAttributes,
        dispatchAnalytics
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            ui: ui,
            operational: operational,
            track: track,
            screen: screen
        }), [
        ui,
        operational,
        track,
        screen
    ]);
};

});
parcelRegister("cGAGh", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $6b31d06902eb0186$export$94df0e59ebebf4a7);
const $6b31d06902eb0186$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("bTNMs", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $0a26d6e0cc0b2d68$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $0a26d6e0cc0b2d68$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $0a26d6e0cc0b2d68$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $0a26d6e0cc0b2d68$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $0a26d6e0cc0b2d68$export$b91e0203b928470c);
$parcel$export(module.exports, "resolvedEvent", () => $0a26d6e0cc0b2d68$export$e2e1bab8375c3115);
$parcel$export(module.exports, "unresolvedEvent", () => $0a26d6e0cc0b2d68$export$331b399cdebbb8d4);
$parcel$export(module.exports, "invokeSucceededEvent", () => $0a26d6e0cc0b2d68$export$237caeb1002642ba);
$parcel$export(module.exports, "invokeFailedEvent", () => $0a26d6e0cc0b2d68$export$ac488bf3e4c7f93);
$parcel$export(module.exports, "connectSucceededEvent", () => $0a26d6e0cc0b2d68$export$5f549b8ba38f19b1);
$parcel$export(module.exports, "connectFailedEvent", () => $0a26d6e0cc0b2d68$export$fdfcba182edbb89a);
$parcel$export(module.exports, "trackAppAccountConnected", () => $0a26d6e0cc0b2d68$export$27d8deca51e9575c);
$parcel$export(module.exports, "trackAppAccountAuthStarted", () => $0a26d6e0cc0b2d68$export$48e92e116e00d94c);
$parcel$export(module.exports, "trackSmartLinkQuickActionStarted", () => $0a26d6e0cc0b2d68$export$1c2a74fe02a8031b);
$parcel$export(module.exports, "trackSmartLinkQuickActionSuccess", () => $0a26d6e0cc0b2d68$export$afbd6446c1c03a3e);
$parcel$export(module.exports, "trackSmartLinkQuickActionFailed", () => $0a26d6e0cc0b2d68$export$2706827739a8c50);
$parcel$export(module.exports, "trackHoverCardResolutionStarted", () => $0a26d6e0cc0b2d68$export$daa964b113be9527);
$parcel$export(module.exports, "uiAuthEvent", () => $0a26d6e0cc0b2d68$export$5318734335f1d8b8);
$parcel$export(module.exports, "uiAuthAlternateAccountEvent", () => $0a26d6e0cc0b2d68$export$14f2ce8523ccb652);
$parcel$export(module.exports, "uiCardClickedEvent", () => $0a26d6e0cc0b2d68$export$8b5d1f55370347a1);
$parcel$export(module.exports, "uiIframeDwelledEvent", () => $0a26d6e0cc0b2d68$export$6b045396616c2e9f);
$parcel$export(module.exports, "uiIframeFocusedEvent", () => $0a26d6e0cc0b2d68$export$93fa3246cf9e3b52);
$parcel$export(module.exports, "uiActionClickedEvent", () => $0a26d6e0cc0b2d68$export$e00b9d79d3367530);
$parcel$export(module.exports, "uiClosedAuthEvent", () => $0a26d6e0cc0b2d68$export$fe5b1f066ca3365d);
$parcel$export(module.exports, "screenAuthPopupEvent", () => $0a26d6e0cc0b2d68$export$69bb595db263d8ef);
$parcel$export(module.exports, "uiRenderSuccessEvent", () => $0a26d6e0cc0b2d68$export$bd308326cf1076aa);
$parcel$export(module.exports, "uiRenderFailedEvent", () => $0a26d6e0cc0b2d68$export$1543b6391f48a5e2);
$parcel$export(module.exports, "uiHoverCardViewedEvent", () => $0a26d6e0cc0b2d68$export$e80a2f97cccab3b1);
$parcel$export(module.exports, "uiHoverCardDismissedEvent", () => $0a26d6e0cc0b2d68$export$3d10c6f90bc461d3);
$parcel$export(module.exports, "uiHoverCardOpenLinkClickedEvent", () => $0a26d6e0cc0b2d68$export$ad3275d7dff50d21);
$parcel$export(module.exports, "uiLearnMoreLinkClickedEvent", () => $0a26d6e0cc0b2d68$export$925348ae8d2e0bf3);
$parcel$export(module.exports, "chunkloadFailedEvent", () => $0a26d6e0cc0b2d68$export$2b6bbed3753f06f9);
$parcel$export(module.exports, "uiSmartLinkStatusLozengeButtonClicked", () => $0a26d6e0cc0b2d68$export$94c3643533642ab);
$parcel$export(module.exports, "uiSmartLinkStatusListItemButtonClicked", () => $0a26d6e0cc0b2d68$export$18dfe458db0b743d);
$parcel$export(module.exports, "uiSmartLinkStatusOpenPreviewButtonClicked", () => $0a26d6e0cc0b2d68$export$9a352e2e15b3de89);
$parcel$export(module.exports, "uiServerActionClicked", () => $0a26d6e0cc0b2d68$export$a66dc699502b5d28);

var $hEsGF = parcelRequire("hEsGF");

var $cCvxR = parcelRequire("cCvxR");
const $0a26d6e0cc0b2d68$export$85183a312807388d = 'media';
const $0a26d6e0cc0b2d68$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $0a26d6e0cc0b2d68$export$72af824fa910c33e;
(function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
})($0a26d6e0cc0b2d68$export$72af824fa910c33e || ($0a26d6e0cc0b2d68$export$72af824fa910c33e = {}));
var $0a26d6e0cc0b2d68$export$c89e475f7f7174c2;
(function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
})($0a26d6e0cc0b2d68$export$c89e475f7f7174c2 || ($0a26d6e0cc0b2d68$export$c89e475f7f7174c2 = {}));
const $0a26d6e0cc0b2d68$export$bbd674aacb40a160 = {
    [(0, $cCvxR.SmartLinkActionType).FollowEntityAction]: 'Follow',
    [(0, $cCvxR.SmartLinkActionType).StatusUpdateAction]: 'StatusUpdate',
    [(0, $cCvxR.SmartLinkActionType).UnfollowEntityAction]: 'Unfollow'
};
const $0a26d6e0cc0b2d68$export$baf70a532f8c6fa6 = {
    [(0, $cCvxR.SmartLinkActionType).FollowEntityAction]: 'smartLinkFollowButton',
    [(0, $cCvxR.SmartLinkActionType).UnfollowEntityAction]: 'smartLinkFollowButton'
};
const $0a26d6e0cc0b2d68$var$uiActionSubjectIds = {
    DownloadAction: 'downloadDocument',
    PreviewAction: 'invokePreviewScreen',
    ViewAction: 'shortcutGoToLink',
    StatusAction: 'issueStatusUpdate'
};
class $0a26d6e0cc0b2d68$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $0a26d6e0cc0b2d68$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $0a26d6e0cc0b2d68$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($0a26d6e0cc0b2d68$export$85183a312807388d);
};
const $0a26d6e0cc0b2d68$export$e2e1bab8375c3115 = (props)=>({
        action: 'resolved',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...props,
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$331b399cdebbb8d4 = ({ id: id, definitionId: definitionId, extensionKey: extensionKey, resourceType: resourceType, destinationSubproduct: destinationSubproduct, destinationProduct: destinationProduct, error: error, status: status, location: location })=>({
        action: 'unresolved',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            id: id,
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...definitionId ? {
                definitionId: definitionId
            } : {},
            ...extensionKey ? {
                extensionKey: extensionKey
            } : {},
            ...resourceType ? {
                resourceType: resourceType
            } : {},
            ...destinationSubproduct ? {
                destinationSubproduct: destinationSubproduct
            } : {},
            ...destinationProduct ? {
                destinationProduct: destinationProduct
            } : {},
            ...location ? {
                location: location
            } : {},
            reason: status,
            error: error ? {
                message: error?.message,
                kind: error?.kind,
                type: error?.type
            } : undefined
        }
    });
const $0a26d6e0cc0b2d68$export$237caeb1002642ba = ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
    const measure = id ? (0, $hEsGF.getMeasure)(id, 'resolved') : undefined;
    return {
        action: 'resolved',
        actionSubject: 'smartLinkAction',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            actionType: actionType,
            display: display,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            extensionKey: extensionKey,
            duration: measure?.duration
        }
    };
};
const $0a26d6e0cc0b2d68$export$ac488bf3e4c7f93 = ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
    const measure = id ? (0, $hEsGF.getMeasure)(id, 'errored') : undefined;
    return {
        action: 'unresolved',
        actionSubject: 'smartLinkAction',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            actionType: actionType,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            duration: measure?.duration,
            reason: reason
        }
    };
};
const $0a26d6e0cc0b2d68$export$5f549b8ba38f19b1 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'connectSucceeded',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$fdfcba182edbb89a = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, reason: reason })=>({
        action: 'connectFailed',
        actionSubject: 'smartLink',
        actionSubjectId: reason,
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            reason: reason,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$27d8deca51e9575c = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'connected',
        actionSubject: 'applicationAccount',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$48e92e116e00d94c = ({ extensionKey: extensionKey, location: location })=>({
        action: 'authStarted',
        actionSubject: 'applicationAccount',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$1c2a74fe02a8031b = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'started',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$afbd6446c1c03a3e = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'success',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$2706827739a8c50 = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'failed',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$daa964b113be9527 = ({ display: display, ...attributes })=>({
        action: 'resolved',
        actionSubject: 'hoverCard',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$5318734335f1d8b8 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'connectAccount',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$14f2ce8523ccb652 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
        action: 'clicked',
        actionSubject: 'smartLink',
        actionSubjectId: 'tryAnotherAccount',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$8b5d1f55370347a1 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>({
        action: 'clicked',
        actionSubject: 'smartLink',
        actionSubjectId: actionSubjectId,
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            isModifierKeyPressed: isModifierKeyPressed,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct
        }
    });
const $0a26d6e0cc0b2d68$export$6b045396616c2e9f = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>({
        action: 'dwelled',
        actionSubject: 'smartLinkIframe',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            dwellTime: dwellTime,
            dwellPercentVisible: dwellPercentVisible
        }
    });
const $0a26d6e0cc0b2d68$export$93fa3246cf9e3b52 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>({
        action: 'focused',
        actionSubject: 'smartLinkIframe',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct
        }
    });
const $0a26d6e0cc0b2d68$export$e00b9d79d3367530 = ({ id: id, actionType: actionType, extensionKey: extensionKey, display: display, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: $0a26d6e0cc0b2d68$var$uiActionSubjectIds[actionType],
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            display: display,
            actionType: actionType,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$fe5b1f066ca3365d = ({ display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'closed',
        actionSubject: 'consentModal',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$69bb595db263d8ef = ({ extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        actionSubject: 'consentModal',
        eventType: 'screen',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$bd308326cf1076aa = ({ display: display, status: status, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource })=>({
        action: 'renderSuccess',
        actionSubject: 'smartLink',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            status: status,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display,
            canBeDatasource: canBeDatasource
        }
    });
const $0a26d6e0cc0b2d68$export$1543b6391f48a5e2 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        actionSubject: 'smartLink',
        action: 'renderFailed',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            error: error,
            errorInfo: errorInfo,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$e80a2f97cccab3b1 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
        action: 'viewed',
        actionSubject: 'hoverCard',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod,
            status: status
        }
    });
const $0a26d6e0cc0b2d68$export$3d10c6f90bc461d3 = ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
        action: 'dismissed',
        actionSubject: 'hoverCard',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            hoverTime: hoverTime,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod,
            status: status
        }
    });
const $0a26d6e0cc0b2d68$export$ad3275d7dff50d21 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'shortcutGoToLink',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod
        }
    });
const $0a26d6e0cc0b2d68$export$925348ae8d2e0bf3 = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'learnMore',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$2b6bbed3753f06f9 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'chunkLoadFailed',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            error: error,
            errorInfo: errorInfo,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$94c3643533642ab = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusLozenge',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$18dfe458db0b743d = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusListItem',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$9a352e2e15b3de89 = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusOpenPreview',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$a66dc699502b5d28 = ({ smartLinkActionType: smartLinkActionType })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: $0a26d6e0cc0b2d68$export$baf70a532f8c6fa6[smartLinkActionType] ?? smartLinkActionType,
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });

});
parcelRegister("cCvxR", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $8c69a400a46c2e51$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $8c69a400a46c2e51$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $8c69a400a46c2e51$export$6324b7946ad663e9;
(function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
})($8c69a400a46c2e51$export$6324b7946ad663e9 || ($8c69a400a46c2e51$export$6324b7946ad663e9 = {}));
class $8c69a400a46c2e51$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});


parcelRegister("x8tkc", function(module, exports) {

$parcel$export(module.exports, "instrumentEvent", () => $823c14fa33decb2a$export$860cf9c079ed505);

var $hEsGF = parcelRequire("hEsGF");

var $bTNMs = parcelRequire("bTNMs");
const $823c14fa33decb2a$export$860cf9c079ed505 = ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
    const measure = (0, $hEsGF.getMeasure)(id, status) || {
        duration: undefined
    };
    if (status === 'resolved') {
        const event = (0, $bTNMs.resolvedEvent)({
            id: id,
            extensionKey: extensionKey,
            definitionId: definitionId,
            resourceType: resourceType,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        });
        return {
            ...event,
            attributes: {
                ...event.attributes,
                duration: measure.duration
            }
        };
    } else if (error?.type !== 'ResolveUnsupportedError') {
        const event = (0, $bTNMs.unresolvedEvent)({
            id: id,
            status: status,
            extensionKey: extensionKey,
            definitionId: definitionId,
            resourceType: resourceType,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            error: error
        });
        return {
            ...event,
            attributes: {
                ...event.attributes,
                duration: measure.duration
            }
        };
    }
};

});

parcelRegister("2cI4y", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $6dc76d5a97c623dd$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $6dc76d5a97c623dd$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $6dc76d5a97c623dd$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $6dc76d5a97c623dd$export$4084c0df4a03a6af);

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
const $6dc76d5a97c623dd$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Experience,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
};
const $6dc76d5a97c623dd$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Load,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
};
const $6dc76d5a97c623dd$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Experience,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
};
const $6dc76d5a97c623dd$var$ufoExperiences = {
    'smart-link-rendered': new (0, $2kFUE.ConcurrentExperience)('smart-link-rendered', $6dc76d5a97c623dd$var$renderExperience),
    'smart-link-authenticated': new (0, $2kFUE.ConcurrentExperience)('smart-link-authenticated', $6dc76d5a97c623dd$var$inlineExperience),
    'smart-link-action-invocation': new (0, $2kFUE.ConcurrentExperience)('smart-link-action-invocation', $6dc76d5a97c623dd$var$inlineExperience),
    'smart-link-ai-summary': new (0, $2kFUE.ConcurrentExperience)('smart-link-ai-summary', $6dc76d5a97c623dd$var$aiExperience)
};
const $6dc76d5a97c623dd$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $6dc76d5a97c623dd$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $6dc76d5a97c623dd$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $6dc76d5a97c623dd$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});
parcelRegister("2kFUE", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $a30e24b2c52cc36f$export$ac1cddfee07ba6ac);

var $f0LiU = parcelRequire("f0LiU");

var $7dDfK = parcelRequire("7dDfK");
class $a30e24b2c52cc36f$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $7dDfK.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $f0LiU.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("f0LiU", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $c2704d0c50f619e5$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c2704d0c50f619e5$export$d53d07b6034c4560);
class $c2704d0c50f619e5$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $c2704d0c50f619e5$export$4ab84f6f04f6566d = new $c2704d0c50f619e5$var$UFOLogger();
const $c2704d0c50f619e5$export$b4958caff08a0960 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.log(...args);
};
const $c2704d0c50f619e5$export$d53d07b6034c4560 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("7dDfK", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $0bfda9d094674d59$export$c00d22927c60484a);

var $4XjsX = parcelRequire("4XjsX");
class $0bfda9d094674d59$export$c00d22927c60484a extends (0, $4XjsX.UFOAbstractExperience) {
}

});
parcelRegister("4XjsX", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $b82268227d2a5ae4$export$d31c89db257648c);

var $hompL = parcelRequire("hompL");


var $6fEIi = parcelRequire("6fEIi");

var $f0LiU = parcelRequire("f0LiU");

var $1A03k = parcelRequire("1A03k");

var $5bc3G = parcelRequire("5bc3G");

var $a72vD = parcelRequire("a72vD");

var $9IyR3 = parcelRequire("9IyR3");

var $uMitL = parcelRequire("uMitL");

var $3vocg = parcelRequire("3vocg");

var $3yYXq = parcelRequire("3yYXq");
const $b82268227d2a5ae4$var$getPageVisibleState = ()=>{
    return !(0, $9IyR3.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $5bc3G.PageVisibleState).VISIBLE : (0, $5bc3G.PageVisibleState).HIDDEN;
};
const $b82268227d2a5ae4$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $a72vD.roundPerfNow)();
};
class $b82268227d2a5ae4$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $uMitL.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $5bc3G.PageVisibleState).MIXED;
            (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $f0LiU.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $3vocg.canTransition)(this.state, newState)) {
            (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $uMitL.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $hompL.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.unsubscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $f0LiU.ufolog)('this.parent', this.parent);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $f0LiU.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $uMitL.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
            (0, $1A03k.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $f0LiU.ufolog)('subscribed', this.id);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.subscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $5bc3G.FMP_MARK) && name !== (0, $5bc3G.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $f0LiU.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $uMitL.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $5bc3G.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $5bc3G.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $f0LiU.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $f0LiU.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $392a4a01cdcd9472$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $392a4a01cdcd9472$export$2295b861f318254a = '0.1.5';

parcelRegister("6fEIi", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $7118726fd593c611$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $7118726fd593c611$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $7118726fd593c611$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $7118726fd593c611$export$7c957416596ca127);

var $f0LiU = parcelRequire("f0LiU");

var $5bc3G = parcelRequire("5bc3G");
const $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $7118726fd593c611$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $7118726fd593c611$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $f0LiU.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $7118726fd593c611$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("5bc3G", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $6db1c4aca6f838ac$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $6db1c4aca6f838ac$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $6db1c4aca6f838ac$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $6db1c4aca6f838ac$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $6db1c4aca6f838ac$export$837e0f79a8056912);
var $6db1c4aca6f838ac$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($6db1c4aca6f838ac$export$96253c35c37cf96b || ($6db1c4aca6f838ac$export$96253c35c37cf96b = {}));
var $6db1c4aca6f838ac$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($6db1c4aca6f838ac$export$a12c67b37a306b13 || ($6db1c4aca6f838ac$export$a12c67b37a306b13 = {}));
var $6db1c4aca6f838ac$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$66b33c055cbb625e || ($6db1c4aca6f838ac$export$66b33c055cbb625e = {}));
var $6db1c4aca6f838ac$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$3ce489cbe02dc21b || ($6db1c4aca6f838ac$export$3ce489cbe02dc21b = {}));
var $6db1c4aca6f838ac$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($6db1c4aca6f838ac$export$341b330828bd3906 || ($6db1c4aca6f838ac$export$341b330828bd3906 = {}));
var $6db1c4aca6f838ac$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($6db1c4aca6f838ac$export$b9b20160f581e4f8 || ($6db1c4aca6f838ac$export$b9b20160f581e4f8 = {}));
const $6db1c4aca6f838ac$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $6db1c4aca6f838ac$export$9f2bf58999404c75 = 'fmp';
const $6db1c4aca6f838ac$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("1A03k", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $95f5135adf29b140$export$13e680397ec8f3eb);

var $9IyR3 = parcelRequire("9IyR3");
class $95f5135adf29b140$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $9IyR3.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $95f5135adf29b140$export$13e680397ec8f3eb = new $95f5135adf29b140$var$VisibilityChangeObserver();

});
parcelRegister("9IyR3", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $3677fb5e29ccb89d$export$15e172712955e18f);
const $3677fb5e29ccb89d$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("a72vD", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $abf5afa8ee98b73d$export$5f490af6b2b115cf);
const $abf5afa8ee98b73d$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("uMitL", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $dce4f34a405f688c$export$81b70111112841a0);
const $dce4f34a405f688c$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("3vocg", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $5c3cafcf3c197b83$export$178881f329fdb81f);

var $uMitL = parcelRequire("uMitL");
const $5c3cafcf3c197b83$var$UFOStateAvailableTransitions = {
    [(0, $uMitL.UFOExperienceState).NOT_STARTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).STARTED.id]: [
        (0, $uMitL.UFOExperienceState).IN_PROGRESS.id,
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).BLOCKED.id]: [
        (0, $uMitL.UFOExperienceState).RECOVERED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).RECOVERED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).FAILED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).ABORTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ]
};
const $5c3cafcf3c197b83$export$178881f329fdb81f = (state1, state2)=>{
    return $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id] && $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("3yYXq", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $156ab33d023ea8cf$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $156ab33d023ea8cf$export$cc26007c03242fff);
var $156ab33d023ea8cf$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($156ab33d023ea8cf$export$994164cf3ae1cc9a || ($156ab33d023ea8cf$export$994164cf3ae1cc9a = {}));
var $156ab33d023ea8cf$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($156ab33d023ea8cf$export$cc26007c03242fff || ($156ab33d023ea8cf$export$cc26007c03242fff = {}));

});





parcelRegister("269iK", function(module, exports) {

$parcel$export(module.exports, "getByDefinitionId", () => $7ebbf14b484e98b7$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $7ebbf14b484e98b7$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $7ebbf14b484e98b7$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $7ebbf14b484e98b7$export$218d96312e385949);
$parcel$export(module.exports, "getResourceType", () => $7ebbf14b484e98b7$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getProduct", () => $7ebbf14b484e98b7$export$e2005c9600188ac7);
$parcel$export(module.exports, "getSubproduct", () => $7ebbf14b484e98b7$export$f8fdefc70357968e);
$parcel$export(module.exports, "getServices", () => $7ebbf14b484e98b7$export$a009e3a1163d46fb);
$parcel$export(module.exports, "getStatusDetails", () => $7ebbf14b484e98b7$export$a752a116d184ffbd);
$parcel$export(module.exports, "isFinalState", () => $7ebbf14b484e98b7$export$d590d08942abc17a);
$parcel$export(module.exports, "getCanBeDatasource", () => $7ebbf14b484e98b7$export$ba6d13ab7b87c55c);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $7ebbf14b484e98b7$export$3f9446bb21b945a0);

var $5gJEv = parcelRequire("5gJEv");
const $7ebbf14b484e98b7$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $7ebbf14b484e98b7$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $5gJEv.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $7ebbf14b484e98b7$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $7ebbf14b484e98b7$export$218d96312e385949 = (details)=>details?.meta?.key;
const $7ebbf14b484e98b7$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $7ebbf14b484e98b7$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $7ebbf14b484e98b7$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $7ebbf14b484e98b7$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $7ebbf14b484e98b7$export$ac5d414b1ebfab5a = (details)=>details && $7ebbf14b484e98b7$export$cd41ae544cfc2a65(details) && $7ebbf14b484e98b7$export$795910f5f15a9633(details);
const $7ebbf14b484e98b7$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $7ebbf14b484e98b7$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $7ebbf14b484e98b7$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $7ebbf14b484e98b7$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $7ebbf14b484e98b7$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $7ebbf14b484e98b7$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $7ebbf14b484e98b7$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $7ebbf14b484e98b7$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;

});
parcelRegister("5gJEv", function(module, exports) {

$parcel$export(module.exports, "extractVisitUrl", () => $dbcf37ca341757a3$export$c81497d3681f24f4);
const $dbcf37ca341757a3$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});


parcelRegister("gqldc", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $ee9cd29169baa49b$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $ee9cd29169baa49b$export$e1d190b530cf0ee9);

var $eUqFw = parcelRequire("eUqFw");

const $ee9cd29169baa49b$export$156b523e63b4f63a = (0, $eUqFw.createContext)(undefined);
function $ee9cd29169baa49b$export$e1d190b530cf0ee9() {
    const context = (0, $eUqFw.useContext)($ee9cd29169baa49b$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
var $ee9cd29169baa49b$export$2e2bcd8739ae039 = $ee9cd29169baa49b$export$156b523e63b4f63a;

});

parcelRegister("h71BW", function(module, exports) {

$parcel$export(module.exports, "useDispatchAnalytics", () => $abd09e159ea44bb9$export$5f37699fba0ba807);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $bTNMs = parcelRequire("bTNMs");
const $abd09e159ea44bb9$export$5f37699fba0ba807 = (handler)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return {
        dispatchAnalytics: (0, $eUqFw.useMemo)(()=>{
            if (handler) return handler;
            return (payload)=>{
                createAnalyticsEvent(payload).fire((0, $bTNMs.ANALYTICS_CHANNEL));
            };
        }, [
            handler,
            createAnalyticsEvent
        ])
    };
};

});


parcelRegister("fsWgj", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $b64cd29097fd54b5$export$1ca0544321134ad6);

var $eUqFw = parcelRequire("eUqFw");

var $4lXV3 = parcelRequire("4lXV3");

const $b64cd29097fd54b5$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4lXV3.CardLinkView), {
        key: 'lazy-render-key',
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $02e88e077d3b3f54$export$4b2b7d155f69aed4),
        placeholder: placeholder
    });
};

});
parcelRegister("4lXV3", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $d5d78f84908c43a5$export$ce508304ed2dd145);

var $eUqFw = parcelRequire("eUqFw");

var $8BByu = parcelRequire("8BByu");
class $d5d78f84908c43a5$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BByu.Frame), {
            withoutBackground: true,
            ...this.props
        }, this.props.placeholder || this.props.link);
    }
}

});
parcelRegister("8BByu", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $824e9bb758b8c755$export$b89a827e9254211a);

var $eUqFw = parcelRequire("eUqFw");

var $5IgfK = parcelRequire("5IgfK");

var $8sbpW = parcelRequire("8sbpW");
const $824e9bb758b8c755$export$b89a827e9254211a = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered } = props;
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $8sbpW.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = link || onClick ? (0, $5IgfK.WrapperAnchor) : (0, $5IgfK.WrapperSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered
    }, children);
});

});
parcelRegister("5IgfK", function(module, exports) {

$parcel$export(module.exports, "WrapperAnchor", () => $59c993fb46da8057$export$6e4bde711df5c2ab);
$parcel$export(module.exports, "WrapperSpan", () => $59c993fb46da8057$export$8b5c95e985c4ec9a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $joBf7 = parcelRequire("joBf7");
const $59c993fb46da8057$var$selectedStyles = {
    cursor: 'pointer',
    boxShadow: `0 0 0 2px ${`var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`,
    outline: 'none',
    userSelect: 'none',
    '&, :hover, :focus, :active': {
        textDecoration: 'none'
    },
    '&:hover': {
        border: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`}`
    }
};
const $59c993fb46da8057$var$isInteractive = ({ isInteractive: isInteractive })=>{
    if (isInteractive) return {
        ':active': {
            backgroundColor: `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`
        },
        ':focus': $59c993fb46da8057$var$selectedStyles
    };
    return undefined;
};
const $59c993fb46da8057$var$isSelected = ({ isSelected: isSelected })=>{
    if (isSelected) return $59c993fb46da8057$var$selectedStyles;
    else return {
        userSelect: 'text'
    };
};
const $59c993fb46da8057$var$hoveredStyles = {
    borderColor: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`
};
const $59c993fb46da8057$var$activeHoveredFocusedStyles = (props)=>{
    if (props.withoutBackground) return undefined;
    return {
        textDecoration: 'none'
    };
};
const $59c993fb46da8057$var$hoveredWihBorderStyles = (props)=>({
        ...$59c993fb46da8057$var$hoveredStyles,
        ...$59c993fb46da8057$var$activeHoveredFocusedStyles(props)
    });
/*
  Inline smart cards should have the following layout:
  ------------------------------------
  | icon | title | action OR lozenge |
  ------------------------------------
  The aim is to ensure (1) all children are
  in line with each other, (2) are vertically
  centered.
*/ // NB: `padding` consistent with @mentions.
// NB: `display: inline` required for `box-decoration-break` to work.
// NB: `box-decoration-break` required for retaining properties (border-radius) on wrap.
const $59c993fb46da8057$var$baseWrapperStyles = (props)=>({
        lineHeight: '22px',
        padding: `${"var(--ds-space-025, 2px)"} 0px`,
        ...props.withoutBackground ? {
            paddingLeft: 0,
            marginLeft: "var(--ds-space-negative-025, -2px)"
        } : undefined,
        display: 'inline',
        boxDecorationBreak: 'clone',
        borderRadius: "var(--ds-border-radius-100, 4px)",
        color: `var(--ds-link, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        ...props.withoutBackground ? undefined : {
            backgroundColor: "var(--ds-surface-raised, white)"
        },
        ...$59c993fb46da8057$var$isSelected(props),
        ...props.withoutBackground ? undefined : {
            border: `1px solid ${`var(--ds-border, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`}`
        },
        '&:hover': $59c993fb46da8057$var$hoveredStyles,
        '&, :hover, :focus, :active': $59c993fb46da8057$var$activeHoveredFocusedStyles(props),
        transition: '0.1s all ease-in-out',
        MozUserSelect: 'none',
        // -moz-user-select
        ...props.isHovered ? $59c993fb46da8057$var$hoveredWihBorderStyles(props) : undefined
    });
const $59c993fb46da8057$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $joBf7.default)("a", {
    target: "e26bri1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$59c993fb46da8057$var$baseWrapperStyles(props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$59c993fb46da8057$var$isInteractive(props)
    }));
$59c993fb46da8057$export$6e4bde711df5c2ab.displayName = 'WrapperAnchor';
const $59c993fb46da8057$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e26bri0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$59c993fb46da8057$var$baseWrapperStyles(props)
    }));
$59c993fb46da8057$export$8b5c95e985c4ec9a.displayName = 'WrapperSpan';

});

parcelRegister("8sbpW", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $ae3e58c828553a00$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $ae3e58c828553a00$export$df67f318ded0283c);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $lyAeo = parcelRequire("lyAeo");
var $ae3e58c828553a00$export$81a5b494baf0f17c;
(function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
})($ae3e58c828553a00$export$81a5b494baf0f17c || ($ae3e58c828553a00$export$81a5b494baf0f17c = {}));
const $ae3e58c828553a00$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $lyAeo.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $ae3e58c828553a00$var$isNotLeftClick = (event)=>event.button !== 0;
const $ae3e58c828553a00$export$df67f318ded0283c = (onMouseDown)=>{
    return $ae3e58c828553a00$export$5993d3ca6c85f774(onMouseDown, $ae3e58c828553a00$var$isNotLeftClick);
};

});
parcelRegister("lyAeo", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $a830f7743a3fdab2$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $a830f7743a3fdab2$export$263352d59c0c5966);

var $eUqFw = parcelRequire("eUqFw");

var $4LwTb = parcelRequire("4LwTb");

var $bTNMs = parcelRequire("bTNMs");

var $8sbpW = parcelRequire("8sbpW");
const $a830f7743a3fdab2$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $a830f7743a3fdab2$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $a830f7743a3fdab2$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $a830f7743a3fdab2$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $4LwTb.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($a830f7743a3fdab2$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $a830f7743a3fdab2$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $a830f7743a3fdab2$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $a830f7743a3fdab2$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $a830f7743a3fdab2$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $a830f7743a3fdab2$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    return $a830f7743a3fdab2$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
};
const $a830f7743a3fdab2$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $a830f7743a3fdab2$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            }
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };
const $a830f7743a3fdab2$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $a830f7743a3fdab2$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $8sbpW.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $8sbpW.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$a830f7743a3fdab2$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("4LwTb", function(module, exports) {

$parcel$export(module.exports, "browser", () => $53e1c38db50269d3$export$3f2684e5d7cb1006);
const $53e1c38db50269d3$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $53e1c38db50269d3$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $53e1c38db50269d3$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $53e1c38db50269d3$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $53e1c38db50269d3$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $53e1c38db50269d3$var$result.android = /Android \d/.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $53e1c38db50269d3$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $53e1c38db50269d3$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $53e1c38db50269d3$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $53e1c38db50269d3$export$3f2684e5d7cb1006() {
    return $53e1c38db50269d3$var$result;
}

});





const $02e88e077d3b3f54$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';


parcelRegister("9A6mL", function(module, exports) {

$parcel$export(module.exports, "isCardWithData", () => $4e9a30041ebff1a9$export$f287576685db4026);
$parcel$export(module.exports, "isSpecialEvent", () => $4e9a30041ebff1a9$export$efca2c4705678489);
$parcel$export(module.exports, "getIconForFileType", () => $4e9a30041ebff1a9$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $4e9a30041ebff1a9$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $4e9a30041ebff1a9$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $4e9a30041ebff1a9$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $4e9a30041ebff1a9$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $4e9a30041ebff1a9$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $4e9a30041ebff1a9$export$a238cfe4a10e6279);
$parcel$export(module.exports, "combineFrameStyle", () => $4e9a30041ebff1a9$export$666eb6846f461ee6);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $4e9a30041ebff1a9$export$4470f298c61a79da);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $iednx = parcelRequire("iednx");
const $4e9a30041ebff1a9$export$f287576685db4026 = (props)=>!!props.data;
const $4e9a30041ebff1a9$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($4e9a30041ebff1a9$export$e6c5ffa684aac4d7() || $4e9a30041ebff1a9$export$d8de0cd37d316fdf(evt) || $4e9a30041ebff1a9$export$5b1771037ab7c451(evt));
const $4e9a30041ebff1a9$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $4e9a30041ebff1a9$export$d8de0cd37d316fdf = (event)=>event.metaKey || event.ctrlKey;
const $4e9a30041ebff1a9$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $4e9a30041ebff1a9$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $4e9a30041ebff1a9$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $4e9a30041ebff1a9$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $4e9a30041ebff1a9$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label] = icon;
    return label;
};


















































const $4e9a30041ebff1a9$var$typeToIcon = {
    'text/plain': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.oasis.opendocument.text': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.apple.pages': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.google-apps.document': [
        'Google Doc',
        ()=>(parcelRequire("2Zwb9"))
    ],
    'application/msword': [
        'Word document',
        ()=>(parcelRequire("9pS0E"))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        'Word document',
        ()=>(parcelRequire("9pS0E"))
    ],
    'application/pdf': [
        'PDF document',
        ()=>(parcelRequire("iqKJJ"))
    ],
    'application/vnd.oasis.opendocument.spreadsheet': [
        'Spreadsheet',
        ()=>(parcelRequire("7dTur"))
    ],
    'application/vnd.apple.numbers': [
        'Spreadsheet',
        ()=>(parcelRequire("7dTur"))
    ],
    'application/vnd.google-apps.spreadsheet': [
        'Google Sheet',
        ()=>(parcelRequire("kENAJ"))
    ],
    'application/vnd.ms-excel': [
        'Excel spreadsheet',
        ()=>(parcelRequire("dsRgj"))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        'Excel spreadsheet',
        ()=>(parcelRequire("dsRgj"))
    ],
    'application/vnd.oasis.opendocument.presentation': [
        'Presentation',
        ()=>(parcelRequire("43vNc"))
    ],
    'application/vnd.apple.keynote': [
        'Presentation',
        ()=>(parcelRequire("43vNc"))
    ],
    'application/vnd.google-apps.presentation': [
        'Google Slide',
        ()=>(parcelRequire("hMCpa"))
    ],
    'application/vnd.ms-powerpoint': [
        'PowerPoint presentation',
        ()=>(parcelRequire("4xnuT"))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        'PowerPoint presentation',
        ()=>(parcelRequire("4xnuT"))
    ],
    'application/vnd.google-apps.form': [
        'Google Form',
        ()=>(parcelRequire("14hrM"))
    ],
    'image/png': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/jpeg': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/bmp': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/webp': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/svg+xml': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/gif': [
        'GIF',
        ()=>(parcelRequire("a0cSu"))
    ],
    'audio/midi': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'audio/mpeg': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'audio/webm': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'audio/ogg': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'audio/wav': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'video/mp4': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/quicktime': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/mov': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/webm': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/ogg': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/x-ms-wmv': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/x-msvideo': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'application/zip': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/x-tar': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/x-gtar': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/x-7z-compressed': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/x-apple-diskimage': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/vnd.rar': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/dmg': [
        'Executable',
        ()=>(parcelRequire("az87C"))
    ],
    'text/css': [
        'Source Code',
        ()=>(parcelRequire("5XXvD"))
    ],
    'text/html': [
        'Source Code',
        ()=>(parcelRequire("5XXvD"))
    ],
    'application/javascript': [
        'Source Code',
        ()=>(parcelRequire("5XXvD"))
    ],
    'application/octet-stream': [
        'Binary file',
        ()=>(parcelRequire("gEIPy"))
    ],
    'application/invision.prototype': [
        'Prototype',
        ()=>(parcelRequire("gEIPy"))
    ],
    // TODO: Figure a way to detect those
    'application/sketch': [
        'Sketch',
        ()=>(parcelRequire("eyLKt"))
    ],
    folder: [
        'Folder',
        ()=>(parcelRequire("IR5Zr"))
    ]
};
const $4e9a30041ebff1a9$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $4e9a30041ebff1a9$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $4e9a30041ebff1a9$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $4e9a30041ebff1a9$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $4e9a30041ebff1a9$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $4e9a30041ebff1a9$export$e772c8ff12451969(interval);
            return $4e9a30041ebff1a9$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $4e9a30041ebff1a9$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $4e9a30041ebff1a9$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $4e9a30041ebff1a9$export$666eb6846f461ee6 = (frameStyle, isFrameVisible)=>{
    if (frameStyle !== undefined) return frameStyle;
    if (isFrameVisible) return 'show';
};
const $4e9a30041ebff1a9$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $iednx.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};

});
parcelRegister("33pqc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $23955f1f88135281$var$_react = $23955f1f88135281$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $23955f1f88135281$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $23955f1f88135281$var$Document16Icon = (props)=>/*#__PURE__*/ $23955f1f88135281$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2 3a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 000 2h4a1 1 0 000-2H4z"/></svg>`
    }, props, {
        size: 'small'
    }));
$23955f1f88135281$var$Document16Icon.displayName = 'Document16Icon';
var $23955f1f88135281$var$_default = $23955f1f88135281$var$Document16Icon;
module.exports.default = $23955f1f88135281$var$_default;

});

parcelRegister("2Zwb9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("f6s74").then(()=>parcelRequire('koIAu'));

});

parcelRegister("9pS0E", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gnAw0").then(()=>parcelRequire('IXu7C'));

});

parcelRegister("iqKJJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jD9x7").then(()=>parcelRequire('gZQhT'));

});

parcelRegister("7dTur", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6OMu9").then(()=>parcelRequire('kaVAc'));

});

parcelRegister("kENAJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cXU5K").then(()=>parcelRequire('8o5C6'));

});

parcelRegister("dsRgj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3jhqX").then(()=>parcelRequire('iByLo'));

});

parcelRegister("43vNc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dY9Y8").then(()=>parcelRequire('iIEQk'));

});

parcelRegister("hMCpa", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7yNJI").then(()=>parcelRequire('2pi7o'));

});

parcelRegister("4xnuT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ifX94").then(()=>parcelRequire('3Xmfm'));

});

parcelRegister("14hrM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3fs5M").then(()=>parcelRequire('7ISrx'));

});

parcelRegister("bvjMQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cCULL").then(()=>parcelRequire('cOsqE'));

});

parcelRegister("a0cSu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("81ele").then(()=>parcelRequire('heDum'));

});

parcelRegister("04uCN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9CNV1").then(()=>parcelRequire('ax6gr'));

});

parcelRegister("bXPYz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dwqKI").then(()=>parcelRequire('8DjS6'));

});

parcelRegister("hhmAa", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("c9j7H").then(()=>parcelRequire('avXTG'));

});

parcelRegister("az87C", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("MsAMf").then(()=>parcelRequire('kRSyE'));

});

parcelRegister("5XXvD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kj99S").then(()=>parcelRequire('cu0Sf'));

});

parcelRegister("gEIPy", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3sdrx").then(()=>parcelRequire('hC3Rz'));

});

parcelRegister("eyLKt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1bzA4").then(()=>parcelRequire('dCALS'));

});

parcelRegister("IR5Zr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hqUNL").then(()=>parcelRequire('bXsFc'));

});


parcelRegister("6oJXW", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $7acfde2c70552128$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $7acfde2c70552128$export$df0092b19156b140);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $7acfde2c70552128$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $7acfde2c70552128$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $7acfde2c70552128$export$c0547b4405cae584);

var $eUqFw = parcelRequire("eUqFw");

var $kMn00 = parcelRequire("kMn00");
var $4bEHq = parcelRequire("4bEHq");
var $d9NWW = parcelRequire("d9NWW");
var $kcn2F = parcelRequire("kcn2F");

var $bampN = parcelRequire("bampN");
const $7acfde2c70552128$export$3c94e0f4719f5c2a = (children)=>{
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).some((child)=>$7acfde2c70552128$export$df0092b19156b140(child))) return true;
    return false;
};
const $7acfde2c70552128$export$b56fc89cf6e7d1e9 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && Object.values($kMn00).some((type)=>type === node.type);
const $7acfde2c70552128$export$d7fc505bb0bd5756 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && Object.values($bampN).some((type)=>type === node.type);
const $7acfde2c70552128$export$df0092b19156b140 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $4bEHq.default);
const $7acfde2c70552128$export$c0547b4405cae584 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $d9NWW.default);
const $7acfde2c70552128$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $kcn2F.default);

});
parcelRegister("kMn00", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("kcn2F")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("cIk4w")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("d9NWW")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("bTLTu")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("4bEHq")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("4sQhG")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("fbX7D")).default);
$parcel$export(module.exports, "RelatedUrlsBlock", () => (parcelRequire("8jYmN")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("h2NbM")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("jgolE")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("5I51G")).default);

var $kcn2F = parcelRequire("kcn2F");

var $cIk4w = parcelRequire("cIk4w");

var $d9NWW = parcelRequire("d9NWW");

var $bTLTu = parcelRequire("bTLTu");

var $4bEHq = parcelRequire("4bEHq");

var $4sQhG = parcelRequire("4sQhG");

var $fbX7D = parcelRequire("fbX7D");

var $8jYmN = parcelRequire("8jYmN");

var $h2NbM = parcelRequire("h2NbM");

var $jgolE = parcelRequire("jgolE");

var $5I51G = parcelRequire("5I51G");

});
parcelRegister("kcn2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $e186a177ed6dee21$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fbX7D = parcelRequire("fbX7D");

var $caOA9 = parcelRequire("caOA9");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $e186a177ed6dee21$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fbX7D.default), {
        ...props,
        testId: testId
    });
};
var $e186a177ed6dee21$export$2e2bcd8739ae039 = $e186a177ed6dee21$var$FooterBlock;

});
parcelRegister("fbX7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c6de85b494ec94f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $4AAjx = parcelRequire("4AAjx");

var $bampN = parcelRequire("bampN");

var $fNWSr = parcelRequire("fNWSr");

var $4sQhG = parcelRequire("4sQhG");

var $7GItJ = parcelRequire("7GItJ");

var $d2BrZ = parcelRequire("d2BrZ");
const $5c6de85b494ec94f$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $caOA9.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const hasActions = (0, $eUqFw.useMemo)(()=>(0, $d2BrZ.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const onDropdownOpenChange = (0, $eUqFw.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, !hideProvider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.Provider), {
        testId: `${testId}-provider`
    }), actions && hasActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        testId: "smart-element-group-actions",
        align: (0, $caOA9.SmartLinkAlignment).Right,
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        overrideCss: (0, $d2BrZ.getActionGroupStyles)(size),
        width: (0, $caOA9.SmartLinkWidth).Flexible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNWSr.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: actions,
        appearance: "default"
    })) : null);
};
var $5c6de85b494ec94f$export$2e2bcd8739ae039 = $5c6de85b494ec94f$var$FooterBlockResolvedView;

});
parcelRegister("caOA9", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $0e147ae1cf3527e1$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $0e147ae1cf3527e1$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $0e147ae1cf3527e1$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $0e147ae1cf3527e1$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $0e147ae1cf3527e1$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $0e147ae1cf3527e1$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $0e147ae1cf3527e1$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $0e147ae1cf3527e1$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $0e147ae1cf3527e1$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $0e147ae1cf3527e1$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $0e147ae1cf3527e1$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $0e147ae1cf3527e1$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $0e147ae1cf3527e1$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $0e147ae1cf3527e1$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $0e147ae1cf3527e1$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $0e147ae1cf3527e1$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $0e147ae1cf3527e1$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $0e147ae1cf3527e1$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $0e147ae1cf3527e1$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $0e147ae1cf3527e1$export$6ca4ef8b3dc2c804);
const $0e147ae1cf3527e1$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $0e147ae1cf3527e1$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $0e147ae1cf3527e1$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $0e147ae1cf3527e1$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $0e147ae1cf3527e1$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $0e147ae1cf3527e1$export$8910bf86027fe6be;
(function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
})($0e147ae1cf3527e1$export$8910bf86027fe6be || ($0e147ae1cf3527e1$export$8910bf86027fe6be = {}));
var $0e147ae1cf3527e1$export$60831686b0574c86;
(function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
})($0e147ae1cf3527e1$export$60831686b0574c86 || ($0e147ae1cf3527e1$export$60831686b0574c86 = {}));
var $0e147ae1cf3527e1$export$d58e6377644d1dcf;
(function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
})($0e147ae1cf3527e1$export$d58e6377644d1dcf || ($0e147ae1cf3527e1$export$d58e6377644d1dcf = {}));
var $0e147ae1cf3527e1$export$51f13ced115cbdae;
(function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
})($0e147ae1cf3527e1$export$51f13ced115cbdae || ($0e147ae1cf3527e1$export$51f13ced115cbdae = {}));
var $0e147ae1cf3527e1$export$61cff06be26816f;
(function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
})($0e147ae1cf3527e1$export$61cff06be26816f || ($0e147ae1cf3527e1$export$61cff06be26816f = {}));
var $0e147ae1cf3527e1$export$aed0f1e801ad691f;
(function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
})($0e147ae1cf3527e1$export$aed0f1e801ad691f || ($0e147ae1cf3527e1$export$aed0f1e801ad691f = {}));
var $0e147ae1cf3527e1$export$9aafec380d7005da;
(function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
})($0e147ae1cf3527e1$export$9aafec380d7005da || ($0e147ae1cf3527e1$export$9aafec380d7005da = {}));
var $0e147ae1cf3527e1$export$19c60054ee783de6;
(function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
})($0e147ae1cf3527e1$export$19c60054ee783de6 || ($0e147ae1cf3527e1$export$19c60054ee783de6 = {}));
var $0e147ae1cf3527e1$export$d65b168331104a46;
(function(ElementName) {
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
})($0e147ae1cf3527e1$export$d65b168331104a46 || ($0e147ae1cf3527e1$export$d65b168331104a46 = {}));
var $0e147ae1cf3527e1$export$9c95d6e1614bad84;
(function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    /**
	 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-8954 Internal documentation for deprecation (no external access)}
	 */ ActionName["ViewAction"] = "ViewAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
})($0e147ae1cf3527e1$export$9c95d6e1614bad84 || ($0e147ae1cf3527e1$export$9c95d6e1614bad84 = {}));
var $0e147ae1cf3527e1$export$4871a84b35cf8eb9;
(function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
})($0e147ae1cf3527e1$export$4871a84b35cf8eb9 || ($0e147ae1cf3527e1$export$4871a84b35cf8eb9 = {}));
var $0e147ae1cf3527e1$export$13ff1290a9e22e77;
(function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
})($0e147ae1cf3527e1$export$13ff1290a9e22e77 || ($0e147ae1cf3527e1$export$13ff1290a9e22e77 = {}));
var $0e147ae1cf3527e1$export$483c11740a902fcd;
(function(MediaType) {
    MediaType["Image"] = "image";
})($0e147ae1cf3527e1$export$483c11740a902fcd || ($0e147ae1cf3527e1$export$483c11740a902fcd = {}));
var $0e147ae1cf3527e1$export$f9f4737e25ab90fa;
(function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
})($0e147ae1cf3527e1$export$f9f4737e25ab90fa || ($0e147ae1cf3527e1$export$f9f4737e25ab90fa = {}));
var $0e147ae1cf3527e1$export$6ca4ef8b3dc2c804;
(function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
})($0e147ae1cf3527e1$export$6ca4ef8b3dc2c804 || ($0e147ae1cf3527e1$export$6ca4ef8b3dc2c804 = {}));

});

parcelRegister("4AAjx", function(module, exports) {

$parcel$export(module.exports, "FlexibleUiContext", () => $43db55e8f7afe139$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $43db55e8f7afe139$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiAnalyticsContext", () => $43db55e8f7afe139$export$9296fed6018ca95b);
$parcel$export(module.exports, "useFlexibleUiAnalyticsContext", () => $43db55e8f7afe139$export$80b8dfec38d1d85c);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $43db55e8f7afe139$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $43db55e8f7afe139$export$e6b5ad18b56e8f51);

var $eUqFw = parcelRequire("eUqFw");
const $43db55e8f7afe139$export$ca70b164b615de47 = (0, $eUqFw.createContext)(undefined);
const $43db55e8f7afe139$export$61d7957a243df7aa = ()=>(0, $eUqFw.useContext)($43db55e8f7afe139$export$ca70b164b615de47);
const $43db55e8f7afe139$export$9296fed6018ca95b = (0, $eUqFw.createContext)(undefined);
const $43db55e8f7afe139$export$80b8dfec38d1d85c = ()=>(0, $eUqFw.useContext)($43db55e8f7afe139$export$9296fed6018ca95b);
const $43db55e8f7afe139$export$f7433dbd6c50e26a = (0, $eUqFw.createContext)(undefined);
const $43db55e8f7afe139$export$e6b5ad18b56e8f51 = ()=>(0, $eUqFw.useContext)($43db55e8f7afe139$export$f7433dbd6c50e26a);

});

parcelRegister("bampN", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => $706e9ad9ba761081$export$d3af56c23f9e459b);
$parcel$export(module.exports, "AssignedToGroup", () => $706e9ad9ba761081$export$fbd18f11bf3a3444);
$parcel$export(module.exports, "AttachmentCount", () => $706e9ad9ba761081$export$3bc3c9693a40aa);
$parcel$export(module.exports, "AuthorGroup", () => $706e9ad9ba761081$export$2ae2af4435dd6144);
$parcel$export(module.exports, "ChecklistProgress", () => $706e9ad9ba761081$export$5742b38fd5cfe410);
$parcel$export(module.exports, "CollaboratorGroup", () => $706e9ad9ba761081$export$a1e647014985ddb9);
$parcel$export(module.exports, "CommentCount", () => $706e9ad9ba761081$export$f4c1466e6fdd07b);
$parcel$export(module.exports, "CreatedOn", () => $706e9ad9ba761081$export$53ced9403d373871);
$parcel$export(module.exports, "CreatedBy", () => $706e9ad9ba761081$export$db468caedefbb630);
$parcel$export(module.exports, "DueOn", () => $706e9ad9ba761081$export$fea59459cfa1625b);
$parcel$export(module.exports, "LatestCommit", () => $706e9ad9ba761081$export$2aa8c58ab6c8ae64);
$parcel$export(module.exports, "LinkIcon", () => $706e9ad9ba761081$export$69387b41dfc808f7);
$parcel$export(module.exports, "Location", () => $706e9ad9ba761081$export$18a2be9195644f38);
$parcel$export(module.exports, "ModifiedBy", () => $706e9ad9ba761081$export$ebbbdcc68d717b7b);
$parcel$export(module.exports, "ModifiedOn", () => $706e9ad9ba761081$export$a6db3f4240728b58);
$parcel$export(module.exports, "OwnedBy", () => $706e9ad9ba761081$export$fa04b1f8d953704f);
$parcel$export(module.exports, "OwnedByGroup", () => $706e9ad9ba761081$export$90e81c873cca1e90);
$parcel$export(module.exports, "Priority", () => $706e9ad9ba761081$export$300334f671c43555);
$parcel$export(module.exports, "ProgrammingLanguage", () => $706e9ad9ba761081$export$7904b5485bf997ea);
$parcel$export(module.exports, "Provider", () => $706e9ad9ba761081$export$2881499e37b75b9a);
$parcel$export(module.exports, "ReactCount", () => $706e9ad9ba761081$export$f69df2decd5f729e);
$parcel$export(module.exports, "ReadTime", () => $706e9ad9ba761081$export$77dedcd16f070a20);
$parcel$export(module.exports, "SentOn", () => $706e9ad9ba761081$export$897b145a1ed39fe5);
$parcel$export(module.exports, "SourceBranch", () => $706e9ad9ba761081$export$387c3264a8f67d61);
$parcel$export(module.exports, "State", () => $706e9ad9ba761081$export$7254cc27399e90bd);
$parcel$export(module.exports, "SubscriberCount", () => $706e9ad9ba761081$export$cfafe90bba8a54db);
$parcel$export(module.exports, "SubTasksProgress", () => $706e9ad9ba761081$export$d441f34e4c8dd9e7);
$parcel$export(module.exports, "StoryPoints", () => $706e9ad9ba761081$export$634eef04d1a9a575);
$parcel$export(module.exports, "TargetBranch", () => $706e9ad9ba761081$export$b5e4199e062b8f44);
$parcel$export(module.exports, "Title", () => $706e9ad9ba761081$export$f99233281efd08a0);
$parcel$export(module.exports, "ViewCount", () => $706e9ad9ba761081$export$ae2d8be089b6cfe0);
$parcel$export(module.exports, "VoteCount", () => $706e9ad9ba761081$export$b080bef6ed7fa75a);
$parcel$export(module.exports, "Preview", () => (parcelRequire("2mW0Z")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("jtGWU")).default);

var $577Fl = parcelRequire("577Fl");

var $caOA9 = parcelRequire("caOA9");

var $2mW0Z = parcelRequire("2mW0Z");

var $jtGWU = parcelRequire("jtGWU");
const $706e9ad9ba761081$export$d3af56c23f9e459b = (0, $577Fl.createElement)((0, $caOA9.ElementName).AssignedTo);
const $706e9ad9ba761081$export$fbd18f11bf3a3444 = (0, $577Fl.createElement)((0, $caOA9.ElementName).AssignedToGroup);
const $706e9ad9ba761081$export$3bc3c9693a40aa = (0, $577Fl.createElement)((0, $caOA9.ElementName).AttachmentCount);
const $706e9ad9ba761081$export$2ae2af4435dd6144 = (0, $577Fl.createElement)((0, $caOA9.ElementName).AuthorGroup);
const $706e9ad9ba761081$export$5742b38fd5cfe410 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ChecklistProgress);
const $706e9ad9ba761081$export$a1e647014985ddb9 = (0, $577Fl.createElement)((0, $caOA9.ElementName).CollaboratorGroup);
const $706e9ad9ba761081$export$f4c1466e6fdd07b = (0, $577Fl.createElement)((0, $caOA9.ElementName).CommentCount);
const $706e9ad9ba761081$export$53ced9403d373871 = (0, $577Fl.createElement)((0, $caOA9.ElementName).CreatedOn);
const $706e9ad9ba761081$export$db468caedefbb630 = (0, $577Fl.createElement)((0, $caOA9.ElementName).CreatedBy);
const $706e9ad9ba761081$export$fea59459cfa1625b = (0, $577Fl.createElement)((0, $caOA9.ElementName).DueOn);
const $706e9ad9ba761081$export$2aa8c58ab6c8ae64 = (0, $577Fl.createElement)((0, $caOA9.ElementName).LatestCommit);
const $706e9ad9ba761081$export$69387b41dfc808f7 = (0, $577Fl.createElement)((0, $caOA9.ElementName).LinkIcon);
const $706e9ad9ba761081$export$18a2be9195644f38 = (0, $577Fl.createElement)((0, $caOA9.ElementName).Location);
const $706e9ad9ba761081$export$ebbbdcc68d717b7b = (0, $577Fl.createElement)((0, $caOA9.ElementName).ModifiedBy);
const $706e9ad9ba761081$export$a6db3f4240728b58 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ModifiedOn);
const $706e9ad9ba761081$export$fa04b1f8d953704f = (0, $577Fl.createElement)((0, $caOA9.ElementName).OwnedBy);
const $706e9ad9ba761081$export$90e81c873cca1e90 = (0, $577Fl.createElement)((0, $caOA9.ElementName).OwnedByGroup);
const $706e9ad9ba761081$export$300334f671c43555 = (0, $577Fl.createElement)((0, $caOA9.ElementName).Priority);
const $706e9ad9ba761081$export$7904b5485bf997ea = (0, $577Fl.createElement)((0, $caOA9.ElementName).ProgrammingLanguage);
const $706e9ad9ba761081$export$2881499e37b75b9a = (0, $577Fl.createElement)((0, $caOA9.ElementName).Provider);
const $706e9ad9ba761081$export$f69df2decd5f729e = (0, $577Fl.createElement)((0, $caOA9.ElementName).ReactCount);
const $706e9ad9ba761081$export$77dedcd16f070a20 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ReadTime);
const $706e9ad9ba761081$export$897b145a1ed39fe5 = (0, $577Fl.createElement)((0, $caOA9.ElementName).SentOn);
const $706e9ad9ba761081$export$387c3264a8f67d61 = (0, $577Fl.createElement)((0, $caOA9.ElementName).SourceBranch);
const $706e9ad9ba761081$export$7254cc27399e90bd = (0, $577Fl.createElement)((0, $caOA9.ElementName).State);
const $706e9ad9ba761081$export$cfafe90bba8a54db = (0, $577Fl.createElement)((0, $caOA9.ElementName).SubscriberCount);
const $706e9ad9ba761081$export$d441f34e4c8dd9e7 = (0, $577Fl.createElement)((0, $caOA9.ElementName).SubTasksProgress);
const $706e9ad9ba761081$export$634eef04d1a9a575 = (0, $577Fl.createElement)((0, $caOA9.ElementName).StoryPoints);
const $706e9ad9ba761081$export$b5e4199e062b8f44 = (0, $577Fl.createElement)((0, $caOA9.ElementName).TargetBranch);
const $706e9ad9ba761081$export$f99233281efd08a0 = (0, $577Fl.createElement)((0, $caOA9.ElementName).Title);
const $706e9ad9ba761081$export$ae2d8be089b6cfe0 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ViewCount);
const $706e9ad9ba761081$export$b080bef6ed7fa75a = (0, $577Fl.createElement)((0, $caOA9.ElementName).VoteCount);

});
parcelRegister("577Fl", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $d123e4d2e9f5aa27$export$c8a8987d4410bf2d);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");

var $caOA9 = parcelRequire("caOA9");

var $c2pJy = parcelRequire("c2pJy");

var $39rqs = parcelRequire("39rqs");

var $kIJ39 = parcelRequire("kIJ39");

var $4AAjx = parcelRequire("4AAjx");

var $ecYnC = parcelRequire("ecYnC");

var $1aEBl = parcelRequire("1aEBl");

var $2aeJ6 = parcelRequire("2aeJ6");

var $gsehw = parcelRequire("gsehw");

var $4abrz = parcelRequire("4abrz");

var $iAt1y = parcelRequire("iAt1y");

var $8UE2N = parcelRequire("8UE2N");
const $d123e4d2e9f5aa27$var$elementMappings = {
    [(0, $caOA9.ElementName).AttachmentCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Attachment
        }
    },
    [(0, $caOA9.ElementName).AuthorGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).ChecklistProgress]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).CheckItem
        }
    },
    [(0, $caOA9.ElementName).CollaboratorGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).CommentCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Comment
        }
    },
    [(0, $caOA9.ElementName).ViewCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).View
        }
    },
    [(0, $caOA9.ElementName).ReactCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).React
        }
    },
    [(0, $caOA9.ElementName).VoteCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Vote
        }
    },
    [(0, $caOA9.ElementName).CreatedBy]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).OwnedBy]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).AssignedTo]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).AssignedToGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).OwnedByGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).CreatedOn]: {
        component: (0, $iAt1y.default)
    },
    [(0, $caOA9.ElementName).DueOn]: {
        component: (0, $kIJ39.default)
    },
    [(0, $caOA9.ElementName).LatestCommit]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Commit
        }
    },
    [(0, $caOA9.ElementName).LinkIcon]: {
        component: (0, $c2pJy.default)
    },
    [(0, $caOA9.ElementName).ModifiedBy]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).ModifiedOn]: {
        component: (0, $iAt1y.default)
    },
    [(0, $caOA9.ElementName).Preview]: {
        component: (0, $2aeJ6.default)
    },
    [(0, $caOA9.ElementName).Priority]: {
        component: (0, $ecYnC.default)
    },
    [(0, $caOA9.ElementName).ProgrammingLanguage]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).ProgrammingLanguage
        }
    },
    [(0, $caOA9.ElementName).Provider]: {
        component: (0, $ecYnC.default)
    },
    [(0, $caOA9.ElementName).ReadTime]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).SentOn]: {
        component: (0, $iAt1y.default)
    },
    [(0, $caOA9.ElementName).SourceBranch]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).State]: {
        component: (0, $kIJ39.default)
    },
    [(0, $caOA9.ElementName).SubscriberCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Subscriber
        }
    },
    [(0, $caOA9.ElementName).SubTasksProgress]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).SubTasksProgress
        }
    },
    [(0, $caOA9.ElementName).StoryPoints]: {
        component: (0, $8UE2N.default)
    },
    [(0, $caOA9.ElementName).TargetBranch]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).Title]: {
        component: (0, $39rqs.default)
    },
    [(0, $caOA9.ElementName).Location]: {
        component: (0, $39rqs.default),
        props: {
            theme: (0, $caOA9.SmartLinkInternalTheme).Grey
        }
    }
};
const $d123e4d2e9f5aa27$var$getContextKey = (name)=>{
    // Attempt to predict context prop name in advance to reduce the amount of
    // code run during runtime
    return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
const $d123e4d2e9f5aa27$var$getData = (elementName, contextKey, context)=>{
    if (!context) return undefined;
    const data = context[contextKey];
    switch(elementName){
        case (0, $caOA9.ElementName).AssignedToGroup:
        case (0, $caOA9.ElementName).AuthorGroup:
        case (0, $caOA9.ElementName).CollaboratorGroup:
        case (0, $caOA9.ElementName).OwnedByGroup:
            const AvatarGroupsWithFallback = [
                (0, $caOA9.ElementName).AssignedToGroup
            ];
            const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
            return $d123e4d2e9f5aa27$var$toAvatarGroupProps(data, showFallbackAvatar);
        case (0, $caOA9.ElementName).AttachmentCount:
        case (0, $caOA9.ElementName).ChecklistProgress:
        case (0, $caOA9.ElementName).CommentCount:
        case (0, $caOA9.ElementName).ViewCount:
        case (0, $caOA9.ElementName).ReactCount:
        case (0, $caOA9.ElementName).VoteCount:
        case (0, $caOA9.ElementName).ProgrammingLanguage:
        case (0, $caOA9.ElementName).SubscriberCount:
        case (0, $caOA9.ElementName).LatestCommit:
        case (0, $caOA9.ElementName).SubTasksProgress:
            return $d123e4d2e9f5aa27$var$toBadgeProps(data);
        case (0, $caOA9.ElementName).StoryPoints:
            return $d123e4d2e9f5aa27$var$toAtlaskitBadgeProps(data);
        case (0, $caOA9.ElementName).CreatedBy:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).created_by, context.createdBy);
        case (0, $caOA9.ElementName).AssignedTo:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).assigned_to, context.assignedTo);
        case (0, $caOA9.ElementName).OwnedBy:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).owned_by, context.ownedBy);
        case (0, $caOA9.ElementName).CreatedOn:
            return $d123e4d2e9f5aa27$var$toDateTimeProps('created', context.createdOn);
        case (0, $caOA9.ElementName).DueOn:
            return $d123e4d2e9f5aa27$var$toDateLozengeProps(context.dueOn);
        case (0, $caOA9.ElementName).ModifiedBy:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).modified_by, context.modifiedBy);
        case (0, $caOA9.ElementName).ModifiedOn:
            return $d123e4d2e9f5aa27$var$toDateTimeProps('modified', context.modifiedOn);
        case (0, $caOA9.ElementName).SentOn:
            return $d123e4d2e9f5aa27$var$toDateTimeProps('sent', context.sentOn);
        case (0, $caOA9.ElementName).ReadTime:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).read_time, data);
        case (0, $caOA9.ElementName).SourceBranch:
        case (0, $caOA9.ElementName).TargetBranch:
            return $d123e4d2e9f5aa27$var$toTextProps(data);
        case (0, $caOA9.ElementName).Title:
            return $d123e4d2e9f5aa27$var$toLinkProps(context.title, context.url);
        default:
            return typeof data === 'object' ? data : undefined;
    }
};
const $d123e4d2e9f5aa27$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toBadgeProps = (label)=>{
    return label ? {
        label: label
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toAtlaskitBadgeProps = (value)=>{
    return value ? {
        value: value
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toDateLozengeProps = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90IgZ.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
const $d123e4d2e9f5aa27$var$toDateTimeProps = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toFormattedTextProps = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toLinkProps = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toTextProps = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
const $d123e4d2e9f5aa27$export$c8a8987d4410bf2d = (name)=>{
    const { component: BaseElement, props: props } = $d123e4d2e9f5aa27$var$elementMappings[name] || {};
    const contextKey = $d123e4d2e9f5aa27$var$getContextKey(name);
    if (!BaseElement) throw Error(`Element ${name} does not exist.`);
    return (overrides)=>{
        const context = (0, $eUqFw.useContext)((0, $4AAjx.FlexibleUiContext));
        const data = $d123e4d2e9f5aa27$var$getData(name, contextKey, context);
        return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BaseElement, {
            ...props,
            ...data,
            ...overrides,
            name: name
        }) : null;
    };
};

});
parcelRegister("c2pJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $13d34755e025af7a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $fBftA = parcelRequire("fBftA");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $h0YJD = parcelRequire("h0YJD");

var $2pE6J = parcelRequire("2pE6J");

var $4z862 = parcelRequire("4z862");
function $13d34755e025af7a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $13d34755e025af7a$var$_ref = {
    name: "1xpq7g4",
    styles: "align-self:flex-start;margin:0"
};
var $13d34755e025af7a$var$_ref2 = {
    name: "qbt5ty",
    styles: "align-self:center"
};
const $13d34755e025af7a$var$getPositionStyles = (position)=>{
    switch(position){
        case (0, $caOA9.SmartLinkPosition).Center:
            return $13d34755e025af7a$var$_ref2;
        case (0, $caOA9.SmartLinkPosition).Top:
        default:
            return $13d34755e025af7a$var$_ref;
    }
};
const $13d34755e025af7a$var$getIconStyles = (position, width)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)($13d34755e025af7a$var$getPositionStyles(position), (0, $4z862.getIconSizeStyles)(width));
const $13d34755e025af7a$var$getCustomRenderStyles = (value)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)((0, $4z862.getTruncateStyles)(1, value), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: value,
        textAlign: 'center',
        textOverflow: 'clip',
        WebkitBoxOrient: 'unset',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        span: {
            margin: 0,
            padding: 0,
            verticalAlign: 'baseline'
        }
    });
const $13d34755e025af7a$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $h0YJD.default), {
        icon: icon,
        testId: `${testId}-icon`
    });
};
const $13d34755e025af7a$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBftA))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $13d34755e025af7a$var$renderImageIcon = (defaultIcon, url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2pE6J.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param {IconProps} IconProps - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $13d34755e025af7a$var$Icon = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $caOA9.SmartLinkPosition).Top, overrideCss: overrideCss, render: render, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
    const element = (0, $eUqFw.useMemo)(()=>{
        const defaultIcon = $13d34755e025af7a$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $13d34755e025af7a$var$renderImageIcon(defaultIcon, url, testId) || $13d34755e025af7a$var$renderAtlaskitIcon(icon, testId) || defaultIcon;
    }, [
        overrideIcon,
        icon,
        label,
        render,
        testId,
        url
    ]);
    const width = (0, $4z862.getIconWidth)(size);
    const styles = $13d34755e025af7a$var$getIconStyles(position, width);
    const renderStyles = render ? $13d34755e025af7a$var$getCustomRenderStyles(width) : undefined;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
        css: [
            styles,
            renderStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId
    }, element);
};
var $13d34755e025af7a$export$2e2bcd8739ae039 = $13d34755e025af7a$var$Icon;

});
parcelRegister("fBftA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70f2b78564f0b7c3236457f67879324e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5b650fc75d7cc02$var$_react = $b5b650fc75d7cc02$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b5b650fc75d7cc02$var$_link = $b5b650fc75d7cc02$var$_interopRequireDefault((parcelRequire("h0HFa")));

var $b5b650fc75d7cc02$var$_link2 = $b5b650fc75d7cc02$var$_interopRequireDefault((parcelRequire("hUwRB")));
function $b5b650fc75d7cc02$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5b650fc75d7cc02$var$LinkIcon = (props)=>/*#__PURE__*/ $b5b650fc75d7cc02$var$_react.default.createElement($b5b650fc75d7cc02$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $b5b650fc75d7cc02$var$_link2.default
    }, props));
$b5b650fc75d7cc02$var$LinkIcon.Name = 'LinkIconMigration';
var $b5b650fc75d7cc02$var$_default = module.exports.default = $b5b650fc75d7cc02$var$LinkIcon;

});
parcelRegister("h0HFa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7939ee5038402c5f027adffad929d2df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6244e4cd9ddde64$var$_react = $c6244e4cd9ddde64$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c6244e4cd9ddde64$var$_UNSAFE_baseNew = $c6244e4cd9ddde64$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c6244e4cd9ddde64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6244e4cd9ddde64$var$LinkIcon = (props)=>/*#__PURE__*/ $c6244e4cd9ddde64$var$_react.default.createElement($c6244e4cd9ddde64$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$c6244e4cd9ddde64$var$LinkIcon.displayName = 'LinkIcon';
var $c6244e4cd9ddde64$var$_default = module.exports.default = $c6244e4cd9ddde64$var$LinkIcon;

});

parcelRegister("hUwRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0a128a0d80d703a$var$_react = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d0a128a0d80d703a$var$_link = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("h0HFa")));
function $d0a128a0d80d703a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d0a128a0d80d703a$var$LinkIcon = (props)=>/*#__PURE__*/ $d0a128a0d80d703a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $d0a128a0d80d703a$var$_link.default
    }));
$d0a128a0d80d703a$var$LinkIcon.displayName = 'LinkIcon';
var $d0a128a0d80d703a$var$_default = module.exports.default = $d0a128a0d80d703a$var$LinkIcon;

});


parcelRegister("h0YJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc7df94b43718706$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");


var $5KT10 = parcelRequire("5KT10");
var $77CtJ = parcelRequire("77CtJ");

var $33pqc = parcelRequire("33pqc");

var $42mVw = parcelRequire("42mVw");

var $caOA9 = parcelRequire("caOA9");





























































// prettier-ignore
const $bc7df94b43718706$var$importIconMapper = {
    [(0, $caOA9.IconType).Archive]: ()=>(parcelRequire("hhmAa")),
    [(0, $caOA9.IconType).Audio]: ()=>(parcelRequire("04uCN")),
    [(0, $caOA9.IconType).Code]: ()=>(parcelRequire("5XXvD")),
    [(0, $caOA9.IconType).Executable]: ()=>(parcelRequire("az87C")),
    [(0, $caOA9.IconType).File]: ()=>(parcelRequire("gEIPy")),
    [(0, $caOA9.IconType).Folder]: ()=>(parcelRequire("IR5Zr")),
    [(0, $caOA9.IconType).Generic]: ()=>(parcelRequire("gEIPy")),
    [(0, $caOA9.IconType).GIF]: ()=>(parcelRequire("a0cSu")),
    [(0, $caOA9.IconType).GoogleDocs]: ()=>(parcelRequire("2Zwb9")),
    [(0, $caOA9.IconType).GoogleForms]: ()=>(parcelRequire("14hrM")),
    [(0, $caOA9.IconType).GoogleSheets]: ()=>(parcelRequire("kENAJ")),
    [(0, $caOA9.IconType).GoogleSlides]: ()=>(parcelRequire("hMCpa")),
    [(0, $caOA9.IconType).Image]: ()=>(parcelRequire("bvjMQ")),
    [(0, $caOA9.IconType).MSExcel]: ()=>(parcelRequire("dsRgj")),
    [(0, $caOA9.IconType).MSPowerpoint]: ()=>(parcelRequire("4xnuT")),
    [(0, $caOA9.IconType).MSWord]: ()=>(parcelRequire("9pS0E")),
    [(0, $caOA9.IconType).PDF]: ()=>(parcelRequire("iqKJJ")),
    [(0, $caOA9.IconType).Presentation]: ()=>(parcelRequire("43vNc")),
    [(0, $caOA9.IconType).Sketch]: ()=>(parcelRequire("eyLKt")),
    [(0, $caOA9.IconType).Spreadsheet]: ()=>(parcelRequire("7dTur")),
    [(0, $caOA9.IconType).Template]: ()=>(parcelRequire("fftwl")),
    [(0, $caOA9.IconType).Video]: ()=>(parcelRequire("bXPYz")),
    // Bitbucket icons
    [(0, $caOA9.IconType).Branch]: ()=>(parcelRequire("hWtno")),
    [(0, $caOA9.IconType).Commit]: ()=>(parcelRequire("3CUe5")),
    [(0, $caOA9.IconType).Project]: ()=>Promise.resolve((parcelRequire("iwsIy"))),
    [(0, $caOA9.IconType).PullRequest]: ()=>(parcelRequire("lPCrS")),
    [(0, $caOA9.IconType).Repo]: ()=>(parcelRequire("2fxL5")),
    // Jira icons
    [(0, $caOA9.IconType).Bug]: ()=>(parcelRequire("6jKnq")),
    [(0, $caOA9.IconType).Change]: ()=>(parcelRequire("87ALa")),
    [(0, $caOA9.IconType).Epic]: ()=>(parcelRequire("5O2YE")),
    [(0, $caOA9.IconType).Incident]: ()=>(parcelRequire("lnZYZ")),
    [(0, $caOA9.IconType).Problem]: ()=>(parcelRequire("av3OT")),
    [(0, $caOA9.IconType).ServiceRequest]: ()=>(parcelRequire("lkYBV")),
    [(0, $caOA9.IconType).Story]: ()=>(parcelRequire("hf65U")),
    [(0, $caOA9.IconType).SubTask]: ()=>(parcelRequire("2JaZ4")),
    [(0, $caOA9.IconType).Task]: ()=>(parcelRequire("exFM9")),
    // Provider icons
    [(0, $caOA9.IconType).Confluence]: ()=>Promise.resolve((parcelRequire("5KT10"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                default: ConfluenceIcon
            })),
    [(0, $caOA9.IconType).Jira]: ()=>Promise.resolve((parcelRequire("77CtJ"))).then(({ JiraIcon: JiraIcon })=>({
                default: JiraIcon
            })),
    // Fallback icons
    [(0, $caOA9.IconType).Default]: ()=>Promise.resolve((parcelRequire("hUwRB"))),
    [(0, $caOA9.IconType).Error]: ()=>Promise.resolve((parcelRequire("96IgR"))),
    [(0, $caOA9.IconType).Forbidden]: ()=>(parcelRequire("dwS4O")),
    // Badge
    [(0, $caOA9.IconType).Attachment]: ()=>(parcelRequire("hQtFe")),
    [(0, $caOA9.IconType).CheckItem]: ()=>(parcelRequire("0zYUH")),
    [(0, $caOA9.IconType).Comment]: ()=>(parcelRequire("3rkiP")),
    [(0, $caOA9.IconType).View]: ()=>(parcelRequire("aonoe")),
    [(0, $caOA9.IconType).React]: ()=>(parcelRequire("4J3iF")),
    [(0, $caOA9.IconType).Vote]: ()=>(parcelRequire("3sCdr")),
    [(0, $caOA9.IconType).PriorityBlocker]: ()=>(parcelRequire("6SGL9")),
    [(0, $caOA9.IconType).PriorityCritical]: ()=>(parcelRequire("eXGDS")),
    [(0, $caOA9.IconType).PriorityHigh]: ()=>(parcelRequire("hgVzO")),
    [(0, $caOA9.IconType).PriorityHighest]: ()=>(parcelRequire("mLn3Q")),
    [(0, $caOA9.IconType).PriorityLow]: ()=>(parcelRequire("cLsbI")),
    [(0, $caOA9.IconType).PriorityLowest]: ()=>(parcelRequire("1qbPt")),
    [(0, $caOA9.IconType).PriorityMajor]: ()=>(parcelRequire("5sbHU")),
    [(0, $caOA9.IconType).PriorityMedium]: ()=>(parcelRequire("gLmUj")),
    [(0, $caOA9.IconType).PriorityMinor]: ()=>(parcelRequire("jFzry")),
    [(0, $caOA9.IconType).PriorityTrivial]: ()=>(parcelRequire("hIhZX")),
    [(0, $caOA9.IconType).PriorityUndefined]: ()=>(parcelRequire("hdkC1")),
    [(0, $caOA9.IconType).ProgrammingLanguage]: ()=>(parcelRequire("1YXpW")),
    [(0, $caOA9.IconType).Subscriber]: ()=>(parcelRequire("bpSlM")),
    [(0, $caOA9.IconType).SubTasksProgress]: ()=>(parcelRequire("bIh7y"))
};
const $bc7df94b43718706$var$getIconImportFn = (icon)=>$bc7df94b43718706$var$importIconMapper[icon];
const $bc7df94b43718706$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $bc7df94b43718706$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $caOA9.IconType).Document:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33pqc))), {
                label: label || 'document',
                testId: testId
            });
        case (0, $caOA9.IconType).Blog:
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42mVw))), {
                label: label || 'blog',
                testId: testId
            });
    }
    const importFn = $bc7df94b43718706$var$getIconImportFn(icon);
    if (!importFn) return null;
    const ImportedIcon = $bc7df94b43718706$var$importIcon(importFn);
    switch(icon){
        case (0, $caOA9.IconType).Confluence:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
                appearance: "brand",
                testId: testId
            });
        case (0, $caOA9.IconType).Jira:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
                appearance: "brand",
                testId: testId
            });
        case (0, $caOA9.IconType).Error:
        case (0, $caOA9.IconType).Forbidden:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
                label: label,
                testId: testId
            });
    }
};
var $bc7df94b43718706$export$2e2bcd8739ae039 = $bc7df94b43718706$var$AtlaskitIcon;

});
parcelRegister("42mVw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f09221b0a539484$var$_react = $2f09221b0a539484$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2f09221b0a539484$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2f09221b0a539484$var$Blog16Icon = (props)=>/*#__PURE__*/ $2f09221b0a539484$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 10-2.37 2.87c-.277.394-.616.815-1.016 1.265a.916.916 0 00-.058 1.147.607.607 0 00.948.043c1.939-2.221 2.77-3.996 2.496-5.325zm7 0a2.5 2.5 0 10-2.37 2.87c-.277.394-.616.815-1.016 1.265a.916.916 0 00-.058 1.147.607.607 0 00.948.043c1.939-2.221 2.77-3.996 2.496-5.325zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$2f09221b0a539484$var$Blog16Icon.displayName = 'Blog16Icon';
var $2f09221b0a539484$var$_default = $2f09221b0a539484$var$Blog16Icon;
module.exports.default = $2f09221b0a539484$var$_default;

});

parcelRegister("fftwl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ec24o").then(()=>parcelRequire('nzdI3'));

});

parcelRegister("hWtno", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6sdEd").then(()=>parcelRequire('gQa4O'));

});

parcelRegister("3CUe5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("0XCgk").then(()=>parcelRequire('fU2qj'));

});

parcelRegister("lPCrS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("d7x2y").then(()=>parcelRequire('6VQ7Z'));

});

parcelRegister("2fxL5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jQWgi").then(()=>parcelRequire('egbU6'));

});

parcelRegister("6jKnq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7gYJE").then(()=>parcelRequire('3YEb9'));

});

parcelRegister("87ALa", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("e32zY").then(()=>parcelRequire('fsJVW'));

});

parcelRegister("5O2YE", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gAatW").then(()=>parcelRequire('gFrvj'));

});

parcelRegister("lnZYZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2k8XF").then(()=>parcelRequire('bJZ7m'));

});

parcelRegister("av3OT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("igYUv").then(()=>parcelRequire('5cywL'));

});

parcelRegister("lkYBV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9RGyV").then(()=>parcelRequire('2NYtj'));

});

parcelRegister("hf65U", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("87XEJ").then(()=>parcelRequire('3Fcny'));

});

parcelRegister("2JaZ4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1AHX9").then(()=>parcelRequire('aJNc8'));

});

parcelRegister("exFM9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cFs1I").then(()=>parcelRequire('hiUvC'));

});

parcelRegister("dwS4O", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("l5Ls8").then(()=>parcelRequire('f4A0J'));

});

parcelRegister("hQtFe", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hpSb1").then(()=>parcelRequire('jUThT'));

});

parcelRegister("0zYUH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6F2ZJ").then(()=>parcelRequire('eRawo'));

});

parcelRegister("3rkiP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("h5H6F").then(()=>parcelRequire('d3vNK'));

});

parcelRegister("aonoe", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("NpdOV").then(()=>parcelRequire('jHMvH'));

});

parcelRegister("4J3iF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("YPDkL").then(()=>parcelRequire('fvQWm'));

});

parcelRegister("3sCdr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iWD7v").then(()=>parcelRequire('hL0Qd'));

});

parcelRegister("6SGL9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kvwg1").then(()=>parcelRequire('8nY6X'));

});

parcelRegister("eXGDS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("yTwnW").then(()=>parcelRequire('eIr2t'));

});

parcelRegister("hgVzO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9yvg0").then(()=>parcelRequire('hRYdU'));

});

parcelRegister("mLn3Q", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ebVzT").then(()=>parcelRequire('gSFPI'));

});

parcelRegister("cLsbI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aRCDF").then(()=>parcelRequire('h0cb1'));

});

parcelRegister("1qbPt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9VtCD").then(()=>parcelRequire('k3ak7'));

});

parcelRegister("5sbHU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2bZsf").then(()=>parcelRequire('7JgHV'));

});

parcelRegister("gLmUj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fNIof").then(()=>parcelRequire('fQ2EI'));

});

parcelRegister("jFzry", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hK23s").then(()=>parcelRequire('1psqr'));

});

parcelRegister("hIhZX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("k2MLG").then(()=>parcelRequire('cLW4D'));

});

parcelRegister("hdkC1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("l1hYo")
]).then(()=>parcelRequire('eQuyQ'));

});

parcelRegister("1YXpW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9ZHUo").then(()=>parcelRequire('2Q5Ee'));

});

parcelRegister("bpSlM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("4XpLQ")
]).then(()=>parcelRequire('4nce6'));

});

parcelRegister("bIh7y", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kr06K").then(()=>parcelRequire('eyI8O'));

});


parcelRegister("2pE6J", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d21a9774b5a2f1e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $cRPaW = parcelRequire("cRPaW");

var $8SIiI = parcelRequire("8SIiI");
const $6d21a9774b5a2f1e$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, onError: onError, onLoad: onLoad })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cRPaW))), {
        src: url,
        loading: /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
            testId: `${testId}-loading`
        }),
        loaded: /*#__PURE__*/ (0, $byn9U.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
var $6d21a9774b5a2f1e$export$2e2bcd8739ae039 = $6d21a9774b5a2f1e$var$ImageIcon;

});
parcelRegister("cRPaW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $95e221a7f9807f92$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eUqFw = parcelRequire("eUqFw");
var $95e221a7f9807f92$var$React = $95e221a7f9807f92$var$_interopRequireWildcard($eUqFw);
function $95e221a7f9807f92$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $95e221a7f9807f92$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $95e221a7f9807f92$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $95e221a7f9807f92$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $95e221a7f9807f92$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $95e221a7f9807f92$var$loaded() {
    return {
        isLoaded: true
    };
}
function $95e221a7f9807f92$var$errored() {
    return {
        isErrored: true
    };
}
function $95e221a7f9807f92$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $95e221a7f9807f92$var$ImageRenderer = function(_React$Component) {
    $95e221a7f9807f92$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $95e221a7f9807f92$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $95e221a7f9807f92$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($95e221a7f9807f92$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($95e221a7f9807f92$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $95e221a7f9807f92$var$_possibleConstructorReturn(_this, _ret);
    }
    $95e221a7f9807f92$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($95e221a7f9807f92$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($95e221a7f9807f92$var$hasPropsChanged(this.props, nextProps)) this.setState($95e221a7f9807f92$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($95e221a7f9807f92$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($95e221a7f9807f92$var$React.Component);
module.exports.default = $95e221a7f9807f92$var$ImageRenderer;

});

parcelRegister("8SIiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9060a2498f61f4f2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $9060a2498f61f4f2$var$LoadingSkeleton = ({ testId: testId, width: width, height: height })=>{
    const animationNameStyles = (0, $byn9U.keyframes)({
        '0%': {
            backgroundPosition: '50% 0'
        },
        '100%': {
            backgroundPosition: '-50% 0'
        }
    });
    const styles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${width}rem`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${height}rem`,
        borderRadius: '2px',
        userSelect: 'none',
        background: "var(--ds-skeleton-subtle, #f6f7f8)",
        backgroundImage: `linear-gradient( to right, transparent 0%, ${"var(--ds-skeleton, #edeef1)"} 20%, transparent 40%, transparent 100% )`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '280% 100%',
        display: 'inline-block',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        animationName: animationNameStyles,
        animationTimingFunction: 'linear'
    });
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: styles,
        "data-testid": testId
    });
};
var $9060a2498f61f4f2$export$2e2bcd8739ae039 = $9060a2498f61f4f2$var$LoadingSkeleton;

});


parcelRegister("4z862", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $c5cf90fd8bf8cba5$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $c5cf90fd8bf8cba5$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $c5cf90fd8bf8cba5$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconSizeStyles", () => $c5cf90fd8bf8cba5$export$a5dfadfde90ee066);
$parcel$export(module.exports, "getIconWidth", () => $c5cf90fd8bf8cba5$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $c5cf90fd8bf8cba5$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getLinkLineHeight", () => $c5cf90fd8bf8cba5$export$1826e889cc97649);
$parcel$export(module.exports, "getLinkSizeStyles", () => $c5cf90fd8bf8cba5$export$7c3a25542ae9da0e);
$parcel$export(module.exports, "getMaxLineHeight", () => $c5cf90fd8bf8cba5$export$a681bd062fee88a5);
$parcel$export(module.exports, "getMaxLines", () => $c5cf90fd8bf8cba5$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $c5cf90fd8bf8cba5$export$475c391af8171fec);
$parcel$export(module.exports, "getPrimitivesPaddingSpaceBySize", () => $c5cf90fd8bf8cba5$export$1af10e3728e3a644);
$parcel$export(module.exports, "getTruncateStyles", () => $c5cf90fd8bf8cba5$export$8847c5561c06da49);
$parcel$export(module.exports, "hasWhiteSpace", () => $c5cf90fd8bf8cba5$export$619e376a425cb759);
$parcel$export(module.exports, "openEmbedModalWithFlexibleUiIcon", () => $c5cf90fd8bf8cba5$export$7207d5a516d3bfa8);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $c2pJy = parcelRequire("c2pJy");

var $1csi6 = parcelRequire("1csi6");

var $bYKiA = parcelRequire("bYKiA");
const $c5cf90fd8bf8cba5$export$9d642f65a919fb93 = {
    [(0, $caOA9.SmartLinkSize).Small]: 'none',
    [(0, $caOA9.SmartLinkSize).Medium]: 'compact',
    [(0, $caOA9.SmartLinkSize).Large]: 'compact',
    [(0, $caOA9.SmartLinkSize).XLarge]: 'default'
};
const $c5cf90fd8bf8cba5$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...descriptor,
            values: values
        });
    }
};
const $c5cf90fd8bf8cba5$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $c5cf90fd8bf8cba5$var$getIconDimensionStyles = (value)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: value
    });
const $c5cf90fd8bf8cba5$export$a5dfadfde90ee066 = (width)=>{
    const sizeStyles = $c5cf90fd8bf8cba5$var$getIconDimensionStyles(width);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)("flex:0 0 auto;", sizeStyles, " span,svg,img{", sizeStyles, ";}svg{padding:0;}");
};
const $c5cf90fd8bf8cba5$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return '2rem';
        case (0, $caOA9.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $caOA9.SmartLinkSize).Medium:
            return '1rem';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '.75rem';
    }
};
const $c5cf90fd8bf8cba5$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $c5cf90fd8bf8cba5$export$1826e889cc97649 = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return '1.5rem';
        case (0, $caOA9.SmartLinkSize).Large:
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $c5cf90fd8bf8cba5$export$7c3a25542ae9da0e = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '1.25rem',
                fontWeight: 400,
                letterSpacing: '-0.008em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                lineHeight: $c5cf90fd8bf8cba5$export$1826e889cc97649(size)
            });
        case (0, $caOA9.SmartLinkSize).Large:
        case (0, $caOA9.SmartLinkSize).Medium:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '0.875rem',
                fontWeight: 400,
                letterSpacing: '-0.003em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                lineHeight: $c5cf90fd8bf8cba5$export$1826e889cc97649(size)
            });
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '0.75rem',
                fontWeight: 400,
                letterSpacing: '0em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                lineHeight: $c5cf90fd8bf8cba5$export$1826e889cc97649(size)
            });
    }
};
const $c5cf90fd8bf8cba5$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Large:
            return 1.75;
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $c5cf90fd8bf8cba5$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $c5cf90fd8bf8cba5$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $caOA9.SmartLinkSize).Large:
            return 'space.200';
        case (0, $caOA9.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $c5cf90fd8bf8cba5$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return 'space.300';
        case (0, $caOA9.SmartLinkSize).Large:
            return 'space.250';
        case (0, $caOA9.SmartLinkSize).Medium:
            return 'space.200';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 'space.100';
    }
};
const $c5cf90fd8bf8cba5$export$8847c5561c06da49 = (maxLines, lineHeight = '1rem', wordBreak = 'break-word')=>/*#__PURE__*/ (0, $byn9U.css)({
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        wordBreak: wordBreak,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        '@supports not (-webkit-line-clamp: 1)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxHeight: `calc(${maxLines} * ${lineHeight})`
        }
    });
const $c5cf90fd8bf8cba5$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};
const $c5cf90fd8bf8cba5$export$7207d5a516d3bfa8 = ({ linkIcon: linkIcon, ...props })=>{
    const icon = {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c2pJy.default), {
            ...linkIcon,
            size: (0, $caOA9.SmartLinkSize).Large
        }),
        isFlexibleUi: true
    };
    return (0, $1csi6.openEmbedModal)({
        ...props,
        icon: icon,
        // Flex should not send origin as block card. It should be able to support
        // its internal parent components like hover card, block card and
        // itself as a standalone. To be investigated and fix in EDM-7520.
        origin: 'smartLinkCard'
    });
};

});
parcelRegister("1csi6", function(module, exports) {

$parcel$export(module.exports, "openEmbedModal", () => $06a3274b0148278d$export$7859f96cd8cff034);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $3dpxL = parcelRequire("3dpxL");
const $06a3274b0148278d$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $06a3274b0148278d$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $06a3274b0148278d$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($06a3274b0148278d$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $06a3274b0148278d$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("1zJPX"));
    (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Modal.default, {
        ...props,
        iframeName: $06a3274b0148278d$var$IFRAME_NAME,
        onClose: (_context)=>{
            if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unmountComponentAtNode(popupMountPoint);
            if (onClose) onClose(_context);
        },
        showModal: true
    })), popupMountPoint);
}

});
parcelRegister("1zJPX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ivIPh")
]).then(()=>parcelRequire('2vsut'));

});




parcelRegister("39rqs", function(module, exports) {

$parcel$export(module.exports, "default", () => $105659f25305e8c7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8cU5f = parcelRequire("8cU5f");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");

var $8sbpW = parcelRequire("8sbpW");
function $105659f25305e8c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $105659f25305e8c7$var$DEFAULT_MAX_LINES = 2;
const $105659f25305e8c7$var$MAXIMUM_MAX_LINES = 2;
const $105659f25305e8c7$var$MINIMUM_MAX_LINES = 1;
const $105659f25305e8c7$var$containerStyles = {
    name: "mkkf9p",
    styles: "flex:1 1 auto"
};
var $105659f25305e8c7$var$_ref = {
    name: "16ucc2m",
    styles: "color:var(--ds-link, #0C66E4);:active{color:var(--ds-link-pressed, #0055CC);}:hover{color:var(--ds-link, #0C66E4);text-decoration:underline;}"
};
var $105659f25305e8c7$var$_ref2 = {
    name: "1glvof",
    styles: "color:var(--ds-text-subtle, #44546F);:active{color:var(--ds-text, #172B4D);}:hover{color:var(--ds-text-subtle, #44546F);text-decoration:underline;}"
};
var $105659f25305e8c7$var$_ref3 = {
    name: "rllj93",
    styles: "a&{color:var(--ds-text-subtlest, #626F86);&:active, &:visited, &:focus, &:hover{color:var(--ds-text-subtlest, #626F86);text-decoration:underline;}font-size:12px;}"
};
const $105659f25305e8c7$var$getThemeStyles = (theme)=>{
    switch(theme){
        case (0, $caOA9.SmartLinkInternalTheme).Grey:
            // We are being specifc with the CSS selectors to ensure that Confluence overrides
            // do not affect our internal Smart Card styles
            return $105659f25305e8c7$var$_ref3;
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        case (0, $caOA9.SmartLinkTheme).Black:
            return $105659f25305e8c7$var$_ref2;
        case (0, $caOA9.SmartLinkTheme).Link:
        default:
            return $105659f25305e8c7$var$_ref;
    }
};
const $105659f25305e8c7$var$getAnchorStyles = (size, theme, maxLines, hasSpace)=>{
    const sizeStyles = (0, $4z862.getLinkSizeStyles)(size);
    return /*#__PURE__*/ (0, $byn9U.css)("flex:1 1 auto;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    sizeStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines, (0, $4z862.getLinkLineHeight)(size), hasSpace ? 'break-word' : 'break-all'), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $105659f25305e8c7$var$getThemeStyles(theme));
};
const $105659f25305e8c7$var$getMaxLines = (maxLines)=>{
    if (maxLines > $105659f25305e8c7$var$MAXIMUM_MAX_LINES) return $105659f25305e8c7$var$DEFAULT_MAX_LINES;
    if (maxLines < $105659f25305e8c7$var$MINIMUM_MAX_LINES) return $105659f25305e8c7$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $105659f25305e8c7$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
/**
 * A base element that represent an anchor.
 * @internal
 * @param {LinkProps} LinkProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $105659f25305e8c7$var$Link = ({ hideTooltip: hideTooltip, maxLines: maxLines = $105659f25305e8c7$var$DEFAULT_MAX_LINES, name: name, overrideCss: overrideCss, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $caOA9.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
    const onMouseDown = (0, $8sbpW.useMouseDownEvent)();
    const hasSpace = (0, $eUqFw.useMemo)(()=>text ? (0, $4z862.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $byn9U.jsx)("a", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $105659f25305e8c7$var$getAnchorStyles(size, theme, $105659f25305e8c7$var$getMaxLines(maxLines), hasSpace),
            overrideCss
        ],
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        ...target !== '_self' && {
            target: target
        }
    }, text);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $105659f25305e8c7$var$containerStyles
    }, hideTooltip || text === undefined ? anchor : $105659f25305e8c7$var$withTooltip(anchor, text, testId));
};
var $105659f25305e8c7$export$2e2bcd8739ae039 = $105659f25305e8c7$var$Link;

});

parcelRegister("kIJ39", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab46ec5e33c2c988$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $ffiyv = parcelRequire("ffiyv");

var $cCDvW = parcelRequire("cCDvW");

var $4AAjx = parcelRequire("4AAjx");
function $ab46ec5e33c2c988$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ab46ec5e33c2c988$var$styles = {
    name: "cvfhjc",
    styles: "display:inline-flex;line-height:inherit"
};
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
 * @see State
 */ const $ab46ec5e33c2c988$var$Lozenge = ({ action: action, appearance: appearance = 'default', name: name, overrideCss: overrideCss, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $4AAjx.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $cCDvW.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), {
        appearance: appearance,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`
    }, text);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $ab46ec5e33c2c988$var$styles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId
    }, lozenge);
};
var $ab46ec5e33c2c988$export$2e2bcd8739ae039 = $ab46ec5e33c2c988$var$Lozenge;

});
parcelRegister("cCDvW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8af307a3451da5a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $6OfWd = parcelRequire("6OfWd");

var $gNhy0 = parcelRequire("gNhy0");

var $k18Wh = parcelRequire("k18Wh");

var $aiL3q = parcelRequire("aiL3q");

var $fZ5ue = parcelRequire("fZ5ue");

var $2n1yu = parcelRequire("2n1yu");

var $5PFec = parcelRequire("5PFec");

var $af6S8 = parcelRequire("af6S8");

var $gBDMJ = parcelRequire("gBDMJ");

var $8McbT = parcelRequire("8McbT");

var $4AAjx = parcelRequire("4AAjx");

var $bTNMs = parcelRequire("bTNMs");

var $5Oy6H = parcelRequire("5Oy6H");

var $4jHIN = parcelRequire("4jHIN");
const $c8af307a3451da5a$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $c8af307a3451da5a$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $eUqFw.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $eUqFw.useState)(false);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [items, setItems] = (0, $eUqFw.useState)();
    const [errorMessage, setErrorMessage] = (0, $eUqFw.useState)();
    const reload = (0, $af6S8.default)();
    //TODO EDM-6583 Replace usage of useFlexibleUiAnalyticsContext with linking platform analytics context from find team.
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $fZ5ue.default)();
    (0, $eUqFw.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, previewData: previewData } = action?.update?.details || {};
    const handleOpenChange = (0, $eUqFw.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            analytics?.ui.smartLinkLozengeActionClickedEvent();
            analytics?.track.smartLinkQuickActionStarted({
                smartLinkActionType: (0, $bTNMs.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $2n1yu.default));
                const validItems = typeof text === 'string' ? $c8af307a3451da5a$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $gBDMJ.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $gBDMJ.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        analytics,
        invoke,
        isLoaded,
        text
    ]);
    const trigger = (0, $eUqFw.useCallback)((props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gNhy0.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $eUqFw.useCallback)(async (id, text, appearance)=>{
        try {
            analytics?.ui.smartLinkLozengeActionListItemClickedEvent();
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $5PFec.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                analytics?.track.smartLinkQuickActionSuccess({
                    smartLinkActionType: (0, $bTNMs.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $8McbT.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $gBDMJ.LozengeActionErrorMessages).updateFailed);
                analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        analytics,
        invoke,
        linkId,
        reload,
        url
    ]);
    const dropdownItemGroup = (0, $eUqFw.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $k18Wh.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            previewData: previewData
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4jHIN.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        previewData,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $6OfWd.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex
    }, dropdownItemGroup);
};
var $c8af307a3451da5a$export$2e2bcd8739ae039 = (0, $aiL3q.default)($c8af307a3451da5a$var$LozengeAction);

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $epS3S = parcelRequire("epS3S");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $eUqFw.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event, currentLevel)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epS3S.DropdownMenuProvider), {
        value: {
            returnFocusRef: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    })));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);


var $XHGTv = parcelRequire("XHGTv");

var $8gwL5 = parcelRequire("8gwL5");
const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if ((0, $XHGTv.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $8gwL5.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});



parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("epS3S", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuProvider", () => $ee1dc8dd27dd916a$export$9357e33608f1035a);

var $eUqFw = parcelRequire("eUqFw");
const $ee1dc8dd27dd916a$var$DropdownMenuContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ee1dc8dd27dd916a$export$9357e33608f1035a = $ee1dc8dd27dd916a$var$DropdownMenuContext.Provider;

});

parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});


parcelRegister("gNhy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7635f6bba3760eba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $86Ndv = parcelRequire("86Ndv");

var $bPzws = parcelRequire("bPzws");
const $7635f6bba3760eba$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $eUqFw.useState)(false);
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $eUqFw.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), {
            appearance: appearance,
            isBold: isBold
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $bPzws.triggerLozengeStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", null, text), /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: "options",
            size: "medium"
        }))), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        type: "button",
        ...props,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $bPzws.triggerButtonStyles),
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef
    }, lozenge);
};
var $7635f6bba3760eba$export$2e2bcd8739ae039 = $7635f6bba3760eba$var$LozengeActionTrigger;

});
parcelRegister("bPzws", function(module, exports) {

$parcel$export(module.exports, "triggerButtonStyles", () => $fc5d2e39c54f8883$export$ae858546f0bfd05c);
$parcel$export(module.exports, "triggerLozengeStyles", () => $fc5d2e39c54f8883$export$5717c7336384f3a6);
$parcel$export(module.exports, "dropdownItemGroupStyles", () => $fc5d2e39c54f8883$export$2c40d814aeff5db);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $fc5d2e39c54f8883$export$ae858546f0bfd05c = /*#__PURE__*/ (0, $byn9U.css)({
    all: 'unset',
    backgroundColor: 'transparent',
    color: 'unset',
    cursor: 'pointer',
    fontFamily: 'unset',
    fontSize: 'unset',
    fontStyle: 'unset',
    fontWeight: 'unset',
    fontVariant: 'unset',
    lineHeight: 0,
    padding: 0,
    textTransform: 'unset',
    border: '2px solid transparent',
    margin: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:focus-visible, &:focus-within, &[aria-expanded='true']": {
        outline: 'none',
        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`,
        borderRadius: '5px'
    }
});
const $fc5d2e39c54f8883$export$5717c7336384f3a6 = /*#__PURE__*/ (0, $byn9U.css)({
    alignItems: 'center',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "span[role='img']": {
        margin: `${"var(--ds-space-negative-050, -4px)"} ${"var(--ds-space-negative-100, -8px)"} ${"var(--ds-space-negative-050, -4px)"} -1px`
    }
});
const $fc5d2e39c54f8883$export$2c40d814aeff5db = /*#__PURE__*/ (0, $byn9U.css)({
    maxHeight: '300px',
    overflowY: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        minHeight: '28px',
        width: '220px',
        '&:hover': {
            backgroundColor: 'inherit'
        },
        '&:focus, &:focus-visible': {
            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            boxSizing: 'border-box',
            boxShadow: `inset 2px 0 0 ${"var(--ds-border-selected, #0C66E4)"}`,
            outline: 'none'
        }
    }
});

});


parcelRegister("k18Wh", function(module, exports) {

$parcel$export(module.exports, "default", () => $723d9a69e05743b3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");


var $gw74N = parcelRequire("gw74N");

var $c3mz7 = parcelRequire("c3mz7");

var $4z862 = parcelRequire("4z862");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $af6S8 = parcelRequire("af6S8");
const $723d9a69e05743b3$var$MAX_LINE_NUMBER = 8;
const $723d9a69e05743b3$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $723d9a69e05743b3$var$MAX_LINE_NUMBER, url: url, previewData: previewData })=>{
    const reload = (0, $af6S8.default)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const isPreviewAvailable = previewData && previewData.src !== undefined;
    const handlePreviewClose = (0, $eUqFw.useCallback)(()=>{
        if (url) reload(url, true);
    }, [
        reload,
        url
    ]);
    const handlePreviewOpen = (0, $eUqFw.useCallback)(()=>{
        if (isPreviewAvailable) {
            analytics?.ui.smartLinkLozengeActionErrorOpenPreviewClickedEvent();
            return (0, $4z862.openEmbedModalWithFlexibleUiIcon)({
                ...previewData,
                analytics: analytics,
                onClose: handlePreviewClose
            });
        }
    }, [
        analytics,
        handlePreviewClose,
        isPreviewAvailable,
        previewData
    ]);
    const content = (0, $eUqFw.useMemo)(()=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $c3mz7.contentStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gw74N))), {
            testId: `${testId}-icon`,
            LEGACY_size: "medium",
            color: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd)})`,
            label: 'error',
            spacing: "spacious"
        }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $c3mz7.textStyles)(maxLineNumber),
            "data-testid": `${testId}-error-message`
        }, typeof errorMessage === 'string' ? errorMessage : (0, $4z862.getFormattedMessage)(errorMessage))), isPreviewAvailable ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $c3mz7.linkStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)("a", {
            target: "_blank",
            "data-testid": `${testId}-open-embed`,
            onClick: handlePreviewOpen
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        maxLineNumber,
        testId
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $c3mz7.dropdownItemGroupStyles),
        "data-testid": `${testId}-error-item-group`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fEubG.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hD6GJ.default), {
        testId: `${testId}-error`
    }, content))));
};
var $723d9a69e05743b3$export$2e2bcd8739ae039 = $723d9a69e05743b3$var$LozengeActionError;

});
parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $ki32l.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("c3mz7", function(module, exports) {

$parcel$export(module.exports, "dropdownItemGroupStyles", () => $88f4678df04deb4b$export$2c40d814aeff5db);
$parcel$export(module.exports, "contentStyles", () => $88f4678df04deb4b$export$a38ecc1ac2e6fba);
$parcel$export(module.exports, "linkStyles", () => $88f4678df04deb4b$export$4ea5976125a01ffa);
$parcel$export(module.exports, "textStyles", () => $88f4678df04deb4b$export$6a54c24d15b0f6ba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4z862 = parcelRequire("4z862");
function $88f4678df04deb4b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $88f4678df04deb4b$export$2c40d814aeff5db = {
    name: "a7m7l8",
    styles: "button{width:220px;&:hover{background-color:inherit;cursor:default;}}"
};
const $88f4678df04deb4b$var$sharedBlockStyles = {
    name: "gx0rja",
    styles: "display:flex;gap:var(--ds-space-100, 0.5rem);line-height:1rem;min-width:0;overflow:hidden;flex-direction:row;align-items:center"
};
const $88f4678df04deb4b$export$a38ecc1ac2e6fba = /*#__PURE__*/ (0, $byn9U.css)($88f4678df04deb4b$var$sharedBlockStyles, {
    marginTop: "var(--ds-space-025, 2px)",
    alignItems: 'flex-start',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span, > div': {
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`
    }
});
const $88f4678df04deb4b$export$4ea5976125a01ffa = /*#__PURE__*/ (0, $byn9U.css)($88f4678df04deb4b$var$sharedBlockStyles, "cursor:pointer;font-size:0.875rem;margin-top:var(--ds-space-100, 8px);margin-left:var(--ds-space-400, 32px);margin-bottom:var(--ds-space-025, 2px);");
const $88f4678df04deb4b$export$6a54c24d15b0f6ba = (maxLines)=>/*#__PURE__*/ (0, $byn9U.css)("line-height:1rem;white-space:normal;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines));

});

parcelRegister("4abrz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ebfdcddf6874aaf0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ebfdcddf6874aaf0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules...',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related_work_items_not_found: {
        id: 'fabric.linking.related_work_items_not_found',
        defaultMessage: 'This link is not mentioned anywhere else.',
        description: 'Informs the user that there are no related resources for a given url'
    },
    last_mentioned_in: {
        id: 'fabric.linking.last_mentioned_in',
        defaultMessage: 'Last mentioned in',
        description: 'Informs the user about where the resource was last mentioned in'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls.nonfinal',
        defaultMessage: 'View recent links...',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    }
});

});

parcelRegister("af6S8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2997c27397645ece$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2cI4y = parcelRequire("2cI4y");

var $caOA9 = parcelRequire("caOA9");

var $gqldc = parcelRequire("gqldc");

var $fQBSX = parcelRequire("fQBSX");
const $2997c27397645ece$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $fQBSX.default)();
    return (0, $eUqFw.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $caOA9.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data);
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $2cI4y.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $2997c27397645ece$export$2e2bcd8739ae039 = $2997c27397645ece$var$useResolve;

});
parcelRegister("fQBSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae1d36093d90197e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6EHO5 = parcelRequire("6EHO5");
var $f9yXU = parcelRequire("f9yXU");
var $4hPjC = parcelRequire("4hPjC");

var $caOA9 = parcelRequire("caOA9");

var $7pH5u = parcelRequire("7pH5u");


var $lEfVV = parcelRequire("lEfVV");

var $gqldc = parcelRequire("gqldc");
const $ae1d36093d90197e$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $gqldc.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $eUqFw.useCallback)((url, metadataStatus)=>{
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $eUqFw.useCallback)((url, error, response, isMetadataRequest)=>{
        const { details: details } = getState()[url] || {
            status: (0, $caOA9.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If there's no previous data in the store for this URL, then bail
            // out and let the editor handle fallbacks (returns to a blue link).
            if (!hasData && status !== 'resolved') {
                dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
                url: url
            }, details));
        // Handle AuthErrors (user did not have access to resource) -
        // Missing AAID in ASAP claims, or missing UserContext, or 403 from downstream
        } else if (error.kind === 'auth') dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
            url: url
        }, (0, $7pH5u.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $eUqFw.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $eUqFw.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $4hPjC.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('fallback', hostname, (0, $30e664360e28092c$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('fatal', hostname, (0, $30e664360e28092c$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('error', hostname, (0, $30e664360e28092c$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $lEfVV.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $ae1d36093d90197e$export$2e2bcd8739ae039 = $ae1d36093d90197e$var$useResponse;

});
parcelRegister("6EHO5", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $48f17d480117024d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $48f17d480117024d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $48f17d480117024d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $48f17d480117024d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $48f17d480117024d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $48f17d480117024d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $48f17d480117024d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $48f17d480117024d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $48f17d480117024d$export$6e470aad5ba8952e = 'pending';
const $48f17d480117024d$export$9a6a932a0a39498e = 'resolving';
const $48f17d480117024d$export$63ec8bc7a8a75482 = 'resolved';
const $48f17d480117024d$export$b8cfaa842c9ab487 = 'reloading';
const $48f17d480117024d$export$6d8ed3f9433dd372 = 'errored';
const $48f17d480117024d$export$cfbbb7126bc8a0c6 = 'fallback';
const $48f17d480117024d$export$76b5c1aca20759c6 = 'preload';
const $48f17d480117024d$export$2c5edb971b673330 = 'metadata';
const $48f17d480117024d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("f9yXU", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $eab65a9e311d10e1$export$3e5b797e39668f84);
class $eab65a9e311d10e1$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`);
        this.kind = kind;
        this.hostname = hostname;
        this.message = message;
        this.type = type;
        this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("4hPjC", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $6a6a7fcdba3f3a7c$export$b70265791d2079d4);
const $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $6a6a7fcdba3f3a7c$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("7pH5u", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $c6847fc9d6f0df43$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $c6847fc9d6f0df43$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $c6847fc9d6f0df43$export$e32193033a594efb);
const $c6847fc9d6f0df43$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $c6847fc9d6f0df43$export$2796a804c6e44f63 = ()=>$c6847fc9d6f0df43$var$emptyData;
const $c6847fc9d6f0df43$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$c6847fc9d6f0df43$var$emptyData
        }
    });
const $c6847fc9d6f0df43$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$c6847fc9d6f0df43$var$emptyData
        }
    });

});

const $30e664360e28092c$export$297c39c8b9bfca0 = 'resolving';
const $30e664360e28092c$export$b64a888338c24e0e = 'errored';
const $30e664360e28092c$export$677b6edfa0002c70 = 'fallback';
const $30e664360e28092c$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $30e664360e28092c$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $30e664360e28092c$export$338f7d9ccca1975d = 'Error resolving metadata.';




parcelRegister("aiL3q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac18b970e0fdc7f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jb3WS = parcelRequire("jb3WS");

var $ffiyv = parcelRequire("ffiyv");
const $ac18b970e0fdc7f3$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: props?.appearance,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`
            }, props?.text), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props));
    };
var $ac18b970e0fdc7f3$export$2e2bcd8739ae039 = $ac18b970e0fdc7f3$var$withErrorBoundary;

});

parcelRegister("fZ5ue", function(module, exports) {

$parcel$export(module.exports, "default", () => $526f1cd6fde31da2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $imCrQ = parcelRequire("imCrQ");

var $gqldc = parcelRequire("gqldc");
const $526f1cd6fde31da2$var$useInvoke = ()=>{
    const { connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const clientExt = (0, $imCrQ.useSmartLinkClientExtension)(connections.client);
    return (0, $eUqFw.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $526f1cd6fde31da2$export$2e2bcd8739ae039 = $526f1cd6fde31da2$var$useInvoke;

});
parcelRegister("imCrQ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $e90617a456d47f08$export$303ede4eed148855);

var $eUqFw = parcelRequire("eUqFw");

var $5LW2w = parcelRequire("5LW2w");

var $cCvxR = parcelRequire("cCvxR");

var $euvAQ = parcelRequire("euvAQ");
const $e90617a456d47f08$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $euvAQ.useResolverUrl)(cardClient);
    const invoke = (0, $eUqFw.useCallback)(async (data)=>{
        try {
            return await (0, $5LW2w.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $cCvxR.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    const relatedUrls = (0, $eUqFw.useCallback)(async (url)=>{
        return await (0, $5LW2w.request)('get', `${resolverUrl}/related-urls?url=${encodeURIComponent(url)}`, undefined, {
            'Cache-Control': 'private'
        }, [
            200
        ]);
    }, [
        resolverUrl
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            invoke: invoke,
            relatedUrls: relatedUrls
        }), [
        invoke,
        relatedUrls
    ]);
};

});
parcelRegister("5LW2w", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $182a4c691eac998e$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $182a4c691eac998e$export$b5fe3f66a567bec0);
const $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $182a4c691eac998e$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $182a4c691eac998e$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $182a4c691eac998e$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("euvAQ", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $56f10bb2820b4284$export$d08617a365fbe694);

var $eUqFw = parcelRequire("eUqFw");

var $dUrSu = parcelRequire("dUrSu");
const $56f10bb2820b4284$export$d08617a365fbe694 = (cardClient)=>(0, $eUqFw.useMemo)(()=>(0, $dUrSu.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});
parcelRegister("dUrSu", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $67d3f38f231759a2$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $67d3f38f231759a2$export$dc37652c1696f231);
const $67d3f38f231759a2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $67d3f38f231759a2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $67d3f38f231759a2$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $67d3f38f231759a2$export$e2b040f052407032 = {
    dev: $67d3f38f231759a2$var$devBaseUrl,
    development: $67d3f38f231759a2$var$devBaseUrl,
    stg: $67d3f38f231759a2$var$stgBaseUrl,
    staging: $67d3f38f231759a2$var$stgBaseUrl,
    prd: $67d3f38f231759a2$var$prodBaseUrl,
    prod: $67d3f38f231759a2$var$prodBaseUrl,
    production: $67d3f38f231759a2$var$prodBaseUrl
};
const $67d3f38f231759a2$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $67d3f38f231759a2$export$e2b040f052407032 ? $67d3f38f231759a2$export$e2b040f052407032[envKey] : $67d3f38f231759a2$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $67d3f38f231759a2$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $67d3f38f231759a2$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $67d3f38f231759a2$export$2e2bcd8739ae039 = $67d3f38f231759a2$export$e2b040f052407032;

});




parcelRegister("2n1yu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8986176ef21b1b25$export$2e2bcd8739ae039);
const $8986176ef21b1b25$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $8986176ef21b1b25$export$2e2bcd8739ae039 = $8986176ef21b1b25$var$extractLozengeActionItems;

});

parcelRegister("5PFec", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf0e102a3fe2298$export$2e2bcd8739ae039);
const $1bf0e102a3fe2298$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $1bf0e102a3fe2298$export$2e2bcd8739ae039 = $1bf0e102a3fe2298$var$createStatusUpdateRequest;

});

parcelRegister("gBDMJ", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $7b8be149f9c2eaef$export$4f2e371a667ad688);

var $4abrz = parcelRequire("4abrz");
const $7b8be149f9c2eaef$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $4abrz.messages)['status_change_permission_error']
    },
    unknown: {
        descriptor: (0, $4abrz.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $4abrz.messages)['status_change_update_error']
    }
};

});

parcelRegister("8McbT", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $1c7a2500ec767744$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $1c7a2500ec767744$export$1694272377fa07d8);

var $bTNMs = parcelRequire("bTNMs");
const $1c7a2500ec767744$export$65b3f792dff0bd60 = (err)=>{
    if (!$1c7a2500ec767744$export$1694272377fa07d8(err)) return (0, $bTNMs.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $bTNMs.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $bTNMs.TrackQuickActionFailureReason).UnknownError;
    }
};
const $1c7a2500ec767744$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("5Oy6H", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$618660b8f2aa87e2);
const $2f5a2618d92e65d0$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $2f5a2618d92e65d0$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $2f5a2618d92e65d0$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $2f5a2618d92e65d0$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("4jHIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $85a1291c7d9bca32$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $5etYV = parcelRequire("5etYV");

var $bPzws = parcelRequire("bPzws");

var $fEubG = parcelRequire("fEubG");
const $85a1291c7d9bca32$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $bPzws.dropdownItemGroupStyles),
        "data-testid": `${testId}-item-group`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fEubG.default), null, items.map((item, idx)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5etYV.default), {
            ...item,
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        }))));
var $85a1291c7d9bca32$export$2e2bcd8739ae039 = $85a1291c7d9bca32$var$LozengeActionItemsGroup;

});
parcelRegister("5etYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fefc6a85569ce88$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $ffiyv = parcelRequire("ffiyv");
const $4fefc6a85569ce88$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $eUqFw.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        onMouseEnter: handleMouseEnter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: appearance
    }, text)));
};
var $4fefc6a85569ce88$export$2e2bcd8739ae039 = $4fefc6a85569ce88$var$LozengeActionItem;

});




parcelRegister("ecYnC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3fe7a328e3dd330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4z862 = parcelRequire("4z862");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $2pE6J = parcelRequire("2pE6J");

var $h0YJD = parcelRequire("h0YJD");
function $e3fe7a328e3dd330$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e3fe7a328e3dd330$var$badgeStyles = {
    name: "9qxyko",
    styles: "align-items:center;display:inline-flex;min-width:fit-content"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $e3fe7a328e3dd330$var$iconStyles = /*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-icon-subtle, #626F86);line-height:0;vertical-align:middle;", (0, $4z862.getIconSizeStyles)('1rem'), " img,span,svg{line-height:0;vertical-align:middle;}");
const $e3fe7a328e3dd330$var$labelStyles = {
    name: "8loelm",
    styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;padding-left:var(--ds-space-025, 0.125rem);vertical-align:middle"
};
const $e3fe7a328e3dd330$var$messageMapper = {
    [(0, $caOA9.IconType).PriorityBlocker]: (0, $4abrz.messages).priority_blocker,
    [(0, $caOA9.IconType).PriorityCritical]: (0, $4abrz.messages).priority_critical,
    [(0, $caOA9.IconType).PriorityHigh]: (0, $4abrz.messages).priority_high,
    [(0, $caOA9.IconType).PriorityHighest]: (0, $4abrz.messages).priority_highest,
    [(0, $caOA9.IconType).PriorityLow]: (0, $4abrz.messages).priority_low,
    [(0, $caOA9.IconType).PriorityLowest]: (0, $4abrz.messages).priority_lowest,
    [(0, $caOA9.IconType).PriorityMajor]: (0, $4abrz.messages).priority_major,
    [(0, $caOA9.IconType).PriorityMedium]: (0, $4abrz.messages).priority_medium,
    [(0, $caOA9.IconType).PriorityMinor]: (0, $4abrz.messages).priority_minor,
    [(0, $caOA9.IconType).PriorityTrivial]: (0, $4abrz.messages).priority_trivial,
    [(0, $caOA9.IconType).PriorityUndefined]: (0, $4abrz.messages).priority_undefined
};
const $e3fe7a328e3dd330$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $e3fe7a328e3dd330$var$messageMapper[icon];
        if (descriptor) return (0, $4z862.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $e3fe7a328e3dd330$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $h0YJD.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $e3fe7a328e3dd330$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2pE6J.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $e3fe7a328e3dd330$var$Badge = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $e3fe7a328e3dd330$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $e3fe7a328e3dd330$var$renderAtlaskitIcon(icon, testId) || $e3fe7a328e3dd330$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $e3fe7a328e3dd330$var$badgeStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId
    }, !hideIcon && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $e3fe7a328e3dd330$var$iconStyles
    }, badgeIcon), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $e3fe7a328e3dd330$var$labelStyles,
        "data-testid": `${testId}-label`
    }, formattedMessageOrLabel));
};
var $e3fe7a328e3dd330$export$2e2bcd8739ae039 = $e3fe7a328e3dd330$var$Badge;

});

parcelRegister("1aEBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a383934139702b93$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4XQdE = parcelRequire("4XQdE");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4z862 = parcelRequire("4z862");
function $a383934139702b93$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a383934139702b93$var$MAX_COUNT = 4;
var $a383934139702b93$var$_ref = {
    name: "1brfzli",
    styles: "display:inline-flex;ul{margin-right:var(--ds-space-100, 0.5rem);margin-top:0;}"
};
const $a383934139702b93$var$getStyles = (size)=>{
    const styles = $a383934139702b93$var$_ref;
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Large:
            // Default AK small size
            return styles;
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
            return /*#__PURE__*/ (0, $byn9U.css)(styles, " li{span,svg{max-height:1.25rem;max-width:1.25rem;}}");
    }
};
const $a383934139702b93$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $caOA9.ElementName).AssignedToGroup:
            return (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).assigned_to, personName);
        case (0, $caOA9.ElementName).OwnedByGroup:
            return (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).owned_by, personName);
        case (0, $caOA9.ElementName).AuthorGroup:
            return (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $a383934139702b93$var$AvatarGroup = ({ items: items = [], maxCount: maxCount = $a383934139702b93$var$MAX_COUNT, name: name, overrideCss: overrideCss, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $5JgJ2.default)();
    const data = (0, $eUqFw.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $caOA9.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $a383934139702b93$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $a383934139702b93$var$getStyles(size),
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4XQdE.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
var $a383934139702b93$export$2e2bcd8739ae039 = $a383934139702b93$var$AvatarGroup;

});
parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor || avatarData.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    isolation: 'isolate',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $XHGTv = parcelRequire("XHGTv");

const $80bc7348cf05a7b7$var$buttonSizes = {
    xsmall: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`}`,
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-border-inverse, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $80bc7348cf05a7b7$var$buttonSizes[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});

parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    isolation: 'isolate',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});



parcelRegister("2aeJ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1ea9141ebba5fdb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $2pE6J = parcelRequire("2pE6J");
function $f1ea9141ebba5fdb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $f1ea9141ebba5fdb$var$styles = {
    name: "a50hvv",
    styles: "aspect-ratio:16 / 9;display:flex;width:100%;height:fit-content;@supports not (aspect-ratio: auto){padding-top:56.25%;height:0;position:relative;overflow:hidden;}> img, > span{min-height:100%;min-width:100%;max-height:100%;max-width:100%;object-fit:cover;object-position:center center;@supports not (aspect-ratio: auto){position:absolute;transform:translate(-50%, -50%);left:50%;top:50%;width:auto;height:auto;}}"
};
/**
 * A base element that displays a Media.
 * @internal
 * @param {MediaProps} MediaProps - The props necessary for the Media element.
 * @see Preview
 */ const $f1ea9141ebba5fdb$var$Media = ({ name: name, overrideCss: overrideCss, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $f1ea9141ebba5fdb$var$styles,
            overrideCss
        ],
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2pE6J.default), {
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
var $f1ea9141ebba5fdb$export$2e2bcd8739ae039 = $f1ea9141ebba5fdb$var$Media;

});

parcelRegister("gsehw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dd937a6ee8e1ad3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4z862 = parcelRequire("4z862");
const $5dd937a6ee8e1ad3$var$getStyles = (maxLines)=>/*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;white-space:normal;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines));
/**
 * A base element that displays some Text.
 * @internal
 * @param {TextProps} TextProps - The props necessary for the Text element.
 * @see Title
 */ const $5dd937a6ee8e1ad3$var$Text = ({ content: content, maxLines: maxLines = 1, message: message, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-text' })=>{
    if (!message && !content) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $5dd937a6ee8e1ad3$var$getStyles(maxLines),
            overrideCss
        ],
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId
    }, (0, $4z862.getFormattedMessage)(message) || content);
};
var $5dd937a6ee8e1ad3$export$2e2bcd8739ae039 = $5dd937a6ee8e1ad3$var$Text;

});

parcelRegister("iAt1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $588a9b7e2c02aa74$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $byn9U = parcelRequire("byn9U");

var $4z862 = parcelRequire("4z862");

var $9KU0P = parcelRequire("9KU0P");

var $4abrz = parcelRequire("4abrz");
const $588a9b7e2c02aa74$var$styles = /*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $4z862.getTruncateStyles)(1));
const $588a9b7e2c02aa74$var$typeToDescriptorMap = {
    created: {
        relative: (0, $4abrz.messages).created_on_relative,
        absolute: (0, $4abrz.messages).created_on_absolute
    },
    modified: {
        relative: (0, $4abrz.messages).modified_on_relative,
        absolute: (0, $4abrz.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $4abrz.messages).sent_on_relative,
        absolute: (0, $4abrz.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $588a9b7e2c02aa74$var$DateTime = ({ date: date, name: name, overrideCss: overrideCss, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $5JgJ2.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $9KU0P.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $588a9b7e2c02aa74$var$styles,
            overrideCss
        ],
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId
    }, text ? `${text} ${context}` : /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
        ...$588a9b7e2c02aa74$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    }));
};
var $588a9b7e2c02aa74$export$2e2bcd8739ae039 = $588a9b7e2c02aa74$var$DateTime;

});

parcelRegister("8UE2N", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d82cf77148d10f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nkwJ = parcelRequire("9nkwJ");

var $byn9U = parcelRequire("byn9U");
function $82d82cf77148d10f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $82d82cf77148d10f$var$badgeStyles = {
    name: "qowjig",
    styles: "align-items:center;display:inline-flex"
};
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $82d82cf77148d10f$var$AtlaskitBadge = ({ value: value, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $82d82cf77148d10f$var$badgeStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9nkwJ.default), null, value));
};
var $82d82cf77148d10f$export$2e2bcd8739ae039 = $82d82cf77148d10f$var$AtlaskitBadge;

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
function $00d99ab26ca06411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $00d99ab26ca06411$var$neutral300 = '#DDDEE1';
const $00d99ab26ca06411$var$red300 = '#FD9891';
const $00d99ab26ca06411$var$blue300 = '#8FB8F6';
const $00d99ab26ca06411$var$neutral1000 = '#292A2E';
const $00d99ab26ca06411$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$neutral300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$red300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$blue300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $00d99ab26ca06411$var$styles.root,
            $00d99ab26ca06411$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});




parcelRegister("2mW0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dc684baf7d7b3ad$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4AAjx = parcelRequire("4AAjx");

var $caOA9 = parcelRequire("caOA9");

var $2aeJ6 = parcelRequire("2aeJ6");
const $1dc684baf7d7b3ad$var$Preview = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $eUqFw.useContext)((0, $4AAjx.FlexibleUiContext));
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $caOA9.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2aeJ6.default), {
        ...rest,
        ...data
    });
};
var $1dc684baf7d7b3ad$export$2e2bcd8739ae039 = $1dc684baf7d7b3ad$var$Preview;

});

parcelRegister("jtGWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f9944feb1da4750$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $4AAjx = parcelRequire("4AAjx");

var $gsehw = parcelRequire("gsehw");
const $7f9944feb1da4750$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $7f9944feb1da4750$var$getSnippetStyles = (overrideCss)=>/*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-text, #172B4D);-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    overrideCss);
const $7f9944feb1da4750$var$SnippetElement = ({ content: overrideContent, maxLines: maxLines = $7f9944feb1da4750$var$SNIPPET_DEFAULT_MAX_LINES, overrideCss: overrideCss, ...props } = {})=>{
    const context = (0, $eUqFw.useContext)((0, $4AAjx.FlexibleUiContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gsehw.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        overrideCss: $7f9944feb1da4750$var$getSnippetStyles(overrideCss),
        ...props
    });
};
var $7f9944feb1da4750$export$2e2bcd8739ae039 = $7f9944feb1da4750$var$SnippetElement;

});


parcelRegister("fNWSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b51d5450dd65dfd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $byn9U = parcelRequire("byn9U");

var $bLFgh = parcelRequire("bLFgh");

var $8cU5f = parcelRequire("8cU5f");

var $6OfWd = parcelRequire("6OfWd");

var $caOA9 = parcelRequire("caOA9");

var $7u4fN = parcelRequire("7u4fN");

var $34Io4 = parcelRequire("34Io4");

var $4z862 = parcelRequire("4z862");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $avp6V = parcelRequire("avp6V");

var $d2BrZ = parcelRequire("d2BrZ");

var $asu8X = parcelRequire("asu8X");
function $7b51d5450dd65dfd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b51d5450dd65dfd$var$styles = {
    name: "inf63k",
    styles: "display:inline-flex;line-height:1rem;> div{align-items:center;button:focus-visible{outline-offset:var(--ds-space-negative-025, -2px);}}"
};
const $7b51d5450dd65dfd$var$renderActionItems = (items = [], size = (0, $caOA9.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $avp6V.default), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $7b51d5450dd65dfd$var$ActionGroup = ({ items: items = [], size: size = (0, $caOA9.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $asu8X.di)((0, $6OfWd.default));
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const ui = (0, $4AAjx.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const renderableActionItems = (0, $eUqFw.useMemo)(()=>(0, $d2BrZ.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $eUqFw.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $eUqFw.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $eUqFw.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $7b51d5450dd65dfd$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $eUqFw.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $4z862.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($34Io4))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).more_actions);
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $6OfWd.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
                        ...props,
                        spacing: spacing,
                        testId: "action-group-more-button",
                        iconBefore: moreIcon,
                        ref: triggerRef
                    })),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex
            }, $7b51d5450dd65dfd$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7b51d5450dd65dfd$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "actions-button-group",
        "data-action-open": isOpen
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bLFgh.default), null, actionButtons, moreActionDropdown)) : null;
};
var $7b51d5450dd65dfd$export$2e2bcd8739ae039 = $7b51d5450dd65dfd$var$ActionGroup;

});
parcelRegister("34Io4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f3e3907f1ddb8ccd2d9276da16185e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23d42d3583f8fd73$var$_react = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $23d42d3583f8fd73$var$_showMoreHorizontal = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("7JXZ0")));

var $23d42d3583f8fd73$var$_more = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("jG1wZ")));
function $23d42d3583f8fd73$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23d42d3583f8fd73$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $23d42d3583f8fd73$var$_react.default.createElement($23d42d3583f8fd73$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $23d42d3583f8fd73$var$_more.default
    }, props));
$23d42d3583f8fd73$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $23d42d3583f8fd73$var$_default = module.exports.default = $23d42d3583f8fd73$var$ShowMoreHorizontalIcon;

});

parcelRegister("avp6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $02b4f62361713a29$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $eJljw = parcelRequire("eJljw");
const $02b4f62361713a29$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $eUqFw.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $eJljw ? $eJljw[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $byn9U.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $02b4f62361713a29$export$2e2bcd8739ae039 = $02b4f62361713a29$var$ActionGroupItem;

});
parcelRegister("eJljw", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("lLAmK")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("6fkrT")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("gui89")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("daPVN")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("iY7WF")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("dDX5p")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("8TjUj")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("e5u7V")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("9QQRq")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("9razy")).default);

var $lLAmK = parcelRequire("lLAmK");

var $6fkrT = parcelRequire("6fkrT");

var $gui89 = parcelRequire("gui89");

var $daPVN = parcelRequire("daPVN");

var $iY7WF = parcelRequire("iY7WF");

var $dDX5p = parcelRequire("dDX5p");

var $8TjUj = parcelRequire("8TjUj");

var $e5u7V = parcelRequire("e5u7V");

var $9QQRq = parcelRequire("9QQRq");

var $9razy = parcelRequire("9razy");

});
parcelRegister("lLAmK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5ab2f99cd527f23$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $27JBd = parcelRequire("27JBd");

var $48lKs = parcelRequire("48lKs");

var $eh8Nz = parcelRequire("eh8Nz");

var $32zsR = parcelRequire("32zsR");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $b5ab2f99cd527f23$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, xcss: xcss, asDropDownItem: asDropDownItem, overrideCss: overrideCss, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon && /*#__PURE__*/ (0, $byn9U.jsx)((0, $32zsR.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    });
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27JBd.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eh8Nz.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $byn9U.jsx)((0, $48lKs.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        overrideCss: overrideCss,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $byn9U.jsx)(Wrapper, null, button) : button;
};
var $b5ab2f99cd527f23$export$2e2bcd8739ae039 = $b5ab2f99cd527f23$var$Action;

});
parcelRegister("27JBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $885b23cdbf468f5a$export$2e2bcd8739ae039);

var $8cU5f = parcelRequire("8cU5f");

var $eUqFw = parcelRequire("eUqFw");

var $cVfTe = parcelRequire("cVfTe");
const $885b23cdbf468f5a$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVfTe.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVfTe.default), {
            ...props,
            content: content,
            tooltipProps: tooltipProps
        }));
var $885b23cdbf468f5a$export$2e2bcd8739ae039 = $885b23cdbf468f5a$var$ActionStackItem;

});
parcelRegister("cVfTe", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f587baae0a0b39b$export$2e2bcd8739ae039);

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $eUqFw = parcelRequire("eUqFw");

var $4z862 = parcelRequire("4z862");

var $32zsR = parcelRequire("32zsR");
const $6f587baae0a0b39b$var$buttonStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    padding: 'space.050',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $6f587baae0a0b39b$var$contentStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    // Replace with font token once it becomes stable (currently alpha)
    // font: 'font.body.small',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px'
});
const $6f587baae0a0b39b$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, xcss: xcss })=>{
    const space = spaceOption ?? (0, $4z862.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $32zsR.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        xcss: [
            $6f587baae0a0b39b$var$buttonStyles,
            xcss
        ],
        ...tooltipProps,
        onClick: onClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        grow: "fill",
        space: space
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6f587baae0a0b39b$var$contentStyles
    }, content))));
};
var $6f587baae0a0b39b$export$2e2bcd8739ae039 = $6f587baae0a0b39b$var$ActionButton;

});
parcelRegister("32zsR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cdb5dc66621388c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");
const $5cdb5dc66621388c$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $5cdb5dc66621388c$var$getIconStyles = (isDisabled)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: isDisabled ? "var(--ds-text-disabled, #6B778C)" : "var(--ds-icon, #44546F)"
    });
const $5cdb5dc66621388c$var$stackItemIconSizeStyles = (0, $4z862.getIconSizeStyles)('20px');
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5cdb5dc66621388c$var$stackItemIconStyles = /*#__PURE__*/ (0, $byn9U.css)($5cdb5dc66621388c$var$stackItemIconSizeStyles, "display:inline-block;line-height:0;padding:var(--ds-space-025, 2px);span,svg,img{line-height:0;}");
const $5cdb5dc66621388c$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $5cdb5dc66621388c$var$getIconStyles(isDisabled),
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            asStackItemIcon ? $5cdb5dc66621388c$var$stackItemIconStyles : (0, $4z862.getIconSizeStyles)($5cdb5dc66621388c$var$getIconWidth(size))
        ],
        "data-testid": `${testId}-icon`
    }, icon);
var $5cdb5dc66621388c$export$2e2bcd8739ae039 = $5cdb5dc66621388c$var$ActionIcon;

});



parcelRegister("48lKs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e93679c6d64657cb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7opLA = parcelRequire("7opLA");

var $8cU5f = parcelRequire("8cU5f");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");
function $e93679c6d64657cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e93679c6d64657cb$var$_ref = {
    name: "kaj2cp",
    styles: "button, button:hover, button:focus, button:active{padding:0;> span{margin:0;}}"
};
const $e93679c6d64657cb$var$getButtonStyle = (size, iconOnly)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).Large:
            return iconOnly ? $e93679c6d64657cb$var$_ref : '';
        case (0, $caOA9.SmartLinkSize).Small:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '0.75rem',
                fontWeight: 500,
                lineHeight: '1rem',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                'button, button:hover, button:focus, button:active': [
                    {
                        lineHeight: '1rem'
                    },
                    iconOnly ? `
            padding: 0.125rem;
          ` : `
            padding-left: 0.25rem;
            padding-right: 0.25rem;
          `
                ]
            });
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Medium:
        default:
            return '';
    }
};
const $e93679c6d64657cb$var$ActionButton = ({ appearance: appearance, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, overrideCss: overrideCss, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eUqFw.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $e93679c6d64657cb$var$getButtonStyle(size, iconOnly),
            overrideCss
        ],
        "data-testid": `${testId}-button-wrapper`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7opLA.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $4z862.sizeToButtonSpacing)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
var $e93679c6d64657cb$export$2e2bcd8739ae039 = $e93679c6d64657cb$var$ActionButton;

});

parcelRegister("eh8Nz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2b98a59bc5a7d99$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $9A6mL = parcelRequire("9A6mL");
const $b2b98a59bc5a7d99$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $9A6mL.handleOnClick)(onClick),
        testId: testId
    }, content);
var $b2b98a59bc5a7d99$export$2e2bcd8739ae039 = $b2b98a59bc5a7d99$var$ActionDropdownItem;

});


parcelRegister("6fkrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2513bc2d127363c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $jWuk1 = parcelRequire("jWuk1");
const $a2513bc2d127363c$var$DeleteAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).delete),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).delete),
        ...props
    });
var $a2513bc2d127363c$export$2e2bcd8739ae039 = $a2513bc2d127363c$var$DeleteAction;

});

parcelRegister("gui89", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a1b155aa63a7698$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $bZ1Zi = parcelRequire("bZ1Zi");
const $6a1b155aa63a7698$var$EditAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).edit),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZ1Zi))), {
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).edit),
        ...props
    });
var $6a1b155aa63a7698$export$2e2bcd8739ae039 = $6a1b155aa63a7698$var$EditAction;

});
parcelRegister("bZ1Zi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b96eef1afb7c03f$var$_react = $8b96eef1afb7c03f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $8b96eef1afb7c03f$var$_edit = $8b96eef1afb7c03f$var$_interopRequireDefault((parcelRequire("e5yQJ")));
function $8b96eef1afb7c03f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8b96eef1afb7c03f$var$EditIcon = (props)=>/*#__PURE__*/ $8b96eef1afb7c03f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $8b96eef1afb7c03f$var$_edit.default
    }));
$8b96eef1afb7c03f$var$EditIcon.displayName = 'EditIcon';
var $8b96eef1afb7c03f$var$_default = module.exports.default = $8b96eef1afb7c03f$var$EditIcon;

});
parcelRegister("e5yQJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32c191357b748545769418a2438f72bf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a41c90bad15a5169$var$_react = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a41c90bad15a5169$var$_UNSAFE_baseNew = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a41c90bad15a5169$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a41c90bad15a5169$var$EditIcon = (props)=>/*#__PURE__*/ $a41c90bad15a5169$var$_react.default.createElement($a41c90bad15a5169$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9m-.75-4 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 8.979 9.521c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$a41c90bad15a5169$var$EditIcon.displayName = 'EditIcon';
var $a41c90bad15a5169$var$_default = module.exports.default = $a41c90bad15a5169$var$EditIcon;

});



parcelRegister("daPVN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f5689d24bc37939$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9A6mL = parcelRequire("9A6mL");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $lLAmK = parcelRequire("lLAmK");

var $4AAjx = parcelRequire("4AAjx");

var $3SJS1 = parcelRequire("3SJS1");

var $i9nBX = parcelRequire("i9nBX");
const $3f5689d24bc37939$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $3SJS1.default)({
        analytics: analytics
    });
    const data = context?.actions?.[(0, $caOA9.ActionName).DownloadAction];
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data?.downloadUrl) {
            invoke({
                actionType: (0, $caOA9.ActionName).DownloadAction,
                actionFn: async ()=>(0, $9A6mL.downloadUrl)(data?.downloadUrl),
                // These values have already been set in analytics context.
                // We only pass these here for ufo experience.
                display: analytics?.display,
                extensionKey: analytics?.extensionKey
            });
            if (onClickCallback) onClickCallback();
        }
    }, [
        analytics,
        data?.downloadUrl,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $4abrz.messages).download_file : (0, $4abrz.messages).download;
    const tooltipMessage = isStackItem ? (0, $4abrz.messages).download_description : (0, $4abrz.messages).download;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), label),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i9nBX))), {
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        ...data,
        ...props
    }) : null;
};
var $3f5689d24bc37939$export$2e2bcd8739ae039 = $3f5689d24bc37939$var$DownloadAction;

});
parcelRegister("3SJS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a127f233fa1a4ad$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $hEsGF = parcelRequire("hEsGF");

var $2cI4y = parcelRequire("2cI4y");
const $5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $5a127f233fa1a4ad$var$useInvokeClientAction = ({ analytics: analytics })=>(0, $eUqFw.useCallback)(async ({ actionType: actionType, actionFn: actionFn, extensionKey: extensionKey, display: display })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $hEsGF.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $2cI4y.startUfoExperience)($5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            analytics?.ui.actionClickedEvent({
                actionType: actionType,
                display: display
            });
            // Invoke action
            const result = await actionFn();
            $hEsGF.mark(markName, 'resolved');
            (0, $2cI4y.succeedUfoExperience)($5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME, experienceId);
            analytics?.operational.invokeSucceededEvent({
                actionType: actionType,
                display: display
            });
            return result;
        } catch (err) {
            $hEsGF.mark(markName, 'errored');
            (0, $2cI4y.failUfoExperience)($5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            analytics?.operational.invokeFailedEvent({
                actionType: actionType,
                display: display,
                reason: reason
            });
        }
    }, [
        analytics?.operational,
        analytics?.ui
    ]);
var $5a127f233fa1a4ad$export$2e2bcd8739ae039 = $5a127f233fa1a4ad$var$useInvokeClientAction;

});

parcelRegister("i9nBX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d36b61f12f7a705f$var$_react = $d36b61f12f7a705f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d36b61f12f7a705f$var$_download = $d36b61f12f7a705f$var$_interopRequireDefault((parcelRequire("9WkaC")));
function $d36b61f12f7a705f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d36b61f12f7a705f$var$DownloadIcon = (props)=>/*#__PURE__*/ $d36b61f12f7a705f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $d36b61f12f7a705f$var$_download.default
    }));
$d36b61f12f7a705f$var$DownloadIcon.displayName = 'DownloadIcon';
var $d36b61f12f7a705f$var$_default = module.exports.default = $d36b61f12f7a705f$var$DownloadIcon;

});
parcelRegister("9WkaC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb1ef1149a66571c4f3afc5dc7ecc365>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73c92d3b66138ed0$var$_react = $73c92d3b66138ed0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $73c92d3b66138ed0$var$_UNSAFE_baseNew = $73c92d3b66138ed0$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $73c92d3b66138ed0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $73c92d3b66138ed0$var$DownloadIcon = (props)=>/*#__PURE__*/ $73c92d3b66138ed0$var$_react.default.createElement($73c92d3b66138ed0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1v8.75m-4-3.5 4 4 4-4"/>`
    }, props));
$73c92d3b66138ed0$var$DownloadIcon.displayName = 'DownloadIcon';
var $73c92d3b66138ed0$var$_default = module.exports.default = $73c92d3b66138ed0$var$DownloadIcon;

});



parcelRegister("iY7WF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4000632475db60c8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $bPnXx = parcelRequire("bPnXx");

var $4z862 = parcelRequire("4z862");

var $5c3rh = parcelRequire("5c3rh");


const $4000632475db60c8$var$importIconMapper = {
    goal: ()=>(parcelRequire("6MTFz")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("aw3dF")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $4000632475db60c8$var$getIcon = (stackIconType)=>{
    const importFn = $4000632475db60c8$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $4z862.importIcon)(importFn);
};
const $4000632475db60c8$var$FollowAction = (props)=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $4abrz.messages).follow : (0, $4abrz.messages).unfollow;
    const projectMessage = value ? (0, $4abrz.messages).follow_project : (0, $4abrz.messages).unfollow_project;
    const goalMessage = value ? (0, $4abrz.messages).follow_goal : (0, $4abrz.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $4abrz.messages).follow_project_description : (0, $4abrz.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $4abrz.messages).follow_goal_description : (0, $4abrz.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $4000632475db60c8$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $5c3rh.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), errorMessage),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bPnXx.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), label),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        ...data,
        ...props,
        onError: handleError
    });
};
var $4000632475db60c8$export$2e2bcd8739ae039 = $4000632475db60c8$var$FollowAction;

});
parcelRegister("bPnXx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee58e6cedb3bfa7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fZ5ue = parcelRequire("fZ5ue");

var $8McbT = parcelRequire("8McbT");

var $af6S8 = parcelRequire("af6S8");

var $201mO = parcelRequire("201mO");

var $lLAmK = parcelRequire("lLAmK");

var $4AAjx = parcelRequire("4AAjx");
const $fee58e6cedb3bfa7$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $fZ5ue.default)();
    const reload = (0, $af6S8.default)();
    const handleClick = (0, $eUqFw.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                analytics?.ui.smartLinkServerActionClickedEvent({
                    smartLinkActionType: smartLinkActionType
                });
                analytics?.track.smartLinkQuickActionStarted({
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $201mO.default)(action);
                await invoke(request);
                analytics?.track.smartLinkQuickActionSuccess({
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                analytics?.track.smartLinkQuickActionFailed({
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $8McbT.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        analytics?.track,
        analytics?.ui,
        invoke,
        onClick,
        onErrorCallback,
        reload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $fee58e6cedb3bfa7$export$2e2bcd8739ae039 = $fee58e6cedb3bfa7$var$ServerAction;

});
parcelRegister("201mO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b51aec3ddbd0b82b$export$2e2bcd8739ae039);
const $b51aec3ddbd0b82b$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $b51aec3ddbd0b82b$export$2e2bcd8739ae039 = $b51aec3ddbd0b82b$var$createInvokeRequest;

});


parcelRegister("5c3rh", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $caf136fdee970c8a$export$49248678d3914625);

var $4abrz = parcelRequire("4abrz");
const $caf136fdee970c8a$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $4abrz.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $4abrz.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $4abrz.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $4abrz.messages).unfollow_goal_error;
    return (0, $4abrz.messages).generic_error_message;
};

});

parcelRegister("6MTFz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kGvxd").then(()=>parcelRequire('hSFb0'));

});

parcelRegister("aw3dF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2WhTq").then(()=>parcelRequire('9dFQg'));

});


parcelRegister("dDX5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $e249092d4fa8c714$export$2e2bcd8739ae039);

var $22LS1 = parcelRequire("22LS1");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $3SJS1 = parcelRequire("3SJS1");

var $4z862 = parcelRequire("4z862");

var $lLAmK = parcelRequire("lLAmK");
const $e249092d4fa8c714$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $3SJS1.default)({
        analytics: analytics
    });
    const data = context?.actions?.[(0, $caOA9.ActionName).PreviewAction];
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data) invoke({
            actionType: (0, $caOA9.ActionName).PreviewAction,
            actionFn: async ()=>(0, $4z862.openEmbedModalWithFlexibleUiIcon)({
                    download: data?.downloadUrl,
                    extensionKey: analytics?.extensionKey,
                    analytics: analytics,
                    ...data
                }),
            // These values have already been set in analytics context.
            // We only pass these here for ufo experience.
            display: analytics?.display,
            extensionKey: analytics?.extensionKey
        });
        if (onClickCallback) onClickCallback();
    }, [
        analytics,
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $4abrz.messages).preview_description : (0, $4abrz.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).preview_improved),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-20003
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($22LS1))), {
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $e249092d4fa8c714$export$2e2bcd8739ae039 = $e249092d4fa8c714$var$PreviewAction;

});
parcelRegister("22LS1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17d0e6b497755428$var$_react = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $17d0e6b497755428$var$_growDiagonal = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("8TYN8")));
function $17d0e6b497755428$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $17d0e6b497755428$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $17d0e6b497755428$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $17d0e6b497755428$var$_growDiagonal.default
    }));
$17d0e6b497755428$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $17d0e6b497755428$var$_default = module.exports.default = $17d0e6b497755428$var$MediaServicesActualSizeIcon;

});
parcelRegister("8TYN8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7a69662d7c3f46d3a483d39154b3f1d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67b29db82a7ea305$var$_react = $67b29db82a7ea305$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $67b29db82a7ea305$var$_UNSAFE_baseNew = $67b29db82a7ea305$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $67b29db82a7ea305$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $67b29db82a7ea305$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $67b29db82a7ea305$var$_react.default.createElement($67b29db82a7ea305$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
    }, props));
$67b29db82a7ea305$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $67b29db82a7ea305$var$_default = module.exports.default = $67b29db82a7ea305$var$GrowDiagonalIcon;

});



parcelRegister("8TjUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c2597fe5d03e9fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $hUwRB = parcelRequire("hUwRB");

var $4AAjx = parcelRequire("4AAjx");

var $caOA9 = parcelRequire("caOA9");

var $3SJS1 = parcelRequire("3SJS1");
const $8c2597fe5d03e9fc$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $3SJS1.default)({
        analytics: analytics
    });
    const data = context?.actions?.[(0, $caOA9.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $eUqFw.useState)((0, $4abrz.messages).copy_url_to_clipboard);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data && data.url) invoke({
            actionType: (0, $caOA9.ActionName).CopyLinkAction,
            actionFn: async ()=>{
                await navigator.clipboard.writeText(data.url ?? '');
                setTooltipMessage((0, $4abrz.messages).copied_url_to_clipboard);
            },
            // These values have already been set in analytics context.
            // We only pass these here for ufo experience.
            display: analytics?.display,
            extensionKey: analytics?.extensionKey
        });
        if (onClickCallback) onClickCallback();
    }, [
        analytics,
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).copy_url_to_clipboard),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
            label: "copy url",
            size: "medium"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $4abrz.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $8c2597fe5d03e9fc$export$2e2bcd8739ae039 = $8c2597fe5d03e9fc$var$CopyLinkAction;

});

parcelRegister("e5u7V", function(module, exports) {

$parcel$export(module.exports, "default", () => $911fbb2dd20043a1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4AAjx = parcelRequire("4AAjx");

var $caOA9 = parcelRequire("caOA9");

var $47wdF = parcelRequire("47wdF");
const $911fbb2dd20043a1$var$AISummaryAction = (props)=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $47wdF.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $911fbb2dd20043a1$export$2e2bcd8739ae039 = $911fbb2dd20043a1$var$AISummaryAction;

});
parcelRegister("47wdF", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $b6dae4aa0e47e00e$export$8eed96bc6d982595);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $04PAQ = parcelRequire("04PAQ");

var $b8pNE = parcelRequire("b8pNE");

var $5UoQc = parcelRequire("5UoQc");
const $b6dae4aa0e47e00e$export$8eed96bc6d982595 = (props)=>{
    (0, $asu8X.di)((0, $04PAQ.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $04PAQ.default)(url);
    (0, $eUqFw.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b8pNE.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5UoQc.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("04PAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $060f4b6c56808cdc$export$2e2bcd8739ae039);

var $1qrFi = parcelRequire("1qrFi");
var $lnW6z = parcelRequire("lnW6z");

var $eUqFw = parcelRequire("eUqFw");

var $45sl7 = parcelRequire("45sl7");

var $2cI4y = parcelRequire("2cI4y");

var $b81Yi = parcelRequire("b81Yi");

var $jOo8k = parcelRequire("jOo8k");

var $8ru2D = parcelRequire("8ru2D");
const $060f4b6c56808cdc$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $060f4b6c56808cdc$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $8ru2D.useAISummaryConfig)();
    const cardState = (0, $b81Yi.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $1qrFi.extractAri)(data);
    const dataUrl = data && (0, $lnW6z.extractLink)(data) || '';
    const onStart = (0, $eUqFw.useCallback)((id)=>{
        (0, $2cI4y.startUfoExperience)($060f4b6c56808cdc$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $eUqFw.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $2cI4y.succeedUfoExperience)($060f4b6c56808cdc$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $eUqFw.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $2cI4y.failUfoExperience)($060f4b6c56808cdc$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $jOo8k.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $060f4b6c56808cdc$export$2e2bcd8739ae039 = $060f4b6c56808cdc$var$useAISummaryAction;

});
parcelRegister("1qrFi", function(module, exports) {

$parcel$export(module.exports, "extractAri", () => $719f58b8f5cece0a$export$be18a6294fd426ec);
const $719f58b8f5cece0a$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
};

});

parcelRegister("lnW6z", function(module, exports) {

$parcel$export(module.exports, "extractLink", () => $798276e7999c5211$export$63f54cf4c5883620);

var $9W7HP = parcelRequire("9W7HP");
const $798276e7999c5211$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $9W7HP.extractUrlFromLinkJsonLd)(url);
    }
};

});
parcelRegister("9W7HP", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65);
const $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("45sl7", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $20285615fd58f92d$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::3fdfbbdbdb062babb9a2ab4e53454d79>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");


var $dHNAr = parcelRequire("dHNAr");
const $20285615fd58f92d$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireEvent = (0, $eUqFw.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $dHNAr.default)(...params));
        event.fire((0, $1695fa5341c6d031$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $1695fa5341c6d031$export$3f072f06b90c3985 = 'media';

parcelRegister("dHNAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd9d05577ac8ffe9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::0d08fdca953a1eb1130683499e509165>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $dd9d05577ac8ffe9$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $dd9d05577ac8ffe9$export$2e2bcd8739ae039 = $dd9d05577ac8ffe9$var$createEventPayload;

});


parcelRegister("b81Yi", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $e9516c66fbd4716f$export$b0444d00ba7313c6);

var $awFmn = parcelRequire("awFmn");

var $gqldc = parcelRequire("gqldc");
const $e9516c66fbd4716f$var$PENDING_STATE = {
    status: 'pending'
};
function $e9516c66fbd4716f$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $gqldc.useSmartLinkContext)();
    const cardState = (0, $awFmn.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $e9516c66fbd4716f$var$PENDING_STATE;
}

});

parcelRegister("jOo8k", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $8e7665aa4bc9eed3$export$becd8f2eba1bbd96);

var $eUqFw = parcelRequire("eUqFw");

var $iThCc = parcelRequire("iThCc");

var $96eVN = parcelRequire("96eVN");
const $8e7665aa4bc9eed3$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $eUqFw.useState)((0, $iThCc.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    (0, $eUqFw.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $iThCc.AISummariesStore).get(url)) (0, $iThCc.AISummariesStore).set(url, new (0, $96eVN.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $iThCc.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey
    ]);
    const summariseUrl = ()=>{
        return (0, $iThCc.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("iThCc", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $a00dd5447fec502f$export$6979339b6d41707e);

var $6roQF = parcelRequire("6roQF");
const $a00dd5447fec502f$var$AI_SUMMARY_CACHE_SIZE = 100;
const $a00dd5447fec502f$export$6979339b6d41707e = new (0, $6roQF.LRUMap)($a00dd5447fec502f$var$AI_SUMMARY_CACHE_SIZE);

});

parcelRegister("96eVN", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $4ceaf946d9c480f1$export$73e4b807d5bd74b6);

var $hompL = parcelRequire("hompL");

var $906lw = parcelRequire("906lw");

var $7h3kH = parcelRequire("7h3kH");

var $03QE9 = parcelRequire("03QE9");

var $dUrSu = parcelRequire("dUrSu");
class $4ceaf946d9c480f1$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $dUrSu.getBaseUrl)(envKey);
                return (0, $7h3kH.addPath)(baseUrl, path);
            }
            return (0, $7h3kH.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown'
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $03QE9.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $7h3kH.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new Error(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof Error && this.isExpectedError(err.message) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    isExpectedError(value) {
        return typeof value === 'string' && (0, $906lw.errorMessages).some((a)=>a === value);
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("906lw", function(module, exports) {

$parcel$export(module.exports, "errorMessages", () => $5cf044834cb63238$export$d8bd0967cb58683);
const $5cf044834cb63238$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});

parcelRegister("7h3kH", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $b6cc5b1d42af4557$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $b6cc5b1d42af4557$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $b6cc5b1d42af4557$export$ff2962de2b2c930f);
const $b6cc5b1d42af4557$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $b6cc5b1d42af4557$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $b6cc5b1d42af4557$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $b6cc5b1d42af4557$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $b6cc5b1d42af4557$export$ff2962de2b2c930f = (product)=>{
    if ($b6cc5b1d42af4557$var$isJiraProduct(product)) return $b6cc5b1d42af4557$var$AiMateJiraXProduct[product];
    return product;
};

});

parcelRegister("03QE9", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $8a24a33dc932f4e5$export$e45226161c660403);

var $7h3kH = parcelRequire("7h3kH");
async function* $8a24a33dc932f4e5$export$e45226161c660403(response) {
    const reader = (0, $7h3kH.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});



parcelRegister("8ru2D", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $4403e58f54b47af1$export$4480af2c00aa7ebe);

var $gqldc = parcelRequire("gqldc");

var $eUqFw = parcelRequire("eUqFw");
const $4403e58f54b47af1$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $gqldc.useSmartLinkContext)();
    return (0, $eUqFw.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("b8pNE", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $42b519d5e1f81e55$export$cfa1d3eed9a61059);

var $eUqFw = parcelRequire("eUqFw");

var $dmCPj = parcelRequire("dmCPj");

var $8uD7Y = parcelRequire("8uD7Y");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $45sl7 = parcelRequire("45sl7");
function $42b519d5e1f81e55$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $eUqFw.useState)((0, $4abrz.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $eUqFw.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $4abrz.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).copy_summary_action),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), {
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $4abrz.messages).copy_summary_action_description),
        ...props
    });
}

});

parcelRegister("5UoQc", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $0bc861f7676c4d20$export$75a19de44af58722);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $lLAmK = parcelRequire("lLAmK");

var $fN7pY = parcelRequire("fN7pY");

var $4abrz = parcelRequire("4abrz");

var $45sl7 = parcelRequire("45sl7");

var $exKwM = parcelRequire("exKwM");
function $0bc861f7676c4d20$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const onCompleted = (0, $eUqFw.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $exKwM.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $eUqFw.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).ai_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fN7pY.default), {
            label: "Summarise with AI"
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).ai_summary_action_description),
        ...props
    });
}

});
parcelRegister("fN7pY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c379c2d8e36be306$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $c379c2d8e36be306$var$AiIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: "var(--ds-icon, #44546F)"
    })));
var $c379c2d8e36be306$export$2e2bcd8739ae039 = $c379c2d8e36be306$var$AiIcon;

});

parcelRegister("exKwM", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $7d236111ed75f623$export$82f46aa4e6535a45);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hZwiw = parcelRequire("hZwiw");

var $bJ9S9 = parcelRequire("bJ9S9");

var $fv3b5 = parcelRequire("fv3b5");
const $7d236111ed75f623$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $hZwiw.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bJ9S9.default), {
            reason: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...message,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fv3b5.default), {
                        href: url
                    }, chunks)
            }
        }))
    };
};

});
parcelRegister("hZwiw", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $13fbd6746cda9c21$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $13fbd6746cda9c21$export$cd2e891d7f87074d);

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");
const $13fbd6746cda9c21$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $13fbd6746cda9c21$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $4abrz.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $caOA9.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $4abrz.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $4abrz.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $4abrz.messages).ai_summary_error_generic,
                url: (0, $caOA9.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("bJ9S9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f231676b33723539$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $45sl7 = parcelRequire("45sl7");
const $f231676b33723539$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $f231676b33723539$export$2e2bcd8739ae039 = $f231676b33723539$var$AIEventErrorViewed;

});

parcelRegister("fv3b5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ed25baefb28285c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");
const $0ed25baefb28285c$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: (0, $caOA9.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props
    }, children);
var $0ed25baefb28285c$export$2e2bcd8739ae039 = $0ed25baefb28285c$var$AILearnMoreAnchor;

});





parcelRegister("9QQRq", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f1aac8212e0f674$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jgpX5 = parcelRequire("jgpX5");

var $lLAmK = parcelRequire("lLAmK");

var $4AAjx = parcelRequire("4AAjx");

var $iNbFo = parcelRequire("iNbFo");

var $45sl7 = parcelRequire("45sl7");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $1tnZc = parcelRequire("1tnZc");

const $8f1aac8212e0f674$var$AutomationModal = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("aDQEB")));
const $8f1aac8212e0f674$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const modal = (0, $iNbFo.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $caOA9.ActionName).AutomationAction];
    const automationActionOnClick = (0, $eUqFw.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $1tnZc.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), modalTitle) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f1aac8212e0f674$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).automation_action_title);
    const automationActionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).automation_action_tooltip);
    const automationActionIconLabel = formatMessage((0, $4abrz.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: automationActionTitle,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jgpX5.default), {
            label: automationActionIconLabel
        }),
        testId: "smart-action-automation-action",
        tooltipMessage: automationActionTooltip,
        ...props,
        onClick: ()=>automationActionOnClick(automationActionData)
    }));
};
var $8f1aac8212e0f674$export$2e2bcd8739ae039 = $8f1aac8212e0f674$var$AutomationAction;

});
parcelRegister("jgpX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbd431ca61fafd84$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbd431ca61fafd84$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
var $bbd431ca61fafd84$export$2e2bcd8739ae039 = $bbd431ca61fafd84$var$AutomationManualTriggersGlyph;

});

parcelRegister("iNbFo", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $6a9669e2457be519$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $6a9669e2457be519$export$1fd7f5f21a6d6cb8);

var $eUqFw = parcelRequire("eUqFw");

var $jb3WS = parcelRequire("jb3WS");

var $4kwA4 = parcelRequire("4kwA4");
const $6a9669e2457be519$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $6a9669e2457be519$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($6a9669e2457be519$var$FALLBACK_API);
const $6a9669e2457be519$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $eUqFw.useState)(null);
    const api = (0, $eUqFw.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kwA4.StopPropagation), null, modal))),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $eUqFw.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $eUqFw.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a9669e2457be519$export$f4c0a0f23ba57f8c.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
        fallbackRender: fallbackRender,
        onReset: onReset
    }, element));
};
const $6a9669e2457be519$export$1fd7f5f21a6d6cb8 = ()=>(0, $eUqFw.useContext)($6a9669e2457be519$export$f4c0a0f23ba57f8c);

});
parcelRegister("4kwA4", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $7985491467a1c6bf$export$3e100bc08448f36c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");
function $7985491467a1c6bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7985491467a1c6bf$var$styles = {
    name: "g32yti",
    styles: "max-height:0;max-width:0;position:absolute"
};
const $7985491467a1c6bf$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $eUqFw.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $7985491467a1c6bf$var$styles,
        onClick: onClick
    }, children);
};

});


parcelRegister("1tnZc", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $15c366388beaffc3$export$93e707b363eaf5c8);

var $4abrz = parcelRequire("4abrz");
const $15c366388beaffc3$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $4abrz.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $4abrz.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("aDQEB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hKMCy")
]).then(()=>parcelRequire('lRKyt'));

});


parcelRegister("9razy", function(module, exports) {

$parcel$export(module.exports, "default", () => $10dd6358c7ba1901$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lLAmK = parcelRequire("lLAmK");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $bP3BY = parcelRequire("bP3BY");

var $eUqFw = parcelRequire("eUqFw");

var $iNbFo = parcelRequire("iNbFo");

var $45sl7 = parcelRequire("45sl7");

const $10dd6358c7ba1901$var$RelatedLinksModal = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("dbUjg")));
const $10dd6358c7ba1901$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $iNbFo.useSmartLinkModal)();
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $byn9U.jsx)($10dd6358c7ba1901$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).related_links_view_related_urls),
        icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, $bP3BY.default), null),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $10dd6358c7ba1901$export$2e2bcd8739ae039 = $10dd6358c7ba1901$var$ViewRelatedLinksAction;

});
parcelRegister("bP3BY", function(module, exports) {

$parcel$export(module.exports, "default", () => $091bd7b6fd540225$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jfQfF = parcelRequire("jfQfF");
function $091bd7b6fd540225$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $091bd7b6fd540225$var$rotateSvg = {
    name: "9v7l5f",
    styles: "transform:rotate(180deg);display:inline-block"
};
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $091bd7b6fd540225$var$RelatedLinksActionIcon = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $091bd7b6fd540225$var$rotateSvg
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jfQfF))), {
        label: "View recent links..."
    }));
var $091bd7b6fd540225$export$2e2bcd8739ae039 = $091bd7b6fd540225$var$RelatedLinksActionIcon;

});
parcelRegister("jfQfF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e047f322faad4563$var$_react = $e047f322faad4563$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e047f322faad4563$var$_childIssues = $e047f322faad4563$var$_interopRequireDefault((parcelRequire("hudZr")));
function $e047f322faad4563$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e047f322faad4563$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $e047f322faad4563$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $e047f322faad4563$var$_childIssues.default
    }));
$e047f322faad4563$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $e047f322faad4563$var$_default = module.exports.default = $e047f322faad4563$var$ChildIssuesIcon;

});
parcelRegister("hudZr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84cbfeef7a88f21c194aee533f5af188>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbb01725e51449c9$var$_react = $cbb01725e51449c9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cbb01725e51449c9$var$_UNSAFE_baseNew = $cbb01725e51449c9$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cbb01725e51449c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cbb01725e51449c9$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $cbb01725e51449c9$var$_react.default.createElement($cbb01725e51449c9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 12.25v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0H3c-.69 0-1.25-.56-1.25-1.25V5.25m0-4.25v4.25m6 0v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0h-6"/>`
    }, props));
$cbb01725e51449c9$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $cbb01725e51449c9$var$_default = module.exports.default = $cbb01725e51449c9$var$ChildIssuesIcon;

});



parcelRegister("dbUjg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("e8loy")
]).then(()=>parcelRequire('ixfFh'));

});




parcelRegister("d2BrZ", function(module, exports) {

$parcel$export(module.exports, "getGapSize", () => $8ab32f415250f7e3$export$ff20be09ae01c52e);
$parcel$export(module.exports, "getBaseStyles", () => $8ab32f415250f7e3$export$bff8031d86bb089);
$parcel$export(module.exports, "highlightRemoveStyles", () => $8ab32f415250f7e3$export$1928241a6f267c0d);
$parcel$export(module.exports, "getActionGroupStyles", () => $8ab32f415250f7e3$export$393b0054595c3748);
$parcel$export(module.exports, "filterActionItems", () => $8ab32f415250f7e3$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $8ab32f415250f7e3$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $8ab32f415250f7e3$export$9678d3ca18bd7526);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $bampN = parcelRequire("bampN");

var $6oJXW = parcelRequire("6oJXW");

var $fNWSr = parcelRequire("fNWSr");

var $7GItJ = parcelRequire("7GItJ");
function $8ab32f415250f7e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ab32f415250f7e3$export$f942619ce67b1a41 = {
    [(0, $caOA9.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Location]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Preview]: [
        'block'
    ],
    [(0, $caOA9.ElementName).Priority]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Provider]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Snippet]: [
        'block'
    ],
    [(0, $caOA9.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).State]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Title]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).VoteCount]: [
        'inline'
    ]
};
var $8ab32f415250f7e3$var$_ref2 = {
    name: "2rtvke",
    styles: "flex-direction:row;align-items:center"
};
var $8ab32f415250f7e3$var$_ref3 = {
    name: "1ejri1g",
    styles: "flex-direction:column;align-items:flex-start"
};
const $8ab32f415250f7e3$var$getDirectionStyles = (direction)=>{
    switch(direction){
        case (0, $caOA9.SmartLinkDirection).Vertical:
            return $8ab32f415250f7e3$var$_ref3;
        case (0, $caOA9.SmartLinkDirection).Horizontal:
        default:
            return $8ab32f415250f7e3$var$_ref2;
    }
};
const $8ab32f415250f7e3$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $caOA9.SmartLinkSize).Large:
            return 1;
        case (0, $caOA9.SmartLinkSize).Medium:
            return 0.5;
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $8ab32f415250f7e3$export$bff8031d86bb089 = (direction, size)=>/*#__PURE__*/ (0, $byn9U.css)({
        alignItems: 'center',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gap: `${$8ab32f415250f7e3$export$ff20be09ae01c52e(size)}rem`,
        lineHeight: '1rem',
        minWidth: 0,
        overflow: 'hidden'
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $8ab32f415250f7e3$var$getDirectionStyles(direction), "&:empty{display:none;}& > *{min-width:0;}& > [data-fit-to-content]{min-width:fit-content;}");
const $8ab32f415250f7e3$export$1928241a6f267c0d = {
    name: "1klm9nt",
    styles: "outline:none!important;outline-color:inherit;color:inherit;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none"
};
const $8ab32f415250f7e3$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $fNWSr.default);
const $8ab32f415250f7e3$var$isElementDisplayValid = (name, display)=>{
    return $8ab32f415250f7e3$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $8ab32f415250f7e3$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $8ab32f415250f7e3$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && ((0, $6oJXW.isFlexibleUiElement)(node) || node.type === (0, $7GItJ.default));
var $8ab32f415250f7e3$var$_ref = {
    name: "bceqwf",
    styles: "max-height:2rem"
};
const $8ab32f415250f7e3$export$393b0054595c3748 = (size)=>{
    if (size === (0, $caOA9.SmartLinkSize).XLarge) // The biggest height of the action button exceeds the max line-height
    // of the elements causing the action on the block with x-large size to
    // get cut at the bottom.
    return $8ab32f415250f7e3$var$_ref;
};
const $8ab32f415250f7e3$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $caOA9.ActionName).DeleteAction:
            case (0, $caOA9.ActionName).EditAction:
            case (0, $caOA9.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $caOA9.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $8ab32f415250f7e3$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (child)=>{
        if ($8ab32f415250f7e3$var$isElementOrElementGroup(child) || $8ab32f415250f7e3$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $8ab32f415250f7e3$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $bampN[name];
        const typedProps = props;
        if (Element && $8ab32f415250f7e3$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Element, {
                key: idx,
                ...typedProps
            });
            if (!$8ab32f415250f7e3$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("7GItJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef467f6c35c7534c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");

var $4z862 = parcelRequire("4z862");
function $ef467f6c35c7534c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ef467f6c35c7534c$var$_ref = {
    name: "3l7cjm",
    styles: "-webkit-box-align:start;-ms-flex-align:start;justify-content:flex-start;text-align:left"
};
var $ef467f6c35c7534c$var$_ref2 = {
    name: "1ofqdyp",
    styles: "-webkit-box-align:end;-ms-flex-align:end;justify-content:flex-end;text-align:right"
};
const $ef467f6c35c7534c$var$getAlignmentStyles = (align)=>{
    switch(align){
        case (0, $caOA9.SmartLinkAlignment).Right:
            return $ef467f6c35c7534c$var$_ref2;
        case (0, $caOA9.SmartLinkAlignment).Left:
        default:
            return $ef467f6c35c7534c$var$_ref;
    }
};
const $ef467f6c35c7534c$var$getGapStyles = (size, align)=>{
    const gap = (0, $d2BrZ.getGapSize)(size);
    if (align === (0, $caOA9.SmartLinkAlignment).Right) return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginLeft: `${gap}rem`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> span:first-child': {
            marginLeft: 'initial'
        }
    });
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginRight: `${gap}rem`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:last-child': {
                marginRight: 'initial'
            }
        }
    });
};
const $ef467f6c35c7534c$var$getHorizontalDirectionStyles = (size, align)=>{
    const lineHeight = (0, $4z862.getMaxLineHeight)(size);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)("display:block;vertical-align:middle;", (0, $4z862.getTruncateStyles)(1, lineHeight + 'rem'), ">span,>div{vertical-align:middle;&[data-smart-element-date-time],&[data-smart-element-text]{display:inline;}}", $ef467f6c35c7534c$var$getGapStyles(size, align), ";");
};
const $ef467f6c35c7534c$export$91d118d179d992a4 = (direction, size, align, width, position)=>/*#__PURE__*/ (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $d2BrZ.getBaseStyles)(direction, size), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ef467f6c35c7534c$var$getAlignmentStyles(align), "min-width:10%;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    width === (0, $caOA9.SmartLinkWidth).Flexible ? `flex: 1 3;` : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    direction === (0, $caOA9.SmartLinkDirection).Horizontal ? $ef467f6c35c7534c$var$getHorizontalDirectionStyles(size, align) : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    position === (0, $caOA9.SmartLinkPosition).Top ? 'align-self: flex-start;' : '');
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $ef467f6c35c7534c$var$ElementGroup = ({ align: align = (0, $caOA9.SmartLinkAlignment).Left, children: children, overrideCss: overrideCss, direction: direction = (0, $caOA9.SmartLinkDirection).Horizontal, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $caOA9.SmartLinkWidth).FitToContent, position: position = (0, $caOA9.SmartLinkPosition).Center })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $ef467f6c35c7534c$export$91d118d179d992a4(direction, size, align, width, position),
            overrideCss
        ],
        "data-smart-element-group": true,
        "data-testid": testId
    }, (0, $d2BrZ.renderChildren)(children, size));
var $ef467f6c35c7534c$export$2e2bcd8739ae039 = $ef467f6c35c7534c$var$ElementGroup;

});



parcelRegister("4sQhG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2059b5fdc19a0897$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");
const $2059b5fdc19a0897$var$getBlockStyles = (direction, size)=>/*#__PURE__*/ (0, $byn9U.css)((0, $d2BrZ.getBaseStyles)(direction, size), " ", (0, $d2BrZ.highlightRemoveStyles), " justify-content:flex-start;[data-separator]+[data-separator]:before{content:'\u2022';margin-right:", (0, $d2BrZ.getGapSize)(size), "rem;}[data-smart-element='", (0, $caOA9.ElementName).SourceBranch, "']+[data-smart-element='", (0, $caOA9.ElementName).TargetBranch, "']:before{content:'\u2192';}[data-smart-element='", (0, $caOA9.ElementName).TargetBranch, "']+[data-smart-element='", (0, $caOA9.ElementName).SourceBranch, "']:before{content:'\u2190';}");
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $2059b5fdc19a0897$var$Block = ({ children: children, direction: direction = (0, $caOA9.SmartLinkDirection).Horizontal, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-block', overrideCss: overrideCss, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd })=>{
    (0, $eUqFw.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $2059b5fdc19a0897$var$getBlockStyles(direction, size),
            overrideCss
        ],
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef
    }, (0, $d2BrZ.renderChildren)(children, size));
};
var $2059b5fdc19a0897$export$2e2bcd8739ae039 = $2059b5fdc19a0897$var$Block;

});



parcelRegister("cIk4w", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fdb61e49b433fdb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");

var $4sQhG = parcelRequire("4sQhG");

var $7GItJ = parcelRequire("7GItJ");

var $4z862 = parcelRequire("4z862");
const $6fdb61e49b433fdb$var$DEFAULT_MAX_LINES = 2;
const $6fdb61e49b433fdb$var$MAXIMUM_MAX_LINES = 2;
const $6fdb61e49b433fdb$var$MINIMUM_MAX_LINES = 1;
const $6fdb61e49b433fdb$var$getElementGroupStyles = (size, maxLines)=>{
    // MetadataBlock allows metadata elements to be displayed in
    // multiple lines, with maximum of 2 lines.
    // We need the height of the line to be equal on both left and right
    // sides so they line up nicely.
    const lineHeight = (0, $4z862.getMaxLineHeight)(size);
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: `${lineHeight}rem`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines, lineHeight + 'rem'));
};
const $6fdb61e49b433fdb$var$getMaxLines = (maxLines)=>{
    if (maxLines > $6fdb61e49b433fdb$var$MAXIMUM_MAX_LINES) return $6fdb61e49b433fdb$var$DEFAULT_MAX_LINES;
    if (maxLines < $6fdb61e49b433fdb$var$MINIMUM_MAX_LINES) return $6fdb61e49b433fdb$var$MINIMUM_MAX_LINES;
    return maxLines;
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $6fdb61e49b433fdb$var$MetadataBlock = ({ maxLines: maxLines = $6fdb61e49b433fdb$var$DEFAULT_MAX_LINES, status: status = (0, $caOA9.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $caOA9.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $d2BrZ.renderElementItems)(primary);
    const secondaryElements = (0, $d2BrZ.renderElementItems)(secondary);
    const { size: size = (0, $caOA9.SmartLinkSize).Medium } = blockProps;
    const elementGroupStyles = $6fdb61e49b433fdb$var$getElementGroupStyles(size, $6fdb61e49b433fdb$var$getMaxLines(maxLines));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, primaryElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        align: (0, $caOA9.SmartLinkAlignment).Left,
        overrideCss: elementGroupStyles,
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        width: (0, $caOA9.SmartLinkWidth).Flexible
    }, primaryElements), secondaryElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        align: (0, $caOA9.SmartLinkAlignment).Right,
        overrideCss: elementGroupStyles,
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        width: (0, $caOA9.SmartLinkWidth).Flexible
    }, secondaryElements));
};
var $6fdb61e49b433fdb$export$2e2bcd8739ae039 = $6fdb61e49b433fdb$var$MetadataBlock;

});

parcelRegister("d9NWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0f26c88235b3036$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $l5CPU = parcelRequire("l5CPU");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $f0f26c88235b3036$var$PreviewBlock = ({ status: status = (0, $caOA9.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $l5CPU.default), {
        ...blockProps,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $f0f26c88235b3036$export$2e2bcd8739ae039 = $f0f26c88235b3036$var$PreviewBlock;

});
parcelRegister("l5CPU", function(module, exports) {

$parcel$export(module.exports, "default", () => $895a212ba51d5e0c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $4sQhG = parcelRequire("4sQhG");

var $2mW0Z = parcelRequire("2mW0Z");
function $895a212ba51d5e0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Due to its placement on the left/right and ignoreContainerPadding prop
 * rely on its parent container styling, css variables are declared in
 * <Container /> to preset the base values for the preview block styling.
 *
 * `--container-padding` is the padding of the Container. This value is based
 *   on size and hidePadding.
 * `--container-gap-left` and `--container-gap-right` are the gap or padding of
 *   the Container depending on whether the container has other preview blocks
 *   with left/right positioning.
 * `--preview-block-width` is the size of the preview image in relation to
 *   the Container width when the placement is left/right.
 * @param placement
 * @param ignoreContainerPadding
 */ var $895a212ba51d5e0c$var$_ref = {
    name: "ooh6hm",
    styles: "margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1);&:first-of-type{margin-top:calc(var(--container-padding) * -1);}&:last-of-type{margin-bottom:calc(var(--container-padding) * -1);}"
};
const $895a212ba51d5e0c$var$getPreviewBlockStyles = (placement, ignoreContainerPadding)=>{
    if (placement === (0, $caOA9.MediaPlacement).Left || placement === (0, $caOA9.MediaPlacement).Right) {
        const containerPadding = ignoreContainerPadding ? '0rem' : 'var(--container-padding)';
        // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $byn9U.css)("position:absolute;top:", containerPadding, ";bottom:", containerPadding, ";width:calc(var(--preview-block-width) - ", containerPadding, ");", placement === (0, $caOA9.MediaPlacement).Left ? `left: ${containerPadding};` : '', " ", placement === (0, $caOA9.MediaPlacement).Right ? `right: ${containerPadding};` : '', " [data-smart-element-media='image']{aspect-ratio:unset;padding-top:unset;width:100%;height:100%;object-fit:cover;}");
    }
    if (ignoreContainerPadding) return $895a212ba51d5e0c$var$_ref;
};
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $895a212ba51d5e0c$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, overrideCss: overrideCss, placement: placement, testId: testId, overrideUrl: overrideUrl, ...blockProps })=>{
    const [styles, setStyles] = (0, $eUqFw.useState)(overrideCss);
    const updateStyles = (0, $eUqFw.useCallback)(()=>{
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        setStyles(/*#__PURE__*/ (0, $byn9U.css)($895a212ba51d5e0c$var$getPreviewBlockStyles(placement, ignoreContainerPadding), overrideCss));
    }, [
        ignoreContainerPadding,
        overrideCss,
        placement
    ]);
    (0, $eUqFw.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        overrideCss,
        placement,
        updateStyles
    ]);
    const handleOnLoad = (0, $eUqFw.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $eUqFw.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4sQhG.default), {
        ...blockProps,
        overrideCss: styles,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2mW0Z.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
var $895a212ba51d5e0c$export$2e2bcd8739ae039 = $895a212ba51d5e0c$var$PreviewBlockResolvedView;

});


parcelRegister("bTLTu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c244300e3064a1f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4sQhG = parcelRequire("4sQhG");

var $caOA9 = parcelRequire("caOA9");

var $jtGWU = parcelRequire("jtGWU");

var $4z862 = parcelRequire("4z862");
const $2c244300e3064a1f$var$DEFAULT_MAX_LINES = 3;
const $2c244300e3064a1f$var$MAXIMUM_MAX_LINES = 6;
const $2c244300e3064a1f$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $2c244300e3064a1f$var$SnippetBlock = ({ maxLines: maxLines = $2c244300e3064a1f$var$DEFAULT_MAX_LINES, status: status = (0, $caOA9.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $4z862.getMaxLines)(maxLines, $2c244300e3064a1f$var$DEFAULT_MAX_LINES, $2c244300e3064a1f$var$MAXIMUM_MAX_LINES, $2c244300e3064a1f$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-${statusTestId}-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtGWU.default), {
        maxLines: snippetMaxLines,
        content: text
    }));
};
var $2c244300e3064a1f$export$2e2bcd8739ae039 = $2c244300e3064a1f$var$SnippetBlock;

});

parcelRegister("4bEHq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d96c71ded8e60f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8sbpW = parcelRequire("8sbpW");

var $caOA9 = parcelRequire("caOA9");

var $dKmeE = parcelRequire("dKmeE");

var $fTNaM = parcelRequire("fTNaM");

var $G9qxY = parcelRequire("G9qxY");

var $fNWSr = parcelRequire("fNWSr");

var $bampN = parcelRequire("bampN");
function $1d96c71ded8e60f3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1d96c71ded8e60f3$var$_ref = {
    name: "11eaz",
    styles: ".actions-button-group{opacity:0;}&:hover .actions-button-group, .actions-button-group:focus-within{opacity:1;}"
};
const $1d96c71ded8e60f3$var$getActionStyles = (showOnHover, isOpen)=>{
    if (showOnHover && !isOpen) return $1d96c71ded8e60f3$var$_ref;
};
const $1d96c71ded8e60f3$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $caOA9.SmartLinkStatus).Pending:
        case (0, $caOA9.SmartLinkStatus).Resolving:
            return 0, $G9qxY.default;
        case (0, $caOA9.SmartLinkStatus).Resolved:
            return 0, $dKmeE.default;
        case (0, $caOA9.SmartLinkStatus).Unauthorized:
        case (0, $caOA9.SmartLinkStatus).Forbidden:
        case (0, $caOA9.SmartLinkStatus).NotFound:
        case (0, $caOA9.SmartLinkStatus).Errored:
        case (0, $caOA9.SmartLinkStatus).Fallback:
        default:
            return 0, $fTNaM.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingView
 * @see TitleBlockResolvedView
 * @see TitleBlockErroredView
 */ const $1d96c71ded8e60f3$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, overrideCss: overrideCss, status: status = (0, $caOA9.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, ...props })=>{
    if (hideRetry && props.retry) delete props.retry;
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $eUqFw.useState)(false);
    const onDropdownOpenChange = (0, $eUqFw.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNWSr.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const actionStyles = $1d96c71ded8e60f3$var$getActionStyles(showActionOnHover, actionDropdownOpen);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const combinedCss = /*#__PURE__*/ (0, $byn9U.css)(actionStyles, overrideCss);
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $8sbpW.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme,
        ...overrideText
    });
    const Component = $1d96c71ded8e60f3$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        ...props,
        actionGroup: actionGroup,
        overrideCss: combinedCss,
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        icon: icon
    });
};
var $1d96c71ded8e60f3$export$2e2bcd8739ae039 = $1d96c71ded8e60f3$var$TitleBlock;

});
parcelRegister("dKmeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bd04caefc73a85e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bampN = parcelRequire("bampN");

var $4sQhG = parcelRequire("4sQhG");

var $7GItJ = parcelRequire("7GItJ");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");
function $3bd04caefc73a85e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ var $3bd04caefc73a85e$var$_ref = {
    name: "v43pxc",
    styles: "gap:var(--ds-space-050, 0.25rem)"
};
const $3bd04caefc73a85e$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const metadataElements = (0, $d2BrZ.renderElementItems)(metadata);
    const subtitleElements = (0, $d2BrZ.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.LinkIcon), {
        overrideIcon: icon,
        position: position
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Vertical,
        width: (0, $caOA9.SmartLinkWidth).Flexible,
        overrideCss: $3bd04caefc73a85e$var$_ref
    }, title, subtitleElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Horizontal
    }, subtitleElements)), metadataElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        align: (0, $caOA9.SmartLinkAlignment).Right,
        position: metadataPosition ?? (0, $caOA9.SmartLinkPosition).Center
    }, metadataElements), actionGroup);
};
var $3bd04caefc73a85e$export$2e2bcd8739ae039 = $3bd04caefc73a85e$var$TitleBlockResolvedView;

});

parcelRegister("fTNaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35c62bcc8002acc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8uD7Y = parcelRequire("8uD7Y");

var $byn9U = parcelRequire("byn9U");

var $bampN = parcelRequire("bampN");

var $4sQhG = parcelRequire("4sQhG");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");

var $7GItJ = parcelRequire("7GItJ");
function $d35c62bcc8002acc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d35c62bcc8002acc$var$actionStyles = {
    name: "r982j0",
    styles: "cursor:pointer;:hover{color:var(--ds-text-subtle, #8993A4);text-decoration:underline;}"
};
const $d35c62bcc8002acc$var$getMessageStyles = (size, hasAction)=>{
    const sizeStyles = (0, $4z862.getLinkSizeStyles)(size);
    return /*#__PURE__*/ (0, $byn9U.css)("flex:1 1 auto;justify-content:flex-end;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasAction ? $d35c62bcc8002acc$var$actionStyles : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    sizeStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(1, (0, $4z862.getLinkLineHeight)(size)), {
        color: "var(--ds-text-disabled, #6B778C)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: `${"var(--ds-border-focused, #388BFF)"} solid 2px`
        }
    });
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $d35c62bcc8002acc$var$TitleBlockErroredView = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const { size: size = (0, $caOA9.SmartLinkSize).Medium } = blockProps;
    const hasAction = onClick !== undefined;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-errored-view`
    }, !hideIcon && /*#__PURE__*/ (0, $byn9U.jsx)((0, $bampN.LinkIcon), {
        overrideIcon: icon,
        position: position
    }), title, descriptor && /*#__PURE__*/ (0, $byn9U.jsx)((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        align: (0, $caOA9.SmartLinkAlignment).Right
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: hasAction ? 'has-action' : '',
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $d35c62bcc8002acc$var$getMessageStyles(size, hasAction),
        onClick: onClick,
        "data-testid": `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
        ...descriptor,
        values: values
    }))), actionGroup);
};
var $d35c62bcc8002acc$export$2e2bcd8739ae039 = $d35c62bcc8002acc$var$TitleBlockErroredView;

});

parcelRegister("G9qxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6e75535fc810aa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4sQhG = parcelRequire("4sQhG");

var $caOA9 = parcelRequire("caOA9");

var $8SIiI = parcelRequire("8SIiI");

var $4z862 = parcelRequire("4z862");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $1c6e75535fc810aa$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $caOA9.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $4z862.getIconWidth)(size);
    const iconStyles = (0, $4z862.getIconSizeStyles)(iconWidth);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`
    }, !hideIcon && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: iconStyles,
        "data-testid": `${testId}-icon`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
var $1c6e75535fc810aa$export$2e2bcd8739ae039 = $1c6e75535fc810aa$var$TitleBlockResolvingView;

});


parcelRegister("8jYmN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef2bdb59e926ed8a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $bFzGY = parcelRequire("bFzGY");

var $jOVzD = parcelRequire("jOVzD");

var $buene = parcelRequire("buene");

var $44yzk = parcelRequire("44yzk");

var $aguBP = parcelRequire("aguBP");

var $iWItW = parcelRequire("iWItW");
function $ef2bdb59e926ed8a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Represents a block to display related resources of a url
 */ var $ef2bdb59e926ed8a$var$_ref = {
    name: "1ftjnda",
    styles: "min-height:1.55rem"
};
const $ef2bdb59e926ed8a$var$RelatedUrlsBlock = ({ testId: testId = 'smart-block-related-urls', url: url, renderers: renderers, ...blockProps })=>{
    (0, $asu8X.di)((0, $jOVzD.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [loadingRelatedUrls, setLoadingRelatedUrls] = (0, $eUqFw.useState)(true);
    const [err, setErr] = (0, $eUqFw.useState)();
    const [relatedUrls, setRelatedUrls] = (0, $eUqFw.useState)();
    const getRelatedUrls = (0, $jOVzD.default)();
    (0, $eUqFw.useEffect)(()=>{
        const fetchRelatedUrls = async ()=>{
            try {
                const relUrls = await getRelatedUrls(url);
                setRelatedUrls(relUrls);
                /**
         * Fire TrackRelatedLinksLoadedEvent
         */ (0, $iWItW.fireRelatedLinksLoadedEvent)(createAnalyticsEvent)({
                    relatedLinksCount: relUrls.resolvedResults?.length ?? 0
                });
            } catch (error) {
                setErr(error);
            }
            setLoadingRelatedUrls(false);
        };
        fetchRelatedUrls();
    }, [
        createAnalyticsEvent,
        getRelatedUrls,
        url
    ]);
    if (loadingRelatedUrls) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aguBP.RelatedUrlsBlockResolvingView), {
        testId: `${testId}-resolving-view`,
        ...blockProps
    });
    if (relatedUrls) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $44yzk.RelatedUrlsResolvedView), {
        renderers: renderers,
        overrideCss: $ef2bdb59e926ed8a$var$_ref,
        testId: `${testId}-resolved-view`,
        relatedUrlsResponse: relatedUrls,
        ...blockProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $buene.RelatedUrlsBlockErroredView), {
        err: err,
        testId: `${testId}-errored-view`,
        ...blockProps
    });
};
var $ef2bdb59e926ed8a$export$2e2bcd8739ae039 = $ef2bdb59e926ed8a$var$RelatedUrlsBlock;

});
parcelRegister("jOVzD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d17b3a7a9d9f04e2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $imCrQ = parcelRequire("imCrQ");

var $gqldc = parcelRequire("gqldc");
const $d17b3a7a9d9f04e2$var$useRelatedUrls = ()=>{
    const { connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const clientExt = (0, $imCrQ.useSmartLinkClientExtension)(connections.client);
    return (0, $eUqFw.useCallback)(async (url)=>{
        return await clientExt.relatedUrls(url);
    }, [
        clientExt
    ]);
};
var $d17b3a7a9d9f04e2$export$2e2bcd8739ae039 = $d17b3a7a9d9f04e2$var$useRelatedUrls;

});

parcelRegister("buene", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsBlockErroredView", () => $c113a405c1268075$export$35d9a5df27ecfbf0);

var $eUqFw = parcelRequire("eUqFw");

var $4abrz = parcelRequire("4abrz");

var $gsehw = parcelRequire("gsehw");

var $4sQhG = parcelRequire("4sQhG");
const $c113a405c1268075$export$35d9a5df27ecfbf0 = ({ testId: testId, ...blockProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        message: {
            descriptor: (0, $4abrz.messages).generic_error_message
        }
    }));

});

parcelRegister("44yzk", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsResolvedView", () => $a007e2cede3efc31$export$743935ead2c9d445);

var $eUqFw = parcelRequire("eUqFw");

var $4abrz = parcelRequire("4abrz");

var $4sQhG = parcelRequire("4sQhG");

var $6pyKj = parcelRequire("6pyKj");
const $a007e2cede3efc31$export$743935ead2c9d445 = ({ relatedUrlsResponse: { resolvedResults: resolvedResults }, renderers: renderers, testId: testId, initializeOpened: initializeOpened, ...blockProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: testId
    }, resolvedResults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6pyKj.default), {
        testId: `${testId}-list`,
        renderers: renderers,
        initializeOpened: initializeOpened,
        title: (0, $4abrz.messages).last_mentioned_in,
        resolvedResults: resolvedResults
    }));
};

});
parcelRegister("6pyKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ccec9f065474826$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $e9T6i = parcelRequire("e9T6i");

var $f1ChA = parcelRequire("f1ChA");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $4abrz = parcelRequire("4abrz");

var $4z862 = parcelRequire("4z862");

var $gsehw = parcelRequire("gsehw");

var $gDdZc = parcelRequire("gDdZc");
function $2ccec9f065474826$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2ccec9f065474826$var$_ref = {
    name: "rbkjwc",
    styles: "font-weight:var(--ds-font-weight-medium, 500)"
};
const $2ccec9f065474826$var$RelatedUrlList = ({ resolvedResults: resolvedResults, title: title, renderers: renderers, testId: testId, initializeOpened: initializeOpened })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(initializeOpened);
    const chevronClickHandler = (0, $eUqFw.useCallback)(()=>setIsOpen(!isOpen), [
        isOpen
    ]);
    const ChevronComponent = isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($f1ChA))) : (0, (/*@__PURE__*/$parcel$interopDefault($e9T6i)));
    const intl = (0, $5JgJ2.default)();
    return resolvedResults.length > 0 ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        testId: testId,
        xcss: (0, $1ZAYh.xcss)({
            width: '100%'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        onClick: chevronClickHandler,
        testId: `${testId}-expand-title`,
        backgroundColor: "color.background.neutral.subtle",
        "aria-expanded": !!isOpen,
        padding: "space.0",
        paddingInlineEnd: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.050",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        overrideCss: $2ccec9f065474826$var$_ref,
        message: {
            descriptor: title
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChevronComponent, {
        LEGACY_margin: "0 -4px",
        label: (0, $4z862.getFormattedMessageAsString)(intl, title),
        color: "currentColor"
    }))), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gDdZc.default), {
        resolvedResults: resolvedResults,
        testId: testId,
        renderers: renderers
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        testId: testId,
        message: {
            descriptor: (0, $4abrz.messages).related_work_items_not_found
        }
    });
};
var $2ccec9f065474826$export$2e2bcd8739ae039 = $2ccec9f065474826$var$RelatedUrlList;

});
parcelRegister("f1ChA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::72825bd81c3e7ee8ad2525c5c344ccda>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af04a522dea9b502$var$_react = $af04a522dea9b502$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $af04a522dea9b502$var$_chevronUp = $af04a522dea9b502$var$_interopRequireDefault((parcelRequire("ibyhG")));

var $af04a522dea9b502$var$_chevronUp2 = $af04a522dea9b502$var$_interopRequireDefault((parcelRequire("5xnoX")));
function $af04a522dea9b502$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "ChevronUpIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af04a522dea9b502$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $af04a522dea9b502$var$_react.default.createElement($af04a522dea9b502$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $af04a522dea9b502$var$_chevronUp2.default
    }, props));
$af04a522dea9b502$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $af04a522dea9b502$var$_default = module.exports.default = $af04a522dea9b502$var$ChevronUpIcon;

});
parcelRegister("5xnoX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40822fe6f5908262$var$_react = $40822fe6f5908262$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $40822fe6f5908262$var$_chevronUp = $40822fe6f5908262$var$_interopRequireDefault((parcelRequire("ibyhG")));
function $40822fe6f5908262$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $40822fe6f5908262$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $40822fe6f5908262$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $40822fe6f5908262$var$_chevronUp.default,
        iconType: "utility"
    }));
$40822fe6f5908262$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $40822fe6f5908262$var$_default = module.exports.default = $40822fe6f5908262$var$ChevronUpIcon;

});


parcelRegister("gDdZc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a454004ca0f579a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $aw5Sy = parcelRequire("aw5Sy");
var $bFzGY = parcelRequire("bFzGY");

var $elJTs = parcelRequire("elJTs");

var $f6EQU = parcelRequire("f6EQU");
const $a454004ca0f579a9$var$ResolvedResultsStack = ({ resolvedResults: resolvedResults, testId: testId, renderers: renderers })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        // This event will fire each time the component is loaded
        (0, $f6EQU.fireRelatedLinksViewedEvent)(createAnalyticsEvent)({
            relatedLinksCount: resolvedResults.length
        });
    }, [
        resolvedResults.length,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050",
        testId: `${testId}-items-wrapper`,
        as: "ul",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $1ZAYh.xcss)({
            paddingLeft: 'space.0',
            marginTop: 'space.0'
        })
    }, resolvedResults.map((resolvedResults, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f6EQU.RelatedUrlItemAnalyticsContext), {
            details: resolvedResults,
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elJTs.default), {
            testId: `${testId}-item`,
            results: resolvedResults,
            renderers: renderers
        }))));
};
const $a454004ca0f579a9$var$ResolvedResultsStackWithAnalytics = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            component: 'relatedLinksSection'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a454004ca0f579a9$var$ResolvedResultsStack, props));
};
var $a454004ca0f579a9$export$2e2bcd8739ae039 = $a454004ca0f579a9$var$ResolvedResultsStackWithAnalytics;

});
parcelRegister("elJTs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c7174b4dbac0a44$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9Amv1 = parcelRequire("9Amv1");

var $bFzGY = parcelRequire("bFzGY");

var $caOA9 = parcelRequire("caOA9");

var $fsHAt = parcelRequire("fsHAt");

var $c2pJy = parcelRequire("c2pJy");

var $39rqs = parcelRequire("39rqs");

var $lyAeo = parcelRequire("lyAeo");
const $6c7174b4dbac0a44$var$RelatedUrlItem = ({ results: results, renderers: renderers, testId: testId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const flexibleDataContext = (0, $eUqFw.useMemo)(()=>(0, $fsHAt.default)({
            response: results,
            renderers: renderers
        }), [
        renderers,
        results
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        (0, $lyAeo.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.050",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c2pJy.default), {
        ...flexibleDataContext?.linkIcon,
        testId: `${testId}-icon`,
        size: (0, $caOA9.SmartLinkSize).Small
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $39rqs.default), {
        testId: `${testId}-link`,
        text: flexibleDataContext?.title,
        url: flexibleDataContext?.url,
        size: (0, $caOA9.SmartLinkSize).Small,
        maxLines: 1,
        onClick: onClick
    }));
};
var $6c7174b4dbac0a44$export$2e2bcd8739ae039 = $6c7174b4dbac0a44$var$RelatedUrlItem;

});
parcelRegister("fsHAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a709dad76fe90a85$export$2e2bcd8739ae039);

var $4zMKr = parcelRequire("4zMKr");

var $8hH6p = parcelRequire("8hH6p");

var $903Mk = parcelRequire("903Mk");

var $fmv4j = parcelRequire("fmv4j");

var $7DLuu = parcelRequire("7DLuu");

var $1qrFi = parcelRequire("1qrFi");
var $h1sO6 = parcelRequire("h1sO6");
var $dGfXu = parcelRequire("dGfXu");
var $lnW6z = parcelRequire("lnW6z");
var $c8AiI = parcelRequire("c8AiI");
var $dMa80 = parcelRequire("dMa80");
var $a4gSw = parcelRequire("a4gSw");

var $77p4K = parcelRequire("77p4K");

var $9BBAF = parcelRequire("9BBAF");

var $ket3S = parcelRequire("ket3S");

var $2umDH = parcelRequire("2umDH");

var $asvOI = parcelRequire("asvOI");

var $eywmF = parcelRequire("eywmF");
const $a709dad76fe90a85$var$extractFlexibleUiContext = ({ id: id, renderers: renderers, actionOptions: actionOptions, response: response, aiSummaryConfig: aiSummaryConfig, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const url = (0, $lnW6z.extractLink)(data);
    return {
        // Use the original URL in edge cases, such as short links for AI summary and copy link actions.
        actions: (0, $8hH6p.default)(response, props.url, actionOptions, id, aiSummaryConfig),
        assignedToGroup: (0, $fmv4j.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $fmv4j.extractAttachmentCount)(data),
        authorGroup: (0, $c8AiI.extractPersonCreatedBy)(data),
        ownedByGroup: (0, $dMa80.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $7DLuu.extractPersonsUpdatedBy)(data),
        commentCount: (0, $fmv4j.extractCommentCount)(data),
        viewCount: (0, $fmv4j.extractViewCount)(data),
        reactCount: (0, $fmv4j.extractReactCount)(data),
        voteCount: (0, $fmv4j.extractVoteCount)(data),
        checklistProgress: (0, $fmv4j.extractChecklistProgress)(data),
        createdBy: (0, $fmv4j.extractCreatedBy)(data),
        ownedBy: (0, $fmv4j.extractOwnedBy)(data),
        assignedTo: (0, $fmv4j.extractAssignedTo)(data),
        createdOn: (0, $h1sO6.extractDateCreated)(data),
        dueOn: (0, $fmv4j.extractDueOn)(data),
        viewAction: (0, $eywmF.extractViewAction)(data, actionOptions),
        latestCommit: (0, $asvOI.extractLatestCommit)(data),
        linkIcon: (0, $903Mk.extractLinkIcon)(response, renderers),
        location: (0, $fmv4j.extractLocation)(data),
        modifiedBy: (0, $fmv4j.extractModifiedBy)(data),
        modifiedOn: (0, $dGfXu.extractDateUpdated)(data),
        preview: (0, $ket3S.default)(data),
        priority: (0, $77p4K.default)(data),
        provider: (0, $9BBAF.default)(data),
        programmingLanguage: (0, $fmv4j.extractProgrammingLanguage)(data),
        readTime: (0, $fmv4j.extractReadTime)(data),
        sentOn: (0, $fmv4j.extractSentOn)(data),
        snippet: (0, $4zMKr.extractSummary)(data) || undefined,
        sourceBranch: (0, $fmv4j.extractSourceBranch)(data),
        state: (0, $2umDH.default)(response, actionOptions, id),
        subscriberCount: (0, $fmv4j.extractSubscriberCount)(data),
        subTasksProgress: (0, $fmv4j.extractSubTasksProgress)(data),
        storyPoints: (0, $fmv4j.extractStoryPoints)(data),
        targetBranch: (0, $fmv4j.extractTargetBranch)(data),
        title: (0, $a4gSw.extractTitle)(data) || url,
        url: url,
        ari: (0, $1qrFi.extractAri)(data)
    };
};
var $a709dad76fe90a85$export$2e2bcd8739ae039 = $a709dad76fe90a85$var$extractFlexibleUiContext;

});
parcelRegister("4zMKr", function(module, exports) {

$parcel$export(module.exports, "extractSummary", () => $03eb7123b442c89e$export$db5a8500f6b6286e);
const $03eb7123b442c89e$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};

});

parcelRegister("8hH6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $53addcfa7a39f29f$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $caOA9 = parcelRequire("caOA9");

var $ehbIu = parcelRequire("ehbIu");

var $RO4Pi = parcelRequire("RO4Pi");

var $amwpE = parcelRequire("amwpE");

var $6qhhh = parcelRequire("6qhhh");

var $zhR2s = parcelRequire("zhR2s");

var $1GqIw = parcelRequire("1GqIw");

var $gK2mf = parcelRequire("gK2mf");
const $53addcfa7a39f29f$var$extractActions = (response, url, actionOptions, id, aiSummaryConfig)=>{
    const data = response.data;
    const action = {
        [(0, $caOA9.ActionName).CopyLinkAction]: (0, $zhR2s.extractCopyLinkAction)(data, actionOptions),
        [(0, $caOA9.ActionName).DownloadAction]: (0, $ehbIu.extractDownloadAction)(data, actionOptions),
        [(0, $caOA9.ActionName).FollowAction]: (0, $6qhhh.default)(response, actionOptions, id),
        [(0, $caOA9.ActionName).PreviewAction]: (0, $RO4Pi.extractPreviewAction)(response, actionOptions),
        [(0, $caOA9.ActionName).AutomationAction]: (0, $1GqIw.extractAutomationAction)(response),
        [(0, $caOA9.InternalActionName).AISummaryAction]: (0, $amwpE.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        ...(0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.enable-view-related-urls-action') ? {
            [(0, $caOA9.InternalActionName).ViewRelatedLinksAction]: (0, $gK2mf.extractViewRelatedLinksAction)(response)
        } : {}
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};
var $53addcfa7a39f29f$export$2e2bcd8739ae039 = $53addcfa7a39f29f$var$extractActions;

});
parcelRegister("ehbIu", function(module, exports) {

$parcel$export(module.exports, "extractDownloadAction", () => $66eea790b8ba0e58$export$e2076b2e4a490ac5);

var $44Wm8 = parcelRequire("44Wm8");

var $hqABm = parcelRequire("hqABm");

var $e3WTQ = parcelRequire("e3WTQ");

var $lIFl3 = parcelRequire("lIFl3");
const $66eea790b8ba0e58$export$e2076b2e4a490ac5 = (data, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).DownloadAction, actionOptions)) return;
    const downloadActionExists = (0, $e3WTQ.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) return {
        downloadUrl: (0, $lIFl3.extractDownloadUrl)(data)
    };
    return;
};

});
parcelRegister("44Wm8", function(module, exports) {

$parcel$export(module.exports, "canShowAction", () => $da2b2293f1c35c89$export$2487b058456cca75);
const $da2b2293f1c35c89$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});

parcelRegister("hqABm", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $e9d011026964d0c2$export$f40b7e0b762b928b);
var $e9d011026964d0c2$export$f40b7e0b762b928b;
(function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
})($e9d011026964d0c2$export$f40b7e0b762b928b || ($e9d011026964d0c2$export$f40b7e0b762b928b = {}));

});

parcelRegister("e3WTQ", function(module, exports) {

$parcel$export(module.exports, "getActionsFromJsonLd", () => $20656457f4b723f0$export$8f031784a3a03b23);
$parcel$export(module.exports, "extractClientActions", () => $20656457f4b723f0$export$75be35b463ab3fda);

var $hMDH6 = parcelRequire("hMDH6");

var $dAGi3 = parcelRequire("dAGi3");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $20656457f4b723f0$var$isClientAction = (action)=>[
        'ViewAction',
        'DownloadAction'
    ].indexOf(action['@type']) > -1;
const $20656457f4b723f0$var$getClientAction = (jsonLd, action)=>{
    switch(action['@type']){
        case 'ViewAction':
            return (0, $hMDH6.ViewAction)({
                url: jsonLd.url
            });
        case 'DownloadAction':
            return (0, $dAGi3.DownloadAction)({
                url: jsonLd['atlassian:downloadUrl']
            });
    }
};
const $20656457f4b723f0$var$isActionEnabled = (action, actionOptions)=>{
    switch(action['@type']){
        case 'ViewAction':
            return (0, $44Wm8.canShowAction)((0, $hqABm.CardAction).ViewAction, actionOptions);
        case 'DownloadAction':
            return (0, $44Wm8.canShowAction)((0, $hqABm.CardAction).DownloadAction, actionOptions);
    }
    return true;
};
const $20656457f4b723f0$var$getClientActionProps = (jsonLd, action, handler)=>{
    const clientAction = $20656457f4b723f0$var$getClientAction(jsonLd, action);
    const clientActionInvokeOpts = {
        type: 'client',
        key: action.identifier,
        action: {
            type: action['@type'],
            promise: clientAction.promise
        }
    };
    // Send client actions through common invocation flow; for analytics
    // and, in future, in order to propagate state changes.
    return {
        ...clientAction,
        promise: ()=>handler(clientActionInvokeOpts)
    };
};
const $20656457f4b723f0$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};
function $20656457f4b723f0$export$75be35b463ab3fda(jsonLd, handler, actionOptions) {
    const actions = $20656457f4b723f0$export$8f031784a3a03b23(jsonLd);
    const clientActions = actions.filter((action)=>$20656457f4b723f0$var$isClientAction(action) && $20656457f4b723f0$var$isActionEnabled(action, actionOptions));
    const clientActionImpls = clientActions.map((action)=>$20656457f4b723f0$var$getClientActionProps(jsonLd, action, handler));
    return clientActionImpls;
}

});
parcelRegister("hMDH6", function(module, exports) {

$parcel$export(module.exports, "ViewAction", () => $724f4a3330fcc48e$export$a96f88e1928d92fa);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $9A6mL = parcelRequire("9A6mL");
const $724f4a3330fcc48e$export$a96f88e1928d92fa = ({ url: url })=>({
        id: 'view-content',
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).view),
        promise: ()=>(0, $9A6mL.openUrl)(url)
    });

});

parcelRegister("dAGi3", function(module, exports) {

$parcel$export(module.exports, "DownloadAction", () => $15ad76cb67b3a953$export$7a2b423858a679ca);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $9A6mL = parcelRequire("9A6mL");
const $15ad76cb67b3a953$export$7a2b423858a679ca = ({ url: url })=>({
        id: 'download-content',
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).download),
        promise: ()=>(0, $9A6mL.downloadUrl)(url)
    });

});


parcelRegister("lIFl3", function(module, exports) {

$parcel$export(module.exports, "extractDownloadUrl", () => $833f00c4d88e64d9$export$9682e3ac9d184e95);
const $833f00c4d88e64d9$export$9682e3ac9d184e95 = (jsonLd)=>{
    if (jsonLd['atlassian:downloadUrl']) return jsonLd['atlassian:downloadUrl'];
};

});


parcelRegister("RO4Pi", function(module, exports) {

$parcel$export(module.exports, "extractPreviewAction", () => $834bef11f28eb280$export$eba2f3246148e526);

var $lIFl3 = parcelRequire("lIFl3");

var $lnW6z = parcelRequire("lnW6z");
var $fQDHB = parcelRequire("fQDHB");
var $ebCNT = parcelRequire("ebCNT");
var $a4gSw = parcelRequire("a4gSw");

var $903Mk = parcelRequire("903Mk");

var $dB5lQ = parcelRequire("dB5lQ");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $834bef11f28eb280$export$eba2f3246148e526 = (response, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).PreviewAction, actionOptions)) return;
    const data = response.data;
    const meta = response.meta;
    const src = (0, $fQDHB.extractPreview)(data, 'web')?.src;
    if (src) return {
        downloadUrl: (0, $lIFl3.extractDownloadUrl)(data),
        providerName: (0, $ebCNT.extractProvider)(data)?.text,
        src: src,
        title: (0, $a4gSw.extractTitle)(data),
        linkIcon: (0, $903Mk.extractLinkIcon)(response),
        url: (0, $lnW6z.extractLink)(data),
        isSupportTheming: (0, $dB5lQ.extractIsSupportTheming)(meta)
    };
};

});
parcelRegister("fQDHB", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $060df7d9b738514e$export$4b0d98b1b7f6d115);

var $5amkT = parcelRequire("5amkT");

var $9W7HP = parcelRequire("9W7HP");
const $060df7d9b738514e$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $5amkT.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("5amkT", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $8b80b7bf7b97ac24$export$3e8ad908070b68b2);
const $8b80b7bf7b97ac24$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});


parcelRegister("ebCNT", function(module, exports) {

$parcel$export(module.exports, "extractProvider", () => $949786e11a712549$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $949786e11a712549$export$6fb636a2ac885215);

var $eUqFw = parcelRequire("eUqFw");

var $5KT10 = parcelRequire("5KT10");

var $77CtJ = parcelRequire("77CtJ");


var $amPw7 = parcelRequire("amPw7");
var $9W7HP = parcelRequire("9W7HP");
const $949786e11a712549$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $949786e11a712549$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $949786e11a712549$var$extractProviderImage(generator.image)
            };
        }
    }
};
const $949786e11a712549$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $91701787b8fb623d$export$cee224b5de4d6d66)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
            appearance: "brand",
            /* eslint-enable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/no-deprecated-apis */ size: "xsmall"
        });
        else if (id === (0, $91701787b8fb623d$export$f654d825189934a7)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
            appearance: "brand",
            /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ size: "xsmall"
        });
    }
    if (icon) return (0, $amPw7.extractUrlFromIconJsonLd)(icon);
};
const $949786e11a712549$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});
const $91701787b8fb623d$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $91701787b8fb623d$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $91701787b8fb623d$export$84a73a0383f58180 = 'JiraTask';
const $91701787b8fb623d$export$c6c83963a9378a67 = 'JiraSubTask';
const $91701787b8fb623d$export$58af3c426c111a6d = 'JiraStory';
const $91701787b8fb623d$export$ac9898a63417219e = 'JiraBug';
const $91701787b8fb623d$export$54db5e3fb12e39cd = 'JiraEpic';
const $91701787b8fb623d$export$2f54a5a217202c85 = 'JiraIncident';
const $91701787b8fb623d$export$d097371052bfc411 = 'JiraServiceRequest';
const $91701787b8fb623d$export$efd9452ad16c6676 = 'JiraChange';
const $91701787b8fb623d$export$2e7e70abb5d81f67 = 'JiraProblem';
const $91701787b8fb623d$export$ce25cfc40b280dbc = 'JiraCustomTaskType';

parcelRegister("amPw7", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $8352024242ae3429$export$67f3d92c824fd850);

var $9W7HP = parcelRequire("9W7HP");
const $8352024242ae3429$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(icon.url);
    }
};

});


parcelRegister("a4gSw", function(module, exports) {

$parcel$export(module.exports, "extractTitle", () => $a665721ac2392089$export$b05803156e5015b6);

var $ieJEX = parcelRequire("ieJEX");

var $4yj9H = parcelRequire("4yj9H");
const $a665721ac2392089$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $ieJEX.extractContext)(jsonLd);
    const type = (0, $4yj9H.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("ieJEX", function(module, exports) {

$parcel$export(module.exports, "extractContext", () => $24c906d1ff23560a$export$efdbd45f3e77a161);

var $4yj9H = parcelRequire("4yj9H");

var $amPw7 = parcelRequire("amPw7");
const $24c906d1ff23560a$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $amPw7.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $4yj9H.extractType)(context)
            };
        }
    }
};

});
parcelRegister("4yj9H", function(module, exports) {

$parcel$export(module.exports, "extractType", () => $b06a91293523bc6e$export$2e9ae379995d99e3);
const $b06a91293523bc6e$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
};

});



parcelRegister("903Mk", function(module, exports) {

$parcel$export(module.exports, "extractLinkIcon", () => $3d22e311bd34cc2d$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $3d22e311bd34cc2d$export$bdd29be9b0395931);

var $gaEk5 = parcelRequire("gaEk5");

var $9BBAF = parcelRequire("9BBAF");

var $caOA9 = parcelRequire("caOA9");

var $eYh51 = parcelRequire("eYh51");
const $3d22e311bd34cc2d$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $eYh51.default)(data, renderers);
    return {
        ...(0, $gaEk5.default)(data),
        render: render
    };
};
const $3d22e311bd34cc2d$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $9BBAF.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $caOA9.SmartLinkStatus).Forbidden:
        case (0, $caOA9.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $caOA9.IconType).Forbidden
            };
        case (0, $caOA9.SmartLinkStatus).NotFound:
            return {
                icon: (0, $caOA9.IconType).Error
            };
        case (0, $caOA9.SmartLinkStatus).Errored:
        case (0, $caOA9.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $caOA9.IconType).Default
            };
    }
};

});
parcelRegister("gaEk5", function(module, exports) {

$parcel$export(module.exports, "default", () => $022ee8dc75d3db15$export$2e2bcd8739ae039);

var $4DxpJ = parcelRequire("4DxpJ");

var $60G1O = parcelRequire("60G1O");

var $iTTUV = parcelRequire("iTTUV");

var $WIkzi = parcelRequire("WIkzi");

var $9BBAF = parcelRequire("9BBAF");

var $d5yin = parcelRequire("d5yin");

var $jy3WR = parcelRequire("jy3WR");

var $a4gSw = parcelRequire("a4gSw");

var $2aTcn = parcelRequire("2aTcn");

var $caOA9 = parcelRequire("caOA9");

var $4afqa = parcelRequire("4afqa");
const $022ee8dc75d3db15$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $jy3WR.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $022ee8dc75d3db15$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $2aTcn.extractorPriorityMap)[b] - (0, $2aTcn.extractorPriorityMap)[a])[0] : type;
};
const $022ee8dc75d3db15$var$isJiraProvider = (provider)=>provider === (0, $4DxpJ.JIRA_GENERATOR_ID);
function $022ee8dc75d3db15$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $iTTUV.default)(fileFormat);
    const documentTypeIcon = $022ee8dc75d3db15$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $60G1O.default)(type, label);
    return (0, $4afqa.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $022ee8dc75d3db15$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $caOA9.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return {
                icon: (0, $caOA9.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $caOA9.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $caOA9.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $caOA9.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $caOA9.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $caOA9.IconType).Task,
                label: taskLabel
            };
            if ($022ee8dc75d3db15$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $022ee8dc75d3db15$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $WIkzi.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $022ee8dc75d3db15$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $a4gSw.extractTitle)(data);
    const type = $022ee8dc75d3db15$var$extractType(data);
    const urlIcon = (0, $d5yin.default)(data.icon, label);
    const providerIcon = (0, $9BBAF.default)(data);
    return $022ee8dc75d3db15$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $022ee8dc75d3db15$export$2e2bcd8739ae039 = $022ee8dc75d3db15$var$extractJsonldDataIcon;

});
parcelRegister("4DxpJ", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $0689ce76a4c51982$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $0689ce76a4c51982$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $0689ce76a4c51982$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $0689ce76a4c51982$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $0689ce76a4c51982$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $0689ce76a4c51982$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $0689ce76a4c51982$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $0689ce76a4c51982$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $0689ce76a4c51982$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $0689ce76a4c51982$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $0689ce76a4c51982$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $0689ce76a4c51982$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $0689ce76a4c51982$export$fe44ce30fd8d131b);
const $0689ce76a4c51982$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $0689ce76a4c51982$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $0689ce76a4c51982$export$84a73a0383f58180 = 'JiraTask';
const $0689ce76a4c51982$export$c6c83963a9378a67 = 'JiraSubTask';
const $0689ce76a4c51982$export$58af3c426c111a6d = 'JiraStory';
const $0689ce76a4c51982$export$ac9898a63417219e = 'JiraBug';
const $0689ce76a4c51982$export$54db5e3fb12e39cd = 'JiraEpic';
const $0689ce76a4c51982$export$2f54a5a217202c85 = 'JiraIncident';
const $0689ce76a4c51982$export$d097371052bfc411 = 'JiraServiceRequest';
const $0689ce76a4c51982$export$efd9452ad16c6676 = 'JiraChange';
const $0689ce76a4c51982$export$2e7e70abb5d81f67 = 'JiraProblem';
const $0689ce76a4c51982$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $0689ce76a4c51982$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider'
];

});

parcelRegister("60G1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaccd265493698eb$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");
const $aaccd265493698eb$var$extractDocumentTypeIcon = (documentType, label)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $caOA9.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            return {
                icon: (0, $caOA9.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $caOA9.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $caOA9.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $caOA9.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $caOA9.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $caOA9.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $aaccd265493698eb$export$2e2bcd8739ae039 = $aaccd265493698eb$var$extractDocumentTypeIcon;

});

parcelRegister("iTTUV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfa68e49b5e1b13b$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");
const $cfa68e49b5e1b13b$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $caOA9.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $caOA9.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $caOA9.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $caOA9.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $caOA9.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $caOA9.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $caOA9.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $caOA9.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $caOA9.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $caOA9.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $caOA9.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $caOA9.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $caOA9.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $caOA9.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $caOA9.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $caOA9.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $caOA9.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $caOA9.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $caOA9.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $caOA9.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $caOA9.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $caOA9.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $cfa68e49b5e1b13b$export$2e2bcd8739ae039 = $cfa68e49b5e1b13b$var$extractFileFormatIcon;

});

parcelRegister("WIkzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a469cd27ea0426c$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");
const $0a469cd27ea0426c$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $caOA9.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $caOA9.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $caOA9.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $caOA9.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $caOA9.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $caOA9.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $caOA9.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $caOA9.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $caOA9.IconType).Task,
                label: label
            };
    }
};
var $0a469cd27ea0426c$export$2e2bcd8739ae039 = $0a469cd27ea0426c$var$extractJiraTaskIcon;

});

parcelRegister("9BBAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a453423411755a2f$export$2e2bcd8739ae039);

var $4DxpJ = parcelRequire("4DxpJ");

var $caOA9 = parcelRequire("caOA9");

var $d5yin = parcelRequire("d5yin");

var $a4gSw = parcelRequire("a4gSw");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $a453423411755a2f$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $a4gSw.extractTitle)(data);
    if (provider === (0, $4DxpJ.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $caOA9.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $4DxpJ.JIRA_GENERATOR_ID)) return {
        icon: (0, $caOA9.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $d5yin.default)(icon, label);
};
var $a453423411755a2f$export$2e2bcd8739ae039 = $a453423411755a2f$var$extractProviderIcon;

});
parcelRegister("d5yin", function(module, exports) {

$parcel$export(module.exports, "default", () => $a073a66919740263$export$2e2bcd8739ae039);

var $amPw7 = parcelRequire("amPw7");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $a073a66919740263$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $amPw7.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $a073a66919740263$export$2e2bcd8739ae039 = $a073a66919740263$var$extractUrlIcon;

});


parcelRegister("jy3WR", function(module, exports) {

$parcel$export(module.exports, "extractTaskType", () => $345dc23d744dc954$export$ed3fd59180514d27);

var $amPw7 = parcelRequire("amPw7");
const $345dc23d744dc954$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $amPw7.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("2aTcn", function(module, exports) {

$parcel$export(module.exports, "extractorPriorityMap", () => $52be4013925bc58c$export$e0deaeb4a2dfe2b4);
const $52be4013925bc58c$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("4afqa", function(module, exports) {

$parcel$export(module.exports, "prioritiseIcon", () => $4cb04ba6bb191e3c$export$65e47eb22a387a86);
function $4cb04ba6bb191e3c$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});


parcelRegister("eYh51", function(module, exports) {

$parcel$export(module.exports, "default", () => $4581489debbadb7f$export$2e2bcd8739ae039);
const $4581489debbadb7f$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $4581489debbadb7f$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $4581489debbadb7f$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $4581489debbadb7f$export$2e2bcd8739ae039 = $4581489debbadb7f$var$extractIconRenderer;

});


parcelRegister("dB5lQ", function(module, exports) {

$parcel$export(module.exports, "extractIsSupportTheming", () => $b34c0ba6cc99590f$export$38d755f52cdf4acb);

var $4DxpJ = parcelRequire("4DxpJ");
const $b34c0ba6cc99590f$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $4DxpJ.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});


parcelRegister("amwpE", function(module, exports) {

$parcel$export(module.exports, "extractAISummaryAction", () => $38c5d89c8c4c78d5$export$e7f7a50a8b8932df);

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");

var $hZwiw = parcelRequire("hZwiw");
const $38c5d89c8c4c78d5$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).AISummaryAction, actionOptions) || !(0, $hZwiw.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});

parcelRegister("6qhhh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a426c8146558b6e$export$2e2bcd8739ae039);

var $lnW6z = parcelRequire("lnW6z");
var $4yj9H = parcelRequire("4yj9H");

var $cCvxR = parcelRequire("cCvxR");

var $269iK = parcelRequire("269iK");

var $5cnU7 = parcelRequire("5cnU7");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $6a426c8146558b6e$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $269iK.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $5cnU7.default)(data);
    const type = (0, $4yj9H.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $cCvxR.SmartLinkActionType).FollowEntityAction || actionName === (0, $cCvxR.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $lnW6z.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $cCvxR.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $6a426c8146558b6e$export$2e2bcd8739ae039 = $6a426c8146558b6e$var$extractFollowAction;

});
parcelRegister("5cnU7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ba438025015c1fd$export$2e2bcd8739ae039);
const $5ba438025015c1fd$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $5ba438025015c1fd$export$2e2bcd8739ae039 = $5ba438025015c1fd$var$extractServerAction;

});


parcelRegister("zhR2s", function(module, exports) {

$parcel$export(module.exports, "extractCopyLinkAction", () => $f482c27c7008fd92$export$5b7ae1fa8fdb83ba);

var $lnW6z = parcelRequire("lnW6z");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $f482c27c7008fd92$export$5b7ae1fa8fdb83ba = (data, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $lnW6z.extractLink)(data);
    if (!url) return;
    return {
        url: url
    };
};

});

parcelRegister("1GqIw", function(module, exports) {

$parcel$export(module.exports, "extractAutomationAction", () => $6447dee659182c27$export$f913cc6abf3ec084);

var $caOA9 = parcelRequire("caOA9");
const $6447dee659182c27$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $caOA9.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("gK2mf", function(module, exports) {

$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $d3a00a758146d92c$export$debae7424a0231b9);

var $1qrFi = parcelRequire("1qrFi");
const $d3a00a758146d92c$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $1qrFi.extractAri)(response.data);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("fmv4j", function(module, exports) {

$parcel$export(module.exports, "extractCommentCount", () => $469a01a9f706d88b$export$b68822b76d5d51d5);
$parcel$export(module.exports, "extractDueOn", () => $469a01a9f706d88b$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $469a01a9f706d88b$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractReactCount", () => $469a01a9f706d88b$export$44130aa92252501);
$parcel$export(module.exports, "extractVoteCount", () => $469a01a9f706d88b$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $469a01a9f706d88b$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $469a01a9f706d88b$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $469a01a9f706d88b$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractCreatedBy", () => $469a01a9f706d88b$export$69b10d653f96288b);
$parcel$export(module.exports, "extractModifiedBy", () => $469a01a9f706d88b$export$bcb193c84c865ec9);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $469a01a9f706d88b$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $469a01a9f706d88b$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $469a01a9f706d88b$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractAttachmentCount", () => $469a01a9f706d88b$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $469a01a9f706d88b$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $469a01a9f706d88b$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $469a01a9f706d88b$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $469a01a9f706d88b$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractReadTime", () => $469a01a9f706d88b$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSentOn", () => $469a01a9f706d88b$export$b592ddecae70b61d);
$parcel$export(module.exports, "extractStoryPoints", () => $469a01a9f706d88b$export$bdcea84d1550eb9d);

var $dlXJJ = parcelRequire("dlXJJ");
var $c8AiI = parcelRequire("c8AiI");
var $dMa80 = parcelRequire("dMa80");
var $gd1O9 = parcelRequire("gd1O9");
const $469a01a9f706d88b$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $469a01a9f706d88b$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $469a01a9f706d88b$export$b68822b76d5d51d5 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'schema:commentCount');
const $469a01a9f706d88b$export$ac56bd7a37249b48 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'endTime');
const $469a01a9f706d88b$export$e57334ce4738e29d = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:viewCount');
const $469a01a9f706d88b$export$44130aa92252501 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:reactCount');
const $469a01a9f706d88b$export$c8bef3d5e550a3a = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:voteCount');
const $469a01a9f706d88b$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $dMa80.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $469a01a9f706d88b$export$5546969a505305 = (data)=>{
    const person = (0, $dlXJJ.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $469a01a9f706d88b$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $dlXJJ.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $469a01a9f706d88b$export$69b10d653f96288b = (data)=>{
    const persons = (0, $c8AiI.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $469a01a9f706d88b$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $gd1O9.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $469a01a9f706d88b$export$43e54589935a1ff = (data)=>$469a01a9f706d88b$var$extractValue(data, 'schema:programmingLanguage');
const $469a01a9f706d88b$export$949ac6a8325b3fdb = (data)=>$469a01a9f706d88b$var$extractLinkName(data['atlassian:mergeSource']);
const $469a01a9f706d88b$export$8bd03a7beb5badf1 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:subscriberCount');
const $469a01a9f706d88b$export$65362ff78a97fd8 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:attachmentCount');
const $469a01a9f706d88b$export$29b0ac5d2f9890cf = (data)=>$469a01a9f706d88b$var$extractLinkName(data['atlassian:mergeDestination']);
const $469a01a9f706d88b$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $469a01a9f706d88b$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $469a01a9f706d88b$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $469a01a9f706d88b$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $469a01a9f706d88b$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $469a01a9f706d88b$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $469a01a9f706d88b$export$cc4028b2878d0675 = (data)=>{
    return $469a01a9f706d88b$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $469a01a9f706d88b$export$b592ddecae70b61d = (data)=>{
    return $469a01a9f706d88b$var$extractValue(data, 'dateSent');
};
const $469a01a9f706d88b$export$bdcea84d1550eb9d = (data)=>{
    return $469a01a9f706d88b$var$extractValue(data, 'atlassian:storyPoints');
};

});
parcelRegister("dlXJJ", function(module, exports) {

$parcel$export(module.exports, "extractPersonAssignedTo", () => $eecb0f85fd3e820f$export$38a0979ebf273662);

var $3gIUj = parcelRequire("3gIUj");
const $eecb0f85fd3e820f$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $3gIUj.extractPersonFromJsonLd)(assignedTo);
};

});
parcelRegister("3gIUj", function(module, exports) {

$parcel$export(module.exports, "extractPersonFromJsonLd", () => $2b1bbf71ecf49172$export$c471ae5fddcf1392);

var $amPw7 = parcelRequire("amPw7");
const $2b1bbf71ecf49172$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $amPw7.extractUrlFromIconJsonLd)(person.icon)
        };
    }
};

});


parcelRegister("c8AiI", function(module, exports) {

$parcel$export(module.exports, "extractPersonCreatedBy", () => $62e4f86ca3f5f110$export$a66235cba0c9d11a);

var $3gIUj = parcelRequire("3gIUj");
const $62e4f86ca3f5f110$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $3gIUj.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $3gIUj.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
};

});

parcelRegister("dMa80", function(module, exports) {

$parcel$export(module.exports, "extractPersonOwnedBy", () => $ce0e432e194a4e67$export$19ee667f3f7a6ec3);

var $3gIUj = parcelRequire("3gIUj");
const $ce0e432e194a4e67$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $3gIUj.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $3gIUj.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});

parcelRegister("gd1O9", function(module, exports) {

$parcel$export(module.exports, "extractPersonUpdatedBy", () => $20f4bd3f1c7a69fa$export$8a2d1ed7e6f336f0);

var $3gIUj = parcelRequire("3gIUj");
const $20f4bd3f1c7a69fa$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $3gIUj.extractPersonFromJsonLd)(updatedBy);
};

});


parcelRegister("7DLuu", function(module, exports) {

$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $144ad24fb0523f2d$export$216e4f6aa7c169b8);

var $cx2mN = parcelRequire("cx2mN");
var $3gIUj = parcelRequire("3gIUj");
const $144ad24fb0523f2d$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $cx2mN.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $3gIUj.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("cx2mN", function(module, exports) {

$parcel$export(module.exports, "extractMembers", () => $f6777de4e93b831a$export$6281d080d62a0719);

var $3gIUj = parcelRequire("3gIUj");
const $f6777de4e93b831a$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $3gIUj.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $3gIUj.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});


parcelRegister("h1sO6", function(module, exports) {

$parcel$export(module.exports, "extractDateCreated", () => $b0559218890d0714$export$e1226a5e0bbbf862);
const $b0559218890d0714$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
};

});

parcelRegister("dGfXu", function(module, exports) {

$parcel$export(module.exports, "extractDateUpdated", () => $172490fac0121aa1$export$7fc2f5e6f9d22ae7);
const $172490fac0121aa1$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
};

});

parcelRegister("77p4K", function(module, exports) {

$parcel$export(module.exports, "default", () => $e993678abbe0145f$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");

var $amPw7 = parcelRequire("amPw7");
const $e993678abbe0145f$var$priorityMapper = {
    blocker: (0, $caOA9.IconType).PriorityBlocker,
    critical: (0, $caOA9.IconType).PriorityCritical,
    high: (0, $caOA9.IconType).PriorityHigh,
    highest: (0, $caOA9.IconType).PriorityHighest,
    low: (0, $caOA9.IconType).PriorityLow,
    lowest: (0, $caOA9.IconType).PriorityLowest,
    major: (0, $caOA9.IconType).PriorityMajor,
    medium: (0, $caOA9.IconType).PriorityMedium,
    minor: (0, $caOA9.IconType).PriorityMinor,
    trivial: (0, $caOA9.IconType).PriorityTrivial,
    undefined: (0, $caOA9.IconType).PriorityUndefined
};
const $e993678abbe0145f$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $e993678abbe0145f$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $amPw7.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $e993678abbe0145f$export$2e2bcd8739ae039 = $e993678abbe0145f$var$extractPriority;

});

parcelRegister("ket3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bd5351f90659454$export$2e2bcd8739ae039);

var $lbKTa = parcelRequire("lbKTa");

var $caOA9 = parcelRequire("caOA9");
const $0bd5351f90659454$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $lbKTa.extractImage)(data);
    return url ? {
        type: (0, $caOA9.MediaType).Image,
        url: url
    } : undefined;
};
var $0bd5351f90659454$export$2e2bcd8739ae039 = $0bd5351f90659454$var$extractPreview;

});
parcelRegister("lbKTa", function(module, exports) {

$parcel$export(module.exports, "extractImage", () => $205a59ce4cd20de1$export$4c753a1297cb9805);

var $9W7HP = parcelRequire("9W7HP");
const $205a59ce4cd20de1$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});


parcelRegister("2umDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ca2df7ccfe49f1$export$2e2bcd8739ae039);

var $i9zl6 = parcelRequire("i9zl6");

var $269iK = parcelRequire("269iK");

var $5cnU7 = parcelRequire("5cnU7");

var $lnW6z = parcelRequire("lnW6z");

var $RO4Pi = parcelRequire("RO4Pi");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $c8ca2df7ccfe49f1$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $c8ca2df7ccfe49f1$var$extractAction = (response, id)=>{
    const extensionKey = (0, $269iK.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $5cnU7.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $c8ca2df7ccfe49f1$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $lnW6z.extractLink)(data);
    const previewData = response ? (0, $RO4Pi.extractPreviewAction)(response) : null;
    const details = {
        id: id,
        url: url,
        previewData: previewData
    };
    const update = $c8ca2df7ccfe49f1$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $c8ca2df7ccfe49f1$var$extractState = (response, actionOptions, id)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $i9zl6.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $c8ca2df7ccfe49f1$var$extractAction(response, id);
    return {
        ...lozenge,
        action: action
    };
};
var $c8ca2df7ccfe49f1$export$2e2bcd8739ae039 = $c8ca2df7ccfe49f1$var$extractState;

});
parcelRegister("i9zl6", function(module, exports) {

$parcel$export(module.exports, "extractLozenge", () => $f0d2b04ab2e51680$export$e5da155556a77bca);

var $9tMLz = parcelRequire("9tMLz");

var $h8zKt = parcelRequire("h8zKt");

var $dSEZR = parcelRequire("dSEZR");

var $4yj9H = parcelRequire("4yj9H");

var $jy3WR = parcelRequire("jy3WR");
const $f0d2b04ab2e51680$var$DOC_TYPES = [
    'schema:BlogPosting',
    'schema:TextDigitalDocument',
    'schema:DigitalDocument',
    'schema:PresentationDigitalDocument',
    'schema:SpreadsheetDigitalDocument'
];
const $f0d2b04ab2e51680$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $4yj9H.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:SourceCodePullRequest')) return (0, $9tMLz.extractState)(jsonLd);
        else if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $h8zKt.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $dSEZR.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $f0d2b04ab2e51680$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        } else if (type.some((types)=>$f0d2b04ab2e51680$var$DOC_TYPES.includes(types))) {
            const jsonLdDocument = jsonLd;
            const lozengeFromState = (0, $9tMLz.extractState)(jsonLdDocument);
            return lozengeFromState;
        } else if (type.includes('atlassian:Goal')) {
            const jsonLdProject = jsonLd;
            const lozengeFromState = (0, $9tMLz.extractState)(jsonLdProject);
            return lozengeFromState;
        } else if (type.includes('atlassian:Project')) {
            const jsonLdProject = jsonLd;
            const lozengeFromState = (0, $9tMLz.extractState)(jsonLdProject);
            return lozengeFromState;
        } else if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
    }
};
const $f0d2b04ab2e51680$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $jy3WR.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("9tMLz", function(module, exports) {

$parcel$export(module.exports, "extractState", () => $c909e4d157540c3d$export$5e4074cbce6574c7);

var $BOwLU = parcelRequire("BOwLU");
// Maps accent color short names to their corresponding background and text colors
const $c909e4d157540c3d$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $c909e4d157540c3d$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $BOwLU.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $BOwLU.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $c909e4d157540c3d$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("BOwLU", function(module, exports) {

$parcel$export(module.exports, "isValidAppearance", () => $9ca9d217c185ead7$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $9ca9d217c185ead7$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $9ca9d217c185ead7$export$772610da74ddbc07);
const $9ca9d217c185ead7$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $9ca9d217c185ead7$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $9ca9d217c185ead7$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $9ca9d217c185ead7$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $9ca9d217c185ead7$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("h8zKt", function(module, exports) {

$parcel$export(module.exports, "extractTag", () => $c3a22850fb93f457$export$962a8da34cf78a4f);

var $BOwLU = parcelRequire("BOwLU");
const $c3a22850fb93f457$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($c3a22850fb93f457$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $c3a22850fb93f457$var$extractTagItem(tag);
    }
};
const $c3a22850fb93f457$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $BOwLU.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("dSEZR", function(module, exports) {

$parcel$export(module.exports, "extractTaskStatus", () => $845f51ab32eef1a6$export$7698df1946deda72);
const $845f51ab32eef1a6$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("asvOI", function(module, exports) {

$parcel$export(module.exports, "extractLatestCommit", () => $1458752047a9ffeb$export$f222392162cff0d8);
const $1458752047a9ffeb$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});

parcelRegister("eywmF", function(module, exports) {

$parcel$export(module.exports, "extractViewAction", () => $151b53176fbfdd54$export$96c7e3a7e9c64e85);

var $lnW6z = parcelRequire("lnW6z");

var $e3WTQ = parcelRequire("e3WTQ");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $151b53176fbfdd54$export$96c7e3a7e9c64e85 = (data, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).ViewAction, actionOptions)) return;
    const viewActionExists = (0, $e3WTQ.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (viewActionExists) return {
        viewUrl: (0, $lnW6z.extractLink)(data)
    };
    return undefined;
};

});



parcelRegister("f6EQU", function(module, exports) {

$parcel$export(module.exports, "fireRelatedLinksViewedEvent", () => $08d93b061d67c6f8$export$b33ea4a8393685d8);
$parcel$export(module.exports, "RelatedUrlItemAnalyticsContext", () => $08d93b061d67c6f8$export$e88153cb3e6fc3fc);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $jfVIr = parcelRequire("jfVIr");

var $bTNMs = parcelRequire("bTNMs");
const $08d93b061d67c6f8$var$createUiRelatedLinksViewedEventPayload = ({ relatedLinksCount: relatedLinksCount })=>({
        action: 'viewed',
        actionSubject: 'relatedLinks',
        eventType: 'ui',
        attributes: {
            relatedLinksCount: relatedLinksCount
        }
    });
const $08d93b061d67c6f8$export$b33ea4a8393685d8 = (createAnalyticsEvent)=>(attributes)=>{
        const payload = $08d93b061d67c6f8$var$createUiRelatedLinksViewedEventPayload(attributes);
        if (payload) createAnalyticsEvent({
            ...payload
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };
const $08d93b061d67c6f8$export$e88153cb3e6fc3fc = (props)=>{
    const { children: children, details: details } = props;
    /**
	 * We don't really need the `url` to get the attributes here so set
	 * it to an empty string to just make typescript happy
	 */ const attributes = (0, $jfVIr.getResolvedAttributes)({
        url: ''
    }, details);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            attributes: attributes,
            component: 'relatedLink'
        }
    }, children);
};

});
parcelRegister("jfVIr", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $ea95fbff36d57274$export$7243431f5325a7b);

var $4hPjC = parcelRequire("4hPjC");

var $kFGtp = parcelRequire("kFGtp");
const $ea95fbff36d57274$export$7243431f5325a7b = (linkDetails, details, linkStatus)=>{
    const status = linkStatus ?? (details && (0, $4hPjC.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $kFGtp.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("kFGtp", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $c8d9d9ce9f7c0d20$export$28ddbae335bd80b5);
const $c8d9d9ce9f7c0d20$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});






parcelRegister("aguBP", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsBlockResolvingView", () => $507d5607706e35a7$export$50a43430722f62f8);

var $eUqFw = parcelRequire("eUqFw");

var $8SIiI = parcelRequire("8SIiI");

var $4sQhG = parcelRequire("4sQhG");
const $507d5607706e35a7$export$50a43430722f62f8 = ({ testId: testId, ...blockProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SIiI.default), {
        height: 1.55,
        width: 22
    }));

});

parcelRegister("iWItW", function(module, exports) {

$parcel$export(module.exports, "fireRelatedLinksLoadedEvent", () => $cf9e32bcbac3d864$export$d2852f8792c380fa);

var $bTNMs = parcelRequire("bTNMs");
const $cf9e32bcbac3d864$var$createTrackRelatedLinksLoadedEventPayload = ({ relatedLinksCount: relatedLinksCount })=>({
        action: 'loaded',
        actionSubject: 'relatedLinks',
        eventType: 'track',
        attributes: {
            relatedLinksCount: relatedLinksCount
        }
    });
const $cf9e32bcbac3d864$export$d2852f8792c380fa = (createAnalyticsEvent)=>(attributes)=>{
        const payload = $cf9e32bcbac3d864$var$createTrackRelatedLinksLoadedEventPayload(attributes);
        if (payload) createAnalyticsEvent({
            ...payload
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };

});


parcelRegister("h2NbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fe889a6e310b451$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ayl0W = parcelRequire("ayl0W");

var $caOA9 = parcelRequire("caOA9");

var $4AAjx = parcelRequire("4AAjx");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $5fe889a6e310b451$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.InternalActionName).AISummaryAction];
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ayl0W.default), {
        ...props,
        testId: testId,
        url: actionData.url
    });
};
var $5fe889a6e310b451$export$2e2bcd8739ae039 = $5fe889a6e310b451$var$AISummaryBlock;

});
parcelRegister("ayl0W", function(module, exports) {

$parcel$export(module.exports, "default", () => $04e07ab863de3221$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $4sQhG = parcelRequire("4sQhG");

var $3FvFV = parcelRequire("3FvFV");

var $04PAQ = parcelRequire("04PAQ");

var $4zu6H = parcelRequire("4zu6H");

var $8xb3a = parcelRequire("8xb3a");

var $asu8X = parcelRequire("asu8X");

var $byn9U = parcelRequire("byn9U");
const $04e07ab863de3221$var$AISummaryBlockResolvedView = (props)=>{
    (0, $asu8X.di)((0, $04PAQ.default), (0, $4zu6H.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $04PAQ.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $eUqFw.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...props,
        direction: (0, $caOA9.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ overrideCss: (0, $byn9U.css)("overflow:visible;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.overrideCss)
    }, status === 'done' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8xb3a.default), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3FvFV.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zu6H.default), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    })));
};
var $04e07ab863de3221$export$2e2bcd8739ae039 = $04e07ab863de3221$var$AISummaryBlockResolvedView;

});
parcelRegister("3FvFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $470ec6acac7c72bd$export$2e2bcd8739ae039);

var $b5IAe = parcelRequire("b5IAe");

var $eUqFw = parcelRequire("eUqFw");
const $470ec6acac7c72bd$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $eUqFw.useState)(0);
    const ref = (0, $eUqFw.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $eUqFw.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref
    }, children) : null;
};
var $470ec6acac7c72bd$export$2e2bcd8739ae039 = $470ec6acac7c72bd$export$6118ed0013927eb2;

});

parcelRegister("4zu6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $aae60e2ff2b3e6cc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $27B3S = parcelRequire("27B3S");

var $byn9U = parcelRequire("byn9U");

var $fRvRW = parcelRequire("fRvRW");
function $aae60e2ff2b3e6cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aae60e2ff2b3e6cc$var$AISummaryCSSStyles = {
    name: "178flxl",
    styles: "font-size:0.75rem;line-height:1rem;word-wrap:break-word;word-break:break-word;white-space:normal;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text"
};
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $aae60e2ff2b3e6cc$var$AISummary = ({ content: content = '', overrideCss: overrideCss, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27B3S.default), {
        "data-testid": testId,
        css: [
            $aae60e2ff2b3e6cc$var$AISummaryCSSStyles,
            overrideCss
        ],
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $fRvRW.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $aae60e2ff2b3e6cc$export$2e2bcd8739ae039 = $aae60e2ff2b3e6cc$var$AISummary;

});
parcelRegister("27B3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b8fbd7df5541f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $18b8fbd7df5541f7$var$n() {
    return $18b8fbd7df5541f7$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var t = arguments[n];
            for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e;
    }, $18b8fbd7df5541f7$var$n.apply(this, arguments);
}
const $18b8fbd7df5541f7$var$t = [
    "children",
    "options"
];
var $18b8fbd7df5541f7$export$e0aa44767d8750d5, $18b8fbd7df5541f7$var$i;
!function(e) {
    e.blockQuote = "0", e.breakLine = "1", e.breakThematic = "2", e.codeBlock = "3", e.codeFenced = "4", e.codeInline = "5", e.footnote = "6", e.footnoteReference = "7", e.gfmTask = "8", e.heading = "9", e.headingSetext = "10", e.htmlBlock = "11", e.htmlComment = "12", e.htmlSelfClosing = "13", e.image = "14", e.link = "15", e.linkAngleBraceStyleDetector = "16", e.linkBareUrlDetector = "17", e.linkMailtoDetector = "18", e.newlineCoalescer = "19", e.orderedList = "20", e.paragraph = "21", e.ref = "22", e.refImage = "23", e.refLink = "24", e.table = "25", e.tableSeparator = "26", e.text = "27", e.textBolded = "28", e.textEmphasized = "29", e.textEscaped = "30", e.textMarked = "31", e.textStrikethroughed = "32", e.unorderedList = "33";
}($18b8fbd7df5541f7$export$e0aa44767d8750d5 || ($18b8fbd7df5541f7$export$e0aa44767d8750d5 = {})), function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($18b8fbd7df5541f7$var$i || ($18b8fbd7df5541f7$var$i = {}));
const $18b8fbd7df5541f7$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, n)=>(e[n.toLowerCase()] = n, e), {
    for: "htmlFor"
}), $18b8fbd7df5541f7$var$o = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $18b8fbd7df5541f7$var$c = [
    "style",
    "script"
], $18b8fbd7df5541f7$var$a = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $18b8fbd7df5541f7$var$s = /mailto:/i, $18b8fbd7df5541f7$var$d = /\n{2,}$/, $18b8fbd7df5541f7$var$u = /^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/, $18b8fbd7df5541f7$var$p = /^ *> ?/gm, $18b8fbd7df5541f7$var$f = /^ {2,}\n/, $18b8fbd7df5541f7$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $18b8fbd7df5541f7$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $18b8fbd7df5541f7$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $18b8fbd7df5541f7$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $18b8fbd7df5541f7$var$k = /^(?:\n *)*\n/, $18b8fbd7df5541f7$var$x = /\r\n?/g, $18b8fbd7df5541f7$var$v = /^\[\^([^\]]+)](:.*)\n/, $18b8fbd7df5541f7$var$b = /^\[\^([^\]]+)]/, $18b8fbd7df5541f7$var$$ = /\f/g, $18b8fbd7df5541f7$var$S = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $18b8fbd7df5541f7$var$w = /^\s*?\[(x|\s)\]/, $18b8fbd7df5541f7$var$C = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $18b8fbd7df5541f7$var$E = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $18b8fbd7df5541f7$var$A = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $18b8fbd7df5541f7$var$O = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i, $18b8fbd7df5541f7$var$T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $18b8fbd7df5541f7$var$L = /^<!--[\s\S]*?(?:-->)/, $18b8fbd7df5541f7$var$z = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $18b8fbd7df5541f7$var$M = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $18b8fbd7df5541f7$var$I = /^\{.*\}$/, $18b8fbd7df5541f7$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $18b8fbd7df5541f7$var$U = /^<([^ >]+@[^ >]+)>/, $18b8fbd7df5541f7$var$j = /^<([^ >]+:\/[^ >]+)>/, $18b8fbd7df5541f7$var$B = /-([a-z])?/gi, $18b8fbd7df5541f7$var$N = /^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/, $18b8fbd7df5541f7$var$H = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $18b8fbd7df5541f7$var$D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $18b8fbd7df5541f7$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $18b8fbd7df5541f7$var$_ = /(\[|\])/g, $18b8fbd7df5541f7$var$F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $18b8fbd7df5541f7$var$W = /\t/g, $18b8fbd7df5541f7$var$G = /^ *\| */, $18b8fbd7df5541f7$var$Z = /(^ *\||\| *$)/g, $18b8fbd7df5541f7$var$q = / *$/, $18b8fbd7df5541f7$var$V = /^ *:-+: *$/, $18b8fbd7df5541f7$var$X = /^ *:-+ *$/, $18b8fbd7df5541f7$var$Q = /^ *-+: *$/, $18b8fbd7df5541f7$var$J = /^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/, $18b8fbd7df5541f7$var$K = /^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/, $18b8fbd7df5541f7$var$Y = /^==((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)==/, $18b8fbd7df5541f7$var$ee = /^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/, $18b8fbd7df5541f7$var$ne = /^\\([^0-9A-Za-z\s])/, $18b8fbd7df5541f7$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $18b8fbd7df5541f7$var$re = /^\n+/, $18b8fbd7df5541f7$var$ie = /^([ \t]*)/, $18b8fbd7df5541f7$var$le = /\\([^\\])/g, $18b8fbd7df5541f7$var$oe = / *\n+$/, $18b8fbd7df5541f7$var$ce = /(?:^|\n)( *)$/, $18b8fbd7df5541f7$var$ae = "(?:\\d+\\.)", $18b8fbd7df5541f7$var$se = "(?:[*+-])";
function $18b8fbd7df5541f7$var$de(e) {
    return "( *)(" + (1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se) + ") +";
}
const $18b8fbd7df5541f7$var$ue = $18b8fbd7df5541f7$var$de(1), $18b8fbd7df5541f7$var$pe = $18b8fbd7df5541f7$var$de(2);
function $18b8fbd7df5541f7$var$fe(e) {
    return new RegExp("^" + (1 === e ? $18b8fbd7df5541f7$var$ue : $18b8fbd7df5541f7$var$pe));
}
const $18b8fbd7df5541f7$var$he = $18b8fbd7df5541f7$var$fe(1), $18b8fbd7df5541f7$var$me = $18b8fbd7df5541f7$var$fe(2);
function $18b8fbd7df5541f7$var$ge(e) {
    return new RegExp("^" + (1 === e ? $18b8fbd7df5541f7$var$ue : $18b8fbd7df5541f7$var$pe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $18b8fbd7df5541f7$var$ye = $18b8fbd7df5541f7$var$ge(1), $18b8fbd7df5541f7$var$ke = $18b8fbd7df5541f7$var$ge(2);
function $18b8fbd7df5541f7$var$xe(e) {
    const n = 1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se;
    return new RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
const $18b8fbd7df5541f7$var$ve = $18b8fbd7df5541f7$var$xe(1), $18b8fbd7df5541f7$var$be = $18b8fbd7df5541f7$var$xe(2);
function $18b8fbd7df5541f7$var$$e(e, n) {
    const t = 1 === n, r = t ? $18b8fbd7df5541f7$var$ve : $18b8fbd7df5541f7$var$be, i = t ? $18b8fbd7df5541f7$var$ye : $18b8fbd7df5541f7$var$ke, l = t ? $18b8fbd7df5541f7$var$he : $18b8fbd7df5541f7$var$me;
    return {
        match (e, n, t) {
            const i = $18b8fbd7df5541f7$var$ce.exec(t);
            return i && (n.list || !n.inline && !n.simple) ? r.exec(e = i[1] + e) : null;
        },
        order: 1,
        parse (e, n, r) {
            const o = t ? +e[2] : void 0, c = e[0].replace($18b8fbd7df5541f7$var$d, "\n").match(i);
            let a = !1;
            return {
                items: c.map(function(e, t) {
                    const i = l.exec(e)[0].length, o = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(o, "").replace(l, ""), d = t === c.length - 1, u = -1 !== s.indexOf("\n\n") || d && a;
                    a = u;
                    const p = r.inline, f = r.list;
                    let h;
                    r.list = !0, u ? (r.inline = !1, h = s.replace($18b8fbd7df5541f7$var$oe, "\n\n")) : (r.inline = !0, h = s.replace($18b8fbd7df5541f7$var$oe, ""));
                    const m = n(h, r);
                    return r.inline = p, r.list = f, m;
                }),
                ordered: t,
                start: o
            };
        },
        render: (n, t, r)=>e(n.ordered ? "ol" : "ul", {
                key: r.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, i) {
                return e("li", {
                    key: i
                }, t(n, r));
            }))
    };
}
const $18b8fbd7df5541f7$var$Se = /^\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $18b8fbd7df5541f7$var$we = /^!\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $18b8fbd7df5541f7$var$Ce = [
    $18b8fbd7df5541f7$var$u,
    $18b8fbd7df5541f7$var$m,
    $18b8fbd7df5541f7$var$g,
    $18b8fbd7df5541f7$var$C,
    $18b8fbd7df5541f7$var$A,
    $18b8fbd7df5541f7$var$E,
    $18b8fbd7df5541f7$var$L,
    $18b8fbd7df5541f7$var$N,
    $18b8fbd7df5541f7$var$ye,
    $18b8fbd7df5541f7$var$ve,
    $18b8fbd7df5541f7$var$ke,
    $18b8fbd7df5541f7$var$be
], $18b8fbd7df5541f7$var$Ee = [
    ...$18b8fbd7df5541f7$var$Ce,
    /^[^\n]+(?:  \n|\n{2,})/,
    $18b8fbd7df5541f7$var$O,
    $18b8fbd7df5541f7$var$M
];
function $18b8fbd7df5541f7$var$Ae(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $18b8fbd7df5541f7$var$Oe(e) {
    return $18b8fbd7df5541f7$var$Q.test(e) ? "right" : $18b8fbd7df5541f7$var$V.test(e) ? "center" : $18b8fbd7df5541f7$var$X.test(e) ? "left" : null;
}
function $18b8fbd7df5541f7$var$Te(e, n, t) {
    const r = t.inTable;
    t.inTable = !0;
    const i = n(e.trim(), t);
    t.inTable = r;
    let l = [
        []
    ];
    return i.forEach(function(e, n) {
        "26" === e.type ? 0 !== n && n !== i.length - 1 && l.push([]) : ("27" !== e.type || null != i[n + 1] && "26" !== i[n + 1].type || (e.text = e.text.replace($18b8fbd7df5541f7$var$q, "")), l[l.length - 1].push(e));
    }), l;
}
function $18b8fbd7df5541f7$var$Le(e, n, t) {
    t.inline = !0;
    const r = $18b8fbd7df5541f7$var$Te(e[1], n, t), i = e[2].replace($18b8fbd7df5541f7$var$Z, "").split("|").map($18b8fbd7df5541f7$var$Oe), l = function(e, n, t) {
        return e.trim().split("\n").map(function(e) {
            return $18b8fbd7df5541f7$var$Te(e, n, t);
        });
    }(e[3], n, t);
    return t.inline = !1, {
        align: i,
        cells: l,
        header: r,
        type: "25"
    };
}
function $18b8fbd7df5541f7$var$ze(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $18b8fbd7df5541f7$var$Me(e) {
    return function(n, t) {
        return t.inline ? e.exec(n) : null;
    };
}
function $18b8fbd7df5541f7$var$Ie(e) {
    return function(n, t) {
        return t.inline || t.simple ? e.exec(n) : null;
    };
}
function $18b8fbd7df5541f7$var$Re(e) {
    return function(n, t) {
        return t.inline || t.simple ? null : e.exec(n);
    };
}
function $18b8fbd7df5541f7$var$Ue(e) {
    return function(n) {
        return e.exec(n);
    };
}
function $18b8fbd7df5541f7$var$je(e, n, t) {
    if (n.inline || n.simple) return null;
    if (t && !t.endsWith("\n")) return null;
    let r = "";
    e.split("\n").every((e)=>!$18b8fbd7df5541f7$var$Ce.some((n)=>n.test(e)) && (r += e + "\n", e.trim()));
    const i = r.trimEnd();
    return "" == i ? null : [
        r,
        i
    ];
}
function $18b8fbd7df5541f7$var$Be(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
    } catch (e) {
        return null;
    }
    return e;
}
function $18b8fbd7df5541f7$var$Ne(e) {
    return e.replace($18b8fbd7df5541f7$var$le, "$1");
}
function $18b8fbd7df5541f7$var$He(e, n, t) {
    const r = t.inline || !1, i = t.simple || !1;
    t.inline = !0, t.simple = !0;
    const l = e(n, t);
    return t.inline = r, t.simple = i, l;
}
function $18b8fbd7df5541f7$var$De(e, n, t) {
    const r = t.inline || !1, i = t.simple || !1;
    t.inline = !1, t.simple = !0;
    const l = e(n, t);
    return t.inline = r, t.simple = i, l;
}
function $18b8fbd7df5541f7$var$Pe(e, n, t) {
    return t.inline = !1, e(n, t);
}
const $18b8fbd7df5541f7$var$_e = (e, n, t)=>({
        children: $18b8fbd7df5541f7$var$He(n, e[1], t)
    });
function $18b8fbd7df5541f7$var$Fe() {
    return {};
}
function $18b8fbd7df5541f7$var$We() {
    return null;
}
function $18b8fbd7df5541f7$var$Ge(...e) {
    return e.filter(Boolean).join(" ");
}
function $18b8fbd7df5541f7$var$Ze(e, n, t) {
    let r = e;
    const i = n.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || t;
}
function $18b8fbd7df5541f7$export$69f434acfbdb0b32(t, r = {}) {
    r.overrides = r.overrides || {}, r.slugify = r.slugify || $18b8fbd7df5541f7$var$Ae, r.namedCodesToUnicode = r.namedCodesToUnicode ? $18b8fbd7df5541f7$var$n({}, $18b8fbd7df5541f7$var$o, r.namedCodesToUnicode) : $18b8fbd7df5541f7$var$o;
    const i = r.createElement || $eUqFw.createElement;
    function d(e, t, ...l) {
        const o = $18b8fbd7df5541f7$var$Ze(r.overrides, `${e}.props`, {});
        return i(function(e, n) {
            const t = $18b8fbd7df5541f7$var$Ze(n, e);
            return t ? "function" == typeof t || "object" == typeof t && "render" in t ? t : $18b8fbd7df5541f7$var$Ze(n, `${e}.component`, e) : e;
        }(e, r.overrides), $18b8fbd7df5541f7$var$n({}, t, o, {
            className: $18b8fbd7df5541f7$var$Ge(null == t ? void 0 : t.className, o.className) || void 0
        }), ...l);
    }
    function Z(n) {
        n = n.replace($18b8fbd7df5541f7$var$S, "");
        let t = !1;
        r.forceInline ? t = !0 : r.forceBlock || (t = !1 === $18b8fbd7df5541f7$var$F.test(n));
        const i = oe(le(t ? n : `${n.trimEnd().replace($18b8fbd7df5541f7$var$re, "")}\n\n`, {
            inline: t
        }));
        for(; "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();)i.pop();
        if (null === r.wrapper) return i;
        const l = r.wrapper || (t ? "span" : "div");
        let o;
        if (i.length > 1 || r.forceWrapper) o = i;
        else {
            if (1 === i.length) return o = i[0], "string" == typeof o ? d("span", {
                key: "outer"
            }, o) : o;
            o = null;
        }
        return $eUqFw.createElement(l, {
            key: "outer"
        }, o);
    }
    function q(n) {
        const t = n.match($18b8fbd7df5541f7$var$a);
        return t ? t.reduce(function(n, t, r) {
            const i = t.indexOf("=");
            if (-1 !== i) {
                const o = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($18b8fbd7df5541f7$var$z) && (e = e.replace($18b8fbd7df5541f7$var$B, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(t.slice(0, i)).trim(), c = function(e) {
                    const n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(t.slice(i + 1).trim()), a = $18b8fbd7df5541f7$var$l[o] || o, s = n[a] = function(e, n) {
                    return "style" === e ? n.split(/;\s?/).reduce(function(e, n) {
                        const t = n.slice(0, n.indexOf(":"));
                        return e[t.replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = n.slice(t.length + 1).trim(), e;
                    }, {}) : "href" === e || "src" === e ? $18b8fbd7df5541f7$var$Be(n) : (n.match($18b8fbd7df5541f7$var$I) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(o, c);
                "string" == typeof s && ($18b8fbd7df5541f7$var$O.test(s) || $18b8fbd7df5541f7$var$M.test(s)) && (n[a] = $eUqFw.cloneElement(Z(s.trim()), {
                    key: r
                }));
            } else "style" !== t && (n[$18b8fbd7df5541f7$var$l[t] || t] = !0);
            return n;
        }, {}) : null;
    }
    const V = [], X = {}, Q = {
        0: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$u),
            order: 1,
            parse: (e, n, t)=>({
                    children: n(e[0].replace($18b8fbd7df5541f7$var$p, ""), t)
                }),
            render: (e, n, t)=>d("blockquote", {
                    key: t.key
                }, n(e.children, t))
        },
        1: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$f),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: (e, n, t)=>d("br", {
                    key: t.key
                })
        },
        2: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$h),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: (e, n, t)=>d("hr", {
                    key: t.key
                })
        },
        3: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, t, r)=>d("pre", {
                    key: r.key
                }, d("code", $18b8fbd7df5541f7$var$n({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        4: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: q(e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: "3"
                })
        },
        5: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, n, t)=>d("code", {
                    key: t.key
                }, e.text)
        },
        6: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$v),
            order: 0,
            parse: (e)=>(V.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $18b8fbd7df5541f7$var$We
        },
        7: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$b),
            order: 1,
            parse: (e)=>({
                    target: `#${r.slugify(e[1])}`,
                    text: e[1]
                }),
            render: (e, n, t)=>d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(e.target)
                }, d("sup", {
                    key: t.key
                }, e.text))
        },
        8: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$w),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, n, t)=>d("input", {
                    checked: e.completed,
                    key: t.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        9: {
            match: $18b8fbd7df5541f7$var$Re(r.enforceAtxHeadings ? $18b8fbd7df5541f7$var$E : $18b8fbd7df5541f7$var$C),
            order: 1,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$He(n, e[2], t),
                    id: r.slugify(e[2]),
                    level: e[1].length
                }),
            render: (e, n, t)=>d(`h${e.level}`, {
                    id: e.id,
                    key: t.key
                }, n(e.children, t))
        },
        10: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$A),
            order: 0,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$He(n, e[1], t),
                    level: "=" === e[2] ? 1 : 2,
                    type: "9"
                })
        },
        11: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$O),
            order: 1,
            parse (e, n, t) {
                const [, r] = e[3].match($18b8fbd7df5541f7$var$ie), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), o = (a = l, $18b8fbd7df5541f7$var$Ee.some((e)=>e.test(a)) ? $18b8fbd7df5541f7$var$Pe : $18b8fbd7df5541f7$var$He);
                var a;
                const s = e[1].toLowerCase(), d = -1 !== $18b8fbd7df5541f7$var$c.indexOf(s), u = {
                    attrs: q(e[2]),
                    noInnerParse: d,
                    tag: d ? s : e[1]
                };
                return t.inAnchor = t.inAnchor || "a" === s, d ? u.text = e[3] : u.children = o(n, l, t), t.inAnchor = !1, u;
            },
            render: (e, t, r)=>d(e.tag, $18b8fbd7df5541f7$var$n({
                    key: r.key
                }, e.attrs), e.text || t(e.children, r))
        },
        13: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$M),
            order: 1,
            parse: (e)=>({
                    attrs: q(e[2] || ""),
                    tag: e[1]
                }),
            render: (e, t, r)=>d(e.tag, $18b8fbd7df5541f7$var$n({}, e.attrs, {
                    key: r.key
                }))
        },
        12: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$L),
            order: 1,
            parse: ()=>({}),
            render: $18b8fbd7df5541f7$var$We
        },
        14: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$we),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $18b8fbd7df5541f7$var$Ne(e[2]),
                    title: e[3]
                }),
            render: (e, n, t)=>d("img", {
                    key: t.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: $18b8fbd7df5541f7$var$Be(e.target)
                })
        },
        15: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$Se),
            order: 3,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$De(n, e[1], t),
                    target: $18b8fbd7df5541f7$var$Ne(e[2]),
                    title: e[3]
                }),
            render: (e, n, t)=>d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(e.target),
                    title: e.title
                }, n(e.children, t))
        },
        16: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$j),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    type: "15"
                })
        },
        17: {
            match: (e, n)=>n.inAnchor ? null : $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$R)(e, n),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: "15"
                })
        },
        18: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$U),
            order: 0,
            parse (e) {
                let n = e[1], t = e[1];
                return $18b8fbd7df5541f7$var$s.test(t) || (t = "mailto:" + t), {
                    children: [
                        {
                            text: n.replace("mailto:", ""),
                            type: "27"
                        }
                    ],
                    target: t,
                    type: "15"
                };
            }
        },
        20: $18b8fbd7df5541f7$var$$e(d, 1),
        33: $18b8fbd7df5541f7$var$$e(d, 2),
        19: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$k),
            order: 3,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: ()=>"\n"
        },
        21: {
            match: $18b8fbd7df5541f7$var$je,
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("p", {
                    key: t.key
                }, n(e.children, t))
        },
        22: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$H),
            order: 0,
            parse: (e)=>(X[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $18b8fbd7df5541f7$var$We
        },
        23: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$D),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, n, t)=>d("img", {
                    key: t.key,
                    alt: e.alt,
                    src: $18b8fbd7df5541f7$var$Be(X[e.ref].target),
                    title: X[e.ref].title
                })
        },
        24: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$P),
            order: 0,
            parse: (e, n, t)=>({
                    children: n(e[1], t),
                    fallbackChildren: n(e[0].replace($18b8fbd7df5541f7$var$_, "\\$1"), t),
                    ref: e[2]
                }),
            render: (e, n, t)=>X[e.ref] ? d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(X[e.ref].target),
                    title: X[e.ref].title
                }, n(e.children, t)) : d("span", {
                    key: t.key
                }, n(e.fallbackChildren, t))
        },
        25: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$N),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Le,
            render: (e, n, t)=>d("table", {
                    key: t.key
                }, d("thead", null, d("tr", null, e.header.map(function(r, i) {
                    return d("th", {
                        key: i,
                        style: $18b8fbd7df5541f7$var$ze(e, i)
                    }, n(r, t));
                }))), d("tbody", null, e.cells.map(function(r, i) {
                    return d("tr", {
                        key: i
                    }, r.map(function(r, i) {
                        return d("td", {
                            key: i,
                            style: $18b8fbd7df5541f7$var$ze(e, i)
                        }, n(r, t));
                    }));
                })))
        },
        26: {
            match: function(e, n) {
                return n.inTable ? (n.inline = !0, $18b8fbd7df5541f7$var$G.exec(e)) : null;
            },
            order: 1,
            parse: function() {
                return {
                    type: "26"
                };
            },
            render: ()=>" | "
        },
        27: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$te),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($18b8fbd7df5541f7$var$T, (e, n)=>r.namedCodesToUnicode[n] ? r.namedCodesToUnicode[n] : e)
                }),
            render: (e)=>e.text
        },
        28: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$J),
            order: 2,
            parse: (e, n, t)=>({
                    children: n(e[2], t)
                }),
            render: (e, n, t)=>d("strong", {
                    key: t.key
                }, n(e.children, t))
        },
        29: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$K),
            order: 3,
            parse: (e, n, t)=>({
                    children: n(e[2], t)
                }),
            render: (e, n, t)=>d("em", {
                    key: t.key
                }, n(e.children, t))
        },
        30: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$ne),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: "27"
                })
        },
        31: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$Y),
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("mark", {
                    key: t.key
                }, n(e.children, t))
        },
        32: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$ee),
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("del", {
                    key: t.key
                }, n(e.children, t))
        }
    };
    !0 === r.disableParsingRawHTML && (delete Q[11], delete Q[13]);
    const le = function(e) {
        let n = Object.keys(e);
        function t(r, i) {
            let l = [], o = "";
            for(; r;){
                let c = 0;
                for(; c < n.length;){
                    const a = n[c], s = e[a], d = s.match(r, i, o);
                    if (d) {
                        const e = d[0];
                        r = r.substring(e.length);
                        const n = s.parse(d, t, i);
                        null == n.type && (n.type = a), l.push(n), o = e;
                        break;
                    }
                    c++;
                }
            }
            return l;
        }
        return n.sort(function(n, t) {
            let r = e[n].order, i = e[t].order;
            return r !== i ? r - i : 1;
        }), function(e, n) {
            return t(function(e) {
                return e.replace($18b8fbd7df5541f7$var$x, "\n").replace($18b8fbd7df5541f7$var$$, "").replace($18b8fbd7df5541f7$var$W, "    ");
            }(e), n);
        };
    }(Q), oe = (ce = function(e, n) {
        return function(t, r, i) {
            const l = e[t.type].render;
            return n ? n(()=>l(t, r, i), t, r, i) : l(t, r, i);
        };
    }(Q, r.renderRule), function e(n, t = {}) {
        if (Array.isArray(n)) {
            const r = t.key, i = [];
            let l = !1;
            for(let r = 0; r < n.length; r++){
                t.key = r;
                const o = e(n[r], t), c = "string" == typeof o;
                c && l ? i[i.length - 1] += o : null !== o && i.push(o), l = c;
            }
            return t.key = r, i;
        }
        return ce(n, e, t);
    });
    var ce;
    const ae = Z(t);
    return V.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, V.map(function(e) {
        return d("div", {
            id: r.slugify(e.identifier),
            key: e.identifier
        }, e.identifier, oe(le(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $18b8fbd7df5541f7$export$2e2bcd8739ae039 = (n)=>{
    let { children: r, options: i } = n, l = function(e, n) {
        if (null == e) return {};
        var t, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)n.indexOf(t = l[r]) >= 0 || (i[t] = e[t]);
        return i;
    }(n, $18b8fbd7df5541f7$var$t);
    return $eUqFw.cloneElement($18b8fbd7df5541f7$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("fRvRW", function(module, exports) {

$parcel$export(module.exports, "default", () => $215caff20423c5d7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $215caff20423c5d7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $215caff20423c5d7$var$listStyles = {
    name: "k4jzwf",
    styles: "padding-left:var(--ds-space-250, 20px);padding-inline-start:var(--ds-space-250, 20px)"
};
const $215caff20423c5d7$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        css: $215caff20423c5d7$var$listStyles,
        ...props
    }, children);
var $215caff20423c5d7$export$2e2bcd8739ae039 = $215caff20423c5d7$var$UList;

});


parcelRegister("8xb3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc0ebde4df0a9cbc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $45sl7 = parcelRequire("45sl7");
const $bc0ebde4df0a9cbc$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $bc0ebde4df0a9cbc$export$2e2bcd8739ae039 = $bc0ebde4df0a9cbc$var$AIEventSummaryViewed;

});



parcelRegister("jgolE", function(module, exports) {

$parcel$export(module.exports, "default", () => $64f51aa4942c7ea2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4AgCU = parcelRequire("4AgCU");

var $caOA9 = parcelRequire("caOA9");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $64f51aa4942c7ea2$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4AgCU.default), {
        ...props,
        testId: testId
    });
};
var $64f51aa4942c7ea2$export$2e2bcd8739ae039 = $64f51aa4942c7ea2$var$AIFooterBlock;

});
parcelRegister("4AgCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4ddf1676e35a244$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4sQhG = parcelRequire("4sQhG");

var $bampN = parcelRequire("bampN");

var $caOA9 = parcelRequire("caOA9");

var $7IEJa = parcelRequire("7IEJa");

var $4AAjx = parcelRequire("4AAjx");
const $f4ddf1676e35a244$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.Provider), {
        testId: `${testId}-provider`
    }), actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7IEJa.AIFooterMetadata), {
        ...actionData,
        testId: `${testId}-ai-metadata`
    }) : null);
};
var $f4ddf1676e35a244$export$2e2bcd8739ae039 = $f4ddf1676e35a244$var$AIFooterBlockResolvedView;

});
parcelRegister("7IEJa", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $de37226e2d74f64d$export$175228cc2c92b3b6);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $asu8X = parcelRequire("asu8X");

var $8uD7Y = parcelRequire("8uD7Y");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");

var $fN7pY = parcelRequire("fN7pY");

var $f9UoZ = parcelRequire("f9UoZ");

var $4abrz = parcelRequire("4abrz");

var $04PAQ = parcelRequire("04PAQ");
const $de37226e2d74f64d$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $asu8X.di)((0, $04PAQ.default));
    const { state: { status: status } } = (0, $04PAQ.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).ai_summarized_info_short),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9UoZ.InfoIcon), {
            label: "Information",
            size: "small",
            primaryColor: "var(--ds-icon-subtle, #626F86)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fN7pY.default), {
        label: "AI",
        size: "small",
        primaryColor: "var(--ds-icon-subtle, #626F86)"
    }));
};

});
parcelRegister("f9UoZ", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $73dd1366f48d3276$export$2957fc44b3d2481);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $73dd1366f48d3276$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
        fill: "currentColor"
    }));
const $73dd1366f48d3276$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        ...props,
        glyph: $73dd1366f48d3276$var$CustomGlyph
    });

});




parcelRegister("5I51G", function(module, exports) {

$parcel$export(module.exports, "default", () => $af32a75a0d93a295$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $4AAjx = parcelRequire("4AAjx");

var $eJljw = parcelRequire("eJljw");

var $4z862 = parcelRequire("4z862");

var $kbWJ8 = parcelRequire("kbWJ8");

var $asu8X = parcelRequire("asu8X");
function $af32a75a0d93a295$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $af32a75a0d93a295$var$ignoreContainerPaddingStyles = {
    name: "19m4cma",
    styles: "display:flex;flex-direction:column;box-sizing:border-box;flex-grow:1;width:100%;margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1)"
};
const $af32a75a0d93a295$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $af32a75a0d93a295$var$sort = (a, b)=>{
    let idxA = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $af32a75a0d93a295$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, testId: testId = 'smart-block-action' })=>{
    (0, $asu8X.di)((0, $kbWJ8.ActionFooter));
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const ui = (0, $4AAjx.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $eUqFw.useState)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const onLoadingChange = (0, $eUqFw.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? (0, $4z862.getPrimitivesPaddingSpaceBySize)(ui?.size || (0, $caOA9.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $eUqFw.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $eUqFw.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $eUqFw.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($af32a75a0d93a295$var$sort);
        return arr.map((name)=>{
            const Action = name in $eJljw ? $eJljw[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $byn9U.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                xcss: (0, $1ZAYh.xcss)({
                    paddingInline: padding
                }),
                hideTooltip: isLoading
            }) : null;
        });
    }, [
        context?.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $af32a75a0d93a295$var$ignoreContainerPaddingStyles,
        ref: blockRef,
        "data-testid": testId
    }, actions, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbWJ8.ActionFooter), {
        message: message,
        paddingInline: padding,
        testId: testId
    })) : null;
};
var $af32a75a0d93a295$export$2e2bcd8739ae039 = $af32a75a0d93a295$var$ActionBlock;

});
parcelRegister("kbWJ8", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $9ecf2b3307383602$export$2d2b754ac238f9aa);

var $96IgR = parcelRequire("96IgR");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $eUqFw = parcelRequire("eUqFw");

var $3FvFV = parcelRequire("3FvFV");
const $9ecf2b3307383602$var$containerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    borderRadius: 'border.radius',
    margin: 'space.100',
    marginBottom: 'space.0',
    lineHeight: '20px',
    padding: 'space.075',
    paddingInline: 'space.100',
    width: '100%',
    ':empty': {
        display: 'none'
    }
});
const $9ecf2b3307383602$var$errorStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.danger'
});
const $9ecf2b3307383602$var$titleStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '16px'
});
const $9ecf2b3307383602$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                primaryColor: "var(--ds-icon-danger, #C9372C)",
                label: "Error",
                size: "small",
                testId: "action-error-icon"
            }));
        default:
            return null;
    }
};
const $9ecf2b3307383602$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: `${testId}-footer`,
        xcss: [
            $9ecf2b3307383602$var$containerStyles,
            message.appearance === 'error' && $9ecf2b3307383602$var$errorStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3FvFV.default), {
        isFadeIn: true,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "start",
        grow: "fill",
        space: "space.050"
    }, message.icon || $9ecf2b3307383602$var$getIcon(message.appearance), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9ecf2b3307383602$var$titleStyles
    }, message.title))));
};

});




parcelRegister("5SeSf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jvifZ")
]).then(()=>parcelRequire('2lOE6'));

});



parcelRegister("aml13", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $ddfb038c93ff29bc$export$497ecb0280204df4);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $cGAGh = parcelRequire("cGAGh");

var $fQDHB = parcelRequire("fQDHB");

var $aatVr = parcelRequire("aatVr");

var $gqldc = parcelRequire("gqldc");

var $1Hojg = parcelRequire("1Hojg");
function $ddfb038c93ff29bc$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
    const parentContext = (0, $eUqFw.useContext)((0, $gqldc.SmartCardContext));
    const defaultInitialState = (0, $eUqFw.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $eUqFw.useMemo)(()=>{
        return (0, $huRi7.createStore)((0, $aatVr.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $eUqFw.useMemo)(()=>{
        const client = customClient || new (0, $1Hojg.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $cGAGh.getUrl)(store, url);
            return cardState.details ? (0, $fQDHB.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gqldc.SmartCardContext).Provider, {
        value: parentContext || providerValue
    }, children);
}
var $ddfb038c93ff29bc$export$2e2bcd8739ae039 = $ddfb038c93ff29bc$export$497ecb0280204df4;

});
parcelRegister("aatVr", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $f4cdd08462296438$export$3c7c3113a97b6492);

var $6EHO5 = parcelRequire("6EHO5");
var $4hPjC = parcelRequire("4hPjC");
const $f4cdd08462296438$var$isCardAction = (action)=>{
    return [
        (0, $6EHO5.ACTION_PENDING),
        (0, $6EHO5.ACTION_RESOLVING),
        (0, $6EHO5.ACTION_RESOLVED),
        (0, $6EHO5.ACTION_RELOADING),
        (0, $6EHO5.ACTION_ERROR),
        (0, $6EHO5.ACTION_ERROR_FALLBACK),
        (0, $6EHO5.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $f4cdd08462296438$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $4hPjC.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $f4cdd08462296438$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $6EHO5.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVED:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $6EHO5.ACTION_RELOADING:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $6EHO5.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $6EHO5.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $6EHO5.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $f4cdd08462296438$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$f4cdd08462296438$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $f4cdd08462296438$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});

parcelRegister("1Hojg", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d12fbaea01fc74$export$2e2bcd8739ae039);

var $1l2Nv = parcelRequire("1l2Nv");

var $aTD8J = parcelRequire("aTD8J");

var $bsIpz = parcelRequire("bsIpz");

var $f9yXU = parcelRequire("f9yXU");
var $dUrSu = parcelRequire("dUrSu");
var $4hPjC = parcelRequire("4hPjC");
var $5LW2w = parcelRequire("5LW2w");

var $gbc85 = parcelRequire("gbc85");

var $6roQF = parcelRequire("6roQF");

var $XHGTv = parcelRequire("XHGTv");
const $22d12fbaea01fc74$var$MAX_BATCH_SIZE = 50;
const $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE = 100;
const $22d12fbaea01fc74$export$d6a66073b5d79eb3 = new (0, $6roQF.LRUMap)($22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE);
class $22d12fbaea01fc74$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ ...(0, $XHGTv.fg)('platform.linking-platform.datasource.add-timezone-header') ? {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
                } : {},
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $gbc85.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $dUrSu.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($bsIpz)))({
            limit: 1,
            interval: $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1l2Nv)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $22d12fbaea01fc74$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $22d12fbaea01fc74$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $gbc85.isSuccessfulResponse)(response) || (0, $4hPjC.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $gbc85.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $gbc85.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $gbc85.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $gbc85.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $gbc85.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $5LW2w.NetworkError)) return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $f9yXU.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    return new (0, $f9yXU.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $f9yXU.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $f9yXU.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("1l2Nv", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $0f99ec2102c35890$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $0f99ec2102c35890$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $0f99ec2102c35890$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $0f99ec2102c35890$var$getValidCacheKeyFn(options);
        this._cacheMap = $0f99ec2102c35890$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $0f99ec2102c35890$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $0f99ec2102c35890$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$0f99ec2102c35890$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $0f99ec2102c35890$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$0f99ec2102c35890$var$resolvedPromise) $0f99ec2102c35890$var$resolvedPromise = Promise.resolve();
    $0f99ec2102c35890$var$resolvedPromise.then(function() {
        $2fFJv.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $0f99ec2102c35890$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $0f99ec2102c35890$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $0f99ec2102c35890$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $0f99ec2102c35890$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $0f99ec2102c35890$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$0f99ec2102c35890$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $0f99ec2102c35890$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $0f99ec2102c35890$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $0f99ec2102c35890$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $0f99ec2102c35890$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $0f99ec2102c35890$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $0f99ec2102c35890$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $0f99ec2102c35890$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $0f99ec2102c35890$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $0f99ec2102c35890$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $0f99ec2102c35890$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $0f99ec2102c35890$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $0f99ec2102c35890$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $0f99ec2102c35890$var$DataLoader;

});

parcelRegister("aTD8J", function(module, exports) {
// Packages

var $kiPA0 = parcelRequire("kiPA0");
function $7eed66c63d4af541$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        var op = $kiPA0.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $7eed66c63d4af541$var$retry;

});
parcelRegister("kiPA0", function(module, exports) {

module.exports = (parcelRequire("2aMUW"));

});
parcelRegister("2aMUW", function(module, exports) {

var $6ZiEJ = parcelRequire("6ZiEJ");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $6ZiEJ(timeouts, {
        forever: options && options.forever,
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("6ZiEJ", function(module, exports) {
function $5166e949108ea881$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $5166e949108ea881$var$RetryOperation;
$5166e949108ea881$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts;
};
$5166e949108ea881$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$5166e949108ea881$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(this._errors.length - 1, this._errors.length);
            this._timeouts = this._cachedTimeouts.slice(0);
            timeout = this._timeouts.shift();
        } else return false;
    }
    var self = this;
    var timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) timer.unref();
    return true;
};
$5166e949108ea881$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$5166e949108ea881$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = $5166e949108ea881$var$RetryOperation.prototype.try;
$5166e949108ea881$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$5166e949108ea881$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$5166e949108ea881$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("bsIpz", function(module, exports) {
'use strict';
class $8584c26edaaf8f93$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $8584c26edaaf8f93$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $8584c26edaaf8f93$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $8584c26edaaf8f93$var$pThrottle;
module.exports.AbortError = $8584c26edaaf8f93$var$AbortError;

});

parcelRegister("gbc85", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $fe0c9814ae7f11c7$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $fe0c9814ae7f11c7$export$bea7bee8a87e7c52);
const $fe0c9814ae7f11c7$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $fe0c9814ae7f11c7$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});



parcelRegister("gJOO5", function(module, exports) {

$parcel$export(module.exports, "smartLinkFallback", () => $a676c75de2ddf0d0$export$e684dcf56ac8ae14);

var $eUqFw = parcelRequire("eUqFw");

var $5OdZ3 = parcelRequire("5OdZ3");
const $a676c75de2ddf0d0$export$e684dcf56ac8ae14 = (url)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer"
        }, url);

});

parcelRegister("ibi44", function(module, exports) {

$parcel$export(module.exports, "useKnowledgeFilterService", () => $09b479fbed9cb0f6$export$e7f441744c2ab3f0);
$parcel$export(module.exports, "useKnowledgeFilterFormField", () => $09b479fbed9cb0f6$export$ad221c44afd5157f);

var $eUqFw = parcelRequire("eUqFw");

var $5rVun = parcelRequire("5rVun");

var $dLW3L = parcelRequire("dLW3L");
const $09b479fbed9cb0f6$export$cac55d864f039044 = (0, $eUqFw.createContext)(null);
const $09b479fbed9cb0f6$export$e7f441744c2ab3f0 = ()=>{
    const { siteId: siteId } = (0, $dLW3L.useSiteContext)();
    const serviceContext = (0, $eUqFw.useContext)($09b479fbed9cb0f6$export$cac55d864f039044);
    const knowledgeFilterService = (0, $eUqFw.useMemo)(()=>{
        if (serviceContext) return serviceContext;
        return new (0, $5rVun.KnowledgeFilterServiceImpl)(siteId);
    }, [
        serviceContext,
        siteId
    ]);
    return knowledgeFilterService;
};
const $09b479fbed9cb0f6$export$ad221c44afd5157f = ()=>{
    const { getEntitiesByAris: getEntitiesByAris } = $09b479fbed9cb0f6$export$e7f441744c2ab3f0();
    const getKnowledgeSourcesFromFormFields = (0, $eUqFw.useCallback)((fields)=>{
        const sources = [];
        if (fields.confluenceKnowledgeEnabled) {
            let space_filter = [];
            let parent_filter = [];
            if (fields.confluenceFilterScope?.value === 'pages') fields.confluenceAncestorPageFilters?.forEach((filter)=>{
                parent_filter.push(filter.ari);
            });
            else if (fields.confluenceFilterScope?.value === 'spaces') fields.confluenceSpaceFilters?.forEach((filter)=>{
                space_filter.push(filter.ari);
            });
            sources.push({
                enabled: true,
                source: 'confluence',
                configuration: {
                    parent_filter: parent_filter,
                    space_filter: space_filter
                }
            });
        }
        if (fields.jiraKnowledgeEnabled) sources.push({
            enabled: true,
            source: 'jira',
            configuration: {
                project_filter: fields.jiraProjectFilters?.map((filter)=>filter.ari) ?? []
            }
        });
        if (fields.atlasKnowledgeEnabled) sources.push({
            enabled: true,
            source: 'atlas',
            configuration: undefined
        });
        if (fields.googleDriveKnowledgeEnabled) sources.push({
            enabled: true,
            source: 'google_drive',
            configuration: undefined
        });
        if (fields.microsoftSharePointKnowledgeEnabled) sources.push({
            enabled: true,
            source: 'microsoft_sharepoint',
            configuration: undefined
        });
        if (!sources.length) return {
            enabled: false,
            sources: []
        };
        return {
            enabled: true,
            sources: sources
        };
    }, []);
    const getKnowledgeSourceFieldsFromScaffold = (0, $eUqFw.useCallback)(async (agent)=>{
        let config = {
            knowledgeScope: false
        };
        if (!agent.knowledge_sources?.enabled) return config;
        config.knowledgeScope = true;
        const filterPromises = [];
        for (const { source: source, configuration: knowledgeConfig, enabled: enabled } of agent.knowledge_sources.sources)switch(source){
            case 'confluence':
                config.confluenceKnowledgeEnabled = enabled;
                if (knowledgeConfig.parent_filter.length) filterPromises.push(getEntitiesByAris({
                    aris: knowledgeConfig.parent_filter
                }).then((filters)=>{
                    config.confluenceAncestorPageFilters = filters.map((page)=>({
                            ari: page.ari,
                            label: page.displayName,
                            value: page.ari,
                            url: page.url
                        }));
                    config.confluenceFilterScope = {
                        label: '',
                        value: 'pages'
                    };
                }));
                if (knowledgeConfig.space_filter.length) filterPromises.push(getEntitiesByAris({
                    aris: knowledgeConfig.space_filter
                }).then((filters)=>{
                    config.confluenceSpaceFilters = filters.map((page)=>({
                            ari: page.ari,
                            label: page.displayName,
                            value: page.ari,
                            iconUrl: page.iconUrl,
                            url: page.url
                        }));
                    config.confluenceFilterScope = {
                        label: '',
                        value: 'spaces'
                    };
                }));
                break;
            case 'jira':
                config.jiraKnowledgeEnabled = enabled;
                filterPromises.push(getEntitiesByAris({
                    aris: knowledgeConfig.project_filter
                }).then((filters)=>{
                    config.jiraProjectFilters = filters.map((page)=>({
                            ari: page.ari,
                            label: page.displayName,
                            value: page.ari,
                            iconUrl: page.iconUrl,
                            url: page.url
                        }));
                }));
                break;
            case 'atlas':
                config.atlasKnowledgeEnabled = enabled;
                break;
            case 'google_drive':
                config.googleDriveKnowledgeEnabled = enabled;
                break;
            case 'microsoft_sharepoint':
                config.microsoftSharePointKnowledgeEnabled = enabled;
                break;
        }
        await Promise.all(filterPromises);
        return config;
    }, [
        getEntitiesByAris
    ]);
    return {
        getKnowledgeSourcesFromFormFields: getKnowledgeSourcesFromFormFields,
        getKnowledgeSourceFieldsFromScaffold: getKnowledgeSourceFieldsFromScaffold
    };
};

});
parcelRegister("5rVun", function(module, exports) {

$parcel$export(module.exports, "KnowledgeFilterServiceImpl", () => $ffebdf9067a04a83$export$a0684b2b2bbfab69);

var $eMS3y = parcelRequire("eMS3y");

class $ffebdf9067a04a83$export$a0684b2b2bbfab69 {
    constructor(siteId){
        this.siteId = siteId;
        this.entityTypeToAti = (type)=>{
            switch(type){
                case 'space':
                    return 'ati:cloud:confluence:space';
                case 'page':
                    return 'ati:cloud:confluence:page';
                case 'project':
                    return 'ati:cloud:jira:project';
            }
        };
        this.filterResults = async ({ query: query, entityType: entityType, confluenceSpaces: confluenceSpaces = [] })=>{
            const result = await (0, $eMS3y.fetchAgg)({
                graphQuery: (0, $85c862577a8558ce$export$4bc63ef50ec3954e),
                siteId: this.siteId,
                variables: {
                    query: query,
                    entityAti: this.entityTypeToAti(entityType),
                    confluenceSpaces: confluenceSpaces
                }
            });
            return result?.data?.search?.search?.edges?.map((edge)=>edge.node).map((item)=>({
                    ari: item.ari,
                    displayName: item.displayName,
                    iconUrl: item.iconUrl,
                    spaceKey: item.spaceKey,
                    url: item.url
                }));
        };
        this.getEntitiesByAris = async (options)=>{
            let entities = {
                space: {
                    responseMapper: (response)=>response?.data?.confluence?.spaces?.map((space)=>({
                                ...space,
                                url: space.links.base + space.links.webUi
                            })) ?? [],
                    aris: [],
                    graphQuery: (0, $85c862577a8558ce$export$21da0c227e4ca0b8)
                },
                page: {
                    responseMapper: (response)=>response?.data?.confluence?.pages?.map((page)=>({
                                ...page,
                                url: page.links.base + page.links.webUi
                            })) ?? [],
                    aris: [],
                    graphQuery: (0, $85c862577a8558ce$export$a970d24119afd9d2)
                },
                project: {
                    responseMapper: (response)=>response?.data?.jira?.jiraProjects ?? [],
                    aris: [],
                    graphQuery: (0, $85c862577a8558ce$export$46cf0e4af88c5342)
                }
            };
            for (const ari of options.aris)try {
                const resourceType = ari.split(/[:\/]/)[4];
                if (entities[resourceType]) entities[resourceType].aris.push(ari);
            } catch (error) {
            // Ignore invalid aris
            }
            const aggPromises = [];
            for (const { aris: aris, graphQuery: graphQuery, responseMapper: responseMapper } of Object.values(entities))if (aris.length) aggPromises.push((0, $eMS3y.fetchAgg)({
                graphQuery: graphQuery,
                variables: {
                    aris: aris
                }
            }).then((result)=>{
                return responseMapper(result).map((item)=>({
                        ari: item.ari,
                        displayName: item.displayName,
                        iconUrl: item.iconUrl,
                        spaceKey: item.spaceKey,
                        url: item.url
                    }));
            }));
            const results = await Promise.all(aggPromises);
            return results.flat();
        };
    }
}

});
parcelRegister("eMS3y", function(module, exports) {

$parcel$export(module.exports, "fetchAgg", () => $8abf7bfdfacf7e56$export$f49dad89491f6bf2);
const $8abf7bfdfacf7e56$export$f49dad89491f6bf2 = async ({ siteId: siteId, graphQuery: graphQuery, variables: variables })=>{
    const response = await fetch('/gateway/api/graphql', {
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
            query: graphQuery,
            variables: {
                siteAri: siteId ? `ari:cloud:confluence::site/${siteId}` : undefined,
                ...variables
            }
        })
    });
    const json = await response.json();
    return json;
};

});

const $85c862577a8558ce$export$4bc63ef50ec3954e = `
query ListSpaces($query: String!, $siteAri: String!, $entityAti: String!, $confluenceSpaces: [String!]) {
	search {
		search(
			query: $query
			filters: {
				entities: [$entityAti],
				locations: [$siteAri],
				confluenceFilters: {
					spacesFilter: $confluenceSpaces
				}
			}
			experience: "rovo-chat"
		) {
			edges {
				node {
					ari: id
					displayName: title
					iconUrl
					url
					... on SearchConfluenceSpace {
						spaceKey: key
					}
				}
			}
		}
	}
}
`;
const $85c862577a8558ce$export$46cf0e4af88c5342 = `
query GetProjects($aris: [ID!]!) {
  jira {
    jiraProjects(
      ids: $aris
    ) {
      ari: id
      displayName: name
      iconUrl: avatar {
        small
      }
			url: webUrl
    }
  }
}
`;
const $85c862577a8558ce$export$a970d24119afd9d2 = `
query GetPages($aris: [ID!]!) {
  confluence {
    pages(
      ids: $aris
    ) {
      ari: id
      displayName: title
			links {
        base
        webUi
      }
    }
  }
}
`;
const $85c862577a8558ce$export$21da0c227e4ca0b8 = `
query GetSpaces($aris: [ID!]!) {
  confluence {
    spaces(
      ids: $aris
    ) {
      ari: id
      displayName: name
      iconUrl: icon {
        path
      }
			spaceKey: key
			links {
        base
        webUi
      }
    }
  }
}
`;


parcelRegister("dLW3L", function(module, exports) {

$parcel$export(module.exports, "SiteContext", () => $d5eabfe7ec927315$export$2cab3982d83485b0);
$parcel$export(module.exports, "useSiteContext", () => $d5eabfe7ec927315$export$55c0e3cb4fbc46cf);

var $eUqFw = parcelRequire("eUqFw");
const $d5eabfe7ec927315$export$2cab3982d83485b0 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    siteId: ''
});
const $d5eabfe7ec927315$export$55c0e3cb4fbc46cf = ()=>{
    const context = (0, $eUqFw.useContext)($d5eabfe7ec927315$export$2cab3982d83485b0);
    return context;
};

});


parcelRegister("2Hoee", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb3dbb24552b9f38$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cb3dbb24552b9f38$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noKnowledgeAdded: {
        id: 'rovo-chat.view-agent.no-knowledge-added',
        defaultMessage: 'No custom knowledge sources',
        description: 'Message displayed when no knowledge is added to the Agent'
    },
    privateKnowledgeTitle: {
        id: 'rovo-chat.view-agent.hidden-knowledge-title',
        defaultMessage: 'These knowledge is private',
        description: 'Title of the knowledge section, this is displayed when knowledge is purposely hidden'
    },
    privateKnowledgeDescription: {
        id: 'rovo-chat.view-agent.hidden-knowledge-description',
        defaultMessage: 'Agents built by Atlassian Marketplace partners have their knowledge hidden for privacy.',
        description: 'Description of the knowledge section, this is displayed when knowledge is purposely hidden'
    }
});

});


parcelRegister("1Zrfp", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $8696e2efdb723f53$export$3761e66a04602cbd);
$parcel$export(module.exports, "AgentCreatedBy", () => $8696e2efdb723f53$export$1565ea9a9fb7ad67);
$parcel$export(module.exports, "useProfileResolution", () => $8696e2efdb723f53$export$5d980898591175e);
$parcel$export(module.exports, "filterAndSortAgents", () => $8696e2efdb723f53$export$13d60404a0dddebd);
$parcel$export(module.exports, "getEnabledKnowlegeArisFromAgent", () => $8696e2efdb723f53$export$a6e36c224ec3c0cb);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $asu8X = parcelRequire("asu8X");

var $24y6N = parcelRequire("24y6N");

var $g78aE = parcelRequire("g78aE");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
parcelRequire("j2NCp");
var $1I4cW = parcelRequire("1I4cW");
var $lsiAJ = parcelRequire("lsiAJ");

var $hFxJG = parcelRequire("hFxJG");

var $6n1kb = parcelRequire("6n1kb");

var $7mHhy = parcelRequire("7mHhy");

var $wPTaH = parcelRequire("wPTaH");
const $8696e2efdb723f53$export$3761e66a04602cbd = (ari)=>{
    const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
    return matched ? matched[1] : undefined;
};
const $8696e2efdb723f53$export$1565ea9a9fb7ad67 = ({ agent: agent, siteId: siteId, simplified: simplified })=>{
    if ((0, $7mHhy.isCustomerAgent)(agent)) {
        const aaid = agent.creator ? $8696e2efdb723f53$export$3761e66a04602cbd(agent.creator) : undefined;
        if (!aaid) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8696e2efdb723f53$var$ResolvingMention, {
            userId: aaid,
            siteId: siteId,
            profileCard: true,
            simplified: simplified
        });
    }
    if ((0, $7mHhy.isSystemAgent)(agent) || !agent.creator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        testId: "atlassian-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24y6N))), {
        primaryColor: "var(--ds-icon-brand, #0C66E4)",
        label: "Atlassian"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, "Atlassian"));
    if ((0, $7mHhy.isForgeAgent)(agent)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, agent.creator);
    return null;
};
const $8696e2efdb723f53$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false })=>{
    (0, $asu8X.di)($8696e2efdb723f53$export$5d980898591175e);
    const { profile: profile, client: client } = $8696e2efdb723f53$export$5d980898591175e(userId, siteId);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, $wPTaH.default).deactivatedCreatorName, {
        name: profile.data.fullName
    }) : profile.data?.fullName;
    if (profile.isFetching || !profile.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
        isShimmering: true,
        height: 18,
        width: 100,
        borderRadius: 3
    });
    if (simplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: `/people/${userId}`,
        target: "_blank"
    }, fullName);
    return profileCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1I4cW.default), {
        userId: userId,
        resourceClient: client,
        ariaLabel: fullName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g78aE.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g78aE.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    });
};
const $8696e2efdb723f53$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
let $8696e2efdb723f53$var$client;
function $8696e2efdb723f53$export$5d980898591175e(userId, siteId, shouldFetch = true) {
    (0, $asu8X.di)((0, $lsiAJ.default));
    const profileClient = (0, $eUqFw.useMemo)(()=>{
        if (!$8696e2efdb723f53$var$client) // To support di
        $8696e2efdb723f53$var$client = new (0, $lsiAJ.default)({
            url: $8696e2efdb723f53$var$DIRECTORY_URL,
            cacheSize: 1000,
            // 1 day
            cacheMaxAge: 86400000
        });
        return $8696e2efdb723f53$var$client;
    }, []);
    const profile = (0, $6n1kb.useQuery)({
        queryKey: [
            'fetchProfile',
            siteId,
            userId
        ],
        queryFn: async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (error) {
                return {};
            }
        },
        enabled: shouldFetch
    });
    return {
        profile: profile,
        client: profileClient
    };
}
const $8696e2efdb723f53$export$13d60404a0dddebd = (agents, filters)=>{
    return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
};
const $8696e2efdb723f53$export$a6e36c224ec3c0cb = (agent)=>{
    if (!agent.knowledge_sources?.enabled) return [];
    return agent.knowledge_sources.sources.filter((source)=>source.enabled).reduce((acc, source)=>{
        switch(source.source){
            case 'confluence':
                acc.push(...source.configuration?.parent_filter ?? []);
                acc.push(...source.configuration?.space_filter ?? []);
                break;
            case 'jira':
                acc.push(...source.configuration?.project_filter ?? []);
                break;
        }
        return acc;
    }, []);
};

});
parcelRegister("g78aE", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_USER_ID", () => $09a96119682ba6da$export$af8124aa496797f2);
$parcel$export(module.exports, "default", () => $09a96119682ba6da$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $51sCz = parcelRequire("51sCz");

var $cWlAm = parcelRequire("cWlAm");

var $bQOul = parcelRequire("bQOul");

var $aR8m5 = parcelRequire("aR8m5");

var $hWvv0 = parcelRequire("hWvv0");

var $4lC4o = parcelRequire("4lC4o");

var $2jDha = parcelRequire("2jDha");

var $uMitL = parcelRequire("uMitL");

var $htnG8 = parcelRequire("htnG8");

var $6fh6t = parcelRequire("6fh6t");
const $09a96119682ba6da$export$7452d7062a4d0634 = 1000;
const $09a96119682ba6da$export$af8124aa496797f2 = '_|unknown|_';
class $09a96119682ba6da$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(props){
        super(props);
        this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        };
        this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $09a96119682ba6da$export$7452d7062a4d0634);
        };
        this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        };
        this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $hWvv0.MentionType).SELF;
            if ((0, $hWvv0.isRestricted)(accessLevel)) return (0, $hWvv0.MentionType).RESTRICTED;
            return (0, $hWvv0.MentionType).DEFAULT;
        };
        (0, $6fh6t.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
    componentDidMount() {
        (0, $6fh6t.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $6fh6t.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $uMitL.UFOExperienceState)['STARTED'],
            (0, $uMitL.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $htnG8.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            }
        }, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, `@${message}`));
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$09a96119682ba6da$export$af8124aa496797f2}`;
        const mentionComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bQOul.default), {
            mentionType: mentionType,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            spellCheck: false
        }, failedMention ? this.renderUnknownUserError(id) : text || '@...'));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6fh6t.UfoErrorBoundary), {
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            id: localId,
            "data-mention-id": id,
            "data-local-id": localId,
            "data-access-level": accessLevel,
            spellCheck: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cWlAm.default), null, mentionType === (0, $hWvv0.MentionType).RESTRICTED ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
            fallback: mentionComponent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8m5.default), {
            name: text
        }, mentionComponent)) : mentionComponent)));
    }
}
const $09a96119682ba6da$var$MentionWithAnalytics = (0, $2jDha.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $4lC4o.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $4lC4o.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($09a96119682ba6da$export$92ab8442e7a15cef);
const $09a96119682ba6da$var$Mention = $09a96119682ba6da$var$MentionWithAnalytics;
var $09a96119682ba6da$export$2e2bcd8739ae039 = $09a96119682ba6da$var$Mention;

});
parcelRegister("cWlAm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccefe77db3bb3d62$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");

var $htnG8 = parcelRequire("htnG8");
const $ccefe77db3bb3d62$var$EMPTY = {};
const $ccefe77db3bb3d62$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState($ccefe77db3bb3d62$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        let aborted = false;
        setMessages($ccefe77db3bb3d62$var$EMPTY);
        (0, $htnG8.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $ccefe77db3bb3d62$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $5JgJ2.default)();
    const messages = $ccefe77db3bb3d62$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        ...intl,
        messages: messages
    }, children);
};
var $ccefe77db3bb3d62$export$2e2bcd8739ae039 = $ccefe77db3bb3d62$var$MessagesIntlProvider;

});
parcelRegister("htnG8", function(module, exports) {

$parcel$export(module.exports, "UnknownUserError", () => $eff89fe3c5b3e80b$export$98e06fe7a6174253);
$parcel$export(module.exports, "NoAccessWarning", () => $eff89fe3c5b3e80b$export$58bd5a2057b6b855);
$parcel$export(module.exports, "NoAccessLabel", () => $eff89fe3c5b3e80b$export$da9f8ce14593162f);
$parcel$export(module.exports, "getMessagesForLocale", () => $eff89fe3c5b3e80b$export$d0a3169680473b6c);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $1Y1qJ = parcelRequire("1Y1qJ");
const $eff89fe3c5b3e80b$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            values: values,
            ...messageDescriptor
        });
    };
const $eff89fe3c5b3e80b$export$98e06fe7a6174253 = $eff89fe3c5b3e80b$export$392a0c6a82ab0e50((0, $1Y1qJ.messages).unknownUserError);
const $eff89fe3c5b3e80b$export$58bd5a2057b6b855 = $eff89fe3c5b3e80b$export$392a0c6a82ab0e50((0, $1Y1qJ.messages).noAccessWarning);
const $eff89fe3c5b3e80b$export$da9f8ce14593162f = $eff89fe3c5b3e80b$export$392a0c6a82ab0e50((0, $1Y1qJ.messages).noAccessLabel);
const $eff89fe3c5b3e80b$export$4a258ffee7316766 = $eff89fe3c5b3e80b$export$392a0c6a82ab0e50((0, $1Y1qJ.messages).defaultHeadline);
const $eff89fe3c5b3e80b$export$702321a50d74536e = $eff89fe3c5b3e80b$export$392a0c6a82ab0e50((0, $1Y1qJ.messages).defaultAdvisedAction);
const $eff89fe3c5b3e80b$export$ed7f16088a93ae9d = $eff89fe3c5b3e80b$export$392a0c6a82ab0e50((0, $1Y1qJ.messages).loginAgain);
const $eff89fe3c5b3e80b$export$3ab158df56460d1c = $eff89fe3c5b3e80b$export$392a0c6a82ab0e50((0, $1Y1qJ.messages).differentText);






























const $eff89fe3c5b3e80b$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("lNXXT")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("eFor3")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("e5f8I")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("hpUej")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("f2RQm")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("fnQH0")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("71qrc")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("cFESx")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("3mUVG")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("j2ew9")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("dtNtP")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("hwtL2")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("cNOdz")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("6tCOb")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("ayMcL")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("ileIk")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("bwyiL")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("fFnRd")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("4klVr")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("2kvbQ")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("VXvT5")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("e8OcR")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("2SCDc")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("cvo1U")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("a2dsG")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("hwXFR")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("7c1fy")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("bSy9T")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("cAocm")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $eff89fe3c5b3e80b$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("hpUej")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("1Y1qJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40b24a9f4146e474$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $40b24a9f4146e474$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    unknownUserError: {
        id: 'fabric.mention.unknow.user.error',
        defaultMessage: 'Unknown user {userId}',
        description: 'Mention user name could not be found or look up failed'
    },
    noAccessWarning: {
        id: 'fabric.mention.noAccess.warning',
        defaultMessage: "{name} won't be notified as they have no access",
        description: "Warning message to show that the mentioned user won't be notified"
    },
    noAccessLabel: {
        id: 'fabric.mention.noAccess.label',
        defaultMessage: 'No access',
        description: 'Label for no access icon'
    },
    defaultHeadline: {
        id: 'fabric.mention.error.defaultHeadline',
        defaultMessage: 'Something went wrong',
        description: 'Error message shown when there is an error communicating with backend'
    },
    defaultAdvisedAction: {
        id: 'fabric.mention.error.defaultAction',
        defaultMessage: 'Try again in a few seconds',
        description: 'Default advised action when an error occurs'
    },
    loginAgain: {
        id: 'fabric.mention.error.loginAgain',
        defaultMessage: 'Try logging out then in again',
        description: 'Login again message when there is an authentication error occurs'
    },
    differentText: {
        id: 'fabric.mention.error.differentText',
        defaultMessage: 'Try entering different text',
        description: 'Enter different text message when a forbidden error occurs'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.mentions.team.member.count',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.mentions.team.member.count.including.you',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.mentions.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.mentions.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    }
});

});

parcelRegister("lNXXT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1ryKt").then(()=>parcelRequire('lmqlI'));

});

parcelRegister("eFor3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6Lxk7").then(()=>parcelRequire('bU2vr'));

});

parcelRegister("e5f8I", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3lDkK").then(()=>parcelRequire('4PiFm'));

});

parcelRegister("hpUej", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bo3Fa").then(()=>parcelRequire('7KlbL'));

});

parcelRegister("f2RQm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8b2up").then(()=>parcelRequire('297r7'));

});

parcelRegister("fnQH0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("i1UOD").then(()=>parcelRequire('4jzxE'));

});

parcelRegister("71qrc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8Vvnt").then(()=>parcelRequire('5lz42'));

});

parcelRegister("cFESx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4jI2L").then(()=>parcelRequire('lwvA0'));

});

parcelRegister("3mUVG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("c4qN0").then(()=>parcelRequire('euBBh'));

});

parcelRegister("j2ew9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("l5cXn").then(()=>parcelRequire('A71OZ'));

});

parcelRegister("dtNtP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("39N86").then(()=>parcelRequire('fuMHD'));

});

parcelRegister("hwtL2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bf7yA").then(()=>parcelRequire('jfe2D'));

});

parcelRegister("cNOdz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gEVBg").then(()=>parcelRequire('7rXOZ'));

});

parcelRegister("6tCOb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9uBYF").then(()=>parcelRequire('cCtdJ'));

});

parcelRegister("ayMcL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hPxr9").then(()=>parcelRequire('99OCa'));

});

parcelRegister("ileIk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1P7Cm").then(()=>parcelRequire('jqDbH'));

});

parcelRegister("bwyiL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gamrO").then(()=>parcelRequire('2u4mB'));

});

parcelRegister("fFnRd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fFbIi").then(()=>parcelRequire('kHfh5'));

});

parcelRegister("4klVr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("eXdnm").then(()=>parcelRequire('1kilQ'));

});

parcelRegister("2kvbQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hhGMF").then(()=>parcelRequire('a1bfS'));

});

parcelRegister("VXvT5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("e3teQ").then(()=>parcelRequire('eMAKJ'));

});

parcelRegister("e8OcR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("849qd").then(()=>parcelRequire('bIUT7'));

});

parcelRegister("2SCDc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8Ap8w").then(()=>parcelRequire('ldCZI'));

});

parcelRegister("cvo1U", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6byp0").then(()=>parcelRequire('gTCTR'));

});

parcelRegister("a2dsG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bRjBO").then(()=>parcelRequire('9sqZe'));

});

parcelRegister("hwXFR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aR7Nm").then(()=>parcelRequire('1X8Z7'));

});

parcelRegister("7c1fy", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6HZtt").then(()=>parcelRequire('lxgKj'));

});

parcelRegister("bSy9T", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5rOQh").then(()=>parcelRequire('eA7x1'));

});

parcelRegister("cAocm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9VfRG").then(()=>parcelRequire('aVWsq'));

});



parcelRegister("bQOul", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e66141c3867db23$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $hWvv0 = parcelRequire("hWvv0");

var $eUqFw = parcelRequire("eUqFw");
const $3e66141c3867db23$var$mentionStyle = {
    [(0, $hWvv0.MentionType).SELF]: {
        background: `var(--ds-background-brand-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
    },
    [(0, $hWvv0.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: `var(--ds-border-bold, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        text: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $hWvv0.MentionType).DEFAULT]: {
        background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`,
        pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`
    }
};
const $3e66141c3867db23$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $3e66141c3867db23$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $3e66141c3867db23$var$PrimitiveMention = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $byn9U.css)("display:inline;border:1px solid ", $3e66141c3867db23$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $3e66141c3867db23$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $3e66141c3867db23$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:normal;word-break:break-word;&:hover{background:", $3e66141c3867db23$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $3e66141c3867db23$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $3e66141c3867db23$export$2e2bcd8739ae039 = $3e66141c3867db23$var$PrimitiveMention;

});
parcelRegister("hWvv0", function(module, exports) {

$parcel$export(module.exports, "MentionType", () => $0e3c071eb6987c64$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $0e3c071eb6987c64$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $0e3c071eb6987c64$export$8436e53e45ffe15b);
$parcel$export(module.exports, "MentionNameStatus", () => $0e3c071eb6987c64$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $0e3c071eb6987c64$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $0e3c071eb6987c64$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $0e3c071eb6987c64$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $0e3c071eb6987c64$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $0e3c071eb6987c64$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $0e3c071eb6987c64$export$4369c812aac99591);
var $0e3c071eb6987c64$export$2102863a3c660c6b;
(function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
})($0e3c071eb6987c64$export$2102863a3c660c6b || ($0e3c071eb6987c64$export$2102863a3c660c6b = {}));
var $0e3c071eb6987c64$export$81124e6148ca5db0;
(function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
})($0e3c071eb6987c64$export$81124e6148ca5db0 || ($0e3c071eb6987c64$export$81124e6148ca5db0 = {}));
var $0e3c071eb6987c64$export$8436e53e45ffe15b;
(function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
})($0e3c071eb6987c64$export$8436e53e45ffe15b || ($0e3c071eb6987c64$export$8436e53e45ffe15b = {}));
var $0e3c071eb6987c64$export$b8fa67dc54502853;
(function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
})($0e3c071eb6987c64$export$b8fa67dc54502853 || ($0e3c071eb6987c64$export$b8fa67dc54502853 = {}));
function $0e3c071eb6987c64$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $0e3c071eb6987c64$export$81124e6148ca5db0[0];
}
function $0e3c071eb6987c64$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $0e3c071eb6987c64$export$8436e53e45ffe15b[1];
}
function $0e3c071eb6987c64$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $0e3c071eb6987c64$export$8436e53e45ffe15b[2];
}
function $0e3c071eb6987c64$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $0e3c071eb6987c64$export$8436e53e45ffe15b[3];
}
function $0e3c071eb6987c64$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $0e3c071eb6987c64$export$4369c812aac99591 = (p)=>!!(p && p.then);

});


parcelRegister("aR8m5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f459954a49e16c01$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $f459954a49e16c01$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("kKRJL")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $f459954a49e16c01$export$2e2bcd8739ae039 = $f459954a49e16c01$var$AsyncNoAccessTooltip;

});
parcelRegister("kKRJL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kSiCt").then(()=>parcelRequire('8mcYc'));

});


parcelRegister("4lC4o", function(module, exports) {

$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $dfdfb81b6234304f$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $dfdfb81b6234304f$export$c724588856bbfbcf);
$parcel$export(module.exports, "SliNames", () => $dfdfb81b6234304f$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "Actions", () => $dfdfb81b6234304f$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $dfdfb81b6234304f$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "buildSliPayload", () => $dfdfb81b6234304f$export$c357a2872628de7c);



var $hWvv0 = parcelRequire("hWvv0");
const $dfdfb81b6234304f$var$packageName = "platform-pkg";
const $dfdfb81b6234304f$var$packageVersion = "0.0.0-use.local";
const $dfdfb81b6234304f$export$245097525aef1262 = 'sli';
const $dfdfb81b6234304f$export$c724588856bbfbcf = 'smart';
var $dfdfb81b6234304f$export$7afb0727c7d7e8af;
(function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
})($dfdfb81b6234304f$export$7afb0727c7d7e8af || ($dfdfb81b6234304f$export$7afb0727c7d7e8af = {}));
var $dfdfb81b6234304f$export$5c42d9dea6d035c1;
(function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
})($dfdfb81b6234304f$export$5c42d9dea6d035c1 || ($dfdfb81b6234304f$export$5c42d9dea6d035c1 = {}));
var $dfdfb81b6234304f$export$b52183d5cfb26dc9;
(function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
})($dfdfb81b6234304f$export$b52183d5cfb26dc9 || ($dfdfb81b6234304f$export$b52183d5cfb26dc9 = {}));
const $dfdfb81b6234304f$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: "mentionTypeahead",
                attributes: {
                    packageName: $dfdfb81b6234304f$var$packageName,
                    packageVersion: $dfdfb81b6234304f$var$packageVersion,
                    componentName: "mention",
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $662e33bb7444ae33$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        }
    };
const $dfdfb81b6234304f$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $662e33bb7444ae33$export$a1562d08625f5d7e),
            attributes: {
                packageName: $dfdfb81b6234304f$var$packageName,
                packageVersion: $dfdfb81b6234304f$var$packageVersion,
                componentName: "mention",
                accessLevel: accessLevel,
                isSpecial: (0, $hWvv0.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        return event;
    };
const $dfdfb81b6234304f$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $dfdfb81b6234304f$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        }
    };
const $dfdfb81b6234304f$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        attributes: {
            packageName: $dfdfb81b6234304f$var$packageName,
            packageVersion: $dfdfb81b6234304f$var$packageVersion,
            componentName: "mention",
            ...attributes
        }
    };
    return eventPayload;
};
const $dfdfb81b6234304f$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: "mention",
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $dfdfb81b6234304f$var$packageName,
                    packageVersion: $dfdfb81b6234304f$var$packageVersion,
                    componentName: "mention",
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $662e33bb7444ae33$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $dfdfb81b6234304f$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $dfdfb81b6234304f$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$dfdfb81b6234304f$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $hWvv0.isSpecialMentionText)(text)
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $662e33bb7444ae33$export$a1562d08625f5d7e = 'ui';
const $662e33bb7444ae33$export$947dac6c72b26f81 = 'track';
const $662e33bb7444ae33$export$f1d537d508d2945a = 'screen';
const $662e33bb7444ae33$export$12346a674644c156 = 'operational';
const $662e33bb7444ae33$export$b055de0e665cb20c = 'unknown';

const $ff610ba30633db9d$export$d821aa4c8afb384e = 'fabric-elements';


parcelRegister("6fh6t", function(module, exports) {

$parcel$export(module.exports, "mentionRenderedUfoExperience", () => $2cd6624fc0dd09be$export$1d011e4240507c78);
$parcel$export(module.exports, "UfoErrorBoundary", () => $2cd6624fc0dd09be$export$5ef1c2550074a375);

var $eUqFw = parcelRequire("eUqFw");

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
const $2cd6624fc0dd09be$export$1d011e4240507c78 = new (0, $2kFUE.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $3yYXq.ExperienceTypes).Load,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
});
class $2cd6624fc0dd09be$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch() {
        $2cd6624fc0dd09be$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("j2NCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5f762d9b5740e9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "withOuterListeners", () => (parcelRequire("icLG8")).default);
$parcel$export(module.exports, "TeamProfileCard", () => (parcelRequire("g8DVf")).default);
$parcel$export(module.exports, "ProfileCardTrigger", () => (parcelRequire("1I4cW")).default);
$parcel$export(module.exports, "ProfileClient", () => (parcelRequire("lsiAJ")).default);
$parcel$export(module.exports, "UserProfileClient", () => (parcelRequire("b4hs7")).default);
$parcel$export(module.exports, "DELAY_MS_SHOW", () => $515c9dbc88c31cf4$export$5b956b542f1bc1b3);
$parcel$export(module.exports, "AgentProfileCardTrigger", () => (parcelRequire("b5p0p")).AgentProfileCardTrigger);
// Avoid exporting new components in this file as they will affect the bundle size of all consumers
// importing directly from @atlaskit/profilecard.

var $lsiAJ = parcelRequire("lsiAJ");

var $kWhjG = parcelRequire("kWhjG");

var $b4hs7 = parcelRequire("b4hs7");

var $6uyUT = parcelRequire("6uyUT");

var $94Fw4 = parcelRequire("94Fw4");

var $ehM5E = parcelRequire("ehM5E");

var $6aOtB = parcelRequire("6aOtB");

var $1I4cW = parcelRequire("1I4cW");


var $icLG8 = parcelRequire("icLG8");

var $g8DVf = parcelRequire("g8DVf");

var $b5p0p = parcelRequire("b5p0p");

var $eKJ5n = parcelRequire("eKJ5n");
var $ce5f762d9b5740e9$export$2e2bcd8739ae039 = (0, $6aOtB.default);

});
parcelRegister("6uyUT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ab452e3339485e67$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $fM5iV = parcelRequire("fM5iV");
var $1n3pn = parcelRequire("1n3pn");
var $920hm = parcelRequire("920hm");

var $3vXh8 = parcelRequire("3vXh8");

var $4x5z4 = parcelRequire("4x5z4");
parcelRequire("iINHb");
var $4ga2m = parcelRequire("4ga2m");

var $dDnjt = parcelRequire("dDnjt");

var $kCTG1 = parcelRequire("kCTG1");

var $1Z0pV = parcelRequire("1Z0pV");

var $2TnXV = parcelRequire("2TnXV");

var $kKBsF = parcelRequire("kKBsF");
const $ab452e3339485e67$var$styles = (0, $1ZAYh.xcss)({
    paddingBlockStart: 'space.400',
    paddingInline: 'space.200'
});
const $ab452e3339485e67$var$avatarStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: 'space.300',
    left: 'space.200'
});
const $ab452e3339485e67$var$cardContainerStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.overlay',
    position: 'relative'
});
const $ab452e3339485e67$var$AgentProfileCard = ({ agent: agent, isLoading: isLoading, isCreatedByViewingUser: isCreatedByViewingUser, cloudId: cloudId, onChatClick: onChatClick, product: product = 'rovo', hasError: hasError, errorType: errorType, onConversationStartersClick: onConversationStartersClick, resourceClient: resourceClient, addFlag: addFlag })=>{
    const { onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent, onOpenChat: onOpenChatFullScreecn, onConversationStarter: onConversationStarter } = (0, $2TnXV.useAgentUrlActions)({
        cloudId: cloudId || ''
    });
    const [isStarred, setIsStarred] = (0, $eUqFw.useState)(false);
    const [starCount, setStarCount] = (0, $eUqFw.useState)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        setIsStarred(!!agent?.favourite);
        setStarCount(agent?.favourite_count);
    }, [
        agent?.favourite,
        agent?.favourite_count
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const handleSetFavourite = (0, $eUqFw.useCallback)(async ()=>{
        if (agent?.id) try {
            await resourceClient.setFavouriteAgent(agent.id, !isStarred, fireAnalytics);
            if (isStarred) setStarCount(starCount ? starCount - 1 : 0);
            else setStarCount((starCount || 0) + 1);
            setIsStarred(!isStarred);
        } catch (error) {}
    }, [
        agent?.id,
        fireAnalytics,
        isStarred,
        resourceClient,
        starCount
    ]);
    const handleOnDelete = (0, $eUqFw.useCallback)(async ()=>{
        if (agent) try {
            await resourceClient.deleteAgent(agent.id, fireAnalytics);
            addFlag?.({
                title: formatMessage((0, $kKBsF.messages).agentDeletedSuccessFlagTitle),
                description: formatMessage((0, $kKBsF.messages).agentDeletedSuccessFlagDescription, {
                    agentName: agent.name
                }),
                type: 'success',
                id: 'ptc-directory.agent-profile.delete-agent-success'
            });
        } catch (error) {
            addFlag?.({
                title: formatMessage((0, $kKBsF.messages).agentDeletedErrorFlagTitle),
                description: formatMessage((0, $kKBsF.messages).agentDeletedErrorFlagDescription),
                type: 'error',
                id: 'ptc-directory.agent-profile.delete-agent-error'
            });
        }
    }, [
        addFlag,
        agent,
        fireAnalytics,
        formatMessage,
        resourceClient
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isLoading && agent) fireAnalytics((0, $3vXh8.profileCardRendered)('agent', 'content'));
    }, [
        agent,
        fireAnalytics,
        isLoading
    ]);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCTG1.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4x5z4.LoadingState), {
        profileType: "agent",
        fireAnalytics: fireAnalytics
    }));
    if (hasError || !agent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCTG1.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ga2m.default), {
        errorType: errorType,
        fireAnalytics: fireAnalytics
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCTG1.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ab452e3339485e67$var$cardContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1n3pn.AgentBanner), {
        agentId: agent.id,
        agentNamedId: agent.named_id,
        height: 96,
        agentIdentityAccountId: agent.identity_account_id
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ab452e3339485e67$var$avatarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fM5iV.AgentAvatar), {
        agentId: agent.id,
        agentNamedId: agent.named_id,
        agentIdentityAccountId: agent.identity_account_id,
        size: "xlarge"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        xcss: $ab452e3339485e67$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $920hm.AgentProfileInfo), {
        agentName: agent.name,
        isStarred: isStarred,
        onStarToggle: handleSetFavourite,
        isHidden: agent.visibility === 'PRIVATE',
        creatorRender: agent.creatorInfo?.type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $920hm.AgentProfileCreator), {
            creator: {
                type: agent.creatorInfo?.type,
                name: agent.creatorInfo?.name || '',
                profileLink: agent.creatorInfo?.profileLink || ''
            },
            isLoading: false,
            onCreatorLinkClick: ()=>{}
        }),
        starCountRender: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $920hm.AgentStarCount), {
            starCount: starCount,
            isLoading: false
        }),
        agentDescription: agent.description
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Z0pV.ConversationStarters), {
        isAgentDefault: agent.is_default,
        userDefinedConversationStarters: agent.user_defined_conversation_starters,
        onConversationStarterClick: (conversationStarter)=>{
            onConversationStartersClick ? onConversationStartersClick(conversationStarter) : onConversationStarter({
                agentId: agent.id,
                prompt: conversationStarter
            });
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dDnjt.AgentActions), {
        agent: agent,
        isAgentCreatedByCurrentUser: isCreatedByViewingUser,
        onEditAgent: ()=>onEditAgent(agent.id),
        onCopyAgent: ()=>onCopyAgent(agent.id),
        onDuplicateAgent: ()=>onDuplicateAgent(agent.id),
        onDeleteAgent: handleOnDelete,
        onChatClick: ()=>onChatClick ? onChatClick() : onOpenChatFullScreecn()
    })));
};
var $ab452e3339485e67$export$2e2bcd8739ae039 = $ab452e3339485e67$var$AgentProfileCard;

});
parcelRegister("4x5z4", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $b3ecabf9b19940d0$export$62aa48085237e36f);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");
const $b3ecabf9b19940d0$export$62aa48085237e36f = ({ fireAnalytics: fireAnalytics, profileType: profileType })=>{
    (0, $eUqFw.useEffect)(()=>{
        if (fireAnalytics) fireAnalytics((0, $3vXh8.profileCardRendered)(profileType, 'spinner'));
    }, [
        fireAnalytics,
        profileType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
};

});
parcelRegister("kqibQ", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $9338621abe3237e0$export$6aa22a823032b784);
$parcel$export(module.exports, "ProfileImage", () => $9338621abe3237e0$export$a7a74ab5cffd1455);
$parcel$export(module.exports, "ActionsFlexSpacer", () => $9338621abe3237e0$export$d395c8d16f1e359d);
$parcel$export(module.exports, "KudosBlobAnimation", () => $9338621abe3237e0$export$4a8a956251d4bf6f);
$parcel$export(module.exports, "AnimationWrapper", () => $9338621abe3237e0$export$58517bb1b373a54c);
$parcel$export(module.exports, "AnimatedKudosButton", () => $9338621abe3237e0$export$6196a3f52a6944fe);
$parcel$export(module.exports, "ActionButtonGroup", () => $9338621abe3237e0$export$73d695ae27330056);
$parcel$export(module.exports, "OverflowActionButtonsWrapper", () => $9338621abe3237e0$export$ff778e5b796745a6);
$parcel$export(module.exports, "CardContent", () => $9338621abe3237e0$export$64ef9b8c11710c47);
$parcel$export(module.exports, "DetailsGroup", () => $9338621abe3237e0$export$35cf684daac137ac);
$parcel$export(module.exports, "DisabledInfo", () => $9338621abe3237e0$export$2062e7265a95a823);
$parcel$export(module.exports, "FullNameLabel", () => $9338621abe3237e0$export$1270e9c1fc39142b);
$parcel$export(module.exports, "LozengeWrapper", () => $9338621abe3237e0$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "CustomLozengeContainer", () => $9338621abe3237e0$export$6ebf103500ba5a45);
$parcel$export(module.exports, "JobTitleLabel", () => $9338621abe3237e0$export$d6c0e5f211c8d617);
$parcel$export(module.exports, "AppTitleLabel", () => $9338621abe3237e0$export$4865ffa72a4d5f9);
$parcel$export(module.exports, "SpinnerContainer", () => $9338621abe3237e0$export$a5e06607a5ac6158);
$parcel$export(module.exports, "CardContainer", () => $9338621abe3237e0$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "DetailsLabel", () => $9338621abe3237e0$export$138a08882ebf7289);
$parcel$export(module.exports, "DetailsLabelIcon", () => $9338621abe3237e0$export$79d7d9b2f6a70c70);
$parcel$export(module.exports, "DetailsLabelText", () => $9338621abe3237e0$export$b0ec2c767a0e0eab);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $lcnyw = parcelRequire("lcnyw");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
function $9338621abe3237e0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9338621abe3237e0$var$getFullNameMargin = (props)=>props.noMeta ? `${"var(--ds-space-400, 32px)"} 0 ${"var(--ds-space-150, 12px)"} 0` : `${"var(--ds-space-150, 12px)"} 0 0 0`;
const $9338621abe3237e0$export$6aa22a823032b784 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo20"
})("background-color:", (0, $5PC5M.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:", (0, $lcnyw.gridSize)() * 45, "px;");
const $9338621abe3237e0$export$a7a74ab5cffd1455 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo19"
})({
    name: "eukccz",
    styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px)"
});
const $9338621abe3237e0$export$d395c8d16f1e359d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo18"
})({
    name: "18pny36",
    styles: "flex:1 0 auto"
});
// eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation
const $9338621abe3237e0$var$kudosButtonAnimationTransformation = (0, $byn9U.keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
const $9338621abe3237e0$export$b08abf2f97b92ea5 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo17"
})("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", (0, $lcnyw.gridSize)() * 4 / (0, $lcnyw.fontSize)(), "em;animation-name:", $9338621abe3237e0$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient(\n\t\tcircle,\n\t\tvar(--ds-background-information-pressed, #85B8FF) 0%,\n\t\tvar(--ds-background-discovery-pressed, #B8ACF6) 25%,\n\t\ttransparent 50%\n\t);overflow:hidden;");
const $9338621abe3237e0$export$4a8a956251d4bf6f = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9338621abe3237e0$export$b08abf2f97b92ea5, {
        className: "kudos-blob-animation",
        ...props
    });
const $9338621abe3237e0$export$58517bb1b373a54c = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo16"
})("clip-path:inset(0px 0px 0px 0px round ", (0, $lcnyw.borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
const $9338621abe3237e0$export$6196a3f52a6944fe = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo15"
})({
    name: "18xp5qc",
    styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
});
const $9338621abe3237e0$export$73d695ae27330056 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo14"
})("user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $9338621abe3237e0$export$ff778e5b796745a6 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo13"
})("display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $9338621abe3237e0$export$64ef9b8c11710c47 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo12"
})("display:flex;flex-direction:column;min-height:", (0, $lcnyw.gridSize)() * 17, "px;");
const $9338621abe3237e0$export$35cf684daac137ac = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo11"
})("display:flex;flex-direction:column;margin-left:", (0, $lcnyw.gridSize)() * 14.5, "px;width:", (0, $lcnyw.gridSize)() * 24.5, "px;");
const $9338621abe3237e0$export$2062e7265a95a823 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo10"
})("font-size:", (0, $lcnyw.fontSizeSmall)(), "px;color:", (0, $5PC5M.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
const $9338621abe3237e0$export$1270e9c1fc39142b = /*#__PURE__*/ (0, $joBf7.default)("h2", {
    target: "e1ebb2vo9"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:18px;font-weight:400;letter-spacing:normal;color:", (props)=>props.isDisabledAccount ? (0, $5PC5M.headerTextColorInactive) : (0, $5PC5M.headerTextColor), ";margin:", (props)=>$9338621abe3237e0$var$getFullNameMargin(props), ";line-height:", 24 / 18, "em;:first-child{margin:", (props)=>$9338621abe3237e0$var$getFullNameMargin(props), ";}");
const $9338621abe3237e0$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo8"
})({
    name: "m760b1",
    styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block"
});
const $9338621abe3237e0$export$6ebf103500ba5a45 = /*#__PURE__*/ (0, $joBf7.default)($9338621abe3237e0$export$75180efdd3f4d9c2, {
    target: "e1ebb2vo7"
})({
    name: "15oqcei",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);>*{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
});
const $9338621abe3237e0$export$d6c0e5f211c8d617 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1ebb2vo6"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:14px;color:", (0, $5PC5M.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
const $9338621abe3237e0$export$4865ffa72a4d5f9 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1ebb2vo5"
})("background:", (0, $5PC5M.appLabelBgColor), ";color:", (0, $5PC5M.appLabelTextColor), ";border-radius:", (0, $lcnyw.borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:bold;text-transform:uppercase;font-size:12px;margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
const $9338621abe3237e0$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo4"
})("align-items:center;display:flex;height:", (0, $lcnyw.gridSize)() * 12, "px;justify-content:center;position:relative;");
const $9338621abe3237e0$export$8a23e74e5cf3ca41 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo3"
})("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient(\n\t\tto bottom,\n\t\t", (props)=>props.isDisabledUser ? (0, $5PC5M.headerBgColorDisabledUser) : (0, $5PC5M.headerBgColor), "\n\t\t\t0%,\n\t\t", (props)=>props.isDisabledUser ? (0, $5PC5M.headerBgColorDisabledUser) : (0, $5PC5M.headerBgColor), " 100%\n\t);background-repeat:no-repeat;background-size:100% ", (0, $lcnyw.gridSize)() * 12, "px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5}, 0 0 1px ${0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0}`})`}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, $lcnyw.borderRadius)()}px`, ";overflow:hidden;");
const $9338621abe3237e0$export$138a08882ebf7289 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo2"
})("display:flex;align-items:center;line-height:24px;font-size:", (0, $lcnyw.gridSize)() * 1.5, "px;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;&+&{margin-top:var(--ds-space-025, 2px);}");
const $9338621abe3237e0$export$79d7d9b2f6a70c70 = /*#__PURE__*/ (0, $joBf7.default)("dt", {
    target: "e1ebb2vo1"
})("display:flex;flex-shrink:0;color:", (0, $5PC5M.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
const $9338621abe3237e0$export$b0ec2c767a0e0eab = /*#__PURE__*/ (0, $joBf7.default)("dd", {
    target: "e1ebb2vo0"
})("overflow:hidden;text-overflow:ellipsis;color:", (0, $5PC5M.labelTextColor), ";padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");

});
parcelRegister("5PC5M", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $94991c92a8b245c9$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $94991c92a8b245c9$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $94991c92a8b245c9$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $94991c92a8b245c9$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $94991c92a8b245c9$export$5c2df128da90e8de);
$parcel$export(module.exports, "headerTextColorInactive", () => $94991c92a8b245c9$export$a882617dcf7f98a6);
$parcel$export(module.exports, "appLabelBgColor", () => $94991c92a8b245c9$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $94991c92a8b245c9$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $94991c92a8b245c9$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $94991c92a8b245c9$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $94991c92a8b245c9$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $94991c92a8b245c9$export$be3c814f7ed506ed);
$parcel$export(module.exports, "errorTextColor", () => $94991c92a8b245c9$export$ddf766d3bfcf965c);

const $94991c92a8b245c9$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $94991c92a8b245c9$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`;
const $94991c92a8b245c9$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`;
const $94991c92a8b245c9$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`;
const $94991c92a8b245c9$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $94991c92a8b245c9$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
const $94991c92a8b245c9$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`;
const $94991c92a8b245c9$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
const $94991c92a8b245c9$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
const $94991c92a8b245c9$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$c2e91cbeada39b8b)})`;
const $94991c92a8b245c9$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`;
const $94991c92a8b245c9$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
const $94991c92a8b245c9$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`;

});



parcelRegister("iINHb", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => (parcelRequire("9Pgj1")).ErrorBoundary);
$parcel$export(module.exports, "ErrorIllustration", () => (parcelRequire("8J4a2")).ErrorIllustration);
$parcel$export(module.exports, "ErrorMessage", () => (parcelRequire("4ga2m")).default);

var $9Pgj1 = parcelRequire("9Pgj1");

var $8J4a2 = parcelRequire("8J4a2");

var $4ga2m = parcelRequire("4ga2m");

});
parcelRegister("9Pgj1", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $4fd3e125f285a7c7$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");
class $4fd3e125f285a7c7$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch() {
        // Failure analytics here too
        this.props.onError();
    }
    render() {
        return this.props.children;
    }
}
var $4fd3e125f285a7c7$export$2e2bcd8739ae039 = $4fd3e125f285a7c7$export$e926676385687eaf;

});

parcelRegister("8J4a2", function(module, exports) {

$parcel$export(module.exports, "ErrorIllustration", () => $87687304f7d83e3d$export$e0319f52fc2380b1);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eUqFw = parcelRequire("eUqFw");
const $87687304f7d83e3d$export$e0319f52fc2380b1 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "42",
        height: "53",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "var(--ds-surface-overlay, white)",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
        fill: "url(#paint0_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
        fill: "#C1C7D0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear",
        x1: "26.1692",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.297",
        stopColor: "#C6CBD4",
        stopOpacity: "0.8812"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6301",
        stopColor: "#D3D7DE",
        stopOpacity: "0.748"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9795",
        stopColor: "#E9EBEF",
        stopOpacity: "0.6082"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: "0.6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "white"
    }))));
};

});

parcelRegister("4ga2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $486d3bd21855e22f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $5k4ch = parcelRequire("5k4ch");

var $fnJ1y = parcelRequire("fnJ1y");

var $3vXh8 = parcelRequire("3vXh8");
const $486d3bd21855e22f$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $eUqFw.useEffect)(()=>{
        fireAnalytics((0, $3vXh8.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorTitle), null, "The user is no longer available for the site");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorTitle), null, "Oops, looks like we\u2019re having issues", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorText), null, "Try again and we\u2019ll give it another shot"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorWrapper), {
        "data-testid": "profilecard-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
        label: "icon error",
        size: "xlarge"
    }), errorContent(), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: reload
    }, "Try again"));
};
var $486d3bd21855e22f$export$2e2bcd8739ae039 = $486d3bd21855e22f$var$ErrorMessage;

});
parcelRegister("5k4ch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e02137160dfc264$var$_react = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $3e02137160dfc264$var$_crossCircle = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $3e02137160dfc264$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3e02137160dfc264$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $3e02137160dfc264$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $3e02137160dfc264$var$_crossCircle.default
    }));
$3e02137160dfc264$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $3e02137160dfc264$var$_default = module.exports.default = $3e02137160dfc264$var$CrossCircleIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e3245a4cda5405cbe39cdb10fb1ac0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});


parcelRegister("fnJ1y", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $0ffb74661b2a3e3e$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $0ffb74661b2a3e3e$export$b065fd053267ec81);
$parcel$export(module.exports, "ErrorText", () => $0ffb74661b2a3e3e$export$7f714e6c560938e5);
$parcel$export(module.exports, "TeamErrorTitle", () => $0ffb74661b2a3e3e$export$d139ade0bdee219d);
$parcel$export(module.exports, "TeamErrorText", () => $0ffb74661b2a3e3e$export$90d92ccfb27352c6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $lcnyw = parcelRequire("lcnyw");

var $4lTFP = parcelRequire("4lTFP");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
const $0ffb74661b2a3e3e$export$bb27b7e39840238f = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1g2atxt4"
})({
    textAlign: 'center',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorIconColor)
});
const $0ffb74661b2a3e3e$export$b065fd053267ec81 = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorTitleColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: `${(0, $lcnyw.gridSize)() * 3}px`,
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $0ffb74661b2a3e3e$export$7f714e6c560938e5 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1g2atxt2"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorTextColor)
});
const $0ffb74661b2a3e3e$export$d139ade0bdee219d = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt1"
})((0, $4lTFP.h400));
const $0ffb74661b2a3e3e$export$90d92ccfb27352c6 = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt0"
})({
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-100, 8px)"
});

});



parcelRegister("dDnjt", function(module, exports) {

$parcel$export(module.exports, "AgentActions", () => $4ca46e58b113fec1$export$a091e6fbe251d12f);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6zOB7 = parcelRequire("6zOB7");
var $j9fWg = parcelRequire("j9fWg");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $34Io4 = parcelRequire("34Io4");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $kDlNh = parcelRequire("kDlNh");

var $6Rnl4 = parcelRequire("6Rnl4");
const $4ca46e58b113fec1$var$chatToAgentButtonContainer = (0, $1ZAYh.xcss)({
    width: '100%'
});
const $4ca46e58b113fec1$var$chatToAgentButtonWrapper = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'center',
    lineHeight: '20px',
    padding: 'space.075',
    fontWeight: '500'
});
const $4ca46e58b113fec1$var$chatPillButtonInlineStyles = (0, $1ZAYh.xcss)({
    paddingInline: 'space.025'
});
const $4ca46e58b113fec1$var$chatPillTextStyles = (0, $1ZAYh.xcss)({
    wordBreak: 'break-word',
    textAlign: 'left',
    whiteSpace: 'pre-wrap'
});
const $4ca46e58b113fec1$var$chatPillIconWrapper = (0, $1ZAYh.xcss)({
    minWidth: '20px',
    height: '20px'
});
const $4ca46e58b113fec1$var$actionsWrapperStyles = (0, $1ZAYh.xcss)({
    borderTop: '1px',
    borderTopStyle: 'solid',
    borderColor: 'color.border',
    padding: 'space.200',
    marginBlockStart: 'space.200',
    color: 'color.text'
});
const $4ca46e58b113fec1$var$buildAgentActions = ({ onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent })=>{
    return [
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $4ca46e58b113fec1$var$messages.actionDuplicate),
            onClick: onDuplicateAgent
        },
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $4ca46e58b113fec1$var$messages.actionCopyLink),
            onClick: onCopyAgent
        }
    ];
};
const $4ca46e58b113fec1$var$buildAgentSettings = ({ onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent })=>{
    return [
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $4ca46e58b113fec1$var$messages.actionEdit),
            onClick: onEditAgent
        },
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $4ca46e58b113fec1$var$messages.actionDelete),
            onClick: onDeleteAgent
        }
    ];
};
const $4ca46e58b113fec1$export$a091e6fbe251d12f = ({ isAgentCreatedByCurrentUser: isAgentCreatedByCurrentUser, onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent, onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent, onChatClick: onChatClick, agent: agent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $eUqFw.useState)(false);
    const agentActions = $4ca46e58b113fec1$var$buildAgentActions({
        onDuplicateAgent: onDuplicateAgent,
        onCopyAgent: onCopyAgent
    });
    const agentSetting = $4ca46e58b113fec1$var$buildAgentSettings({
        onEditAgent: onEditAgent,
        onDeleteAgent: ()=>{
            setIsDeleteModalOpen(true);
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        xcss: $4ca46e58b113fec1$var$actionsWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4ca46e58b113fec1$var$chatToAgentButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        shouldFitContainer: true,
        onClick: (e)=>{
            e.stopPropagation();
            onChatClick();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4ca46e58b113fec1$var$chatToAgentButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        xcss: $4ca46e58b113fec1$var$chatPillButtonInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4ca46e58b113fec1$var$chatPillIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kDlNh.ChatPillIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4ca46e58b113fec1$var$chatPillTextStyles
    }, formatMessage($4ca46e58b113fec1$var$messages.actionChatToAgent)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($34Io4))),
                label: "more",
                ref: triggerRef,
                onClick: (e)=>{
                    e.stopPropagation();
                    props.onClick?.(e);
                }
            })),
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, agentActions.map(({ text: text, onClick: onClick }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: idx,
            onClick: (e)=>{
                e.stopPropagation();
                onClick?.();
            }
        }, text);
    })), isAgentCreatedByCurrentUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        hasSeparator: true
    }, agentSetting.map(({ text: text, onClick: onClick }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: idx,
            onClick: (e)=>{
                e.stopPropagation();
                onClick?.();
            }
        }, text);
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Rnl4.AgentDeleteConfirmationModal), {
        isOpen: isDeleteModalOpen,
        onClose: ()=>{
            setIsDeleteModalOpen(false);
        },
        onSubmit: onDeleteAgent,
        agentId: agent.id,
        agentName: agent.name
    }));
};
const $4ca46e58b113fec1$var$messages = (0, $90IgZ.defineMessages)({
    actionChatToAgent: {
        id: 'ptc-directory.agent-profile.action.dropdown.chat-to-agent.nonfinal',
        defaultMessage: 'Chat to Agent',
        description: 'Text for the "chat to agent" action to chat to the agent'
    },
    actionDelete: {
        id: 'ptc-directory.agent-profile.action.dropdown.delete.nonfinal',
        defaultMessage: 'Delete Agent',
        description: 'Text for the "Delete" action to delete an agent'
    },
    actionEdit: {
        id: 'ptc-directory.agent-profile.action.dropdown.edit.nonfinal',
        defaultMessage: 'Edit Agent',
        description: 'Text for the "Edit" action to edit an agent'
    },
    actionCopyLink: {
        id: 'ptc-directory.agent-profile.action.dropdown.copy-link.nonfinal',
        defaultMessage: 'Copy link',
        description: 'Text for the Copy link of an agent'
    },
    actionDuplicate: {
        id: 'ptc-directory.agent-profile.action.dropdown.duplicate.nonfinal',
        defaultMessage: 'Duplicate Agent',
        description: 'Text for the Duplicate Agent action to create a duplicate'
    }
});

});
parcelRegister("kDlNh", function(module, exports) {

$parcel$export(module.exports, "ChatPillIcon", () => $a3e4a399a3fc0cd1$export$38f9b635c1c454e7);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $a3e4a399a3fc0cd1$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.00023 14.25C7.86431 14.25 7.73094 14.287 7.61439 14.3569L3.75024 16.6752V14V4.99998C3.75024 4.30963 4.30988 3.74999 5.00023 3.74998L15.0002 3.74984C15.6906 3.74984 16.2502 4.30948 16.2502 4.99984V12.9999C16.2502 13.6902 15.6906 14.2498 15.0003 14.2499L8.00023 14.25Z",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        fill: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "8",
        width: "2",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "9",
        y: "8",
        width: "2",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "12",
        y: "8",
        width: "2",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));
const $a3e4a399a3fc0cd1$export$38f9b635c1c454e7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        ...props,
        glyph: $a3e4a399a3fc0cd1$var$CustomGlyph,
        label: "",
        size: "small"
    });

});

parcelRegister("6Rnl4", function(module, exports) {

$parcel$export(module.exports, "AgentDeleteConfirmationModal", () => $c2674505d54c0f56$export$39d869cf16a68f79);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6zOB7 = parcelRequire("6zOB7");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $1Yimi = parcelRequire("1Yimi");
const $c2674505d54c0f56$export$39d869cf16a68f79 = ({ onClose: onClose, agentName: agentName, isOpen: isOpen, onSubmit: onSubmit, agentId: agentId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleDeleteAgent = (0, $eUqFw.useCallback)(async ()=>{
        if (agentId) {
            await onSubmit();
            onClose();
        }
    }, [
        agentId,
        onClose,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage($c2674505d54c0f56$var$messages.title, {
        agentName: agentName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage($c2674505d54c0f56$var$messages.body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage($c2674505d54c0f56$var$messages.cancelText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "danger",
        onClick: (_e, event)=>{
            handleDeleteAgent();
        }
    }, formatMessage($c2674505d54c0f56$var$messages.confirmText))))));
};
const $c2674505d54c0f56$var$messages = (0, $90IgZ.defineMessages)({
    cancelText: {
        id: 'profilecard.agent-profile.agent-delete-confirm.cancel-text',
        defaultMessage: 'Cancel'
    },
    confirmText: {
        id: 'profilecard.agent-profile.agent-delete-confirm.confirm-text',
        defaultMessage: 'Delete'
    },
    title: {
        id: 'profilecard.agent-profile.delete-agent-confirm-title',
        defaultMessage: 'Delete "{agentName}"?',
        description: 'Title text for the delete agent confirmation modal'
    },
    body: {
        id: 'profilecard.agent-profile.delete-agent-confirm-body',
        defaultMessage: `Are you sure you want to delete this agent? This action cannot be undone.`,
        description: 'Body text for the delete agent confirmation modal'
    },
    error: {
        id: 'profilecard.agent-profile.delete-agent-error',
        defaultMessage: 'Could not delete agent',
        description: 'Error message displayed when an agent cannot be deleted'
    },
    errorAgentNotFound: {
        id: 'profilecard.agent-profile.delete-agent-error.agent-not-found',
        defaultMessage: 'That agent could not be found.',
        description: 'Error message displayed when an agent cannot be found'
    },
    errorAgentInUse: {
        id: 'profilecard.agent-profile.delete-agent-error.agent-in-use',
        defaultMessage: 'Agent is currently in use. Try again later.',
        description: 'Error message displayed when an agent is in use'
    },
    errorIncorrectOwner: {
        id: 'profilecard.agent-profile.delete-agent-error.incorrect-owner',
        defaultMessage: 'You cannot delete agents you have not created yourself. Please contact the agent owner.',
        description: 'Error message displayed when the agent owner is incorrect'
    },
    agentDeletedSuccess: {
        id: 'profilecard.agent-profile.delete-agent-success',
        defaultMessage: 'Agent has been deleted!',
        description: 'Success message displayed when an agent is deleted'
    }
});

});


parcelRegister("kCTG1", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $66858e19046e4863$export$2c6604b50c274e6f);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $66858e19046e4863$var$styles = (0, $1ZAYh.xcss)({
    width: '360px'
});
const $66858e19046e4863$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $66858e19046e4863$var$styles
    }, children);
};

});

parcelRegister("1Z0pV", function(module, exports) {

$parcel$export(module.exports, "ConversationStarters", () => $7d1e0be3836402a9$export$ea338c37011da44c);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");

var $fc0pM = parcelRequire("fc0pM");
const $7d1e0be3836402a9$export$ea338c37011da44c = ({ isAgentDefault: isAgentDefault, onConversationStarterClick: onConversationStarterClick, userDefinedConversationStarters: userDefinedConversationStarters })=>{
    const handleConversationStarterClick = (conversationStarter)=>{
        onConversationStarterClick(conversationStarter);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fc0pM.AgentConversationStarters), {
        isAgentDefault: isAgentDefault,
        onConversationStarterClick: handleConversationStarterClick,
        userDefinedConversationStarters: userDefinedConversationStarters
    }));
};

});
parcelRegister("fc0pM", function(module, exports) {

$parcel$export(module.exports, "getConversationStarters", () => $09834075c65ca3b7$export$c2d882153e0984c5);
$parcel$export(module.exports, "AgentConversationStarters", () => $09834075c65ca3b7$export$171adfc74aa509c3);
$parcel$export(module.exports, "ConversationStarters", () => $09834075c65ca3b7$export$ea338c37011da44c);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $j9fWg = parcelRequire("j9fWg");

var $iAqay = parcelRequire("iAqay");

var $9Amv1 = parcelRequire("9Amv1");

var $i1PAb = parcelRequire("i1PAb");

var $8qJMo = parcelRequire("8qJMo");
const $09834075c65ca3b7$export$c2d882153e0984c5 = ({ userDefinedConversationStarters: userDefinedConversationStartersParam, isAgentDefault: isAgentDefault })=>{
    const customAgentConversationStarters = [
        (0, $8qJMo.messages).agentEmptyStateSuggestion1,
        (0, $8qJMo.messages).agentEmptyStateSuggestion2,
        (0, $8qJMo.messages).agentEmptyStateSuggestion3
    ];
    const userDefinedConversationStarters = userDefinedConversationStartersParam ?? [];
    const defaultAgentConversationStarters = [
        (0, $8qJMo.messages).emptyStateSuggestion1,
        (0, $8qJMo.messages).emptyStateSuggestion2,
        (0, $8qJMo.messages).emptyStateSuggestion3
    ];
    const getCombinedConversationStarters = ()=>{
        const shouldCombine = !isAgentDefault;
        if (shouldCombine) // Return default suggestions + user defined suggestions with a max of 3 suggestions
        return [
            ...customAgentConversationStarters.slice(0, 3 - userDefinedConversationStarters.length),
            ...userDefinedConversationStarters
        ];
        return defaultAgentConversationStarters;
    };
    return {
        userDefinedConversationStarters: userDefinedConversationStarters,
        customAgentConversationStarters: customAgentConversationStarters,
        defaultAgentConversationStarters: defaultAgentConversationStarters,
        combinedConversationStarters: getCombinedConversationStarters()
    };
};
const $09834075c65ca3b7$export$171adfc74aa509c3 = ({ userDefinedConversationStarters: userDefinedConversationStarters, isAgentDefault: isAgentDefault, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { combinedConversationStarters: combinedConversationStarters } = (0, $eUqFw.useMemo)(()=>$09834075c65ca3b7$export$c2d882153e0984c5({
            userDefinedConversationStarters: userDefinedConversationStarters,
            isAgentDefault: isAgentDefault
        }), [
        userDefinedConversationStarters,
        isAgentDefault
    ]);
    const starters = (0, $eUqFw.useMemo)(()=>combinedConversationStarters.map((starter)=>typeof starter === 'string' ? starter : formatMessage(starter)), [
        combinedConversationStarters,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($09834075c65ca3b7$export$ea338c37011da44c, {
        starters: starters,
        ...props
    });
};
const $09834075c65ca3b7$export$ea338c37011da44c = ({ starters: starters, onConversationStarterClick: onConversationStarterClick, showReloadButton: showReloadButton = false, onReloadButtonClick: onReloadButtonClick = ()=>{} })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, starters.map((starter, index)=>{
        const isLastStarter = index === starters.length - 1;
        const chatPill = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i1PAb.ChatPill), {
            testId: "conversation-starter",
            key: starter,
            onClick: ()=>onConversationStarterClick(starter)
        }, starter);
        return isLastStarter && showReloadButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.050",
            grow: "fill",
            alignInline: "end",
            key: starter
        }, chatPill, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAqay))),
            onClick: onReloadButtonClick,
            appearance: "subtle",
            label: ""
        })) : chatPill;
    }));
};

});
parcelRegister("iAqay", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3fefdb7c4870975ce9a50ab04b1b4e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d87fe36e3f00d89c$var$_react = $d87fe36e3f00d89c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d87fe36e3f00d89c$var$_UNSAFE_baseNew = $d87fe36e3f00d89c$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $d87fe36e3f00d89c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d87fe36e3f00d89c$var$RetryIcon = (props)=>/*#__PURE__*/ $d87fe36e3f00d89c$var$_react.default.createElement($d87fe36e3f00d89c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 14a6 6 0 1 1 6-6v2.5m2.625-2.125L12.75 11l-2.625-2.625"/>`
    }, props));
$d87fe36e3f00d89c$var$RetryIcon.displayName = 'RetryIcon';
var $d87fe36e3f00d89c$var$_default = module.exports.default = $d87fe36e3f00d89c$var$RetryIcon;

});

parcelRegister("i1PAb", function(module, exports) {

$parcel$export(module.exports, "ChatPill", () => $54ff5c9d6063b7a8$export$e33faa86e0996d96);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $kDlNh = parcelRequire("kDlNh");
const $54ff5c9d6063b7a8$var$buttonStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    padding: 'space.100',
    borderRadius: 'border.radius.200',
    borderBottomRightRadius: "var(--ds-border-radius-050, 2px)",
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    lineHeight: '16px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flexShrink: 1,
    backgroundColor: 'color.background.neutral',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.pressed'
    }
});
const $54ff5c9d6063b7a8$var$buttonInlineStyles = (0, $1ZAYh.xcss)({
    paddingInline: 'space.025'
});
const $54ff5c9d6063b7a8$var$queryTextStyles = (0, $1ZAYh.xcss)({
    wordBreak: 'break-word',
    textAlign: 'left'
});
const $54ff5c9d6063b7a8$var$whiteSpacePreWrapStyles = (0, $1ZAYh.xcss)({
    whiteSpace: 'pre-wrap'
});
const $54ff5c9d6063b7a8$export$e33faa86e0996d96 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        ref: ref,
        ...props,
        xcss: $54ff5c9d6063b7a8$var$buttonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        xcss: $54ff5c9d6063b7a8$var$buttonInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kDlNh.ChatPillIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $54ff5c9d6063b7a8$var$queryTextStyles,
            whiteSpacePreWrap && $54ff5c9d6063b7a8$var$whiteSpacePreWrapStyles
        ]
    }, children))));

});

parcelRegister("8qJMo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e80cab5507804e86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $e80cab5507804e86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    emptyStateSuggestion1: {
        id: 'ai-mate.chat-history.empty-state.suggestion1',
        defaultMessage: 'Are any of my tickets overdue?',
        description: 'The first suggestion displayed in the empty state of the chat history'
    },
    emptyStateSuggestion2: {
        id: 'ai-mate.chat-history.empty-state.suggestion2',
        defaultMessage: 'What should I work on next?',
        description: 'The second suggestion displayed in the empty state of the chat history'
    },
    emptyStateSuggestion3: {
        id: 'ai-mate.chat-history.empty-state.suggestion3',
        defaultMessage: 'Write an update about my week',
        description: 'The third suggestion displayed in the empty state of the chat history'
    },
    agentEmptyStateSuggestion1: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion1',
        defaultMessage: 'Tell me about yourself',
        description: 'The first suggestion displayed in the empty state when an agent is selected'
    },
    agentEmptyStateSuggestion2: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion2',
        defaultMessage: 'What can you help me with?',
        description: 'The second suggestion displayed in the empty state when an agent is selected'
    },
    agentEmptyStateSuggestion3: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion3',
        defaultMessage: "Summarize what I'm looking at",
        description: 'The third suggestion displayed in the empty state when an agent is selected'
    }
});

});



parcelRegister("2TnXV", function(module, exports) {

$parcel$export(module.exports, "useAgentUrlActions", () => $934b89b97dc0779a$export$56665b80ee272742);

var $eUqFw = parcelRequire("eUqFw");

var $bW292 = parcelRequire("bW292");

var $2b1Yl = parcelRequire("2b1Yl");
const $934b89b97dc0779a$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $934b89b97dc0779a$var$ROVO_PARAM_PREFIX = 'rovoChat';
const $934b89b97dc0779a$var$createRovoParams = (params)=>{
    const rovoParams = {};
    Object.entries(params).forEach(([key, value])=>{
        rovoParams[`${$934b89b97dc0779a$var$ROVO_PARAM_PREFIX}${$934b89b97dc0779a$export$fda91e425d265029(key)}`] = encodeURIComponent(value);
    });
    return rovoParams;
};
const $934b89b97dc0779a$export$56665b80ee272742 = ({ cloudId: cloudId })=>{
    const onEditAgent = (0, $eUqFw.useCallback)((agentId)=>{
        const url = `${(0, $bW292.getATLContextUrl)('home')}/agents/${agentId}/edit`;
        const urlWithParams = (0, $2b1Yl.encodeParamsToUrl)(url, {
            cloudId: cloudId,
            ...$934b89b97dc0779a$var$createRovoParams({
                cloudId: cloudId
            })
        });
        window.open(urlWithParams, '_blank', 'noopener, noreferrer');
    }, [
        cloudId
    ]);
    const onCopyAgent = (agentId)=>{
        navigator.clipboard.writeText(`${window.location.origin}/people/agent/${agentId}`);
    };
    const onDuplicateAgent = (0, $eUqFw.useCallback)((agentId)=>{
        const baseUrl = `${(0, $bW292.getATLContextUrl)('home')}/chat/agents/new`;
        const urlWithParams = (0, $2b1Yl.encodeParamsToUrl)(baseUrl, {
            cloudId: cloudId,
            ...$934b89b97dc0779a$var$createRovoParams({
                cloudId: cloudId,
                agentId: agentId,
                pathway: 'agents-create'
            })
        });
        window.open(urlWithParams, '_blank', 'noopener, noreferrer');
    }, [
        cloudId
    ]);
    const onConversationStarter = ({ agentId: agentId, prompt: prompt })=>{
        const baseUrl = `${(0, $bW292.getATLContextUrl)('home')}/chat`;
        const urlWithParams = (0, $2b1Yl.encodeParamsToUrl)(baseUrl, {
            cloudId: cloudId,
            ...$934b89b97dc0779a$var$createRovoParams({
                cloudId: cloudId,
                agentId: agentId,
                prompt: prompt,
                pathway: 'chat'
            })
        });
        window.open(urlWithParams, '_blank', 'noopener, noreferrer');
    };
    const onOpenChat = ()=>{
        const baseUrl = `${(0, $bW292.getATLContextUrl)('home')}/chat`;
        const urlWithParams = (0, $2b1Yl.encodeParamsToUrl)(baseUrl, {
            cloudId: cloudId,
            ...$934b89b97dc0779a$var$createRovoParams({
                cloudId: cloudId
            })
        });
        window.open(urlWithParams, '_blank', 'noopener, noreferrer');
    };
    return {
        onEditAgent: onEditAgent,
        onCopyAgent: onCopyAgent,
        onDuplicateAgent: onDuplicateAgent,
        onOpenChat: onOpenChat,
        onConversationStarter: onConversationStarter
    };
};

});
parcelRegister("2b1Yl", function(module, exports) {

$parcel$export(module.exports, "encodeParamsToUrl", () => $fdbe762c1a952693$export$3220405ab77f2c5d);
const $fdbe762c1a952693$export$3220405ab77f2c5d = (baseUrl, params)=>{
    const url = new URL(baseUrl);
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params))searchParams.append(key, String(value));
    url.search = searchParams.toString();
    return url.toString();
};

});


parcelRegister("kKBsF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $755d403db0b4a04c$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $755d403db0b4a04c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    agentDeletedSuccessFlagTitle: {
        id: 'profilecard.agent-profile-card.delete-agent-success-flag-title',
        defaultMessage: 'Agent deleted',
        description: 'Flag message title displayed when an agent is deleted'
    },
    agentDeletedSuccessFlagDescription: {
        id: 'profilecard.agent-profile-card.delete-agent-success-flag-description',
        defaultMessage: 'You deleted {agentName}',
        description: 'Flag message description displayed when an agent is deleted'
    },
    agentDeletedErrorFlagTitle: {
        id: 'profilecard.agent-profile-card.delete-agent-error-flag-title',
        defaultMessage: 'Failed to delete Agent',
        description: 'Flag message title displayed when there is an error deleting agent'
    },
    agentDeletedErrorFlagDescription: {
        id: 'profilecard.agent-profile-card.delete-agent-error-flag-description',
        defaultMessage: 'Something went wrong while deleting the agent. Try again in a few moments.',
        description: 'Flag message description displayed when there is an error deleting agent'
    }
});

});


parcelRegister("94Fw4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b80709e37e35f48e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $2jDha = parcelRequire("2jDha");

var $dx7Op = parcelRequire("dx7Op");
var $btCBO = parcelRequire("btCBO");

var $XHGTv = parcelRequire("XHGTv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $5Jx7I = parcelRequire("5Jx7I");

var $aCbpp = parcelRequire("aCbpp");

var $3vXh8 = parcelRequire("3vXh8");

var $7NIUg = parcelRequire("7NIUg");


var $cEOpo = parcelRequire("cEOpo");
parcelRequire("iINHb");
var $9Pgj1 = parcelRequire("9Pgj1");

var $j7pJq = parcelRequire("j7pJq");

var $dO06T = parcelRequire("dO06T");
class $b80709e37e35f48e$export$f811dc569217c959 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.defaultProps = {
            actions: [],
            trigger: 'hover',
            position: 'bottom-start',
            triggerLinkType: 'link'
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentDidUpdate(prevProps) {
        const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
        const { visible: visible } = this.state;
        // just re-fetching data when the card opens
        if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
    }
    handleClientSuccess(team, shouldShowGiveKudos) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: team,
            shouldShowGiveKudos: shouldShowGiveKudos,
            teamCentralBaseUrl: this.props.resourceClient.getTeamCentralBaseUrl()
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    filterActions() {
        const actions = (0, $5Jx7I.default)(this.props.actions, this.state.data);
        if (this.state.shouldShowGiveKudos) {
            const kudosAction = {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).giveKudosButton),
                id: 'give-kudos',
                callback: ()=>{
                    this.openKudosDrawer();
                },
                link: this.kudosUrl()
            };
            return actions.concat([
                kudosAction
            ]);
        }
        return actions;
    }
    renderPopup() {
        if (this.state.renderError) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Pgj1.ErrorBoundary), {
            onError: this.onErrorBoundary
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
            isOpen: !!this.state.visible,
            onClose: this.onClose,
            placement: this.props.position,
            content: this.renderProfileCard,
            trigger: (triggerProps)=>this.renderTrigger(triggerProps),
            zIndex: (0, $lcnyw.layers).modal(),
            shouldFlip: true,
            autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
            shouldRenderToParent: (0, $XHGTv.fg)('enable_appropriate_reading_order_in_profile_card')
        }));
    }
    render() {
        if (this.props.children) return this.renderPopup();
        else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
    }
    constructor(...args){
        super(...args);
        this._isMounted = false;
        this.showTimer = 0;
        this.hideTimer = 0;
        this.openedByHover = false;
        this.openTime = 0;
        this.fireAnalytics = (payload)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $3vXh8.fireEvent)(this.props.createAnalyticsEvent, payload);
        };
        this.fireAnalyticsWithDuration = (generator)=>{
            const event = generator((0, $cEOpo.getPageTime)() - this.openTime);
            this.fireAnalytics(event);
        };
        this.hideProfilecard = (delay = 0)=>{
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = window.setTimeout(()=>{
                this.setState({
                    visible: false
                });
            }, delay);
        };
        this.showProfilecard = (delay = 0)=>{
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            this.showTimer = window.setTimeout(()=>{
                if (!this.state.visible) {
                    this.clientFetchProfile();
                    this.openTime = (0, $cEOpo.getPageTime)();
                    this.setState({
                        visible: true
                    });
                }
            }, delay);
        };
        this.onClick = (event)=>{
            if (this.props.triggerLinkType === 'link') // We want to prevent navigation occurring on basic click, but it's important that
            // cmd+click, ctrl+click, etc. still work as expected.
            {
                if ((0, $7NIUg.isBasicClick)(event)) event.preventDefault();
            }
            if (this.props.triggerLinkType === 'clickable-link') {
                if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
            }
            if (this.props.trigger !== 'hover') {
                this.openedByHover = false;
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics((0, $3vXh8.cardTriggered)('team', 'click'));
            }
        };
        this.onMouseEnter = ()=>{
            if (this.props.trigger === 'click') return;
            if (!this.state.visible) {
                this.openedByHover = true;
                this.fireAnalytics((0, $3vXh8.cardTriggered)('team', 'hover'));
            }
            this.showProfilecard((0, $515c9dbc88c31cf4$export$5b956b542f1bc1b3));
        };
        this.onMouseLeave = ()=>{
            if (this.props.trigger === 'click') return;
            if (this.openedByHover) this.hideProfilecard((0, $515c9dbc88c31cf4$export$89a9f35a94d7f196));
        };
        this.onClose = ()=>{
            this.hideProfilecard();
        };
        this.openKudosDrawer = ()=>{
            this.hideProfilecard((0, $515c9dbc88c31cf4$export$89a9f35a94d7f196));
            this.setState({
                kudosDrawerOpen: true
            });
        };
        this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        };
        this.kudosUrl = ()=>{
            const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
            const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
            return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
        };
        this.stopPropagation = (event)=>{
            // We need to stop propagation when users click on the card, so that it
            // doesn't trigger any special effects that occur when clicking the trigger.
            event.stopPropagation();
        };
        this.triggerListeners = {
            onClick: this.onClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        this.cardListeners = {
            onClick: this.stopPropagation,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false
        };
        this.clientFetchProfile = ()=>{
            const { orgId: orgId, teamId: teamId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                data: null
            }, ()=>{
                const fireEvent = (event)=>{
                    this.fireAnalytics(event);
                };
                const requests = Promise.all([
                    this.props.resourceClient.getTeamProfile(teamId, orgId, fireEvent),
                    this.props.resourceClient.shouldShowGiveKudos()
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        };
        this.onErrorBoundary = ()=>{
            this.fireAnalytics((0, $3vXh8.profileCardRendered)('team', 'errorBoundary', {
                duration: 0
            }));
            this.setState({
                renderError: true
            });
        };
        this.renderProfileCard = ()=>{
            const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
            const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
            const newProps = {
                clientFetchProfile: this.clientFetchProfile,
                actions: this.filterActions(),
                analytics: this.fireAnalyticsWithDuration,
                team: data || undefined,
                generateUserLink: generateUserLink,
                onUserClick: onUserClick,
                viewingUserId: viewingUserId,
                viewProfileLink: viewProfileLink,
                viewProfileOnClick: viewProfileOnClick
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", this.cardListeners, this.state.visible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dO06T.default), {
                    analytics: this.fireAnalyticsWithDuration
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7pJq.TeamProfileCardLazy), {
                ...newProps,
                isLoading: isLoading,
                hasError: hasError,
                errorType: error
            })));
        };
        this.renderKudosLauncher = ()=>{
            return this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dx7Op.GiveKudosLauncherLazy), {
                isOpen: this.state.kudosDrawerOpen,
                recipient: {
                    type: (0, $btCBO.KudosType).TEAM,
                    recipientId: this.props.teamId
                },
                analyticsSource: "team-profile-card",
                teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                cloudId: this.props.cloudId || '',
                addFlag: this.props.addFlag,
                onClose: this.closeKudosDrawer
            }));
        };
        this.renderTrigger = (triggerProps)=>{
            const { children: children, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
            if (triggerLinkType === 'none') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.renderKudosLauncher(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                "data-testid": "team-profilecard-trigger-wrapper",
                ...triggerProps,
                ...this.triggerListeners
            }, children));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.renderKudosLauncher(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                "data-testid": "team-profilecard-trigger-wrapper",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    color: 'initial',
                    textDecoration: 'none'
                },
                href: viewProfileLink,
                ...triggerProps,
                ref: triggerProps.ref,
                ...this.triggerListeners
            }, children));
        };
    }
}
var $b80709e37e35f48e$export$2e2bcd8739ae039 = (0, $2jDha.default)()($b80709e37e35f48e$export$f811dc569217c959);

});
parcelRegister("dx7Op", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $1be4d1ec21b65937$export$93fe397a02fe8b76);

var $eUqFw = parcelRequire("eUqFw");

const $1be4d1ec21b65937$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("7lJgg")));

});
parcelRegister("7lJgg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("dSAyy")
]).then(()=>parcelRequire('5A0d0'));

});


parcelRegister("btCBO", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $5cf31a8d69eb9e81$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $5cf31a8d69eb9e81$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $5cf31a8d69eb9e81$export$7a1fc1a1b0477464);
var $5cf31a8d69eb9e81$export$4fa2020056771264;
(function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
})($5cf31a8d69eb9e81$export$4fa2020056771264 || ($5cf31a8d69eb9e81$export$4fa2020056771264 = {}));
var $5cf31a8d69eb9e81$export$d21f9befaa2961a;
(function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
})($5cf31a8d69eb9e81$export$d21f9befaa2961a || ($5cf31a8d69eb9e81$export$d21f9befaa2961a = {}));
const $5cf31a8d69eb9e81$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($5cf31a8d69eb9e81$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("5Jx7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c805980c1a8d0797$export$2e2bcd8739ae039);
const $c805980c1a8d0797$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $c805980c1a8d0797$export$2e2bcd8739ae039 = $c805980c1a8d0797$var$filterActions;

});

parcelRegister("aCbpp", function(module, exports) {

$parcel$export(module.exports, "default", () => $99816a416a8a70ef$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $99816a416a8a70ef$var$messages = (0, $90IgZ.defineMessages)({
    inactiveAccountMsg: {
        id: 'pt.profile-card.inactive.account',
        defaultMessage: 'Account deactivated',
        description: 'A text in a grey lozenge shows that this user is inactive'
    },
    generalDescMsgForDisabledUser: {
        id: 'pt.profile-card.general.msg.disabled.user',
        defaultMessage: 'You can no longer collaborate with this person.',
        description: 'A first sentence of a long text explains this user is inactive/closed'
    },
    inactiveAccountDescMsgNoDate: {
        id: 'pt.profile-card.inactive.account.no.date',
        defaultMessage: 'Their account has been deactivated.',
        description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.inactive.account.has.date.this.week',
        defaultMessage: 'Their account was deactivated this week.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.inactive.account.has.date.this.month',
        defaultMessage: 'Their account was deactivated this month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.inactive.account.has.date.last.month',
        defaultMessage: 'Their account was deactivated last month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.inactive.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deactivated for a few months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.inactive.account.has.date.several.months',
        defaultMessage: 'Their account has been deactivated for several months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deactivated for more than a year.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    closedAccountMsg: {
        id: 'pt.profile-card.closed.account',
        defaultMessage: 'Account deleted',
        description: 'A text in a grey lozenge shows that this user is closed/deleted'
    },
    closedAccountDescMsgNoDate: {
        id: 'pt.profile-card.closed.account.no.date',
        defaultMessage: 'Their account has been deleted.',
        description: 'A long text explains this user is closed when we do not know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.closed.account.has.date.this.week',
        defaultMessage: 'Their account was deleted this week.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.closed.account.has.date.this.month',
        defaultMessage: 'Their account was deleted this month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.closed.account.has.date.last.month',
        defaultMessage: 'Their account was deleted last month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.closed.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deleted for a few months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.closed.account.has.date.several.months',
        defaultMessage: 'Their account has been deleted for several months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deleted for more than a year.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    disabledAccountDefaultName: {
        id: 'pt.profile-card.disabled.account.default.name',
        defaultMessage: 'Former user',
        description: 'A default name when we cannot get name of an inactive or closed user'
    },
    teamViewProfile: {
        id: 'pt.team-profile-card.team.action.view-profile',
        defaultMessage: 'View profile',
        description: "Button that takes you to view this team\u2019s profile"
    },
    memberCount: {
        id: 'pt.team-profile-card.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team'
    },
    memberCountIncludingYou: {
        id: 'pt.team-profile-card.team.member.count-including-you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team and highlight that the user is a member'
    },
    membersMoreThan50: {
        id: 'pt.team-profile-card.team.member.many',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the team has more than 50 members'
    },
    membersMoreThan50IncludingYou: {
        id: 'pt.team-profile-card.team.member.many-including-you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the team has more than 50 members and highlight that the user is a member'
    },
    teamErrorTitle: {
        id: 'pt.team-profile-card.error.title',
        defaultMessage: "We\u2019re having trouble retrieving this teams information",
        description: 'Title for an error view explaining that data for this team cannot be accessed'
    },
    teamErrorText: {
        id: 'pt.team-profile-card.error.suggestion',
        defaultMessage: 'Wait a few moments, then try again.',
        description: 'Second line suggesting how to fix the issue'
    },
    teamErrorButton: {
        id: 'pt.team-profile-card.error.refresh-button',
        defaultMessage: 'Try again',
        description: 'Text on a button that will try to get the data again when clicked'
    },
    teamForbiddenErrorStateTitle: {
        id: 'pt.team-profile-card.forbidden-error-state.title',
        defaultMessage: "We can\u2019t show you this team",
        description: 'Title for the error state that is displayed when a user lacks access to the team'
    },
    teamForbiddenErrorStateDescription: {
        id: 'pt.team-profile-card.forbidden-error-state.description',
        defaultMessage: "You don\u2019t have access to view this team.",
        description: 'Description for the error state that is displayed when a user lacks access to the team'
    },
    managerSectionHeading: {
        id: 'pt.team-profile-card.manager.heading',
        defaultMessage: 'Manager',
        description: "Title for a section on the profile card that show the user's direct manager"
    },
    directReportsSectionHeading: {
        id: 'pt.team-profile-card.directReports.heading',
        defaultMessage: 'Direct reports',
        description: "Title for a section on the profile card that show the user's direct reports"
    },
    giveKudosButton: {
        id: 'pt.profile-card.give-kudos',
        defaultMessage: 'Give kudos',
        description: 'Title for the button on the profile card for a user to give a kudos'
    },
    profileCardMoreIconLabel: {
        id: 'pt.profile-card.more-icon-label',
        defaultMessage: 'More',
        description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
    }
});
var $99816a416a8a70ef$export$2e2bcd8739ae039 = $99816a416a8a70ef$var$messages;

});

parcelRegister("7NIUg", function(module, exports) {

$parcel$export(module.exports, "isBasicClick", () => $211cf3e2277295bb$export$eddcd8a5b7e09991);
const $211cf3e2277295bb$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

});

const $515c9dbc88c31cf4$export$5b956b542f1bc1b3 = 800;
const $515c9dbc88c31cf4$export$89a9f35a94d7f196 = 200;

parcelRegister("j7pJq", function(module, exports) {

$parcel$export(module.exports, "TeamProfileCardLazy", () => $5ae4a5a4fd9fbf1e$export$82a49d896f41ca78);

var $eUqFw = parcelRequire("eUqFw");

const $5ae4a5a4fd9fbf1e$export$82a49d896f41ca78 = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>Promise.resolve((parcelRequire("g8DVf"))));

});
parcelRegister("g8DVf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b92b2ec2eaaa8f9d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4XQdE = parcelRequire("4XQdE");

var $7opLA = parcelRequire("7opLA");

var $7u4fN = parcelRequire("7u4fN");

var $51sCz = parcelRequire("51sCz");

var $34Io4 = parcelRequire("34Io4");

var $bo4OB = parcelRequire("bo4OB");
var $8PFhw = parcelRequire("8PFhw");

var $XHGTv = parcelRequire("XHGTv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $aCbpp = parcelRequire("aCbpp");

var $kqibQ = parcelRequire("kqibQ");

var $fnJ1y = parcelRequire("fnJ1y");

var $dRbkr = parcelRequire("dRbkr");

var $3vXh8 = parcelRequire("3vXh8");

var $7NIUg = parcelRequire("7NIUg");
parcelRequire("iINHb");
var $8J4a2 = parcelRequire("8J4a2");

var $22Tpa = parcelRequire("22Tpa");

var $dO06T = parcelRequire("dO06T");
const $b92b2ec2eaaa8f9d$var$LARGE_MEMBER_COUNT = 50;
const $b92b2ec2eaaa8f9d$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
function $b92b2ec2eaaa8f9d$var$onMemberClick(callback, userId, analytics, index, hasHref) {
    return (event)=>{
        analytics((duration)=>(0, $3vXh8.teamAvatarClicked)({
                duration: duration,
                hasHref: hasHref,
                hasOnClick: !!callback,
                index: index
            }));
        if (callback) callback(userId, event);
    };
}
const $b92b2ec2eaaa8f9d$var$TeamMembers = ({ analytics: analytics, generateUserLink: generateUserLink, members: members, onUserClick: onUserClick, includingYou: includingYou })=>{
    const count = members ? members.length : 0;
    const message = includingYou ? count >= $b92b2ec2eaaa8f9d$var$LARGE_MEMBER_COUNT ? (0, $aCbpp.default).membersMoreThan50IncludingYou : (0, $aCbpp.default).memberCountIncludingYou : count >= $b92b2ec2eaaa8f9d$var$LARGE_MEMBER_COUNT ? (0, $aCbpp.default).membersMoreThan50 : (0, $aCbpp.default).memberCount;
    // Use a ref to track whether this is currently open, so we can fire events
    // iff the more section is being opened (not closed).
    const isMoreMembersOpen = (0, $eUqFw.useRef)(false);
    const onMoreClick = (0, $eUqFw.useCallback)(()=>{
        const { current: isOpen } = isMoreMembersOpen;
        if (!isOpen) analytics((duration)=>(0, $3vXh8.moreMembersClicked)({
                duration: duration,
                memberCount: count
            }));
        isMoreMembersOpen.current = !isOpen;
    }, [
        analytics,
        count
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.MemberCount), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...message,
        values: {
            count: count
        }
    })), members && members.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.AvatarSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        appearance: "stack",
        data: members.map((member, index)=>{
            const href = generateUserLink?.(member.id);
            const onClick = $b92b2ec2eaaa8f9d$var$onMemberClick(onUserClick, member.id, analytics, index, !!generateUserLink);
            return {
                key: member.id,
                name: member.fullName,
                src: member.avatarUrl,
                href: href,
                onClick: onClick
            };
        }),
        maxCount: 9,
        showMoreButtonProps: {
            onClick: onMoreClick
        },
        testId: "profilecard-avatar-group"
    })));
};
function $b92b2ec2eaaa8f9d$var$onActionClick(action, analytics, index) {
    return (event, ...args)=>{
        analytics((duration)=>(0, $3vXh8.actionClicked)('team', {
                duration: duration,
                hasHref: !!action.link,
                hasOnClick: !!action.callback,
                index: index,
                actionId: action.id || ''
            }));
        if (action.callback && (0, $7NIUg.isBasicClick)(event)) {
            event.preventDefault();
            action.callback(event, ...args);
        }
    };
}
const $b92b2ec2eaaa8f9d$var$ActionButton = ({ action: action, analytics: analytics, index: index })=>{
    const isGiveKudosActionButton = action.id === $b92b2ec2eaaa8f9d$var$GIVE_KUDOS_ACTION_ID;
    const actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        key: action.id || index,
        onClick: $b92b2ec2eaaa8f9d$var$onActionClick(action, analytics, index),
        href: action.link,
        shouldFitContainer: true
    }, action.label, isGiveKudosActionButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.KudosBlobAnimation), null))));
    if (isGiveKudosActionButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AnimatedKudosButton), null, actionButton);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.WrappedButton), null, actionButton);
};
const $b92b2ec2eaaa8f9d$var$ExtraActions = ({ actions: actions, analytics: analytics })=>{
    const [isOpen, setOpen] = (0, $eUqFw.useState)(false);
    const count = actions.length;
    const onMoreClick = (0, $eUqFw.useCallback)((shouldBeOpen)=>{
        if (shouldBeOpen) // Only fire this event when OPENING the dropdown
        analytics((duration)=>(0, $3vXh8.moreActionsClicked)('team', {
                duration: duration,
                numActions: count + 2
            }));
        setOpen(shouldBeOpen);
    }, [
        analytics,
        count
    ]);
    if (!count) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.MoreButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>setOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
                    onClick: $b92b2ec2eaaa8f9d$var$onActionClick(action, analytics, index + 2),
                    key: action.id || index,
                    href: action.link
                }, action.label))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                testId: "more-actions-button",
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>onMoreClick(!isOpen),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Io4))), {
                    spacing: "spacious",
                    label: "actions",
                    color: "currentColor"
                })
            }),
        zIndex: (0, $lcnyw.layers).modal(),
        shouldRenderToParent: (0, $XHGTv.fg)('enable_appropriate_reading_order_in_profile_card')
    }));
};
const $b92b2ec2eaaa8f9d$var$ButtonSection = ({ actions: actions, analytics: analytics })=>{
    if (!actions) return null;
    const extraActions = actions.slice(2);
    const initialActions = actions.slice(0, 2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.ActionButtons), null, initialActions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$ActionButton, {
            action: action,
            analytics: analytics,
            index: index,
            key: index
        })), extraActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$ExtraActions, {
        actions: extraActions,
        analytics: analytics
    }));
};
const $b92b2ec2eaaa8f9d$var$TeamProfilecardContent = ({ actions: actions, analytics: analytics, team: team, viewingUserId: viewingUserId, generateUserLink: generateUserLink, onUserClick: onUserClick, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick })=>{
    const allActions = [
        {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).teamViewProfile),
            link: viewProfileLink,
            callback: viewProfileOnClick,
            id: 'view-profile'
        },
        ...actions || []
    ];
    const includingYou = team.members && team.members.some((member)=>member.id === viewingUserId);
    (0, $eUqFw.useEffect)(()=>{
        analytics((duration)=>(0, $3vXh8.profileCardRendered)('team', 'content', {
                duration: duration,
                numActions: allActions.length,
                memberCount: team.members?.length,
                includingYou: includingYou,
                descriptionLength: team.description.length,
                titleLength: team.displayName.length
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardWrapper), {
        "data-testid": "team-profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardHeader), {
        image: team.largeHeaderImageUrl || team.smallHeaderImageUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: team.displayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.TeamName), null, team.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$TeamMembers, {
        analytics: analytics,
        members: team.members,
        generateUserLink: generateUserLink,
        includingYou: includingYou,
        onUserClick: onUserClick
    }), team.description.trim() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.DescriptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.Description), null, team.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$ButtonSection, {
        actions: allActions,
        analytics: analytics
    })));
};
const $b92b2ec2eaaa8f9d$var$ErrorMessage = ({ analytics: analytics, clientFetchProfile: clientFetchProfile, isLoading: isLoading })=>{
    const hasRetry = !!clientFetchProfile;
    (0, $eUqFw.useEffect)(()=>{
        analytics((duration)=>(0, $3vXh8.profileCardRendered)('team', 'error', {
                duration: duration,
                hasRetry: hasRetry
            }));
    }, [
        analytics,
        hasRetry
    ]);
    const retry = (0, $eUqFw.useCallback)(()=>{
        analytics((duration)=>(0, $3vXh8.errorRetryClicked)({
                duration: duration
            }));
        if (clientFetchProfile) clientFetchProfile();
    }, [
        analytics,
        clientFetchProfile
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorWrapper), {
        "data-testid": "team-profilecard-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8J4a2.ErrorIllustration), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.TeamErrorTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).teamErrorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.TeamErrorText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).teamErrorText)), clientFetchProfile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.ActionButtons), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.WrappedButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        testId: "client-fetch-profile-button",
        shouldFitContainer: true,
        onClick: retry,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).teamErrorButton)))));
};
const $b92b2ec2eaaa8f9d$var$TeamProfileCard = (props)=>{
    const { analytics: analytics, clientFetchProfile: clientFetchProfile, hasError: hasError, isLoading: isLoading, team: team, errorType: errorType } = props;
    if (hasError) {
        if (errorType?.reason === 'TEAMS_FORBIDDEN') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22Tpa.default), {
            analytics: analytics
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardWrapper), {
            "data-testid": "team-profilecard"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$ErrorMessage, {
            analytics: analytics,
            clientFetchProfile: clientFetchProfile,
            isLoading: isLoading
        }));
    }
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dO06T.default), {
        analytics: analytics
    });
    if (team) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$TeamProfilecardContent, {
        ...props,
        team: team
    });
    return null;
};
var $b92b2ec2eaaa8f9d$export$2e2bcd8739ae039 = $b92b2ec2eaaa8f9d$var$TeamProfileCard;

});
parcelRegister("dRbkr", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $44bed1e2692b7853$export$6aa22a823032b784);
$parcel$export(module.exports, "TeamForbiddenErrorStateWrapper", () => $44bed1e2692b7853$export$66ecf3d3b7b1c016);
$parcel$export(module.exports, "CardHeader", () => $44bed1e2692b7853$export$5665775b26e26c5d);
$parcel$export(module.exports, "CardContent", () => $44bed1e2692b7853$export$64ef9b8c11710c47);
$parcel$export(module.exports, "TeamName", () => $44bed1e2692b7853$export$8fe6f0aed18a58c7);
$parcel$export(module.exports, "MemberCount", () => $44bed1e2692b7853$export$1cbd03a20253b620);
$parcel$export(module.exports, "AvatarSection", () => $44bed1e2692b7853$export$82a6f3ee677bdbfe);
$parcel$export(module.exports, "DescriptionWrapper", () => $44bed1e2692b7853$export$2bf1f2b0d31b60fc);
$parcel$export(module.exports, "Description", () => $44bed1e2692b7853$export$393edc798c47379d);
$parcel$export(module.exports, "ActionButtons", () => $44bed1e2692b7853$export$88c65d2d98aab183);
$parcel$export(module.exports, "WrappedButton", () => $44bed1e2692b7853$export$44e087c32db6077d);
$parcel$export(module.exports, "MoreButton", () => $44bed1e2692b7853$export$7f94856880993f27);
$parcel$export(module.exports, "LoadingWrapper", () => $44bed1e2692b7853$export$43a792a870d28db2);
$parcel$export(module.exports, "AccessLockSVGWrapper", () => $44bed1e2692b7853$export$71bcd744fda975e5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $lcnyw = parcelRequire("lcnyw");

var $4lTFP = parcelRequire("4lTFP");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
function $44bed1e2692b7853$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $44bed1e2692b7853$export$a443be8291b92497 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f414"
})({
    name: "ck88l6",
    styles: "display:inherit"
});
const $44bed1e2692b7853$export$6aa22a823032b784 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f413"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $5PC5M.bgColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $lcnyw.borderRadius)()}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $lcnyw.gridSize)() * 40}px`,
    position: 'relative',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale'
});
const $44bed1e2692b7853$export$66ecf3d3b7b1c016 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f412"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $lcnyw.gridSize)() * 40}px`,
    position: 'relative'
});
const $44bed1e2692b7853$export$5665775b26e26c5d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f411"
})("background-color:", (props)=>props.isLoading ? `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : props.image ? '' : (0, $5PC5M.teamHeaderBgColor), ";background-image:", (props)=>props.image ? `url(${props.image})` : '', ";background-repeat:no-repeat;background-position:center;background-size:cover;box-sizing:content-box;height:", (0, $lcnyw.gridSize)() * 16, "px;");
const $44bed1e2692b7853$export$64ef9b8c11710c47 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f410"
})({
    display: 'flex',
    flexDirection: 'column',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $lcnyw.gridSize)() * 13}px`
});
const $44bed1e2692b7853$export$8fe6f0aed18a58c7 = /*#__PURE__*/ (0, $joBf7.default)("h6", {
    target: "e1kkd6f49"
})((0, $4lTFP.h600), "text-transform:none;overflow:hidden;max-height:48px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;");
const $44bed1e2692b7853$export$1cbd03a20253b620 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f48"
})({
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-050, 4px)"
});
const $44bed1e2692b7853$export$82a6f3ee677bdbfe = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f47"
})({
    name: "li9rw7",
    styles: "margin-top:var(--ds-space-200, 16px);margin-left:var(--ds-space-negative-025, -2px)"
});
const $44bed1e2692b7853$export$2bf1f2b0d31b60fc = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f46"
})({
    name: "vi4bqq",
    styles: "margin-top:var(--ds-space-200, 16px);align-items:center;display:flex"
});
const $44bed1e2692b7853$export$393edc798c47379d = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1kkd6f45"
})({
    name: "yog5y2",
    styles: "overflow:hidden;max-height:60px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical"
});
const $44bed1e2692b7853$export$88c65d2d98aab183 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f44"
})({
    width: 'calc(100% + 8px)',
    display: 'flex',
    justifyContent: 'space-between',
    margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-negative-300, -24px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
    backgroundColor: "var(--ds-surface-overlay, hsla(0, 100%, 100%, 0.2))"
});
const $44bed1e2692b7853$export$44e087c32db6077d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f43"
})({
    name: "1svotkm",
    styles: "flex-basis:0;flex-grow:1;margin-left:var(--ds-space-100, 8px)"
});
const $44bed1e2692b7853$export$7f94856880993f27 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f42"
})({
    name: "9kivhj",
    styles: "margin-left:var(--ds-space-100, 8px)"
});
const $44bed1e2692b7853$export$43a792a870d28db2 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f41"
})({
    name: "o13o72",
    styles: "text-align:center;margin-top:var(--ds-space-500, 40px)"
});
const $44bed1e2692b7853$export$71bcd744fda975e5 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f40"
})({
    name: "ifz8jz",
    styles: "margin-bottom:var(--ds-space-300, 24px)"
}); // export const LoadingTeamName = styled.div`
 //   width: 175px;
 //   height: ${gridSize () *3)px;
 //   border-radius: ${borderRadius}px;
 //   background-color: #f4f5f7;
 // `;
 // export const LoadingMemberCount = styled.div`
 //   width: 81px;
 //   height: ${gridSize () *2)px;
 //   border-radius: 3px;
 //   background-color: #f4f5f7;
 //   margin: 4px 0;
 // `;

});

parcelRegister("22Tpa", function(module, exports) {

$parcel$export(module.exports, "default", () => $479bbf795543ee24$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $220ac = parcelRequire("220ac");

var $aCbpp = parcelRequire("aCbpp");

var $dRbkr = parcelRequire("dRbkr");

var $3vXh8 = parcelRequire("3vXh8");

var $1eRuZ = parcelRequire("1eRuZ");
var $479bbf795543ee24$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    const intl = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        analytics((duration)=>(0, $3vXh8.profileCardRendered)('team', 'error', {
                duration: duration
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.TeamForbiddenErrorStateWrapper), {
        "data-testid": "team-profilecard-forbidden-error-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: intl.formatMessage((0, $aCbpp.default).teamForbiddenErrorStateTitle),
        description: intl.formatMessage((0, $aCbpp.default).teamForbiddenErrorStateDescription),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.AccessLockSVGWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1eRuZ.default), null))
    }));
};

});
parcelRegister("1eRuZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f333fc6edfa90ad9$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eUqFw = parcelRequire("eUqFw");
const $f333fc6edfa90ad9$var$AccessLockSVG = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "191",
        height: "222",
        viewBox: "0 0 191 222",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M122.7 119.9H49.4V36.9998C49.8906 27.6107 53.9659 18.7679 60.7854 12.2956C67.6048 5.82318 76.6481 2.21484 86.05 2.21484C95.4519 2.21484 104.495 5.82318 111.315 12.2956C118.134 18.7679 122.209 27.6107 122.7 36.9998V119.9ZM61.4 107.9H110.7V36.9998C110.301 30.7336 107.53 24.8546 102.951 20.5583C98.3722 16.2619 92.3289 13.8706 86.05 13.8706C79.7711 13.8706 73.7279 16.2619 69.149 20.5583C64.5701 24.8546 61.7993 30.7336 61.4 36.9998V107.9Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H19.1C18.348 59.2976 17.605 59.4639 16.9262 59.7874C16.2474 60.111 15.6503 60.5834 15.1794 61.1697C14.7085 61.7559 14.3758 62.4408 14.2063 63.1734C14.0367 63.906 14.0346 64.6675 14.2 65.401C17.9782 81.0252 15.9154 97.4916 8.4 111.701C2.5112 123.071 -0.389112 135.752 -0.0282299 148.551C0.332652 161.351 3.94288 173.848 10.463 184.868C16.9831 195.888 26.1988 205.069 37.2436 211.548C48.2884 218.026 60.7993 221.589 73.6 221.901H91.5C101.565 222.141 111.577 220.365 120.946 216.679C130.315 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601Z",
        fill: "#FF991F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H36.9C36.154 59.3157 35.4203 59.494 34.7507 59.8232C34.0812 60.1523 33.492 60.6244 33.0247 61.2061C32.5574 61.7878 32.2235 62.4649 32.0464 63.1897C31.8694 63.9146 31.8535 64.6694 32 65.401C35.8087 81.0131 33.7816 97.4789 26.3 111.701C20.3828 123.006 17.4891 135.648 17.9 148.401C18.9 188.401 51.5 220.901 91.5 221.901C101.565 222.141 111.577 220.365 120.946 216.679C130.314 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501Z",
        fill: "#FFAB00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M93.4001 214H91.7001C80.2465 213.718 69.0525 210.53 59.1692 204.735C49.2859 198.939 41.0377 190.727 35.1991 180.87C29.3605 171.012 26.1231 159.832 25.7909 148.38C25.4587 136.928 28.0426 125.579 33.3001 115.4C41.036 100.558 43.5711 83.5517 40.5001 67.0996H146.2C143.017 83.4736 145.522 100.444 153.3 115.2C158.352 124.82 160.962 135.534 160.9 146.4C160.926 155.276 159.199 164.07 155.818 172.277C152.436 180.484 147.467 187.942 141.195 194.223C134.923 200.505 127.472 205.485 119.27 208.879C111.068 212.273 102.276 214.013 93.4001 214Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        style: {
            mixBlendMode: 'multiply'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M152.8 178.6L84.5 119.6L80.8 123.9L149.9 183.5L152.8 178.6Z",
        fill: "#FFE380"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M90.4 170.601C88.3452 170.598 86.3155 170.15 84.4509 169.287C82.5862 168.424 80.9312 167.166 79.5999 165.601C78.2601 164.053 77.2786 162.229 76.7254 160.259C76.1722 158.288 76.0611 156.219 76.4 154.201L78.3 141.601C75.4643 138.69 73.5294 135.023 72.7277 131.039C71.926 127.055 72.2917 122.925 73.7808 119.144C75.2699 115.363 77.8191 112.093 81.122 109.726C84.4249 107.359 88.3411 105.996 92.4 105.801H93.4C98.996 105.801 104.363 108.024 108.32 111.981C112.277 115.938 114.5 121.305 114.5 126.901C114.496 132.416 112.302 137.703 108.4 141.601L110.4 154.201C110.692 156.226 110.548 158.291 109.979 160.257C109.41 162.222 108.428 164.044 107.1 165.601C105.769 167.166 104.114 168.424 102.249 169.287C100.384 170.15 98.3547 170.598 96.3 170.601H90.4Z",
        fill: "#FFAB00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M106.6 126.9C106.586 128.711 106.196 130.499 105.456 132.151C104.716 133.803 103.641 135.284 102.3 136.5C101.574 137.222 101.032 138.107 100.719 139.081C100.405 140.056 100.33 141.091 100.5 142.1L102.6 155.4C102.728 156.305 102.662 157.226 102.405 158.103C102.147 158.979 101.706 159.79 101.109 160.482C100.512 161.173 99.7741 161.729 98.9446 162.112C98.1152 162.494 97.2134 162.695 96.3 162.7H90.4C89.4866 162.695 88.5848 162.494 87.7554 162.112C86.926 161.729 86.188 161.173 85.5912 160.482C84.9944 159.79 84.5526 158.979 84.2954 158.103C84.0382 157.226 83.9715 156.305 84.1 155.4L86.2 142C86.3747 140.983 86.2925 139.937 85.9607 138.959C85.6289 137.981 85.058 137.102 84.3 136.4C82.8962 135.116 81.7988 133.532 81.0892 131.767C80.3795 130.001 80.0756 128.099 80.2 126.2C80.2928 122.699 81.7726 119.379 84.3137 116.969C86.8548 114.559 90.2492 113.258 93.75 113.35C97.2509 113.443 100.571 114.923 102.981 117.464C105.391 120.005 106.693 123.399 106.6 126.9Z",
        fill: "#253858"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M149.2 130.901H93.4C92.8286 130.992 92.2443 130.959 91.6872 130.802C91.1302 130.645 90.6138 130.37 90.1736 129.994C89.7334 129.619 89.3799 129.152 89.1375 128.627C88.8951 128.102 88.7695 127.53 88.7695 126.951C88.7695 126.373 88.8951 125.801 89.1375 125.275C89.3799 124.75 89.7334 124.284 90.1736 123.908C90.6138 123.532 91.1302 123.257 91.6872 123.1C92.2443 122.944 92.8286 122.91 93.4 123.001H149.2C150.14 123.151 150.995 123.631 151.613 124.355C152.23 125.079 152.57 126 152.57 126.951C152.57 127.903 152.23 128.823 151.613 129.547C150.995 130.271 150.14 130.751 149.2 130.901Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M153.1 126.901C153.075 125.875 152.656 124.897 151.93 124.172C151.204 123.446 150.226 123.027 149.2 123.001H112.4C111.829 122.91 111.244 122.944 110.687 123.1C110.13 123.257 109.614 123.532 109.174 123.908C108.733 124.284 108.38 124.75 108.137 125.275C107.895 125.801 107.77 126.373 107.77 126.951C107.77 127.53 107.895 128.102 108.137 128.627C108.38 129.152 108.733 129.619 109.174 129.994C109.614 130.37 110.13 130.645 110.687 130.802C111.244 130.959 111.829 130.992 112.4 130.901H149.2C150.243 130.875 151.235 130.442 151.964 129.695C152.693 128.947 153.1 127.945 153.1 126.901Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M167.7 149.4C163.25 149.4 158.9 148.081 155.2 145.608C151.5 143.136 148.616 139.622 146.913 135.511C145.21 131.399 144.764 126.875 145.632 122.511C146.5 118.146 148.643 114.137 151.79 110.99C154.937 107.844 158.946 105.701 163.31 104.833C167.675 103.965 172.199 104.41 176.31 106.113C180.422 107.816 183.936 110.7 186.408 114.4C188.88 118.1 190.2 122.45 190.2 126.9C190.2 132.868 187.829 138.591 183.61 142.81C179.39 147.03 173.667 149.4 167.7 149.4ZM167.7 112.3C164.812 112.3 161.99 113.157 159.589 114.761C157.188 116.365 155.316 118.645 154.211 121.313C153.106 123.981 152.817 126.917 153.381 129.749C153.944 132.581 155.334 135.182 157.376 137.224C159.418 139.266 162.02 140.657 164.852 141.22C167.684 141.783 170.619 141.494 173.287 140.389C175.955 139.284 178.235 137.413 179.839 135.012C181.444 132.611 182.3 129.788 182.3 126.9C182.274 123.036 180.727 119.338 177.995 116.606C175.262 113.873 171.564 112.327 167.7 112.3Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M67.8 165.301H55.6C55.3423 165.278 55.1009 165.166 54.918 164.983C54.7351 164.8 54.6225 164.558 54.6 164.301C54.6 164.036 54.7053 163.781 54.8929 163.594C55.0804 163.406 55.3348 163.301 55.6 163.301H67.8C68.0652 163.301 68.3196 163.406 68.5071 163.594C68.6946 163.781 68.8 164.036 68.8 164.301C68.7775 164.558 68.6649 164.8 68.482 164.983C68.2991 165.166 68.0576 165.278 67.8 165.301Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M62.7999 182.5C62.6675 182.512 62.5342 182.491 62.412 182.438C62.2897 182.386 62.1825 182.304 62.0999 182.2C61.9167 182.013 61.8141 181.761 61.8141 181.5C61.8141 181.238 61.9167 180.987 62.0999 180.8L70.4999 172.3C70.6925 172.155 70.9307 172.085 71.1708 172.102C71.4109 172.119 71.6368 172.222 71.807 172.393C71.9773 172.563 72.0804 172.789 72.0974 173.029C72.1145 173.269 72.0444 173.507 71.8999 173.7L63.4999 182.2C63.3098 182.38 63.0616 182.486 62.7999 182.5Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M79.9 189.6C79.6424 189.577 79.4009 189.464 79.218 189.282C79.0351 189.099 78.9226 188.857 78.9 188.6V175.6C78.9226 175.342 79.0351 175.1 79.218 174.918C79.4009 174.735 79.6424 174.622 79.9 174.6C80.1652 174.6 80.4196 174.705 80.6071 174.893C80.7947 175.08 80.9 175.334 80.9 175.6V188.6C80.9 188.865 80.7947 189.119 80.6071 189.307C80.4196 189.494 80.1652 189.6 79.9 189.6Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M128.8 111.301H116.7C116.565 111.317 116.428 111.302 116.299 111.257C116.17 111.213 116.054 111.14 115.957 111.043C115.861 110.947 115.788 110.83 115.743 110.702C115.699 110.573 115.684 110.436 115.7 110.301C115.7 110.036 115.805 109.781 115.993 109.594C116.18 109.406 116.435 109.301 116.7 109.301H128.8C129.065 109.301 129.32 109.406 129.507 109.594C129.695 109.781 129.8 110.036 129.8 110.301C129.816 110.436 129.801 110.573 129.757 110.702C129.712 110.83 129.639 110.947 129.543 111.043C129.446 111.14 129.33 111.213 129.201 111.257C129.072 111.302 128.935 111.317 128.8 111.301Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M113.2 102.601C112.938 102.587 112.69 102.481 112.5 102.301C112.317 102.114 112.214 101.863 112.214 101.601C112.214 101.339 112.317 101.088 112.5 100.901L121 92.5008C121.193 92.3563 121.431 92.2862 121.671 92.3033C121.911 92.3204 122.137 92.4235 122.307 92.5937C122.477 92.7639 122.58 92.9898 122.597 93.2299C122.615 93.47 122.544 93.7082 122.4 93.9008L113.9 102.301C113.812 102.399 113.704 102.477 113.583 102.528C113.462 102.58 113.331 102.605 113.2 102.601Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M104.5 100C104.235 100 103.98 99.8947 103.793 99.7072C103.605 99.5196 103.5 99.2653 103.5 99.0001V86.1C103.5 85.8348 103.605 85.5805 103.793 85.3929C103.98 85.2054 104.235 85.1 104.5 85.1C104.635 85.084 104.772 85.0988 104.901 85.1433C105.03 85.1879 105.146 85.2611 105.243 85.3574C105.339 85.4536 105.412 85.5705 105.457 85.6991C105.501 85.8278 105.516 85.9649 105.5 86.1V99.0001C105.516 99.1352 105.501 99.2723 105.457 99.401C105.412 99.5296 105.339 99.6465 105.243 99.7428C105.146 99.839 105.03 99.9122 104.901 99.9568C104.772 100.001 104.635 100.016 104.5 100Z",
        fill: "#FFFAE5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
        fill: "white"
    }))));
};
var $f333fc6edfa90ad9$export$2e2bcd8739ae039 = $f333fc6edfa90ad9$var$AccessLockSVG;

});


parcelRegister("dO06T", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aac33fd408e01e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $dRbkr = parcelRequire("dRbkr");

var $3vXh8 = parcelRequire("3vXh8");
var $5aac33fd408e01e7$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    (0, $eUqFw.useEffect)(()=>{
        analytics((duration)=>(0, $3vXh8.profileCardRendered)('team', 'spinner', {
                duration: duration
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardWrapper), {
        "data-testid": "team-profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardHeader), {
        isLoading: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.LoadingWrapper), {
        "data-testid": "team-profilecard-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null))));
};

});




parcelRegister("ehM5E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ProfilecardInternal", () => $aaa133bbdb29f425$export$64e0275ede8ab792);
$parcel$export(module.exports, "default", () => $aaa133bbdb29f425$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $2jDha = parcelRequire("2jDha");

var $iJlfe = parcelRequire("iJlfe");

var $7u4fN = parcelRequire("7u4fN");

var $51sCz = parcelRequire("51sCz");

var $4Bees = parcelRequire("4Bees");


var $aCbpp = parcelRequire("aCbpp");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");

var $7NIUg = parcelRequire("7NIUg");

var $cEOpo = parcelRequire("cEOpo");
parcelRequire("iINHb");
var $4ga2m = parcelRequire("4ga2m");

var $g8EW1 = parcelRequire("g8EW1");

var $gXyvb = parcelRequire("gXyvb");
const $aaa133bbdb29f425$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
const $aaa133bbdb29f425$var$useKudos = (cloudId, userId, teamCentralBaseUrl, openKudosDrawer)=>{
    const kudosUrl = (0, $eUqFw.useMemo)(()=>{
        const recipientId = userId ? `&recipientId=${userId}` : '';
        const cloudIdParam = cloudId ? `&cloudId=${cloudId}` : '';
        return `${teamCentralBaseUrl || ''}/kudos/give?type=individual${recipientId}${cloudIdParam}`;
    }, [
        cloudId,
        teamCentralBaseUrl,
        userId
    ]);
    const kudosButtonCallback = (0, $eUqFw.useCallback)(()=>{
        if (openKudosDrawer) openKudosDrawer();
        else window.open(kudosUrl);
    }, [
        kudosUrl,
        openKudosDrawer
    ]);
    const kudosAction = (0, $eUqFw.useMemo)(()=>{
        return {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).giveKudosButton),
            id: $aaa133bbdb29f425$var$GIVE_KUDOS_ACTION_ID,
            callback: kudosButtonCallback,
            link: kudosUrl
        };
    }, [
        kudosButtonCallback,
        kudosUrl
    ]);
    return {
        kudosAction: kudosAction,
        kudosButtonCallback: kudosButtonCallback,
        kudosUrl: kudosUrl
    };
};
const $aaa133bbdb29f425$var$Wrapper = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), {
        "data-testid": "profilecard",
        role: "dialog",
        "aria-labelledby": "profilecard-name-label"
    }, props.children);
const $aaa133bbdb29f425$export$64e0275ede8ab792 = (props)=>{
    const [openTime] = (0, $eUqFw.useState)((0, $cEOpo.getPageTime)());
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsWithDuration = (0, $eUqFw.useCallback)((generator)=>{
        const elapsed = (0, $cEOpo.getPageTime)() - openTime;
        const event = generator(elapsed);
        fireAnalytics(event);
    }, [
        fireAnalytics,
        openTime
    ]);
    const { kudosAction: kudosAction } = $aaa133bbdb29f425$var$useKudos(props.cloudId, props.userId, props.teamCentralBaseUrl, props.openKudosDrawer);
    const { actions: actions = [], isCurrentUser: isCurrentUser, isKudosEnabled: isKudosEnabled, status: status = 'active' } = props;
    const realActions = (0, $eUqFw.useMemo)(()=>{
        if (isCurrentUser || !isKudosEnabled || status !== 'active') return actions;
        return actions.concat([
            kudosAction
        ]);
    }, [
        actions,
        isCurrentUser,
        isKudosEnabled,
        kudosAction,
        status
    ]);
    const { isLoading: isLoading, fullName: fullName, hasError: hasError } = props;
    const canRender = !hasError && !isLoading && !!(fullName || status === 'closed');
    (0, $eUqFw.useEffect)(()=>{
        if (canRender) fireAnalyticsWithDuration((duration)=>(0, $3vXh8.profileCardRendered)('user', 'content', {
                duration: duration,
                numActions: realActions.length
            }));
    }, [
        canRender,
        fireAnalyticsWithDuration,
        realActions
    ]);
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ga2m.default), {
        reload: props.clientFetchProfile,
        errorType: props.errorType || null,
        fireAnalytics: fireAnalytics
    }));
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$LoadingView, {
        fireAnalyticsWithDuration: fireAnalyticsWithDuration
    }));
    if (!canRender) return null;
    const isDisabledUser = status === 'inactive' || status === 'closed';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardContainer), {
        isDisabledUser: isDisabledUser,
        withoutElevation: props.withoutElevation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.ProfileImage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "xlarge",
        src: status !== 'closed' ? props.avatarUrl : undefined,
        borderColor: `var(--ds-shadow-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gXyvb.ProfileCardDetails), {
        ...props,
        status: status,
        fireAnalyticsWithDuration: fireAnalyticsWithDuration
    }), realActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.ActionsFlexSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$Actions, {
        actions: realActions,
        fireAnalyticsWithDuration: fireAnalyticsWithDuration,
        isTriggeredUsingKeyboard: props.isTriggeredUsingKeyboard
    })))));
};
const $aaa133bbdb29f425$var$Actions = ({ actions: actions, fireAnalyticsWithDuration: fireAnalyticsWithDuration, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard })=>{
    const onActionClick = (0, $eUqFw.useCallback)((action, args, event, index)=>{
        fireAnalyticsWithDuration((duration)=>(0, $3vXh8.actionClicked)('user', {
                duration: duration,
                hasHref: !!action.link,
                hasOnClick: !!action.callback,
                index: index,
                actionId: action.id || 'no-id-specified'
            }));
        if (action.callback && (0, $7NIUg.isBasicClick)(event)) {
            event.preventDefault();
            action.callback(event, ...args);
        }
    }, [
        fireAnalyticsWithDuration
    ]);
    if (!actions || actions.length === 0) return null;
    const regularActions = actions.slice(0, (0, $g8EW1.ACTION_OVERFLOW_THRESHOLD));
    const overflowActions = actions.length > (0, $g8EW1.ACTION_OVERFLOW_THRESHOLD) ? actions.slice((0, $g8EW1.ACTION_OVERFLOW_THRESHOLD)) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.ActionButtonGroup), {
        "data-testid": "profilecard-actions"
    }, regularActions.map((action, index)=>{
        const isKudos = action.id === $aaa133bbdb29f425$var$GIVE_KUDOS_ACTION_ID;
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
            isInset: true,
            key: `profile-card-action-focus-ring_${action.id || index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "default",
            key: action.id || index,
            onClick: (event, ...args)=>onActionClick(action, args, event, index),
            href: action.link,
            autoFocus: index === 0 && isTriggeredUsingKeyboard
        }, action.label, isKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.KudosBlobAnimation), null))));
        if (isKudos) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AnimatedKudosButton), {
            key: `profile-card-action-kudos_${action.id || index}`
        }, button);
        return button;
    }), overflowActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g8EW1.OverflowProfileCardButtons), {
        actions: overflowActions,
        fireAnalyticsWithDuration: fireAnalyticsWithDuration,
        onItemClick: (action, args, event, index)=>onActionClick(action, args, event, index + (0, $g8EW1.ACTION_OVERFLOW_THRESHOLD))
    }));
};
const $aaa133bbdb29f425$var$LoadingView = ({ fireAnalyticsWithDuration: fireAnalyticsWithDuration })=>{
    (0, $eUqFw.useEffect)(()=>{
        fireAnalyticsWithDuration((duration)=>(0, $3vXh8.profileCardRendered)('user', 'spinner', {
                duration: duration
            }));
    }, [
        fireAnalyticsWithDuration
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.SpinnerContainer), {
        "data-testid": "profilecard-spinner-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
};
var $aaa133bbdb29f425$export$2e2bcd8739ae039 = (0, $2jDha.default)()($aaa133bbdb29f425$export$64e0275ede8ab792);

});
parcelRegister("g8EW1", function(module, exports) {

$parcel$export(module.exports, "ACTION_OVERFLOW_THRESHOLD", () => $4d541855ce71e000$export$3e2419a7546ad45e);
$parcel$export(module.exports, "OverflowProfileCardButtons", () => $4d541855ce71e000$export$9d9b53d23c0df7a1);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bbaTG = parcelRequire("bbaTG");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $34Io4 = parcelRequire("34Io4");

var $aCbpp = parcelRequire("aCbpp");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");
const $4d541855ce71e000$export$3e2419a7546ad45e = 2;
const $4d541855ce71e000$export$9d9b53d23c0df7a1 = (props)=>{
    const intl = (0, $5JgJ2.default)();
    const [, setOpen] = (0, $eUqFw.useState)(false);
    const { actions: actions, onItemClick: onItemClick, fireAnalyticsWithDuration: fireAnalyticsWithDuration } = props;
    const numActions = actions.length + $4d541855ce71e000$export$3e2419a7546ad45e;
    const onOpenChange = (0, $eUqFw.useCallback)(({ isOpen: nextOpen })=>{
        setOpen((prevOpen)=>{
            if (nextOpen && !prevOpen) fireAnalyticsWithDuration((duration)=>(0, $3vXh8.moreActionsClicked)('user', {
                    duration: duration,
                    numActions: numActions
                }));
            return nextOpen;
        });
    }, [
        numActions,
        fireAnalyticsWithDuration
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.OverflowActionButtonsWrapper), {
        "data-testid": "profilecard-actions-overflow"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        onOpenChange: onOpenChange,
        placement: 'bottom-end',
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: testId, ...providedProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
                type: "button",
                ...providedProps,
                ref: triggerRef,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Io4))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: intl.formatMessage((0, $aCbpp.default).profileCardMoreIconLabel)
                })
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: action.id,
            onClick: (event, ...args)=>{
                onItemClick(action, args, event, index);
            },
            href: action.link
        }, action.label)))));
};

});

parcelRegister("gXyvb", function(module, exports) {

$parcel$export(module.exports, "ProfileCardDetails", () => $6edf297decc2faf3$export$c0e6870b898eb99d);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hkN79 = parcelRequire("hkN79");

var $aCbpp = parcelRequire("aCbpp");

var $kqibQ = parcelRequire("kqibQ");
parcelRequire("f8FAx");
var $2XE3d = parcelRequire("2XE3d");

var $4VIvN = parcelRequire("4VIvN");
const $6edf297decc2faf3$var$detailedListWrapperStyles = (0, $1ZAYh.xcss)({
    margin: 'space.0',
    padding: 'space.0'
});
const $6edf297decc2faf3$var$renderName = (nickname, fullName, meta)=>{
    if (!fullName && !nickname) return null;
    const isNicknameRedundant = !nickname || nickname === fullName;
    const shownNickname = ` (${nickname}) `;
    const displayName = isNicknameRedundant ? fullName : `${fullName}${shownNickname}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.FullNameLabel), {
        noMeta: !meta,
        "data-testid": "profilecard-name",
        id: "profilecard-name-label"
    }, displayName);
};
const $6edf297decc2faf3$var$disabledAccountDesc = (statusModifiedDate, disabledAccountMessage, status = 'closed')=>{
    // consumer does not want to use built-in message
    if (disabledAccountMessage) return disabledAccountMessage;
    const date = statusModifiedDate ? new Date(statusModifiedDate * 1000) : null;
    const relativeDateKey = (0, $hkN79.default)(date);
    const msgKey = relativeDateKey ? `${status}AccountDescMsgHasDate${relativeDateKey}` : `${status}AccountDescMsgNoDate`;
    const secondSentence = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default)[msgKey]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        "data-testid": "profilecard-disabled-account"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).generalDescMsgForDisabledUser), " ", secondSentence);
};
const $6edf297decc2faf3$var$CustomLozenges = ({ lozenges: lozenges = [] })=>{
    if (lozenges.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CustomLozengeContainer), null, lozenges.map(({ text: text, ...otherProps }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            ...otherProps,
            key: index
        }, text)));
};
const $6edf297decc2faf3$var$BotProfileCardDetails = (props)=>{
    const { fullName: fullName, nickname: nickname } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsGroup), null, $6edf297decc2faf3$var$renderName(nickname, fullName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AppTitleLabel), null, "App"));
};
const $6edf297decc2faf3$var$DisabledProfileCardDetails = (props)=>{
    const { companyName: companyName, disabledAccountMessage: disabledAccountMessage, fullName: fullName, hasDisabledAccountLozenge: hasDisabledAccountLozenge = true, nickname: nickname, status: status, statusModifiedDate: statusModifiedDate } = props;
    const name = status === 'inactive' ? fullName || nickname : nickname || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).disabledAccountDefaultName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.FullNameLabel), {
        noMeta: true,
        isDisabledAccount: true,
        "data-testid": "profilecard-name",
        id: "profilecard-name-label"
    }, name), hasDisabledAccountLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.LozengeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "default",
        isBold: true
    }, status === 'inactive' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).inactiveAccountMsg) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).closedAccountMsg))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DisabledInfo), null, $6edf297decc2faf3$var$disabledAccountDesc(statusModifiedDate, disabledAccountMessage, status)), status === 'inactive' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "companyName"
    }, companyName));
};
const $6edf297decc2faf3$export$c0e6870b898eb99d = (props)=>{
    const { meta: meta, status: status } = props;
    if (props.isBot) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6edf297decc2faf3$var$BotProfileCardDetails, props);
    if (status === 'inactive' || status === 'closed') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6edf297decc2faf3$var$DisabledProfileCardDetails, {
        ...props,
        status: status
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsGroup), null, $6edf297decc2faf3$var$renderName(props.nickname, props.fullName, meta), meta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.JobTitleLabel), null, meta), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6edf297decc2faf3$var$CustomLozenges, {
        lozenges: props.customLozenges
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "dl",
        xcss: $6edf297decc2faf3$var$detailedListWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "email"
    }, props.email), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "time"
    }, props.timestring), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "companyName"
    }, props.companyName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "location"
    }, props.location)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4VIvN.default), {
        reportingLines: props.reportingLines,
        reportingLinesProfileUrl: props.reportingLinesProfileUrl,
        onReportingLinesClick: props.onReportingLinesClick,
        fireAnalyticsWithDuration: props.fireAnalyticsWithDuration
    }));
};

});
parcelRegister("hkN79", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be3e2500aef7a3b$export$2e2bcd8739ae039);

var $1raUW = parcelRequire("1raUW");

var $7CyDX = parcelRequire("7CyDX");

var $hX17M = parcelRequire("hX17M");

var $7ueqz = parcelRequire("7ueqz");
function $7be3e2500aef7a3b$export$c03bb0116ee09d4b(date, today = new Date()) {
    return !!date.getTime && (0, $7ueqz.default)(date) && date.getTime() <= today.getTime();
}
function $7be3e2500aef7a3b$export$2e2bcd8739ae039(date, today = new Date()) {
    if (!date || !$7be3e2500aef7a3b$export$c03bb0116ee09d4b(date, today)) return null;
    if ((0, $hX17M.default)(date)) return 'ThisWeek';
    if ((0, $7CyDX.default)(date)) return 'ThisMonth';
    if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() - 1) return 'LastMonth';
    const diffInMonths = (0, $1raUW.default)(today, date);
    if (diffInMonths < 6) return 'AFewMonths';
    if (diffInMonths <= 12) return 'SeveralMonths';
    return 'MoreThanAYear';
}

});

parcelRegister("f8FAx", function(module, exports) {

$parcel$export(module.exports, "IconLabel", () => (parcelRequire("2XE3d")).default);

var $2XE3d = parcelRequire("2XE3d");

});
parcelRegister("2XE3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b4197d6aec28d50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2o6Nb = parcelRequire("2o6Nb");

var $9UAhx = parcelRequire("9UAhx");

var $1sqLF = parcelRequire("1sqLF");

var $4wgnn = parcelRequire("4wgnn");

var $kqibQ = parcelRequire("kqibQ");
const $3b4197d6aec28d50$var$icons = {
    location: (0, (/*@__PURE__*/$parcel$interopDefault($1sqLF))),
    time: (0, (/*@__PURE__*/$parcel$interopDefault($2o6Nb))),
    email: (0, (/*@__PURE__*/$parcel$interopDefault($9UAhx))),
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($4wgnn)))
};
class $3b4197d6aec28d50$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.defaultProps = {
            icon: ''
        };
    }
    render() {
        if (!this.props.children) return null;
        // @ts-ignore
        const IconElement = this.props.icon && $3b4197d6aec28d50$var$icons[this.props.icon];
        const displayIcon = IconElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IconElement, {
            label: `${this.props.icon}`,
            LEGACY_size: "small",
            color: "currentColor"
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsLabel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsLabelIcon), null, displayIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsLabelText), null, this.props.children));
    }
}

});
parcelRegister("2o6Nb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6806c227602236faeeb3f1399e5f3974>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1bd3177144d2e857$var$_react = $1bd3177144d2e857$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1bd3177144d2e857$var$_clock = $1bd3177144d2e857$var$_interopRequireDefault((parcelRequire("eSHsi")));

var $1bd3177144d2e857$var$_recent = $1bd3177144d2e857$var$_interopRequireDefault((parcelRequire("k6W9R")));
function $1bd3177144d2e857$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ClockIcon.
 * This component is ClockIcon, with `UNSAFE_fallbackIcon` set to "RecentIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: recent, time input, sprint time remaining.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1bd3177144d2e857$var$ClockIcon = (props)=>/*#__PURE__*/ $1bd3177144d2e857$var$_react.default.createElement($1bd3177144d2e857$var$_clock.default, Object.assign({
        LEGACY_fallbackIcon: $1bd3177144d2e857$var$_recent.default
    }, props));
$1bd3177144d2e857$var$ClockIcon.Name = 'ClockIconMigration';
var $1bd3177144d2e857$var$_default = module.exports.default = $1bd3177144d2e857$var$ClockIcon;

});

parcelRegister("9UAhx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7a2b6cdc35065dd9118d8dca0206090>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73757cd51f353c0b$var$_react = $73757cd51f353c0b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $73757cd51f353c0b$var$_email = $73757cd51f353c0b$var$_interopRequireDefault((parcelRequire("8qa3H")));

var $73757cd51f353c0b$var$_email2 = $73757cd51f353c0b$var$_interopRequireDefault((parcelRequire("8IVhP")));
function $73757cd51f353c0b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $73757cd51f353c0b$var$EmailIcon = (props)=>/*#__PURE__*/ $73757cd51f353c0b$var$_react.default.createElement($73757cd51f353c0b$var$_email.default, Object.assign({
        LEGACY_fallbackIcon: $73757cd51f353c0b$var$_email2.default
    }, props));
$73757cd51f353c0b$var$EmailIcon.Name = 'EmailIconMigration';
var $73757cd51f353c0b$var$_default = module.exports.default = $73757cd51f353c0b$var$EmailIcon;

});
parcelRegister("8qa3H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5cb86c704b4aada9757c695d217a2634>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62188de139005924$var$_react = $62188de139005924$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $62188de139005924$var$_UNSAFE_baseNew = $62188de139005924$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $62188de139005924$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62188de139005924$var$EmailIcon = (props)=>/*#__PURE__*/ $62188de139005924$var$_react.default.createElement($62188de139005924$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 4.97V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v.97m14.5 0V12c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V4.97m14.5 0L8 8.986.75 4.971"/>`
    }, props));
$62188de139005924$var$EmailIcon.displayName = 'EmailIcon';
var $62188de139005924$var$_default = module.exports.default = $62188de139005924$var$EmailIcon;

});

parcelRegister("8IVhP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $659edeb603307d4b$var$_react = $659edeb603307d4b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $659edeb603307d4b$var$_email = $659edeb603307d4b$var$_interopRequireDefault((parcelRequire("8qa3H")));
function $659edeb603307d4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $659edeb603307d4b$var$EmailIcon = (props)=>/*#__PURE__*/ $659edeb603307d4b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $659edeb603307d4b$var$_email.default
    }));
$659edeb603307d4b$var$EmailIcon.displayName = 'EmailIcon';
var $659edeb603307d4b$var$_default = module.exports.default = $659edeb603307d4b$var$EmailIcon;

});


parcelRegister("1sqLF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::545a43140aa544d5a11b5ce8a7ee4181>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10fd2b7df2e2da22$var$_react = $10fd2b7df2e2da22$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $10fd2b7df2e2da22$var$_location = $10fd2b7df2e2da22$var$_interopRequireDefault((parcelRequire("gIKck")));

var $10fd2b7df2e2da22$var$_location2 = $10fd2b7df2e2da22$var$_interopRequireDefault((parcelRequire("izGRi")));
function $10fd2b7df2e2da22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LocationIcon.
 * This component is LocationIcon, with `UNSAFE_fallbackIcon` set to "LocationIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10fd2b7df2e2da22$var$LocationIcon = (props)=>/*#__PURE__*/ $10fd2b7df2e2da22$var$_react.default.createElement($10fd2b7df2e2da22$var$_location.default, Object.assign({
        LEGACY_fallbackIcon: $10fd2b7df2e2da22$var$_location2.default
    }, props));
$10fd2b7df2e2da22$var$LocationIcon.Name = 'LocationIconMigration';
var $10fd2b7df2e2da22$var$_default = module.exports.default = $10fd2b7df2e2da22$var$LocationIcon;

});
parcelRegister("gIKck", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63fb0b6df7e49e2098c2ec6d28a5ea51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2c4975ab9840edb$var$_react = $c2c4975ab9840edb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c2c4975ab9840edb$var$_UNSAFE_baseNew = $c2c4975ab9840edb$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c2c4975ab9840edb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c2c4975ab9840edb$var$LocationIcon = (props)=>/*#__PURE__*/ $c2c4975ab9840edb$var$_react.default.createElement($c2c4975ab9840edb$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.677 8.982 8 15.25l4.323-6.268C14.725 5.5 12.232.75 8 .75c-4.231 0-6.725 4.749-4.323 8.232Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.75 6a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$c2c4975ab9840edb$var$LocationIcon.displayName = 'LocationIcon';
var $c2c4975ab9840edb$var$_default = module.exports.default = $c2c4975ab9840edb$var$LocationIcon;

});

parcelRegister("izGRi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d85cbdb8c81e089a$var$_react = $d85cbdb8c81e089a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d85cbdb8c81e089a$var$_location = $d85cbdb8c81e089a$var$_interopRequireDefault((parcelRequire("gIKck")));
function $d85cbdb8c81e089a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d85cbdb8c81e089a$var$LocationIcon = (props)=>/*#__PURE__*/ $d85cbdb8c81e089a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1 1 12 0c0 3.314-3.72 12-6 12m0-9a2.912 2.912 0 1 0 0-5.824A2.912 2.912 0 0 0 12 12"/></svg>`
    }, props, {
        newIcon: $d85cbdb8c81e089a$var$_location.default
    }));
$d85cbdb8c81e089a$var$LocationIcon.displayName = 'LocationIcon';
var $d85cbdb8c81e089a$var$_default = module.exports.default = $d85cbdb8c81e089a$var$LocationIcon;

});


parcelRegister("4wgnn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c0e8d80bcfd2271e8d913a54d2e0fe5a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34a6da89084607d2$var$_react = $34a6da89084607d2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $34a6da89084607d2$var$_officeBuilding = $34a6da89084607d2$var$_interopRequireDefault((parcelRequire("jaf6K")));

var $34a6da89084607d2$var$_officeBuilding2 = $34a6da89084607d2$var$_interopRequireDefault((parcelRequire("bK40S")));
function $34a6da89084607d2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for OfficeBuildingIcon.
 * This component is OfficeBuildingIcon, with `UNSAFE_fallbackIcon` set to "OfficeBuildingIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34a6da89084607d2$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $34a6da89084607d2$var$_react.default.createElement($34a6da89084607d2$var$_officeBuilding.default, Object.assign({
        LEGACY_fallbackIcon: $34a6da89084607d2$var$_officeBuilding2.default
    }, props));
$34a6da89084607d2$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
var $34a6da89084607d2$var$_default = module.exports.default = $34a6da89084607d2$var$OfficeBuildingIcon;

});
parcelRegister("jaf6K", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::59ed0d1eaf3692b12c2c689c7a7ea5c7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df3aab978cc1c9fb$var$_react = $df3aab978cc1c9fb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $df3aab978cc1c9fb$var$_UNSAFE_baseNew = $df3aab978cc1c9fb$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $df3aab978cc1c9fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df3aab978cc1c9fb$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $df3aab978cc1c9fb$var$_react.default.createElement($df3aab978cc1c9fb$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15.25V2c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v13.25m10.5 0h-3.5m3.5 0H15m-12.25 0h3.5m-3.5 0H1m4-11.5h2m2 0h2m0 3H9m-2 0H5m1.25 8.5v-4.5h3.5v4.5m-3.5 0h3.5"/>`
    }, props));
$df3aab978cc1c9fb$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $df3aab978cc1c9fb$var$_default = module.exports.default = $df3aab978cc1c9fb$var$OfficeBuildingIcon;

});

parcelRegister("bK40S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88c71a7d3deb32d8$var$_react = $88c71a7d3deb32d8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $88c71a7d3deb32d8$var$_officeBuilding = $88c71a7d3deb32d8$var$_interopRequireDefault((parcelRequire("jaf6K")));
function $88c71a7d3deb32d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $88c71a7d3deb32d8$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $88c71a7d3deb32d8$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144z"/><path d="M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/><path fill-rule="nonzero" d="M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/></g></svg>`
    }, props, {
        newIcon: $88c71a7d3deb32d8$var$_officeBuilding.default
    }));
$88c71a7d3deb32d8$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $88c71a7d3deb32d8$var$_default = module.exports.default = $88c71a7d3deb32d8$var$OfficeBuildingIcon;

});




parcelRegister("4VIvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea078b29528825bd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $iJlfe = parcelRequire("iJlfe");

var $4XQdE = parcelRequire("4XQdE");

var $7u4fN = parcelRequire("7u4fN");

var $aCbpp = parcelRequire("aCbpp");

var $82aoD = parcelRequire("82aoD");

var $3vXh8 = parcelRequire("3vXh8");
function $ea078b29528825bd$var$getProfileHref(userId, profileUrl) {
    return profileUrl ? profileUrl + userId : undefined;
}
const $ea078b29528825bd$var$ReportingLinesDetails = (props)=>{
    const { fireAnalyticsWithDuration: fireAnalyticsWithDuration, reportingLines: reportingLines = {}, reportingLinesProfileUrl: reportingLinesProfileUrl, onReportingLinesClick: onReportingLinesClick } = props;
    const { managers: managers = [], reports: reports = [] } = reportingLines;
    const manager = managers.length >= 1 ? managers[0] : undefined;
    const hasReports = reports.length > 0;
    const getReportingLinesOnClick = (user, userType)=>onReportingLinesClick ? ()=>{
            fireAnalyticsWithDuration((duration)=>(0, $3vXh8.reportingLinesClicked)({
                    duration: duration,
                    userType: userType
                }));
            onReportingLinesClick(user);
        } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, manager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ReportingLinesSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ReportingLinesHeading), {
        style: {
            marginBottom: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).managerSectionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.OffsetWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        href: $ea078b29528825bd$var$getProfileHref(manager.accountIdentifier, reportingLinesProfileUrl),
        onClick: getReportingLinesOnClick(manager, 'manager'),
        isDisabled: !onReportingLinesClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ManagerSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "xsmall",
        src: manager.pii?.picture
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ManagerName), null, manager.pii?.name))))), hasReports && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ReportingLinesSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ReportingLinesHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).directReportsSectionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        appearance: "stack",
        size: "small",
        data: reports.map((member)=>{
            return {
                key: member.accountIdentifier,
                name: member.pii?.name || '',
                src: member.pii?.picture,
                href: $ea078b29528825bd$var$getProfileHref(member.accountIdentifier, reportingLinesProfileUrl),
                onClick: getReportingLinesOnClick(member, 'direct-report')
            };
        }),
        maxCount: 5,
        testId: "profilecard-reports-avatar-group"
    })));
};
var $ea078b29528825bd$export$2e2bcd8739ae039 = $ea078b29528825bd$var$ReportingLinesDetails;

});
parcelRegister("82aoD", function(module, exports) {

$parcel$export(module.exports, "ReportingLinesSection", () => $04441ecf0f4a2833$export$ae48ddd79a45b949);
$parcel$export(module.exports, "ReportingLinesHeading", () => $04441ecf0f4a2833$export$abdd342d30bb5b5f);
$parcel$export(module.exports, "ManagerSection", () => $04441ecf0f4a2833$export$2992b481dad9fb03);
$parcel$export(module.exports, "ManagerName", () => $04441ecf0f4a2833$export$98f8ec89e658b052);
$parcel$export(module.exports, "OffsetWrapper", () => $04441ecf0f4a2833$export$56eae56612ce5f3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lcnyw = parcelRequire("lcnyw");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
function $04441ecf0f4a2833$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $04441ecf0f4a2833$export$ae48ddd79a45b949 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e11fux8a4"
})({
    name: "1m5erzj",
    styles: "margin-left:var(--ds-space-050, 4px);margin-top:var(--ds-space-100, 8px)"
});
const $04441ecf0f4a2833$export$abdd342d30bb5b5f = /*#__PURE__*/ (0, $joBf7.default)("h3", {
    target: "e11fux8a3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.appLabelTextColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $lcnyw.gridSize)() * 1.5}px`,
    fontWeight: 600,
    marginBottom: "var(--ds-space-100, 8px)"
});
const $04441ecf0f4a2833$export$2992b481dad9fb03 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e11fux8a2"
})({
    display: 'flex',
    alignItems: 'center',
    margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
});
const $04441ecf0f4a2833$export$98f8ec89e658b052 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e11fux8a1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $lcnyw.gridSize)() * 1.5}px`,
    marginLeft: "var(--ds-space-100, 8px)"
});
const $04441ecf0f4a2833$export$56eae56612ce5f3 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e11fux8a0"
})({
    name: "ysolxb",
    styles: "margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-negative-050, -4px)"
});

});




parcelRegister("6aOtB", function(module, exports) {

$parcel$export(module.exports, "default", () => $184c4f94fc0b4764$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $dx7Op = parcelRequire("dx7Op");
var $btCBO = parcelRequire("btCBO");

var $5Jx7I = parcelRequire("5Jx7I");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");
parcelRequire("iINHb");
var $4ga2m = parcelRequire("4ga2m");

var $ehM5E = parcelRequire("ehM5E");

var $ijWKk = parcelRequire("ijWKk");
class $184c4f94fc0b4764$var$ProfileCardResourced extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.defaultProps = {
            actions: []
        };
    }
    componentDidMount() {
        this._isMounted = true;
        this.clientFetchProfile();
    }
    componentDidUpdate(prevProps) {
        const { userId: userId, cloudId: cloudId, resourceClient: resourceClient } = this.props;
        if (userId !== prevProps.userId || cloudId !== prevProps.cloudId || resourceClient !== prevProps.resourceClient) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    handleClientSuccess(profileData, reportingLinesData, shouldShowGiveKudos) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: profileData,
            reportingLinesData: reportingLinesData,
            isKudosEnabled: shouldShowGiveKudos
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    render() {
        const { isLoading: isLoading, hasError: hasError, error: error, data: data, reportingLinesData: reportingLinesData, isKudosEnabled: isKudosEnabled } = this.state;
        const { onReportingLinesClick: onReportingLinesClick, cloudId: cloudId, userId: userId, addFlag: addFlag } = this.props;
        const isFetchingOrNotStartToFetchYet = isLoading === true || isLoading === undefined;
        if (isFetchingOrNotStartToFetchYet) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijWKk.default), {
            fireAnalytics: this.fireAnalytics
        }));
        else if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ga2m.default), {
            errorType: error,
            reload: this.clientFetchProfile,
            fireAnalytics: this.fireAnalytics
        }));
        const newProps = {
            hasError: hasError,
            errorType: error,
            clientFetchProfile: this.clientFetchProfile,
            reportingLines: reportingLinesData,
            onReportingLinesClick: onReportingLinesClick,
            cloudId: cloudId,
            userId: userId,
            addFlag: addFlag,
            ...data,
            isKudosEnabled: isKudosEnabled,
            teamCentralBaseUrl: this.props.resourceClient.getTeamCentralBaseUrl(),
            openKudosDrawer: this.openKudosDrawer
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isKudosEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dx7Op.GiveKudosLauncherLazy), {
            isOpen: this.state.kudosDrawerOpen,
            recipient: {
                type: (0, $btCBO.KudosType).INDIVIDUAL,
                recipientId: this.props.userId
            },
            analyticsSource: "profile-card",
            teamCentralBaseUrl: newProps.teamCentralBaseUrl,
            cloudId: this.props.cloudId,
            addFlag: this.props.addFlag,
            onClose: this.closeKudosDrawer
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ehM5E.default), {
            ...newProps,
            actions: this.filterActions()
        })));
    }
    constructor(...args){
        super(...args);
        this._isMounted = false;
        this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            reportingLinesData: undefined,
            isKudosEnabled: false,
            kudosDrawerOpen: false
        };
        this.fireAnalytics = (payload)=>{
            // Don't fire analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $3vXh8.fireEvent)(this.props.createAnalyticsEvent, payload);
        };
        this.clientFetchProfile = ()=>{
            const { cloudId: cloudId, userId: userId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                hasError: false,
                data: null
            }, ()=>{
                const requests = Promise.all([
                    this.props.resourceClient.getProfile(cloudId, userId, this.fireAnalytics),
                    this.props.resourceClient.getReportingLines(userId),
                    this.props.resourceClient.shouldShowGiveKudos()
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        };
        this.filterActions = ()=>(0, $5Jx7I.default)(this.props.actions, this.state.data);
        this.openKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: true
            });
        };
        this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        };
    }
}
const $184c4f94fc0b4764$export$a6d9ff68ecba3be5 = $184c4f94fc0b4764$var$ProfileCardResourced;
var $184c4f94fc0b4764$export$2e2bcd8739ae039 = (0, $2jDha.default)()($184c4f94fc0b4764$var$ProfileCardResourced);

});
parcelRegister("ijWKk", function(module, exports) {

$parcel$export(module.exports, "default", () => $005cfbb6d85cc048$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");
const $005cfbb6d85cc048$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $eUqFw.useEffect)(()=>{
        fireAnalytics((0, $3vXh8.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
};
var $005cfbb6d85cc048$export$2e2bcd8739ae039 = $005cfbb6d85cc048$var$UserLoadingState;

});


parcelRegister("1I4cW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9a11e1a2b837fef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $dx7Op = parcelRequire("dx7Op");
var $btCBO = parcelRequire("btCBO");

var $XHGTv = parcelRequire("XHGTv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $5Jx7I = parcelRequire("5Jx7I");

var $l2W2J = parcelRequire("l2W2J");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");


var $eKJ5n = parcelRequire("eKJ5n");

var $hSM1E = parcelRequire("hSM1E");

var $ijWKk = parcelRequire("ijWKk");
function $d9a11e1a2b837fef$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent && (0, $XHGTv.fg)('enable_agent_profile_card')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eKJ5n.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSM1E.ProfileCardLazy), {
        ...profilecardProps,
        actions: profileCardAction,
        hasError: hasError,
        errorType: errorType,
        withoutElevation: true
    }));
}
function $d9a11e1a2b837fef$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isMounted = (0, $eUqFw.useRef)(false);
    const showDelay = trigger === 'click' ? 0 : (0, $515c9dbc88c31cf4$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' ? 0 : (0, $515c9dbc88c31cf4$export$89a9f35a94d7f196);
    const showTimer = (0, $eUqFw.useRef)(0);
    const hideTimer = (0, $eUqFw.useRef)(0);
    const [visible, setVisible] = (0, $eUqFw.useState)(false);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(undefined);
    const [hasError, setHasError] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $eUqFw.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $eUqFw.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $eUqFw.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $eUqFw.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const triggerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $eUqFw.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $eUqFw.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $eUqFw.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $eUqFw.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setTeamCentralBaseUrl(resourceClient.getTeamCentralBaseUrl());
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos()
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const containerListeners = (0, $eUqFw.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $eUqFw.useCallback)(()=>{
        return (0, $5Jx7I.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $eUqFw.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: (0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query_profile_card') ? userId === viewingUserId : data?.isCurrentUser,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: !!visible,
        onClose: (event)=>{
            hideProfilecard();
            handleKeyboardClose(event);
        },
        placement: position,
        offset: offset ?? [
            0,
            8
        ],
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", wrapperProps, showLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9a11e1a2b837fef$var$LoadingView, {
                fireAnalytics: fireAnalytics
            }) : visible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9a11e1a2b837fef$var$ProfileCardContent, {
                profilecardProps: profilecardProps,
                isAgent: !!data?.isAgent,
                userId: userId,
                cloudId: cloudId,
                resourceClient: resourceClient,
                viewingUserId: viewingUserId,
                trigger: trigger,
                product: product,
                profileCardAction: filterActions(),
                errorType: error,
                hasError: hasError,
                agentActions: agentActions,
                addFlag: addFlag
            })),
        trigger: (triggerProps)=>{
            const { ref: callbackRef, ...innerProps } = triggerProps;
            const ref = (element)=>{
                triggerRef.current = element;
                if (typeof callbackRef === 'function') callbackRef(element);
            };
            const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                ...disabledAriaAttributes ? restInnerProps : triggerProps,
                ...containerListeners,
                ref: ref,
                "data-testid": testId,
                "aria-labelledby": ariaLabelledBy,
                ...disabledAriaAttributes ? {} : {
                    role: 'button',
                    tabIndex: 0,
                    'aria-label': (0, $l2W2J.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                }
            }, children);
        },
        zIndex: (0, $lcnyw.layers).modal(),
        shouldUseCaptureOnOutsideClick: true,
        autoFocus: autoFocus ?? trigger === 'click'
    }), shouldShowGiveKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dx7Op.GiveKudosLauncherLazy), {
        isOpen: kudosDrawerOpen,
        recipient: {
            type: (0, $btCBO.KudosType).INDIVIDUAL,
            recipientId: userId
        },
        analyticsSource: "profile-card",
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        addFlag: addFlag,
        onClose: closeKudosDrawer
    })));
}
const $d9a11e1a2b837fef$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), {
        "data-testId": "profilecard.profilecardtrigger.loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijWKk.default), {
        fireAnalytics: fireAnalytics
    }));

});
parcelRegister("l2W2J", function(module, exports) {

$parcel$export(module.exports, "default", () => $02881092ed20fd17$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $02881092ed20fd17$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($02881092ed20fd17$var$messages.label, {
        fullName: fullName
    }) : formatMessage($02881092ed20fd17$var$messages.fallbackLabel);
};
const $02881092ed20fd17$var$messages = (0, $90IgZ.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $02881092ed20fd17$export$2e2bcd8739ae039 = $02881092ed20fd17$var$getLabelMessage;

});

parcelRegister("eKJ5n", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $f174a152b20761e7$export$4b013ffffcb40af8);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $3vXh8 = parcelRequire("3vXh8");

var $6oOPK = parcelRequire("6oOPK");

var $4ga2m = parcelRequire("4ga2m");

var $kCTG1 = parcelRequire("kCTG1");

var $i6n3V = parcelRequire("i6n3V");
const $f174a152b20761e7$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $eUqFw.useState)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $eUqFw.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $6oOPK.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const getCreator = (0, $eUqFw.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient
    ]);
    const getAgentInfo = (0, $eUqFw.useCallback)(()=>{
        return props.resourceClient.getRovoAgentProfile({
            type: 'identity',
            value: props.accountId
        }, fireAnalytics);
    }, [
        fireAnalytics,
        props.accountId,
        props.resourceClient
    ]);
    const fetchData = (0, $eUqFw.useCallback)(async ()=>{
        setIsLoading(true);
        const getAgentData = async ()=>{
            const profileData = await getAgentInfo();
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            return {
                ...profileData,
                creatorInfo: agentCreatorInfo
            };
        };
        const agentData = await getAgentData();
        setAgentData(agentData);
        setIsLoading(false);
    }, [
        getAgentInfo,
        getCreator
    ]);
    (0, $eUqFw.useEffect)(()=>{
        try {
            fetchData();
        } catch (error) {
            setIsLoading(false);
            setError(error);
        }
    }, [
        fetchData,
        getAgentInfo,
        getCreator,
        props.accountId,
        props.cloudId,
        props.resourceClient
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCTG1.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ga2m.default), {
        reload: ()=>{
            fetchData();
        },
        errorType: error || null,
        fireAnalytics: ()=>{}
    }));
    if (agentData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6n3V.AgentProfileCardLazy), {
        agent: agentData,
        isLoading: isLoading,
        hasError: !!error,
        isCreatedByViewingUser: creatorUserId === props.viewingUserId,
        product: props.product,
        onConversationStartersClick: props.onConversationStartersClick,
        onChatClick: props.onChatClick,
        addFlag: props.addFlag,
        resourceClient: props.resourceClient
    });
    return null;
};

});
parcelRegister("6oOPK", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $d85581b87885252e$export$3761e66a04602cbd);
const $d85581b87885252e$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d85581b87885252e$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d85581b87885252e$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("i6n3V", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $05a0ac107f346903$export$ed0ca9c1d49ea0bf);

var $eUqFw = parcelRequire("eUqFw");

const $05a0ac107f346903$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>Promise.resolve((parcelRequire("6uyUT"))));

});


parcelRegister("hSM1E", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $79ec67bb4c36fbd6$export$403d297463f226af);

var $eUqFw = parcelRequire("eUqFw");

const $79ec67bb4c36fbd6$export$403d297463f226af = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>Promise.resolve((parcelRequire("ehM5E"))));

});


parcelRegister("icLG8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3275fd86a923b35a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
function $3275fd86a923b35a$export$2e2bcd8739ae039(Component) {
    return class WithOuterListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
        componentDidMount() {
            if (this.props.handleClickOutside) document.addEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) document.addEventListener('keydown', this.handleKeydown, false);
        }
        componentWillUnmount() {
            if (this.props.handleClickOutside) document.removeEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) document.removeEventListener('keydown', this.handleKeydown, false);
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, this.props);
        }
        constructor(...args){
            super(...args);
            this.handleClick = (evt)=>{
                const { handleClickOutside: handleClickOutside } = this.props;
                if (handleClickOutside) {
                    const domNode = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(this); // eslint-disable-line react/no-find-dom-node
                    if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) handleClickOutside();
                }
            };
            this.handleKeydown = (evt)=>{
                const { handleEscapeKeydown: handleEscapeKeydown } = this.props;
                if (handleEscapeKeydown && evt.code === 'Escape') handleEscapeKeydown();
            };
        }
    };
}

});

parcelRegister("b5p0p", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardTrigger", () => $a90530629aa60146$export$64983741fea6a45d);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $3vXh8 = parcelRequire("3vXh8");

var $6oOPK = parcelRequire("6oOPK");

var $4CtB0 = parcelRequire("4CtB0");

var $i6n3V = parcelRequire("i6n3V");
const $a90530629aa60146$export$64983741fea6a45d = ({ trigger: trigger = 'hover', viewingUserId: viewingUserId, product: product, ...props })=>{
    const { resourceClient: resourceClient, agentId: userId, cloudId: cloudId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const getCreator = async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                const userId = (0, $6oOPK.getAAIDFromARI)(creator) || '';
                try {
                    if (!userId || !cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(cloudId, userId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${userId}`,
                        id: userId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    };
    const fetchAgentProfile = async ()=>{
        const agentInfo = await resourceClient.getRovoAgentProfile({
            type: 'agent',
            value: userId
        }, fireAnalytics);
        const agentCreatorInfo = await getCreator(agentInfo.creator_type, agentInfo.creator || undefined);
        return {
            ...agentInfo,
            creatorInfo: agentCreatorInfo
        };
    };
    const renderProfileCard = ({ profileData: profileData, error: error })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6n3V.AgentProfileCardLazy), {
            agent: profileData,
            hasError: !!error,
            isCreatedByViewingUser: profileData?.creatorInfo && profileData?.creatorInfo?.id === viewingUserId,
            cloudId: props.cloudId,
            product: product,
            errorType: error,
            onChatClick: props.onChatClick,
            onConversationStartersClick: props.onConversationStartersClick,
            resourceClient: props.resourceClient,
            addFlag: props.addFlag
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4CtB0.default), {
        ...props,
        trigger: "hover",
        renderProfileCard: renderProfileCard,
        fetchProfile: fetchAgentProfile,
        fireAnalytics: fireAnalytics,
        profileCardType: "agent"
    });
};

});
parcelRegister("4CtB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d11892819ca4415$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $3vXh8 = parcelRequire("3vXh8");

var $4Ytsq = parcelRequire("4Ytsq");

var $4x5z4 = parcelRequire("4x5z4");

var $dU1zo = parcelRequire("dU1zo");

var $krP5g = parcelRequire("krP5g");
const $8d11892819ca4415$var$DELAY_MS_SHOW = 800;
const $8d11892819ca4415$var$DELAY_MS_HIDE = 200;
function $8d11892819ca4415$var$ProfileCardTrigger({ trigger: trigger, ariaLabelledBy: ariaLabelledBy, children: children, renderProfileCard: renderProfileCard, fetchProfile: fetchProfile, disabledAriaAttributes: disabledAriaAttributes, profileCardType: profileCardType, fireAnalytics: fireAnalytics, ...popupProps }) {
    const showDelay = trigger === 'click' ? 0 : $8d11892819ca4415$var$DELAY_MS_SHOW;
    const hideDelay = trigger === 'click' ? 0 : $8d11892819ca4415$var$DELAY_MS_HIDE;
    const showTimer = (0, $eUqFw.useRef)(0);
    const hideTimer = (0, $eUqFw.useRef)(0);
    const [visible, setVisible] = (0, $eUqFw.useState)(false);
    const { profileData: profileData, isLoading: isLoading, error: error, getProfileData: getProfileData } = (0, $4Ytsq.useProfileInfo)({
        fetchUserProfile: fetchProfile
    });
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    const hideProfilecard = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
        }, hideDelay);
    }, [
        hideDelay
    ]);
    const showProfilecard = (0, $eUqFw.useCallback)(async ()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                getProfileData?.();
                setVisible(true);
                if (fireAnalytics) fireAnalytics((0, $3vXh8.cardTriggered)(profileCardType, trigger));
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        getProfileData,
        fireAnalytics,
        profileCardType,
        trigger
    ]);
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        ...popupProps,
        isOpen: !!visible,
        onClose: hideProfilecard,
        shouldUseCaptureOnOutsideClick: true,
        autoFocus: popupProps.autoFocus ?? trigger === 'click',
        zIndex: (0, $lcnyw.layers).modal(),
        shouldFitContainer: false,
        trigger: (triggerProps)=>{
            const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = triggerProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dU1zo.PopupTrigger), {
                ...disabledAriaAttributes ? restInnerProps : triggerProps,
                ref: triggerProps.ref,
                hideProfilecard: hideProfilecard,
                showProfilecard: showProfilecard,
                children: children,
                ariaLabelledBy: ariaLabelledBy,
                trigger: trigger
            });
        },
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onFocus: showProfilecard
            }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $krP5g.ProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4x5z4.LoadingState), {
                fireAnalytics: fireAnalytics,
                profileType: profileCardType
            })) : renderProfileCard({
                profileData: profileData,
                error: error
            }))
    });
}
var $8d11892819ca4415$export$2e2bcd8739ae039 = $8d11892819ca4415$var$ProfileCardTrigger;

});
parcelRegister("4Ytsq", function(module, exports) {

$parcel$export(module.exports, "useProfileInfo", () => $b18841adfa594cc7$export$6cace87f7d7a9738);

var $eUqFw = parcelRequire("eUqFw");
const $b18841adfa594cc7$export$6cace87f7d7a9738 = ({ fetchUserProfile: fetchUserProfile })=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [profileData, setProfileData] = (0, $eUqFw.useState)();
    const getProfileData = async ()=>{
        setIsLoading(true);
        try {
            const profileData = await fetchUserProfile?.();
            setProfileData(profileData);
            setIsLoading(false);
        } catch (error) {
            setError(error);
            setIsLoading(false);
        }
    };
    return {
        profileData: profileData,
        isLoading: isLoading,
        error: error,
        getProfileData: getProfileData
    };
};

});

parcelRegister("dU1zo", function(module, exports) {

$parcel$export(module.exports, "PopupTrigger", () => $0abfc530bf195494$export$95d4acdbab2fc6ef);

var $eUqFw = parcelRequire("eUqFw");
const $0abfc530bf195494$var$PopupTriggerInner = ({ children: children, trigger: trigger, showProfilecard: showProfilecard, hideProfilecard: hideProfilecard, ariaLabelledBy: ariaLabelledBy, ...props }, ref)=>{
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const onKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            showProfilecard();
        }
    }, [
        showProfilecard
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // Prevent the click event from propagating to parent containers.
        event.stopPropagation();
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const containerListeners = (0, $eUqFw.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ...props,
        ...containerListeners,
        ref: ref,
        "aria-labelledby": ariaLabelledBy
    }, children);
};
const $0abfc530bf195494$export$95d4acdbab2fc6ef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef($0abfc530bf195494$var$PopupTriggerInner);

});

parcelRegister("krP5g", function(module, exports) {

$parcel$export(module.exports, "ProfileCardWrapper", () => $6870e7512d19a464$export$59abd6feb7dc8540);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $6870e7512d19a464$var$styles = (0, $1ZAYh.xcss)({
    width: '360px'
});
const $6870e7512d19a464$export$59abd6feb7dc8540 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6870e7512d19a464$var$styles
    }, children);
};

});




parcelRegister("7mHhy", function(module, exports) {

$parcel$export(module.exports, "isSystemAgent", () => $7711ba6d34f9c270$export$7c120b233d4844c6);
$parcel$export(module.exports, "isCustomerAgent", () => $7711ba6d34f9c270$export$f817e52cf2c5cc8c);
$parcel$export(module.exports, "isForgeAgent", () => $7711ba6d34f9c270$export$2149adda3d8a5807);
$parcel$export(module.exports, "useAgentsController", () => $7711ba6d34f9c270$export$eee66751ca85dbf7);
$parcel$export(module.exports, "useAgentsList", () => $7711ba6d34f9c270$export$6553fa633373a34);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $asu8X = parcelRequire("asu8X");

var $WBLbN = parcelRequire("WBLbN");

var $XHGTv = parcelRequire("XHGTv");

var $itKco = parcelRequire("itKco");

var $19xaS = parcelRequire("19xaS");
var $dXg8a = parcelRequire("dXg8a");

var $8jvuZ = parcelRequire("8jvuZ");
var $bxiUx = parcelRequire("bxiUx");
var $1DkoF = parcelRequire("1DkoF");
var $2jCEn = parcelRequire("2jCEn");
var $6n1kb = parcelRequire("6n1kb");

var $bH5Sg = parcelRequire("bH5Sg");

var $24e7T = parcelRequire("24e7T");

var $4SDYM = parcelRequire("4SDYM");
var $3a1Rq = parcelRequire("3a1Rq");

var $l8Otf = parcelRequire("l8Otf");

var $gYj4m = parcelRequire("gYj4m");
const $7711ba6d34f9c270$var$categoriseAgents = (agents)=>agents.reduce((categorisedAgents, agent)=>{
        if (agent.creator_type === 'SYSTEM') categorisedAgents.system.push(agent);
        else if (agent.visibility === 'PUBLIC') categorisedAgents.public.push(agent);
        else if (agent.visibility === 'PRIVATE') categorisedAgents.private.push(agent);
        else if (!agent.visibility && agent.creator_type === 'CUSTOMER') categorisedAgents.private.push(agent);
        return categorisedAgents;
    }, {
        public: [],
        private: [],
        system: []
    });
const $7711ba6d34f9c270$var$agentsStore = (0, $WBLbN.createStore)({
    initialState: {
        availableAgents: [],
        categorisedAgents: {
            private: [],
            public: [],
            system: []
        },
        agentsInitialized: false
    },
    name: 'AgentsStore',
    actions: {
        setAgents: (availableAgents)=>({ setState: setState })=>{
                setState({
                    availableAgents: availableAgents,
                    categorisedAgents: $7711ba6d34f9c270$var$categoriseAgents(availableAgents)
                });
            },
        getAgentDetails: (id)=>({ getState: getState })=>{
                const { availableAgents: availableAgents } = getState();
                return availableAgents.find((agent)=>agent.id === id);
            },
        setAgentsInitialized: ()=>({ setState: setState })=>{
                setState({
                    agentsInitialized: true
                });
            }
    }
});
const $7711ba6d34f9c270$var$useAgentsStore = (0, $WBLbN.createHook)($7711ba6d34f9c270$var$agentsStore);
const $7711ba6d34f9c270$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
const $7711ba6d34f9c270$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
const $7711ba6d34f9c270$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
const $7711ba6d34f9c270$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
const $7711ba6d34f9c270$export$f5b1109ecd7858c1 = ({ onError: onError, experienceId: experienceId = 'ai-mate', product: product } = {})=>{
    (0, $asu8X.di)((0, $1DkoF.useAssistanceService));
    const { isRovoEnabled: isRovoEnabled } = (0, $itKco.useRovoEntitlement)();
    const assistanceService = (0, $1DkoF.useAssistanceService)({
        experienceId: experienceId,
        product: product
    });
    const { agentIdFiltersOverride: agentIdFiltersOverride, agentDefaultIdOverride: agentDefaultIdOverride } = (0, $3a1Rq.useAgentOverrider)();
    const [{ availableAgents: availableAgents, categorisedAgents: categorisedAgents, agentsInitialized: agentsInitialized }, { setAgents: setAgents, getAgentDetails: getAgentDetails, setAgentsInitialized: setAgentsInitialized }] = $7711ba6d34f9c270$var$useAgentsStore();
    const experience = (0, $dXg8a.useAIMateExperienceTracker)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $24e7T.useAgentFavourites)({
        experienceId: experienceId,
        product: product
    });
    const favouritedAgents = availableAgents.filter((agent)=>agent.favourite);
    const defaultAgent = (0, $eUqFw.useMemo)(()=>availableAgents.find((agent)=>agent.is_default), [
        availableAgents
    ]);
    const nonDefaultAgents = (0, $eUqFw.useMemo)(()=>availableAgents.filter((agent)=>!agent.is_default), [
        availableAgents
    ]);
    const nonDefaultFavouriteAgents = (0, $eUqFw.useMemo)(()=>nonDefaultAgents.filter((agent)=>!agent.favourite), [
        nonDefaultAgents
    ]);
    const fetchAndStoreAvailableAgents = (0, $6n1kb.useQuery)({
        queryKey: [
            'fetchAgents'
        ],
        queryFn: async ()=>{
            try {
                experience.start({
                    id: (0, $19xaS.ExperienceName).FETCH_AGENTS,
                    name: (0, $19xaS.ExperienceName).FETCH_AGENTS
                });
                const agents = await (0, $8jvuZ.exponentialRetry)({
                    fn: ()=>assistanceService.getAgents(),
                    errorFilter: (0, $bxiUx.isRateLimitedError)
                });
                const transformedAgents = agents.map((agent)=>{
                    // Rename default agent to Chat, which is displayed in the UI
                    if (agent.is_default) {
                        agent.name = formatMessage((0, $gYj4m.default).defaultAgentName);
                        agent.description = formatMessage((0, $gYj4m.default).defaultAgentDescription);
                    }
                    return agent;
                });
                const overriddenAgents = (0, $4SDYM.getOverridenAgents)(transformedAgents, agentIdFiltersOverride, agentDefaultIdOverride);
                setAgents(overriddenAgents);
                experience.succeed({
                    name: (0, $19xaS.ExperienceName).FETCH_AGENTS
                });
                setAgentsInitialized();
            } catch (error) {
                experience.fail({
                    name: (0, $19xaS.ExperienceName).FETCH_AGENTS,
                    error: error
                });
                throw error;
            }
        },
        onError: onError,
        enabled: isRovoEnabled,
        refetchOnWindowFocus: (0, $XHGTv.fg)('rovo_refetch_agent_on_window_focus')
    });
    const createAgent = (0, $2jCEn.useMutation)({
        mutationFn: async (payload)=>{
            experience.start({
                id: (0, $19xaS.ExperienceName).CREATE_AGENT,
                name: (0, $19xaS.ExperienceName).CREATE_AGENT
            });
            return await assistanceService.createAgent(payload);
        },
        onSuccess: async (agent)=>{
            await favouriteAgent.mutate(agent.id);
            await fetchAndStoreAvailableAgents.refetch();
            experience.succeed({
                name: (0, $19xaS.ExperienceName).CREATE_AGENT
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $19xaS.ExperienceName).CREATE_AGENT,
                error: error
            });
        }
    });
    const updateAgent = (0, $2jCEn.useMutation)({
        mutationFn: async (payload)=>{
            experience.start({
                id: (0, $19xaS.ExperienceName).UPDATE_AGENT,
                name: (0, $19xaS.ExperienceName).UPDATE_AGENT
            });
            return await assistanceService.updateAgent(payload.id, payload.data);
        },
        onSuccess: async (_agent)=>{
            await fetchAndStoreAvailableAgents.refetch();
            experience.succeed({
                name: (0, $19xaS.ExperienceName).UPDATE_AGENT
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $19xaS.ExperienceName).UPDATE_AGENT,
                error: error
            });
        }
    });
    const { deleteAgent: deleteAgent } = (0, $bH5Sg.useDeleteAgent)({
        experienceId: experienceId,
        product: product,
        onSuccess: ()=>{
            fetchAndStoreAvailableAgents.refetch();
        }
    });
    const setFavouriteAgent = (0, $eUqFw.useCallback)(async (id, isFavourite)=>{
        const updatedAgent = availableAgents.find((a)=>a.id === id);
        const setUpdatedAgent = (shouldBeFavourite)=>{
            if (updatedAgent) {
                updatedAgent.favourite = shouldBeFavourite;
                setAgents(availableAgents.map((a)=>{
                    // If the current agent's id matches the new agent's id, return the new agent.
                    // Otherwise, return the current agent.
                    return a.id === updatedAgent.id ? updatedAgent : a;
                }));
            }
        };
        //Optimistically update favourite value before we mutate
        setUpdatedAgent(isFavourite);
        //Pass callback to roll back optimistic update if mutation fails
        const errorCallback = {
            onError: ()=>{
                setUpdatedAgent(!isFavourite);
            }
        };
        if (isFavourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        availableAgents,
        setAgents,
        favouriteAgent,
        unfavouriteAgent
    ]);
    return {
        availableAgents: availableAgents,
        favouritedAgents: favouritedAgents,
        categorisedAgents: categorisedAgents,
        fetchAndStoreAvailableAgents: fetchAndStoreAvailableAgents,
        createAgent: createAgent,
        updateAgent: updateAgent,
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        getAgentDetails: getAgentDetails,
        defaultAgent: defaultAgent,
        agentsInitialized: agentsInitialized,
        nonDefaultAgents: nonDefaultAgents,
        nonDefaultFavouriteAgents: nonDefaultFavouriteAgents
    };
};
const $7711ba6d34f9c270$var$noopAsync = async ()=>{};
const $7711ba6d34f9c270$var$noopFn = ()=>undefined;
const $7711ba6d34f9c270$var$noopArray = [];
const $7711ba6d34f9c270$var$noopCategorisedAgent = {
    public: [],
    private: [],
    system: []
};
const $7711ba6d34f9c270$export$65742028fec5fb81 = {
    id: 'NOOP',
    name: 'NOOP',
    named_id: 'NOOP',
    user_defined_conversation_starters: [],
    description: '',
    available_plugins: {},
    actor_type: 'AGENT',
    creator_type: 'SYSTEM',
    visibility: 'PRIVATE',
    is_default: false,
    favourite: false,
    deactivated: false
};
const $7711ba6d34f9c270$export$eee66751ca85dbf7 = (param)=>{
    const { isRovoEnabled: isRovoEnabled } = (0, $itKco.useRovoEntitlement)();
    const controllerResult = $7711ba6d34f9c270$export$f5b1109ecd7858c1(param);
    const noopUseQuery = (0, $6n1kb.useQuery)({
        queryKey: [
            'noop'
        ],
        queryFn: $7711ba6d34f9c270$var$noopAsync,
        enabled: false
    });
    const noopUseMutation = (0, $2jCEn.useMutation)({
        mutationFn: async ()=>$7711ba6d34f9c270$export$65742028fec5fb81,
        onSuccess: $7711ba6d34f9c270$var$noopAsync,
        onError: $7711ba6d34f9c270$var$noopAsync
    });
    if (!isRovoEnabled) return {
        availableAgents: $7711ba6d34f9c270$var$noopArray,
        favouritedAgents: $7711ba6d34f9c270$var$noopArray,
        categorisedAgents: $7711ba6d34f9c270$var$noopCategorisedAgent,
        defaultAgent: undefined,
        agentsInitialized: false,
        getAgentDetails: $7711ba6d34f9c270$var$noopFn,
        fetchAndStoreAvailableAgents: noopUseQuery,
        createAgent: noopUseMutation,
        updateAgent: noopUseMutation,
        deleteAgent: noopUseMutation,
        setFavouriteAgent: noopUseMutation,
        nonDefaultAgents: $7711ba6d34f9c270$var$noopArray,
        nonDefaultFavouriteAgents: $7711ba6d34f9c270$var$noopArray
    };
    return controllerResult;
};
const $7711ba6d34f9c270$export$6553fa633373a34 = ({ product: product, experienceId: experienceId = 'ai-mate', filter: filter } = {})=>{
    const { availableAgents: availableAgents, favouritedAgents: favouritedAgents } = $7711ba6d34f9c270$export$eee66751ca85dbf7({
        product: product,
        experienceId: experienceId
    });
    const validAgents = availableAgents.filter((agent)=>(0, $l8Otf.DEFAULT_AGENTS_NAMED_ID_LIST).has(agent.named_id));
    const defaultAgentsOutsideUserFavourites = validAgents.filter((defaultAgent)=>!favouritedAgents.find((favAgent)=>favAgent.named_id === defaultAgent.named_id));
    const favouritedAgentsWithDefault = [
        ...favouritedAgents,
        ...defaultAgentsOutsideUserFavourites.slice(0, Math.max(3 - favouritedAgents.length, 0))
    ];
    return filter === 'favourites' ? favouritedAgentsWithDefault : availableAgents;
};

});
parcelRegister("8jvuZ", function(module, exports) {

$parcel$export(module.exports, "exponentialRetry", () => $9eb53651b5ca09e1$export$4dfcad98182a1ece);
const $9eb53651b5ca09e1$export$4dfcad98182a1ece = async ({ fn: fn, maxRetries: maxRetries = 3, retryCount: retryCount = 0, delay: delay = 1000, errorFilter: errorFilter })=>{
    try {
        return await fn();
    } catch (error) {
        if (errorFilter && !errorFilter(error)) throw error;
        if (retryCount >= maxRetries) throw error;
        await new Promise((resolve)=>setTimeout(resolve, delay));
        return await $9eb53651b5ca09e1$export$4dfcad98182a1ece({
            fn: fn,
            maxRetries: maxRetries,
            retryCount: retryCount + 1,
            delay: delay * 2,
            errorFilter: errorFilter
        });
    }
};

});

parcelRegister("2jCEn", function(module, exports) {

$parcel$export(module.exports, "useMutation", () => $584bd6830afd3a7d$export$609860bf8b0084c);

var $eUqFw = parcelRequire("eUqFw");

var $cfr3D = parcelRequire("cfr3D");
const $584bd6830afd3a7d$export$609860bf8b0084c = ({ mutationFn: mutationFn, onSuccess: onSuccess, onError: onError })=>{
    const mutationFnRef = (0, $eUqFw.useRef)(mutationFn);
    mutationFnRef.current = mutationFn;
    const onSuccessRef = (0, $eUqFw.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $eUqFw.useRef)(onError);
    onErrorRef.current = onError;
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [isSubmitting, setIsSubmitting] = (0, $eUqFw.useState)(false);
    const mutate = (0, $eUqFw.useCallback)(async (payload, mutateCallback)=>{
        setIsSubmitting(true);
        try {
            const response = await mutationFnRef.current(payload);
            setData(response);
            onSuccessRef.current?.(response);
            mutateCallback?.onSuccess?.(response);
        } catch (error) {
            const apiError = (0, $cfr3D.mapErrorToApiError)(error);
            setError(apiError);
            onErrorRef.current?.(apiError);
            mutateCallback?.onError?.(apiError);
        } finally{
            setIsSubmitting(false);
        }
    }, []);
    return {
        data: data,
        error: error,
        isSubmitting: isSubmitting,
        mutate: mutate
    };
};

});

parcelRegister("bH5Sg", function(module, exports) {

$parcel$export(module.exports, "useDeleteAgent", () => $e03d3ae2ff712ef8$export$89877d4f8d8790ca);

var $asu8X = parcelRequire("asu8X");

var $19xaS = parcelRequire("19xaS");
var $dXg8a = parcelRequire("dXg8a");

var $1DkoF = parcelRequire("1DkoF");
var $2jCEn = parcelRequire("2jCEn");
const $e03d3ae2ff712ef8$export$89877d4f8d8790ca = ({ experienceId: experienceId, product: product, onSuccess: onSuccess, onError: onError } = {})=>{
    (0, $asu8X.di)((0, $1DkoF.useAssistanceService));
    const experience = (0, $dXg8a.useAIMateExperienceTracker)();
    const assistanceService = (0, $1DkoF.useAssistanceService)({
        experienceId: experienceId,
        product: product
    });
    const deleteAgent = (0, $2jCEn.useMutation)({
        mutationFn: async (id)=>{
            experience.start({
                id: (0, $19xaS.ExperienceName).DELETE_AGENT,
                name: (0, $19xaS.ExperienceName).DELETE_AGENT
            });
            return await assistanceService.deleteAgent(id);
        },
        onSuccess: async (data)=>{
            experience.succeed({
                name: (0, $19xaS.ExperienceName).DELETE_AGENT
            });
            onSuccess?.();
            return data;
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $19xaS.ExperienceName).DELETE_AGENT,
                error: error
            });
            onError?.();
        }
    });
    return {
        deleteAgent: deleteAgent
    };
};

});

parcelRegister("24e7T", function(module, exports) {

$parcel$export(module.exports, "useAgentFavourites", () => $71277e8a34df4ddc$export$5c4c46b1f93a6e69);

var $asu8X = parcelRequire("asu8X");

var $19xaS = parcelRequire("19xaS");
var $dXg8a = parcelRequire("dXg8a");

var $1DkoF = parcelRequire("1DkoF");
var $2jCEn = parcelRequire("2jCEn");
const $71277e8a34df4ddc$export$5c4c46b1f93a6e69 = ({ onError: onError, onSuccess: onSuccess, experienceId: experienceId = 'ai-mate', product: product } = {})=>{
    (0, $asu8X.di)((0, $1DkoF.useAssistanceService));
    const assistanceService = (0, $1DkoF.useAssistanceService)({
        experienceId: experienceId,
        product: product
    });
    const experience = (0, $dXg8a.useAIMateExperienceTracker)();
    const favouriteAgent = (0, $2jCEn.useMutation)({
        mutationFn: async (id)=>{
            experience.start({
                id: (0, $19xaS.ExperienceName).FAVOURITE_AGENT,
                name: (0, $19xaS.ExperienceName).FAVOURITE_AGENT
            });
            return await assistanceService.favouriteAgent(id);
        },
        onSuccess: async ()=>{
            experience.succeed({
                name: (0, $19xaS.ExperienceName).FAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: true
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $19xaS.ExperienceName).FAVOURITE_AGENT,
                error: error
            });
            onError?.({
                favourite: true
            });
        }
    });
    const unfavouriteAgent = (0, $2jCEn.useMutation)({
        mutationFn: async (id)=>{
            experience.start({
                id: (0, $19xaS.ExperienceName).UNFAVOURITE_AGENT,
                name: (0, $19xaS.ExperienceName).UNFAVOURITE_AGENT
            });
            return await assistanceService.unfavouriteAgent(id);
        },
        onSuccess: async ()=>{
            experience.succeed({
                name: (0, $19xaS.ExperienceName).UNFAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: false
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $19xaS.ExperienceName).UNFAVOURITE_AGENT,
                error: error
            });
            onError?.({
                favourite: false
            });
        }
    });
    return {
        favouriteAgent: favouriteAgent,
        unfavouriteAgent: unfavouriteAgent
    };
};

});

parcelRegister("4SDYM", function(module, exports) {

$parcel$export(module.exports, "getOverridenAgents", () => $91890505bc5364bb$export$b873e2166b2a4c4f);
const $91890505bc5364bb$export$b873e2166b2a4c4f = (agents, agentIdFiltersOverride, agentDefaultIdOverride)=>{
    const defaultOverrideAgentsIndex = agents.findIndex((agent)=>agentDefaultIdOverride === agent.id);
    let overridenAgents = [];
    if (defaultOverrideAgentsIndex !== -1) overridenAgents = agents.map((agent, index)=>({
            ...agent,
            is_default: index === defaultOverrideAgentsIndex
        }));
    else overridenAgents = agents;
    if (Array.isArray(agentIdFiltersOverride)) return overridenAgents.filter((agent)=>agentIdFiltersOverride?.includes(agent.id) || agent.is_default);
    return overridenAgents;
};

});

parcelRegister("3a1Rq", function(module, exports) {

$parcel$export(module.exports, "useAgentOverrider", () => $c3e461369880ec98$export$7b61e11d4e81ba17);
$parcel$export(module.exports, "AgentOverriderProvider", () => $c3e461369880ec98$export$aa582af5b4b72bb2);
$parcel$export(module.exports, "createAgentsConfig", () => $c3e461369880ec98$export$6aab84dc399ad753);

var $eUqFw = parcelRequire("eUqFw");

var $4SDYM = parcelRequire("4SDYM");
const $c3e461369880ec98$export$ccc6603eb027f48b = /*#__PURE__*/ (0, $eUqFw.createContext)({});
const $c3e461369880ec98$export$7b61e11d4e81ba17 = ()=>(0, $eUqFw.useContext)($c3e461369880ec98$export$ccc6603eb027f48b);
const $c3e461369880ec98$export$aa582af5b4b72bb2 = $c3e461369880ec98$export$ccc6603eb027f48b.Provider;
const $c3e461369880ec98$export$6aab84dc399ad753 = (config)=>({
        agentDefaultIdOverride: config?.defaultAgentId,
        agentIdFiltersOverride: config?.filter
    });

});

parcelRegister("l8Otf", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_AGENTS_NAMED_ID_LIST", () => $eefa3db921bcf81e$export$2d0163867590928d);
const $eefa3db921bcf81e$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC'
};
const $eefa3db921bcf81e$export$2d0163867590928d = new Set([
    'decision_director_agent',
    'user_manual_writer_agent',
    'product_requirements_expert_agent'
]);

});

parcelRegister("gYj4m", function(module, exports) {

$parcel$export(module.exports, "default", () => $db3d7d4ec71b948c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $db3d7d4ec71b948c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    defaultAgentName: {
        id: 'ai-mate.agent-selector.default-agent-name',
        defaultMessage: 'Chat',
        description: 'Default agent name'
    },
    defaultAgentDescription: {
        id: 'ai-mate.agent-selector.default-agent-description',
        defaultMessage: 'Get answers, generate new ideas, and accelerate everyday work.'
    }
});

});


parcelRegister("wPTaH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1665fa69b74f74c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b1665fa69b74f74c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    deactivatedCreatorName: {
        id: 'rovo-chat.agent-card.deactivated-name',
        defaultMessage: '{name} (deactivated)',
        description: 'Name of the agent creator when it is deactivated'
    }
});

});


parcelRegister("2LVgg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac9b3d75b83a8cbc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $cAuBo = parcelRequire("cAuBo");
var $cWYE1 = parcelRequire("cWYE1");

var $6sOvy = parcelRequire("6sOvy");
function $ac9b3d75b83a8cbc$export$1064229c13822d9f(props) {
    const [{ orgId: orgId }] = (0, $cWYE1.useOrg)();
    return orgId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6sOvy.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac9b3d75b83a8cbc$var$ProfileAboutTeamsSpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cAuBo.default), {
        size: 'small'
    }));
}
var $ac9b3d75b83a8cbc$export$2e2bcd8739ae039 = $ac9b3d75b83a8cbc$export$1064229c13822d9f;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ac9b3d75b83a8cbc$var$ProfileAboutTeamsSpinnerWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-17jr9k9-0"
})`display:flex;justify-content:center;align-items:center;`;

});
parcelRegister("cAuBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f20f31215dfe5834$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $3pNyn = parcelRequire("3pNyn");
const $f20f31215dfe5834$var$Spinner = ({ wrapperHeight: wrapperHeight, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3pNyn.SpinnerWrapper, {
        height: wrapperHeight,
        "data-test-selector": "spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), props));
var $f20f31215dfe5834$export$2e2bcd8739ae039 = $f20f31215dfe5834$var$Spinner;

});
parcelRegister("3pNyn", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $496035e6d0a3c4b3$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $496035e6d0a3c4b3$var$getHeight = ({ height: height })=>{
    if (typeof height === 'number') return `${height}px`;
    return height;
};
const $496035e6d0a3c4b3$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1umpdm7-0"
})`display:flex;justify-content:center;align-items:center;margin:${"var(--ds-space-200, 16px)"} 0;height:${$496035e6d0a3c4b3$var$getHeight};`;

});


parcelRegister("6sOvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $592d05b683f3d6cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");

var $7u4fN = parcelRequire("7u4fN");

var $gw74N = parcelRequire("gw74N");


var $1io2n = parcelRequire("1io2n");
var $2lryl = parcelRequire("2lryl");
var $4ZUSO = parcelRequire("4ZUSO");
var $cAuBo = parcelRequire("cAuBo");
var $74Hyh = parcelRequire("74Hyh");
var $elP2D = parcelRequire("elP2D");
var $gakch = parcelRequire("gakch");
var $iNIpe = parcelRequire("iNIpe");

var $lEcQZ = parcelRequire("lEcQZ");

var $4XuTO = parcelRequire("4XuTO");

var $dth5h = parcelRequire("dth5h");

var $ftQay = parcelRequire("ftQay");

var $88bBf = parcelRequire("88bBf");

var $bxeZb = parcelRequire("bxeZb");
const $592d05b683f3d6cb$export$4a2947f47d583741 = 10;
const $592d05b683f3d6cb$export$b827413854913969 = 30;
function $592d05b683f3d6cb$export$2697725d6b507e8c(props) {
    const analytics = (0, $74Hyh.default)();
    const [enableInfiniteScroll, setEnableInfiniteScroll] = (0, $eUqFw.useState)(false);
    const [showLess, setShowLess] = (0, $eUqFw.useState)(true);
    const [{ hasLoaded: hasUserDataLoaded, principalUserId: currentUserId }] = (0, $gakch.usePrincipalUser)();
    const { isLoading: isTeamSearchLoading, teams: teamSearchTeams, error: ApolloError, loadMore: loadMore, hasMore: hasMore } = (0, $lEcQZ.useTeamSearchQuery)({
        first: $592d05b683f3d6cb$export$4a2947f47d583741 + 1,
        // +1 to make sure it has more than 10 teams
        batchSize: $592d05b683f3d6cb$export$b827413854913969,
        memberIds: [
            props.userId
        ]
    });
    // don't need to trigger start event here because it's already triggered in `NeedBrowseUsersPerm`
    (0, $elP2D.useExpTrackerStop)({
        name: (0, $iNIpe.UserExperienceNames).USER_PROFILE_USERS_TEAMS,
        error: ApolloError
    });
    const createProposedMember = (0, $eUqFw.useCallback)(()=>props.userFullName ? [
            {
                id: props.userId,
                value: props.userId,
                label: props.userFullName,
                avatarUrl: props.userAvatarUrl,
                type: 'user'
            }
        ] : [], [
        props.userAvatarUrl,
        props.userFullName,
        props.userId
    ]);
    const handleTeamItemClick = (0, $eUqFw.useCallback)((e, index)=>{
        analytics.pushUIEvent({
            source: (0, $1io2n.AnalyticsEventSource)[props.analyticsSource] || (0, $1io2n.AnalyticsEventSource).USER_PROFILE_SCREEN,
            action: (0, $1io2n.AnalyticsEventActions).CLICKED,
            actionSubject: 'teamProfileItem',
            attributes: {
                position: index
            }
        });
    }, [
        analytics,
        props.analyticsSource
    ]);
    const isCurrentUser = ()=>currentUserId === props.userId;
    // loading --> skeleton and do not render ExperienceSuccess
    // not loading + empty data + viewing others profile --> rendering nothing and ExperienceSuccess
    // not loading + has error --> rendering nothing and "useExpTrackerStop" will trigger the stop experience event.
    // not loading + has data --> render UI and ExperienceSuccess
    const hasNoData = !teamSearchTeams;
    if (hasNoData) return null;
    if (ApolloError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dth5h.AboutSectionTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $592d05b683f3d6cb$export$defe85febe8b728c.teamSectionTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bxeZb.ErrorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bxeZb.ErrorIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gw74N))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        color: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`,
        label: $592d05b683f3d6cb$export$defe85febe8b728c.errorStateTitle.defaultMessage
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bxeZb.ErrorMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bxeZb.ErrorTitle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $592d05b683f3d6cb$export$defe85febe8b728c.errorStateTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bxeZb.ErrorMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $592d05b683f3d6cb$export$defe85febe8b728c.errorStateMessage)))));
    const onShowMoreButtonClick = ()=>{
        analytics.pushUIEvent({
            source: (0, $1io2n.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'showMore',
            action: (0, $1io2n.AnalyticsEventActions).CLICKED
        });
        setEnableInfiniteScroll(true);
        setShowLess(false);
    };
    const collapseTeamList = ()=>{
        if (!enableInfiniteScroll) setEnableInfiniteScroll(true);
        setShowLess(!showLess);
    };
    const teamList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XuTO.default), {
        loadMore: loadMore,
        hasMore: hasMore && enableInfiniteScroll,
        loader: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cAuBo.default), null),
        isLoading: isTeamSearchLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, showLess ? teamSearchTeams.slice(0, $592d05b683f3d6cb$export$4a2947f47d583741).map((team, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ftQay.default), {
            key: team.id,
            team: team,
            isCurrentUser: isCurrentUser(),
            index: index,
            onClick: handleTeamItemClick
        })) : teamSearchTeams.map((team, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ftQay.default), {
            key: team.id,
            team: team,
            isCurrentUser: isCurrentUser(),
            index: index,
            onClick: handleTeamItemClick
        })), !enableInfiniteScroll && teamSearchTeams.length > $592d05b683f3d6cb$export$4a2947f47d583741 && (hasMore || !hasMore && showLess) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bxeZb.ShowMoreButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        onClick: onShowMoreButtonClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $592d05b683f3d6cb$export$defe85febe8b728c.showMore))), enableInfiniteScroll && !hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bxeZb.ShowMoreButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        onClick: collapseTeamList
    }, showLess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $592d05b683f3d6cb$export$defe85febe8b728c.showMore) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $592d05b683f3d6cb$export$defe85febe8b728c.showLess)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dth5h.AboutSectionTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $592d05b683f3d6cb$export$defe85febe8b728c.teamSectionTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bxeZb.AboutTeamsList, null, hasUserDataLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $88bBf.default), {
        source: "teamsList",
        isCurrentUser: isCurrentUser(),
        proposedMembers: isCurrentUser() ? [] : createProposedMember(),
        isActiveUser: props.isActiveUser
    }), isTeamSearchLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZUSO.default), {
        hasAvatar: true,
        isShimmering: true,
        cssFn: ()=>({
                paddingLeft: 0,
                paddingRight: 0
            }),
        itemCount: 3
    }) : teamList), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2lryl.ExperienceSuccess), {
        hasLoaded: !isTeamSearchLoading && !ApolloError,
        name: (0, $iNIpe.UserExperienceNames).USER_PROFILE_USERS_TEAMS
    }));
}
const $592d05b683f3d6cb$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    teamSectionTitle: {
        id: 'ptc-directory.user-profile-page.about.teams.heading',
        defaultMessage: 'Teams',
        description: 'Heading for the teams that user is a member of'
    },
    showMore: {
        id: 'ptc-directory.user-profile-page.about.teams.show.more.button',
        defaultMessage: 'Show more',
        description: 'Text for the show more button'
    },
    showLess: {
        id: 'ptc-directory.user-profile-page.about.teams.show.less.button',
        defaultMessage: 'Show less',
        description: 'Text for the show less button'
    },
    errorStateTitle: {
        id: 'ptc-directory.user-profile-page.about.teams.error.title',
        defaultMessage: 'Something went wrong',
        description: 'Error title for when teams fail to load'
    },
    errorStateMessage: {
        id: 'ptc-directory.user-profile-page.about.teams.error.message',
        defaultMessage: 'Refresh the page or try again later',
        description: 'Error instruction for when teams fail to load'
    }
});
var $592d05b683f3d6cb$export$2e2bcd8739ae039 = $592d05b683f3d6cb$export$2697725d6b507e8c;

});
parcelRegister("lEcQZ", function(module, exports) {

$parcel$export(module.exports, "useTeamSearchQuery", () => $1b1e715b7adef5fb$export$209c3a9213f9e947);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $k7WCG = parcelRequire("k7WCG");
var $712kr = parcelRequire("712kr");
var $6XUHL = parcelRequire("6XUHL");
var $2sEko = parcelRequire("2sEko");
var $47tex = parcelRequire("47tex");

var $kPKKc = parcelRequire("kPKKc");

var $avLBj = parcelRequire("avLBj");

var $kuWTY = parcelRequire("kuWTY");

var $9AsMF = parcelRequire("9AsMF");

var $jB1nz = parcelRequire("jB1nz");

var $j9wA1 = parcelRequire("j9wA1");
const $1b1e715b7adef5fb$var$QueryErrorToApolloError = (error)=>{
    return new (0, $9AsMF.ApolloError)(error.message, error.graphQLErrors, error.networkError ?? null, error.extensions);
};
const $1b1e715b7adef5fb$var$excludeKnownGraphQLErrors = (error)=>{
    const mappedError = error instanceof (0, $kPKKc.UseQueryLightError) ? $1b1e715b7adef5fb$var$QueryErrorToApolloError(error) : error;
    if (mappedError.message === 'GraphQL error: User does not have access to the org') // Escapes from this error as discussed in https://atlassian.slack.com/archives/C04939SL1J5/p1675215336793559
    return undefined;
    else if (mappedError.graphQLErrors) {
        const filteredError = {
            ...mappedError,
            // TODO PR Question - Is duplicating an error via spreading OK? (Not really an "Error" after that)
            graphQLErrors: (0, $j9wA1.filterExcludedMessages)(mappedError.graphQLErrors)
        };
        // If there's no actual errors left, then discard the error object
        const noErrorsLeft = filteredError.networkError == null && filteredError.graphQLErrors.length === 0;
        return noErrorsLeft ? undefined : filteredError;
    }
    return mappedError;
};
function $1b1e715b7adef5fb$var$orgIdWithARI(orgId) {
    return orgId?.startsWith((0, $j9wA1.ORG_ARI_PREFIX)) ? orgId : `${0, $j9wA1.ORG_ARI_PREFIX}${orgId}`;
}
const $1b1e715b7adef5fb$export$209c3a9213f9e947 = (props)=>{
    const { cursor: cursor, first: first, memberIds: memberIds, query: query, batchSize: batchSize, skip: providedSkip } = props;
    const { orgId: orgId } = (0, $47tex.useV3OrgIdStatus)();
    const [exitedTeams] = (0, $712kr.useExitedTeams)();
    const { isLoading: isTeamsVisibilityLoading, permissions: { canViewTeams: canViewTeams } } = (0, $2sEko.useTeamVisibility)();
    const [{ cloudId: cloudId }] = (0, $6XUHL.useSite)();
    const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, $jB1nz.useQueryWrapper)((0, $kuWTY.default), {
        client: (0, $k7WCG.getGatewayClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'team-members-beta',
                'atl-client-name': "platform-pkg",
                'atl-client-version': "0.0.0-use.local"
            }
        },
        operationName: 'TeamSearchV2',
        serviceUrl: `${(0, $avLBj.getConfig)().stargateRoot}/graphql`,
        variables: {
            first: first,
            memberIds: memberIds,
            query: query,
            organizationId: $1b1e715b7adef5fb$var$orgIdWithARI(orgId),
            after: cursor,
            sortBy: query ? null : (0, $9AsMF.sortBy),
            siteId: cloudId,
            showEmptyTeams: true
        },
        skip: providedSkip || !orgId || /**
     * Don't make the call when
     * 1. the permissions are currently loading
     * 2. the permissions have loaded but the user doesn't have permission to view teams
     */ !canViewTeams || isTeamsVisibilityLoading
    }, (0, $XHGTv.fg)('enable_teams_graphql_migration'));
    const filteredError = error && $1b1e715b7adef5fb$var$excludeKnownGraphQLErrors(error);
    const formattedTeams = (0, $eUqFw.useMemo)(()=>{
        if (!data?.team || filteredError) // GraphQL queries can have a partial failure, where some data is returned
        // but not all of it. By default, Apollo will discard any partial data if
        // there's an error:
        // https://www.apollographql.com/docs/react/data/error-handling/#partial-data-with-resolver-errors
        //
        // In PTC-6588, we wanted to be able to support partial data for the case
        // where a team has been deleted, so we set the error policy to 'all'.
        // Otherwise, the whole page fails to load because of one bad team.
        // However, most of the app wasn't written to handle partial data, so if
        // there are any errors, we return nothing.
        return [];
        return (0, $j9wA1.fromV2ToTeamSearchViewFormat)(data.team?.teamSearch?.nodes || []);
    }, [
        data,
        filteredError
    ]);
    const loadMore = ()=>{
        fetchMore({
            variables: {
                after: data?.team?.teamSearch?.pageInfo?.endCursor,
                first: batchSize || first
            },
            handleDataMerge: (prevResult, fetchMoreResult)=>{
                if (!fetchMoreResult) return prevResult;
                const prevTeams = prevResult?.team?.teamSearch?.nodes || [];
                const newTeams = fetchMoreResult?.team?.teamSearch?.nodes || [];
                return {
                    ...fetchMoreResult,
                    team: {
                        ...fetchMoreResult.team,
                        teamSearch: {
                            ...fetchMoreResult.team?.teamSearch,
                            nodes: [
                                ...prevTeams,
                                ...newTeams
                            ]
                        }
                    }
                };
            }
        });
    };
    const filteredTeams = (0, $eUqFw.useMemo)(()=>formattedTeams.filter((team)=>!exitedTeams.has(team.id)), [
        formattedTeams,
        exitedTeams
    ]);
    return {
        isLoading: loading,
        teams: filteredTeams,
        error: filteredError,
        loadMore: loadMore,
        hasMore: !!data?.team?.teamSearch?.pageInfo?.hasNextPage
    };
};

});
parcelRegister("712kr", function(module, exports) {

$parcel$export(module.exports, "useTeamProfileDataState", () => $a61297d1e938cd50$export$1983fe04e6d15665);
$parcel$export(module.exports, "useTeamMembersState", () => $a61297d1e938cd50$export$c90591c2030bee);
$parcel$export(module.exports, "useMyMembership", () => $a61297d1e938cd50$export$7d96b11823e54583);
$parcel$export(module.exports, "useExitedTeams", () => $a61297d1e938cd50$export$d85ae427dffd7a31);
$parcel$export(module.exports, "useTeamHealthState", () => $a61297d1e938cd50$export$cb6078fc91fe0c8c);
$parcel$export(module.exports, "useTeamAgentsState", () => $a61297d1e938cd50$export$80fb38915e92c27f);

var $WBLbN = parcelRequire("WBLbN");

var $cAxhS = parcelRequire("cAxhS");

var $90LXS = parcelRequire("90LXS");
var $i9eWv = parcelRequire("i9eWv");
var $i77Uo = parcelRequire("i77Uo");
var $jTquG = parcelRequire("jTquG");
var $dKvFG = parcelRequire("dKvFG");
var $hPwM7 = parcelRequire("hPwM7");
var $eFLV5 = parcelRequire("eFLV5");
var $5eQdo = parcelRequire("5eQdo");
var $bWsO5 = parcelRequire("bWsO5");
var $1iS3l = parcelRequire("1iS3l");

var $iCFlr = parcelRequire("iCFlr");
const $a61297d1e938cd50$var$initialState = {
    teamProfile: {
        teamId: '',
        isLoading: true,
        hasLoaded: false,
        errorType: null,
        data: {}
    },
    teamHealth: {
        teamId: '',
        isLoading: true,
        hasLoaded: false,
        errorType: null,
        data: []
    },
    teamMembers: {
        teamId: '',
        isLoading: true,
        isLoadingNextPage: false,
        hasLoaded: false,
        hasError: false,
        errorType: null,
        members: [],
        requestingToJoinUsers: [],
        membersPageInfo: {
            hasNextPage: false,
            cursor: null
        },
        requestingToJoinUsersPageInfo: {
            hasNextPage: false,
            cursor: null
        }
    },
    teamAgents: {
        teamId: '',
        isLoading: true,
        isLoadingNextPage: false,
        hasLoaded: false,
        hasError: false,
        errorType: null,
        members: []
    },
    myTeamMembership: {
        teamId: '',
        hasLoaded: false,
        membership: undefined
    },
    exitedTeams: new Set(),
    allTeamsData: {
        teams: [],
        isLoading: true,
        hasError: false,
        cursor: ''
    }
};
const $a61297d1e938cd50$var$actions = {
    /**
	 * @deprecated set the config on the teamsClient using useTeamsClientSetup
	 */ setTeamClientRootUrl: (rootUrl)=>()=>{
            (0, $cAxhS.teamsClient).setLegionRootUrl(rootUrl);
        },
    collectTeamData: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
            // If we already have the team's data, do not collect it again
            if (getState().teamProfile.teamId === teamId) return;
            await Promise.all([
                dispatch((0, $eFLV5.getTeamProfile)(teamId)),
                dispatch((0, $jTquG.getMyTeamMembership)(teamId)),
                dispatch((0, $hPwM7.getTeamMembers)(teamId)),
                dispatch((0, $dKvFG.getTeamHealth)(teamId))
            ]);
            dispatch((0, $i77Uo.getRequestingToJoinUsers)(teamId));
        },
    restoreTeam: (teamId, options)=>async ({ dispatch: dispatch })=>{
            await (0, $cAxhS.teamsClient).restoreTeam(teamId);
            if (options?.fetchTeamData) await Promise.all([
                dispatch((0, $eFLV5.getTeamProfile)(teamId)),
                dispatch((0, $jTquG.getMyTeamMembership)(teamId)),
                dispatch((0, $hPwM7.getTeamMembers)(teamId)),
                dispatch((0, $dKvFG.getTeamHealth)(teamId))
            ]);
        },
    fetchTeamMembersNextPage: (teamId, count = 100)=>async ({ dispatch: dispatch, getState: getState })=>{
            if (!getState().teamMembers.membersPageInfo.hasNextPage) return;
            await dispatch((0, $hPwM7.getTeamMembers)(teamId, true, count));
        },
    refreshRequestingToJoinUsers: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
            // Check that we're refreshing data for the current team
            if (getState().teamProfile.teamId !== teamId) return [];
            return await dispatch((0, $i77Uo.getRequestingToJoinUsers)(teamId));
        },
    prefillTeamData: $bWsO5.prefillTeamData,
    updateTeamProfile: (teamId, data)=>async ({ dispatch: dispatch, getState: getState, setState: setState })=>{
            const isTransitioningToOpen = data.membershipSettings === 'OPEN' && getState().teamProfile.data.membershipSettings === 'MEMBER_INVITE';
            const response = await (0, $cAxhS.teamsClient).updateTeamById(teamId, data);
            setState({
                teamProfile: {
                    ...getState().teamProfile,
                    data: response
                }
            });
            if (isTransitioningToOpen) dispatch((0, $hPwM7.getTeamMembers)(teamId));
            return response;
        },
    acceptAllJoinRequests: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
            const requests = getState().teamMembers.requestingToJoinUsers;
            await Promise.all(requests.map((request)=>{
                return dispatch((0, $i9eWv.approveJoinRequest)(teamId, request.membershipId.memberId, request.user));
            }));
        },
    declineAllJoinRequests: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
            const requests = getState().teamMembers.requestingToJoinUsers;
            await Promise.all(requests.map((request)=>{
                return dispatch((0, $i77Uo.declineJoinRequest)(teamId, request.membershipId.memberId));
            }));
        },
    removeTeamMember: // Throws if we cannot remove the member
    $1iS3l.removeTeamMember,
    revokeTeamInvite: (teamId, memberId)=>async ({ getState: getState, setState: setState })=>{
            const { teamMembers: { teamId: currentTeamId } } = getState();
            const removedInvite = await (0, $cAxhS.teamsClient).revokeTeamInvite(teamId, memberId);
            if (removedInvite && removedInvite.state !== 'ALUMNI') throw Error('Invite claims to be cancelled but was not');
            if (currentTeamId !== teamId) return;
            setState({
                teamMembers: {
                    ...getState().teamMembers,
                    members: getState().teamMembers.members.filter((member)=>!!member.user && member.user.id !== memberId)
                }
            });
        },
    joinTeam: // Throws if teamsClient.selfJoinTeam throws
    $90LXS.joinTeam,
    // Throws if teamsClient.cancelJoinRequest throws
    cancelJoinRequest: (teamId)=>async ({ getState: getState, setState: setState })=>{
            const { teamProfile: { teamId: currentTeamId } } = getState();
            await (0, $cAxhS.teamsClient).cancelJoinRequest(teamId);
            const state = getState();
            if (currentTeamId !== teamId) return;
            setState({
                ...state,
                myTeamMembership: {
                    teamId: teamId,
                    hasLoaded: true,
                    membership: undefined
                }
            });
        },
    acceptTeamInvitation: // Throws if teamsClient.acceptTeamInvitation throws
    $90LXS.acceptTeamInvitation,
    // Throws if teamsClient.declineTeamInvitation throws
    declineTeamInvitation: (teamId)=>async ({ getState: getState })=>{
            const { exitedTeams: exitedTeams } = getState();
            await (0, $cAxhS.teamsClient).declineTeamInvitation(teamId);
            exitedTeams.add(teamId);
        // No need to re-fetch, when an invite is declined we navigate away
        },
    inviteUsersToTeam: // Throws if teamsClient.inviteUsersToTeam or publicApiClient.addUsersToTeam throws
    $5eQdo.inviteUsersToTeam,
    approveJoinRequest: // Throws if teamsClient.approveJoinRequest throws
    $i9eWv.approveJoinRequest,
    declineJoinRequest: // Throws if teamsClient.declineJoinRequest throws
    $i77Uo.declineJoinRequest,
    // Throws if teamsClient.deleteTeam throws
    deleteTeam: (teamId)=>async ({ getState: getState, setState: setState })=>{
            const { exitedTeams: exitedTeams } = getState();
            await (0, $cAxhS.teamsClient).deleteTeam(teamId);
            setState({
                teamProfile: $a61297d1e938cd50$var$initialState.teamProfile,
                teamMembers: $a61297d1e938cd50$var$initialState.teamMembers,
                myTeamMembership: $a61297d1e938cd50$var$initialState.myTeamMembership,
                teamHealth: $a61297d1e938cd50$var$initialState.teamHealth
            });
            exitedTeams.add(teamId);
        },
    getAllTeams: (allTeamsQuery, keepExistingData)=>async ({ dispatch: dispatch })=>{
            await dispatch((0, $iCFlr.default)(allTeamsQuery, keepExistingData));
        },
    refreshTeamHealthMonitors: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
            // Check that we're refreshing data for the current team
            if (getState().teamProfile.teamId !== teamId) return Promise.reject(`${teamId} is not the current team`);
            return await dispatch((0, $dKvFG.getTeamHealth)(teamId));
        }
};
const $a61297d1e938cd50$var$TeamStore = (0, $WBLbN.createStore)({
    initialState: $a61297d1e938cd50$var$initialState,
    actions: $a61297d1e938cd50$var$actions
});
const $a61297d1e938cd50$export$1983fe04e6d15665 = (0, $WBLbN.createHook)($a61297d1e938cd50$var$TeamStore, {
    selector: (state)=>state.teamProfile
});
const $a61297d1e938cd50$export$c90591c2030bee = (0, $WBLbN.createHook)($a61297d1e938cd50$var$TeamStore, {
    selector: (state)=>state.teamMembers
});
const $a61297d1e938cd50$export$7d96b11823e54583 = (0, $WBLbN.createHook)($a61297d1e938cd50$var$TeamStore, {
    selector: (state)=>state.myTeamMembership
});
const $a61297d1e938cd50$export$d85ae427dffd7a31 = (0, $WBLbN.createHook)($a61297d1e938cd50$var$TeamStore, {
    selector: (state)=>state.exitedTeams
});
const $a61297d1e938cd50$export$a50a7dc1b87fcc7 = (0, $WBLbN.createHook)($a61297d1e938cd50$var$TeamStore, {
    selector: (state)=>state.allTeamsData
});
const $a61297d1e938cd50$export$cb6078fc91fe0c8c = (0, $WBLbN.createHook)($a61297d1e938cd50$var$TeamStore, {
    selector: (state)=>state.teamHealth
});
const $a61297d1e938cd50$export$80fb38915e92c27f = (0, $WBLbN.createHook)($a61297d1e938cd50$var$TeamStore, {
    selector: (state)=>state.teamAgents
});

});
parcelRegister("90LXS", function(module, exports) {

$parcel$export(module.exports, "joinTeam", () => $ac6e1a22c33a931a$export$47f143084f31963c);
$parcel$export(module.exports, "acceptTeamInvitation", () => $ac6e1a22c33a931a$export$a0ce1bbc3e3f2e4d);

var $cAxhS = parcelRequire("cAxhS");

var $i77Uo = parcelRequire("i77Uo");

var $2gD0d = parcelRequire("2gD0d");
const $ac6e1a22c33a931a$export$e4da98dc943d58c8 = (teamId, member)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        if (state.teamProfile.teamId !== teamId) return;
        const nextState = (0, $2gD0d.joinTeamState)(state, member);
        setState(nextState);
    };
const $ac6e1a22c33a931a$export$47f143084f31963c = (teamId, originQuery, user)=>async ({ dispatch: dispatch })=>{
        const response = await (0, $cAxhS.teamsClient).selfJoinTeam(teamId, originQuery);
        const newMembership = {
            ...response,
            user: user
        };
        dispatch($ac6e1a22c33a931a$export$e4da98dc943d58c8(teamId, newMembership));
        return response;
    };
const $ac6e1a22c33a931a$export$a0ce1bbc3e3f2e4d = (teamId, currentUserId)=>async ({ dispatch: dispatch, getState: getState })=>{
        const response = await (0, $cAxhS.teamsClient).acceptTeamInvitation(teamId);
        const existingUser = getState().teamMembers.members.find((member)=>member.membershipId.memberId === currentUserId);
        // This membership MUST exist for the user to be able to call this function,
        // and `user` will be defined as this membership comes from the directory.
        if (!existingUser || !existingUser.user) return;
        const newMembership = {
            ...response,
            user: existingUser.user
        };
        dispatch($ac6e1a22c33a931a$export$e4da98dc943d58c8(teamId, newMembership));
        // Don't await this, let them load afterwards
        dispatch((0, $i77Uo.getRequestingToJoinUsers)(teamId));
    };

});
parcelRegister("i77Uo", function(module, exports) {

$parcel$export(module.exports, "getRequestingToJoinUsers", () => $dcfb9bcf1e2f8e55$export$eb1265581ad35874);
$parcel$export(module.exports, "declineJoinRequest", () => $dcfb9bcf1e2f8e55$export$d71ce2a87bc937b0);

var $7HVx0 = parcelRequire("7HVx0");
var $cAxhS = parcelRequire("cAxhS");

var $19IXw = parcelRequire("19IXw");

var $chxpa = parcelRequire("chxpa");
const $dcfb9bcf1e2f8e55$export$eb1265581ad35874 = (teamId)=>async ({ getState: getState, setState: setState })=>{
        const initialState = getState();
        const isOpenTeam = initialState.teamProfile.data.membershipSettings === 'OPEN';
        const membershipErrors = initialState.teamMembers.hasError;
        const hasPermissionToViewRequestingUsers = initialState.teamProfile.data.permission === 'FULL_WRITE';
        const teamChanged = initialState.teamMembers.teamId !== teamId;
        if (teamChanged || !hasPermissionToViewRequestingUsers || membershipErrors || isOpenTeam) return [];
        try {
            const requestingUsersResponse = await (0, $cAxhS.teamsClient).queryTeamMemberships(teamId, [
                'REQUESTING_TO_JOIN'
            ], {
                first: 100,
                after: initialState.teamMembers.requestingToJoinUsersPageInfo.cursor ?? undefined
            });
            const requestingUsers = (0, $19IXw.isResultWithPageInfo)(requestingUsersResponse) ? requestingUsersResponse.edges : requestingUsersResponse;
            const state = getState();
            if (state.teamMembers.teamId !== teamId) return [];
            const sortedRequesters = (0, $7HVx0.sortMembersByType)(requestingUsers);
            setState({
                teamMembers: {
                    ...state.teamMembers,
                    requestingToJoinUsers: sortedRequesters
                }
            });
            return sortedRequesters;
        } catch (err) {
            (0, $chxpa.logException)(err, 'Could not load requesting-to-join users');
            return [];
        }
    };
const $dcfb9bcf1e2f8e55$export$d71ce2a87bc937b0 = (teamId, memberId)=>async ({ getState: getState, setState: setState })=>{
        await (0, $cAxhS.teamsClient).declineJoinRequest(teamId, memberId);
        const state = getState();
        if (state.teamMembers.teamId !== teamId) return;
        setState({
            ...state,
            teamMembers: {
                ...state.teamMembers,
                requestingToJoinUsers: state.teamMembers.requestingToJoinUsers.filter((user)=>user.membershipId.memberId !== memberId)
            }
        });
    };

});
parcelRegister("7HVx0", function(module, exports) {

$parcel$export(module.exports, "sortMembersByType", () => $5e3d05be034d8fbf$export$90b27c15351f4a21);
var $5e3d05be034d8fbf$var$MemberType;
(function(MemberType) {
    MemberType[MemberType["CURRENT_USER"] = 0] = "CURRENT_USER";
    MemberType[MemberType["MEMBER"] = 1] = "MEMBER";
    MemberType[MemberType["INVITED"] = 2] = "INVITED";
    MemberType[MemberType["INACTIVE"] = 3] = "INACTIVE";
    MemberType[MemberType["DELETED"] = 4] = "DELETED";
})($5e3d05be034d8fbf$var$MemberType || ($5e3d05be034d8fbf$var$MemberType = {}));
const $5e3d05be034d8fbf$var$checkType = (member, currentAccountId)=>{
    if (member.membershipId.memberId === currentAccountId) return 0;
    else if (member && member.state === 'INVITED') return 2;
    else if (member.user?.status === 'inactive') return 3;
    else if (member.user?.status === 'closed') return 4;
    else return 1;
};
const $5e3d05be034d8fbf$export$90b27c15351f4a21 = (members, currentAccountId)=>{
    const newMembers = members.map((member)=>({
            member: member,
            type: $5e3d05be034d8fbf$var$checkType(member, currentAccountId)
        }));
    newMembers.sort(({ member: memberA, type: typeA }, { member: memberB, type: typeB })=>{
        if (typeA === typeB) return memberA.user?.fullName.localeCompare(memberB.user?.fullName || '') || 0;
        else return typeA - typeB;
    });
    return newMembers.map(({ member: member })=>member);
};

});

parcelRegister("19IXw", function(module, exports) {

$parcel$export(module.exports, "isResultWithPageInfo", () => $3ab83c802a97bcd3$export$7fb758c207c3ab4b);
function $3ab83c802a97bcd3$export$7fb758c207c3ab4b(result) {
    return result.pageInfo !== undefined;
}

});


parcelRegister("2gD0d", function(module, exports) {

$parcel$export(module.exports, "joinTeamState", () => $831191bfb334da9d$export$6842649be21ecf13);

var $7HVx0 = parcelRequire("7HVx0");
const $831191bfb334da9d$export$6842649be21ecf13 = (teamState, newMembership)=>{
    const { exitedTeams: exitedTeams, teamMembers: teamMembers, teamProfile: teamProfile } = teamState;
    const requestingToJoin = newMembership.state === 'REQUESTING_TO_JOIN';
    const teamId = newMembership.membershipId.teamId;
    if (requestingToJoin) return {
        ...teamState,
        myTeamMembership: {
            teamId: teamId,
            hasLoaded: true,
            membership: newMembership
        }
    };
    // If we're joining this team, remove it from the set of exited teams
    exitedTeams.delete(teamId);
    const currentUserId = newMembership.membershipId.memberId;
    const newMembers = teamMembers.members.filter((membership)=>{
        return membership.membershipId.memberId !== currentUserId;
    }).concat(newMembership);
    return {
        ...teamState,
        teamProfile: {
            teamId: teamId,
            hasLoaded: true,
            isLoading: false,
            errorType: null,
            data: {
                ...teamProfile.data,
                permission: 'FULL_WRITE'
            }
        },
        teamMembers: {
            teamId: teamId,
            hasLoaded: true,
            hasError: false,
            isLoading: false,
            isLoadingNextPage: false,
            errorType: null,
            members: (0, $7HVx0.sortMembersByType)(newMembers, currentUserId),
            requestingToJoinUsers: teamMembers.requestingToJoinUsers,
            membersPageInfo: teamMembers.membersPageInfo,
            requestingToJoinUsersPageInfo: {
                hasNextPage: false,
                cursor: null
            }
        },
        myTeamMembership: {
            teamId: teamId,
            hasLoaded: true,
            membership: newMembership
        }
    };
};

});


parcelRegister("i9eWv", function(module, exports) {

$parcel$export(module.exports, "approveJoinRequest", () => $8f86875f6887b8e6$export$a355add01c2f52a3);

var $7HVx0 = parcelRequire("7HVx0");
var $cAxhS = parcelRequire("cAxhS");
const $8f86875f6887b8e6$export$a355add01c2f52a3 = (teamId, memberId, user)=>async ({ getState: getState, setState: setState })=>{
        const membership = await (0, $cAxhS.teamsClient).acceptJoinRequest(teamId, memberId);
        const state = getState();
        const { myTeamMembership: myTeamMembership, teamMembers: teamMembers, teamProfile: { teamId: currentTeamId } } = state;
        if (currentTeamId !== teamId || membership.state !== 'FULL_MEMBER') return;
        const newMembership = {
            ...membership,
            user: user
        };
        const newMembers = teamMembers.members.filter((membership)=>{
            return membership.membershipId.memberId !== memberId;
        }).concat(newMembership);
        const myMembership = myTeamMembership.membership;
        setState({
            ...state,
            teamMembers: {
                teamId: teamId,
                hasLoaded: true,
                isLoadingNextPage: false,
                hasError: false,
                isLoading: false,
                errorType: null,
                membersPageInfo: teamMembers.membersPageInfo,
                requestingToJoinUsersPageInfo: teamMembers.requestingToJoinUsersPageInfo,
                members: (0, $7HVx0.sortMembersByType)(newMembers, myMembership?.membershipId.memberId),
                requestingToJoinUsers: teamMembers.requestingToJoinUsers.filter((user)=>user.membershipId.memberId !== memberId)
            }
        });
    };

});

parcelRegister("jTquG", function(module, exports) {

$parcel$export(module.exports, "getMyTeamMembership", () => $395c8f5e10aa531f$export$72e6f466f46f9da0);

var $7HVx0 = parcelRequire("7HVx0");
var $cAxhS = parcelRequire("cAxhS");

var $jz9bg = parcelRequire("jz9bg");
const $395c8f5e10aa531f$export$72e6f466f46f9da0 = (teamId, keepExistingData)=>async ({ getState: getState, setState: setState })=>{
        if (!keepExistingData) setState({
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: false,
                membership: undefined
            }
        });
        const { myTeamMembership: myTeamMembership } = getState();
        if (myTeamMembership.teamId !== teamId) return;
        const { value: membership } = await (0, $jz9bg.promiseWithDefault)((0, $cAxhS.teamsClient).getMyTeamMembership(teamId), undefined);
        const { teamMembers: teamMembers } = getState();
        const members = teamMembers.members;
        const sortedMembers = members.length > 0 && !!membership ? {
            teamMembers: {
                ...teamMembers,
                members: (0, $7HVx0.sortMembersByType)(members, membership.membershipId.memberId)
            }
        } : {};
        setState({
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: true,
                membership: membership
            },
            ...sortedMembers
        });
    };

});
parcelRegister("jz9bg", function(module, exports) {

$parcel$export(module.exports, "promiseWithDefault", () => $b245cb500a733aaa$export$a970b469503acdc8);
function $b245cb500a733aaa$export$a970b469503acdc8(promise, defaultValue) {
    return promise.then((value)=>({
            value: value,
            success: true
        })).catch(()=>({
            value: defaultValue,
            success: false
        }));
}

});


parcelRegister("dKvFG", function(module, exports) {

$parcel$export(module.exports, "getTeamHealth", () => $0753bcf442352c38$export$d45598c76c9fc303);

var $8tM2T = parcelRequire("8tM2T");

var $cAxhS = parcelRequire("cAxhS");

var $avLBj = parcelRequire("avLBj");
const $0753bcf442352c38$export$d45598c76c9fc303 = (teamId)=>async ({ setState: setState })=>{
        if ((0, $8tM2T.default).initializeCompleted() && !(0, $8tM2T.default).checkGate('enable_atlas_team_health_monitor') || (0, $avLBj.isFedramp)()) return;
        setState({
            teamHealth: {
                teamId: teamId,
                isLoading: true,
                hasLoaded: false,
                errorType: null,
                data: []
            }
        });
        try {
            const monitors = await (0, $cAxhS.teamsClient).queryTeamHealthMonitors(teamId);
            setState({
                teamHealth: {
                    teamId: teamId,
                    isLoading: false,
                    hasLoaded: true,
                    errorType: null,
                    data: monitors
                }
            });
        } catch (e) {
            setState({
                teamHealth: {
                    teamId: teamId,
                    isLoading: false,
                    hasLoaded: true,
                    errorType: e,
                    data: []
                }
            });
        }
    };

});

parcelRegister("hPwM7", function(module, exports) {

$parcel$export(module.exports, "getTeamMembers", () => $d9db36f7fdb50ed5$export$e662071d38e352a1);

var $XHGTv = parcelRequire("XHGTv");

var $7HVx0 = parcelRequire("7HVx0");
var $cAxhS = parcelRequire("cAxhS");

var $19IXw = parcelRequire("19IXw");
const $d9db36f7fdb50ed5$var$combineIn = (existing, newData)=>{
    const addedMemberIds = new Set(newData.map((member)=>member.membershipId.memberId));
    return existing.filter((member)=>!addedMemberIds.has(member.membershipId.memberId)).concat(newData);
};
const $d9db36f7fdb50ed5$export$e662071d38e352a1 = (teamId, keepExistingData, first = 100)=>async ({ getState: getState, setState: setState })=>{
        if (!keepExistingData) setState({
            teamMembers: {
                teamId: teamId,
                isLoading: true,
                isLoadingNextPage: false,
                hasLoaded: false,
                hasError: false,
                errorType: null,
                members: [],
                requestingToJoinUsers: [],
                membersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                },
                requestingToJoinUsersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                }
            },
            teamAgents: {
                teamId: teamId,
                isLoading: true,
                isLoadingNextPage: false,
                hasLoaded: false,
                hasError: false,
                errorType: null,
                members: []
            }
        });
        const { teamMembers: teamMembers } = getState();
        if (teamMembers.teamId !== teamId) return;
        setState({
            teamMembers: {
                ...teamMembers,
                isLoadingNextPage: true
            },
            teamAgents: {
                ...teamMembers
            }
        });
        try {
            const membershipsResponse = await (0, $cAxhS.teamsClient).queryTeamMemberships(teamId, [
                'FULL_MEMBER'
            ], {
                first: first,
                after: teamMembers.membersPageInfo.cursor ?? undefined
            });
            const memberships = (0, $19IXw.isResultWithPageInfo)(membershipsResponse) ? membershipsResponse.edges : membershipsResponse;
            const pageInfo = (0, $19IXw.isResultWithPageInfo)(membershipsResponse) ? membershipsResponse.pageInfo : {
                hasNextPage: false,
                endCursor: null
            };
            const myMembership = getState().myTeamMembership.membership;
            const myAccountId = myMembership?.membershipId.memberId;
            const membershipsWithExisting = keepExistingData ? $d9db36f7fdb50ed5$var$combineIn(teamMembers.members, memberships) : memberships;
            const sortedMembers = (0, $7HVx0.sortMembersByType)(membershipsWithExisting, myAccountId);
            const membersWithoutAgents = (0, $XHGTv.fg)('enable_teams_for_agents') ? sortedMembers.filter((member)=>!(member.user?.userType === 'agent')) : sortedMembers;
            const agents = sortedMembers.filter((member)=>member.user?.userType === 'agent');
            setState({
                teamMembers: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: false,
                    errorType: null,
                    members: membersWithoutAgents,
                    requestingToJoinUsers: [],
                    requestingToJoinUsersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    },
                    membersPageInfo: {
                        hasNextPage: pageInfo.hasNextPage,
                        cursor: pageInfo.endCursor
                    }
                },
                teamAgents: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: false,
                    errorType: null,
                    members: agents
                }
            });
        } catch (e) {
            if (getState().teamMembers.teamId !== teamId) return;
            setState({
                teamMembers: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: true,
                    errorType: e,
                    members: [],
                    requestingToJoinUsers: [],
                    membersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    },
                    requestingToJoinUsersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    }
                },
                teamAgents: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: true,
                    errorType: e,
                    members: []
                }
            });
        }
    };

});

parcelRegister("eFLV5", function(module, exports) {

$parcel$export(module.exports, "getTeamProfile", () => $89b09e3016cd88b3$export$7a5bb1168a5e8491);

var $cAxhS = parcelRequire("cAxhS");
const $89b09e3016cd88b3$export$7a5bb1168a5e8491 = (teamId)=>async ({ setState: setState })=>{
        setState({
            teamProfile: {
                teamId: teamId,
                isLoading: true,
                hasLoaded: false,
                errorType: null,
                data: {}
            }
        });
        try {
            const team = await (0, $cAxhS.teamsClient).getTeamById(teamId);
            setState({
                teamProfile: {
                    teamId: teamId,
                    isLoading: false,
                    hasLoaded: true,
                    errorType: null,
                    data: team
                }
            });
        } catch (e) {
            setState({
                teamProfile: {
                    teamId: teamId,
                    isLoading: false,
                    hasLoaded: true,
                    errorType: e,
                    data: {}
                }
            });
        }
    };

});

parcelRegister("5eQdo", function(module, exports) {

$parcel$export(module.exports, "inviteUsersToTeam", () => $309dfe524f9beb6a$export$ac31c528ad2c8490);

var $7HVx0 = parcelRequire("7HVx0");
var $cAxhS = parcelRequire("cAxhS");

var $chxpa = parcelRequire("chxpa");

var $9BoRD = parcelRequire("9BoRD");
const $309dfe524f9beb6a$export$d7fb3590d40d5847 = (teamState, newMemberships)=>{
    const { teamMembers: teamMembers } = teamState;
    const memberIds = new Set(newMemberships.map(({ membershipId: membershipId })=>membershipId.memberId));
    const existingMembers = teamMembers.members.filter((member)=>{
        return !memberIds.has(member.membershipId.memberId);
    });
    const currentUserId = teamState.myTeamMembership.membership?.membershipId.memberId;
    const finalMembers = (0, $7HVx0.sortMembersByType)(newMemberships.concat(existingMembers), currentUserId);
    return {
        ...teamState,
        teamMembers: {
            ...teamState.teamMembers,
            teamId: teamState.teamMembers.teamId,
            hasLoaded: true,
            hasError: false,
            isLoading: false,
            errorType: null,
            members: finalMembers
        }
    };
};
const $309dfe524f9beb6a$var$fetchJobTitlesOfNewMembers = (teamId, unpopulatedMembers, originQuery)=>async ({ getState: getState, setState: setState })=>{
        Promise.all(unpopulatedMembers.map((membership)=>{
            return (0, $cAxhS.teamsClient).queryUser(membership.membershipId.memberId, originQuery.cloudId).then(({ CloudUser: CloudUser })=>{
                return {
                    ...membership,
                    user: CloudUser
                };
            });
        })).then((memberships)=>{
            const state = getState();
            // Cancel if the data we fetched is stale
            if (state.teamMembers.teamId !== teamId) return;
            const titles = {};
            for (const member of memberships)titles[member.membershipId.memberId] = member.user.title || undefined;
            setState({
                ...state,
                teamMembers: {
                    ...state.teamMembers,
                    members: state.teamMembers.members.map(// @ts-ignore
                    (member)=>{
                        return {
                            ...member,
                            user: {
                                ...member.user,
                                title: titles[member.membershipId.memberId] || member.user.title
                            }
                        };
                    })
                }
            });
        }).catch((error)=>{
            (0, $chxpa.logException)(error, 'Could not populate new team members with titles');
        });
    };
const $309dfe524f9beb6a$export$ac31c528ad2c8490 = (teamId, members, originQuery)=>async ({ dispatch: dispatch, getState: getState, setState: setState })=>{
        (0, $9BoRD.addNewMembertoTeamSubExp).addMetadata({
            apiVersion: 'v4'
        });
        const addMembershipResponse = await (0, $cAxhS.teamsClient).addUsersToTeam(teamId, members.map((member)=>({
                accountId: member.id
            })));
        const memberships = addMembershipResponse.members.reduce((acc, partial)=>{
            if (!partial.accountId) {
                (0, $chxpa.logInfoMessage)('teamInvitationInvalidResponse', {
                    message: 'Membership in response was invalid',
                    member: partial,
                    response: addMembershipResponse
                });
                return acc;
            }
            const user = members.find((member)=>member.id === partial.accountId);
            if (!user) {
                (0, $chxpa.logInfoMessage)('teamInvitationInvalidResponse', {
                    message: 'Could not find user details for this member',
                    member: partial,
                    response: addMembershipResponse
                });
                return acc;
            }
            acc.push({
                membershipId: {
                    teamId: teamId,
                    memberId: partial.accountId
                },
                // state and role are deprecated in V4, so hard code them here
                state: 'FULL_MEMBER',
                role: 'REGULAR',
                user: {
                    id: user.id,
                    fullName: user.name,
                    avatarUrl: user.avatarUrl,
                    userType: 'user'
                }
            });
            return acc;
        }, []);
        const state = getState();
        // If focused team has changed whilst invite request was resolving, abort.
        if (teamId !== state.teamMembers.teamId) return;
        // Update the state with the new members.
        const nextState = $309dfe524f9beb6a$export$d7fb3590d40d5847(state, memberships);
        setState(nextState);
        // Send request to populate job titles off the main thread.
        const unpopulatedMembers = addMembershipResponse.members.map((member)=>({
                membershipId: {
                    teamId: teamId,
                    memberId: member.accountId
                },
                // state and role are deprecated in V4, so hard code them here
                state: 'FULL_MEMBER',
                role: 'REGULAR'
            }));
        dispatch($309dfe524f9beb6a$var$fetchJobTitlesOfNewMembers(teamId, unpopulatedMembers, originQuery));
        return memberships;
    };

});
parcelRegister("9BoRD", function(module, exports) {

$parcel$export(module.exports, "renderTeamMemberRemoveDialogSubExp", () => $0542d1d2b0b7750b$export$d04a4af02b71bd20);
$parcel$export(module.exports, "removeMemberFromTeamSubExp", () => $0542d1d2b0b7750b$export$8e622ac1f6a9e9f4);
$parcel$export(module.exports, "removeMemberFromTeamExp", () => $0542d1d2b0b7750b$export$ded699d92af3fb9e);
$parcel$export(module.exports, "teamSettingsOverallExp", () => $0542d1d2b0b7750b$export$efd0793305afa76a);
$parcel$export(module.exports, "teamSettingsChangeTeamTypeExp", () => $0542d1d2b0b7750b$export$fba164816385656f);
$parcel$export(module.exports, "renderTeamMemberInviteDialogSubExp", () => $0542d1d2b0b7750b$export$568d3db878ad8d23);
$parcel$export(module.exports, "addNewMembertoTeamSubExp", () => $0542d1d2b0b7750b$export$d691a209050136d6);
$parcel$export(module.exports, "inviteMembersToTeamExperience", () => $0542d1d2b0b7750b$export$2bd703f1fbcc240b);

var $csKSa = parcelRequire("csKSa");

var $12kyE = parcelRequire("12kyE");
var $6coAu = parcelRequire("6coAu");
const $0542d1d2b0b7750b$export$d04a4af02b71bd20 = new (0, $csKSa.TeamsUFOExperience)('render-team-member-remove-dialog', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $0542d1d2b0b7750b$export$8e622ac1f6a9e9f4 = new (0, $csKSa.TeamsUFOExperience)('remove-member-from-team-action', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $0542d1d2b0b7750b$var$removeMemberFromTeamSubExperiences = [
    $0542d1d2b0b7750b$export$d04a4af02b71bd20,
    $0542d1d2b0b7750b$export$8e622ac1f6a9e9f4
];
const $0542d1d2b0b7750b$export$ded699d92af3fb9e = new (0, $csKSa.TeamsUFOExperience)('remove-a-member-from-team', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    platform: {
        component: 'people'
    },
    until: (0, $6coAu.untilAll)($0542d1d2b0b7750b$var$removeMemberFromTeamSubExperiences.map((experience)=>({
            experience: experience
        })))
});
const $0542d1d2b0b7750b$export$efd0793305afa76a = new (0, $csKSa.TeamsUFOExperience)('membership-control-change', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $0542d1d2b0b7750b$export$a7f093db8a7d96e1 = new (0, $csKSa.TeamsUFOExperience)('membership-control-change-handle-requests', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $0542d1d2b0b7750b$export$fba164816385656f = new (0, $csKSa.TeamsUFOExperience)('membership-control-change-change-team-type', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $0542d1d2b0b7750b$export$568d3db878ad8d23 = new (0, $csKSa.TeamsUFOExperience)('render-team-member-invite-dialog', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $0542d1d2b0b7750b$export$d691a209050136d6 = new (0, $csKSa.TeamsUFOExperience)('add-new-member-to-team-action', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $0542d1d2b0b7750b$var$inviteMembersToTeamSubExperiences = [
    $0542d1d2b0b7750b$export$568d3db878ad8d23,
    $0542d1d2b0b7750b$export$d691a209050136d6
];
const $0542d1d2b0b7750b$export$2bd703f1fbcc240b = new (0, $csKSa.TeamsUFOExperience)('invite-members-to-team', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    platform: {
        component: 'people'
    },
    until: (0, $6coAu.untilAll)($0542d1d2b0b7750b$var$inviteMembersToTeamSubExperiences.map((experience)=>({
            experience: experience
        })))
});

});


parcelRegister("bWsO5", function(module, exports) {

$parcel$export(module.exports, "prefillTeamData", () => $f9b5678a86b9107a$export$bc2925813ab9bc57);

var $7HVx0 = parcelRequire("7HVx0");

var $jTquG = parcelRequire("jTquG");

var $hPwM7 = parcelRequire("hPwM7");
const $f9b5678a86b9107a$var$TIMEOUT_DELAY = 5000;
function $f9b5678a86b9107a$var$membershipMaker(teamId) {
    return (user)=>{
        return {
            membershipId: {
                teamId: teamId,
                memberId: user.id
            },
            state: 'FULL_MEMBER',
            role: 'REGULAR',
            user: user
        };
    };
}
const $f9b5678a86b9107a$export$bc2925813ab9bc57 = (teamId, teamData, members, currentUser)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const newState = {
            ...getState(),
            teamProfile: {
                teamId: teamId,
                isLoading: false,
                hasLoaded: true,
                errorType: null,
                data: teamData
            },
            teamMembers: {
                teamId: teamId,
                isLoading: false,
                isLoadingNextPage: false,
                hasLoaded: true,
                hasError: false,
                errorType: null,
                members: (0, $7HVx0.sortMembersByType)(members.map($f9b5678a86b9107a$var$membershipMaker(teamId)), currentUser.id),
                requestingToJoinUsers: [],
                membersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                },
                requestingToJoinUsersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                }
            },
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: true,
                membership: members.some((x)=>x.id === currentUser.id) ? $f9b5678a86b9107a$var$membershipMaker(teamId)(currentUser) : undefined
            }
        };
        setState(newState);
        setTimeout(()=>{
            if (getState().teamProfile.teamId !== teamId) return;
            dispatch((0, $hPwM7.getTeamMembers)(teamId, true));
            dispatch((0, $jTquG.getMyTeamMembership)(teamId, true));
        }, $f9b5678a86b9107a$var$TIMEOUT_DELAY);
    };

});

parcelRegister("1iS3l", function(module, exports) {

$parcel$export(module.exports, "removeTeamMember", () => $1c9a1aff7197c729$export$f7c0e1c7a2575f28);

var $cAxhS = parcelRequire("cAxhS");
const $1c9a1aff7197c729$export$87a89dfcfcd29512 = (teamState, memberId, permissions)=>{
    const { exitedTeams: exitedTeams, myTeamMembership: myTeamMembership, teamMembers: teamMembers, teamProfile: teamProfile } = teamState;
    const teamId = myTeamMembership.teamId;
    const myMembership = myTeamMembership.membership;
    const isCurrentUser = myMembership && myMembership.membershipId.memberId === memberId;
    const finalMembers = {
        ...teamMembers,
        teamId: teamId,
        hasLoaded: true,
        hasError: false,
        isLoading: false,
        errorType: null,
        members: teamMembers.members.filter((member)=>!!member.user && member.user.id !== memberId)
    };
    if (!isCurrentUser) return {
        ...teamState,
        teamMembers: finalMembers
    };
    // No longer a part of this team, hide it from search results
    exitedTeams.add(teamId);
    const currentTeam = teamProfile.data;
    /**
	 * Allow admins to manage teams after they are removed from the team
	 * If currentTeam.permission is not undefined and user is not admin, they can only view the team after removal, set permission to FULL_READ
	 * If currentTeam.permission is not undefined and user is admin, they can still manage the team after removal, set permission to FULL_WRITE
	 * If currentTeam.permission is undefined, don't override the permission
	 */ const permissionAfterRemoval = currentTeam.permission ? permissions?.canAdminTeams ? 'FULL_WRITE' : 'FULL_READ' : currentTeam.permission;
    // Nullify myMembership and change permission
    return {
        ...teamState,
        teamMembers: finalMembers,
        myTeamMembership: {
            teamId: teamId,
            hasLoaded: true,
            membership: undefined
        },
        teamProfile: {
            teamId: teamId,
            isLoading: false,
            hasLoaded: true,
            errorType: null,
            data: {
                ...currentTeam,
                permission: permissionAfterRemoval
            }
        }
    };
};
const $1c9a1aff7197c729$export$f7c0e1c7a2575f28 = (teamId, memberId, permissions)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        const removeMembershipResponse = await (0, $cAxhS.teamsClient).removeTeamMemberships(teamId, [
            {
                accountId: memberId
            }
        ]);
        // as we only removing 1 member at a time, it is safe to say task failed with even 1 error
        if (removeMembershipResponse.errors && removeMembershipResponse.errors.length) throw Error('Membership claims to be removed but was not');
        if (state.teamMembers.teamId !== teamId) return;
        const nextState = $1c9a1aff7197c729$export$87a89dfcfcd29512(state, memberId, permissions);
        setState(nextState);
    };

});

parcelRegister("iCFlr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ace744de63f3956f$export$2e2bcd8739ae039);

var $cAxhS = parcelRequire("cAxhS");
const $ace744de63f3956f$var$getAllTeams = (allTeamsQuery, keepExistingData)=>async ({ getState: getState, setState: setState })=>{
        if (!keepExistingData) setState({
            allTeamsData: {
                teams: [],
                isLoading: true,
                hasError: false,
                cursor: ''
            }
        });
        try {
            const { teams: newTeams, cursor: cursor } = await (0, $cAxhS.teamsClient).getAllTeams(allTeamsQuery);
            setState({
                allTeamsData: {
                    teams: [
                        ...getState().allTeamsData.teams,
                        ...newTeams
                    ],
                    isLoading: false,
                    hasError: false,
                    cursor: cursor
                }
            });
        } catch (e) {
            setState({
                allTeamsData: {
                    isLoading: false,
                    hasError: true,
                    teams: [],
                    cursor: '',
                    errorStatusCode: e.status
                }
            });
        }
    };
var $ace744de63f3956f$export$2e2bcd8739ae039 = $ace744de63f3956f$var$getAllTeams;

});


parcelRegister("47tex", function(module, exports) {

$parcel$export(module.exports, "useV3OrgIdStatus", () => $ce064a03c15468ba$export$52558c271a487a01);
$parcel$export(module.exports, "verifyTeamsInSameOrgIfNeeded", () => $ce064a03c15468ba$export$61f31a8e9c589b24);

var $1io2n = parcelRequire("1io2n");

var $cWYE1 = parcelRequire("cWYE1");

var $fECJU = parcelRequire("fECJU");
function $ce064a03c15468ba$export$52558c271a487a01() {
    const [{ orgId: orgId }] = (0, $cWYE1.useOrg)();
    return {
        orgId: orgId,
        isOrgLoading: !orgId
    };
}
function $ce064a03c15468ba$export$61f31a8e9c589b24(teams, analytics, queryName, currentOrgId) {
    if (!currentOrgId) return;
    const orgARI = `ari:cloud:platform::org/${currentOrgId}`;
    const invalidTeams = teams.filter((team)=>!team.includesYou && team.orgId !== currentOrgId && team.orgId !== orgARI);
    if (invalidTeams.length) {
        const logTeamsData = invalidTeams.map((t)=>({
                teamId: t.id,
                orgId: t.orgId
            }));
        analytics.pushOperationalEvent({
            source: (0, $1io2n.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: 'TeamOrgMismatch',
            action: (0, $1io2n.AnalyticsEventActions).FAILED,
            attributes: {
                currentOrgId: currentOrgId,
                queryName: queryName
            }
        });
        (0, $fECJU.logErrorMessage)('TeamOrgMismatch', {
            currentOrgId: currentOrgId,
            teams: logTeamsData
        });
    }
}

});

parcelRegister("kPKKc", function(module, exports) {

$parcel$export(module.exports, "UseQueryLightError", () => $61767e160e2e6fa8$export$a1c33d09dbc37a86);
class $61767e160e2e6fa8$export$7f29b23735f2fedd extends Error {
    constructor(message){
        super(message);
        this.message = message;
    }
}
class $61767e160e2e6fa8$export$a1c33d09dbc37a86 extends Error {
    constructor(message, name, graphQLErrors, networkError, extensions){
        super(message);
        this.graphQLErrors = graphQLErrors;
        this.networkError = networkError;
        this.extensions = extensions;
        if (name) this.name = name;
    }
}

});

parcelRegister("kuWTY", function(module, exports) {

$parcel$export(module.exports, "default", () => $999c20825c55208b$export$2e2bcd8739ae039);

var $9ypom = parcelRequire("9ypom");
var $999c20825c55208b$export$2e2bcd8739ae039 = (0, $9ypom.default)`
	query teamSearchV2(
		$first: Int
		$after: String
		$organizationId: ID!
		$query: String = ""
		$memberIds: [ID] = []
		$sortBy: [TeamSort]
		$siteId: String!
		$showEmptyTeams: Boolean = false
	) {
		team {
			teamSearch: teamSearchV2(
				first: $first
				after: $after
				organizationId: $organizationId
				filter: { query: $query, membership: { memberIds: $memberIds } }
				sortBy: $sortBy
				siteId: $siteId
				showEmptyTeams: $showEmptyTeams
			) @optIn(to: ["Team-search-v2"]) {
				nodes {
					...TeamNodeV2
				}
				pageInfo {
					hasNextPage
					endCursor
				}
			}
		}
	}

	fragment TeamNodeV2 on TeamSearchResultV2 {
		team {
			id
			organizationId
			membershipSettings
			description
			displayName
			state
			largeAvatarImageUrl
			smallAvatarImageUrl
			largeHeaderImageUrl
			smallHeaderImageUrl
			members {
				nodes {
					member {
						id
						accountStatus
						name
						picture
					}
				}
			}
		}
		memberCount
		includesYou
	}
`;

});

parcelRegister("9AsMF", function(module, exports) {

$parcel$export(module.exports, "ApolloError", () => $74659d898aa15d0a$export$26a337512320b8c6);
$parcel$export(module.exports, "sortBy", () => $74659d898aa15d0a$export$b035e44d7bb4278f);
class $74659d898aa15d0a$export$26a337512320b8c6 extends Error {
    constructor(message, graphQLErrors, networkError, extraInfo, type){
        super(message);
        this.message = message;
        this.graphQLErrors = graphQLErrors;
        this.networkError = networkError;
        this.extraInfo = extraInfo;
        this.type = type;
    }
}
const $74659d898aa15d0a$export$b035e44d7bb4278f = [
    {
        field: 'DISPLAY_NAME',
        order: 'ASC'
    }
];

});

parcelRegister("jB1nz", function(module, exports) {

$parcel$export(module.exports, "useQueryWrapper", () => $c1fa0f387368415c$export$3257ca80ae5054af);
/**
 * Temporary wrapper for smooth trasition from
 * Apollo useQuery to
 * custom hook useQueryLight
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $qgw6h = parcelRequire("qgw6h");
const $c1fa0f387368415c$export$3257ca80ae5054af = (query, options, enableTeamsGqlQueryMigration)=>{
    const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, $iZuDo.useQuery)(query, {
        ...options,
        skip: options.skip || enableTeamsGqlQueryMigration
    });
    const { data: dataNext, loading: loadingNext, error: errorNext, fetchMore: fetchMoreNext } = (0, $qgw6h.useQueryLight)(query, {
        operationName: options.operationName,
        serviceUrl: options.serviceUrl,
        customHeaders: options.customHeaders || options.context?.headers,
        variables: options.variables,
        skip: options.skip || !enableTeamsGqlQueryMigration
    });
    const transformedApolloFetchMore = (0, $eUqFw.useCallback)(({ variables: variables, handleDataMerge: handleDataMerge })=>{
        fetchMore({
            variables: variables,
            updateQuery: (prevResult, { fetchMoreResult: fetchMoreResult })=>{
                return handleDataMerge(prevResult, fetchMoreResult) || prevResult;
            }
        });
    }, [
        fetchMore
    ]);
    if (enableTeamsGqlQueryMigration) return {
        data: dataNext,
        loading: loadingNext,
        error: errorNext,
        fetchMore: fetchMoreNext
    };
    return {
        loading: loading,
        error: error,
        data: data,
        fetchMore: transformedApolloFetchMore
    };
};

});
parcelRegister("qgw6h", function(module, exports) {

$parcel$export(module.exports, "useQueryLight", () => $292cc331623d40d7$export$153654f6c7880a35);
$parcel$export(module.exports, "useLazyQueryLight", () => $292cc331623d40d7$export$3309ae9fea8ae473);

var $eUqFw = parcelRequire("eUqFw");

var $aKlnM = parcelRequire("aKlnM");

var $hTLlD = parcelRequire("hTLlD");

var $3MdrA = parcelRequire("3MdrA");

var $jnlyS = parcelRequire("jnlyS");

var $kPKKc = parcelRequire("kPKKc");
const $292cc331623d40d7$var$transformError = ({ error: error, graphQLErrors: graphQLErrors })=>new (0, $kPKKc.UseQueryLightError)(// Network error would lead to no graphqlErrors as the query would not be fired. Hence at the front.
    error?.message || graphQLErrors?.[0]?.message || 'Unknown error', error?.name || graphQLErrors?.[0]?.name, graphQLErrors, error);
const $292cc331623d40d7$export$153654f6c7880a35 = (query, options)=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const [data, setData] = (0, $eUqFw.useState)(undefined);
    const variablesRef = (0, $eUqFw.useRef)(options.variables);
    // Need this to deep compare variables to avoid infinite loops in useEffect
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(variablesRef.current, options.variables)) variablesRef.current = options.variables;
    // Initial fetch, and refetch
    const fetchData = (0, $eUqFw.useCallback)(async ()=>{
        try {
            setLoading(true);
            const response = await (0, $3MdrA.fetchWithExponentialBackoff)(`${options.serviceUrl}?q=${options.operationName}`, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    ...options.customHeaders
                }),
                credentials: 'include',
                body: JSON.stringify({
                    query: (0, $aKlnM.print)(query),
                    variables: {
                        ...variablesRef.current
                    }
                })
            });
            const responseData = await response.json();
            if (response.ok) {
                if (responseData.errors) setError($292cc331623d40d7$var$transformError({
                    graphQLErrors: responseData.errors
                }));
                setData(responseData.data);
                setLoading(false);
            } else throw new Error(`Generic fetch error within useQueryLight, status ${response.status}`);
        } catch (error) {
            if (error instanceof Error) setError($292cc331623d40d7$var$transformError({
                error: error
            }));
            else {
                setError($292cc331623d40d7$var$transformError({
                    error: new Error('Unknown error')
                }));
                (0, $jnlyS.logException)(error, `useQueryLight - ${options.operationName}`);
            }
            setData(undefined);
            setLoading(false);
        }
    }, [
        query,
        options.serviceUrl,
        options.operationName,
        options.customHeaders
    ]);
    // Fetch more
    const fetchMore = (0, $eUqFw.useCallback)(async ({ variables: variables, handleDataMerge: handleDataMerge })=>{
        try {
            // reset errors to catch new ones
            setError(undefined);
            const response = await (0, $3MdrA.fetchWithExponentialBackoff)(`${options.serviceUrl}?q=${options.operationName}`, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    ...options.customHeaders
                }),
                credentials: 'include',
                body: JSON.stringify({
                    query: (0, $aKlnM.print)(query),
                    variables: {
                        ...variablesRef.current,
                        ...variables
                    }
                })
            });
            const responseData = await response.json();
            if (response.ok) {
                if (responseData.errors) setError($292cc331623d40d7$var$transformError({
                    graphQLErrors: responseData.errors
                }));
                setData((prevData)=>handleDataMerge(prevData, responseData.data));
            } else throw new Error(`Generic fetch error within useQueryLight, status ${response.status}`);
        } catch (error) {
            if (error instanceof Error) setError($292cc331623d40d7$var$transformError({
                error: error
            }));
            else {
                setError($292cc331623d40d7$var$transformError({
                    error: new Error('Unknown error')
                }));
                (0, $jnlyS.logException)(error, `useQueryLight fetchMore - ${options.operationName}`);
            }
        }
    }, [
        query,
        options.serviceUrl,
        options.operationName,
        options.customHeaders
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!options.skip) fetchData();
        else setLoading(false);
    }, [
        options.skip,
        variablesRef.current
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        loading: loading,
        error: error,
        data: data,
        refetch: fetchData,
        fetchMore: fetchMore
    };
};
const $292cc331623d40d7$export$3309ae9fea8ae473 = (query, options)=>{
    const [fetchTriggered, setFetchTriggered] = (0, $eUqFw.useState)(false);
    const { loading: loading, error: error, data: data, refetch: refetch, fetchMore: fetchMore } = $292cc331623d40d7$export$153654f6c7880a35(query, {
        ...options,
        skip: !fetchTriggered
    });
    const triggerFetch = (0, $eUqFw.useCallback)(()=>{
        setFetchTriggered(true);
    }, []);
    return [
        triggerFetch,
        {
            loading: loading,
            error: error,
            data: data,
            refetch: refetch,
            fetchMore: fetchMore
        }
    ];
};

});



parcelRegister("4XuTO", function(module, exports) {

$parcel$export(module.exports, "default", () => $022299a45f92fddd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $022299a45f92fddd$var$InfiniteScroller = ({ hasMore: hasMore, children: children, loadMore: loadMore, loader: loader, isLoading: isLoading })=>{
    const loadMoreRef = (0, $eUqFw.useRef)(null);
    const fetchMoreCallback = (0, $eUqFw.useCallback)(([loadMoreEntry])=>{
        // Automatically load more data when our invisible "load more" div is within the viewport
        if (loadMoreEntry.isIntersecting && hasMore && !isLoading) loadMore();
    }, [
        loadMore,
        hasMore,
        isLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const intersectionObserver = new IntersectionObserver(fetchMoreCallback);
        if (loadMoreRef.current) intersectionObserver.observe(loadMoreRef.current);
        return ()=>{
            intersectionObserver.disconnect();
        };
    }, [
        loadMoreRef,
        fetchMoreCallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children, hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: loadMoreRef
    }), hasMore && loader);
};
var $022299a45f92fddd$export$2e2bcd8739ae039 = $022299a45f92fddd$var$InfiniteScroller;

});

parcelRegister("dth5h", function(module, exports) {

$parcel$export(module.exports, "AboutContent", () => $025f368396178e1b$export$8197a708459a0877);
$parcel$export(module.exports, "EmptyState", () => $025f368396178e1b$export$fddf379e22a74b00);
$parcel$export(module.exports, "AboutSectionTitle", () => $025f368396178e1b$export$c9a3ce67560199a2);
$parcel$export(module.exports, "AboutItemList", () => $025f368396178e1b$export$b7e7108d011c572b);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $4lTFP = parcelRequire("4lTFP");
const $025f368396178e1b$export$8197a708459a0877 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1m5ose4-0"
})``;
const $025f368396178e1b$export$fddf379e22a74b00 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1m5ose4-1"
})`display:flex;flex-direction:column;align-items:center;width:200px;margin:${"var(--ds-space-500, 40px)"} auto ${"var(--ds-space-200, 16px)"};text-align:center;p{margin-top:${"var(--ds-space-400, 32px)"};}`;
const $025f368396178e1b$export$c9a3ce67560199a2 = /*#__PURE__*/ (0, $kwce8.default).h2.withConfig({
    componentId: "sc-1m5ose4-2"
})`${(0, $4lTFP.h200)};margin-top:${"var(--ds-space-300, 24px)"};margin-bottom:${"var(--ds-space-200, 16px)"};text-transform:uppercase;letter-spacing:normal;`;
const $025f368396178e1b$export$b7e7108d011c572b = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1m5ose4-3"
})`>:not(:last-child){margin-bottom:${"var(--ds-space-050, 4px)"};}`;

});

parcelRegister("ftQay", function(module, exports) {

$parcel$export(module.exports, "default", () => $5820d58187930a20$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $dMWau = parcelRequire("dMWau");

var $gH4G1 = parcelRequire("gH4G1");

var $39ipY = parcelRequire("39ipY");

var $28VEh = parcelRequire("28VEh");

var $4uF0M = parcelRequire("4uF0M");
const $5820d58187930a20$var$findMemberText = (isCurrentUser, team)=>{
    let messageData;
    if (isCurrentUser) messageData = (0, $28VEh.messages).membersPlain;
    else messageData = team.includesYou ? (0, $28VEh.messages).membersIncludingYou : (0, $28VEh.messages).membersPlain;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...messageData,
        values: {
            memberCount: team.memberCount
        }
    });
};
function $5820d58187930a20$export$2e2bcd8739ae039(props) {
    const { team: team, isCurrentUser: isCurrentUser, index: index, onClick: onClick } = props;
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        if (onClick) onClick(e, index);
    }, [
        index,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $39ipY.default), {
        teamId: team.id,
        trigger: "hover",
        triggerLinkType: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dMWau.StyledOutlineLink), {
        onClick: handleClick,
        href: `team/${team.id}`,
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4uF0M.TeamsProfileItemWrapper, {
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4uF0M.TeamsProfileItemAvatar, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gH4G1.default), {
        teamId: team.id,
        avatarUrl: team.smallAvatarImageUrl
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4uF0M.TeamsProfileItemBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4uF0M.TeamsProfileItemTeamName, null, team.displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4uF0M.TeamsProfileItemTeamMembers, null, $5820d58187930a20$var$findMemberText(isCurrentUser, team))))));
}

});
parcelRegister("dMWau", function(module, exports) {

$parcel$export(module.exports, "StyledOutlineLink", () => $8ab77f75562686ef$export$2311a2c1c380abc1);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");


var $kcFkB = parcelRequire("kcFkB");
const $8ab77f75562686ef$export$2311a2c1c380abc1 = /*#__PURE__*/ (0, $kwce8.default)((0, $kcFkB.default)).withConfig({
    componentId: "bs9apg-0"
})`display:block;background-color:${`var(--ds-surface, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`};border:none;padding:0;&:hover{background-color:${`var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`};cursor:pointer;border-radius:${"var(--ds-border-radius-100, 3px)"};}&:focus{background-color:${`var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`};outline:none;box-shadow:0 0 0 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};transition:box-shadow 0.2s ease-in-out;}&:active{background-color:${`var(--ds-background-neutral-subtle-pressed, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`};}> *:focus{outline:none;}`;

});

parcelRegister("gH4G1", function(module, exports) {

$parcel$export(module.exports, "default", () => $de3ea934bec066b4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $hX145 = parcelRequire("hX145");

var $j7BH0 = parcelRequire("j7BH0");

var $9xfTJ = parcelRequire("9xfTJ");
const $de3ea934bec066b4$var$TeamAvatarLegacy = ({ avatarUrl: avatarUrl, teamId: teamId })=>{
    const [hasError, setError] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        setError(false);
    }, [
        avatarUrl,
        teamId
    ]);
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9xfTJ.GradientImage, {
        gradientValues: (0, $j7BH0.getColorFromString)(teamId)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9xfTJ.Image, {
        src: avatarUrl,
        onError: ()=>setError(true),
        alt: ""
    });
};
function $de3ea934bec066b4$export$49e1e29e42184983(props) {
    if ((0, $XHGTv.fg)('use_consistent_default_gradient_component')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hX145.TeamAvatar), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($de3ea934bec066b4$var$TeamAvatarLegacy, props);
}
var $de3ea934bec066b4$export$2e2bcd8739ae039 = $de3ea934bec066b4$export$49e1e29e42184983;

});
parcelRegister("hX145", function(module, exports) {

$parcel$export(module.exports, "TeamAvatar", () => $54a8d3aa3c98a095$export$49e1e29e42184983);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $1ZAYh = parcelRequire("1ZAYh");

var $fNu4n = parcelRequire("fNu4n");

var $aK13q = parcelRequire("aK13q");

var $6wDbg = parcelRequire("6wDbg");
const $54a8d3aa3c98a095$var$fallbackStyle = (0, $1ZAYh.xcss)({
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    margin: 'space.025'
});
const $54a8d3aa3c98a095$export$49e1e29e42184983 = ({ avatarUrl: avatarUrl, teamId: teamId })=>{
    const [hasError, setError] = (0, $eUqFw.useState)(false);
    const [hasLoaded, setLoaded] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        setError(false);
        setLoaded(false);
    }, [
        avatarUrl,
        teamId
    ]);
    if (hasError) return (0, $XHGTv.fg)('use_consistent_default_gradient_component') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aK13q.FallbackGradient), {
        stringToHash: teamId,
        customStyles: $54a8d3aa3c98a095$var$fallbackStyle
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6wDbg.GradientImage, {
        gradientValues: (0, $fNu4n.getColorFromString)(teamId)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6wDbg.Image, {
        src: avatarUrl,
        onError: ()=>setError(true),
        onLoad: ()=>setLoaded(true),
        hasLoaded: hasLoaded,
        alt: ""
    });
};

});
parcelRegister("fNu4n", function(module, exports) {

$parcel$export(module.exports, "getColorFromString", () => $936abcef1be072e8$export$137ec5185b12f5a2);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
const $936abcef1be072e8$var$gradients = [
    `270deg, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)} 0%, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd)} 0%, ${(0, $73a5c9d720aa66e1$export$be802dd0d8b57f35)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$363e4475840015bb)} 0%, ${(0, $73a5c9d720aa66e1$export$4b0a4417ed59760f)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)} 0%, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$7a8f4d33f6f9772c)} 0%, ${(0, $73a5c9d720aa66e1$export$776c9c497ef08533)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$8a6341c32b6a3ee6)} 0%, ${(0, $73a5c9d720aa66e1$export$afbce1382ec95f73)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$41060a744ab0b7ae)} 0%, ${(0, $73a5c9d720aa66e1$export$5aae31392d72caaa)} 100%`
];
const $936abcef1be072e8$export$d41d9ab3de2def3d = (str)=>{
    let hash = 0;
    let chr;
    let i;
    for(i = 0; i < str.length; i++){
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};
const $936abcef1be072e8$export$1ca062359344df12 = (id)=>{
    if (!id) return 0;
    const ordinal = ($936abcef1be072e8$export$d41d9ab3de2def3d(id) % 50).toString()// split string into character array
    .split('')// map to array of charCodes of each character
    .map((chr)=>chr.charCodeAt(0))// add up all charCodes in the array
    .reduce((a, b)=>a + b, 0);
    return ordinal % $936abcef1be072e8$var$gradients.length;
};
const $936abcef1be072e8$export$137ec5185b12f5a2 = (str)=>{
    const index = $936abcef1be072e8$export$1ca062359344df12(str);
    return $936abcef1be072e8$var$gradients[index];
};

});

parcelRegister("aK13q", function(module, exports) {

$parcel$export(module.exports, "FallbackGradient", () => $116a79e3e091b5ee$export$358466f81685c10c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4ofLi = parcelRequire("4ofLi");

var $2cntE = parcelRequire("2cntE");
const $116a79e3e091b5ee$var$styles = (0, $1ZAYh.xcss)({
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    overflow: 'hidden'
});
const $116a79e3e091b5ee$var$gradientStyles = (0, $4ofLi.gradients).map((gradient)=>(0, $1ZAYh.xcss)({
        backgroundImage: `linear-gradient(${gradient})`
    }));
function $116a79e3e091b5ee$export$358466f81685c10c(props) {
    const gradientIndex = (0, $eUqFw.useMemo)(()=>(0, $2cntE.getGradientIndexByString)(props.stringToHash), [
        props.stringToHash
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $116a79e3e091b5ee$var$styles,
            $116a79e3e091b5ee$var$gradientStyles[gradientIndex],
            ...Array.isArray(props.customStyles) ? props.customStyles : [
                props.customStyles
            ]
        ]
    }, props.children);
}

});
parcelRegister("4ofLi", function(module, exports) {

$parcel$export(module.exports, "gradients", () => $2fc623c98072013e$export$fc5727d09955ec17);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
const $2fc623c98072013e$export$fc5727d09955ec17 = [
    `270deg, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)} 0%, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd)} 0%, ${(0, $73a5c9d720aa66e1$export$be802dd0d8b57f35)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$363e4475840015bb)} 0%, ${(0, $73a5c9d720aa66e1$export$4b0a4417ed59760f)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)} 0%, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$7a8f4d33f6f9772c)} 0%, ${(0, $73a5c9d720aa66e1$export$776c9c497ef08533)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$8a6341c32b6a3ee6)} 0%, ${(0, $73a5c9d720aa66e1$export$afbce1382ec95f73)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$41060a744ab0b7ae)} 0%, ${(0, $73a5c9d720aa66e1$export$5aae31392d72caaa)} 100%`
];

});

parcelRegister("2cntE", function(module, exports) {

$parcel$export(module.exports, "getGradientIndexByString", () => $c6fc47f86987da6a$export$47d4d34461987b5d);

var $4ofLi = parcelRequire("4ofLi");
// Code to generate index number from ids is taken from:
// src/master/src/static/gradients/README.md
/**
 * Generate 32bit integer from given string
 */ const $c6fc47f86987da6a$var$hashCode = (str)=>{
    let hash = 0;
    let chr;
    let i;
    for(i = 0; i < str.length; i++){
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};
const $c6fc47f86987da6a$export$47d4d34461987b5d = (id)=>{
    if (!id) return 0;
    const ordinal = ($c6fc47f86987da6a$var$hashCode(id) % 50).toString()// split string into character array
    .split('')// map to array of charCodes of each character
    .map((chr)=>chr.charCodeAt(0))// add up all charCodes in the array
    .reduce((a, b)=>a + b, 0);
    return ordinal % (0, $4ofLi.gradients).length;
};
const $c6fc47f86987da6a$export$137ec5185b12f5a2 = (str)=>{
    const index = $c6fc47f86987da6a$export$47d4d34461987b5d(str);
    return (0, $4ofLi.gradients)[index];
};

});


parcelRegister("6wDbg", function(module, exports) {

$parcel$export(module.exports, "GradientImage", () => $c206a5391d79aa28$export$cf9c515a80d2f7a4);
$parcel$export(module.exports, "Image", () => $c206a5391d79aa28$export$3e431a229df88919);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation (causes type issues)
const $c206a5391d79aa28$var$commonCss = /*#__PURE__*/ (0, $kwce8.css)`width:24px;height:24px;border-radius:50%;margin:${"var(--ds-space-025, 2px)"};display:flex;`;
const $c206a5391d79aa28$export$cf9c515a80d2f7a4 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1vmhbf4-0"
})`${$c206a5391d79aa28$var$commonCss};background-image:linear-gradient(${(props)=>props.gradientValues});`;
const $c206a5391d79aa28$export$3e431a229df88919 = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "sc-1vmhbf4-1"
})`${$c206a5391d79aa28$var$commonCss};opacity:${(props)=>props.hasLoaded ? 1 : 0};`;

});


parcelRegister("j7BH0", function(module, exports) {

$parcel$export(module.exports, "getColorFromString", () => $5a40c920d7e692f2$export$137ec5185b12f5a2);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
const $5a40c920d7e692f2$var$gradients = [
    `270deg, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)} 0%, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd)} 0%, ${(0, $73a5c9d720aa66e1$export$be802dd0d8b57f35)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$363e4475840015bb)} 0%, ${(0, $73a5c9d720aa66e1$export$4b0a4417ed59760f)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)} 0%, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$7a8f4d33f6f9772c)} 0%, ${(0, $73a5c9d720aa66e1$export$776c9c497ef08533)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$8a6341c32b6a3ee6)} 0%, ${(0, $73a5c9d720aa66e1$export$afbce1382ec95f73)} 100%`,
    `270deg, ${(0, $73a5c9d720aa66e1$export$41060a744ab0b7ae)} 0%, ${(0, $73a5c9d720aa66e1$export$5aae31392d72caaa)} 100%`
];
const $5a40c920d7e692f2$export$d41d9ab3de2def3d = (str)=>{
    let hash = 0;
    let chr;
    let i;
    for(i = 0; i < str.length; i++){
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};
const $5a40c920d7e692f2$export$1ca062359344df12 = (id)=>{
    if (!id) return 0;
    const ordinal = ($5a40c920d7e692f2$export$d41d9ab3de2def3d(id) % 50).toString()// split string into character array
    .split('')// map to array of charCodes of each character
    .map((chr)=>chr.charCodeAt(0))// add up all charCodes in the array
    .reduce((a, b)=>a + b, 0);
    return ordinal % $5a40c920d7e692f2$var$gradients.length;
};
const $5a40c920d7e692f2$export$137ec5185b12f5a2 = (str)=>{
    const index = $5a40c920d7e692f2$export$1ca062359344df12(str);
    return $5a40c920d7e692f2$var$gradients[index];
};

});

parcelRegister("9xfTJ", function(module, exports) {

$parcel$export(module.exports, "GradientImage", () => $03f4e2d6dd51805d$export$cf9c515a80d2f7a4);
$parcel$export(module.exports, "Image", () => $03f4e2d6dd51805d$export$3e431a229df88919);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @repo/internal/styles/use-emotion, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
const $03f4e2d6dd51805d$var$commonCss = /*#__PURE__*/ (0, $kwce8.css)`width:24px;height:24px;border-radius:50%;margin:${"var(--ds-space-025, 2px)"};display:flex;`;
const $03f4e2d6dd51805d$export$cf9c515a80d2f7a4 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-3e4kix-0"
})`${$03f4e2d6dd51805d$var$commonCss};background-image:linear-gradient(${(props)=>props.gradientValues});`;
const $03f4e2d6dd51805d$export$3e431a229df88919 = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "sc-3e4kix-1"
})`${$03f4e2d6dd51805d$var$commonCss};`;

});


parcelRegister("39ipY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5090256cd22e3e5e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2eHAZ = parcelRequire("2eHAZ");

var $gakch = parcelRequire("gakch");
var $6XUHL = parcelRequire("6XUHL");
var $47tex = parcelRequire("47tex");

var $356vp = parcelRequire("356vp");

var $fef5r = parcelRequire("fef5r");

var $kZURK = parcelRequire("kZURK");
var $ie6h2 = parcelRequire("ie6h2");
function $5090256cd22e3e5e$export$2e2bcd8739ae039(props) {
    const { children: children, onClick: onClick, position: position = 'bottom-start', trigger: trigger = 'hover', triggerLinkType: triggerLinkType = 'link', teamId: teamId } = props;
    const [{ cloudId: cloudId }] = (0, $6XUHL.useSite)();
    const addFlag = (0, $ie6h2.useFlags)();
    const { contextEntryPoint: contextEntryPoint, push: push } = (0, $kZURK.useAppConfig)();
    const profileClient = (0, $356vp.useProfileClient)();
    const [{ principalUserId: principalUserId }] = (0, $gakch.usePrincipalUser)();
    const { orgId: orgId, isOrgLoading: isOrgLoading } = (0, $47tex.useV3OrgIdStatus)();
    const navigateToTeam = (0, $eUqFw.useCallback)(()=>push(`team/${teamId}`), [
        push,
        teamId
    ]);
    const generateUserLink = (0, $eUqFw.useCallback)((userId)=>(0, $fef5r.prefixWithContextEntryPoint)(userId, contextEntryPoint), [
        contextEntryPoint
    ]);
    const onUserClick = (0, $eUqFw.useCallback)((userId)=>push(userId), [
        push
    ]);
    if (isOrgLoading) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eHAZ.default), {
        position: position,
        orgId: orgId,
        teamId: teamId,
        resourceClient: profileClient,
        viewingUserId: principalUserId,
        trigger: trigger,
        triggerLinkType: triggerLinkType,
        viewProfileLink: (0, $fef5r.prefixWithContextEntryPoint)(`team/${teamId}`, contextEntryPoint),
        viewProfileOnClick: onClick || navigateToTeam,
        generateUserLink: generateUserLink,
        onUserClick: onUserClick,
        addFlag: addFlag,
        cloudId: cloudId
    }, children);
}

});
parcelRegister("2eHAZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $406b356f69bb6521$export$2e2bcd8739ae039);
// Do not export TeamProfileCard here as it will break lazy-loading for the team trigger.


var $94Fw4 = parcelRequire("94Fw4");
var $406b356f69bb6521$export$2e2bcd8739ae039 = (0, $94Fw4.default);

});

parcelRegister("356vp", function(module, exports) {

$parcel$export(module.exports, "useProfileClient", () => $c39a5875bc399601$export$d43dc22a8337ee9f);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $8PYmV = parcelRequire("8PYmV");

var $5bjdJ = parcelRequire("5bjdJ");

var $avLBj = parcelRequire("avLBj");

var $kZURK = parcelRequire("kZURK");
const $c39a5875bc399601$var$CACHE_MAX_AGE = 60000;
function $c39a5875bc399601$var$currentClientMatchesConfig(state, enableTeamCentral, cloudId) {
    if (!state.profileClient) return false;
    return state.enableTeamCentral === enableTeamCentral && state.cloudId === cloudId;
}
const $c39a5875bc399601$var$actions = {
    getClient: ()=>({ getState: getState, dispatch: dispatch })=>{
            const currentClient = getState().profileClient;
            if (currentClient) return currentClient;
            return dispatch($c39a5875bc399601$var$actions.createClient());
        },
    createClient: (enableTeamCentral = false, cloudId = 'None', productName = '')=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            if ($c39a5875bc399601$var$currentClientMatchesConfig(currentState, enableTeamCentral, cloudId)) return currentState.profileClient;
            // Immediately save config to avoid re-create loop
            setState({
                enableTeamCentral: enableTeamCentral,
                cloudId: cloudId
            });
            const { stargateRoot: stargateRoot } = (0, $avLBj.getConfig)();
            const profileClient = new (0, $8PYmV.default)({
                gatewayGraphqlUrl: `${stargateRoot}/graphql`,
                url: `${stargateRoot}/directory/graphql`,
                teamCentralUrl: enableTeamCentral ? `${stargateRoot}/watermelon/graphql` : undefined,
                teamCentralBaseUrl: enableTeamCentral ? (0, $avLBj.getConfig)().teamCentralUrl : undefined,
                cacheSize: 20,
                cacheMaxAge: $c39a5875bc399601$var$CACHE_MAX_AGE,
                cloudId: cloudId,
                productIdentifier: productName.toLowerCase()
            });
            setState({
                profileClient: profileClient
            });
            return profileClient;
        }
};
const $c39a5875bc399601$var$ProfileClientStore = (0, $WBLbN.createStore)({
    initialState: {
        enableTeamCentral: false,
        cloudId: 'None'
    },
    actions: $c39a5875bc399601$var$actions
});
const $c39a5875bc399601$var$useProfileClientState = (0, $WBLbN.createHook)($c39a5875bc399601$var$ProfileClientStore);
const $c39a5875bc399601$export$d43dc22a8337ee9f = ()=>{
    const [{ hasWorkspace: hasWorkspace, orgHasWorkspace: orgHasWorkspace }] = (0, $5bjdJ.useTeamCentralStore)();
    const [state, { getClient: getClient, createClient: createClient }] = $c39a5875bc399601$var$useProfileClientState();
    const { cloudId: cloudId, productName: productName } = (0, $kZURK.useAppConfig)();
    const enableTeamCentral = hasWorkspace || orgHasWorkspace;
    (0, $eUqFw.useEffect)(()=>{
        if (!$c39a5875bc399601$var$currentClientMatchesConfig(state, enableTeamCentral, cloudId)) // re-create the client
        createClient(enableTeamCentral, cloudId, productName);
    }, [
        createClient,
        enableTeamCentral,
        state,
        cloudId,
        productName
    ]);
    return getClient();
};

});

parcelRegister("ie6h2", function(module, exports) {

$parcel$export(module.exports, "useFlags", () => $4dde05264654aec5$export$2879604e6aec4ab);

var $eUqFw = parcelRequire("eUqFw");

var $74Hyh = parcelRequire("74Hyh");

var $kZURK = parcelRequire("kZURK");
const $4dde05264654aec5$export$2879604e6aec4ab = ()=>{
    const { addFlag: addFlag } = (0, $eUqFw.useContext)((0, $kZURK.default));
    const analytics = (0, $74Hyh.default)();
    const addFlagWithAnalytics = (flag, analyticsEvent)=>{
        if (analyticsEvent?.sendAnalytics) analytics.pushScreenEvent({
            name: analyticsEvent.name
        });
        addFlag(flag);
    };
    return addFlagWithAnalytics;
};

});


parcelRegister("28VEh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $eadfe211ecc5e524$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $eadfe211ecc5e524$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    membersPlain: {
        id: 'ptc-directory.user-profile-page.about.teams.item.members.plain',
        defaultMessage: '{memberCount, number} {memberCount, plural, one {member} other {members}}',
        description: 'Either the number of members your team has when you are viewing your own profile, or someone elses team that you are not a member of'
    },
    membersIncludingYou: {
        id: 'ptc-directory.user-profile-page.about.teams.item.members.including.you',
        defaultMessage: '{memberCount, number} {memberCount, plural, one {member, including you} other {members, including you}}',
        description: 'The number of team members, when viewing someone elses profile and you are also a member'
    },
    createTeamLabel: {
        id: 'ptc-directory.team-profile-page.create.team.button',
        defaultMessage: 'Create a team',
        description: 'Label of the CTA to create a new team. It is located in the list of teams a user is already a member of'
    },
    createTeamLabelOtherPeople: {
        id: 'ptc-directory.team-profile-page.create.team.button.other-people',
        defaultMessage: 'Create a team together',
        description: 'Label of the CTA to create a new team with other people. It is located in the list of teams a user is already a member of'
    }
});

});

parcelRegister("4uF0M", function(module, exports) {

$parcel$export(module.exports, "OutlineLink", () => $1732857f308217a3$export$5749dbf81b0a6091);
$parcel$export(module.exports, "TeamsProfileItemWrapper", () => $1732857f308217a3$export$dfa3a67150a99336);
$parcel$export(module.exports, "TeamsProfileItemAvatar", () => $1732857f308217a3$export$5b03fe4ece786130);
$parcel$export(module.exports, "TeamsProfileAddIcon", () => $1732857f308217a3$export$e26c34d851c862e3);
$parcel$export(module.exports, "TeamsProfileItemBody", () => $1732857f308217a3$export$6dae78c6213b453c);
$parcel$export(module.exports, "TeamsProfileItemTeamName", () => $1732857f308217a3$export$14cef269f8b93bc1);
$parcel$export(module.exports, "TeamsProfileItemTeamMembers", () => $1732857f308217a3$export$b7842987d4a39270);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");


var $dMWau = parcelRequire("dMWau");

var $hxsfc = parcelRequire("hxsfc");
const $1732857f308217a3$export$5749dbf81b0a6091 = (0, $dMWau.StyledOutlineLink).withComponent('button');
const $1732857f308217a3$export$dfa3a67150a99336 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8junt6-0"
})`display:flex;flex-basis:auto;${(0, $hxsfc.ellipsisInFlexChild)} height:${"var(--ds-space-500, 40px)"};align-items:center;`;
const $1732857f308217a3$export$5b03fe4ece786130 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8junt6-1"
})`display:flex;padding-right:${"var(--ds-space-100, 8px)"};`;
const $1732857f308217a3$export$99f8df7d064294cc = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8junt6-2"
})`display:flex;padding-right:${"var(--ds-space-100, 8px)"};margin:0px ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"};`;
const $1732857f308217a3$export$e26c34d851c862e3 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8junt6-3"
})`display:flex;padding-right:${"var(--ds-space-100, 8px)"};margin:${"var(--ds-space-025, 2px)"};`;
const $1732857f308217a3$export$6dae78c6213b453c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8junt6-4"
})`display:flex;flex-flow:column;flex-basis:auto;${(0, $hxsfc.ellipsisInFlexChild)};`;
const $1732857f308217a3$export$14cef269f8b93bc1 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8junt6-5"
})`font-size:14px;line-height:16px;padding-bottom:${"var(--ds-space-025, 2px)"};flex-basis:auto;${(0, $hxsfc.ellipsisInFlexChild)} color:${`var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`};`;
const $1732857f308217a3$export$b7842987d4a39270 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8junt6-6"
})`font-size:11px;line-height:14px;color:${`var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`};`;

});


parcelRegister("88bBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $16a337edaeb16d25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $1io2n = parcelRequire("1io2n");
var $74Hyh = parcelRequire("74Hyh");
var $b2XvR = parcelRequire("b2XvR");

var $5wKIN = parcelRequire("5wKIN");
var $2sEko = parcelRequire("2sEko");

var $a1e4H = parcelRequire("a1e4H");

var $28VEh = parcelRequire("28VEh");

var $6vunV = parcelRequire("6vunV");

var $4uF0M = parcelRequire("4uF0M");
const $16a337edaeb16d25$var$TeamsProfileItemButton = (props)=>{
    const analytics = (0, $74Hyh.default)();
    const { openDialog: openDialog } = (0, $b2XvR.useDialog)();
    const { proposedMembers: proposedMembers, source: source, isCurrentUser: isCurrentUser, isActiveUser: isActiveUser } = props;
    const { permissions: { canCreateTeams: canCreateTeams } } = (0, $2sEko.useTeamVisibility)();
    const [{ hasBrowseUsersPermission: hasBrowseUsersPermission }] = (0, $5wKIN.useSettings)();
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        // Track where trigger button is being clicked from
        analytics.pushUIEvent({
            source: (0, $1io2n.AnalyticsEventSource).CREATE_TEAM_MODAL,
            action: (0, $1io2n.AnalyticsEventActions).CLICKED,
            actionSubject: 'teamCreateDialogTriggerButton',
            attributes: {
                // Record where in the UI the modal was triggered from
                trigger: source
            }
        });
        // @ts-ignore
        openDialog((0, $a1e4H.default), {
            proposedMembers: proposedMembers || []
        });
    }, [
        analytics,
        openDialog,
        proposedMembers,
        source
    ]);
    const canStartTeamWithUser = hasBrowseUsersPermission && isActiveUser && canCreateTeams;
    /**
	 * Show the button if:
	 * - it's the current user's profile page
	 * - or it's other people's profile pages and the user has permission
	 */ const showButton = isCurrentUser || !isCurrentUser && canStartTeamWithUser;
    return showButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4uF0M.OutlineLink, {
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4uF0M.TeamsProfileItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4uF0M.TeamsProfileAddIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6vunV.TeamAddIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4uF0M.TeamsProfileItemBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4uF0M.TeamsProfileItemTeamName, null, isCurrentUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $28VEh.messages).createTeamLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $28VEh.messages).createTeamLabelOtherPeople))))) : null;
};
var $16a337edaeb16d25$export$2e2bcd8739ae039 = $16a337edaeb16d25$var$TeamsProfileItemButton;

});
parcelRegister("5wKIN", function(module, exports) {

$parcel$export(module.exports, "useSettings", () => $06134dd6c85c5d96$export$9115b42802a3e44f);
$parcel$export(module.exports, "useSettingsFeatureFlag", () => $06134dd6c85c5d96$export$f2df9067cb58ea32);

var $WBLbN = parcelRequire("WBLbN");

var $cAxhS = parcelRequire("cAxhS");

var $jz9bg = parcelRequire("jz9bg");

var $82kzV = parcelRequire("82kzV");
const $06134dd6c85c5d96$export$28456d095a642fd = 'internal.browse-users-allowed';
const $06134dd6c85c5d96$var$actions = {
    /**
	 * Fetches feature flag settings from LaunchDarkly via activity service and directory service
	 * Caches the fetched settings in local storage to be used as optimistic settings on next load
	 * @param product - only Embeddable Directory needs product information. Standalone app does not need this.
	 * @param cloudId - Cloud Id.
	 */ getSettings: (product, cloudId)=>async ({ setState: setState })=>{
            setState({
                isFetching: true
            });
            try {
                // in siteless, we don't need to query features flags in directory
                const directorySettingPromise = cloudId ? (0, $cAxhS.teamsClient).querySettings(cloudId, product ?? 'site-directory') : Promise.resolve({
                    [$06134dd6c85c5d96$export$28456d095a642fd]: true
                });
                return (0, $jz9bg.promiseWithDefault)(directorySettingPromise, {
                    [$06134dd6c85c5d96$export$28456d095a642fd]: false
                }).then(({ value: browseUsersEnabled, success: settingsSuccess })=>{
                    const settingsFromRequests = {
                        // If settings cannot be accessed, default to permission denied.
                        [$06134dd6c85c5d96$export$28456d095a642fd]: false,
                        ...browseUsersEnabled
                    };
                    if (settingsSuccess) setState({
                        hasLoadedSettings: true,
                        hasBrowseUsersPermission: !!settingsFromRequests[$06134dd6c85c5d96$export$28456d095a642fd],
                        settings: {
                            ...settingsFromRequests
                        }
                    });
                    // Fallback as needed to compute effective flag values
                    const finalSettings = {
                        ...(0, $82kzV.getSettingsFromStorage)() || {},
                        ...settingsFromRequests
                    };
                    setState({
                        hasLoadedSettings: true,
                        hasErrorOnFetchSettings: !settingsSuccess,
                        hasBrowseUsersPermission: !!finalSettings[$06134dd6c85c5d96$export$28456d095a642fd],
                        settings: finalSettings
                    });
                });
            } finally{
                setState({
                    isFetching: false
                });
            }
        }
};
const $06134dd6c85c5d96$var$initialState = {
    hasLoadedSettings: false,
    hasErrorOnFetchSettings: false,
    hasBrowseUsersPermission: false,
    isFetching: false,
    settings: {
        [$06134dd6c85c5d96$export$28456d095a642fd]: false,
        ...(0, $82kzV.getSettingsFromStorage)() || {}
    }
};
/**
 * Manage states of settings
 */ const $06134dd6c85c5d96$var$Store = (0, $WBLbN.createStore)({
    initialState: $06134dd6c85c5d96$var$initialState,
    actions: $06134dd6c85c5d96$var$actions,
    name: 'Settings'
});
const $06134dd6c85c5d96$export$8376625f8bb18347 = (0, $WBLbN.createContainer)($06134dd6c85c5d96$var$Store, {
    onInit: ()=>({ setState: setState }, state)=>{
            setState(state);
        }
});
const $06134dd6c85c5d96$export$9115b42802a3e44f = (0, $WBLbN.createHook)($06134dd6c85c5d96$var$Store);
const $06134dd6c85c5d96$export$f2df9067cb58ea32 = (flagName)=>{
    const [{ settings: settings }] = $06134dd6c85c5d96$export$9115b42802a3e44f();
    return settings[flagName];
};

});

parcelRegister("a1e4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae387099ed74c74c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $21PR2 = parcelRequire("21PR2");
const $ae387099ed74c74c$var$TeamCreateDialogLazy = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $21PR2.default), props));
};
var $ae387099ed74c74c$export$2e2bcd8739ae039 = $ae387099ed74c74c$var$TeamCreateDialogLazy;

});
parcelRegister("21PR2", function(module, exports) {

$parcel$export(module.exports, "default", () => $64e5388567d540d0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $64e5388567d540d0$var$TeamCreateDialogLazyWrapper = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("jZ309")));
var $64e5388567d540d0$export$2e2bcd8739ae039 = $64e5388567d540d0$var$TeamCreateDialogLazyWrapper;

});
parcelRegister("jZ309", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("i2j2q")
]).then(()=>parcelRequire('25cgm'));

});



parcelRegister("6vunV", function(module, exports) {

$parcel$export(module.exports, "TeamAddIcon", () => $6152e7f2fc63c1e3$export$6972ee87109b1a65);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eUqFw = parcelRequire("eUqFw");
const $6152e7f2fc63c1e3$export$6972ee87109b1a65 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "0.5",
        width: "24",
        height: "24",
        rx: "12",
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        transform: "translate(4 4.5)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.6667 11.8333V9.16667C12.6667 8.98986 12.5964 8.82029 12.4714 8.69526C12.3464 8.57024 12.1768 8.5 12 8.5C11.8232 8.5 11.6536 8.57024 11.5286 8.69526C11.4036 8.82029 11.3333 8.98986 11.3333 9.16667V11.8333H8.66667C8.48986 11.8333 8.32029 11.9036 8.19526 12.0286C8.07024 12.1536 8 12.3232 8 12.5C8 12.6768 8.07024 12.8464 8.19526 12.9714C8.32029 13.0964 8.48986 13.1667 8.66667 13.1667H11.3333V15.8333C11.3333 16.0101 11.4036 16.1797 11.5286 16.3047C11.6536 16.4298 11.8232 16.5 12 16.5C12.1768 16.5 12.3464 16.4298 12.4714 16.3047C12.5964 16.1797 12.6667 16.0101 12.6667 15.8333V13.1667H15.3333C15.5101 13.1667 15.6797 13.0964 15.8047 12.9714C15.9298 12.8464 16 12.6768 16 12.5C16 12.3232 15.9298 12.1536 15.8047 12.0286C15.6797 11.9036 15.5101 11.8333 15.3333 11.8333H12.6667Z",
        fill: "#42526E"
    }));
};

});


parcelRegister("bxeZb", function(module, exports) {

$parcel$export(module.exports, "AboutTeamsList", () => $2c79f902e20aa39b$export$f8d76b4306b647d6);
$parcel$export(module.exports, "ShowMoreButton", () => $2c79f902e20aa39b$export$e41c325c8b11c297);
$parcel$export(module.exports, "ErrorContainer", () => $2c79f902e20aa39b$export$97bdf39f6b82bb0);
$parcel$export(module.exports, "ErrorTitle", () => $2c79f902e20aa39b$export$b065fd053267ec81);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $2c79f902e20aa39b$export$9e874bb1adc98a55);
$parcel$export(module.exports, "ErrorIconWrapper", () => $2c79f902e20aa39b$export$b2471e0920d79944);
$parcel$export(module.exports, "ErrorMessage", () => $2c79f902e20aa39b$export$915e9e7bd4f0f96d);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

const $2c79f902e20aa39b$export$eb5006ed1ea4bea6 = /*#__PURE__*/ (0, $kwce8.default).h6.withConfig({
    componentId: "sc-11mcmk0-0"
})`color:${`var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`};margin-bottom:${"var(--ds-space-200, 16px)"};`;
const $2c79f902e20aa39b$export$f8d76b4306b647d6 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-11mcmk0-1"
})`display:flex;flex-direction:column;>:not(:last-child){margin-bottom:${"var(--ds-space-050, 4px)"};}`;
const $2c79f902e20aa39b$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-11mcmk0-2"
})`margin-right:${"var(--ds-space-100, 8px)"};`;
const $2c79f902e20aa39b$export$e41c325c8b11c297 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-11mcmk0-3"
})`text-align:left;padding:${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"};`;
const $2c79f902e20aa39b$export$97bdf39f6b82bb0 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-11mcmk0-4"
})`display:flex;`;
const $2c79f902e20aa39b$export$b065fd053267ec81 = /*#__PURE__*/ (0, $kwce8.default).h5.withConfig({
    componentId: "sc-11mcmk0-5"
})`color:${`var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`};`;
const $2c79f902e20aa39b$export$9e874bb1adc98a55 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-11mcmk0-6"
})``;
const $2c79f902e20aa39b$export$b2471e0920d79944 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-11mcmk0-7"
})`margin-right:${"var(--ds-space-100, 8px)"};`;
const $2c79f902e20aa39b$export$915e9e7bd4f0f96d = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-11mcmk0-8"
})`color:${`var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`};font-size:11px;`;

});




parcelRegister("5BUhr", function(module, exports) {

$parcel$export(module.exports, "AgentActions", () => $cbd9aafdcdee594b$export$a091e6fbe251d12f);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6zOB7 = parcelRequire("6zOB7");
var $j9fWg = parcelRequire("j9fWg");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $34Io4 = parcelRequire("34Io4");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $kDlNh = parcelRequire("kDlNh");

var $kQ7TK = parcelRequire("kQ7TK");
const $cbd9aafdcdee594b$var$chatToAgentButtonContainer = (0, $1ZAYh.xcss)({
    width: '100%'
});
const $cbd9aafdcdee594b$var$chatToAgentButtonWrapper = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'center',
    lineHeight: '20px',
    padding: 'space.075',
    fontWeight: '500'
});
const $cbd9aafdcdee594b$var$chatPillButtonInlineStyles = (0, $1ZAYh.xcss)({
    paddingInline: 'space.025'
});
const $cbd9aafdcdee594b$var$chatPillTextStyles = (0, $1ZAYh.xcss)({
    wordBreak: 'break-word',
    textAlign: 'left',
    whiteSpace: 'pre-wrap'
});
const $cbd9aafdcdee594b$var$chatPillIconWrapper = (0, $1ZAYh.xcss)({
    minWidth: '20px',
    height: '20px'
});
const $cbd9aafdcdee594b$var$buildAgentActions = ({ onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent })=>{
    return [
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kQ7TK.messages).actionDuplicate),
            onClick: onDuplicateAgent
        },
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kQ7TK.messages).actionCopyLink),
            onClick: onCopyAgent
        }
    ];
};
const $cbd9aafdcdee594b$var$buildAgentSettings = ({ onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent })=>{
    return [
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kQ7TK.messages).actionEdit),
            onClick: onEditAgent
        },
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kQ7TK.messages).actionDelete),
            onClick: onDeleteAgent
        }
    ];
};
const $cbd9aafdcdee594b$export$a091e6fbe251d12f = ({ onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent, onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent, onChatClick: onChatClick, isAgentCreatedByUser: isAgentCreatedByUser })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const agentActions = $cbd9aafdcdee594b$var$buildAgentActions({
        onDuplicateAgent: onDuplicateAgent,
        onCopyAgent: onCopyAgent
    });
    const agentSetting = $cbd9aafdcdee594b$var$buildAgentSettings({
        onEditAgent: onEditAgent,
        onDeleteAgent: onDeleteAgent
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cbd9aafdcdee594b$var$chatToAgentButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        shouldFitContainer: true,
        onClick: onChatClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cbd9aafdcdee594b$var$chatToAgentButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        xcss: $cbd9aafdcdee594b$var$chatPillButtonInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cbd9aafdcdee594b$var$chatPillIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kDlNh.ChatPillIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cbd9aafdcdee594b$var$chatPillTextStyles
    }, formatMessage((0, $kQ7TK.messages).actionChatToAgent)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($34Io4))),
                label: "more",
                ref: triggerRef
            }),
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, agentActions.map(({ text: text, onClick: onClick }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: idx,
            onClick: onClick
        }, text);
    })), isAgentCreatedByUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        hasSeparator: true
    }, agentSetting.map(({ text: text, onClick: onClick }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: idx,
            onClick: onClick
        }, text);
    }))));
};

});
parcelRegister("kQ7TK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a148be47cef329d7$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a148be47cef329d7$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    actionChatToAgent: {
        id: 'ptc-directory.agent-profile.action.dropdown.chat-to-agent.nonfinal',
        defaultMessage: 'Chat to Agent',
        description: 'Text for the "chat to agent" action to chat to the agent'
    },
    actionDelete: {
        id: 'ptc-directory.agent-profile.action.dropdown.delete.nonfinal',
        defaultMessage: 'Delete Agent',
        description: 'Text for the "Delete" action to delete an agent'
    },
    actionEdit: {
        id: 'ptc-directory.agent-profile.action.dropdown.edit.nonfinal',
        defaultMessage: 'Edit Agent',
        description: 'Text for the "Edit" action to edit an agent'
    },
    actionCopyLink: {
        id: 'ptc-directory.agent-profile.action.dropdown.copy-link.nonfinal',
        defaultMessage: 'Copy link',
        description: 'Text for the Copy link of an agent'
    },
    actionDuplicate: {
        id: 'ptc-directory.agent-profile.action.dropdown.duplicate.nonfinal',
        defaultMessage: 'Duplicate Agent',
        description: 'Text for the Duplicate Agent action to create a duplicate'
    },
    agentDeletedSuccessFlagTitle: {
        id: 'ptc-directory.agent-profile.delete-agent-success-flag-title',
        defaultMessage: 'Agent deleted',
        description: 'Flag message title displayed when an agent is deleted'
    },
    agentDeletedSuccessFlagDescription: {
        id: 'ptc-directory.agent-profile.delete-agent-success-flag-description',
        defaultMessage: 'You deleted {agentName}',
        description: 'Flag message description displayed when an agent is deleted'
    },
    agentDeletedErrorFlagTitle: {
        id: 'ptc-directory.agent-profile.delete-agent-error-flag-title',
        defaultMessage: 'Failed to delete Agent',
        description: 'Flag message title displayed when there is an error deleting agent'
    },
    agentDeletedErrorFlagDescription: {
        id: 'ptc-directory.agent-profile.delete-agent-error-flag-description',
        defaultMessage: 'Something went wrong while deleting the agent. Try again in a few moments.',
        description: 'Flag message description displayed when there is an error deleting agent'
    }
});

});


parcelRegister("jvkFO", function(module, exports) {

$parcel$export(module.exports, "AgentConversationStartersSection", () => $2934ad15767049f9$export$574a87e4832466ff);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $1zbEq = parcelRequire("1zbEq");

var $fc0pM = parcelRequire("fc0pM");

var $effNQ = parcelRequire("effNQ");
const $2934ad15767049f9$export$574a87e4832466ff = ({ isAgentDefault: isAgentDefault, onConversationStarterClick: onConversationStarterClick, userDefinedConversationStarters: userDefinedConversationStarters })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleConversationStarterClick = (conversationStarter)=>{
        onConversationStarterClick(conversationStarter);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $effNQ.MainContentHeaders), null, formatMessage($2934ad15767049f9$var$messages.openChatLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignInline: "start",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fc0pM.AgentConversationStarters), {
        isAgentDefault: isAgentDefault,
        onConversationStarterClick: handleConversationStarterClick,
        userDefinedConversationStarters: userDefinedConversationStarters
    })));
};
const $2934ad15767049f9$var$messages = (0, $90IgZ.defineMessages)({
    openChatLabel: {
        id: 'ptc-directory.agent-profile.conversation-starter.header',
        defaultMessage: 'Open chat',
        description: 'Label for about section of the agent'
    }
});

});
parcelRegister("effNQ", function(module, exports) {

$parcel$export(module.exports, "MainContentHeaders", () => $45b528ee6d46e614$export$161f9e38c5e0d38e);

var $eUqFw = parcelRequire("eUqFw");

var $1Yimi = parcelRequire("1Yimi");
const $45b528ee6d46e614$export$161f9e38c5e0d38e = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        size: "large",
        color: "color.text.subtle",
        weight: "semibold"
    }, children);

});


parcelRegister("1g5v7", function(module, exports) {

$parcel$export(module.exports, "AgentCreator", () => $ae5c659b238632be$export$d892e919a94dad49);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $920hm = parcelRequire("920hm");

var $fpa0Z = parcelRequire("fpa0Z");

var $j9wA1 = parcelRequire("j9wA1");

var $hKky0 = parcelRequire("hKky0");
const $ae5c659b238632be$export$d892e919a94dad49 = ({ creator: creator, create_type: create_type })=>{
    const userId = create_type === 'CUSTOMER' && creator ? (0, $j9wA1.trimUserARI)(creator) : '';
    const { data: userData, isLoading: userInfoIsLoading } = (0, $hKky0.default)({
        userId: userId || '',
        skip: (0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query')
    });
    const { isLoading: loadingAgg, data: dataAgg } = (0, $fpa0Z.useTeamsUser)(userId, !userId || !(0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query'));
    const getCreator = ()=>{
        switch(create_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                return {
                    type: 'CUSTOMER',
                    name: (0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query') ? dataAgg?.fullName || '' : userData.fullName,
                    profileLink: `/people/${(0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query') ? dataAgg?.id : userData.id}`
                };
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $920hm.AgentProfileCreator), {
        creator: getCreator(),
        isLoading: (0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query') ? loadingAgg : userInfoIsLoading,
        onCreatorLinkClick: ()=>{}
    });
};

});

parcelRegister("m9pXn", function(module, exports) {

$parcel$export(module.exports, "default", () => $71d1e23a8fe4d809$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6zOB7 = parcelRequire("6zOB7");

var $7jPhn = parcelRequire("7jPhn");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");
const $71d1e23a8fe4d809$var$errStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.150'
});
const $71d1e23a8fe4d809$var$agentResponseMessageTemplate = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DELETE_SUCCESS: 'agentDeletedSuccess'
};
const $71d1e23a8fe4d809$export$39d869cf16a68f79 = ({ onClose: onClose, agentName: agentName, agentId: agentId, onDelete: onDelete })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [deleteError, setDeleteError] = (0, $eUqFw.useState)();
    const [isDeletePending, setIsDeletePending] = (0, $eUqFw.useState)(false);
    const handleDeleteAgent = (0, $eUqFw.useCallback)(async ()=>{
        if (agentId) {
            setIsDeletePending(true);
            try {
                await onDelete?.();
                onClose?.();
            } catch (error) {
                setDeleteError(formatMessage($71d1e23a8fe4d809$var$messages[$71d1e23a8fe4d809$var$agentResponseMessageTemplate[error?.message_template]]));
            } finally{
                setIsDeletePending(false);
            }
        }
    }, [
        agentId,
        formatMessage,
        onClose,
        onDelete
    ]);
    if (!agentId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage($71d1e23a8fe4d809$var$messages.title, {
        agentName: agentName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage($71d1e23a8fe4d809$var$messages.body)), deleteError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $71d1e23a8fe4d809$var$errStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, deleteError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage($71d1e23a8fe4d809$var$messages.cancelText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "danger",
        isDisabled: !!deleteError || isDeletePending,
        onClick: (_e, _event)=>{
            handleDeleteAgent();
        }
    }, formatMessage($71d1e23a8fe4d809$var$messages.confirmText)))));
};
var $71d1e23a8fe4d809$export$2e2bcd8739ae039 = $71d1e23a8fe4d809$export$39d869cf16a68f79;
const $71d1e23a8fe4d809$var$messages = (0, $90IgZ.defineMessages)({
    cancelText: {
        id: 'ptc-directory.agent-profile.agent-delete-confirm.cancel-text',
        defaultMessage: 'Cancel'
    },
    confirmText: {
        id: 'ptc-directory.agent-profile.agent-delete-confirm.confirm-text',
        defaultMessage: 'Delete'
    },
    title: {
        id: 'ptc-directory.agent-profile.delete-agent-confirm-title',
        defaultMessage: 'Delete "{agentName}"?',
        description: 'Title text for the delete agent confirmation modal'
    },
    body: {
        id: 'ptc-directory.agent-profile.delete-agent-confirm-body',
        defaultMessage: `Are you sure you want to delete this agent? This action cannot be undone.`,
        description: 'Body text for the delete agent confirmation modal'
    },
    error: {
        id: 'ptc-directory.agent-profile.delete-agent-error',
        defaultMessage: 'Could not delete agent',
        description: 'Error message displayed when an agent cannot be deleted'
    },
    errorAgentNotFound: {
        id: 'ptc-directory.agent-profile.delete-agent-error.agent-not-found',
        defaultMessage: 'That agent could not be found.',
        description: 'Error message displayed when an agent cannot be found'
    },
    errorAgentInUse: {
        id: 'ptc-directory.agent-profile.delete-agent-error.agent-in-use',
        defaultMessage: 'Agent is currently in use. Try again later.',
        description: 'Error message displayed when an agent is in use'
    },
    errorIncorrectOwner: {
        id: 'ptc-directory.agent-profile.delete-agent-error.incorrect-owner',
        defaultMessage: 'You cannot delete agents you have not created yourself. Please contact the agent owner.',
        description: 'Error message displayed when the agent owner is incorrect'
    },
    agentDeletedSuccess: {
        id: 'ptc-directory.agent-profile.delete-agent-success',
        defaultMessage: 'Agent has been deleted!',
        description: 'Success message displayed when an agent is deleted'
    }
});

});
parcelRegister("7jPhn", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $8d7fd15aabd72279$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $8d7fd15aabd72279$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $8d7fd15aabd72279$export$5505afb209a532c8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lD2Nx = parcelRequire("lD2Nx");

var $96IgR = parcelRequire("96IgR");


var $gaA9C = parcelRequire("gaA9C");
function $8d7fd15aabd72279$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d7fd15aabd72279$var$messageStyles = {
    name: "ywqxo4",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-050, 4px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $8d7fd15aabd72279$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $8d7fd15aabd72279$var$iconWrapperStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $8d7fd15aabd72279$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d7fd15aabd72279$var$iconWrapperStyles
    }, children);
};
const $8d7fd15aabd72279$var$messageIcons = {
    error: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        size: "small",
        label: "success"
    })
};
const $8d7fd15aabd72279$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $8d7fd15aabd72279$var$messageIcons[appearance];
    const messageRef = (0, $eUqFw.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $eUqFw.useState)(false);
    const { isWrapper: isWrapper } = (0, $eUqFw.useContext)($8d7fd15aabd72279$export$579aef2c392a54d4);
    (0, $eUqFw.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $byn9U.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $8d7fd15aabd72279$var$messageStyles,
            $8d7fd15aabd72279$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined
    }, icon && /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$IconWrapper, null, icon), content);
};
const $8d7fd15aabd72279$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isWrapper: false
});
const $8d7fd15aabd72279$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$export$579aef2c392a54d4.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("lD2Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbef6921e18df378$var$_react = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $fbef6921e18df378$var$_success = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("50qGm")));
function $fbef6921e18df378$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fbef6921e18df378$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $fbef6921e18df378$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $fbef6921e18df378$var$_success.default
    }));
$fbef6921e18df378$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $fbef6921e18df378$var$_default = module.exports.default = $fbef6921e18df378$var$EditorSuccessIcon;

});

parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});



parcelRegister("1V5FM", function(module, exports) {

$parcel$export(module.exports, "useAgentActions", () => $78fdf7c6048d5769$export$9115df56efd01c09);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bW292 = parcelRequire("bW292");

var $24e7T = parcelRequire("24e7T");
var $3EWxb = parcelRequire("3EWxb");
var $bH5Sg = parcelRequire("bH5Sg");

var $jraxv = parcelRequire("jraxv");

var $4MkQ9 = parcelRequire("4MkQ9");

var $1io2n = parcelRequire("1io2n");

var $ie6h2 = parcelRequire("ie6h2");
var $ghnah = parcelRequire("ghnah");

var $kQ7TK = parcelRequire("kQ7TK");
const $78fdf7c6048d5769$export$9115df56efd01c09 = ({ product: product, cloudId: cloudId, agentId: agentId, agentName: agentName, agentIdentityAccountId: agentIdentityAccountId })=>{
    const addFlag = (0, $ie6h2.useFlags)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { push: push } = (0, $ghnah.useRouter)();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $24e7T.useAgentFavourites)({
        experienceId: 'profile-page',
        product: product
    });
    const { onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent } = (0, $3EWxb.useAgentUrlActions)({
        siteId: cloudId
    });
    const { deleteAgent: deleteRovoAgent } = (0, $bH5Sg.useDeleteAgent)({
        experienceId: 'profile-page',
        product: product
    });
    const setFavouriteAgent = (0, $eUqFw.useCallback)(async (isFavourite, onSuccess)=>{
        if (!agentId) return;
        if (isFavourite) return await favouriteAgent.mutate(agentId, {
            onSuccess: onSuccess
        });
        else return await unfavouriteAgent.mutate(agentId, {
            onSuccess: onSuccess
        });
    }, [
        agentId,
        favouriteAgent,
        unfavouriteAgent
    ]);
    const { fireEvent: fireEvent } = (0, $4MkQ9.usePeopleTeamAnalyticsEvents)();
    const editAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.editAgent.clicked', {});
        onEditAgent(agentId);
    };
    const copyAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.copyAgent.clicked', {});
        onCopyAgent({
            agentId: agentId,
            agentIdentityAccountId: agentIdentityAccountId
        });
    };
    const duplicateAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.duplicateAgent.clicked', {});
        onDuplicateAgent(agentId);
    };
    const deleteAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.deleteAgent.clicked', {});
        deleteRovoAgent.mutate(agentId, {
            onSuccess: ()=>{
                addFlag({
                    title: formatMessage((0, $kQ7TK.messages).agentDeletedSuccessFlagTitle),
                    description: formatMessage((0, $kQ7TK.messages).agentDeletedSuccessFlagDescription, {
                        agentName: agentName
                    }),
                    type: 'success',
                    id: 'ptc-directory.agent-profile.delete-agent-success'
                }, {
                    sendAnalytics: true,
                    name: (0, $1io2n.AnalyticsEventSource).AGENT_DELETE_SUCCESS_FLAG
                });
                setTimeout(()=>{
                    push('search');
                }, 100);
            },
            onError: ()=>{
                addFlag({
                    title: formatMessage((0, $kQ7TK.messages).agentDeletedErrorFlagTitle),
                    description: formatMessage((0, $kQ7TK.messages).agentDeletedErrorFlagDescription),
                    type: 'error',
                    id: 'ptc-directory.agent-profile.delete-agent-error'
                }, {
                    sendAnalytics: true,
                    name: (0, $1io2n.AnalyticsEventSource).AGENT_DELETE_ERROR_FLAG
                });
            }
        });
    };
    const onChatWithAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.chatWithAgent.clicked', {});
        window.open((0, $jraxv.addRovoParamsToUrl)(`${(0, $bW292.getATLContextUrl)('home')}/chat`, {
            pathway: 'chat',
            cloudId: cloudId,
            agentId: agentId
        }), '_blank', 'noopener, noreferrer');
    };
    const startConversation = (prompt)=>{
        if (!agentId) return;
        fireEvent('ui.startConversationWithAgent.clicked', {});
        window.open((0, $jraxv.addRovoParamsToUrl)(`${(0, $bW292.getATLContextUrl)('home')}/chat`, {
            pathway: 'chat',
            prompt: prompt,
            cloudId: cloudId,
            agentId: agentId
        }), '_blank', 'noopener, noreferrer');
    };
    return {
        setFavouriteAgent: setFavouriteAgent,
        editAgent: editAgent,
        copyAgent: copyAgent,
        duplicateAgent: duplicateAgent,
        deleteAgent: deleteAgent,
        onChatWithAgent: onChatWithAgent,
        startConversation: startConversation
    };
};

});
parcelRegister("3EWxb", function(module, exports) {

$parcel$export(module.exports, "useAgentUrlActions", () => $3b83cfd535b92282$export$56665b80ee272742);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $jraxv = parcelRequire("jraxv");

var $2cx0u = parcelRequire("2cx0u");
const $3b83cfd535b92282$export$56665b80ee272742 = ({ siteId: siteId })=>{
    const onEditAgent = (0, $eUqFw.useCallback)((agentId)=>{
        window.open((0, $2cx0u.getAtlasURL)(siteId, `/chat/agents/${agentId}/edit`), '_blank', 'noopener, noreferrer');
    }, [
        siteId
    ]);
    const onCopyAgent = (0, $eUqFw.useCallback)(({ agentId: agentId, agentIdentityAccountId: agentIdentityAccountId })=>{
        if (agentIdentityAccountId && (0, $XHGTv.fg)('rovo_agent_profile_page')) {
            navigator.clipboard.writeText(`${window.location.origin}/people/agent/${agentId}`);
            return;
        }
        const rovoParams = (0, $jraxv.encodeRovoParams)({
            pathway: 'chat',
            agentId: agentId
        });
        navigator.clipboard.writeText((0, $2cx0u.getAtlasURL)(siteId, `/chat?${rovoParams}`));
    }, [
        siteId
    ]);
    const onDuplicateAgent = (0, $eUqFw.useCallback)((agentId)=>{
        const rovoParams = (0, $jraxv.encodeRovoParams)({
            pathway: 'agents-create',
            agentId: agentId
        });
        window.open((0, $2cx0u.getAtlasURL)(siteId, `/chat/agents/new?${rovoParams}`), '_blank', 'noopener, noreferrer');
    }, [
        siteId
    ]);
    const onViewAgentFullProfile = (0, $eUqFw.useCallback)((agentId)=>{
        window.open(`${window.location.origin}/people/agent/${agentId}`, '_blank', 'noopener, noreferrer');
    }, []);
    return {
        onEditAgent: onEditAgent,
        onCopyAgent: onCopyAgent,
        onDuplicateAgent: onDuplicateAgent,
        onViewAgentFullProfile: onViewAgentFullProfile
    };
};

});
parcelRegister("2cx0u", function(module, exports) {

$parcel$export(module.exports, "getAtlasURL", () => $4c0ab11761f74b7d$export$bfee0f88bf621ad3);

var $jraxv = parcelRequire("jraxv");
const $4c0ab11761f74b7d$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $4c0ab11761f74b7d$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $4c0ab11761f74b7d$var$getAtlasHost = ()=>{
    const host = window.location.host;
    const isStaging = host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('jira-dev.com');
    return isStaging ? $4c0ab11761f74b7d$var$ATLAS_STAGING_URL : $4c0ab11761f74b7d$var$ATLAS_PROD_URL;
};
const $4c0ab11761f74b7d$export$bfee0f88bf621ad3 = (cloudId, path)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    return (0, $jraxv.addRovoParamsToUrl)(`${$4c0ab11761f74b7d$var$getAtlasHost()}${processedPath}${argConcat}cloudId=${cloudId}`, {
        cloudId: cloudId
    });
};

});


parcelRegister("ghnah", function(module, exports) {

$parcel$export(module.exports, "useRouter", () => $d727dc2034ecf5d9$export$9a302a45f65d0572);

var $eUqFw = parcelRequire("eUqFw");

var $kZURK = parcelRequire("kZURK");
const $d727dc2034ecf5d9$export$9a302a45f65d0572 = ()=>{
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, push: push, replace: replace, history: history } = (0, $eUqFw.useContext)((0, $kZURK.default));
    return {
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint,
        push: push,
        replace: replace,
        history: history
    };
};

});



parcelRegister("8OFDT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("023HH").then(()=>parcelRequire('8HmIw'));

});


parcelRegister("4RubW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1043d4bd78ae695$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bsMUn = parcelRequire("bsMUn");
var $74Hyh = parcelRequire("74Hyh");

var $kZURK = parcelRequire("kZURK");

var $aVf8h = parcelRequire("aVf8h");
function $d1043d4bd78ae695$var$recordPageVisitOrigin(replace) {
    const url = new URL(window.location.href);
    if (!url || !url.searchParams) return;
    // ref contains a product like confluence, jira etc.
    const ref = url.searchParams.get('ref') || '';
    // src contains a location like appswitcher, peopledrawer etc.
    const src = url.searchParams.get('src') || '';
    if (!ref && !src) return;
    // save referrer info for retrieving it in further screen events
    (0, $bsMUn.default).set({
        src: src,
        ref: ref
    });
    url.searchParams.delete('ref');
    url.searchParams.delete('src');
    // replace location if it changed after removing ref and src query params
    if (replace) replace(`${url.pathname}${url.search}`);
}
function $d1043d4bd78ae695$var$RecordTransition(props) {
    const { name: name } = props;
    const { replace: replace } = (0, $kZURK.useAppConfig)();
    const refInitialLoadTracked = (0, $eUqFw.useRef)(false);
    const analytics = (0, $74Hyh.default)();
    (0, $eUqFw.useEffect)(()=>{
        if (!refInitialLoadTracked.current) {
            refInitialLoadTracked.current = true;
            // stores referrer info
            $d1043d4bd78ae695$var$recordPageVisitOrigin(replace);
        } else // cleanup stored referrer info on transition
        (0, $bsMUn.default).cleanup();
        (0, $aVf8h.default)(name, analytics);
    }, [
        analytics,
        name,
        replace
    ]);
    return null;
}
var $d1043d4bd78ae695$export$2e2bcd8739ae039 = $d1043d4bd78ae695$var$RecordTransition;

});
parcelRegister("aVf8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b988b1f76895c54f$export$2e2bcd8739ae039);

var $cLI0M = parcelRequire("cLI0M");
let $b988b1f76895c54f$var$dwellHelper = null;
const $b988b1f76895c54f$var$buildDwellEventData = (source)=>{
    return {
        actionSubject: 'page',
        source: source
    };
};
const $b988b1f76895c54f$var$sendDwellEvent = (eventData, analyticsClient)=>{
    analyticsClient.sendTrackEvent(eventData);
};
const $b988b1f76895c54f$var$initialiseDwellTime = (eventSource, analyticsClient)=>{
    if (eventSource) {
        const updatedEventData = $b988b1f76895c54f$var$buildDwellEventData(eventSource);
        $b988b1f76895c54f$var$dwellHelper = (0, $cLI0M.default)((eventData)=>$b988b1f76895c54f$var$sendDwellEvent(eventData, analyticsClient), updatedEventData);
        $b988b1f76895c54f$var$dwellHelper.start();
    }
};
const $b988b1f76895c54f$var$recordNewPageForDwellTime = (eventSource)=>{
    if ($b988b1f76895c54f$var$dwellHelper) {
        if (eventSource) {
            const updatedEventData = $b988b1f76895c54f$var$buildDwellEventData(eventSource);
            $b988b1f76895c54f$var$dwellHelper.newPage(updatedEventData);
        } else // eslint-disable-next-line no-console
        console.error('Unable to record dwell time transition - missing analytics key or source mapping for route');
    } else // eslint-disable-next-line no-console
    console.error('Dwell time has not been initialised');
};
/**
 * Initialises dwell time measurement, or records a page transition if it is already initialised.
 * Note that dwell time will only be initialised on routes that have an analytics key, which should be
 * all routes except for those that result in a redirect.
 */ const $b988b1f76895c54f$var$recordDwellTime = (analyticsKey, analyticsClient)=>{
    const eventName = analyticsClient.mapAnalyticsKeyToEvent(analyticsKey);
    const eventSource = eventName ? `${eventName}Screen` : null;
    if (!$b988b1f76895c54f$var$dwellHelper) $b988b1f76895c54f$var$initialiseDwellTime(eventSource, analyticsClient);
    else $b988b1f76895c54f$var$recordNewPageForDwellTime(eventSource);
};
var $b988b1f76895c54f$export$2e2bcd8739ae039 = $b988b1f76895c54f$var$recordDwellTime;

});
parcelRegister("cLI0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $f442b6c617c34d0a$export$2e2bcd8739ae039);

var $4NcB5 = parcelRequire("4NcB5");
const $f442b6c617c34d0a$var$getDwellTimeHelper = (sendMethod, eventData)=>{
    return new (0, $4NcB5.default)(sendMethod, eventData);
};
var $f442b6c617c34d0a$export$2e2bcd8739ae039 = $f442b6c617c34d0a$var$getDwellTimeHelper;

});




parcelRegister("ghjoM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a475b509b910560$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $7qMvm = parcelRequire("7qMvm");

var $1DMxn = parcelRequire("1DMxn");

var $4RubW = parcelRequire("4RubW");
function $2a475b509b910560$var$hasProfileProp(state) {
    return !!state && 'profile' in state;
}
const $2a475b509b910560$var$KudosPageRoute = ({ match: match, location: location })=>{
    const { uuid: uuid } = match.params;
    const profile = $2a475b509b910560$var$hasProfileProp(location.state) ? location.state.profile : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RubW.default), {
        name: (0, $1io2n.AnalyticsKeys).KUDOS_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qMvm.default), {
        name: (0, $1io2n.AnalyticsKeys).KUDOS_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1DMxn.default), {
        uuid: uuid,
        referrerProfile: profile
    }));
};
var $2a475b509b910560$export$2e2bcd8739ae039 = $2a475b509b910560$var$KudosPageRoute;

});
parcelRegister("1DMxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c533f04d7033e50$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

const $2c533f04d7033e50$var$LazyKudosPage = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("2xKU6")),
    loading: ()=>null
});
$2c533f04d7033e50$var$LazyKudosPage.displayName = 'lazy(KudosPage)';
var $2c533f04d7033e50$export$2e2bcd8739ae039 = $2c533f04d7033e50$var$LazyKudosPage;

});
parcelRegister("2xKU6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("25fzR")
]).then(()=>parcelRequire('d5pVi'));

});



parcelRegister("4ckcM", function(module, exports) {

$parcel$export(module.exports, "default", () => $32e35733ed476493$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $hYfIu = parcelRequire("hYfIu");
var $74Hyh = parcelRequire("74Hyh");
var $gakch = parcelRequire("gakch");

var $3WT37 = parcelRequire("3WT37");
function $32e35733ed476493$export$2e2bcd8739ae039(props) {
    const { contextEntryPoint: contextEntryPoint, location: location } = props;
    const [{ principalUserId: principalUserId }] = (0, $gakch.usePrincipalUser)();
    const analytics = (0, $74Hyh.default)();
    const url = new URL(window.location.href);
    const ref = (0, $hYfIu.sanitiseValue)(url.searchParams.get('ref') || '', {
        shouldHaveSafeCharsOnly: true,
        shouldEncode: true
    });
    (0, $eUqFw.useEffect)(()=>{
        analytics.pushTrackEvent({
            source: (0, $1io2n.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'redirectMePathToMyProfile',
            action: (0, $1io2n.AnalyticsEventActions).REDIRECTED,
            attributes: {
                ref: ref
            }
        });
    }, [
        analytics,
        ref
    ]);
    if (!principalUserId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3WT37.default), {
        to: `${contextEntryPoint}/${principalUserId}${location.search}`
    });
}

});
parcelRegister("3WT37", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f185e6d4784d68f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kZURK = parcelRequire("kZURK");
const $0f185e6d4784d68f$var$Redirect = ({ to: to })=>{
    const { replace: replace } = (0, $kZURK.useAppConfig)();
    (0, $eUqFw.useEffect)(()=>{
        replace(to);
    }, [
        replace,
        to
    ]);
    return null;
};
var $0f185e6d4784d68f$export$2e2bcd8739ae039 = $0f185e6d4784d68f$var$Redirect;

});


parcelRegister("p3lye", function(module, exports) {

$parcel$export(module.exports, "default", () => $60adec8a9bcebfae$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3WT37 = parcelRequire("3WT37");
const $60adec8a9bcebfae$var$RootRedirect = ({ location: location })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3WT37.default), {
        to: `search${location.search}`
    });
var $60adec8a9bcebfae$export$2e2bcd8739ae039 = $60adec8a9bcebfae$var$RootRedirect;

});

parcelRegister("3RsMI", function(module, exports) {

$parcel$export(module.exports, "RouteWithOrgIdLoading", () => $2521fe5296456413$export$ae0909755df943ac);

var $eUqFw = parcelRequire("eUqFw");

var $7QNSj = parcelRequire("7QNSj");

var $kwce8 = parcelRequire("kwce8");

var $4Bees = parcelRequire("4Bees");

var $cWYE1 = parcelRequire("cWYE1");

var $jnlyS = parcelRequire("jnlyS");

var $p3lye = parcelRequire("p3lye");
function $2521fe5296456413$export$ae0909755df943ac({ LoadingComponent: LoadingComponent, ...props }) {
    const [{ orgId: orgId }] = (0, $cWYE1.useOrg)();
    const [timedOut, setTimedOut] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(false);
    const handleNoOrgId = (0, $eUqFw.useCallback)(()=>{
        (0, $jnlyS.logErrorMessage)('No orgId found after 10 seconds', {
            ...props
        });
        setTimedOut(true);
    }, [
        setTimedOut,
        props
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (orgId) return;
        const timeout = setTimeout(()=>{
            if (!orgId) handleNoOrgId();
        }, 10000);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        orgId,
        handleNoOrgId
    ]);
    if (timedOut) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $p3lye.default), {
        location: {
            search: ''
        }
    });
    if (!orgId) return LoadingComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadingComponent, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2521fe5296456413$var$DefaultLoadingWrapper, {
        "data-testid": "route-with-org-id-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: 'large'
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), props);
}
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2521fe5296456413$var$DefaultLoadingWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1wps406-0"
})`height:100%;width:100%;padding-top:100px;display:flex;justify-content:center;align-items:center;`;

});

parcelRegister("bo3ra", function(module, exports) {

$parcel$export(module.exports, "default", () => $a16a5f36c6fc0864$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $7qMvm = parcelRequire("7qMvm");

var $4RubW = parcelRequire("4RubW");

var $kzCiC = parcelRequire("kzCiC");
const $a16a5f36c6fc0864$var$SearchPageRoute = ()=>{
    const url = new URL(window.location.href);
    const searchQuery = url.searchParams.get('q') || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RubW.default), {
        name: (0, $1io2n.AnalyticsKeys).PEOPLE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qMvm.default), {
        name: (0, $1io2n.AnalyticsKeys).PEOPLE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kzCiC.default), {
        searchQuery: searchQuery
    })));
};
var $a16a5f36c6fc0864$export$2e2bcd8739ae039 = $a16a5f36c6fc0864$var$SearchPageRoute;

});
parcelRegister("kzCiC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3286514e9eaf7b47$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $3286514e9eaf7b47$var$LazySearchPage = (0, $eUqFw.lazy)(()=>(parcelRequire("fBM65")));
var $3286514e9eaf7b47$export$2e2bcd8739ae039 = $3286514e9eaf7b47$var$LazySearchPage;

});
parcelRegister("fBM65", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("2WQSq")
]).then(()=>parcelRequire('bGd26'));

});



parcelRegister("8ziB5", function(module, exports) {

$parcel$export(module.exports, "default", () => $13ed01243c3b343e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $7qMvm = parcelRequire("7qMvm");

var $4RubW = parcelRequire("4RubW");

var $12fHr = parcelRequire("12fHr");
const $13ed01243c3b343e$var$SearchTeamsError = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RubW.default), {
        name: (0, $1io2n.AnalyticsKeys).ALL_TEAMS_DISABLED
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qMvm.default), {
        name: (0, $1io2n.AnalyticsKeys).ALL_TEAMS_DISABLED
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $12fHr.LazyTeamsDisabled), null));
};
var $13ed01243c3b343e$export$2e2bcd8739ae039 = $13ed01243c3b343e$var$SearchTeamsError;

});
parcelRegister("12fHr", function(module, exports) {

$parcel$export(module.exports, "LazyTeamsDisabled", () => $4473c14b416a00c4$export$f063de2a1a254e59);

var $bYKiA = parcelRequire("bYKiA");

const $4473c14b416a00c4$export$f063de2a1a254e59 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("eAYWk")).then((module)=>module.TeamsDisabled),
    loading: ()=>null
});
$4473c14b416a00c4$export$f063de2a1a254e59.displayName = 'lazy(TeamsDisabled)';

});
parcelRegister("eAYWk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("facth")
]).then(()=>parcelRequire('8CW8y'));

});



parcelRegister("jmvGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f44c0cbd4595141$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $ezVe4 = parcelRequire("ezVe4");
var $7qMvm = parcelRequire("7qMvm");

var $4RubW = parcelRequire("4RubW");

var $dZdCE = parcelRequire("dZdCE");
const $6f44c0cbd4595141$var$TeamProfileRoute = ({ match: match })=>{
    const { teamId: teamId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RubW.default), {
        name: (0, $1io2n.AnalyticsKeys).TEAM_PROFILE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qMvm.default), {
        name: (0, $1io2n.AnalyticsKeys).TEAM_PROFILE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ezVe4.default), {
        teamId: teamId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dZdCE.default), {
        teamId: teamId
    }));
};
var $6f44c0cbd4595141$export$2e2bcd8739ae039 = $6f44c0cbd4595141$var$TeamProfileRoute;

});
parcelRegister("ezVe4", function(module, exports) {

$parcel$export(module.exports, "default", () => $192ff96f466c6f5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fcW8A = parcelRequire("fcW8A");

var $74Hyh = parcelRequire("74Hyh");
function $192ff96f466c6f5c$export$2e2bcd8739ae039({ teamId: teamId }) {
    const analytics = (0, $74Hyh.default)();
    (0, $fcW8A.useInjectedEventAttribute)('teamId', teamId);
    (0, $eUqFw.useEffect)(()=>{
        analytics.setTeamId(teamId);
        ()=>{
            analytics.setTeamId(undefined);
        };
    }, [
        analytics,
        teamId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
}

});

parcelRegister("dZdCE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e85205f6e8c1e20$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

const $7e85205f6e8c1e20$var$TeamProfilePage = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("hnDiP")),
    loading: ()=>null
});
$7e85205f6e8c1e20$var$TeamProfilePage.displayName = 'lazy(TeamProfilePage)';
var $7e85205f6e8c1e20$export$2e2bcd8739ae039 = $7e85205f6e8c1e20$var$TeamProfilePage;

});
parcelRegister("hnDiP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("ilh4r")
]).then(()=>parcelRequire('eo3a4'));

});



parcelRegister("eurvo", function(module, exports) {

$parcel$export(module.exports, "default", () => $153608dddf255bbc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3WT37 = parcelRequire("3WT37");
const $153608dddf255bbc$var$TeamNoIdRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3WT37.default), {
        to: "/search"
    });
var $153608dddf255bbc$export$2e2bcd8739ae039 = $153608dddf255bbc$var$TeamNoIdRedirect;

});

parcelRegister("9j0B5", function(module, exports) {

$parcel$export(module.exports, "default", () => $45cc6fb3e555409d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $7qMvm = parcelRequire("7qMvm");

var $15dFk = parcelRequire("15dFk");

var $4RubW = parcelRequire("4RubW");
const $45cc6fb3e555409d$var$UserProfileRoute = ({ match: match })=>{
    const { userId: userId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RubW.default), {
        name: (0, $1io2n.AnalyticsKeys).PROFILE_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qMvm.default), {
        name: (0, $1io2n.AnalyticsKeys).PROFILE_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15dFk.default), {
        userId: decodeURIComponent(userId)
    }));
};
var $45cc6fb3e555409d$export$2e2bcd8739ae039 = $45cc6fb3e555409d$var$UserProfileRoute;

});
parcelRegister("15dFk", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bcf491c855beb3$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

const $77bcf491c855beb3$var$LazyUserProfile = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("6nOza")),
    loading: ()=>null
});
$77bcf491c855beb3$var$LazyUserProfile.displayName = 'lazy(UserProfile)';
var $77bcf491c855beb3$export$2e2bcd8739ae039 = $77bcf491c855beb3$var$LazyUserProfile;

});
parcelRegister("6nOza", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("fl34e")
]).then(()=>parcelRequire('83PEA'));

});



parcelRegister("eMmYZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2da85389bd9614b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3WT37 = parcelRequire("3WT37");
const $b2da85389bd9614b$var$UserProfileUnknownRoute = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3WT37.default), {
        to: match.params.userId
    });
var $b2da85389bd9614b$export$2e2bcd8739ae039 = $b2da85389bd9614b$var$UserProfileUnknownRoute;

});

parcelRegister("jIuH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $22745a6a6b53aa64$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $7qMvm = parcelRequire("7qMvm");

var $4RubW = parcelRequire("4RubW");

var $1MR0s = parcelRequire("1MR0s");
const $22745a6a6b53aa64$var$UserProfileWorkedOn = ({ match: match })=>{
    const { userId: userId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RubW.default), {
        name: (0, $1io2n.AnalyticsKeys).PROFILE_WORKED_ON_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qMvm.default), {
        name: (0, $1io2n.AnalyticsKeys).PROFILE_WORKED_ON_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MR0s.default), {
        userId: decodeURIComponent(userId)
    }));
};
var $22745a6a6b53aa64$export$2e2bcd8739ae039 = $22745a6a6b53aa64$var$UserProfileWorkedOn;

});
parcelRegister("1MR0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $295887d3801b2452$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

const $295887d3801b2452$var$LazyUserProfileWorkedOn = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("ePc3R")),
    loading: ()=>null
});
$295887d3801b2452$var$LazyUserProfileWorkedOn.displayName = 'lazy(UserProfileWorkedOn)';
var $295887d3801b2452$export$2e2bcd8739ae039 = $295887d3801b2452$var$LazyUserProfileWorkedOn;

});
parcelRegister("ePc3R", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kmPrM")
]).then(()=>parcelRequire('sCQ1U'));

});




parcelRegister("jmrxX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d469be16bced186$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1PG9B = parcelRequire("1PG9B");

var $fef5r = parcelRequire("fef5r");

var $kZURK = parcelRequire("kZURK");

var $etZQm = parcelRequire("etZQm");
const $2d469be16bced186$var$appProductMap = {
    '': '',
    'site-directory': '',
    'confluence-directory': (0, $1PG9B.ProductName).CONFLUENCE,
    'jira-directory': (0, $1PG9B.ProductName).JIRA,
    'teamcentral-directory': (0, $1PG9B.ProductName).ATLAS,
    'home-directory': (0, $1PG9B.ProductName).HOME
};
const $2d469be16bced186$var$mapAppToProduct = (app)=>{
    return $2d469be16bced186$var$appProductMap[app];
};
class $2d469be16bced186$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        // This is here to let productFeatureFlags from getting updated via props
        const productFeatureFlags = {
            ...this.state.productFeatureFlags,
            ...this.props.productFeatureFlags
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZURK.default).Provider, {
            value: {
                ...this.props,
                ...this.state,
                productFeatureFlags: productFeatureFlags
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.addFlag = (props)=>{
            const { type: type, ...rest } = props;
            this.props.addFlag({
                ...rest,
                id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
                type: type,
                appearance: 'normal',
                icon: (0, $etZQm.getTypeIcon)(type)
            });
        };
        this.push = (path)=>{
            const { contextEntryPoint: contextEntryPoint } = this.props;
            const finalPath = (0, $fef5r.prefixWithContextEntryPoint)(path, contextEntryPoint);
            return this.props.push(finalPath);
        };
        this.replace = (path)=>{
            const { contextEntryPoint: contextEntryPoint } = this.props;
            const finalPath = (0, $fef5r.prefixWithContextEntryPoint)(path, contextEntryPoint);
            return this.props.replace(finalPath);
        };
        this.state = {
            addFlag: this.addFlag,
            push: this.push,
            replace: this.replace,
            productName: $2d469be16bced186$var$mapAppToProduct(this.props.appName),
            productFeatureFlags: this.props.productFeatureFlags,
            invitePeopleHandlers: this.props.invitePeopleHandlers
        };
    }
}

});
parcelRegister("etZQm", function(module, exports) {

$parcel$export(module.exports, "getTypeIcon", () => $9ac5cbae8f4c29b0$export$672f92b0d52b7cfe);

var $eUqFw = parcelRequire("eUqFw");

var $gw74N = parcelRequire("gw74N");

var $ek6sP = parcelRequire("ek6sP");

var $iqFZO = parcelRequire("iqFZO");

var $1Qu2i = parcelRequire("1Qu2i");

const $9ac5cbae8f4c29b0$var$flagIconByType = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gw74N))), {
        label: "error123",
        spacing: "spacious",
        color: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Qu2i))), {
        label: "warning123",
        spacing: "spacious",
        color: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek6sP))), {
        label: "info123",
        spacing: "spacious",
        color: `var(--ds-icon-information, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`
    })
};
const $9ac5cbae8f4c29b0$var$defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iqFZO))), {
    label: "winner123",
    spacing: "spacious",
    color: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`
});
const $9ac5cbae8f4c29b0$export$672f92b0d52b7cfe = (type = 'normal')=>$9ac5cbae8f4c29b0$var$flagIconByType[type] || $9ac5cbae8f4c29b0$var$defaultIcon;

});
parcelRegister("ek6sP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b478a4dfe0bf6ab262246b2cea3eb20f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6d7f28dcbf6a858$var$_react = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a6d7f28dcbf6a858$var$_information = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("h6FFs")));

var $a6d7f28dcbf6a858$var$_info = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("2bv8J")));
function $a6d7f28dcbf6a858$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6d7f28dcbf6a858$var$InformationIcon = (props)=>/*#__PURE__*/ $a6d7f28dcbf6a858$var$_react.default.createElement($a6d7f28dcbf6a858$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $a6d7f28dcbf6a858$var$_info.default
    }, props));
$a6d7f28dcbf6a858$var$InformationIcon.Name = 'InformationIconMigration';
var $a6d7f28dcbf6a858$var$_default = module.exports.default = $a6d7f28dcbf6a858$var$InformationIcon;

});



parcelRegister("YnDGC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c964cd06fdee6c66$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $5QRJ0 = parcelRequire("5QRJ0");
var $fECJU = parcelRequire("fECJU");
class $c964cd06fdee6c66$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        const { analytics: analytics, appName: appName } = this.props;
        (0, $fECJU.logException)(error, 'Caught error in ErrorBoundaryApp', {
            info: errorInfo,
            tags: {
                severity: 'high'
            }
        });
        analytics.pushOperationalEvent({
            source: (0, $1io2n.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: 'errorBoundary',
            action: (0, $1io2n.AnalyticsEventActions).TRIGGERED,
            attributes: {
                product: appName,
                boundary: 'app',
                error: error.toString()
            },
            tags: [
                'error',
                'error-boundary'
            ]
        });
    }
    render() {
        if (!this.state.hasError) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5QRJ0.GenericErrorPage), {
            hasSupportLink: true
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}

});

parcelRegister("aILpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d458045efc6862b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $74Hyh = parcelRequire("74Hyh");
var $gakch = parcelRequire("gakch");
var $hPco0 = parcelRequire("hPco0");
var $6XUHL = parcelRequire("6XUHL");

var $34zWR = parcelRequire("34zWR");
const $6d458045efc6862b$var$mapAppNameToProduct = {
    '': undefined,
    'site-directory': undefined,
    'confluence-directory': 'CONFLUENCE',
    'jira-directory': 'JIRA',
    'teamcentral-directory': 'TOWNSQUARE',
    'home-directory': 'HOME'
};
function $6d458045efc6862b$export$f07589effd6b0ff3(props) {
    const { appName: appName, children: children } = props;
    const [{ cloudId: cloudId }] = (0, $6XUHL.useSite)();
    const [{ principalUserId: principalUserId }, { getPrincipalUserInfo: getPrincipalUserInfo }] = (0, $gakch.usePrincipalUser)();
    const analytics = (0, $74Hyh.default)();
    const [{ hasLoadedSettings: hasLoadedSettings, hasErrorOnFetchSettings: hasErrorOnFetchSettings, isFetching: isFetching }, { getSettings: getSettings }] = (0, $hPco0.useSettings)();
    (0, $eUqFw.useEffect)(()=>{
        analytics.startUIViewedEvent(principalUserId);
    }, [
        analytics,
        principalUserId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasLoadedSettings) analytics.pushOperationalEvent({
            action: hasErrorOnFetchSettings ? (0, $1io2n.AnalyticsEventActions).FAILED : (0, $1io2n.AnalyticsEventActions).SUCCEEDED,
            actionSubject: (0, $34zWR.SliAnalytics).GetSettings,
            source: (0, $1io2n.AnalyticsEventSource).DIRECTORY_APP
        });
    }, [
        analytics,
        hasLoadedSettings,
        hasErrorOnFetchSettings
    ]);
    const product = $6d458045efc6862b$var$mapAppNameToProduct[appName];
    (0, $eUqFw.useEffect)(()=>{
        // currently, cloudId is a required prop of Embedded Directory
        if (!hasLoadedSettings && !isFetching && cloudId) getSettings(product, cloudId);
    }, [
        product,
        hasLoadedSettings,
        getSettings,
        cloudId,
        isFetching
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // currently, cloudId is a required prop of Embedded Directory
        if (cloudId) getPrincipalUserInfo(cloudId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cloudId
    ]);
    return children;
}
var $6d458045efc6862b$export$2e2bcd8739ae039 = $6d458045efc6862b$export$f07589effd6b0ff3;

});
parcelRegister("hPco0", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlag", () => $23bdd30d6f19633d$export$61acb772777ef35d);
$parcel$export(module.exports, "useSettings", () => $23bdd30d6f19633d$export$9115b42802a3e44f);

var $hY5Cf = parcelRequire("hY5Cf");
var $5wKIN = parcelRequire("5wKIN");
const $23bdd30d6f19633d$export$c5cecc6f5d4bab3e = ()=>{
    return true;
};
const $23bdd30d6f19633d$export$61acb772777ef35d = (flagName)=>{
    return (0, $hY5Cf.useFeatureFlag)(flagName);
};
const $23bdd30d6f19633d$export$9115b42802a3e44f = ()=>{
    return (0, $5wKIN.useSettings)();
};

});
parcelRegister("hY5Cf", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlag", () => $96cecbc646ff6917$export$61acb772777ef35d);

var $5wKIN = parcelRequire("5wKIN");

var $WQNHl = parcelRequire("WQNHl");
const $96cecbc646ff6917$export$61acb772777ef35d = (flag)=>{
    const { productFeatureFlags: productFeatureFlags } = (0, $WQNHl.useAppConfig)();
    const flagValue = (0, $5wKIN.useSettingsFeatureFlag)(flag);
    if (productFeatureFlags && productFeatureFlags[flag] !== undefined) return productFeatureFlags[flag];
    return flagValue;
};
const $96cecbc646ff6917$export$80200644648c0ee1 = (flagName)=>!!$96cecbc646ff6917$export$61acb772777ef35d(flagName);

});


parcelRegister("34zWR", function(module, exports) {

$parcel$export(module.exports, "SliAnalytics", () => $1adc48e2f5702dcd$export$9cb5f615baf57db6);
var $1adc48e2f5702dcd$export$9cb5f615baf57db6;
(function(SliAnalytics) {
    SliAnalytics["GetTeamProfile"] = "GetTeamProfile";
    SliAnalytics["GetTeamMembers"] = "GetTeamMembers";
    SliAnalytics["GetTeamLinks"] = "GetTeamLinks";
    SliAnalytics["TeamSearch"] = "TeamSearch";
    SliAnalytics["AccountCentricUserSearch"] = "AccountCentricUserSearch";
    SliAnalytics["LoadProfileAbout"] = "LoadProfileAbout";
    SliAnalytics["GetSettings"] = "GetSettings";
})($1adc48e2f5702dcd$export$9cb5f615baf57db6 || ($1adc48e2f5702dcd$export$9cb5f615baf57db6 = {}));

});




parcelRegister("j0CW6", function(module, exports) {

$parcel$export(module.exports, "createShowFlagHandler", () => $43aa3b2073d8beb6$export$58bf1d914631d59f);

var $eUqFw = parcelRequire("eUqFw");

var $eo17r = parcelRequire("eo17r");

var $iFoSH = parcelRequire("iFoSH");
const $43aa3b2073d8beb6$var$FLAG_PTC_ID_DEFAULT = 'ptc-people-directory.flag-id';
const $43aa3b2073d8beb6$export$58bf1d914631d59f = (showFlag, dismissFlag)=>(flagFromPTC)=>{
        const flagType = flagFromPTC.type === 'success' || flagFromPTC.type === 'error' || flagFromPTC.type === 'info' || flagFromPTC.type === 'warning' ? flagFromPTC.type : 'success';
        const flagTitle = flagFromPTC.title;
        const flagDesc = flagFromPTC.description;
        showFlag({
            render: ({ key: key })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFoSH.default), {
                    key: key,
                    id: key || flagFromPTC.id || $43aa3b2073d8beb6$var$FLAG_PTC_ID_DEFAULT,
                    flagType: flagType,
                    title: flagTitle != null ? flagTitle : '',
                    description: flagDesc != null ? flagDesc : '',
                    isAutoDismiss: true,
                    onDismissed: (id)=>{
                        dismissFlag((0, $eo17r.toFlagId)(id));
                    }
                })
        });
    };

});
parcelRegister("iFoSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d199b2da5c2aad1c$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $d199b2da5c2aad1c$export$2e2bcd8739ae039 = (0, $kQ0RL.CommonFlag);

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("bmR0P")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("bmR0P")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("bmR0P", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cCYJs")
]).then(()=>parcelRequire('kbpOk'));

});

parcelRegister("eWPgg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hkLGi").then(()=>parcelRequire('jkRT2'));

});




parcelRegister("7mFxr", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesPageLoad", () => $08b7272d77e81c54$export$37d218590c0c9938);

var $lNfG4 = parcelRequire("lNfG4");
const $08b7272d77e81c54$export$37d218590c0c9938 = (0, $lNfG4.metrics).pageLoad({
    key: 'people-profiles'
});

});



//# sourceMappingURL=async-people-profiles.5ab9a637.js.map
